webpackJsonp([170],{

/***/ "+1lV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+27f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+quJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+vOg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./src/services/encode.js

var encode_encode = function encode(data) {
  return reverse(btoa(unescape(encodeURIComponent(stringify_default()(data))))) + randomString(7);
};
var encodeToken = function encodeToken(data) {
  data = data + randomString(5);
  return reverse(btoa(unescape(data))) + randomString(10);
};
var encode_encodeRichmenu = function encodeRichmenu(data) {
  return reverse(btoa(unescape(encodeURIComponent(stringify_default()(data))))) + randomString(5);
};

var encode_encodeAuthen_news = function encodeAuthen_news(data) {
  return randomString(7) + reverse(btoa(unescape(encodeURIComponent(stringify_default()(data))))) + randomString(10);
};

function reverse(s) {
  return s.split('').reverse().join('');
}

function randomString(num) {
  var text = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < num; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

/* harmony default export */ var services_encode = ({
  encode: encode_encode,
  encodeToken: encodeToken,
  encodeRichmenu: encode_encodeRichmenu,
  encodeAuthen_news: encode_encodeAuthen_news
});
// CONCATENATED MODULE: ./src/services/decode.js
var decode = function decode(data) {
  return decodeURIComponent(escape(atob(decode_reverse(data.slice(0, -7)))));
};
var decodeToken = function decodeToken(data) {
  return escape(atob(decode_reverse(data.slice(0, -10)))).slice(0, -5);
};

var decodeAuthen_news = function decodeAuthen_news(data) {
  return decodeURIComponent(escape(atob(decode_reverse(data.slice(7).slice(0, -10)))));
  // randomString(7) + reverse(btoa(unescape(encodeURIComponent(JSON.stringify(data))))) + randomString(10)
};

function decode_reverse(s) {
  return s.split('').reverse().join('');
}
/* harmony default export */ var services_decode = ({
  decode: decode,
  decodeToken: decodeToken,
  decodeAuthen_news: decodeAuthen_news
});
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__("oqQY");
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);

// EXTERNAL MODULE: ./node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__("ddRL");
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);

// EXTERNAL MODULE: ./node_modules/dayjs/plugin/timezone.js
var timezone = __webpack_require__("JfjX");
var timezone_default = /*#__PURE__*/__webpack_require__.n(timezone);

// EXTERNAL MODULE: ./node_modules/dayjs/plugin/localeData.js
var localeData = __webpack_require__("kzmA");
var localeData_default = /*#__PURE__*/__webpack_require__.n(localeData);

// EXTERNAL MODULE: ./node_modules/dayjs/plugin/relativeTime.js
var relativeTime = __webpack_require__("B197");
var relativeTime_default = /*#__PURE__*/__webpack_require__.n(relativeTime);

// EXTERNAL MODULE: ./node_modules/dayjs/plugin/localizedFormat.js
var localizedFormat = __webpack_require__("QRof");
var localizedFormat_default = /*#__PURE__*/__webpack_require__.n(localizedFormat);

// EXTERNAL MODULE: ./node_modules/dayjs/locale/th.js
var th = __webpack_require__("70gj");
var th_default = /*#__PURE__*/__webpack_require__.n(th);

// EXTERNAL MODULE: ./node_modules/dayjs/locale/en.js
var en = __webpack_require__("RZac");
var en_default = /*#__PURE__*/__webpack_require__.n(en);

// EXTERNAL MODULE: ./node_modules/dayjs/locale/zh-cn.js
var zh_cn = __webpack_require__("uM1m");
var zh_cn_default = /*#__PURE__*/__webpack_require__.n(zh_cn);

// CONCATENATED MODULE: ./src/services/momentthai.js









dayjs_min_default.a.extend(utc_default.a);
dayjs_min_default.a.extend(timezone_default.a);
dayjs_min_default.a.extend(localeData_default.a);
dayjs_min_default.a.extend(relativeTime_default.a);
dayjs_min_default.a.extend(localizedFormat_default.a);

var momentthai_momenttimethai = function momenttimethai(data) {
  return dayjs_min_default()(data).tz('Pacific/Kiritimati').locale('th').format('LT');
};
var momentthai_momentdatethai = function momentdatethai(data) {
  return dayjs_min_default()(data).add(543, 'year').tz('Pacific/Kiritimati').locale('th').format('ll');
};

var momentthai_momentdateen = function momentdateen(data) {
  return dayjs_min_default()(data).tz('Pacific/Kiritimati').locale('en').format('ll');
};
var momentthai_momentdatecn = function momentdatecn(data) {
  return dayjs_min_default()(data).tz('Pacific/Kiritimati').locale('zh_cn').format('ll');
};

var momentthai_momenttimethaiformnow = function momenttimethaiformnow(data) {
  return dayjs_min_default()(dayjs_min_default()(data).add(7, 'hour').tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD h:mm:ss').locale('th').fromNow();
};

var momentthai_momenttimethaiformnowcn = function momenttimethaiformnowcn(data) {
  return dayjs_min_default()(dayjs_min_default()(data).add(7, 'hour').tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD h:mm:ss').locale('zh_cn').fromNow();
};

var momentthai_momenttimethaiformnowen = function momenttimethaiformnowen(data) {
  return dayjs_min_default()(dayjs_min_default()(data).add(7, 'hour').tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD h:mm:ss').fromNow();
};

var momentthai_momenttimestamp = function momenttimestamp() {
  return dayjs_min_default()().tz('America/Danmarkshavn').format().replace(/T/g, ' ').replace('Z', '');
};

var momentthai_momentdatetimethai = function momentdatetimethai(data) {
  return dayjs_min_default()(data).tz('Asia/Bangkok').locale('th').format('llll').split('เวลา')[0];
};

var momentthai_momentCreateDate = function momentCreateDate() {
  return dayjs_min_default()().tz('Asia/Bangkok').locale('th').format().replace(/T/g, ' ').replace('Z', '');
};

/* harmony default export */ var momentthai = ({
  momenttimethai: momentthai_momenttimethai,
  momentdatethai: momentthai_momentdatethai,
  momenttimethaiformnow: momentthai_momenttimethaiformnow,
  momenttimethaiformnowcn: momentthai_momenttimethaiformnowcn,
  momenttimethaiformnowen: momentthai_momenttimethaiformnowen,
  momenttimestamp: momentthai_momenttimestamp,
  momentdatetimethai: momentthai_momentdatetimethai,
  momentdateen: momentthai_momentdateen,
  momentdatecn: momentthai_momentdatecn,
  momentCreateDate: momentthai_momentCreateDate
});
// CONCATENATED MODULE: ./src/services/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return services_encode; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return services_decode; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return momentthai; });






/***/ }),

/***/ "//W+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/CreateAlbumsDialogMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { Momenttime } from '@/services'

var _ = __webpack_require__("M4fF");
/* harmony default export */ var CreateAlbumsDialogMobile = ({
  props: {
    dialogCreatealbums: false,
    tokenroom: ''
  },
  data: function data() {
    return {
      token: '',
      files: [],
      albumsname: '',
      loading: false
    };
  },
  created: function created() {
    // this.token = Decode.decodeToken(this.$cookie.get('tokenuser'))
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },

  methods: {
    closeDialog: function closeDialog() {
      this.files = [];
      this.albumsname = '';
      this.$emit('closeCreatealbums', false);
    },
    createalbums: function createalbums() {
      var _this = this;

      // console.log(this.files)
      var sizealums = [];
      var formData = new FormData();
      var lengthfile = this.files.length;
      for (var i = 0; i < lengthfile; i++) {
        var file = this.files[i].file;
        formData.append('file[]', file, file.name);
        sizealums[i] = this.files[i].file.size;
        // console.log(file)
      }
      if (_.sum(sizealums) / 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Album.maxSizeFile'), type: 'warning' });
        this.files = [];
        this.loading = false;
      } else {
        this.loading = true;
        formData.append('tokenuser', this.token);
        formData.append('tokenroom', this.$route.params.roomid);
        formData.append('albums_name', this.albumsname);
        this.axios.post("https://uatchat-manage.one.th/event" + '/create_album', formData).then(function (response) {
          _this.loading = false;
          var infoalbums = {};
          infoalbums = response.data.data.albums;
          // console.log(infoalbums)
          _this.$swal('', _this.$t('Alert.Success.createAlbum'), 'success');
          _this.$emit('CreateAlbums', response.data.status, infoalbums);
          _this.files = [];
          _this.albumsname = '';
          _this.$emit('closeCreatealbums', false);
        }, function () {
          _this.loading = false;
          _this.$swal('Network error', _this.$t('Alert.Fail.default.networkError'), 'error');
        });
      }
    },
    extension: function extension(files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase();
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
      var pdf = ['pdf'];
      var file = ['ai', 'ps', 'psd'];
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm'];
      var presentation = ['ppt', 'pps', 'pot', 'pptx'];
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff'];
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf';
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive';
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel';
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint';
      } else if (word.includes(extension)) {
        return 'fas fa-file-word';
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code';
      } else if (image.includes(extension)) {
        return 'fas fa-file-image';
      } else if (file.includes(extension)) {
        return 'fas fa-file';
      } else {
        return 'fas fa-file-alt';
      }
      // return extension[extension.length-1]
    },
    handleFilesUpload: function handleFilesUpload(key) {
      var uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({
          file: uploadedFiles[i],
          status: 'waiting'
        });
      }
      this.getImagePreviews(key);
      document.querySelector('#files').value = '';
    },
    removeFile: function removeFile(key) {
      this.files.splice(key, 1);
      this.getImagePreviews(key);
    },
    getImagePreviews: function getImagePreviews(key) {
      var _this2 = this;

      var _loop = function _loop(i) {
        if (/\.(jpe?g|png|gif)$/i.test(_this2.files[i].file.name)) {
          var reader = new FileReader();
          reader.addEventListener('load', function () {
            this.$refs['preview' + parseInt(i)][0].src = reader.result;
            // console.log(this.$refs['preview' + parseInt(i)][0].src = reader.result)
          }.bind(_this2), false);
          reader.readAsDataURL(_this2.files[i].file);
          // this.extension(this.files[i].name)
          // console.log(this.extension())
        } else {
            // this.$nextTick(function(){
            // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
            // });
            // console.log('mm')
          }
      };

      for (var i = 0; i < this.files.length; i++) {
        _loop(i);
      }
    }
  },
  watch: {
    files: function files() {
      if (this.files.length > 5) {
        this.$swal('', this.$t('Alert.Fail.Album.maxFiles'), 'warning');
        _.pullAt(this.files, [5]);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42afe1aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/CreateAlbumsDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"persistent":"","max-width":"500px","max-height":"500px"},model:{value:(_vm.dialogCreatealbums),callback:function ($$v) {_vm.dialogCreatealbums=$$v},expression:"dialogCreatealbums"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-images")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.album.headerCreate'))+"\n        ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"30px"}},[_c('div',{staticStyle:{"height":"275px","overflow-y":"hidden","margin-top":"10px"}},[_c('div',{},[_c('v-text-field',{attrs:{"name":"name","label":_vm.$t('Alert.Fail.Album.emptyName'),"id":"id"},model:{value:(_vm.albumsname),callback:function ($$v) {_vm.albumsname=$$v},expression:"albumsname"}})],1),_vm._v(" "),_c('div',[_c('form',{ref:"fileform",staticStyle:{"float":"left"}},[_c('label',[_c('b',{staticClass:"CSChatThai",staticStyle:{"text-decoration":"underline","cursor":"pointer","text-indent":"5em"}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.selectPicture')))]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"files","multiple":"","accept":".png, .jpg, .jpeg, .gif, .bmp, .wbmp"},on:{"change":function($event){_vm.handleFilesUpload()}}})])]),_vm._v(" "),(_vm.files.length > 0 )?_c('v-flex',{staticClass:"containers",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","height":"40vh !important","width":"100% !important","display":"-webkit-inline-box","padding-top":"3px"},attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((_vm.files),function(file,key){return _c('div',{staticClass:"borderfile",staticStyle:{"justify-content":"center","margin-left":"2vw","padding-top":"1vh"}},[_c('a',{staticClass:"close-classic",staticStyle:{"float":"right","padding-right":"10px","font-size":"20px"},on:{"click":function($event){_vm.removeFile( key )}}}),_vm._v(" "),(_vm.extension(file.file.name) == 'fas fa-file-image')?_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center"}},[_c('img',{ref:'preview'+parseInt( key ),refInFor:true,staticClass:"preview",staticStyle:{"height":"18vh !important","width":"20vh !important","display":"flex","justify-content":"center","border-radius":"10px","border-color":"#8080808f","border-style":"solid","border-width":"thin"}})]):_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center"}},[_c('v-icon',{staticStyle:{"font-size":"60px !important","color":"#1a222c","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(file.file.name)))])],1)])})):_vm._e()],1)]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticStyle:{"background":"#757575","text-transform":"none"},attrs:{"dark":""},on:{"click":_vm.closeDialog}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n        ")]),_vm._v(" "),(_vm.files.length > 0 && _vm.albumsname !== '')?_c('v-btn',{staticStyle:{"background":"#2562ae","text-transform":"none"},attrs:{"dark":"","loading":_vm.loading},on:{"click":function($event){_vm.createalbums()}}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n        ")]):_c('v-btn',{staticStyle:{"background":"#2562ae","text-transform":"none"},attrs:{"disabled":""}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_CreateAlbumsDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/CreateAlbumsDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("Bn06")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42afe1aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  CreateAlbumsDialogMobile,
  dialog_CreateAlbumsDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_CreateAlbumsDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Djd":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./78-EUC-H.bcmap": [
		"0lHY",
		167
	],
	"./78-EUC-V.bcmap": [
		"8cwC",
		166
	],
	"./78-H.bcmap": [
		"Hj0Y",
		165
	],
	"./78-RKSJ-H.bcmap": [
		"rDt0",
		164
	],
	"./78-RKSJ-V.bcmap": [
		"69NQ",
		163
	],
	"./78-V.bcmap": [
		"OfM+",
		162
	],
	"./78ms-RKSJ-H.bcmap": [
		"uB/y",
		161
	],
	"./78ms-RKSJ-V.bcmap": [
		"h5K9",
		160
	],
	"./83pv-RKSJ-H.bcmap": [
		"9WfI",
		159
	],
	"./90ms-RKSJ-H.bcmap": [
		"0WCd",
		158
	],
	"./90ms-RKSJ-V.bcmap": [
		"IlPF",
		157
	],
	"./90msp-RKSJ-H.bcmap": [
		"JgNn",
		156
	],
	"./90msp-RKSJ-V.bcmap": [
		"vmWD",
		155
	],
	"./90pv-RKSJ-H.bcmap": [
		"yxD0",
		154
	],
	"./90pv-RKSJ-V.bcmap": [
		"5WXK",
		153
	],
	"./Add-H.bcmap": [
		"xhCb",
		152
	],
	"./Add-RKSJ-H.bcmap": [
		"6VbT",
		151
	],
	"./Add-RKSJ-V.bcmap": [
		"RLMU",
		150
	],
	"./Add-V.bcmap": [
		"yp9I",
		149
	],
	"./Adobe-CNS1-0.bcmap": [
		"hUem",
		148
	],
	"./Adobe-CNS1-1.bcmap": [
		"ino3",
		147
	],
	"./Adobe-CNS1-2.bcmap": [
		"ibfO",
		146
	],
	"./Adobe-CNS1-3.bcmap": [
		"GiTj",
		145
	],
	"./Adobe-CNS1-4.bcmap": [
		"hsjj",
		144
	],
	"./Adobe-CNS1-5.bcmap": [
		"YRpi",
		143
	],
	"./Adobe-CNS1-6.bcmap": [
		"w8o3",
		142
	],
	"./Adobe-CNS1-UCS2.bcmap": [
		"rX6d",
		141
	],
	"./Adobe-GB1-0.bcmap": [
		"iD5p",
		140
	],
	"./Adobe-GB1-1.bcmap": [
		"4jEs",
		139
	],
	"./Adobe-GB1-2.bcmap": [
		"Afaj",
		138
	],
	"./Adobe-GB1-3.bcmap": [
		"toY7",
		137
	],
	"./Adobe-GB1-4.bcmap": [
		"faDD",
		136
	],
	"./Adobe-GB1-5.bcmap": [
		"4gVq",
		135
	],
	"./Adobe-GB1-UCS2.bcmap": [
		"L8gf",
		134
	],
	"./Adobe-Japan1-0.bcmap": [
		"hIDG",
		133
	],
	"./Adobe-Japan1-1.bcmap": [
		"iPSW",
		132
	],
	"./Adobe-Japan1-2.bcmap": [
		"S/ep",
		131
	],
	"./Adobe-Japan1-3.bcmap": [
		"YhiS",
		130
	],
	"./Adobe-Japan1-4.bcmap": [
		"wm/L",
		129
	],
	"./Adobe-Japan1-5.bcmap": [
		"Zkyi",
		128
	],
	"./Adobe-Japan1-6.bcmap": [
		"aB41",
		127
	],
	"./Adobe-Japan1-UCS2.bcmap": [
		"2Us0",
		126
	],
	"./Adobe-Korea1-0.bcmap": [
		"Mv2w",
		125
	],
	"./Adobe-Korea1-1.bcmap": [
		"s/Eq",
		124
	],
	"./Adobe-Korea1-2.bcmap": [
		"3o6+",
		123
	],
	"./Adobe-Korea1-UCS2.bcmap": [
		"SV2h",
		122
	],
	"./B5-H.bcmap": [
		"HF7q",
		121
	],
	"./B5-V.bcmap": [
		"fwp9",
		120
	],
	"./B5pc-H.bcmap": [
		"rWMu",
		119
	],
	"./B5pc-V.bcmap": [
		"xFEU",
		118
	],
	"./CNS-EUC-H.bcmap": [
		"B0Kb",
		117
	],
	"./CNS-EUC-V.bcmap": [
		"azx/",
		116
	],
	"./CNS1-H.bcmap": [
		"p4ms",
		115
	],
	"./CNS1-V.bcmap": [
		"9eW7",
		114
	],
	"./CNS2-H.bcmap": [
		"zc6H",
		113
	],
	"./CNS2-V.bcmap": [
		"dvni",
		112
	],
	"./ETHK-B5-H.bcmap": [
		"EOs2",
		111
	],
	"./ETHK-B5-V.bcmap": [
		"3Wsc",
		110
	],
	"./ETen-B5-H.bcmap": [
		"gQjr",
		109
	],
	"./ETen-B5-V.bcmap": [
		"kLXg",
		108
	],
	"./ETenms-B5-H.bcmap": [
		"imo+",
		107
	],
	"./ETenms-B5-V.bcmap": [
		"zm2u",
		106
	],
	"./EUC-H.bcmap": [
		"Q2D6",
		105
	],
	"./EUC-V.bcmap": [
		"k2qw",
		104
	],
	"./Ext-H.bcmap": [
		"YgQs",
		103
	],
	"./Ext-RKSJ-H.bcmap": [
		"hIym",
		102
	],
	"./Ext-RKSJ-V.bcmap": [
		"N32G",
		101
	],
	"./Ext-V.bcmap": [
		"M1wV",
		100
	],
	"./GB-EUC-H.bcmap": [
		"HcIz",
		99
	],
	"./GB-EUC-V.bcmap": [
		"UJd/",
		98
	],
	"./GB-H.bcmap": [
		"IhXA",
		97
	],
	"./GB-V.bcmap": [
		"hcdP",
		96
	],
	"./GBK-EUC-H.bcmap": [
		"1Knm",
		95
	],
	"./GBK-EUC-V.bcmap": [
		"YMus",
		94
	],
	"./GBK2K-H.bcmap": [
		"nBsz",
		93
	],
	"./GBK2K-V.bcmap": [
		"vkSo",
		92
	],
	"./GBKp-EUC-H.bcmap": [
		"dk46",
		91
	],
	"./GBKp-EUC-V.bcmap": [
		"cDOd",
		90
	],
	"./GBT-EUC-H.bcmap": [
		"DdPg",
		89
	],
	"./GBT-EUC-V.bcmap": [
		"hqV7",
		88
	],
	"./GBT-H.bcmap": [
		"7XA5",
		87
	],
	"./GBT-V.bcmap": [
		"qhQE",
		86
	],
	"./GBTpc-EUC-H.bcmap": [
		"1Eun",
		85
	],
	"./GBTpc-EUC-V.bcmap": [
		"849d",
		84
	],
	"./GBpc-EUC-H.bcmap": [
		"A4XZ",
		83
	],
	"./GBpc-EUC-V.bcmap": [
		"an5Q",
		82
	],
	"./H.bcmap": [
		"jg+6",
		81
	],
	"./HKdla-B5-H.bcmap": [
		"dKoA",
		80
	],
	"./HKdla-B5-V.bcmap": [
		"Axzi",
		79
	],
	"./HKdlb-B5-H.bcmap": [
		"Z6Fe",
		78
	],
	"./HKdlb-B5-V.bcmap": [
		"Swbl",
		77
	],
	"./HKgccs-B5-H.bcmap": [
		"4mx8",
		76
	],
	"./HKgccs-B5-V.bcmap": [
		"TbQ6",
		75
	],
	"./HKm314-B5-H.bcmap": [
		"zfm+",
		74
	],
	"./HKm314-B5-V.bcmap": [
		"lr6o",
		73
	],
	"./HKm471-B5-H.bcmap": [
		"EyHw",
		72
	],
	"./HKm471-B5-V.bcmap": [
		"YRl9",
		71
	],
	"./HKscs-B5-H.bcmap": [
		"mP3G",
		70
	],
	"./HKscs-B5-V.bcmap": [
		"6sQV",
		69
	],
	"./Hankaku.bcmap": [
		"Boma",
		68
	],
	"./Hiragana.bcmap": [
		"Aqml",
		67
	],
	"./KSC-EUC-H.bcmap": [
		"RBad",
		66
	],
	"./KSC-EUC-V.bcmap": [
		"C6eU",
		65
	],
	"./KSC-H.bcmap": [
		"Q2pl",
		64
	],
	"./KSC-Johab-H.bcmap": [
		"330r",
		63
	],
	"./KSC-Johab-V.bcmap": [
		"jriO",
		62
	],
	"./KSC-V.bcmap": [
		"qRx5",
		61
	],
	"./KSCms-UHC-H.bcmap": [
		"xEph",
		60
	],
	"./KSCms-UHC-HW-H.bcmap": [
		"JSwJ",
		59
	],
	"./KSCms-UHC-HW-V.bcmap": [
		"G/Oj",
		58
	],
	"./KSCms-UHC-V.bcmap": [
		"/RsT",
		57
	],
	"./KSCpc-EUC-H.bcmap": [
		"D4WR",
		56
	],
	"./KSCpc-EUC-V.bcmap": [
		"OqUO",
		55
	],
	"./Katakana.bcmap": [
		"clhU",
		54
	],
	"./NWP-H.bcmap": [
		"xDZB",
		53
	],
	"./NWP-V.bcmap": [
		"lHHt",
		52
	],
	"./RKSJ-H.bcmap": [
		"1bQs",
		51
	],
	"./RKSJ-V.bcmap": [
		"KD7s",
		50
	],
	"./Roman.bcmap": [
		"KDYN",
		49
	],
	"./UniCNS-UCS2-H.bcmap": [
		"bBFw",
		48
	],
	"./UniCNS-UCS2-V.bcmap": [
		"ne9Q",
		47
	],
	"./UniCNS-UTF16-H.bcmap": [
		"7mve",
		46
	],
	"./UniCNS-UTF16-V.bcmap": [
		"fDmo",
		45
	],
	"./UniCNS-UTF32-H.bcmap": [
		"oBG3",
		44
	],
	"./UniCNS-UTF32-V.bcmap": [
		"R8UX",
		43
	],
	"./UniCNS-UTF8-H.bcmap": [
		"9p4U",
		42
	],
	"./UniCNS-UTF8-V.bcmap": [
		"mrGD",
		41
	],
	"./UniGB-UCS2-H.bcmap": [
		"8bey",
		40
	],
	"./UniGB-UCS2-V.bcmap": [
		"lngy",
		39
	],
	"./UniGB-UTF16-H.bcmap": [
		"Jjcy",
		38
	],
	"./UniGB-UTF16-V.bcmap": [
		"0PdA",
		37
	],
	"./UniGB-UTF32-H.bcmap": [
		"nl8J",
		36
	],
	"./UniGB-UTF32-V.bcmap": [
		"k/6v",
		35
	],
	"./UniGB-UTF8-H.bcmap": [
		"5y08",
		34
	],
	"./UniGB-UTF8-V.bcmap": [
		"Mx+T",
		33
	],
	"./UniJIS-UCS2-H.bcmap": [
		"h4hU",
		32
	],
	"./UniJIS-UCS2-HW-H.bcmap": [
		"Uz5R",
		31
	],
	"./UniJIS-UCS2-HW-V.bcmap": [
		"LdTY",
		30
	],
	"./UniJIS-UCS2-V.bcmap": [
		"cBwd",
		29
	],
	"./UniJIS-UTF16-H.bcmap": [
		"+S0o",
		28
	],
	"./UniJIS-UTF16-V.bcmap": [
		"VEBc",
		27
	],
	"./UniJIS-UTF32-H.bcmap": [
		"m4Cs",
		26
	],
	"./UniJIS-UTF32-V.bcmap": [
		"dWl0",
		25
	],
	"./UniJIS-UTF8-H.bcmap": [
		"leWl",
		24
	],
	"./UniJIS-UTF8-V.bcmap": [
		"ulcQ",
		23
	],
	"./UniJIS2004-UTF16-H.bcmap": [
		"fZfZ",
		22
	],
	"./UniJIS2004-UTF16-V.bcmap": [
		"yeFf",
		21
	],
	"./UniJIS2004-UTF32-H.bcmap": [
		"StCN",
		20
	],
	"./UniJIS2004-UTF32-V.bcmap": [
		"4axz",
		19
	],
	"./UniJIS2004-UTF8-H.bcmap": [
		"petH",
		18
	],
	"./UniJIS2004-UTF8-V.bcmap": [
		"ebP/",
		17
	],
	"./UniJISPro-UCS2-HW-V.bcmap": [
		"bJiI",
		16
	],
	"./UniJISPro-UCS2-V.bcmap": [
		"eCeG",
		15
	],
	"./UniJISPro-UTF8-V.bcmap": [
		"gGQY",
		14
	],
	"./UniJISX0213-UTF32-H.bcmap": [
		"yvQh",
		13
	],
	"./UniJISX0213-UTF32-V.bcmap": [
		"/rlZ",
		12
	],
	"./UniJISX02132004-UTF32-H.bcmap": [
		"0dQZ",
		11
	],
	"./UniJISX02132004-UTF32-V.bcmap": [
		"+GS9",
		10
	],
	"./UniKS-UCS2-H.bcmap": [
		"fGKg",
		9
	],
	"./UniKS-UCS2-V.bcmap": [
		"X3cO",
		8
	],
	"./UniKS-UTF16-H.bcmap": [
		"TMpY",
		7
	],
	"./UniKS-UTF16-V.bcmap": [
		"hTx4",
		6
	],
	"./UniKS-UTF32-H.bcmap": [
		"kbYn",
		5
	],
	"./UniKS-UTF32-V.bcmap": [
		"t4S0",
		4
	],
	"./UniKS-UTF8-H.bcmap": [
		"6InH",
		3
	],
	"./UniKS-UTF8-V.bcmap": [
		"oEkN",
		2
	],
	"./V.bcmap": [
		"xBln",
		1
	],
	"./WP-Symbol.bcmap": [
		"A12k",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "/Djd";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "/K38":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/XvZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/cf8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/vcd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue
//
//
//
//
//
//
//

/* harmony default export */ var streetViewPanorama = ((function (x) {
  return x.default || x;
})(__webpack_require__("8ebl")));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f7f8d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_streetViewPanorama = (esExports);
// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue
function injectStyle (ssrContext) {
  __webpack_require__("EhHL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  streetViewPanorama,
  components_streetViewPanorama,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dist_components_streetViewPanorama = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "07H3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./src/components/chat/dialog/CheckBrowserDialog.vue + 2 modules
var CheckBrowserDialog = __webpack_require__("Se0g");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/agora_call/ans_call.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ans_call = ({
  props: {
    AgoraCallDialog: Boolean,
    infor_call: {},
    tokenuser: String,
    AgoraOption: String
  },
  components: {
    CheckBrowserDialog: CheckBrowserDialog["a" /* default */]
  },
  data: function data() {
    return {
      checkBrowserInfor: {},
      checkBrowserDialog: false
    };
  },

  watch: {
    AgoraCallDialog: function AgoraCallDialog() {
      if (this.AgoraCallDialog) {
        console.log(this.infor_call);
        var soundRingtone = document.getElementById('soundRingtone');
        soundRingtone.currentTime = 0;
        soundRingtone.play();
        // soundRingtone.loop = true
      }
    }
  },
  methods: {
    closeCheckBrowser: function closeCheckBrowser(value) {
      this.checkBrowserDialog = value;
      this.checkBrowserInfor = {};
    },
    closedialog: function closedialog() {
      this.$emit('decline_call', this.infor_call);
      this.$emit('closeAgoraDialog', false);
    },
    accept_call: function accept_call() {
      var _this = this;

      var soundRingtone = document.getElementById('soundRingtone');
      soundRingtone.pause();
      soundRingtone.currentTime = 0;

      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/join-agora', {
        tokenroom: this.infor_call.tokenroom,
        tokenmessage: this.infor_call.tokenmessage,
        tokenuser: this.tokenuser
      }).then(function (response) {
        // console.log(response.data)
        _this.$emit('closeAgoraDialog', false);
        _this.checkBrowser(url);
      }).catch(function (error) {
        console.log(error);
      });
    },
    checkBrowser: function checkBrowser(url) {
      // console.log(url)
      // Get the user-agent string
      var userAgentString = navigator.userAgent;
      // Detect Chrome
      var chromeAgent = userAgentString.indexOf("Chrome") > -1;
      // Detect Internet Explorer
      var IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
      // Detect Firefox
      var firefoxAgent = userAgentString.indexOf("Firefox") > -1;
      // Detect Safari
      var safariAgent = userAgentString.indexOf("Safari") > -1;
      // Discard Safari since it also matches Chrome
      var operaAgent = userAgentString.indexOf("OP") > -1;
      // console.log('firefox = > ' + firefoxAgent)
      // console.log('ie = > ' + IExplorerAgent)
      // console.log('chrome = > ' + chromeAgent)
      // console.log('opera = > ' + operaAgent)
      // console.log('safari = > ' + safariAgent)
      if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
        this.checkBrowserInfor = {
          url: url,
          payload: ''
        };
        this.checkBrowserDialog = true;
      } else if (safariAgent === true && chromeAgent === true) {
        window.open(url, '_blank');
      } else if (safariAgent === true) {
        this.checkBrowserInfor = {
          url: url,
          payload: ''
        };
        this.checkBrowserDialog = true;
      } else {
        window.open(url, '_blank');
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2838859d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/agora_call/ans_call.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"width":"500","persistent":""},model:{value:(_vm.AgoraCallDialog),callback:function ($$v) {_vm.AgoraCallDialog=$$v},expression:"AgoraCallDialog"}},[_c('v-card',{staticStyle:{"height":"350px !important"}},[_c('v-card-text',[_c('v-layout',{staticStyle:{"height":"230px !important"},attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":100}},[(_vm.infor_call.path_pic)?_c('img',{staticClass:"img-w-h",attrs:{"src":_vm.infor_call.path_pic}}):_c('img',{staticClass:"img-w-h",attrs:{"src":"/static/img/default_profile/bot-white.png"}})]),_vm._v(" "),_c('h2',{staticClass:"text-overflow mt-3"},[_vm._v(_vm._s(_vm.infor_call.nickname))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"border-radius",attrs:{"color":"primary"},on:{"click":function($event){_vm.accept_call()}}},[_vm._v("รับสาย")]),_vm._v(" "),_c('v-btn',{staticClass:"border-radius",attrs:{"dark":"","color":"red"},on:{"click":function($event){_vm.closedialog()}}},[_vm._v("ปฏิเสธ")])],1)],1)],1)],1),_vm._v(" "),_c('audio',{attrs:{"src":"/static/sound/sound_1.mp3","id":"soundRingtone","loop":""}}),_vm._v(" "),_c('CheckBrowserDialog',{attrs:{"checkBrowserDialog":_vm.checkBrowserDialog,"checkBrowserInfor":_vm.checkBrowserInfor},on:{"closeCheckBrowser":_vm.closeCheckBrowser}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var agora_call_ans_call = (esExports);
// CONCATENATED MODULE: ./src/components/chat/agora_call/ans_call.vue
function injectStyle (ssrContext) {
  __webpack_require__("TMdv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ans_call,
  agora_call_ans_call,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var chat_agora_call_ans_call = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0JUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_reader__ = __webpack_require__("ikHa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_qrcode_reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_qrcode__ = __webpack_require__("8Vd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mobile_dialog_InforfriendDialogMobile__ = __webpack_require__("gbCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_100vh__ = __webpack_require__("hErE");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_qrcode__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_qrcode__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dialogQrcodRichMenu: Boolean,
    tokenroom: String,
    QrcodeInfor: {}
  },
  components: {
    QrcodeStream: __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_reader__["QrcodeStream"],
    QrcodeDropZone: __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_reader__["QrcodeDropZone"],
    QrcodeCapture: __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_reader__["QrcodeCapture"],
    InforfriendDialogMobile: __WEBPACK_IMPORTED_MODULE_6__components_mobile_dialog_InforfriendDialogMobile__["a" /* default */],
    vue100vh: __WEBPACK_IMPORTED_MODULE_7_vue_100vh__["a" /* default */]
  },
  data: function data() {
    return {
      result: '',
      noStreamApiSupport: false,
      tab: 'tab-2',
      tokenuserQR: '',
      tokenuser: '',
      name: '',
      camera: 'auto',
      noRearCamera: false,
      noFrontCamera: false,
      tokeninforfriend: '',
      inforfrienddialog: false,
      type: '',
      alert_message: ''
    };
  },
  created: function created() {
    this.name = localStorage.getItem('name');
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    this.tokenuserQR = "https://uatchat.one.th" + '/qrcode/friend?id=' + btoa(this.tokenuser);
    this.camera = 'off';
  },

  watch: {
    tab: function tab() {
      if (this.tab == 'tab-2') {
        this.camera = 'auto';
      } else {
        this.camera = 'off';
      }
    },
    dialogQrcodRichMenu: function dialogQrcodRichMenu() {
      // console.log(this.dialogQrcodRichMenu)
      // console.log(this.tokenroom)
      if (this.dialogQrcodRichMenu) {
        this.camera = 'auto';
      } else {
        this.camera = 'off';
      }
    }
  },
  // mounted: {
  //   onInit () {
  //     this.onInit()
  //   }
  // },
  methods: {
    // upfile () {
    //   $('#qrcode-capture-mobile').click()
    // },
    upfileqrcode: function upfileqrcode() {
      $('#qrcode-capture-mobile').click();
      // $('#inputfile').click()
    },
    closeInforfriend: function closeInforfriend() {
      this.inforfrienddialog = false;
      this.tokeninforfriend = '';
      this.result = '';
    },
    toPage: function toPage() {
      // this.$router.push('/mobile/homepage')
      this.camera = 'off';
      this.$emit('closedialogQrcode', false);
    },
    onDecode: function onDecode(result) {
      // console.log(result)
      // alert(result)
      this.result = result;
      if (this.result != '') {
        // this.checkonechat(result)
        this.sendScanQrcode(result);
      } else {
        // alert(result)
        console.log(result);
      }
    },
    sendScanQrcode: function sendScanQrcode(url) {
      var _this = this;

      if (this.QrcodeInfor.status === 'false') {
        this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/qrcode-scan', {
          tokenuser: this.tokenuser,
          tokenroom: this.tokenroom,
          data: url
        }).then(function (response) {
          // console.log(response.data)
          if (response.data.status === 'success') {
            // this.$swal('', 'ส่งข้อมูลสำเร็จ', 'success')
            _this.$swal('', _this.$t('Alert.Success.success'), 'success');
            _this.toPage();
          }
        }).catch(function (error) {
          console.log(error);
          _this.$swal('Network error', _this.$t('Alert.Fail.default.networkError'), 'error');
        });
      } else {
        this.axios.post(Object({"NODE_ENV":"uat","API":"https://uatchat.one.th","APIQRcode":"https://uatchat.one.th","APIpub":"https://uatchat-manage.one.th/event","APIimage":"https://uatchat-manage.one.th/message","APIsocket":"https://uatchat-public.one.th:8998","APImanage":"https://uatchat-manage.one.th/manage","ONEID_API":"https://testoneid.inet.co.th/api","WEBchatdev":"https://uatchat.one.th:8089/docs","Bot_idPaperless":"B0df132b88f9a526691a0576bfdb24196","Bot_idcovid":"Bbe2c9fe1bcc956738a61c9ad0d91cb19","taxid_consent":"0107544000094","serviceid_consent":"SVC-1611218040238","formid_consent":"600956682f8678001cce54e8","AuthenOneid":"https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect","LogoutOneid":"https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage","redirect_url":"https://uatchat.one.th/authorization/redirect","Market_env":"staging","APInew_listchat":"https://uatchat-manage.one.th/go_api/api/v4/getListChat","APInew_getdict":"https://uatchat-manage.one.th/alpine/api/v1/getdictmessage","APInew_pushmessage":"https://uatchat-manage.one.th/alpine/api/v1/pushMessage","APInew_getaccesstoken":"https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken","APInew_getrichmenu":"https://uatchat-manage.one.th/go_api/api/v1/getRichmenuByTokenroom","APInew_addfriend":"https://uatchat-manage.one.th/go_api/api/v1/add-friend","APIcheck_consent":"https://uatapigw.appsdigit.inet.co.th/api/chat/service/check-consent","APInew_pushvideo":"https://uatchat-manage.one.th/media/api/v1/send-video","APInew_acceptfriend":"https://uatchat-manage.one.th/go_api/api/v1/accept-friend","APInew_creategroup":"https://uatchat-manage.one.th/go_api/api/v1/create-group","APIalpine":"https://uatchat-manage.one.th/alpine","APIgo_api":"https://uatchat-manage.one.th/go_api/api","WEBoneEmail":"https://testoneid.inet.co.th/preauth","WEBoneBox":"https://testoneid.inet.co.th/oauth/authorize?client_id=155&response_type=code&scope=account","WEBNews":"https://news.chat.korkla.in/checkauthen?authen=","WEB_Redirect_Onebox":"https://uatbox.one.th/loginbysharetoken?token=","WebAnonymous":"https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token=","Savelognews":"https://news.chat.one.th/backend/api/v1/page-analytics","urlEkyc":"https://uat-ekyc.id.th/redirect-share-token?shared_token=","linkonemeet":"https://meet-test.one.th/?sharetoken=","API_onemeet":"https://meet-test.one.th/","WEB_centrifuge":"wss://uatchat-manage.one.th/connection/websocket","centrifuge_key":'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs',"APIsearchfriend":"https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend","urlLoa":"https://testoneid.inet.co.th/login?redirect_url=https://testoneid.inet.co.th/portal_level&shared_token=","check_password":"https://uatchat-manage.one.th/bot-message/check"}).APIQRcodeLoation, {
          tokenuser: this.tokenuser,
          tokenroom: this.tokenroom,
          data: url,
          lat: this.QrcodeInfor.lat,
          long: this.QrcodeInfor.lng,
          address: this.QrcodeInfor.address
        }).then(function (response) {
          // console.log(response.data)
          if (response.data.status === 'success') {
            // this.$swal('', 'ส่งข้อมูลสำเร็จ', 'success')
            _this.$swal('', _this.$t('Alert.Success.success'), 'success');
            _this.toPage();
          }
        }).catch(function (error) {
          console.log(error);
          _this.$swal('Network error', _this.$t('Alert.Fail.default.networkError'), 'error');
        });
      }
    },
    checkonechat: function checkonechat(url) {
      var _this2 = this;

      // console.log(url)
      if (url.includes("https://uatchat.one.th" + '/qrcode/friend?id=')) {
        var code = url.split("https://uatchat.one.th" + '/qrcode/friend?id=');
        this.tokeninforfriend = atob(code[1]);
        // console.log(this.tokeninforfriend)
        localStorage.setItem('typefriend', 'friend');
        this.$router.push('/mobile/profilefriend/' + this.tokeninforfriend);
        // this.type = 'friend'
        // this.inforfrienddialog = true
      } else if (url.includes("https://uatchat.one.th" + '/qrcode/group?id=')) {
        var code = url.split("https://uatchat.one.th" + '/qrcode/group?id=');
        this.tokeninforfriend = atob(code[1]);
        // console.log(this.tokeninforfriend)
        // this.type = 'group'
        // this.inforfrienddialog = true
        localStorage.setItem('typefriend', 'group');
        this.$router.push('/mobile/profilefriend/' + this.tokeninforfriend);
      } else {
        this.$swal({
          text: this.$t('Settings.Qrcode.resultScan') + url,
          showCancelButton: true,
          confirmButtonColor: '#2562af',
          cancelButtonColor: '#9f9f9f',
          confirmButtonText: this.$t('AnswerQuestion.open'),
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then(function (result) {
          if (result.value) {
            window.open(url);
            _this2.closeInforfriend();
          } else {
            _this2.closeInforfriend();
          }
        });
      }
    },
    logErrors: function logErrors(promise) {
      promise.catch(console.error);
    },
    loadqr: function loadqr() {
      var cnvs = document.getElementById('downloadqruser');
      var button = document.getElementById('btn-download-user');
      var dataURL = cnvs.toDataURL('image/png');
      button.href = dataURL;
    },
    closeCamera: function closeCamera() {
      // console.log('obj')
      this.camera = 'off';
    },
    switchCamera: function switchCamera() {
      // console.log(this.camera)
      switch (this.camera) {
        case 'front':
          this.camera = 'auto';
          // console.log(this.camera)
          // alert(this.camera)
          break;
        case 'rear':
          this.camera = 'auto';
          // console.log(this.camera)
          // alert(this.camera)
          break;
        case 'auto':
          this.camera = 'front';
          // console.log(this.camera)
          // alert(this.camera)
          break;
      }
    },
    onInit: function onInit(promise) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var triedFrontCamera, triedRearCamera, cameraMissingError;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return promise;

              case 3:
                _context.next = 13;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context['catch'](0);

                // console.log(error)
                // console.log(error.name)
                // alert(error)
                triedFrontCamera = _this3.camera === 'front';
                triedRearCamera = _this3.camera === 'rear';
                cameraMissingError = _context.t0.name === 'OverconstrainedError';


                if (triedRearCamera && cameraMissingError) {
                  _this3.noRearCamera = true;
                }

                if (triedFrontCamera && cameraMissingError) {
                  _this3.noFrontCamera = true;
                }
                if (_context.t0.name === 'StreamApiNotSupportedError') {
                  _this3.noStreamApiSupport = true;
                } else if (_context.t0.name === 'NotAllowedError') {
                  // console.log('กรุณาอนุญาตการใช้งานกล้อง')
                  _this3.alert_message = 'NotAllowedError';
                  // if('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices){
                  //   navigator.permissions.query({name: 'camera'})
                  //    .then((permissionObj) => {
                  //     console.log(permissionObj)
                  //     console.log(permissionObj.state)
                  //    })
                  //    .catch((error) => {
                  //     console.log('Got error :', error)
                  //    })
                  // }
                }

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 5]]);
      }))();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "0j5f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/chat/dialog/ShowImage_ProfileDialog.vue + 2 modules
var ShowImage_ProfileDialog = __webpack_require__("sVBg");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/notes/NoteDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var NoteDialog = ({
  props: {
    dialogNote: false,
    note_id: '',
    statemember: String
  },
  data: function data() {
    return {
      datanote: { note_data: { text: 'test' } },
      token: '',
      edit: false,
      edittext: '',
      preedittext: '',
      progress: true,
      status: 'show',
      errormessage: '',
      dialogshowimage_profile: false,
      pathpicture: '',
      typepathpicture: '',
      show: false,
      block_st: ''
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    // console.log(this.note_id)
    // console.log(this.status_block)
  },

  components: {
    ShowImageProfileDialog: ShowImage_ProfileDialog["a" /* default */]
  },
  mounted: function mounted() {},

  methods: {
    clickedit: function clickedit() {
      this.edit = !this.edit;
      this.show = false;
    },
    openPictureProfile: function openPictureProfile(picture, type) {
      this.pathpicture = picture;
      this.typepathpicture = type;
      this.dialogshowimage_profile = true;
    },
    closeDialogShowImage_Profile: function closeDialogShowImage_Profile(value) {
      this.dialogshowimage_profile = value;
    },
    closeDialog: function closeDialog() {
      this.$emit('closeNote', false);
      this.edit = false;
    },
    remove: function remove() {
      var _this = this;

      this.show = false;
      this.$swal({
        text: this.$t('Alert.Right.removeNote'),
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this.axios.post("https://uatchat-manage.one.th/manage" + '/removenote', { note_id: _this.note_id, tokenuser: _this.token }).then(function (response) {
            if (response.data.status === 'success') {
              _this.status = 'error';
              _this.errormessage = _this.$t('Dialog.note.noNote');
              _this.$emit('removeNote', _this.note_id);
              _this.closeDialog();
            } else {
              _this.$swal('', _this.$t('Alert.Fail.default.somethingWrong'), 'error');
            }
          });
        }
      });
    },
    save: function save() {
      var _this2 = this;

      this.edit = false;
      if (this.edittext !== this.preedittext) {
        this.datanote.note_data.text = this.edittext;
        this.preedittext = this.edittext;
        this.axios.post("https://uatchat-manage.one.th/manage" + '/editnote', { note_id: this.note_id, tokenuser: this.token, text: this.edittext }).then(function (response) {
          if (response.data.status === 'success') {
            // console.log(response.data)
            _this2.$emit('editNote', _this2.edittext, _this2.note_id);
          } else {
            _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
          }
        }, function () {
          _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
        });
      }
    },
    cancel: function cancel() {
      this.edit = false;
      this.edittext = this.preedittext;
    },
    date: function date(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    time: function time(timestamp) {
      return services["c" /* Momenttime */].momenttimethai(timestamp);
    },
    convert: function convert(msg) {
      var text = msg;
      var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/\\%?=~_|!:,.;]*[-A-Z0-9+&@#/\\%=~_|])/ig;
      var text1 = text.replace(/</g, '&lt;');
      var text2 = text1.replace(/>/g, '&gt;');
      var text3 = text2.replace(exp, '<a target="_blank" href="$1">$1</a>');
      var exp2 = /(^|[^/\\])(www\.[\S]+(\b|$))/gim;
      var text4 = text3.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
      return text4;
    }
  },
  watch: {
    dialogNote: function dialogNote() {
      var _this3 = this;

      if (this.dialogNote) {
        console.log(this.statemember);
        // this.datanote.note_data.text = 'test'
        this.progress = true;
        this.status = 'progress';
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getnote', { note_id: this.note_id }).then(function (response) {
          if (response.data.list_note.length !== 0) {
            _this3.status = 'show';
            _this3.progress = false;
            _this3.datanote = response.data.list_note[0];
            _this3.edittext = response.data.list_note[0].note_data.text;
            _this3.preedittext = response.data.list_note[0].note_data.text;
          } else {
            _this3.progress = false;
            _this3.status = 'error';
            _this3.errormessage = _this3.$t('Dialog.note.noNote');
          }
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-603b6e20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/notes/NoteDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"max-width":"500px","persistent":"","max-height":"500px"},model:{value:(_vm.dialogNote),callback:function ($$v) {_vm.dialogNote=$$v},expression:"dialogNote"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-sticky-note")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.note.headerNote')))],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.token == _vm.datanote.owner && !_vm.edit)?_c('div',[(_vm.statemember != 'block')?_c('header',{staticClass:"headerUser",staticStyle:{"z-index":"8 !important"},attrs:{"id":"headerMenubarUser"}},[_c('nav',{staticClass:"headerUser__nav"},[_c('ul',{staticClass:"headerUser__navbar"},[_c('li',{staticClass:"headerUser__item"},[_c('a',{staticClass:"headerUser__link",attrs:{"href":"#"}},[_c('button',{key:"off",staticClass:"headerUser--btn",on:{"click":function($event){_vm.show = !_vm.show}}},[_c('v-icon',{staticClass:"headerUser--icon"},[_vm._v("more_vert")])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"dropdown"}},[(_vm.show)?_c('div',{staticClass:"headerUser__dropdown-menu",class:{ active: _vm.show }},[_c('ul',{staticClass:"headerUser__dropdown-menu-nav"},[_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.clickedit()}}},[_c('a',{staticClass:"header__dropdown-menu-link",attrs:{"href":"#"}},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu font-size15",attrs:{"meduim":""}},[_vm._v("mdi-pencil")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                                 "+_vm._s(_vm.$t('AnswerQuestion.edit'))+"\n                               ")])])]),_vm._v(" "),_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":_vm.remove}},[_c('a',{staticClass:"header__dropdown-menu-link",attrs:{"href":"#"}},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu font-size15",attrs:{"meduim":""}},[_vm._v("far fa-trash-alt")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                                 "+_vm._s(_vm.$t('AnswerQuestion.remove'))+"\n                               ")])])])])]):_vm._e()])],1)])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"30px"}},[(_vm.status == 'progress')?_c('v-progress-linear',{attrs:{"indeterminate":_vm.progress}}):(_vm.status == 'show')?_c('div',[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[_c('v-avatar',{staticClass:"user-photonote",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.openPictureProfile(_vm.datanote.profilepicture, _vm.datanote.type)}}},[(_vm.datanote.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.datanote.profilepicture}}):(_vm.datanote.type ==='business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.datanote.type ==='bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"text2",staticStyle:{"font-size":"18px","padding-left":"10px","padding-top":"10px"}},[_vm._v(_vm._s(_vm.datanote.nickname))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","position":"absolute","right":"10px","color":"#5a616b !important"}},[_vm._v("\n            "+_vm._s(_vm.date(_vm.datanote.create_date))+" "+_vm._s(_vm.time(_vm.datanote.create_date))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"200px","min-height":"100px","margin-top":"10px","word-break":"break-all"}},[(_vm.edit)?_c('div',{staticStyle:{"width":"100%"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.edittext),expression:"edittext"}],staticClass:"scrolling-wrapper",staticStyle:{"resize":"none","width":"100%","height":"150px","background":"#1a222b12","padding":"20px","border-radius":"15px"},domProps:{"value":(_vm.edittext)},on:{"input":function($event){if($event.target.composing){ return; }_vm.edittext=$event.target.value}}})]):_c('p',{domProps:{"innerHTML":_vm._s(_vm.convert(_vm.datanote.note_data.text ).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})]),_vm._v(" "),_c('div',[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{staticStyle:{"padding-right":"10px"},attrs:{"align-center":"","justify-end":"","row":"","wrap":""}},[(_vm.token == _vm.datanote.owner && _vm.edit)?_c('v-btn',{staticClass:"btncancel CSChatThai",on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[(_vm.token == _vm.datanote.owner && _vm.edit)?_c('v-btn',{staticClass:"btnallow CSChatThai",attrs:{"disabled":_vm.edittext == _vm.preedittext},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                ")]):_vm._e()],1)],1)],1)],1)],1):(_vm.status == 'error')?_c('div',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#757575 !important","font-size":"80px !important"}},[_vm._v("error_outline")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"font-size":"20px","color":"#757575"}},[_vm._v(" "+_vm._s(_vm.errormessage)+" ")])],1):_vm._e()],1)],1),_vm._v(" "),_c('ShowImageProfileDialog',{attrs:{"dialogshowimage_profile":_vm.dialogshowimage_profile,"pathpicture":_vm.pathpicture,"typepathpicture":_vm.typepathpicture},on:{"closeDialogShowImage_Profile":_vm.closeDialogShowImage_Profile}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var notes_NoteDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/notes/NoteDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("XJSl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-603b6e20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  NoteDialog,
  notes_NoteDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_notes_NoteDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0l21":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0p/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_reader__ = __webpack_require__("ikHa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_qrcode_reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_qrcode__ = __webpack_require__("8Vd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mobile_dialog_InforfriendDialogMobile__ = __webpack_require__("gbCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_100vh__ = __webpack_require__("hErE");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_qrcode__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_qrcode__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    QrcodeStream: __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_reader__["QrcodeStream"],
    QrcodeDropZone: __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_reader__["QrcodeDropZone"],
    QrcodeCapture: __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_reader__["QrcodeCapture"],
    InforfriendDialogMobile: __WEBPACK_IMPORTED_MODULE_6__components_mobile_dialog_InforfriendDialogMobile__["a" /* default */],
    vue100vh: __WEBPACK_IMPORTED_MODULE_7_vue_100vh__["a" /* default */]
  },
  data: function data() {
    return {
      result: '',
      noStreamApiSupport: false,
      tab: 'tab-1',
      tokenuserQR: '',
      tokenuser: '',
      name: '',
      camera: 'auto',
      noRearCamera: false,
      noFrontCamera: false,
      tokeninforfriend: '',
      inforfrienddialog: false,
      type: '',
      alert_message: ''
    };
  },
  created: function created() {
    this.name = localStorage.getItem('name');
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    this.tokenuserQR = "https://uatchat.one.th" + '/qrcode/friend?id=' + btoa(this.tokenuser);
    this.camera = 'off';
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
  },

  watch: {
    tab: function tab() {
      if (this.tab == 'tab-1') {
        this.camera = 'off';
      } else {
        this.camera = 'auto';
      }
    }
  },
  // mounted: {
  //   onInit () {
  //     this.onInit()
  //   }
  // },
  methods: {
    // upfile () {
    //   $('#qrcode-capture-mobile').click()
    // },
    upfileqrcode: function upfileqrcode() {
      $('#qrcode-capture-mobile').click();
      // $('#inputfile').click()
    },
    closeInforfriend: function closeInforfriend() {
      this.inforfrienddialog = false;
      this.tokeninforfriend = '';
      this.result = '';
    },
    toPage: function toPage() {
      this.$router.push('/mobile/homepage');
    },
    onDecode: function onDecode(result) {
      // console.log(result)
      // alert(result)
      this.result = result;
      if (this.result != '') {
        this.checkonechat(result);
      } else {
        alert(result);
      }
    },
    checkonechat: function checkonechat(url) {
      var _this = this;

      // console.log(url)
      if (url.includes("https://uatchat.one.th" + '/qrcode/friend?id=')) {
        var code = url.split("https://uatchat.one.th" + '/qrcode/friend?id=');
        this.tokeninforfriend = atob(code[1]);
        // console.log(this.tokeninforfriend)
        localStorage.setItem('typefriend', 'friend');
        this.$router.push('/mobile/profilefriend/' + this.tokeninforfriend);
        // this.type = 'friend'
        // this.inforfrienddialog = true
      } else if (url.includes("https://uatchat.one.th" + '/qrcode/group?id=')) {
        var code = url.split("https://uatchat.one.th" + '/qrcode/group?id=');
        this.tokeninforfriend = atob(code[1]);
        // console.log(this.tokeninforfriend)
        // this.type = 'group'
        // this.inforfrienddialog = true
        localStorage.setItem('typefriend', 'group');
        this.$router.push('/mobile/profilefriend/' + this.tokeninforfriend);
      } else {
        this.$swal({
          text: this.$t('Settings.Qrcode.resultScan') + url,
          showCancelButton: true,
          confirmButtonColor: '#2562af',
          cancelButtonColor: '#9f9f9f',
          confirmButtonText: this.$t('AnswerQuestion.open'),
          cancelButtonText: this.$t('AnswerQuestion.ok'),
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then(function (result) {
          if (result.value) {
            window.open(url);
            _this.closeInforfriend();
          } else {
            _this.closeInforfriend();
          }
        });
      }
    },
    logErrors: function logErrors(promise) {
      promise.catch(console.error);
    },
    loadqr: function loadqr() {
      var cnvs = document.getElementById('downloadqruser');
      var button = document.getElementById('btn-download-user');
      var dataURL = cnvs.toDataURL('image/png');
      button.href = dataURL;
    },
    closeCamera: function closeCamera() {
      // console.log('obj')
      this.camera = 'off';
    },
    switchCamera: function switchCamera() {
      // console.log(this.camera)
      switch (this.camera) {
        case 'front':
          this.camera = 'auto';
          // console.log(this.camera)
          // alert(this.camera)
          break;
        case 'rear':
          this.camera = 'auto';
          // console.log(this.camera)
          // alert(this.camera)
          break;
        case 'auto':
          this.camera = 'front';
          // console.log(this.camera)
          // alert(this.camera)
          break;
      }
    },
    onInit: function onInit(promise) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var triedFrontCamera, triedRearCamera, cameraMissingError;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return promise;

              case 3:
                _context.next = 13;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context['catch'](0);

                // console.log(error)
                // console.log(error.name)
                // alert(error)
                triedFrontCamera = _this2.camera === 'front';
                triedRearCamera = _this2.camera === 'rear';
                cameraMissingError = _context.t0.name === 'OverconstrainedError';


                if (triedRearCamera && cameraMissingError) {
                  _this2.noRearCamera = true;
                }

                if (triedFrontCamera && cameraMissingError) {
                  _this2.noFrontCamera = true;
                }
                if (_context.t0.name === 'StreamApiNotSupportedError') {
                  _this2.noStreamApiSupport = true;
                } else if (_context.t0.name === 'NotAllowedError') {
                  // console.log('กรุณาอนุญาตการใช้งานกล้อง')
                  _this2.alert_message = 'NotAllowedError';
                  // if('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices){
                  //   navigator.permissions.query({name: 'camera'})
                  //    .then((permissionObj) => {
                  //     console.log(permissionObj)
                  //     console.log(permissionObj.state)
                  //    })
                  //    .catch((error) => {
                  //     console.log('Got error :', error)
                  //    })
                  // }
                }

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 5]]);
      }))();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "0xP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/CreateNoteDialogMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { Momenttime } from '@/services'


/* harmony default export */ var CreateNoteDialogMobile = ({
  props: { dialogCreatenote: false, tokenroom: '' },
  data: function data() {
    return {
      tokenuser: '',
      edittext: '',
      loading: false
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
  },

  methods: {
    closeDialog: function closeDialog() {
      this.edittext = '';
      this.$emit('closeCreatenote', false);
    },
    save: function save() {
      var _this = this;

      this.loading = true;
      if (/\S/.test(this.edittext)) {
        // console.log('not empty')
        this.axios.post("https://uatchat-manage.one.th/manage" + '/createnote', { tokenuser: this.tokenuser, text: this.edittext, tokenroom: this.tokenroom }).then(function (response) {
          if (response.data.status === 'success') {
            _this.loading = false;
            // console.log(response.data)
            _this.$swal('', _this.$t('Alert.Success.createNote'), 'success');
            _this.$emit('CreateNote', 'success', response.data.create_date, response.data.note_id, response.data.tokenroom, response.data.update_date, _this.edittext);
            _this.closeDialog();
          } else {
            _this.loading = false;
            _this.$swal('Network error', _this.$t('Alert.Fail.default.networkError'), 'error');
          }
        }).catch(function (err) {
          _this.loading = false;
          _this.$swal('Network error', _this.$t('Alert.Fail.default.networkError'), 'error');
        });
      }
    }
  },
  watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47522506","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/CreateNoteDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow":"hidden !important"},attrs:{"max-width":"500px","persistent":"","max-height":"500px"},model:{value:(_vm.dialogCreatenote),callback:function ($$v) {_vm.dialogCreatenote=$$v},expression:"dialogCreatenote"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-sticky-note")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.note.headerCreate')))],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.edittext),expression:"edittext"}],staticStyle:{"width":"100%","height":"200px","background":"#1a222b12","padding":"20px"},domProps:{"value":(_vm.edittext)},on:{"input":function($event){if($event.target.composing){ return; }_vm.edittext=$event.target.value}}})]),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{staticStyle:{"padding-right":"10px"},attrs:{"align-center":"","justify-end":"","row":"","wrap":""}},[_c('v-btn',{staticClass:"btncancel text-transform",attrs:{"dark":""},on:{"click":_vm.closeDialog}},[_vm._v("\n              "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n            ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[(/\S/.test(_vm.edittext))?_c('v-btn',{staticClass:"btnallow text-transform",attrs:{"dark":"","loading":_vm.loading},on:{"click":_vm.save}},[_vm._v("\n              "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n            ")]):_c('v-btn',{staticClass:"btnallow text-transform",attrs:{"disabled":""}},[_vm._v("\n              "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_CreateNoteDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/CreateNoteDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("zM04")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47522506"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  CreateNoteDialogMobile,
  dialog_CreateNoteDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_CreateNoteDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0xXd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "15At":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1He0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1K1W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1QwG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Rv0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1eJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chat_dialog_manage_friend_AddFriendDialog__ = __webpack_require__("sSPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_pathify__ = __webpack_require__("YtWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__("+vOg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: { 'dialogGroup': false },
  data: function data() {
    return {
      loading: false,
      AddFriend: false,
      imageData: '',
      selectFile: '',
      token: '',
      selected: [],
      invites: [],
      idbusiness: [],
      GroupName: '',
      FriendList: [],
      searchfriend: '',
      listmember: [],
      step_creategroup: 1
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    FilterFriendList: function FilterFriendList() {
      var _this = this;

      if (this.searchfriend !== '' && this.searchfriend !== null) {
        return this.FriendList.filter(function (post) {
          return post.name.toLowerCase().includes(_this.searchfriend.toLowerCase());
        });
      } else {
        return this.FriendList;
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex_pathify__["c" /* sync */])('*')),
  watch: {
    dialogGroup: function dialogGroup() {
      var _this2 = this;

      if (this.dialogGroup) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistfriend', { tokenuser: this.token }).then(function (response) {
          // console.log(response.data)
          _this2.FriendList = response.data['listfriend'];
          _this2.selected = [];
        });
      }
    },
    socketaccept_friend: function socketaccept_friend(data) {
      var _this3 = this;

      // console.log(data)
      if (data.tokenuser === this.token) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', { owner: this.token, tokenuser: [data.tokenfriend] }).then(function (response) {
          var _ = __webpack_require__("M4fF");
          // update list friend after accept friend
          if (_.find(_this3.FriendList, function (o) {
            return o.tokenuser === response.data.user[0].tokenuser;
          }) === undefined) {
            _this3.FriendList.unshift({
              email: response.data.user[0].email,
              name: response.data.user[0].name,
              phone: response.data.user[0].phone,
              profilepicture: response.data.user[0].profilepicture,
              state: response.data.user[0].state,
              status: response.data.user[0].status,
              tokenuser: response.data.user[0].tokenuser,
              type: response.data.user[0].type,
              tokenroom: data.tokenroom
            });
            _this3.FriendList = _.orderBy(_this3.FriendList, ['name'], ['asc']);
          }
        });
      }
    }
  },
  components: {
    AddDialog: __WEBPACK_IMPORTED_MODULE_1__components_chat_dialog_manage_friend_AddFriendDialog__["a" /* default */]
  },
  methods: {
    removeListAddGroup: function removeListAddGroup(item) {
      this.selected.splice(this.selected.indexOf(item), 1);
    },
    showDialog: function showDialog(dialog) {
      if (dialog === 'AddFriend') {
        this.AddFriend = true;
      }
    },
    closeDialogAddFriend: function closeDialogAddFriend(value) {
      this.AddFriend = value;
    },
    uppic: function uppic() {
      $('#uploadpicgroupweb').click();
    },
    closeDialog: function closeDialog() {
      var self = this;
      this.$emit('closeDialogCreateGroup', false);
      this.invites = [];
      this.idbusiness = [];
      this.GroupName = '';
      this.selected = [];
      self.imageData = '';
      self.selectFile = '';
      document.getElementById('uploadpicgroupweb').value = '';
      this.loading = false;
    },
    previewImageweb: function previewImageweb(data) {
      var _this4 = this;

      var input = data.target;
      this.selectFile = data.target.files[0];
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this4.imageData = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    submit: function submit() {
      var _this5 = this;

      if (this.selected.length < 1) {
        this.$swal({
          title: this.$t('Alert.Fail.createGroup.title'),
          text: this.$t('Alert.Fail.createGroup.selectFriend'),
          type: 'warning',
          showCloseButton: true,
          reverseButtons: true
        });
      } else if (this.GroupName === '') {
        this.$swal({
          title: this.$t('Alert.Fail.createGroup.title'),
          text: this.$t('Alert.Fail.createGroup.groupname'),
          type: 'warning',
          showCloseButton: true,
          reverseButtons: true
        });
      } else {
        for (var i = 0; i < this.selected.length; i++) {
          this.invites[i] = this.selected[i].tokenuser;
          // this.idbusiness[i] = this.selected[i].business_id
          // this.listmember[i] = {tokenuser: this.invites[i], business_id: this.idbusiness[i]}
          if (i === this.selected.length - 1) {
            this.loading = true;
            // console.log(this.listmember)
            this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/create-group", { tokenuser: this.token, listmember: this.invites, group_name: this.GroupName }).then(function (response) {
              if (response.data.status === 'success') {
                // console.log(response.data)
                if (_this5.selectFile !== '') {
                  var uploadFile = new FormData();
                  uploadFile.append('file', _this5.selectFile, _this5.selectFile.name);
                  uploadFile.append('group_id', response.data.group.group_id);
                  uploadFile.append('tokenuser', _this5.token);
                  // console.log(uploadFile)
                  _this5.axios.post("https://uatchat-manage.one.th/manage" + '/setimagegroup', uploadFile).then(function (responsed) {
                    // console.log(responsed.data)
                    if (responsed.data.status === 'success') {
                      _this5.$swal(_this5.$t('Alert.Success.createGroup'), '', 'success');
                      // let self = this
                      _this5.selectFile = '';
                      _this5.imageData = '';
                      _this5.selected = [];
                      _this5.closeDialog();
                      document.getElementById('uploadpicgroupweb').value = '';
                      _this5.$emit('updatecreategroup', response.data.group, responsed.data.filename);
                      _this5.$emit('updatelistchat', response.data.group, responsed.data.filename);
                      _this5.loading = false;
                    }
                    _this5.$emit('closeDialogCreateGroup', false);
                  });
                } else {
                  // let self = this
                  _this5.$swal(_this5.$t('Alert.Success.createGroup'), '', 'success');
                  _this5.selectFile = '';
                  _this5.imageData = '';
                  _this5.selected = [];
                  _this5.closeDialog();
                  document.getElementById('uploadpicgroupweb').value = '';
                  _this5.$emit('closeDialogCreateGroup', false);
                  _this5.$emit('updatecreategroup', response.data.group, '');
                  _this5.$emit('updatelistchat', response.data.group, '');
                  _this5.loading = false;
                }
              } else {
                // console.log(response.data)
                _this5.loading = false;
              }
            });
          }
        }
      }
    }
  },
  created: function created() {
    var _this6 = this;

    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    // this.business_id = localStorage.getItem('business_id')
    // this.typeuser = localStorage.getItem('type_user')
    this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistfriend', { tokenuser: this.token }).then(function (response) {
      // console.log(response.data)
      _this6.FriendList = response.data['listfriend'];
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "20SD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chenfengyuan_vue_countdown__ = __webpack_require__("aCbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chenfengyuan_vue_countdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__chenfengyuan_vue_countdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_homepage_Navbar__ = __webpack_require__("6n5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mobile_dialog_DownloadAppMobile__ = __webpack_require__("a6yM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_chat_dialog_consent_consent_onechat_dialog__ = __webpack_require__("IWN4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_consent_new_consent__ = __webpack_require__("F8NA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex_pathify__ = __webpack_require__("YtWf");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import NewFooter from '@/components/home/NewFooter'
// import Vue from 'vue'


// import VueSocketio from 'vue-socket.io'
var _ = __webpack_require__("M4fF");
var Centrifuge = __webpack_require__("9wbP");
var centrifuge = new Centrifuge("wss://uatchat-manage.one.th/connection/websocket");

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_3__chenfengyuan_vue_countdown___default.a.name, __WEBPACK_IMPORTED_MODULE_3__chenfengyuan_vue_countdown___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      newConsentDialog: false,
      newConsentDetail: {},
      consentOnechatDialog: false,
      url_consent: '',
      usernameRules: [function (v) {
        return _this.regular_username_mobile();
      }],
      passwordRules: [function (v) {
        return _this.regular_pass_mobile();
      }],
      valid: '',
      username: '',
      password: '',
      status: '',
      friend: '',
      status_login: '',
      progress: false,
      failmessage: this.$t('Alert.Login.invalidUserPass'),
      webdev: "https://uatchat.one.th:8089/docs",
      showPassword: false,
      url_redirect: "https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect",
      // url_redirect: 'process.env.AuthenOneid',
      validmobile: '',
      type: 'first',
      phone: '',
      otpCode: '',
      Refcode: '',
      mobile_ref_id: '',
      type_otp: '',
      counting: false,
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex_pathify__["c" /* sync */])('*')),
  created: function created() {
    if (localStorage.getItem('Authenrization')) {
      this.status_login = JSON.parse(__WEBPACK_IMPORTED_MODULE_8__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')))['status_login'];
      var token = JSON.parse(__WEBPACK_IMPORTED_MODULE_8__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')))['tokenuser'];
      // console.log(this.status_login)
      this.connectCentrifuge(token);
      this.getOnechatToken(token);
      // if (this.status_login === 'T') {
      //   if (this.isMobile()) {
      //     this.$router.push('/mobile/homepage')
      //   } else {
      //     this.$router.push('/chat')
      //   }
      // }
    }
  },
  mounted: function mounted() {
    console.log('mounted: ', localStorage.tologin);
    if (localStorage.tologin) {
      this.type = 'phone';
      this.phone = localStorage.tologin;
    }
  },

  methods: {
    closeNewConsent: function closeNewConsent(value) {
      console.log("close new consent", value);
      this.newConsentDialog = value.close;
      this.newConsentDetail = {};
      // set localStorage authorization
      this.progress = true;
      localStorage.setItem('Authenrization', __WEBPACK_IMPORTED_MODULE_8__services__["b" /* Encode */].encode({ 'tokenuser': value.token, 'status_login': 'T', 'type_user': 'user' }));
      if (localStorage.getItem('botid_redirect') !== null) {
        this.progress = false;
        this.searchFriend(localStorage.getItem('botid_redirect'));
      } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
        this.progress = false;
        // redirect bot room with url
        var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
        this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + '&url=' + data.url);
      } else {
        this.progress = false;
        // console.log(`this.isMobile(): ${this.isMobile()}`)
        if (window.innerWidth <= 960) {
          this.$router.push('/mobile/homepage');
        } else {
          this.$router.push('/chat');
        }
      }
    },
    connectCentrifuge: function connectCentrifuge(token) {
      var me = this;
      var events = '';
      var data_msg = '';
      centrifuge.setToken('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs');
      centrifuge.subscribe(token, function (message) {
        console.log(message.data.event);
        events = message.data.event;
        if (events === 'consent') {
          // consent close dialog
          me.consentOnechatDialog = false;
          me.getOnechatToken(token);
        }
      });
      centrifuge.on('connect', function () {
        console.log("connected centrifuge login");
      });
      centrifuge.on('disconnect', function () {
        console.log("disconnected centrifuge login");
      });
      centrifuge.connect();
    },
    closeDialogConsentOnechat: function closeDialogConsentOnechat(value) {
      this.consentOnechatDialog = value;
    },
    getOnechatToken: function getOnechatToken(token) {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var hour = String(today.getHours() + 1).padStart(2, '0');
      var minute = String(today.getMinutes()).padStart(2, '0');
      var seconds = String(today.getSeconds()).padStart(2, '0');
      var milsec = today.getMilliseconds();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00';
        dd = String(today.getDate() + 1).padStart(2, '0');
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1';
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1';
            yyyy = today.getFullYear() + 1;
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0');
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
      // console.log(today)
      var expireddate = Date.parse(today);
      // console.log(expireddate)
      var body = __WEBPACK_IMPORTED_MODULE_8__services__["b" /* Encode */].encodeRichmenu({ 'userid': token, 'expired_date': expireddate });
      // console.log(body)
      this.progress = true;
      // check new consent
      if (this.$cookie.get('check-consent-' + token) === null || this.$cookie.get('check-consent-' + token) === undefined) {
        // test new consent
        this.progress = false;
        this.newConsentDialog = true;
        this.newConsentDetail = { token: token };
      } else {
        this.progress = false;
        // set localStorage authorization
        localStorage.setItem('Authenrization', __WEBPACK_IMPORTED_MODULE_8__services__["b" /* Encode */].encode({ 'tokenuser': token, 'status_login': 'T', 'type_user': 'user' }));
        if (localStorage.getItem('botid_redirect') !== null) {
          this.searchFriend(localStorage.getItem('botid_redirect'));
        } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
          // redirect bot room with url
          var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
          this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + '&url=' + data.url);
        } else {
          // console.log(`this.isMobile(): ${this.isMobile()}`)
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage');
          } else {
            this.$router.push('/chat');
          }
        }
      }

      // this.axios.post(process.env.APIgo_api + `/v1/get-consent`, { onechat_token: body }).then((response) => {
      //   // console.log(response.data)
      //   if (response.data.status === 'success') {
      //     this.progress = false
      //     if (response.data.data.consent_check === 'true') {
      //       // set localStorage authorization
      //       localStorage.setItem('Authenrization', Encode.encode({'tokenuser': token, 'status_login': 'T', 'type_user': 'user'}))
      //       if (localStorage.getItem('botid_redirect') !== null) {
      //         this.searchFriend(localStorage.getItem('botid_redirect'))
      //       } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
      //         // redirect bot room with url
      //         var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
      //         this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
      //       } else {
      //         // console.log(`this.isMobile(): ${this.isMobile()}`)
      //         if (window.innerWidth <= 960) {
      //           this.$router.push('/mobile/homepage')
      //         } else {
      //           this.$router.push('/chat')
      //         }
      //       }
      //     } else {
      //       // show dialog consent
      //       this.consentOnechatDialog = true
      //       this.url_consent = response.data.data.consent_url
      //       // clear localStorage autherization
      //       localStorage.removeItem('Authenrization')
      //       this.$router.push({path: '/login', force: true})
      //     }
      //   }
      // }).catch(err => {
      //   console.log(err)
      //   this.progress = false
      // })
    },
    handleCountdownEnd: function handleCountdownEnd() {
      this.OTP = '';
      this.counting = false;
    },
    open_link: function open_link(link) {
      window.open(link, '_blank');
    },
    otp: function otp() {
      var _this2 = this;

      this.loading = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/otp_login_and_regis', { phone: this.phone, type: 'login' }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          if (response.data.type_otp == 'login') {
            _this2.loading = false;
            _this2.Refcode = response.data.refcode;
            _this2.mobile_ref_id = response.data.mobile_ref_id;
            _this2.type_otp = response.data.type_otp;
            _this2.counting = true;
            _this2.type = "otp";
          } else {
            _this2.loading = false;
            _this2.phone = '';
            _this2.$swal('', _this2.$t('Alert.Login.phoneNotVerify'), 'error');
          }
        } else if (response.data['message'] === 'No JSON object could be decoded') {
          _this2.loading = false;
          _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
        } else if (response.data['message'] === 'too many requests.') {
          _this2.loading = false;
          _this2.$swal('', _this2.$t('Alert.Login.otpRequest'), 'error');
        } else {
          _this2.loading = false;
          _this2.$swal(response.data['status'], response.data['message'], 'error');
        }
      }, function (error) {
        console.log(error);
        _this2.status = 'fail';
        _this2.progress = false;
        _this2.type = 'first';
        _this2.failmessage = _this2.$t('Alert.Fail.default.somethingWrong');
      });
    },
    loginWithotp: function loginWithotp() {
      var _this3 = this;

      this.progress = true;
      var source = { type_otp: this.type_otp, phone: this.phone, otp: this.otpCode, mobile_ref_id: this.mobile_ref_id };
      this.axios.post("https://uatchat-manage.one.th/manage" + '/login_and_regis', source).then(function (response) {
        _this3.status = response.data['status'];
        // console.log(response.data)
        if (_this3.status === 'success') {
          var profile = response.data['account']['profile'];
          _this3.myprofilepicture = profile['profilepicture'];
          _this3.myname = profile['name'];
          // this.$cookie.set('language', 'th')
          _this3.$i18n.locale = _this3.$cookie.get('language') ? _this3.$cookie.get('language') : 'th';
          localStorage.setItem('Authenrization', __WEBPACK_IMPORTED_MODULE_8__services__["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
          localStorage.setItem('profilepicture', profile['profilepicture']);
          localStorage.setItem('name', profile['name']);
          localStorage.setItem('phone', profile['phone']);
          localStorage.setItem('email', profile['email']);
          localStorage.setItem('status', profile['status']);
          localStorage.setItem('type_user', profile['type']);
          localStorage.setItem('wallpaperInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            'info': [{
              'room': '',
              'background': ''
            }]
          }));
          if (profile['username'] === '' || profile['username'] === 'None') {
            localStorage.setItem('status_username', 'false');
          } else {
            localStorage.setItem('status_username', 'true');
          }
          _this3.progress = false;
          if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
            // this.$router.push('/chat')
            _this3.getOnechatToken(profile['tokenuser']);
          } else {
            _this3.$router.push(localStorage.getItem('pathRoom'));
          }
          localStorage.removeItem("tologin");
          localStorage.removeItem("tologin_keep2");
        } else if (response.data['message'] === 'The resource owner or authorization server denied the request.') {
          _this3.$cookie.set('status_login', 'F');
          _this3.progress = false;
          _this3.$swal('', _this3.$t('Alert.Login.otpInvalid'), 'error');
        } else {
          _this3.$cookie.set('status_login', 'F');
          _this3.progress = false;
          _this3.$swal(_this3.status, response.data['message'], 'error');
        }
      }, function (error) {
        console.log(error);
        _this3.status = 'fail';
        _this3.progress = false;
        _this3.failmessage = _this3.$t('Alert.Fail.default.somethingWrong');
      });
    },
    loginRedirect: function loginRedirect() {
      this.progress = true;
      window.open(this.url_redirect, '_parent');
    },
    redirectUrl: function redirectUrl(url) {
      try {
        var link = document.getElementById("iframename").contentWindow.location.href;
        // console.log(link)
        // console.log(_.includes(link, [process.env.redirect_url]))
        if (_.includes(link, ["https://uatchat.one.th/authorization/redirect"])) {
          window.open(link + '&passlogin=true', '_parent');
        }
      } catch (err) {
        console.log(err);
      }
    },
    regular_username_mobile: function regular_username_mobile() {
      // var str = this.username
      this.username = this.username.replace(/[^a-z-0-9@.]/i, '');
      this.username = this.username.toLowerCase();
    },
    regular_pass_mobile: function regular_pass_mobile() {
      this.password = this.password.replace(/^[ก-๛]+/i, '');
    },
    isNumandaz: function isNumandaz($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122) && keyCode != 46 && keyCode != 64) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    isnotthai: function isnotthai($event) {
      // console.log($event)
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // console.log(keyCode)
      if (keyCode >= 3585 && keyCode <= 3642 || keyCode >= 3647 && keyCode <= 3675) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    toNewTab: function toNewTab() {
      window.open(this.webdev, '_parent').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    isMobile: function isMobile() {
      if ($('#mobile').is(':hidden')) {
        return false;
      } else {
        return true;
      }
    },
    login: function login() {
      var _this4 = this;

      var addyear = 10;
      var newDate = new Date();
      newDate.setTime(newDate.getTime() + addyear * 365 * 24 * 60 * 60 * 1000);
      var expiresInTime = "expires=" + newDate.toUTCString();

      if (this.username === '' || this.password === '') {
        this.failmessage = this.$t('Alert.Login.inputUserPass');
      } else {
        this.progress = true;
        var source = __WEBPACK_IMPORTED_MODULE_8__services__["b" /* Encode */].encode({ 'username': this.username, 'password': this.password });
        this.axios.post("https://uatchat-manage.one.th/manage" + '/loginuserwithbusiness', { source: source }).then(function (response) {
          // console.log(response.data)
          _this4.status = response.data['status'];
          if (_this4.status === 'success') {
            var profile = response.data['account']['profile'];
            // localStorage.setItem('status_login', 'T')
            _this4.myprofilepicture = profile['profilepicture'];
            _this4.myname = profile['name'];
            // this.$cookie.set('status_login', 'T')
            // this.$cookie.set('tokenuser', Encode.encodeToken(profile['tokenuser']))
            // this.$cookie.set('language', 'th')
            _this4.$i18n.locale = _this4.$cookie.get('language') ? _this4.$cookie.get('language') : 'th';
            localStorage.setItem('Authenrization', __WEBPACK_IMPORTED_MODULE_8__services__["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
            localStorage.setItem('profilepicture', profile['profilepicture']);
            localStorage.setItem('name', profile['name']);
            localStorage.setItem('phone', profile['phone']);
            localStorage.setItem('email', profile['email']);
            localStorage.setItem('status', profile['status']);
            localStorage.setItem('type_user', profile['type']);
            localStorage.setItem('wallpaperInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
              'info': [{
                'room': '',
                'background': ''
              }]
            }));
            if (profile['username'] === '' || profile['username'] === 'None') {
              localStorage.setItem('status_username', 'false');
            } else {
              localStorage.setItem('status_username', 'true');
            }
            _this4.progress = false;
            // connect centrifuge
            _this4.connectCentrifuge(profile['tokenuser']);
            if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
              _this4.getOnechatToken(profile['tokenuser']);
              // if (localStorage.getItem('botid_redirect') !== null) {
              //   this.searchFriend(localStorage.getItem('botid_redirect'))
              // } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
              //   // redirect bot room with url
              //   var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
              //   this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
              // } else {
              //   if (this.isMobile()) {
              //     this.$router.push('/mobile/homepage')
              //   } else {
              //     this.$router.push('/chat')
              //   }
              // }
            } else {
              _this4.$router.push(localStorage.getItem('pathRoom'));
            }
          } else {
            _this4.$cookie.set('status_login', 'F');
            _this4.progress = false;
            if (response.data['message'] === 'Wrong Username / Password') {
              _this4.failmessage = _this4.$t('Alert.Login.invalidUserPass');
            } else {
              _this4.failmessage = _this4.$t('Alert.Fail.default.somethingWrong');
            }
          }
        }, function (error) {
          console.log(error);
          _this4.status = 'fail';
          _this4.progress = false;
          _this4.failmessage = _this4.$t('Alert.Fail.default.somethingWrong');
        });
      }
    },
    searchFriend: function searchFriend(botid) {
      var _this5 = this;

      // console.log(`bot id : ${localStorage.getItem('botid_redirect')}`)
      if (localStorage.getItem('botid_redirect') !== null) {
        this.progress = true;
        var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_8__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
        this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend", {
          tokenbot: botid,
          tokenuser: decoded.tokenuser
        }).then(function (response) {
          _this5.progress = false;
          // console.log(response.data.listuser)
          if (response.data.listuser.length === 0) {
            if (window.innerWidth <= 960) {
              _this5.$router.push('/mobile/homepage');
            } else {
              _this5.$router.push('/chat');
            }
          } else {
            if (response.data.listuser.relation === 'friend') {
              localStorage.removeItem('botid_redirect');
              if (_this5.isMobile()) {
                _this5.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom);
              } else {
                _this5.$router.push('/chat/room/' + response.data.listuser.user.tokenroom);
              }
            } else {
              console.log('not friend');
              _this5.$router.push('/addbot/' + localStorage.getItem('botid_redirect'));
            }
          }
        }).catch(function (error) {
          console.log(error);
          localStorage.removeItem('botid_redirect');
          _this5.progress = false;
          // this.$swal('', 'ไม่มีข้อมูลบอทในระบบ กรุณาตรวจสอบข้อมูลให้ถูกต้อง', 'warning')
          if (window.innerWidth <= 960) {
            _this5.$router.push('/mobile/homepage');
          } else {
            _this5.$router.push('/chat');
          }
        });
      }
    }
  },
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_4__components_homepage_Navbar__["a" /* default */],
    Download: __WEBPACK_IMPORTED_MODULE_5__components_mobile_dialog_DownloadAppMobile__["a" /* default */],
    checkconsentOnechatDialog: __WEBPACK_IMPORTED_MODULE_6__components_chat_dialog_consent_consent_onechat_dialog__["a" /* default */],
    newConsent: __WEBPACK_IMPORTED_MODULE_7__components_consent_new_consent__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "2TYA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chat_dialog_consent_consent_onechat_dialog__ = __webpack_require__("IWN4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chat_dialog_settings_ShowQRCodeUserDialog__ = __webpack_require__("wgae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chat_layout_Lefttest__ = __webpack_require__("UJPE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_chat_onemeet_LefttestOnemeet__ = __webpack_require__("WWt4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_chat_agora_call_ans_call_v2__ = __webpack_require__("Hruy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_consent_new_consent__ = __webpack_require__("F8NA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_offline__ = __webpack_require__("mbt8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex_pathify__ = __webpack_require__("YtWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services__ = __webpack_require__("+vOg");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// import firebase from 'firebase'
var Centrifuge = __webpack_require__("9wbP");
var centrifuge = new Centrifuge("wss://uatchat-manage.one.th/connection/websocket");

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      newConsentDialog: false,
      newConsentDetail: {},
      AgoraCallDialog: false,
      AgoraOption: '',
      infor_call: {},
      one_id: '',
      show: false,
      show_bell: false,
      textsnackbar: '',
      snackbar: false,
      typeuser: '',
      profilepicture: '',
      name: '',
      token: '',
      status_login: '',
      num_listalert: 0,
      listalert_bell: [],
      listmenu: [],
      groupnameTest: '',
      dialogShowQRCode: false,
      windowWidth: '',
      consentOnechatDialog: false,
      url_consent: ''
    };
  },
  props: {
    source: String
  },
  methods: {
    closeNewConsent: function closeNewConsent(value) {
      console.log("close new consent", value);
      this.newConsentDialog = value.close;
      this.newConsentDetail = {};
    },
    closeDialogConsentOnechat: function closeDialogConsentOnechat(value) {
      this.consentOnechatDialog = value;
    },
    check_consent: function check_consent(token) {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var hour = String(today.getHours() + 1).padStart(2, '0');
      var minute = String(today.getMinutes()).padStart(2, '0');
      var seconds = String(today.getSeconds()).padStart(2, '0');
      var milsec = today.getMilliseconds();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00';
        dd = String(today.getDate() + 1).padStart(2, '0');
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1';
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1';
            yyyy = today.getFullYear() + 1;
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0');
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
      // console.log(today)
      var expireddate = Date.parse(today);
      // console.log(expireddate)
      var body = __WEBPACK_IMPORTED_MODULE_10__services__["b" /* Encode */].encodeRichmenu({ 'userid': token, 'expired_date': expireddate });
      // console.log(body)
      this.progress = true;

      // check new consent
      if (this.$cookie.get('check-consent-' + token) === null || this.$cookie.get('check-consent-' + token) === undefined) {
        // test new consent
        this.progress = false;
        this.newConsentDialog = true;
        this.newConsentDetail = { token: token };
      } else {
        this.progress = false;
        // // set localStorage authorization
        // localStorage.setItem('Authenrization', Encode.encode({'tokenuser': token, 'status_login': 'T', 'type_user': 'user'}))
        // if (localStorage.getItem('botid_redirect') !== null) {
        //   this.searchFriend(localStorage.getItem('botid_redirect'))
        // } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
        //   // redirect bot room with url
        //   var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
        //   this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
        // } else {
        //   // console.log(`this.isMobile(): ${this.isMobile()}`)
        //   if (window.innerWidth <= 960) {
        //     this.$router.push('/mobile/homepage')
        //   } else {
        //     this.$router.push('/chat')
        //   }
        // }
      }
      // this.axios.post(process.env.APIgo_api + `/v1/get-consent`, { onechat_token: body }).then((response) => {
      //   // console.log(response.data)
      //   if (response.data.status === 'success') {
      //     this.progress = false
      //     if (response.data.data.consent_check === 'false') {
      //       this.consentOnechatDialog = true
      //       this.url_consent = response.data.data.consent_url
      //     }
      //   }
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    searchFriend: function searchFriend(botid) {
      var _this = this;

      var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_10__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend", {
        tokenbot: botid,
        tokenuser: decoded.tokenuser
      }).then(function (response) {
        // console.log(response.data.listuser)
        if (response.data.listuser.length === 0) {
          localStorage.removeItem('botid_redirect');
          if (window.innerWidth <= 960) {
            _this.$router.push('/mobile/homepage');
          } else {
            _this.$router.push('/chat');
          }
        } else {
          if (response.data.listuser.relation === 'friend') {
            localStorage.removeItem('botid_redirect');
            if (window.innerWidth <= 960) {
              _this.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom);
            } else {
              _this.$router.push('/chat/room/' + response.data.listuser.user.tokenroom);
            }
          } else {
            console.log('not friend');
            _this.$router.push('/addbot/' + localStorage.getItem('botid_redirect'));
          }
        }
      }).catch(function (error) {
        console.log(error);
        localStorage.removeItem('botid_redirect');
        if (window.innerWidth <= 960) {
          _this.$router.push('/mobile/homepage');
        } else {
          _this.$router.push('/chat');
        }
      });
    },
    decline_call: function decline_call(item) {
      console.log(item);
      // this.axios.post(process.env.APIalpine + `/api/v1/update-agora`, {
      //   tokenuser: this.token,
      //   tokenroom: item.tokenroom,
      //   tokenmessage: item.channel,
      //   time: '',
      //   message: 'cancel'
      // }).then((response) => {
      //   console.log(response)
      //   this.AgoraCallDialog = false
      // })
    },
    closeAgoraDialog: function closeAgoraDialog(value) {
      this.AgoraCallDialog = value;
    },
    changeLan: function changeLan(lang) {
      this.$i18n.locale = lang;
      this.$cookie.set('language', lang);
      this.changeLangMenu();
    },
    get_oneid: function get_oneid() {
      var _this2 = this;

      this.axios.get("https://uatchat-manage.one.th/go_api/api" + ('/v1/getOneID/' + this.token)).then(function (response) {
        if (response.data.status === 'success') {
          _this2.one_id = response.data.one_id;
        }
      });
    },
    getuser: function getuser() {
      var _this3 = this;

      // this.token = Decode.decodeToken(this.$cookie.get('tokenuser'))
      // var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      // this.token = decoded['tokenuser']
      // this.$analytics.logEvent('use_chat', { decodeToken: Encode.encodeToken(this.token) })
      this.profilepicture = localStorage.getItem('profilepicture');
      this.name = localStorage.getItem('name');
      this.typeuser = localStorage.getItem('type_user');
      this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', {
        tokenuser: this.token,
        tokenfriend: this.token
      }).then(function (response) {
        var data = response.data.user;
        if (response.data.status === 'success') {
          localStorage.setItem('profilepicture', data.profilepicture);
          localStorage.setItem('name', data.name);
          localStorage.setItem('usertype', data.usertype);
          _this3.profilepicture = data.profilepicture;
          _this3.name = data.name;
        }
      });
    },
    lengthstateactive: function lengthstateactive(list) {
      return _.filter(list, function (list) {
        return list.state === 'true';
      }).length;
    },
    getlistalert_bell: function getlistalert_bell() {
      var _this4 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getlistannounce', {}).then(function (response) {
        _this4.listalert_bell = response.data.list_announce;
        _this4.num_listalert = _this4.lengthstateactive(_this4.listalert_bell);
        // console.log(response.data)
      });
    },
    dialog_bell: function dialog_bell(item) {
      this.show_bell = false;
      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        text: item.message,
        type: 'warning',
        showCloseButton: true,
        reverseButtons: true,
        confirmButtonText: 'ตกลง'
      });
    },
    open: function open(typecall, tokenroom) {
      // console.log(detailroom)
      // localStorage.setItem('detailroomCall', JSON.stringify(detailroom))
      // window.open('/video_call/answer/' + typecall + '/' + tokenroom, '_parent').focus()
      this.$router.push({ path: '/video_call/answer/' + typecall + '/' + tokenroom, force: true });
    },
    handleConnectivityChange: function handleConnectivityChange(status) {
      // console.log(status)
      if (!status) {
        this.snackbar = true;
        this.textsnackbar = 'Network error! Please check your network connection.';
      }
    },
    openQRcode: function openQRcode() {
      this.show = false;
      this.dialogShowQRCode = true;
    },
    openloa: function openloa() {
      // window.open('/homepage#oneplatform', '_blank')
      var url = "https://testoneid.inet.co.th/login?redirect_url=https://testoneid.inet.co.th/portal_level&shared_token=";
      var body = {
        "tokenuser": this.token,
        "url": url
      };
      this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", body).then(function (response) {
        window.open(url + response.data.data.accesstoken, '_blank');
      });
    },
    closeShowQRCodeUser: function closeShowQRCodeUser(value) {
      this.dialogShowQRCode = value;
    },
    toPage: function toPage(page) {
      this.show = false;
      this.$router.push(page);
      this.pathsettings = page;
    },
    clickservice: function clickservice() {
      window.open('/homepage#oneplatform', '_blank');
    },
    logout: function logout() {
      this.show = false;
      // // this.$socket.emit('leave', {room: Decode.decodeToken(this.$cookie.get('tokenuser')), type: 'web'})
      // localStorage.clear()
      // try {
      //   this.$socket.emit('leave', {room: this.token, type: 'web'})
      // } catch(err) {
      //   console.log(err)
      // }
      this.$socket.emit('leave', { room: this.token, type: 'web' });
      // this.$cookie.delete("tokenuser")
      // this.$cookie.delete("status_login")
      localStorage.clear();
      // window.open(process.env.LogoutOneid, '_parent')
      console.log(this.$cookie.get('logouturl'));
      var logouturl = this.$cookie.get('logouturl');
      if (true) {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent');
          this.$cookie.delete('logouturl');
        } else {
          window.open("https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage", '_parent');
        }
      } else {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent');
          this.$cookie.delete('logouturl');
        } else {
          this.$router.push({ path: '/', force: true });
        }
      }
      // this.$router.push({path: '/login', force: true})
    },
    noti_msg: function noti_msg(name, notimsg, room, pic, type) {
      if (pic === '') {
        if (type === 'business') {
          pic = '/static/img/default_profile/business-white.png';
        } else if (type === 'bot') {
          pic = '/static/img/default_profile/bot-white.png';
        } else {
          pic = '/static/img/default_profile/man-white.png';
        }
      }
      if (Notification.permission === 'granted') {
        var me = this;
        var notification = new Notification('New message from ' + name, { body: notimsg, icon: pic, silent: true });
        notification.onclick = function () {
          // window.open('/chat/room/' + room, '_parent').focus()
          me.$router.push('/chat/room/' + room);
        };
      } else {
        Notification.requestPermission().then(function (result) {
          console.log(result);
        });
      }
    },
    other_noti: function other_noti(title, notimsg, pic) {
      if (pic === '') {
        pic = '/static/img/default_profile/man-white.png';
      }
      if (Notification.permission === 'granted') {
        var notification = new Notification(title, { body: notimsg, icon: pic, silent: true });
        notification.onclick = function () {
          window.open('', '_parent').focus();
        };
      } else {
        Notification.requestPermission().then(function (result) {
          console.log(result);
        });
      }
    },
    changeLangMenu: function changeLangMenu() {
      this.listmenu = [{
        title: this.$t('HeaderMenubar.editProfile'),
        icon: 'person',
        dialog: '/chat/settings/profile'
      },
      // {
      //   title: this.$t('HeaderMenubar.sendOnebox'),
      //   icon: 'file_upload',
      //   dialog: '/chat/settings/uploadfile/onebox'
      // },
      {
        title: this.$t('HeaderMenubar.feedback'),
        icon: 'feedback',
        dialog: '/chat/settings/feedback'
      }, {
        title: this.$t('HeaderMenubar.support'),
        icon: 'contact_support',
        dialog: '/chat/settings/support'
      }, {
        title: this.$t('HeaderMenubar.policy'),
        icon: 'book',
        dialog: '/chat/settings/policy'
      }];
    }
  },
  components: {
    LeftSide: __WEBPACK_IMPORTED_MODULE_4__components_chat_layout_Lefttest__["a" /* default */],
    LeftSideOnemeet: __WEBPACK_IMPORTED_MODULE_5__components_chat_onemeet_LefttestOnemeet__["a" /* default */],
    ShowQRCodeUser: __WEBPACK_IMPORTED_MODULE_3__components_chat_dialog_settings_ShowQRCodeUserDialog__["a" /* default */],
    AgoraCallDialog: __WEBPACK_IMPORTED_MODULE_6__components_chat_agora_call_ans_call_v2__["a" /* default */],
    offline: __WEBPACK_IMPORTED_MODULE_8_v_offline__["a" /* default */],
    checkconsentOnechatDialog: __WEBPACK_IMPORTED_MODULE_2__components_chat_dialog_consent_consent_onechat_dialog__["a" /* default */],
    newConsent: __WEBPACK_IMPORTED_MODULE_7__components_consent_new_consent__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex_pathify__["c" /* sync */])('*')),
  mounted: function mounted() {
    var _this5 = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this5.windowWidth = window.innerWidth;
      });
    });
    var me = this;
    $(document).click(function (event) {
      var target = $(event.target);
      if (!target.closest('#headerMenubar').length && $('#headerMenubar').is(":visible")) {
        me.show = false;
      }
      if (!target.closest('#headerMenubar_bell').length && $('#headerMenubar_bell').is(":visible")) {
        me.show_bell = false;
      }
      //  else if(!target.closest('#menu-sticker').length && $('#menu-sticker').is(":visible")) {
      //   me.sheetsticker = false
      //   // $('#menu-sticker').fadeOut(1600);
      // }
    });
  },

  watch: {
    '$socket.connected': function $socketConnected(data) {
      console.log(this.$socket);
    },
    myprofilepicture: function myprofilepicture() {
      this.profilepicture = localStorage.getItem('profilepicture');
    },
    myname: function myname() {
      this.name = localStorage.getItem('name');
    },
    windowWidth: function windowWidth() {
      if (this.windowWidth <= 960) {
        if (window.location.pathname === '/chat/settings/profile') {
          this.$router.push('/mobile/settings/profile');
        } else if (window.location.pathname === '/chat/settings/uploadfile/onebox') {
          this.$router.push('/mobile/settings/uploadfile/onebox');
        } else if (window.location.pathname === '/chat/settings/feedback') {
          this.$router.push('/mobile/settings/feedback');
        } else if (window.location.pathname === '/chat/settings/support') {
          this.$router.push('/mobile/settings/support');
        } else if (window.location.pathname === '/chat/settings/policy') {
          this.$router.push('/mobile/settings/policy');
        } else if (window.location.pathname === '/chat/settings/managefriend') {
          this.$router.push('/mobile/settings/managefriend');
        } else if (window.location.pathname === '/chat/room/' + this.$route.params.roomid) {
          // this.$router.push('/mobile/room/' + this.$route.params.roomid)
          this.$router.push('/mobile/progress/' + this.$route.params.roomid);
        } else {
          this.$router.push('/mobile/homepage');
        }
      }
    }
  },
  sockets: {
    connect: function connect() {
      console.log('socket connected');
      this.$socket.emit('join', { room: this.token, type: 'web' });
      this.snackbar = true;
      this.textsnackbar = 'server connected';
    },
    disconnect: function disconnect() {
      console.log('socket disconnected');
      this.snackbar = true;
      this.textsnackbar = 'server disconnected';
      // You appear to be offline
    },
    expired_login: function expired_login(data) {
      console.log('expired_login');
      // console.log(data)
      this.socketexpire_login = data;
    },

    // message (data) {
    //   console.log('socket message')
    //   // console.log(data)
    //   if (data.hasOwnProperty('tokenuser')) {
    //     this.axios.post(process.env.APIalpine + '/api/v3/getmessage', {tokenmessage: data.tokenmessage, tokenuser: this.token}).then((response) => {
    //       this.socketmessage = response.data.source
    //       if (data.tokenroom !== this.$route.params.roomid && data.tokenuser !== this.token) {
    //         if (response.data.source.typeofmessage !== 'message') {
    //           this.noti_msg(response.data.source.nickname, 'Send:  ' + response.data.source.typeofmessage + ' to you', response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type)
    //         } else {
    //           // can't use this.convertMention
    //           this.noti_msg(response.data.source.nickname, 'Message:  '  + ((response.data.source.message).replace(/\<tax>/g,'@')).replace(/<\/tax>/g,''), response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type)
    //         }
    //       }
    //     })
    //   }
    //   // keep type option agora call
    //   if (data.option !== undefined) {
    //     this.typeAgoraCall = data.option
    //     console.log(this.typeAgoraCall)
    //   }
    // },
    // update_agora (data) {
    //   console.log('update agora')
    //   // console.log(data)
    //   this.socket_update_agora = data
    // },
    convertMention: function convertMention(msg) {
      msg = msg.replace(/\<tax>/g, '<span style="color:#1976d2;">@');
      msg = msg.replace(/<\/tax>/g, '</span>');
      // console.log(msg)
      return msg;
    },

    // event_unsend (data) {
    //   // console.log(data)
    //   console.log('event_unsend')
    //   this.socket_unsendmessage = data
    // },
    event_kick_group: function event_kick_group(data) {
      console.log('event_kick_group');
      // console.log(data)
      this.socket_kickmember = data;
    },

    // quick_reply (data) {
    //   console.log('quick_reply')
    //   this.socketquickreply = data
    // },
    // disable_quick_reply (data) {
    //   console.log('disable_quick_reply')
    //   this.socketdisablequickreply = data
    // },
    // disable_approve (data) {
    //   console.log('disable_approve')
    //   this.socketdisableapprove = data
    // },
    event_note: function event_note(data) {
      console.log('event_note');
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        this.socketnote = data;
      }
    },
    event_block: function event_block(data) {
      console.log('event_block');
      if (data.hasOwnProperty('tokenuser')) {
        this.socketblock = data;
      }
    },
    event_friend: function event_friend(data) {
      var _this6 = this;

      console.log('event_friend');
      this.socketfriend = data;
      if (data.konAdd !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', { owner: this.token, tokenuser: data.tokenfriend }).then(function (response) {
          // console.log(response.data)
          if (response.data['user'][0]['type'] !== 'company') {
            _this6.other_noti('Friend Request', 'Request friend from ' + response.data['user'][0]['name'], response.data['user'][0]['profilepicture']);
          }
        });
      }
    },
    event_accept_friend: function event_accept_friend(data) {
      var _this7 = this;

      console.log('event_accept_friend');
      // console.log(data)
      this.socketaccept_friend = data;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', { owner: this.token, tokenuser: [data.tokenfriend] }).then(function (response) {
        if (response.data['user'][0]['type'] !== 'business') {
          _this7.other_noti('Accept Friend', 'You and ' + response.data['user'][0]['name'] + ' are friend.', response.data['user'][0]['profilepicture']);
        }
      });
    },
    event_remove_request_friend: function event_remove_request_friend(data) {
      console.log('event_remove_request_friend');
      this.socketremove_request_friend = data;
    },
    event_remove_friend: function event_remove_friend(data) {
      console.log('event_remove_friend');
      this.socketremove_friend = data;
    },
    event_create_group: function event_create_group(data) {
      var _this8 = this;

      console.log('event_create_group');
      // console.log(data)
      this.socketcreate_group = data;
      if (data.fromtokenuser !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', { group_id: data.groupid, tokenuser: data.fromtokenuser }).then(function (response) {
          _this8.groupnameTest = response.data.group.name;
          _this8.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', { owner: _this8.token, tokenuser: [data.fromtokenuser] }).then(function (responsed) {
            // console.log(responsed.data)
            _this8.other_noti('Create group', 'Invite group', responsed.data['user'][0]['name'] + ' invite you to group ' + _this8.groupnameTest, responsed.data['user'][0]['profilepicture']);
          });
        });
      }
    },
    event_invite_group: function event_invite_group(data) {
      var _this9 = this;

      console.log('event_invite_group');
      // console.log(data)
      this.socketinvite_group = data;
      if (data.userinvited !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', { owner: this.token, tokenuser: [data.userinvited] }).then(function (responsed) {
          _this9.other_noti(data.message, responsed.data['user'][0]['profilepicture']);
        });
      }
    },
    event_active_group: function event_active_group(data) {
      var _this10 = this;

      console.log('event_active_group');
      // console.log(data)
      this.socketactive_group = data;
      if (data.tokenuser !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', { group_id: data.groupid, tokenuser: this.token }).then(function (response) {
          _this10.groupnameTest = response.data.group.name;
          _this10.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', { owner: _this10.token, tokenuser: [data.tokenuser] }).then(function (responsed) {
            _this10.other_noti('Accept group', responsed.data['user'][0]['name'] + ' accept group ' + _this10.groupnameTest, responsed.data['user'][0]['profilepicture']);
          });
        });
      }
    },
    event_cancel_group: function event_cancel_group(data) {
      console.log('event_cancel_group');
      // console.log(data)
      this.socketcencel_group = data;
    },
    event_leave_group: function event_leave_group(data) {
      console.log('event_leave_group');
      this.socketleave_group = data;
    },
    event_update_user: function event_update_user(data) {
      console.log('event_update_user');
      // console.log(data)
      if (data.tokenuser === this.token) {
        this.socketupdate_self = data;
        if (data.type_update === 'status') {
          this.mystatus = data.update_data;
          localStorage.setItem('status', data.update_data);
        } else if (data.type_update === 'pictureprofile') {
          this.myprofilepicture = data.update_data;
          localStorage.setItem('profilepicture', data.update_data);
        } else if (data.type_update === 'name') {
          this.myname = data.update_data;
          localStorage.setItem('name', data.update_data);
        }
      } else {
        this.socketupdate_friend = data;
      }
    },
    send: function send(data) {
      console.log(data);
    },

    signaling_message: function signaling_message(data) {
      var me = this;
      // console.log(data)
      var message = JSON.parse(data.message);
      console.log('signaling_message');
      // if (data.type === 'SDP' && data.typesend === 'offer' && localStorage.getItem('Calling') !== 'true') {
      if (data.type === 'SDP' && data.typesend === 'offer') {
        if (message.sdp.type === 'offer' && data.name !== this.token) {
          // this.socketsignaling_message = data
          localStorage.setItem('stateCall', 'true');
          localStorage.setItem('socketsignaling_message', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
          this.other_noti('มีสายเรียกเข้า', data.fullname + ' ต้องการสนทนากับคุณ', data.picture);
          this.open(data.typecall, data.room);
        }
      }
    },
    announce_room: function announce_room(data) {
      this.socket_announce = data;
    },
    edit_task: function edit_task(data) {
      this.socket_edittask = data;
    },
    delete_task: function delete_task(data) {
      this.socket_deletetask = data;
    },

    // disable_official_template (data) {
    //   this.socket_official_template = data
    // },
    // close_webview (data) {
    //   this.socket_close_webview = data
    // },
    // switch_keyboard (data) {
    //   console.log('switch_keyboard')
    //   console.log(data)
    // },
    // switch_richmenu (data) {
    //   console.log('switch_richmenu')
    // },
    message_read: function message_read(data) {
      // console.log('message read')
      // console.log(data)
    }
  },
  created: function created() {
    // console.log(this.$router.currentRoute.path)
    // console.log(this.$analytics)
    // // analytic.logEvent('notification_received')
    // // analytic.logEvent('goal_completion', { name: 'lever_puzzle'})
    // // gtag('event', 'sign_up', { 'method': 'Google' })
    // console.log(this.$analytics.logEvent('test24', { method: 'Google' }))
    // this.$analytics.logEvent("notification_received")
    // this.$analytics.logEvent('momo', { method: 'Vue' })
    // var firebaseConfig = {
    //   apiKey: "AIzaSyDliKV5rvjsLNNK_AxSrcRl5sDUMS_hQF8",
    //   authDomain: "onechat-de3fe.firebaseapp.com",
    //   databaseURL: "https://onechat-de3fe.firebaseio.com",
    //   projectId: "onechat-de3fe",
    //   storageBucket: "onechat-de3fe.appspot.com",
    //   messagingSenderId: "501136854127",
    //   appId: "1:501136854127:web:5b2629b97804c79169919a"
    // };
    // // Initialize Firebase
    // firebase.initializeApp(firebaseConfig);
    // firebase.analytics().logEvent('notification_received');
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_10__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
    this.changeLangMenu();
    this.getuser();
    this.get_oneid();
    // this.check_consent(this.token)
    // this.status_login = this.$cookie.get('status_login')
    // if (this.status_login !== 'T' || this.status_login === null) {
    //   localStorage.setItem('pathRoom', this.$router.currentRoute.path)
    //   this.$router.push('/login')
    // } else {
    this.getlistalert_bell();
    this.$socket.emit('join', { room: this.token, type: 'web' });

    var me = this;
    var events = '';
    var data_msg = '';
    centrifuge.setToken('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs');
    centrifuge.subscribe(me.token, function (message) {
      // console.log(message)
      events = message.data.event;
      data_msg = message.data.data;
      console.log('centrifuge: ' + events);
      // console.log(data_msg)
      if (events === 'message') {
        if (data_msg.last_tokenmessage !== undefined) {
          // event unsend
          me.socket_unsendmessage = data_msg;
        } else {
          // ถ้าข้อความเป็น type official_template, system เก็ทข้อความแบบเดิม ส่วน type อื่นรับปกติ
          if (data_msg.typeofmessage === 'official_template' || data_msg.typeofmessage === 'system' || data_msg.typeofmessage === 'system_action_albums') {
            me.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v3/getmessage', { tokenmessage: data_msg.tokenmessage, tokenuser: me.token }).then(function (response) {
              me.socketmessage = response.data.source;
            });
          } else {
            // event message
            me.socketmessage = data_msg;
          }
          // console.log(me.socketmessage)
          if (data_msg.option !== undefined) {
            me.typeAgoraCall = data_msg.option;
          }
        }
        if (me.socketmessage.tokenroom !== me.$route.params.roomid && me.socketmessage.tokenuser !== me.token) {
          if (me.socketmessage.typeofmessage !== 'message') {
            me.noti_msg(me.socketmessage.nickname, 'Send:  ' + me.socketmessage.typeofmessage + ' to you', me.socketmessage.tokenroom, me.socketmessage.path_pic, me.socketmessage.type);
          } else {
            // can't use this.convertMention
            me.noti_msg(me.socketmessage.nickname, 'Message:  ' + me.socketmessage.message.replace(/\<tax>/g, '@').replace(/<\/tax>/g, ''), me.socketmessage.tokenroom, me.socketmessage.path_pic, me.socketmessage.type);
          }
        }
      } else if (events === 'disable_quick_reply') {
        me.socketdisablequickreply = data_msg;
      } else if (events === 'update-agora') {
        me.socket_update_agora = data_msg;
        me.AgoraCallDialog = false;
      } else if (events === 'accept_call') {
        me.socket_accept_call = data_msg;
        // console.log(me.socket_accept_call)
      } else if (events === 'service_call_agora') {
        // keep type option agora call
        // if (data_msg.option !== undefined) {
        if (false) {
          // ถ้ายังไม่ได้กดเข้าห้องแชทแต่มันการ call
          // if (me.$router.currentRoute.path === '/chat') {
          var typeCall = '';
          if (data_msg.option === 'voice') {
            typeCall = 'audio';
          } else {
            typeCall = data_msg.option;
          }
          // call agora
          setTimeout(function () {
            var infor = {
              agora_token: data_msg.agora_token,
              channel: data_msg.channel,
              nickname: data_msg.nickname,
              option: typeCall,
              picture: data_msg.picture,
              tokenroom: data_msg.tokenroom,
              one_id: me.one_id
            };
            me.infor_call = infor;
            me.AgoraOption = typeCall;
            me.AgoraCallDialog = true;
            // console.log(me.AgoraCallDialog)
            // console.log(me.infor_call)
          }, 1000);
          // } else {
          // me.typeAgoraCall = data_msg
          // }
          // console.log(me.typeAgoraCall)
        }
        // }
      } else if (events === 'disable_approve') {
        me.socketdisableapprove = data_msg;
      } else if (events === 'quick_reply') {
        me.socketquickreply = data_msg;
      } else if (events === 'close_webview') {
        me.socket_close_webview = data_msg;
      } else if (events === 'switch_keyboard') {
        me.socket_switch_keyboard = data_msg;
      } else if (events === 'switch_richmenu') {
        me.socket_switch_richmenu = data_msg;
      } else if (events === 'disable_official_template') {
        me.socket_official_template = data_msg;
      } else if (events === 'drop_menu') {
        me.socket_drop_menu = data_msg;
      } else if (events === 'consent') {
        // me.consentOnechatDialog = false
        me.centrifuge_consent = data_msg;
      }
    });

    centrifuge.on('connect', function () {
      console.log("connected centrifuge");
    });
    centrifuge.on('disconnect', function () {
      console.log("disconnected centrifuge");
    });
    centrifuge.connect();
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "2f0p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("Zx67");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/max-safe-integer.js
var max_safe_integer = __webpack_require__("hiCB");
var max_safe_integer_default = /*#__PURE__*/__webpack_require__.n(max_safe_integer);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-picture-input/PictureInput.vue







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PictureInput = ({
  name: 'picture-input',
  props: {
    width: {
      type: [String, Number],
      default: max_safe_integer_default.a
    },
    height: {
      type: [String, Number],
      default: max_safe_integer_default.a
    },
    margin: {
      type: [String, Number],
      default: 0
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    size: {
      type: [String, Number],
      default: max_safe_integer_default.a
    },
    name: {
      type: String,
      default: null
    },
    id: {
      type: [String, Number],
      default: null
    },
    buttonClass: {
      type: String,
      default: 'btn btn-primary button'
    },
    removeButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    aspectButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    prefill: {
      type: [String, File],
      default: ''
    },
    prefillOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    crop: {
      type: Boolean,
      default: true
    },
    radius: {
      type: [String, Number],
      default: 0
    },
    removable: {
      type: Boolean,
      default: false
    },
    hideChangeButton: {
      type: Boolean,
      default: false
    },
    autoToggleAspectRatio: {
      type: Boolean,
      default: false
    },
    toggleAspectRatio: {
      type: Boolean,
      default: false
    },
    changeOnClick: {
      type: Boolean,
      default: true
    },
    plain: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 10000
    },
    alertOnError: {
      type: Boolean,
      default: true
    },
    customStrings: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    prefill: function prefill() {
      if (this.prefill) {
        this.preloadImage(this.prefill, this.prefillOptions);
      } else {
        this.removeImage();
      }
    }
  },
  data: function data() {
    return {
      imageSelected: false,
      previewHeight: 0,
      previewWidth: 0,
      draggingOver: false,
      canvasWidth: 0,
      canvasHeight: 0,
      strings: {
        upload: '<p>Your device does not support file uploading.</p>',
        drag: 'Drag an image or <br>click here to select a file',
        tap: 'Tap here to select a photo <br>from your gallery',
        change: 'Change Photo',
        aspect: 'Landscape/Portrait',
        remove: 'Remove Photo',
        select: 'Select a Photo',
        selected: '<p>Photo successfully selected!</p>',
        fileSize: 'The file size exceeds the limit',
        fileType: 'This file type is not supported.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.updateStrings();
    if (this.prefill) {
      this.preloadImage(this.prefill, this.prefillOptions);
    }

    this.$nextTick(function () {
      window.addEventListener('resize', _this.onResize);
      _this.onResize();
    });
    if (this.supportsPreview) {
      this.pixelRatio = Math.round(window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI);
      var canvas = this.$refs.previewCanvas;
      if (canvas.getContext) {
        this.context = canvas.getContext('2d');
        this.context.scale(this.pixelRatio, this.pixelRatio);
      }
    }
    if (this.accept !== 'image/*') {
      this.fileTypes = this.accept.split(',');
      this.fileTypes = this.fileTypes.map(function (s) {
        return s.trim();
      });
    }

    this.canvasWidth = this.width;
    this.canvasHeight = this.height;

    this.$on('error', this.onError);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    this.$off('error', this.onError);
  },

  methods: {
    updateStrings: function updateStrings() {
      for (var s in this.customStrings) {
        if (s in this.strings && typeof this.customStrings[s] === 'string') {
          this.strings[s] = this.customStrings[s];
        }
      }
    },
    onClick: function onClick() {
      if (!this.imageSelected) {
        this.selectImage();
        return;
      }

      if (this.changeOnClick) {
        this.selectImage();
      }

      this.$emit('click');
    },
    onResize: function onResize() {
      this.resizeCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }
    },
    onDragStart: function onDragStart() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = true;
    },
    onDragStop: function onDragStop() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = false;
    },
    onFileDrop: function onFileDrop(e) {
      this.onDragStop();
      this.onFileChange(e);
    },
    onFileChange: function onFileChange(e, prefill) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      if (files[0].size <= 0 || files[0].size > this.size * 1024 * 1024) {
        this.$emit('error', {
          type: 'fileSize',
          fileSize: files[0].size,
          fileType: files[0].type,
          fileName: files[0].name,
          message: this.strings.fileSize + ' (' + this.size + 'MB)'
        });
        return;
      }
      if (files[0].name === this.fileName && files[0].size === this.fileSize && this.fileModified === files[0].lastModified) {
        return;
      }

      this.file = files[0];
      this.fileName = files[0].name;
      this.fileSize = files[0].size;
      this.fileModified = files[0].lastModified;
      this.fileType = files[0].type;

      if (this.accept === 'image/*') {
        if (files[0].type.substr(0, 6) !== 'image/') {
          return;
        }
      } else {
        if (this.fileTypes.indexOf(files[0].type) === -1) {
          this.$emit('error', {
            type: 'fileType',
            fileSize: files[0].size,
            fileType: files[0].type,
            fileName: files[0].name,
            message: this.strings.fileType
          });
          return;
        }
      }
      this.imageSelected = true;
      this.image = '';
      if (this.supportsPreview) {
        this.loadImage(files[0], prefill || false);
      } else {
        if (prefill) {
          this.$emit('prefill');
        } else {
          this.$emit('change', this.image);
        }
      }
    },
    onError: function onError(error) {
      if (this.alertOnError) {
        alert(error.message);
      }
    },
    loadImage: function loadImage(file, prefill) {
      var _this2 = this;

      this.getEXIFOrientation(file, function (orientation) {
        _this2.setOrientation(orientation);
        var reader = new FileReader();
        reader.onload = function (e) {
          _this2.image = e.target.result;
          if (prefill) {
            _this2.$emit('prefill');
          } else {
            _this2.$emit('change', _this2.image);
          }
          _this2.imageObject = new Image();
          _this2.imageObject.onload = function () {
            if (_this2.autoToggleAspectRatio) {
              var canvasOrientation = _this2.getOrientation(_this2.canvasWidth, _this2.canvasHeight);
              var imageOrientation = _this2.getOrientation(_this2.imageObject.width, _this2.imageObject.height);
              if (canvasOrientation !== imageOrientation) {
                _this2.rotateCanvas();
              }
            }
            _this2.drawImage(_this2.imageObject);
          };
          _this2.imageObject.src = _this2.image;
        };
        reader.readAsDataURL(file);
      });
    },
    drawImage: function drawImage(image) {
      this.imageWidth = image.width;
      this.imageHeight = image.height;
      this.imageRatio = image.width / image.height;
      var offsetX = 0;
      var offsetY = 0;
      var scaledWidth = this.previewWidth;
      var scaledHeight = this.previewHeight;
      var previewRatio = this.previewWidth / this.previewHeight;
      if (this.crop) {
        if (this.imageRatio >= previewRatio) {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        } else {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        }
      } else {
        if (this.imageRatio >= previewRatio) {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        } else {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        }
      }
      var canvas = this.$refs.previewCanvas;
      canvas.style.background = 'none';
      canvas.width = this.previewWidth * this.pixelRatio;
      canvas.height = this.previewHeight * this.pixelRatio;
      this.context.setTransform(1, 0, 0, 1, 0, 0);
      this.context.clearRect(0, 0, canvas.width, canvas.height);
      if (this.rotate) {
        this.context.translate(offsetX * this.pixelRatio, offsetY * this.pixelRatio);
        this.context.translate(scaledWidth / 2 * this.pixelRatio, scaledHeight / 2 * this.pixelRatio);
        this.context.rotate(this.rotate);
        offsetX = -scaledWidth / 2;
        offsetY = -scaledHeight / 2;
      }
      this.context.drawImage(image, offsetX * this.pixelRatio, offsetY * this.pixelRatio, scaledWidth * this.pixelRatio, scaledHeight * this.pixelRatio);
    },
    selectImage: function selectImage() {
      this.$refs.fileInput.click();
    },
    removeImage: function removeImage() {
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.type = '';
      this.$refs.fileInput.type = 'file';
      this.fileName = '';
      this.fileType = '';
      this.fileSize = 0;
      this.fileModified = 0;
      this.imageSelected = false;
      this.image = '';
      this.file = null;
      this.imageObject = null;
      this.$refs.previewCanvas.style.backgroundColor = 'rgba(200,200,200,.25)';
      this.$refs.previewCanvas.width = this.previewWidth * this.pixelRatio;
      this.$emit('remove');
    },
    rotateImage: function rotateImage() {
      this.rotateCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }

      var newOrientation = this.getOrientation(this.canvasWidth, this.canvasHeight);
      this.$emit('aspectratiochange', newOrientation);
    },
    resizeCanvas: function resizeCanvas() {
      var previewRatio = this.canvasWidth / this.canvasHeight;
      var newWidth = this.$refs.container.clientWidth;
      if (!this.toggleAspectRatio && newWidth === this.containerWidth) {
        return;
      }
      this.containerWidth = newWidth;
      this.previewWidth = Math.min(this.containerWidth - this.margin * 2, this.canvasWidth);
      this.previewHeight = this.previewWidth / previewRatio;
    },
    getOrientation: function getOrientation(width, height) {
      var orientation = 'square';

      if (width > height) {
        orientation = 'landscape';
      } else if (width < height) {
        orientation = 'portrait';
      }

      return orientation;
    },
    switchCanvasOrientation: function switchCanvasOrientation() {
      var canvasWidth = this.canvasWidth;
      var canvasHeight = this.canvasHeight;

      this.canvasWidth = canvasHeight;
      this.canvasHeight = canvasWidth;
    },
    rotateCanvas: function rotateCanvas() {
      this.switchCanvasOrientation();
      this.resizeCanvas();
    },
    setOrientation: function setOrientation(orientation) {
      this.rotate = false;
      if (orientation === 8) {
        this.rotate = -Math.PI / 2;
      } else if (orientation === 6) {
        this.rotate = Math.PI / 2;
      } else if (orientation === 3) {
        this.rotate = -Math.PI;
      }
    },
    getEXIFOrientation: function getEXIFOrientation(file, callback) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) !== 0xFFD8) {
          return callback(-2);
        }
        var length = view.byteLength;
        var offset = 2;
        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) === 0x0112) {
                return callback(view.getUint16(offset + i * 12 + 8, little));
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }
        return callback(-1);
      };
      reader.readAsArrayBuffer(file.slice(0, 65536));
    },
    preloadImage: function preloadImage(source, options) {
      var _this4 = this;

      // ie 11 support
      var File = window.File;
      try {
        new File([], ''); // eslint-disable-line
      } catch (e) {
        File = function (_Blob) {
          inherits_default()(File, _Blob);

          function File(chunks, filename) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            classCallCheck_default()(this, File);

            var _this3 = possibleConstructorReturn_default()(this, (File.__proto__ || get_prototype_of_default()(File)).call(this, chunks, opts));

            _this3.lastModifiedDate = new Date();
            _this3.lastModified = +_this3.lastModifiedDate;
            _this3.name = filename;
            return _this3;
          }

          return File;
        }(Blob);
      }
      options = assign_default()({}, options);
      if ((typeof source === 'undefined' ? 'undefined' : typeof_default()(source)) === 'object') {
        this.imageSelected = true;
        this.image = '';
        if (this.supportsPreview) {
          this.loadImage(source, true);
        } else {
          this.$emit('prefill');
        }
        return;
      }
      var headers = new Headers();
      headers.append('Accept', 'image/*');
      fetch(source, {
        method: 'GET',
        mode: 'cors',
        headers: headers
      }).then(function (response) {
        return response.blob();
      }).then(function (imageBlob) {
        var e = { target: { files: [] } };
        var fileName = options.fileName || source.split('/').slice(-1)[0];
        var mediaType = options.mediaType || 'image/' + (options.fileType || fileName.split('.').slice(-1)[0]);
        mediaType = mediaType.replace('jpg', 'jpeg');
        e.target.files[0] = new File([imageBlob], fileName, { type: mediaType });
        _this4.onFileChange(e, true);
      }).catch(function (err) {
        _this4.$emit('error', {
          type: 'failedPrefill',
          message: 'Failed loading prefill image: ' + err
        });
      });
    }
  },
  computed: {
    supportsUpload: function supportsUpload() {
      if (navigator.userAgent.match(/(Android (1.0|1.1|1.5|1.6|2.0|2.1))|(Windows Phone (OS 7|8.0))|(XBLWP)|(ZuneWP)|(w(eb)?OSBrowser)|(webOS)|(Kindle\/(1.0|2.0|2.5|3.0))/)) {
        return false;
      }
      var el = document.createElement('input');
      el.type = 'file';
      return !el.disabled;
    },
    supportsPreview: function supportsPreview() {
      return window.FileReader && !!window.CanvasRenderingContext2D;
    },
    supportsDragAndDrop: function supportsDragAndDrop() {
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && !('ontouchstart' in window || navigator.msMaxTouchPoints);
    },
    computedClasses: function computedClasses() {
      var classObject = {};
      classObject['dragging-over'] = this.draggingOver;
      return classObject;
    },
    fontSize: function fontSize() {
      return Math.min(0.04 * this.previewWidth, 21) + 'px';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5080a0f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-picture-input/PictureInput.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"picture-input",attrs:{"id":"picture-input"}},[(!_vm.supportsUpload)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.upload)}}):(_vm.supportsPreview)?_c('div',[_c('div',{staticClass:"preview-container",style:({maxWidth: _vm.previewWidth + 'px', height: _vm.previewHeight + 'px', borderRadius: _vm.radius + '%'})},[_c('canvas',{ref:"previewCanvas",staticClass:"picture-preview",class:_vm.computedClasses,style:({height: _vm.previewHeight + 'px', zIndex: _vm.zIndex + 1 }),on:{"drag":function($event){$event.stopPropagation();$event.preventDefault();},"dragover":function($event){$event.stopPropagation();$event.preventDefault();},"dragstart":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStart($event)},"dragenter":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStart($event)},"dragend":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStop($event)},"dragleave":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStop($event)},"drop":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onFileDrop($event)},"click":function($event){$event.preventDefault();return _vm.onClick($event)}}}),_vm._v(" "),(!_vm.imageSelected && !_vm.plain)?_c('div',{staticClass:"picture-inner",style:({top: -_vm.previewHeight + 'px', marginBottom: -_vm.previewHeight + 'px', fontSize: _vm.fontSize, borderRadius: _vm.radius + '%', zIndex: _vm.zIndex + 2})},[(_vm.supportsDragAndDrop)?_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.drag)}}):_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.tap)}})]):_vm._e()]),_vm._v(" "),(_vm.imageSelected && !_vm.hideChangeButton)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();return _vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.toggleAspectRatio && _vm.width !== _vm.height)?_c('button',{class:_vm.aspectButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.rotateImage($event)}}},[_vm._v(_vm._s(_vm.strings.aspect))]):_vm._e()]):_c('div',[(!_vm.imageSelected)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();return _vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.select))]):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.selected)}}),_vm._v(" "),(!_vm.hideChangeButton)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();return _vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]):_vm._e(),_vm._v(" "),(_vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e()])]),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"type":"file","name":_vm.name,"id":_vm.id,"accept":_vm.accept},on:{"change":_vm.onFileChange}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vue_picture_input_PictureInput = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-picture-input/PictureInput.vue
function injectStyle (ssrContext) {
  __webpack_require__("EH9F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5080a0f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  PictureInput,
  vue_picture_input_PictureInput,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var node_modules_vue_picture_input_PictureInput = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "32Ju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_chat/AccountDialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AccountDialog = ({
  props: { dialogAccount: false },
  data: function data() {
    return {
      token: '',
      progress: false,
      status: 'progress',
      FriendList: [],
      search: '',
      contact_select: '',
      typeuser: ''
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.typeuser = localStorage.getItem('type_user');
    this.getlistfriend();
  },

  watch: {
    socketaccept_friend: function socketaccept_friend() {
      this.getlistfriend();
    },
    socketremove_friend: function socketremove_friend() {
      this.getlistfriend();
    }
  },
  computed: extends_default()({
    FilterFriendList: function FilterFriendList() {
      var _this = this;

      if (this.search !== '' && this.search !== null) {
        return this.FriendList.filter(function (post) {
          return post.name.toLowerCase().includes(_this.search.toLowerCase());
        });
      } else {
        return this.FriendList;
      }
    }
  }, Object(vuex_pathify_esm["c" /* sync */])('*')),
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeAccount', false);
      this.contact_select = '';
      this.search = '';
    },
    sendContact: function sendContact() {
      var _this2 = this;

      if (this.contact_select !== '') {
        this.axios.post("https://uatchat-manage.one.th/message" + '/push_contact', { tokenroom: this.$route.params.roomid, tokenuser: this.token, tokencontact: this.contact_select['tokenuser'], type: this.typeuser }).then(function (response) {
          if (response.data['status'] === 'success') {
            _this2.$emit('pushcontact', { data: response.data.data, status: 'success' });
            _this2.$swal('', _this2.$t('Alert.Success.account'), 'success');
            _this2.closeDialog();
          } else {
            _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
            _this2.closeDialog();
          }
        }, function () {
          // console.log(this.contact_select)
          _this2.$emit('pushcontact', { data: _this2.contact_select, status: 'error' });
          _this2.$swal('Network error', _this2.$t('Alert.Fail.default.networkError'), 'error');
          _this2.closeDialog();
        });
      }
    },
    getlistfriend: function getlistfriend() {
      var _this3 = this;

      this.status = 'progress';
      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistfriend', { tokenuser: this.token }).then(function (response) {
        _this3.status = 'show';
        _this3.FriendList = response.data['listfriend'];
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50b24dac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_chat/AccountDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"max-width":"500px","persistent":"","max-height":"500px"},model:{value:(_vm.dialogAccount),callback:function ($$v) {_vm.dialogAccount=$$v},expression:"dialogAccount"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("assignment_ind")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.account')))],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"30px"}},[(_vm.status == 'progress')?_c('v-progress-linear',{attrs:{"indeterminate":_vm.progress}}):_c('v-container',{staticStyle:{"padding-top":"0px"},attrs:{"wrap":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","wrap":""}},[_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center","height":"9vh"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-text-field',{staticClass:"bgsearchcontact CSChatThai",staticStyle:{"height":"8vh"},attrs:{"append-icon":"search","label":_vm.$t('LeftSide.addFiend.searching'),"solo":"","clearable":"","id":"searchcontact"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[(_vm.FilterFriendList.length != 0)?_c('v-container',{staticClass:"scroll-y CSChatThai",staticStyle:{"height":"30vh","margin-top":"0","width":"80%","padding":"0"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-list',{staticClass:"scroll-y CSChatThai",staticStyle:{"width":"100%"},attrs:{"two-line":""}},[_c('v-radio-group',{attrs:{"column":""},model:{value:(_vm.contact_select),callback:function ($$v) {_vm.contact_select=$$v},expression:"contact_select"}},[_vm._l((_vm.FilterFriendList),function(item,index){return [_c('v-list-tile',{attrs:{"avatar":"","ripple":""}},[_c('v-list-tile-action',[_c('v-radio',{attrs:{"value":item}})],1),_vm._v(" "),_c('v-list-tile-avatar',[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'company')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                          "+_vm._s(item.name)+"\n                        ")])],1)],1)]})],2)],1)],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-center":"","wrap":""}},[_c('v-btn',{staticClass:"CSChatThai",staticStyle:{"text-transform":"none"},attrs:{"color":"red","flat":""},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"CSChatThai",staticStyle:{"text-transform":"none"},attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.sendContact()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.send')))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var manage_chat_AccountDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_chat/AccountDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("bDfE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50b24dac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  AccountDialog,
  manage_chat_AccountDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_manage_chat_AccountDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3FVG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3dGV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3nji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState } from 'vuex'

var _ = __webpack_require__("M4fF");

/* harmony default export */ __webpack_exports__["a"] = ({
  props: { 'dialogShowfriend': false, showgroup: '' },
  data: function data() {
    return {
      token: '',
      member: [],
      name: '',
      group_id: '',
      typeuser: '',
      membersGroup: [],
      tokenMember: [],
      businessidMember: [],
      GroupReq: [],
      business_id: '',
      listmember: [],
      usertype: []
    };
  },
  methods: {
    uppic: function uppic() {
      $('#uploadpicprofilechat').click();
    },
    closeDialog: function closeDialog() {
      this.$emit('closeDialogShowFriend', false);
    },
    AcceptReq_GroupReq: function AcceptReq_GroupReq() {
      var _this = this;

      // process.env.APIgo_api + '/v1/accept-group'
      // process.env.APImanage + '/activeinvitegroup'
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/accept-group', { group_id: this.group_id, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          var tokenuser = _this.token;
          var indexgroup = _.findIndex(response.data.group.member, function (o) {
            return o.tokenuser === tokenuser;
          });
          if (indexgroup >= 0) {
            _this.socketactive_group = { timestamp: response.data.group.member[indexgroup].timestamp_in, groupid: _this.group_id, tokenuser: _this.token };
          } else {
            _this.socketactive_group = { timestamp: '', groupid: _this.group_id, tokenuser: _this.token };
          }
        }
      });
      this.closeDialog();
    },
    RemoveReq_GroupReq: function RemoveReq_GroupReq() {
      this.axios.post("https://uatchat-manage.one.th/manage" + '/cancelinvitegroup', { group_id: this.group_id, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {}
      });
      this.closeDialog();
    }
  },
  computed: {},
  watch: {
    showgroup: function showgroup() {
      var _this2 = this;

      this.name = this.showgroup['name'];
      this.group_id = this.showgroup['group_id'];
      this.membersGroup = this.showgroup['member'];
      this.member = _.filter(this.membersGroup, function (member) {
        return member.statemember === 'active';
      });
      var pluck = __webpack_require__("EYc8");
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', { owner: this.token, tokenuser: pluck(this.member, 'tokenuser') }).then(function (response) {
        _this2.member = response.data['user'];
      });
    }
  },
  created: function created() {
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "43GH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "43wB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./node_modules/vue-trix/dist/vue-trix.esm.js
var vue_trix_esm = __webpack_require__("sYAI");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/CreatemailDialogMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var CreatemailDialogMobile = ({
  props: {
    dialogCreatemailMobile: false,
    message: {}
  },
  data: function data() {
    return {
      items: [],
      model: [],
      search: null,
      token: '',
      to: '',
      sender: '',
      subject: '',
      editorContent: '',
      listfriend: [],
      loading: false
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.sender = localStorage.getItem('email');
    this.getlistfriend();
  },
  mounted: function mounted() {},

  methods: {
    closeDialog: function closeDialog() {
      this.editorContent = '';
      this.subject = '';
      this.to = '';
      this.model = [];
      this.$emit('closeCreatemail', false);
    },
    clearMessage: function clearMessage() {
      this.message = {};
    },
    sendmail: function sendmail() {
      var _this = this;

      this.loading = true;
      if (this.to === '') {
        this.loading = false;
        this.$swal('', this.$t('Alert.Fail.SendMail.inputMail'), 'warning');
      } else if (this.subject === '') {
        this.loading = false;
        this.$swal('', this.$t('Alert.Fail.SendMail.inputSubject'), 'warning');
      } else {
        this.axios.post("https://uatchat-manage.one.th/event" + '/send_email', {
          sender: this.sender,
          to: this.to,
          subject: this.subject,
          detail: this.editorContent,
          file_name: this.message.file_name ? this.message.file_name : '',
          file: this.message.message ? this.message.message : ''
        }).then(function (response) {
          if (response.data.status === 'success') {
            _this.loading = false;
            _this.$swal('', _this.$t('Alert.Success.sendEmail'), 'success');
            _this.closeDialog();
          }
        }).catch(function (error) {
          console.log(error);
          _this.loading = false;
          _this.$swal('Network error', _this.$t('Alert.Fail.default.networkError'), 'error');
        });
      }
    },
    getlistfriend: function getlistfriend() {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistfriend', {
        tokenuser: this.token
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this2.listfriend = response.data['listfriend'];
        }
      }, function () {});
    },
    blockevent: function blockevent(data) {
      if (data.event === 'block_friend') {
        indexmsg = _.findIndex(this.listfriend, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        if (indexmsg != -1) {
          _.pullAt(this.listfriend, indexmsg);
        }
      } else if (data.event === 'unblock_friend') {
        this.listfriend.push(data);
        this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc']);
      }
    }
  },
  watch: {
    model: function model(val) {
      // if (val.length > 5) {
      //   this.$nextTick(() => this.model.pop())
      // }
      this.to = val.toString();
    },
    block_friend: function block_friend(data) {
      this.blockevent(data);
    },
    socketremove_friend: function socketremove_friend(data) {
      var index = _.findIndex(this.listfriend, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (index >= 0) {
        this.listfriend.splice(index, 1);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af32feae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/CreatemailDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.dialogCreatemailMobile),callback:function ($$v) {_vm.dialogCreatemailMobile=$$v},expression:"dialogCreatemailMobile"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-email-open-multiple-outline")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.sendEmail.header'))+"\n        ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"30px","height":"535px","overflow-y":"scroll"}},[_c('div',{staticStyle:{"overflow-y":"hidden","margin-top":"10px"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mt-1 pr-2 pl-1",attrs:{"xs12":"","xl12":"","lg12":"","md12":"","sm12":""}},[_c('v-combobox',{attrs:{"items":_vm.items,"search-input":_vm.search,"hide-selected":"","placeholder":_vm.$t('Dialog.sendEmail.to'),"multiple":"","persistent-hint":"","small-chips":"","deletable-chips":"","solo":"","dense":"","outline":"","hide-details":""},on:{"update:searchInput":function($event){_vm.search=$event}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-1 mb-1",attrs:{"xs12":"","xl12":"","lg12":"","md12":"","sm12":""}},[_c('span',{staticStyle:{"color":"#666666","font-size":"12px","padding-left":"10px"}},[_vm._v(_vm._s(_vm.$t('Dialog.sendEmail.note2')))])]),_vm._v(" "),_c('v-flex',{staticClass:"pr-2 pl-1",staticStyle:{"margin-top":"8px"},attrs:{"xs12":"","xl12":"","lg12":"","md12":"","sm12":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject),expression:"subject"}],staticClass:"CSChatThai",attrs:{"type":"text","placeholder":_vm.$t('Dialog.sendEmail.subject')},domProps:{"value":(_vm.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject=$event.target.value}}})]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px"},attrs:{"xs12":"","xl12":"","lg12":"","md12":"","sm12":""}},[_c('VueTrix',{staticClass:"CSChatThai",attrs:{"inputId":"editor1","placeholder":_vm.$t('Dialog.sendEmail.detail')},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})],1),_vm._v(" "),(_vm.message.message)?_c('v-flex',{staticStyle:{"margin-top":"8px"},attrs:{"xs12":"","xl12":"","lg12":"","md12":"","sm12":""}},[_c('div',{staticClass:"attachment_file"},[_c('v-icon',{staticStyle:{"color":"#666666"}},[_vm._v("mdi-paperclip")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#666666"}},[_vm._v(_vm._s(_vm.message.file_name))])],1),_vm._v(" "),_c('span',{staticStyle:{"color":"red"},on:{"click":function($event){_vm.clearMessage()}}},[_vm._v(" "+_vm._s(_vm.$t('Dialog.sendEmail.removeFile'))+" ")])]):_vm._e(),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px","text-align":"center"},attrs:{"xs12":"","xl12":"","lg12":"","md12":"","sm12":""}},[_c('v-btn',{staticStyle:{"background":"#2562af","color":"white","text-transform":"none"},attrs:{"loading":_vm.loading,"disabled":_vm.to === '' || _vm.subject === ''},on:{"click":function($event){_vm.sendmail()}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("mdi-send-outline")]),_vm._v("\n              "+_vm._s(_vm.$t('Dialog.sendEmail.send'))+"\n            ")],1)],1)],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_CreatemailDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/CreatemailDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("9x04")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af32feae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  CreatemailDialogMobile,
  dialog_CreatemailDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_CreatemailDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4enG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4tR0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5ARt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chenfengyuan_vue_countdown__ = __webpack_require__("aCbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chenfengyuan_vue_countdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__chenfengyuan_vue_countdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_homepage_Navbar__ = __webpack_require__("6n5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mobile_dialog_DownloadAppMobile__ = __webpack_require__("a6yM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_chat_dialog_consent_consent_onechat_dialog__ = __webpack_require__("IWN4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_consent_new_consent__ = __webpack_require__("F8NA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex_pathify__ = __webpack_require__("YtWf");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import NewFooter from '@/components/home/NewFooter'
// import Vue from 'vue'


// import VueSocketio from 'vue-socket.io'
var _ = __webpack_require__("M4fF");
var Centrifuge = __webpack_require__("9wbP");
var centrifuge = new Centrifuge("wss://uatchat-manage.one.th/connection/websocket");

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_3__chenfengyuan_vue_countdown___default.a.name, __WEBPACK_IMPORTED_MODULE_3__chenfengyuan_vue_countdown___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      newConsentDialog: false,
      newConsentDetail: {},
      consentOnechatDialog: false,
      url_consent: '',
      usernameRules: [function (v) {
        return _this.regular_username_mobile();
      }],
      passwordRules: [function (v) {
        return _this.regular_pass_mobile();
      }],
      valid: '',
      username: '',
      password: '',
      status: '',
      friend: '',
      status_login: '',
      progress: false,
      failmessage: this.$t('Alert.Login.invalidUserPass'),
      webdev: "https://uatchat.one.th:8089/docs",
      showPassword: false,
      url_redirect: "https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect",
      // url_redirect: 'process.env.AuthenOneid',
      validmobile: '',
      type: 'first',
      phone: '',
      otpCode: '',
      Refcode: '',
      mobile_ref_id: '',
      type_otp: '',
      counting: false,
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex_pathify__["c" /* sync */])('*')),
  created: function created() {
    if (localStorage.getItem('Authenrization')) {
      this.status_login = JSON.parse(__WEBPACK_IMPORTED_MODULE_8__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')))['status_login'];
      var token = JSON.parse(__WEBPACK_IMPORTED_MODULE_8__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')))['tokenuser'];
      // console.log(this.status_login)
      this.connectCentrifuge(token);
      this.getOnechatToken(token);
      // if (this.status_login === 'T') {
      //   if (this.isMobile()) {
      //     this.$router.push('/mobile/homepage')
      //   } else {
      //     this.$router.push('/chat')
      //   }
      // }
    }
  },
  mounted: function mounted() {
    console.log('mounted: ', localStorage.tologin);
    if (localStorage.tologin) {
      this.type = 'phone';
      this.phone = localStorage.tologin;
    }
  },

  methods: {
    closeNewConsent: function closeNewConsent(value) {
      console.log("close new consent", value);
      this.newConsentDialog = value.close;
      this.newConsentDetail = {};
      // set localStorage authorization
      this.progress = true;
      localStorage.setItem('Authenrization', __WEBPACK_IMPORTED_MODULE_8__services__["b" /* Encode */].encode({ 'tokenuser': value.token, 'status_login': 'T', 'type_user': 'user' }));
      if (localStorage.getItem('botid_redirect') !== null) {
        this.progress = false;
        this.searchFriend(localStorage.getItem('botid_redirect'));
      } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
        this.progress = false;
        // redirect bot room with url
        var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
        this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + '&url=' + data.url);
      } else {
        this.progress = false;
        // console.log(`this.isMobile(): ${this.isMobile()}`)
        if (window.innerWidth <= 960) {
          this.$router.push('/mobile/homepage');
        } else {
          this.$router.push('/chat');
        }
      }
    },
    connectCentrifuge: function connectCentrifuge(token) {
      var me = this;
      var events = '';
      var data_msg = '';
      centrifuge.setToken('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs');
      centrifuge.subscribe(token, function (message) {
        console.log(message.data.event);
        events = message.data.event;
        if (events === 'consent') {
          // consent close dialog
          me.consentOnechatDialog = false;
          me.getOnechatToken(token);
        }
      });
      centrifuge.on('connect', function () {
        console.log("connected centrifuge login");
      });
      centrifuge.on('disconnect', function () {
        console.log("disconnected centrifuge login");
      });
      centrifuge.connect();
    },
    closeDialogConsentOnechat: function closeDialogConsentOnechat(value) {
      this.consentOnechatDialog = value;
    },
    getOnechatToken: function getOnechatToken(token) {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var hour = String(today.getHours() + 1).padStart(2, '0');
      var minute = String(today.getMinutes()).padStart(2, '0');
      var seconds = String(today.getSeconds()).padStart(2, '0');
      var milsec = today.getMilliseconds();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00';
        dd = String(today.getDate() + 1).padStart(2, '0');
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1';
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1';
            yyyy = today.getFullYear() + 1;
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0');
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
      // console.log(today)
      var expireddate = Date.parse(today);
      // console.log(expireddate)
      var body = __WEBPACK_IMPORTED_MODULE_8__services__["b" /* Encode */].encodeRichmenu({ 'userid': token, 'expired_date': expireddate });
      // console.log(body)
      this.progress = true;
      // check new consent
      if (this.$cookie.get('check-consent-' + token) === null || this.$cookie.get('check-consent-' + token) === undefined) {
        // test new consent
        this.progress = false;
        this.newConsentDialog = true;
        this.newConsentDetail = { token: token };
      } else {
        this.progress = false;
        // set localStorage authorization
        localStorage.setItem('Authenrization', __WEBPACK_IMPORTED_MODULE_8__services__["b" /* Encode */].encode({ 'tokenuser': token, 'status_login': 'T', 'type_user': 'user' }));
        if (localStorage.getItem('botid_redirect') !== null) {
          this.searchFriend(localStorage.getItem('botid_redirect'));
        } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
          // redirect bot room with url
          var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
          this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + '&url=' + data.url);
        } else {
          // console.log(`this.isMobile(): ${this.isMobile()}`)
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage');
          } else {
            this.$router.push('/chat');
          }
        }
      }

      // this.axios.post(process.env.APIgo_api + `/v1/get-consent`, { onechat_token: body }).then((response) => {
      //   // console.log(response.data)
      //   if (response.data.status === 'success') {
      //     this.progress = false
      //     if (response.data.data.consent_check === 'true') {
      //       // set localStorage authorization
      //       localStorage.setItem('Authenrization', Encode.encode({'tokenuser': token, 'status_login': 'T', 'type_user': 'user'}))
      //       if (localStorage.getItem('botid_redirect') !== null) {
      //         this.searchFriend(localStorage.getItem('botid_redirect'))
      //       } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
      //         // redirect bot room with url
      //         var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
      //         this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
      //       } else {
      //         // console.log(`this.isMobile(): ${this.isMobile()}`)
      //         if (window.innerWidth <= 960) {
      //           this.$router.push('/mobile/homepage')
      //         } else {
      //           this.$router.push('/chat')
      //         }
      //       }
      //     } else {
      //       // show dialog consent
      //       this.consentOnechatDialog = true
      //       this.url_consent = response.data.data.consent_url
      //       // clear localStorage autherization
      //       localStorage.removeItem('Authenrization')
      //       this.$router.push({path: '/login', force: true})
      //     }
      //   }
      // }).catch(err => {
      //   console.log(err)
      //   this.progress = false
      // })
    },
    handleCountdownEnd: function handleCountdownEnd() {
      this.OTP = '';
      this.counting = false;
    },
    open_link: function open_link(link) {
      window.open(link, '_blank');
    },
    otp: function otp() {
      var _this2 = this;

      this.loading = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/otp_login_and_regis', { phone: this.phone, type: 'login' }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          if (response.data.type_otp == 'login') {
            _this2.loading = false;
            _this2.Refcode = response.data.refcode;
            _this2.mobile_ref_id = response.data.mobile_ref_id;
            _this2.type_otp = response.data.type_otp;
            _this2.counting = true;
            _this2.type = "otp";
          } else {
            _this2.loading = false;
            _this2.phone = '';
            _this2.$swal('', _this2.$t('Alert.Login.phoneNotVerify'), 'error');
          }
        } else if (response.data['message'] === 'No JSON object could be decoded') {
          _this2.loading = false;
          _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
        } else if (response.data['message'] === 'too many requests.') {
          _this2.loading = false;
          _this2.$swal('', _this2.$t('Alert.Login.otpRequest'), 'error');
        } else {
          _this2.loading = false;
          _this2.$swal(response.data['status'], response.data['message'], 'error');
        }
      }, function (error) {
        console.log(error);
        _this2.status = 'fail';
        _this2.progress = false;
        _this2.type = 'first';
        _this2.failmessage = _this2.$t('Alert.Fail.default.somethingWrong');
      });
    },
    loginWithotp: function loginWithotp() {
      var _this3 = this;

      this.progress = true;
      var source = { type_otp: this.type_otp, phone: this.phone, otp: this.otpCode, mobile_ref_id: this.mobile_ref_id };
      this.axios.post("https://uatchat-manage.one.th/manage" + '/login_and_regis', source).then(function (response) {
        _this3.status = response.data['status'];
        // console.log(response.data)
        if (_this3.status === 'success') {
          var profile = response.data['account']['profile'];
          _this3.myprofilepicture = profile['profilepicture'];
          _this3.myname = profile['name'];
          // this.$cookie.set('language', 'th')
          _this3.$i18n.locale = _this3.$cookie.get('language') ? _this3.$cookie.get('language') : 'th';
          localStorage.setItem('Authenrization', __WEBPACK_IMPORTED_MODULE_8__services__["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
          localStorage.setItem('profilepicture', profile['profilepicture']);
          localStorage.setItem('name', profile['name']);
          localStorage.setItem('phone', profile['phone']);
          localStorage.setItem('email', profile['email']);
          localStorage.setItem('status', profile['status']);
          localStorage.setItem('type_user', profile['type']);
          localStorage.setItem('wallpaperInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            'info': [{
              'room': '',
              'background': ''
            }]
          }));
          if (profile['username'] === '' || profile['username'] === 'None') {
            localStorage.setItem('status_username', 'false');
          } else {
            localStorage.setItem('status_username', 'true');
          }
          _this3.progress = false;
          if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
            // this.$router.push('/chat')
            _this3.getOnechatToken(profile['tokenuser']);
          } else {
            _this3.$router.push(localStorage.getItem('pathRoom'));
          }
          localStorage.removeItem("tologin");
          localStorage.removeItem("tologin_keep2");
        } else if (response.data['message'] === 'The resource owner or authorization server denied the request.') {
          _this3.$cookie.set('status_login', 'F');
          _this3.progress = false;
          _this3.$swal('', _this3.$t('Alert.Login.otpInvalid'), 'error');
        } else {
          _this3.$cookie.set('status_login', 'F');
          _this3.progress = false;
          _this3.$swal(_this3.status, response.data['message'], 'error');
        }
      }, function (error) {
        console.log(error);
        _this3.status = 'fail';
        _this3.progress = false;
        _this3.failmessage = _this3.$t('Alert.Fail.default.somethingWrong');
      });
    },
    loginRedirect: function loginRedirect() {
      this.progress = true;
      window.open(this.url_redirect, '_parent');
    },
    redirectUrl: function redirectUrl(url) {
      try {
        var link = document.getElementById("iframename").contentWindow.location.href;
        // console.log(link)
        // console.log(_.includes(link, [process.env.redirect_url]))
        if (_.includes(link, ["https://uatchat.one.th/authorization/redirect"])) {
          window.open(link + '&passlogin=true', '_parent');
        }
      } catch (err) {
        console.log(err);
      }
    },
    regular_username_mobile: function regular_username_mobile() {
      // var str = this.username
      this.username = this.username.replace(/[^a-z-0-9@.]/i, '');
      this.username = this.username.toLowerCase();
    },
    regular_pass_mobile: function regular_pass_mobile() {
      this.password = this.password.replace(/^[ก-๛]+/i, '');
    },
    isNumandaz: function isNumandaz($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122) && keyCode != 46 && keyCode != 64) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    isnotthai: function isnotthai($event) {
      // console.log($event)
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // console.log(keyCode)
      if (keyCode >= 3585 && keyCode <= 3642 || keyCode >= 3647 && keyCode <= 3675) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    toNewTab: function toNewTab() {
      window.open(this.webdev, '_parent').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    isMobile: function isMobile() {
      if ($('#mobile').is(':hidden')) {
        return false;
      } else {
        return true;
      }
    },
    login: function login() {
      var _this4 = this;

      var addyear = 10;
      var newDate = new Date();
      newDate.setTime(newDate.getTime() + addyear * 365 * 24 * 60 * 60 * 1000);
      var expiresInTime = "expires=" + newDate.toUTCString();

      if (this.username === '' || this.password === '') {
        this.failmessage = this.$t('Alert.Login.inputUserPass');
      } else {
        this.progress = true;
        var source = __WEBPACK_IMPORTED_MODULE_8__services__["b" /* Encode */].encode({ 'username': this.username, 'password': this.password });
        this.axios.post("https://uatchat-manage.one.th/manage" + '/loginuserwithbusiness', { source: source }).then(function (response) {
          // console.log(response.data)
          _this4.status = response.data['status'];
          if (_this4.status === 'success') {
            var profile = response.data['account']['profile'];
            // localStorage.setItem('status_login', 'T')
            _this4.myprofilepicture = profile['profilepicture'];
            _this4.myname = profile['name'];
            // this.$cookie.set('status_login', 'T')
            // this.$cookie.set('tokenuser', Encode.encodeToken(profile['tokenuser']))
            // this.$cookie.set('language', 'th')
            _this4.$i18n.locale = _this4.$cookie.get('language') ? _this4.$cookie.get('language') : 'th';
            localStorage.setItem('Authenrization', __WEBPACK_IMPORTED_MODULE_8__services__["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
            localStorage.setItem('profilepicture', profile['profilepicture']);
            localStorage.setItem('name', profile['name']);
            localStorage.setItem('phone', profile['phone']);
            localStorage.setItem('email', profile['email']);
            localStorage.setItem('status', profile['status']);
            localStorage.setItem('type_user', profile['type']);
            localStorage.setItem('wallpaperInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
              'info': [{
                'room': '',
                'background': ''
              }]
            }));
            if (profile['username'] === '' || profile['username'] === 'None') {
              localStorage.setItem('status_username', 'false');
            } else {
              localStorage.setItem('status_username', 'true');
            }
            _this4.progress = false;
            // connect centrifuge
            _this4.connectCentrifuge(profile['tokenuser']);
            if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
              _this4.getOnechatToken(profile['tokenuser']);
              // if (localStorage.getItem('botid_redirect') !== null) {
              //   this.searchFriend(localStorage.getItem('botid_redirect'))
              // } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
              //   // redirect bot room with url
              //   var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
              //   this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
              // } else {
              //   if (this.isMobile()) {
              //     this.$router.push('/mobile/homepage')
              //   } else {
              //     this.$router.push('/chat')
              //   }
              // }
            } else {
              _this4.$router.push(localStorage.getItem('pathRoom'));
            }
          } else {
            _this4.$cookie.set('status_login', 'F');
            _this4.progress = false;
            if (response.data['message'] === 'Wrong Username / Password') {
              _this4.failmessage = _this4.$t('Alert.Login.invalidUserPass');
            } else {
              _this4.failmessage = _this4.$t('Alert.Fail.default.somethingWrong');
            }
          }
        }, function (error) {
          console.log(error);
          _this4.status = 'fail';
          _this4.progress = false;
          _this4.failmessage = _this4.$t('Alert.Fail.default.somethingWrong');
        });
      }
    },
    searchFriend: function searchFriend(botid) {
      var _this5 = this;

      // console.log(`bot id : ${localStorage.getItem('botid_redirect')}`)
      if (localStorage.getItem('botid_redirect') !== null) {
        this.progress = true;
        var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_8__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
        this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend", {
          tokenbot: botid,
          tokenuser: decoded.tokenuser
        }).then(function (response) {
          _this5.progress = false;
          // console.log(response.data.listuser)
          if (response.data.listuser.length === 0) {
            if (window.innerWidth <= 960) {
              _this5.$router.push('/mobile/homepage');
            } else {
              _this5.$router.push('/chat');
            }
          } else {
            if (response.data.listuser.relation === 'friend') {
              localStorage.removeItem('botid_redirect');
              if (_this5.isMobile()) {
                _this5.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom);
              } else {
                _this5.$router.push('/chat/room/' + response.data.listuser.user.tokenroom);
              }
            } else {
              console.log('not friend');
              _this5.$router.push('/addbot/' + localStorage.getItem('botid_redirect'));
            }
          }
        }).catch(function (error) {
          console.log(error);
          localStorage.removeItem('botid_redirect');
          _this5.progress = false;
          // this.$swal('', 'ไม่มีข้อมูลบอทในระบบ กรุณาตรวจสอบข้อมูลให้ถูกต้อง', 'warning')
          if (window.innerWidth <= 960) {
            _this5.$router.push('/mobile/homepage');
          } else {
            _this5.$router.push('/chat');
          }
        });
      }
    }
  },
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_4__components_homepage_Navbar__["a" /* default */],
    Download: __WEBPACK_IMPORTED_MODULE_5__components_mobile_dialog_DownloadAppMobile__["a" /* default */],
    checkconsentOnechatDialog: __WEBPACK_IMPORTED_MODULE_6__components_chat_dialog_consent_consent_onechat_dialog__["a" /* default */],
    newConsent: __WEBPACK_IMPORTED_MODULE_7__components_consent_new_consent__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-google-maps/dist/components/map.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var map = ((function (x) {
  return x.default || x;
})(__webpack_require__("hOwk")));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6839df3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-google-maps/dist/components/map.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_map = (esExports);
// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/map.vue
function injectStyle (ssrContext) {
  __webpack_require__("Liod")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  map,
  components_map,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dist_components_map = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-google-maps/dist/components/infoWindow.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var infoWindow = ((function (x) {
  return x.default || x;
})(__webpack_require__("WgA/")));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25e3f758","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-google-maps/dist/components/infoWindow.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_infoWindow = (esExports);
// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/infoWindow.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  infoWindow,
  components_infoWindow,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dist_components_infoWindow = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6NYr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6jRI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6n5U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Navbar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Navbar = ({
  data: function data() {
    return {
      name: '',
      profilepicture: '',
      typeuser: '',
      status_login: 'F',
      pathname: ''
    };
  },

  methods: {
    changeLan: function changeLan(lang) {
      this.$i18n.locale = lang;
      this.$cookie.set('language', lang);
      // this.changeLangMenu()
    },
    toPage: function toPage(page) {
      // console.log(page)
      this.pathname = page;
      this.$router.push(page);
    },
    profilepicture_default: function profilepicture_default() {
      if (this.profilepicture) {
        return this.profilepicture;
      } else if (this.typeuser === 'government' || this.typeuser === 'company') {
        return '/static/img/default_profile/business-white.png';
      } else {
        return '/static/img/default_profile/man-white.png';
      }
    },
    logout: function logout() {
      localStorage.clear();
      // if (process.env.LogoutOneid) {
      //   window.open(process.env.LogoutOneid, '_parent')
      // } else {
      //   this.$router.push({path: '/login', force: true})
      // }
      var logouturl = this.$cookie.get('logouturl');
      if (true) {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent');
          this.$cookie.delete('logouturl');
        } else {
          window.open("https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage", '_parent');
        }
      } else {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent');
          this.$cookie.delete('logouturl');
        } else {
          this.$router.push({ path: '/login', force: true });
        }
      }
    },
    toLogin: function toLogin() {
      if (localStorage.tologin) {
        localStorage.removeItem("tologin");
      }
      this.$router.push('/login');
    }
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {
    myname: function myname() {
      this.name = localStorage.getItem('name');
    },
    myprofilepicture: function myprofilepicture() {
      this.profilepicture = localStorage.getItem('profilepicture');
    }
  },
  created: function created() {
    this.pathname = location.pathname;
    // console.log(this.pathname)
    // this.status_login = this.$cookie.get("status_login")
    // console.log(localStorage.getItem('Authenrization'))
    if (localStorage.getItem('Authenrization')) {
      var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      this.status_login = decoded['status_login'];
    }
    // var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    // this.status_login = decoded['status_login']
    this.name = localStorage.getItem('name');
    this.profilepicture = localStorage.getItem('profilepicture');
    this.typeuser = localStorage.getItem('type_user');
    if (this.$router.currentRoute.path === '/' && this.status_login === 'T') {
      this.$router.push('/chat');
    }
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
    // this.$i18n.locale = 'th'
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e972bec8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Navbar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticStyle:{"color":"#5eca33","background-color":"#2562af"},attrs:{"fixed":"","dark":""}},[_c('v-toolbar-items',{staticClass:"borderXwidth"},[_c('v-btn',{staticClass:"fontset",attrs:{"flat":""},on:{"click":function($event){_vm.toPage('/homepage')}}},[_c('v-avatar',{attrs:{"tile":"","size":"43"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/home.png"}})])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"borderXwidth"},[((_vm.status_login == null || _vm.status_login == 'F'))?_c('v-btn',{staticClass:"fontset text-transform",attrs:{"flat":""},on:{"click":function($event){_vm.toPage('/register')}}},[_vm._v(_vm._s(_vm.$t('Register.Button.register')))]):_vm._e(),_vm._v(" "),((_vm.status_login == null || _vm.status_login == 'F'))?_c('v-btn',{staticClass:"fontset text-transform",staticStyle:{"height":"35px","color":"#2562B0"},attrs:{"round":"","color":"white"},on:{"click":function($event){_vm.toLogin()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.loginnavbar')))]):_c('v-btn',{staticClass:"fontset",attrs:{"flat":""},on:{"click":function($event){_vm.toPage('/chat')}}},[_c('v-avatar',{staticStyle:{"margin-right":"1vw !important"},attrs:{"size":"50px"}},[_c('v-img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer"},attrs:{"alt":"profile picture","src":_vm.profilepicture_default()}})],1),_vm._v(" "),_c('p',{staticClass:"textlayoutnavbar"},[_vm._v(_vm._s(_vm.name))])],1),_vm._v(" "),(_vm.status_login == 'T')?_c('v-btn',{staticStyle:{"margin-top":"11px !important"},attrs:{"flat":"","icon":"","row":"","wrap":""},on:{"click":function($event){_vm.logout()}}},[_c('v-icon',{staticStyle:{"font-size":"25px !important"}},[_vm._v("mdi-logout-variant")])],1):_vm._e(),_vm._v(" "),_c('v-menu',{staticStyle:{"z-index":"11"},attrs:{"offset-y":""}},[(_vm.$i18n.locale == 'th')?_c('img',{staticClass:"iconLanguage",attrs:{"slot":"activator","src":"/static/flag/thailand.svg"},slot:"activator"}):(_vm.$i18n.locale == 'en')?_c('img',{staticClass:"iconLanguage",attrs:{"slot":"activator","src":"/static/flag/united-kingdom.svg"},slot:"activator"}):(_vm.$i18n.locale == 'cn')?_c('img',{staticClass:"iconLanguage",attrs:{"slot":"activator","src":"/static/flag/china.png"},slot:"activator"}):_vm._e(),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.changeLan('th')}}},[_c('v-list-tile-title',[_c('img',{staticStyle:{"height":"20px"},attrs:{"src":"/static/flag/thailand.svg"}}),_vm._v("  ไทย\n                ")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeLan('en')}}},[_c('v-list-tile-title',[_c('img',{staticStyle:{"height":"20px"},attrs:{"src":"/static/flag/united-kingdom.svg"}}),_vm._v("  ENG\n                ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var homepage_Navbar = (esExports);
// CONCATENATED MODULE: ./src/components/homepage/Navbar.vue
function injectStyle (ssrContext) {
  __webpack_require__("hUZz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e972bec8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Navbar,
  homepage_Navbar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_homepage_Navbar = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7CGg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_100vh__ = __webpack_require__("hErE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dragAndDropCapable: false,
      files: [],
      token: ''
    };
  },
  mounted: function mounted() {
    this.dragAndDropCapable = this.determineDragAndDropCapable();
    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
        this.$refs.fileform.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }.bind(this));
      this.$refs.fileform.addEventListener('drop', function (e) {
        for (var i = 0; i < e.dataTransfer.files.length; i++) {
          this.files.push({ file: e.dataTransfer.files[i], status: 'waiting' });
          this.getImagePreviews();
        }
      }.bind(this));
    }
  },

  components: {
    vue100vh: __WEBPACK_IMPORTED_MODULE_1_vue_100vh__["a" /* default */]
  },
  methods: {
    openFileimage: function openFileimage() {
      this.$refs.files.click();
    },
    toPage: function toPage(data) {
      this.$router.push(data);
    },
    upfile: function upfile() {
      $('#uploadfile').click();
    },
    determineDragAndDropCapable: function determineDragAndDropCapable() {
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
    },
    getImagePreviews: function getImagePreviews(key) {
      var _this = this;

      var _loop = function _loop(i) {
        if (/\.(jpe?g|png|gif)$/i.test(_this.files[i].file.name)) {
          var reader = new FileReader();
          reader.addEventListener('load', function () {
            this.$refs['preview' + parseInt(i)][0].src = reader.result;
          }.bind(_this), false);
          reader.readAsDataURL(_this.files[i].file);
          // this.extension(this.files[i].name)
          // console.log(this.extension())
        } else {
            // this.$nextTick(function(){
            // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
            // });
            // console.log('mm')
          }
      };

      for (var i = 0; i < this.files.length; i++) {
        _loop(i);
      }
    },
    handleFilesUpload: function handleFilesUpload(key) {
      var uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({ file: uploadedFiles[i], status: 'waiting' });
      }
      this.getImagePreviews(key);
      document.querySelector('#files').value = '';
    },
    submitFiles: function submitFiles(key) {
      var _this2 = this;

      var formData = new FormData();
      // for (var i = 0; i < this.files.length; i++) {
      var file = this.files[key].file;
      formData.append('files[' + key + ']', file);
      formData.append('file', file, file.name);
      formData.append('tokenuser', this.token);
      formData.append('appkey', 'QWErty1234');
      this.axios.post("https://uatchat-manage.one.th/event" + '/save_onebox', formData).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          // console.log(response)
          _this2.$swal('', _this2.$t('Alert.Success.success'), 'success');
          // this.files.splice(key, 1)
          _this2.removeFile(key);
          // this.files.splice( key )
        } else {
          _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
          _this2.files[key]['status'] = 'fail';
        }
      }, function (response) {
        // console.log('error')
        _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
        _this2.files[key]['status'] = 'fail';
      }).catch(function (error) {
        console.log(error);
        _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
        _this2.files[key]['status'] = 'fail';
      });
    },
    removeFile: function removeFile(key) {
      this.files.splice(key, 1);
      // this.getImagePreviews(key)
    },
    submitallFiles: function submitallFiles() {
      var lengthfile = this.files.length;
      for (var i = 0; i < lengthfile; i++) {
        this.senbox(i);
      }
    },
    senbox: function senbox(i) {
      var _this3 = this;

      var formData = new FormData();
      var file = this.files[i].file;
      // formData.append('files[0]', file)
      formData.append('file', file, file.name);
      formData.append('tokenuser', this.token);
      this.files[i]['status'] = 'process';
      this.axios.post("https://uatchat-manage.one.th/event" + '/save_onebox', formData).then(function (response) {
        if (response.data.status === 'success') {
          // console.log('success')
          _this3.files[i]['status'] = 'success';
          // this.removeFile(i)
          // console.log(this.files.length)
          // return 'true'
          // console.log(this.files.length)
        } else {
          _this3.$swal('', _this3.$t('Alert.Fail.default.somethingWrong'), 'error');
          _this3.files[i]['status'] = 'fail';
          // return 'false'
        }
      }).catch(function (error) {
        console.log(error);
        _this3.$swal('', _this3.$t('Alert.Fail.default.somethingWrong'), 'error');
        _this3.files[i]['status'] = 'fail';
      });
    },
    extension: function extension(files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase();
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
      var pdf = ['pdf'];
      var file = ['ai', 'ps', 'psd'];
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm'];
      var presentation = ['ppt', 'pps', 'pot', 'pptx'];
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff'];
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf';
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive';
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel';
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint';
      } else if (word.includes(extension)) {
        return 'fas fa-file-word';
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code';
      } else if (image.includes(extension)) {
        return 'fas fa-file-image';
      } else if (file.includes(extension)) {
        return 'fas fa-file';
      } else {
        return 'fas fa-file-alt';
      }
      // return extension[extension.length-1]
    }
  },
  created: function created() {
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    // console.log(this.token)
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8SS7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Xnh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8d7s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8xQL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8yZq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/RichmenuDialogMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var RichmenuDialogMobile = ({
  props: {
    Richmenudialog: false,
    inforrichmenu: {},
    type_richmenu: Number
  },
  data: function data() {
    return {
      // type_richmenu: '12'
    };
  },
  created: function created() {
    // console.log(this.inforrichmenu)
    // console.log(this.type_richmenu)
    this.list_menu = this.inforrichmenu;
    // console.log(this.list_menu)
  },

  methods: {
    sendrichmenu: function sendrichmenu(item, index) {
      // console.log(item)
      this.$emit('emitrichmenu', this.inforrichmenu[index]);
    }
  },
  watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ee7a42","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/RichmenuDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type_richmenu === 1)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs4":"","md4":"","sm4":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":item.picture,"lazy-src":item.picture,"aspect-ratio":"1.5","min-height":"140px"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)}))],1):(_vm.type_richmenu === 2)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs6":"","md6":"","sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":item.picture,"lazy-src":item.picture,"aspect-ratio":"1.5","min-height":"100px"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)}))],1):(_vm.type_richmenu === 3)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pa-0",attrs:{"xs12":"","md12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[0].picture,"lazy-src":_vm.list_menu[0].picture,"aspect-ratio":"3","min-height":"100px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[0], 0)}}})],1)],1),_vm._v(" "),_vm._l((_vm.list_menu),function(item,index){return (index !== 0)?_c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs4":"","md4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":item.picture,"lazy-src":item.picture,"aspect-ratio":"1","min-height":"90px"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1):_vm._e()})],2)],1):(_vm.type_richmenu === 4)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pa-0",attrs:{"xs8":"","md8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[0].picture,"lazy-src":_vm.list_menu[0].picture,"aspect-ratio":"1","min-height":"180px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[0], 0)}}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-0",attrs:{"xs4":"","md4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',[_c('v-layout',{attrs:{"column":""}},_vm._l((_vm.list_menu),function(item,index){return (index !== 0)?_c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs12":"","md12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","min-height":"100px","src":item.picture,"lazy-src":item.picture,"aspect-ratio":"1"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1):_vm._e()}))],1)],1)],1)],1):(_vm.type_richmenu === 5)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{staticClass:"pa-0",attrs:{"xs12":"","md12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","min-height":"100px","src":item.picture,"lazy-src":item.picture,"aspect-ratio":"3"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)}))],1):(_vm.type_richmenu === 6)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs6":"","md6":"","sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"src":item.picture,"lazy-src":item.picture,"min-height":"240px","aspect-ratio":"1.3","cover":""},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)})):(_vm.type_richmenu === 7)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"pa-0",attrs:{"xs12":"","md12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[0].picture,"lazy-src":_vm.list_menu[0].picture,"aspect-ratio":"1.5","min-height":"240px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[0], 0)}}})],1)],1)],1):(_vm.type_richmenu === 8)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs4":"","md4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":item.picture,"lazy-src":item.picture,"aspect-ratio":"1","min-height":"90px"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)})):(_vm.type_richmenu === 9)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"pa-0",attrs:{"xs4":"","md4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[0].picture,"lazy-src":_vm.list_menu[0].picture,"aspect-ratio":"1","min-height":"90px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[0], 0)}}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-0",attrs:{"xs8":"","md8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[1].picture,"lazy-src":_vm.list_menu[1].picture,"aspect-ratio":"2","min-height":"90px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[1], 1)}}})],1)],1)],1):(_vm.type_richmenu === 10)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"pa-0",attrs:{"xs8":"","md8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[0].picture,"lazy-src":_vm.list_menu[0].picture,"aspect-ratio":"2","min-height":"90px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[0], 0)}}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-0",attrs:{"xs4":"","md4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[1].picture,"lazy-src":_vm.list_menu[1].picture,"aspect-ratio":"1","min-height":"90px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[1], 1)}}})],1)],1)],1):(_vm.type_richmenu === 11)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs6":"","md6":"","sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":item.picture,"lazy-src":item.picture,"aspect-ratio":"1.5","min-height":"90px"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)})):(_vm.type_richmenu === 12)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"pa-0",attrs:{"xs12":"","md12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[0].picture,"lazy-src":_vm.list_menu[0].picture,"aspect-ratio":"3","height":"70%"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[0], 0)}}})],1)],1)],1):(_vm.type_richmenu === 13)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs3":"","md3":"","sm3":"","md3":"","lg3":"","xl3":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":item.picture,"lazy-src":item.picture,"aspect-ratio":"1.5","min-height":"90px"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_RichmenuDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/RichmenuDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("Q6K3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55ee7a42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  RichmenuDialogMobile,
  dialog_RichmenuDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_RichmenuDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8zZB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9K65":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pdf__ = __webpack_require__("dAhr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_offline__ = __webpack_require__("mbt8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chat_dialog_notes_NoteDialog__ = __webpack_require__("0j5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_chat_dialog_manage_chat_AccountDialog__ = __webpack_require__("32Ju");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_chat_dialog_LoginDialog__ = __webpack_require__("HaTd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_chat_dialog_manage_chat_ForwardDialog__ = __webpack_require__("cGNK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_chat_dialog_manage_chat_MapDialog__ = __webpack_require__("Hwln");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_chat_dialog_manage_chat_ApproveDialog__ = __webpack_require__("OCah");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_chat_dialog_albums_AlbumsDialog__ = __webpack_require__("xh2Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_chat_dialog_albums_AddImageDialog__ = __webpack_require__("at4G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_chat_dialog_settings_Openwebsite__ = __webpack_require__("gDCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_chat_dialog_ShowImageDialog__ = __webpack_require__("fIB/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_chat_dialog_ShowPDFDialog__ = __webpack_require__("blpm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_chat_dialog_mail_CreatemailDialog__ = __webpack_require__("qkiP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_chat_dialog_manage_chat_WebviewBigDialog__ = __webpack_require__("khKU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_chat_dialog_manage_chat_WebviewBigOcrDialog__ = __webpack_require__("aj2r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_chat_manage_task_detail_task_dialog__ = __webpack_require__("l1Ae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_chat_dialog_saveonebox_SaveoneboxDialog__ = __webpack_require__("rTZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_chat_dialog_richmenu_Richmenudialog__ = __webpack_require__("BUqv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_chat_dialog_CheckBrowserDialog__ = __webpack_require__("Se0g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_chat_dialog_settings_ShowQRCodeUserDialog__ = __webpack_require__("wgae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_chat_agora_call_ans_call_v2__ = __webpack_require__("Hruy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_chat_dialog_manage_chat_ReadmoreDialog__ = __webpack_require__("eOAw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_chat_dialog_dialogGetPassword__ = __webpack_require__("nIDX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_link_prevue__ = __webpack_require__("mo46");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_link_prevue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_link_prevue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_context__ = __webpack_require__("IaZh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_link_preview_js__ = __webpack_require__("fqjD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_link_preview_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_link_preview_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_hls_player__ = __webpack_require__("VfTH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_hls_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vue_hls_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_highlightable_input__ = __webpack_require__("6IPY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_at__ = __webpack_require__("2RyS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vue_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_at_dist_vue_at_textarea__ = __webpack_require__("Ve+4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_at_dist_vue_at_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vue_at_dist_vue_at_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuex_pathify__ = __webpack_require__("YtWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vue_mention__ = __webpack_require__("Ddm3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vue_highlights__ = __webpack_require__("1t5/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vue_highlights___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_vue_highlights__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ashwamegh_vue_link_preview__ = __webpack_require__("nPZZ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// import WebviewDialog from '@/components/chat/dialog/manage_chat/WebviewDialog'





















// Vue.use(VueCoreVideoPlayer)

// import ModalImg from '@/components/chat/modal/ModalImg'




var emojiGroups = __webpack_require__("WJD3");
var _ = __webpack_require__("M4fF");




__WEBPACK_IMPORTED_MODULE_35_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_36_vue_highlights___default.a.name, __WEBPACK_IMPORTED_MODULE_36_vue_highlights___default.a, __WEBPACK_IMPORTED_MODULE_26_link_prevue___default.a, __WEBPACK_IMPORTED_MODULE_37__ashwamegh_vue_link_preview__["a" /* default */]);

// let grabity = require("grabity");

window.EventBus = new __WEBPACK_IMPORTED_MODULE_35_vue__["default"]({
  methods: {
    emit: function emit(payload) {
      this.$emit('$EventBusEvent', payload);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ReadmoreDialog: __WEBPACK_IMPORTED_MODULE_24__components_chat_dialog_manage_chat_ReadmoreDialog__["a" /* default */],
    AgoraCallDialog: __WEBPACK_IMPORTED_MODULE_23__components_chat_agora_call_ans_call_v2__["a" /* default */],
    vplayer: __WEBPACK_IMPORTED_MODULE_29_vue_hls_player__["vplayer"],
    QrcodeDialog: __WEBPACK_IMPORTED_MODULE_22__components_chat_dialog_settings_ShowQRCodeUserDialog__["a" /* default */],
    CheckBrowserDialog: __WEBPACK_IMPORTED_MODULE_21__components_chat_dialog_CheckBrowserDialog__["a" /* default */],
    LoginDialog: __WEBPACK_IMPORTED_MODULE_6__components_chat_dialog_LoginDialog__["a" /* default */],
    pdf: __WEBPACK_IMPORTED_MODULE_1_vue_pdf__["a" /* default */],
    DialogGetpassword: __WEBPACK_IMPORTED_MODULE_25__components_chat_dialog_dialogGetPassword__["a" /* default */],
    // ModalImg,
    offline: __WEBPACK_IMPORTED_MODULE_2_v_offline__["a" /* default */],
    MapDialog: __WEBPACK_IMPORTED_MODULE_8__components_chat_dialog_manage_chat_MapDialog__["a" /* default */],
    NoteDialog: __WEBPACK_IMPORTED_MODULE_4__components_chat_dialog_notes_NoteDialog__["a" /* default */],
    AccountDialog: __WEBPACK_IMPORTED_MODULE_5__components_chat_dialog_manage_chat_AccountDialog__["a" /* default */],
    ForwardDialog: __WEBPACK_IMPORTED_MODULE_7__components_chat_dialog_manage_chat_ForwardDialog__["a" /* default */],
    // WebviewDialog,
    WebviewBigDialog: __WEBPACK_IMPORTED_MODULE_16__components_chat_dialog_manage_chat_WebviewBigDialog__["a" /* default */],
    WebviewBigOcrDialog: __WEBPACK_IMPORTED_MODULE_17__components_chat_dialog_manage_chat_WebviewBigOcrDialog__["a" /* default */],
    ApproveDialog: __WEBPACK_IMPORTED_MODULE_9__components_chat_dialog_manage_chat_ApproveDialog__["a" /* default */],
    AlbumsDialog: __WEBPACK_IMPORTED_MODULE_10__components_chat_dialog_albums_AlbumsDialog__["a" /* default */],
    AddImageDialog: __WEBPACK_IMPORTED_MODULE_11__components_chat_dialog_albums_AddImageDialog__["a" /* default */],
    Openwebsite: __WEBPACK_IMPORTED_MODULE_12__components_chat_dialog_settings_Openwebsite__["a" /* default */],
    VueContext: __WEBPACK_IMPORTED_MODULE_27_vue_context__["VueContext"],
    ShowImageDialog: __WEBPACK_IMPORTED_MODULE_13__components_chat_dialog_ShowImageDialog__["a" /* default */],
    ShowPDFDialog: __WEBPACK_IMPORTED_MODULE_14__components_chat_dialog_ShowPDFDialog__["a" /* default */],
    CreatemailDialog: __WEBPACK_IMPORTED_MODULE_15__components_chat_dialog_mail_CreatemailDialog__["a" /* default */],
    DetailTask: __WEBPACK_IMPORTED_MODULE_18__components_chat_manage_task_detail_task_dialog__["a" /* default */],
    SaveOnebox: __WEBPACK_IMPORTED_MODULE_19__components_chat_dialog_saveonebox_SaveoneboxDialog__["a" /* default */],
    Richmenudialog: __WEBPACK_IMPORTED_MODULE_20__components_chat_dialog_richmenu_Richmenudialog__["a" /* default */],
    LinkPrevue: __WEBPACK_IMPORTED_MODULE_26_link_prevue___default.a,
    HighlightableInput: __WEBPACK_IMPORTED_MODULE_30_vue_highlightable_input__["a" /* default */],
    Mentionable: __WEBPACK_IMPORTED_MODULE_34_vue_mention__["a" /* Mentionable */],
    At: __WEBPACK_IMPORTED_MODULE_31_vue_at___default.a,
    AtTa: __WEBPACK_IMPORTED_MODULE_32_vue_at_dist_vue_at_textarea___default.a
    // shareContactDialog
  },
  props: {
    extractUrlsWithoutProtocol: {
      type: Boolean,
      default: true
    },
    caretColor: {
      type: String,
      default: '#ccc'
    },
    placeholder: {
      type: String,
      default: 'What\'s Happening?'
    },
    value: String
  },
  data: function data() {
    return {
      progressBtn: false,
      detailReadmore: {},
      dialogReadmore: false,
      AgoraCallDialog: false,
      AgoraOption: '',
      infor_call: {},
      typeroom: '',
      typemenu: 'richmenu',
      QrcodeInfor: '',
      dialogShowQRCode: false,
      ocr_detailItem: '',
      checkBrowserInfor: {},
      checkBrowserDialog: false,
      center_markermap: {},
      quickreplyStyle: 'position: absolute !important;top: calc(98vh - 160px);',
      itemdetail_quickreply: {},
      bot_id_richmenu: '',
      default_behavior: 0,
      richmenu_label: '',
      list_richmenu: [],
      tokenuser_friend: '',
      type_richmenu: 0,
      Richmenudialog: false,
      inforrichmenu: {},
      sheetrichmenu: false,
      RichmenuState: false,
      tokenmessage_savebox: '',
      extionfile: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
      taskid: '',
      files: [],
      nameFile: 'picture.png',
      dialogDetailTask: false,
      SelectedMessageDetail: {},
      rightclickdialog: false,
      showmention: false,
      picturechip: '',
      chip: false,
      Webview_item: {},
      Webview_item_ocr: {},
      selectedForward: [],
      DetailFile: {},
      DetailImage: {},
      progressLoadChatBox: false,
      showloc: '',
      ForwardState: false,
      dialogSaveOnebox: false,
      dialogshowimage: false,
      dialogshowfile: false,
      dialogForward: false,
      dialogApprove: false,
      dialogAccount: false,
      dialogMap: false,
      dialogSendMap: false,
      dialogNote: false,
      dialogWebview: false,
      dialogWebviewbig: false,
      dialogWebviewbig_ocr: false,
      dialogAlbums: false,
      dialogAddImage: false,
      dialogCreatemail: false,
      dialogopenwebsite: false,
      dialogLogin: false,
      id: '',
      type: '',
      statemember: '',
      imgShow: false,
      // messageQuickreply: true,
      Quickreply: {},
      datepicker: false,
      timepicker: false,
      dateselect: '',
      maxdate: '',
      mindate: '',
      timeselect: '',
      maxtime: '',
      mintime: '',
      typepicker: '',
      infodata: '',
      box_height: '',
      note_id: '',
      tabs: ['tab-1', 'tab-2', 'tab-3'],
      model: 'tab-2',
      filepdf: '',
      // shareContact: false,
      currentPage: 1,
      pageCount: 0,
      scrollMaxOld: 0,
      // firsttime: true,
      statePage: '',
      profile: '',
      offsetTop: 0, // test scroll
      // dialog: false,
      tokenrooomSelect: '',
      // alert: true,
      items: [],
      sendmsg: '',
      name: '',
      selectFile: null,
      statusload: false,
      place: null,
      sheet: false,
      lat: '',
      lng: '',
      address: '',
      nicknameSend: '',
      filenameSend: '',
      timeSend: '',
      picSend: '',
      dateSend: '',
      tokenmsgSend: '',
      pathSend: '',
      typeuserSend: '',
      activeEmoji: null,
      activeSticker: null,
      activetapEmo: null,
      sheetother: false,
      sheetsticker: false,
      chatlogsFlex: '',
      showmessagebottom: false,
      showmessage: '',
      sticker: [{
        'list_sticker': []
      }],
      typeuser: '',
      progressLoadChat: false,
      emojiGroups: emojiGroups,
      map: '',
      x: 15,
      y: 30,
      locationArray: [],
      locationName: '',
      sendmap: '',
      windowWidth: '',
      temp: [],
      online: true,
      ApproveDetail: {},
      albums_id: '',
      ListMenuRightClick: [],
      listannounce: [],
      show: false,
      less: false,
      announcedialog: false,
      announce_message: {},
      dragAndDropCapable: false,
      roomid: '',
      imageData: '',
      RichmenuState_first: false,
      listfriend_filter: [],
      listfriend: [],
      status_tag: false,
      msg: '',
      bot_id: '',
      highlight: [],
      highlightEnabled: true,
      mentionUsers: '',
      length_listfreind: 0,
      text_search: '',
      content: null,
      item_freind: [],
      one_id: '',
      block: '',
      checkPasswordfile: false,
      dialogGetPassword: false,
      passwordFile: '',
      tokenmsg_file_pass: '',
      name_file_pass: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_33_vuex_pathify__["c" /* sync */])('*')),
  mounted: function mounted() {
    var _this = this;

    // this.preview(value)
    // this.map = new longdo.Map({
    //   placeholder: document.getElementById('map'),
    //   lastView: true
    // })
    EventBus.$on('$EventBusEvent', this.handleEventBusEvent);

    this.dragAndDropCapable = this.determineDragAndDropCapable();

    if (this.dragAndDropCapable) {
      // console.log('this.dragAndDropCapable->' + this.dragAndDropCapable)
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
        this.$refs.fileformChat.addEventListener(evt, function (e) {
          // console.log(e)
          e.preventDefault();
          e.stopPropagation();
        });
      }.bind(this));
      // this.$refs.fileformChat.addEventListener('dragover', function (e) {
      //   // console.log('dragover')
      // }.bind(this))
      // this.$refs.fileformChat.addEventListener('dragleave', function (e) {
      //   // console.log('dragleave')
      // }.bind(this))
      this.$refs.fileformChat.addEventListener('drop', function (e) {
        this.onFileDrag(e.dataTransfer.files);
      }.bind(this));
    }
    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
    var me = this;
    $(document).click(function (event) {
      var target = $(event.target);
      if (!target.closest('#menu-chat').length && $('#menu-chat').is(":visible")) {
        me.sheetother = false;
        // $('#menu-chat').fadeOut(1600);
      } else if (!target.closest('#menu-sticker').length && $('#menu-sticker').is(":visible")) {
        me.sheetsticker = false;
        // $('#menu-sticker').fadeOut(1600);
      }
    });
  },

  watch: {
    block_friend: function block_friend(data) {
      // console.log(data)
      if (data.event === 'unblock_friend') {
        this.statemember = 'active';
      } else {
        this.statemember = 'block';
      }
    },

    // items () {
    //   console.log(this.items)
    // },
    // sendmsg () {

    // },
    showmention: function showmention() {
      if (this.showmention == true) {
        this.status_tag = false;
        // console.log('eeeee')
      }
    },
    files: function files() {
      if (this.files.length != 0) {
        // this.chatlogsFlex = 'height:calc(98vh - 310px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 275px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 245px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 275px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 245px);';
        }
      } else {
        // this.chatlogsFlex = 'height:calc(98vh - 185px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
        }
      }
    },
    socket_close_webview: function socket_close_webview(data) {
      // console.log('socket_close_webview')
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        this.Webview_item = {};
        this.dialogWebviewbig = false;
      }
      // this.Webview_item = {}
      // this.dialogWebviewbig = false
    },
    socket_drop_menu: function socket_drop_menu(data) {
      // console.log('drop_menu')
      // console.log(this.sheetrichmenu)
      if (data.tokenroom === this.$route.params.roomid) {
        this.sheetrichmenu = false;
      }
    },
    socket_switch_keyboard: function socket_switch_keyboard(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.RichmenuState = false;
        this.sheetrichmenu = false;
      }
    },
    socket_switch_richmenu: function socket_switch_richmenu(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.RichmenuState = true;
        this.sheetrichmenu = true;
      }
    },
    socketexpire_login: function socketexpire_login(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.dialogLogin = true;
      }
    },
    socket_official_template: function socket_official_template(data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        // console.log(data)
        var index_target = data.target_index;
        var index = _.findIndex(this.items, function (o) {
          return o.tokenmessage == data.tokenmessage;
        });
        this.items[index].element.choice[index_target].disable = '1';
        // console.log(index_target)
      }
    },
    chat_wallpaper: function chat_wallpaper() {
      // console.log(this.chat_wallpaper.info)
      var room = this.$route.params.roomid;
      var index = _.findIndex(this.chat_wallpaper.info, function (o) {
        return o.room === room;
      });
      // console.log(index)
      if (index === -1) {
        this.imageData = '';
      } else {
        this.imageData = this.chat_wallpaper.info[index].background;
      }
      this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');';
      this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
      // console.log(this.imageData)
    },
    less: function less() {
      if (this.less) {
        this.$cookie.set(this.$route.params.roomid, 'less');
      } else {
        this.$cookie.delete(this.$route.params.roomid);
      }
    },
    socket_announce: function socket_announce(data) {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_announce_room_by_id', {
        tokenuser: this.token,
        token_announce: data.token_announce,
        tokenroom: this.tokenrooomSelect
      }).then(function (response) {
        _this2.listannounce.unshift(response.data.data);
      });
    },
    box_height: function box_height() {
      if (this.imageData === '') {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;';
        this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
      } else {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');';
        this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
      }
    },
    selectedForward: function selectedForward() {
      if (this.selectedForward.length > 5) {
        this.$swal('', this.$t('Alert.Fail.Chat.maxMessage'), 'error');
        _.pullAt(this.selectedForward, [5]);
      }
    },
    windowWidth: function windowWidth() {
      if (this.windowWidth <= 960) {
        // this.$router.push('/mobile/room/' + this.$route.params.roomid)
        this.$router.push('/mobile/progress/' + this.$route.params.roomid);
      }
    },
    dialogMap: function dialogMap() {
      if (this.dialogMap) {
        // this.initmapShow()
      }
    },
    sheetrichmenu: function sheetrichmenu() {
      // console.log(this.RichmenuState)
      // console.log(this.sheetrichmenu)
      // console.log(this.type_richmenu <= 7)
      if (this.type_richmenu <= 7) {
        if (this.sheetrichmenu) {
          setTimeout(this.scrollDown, 1);
          if (this.imageData === '') {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 370px) !important; background-color: #fdfdfd;';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 351px);';
          } else {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 370px) !important; background-image: url(' + this.imageData + ');';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 351px);';
          }
        } else {
          if (this.imageData === '') {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-color: #fdfdfd;';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);';
          } else {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-image: url(' + this.imageData + ');';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);';
          }
        }
      } else {
        if (this.sheetrichmenu) {
          setTimeout(this.scrollDown, 1);
          if (this.imageData === '') {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 245px) !important; background-color: #fdfdfd;';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 215px);';
          } else {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 245px) !important; background-image: url(' + this.imageData + ');';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 215px);';
          }
        } else {
          if (this.imageData === '') {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-color: #fdfdfd;';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);';
          } else {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-image: url(' + this.imageData + ');';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);';
          }
        }
      }
    },
    RichmenuState: function RichmenuState() {
      // console.log(this.RichmenuState)
      // console.log(this.sheetrichmenu)
      // console.log(this.type_richmenu <= 7)
      setTimeout(this.scrollDown, 1);
      if (!this.RichmenuState && !this.sheetrichmenu) {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 195px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 165px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 195px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 165px);';
        }
      } else if (this.RichmenuState && !this.sheetrichmenu) {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);';
        }
      }
    },
    sheetsticker: function sheetsticker() {
      if (this.sheetsticker) {
        // this.chatlogsFlex = 'height:calc(98vh - 310px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 310px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 280px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 310px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 280px);';
        }
      } else {
        // this.chatlogsFlex = 'height:calc(98vh - 185px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
        }
      }
    },
    sheetother: function sheetother() {
      if (this.sheetother) {
        // this.chatlogsFlex = 'height:calc(98vh - 260px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 260px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 230px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 260px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 230px);';
        }
      } else {
        // this.chatlogsFlex = 'height: calc(98vh - 185px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
        }
      }
    },
    myprofile: function myprofile() {
      this.profile = localStorage.getItem('profilepicture');
    },
    layout: function layout() {
      this.tokenrooomSelect = this.$route.params.roomid;
    },
    '$route.params.roomid': function $routeParamsRoomid() {
      this.less = false;
      this.scrollMaxOldSet();
      this.statusload = false;
      this.ForwardState = false;
      this.selectedForward = [];
      var container = this.$el.querySelector('#myscroll');
      container.scrollTop = container.scrollHeight;
      this.tokenrooomSelect = this.$route.params.roomid;
      this.items = [];
      this.Quickreply = [];
      this.RichmenuState = false;
      this.sheetrichmenu = false;
      this.inforrichmenu = {};
      this.type_richmenu = 0;
      this.sendmsg = '';
      this.status_tag = false;
      this.getlistfriend();
      this.getroom();
      // this.get_list_richmenu(this.$route.params.roomid)
      this.getOldMessage('');
      this.getreply();
      this.getlistannounce();
      var announce = this.$cookie.get(this.$route.params.roomid);
      // console.log(announce)
      if (announce !== null) {
        this.less = true;
      }
      this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
      // console.log(this.chat_wallpaper)
      var room = this.tokenrooomSelect;
      var index = _.findIndex(this.chat_wallpaper.info, function (o) {
        return o.room === room;
      });
      // console.log(index)
      if (index === -1) {
        this.imageData = '';
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;';
        this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
      } else {
        this.imageData = this.chat_wallpaper.info[index].background;
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');';
        this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
      }
    },
    typeAgoraCall: function typeAgoraCall() {
      // call agora
      var me = this;
      setTimeout(function () {
        var infor = {
          agora_token: me.typeAgoraCall.agora_token,
          channel: me.typeAgoraCall.channel,
          nickname: me.typeAgoraCall.nickname,
          option: me.typeAgoraCall.option,
          picture: me.typeAgoraCall.picture,
          tokenroom: me.typeAgoraCall.tokenroom,
          one_id: me.one_id
          // me.infor_call.one_id = me.one_id
        };me.infor_call = infor;
        me.AgoraOption = me.typeAgoraCall.option;
        me.AgoraCallDialog = true;
        // console.log(me.AgoraCallDialog)
        // console.log(me.infor_call)
      }, 1000);
    },
    socketmessage: function socketmessage() {
      // console.log(this.socketmessage)
      // if (this.socketmessage.typeofmessage === 'agora_call' && this.socketmessage.tokenuser !== this.token) {
      //   console.log(`open dialog call`)
      //   this.infor_call = this.socketmessage
      //   var me = this
      //   setTimeout(function() {
      //     me.AgoraOption = me.typeAgoraCall
      //     me.AgoraCallDialog = true
      //     console.log(me.AgoraCallDialog)
      //   }, 1000);
      // }
      // this.Quickreply = []
      this.getMessageSocket(this.socketmessage);
    },

    // socketnote () {
    //   this.getMessageSocket(this.socketnote)
    // },
    // socketinvite_group () {
    //   this.getMessageSocket(this.socketinvite_group)
    // },
    socket_accept_call: function socket_accept_call(data) {
      // console.log(`acctpt call`)
      // console.log(data)
      // if (data.status === 'success') {
      //   this.infor_call = {}
      //   this.AgoraCallDialog = false
      // }
      // this.infor_call = {}
      this.AgoraCallDialog = false;
    },
    socket_update_agora: function socket_update_agora(data) {
      // console.log(`update agora`)
      // console.log(data)
      if (data.status === 'end' || data.status === 'cancel') {
        this.infor_call = {};
        this.AgoraCallDialog = false;
        var index = _.findIndex(this.items, function (o) {
          return o.tokenmessage === data.tokenmessage;
        });
        if (index !== -1) {
          this.items[index].time = data.time;
          this.items[index].message = data.status;
        }
        // console.log(this.items[index])
      }
    },
    socketremove_friend: function socketremove_friend(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.statemember = 'unfriend';
      }
    },
    socket_kickmember: function socket_kickmember(data) {
      var self = this;
      data.listkick.forEach(function (item) {
        if (self.token === item) {
          self.statemember = 'leave';
        }
      });
    },
    socketactive_group: function socketactive_group(data) {
      if (this.token === data.tokenuser) {
        this.statemember = 'active';
      }
    },
    socketquickreply: function socketquickreply(data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        // this.getreply()
        this.datepicker = false;
        this.timepicker = false;
        this.maxdate = '';
        this.mindate = '';
        this.maxtime = '';
        this.mintime = '';
        this.dateselect = '';
        this.timeselect = '';
        this.infodata = '';
        this.Quickreply = data;
        // console.log(this.Quickreply)
      }
    },
    socketdisablequickreply: function socketdisablequickreply(data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        // this.Quickreply = ''
        // this.getreply()
        this.datepicker = false;
        this.timepicker = false;
        this.maxdate = '';
        this.mindate = '';
        this.maxtime = '';
        this.mintime = '';
        this.dateselect = '';
        this.timeselect = '';
        this.infodata = '';
        this.Quickreply = '';
      }
    },
    socket_unsendmessage: function socket_unsendmessage(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        var indexid = _.findIndex(this.items, function (o) {
          return o.tokenmessage === data.tokenmessage;
        });
        var mentiontokenmessage = this.items[indexid].tokenmessage;
        var indexmentionmsg = _.findIndex(this.items, function (o) {
          return o.file_name === mentiontokenmessage;
        });
        if (indexmentionmsg === -1) {
          this.items[indexid].typeofmessage = 'unsend_message';
        } else {
          this.items[indexid].typeofmessage = 'unsend_message';
          this.items[indexmentionmsg].source_message.typeofmessage = 'unsend_message';
        }
      } else {}
    },
    socketdisableapprove: function socketdisableapprove(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        var indexid = _.findIndex(this.items, function (o) {
          return o.tokenmessage === data.tokenmessage && o.typeofmessage === 'approve_message';
        });
        this.items[indexid].disable = 'true';
      }
    }
  },
  created: function created() {
    var _this3 = this;

    // (async () => {
    //   let it = await grabity.grabIt("https://github.com/e-oj/grabity");

    //   console.log(it);
    // })();
    this.box_height = screen.height - 64.0 - 120.0;
    // this.token = Decode.decodeToken(this.$cookie.get('tokenuser'))
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.tokenrooomSelect = this.$route.params.roomid;
    this.profile = localStorage.getItem('profilepicture');
    this.typeuser = localStorage.getItem('type_user');
    this.name = localStorage.getItem('name');
    this.getlistfriend();
    this.getroom();
    // this.get_list_richmenu(this.$route.params.roomid)
    this.getOldMessage('');
    this.getreply();
    this.getlistannounce();
    this.axios.post("https://uatchat-manage.one.th/message" + '/sticker/gettitleallsticker', {
      tokenuser: this.token
    }).then(function (responsed) {
      _this3.sticker = responsed.data['data'];
    });
    var announce = this.$cookie.get(this.$route.params.roomid);
    if (announce !== null) {
      this.less = true;
    }
    this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
    // console.log(this.chat_wallpaper)
    var room = this.tokenrooomSelect;
    var index = _.findIndex(this.chat_wallpaper.info, function (o) {
      return o.room === room;
    });
    // console.log(index)
    if (index === -1) {
      this.imageData = '';
    } else {
      this.imageData = this.chat_wallpaper.info[index].background;
    }
  },

  methods: {
    passwordPdf: function passwordPdf(evt, index, item) {
      console.log(evt);
      // updatePassword(prompt('password is "test"'));
      // console.log(index)
      // console.log(item)
      // this.checkPasswordPdf(index)
      // return reason
      this.items[index].typeofmessage = 'pdf_password';
    },
    errorPdf: function errorPdf(err) {
      console.log(err);
    },
    closeDialogpassword: function closeDialogpassword(value) {
      this.dialogGetPassword = value;
    },
    getMeta: function getMeta(metaName) {
      var metas = document.getElementsByTagName('meta');
      for (var i = 0; i < metas.length; i++) {
        // console.log(metas[i].getAttribute('content'))
        // if (metas[i].getAttribute('name') === metaName) {
        //   return metas[i].getAttribute('content');
        // }
      }

      return '';
    },
    preview: function preview(value) {
      // console.log('wwww')
      // getLinkPreview(value).then((data) =>
      // console.debug(data)
      // );
    },
    handleClick: function handleClick(preview) {

      // console.log('click', preview.domain, preview.title, preview.description, preview.img)
    },
    CheckUrlRoom: function CheckUrlRoom() {
      if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null && JSON.parse(localStorage.getItem('botid_redirect_url')) !== undefined) {
        var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
        // console.log(data.url)
        var item = {};
        if (data.auth === 'share_token') {
          item = {
            label: '',
            url: data.url,
            size: 'full',
            type: 'webview',
            sign: 'true',
            onechat_token: 'false'
          };
          if (data.url !== undefined && data.url !== 'undefined') {
            this.check_get_accesstoken(item);
          }
        } else {
          item = {
            label: '',
            url: data.url,
            size: 'full',
            type: 'webview',
            sign: 'false',
            onechat_token: 'true'
          };
          if (data.url !== undefined && data.url !== 'undefined') {
            this.check_get_accesstoken(item);
          }
        }
      }
      // หลังเปิด webview ลบค่าตัวแปลที่ใช้เช็ค
      localStorage.removeItem('botid_redirect_url');
    },
    clickReadmore: function clickReadmore(item) {
      this.detailReadmore = item;
      this.dialogReadmore = true;
    },
    closeReadmoreDialog: function closeReadmoreDialog(value) {
      this.dialogReadmore = value;
    },
    closeAgoraDialog: function closeAgoraDialog(value) {
      this.AgoraCallDialog = value;
    },
    decline_call: function decline_call(item) {
      // console.log(item)
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/update-agora', {
        tokenuser: this.token,
        tokenroom: item.tokenroom,
        tokenmessage: item.tokenmessage,
        time: '',
        message: 'cancel'
      }).then(function (response) {
        // console.log(response)
        // if (response.data.status === 'success') {
        //   this.one_id = response.data.one_id
        // }
      });
    },
    get_oneid: function get_oneid() {
      var _this4 = this;

      this.axios.get("https://uatchat-manage.one.th/go_api/api" + ('/v1/getOneID/' + this.token)).then(function (response) {
        if (response.data.status === 'success') {
          _this4.one_id = response.data.one_id;
        }
      });
    },
    ans_ekyc: function ans_ekyc(item, quickreply) {
      var _this5 = this;

      this.ans_quickreply(item, 'ekyc');
      this.axios.post("https://uatchat-manage.one.th/message" + '/api/v1/get_shared_token', { user_id: this.one_id }).then(function (response) {
        if (response.data.status === 'success') {
          var url = '' + "https://uat-ekyc.id.th/redirect-share-token?shared_token=" + response.data.data.shared_token + '&bot_id=' + quickreply.tokenuser;
          _this5.Webview_item = {
            label: item.label,
            url: url,
            size: 'full',
            type: 'ekyc',
            payload: ''
            // this.dialogWebviewbig = true
            // console.log(url)
          };_this5.checkBrowser(url, _this5.Webview_item);
        }
      }).catch(function (error) {
        console.log(error);
        _this5.$swal('', _this5.$t('Alert.Fail.default.somethingWrong'), 'error');
      });
    },
    ans_ekyc_template: function ans_ekyc_template(item, tokenbot) {
      var _this6 = this;

      // console.log(item)
      this.axios.post("https://uatchat-manage.one.th/message" + '/api/v1/get_shared_token', { user_id: this.one_id }).then(function (response) {
        if (response.data.status === 'success') {
          var url = '' + "https://uat-ekyc.id.th/redirect-share-token?shared_token=" + response.data.data.shared_token + '&bot_id=' + tokenbot;
          _this6.Webview_item = {
            label: item.label,
            url: url,
            size: 'full',
            type: 'ekyc',
            payload: ''
            // this.dialogWebviewbig = true
          };_this6.checkBrowser(url, _this6.Webview_item);
          // console.log(url)
        }
      }).catch(function (error) {
        console.log(error);
        _this6.$swal('', _this6.$t('Alert.Fail.default.somethingWrong'), 'error');
      });
    },
    handleEventBusEvent: function handleEventBusEvent(payload) {
      // console.log(payload)
      // alert(payload);
    },

    // handleClick(e) {
    //   console.log(e.target.innerHTML)
    // },
    handleClickTest: function handleClickTest(e) {
      var _this7 = this;

      var username = e.target.innerHTML.substring(1);
      var myUser = localStorage.name;
      // console.log(myUser)
      if (username != myUser) {
        // const item = this.listfriend.filter(friend =>
        //   (friend.name.toLowerCase().replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`))
        //       .includes(username.toLowerCase().replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`))
        // )
        // console.log(item)

        this.listfriend.forEach(function (freind) {
          // var item = []
          var rex = /(?:[\xA9\xAE\u2122\u23E9-\u23EF\u23F3\u23F8-\u23FA\u24C2\u25B6\u2600-\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDE51\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDE80-\uDEFF]|\uD83E[\uDD00-\uDDFF])/g;
          var x = username.replace(rex, function (match) {
            return '[e-' + match.codePointAt(0).toString(16) + ']';
          });
          var y = freind.name.replace(rex, function (match) {
            return '[e-' + match.codePointAt(0).toString(16) + ']';
          });
          // console.log(x)
          // console.log(y)
          // console.log(x.includes(y))
          if (x.includes(y)) {
            // console.log(freind)
            var tokenUser = freind.tokenuser;
            _this7.detailFriend(tokenUser);
          }
        });
      } else {
        var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
        this.detailFriend(decoded.tokenuser);
      }
    },
    getlistfriend: function getlistfriend() {
      var _this8 = this;

      var tokenUser = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services__["a" /* Decode */].decode(localStorage.Authenrization)).tokenuser;
      var me = localStorage.name;
      var body = {
        tokenuser: tokenUser,
        tokenroom: this.$route.params.roomid
      };
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', body).then(function (response) {
        if (response.status === 200) {
          var listfriend = response.data.data_room;
          // console.log('length listfreind' , listfriend.length)
          _this8.listfriend = listfriend.filter(function (friend) {
            return friend.type == 'user' && friend.tokenuser !== tokenUser && friend.statemember === 'active';
          });
          // console.log(this.listfriend)
          // this.length_listfreind = this.listfriend
          // if(listfriend.length == 1){
          //   this.status_tag = false
          // }
        }
      });
    },
    getroom: function getroom() {
      var _this9 = this;

      var body = {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      };
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', body).then(function (response) {
        if (response.status === 200) {
          _this9.block = response.data.statemember;
          // console.log(response.data.data_room)
          _this9.typeroom = response.data.type;
          var me = _this9;
          _this9.listfriend = _.filter(response.data.data_room, function (o) {
            return o.tokenuser !== me.token && o.type === 'user' && o.statemember === 'active';
          });
          if (response.data.data_room.length == 1 && response.data.data_room[0].type == 'bot') {
            var bot_id = response.data.data_room[0].tokenuser;
            // console.log(this.bot_id)
            // state member ต้องเป็น friend และ active ถึงเก็ท richmenu
            if (response.data.statemember === 'friend' || response.data.statemember == 'active') {
              _this9.get_list_richmenu(bot_id);
            } else {
              _this9.list_richmenu = [];
            }
          } else {
            _this9.list_richmenu = [];
          }
        }
      });
      this.get_oneid();
    },
    play: function play(e) {
      console.log(e);
    },
    closeShowQRCodeUser: function closeShowQRCodeUser(value) {
      this.dialogShowQRCode = value;
      // this.checktype = ''
      // this.tokenrooomSelect = ''
    },
    closeCheckBrowser: function closeCheckBrowser(value) {
      this.checkBrowserDialog = value;
      this.checkBrowserInfor = {};
    },
    btn_answer_carousel: function btn_answer_carousel(item) {
      // console.log(item)
      // if (item.type === 'text' || item.type === 'postback') {
      //   this.ans_carousel(item)
      // } else if (item.type === 'webview' || item.type === 'link') {
      //   var infor = {
      //     sign: item.sign,
      //     url: item.action,
      //     type: item.type,
      //     label: item.button,
      //     onechat_token: item.onechat_token,
      //     size: 'full'
      //   }
      //   this.check_get_accesstoken(infor)
      // } else {
      //   console.log(item.type)
      // }
      if (item.type === 'webview' || item.type === 'link') {
        var infor = {
          sign: item.sign,
          url: item.action,
          type: item.type,
          label: item.button,
          onechat_token: item.onechat_token,
          payload: item.payload,
          size: 'full'
        };
        this.check_get_accesstoken(infor);
      } else if (item.type === 'link_market') {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
      } else {
        this.ans_carousel(item);
      }
    },
    saveLogNews: function saveLogNews(item) {
      var _this10 = this;

      // console.log(item)
      this.axios.get("https://uatchat-manage.one.th/go_api/api" + '/v1/getOneID/' + this.token).then(function (response) {
        var one_id = response.data.one_id;
        // console.log(one_id)
        _this10.axios.post("https://news.chat.one.th/backend/api/v1/page-analytics", {
          'one_id': one_id,
          'news_id': item.payload.news_id,
          'news_index': item.payload.news_index.toString(),
          'page_name': item.payload.page_name
        }).then(function (response) {
          // console.log(response)
        }).catch(function (error) {
          console.log(error);
        });
      }, function (error) {
        console.log(error);
      });
    },
    ans_carousel: function ans_carousel(item) {
      var payload = {};
      if (item.payload !== undefined) {
        payload = item.payload;
      }
      var body = {
        tokenuser: this.token,
        tokenroom: this.tokenrooomSelect,
        action: item.action,
        type: item.type,
        payload: payload
        // console.log(body)
      };this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/ansCarousel', body).then(function (response) {
        // console.log(response.data)
      }).catch(function (error) {
        console.log(error);
      });
    },
    emitrichmenu: function emitrichmenu(item) {
      var _this11 = this;

      // console.log(item)
      var expireddate = Date.parse(item.expired_date);
      var body = __WEBPACK_IMPORTED_MODULE_3__services__["b" /* Encode */].encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate });
      var url = '';
      if (_.includes(item.infor.url, ['?'])) {
        url = '&';
      } else {
        url = '?';
      }
      var weburl = item.infor.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate;
      if (item.infor.type === 'text') {
        this.sendMessage(item.infor.message);
      } else if (item.infor.type === 'link') {
        if (item.infor.sign_share === 'true') {
          // window.open(weburl, '_blank')
          this.getSign(item.infor.url, item.infor, this.bot_id_richmenu);
        } else if (item.infor.sign === 'true') {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item);
        } else {
          // window.open(item.infor.url, '_blank')
          this.checkBrowser(item.infor.url, item);
        }
      } else if (item.infor.type === 'webview') {
        if (item.infor.sign_share === 'true') {
          // var infor_webview = {
          //   message: item.infor.message,
          //   picture: item.infor.picture,
          //   sign: item.infor.sign,
          //   size: item.infor.size,
          //   type: item.infor.type,
          //   url: weburl
          // }
          // this.Webview_item = infor_webview
          // this.dialogWebviewbig = true
          this.getSign(item.infor.url, item.infor, this.bot_id_richmenu);
        } else if (item.infor.sign === 'true') {
          var infor_webview = {
            message: item.infor.message,
            picture: item.infor.picture,
            sign: item.infor.sign,
            size: item.infor.size,
            type: item.infor.type,
            url: weburl
          };
          this.Webview_item = infor_webview;
          this.dialogWebviewbig = true;
          // console.log(this.Webview_item)
        } else {
          this.Webview_item = item.infor;
          this.dialogWebviewbig = true;
        }
      } else if (item.infor.type === 'link_market') {
        // console.log(item)
        // this.linkmarket = item.infor.url
        // this.$router.push('/chat/service/market?goto=link_market')
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
      } else if (item.infor.type === 'location') {
        // console.log('rich menu type location')
        this.sendlocation_quickreply();
      } else if (item.infor.type === 'qrcode' && item.infor.location_status === 'false') {
        // console.log('rich menu type qrcode')
        this.dialogShowQRCode = true;
        this.QrcodeInfor = { status: item.infor.location_status, lat: '', lng: '', address: '' };
      } else if (item.infor.type === 'qrcode' && item.infor.location_status === 'true') {
        // console.log('rich menu qrcode location')
        this.dialogShowQRCode = true;
        if (window.navigator.geolocation) {
          window.navigator.geolocation.getCurrentPosition(function (position) {
            _this11.QrcodeInfor = { status: item.infor.location_status, lat: position.coords.latitude, lng: position.coords.longitude, address: '' };
          });
        } else {
          console.log('error geo');
          this.QrcodeInfor = { status: item.infor.location_status, lat: '', lng: '', address: '' };
        }
      } else {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
      }
    },
    chsheetrichmenu: function chsheetrichmenu() {
      this.RichmenuState = true;
      this.Richmenudialog = true;
      this.sheetrichmenu = this.RichmenuState_first;
      // console.log(this.Richmenudialog)
      // console.log('click sheetrichmenu')
    },
    removeFile: function removeFile(key) {
      this.files.splice(key, 1);
    },
    onPaste: function onPaste(evt) {
      var items = (evt.clipboardData || evt.originalEvent.clipboardData).items;
      var index = 0;
      var me = this;
      this.nameFile = 'picture.png';
      for (index in items) {
        var item = items[index];
        if (item.kind === 'string') {
          this.nameFile = evt.clipboardData.getData('text/plain');
        } else if (item.kind === 'file') {
          var blob = item.getAsFile();
          var reader = new FileReader();
          reader.onload = function (evt) {
            me.sendmsg = me.sendmsg.replace(me.nameFile, '');
            me.files.push({
              file: blob,
              filebase64: evt.target.result,
              status: 'waiting',
              name: me.nameFile
            });
          };
          reader.readAsDataURL(blob);
        }
      }
    },
    determineDragAndDropCapable: function determineDragAndDropCapable() {
      // console.log('determineDragAndDropCapable')
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
    },
    open_detail_task: function open_detail_task(taskid, tokenroom) {
      this.taskid = taskid;
      this.roomid = tokenroom;
      this.dialogDetailTask = true;
    },
    checkuserinassign: function checkuserinassign(item) {
      var tokenuser = this.token;
      var index = _.findIndex(item, function (o) {
        return o.tokenuser === tokenuser;
      });
      if (index >= 0) {
        return true;
      } else {
        return false;
      }
    },
    checkbutton: function checkbutton(color, bng) {
      var text = {
        'text-transform': 'none',
        'width': '100%',
        'margin': '0',
        'font-size': '13px',
        'border-radius': '20px'
        // [choice.color]? ('color': choice.color):('color':'black')
      };if (color) {
        text['color'] = color;
      } else {
        text['color'] = 'black';
      }
      if (bng) {
        text['background'] = bng;
      } else {
        text['background'] = 'none';
      }
      return text;
    },
    cancel_announce: function cancel_announce() {
      var _this12 = this;

      this.rightclickdialog = false;
      var token_announce = this.SelectedMessageDetail._id;
      this.$swal({
        text: this.$t('Alert.Chat.announce.cancel'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this12.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/disable_single_announce_room', {
            tokenuser: _this12.token,
            tokenroom: _this12.tokenrooomSelect,
            token_announce: token_announce }).then(function (responsed) {
            if (responsed.data.status == 'success') {
              var index = _.findIndex(_this12.listannounce, function (o) {
                return o._id === token_announce;
              });
              if (index >= 0) {
                _this12.listannounce.splice(index, 1);
              }
            } else {
              _this12.listannounce = [];
            }
          });
        }
      });
    },
    delete_announce: function delete_announce() {
      var _this13 = this;

      this.$swal({
        text: this.$t('Alert.Chat.announce.deleteAll'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this13.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/disable_announce_room', { tokenuser: _this13.token, tokenroom: _this13.tokenrooomSelect }).then(function (responsed) {
            if (responsed.data.status == 'success') {
              _this13.listannounce = [];
            } else {}
          });
        }
      });
    },
    announce_msg: function announce_msg() {
      var _this14 = this;

      this.rightclickdialog = false;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/announce_room', {
        tokenuser: this.token,
        tokenmessage: this.SelectedMessageDetail.tokenmessage,
        tokenroom: this.SelectedMessageDetail.tokenroom
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this14.$swal('', _this14.$t('Alert.Success.announce'), 'success');
        }
        _this14.show = false;
      });
    },
    getlistannounce: function getlistannounce() {
      var _this15 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_announce_room', { tokenuser: this.token, tokenroom: this.tokenrooomSelect }).then(function (responsed) {
        if (responsed.data.status == 'success') {
          _this15.listannounce = responsed.data.data;
          _this15.listannounce = _.reverse(_this15.listannounce);
        } else {
          _this15.listannounce = [];
        }
      }, function () {});
    },
    closeDialog: function closeDialog() {
      this.dialogopenwebsite = false;
    },
    add_image_albums: function add_image_albums() {
      this.dialogAddImage = true;
      this.rightclickdialog = false;
    },
    secondsToHms: function secondsToHms(d) {
      d = Number(d);
      var hours = Math.floor(d / 3600);
      var minutes = Math.floor((d - hours * 3600) / 60);
      var seconds = d - hours * 3600 - minutes * 60;
      var time = '';

      if (hours !== 0) {
        time = hours + ':';
      }
      if (minutes !== 0 || time !== '') {
        minutes = minutes < 10 && time !== '' ? '0' + minutes : String(minutes);
        time += minutes + ':';
      }
      if (time === '') {
        time = seconds + 's';
      } else {
        time += seconds < 10 ? '0' + seconds : String(seconds);
      }
      return time;
    },
    checktypeCall: function checktypeCall(call) {
      if (call === 'cancel') {
        return this.$t('AnswerQuestion.cancel');
      } else if (call === 'decline') {
        return this.$t('LeftSide.chat.call.missed');
      } else if (call === 'end') {
        return this.$t('LeftSide.chat.call.end');
      } else {
        return '';
      }
    },
    RightClickDialog: function RightClickDialog($event, list, item) {
      this.ListMenuRightClick = [];
      if (this.statemember === 'active') {
        if (list.includes("albums")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.addImageAlbum'), methods: 'add_albums' });
        }
        if (list.includes("mention")) {
          if (item.type !== 'bot') {
            this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.mention'), methods: 'mention' });
          }
        }
        if (list.includes("sendmail")) {
          if (item.typeofmessage != 'password_file') {
            this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.sendmail'), methods: 'sendmail' });
          }
        }
        if (list.includes("cancel")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.cancelMsg'), methods: 'cancel' });
        }
        if (list.includes("announce")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.announce'), methods: 'announce' });
        }
        if (list.includes("cancel_announce")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.cancelAnnounce'), methods: 'cancel_announce' });
        }
        if (this.ListMenuRightClick.length !== 0) {
          this.rightclickdialog = true;
          this.$refs.menu.open($event);
        } else {
          this.rightclickdialog = false;
        }
        // this.$refs.menu.open($event)
        this.SelectedMessageDetail = item;
      }
    },
    SelectMenuRightClick: function SelectMenuRightClick(selected) {
      if (selected == 'add_albums') {
        this.add_image_albums();
      } else if (selected == 'mention') {
        this.mention_message();
      } else if (selected == 'cancel') {
        this.unsendmessage();
      } else if (selected == 'sendmail') {
        this.sendemail();
      } else if (selected == 'announce') {
        this.announce_msg();
      } else if (selected == 'cancel_announce') {
        this.cancel_announce();
      }
    },
    sendemail: function sendemail() {
      this.dialogCreatemail = true;
    },
    closeCreatemail: function closeCreatemail(value) {
      this.dialogCreatemail = value;
    },
    mention_message: function mention_message() {
      if (this.statemember === 'active') {
        this.rightclickdialog = false;
        this.showmention = true;
        if (this.SelectedMessageDetail.path_pic === '') {
          if (this.SelectedMessageDetail.type === 'business') {
            this.SelectedMessageDetail.path_pic = '/static/img/default_profile/business-white.png';
          } else if (this.SelectedMessageDetail.type === 'bot') {
            this.SelectedMessageDetail.path_pic = '/static/img/default_profile/bot-white.png';
          } else {
            this.SelectedMessageDetail.path_pic = '/static/img/default_profile/man-white.png';
          }
        }
      }
    },
    unsendmessage: function unsendmessage() {
      var _this16 = this;

      this.rightclickdialog = false;
      this.$swal({
        text: this.$t('Alert.Chat.unsent'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this16.axios.post("https://uatchat-manage.one.th/message" + '/delete_message', {
            tokenuser: _this16.token,
            tokenmessage: _this16.SelectedMessageDetail.tokenmessage
          }).then(function (response) {
            if (response.data['status'] === 'success') {
              _this16.$swal('', _this16.$t('Alert.Success.unsent'), 'success');
            }
          });
        }
      });
    },
    backCall_conference_msg: function backCall_conference_msg(detail) {
      window.open(detail.urlroom);
    },
    joinCall_conference_msg: function joinCall_conference_msg(detail) {
      // console.log(detail)
      this.axios.post("https://uatchat-manage.one.th/message" + '/join_room_conference', {
        meetingid: detail.meetingid,
        name: localStorage.getItem('name'),
        option: detail.option,
        key: detail.key
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          window.open(response.data.data.urlroom);
        }
      });
    },
    openapprove: function openapprove(item) {
      this.ApproveDetail = item;
      this.dialogApprove = true;
    },
    checkBrowser: function checkBrowser(url, item) {
      // console.log(item)
      if (_.includes(url, "https://uatchat.one.th" + '/qrcode/friend?id=')) {
        var link = _.split(url, '?id=', 2);
        // console.log(link[1])
        // console.log(atob(link[1]))
        this.detailFriend(atob(link[1]));
      } else {
        // Get the user-agent string
        var userAgentString = navigator.userAgent;
        // Detect Chrome
        var chromeAgent = userAgentString.indexOf("Chrome") > -1;
        // Detect Internet Explorer
        var IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
        // Detect Firefox
        var firefoxAgent = userAgentString.indexOf("Firefox") > -1;
        // Detect Safari
        var safariAgent = userAgentString.indexOf("Safari") > -1;
        // Discard Safari since it also matches Chrome
        var operaAgent = userAgentString.indexOf("OP") > -1;
        // console.log('firefox = > ' + firefoxAgent)
        // console.log('ie = > ' + IExplorerAgent)
        // console.log('chrome = > ' + chromeAgent)
        // console.log('opera = > ' + operaAgent)
        // console.log('safari = > ' + safariAgent)
        if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
          if (item.payload !== undefined && item.payload !== null) {
            if (item.payload.news_id !== undefined) {
              this.checkBrowserInfor = {
                url: url,
                payload: item.payload
              };
            } else {
              this.checkBrowserInfor = {
                url: url
              };
            }
          } else {
            this.checkBrowserInfor = {
              url: url,
              payload: ''
            };
          }
          this.checkBrowserDialog = true;
        } else if (safariAgent === true && chromeAgent === true) {
          //  console.log('savelog')
          window.open(url, '_blank');
          if (item.payload !== undefined && item.payload !== null) {
            if (item.payload.news_id !== undefined) {
              this.saveLogNews(item);
            }
          }
        } else if (safariAgent === true) {
          // this.checkBrowserInfor =
          if (item.payload !== undefined && item.payload !== null) {
            if (item.payload.news_id !== undefined) {
              this.checkBrowserInfor = {
                url: url,
                payload: item.payload
              };
            } else {
              this.checkBrowserInfor = {
                url: url
              };
            }
          } else {
            this.checkBrowserInfor = {
              url: url,
              payload: ''
            };
          }
          this.checkBrowserDialog = true;
        } else {
          // console.log('savelog')
          window.open(url, '_blank');
          if (item.payload !== undefined && item.payload !== null) {
            if (item.payload.news_id !== undefined) {
              this.saveLogNews(item);
            }
          }
        }
      }
    },
    check_get_accesstoken: function check_get_accesstoken(item) {
      var _this17 = this;

      // console.log(item)
      if (item.sign === 'true') {
        var body = {
          "tokenuser": this.token,
          "url": item.url
        };
        this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", body).then(function (response) {
          // console.log(response.data)
          if (response.data.data) {
            var new_url = response.data.data.url;
            if (item.type === 'link') {
              // item.url = response.data.data.url
              // window.open(new_url, '_blank')
              _this17.checkBrowser(new_url, item);
            } else if (item.type === 'webview') {
              _this17.Webview_item = {
                label: item.label,
                url: new_url,
                size: item.size,
                type: item.type
              };
              _this17.dialogWebviewbig = true;
              if (item.payload.news_id !== undefined) {
                _this17.saveLogNews(item);
              }
            }
          } else {
            _this17.dialogLogin = true;
          }
        }, function (error) {
          console.log(error);
        });
      } else if (item.onechat_token === 'true') {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var hour = String(today.getHours() + 1).padStart(2, '0');
        var minute = String(today.getMinutes()).padStart(2, '0');
        var seconds = String(today.getSeconds()).padStart(2, '0');
        var milsec = today.getMilliseconds();
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00';
          dd = String(today.getDate() + 1).padStart(2, '0');
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1';
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1';
              yyyy = today.getFullYear() + 1;
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0');
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
        // console.log(today)
        var expireddate = Date.parse(today);
        // console.log(expireddate)
        var body = __WEBPACK_IMPORTED_MODULE_3__services__["b" /* Encode */].encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate });
        var url = '';
        if (_.includes(item.url, ['?'])) {
          url = '&';
        } else {
          url = '?';
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate;

        if (item.type === 'link') {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item);
        } else if (item.type === 'webview') {
          this.Webview_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          };
          this.dialogWebviewbig = true;
          if (item.payload.news_id !== undefined) {
            this.saveLogNews(item);
          }
        }
      } else {
        if (item.type === 'link') {
          // window.open(item.url, '_blank')
          // console.log('Carousel')
          this.checkBrowser(item.url, item);
        } else if (item.type === 'webview') {
          this.Webview_item = item;
          this.dialogWebviewbig = true;
          // check payload news
          if (item.payload.news_id !== undefined) {
            this.saveLogNews(item);
          }
        }
      }
    },
    openlink_market: function openlink_market(item) {
      var message = {
        message: '',
        payload: ''
      };
      if (item.type === 'link_market') {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        this.ans_quickreply(message, 'link_market');
        // this.clearQuickreply()
      }
    },
    openlink: function openlink(item) {
      var message = {
        message: '',
        payload: ''
      };
      this.ans_quickreply(message, 'link');
      this.check_get_accesstoken(item);
    },
    openwebview: function openwebview(item) {
      // console.log(item)
      // console.log('openwebview')
      var message = {
        message: '',
        payload: ''
        // this.Webview_item = item
        // this.dialogWebviewbig = true
      };this.ans_quickreply(message, 'webview');
      this.check_get_accesstoken(item);
    },
    sendansApprove: function sendansApprove(item, tokenmessage) {
      var _this18 = this;

      var body = {
        tokenmessage: tokenmessage,
        tokenuser: this.token,
        answer: item
      };
      var indexid = _.findIndex(this.items, function (o) {
        return o.tokenmessage === tokenmessage && o.typeofmessage === 'approve_message';
      });
      this.items[indexid].disable = 'true';
      this.axios.post("https://uatchat-manage.one.th/message" + '/answer_approve', body).then(function (response) {
        // console.log(response.data)
        if (_.find(_this18.items, function (o) {
          return o.tokenmessage === response.data.data.tokenmessage;
        }) === undefined) {
          _this18.items.push(response.data.data);
          _this18.clearQuickreply();
          _this18.items = _.sortBy(_this18.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          _this18.items = _.unionBy(_this18.items, 'tokenmessage');
        }
        setTimeout(_this18.scrollDown, 1);
      }, function () {});
    },
    ans_quickreply: function ans_quickreply(item, type) {
      var _this19 = this;

      var body = {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token,
        type_reply: type,
        message: item.message,
        info_data: item.payload
      };
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/answer_quickreply', body).then(function (response) {
        // console.log(response.data.data)
        if (_.find(_this19.items, function (o) {
          return o.tokenmessage === response.data.tokenmessage;
        }) === undefined) {
          if (response.data.data !== undefined) {
            _this19.items.push(response.data.data);
          }
          _this19.clearQuickreply();
          _this19.items = _.sortBy(_this19.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          _this19.items = _.unionBy(_this19.items, 'tokenmessage');
        }
        setTimeout(_this19.scrollDown, 1);
      }, function () {});
    },
    selectfile_quickreply: function selectfile_quickreply(item) {
      if (item.type == 'image') {
        $('#uploadpic_quickreply').click();
      } else {
        $('#uploadfile_quickreply').click();
      }
      this.itemdetail_quickreply = item;
    },
    sendlocation_quickreply: function sendlocation_quickreply() {
      var _this20 = this;

      // console.log(navigator.geolocation)
      if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(function (position) {
          // console.log(position.coords.latitude, position.coords.longitude)
          _this20.send_location(position.coords.latitude, position.coords.longitude, '');
        });
      } else {
        console.log('error geo');
      }
    },
    btn_answer_question: function btn_answer_question(item, itemmsg) {
      this.ans_question(item, itemmsg.tokenmessage);
      if (item.type === 'link' || item.type === 'webview') {
        this.check_get_accesstoken(item);
      } else if (item.type === 'file') {
        this.downloadFileMenu(item);
      } else if (item.type === 'link_market') {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
      } else if (item.type === 'ekyc') {
        this.ans_ekyc_template(item, itemmsg.tokenuser);
      }
    },
    btn_official_template: function btn_official_template(item, tokenuserBot, tokenmessage) {
      // console.log(item)
      // if (item.type === 'link') {
      //   window.open(item.url, '_blank')
      // } else if (item.type === 'webview') {
      //   this.Webview_item = item
      //   this.dialogWebviewbig = true
      // }
      if (item.sign == 'true' && item.type !== 'text') {
        this.getSign(item.url, item, tokenuserBot);
      } else if (item.onechat_token === 'true' && item.type !== 'text') {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var hour = String(today.getHours() + 1).padStart(2, '0');
        var minute = String(today.getMinutes()).padStart(2, '0');
        var seconds = String(today.getSeconds()).padStart(2, '0');
        var milsec = today.getMilliseconds();
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00';
          dd = String(today.getDate() + 1).padStart(2, '0');
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1';
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1';
              yyyy = today.getFullYear() + 1;
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0');
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
        // console.log(today)

        var expireddate = Date.parse(today);
        var body = __WEBPACK_IMPORTED_MODULE_3__services__["b" /* Encode */].encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate });
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        // var weburl = item.url + url
        var url = '';
        if (_.includes(item.url, ['?'])) {
          url = '&';
        } else {
          url = '?';
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate;

        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item);
        } else if (item.type === 'webview') {
          this.Webview_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          };
          this.dialogWebviewbig = true;
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        }
      } else {
        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item);
        } else if (item.type === 'webview') {
          this.Webview_item = item;
          this.dialogWebviewbig = true;
        } else if (item.type === 'text') {
          this.ans_question(item, tokenmessage);
        } else if (item.type === 'file') {
          this.ans_question(item, tokenmessage);
          this.downloadFileMenu(item);
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        }
      }
    },
    btn_img_official_template: function btn_img_official_template(item, tokenuserBot) {
      // console.log(item)
      if (item.sign === 'true') {
        this.getSignImg(item.url, item, tokenuserBot);
      } else if (item.onechat_token === 'true') {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var hour = String(today.getHours() + 1).padStart(2, '0');
        var minute = String(today.getMinutes()).padStart(2, '0');
        var seconds = String(today.getSeconds()).padStart(2, '0');
        var milsec = today.getMilliseconds();
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00';
          dd = String(today.getDate() + 1).padStart(2, '0');
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1';
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1';
              yyyy = today.getFullYear() + 1;
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0');
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
        // console.log(today)
        var expireddate = Date.parse(today);
        var body = __WEBPACK_IMPORTED_MODULE_3__services__["b" /* Encode */].encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate });
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        // var weburl = item.url + url
        var url = '';
        if (_.includes(item.url, ['?'])) {
          url = '&';
        } else {
          url = '?';
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate;

        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item);
        } else if (item.type === 'webview') {
          this.Webview_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          };
          this.dialogWebviewbig = true;
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        }
      } else {
        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item);
        } else if (item.type === 'webview') {
          this.Webview_item = item;
          this.dialogWebviewbig = true;
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        }
      }
    },
    getSignImg: function getSignImg(url, item, tokenuserBot) {
      var _this21 = this;

      var body = {
        "tokenuser": this.token,
        "url": url
      };
      this.axios.post("https://uatchat-manage.one.th/event" + '/old/api/v1/getAccesstoken', body).then(function (response) {
        if (response.data.data) {
          var new_url = '';
          // console.log(response.data.data)
          new_url = response.data.data.url;
          // console.log(response.data.data.url)
          if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
            // window.open(new_url, '_blank')
            _this21.checkBrowser(new_url, item);
          } else if (item.type === 'webview') {
            _this21.Webview_item = {
              label: item.label,
              url: new_url,
              size: item.size,
              type: item.type
            };
            _this21.dialogWebviewbig = true;
          } else if (item.type === 'link_market') {
            _this21.$swal('', _this21.$t('Alert.Warning.link_market'), 'warning');
          }
        } else {
          _this21.dialogLogin = true;
        }
      }, function () {});
    },
    getSign: function getSign(url, item, tokenuserBot) {
      var _this22 = this;

      // console.log('getSign')
      var body = {
        "tokenuser": this.token,
        "url": url
        // console.log(tokenuserBot)
      };this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", body).then(function (response) {
        // console.log(response.data.data)
        if (response.data.data) {
          var new_url = '';
          new_url = response.data.data.url;
          if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
            // window.open(new_url, '_blank')
            _this22.checkBrowser(new_url, item);
          } else if (item.type === 'webview') {
            _this22.Webview_item = {
              label: item.label,
              url: new_url,
              size: item.size,
              type: item.type
            };
            _this22.dialogWebviewbig = true;
          } else if (item.type === 'link_market') {
            _this22.$swal('', _this22.$t('Alert.Warning.link_market'), 'warning');
          }
        } else {
          _this22.dialogLogin = true;
        }
      }, function () {});
    },
    downloadFileMenu: function downloadFileMenu(item) {
      var name = item.file.split('/')[item.file.split('/').length - 1];
      this.axios.get(item.file, {
        responseType: 'blob'
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
      });
    },
    ans_question: function ans_question(item, tokenmessage) {
      var _this23 = this;

      if (item.payload === undefined) {
        item.payload = null;
      }
      var body = {
        tokenmessage: tokenmessage,
        tokenuser: this.token,
        answer: item
        // console.log(item)
      };this.axios.post("https://uatchat-manage.one.th/alpine" + '/answer_question', body).then(function (response) {
        // console.log(response.data)
        if (item.type === 'text') {
          if (_.find(_this23.items, function (o) {
            return o.tokenmessage === response.data.data.tokenmessage;
          }) === undefined) {
            _this23.items.push(response.data.data);
            _this23.clearQuickreply();
            _this23.items = _.sortBy(_this23.items, function (dateObj) {
              return new Date(dateObj.timestamp);
            });
            _this23.items = _.unionBy(_this23.items, 'tokenmessage');
          }
          setTimeout(_this23.scrollDown, 1);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleConnectivityChange: function handleConnectivityChange(status) {
      this.online = status;
    },
    initmapShow: function initmapShow() {
      this.map = new longdo.Map({
        placeholder: document.getElementById('map'),
        lastView: true
      });
      this.map.Ui.Keyboard.enable(true);
      var control3 = new longdo.TagPanel();
      this.map.Ui.add(control3);
      // this.map.Ui.Crosshair.visible(false)
      this.map.Ui.LayerSelector.visible(false);
      var location = this.locationName.message.split(',');
      var marker = new longdo.Marker({
        lat: location[0],
        lon: location[1]
      }, {
        icon: {
          url: '../../../../static/img/icons/pin.png',
          offset: {
            x: this.x,
            y: this.y
          }
        },
        clickable: true
      });
      this.map.Overlays.add(marker);
      // this.GeometryOptions()
      // console.log(parseFloat(location[0]) - 1)
      // console.log(parseFloat(location[0]) + 1)
      this.map.bound({
        minLon: parseFloat(location[0]) - 1,
        minLat: parseFloat(location[1]) - 1,
        maxLon: parseFloat(location[0]) + 1,
        maxLat: parseFloat(location[1]) + 1
      }, {
        lat: location[0],
        lon: location[1]
      });
      // this.showloc = this.map.bound()
      this.map.zoom(15, true);
      // longdo.Search(this.map, true)
    },
    openlocation: function openlocation(item) {
      // console.log(item)
      this.center_markermap = {
        lat: parseFloat(item.message.split(',')[0]),
        lng: parseFloat(item.message.split(',')[1])
      };
      this.sheetother = false;
      this.dialogMap = true;
      this.locationName = item;
    },
    openmap: function openmap() {
      this.sheetother = false;
      // this.dialogMap = true
      this.dialogSendMap = true;
    },
    senddate: function senddate() {
      var _this24 = this;

      // var _ = require('lodash')
      if (this.typepicker === 'datepicker') {
        // api
        this.datepicker = false;
        this.$swal({
          title: this.$t('Alert.Chat.sendDatetime'),
          html: '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.dateselect) + '</div>',
          confirmButtonColor: '#3085d6',
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          cancelButtonColor: '#d33',
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          buttonsStyling: true,
          showCloseButton: true,
          showCancelButton: true,
          reverseButtons: true
        }).then(function (result) {
          if (result.value) {
            var item = {
              message: _this24.dateselect,
              payload: _this24.infodata
            };
            _this24.ans_quickreply(item, 'datepicker');
          }
        });
      } else if (this.typepicker === 'datetimepicker') {
        this.datepicker = false;
        this.timepicker = true;
        if (this.dateselect === this.mindate) {
          this.maxtime = '24:00';
        } else if (this.dateselect === this.maxdate) {
          this.mintime = '00:00';
        } else {
          this.maxtime = '24:00';
          this.mintime = '00:00';
        }
      }
    },
    sendtime: function sendtime() {
      var _this25 = this;

      this.$swal({
        title: this.$t('Alert.Chat.sendDatetime'),
        html: '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.dateselect) + ' เวลา ' + this.timeselect + '</div>',
        confirmButtonColor: '#3085d6',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          var item = {
            message: _this25.dateselect + 'T' + _this25.timeselect,
            payload: _this25.infodata
          };
          _this25.timepicker = false;
          _this25.ans_quickreply(item, 'datetimepicker');
        }
      });
    },
    setpicker: function setpicker(data) {
      // console.log(data)
      setTimeout(this.scrollDown, 1);
      if (data.type === 'datepicker') {
        this.typepicker = data.type;
        this.datepicker = true;
        this.maxdate = data.max;
        this.mindate = data.min;
        this.dateselect = data.initial;
        this.infodata = data.payload;
      } else if (data.type === 'datetimepicker') {
        this.typepicker = data.type;
        this.datepicker = true;
        this.maxdate = data.max.split('T')[0];
        this.mindate = data.min.split('T')[0];
        this.maxtime = data.max.split('T')[1];
        this.mintime = data.min.split('T')[1];
        this.dateselect = data.initial.split('T')[0];
        this.timeselect = data.initial.split('T')[1];
        this.infodata = data.payload;
      }
    },
    getreply: function getreply() {
      var _this26 = this;

      this.datepicker = false;
      this.timepicker = false;
      this.maxdate = '';
      this.mindate = '';
      this.maxtime = '';
      this.mintime = '';
      this.dateselect = '';
      this.timeselect = '';
      this.infodata = '';
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/get-quickreply', {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this26.Quickreply = response.data.data;
          setTimeout(_this26.scrollDown, 1);
          // console.log(this.Quickreply)
        }
      });
    },
    momentday: function momentday(data) {
      return __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momentdatetimethai(data);
    },
    checkShowmessagwBottom: function checkShowmessagwBottom(data) {
      var scroll = this.$el.querySelector('#myscroll');
      if (scroll.scrollTop >= scroll.scrollHeight - this.box_height - 70.0) {
        setTimeout(this.scrollDown, 1);
      } else {
        this.showmessagebottom = true;
        this.chip = true;
        this.picturechip = data.path_pic;
        if (data.typeofmessage !== 'message') {
          // this.showmessage = data.nickname + ': Send ' + data.typeofmessage + ' to you'
          this.showmessage = 'Send ' + data.typeofmessage + ' to you';
        } else {
          // this.showmessage = data.nickname + ':  ' + data.message
          this.showmessage = data.message;
        }
        // setTimeout(this.scrollDown, 1)
      }
    },
    lookmessage: function lookmessage() {
      this.chip = false;
      this.showmessagebottom = false;
      setTimeout(this.scrollDown, 1);
    },
    scrollFunction: function scrollFunction() {
      this.$refs.menu.close();
      var scroll = this.$el.querySelector('#myscroll');
      // console.log(scroll.scrollTop)
      // console.log(scroll.scrollHeight)
      if (scroll.scrollTop == 0 && this.progressLoadChat == false) {
        this.getOldMessage(this.items[0].timestamp);
      }
      // console.log(scroll.scrollTop >= ((scroll.scrollHeight - this.box_height - 70.0)))
      if (scroll.scrollTop >= scroll.scrollHeight - this.box_height - 70.0) {
        // เห็นข้อความแล้ว ไม่ต้องทำอะไร
        // setTimeout(this.scrollDown, 1)
        this.chip = false;
        this.showmessagebottom = false;
      }
    },
    chsheetother: function chsheetother() {
      // console.log(this.sheetother + '   ch')
      // this.sheetother = !this.sheetother
      if ($('#menu-chat').is(":visible")) {
        this.sheetother = false;
        // $('#menu-chat').fadeOut(1600);
        // this.sheetother = false
      } else {
        this.sheetother = true;
        // $('#menu-chat').fadeOut(1600);
      }
    },
    chsheetsticker: function chsheetsticker() {
      this.sheetsticker = !this.sheetsticker;
    },
    changelink: function changelink(path) {
      return path;
    },
    pushSticker: function pushSticker(stickerid) {
      var _this27 = this;

      this.axios.post("https://uatchat-manage.one.th/message" + '/push_sticker', {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token,
        message: stickerid,
        type: this.typeuser
      }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          if (_.find(_this27.items, function (o) {
            return o.tokenmessage === response.data.data.tokenmessage;
          }) === undefined) {
            var stickerSend = response.data.data;
            stickerSend['status'] = 'success';
            _this27.items.push(stickerSend);
            _this27.clearQuickreply();
          }
          _this27.sheetsticker = false;
          _this27.items = _.sortBy(_this27.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          _this27.items = _.unionBy(_this27.items, 'tokenmessage');
          setTimeout(_this27.scrollDown, 1);
        }
      });
    },
    extension: function extension(path) {
      if (path !== undefined && path.includes('.') == true) {
        var fullname_path = path.split('.')[path.split('.').length - 1].toLowerCase();
        if (fullname_path.includes(' ')) {
          var path_space = fullname_path.split(' ');
          var extension = path_space[0];
        } else {
          var extension = fullname_path;
        }
        // console.log( 'path' , path)
        // var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
        var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
        var pdf = ['pdf'];
        var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm', 'xlsx'];
        var presentation = ['ppt', 'pps', 'pot', 'pptx'];
        var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
        var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
        var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff'];
        var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4', 'divx', 'dat'];
        var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf'];
        if (pdf.includes(extension)) {
          return 'pdf';
        } else if (archive.includes(extension)) {
          return 'fas fa-file-archive';
        } else if (spreadsheet.includes(extension)) {
          return 'fas fa-file-excel';
        } else if (presentation.includes(extension)) {
          return 'fas fa-file-powerpoint';
        } else if (word.includes(extension)) {
          return 'fas fa-file-word';
        } else if (execution.includes(extension)) {
          return 'fas fa-file-code';
        } else if (image.includes(extension)) {
          return 'fas fa-file-image';
        } else if (media.includes(extension)) {
          return 'media';
        } else if (audio.includes(extension)) {
          return 'audio';
        } else {
          return 'fas fa-file-alt';
        }
      } else {
        return 'fas fa-file-alt';
      }
    },
    pushcontact: function pushcontact(item) {
      if (item.status === 'success') {
        if (_.find(this.items, function (o) {
          return o.tokenmessage === item.data.tokenmessage;
        }) === undefined) {
          this.items.push(item.data);
          this.clearQuickreply();
          this.items = _.sortBy(this.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          this.items = _.unionBy(this.items, 'tokenmessage');
          setTimeout(this.scrollDown, 1);
        }
      } else {
        this.items.push({
          tokenuser: this.token,
          message: item.data.tokenuser,
          tokenroom: this.$route.params.roomid,
          typeofmessage: 'contact',
          timestamp: __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp(),
          tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp()),
          path_pic: this.profile,
          nickname: '',
          file_name: '',
          nickname_contact: item.data.name,
          pic_contact: item.data.profilepicture,
          type_contact: item.data.type,
          status: 'no'
        });
      }
    },
    detailFriend: function detailFriend(user) {
      // console.log(user)
      this.id = user;
      this.type = 'friend';
      this.dialogopenwebsite = true;
    },
    chat: function chat(tokenroom) {
      this.$router.push('/chat/room/' + tokenroom);
    },
    AcceptReq: function AcceptReq(tokenFriend) {
      var _this28 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/accept-friend", {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this28.relation = 'friend';
        }
      });
    },
    RemoveReq: function RemoveReq(tokenFriend) {
      var _this29 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this29.relation = 'unknown';
        }
      });
    },
    AddFriend: function AddFriend(tokenFriend) {
      var _this30 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this30.$store.dispatch('sendRequest', tokenFriend);
        } else {
          alert('Error!!!');
        }
      });
    },
    unblock: function unblock(tokenFriend) {
      var _this31 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistblockfriend', {
        tokenuser: this.token
      }).then(function (response) {
        var room = response.data['listBlockFriend'][_this31.findWithAttr(response.data['listBlockFriend'], 'tokenuser', tokenFriend)]['tokenroom'];
        _this31.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', {
          tokenfriend: tokenFriend,
          tokenuser: _this31.token,
          tokenroom: room
        }).then(function (response) {
          if (response.data['status'] === 'success') {
            _this31.$swal('Unblocked!', _this31.$t('Alert.Success.unblock'), 'success');
            _this31.relation = 'friend';
            _this31.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistblockfriend', {
              tokenuser: _this31.token
            }).then(function (response) {
              _this31.$store.dispatch('listFriend', 'listBlockFriend' + tokenFriend);
            });
          }
        });
      });
    },
    findWithAttr: function findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
    append: function append(emoji) {
      // console.log(emoji)
      this.sendmsg += emoji;
    },
    forword: function forword() {
      if (this.currentPage < this.pageCount) {
        this.currentPage = this.currentPage + 1;
      }
    },
    back: function back() {
      if (this.currentPage !== 1) {
        this.currentPage = this.currentPage - 1;
      }
    },
    other_noti: function other_noti(group, title, msg, pic) {
      if (Notification.permission === 'granted') {
        var notification = new Notification(title, {
          body: msg,
          icon: pic,
          silent: true
        });
        notification.onclick = function () {};
      } else {
        Notification.requestPermission().then(function (result) {
          // console.log(result)
        });
      }
    },
    ocropen: function ocropen(item) {
      $('#uploadpic_ocr').click();
      this.ocr_detailItem = item;
    },
    uppic: function uppic() {
      $('#uploadpic').click();
    },
    upfile: function upfile() {
      $('#uploadfileChat').click();
      this.sheetother = false;
    },
    pasteIntoInput: function pasteIntoInput(el, text) {
      el.focus();
      if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
        var val = el.value;
        var selStart = el.selectionStart;
        el.value = val.slice(0, selStart) + text + val.slice(el.selectionEnd);
        el.selectionEnd = el.selectionStart = selStart + text.length;
      } else if (typeof document.selection !== 'undefined') {
        var textRange = document.selection.createRange();
        textRange.text = text;
        textRange.collapse(false);
        textRange.select();
      }
    },
    closemodal: function closemodal() {
      var myModalMap = document.getElementById('myModalMap');
      myModalMap.style.display = 'none';
    },
    zoomfile: function zoomfile(file, state) {
      this.checkPasswordfile = file.typeofmessage;
      this.tokenmsg_file_pass = file.tokenmessage;
      this.name_file_pass = file.file_name;
      if (state) {
        this.DetailFile = file;
        this.dialogshowfile = state;
      } else {
        if (this.checkPasswordfile == 'password_file') {
          this.DetailFile = file;
          // console.log(this.DetailFile)
          this.dialogGetPassword = true;
        } else {
          // console.log(file.message)
          this.axios.get(file.message, {
            responseType: 'blob'
          }).then(function (response) {
            var url = window.URL.createObjectURL(new Blob([response.data]));
            var link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file.file_name);
            document.body.appendChild(link);
            link.click();
          });
        }
      }
    },
    zoom: function zoom(image) {
      image['path'] = image['message'];
      image['file_owner'] = image['nickname'];
      image['typeuser'] = image['type'];
      image['pic_pro'] = image['path_pic'];
      this.DetailImage = image;
      this.dialogshowimage = true;
    },
    closeDialogShowFile: function closeDialogShowFile(value) {
      this.dialogshowfile = value;
      this.DetailFile = {};
    },
    closeDialogShowImage: function closeDialogShowImage(value) {
      this.dialogshowimage = value;
    },

    // sendimgonebox (tokenmessage) {
    //   this.axios.post(process.env.APIpub + '/save_onebox2', {
    //     tokenmessage: tokenmessage,
    //     tokenuser: this.token
    //   }).then((response) => {
    //     console.log(response.data)
    //     if (response.data['status'] === 'success') {
    //       this.$swal(
    //         this.$t('Alert.Success.sending'),
    //         this.$t('Alert.Success.sendFile'),
    //         'success'
    //       )
    //     }
    //   })
    // },
    sendimgonebox: function sendimgonebox(tokenmessage) {
      this.dialogSaveOnebox = true;
      this.tokenmessage_savebox = tokenmessage;
    },
    closeSaveOnebox: function closeSaveOnebox(value) {
      this.dialogSaveOnebox = false;
    },
    scrollMaxOldSet: function scrollMaxOldSet() {
      this.scrollMaxOld = 0;
    },
    scrollDown: function scrollDown() {
      var container = this.$el.querySelector('#myscroll');
      container.scrollTop = container.scrollHeight;
      this.scrollval = container.scrollTop;
    },
    loadchathistory: function loadchathistory() {
      this.progressLoadChat = true;
      this.temp = this.selectedForward;
      this.selectedForward = [];
      this.getOldMessage(this.items[0].timestamp);
    },
    getOldMessage: function getOldMessage(time) {
      var _this32 = this;

      this.progressLoadChat = true;
      if (time === '') {
        this.progressLoadChatBox = true;
      }
      console.log('tokenroom web: ', this.$route.params.roomid !== null && this.$route.params.roomid !== undefined);
      if (this.$route.params.roomid !== null && this.$route.params.roomid !== undefined) {
        this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getdictmessage", {
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token,
          time_in: time
        }).then(function (response) {
          // this.tokenuser_friend = Decode.decodeToken(this.$cookie.get('tokenuser_friend'))
          // this.get_list_richmenu(this.$route.params.roomid)
          _this32.progressLoadChat = false;
          _this32.progressLoadChatBox = false;
          if (response.data['status'] === 'success') {
            // console.log(response.data)
            _this32.statemember = response.data.state_member;
            _this32.items.unshift.apply(_this32.items, response.data['data'].reverse());
            // check url redirect room
            _this32.CheckUrlRoom();
            if (response.data.data.length === 20) {
              _this32.statusload = true;
            } else if (response.data.data.length < 20) {
              _this32.statusload = false;
            }
            _this32.selectedForward = _this32.temp;
            // setTimeout(this.scrollDown, 1)
            if (time === '') {
              setTimeout(_this32.scrollDown, 1);
            } else {
              var container = _this32.$el.querySelector('#myscroll');
              _this32.scrollval = container.scrollTop;
              if (_this32.scrollval < 20) {
                var scrollMaxNew = container.scrollHeight;
                container.scrollTop = scrollMaxNew - _this32.scrollMaxOld;
                _this32.scrollMaxOld = scrollMaxNew;
                _this32.scrollval = container.scrollTop;
              }
            }
          } else {
            if (response.data.message === 'not member.') {
              _this32.$router.push('/chat/not_permission');
            }
          }
        }).catch(function (error) {
          _this32.progressLoadChat = false;
          _this32.progressLoadChatBox = false;
          if (error.response.data.message === 'Tokenroom not found.') {
            _this32.$router.push('/chat/not_found');
          }
        });
      } else {
        this.$router.push('/chat');
      }
    },
    get_list_richmenu: function get_list_richmenu(bot_id) {
      var _this33 = this;

      // console.log(typeroom)
      // if (typeroom !== 'group') {
      this.list_richmenu = [];
      this.inforrichmenu = {};
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-richmenu-by-botid', { bot_id: bot_id }).then(function (response) {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          _this33.list_richmenu = response.data.data.list_menu;
          _this33.type_richmenu = parseInt(response.data.data.type_menu);
          _this33.inforrichmenu = response.data.data.list_menu;
          _this33.richmenu_label = response.data.data.menu_label;
          _this33.bot_id_richmenu = response.data.data.bot_id;
          _this33.default_behavior = parseInt(response.data.data.default_behavior);
          if (_this33.default_behavior === 1) {
            _this33.RichmenuState = true;
            _this33.sheetrichmenu = true;
            _this33.RichmenuState_first = true;
          } else {
            _this33.RichmenuState = false;
            _this33.sheetrichmenu = false;
            _this33.RichmenuState_first = false;
          }
          // console.log(this.type_richmenu)
          // console.log(this.inforrichmenu)
        } else {
          // console.log(response.data)
          _this33.list_richmenu = [];
        }
      }).catch(function (error) {
        console.log(error);
      });
      // }
    },
    isBlank: function isBlank(str) {
      return !str || /^\s*$/.test(str);
    },
    isEmpty: function isEmpty(str) {
      return !str || str.length === 0;
    },
    dateMoment: function dateMoment(data) {
      // return Momenttime.momentdatethai(data)
      if (this.$i18n.locale == 'th') {
        return __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momentdatethai(data);
      } else if (this.$i18n.locale == 'cn') {
        return __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momentdatecn(data);
      } else {
        return __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momentdateen(data);
      }
    },
    timeMoment: function timeMoment(data) {
      return __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimethai(data);
    },
    resendMessage: function resendMessage(data) {
      _.remove(this.items, function (n) {
        return n.tokenmessage === data.tokenmessage;
      });
      this.sendMessage(data.message);
    },
    resendContact: function resendContact(data) {
      _.remove(this.items, function (n) {
        return n.tokenmessage === data.tokenmessage;
      });
      this.sendContact(data);
    },
    sendContact: function sendContact(data) {
      var _this34 = this;

      this.axios.post("https://uatchat-manage.one.th/message" + '/push_contact', {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token,
        tokencontact: data.message,
        type: this.typeuser
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          if (_.find(_this34.items, function (o) {
            return o.tokenmessage === response.data.tokenmessage;
          }) === undefined) {
            _this34.items.push(response.data.data);
            _this34.clearQuickreply();
            _this34.items = _.sortBy(_this34.items, function (dateObj) {
              return new Date(dateObj.timestamp);
            });
            _this34.items = _.unionBy(_this34.items, 'tokenmessage');
            setTimeout(_this34.scrollDown, 1);
          }
          _this34.$swal('', _this34.$t('Alert.Success.account'), 'success');
        } else {
          _this34.items.push({
            tokenuser: _this34.token,
            message: data.tokenuser,
            tokenroom: _this34.$route.params.roomid,
            typeofmessage: 'contact',
            timestamp: __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp(),
            tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp()),
            path_pic: _this34.profile,
            nickname: '',
            file_name: '',
            nickname_contact: data.name,
            pic_contact: data.profilepicture,
            type_contact: data.type,
            status: 'no'
          });
          _this34.$swal('', _this34.$t('Alert.Fail.default.somethingWrong'), 'error');
        }
      }, function () {
        _this34.$swal('Network error', _this34.$t('Alert.Fail.default.networkError'), 'error');
      });
    },
    sendMessage: function sendMessage(data) {
      var _this35 = this;

      // console.log(data)
      this.status_tag = false;
      var index = 0;
      for (index in this.files) {
        this.pushfile(this.files[index].file, this.files[index].name);
        if (index == this.files.length - 1) {
          this.files = [];
          this.sendmsg = '';
        }
      }
      if (this.showmention === false) {
        var replaced = data.replace(/(?:\r\n|\r|\n)/g, '<br>');
        try {
          if (event.keyCode === 13 || event.which === 1) {
            if (event.shiftKey && replaced !== '') {
              this.sendmsg.pasteIntoInput(this.sendmsg, '<br>');
            } else {
              if (!this.isBlank(data) && !this.isEmpty(data)) {
                // this.sendmsg = ''
                if (this.typeroom === 'group') {
                  var result;
                  this.listfriend.map(function (item) {
                    // const condition = `^@${item.name}|\\s@${item.name}`
                    // const regex = new RegExp(condition, "g")
                    // var pattern3 = /\B@([\u0E00-\u0E7Fa-zA-Z'])+/gi
                    var pattern3 = /\B@([^\u0000-\u007F]|[\a-zA-Z])+/gi;
                    result = data.match(pattern3);
                  });
                  // console.log(result)
                  if (result) {
                    var test2 = [];
                    for (var i = 0; i < result.length; i++) {
                      // console.log(result[i])
                      var test = this.listfriend.find(function (person) {
                        return person.name.includes(result[i].substring(1));
                      });
                      test2.push(test);
                      // console.log(test2)
                    }
                    // console.log(test2[0])
                    for (var j = 0; j < test2.length; j++) {
                      if (test2[j] !== undefined) {
                        data = data.replace('@' + test2[j].name, '<tax>' + test2[j].tokenuser + '</tax>');
                      }
                    }
                  } else {
                    // ถ้าข้อความมี spacebar แทยค่าด้วย \u00a0
                    for (var k = 0; k < data.length; k++) {
                      data = data.replace(/ /g, '\xA0');
                    }
                  }
                } else {
                  // ถ้าข้อความมี spacebar แทยค่าด้วย \u00a0
                  for (var l = 0; l < data.length; l++) {
                    data = data.replace(/ /g, '\xA0');
                  }
                }
                this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/pushMessage", {
                  tokenroom: this.$route.params.roomid,
                  tokenuser: this.token,
                  type: this.typeuser,
                  message: data
                  // data.trim()
                }).then(function (response) {
                  // console.log(response)
                  var messageSendChat = response.data.data;
                  if (response.data.status === 'success') {
                    messageSendChat['status'] = 'success';
                    if (_.find(_this35.items, function (o) {
                      return o.tokenmessage === messageSendChat.tokenmessage;
                    }) === undefined) {
                      _this35.items.push(messageSendChat);
                      _this35.clearQuickreply();
                      _this35.items = _.sortBy(_this35.items, function (dateObj) {
                        return new Date(dateObj.timestamp);
                      });
                      _this35.items = _.unionBy(_this35.items, 'tokenmessage');
                    }
                    setTimeout(_this35.scrollDown, 1);
                    _this35.sendmsg = '';
                  } else {
                    _this35.items.push({
                      tokenuser: _this35.token,
                      message: data,
                      tokenroom: _this35.$route.params.roomid,
                      typeofmessage: 'message',
                      timestamp: __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp(),
                      tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp()),
                      path_pic: _this35.profile,
                      nickname: '',
                      file_name: '',
                      status: 'no'
                    });
                    _this35.sendmsg = '';
                  }
                }, function (error) {
                  _this35.items.push({
                    tokenuser: _this35.token,
                    message: data,
                    tokenroom: _this35.$route.params.roomid,
                    typeofmessage: 'message',
                    timestamp: __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp(),
                    tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp()),
                    path_pic: _this35.profile,
                    nickname: '',
                    file_name: '',
                    status: 'no'
                  });
                  _this35.sendmsg = '';
                  _this35.$swal('Network error', _this35.$t('Alert.Fail.default.networkError'), 'error');
                  console.log(error);
                });
              }
            }
            event.preventDefault();
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        this.sendMessageMention(data);
      }
    },
    sendMessageMention: function sendMessageMention(data) {
      var _this36 = this;

      this.showmention = false;
      try {
        if (!this.isBlank(data) && !this.isEmpty(data)) {
          // var result
          // this.listfriend.map((item) => {
          //   var pattern3 = /\B@([\u0E00-\u0E7Fa-zA-Z'])+/gi
          //   result = data.match(pattern3)
          // })
          //   // console.log(result)
          // if(result !== null){
          //   var test2 = []
          //   for(var i=0; i< result.length ; i++){
          //     const test = this.listfriend.find(person =>
          //       person.name.includes(result[i].substring(1)))
          //       test2.push(test)
          //     }
          //     for(var j=0 ; j<test2.length; j++){
          //       data = data.replace(('@'+ test2[j].name), '<tax>'+test2[j].tokenuser+'</tax>')
          //     }
          //   }

          // console.log(data)
          this.axios.post("https://uatchat-manage.one.th/message" + '/mention_message', {
            tokenuser: this.token,
            tokenmessage: this.SelectedMessageDetail.tokenmessage,
            tokenroom: this.$route.params.roomid,
            mention_message: data
          }).then(function (response) {
            var messageSendChat = response.data.data;
            if (response.data.status === 'success') {
              messageSendChat['status'] = 'success';
              if (_.find(_this36.items, function (o) {
                return o.tokenmessage === messageSendChat.tokenmessage;
              }) === undefined) {
                _this36.items.push(messageSendChat);
                _this36.clearQuickreply();
                _this36.items = _.sortBy(_this36.items, function (dateObj) {
                  return new Date(dateObj.timestamp);
                });
                _this36.items = _.unionBy(_this36.items, 'tokenmessage');
              }
              setTimeout(_this36.scrollDown, 1);
              _this36.sendmsg = '';
            } else {
              _this36.items.push({
                tokenuser: _this36.token,
                message: data,
                tokenroom: _this36.$route.params.roomid,
                typeofmessage: 'mention_message',
                timestamp: __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp(),
                tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp()),
                path_pic: _this36.profile,
                nickname: '',
                file_name: '',
                status: 'no'
              });
              _this36.sendmsg = '';
            }
          }, function (error) {
            _this36.items.push({
              tokenuser: _this36.token,
              message: data,
              tokenroom: _this36.$route.params.roomid,
              typeofmessage: 'mention_message',
              timestamp: __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp(),
              tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp()),
              path_pic: _this36.profile,
              nickname: '',
              file_name: '',
              status: 'no'
            });
            _this36.sendmsg = '';
            _this36.$swal('Network error', _this36.$t('Alert.Fail.default.networkError'), 'error');
            console.log(error);
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    checksen: function checksen(data) {
      if (!this.isBlank(data) && !this.isEmpty(data)) {
        return true;
      } else {
        return false;
      }
    },
    clearQuickreply: function clearQuickreply() {
      if (this.Quickreply.length !== 0) {
        // console.log('this.Quickreply')
        // console.log(this.Quickreply)
        // console.log(this.items[this.items.length - 1])
        if (this.Quickreply.timestamp < this.items[this.items.length - 1].timestamp) {
          this.Quickreply = [];
        }
      }
    },
    getMessageSocket: function getMessageSocket(data) {
      // console.log(data)
      // console.log(this.Quickreply)
      // console.log(this.items[this.items.length-1].timestamp)
      // this.clearQuickreply()
      if (data.tokenroom === this.$route.params.roomid) {
        if (data.tokenuser !== this.token) {
          this.checkShowmessagwBottom(data);
        }
        if (_.find(this.items, function (o) {
          return o.tokenmessage === data.tokenmessage;
        }) === undefined) {
          this.items.push(data);
          // console.log(this.items)
          this.clearQuickreply();
          this.items = _.sortBy(this.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          this.items = _.unionBy(this.items, 'tokenmessage');
          // console.log(this.items)
          // setTimeout(this.scrollDown, 1)
          if (data.typeofmessage === 'file') {
            this.socketupdate_file = data;
          } else if (data.typeofmessage === 'image') {
            this.socketupdate_img = data;
          }
          if (data.tokenuser !== this.token) {
            this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/user-mark-read', {
              tokenuser: this.token,
              tokenroom: data.tokenroom
            }).then(function (response) {});
          }
        }
      }
    },
    onScroll: function onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    pushfile: function pushfile(file, filename) {
      var _this37 = this;

      var uploadFile = new FormData();
      uploadFile.append('file', file, filename);
      uploadFile.append('tokenroom', this.$route.params.roomid);
      uploadFile.append('tokenuser', this.token);
      uploadFile.append('type', this.typeuser);
      // this.headers = {headers: {'Authorization': this.tokenservice}}
      this.axios.post("https://uatchat-manage.one.th/message" + '/push_image', uploadFile).then(function (response) {
        if (response.data.status === 'success') {
          if (_.find(_this37.items, function (o) {
            return o.tokenmessage === response.data.data.tokenmessage;
          }) === undefined) {
            _this37.socketupdate_img = response.data.data;
            response.data.data.status = 'success';
            _this37.items.push(response.data.data);
            _this37.clearQuickreply();
            _this37.items = _.sortBy(_this37.items, function (dateObj) {
              return new Date(dateObj.timestamp);
            });
            _this37.items = _.unionBy(_this37.items, 'tokenmessage');
            document.querySelector('#uploadpic').value = '';
            document.querySelector('#uploadfileChat').value = '';
          }
          setTimeout(_this37.scrollDown, 1);
        } else {}
      }, function (error) {
        console.log(error);
        _this37.$swal('Network error', _this37.$t('Alert.Fail.default.networkError'), 'error');
      });
    },
    onimgSelected: function onimgSelected(data) {
      var _this38 = this;

      var uploadedFiles = data.target.files;
      var lengthfile = uploadedFiles.length;
      var sizefile = [];
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = uploadedFiles[i].size;
      }
      if (_.sum(sizefile) / 1024 / 1024 > 100) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile100'), type: 'warning' });
      } else {
        for (var _i = 0; _i < uploadedFiles.length; _i++) {
          if (data.target.files[_i].type === 'image/jpeg' || data.target.files[_i].type === 'image/png' || data.target.files[_i].type === 'image/jpg') {
            this.selectFile = data.target.files[_i];
            var uploadFile = new FormData();
            uploadFile.append('file', this.selectFile, this.selectFile.name);
            uploadFile.append('tokenroom', this.$route.params.roomid);
            uploadFile.append('tokenuser', this.token);
            uploadFile.append('type', this.typeuser);
            this.axios.post("https://uatchat-manage.one.th/message" + '/push_image', uploadFile).then(function (response) {
              if (response.data.status === 'success') {
                if (_.find(_this38.items, function (o) {
                  return o.tokenmessage === response.data.data.tokenmessage;
                }) === undefined) {
                  _this38.socketupdate_img = response.data.data;
                  response.data.data.status = 'success';
                  _this38.items.push(response.data.data);
                  _this38.clearQuickreply();
                  _this38.items = _.sortBy(_this38.items, function (dateObj) {
                    return new Date(dateObj.timestamp);
                  });
                  _this38.items = _.unionBy(_this38.items, 'tokenmessage');
                  document.querySelector('#uploadpic').value = '';
                  document.querySelector('#uploadfileChat').value = '';
                }
                setTimeout(_this38.scrollDown, 1);
              } else {}
            }, function (error) {
              console.log(error);
              _this38.$swal('Network error', _this38.$t('Alert.Fail.default.networkError'), 'error');
            });
          } else {
            this.onFileSelected(data);
          }
        }
      }
    },
    onimgSelected_ocr: function onimgSelected_ocr(data) {
      var uploadedFiles = data.target.files;
      var lengthfile = uploadedFiles.length;
      // console.log(this.ocr_detailItem)
      var me = this;
      var reader = new FileReader();
      reader.readAsDataURL(data.target.files[0]);
      reader.onloadend = function () {
        var body = {
          "tokenroom": me.$route.params.roomid,
          "tokenuser": me.token,
          "base64_image": reader.result,
          "multi_select": me.ocr_detailItem.multi_select
        };
        me.dialogWebviewbig_ocr = true;
        // me.Webview_item = {url: "https://chat-develop.one.th/ocr_scantext?id=Ua4KAHvPEqd2wOXF28cD9", label: ''}

        me.axios.post('https://l.one.th/onechat-ocr/api/v1/send-ocr-image', body).then(function (response) {
          // console.log(response.data.data.link)
          if (response.data.message === 'success') {
            // me.dialogWebviewbig = true
            me.Webview_item_ocr = { url: response.data.data.link, label: '' };
          }
        }, function () {
          me.$swal('ไม่สำเร็จ!', 'โปรดอัปโหลดรูปใหม่', 'warning');
        });
      };
    },
    onimgSelected_quickreply: function onimgSelected_quickreply(data) {
      var _this39 = this;

      var uploadedFiles = data.target.files;
      var lengthfile = uploadedFiles.length;
      this.selectFile = data.target.files[0];
      var uploadFile = new FormData();
      uploadFile.append('file', this.selectFile, this.selectFile.name);
      uploadFile.append('tokenroom', this.$route.params.roomid);
      uploadFile.append('tokenuser', this.token);
      uploadFile.append('type_reply', this.itemdetail_quickreply.type);
      uploadFile.append('info_data', this.itemdetail_quickreply.payload);
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/answer_quickreply', uploadFile).then(function (response) {
        if (response.data.status === 'success') {
          if (_.find(_this39.items, function (o) {
            return o.tokenmessage === response.data.data.tokenmessage;
          }) === undefined) {
            // this.socketupdate_img = response.data.data
            // response.data.data.status = 'success'
            _this39.items.push(response.data.data);
            _this39.clearQuickreply();
            _this39.items = _.sortBy(_this39.items, function (dateObj) {
              return new Date(dateObj.timestamp);
            });
            _this39.items = _.unionBy(_this39.items, 'tokenmessage');
            document.querySelector('#uploadfile_quickreply').value = '';
            document.querySelector('#uploadpic_quickreply').value = '';
          }
          setTimeout(_this39.scrollDown, 1);
        } else {}
      }, function (error) {
        console.log(error);
        _this39.$swal('Network error', _this39.$t('Alert.Fail.default.networkError'), 'error');
      });
    },
    clearImage: function clearImage() {
      $('#uploadpic_ocr').val("");
      $('#uploadpic_quickreply').val("");
    },
    onFileSelected: function onFileSelected(data) {
      var _this40 = this;

      // console.log(data)
      // console.log(data.target.files)
      // console.log(this.extension(data.target.files))
      this.sheetother = false;
      var uploadedFiles = data.target.files;
      var lengthfile = uploadedFiles.length;
      var sizefile = [];
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = uploadedFiles[i].size;
      }
      // if (data.target.files.type === 'image/jpeg' || data.target.files.type === 'image/png' || data.target.files.type === 'image/jpg') {
      //   this.onimgSelected(data)
      // } else {
      if (_.sum(sizefile) / 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile'), type: 'warning' });
      } else {
        for (var _i2 = 0; _i2 < uploadedFiles.length; _i2++) {
          if (uploadedFiles[_i2].type === 'image/jpeg' || uploadedFiles[_i2].type === 'image/png' || uploadedFiles[_i2].type === 'image/jpg') {
            var datas = [];
            datas.push(uploadedFiles[_i2]);
            this.onimgDrag(datas);
          } else if (this.extension(uploadedFiles[_i2].name) === 'media') {
            var file_video = [];
            file_video.push(uploadedFiles[_i2]);
            this.push_video(file_video);
          } else {
            this.selectFile = uploadedFiles[_i2];
            var uploadFile = new FormData();
            uploadFile.append('file', this.selectFile, this.selectFile.name);
            uploadFile.append('tokenroom', this.$route.params.roomid);
            uploadFile.append('tokenuser', this.token);
            uploadFile.append('type', this.typeuser);
            this.axios.post("https://uatchat-manage.one.th/message" + '/push_file', uploadFile).then(function (response) {
              // console.log(response.data)
              if (response.data.status === 'success') {
                if (_.find(_this40.items, function (o) {
                  return o.tokenmessage === response.data.data.tokenmessage;
                }) === undefined) {
                  response.data.data.status = 'success';
                  _this40.items.push(response.data.data);
                  _this40.clearQuickreply();
                  _this40.items = _.sortBy(_this40.items, function (dateObj) {
                    return new Date(dateObj.timestamp);
                  });
                  _this40.items = _.unionBy(_this40.items, 'tokenmessage');
                  document.querySelector('#uploadfileChat').value = '';
                  _this40.socketupdate_file = response.data.data;
                }
                setTimeout(_this40.scrollDown, 1);
              } else {}
            }, function (error) {
              console.log(error);
              _this40.$swal('Network error', _this40.$t('Alert.Fail.default.networkError'), 'error');
            });
          }
        }
        // }
      }
    },
    playvideo: function playvideo() {
      if (Hls.isSupported()) {
        var video2 = document.getElementById('livevideo');
        var hls = new Hls();
        hls.loadSource(video2.src); // GC GET VIDEO SRC
        hls.attachMedia(video2);
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          //video2.play();
        });
      }
    },
    push_video: function push_video(data) {
      var _this41 = this;

      this.sheetother = false;
      var lengthfile = data.length;
      var sizefile = [];
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = data[i].size;
      }
      if (_.sum(sizefile) / 1024 / 1024 > 100) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile100'), type: 'warning' });
      } else {
        for (var _i3 = 0; _i3 < data.length; _i3++) {
          // if (data[i].type === 'image/jpeg' || data[i].type === 'image/png' || data[i].type === 'image/jpg') {
          // console.log('it image')
          this.selectFile = data[_i3];
          var uploadFile = new FormData();
          uploadFile.append('file', this.selectFile, this.selectFile.name);
          uploadFile.append('tokenroom', this.$route.params.roomid);
          uploadFile.append('tokenuser', this.token);
          this.axios.post("https://uatchat-manage.one.th/media/api/v1/send-video", uploadFile).then(function (response) {
            if (response.data.status === 'success') {
              if (_.find(_this41.items, function (o) {
                return o.tokenmessage === response.data.data.tokenmessage;
              }) === undefined) {
                _this41.socketupdate_file = response.data.data;
                // console.log(response.data.data)
                response.data.data.status = 'success';
                _this41.items.push(response.data.data);
                _this41.clearQuickreply();
                _this41.items = _.sortBy(_this41.items, function (dateObj) {
                  return new Date(dateObj.timestamp);
                });
                _this41.items = _.unionBy(_this41.items, 'tokenmessage');
                document.querySelector('#uploadpic').value = '';
                document.querySelector('#uploadfileChat').value = '';
              }
              setTimeout(_this41.scrollDown, 1);
            } else {}
          }, function (error) {
            console.log(error);
            _this41.$swal('Network error', _this41.$t('Alert.Fail.default.networkError'), 'error');
          });
          // } else {
          // }
        }
      }
    },
    onimgDrag: function onimgDrag(data) {
      var _this42 = this;

      this.sheetother = false;
      var lengthfile = data.length;
      var sizefile = [];
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = data[i].size;
      }
      if (_.sum(sizefile) / 1024 / 1024 > 100) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile100'), type: 'warning' });
      } else {
        for (var _i4 = 0; _i4 < data.length; _i4++) {
          if (data[_i4].type === 'image/jpeg' || data[_i4].type === 'image/png' || data[_i4].type === 'image/jpg') {
            // console.log('it image')
            this.selectFile = data[_i4];
            var uploadFile = new FormData();
            uploadFile.append('file', this.selectFile, this.selectFile.name);
            uploadFile.append('tokenroom', this.$route.params.roomid);
            uploadFile.append('tokenuser', this.token);
            uploadFile.append('type', this.typeuser);
            this.axios.post("https://uatchat-manage.one.th/message" + '/push_image', uploadFile).then(function (response) {
              if (response.data.status === 'success') {
                if (_.find(_this42.items, function (o) {
                  return o.tokenmessage === response.data.data.tokenmessage;
                }) === undefined) {
                  _this42.socketupdate_img = response.data.data;
                  response.data.data.status = 'success';
                  _this42.items.push(response.data.data);
                  _this42.clearQuickreply();
                  _this42.items = _.sortBy(_this42.items, function (dateObj) {
                    return new Date(dateObj.timestamp);
                  });
                  _this42.items = _.unionBy(_this42.items, 'tokenmessage');
                  document.querySelector('#uploadpic').value = '';
                  document.querySelector('#uploadfileChat').value = '';
                }
                setTimeout(_this42.scrollDown, 1);
              } else {}
            }, function (error) {
              console.log(error);
              _this42.$swal('Network error', _this42.$t('Alert.Fail.default.networkError'), 'error');
            });
          } else {}
        }
      }
    },
    onFileDrag: function onFileDrag(data) {
      var _this43 = this;

      this.sheetother = false;
      var lengthfile = data.length;
      var sizefile = [];
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = data[i].size;
      }
      if (_.sum(sizefile) / 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile'), type: 'warning' });
      } else {
        for (var _i5 = 0; _i5 < data.length; _i5++) {
          if (data[_i5].type === 'image/jpeg' || data[_i5].type === 'image/png' || data[_i5].type === 'image/jpg') {
            var datas = [];
            datas.push(data[_i5]);
            this.onimgDrag(datas);
          } else {
            this.selectFile = data[_i5];
            var uploadFile = new FormData();
            uploadFile.append('file', this.selectFile, this.selectFile.name);
            uploadFile.append('tokenroom', this.$route.params.roomid);
            uploadFile.append('tokenuser', this.token);
            uploadFile.append('type', this.typeuser);
            this.axios.post("https://uatchat-manage.one.th/message" + '/push_file', uploadFile).then(function (response) {
              if (response.data.status === 'success') {
                if (_.find(_this43.items, function (o) {
                  return o.tokenmessage === response.data.data.tokenmessage;
                }) === undefined) {
                  response.data.data.status = 'success';
                  _this43.items.push(response.data.data);
                  _this43.clearQuickreply();
                  _this43.items = _.sortBy(_this43.items, function (dateObj) {
                    return new Date(dateObj.timestamp);
                  });
                  _this43.items = _.unionBy(_this43.items, 'tokenmessage');
                  document.querySelector('#uploadfileChat').value = '';
                  _this43.socketupdate_file = response.data.data;
                }
                setTimeout(_this43.scrollDown, 1);
              } else {}
            }, function (error) {
              console.log(error);
              _this43.$swal('Network error', _this43.$t('Alert.Fail.default.networkError'), 'error');
            });
          }
        }
        // }
      }
    },
    send_location: function send_location(lat, long, address) {
      var _this44 = this;

      // console.log(lat, long, address)
      if (lat !== '' && long !== '') {
        this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/pushLocation', {
          'tokenroom': this.$route.params.roomid,
          'tokenuser': this.token,
          'lat': lat + '',
          'long': long + '',
          'address': address
        }).then(function (response) {
          // console.log(response.data)
          if (response.data.status === 'success') {
            if (_.find(_this44.items, function (o) {
              return o.tokenmessage === response.data.data.tokenmessage;
            }) === undefined) {
              response.data.data.status = 'success';
              _this44.items.push(response.data.data);
              _this44.clearQuickreply();
              _this44.items = _.sortBy(_this44.items, function (dateObj) {
                return new Date(dateObj.timestamp);
              });
              _this44.items = _.unionBy(_this44.items, 'tokenmessage');
            }
            setTimeout(_this44.scrollDown, 1);
          } else {}
        }, function (error) {
          console.log(error);
          _this44.$swal('Network error', _this44.$t('Alert.Fail.default.networkError'), 'error');
        });
      }
    },
    closeNote: function closeNote(value) {
      this.dialogNote = value;
    },
    closeAlbums: function closeAlbums(value) {
      this.dialogAlbums = value;
    },
    closeDetailTask: function closeDetailTask(value) {
      this.dialogDetailTask = value;
    },
    closeAddImage: function closeAddImage(value) {
      this.dialogAddImage = value;
    },
    closeApprove: function closeApprove(value) {
      this.dialogApprove = value;
    },
    closeAccount: function closeAccount(value) {
      this.dialogAccount = value;
    },
    closeSendMap: function closeSendMap(value) {
      this.dialogSendMap = value;
    },
    closeLoginDialog: function closeLoginDialog(value) {
      this.dialogLogin = value;
    },
    closeWebview: function closeWebview(value) {
      // console.log("closeWebview")
      // console.log(value)
      this.Webview_item = {};
      this.dialogWebview = value;
      this.dialogWebviewbig = value;
      this.dialogWebviewbig_ocr = value;
    },
    closeForward: function closeForward(value) {
      this.ForwardState = value;
      this.dialogForward = value;
      this.selectedForward = [];
    },
    detailNote: function detailNote(id) {
      this.dialogNote = true;
      this.note_id = id;
    },
    detailAlbums: function detailAlbums(id) {
      // console.log(id)
      this.dialogAlbums = true;
      this.albums_id = id;
    },
    convertMention: function convertMention(msg) {
      msg = msg.replace(/\<tax>/g, '<span style="color:#1976d2; cursor:pointer;">@');
      msg = msg.replace(/<\/tax>/g, '</span>');
      // console.log(msg)
      return msg;
    },
    convertMentionAnnounce: function convertMentionAnnounce(msg) {
      msg = msg.replace(/\<tax>/g, '<span style="color:white;">@');
      msg = msg.replace(/<\/tax>/g, '</span>');
      // console.log(msg)
      return msg;
    },
    convert: function convert(msg) {
      // var linkifyStr = require('linkifyjs/string')
      // var str = msg
      // var processedContent = linkifyStr(str)
      // processedContent = processedContent.replace('&lt;tax&gt;', '<b style="color:#1976d2;">@')
      // processedContent = processedContent.replace('&lt;/tax&gt;', '</b>')
      // return processedContent
      var linkifyStr = __webpack_require__("nN35");
      var str = msg;
      var processedContent = linkifyStr(str);
      var regex = /\s|<tax>+[\u0E00-\u0E7Fa-zA-Z'|/^\S+@\S+\.\S+$/]+<\/tax>/g;
      // var word = msg.match(regex)
      // console.log(word)
      if (msg.match(regex)) {
        for (var i = 0; i < msg.match(regex).length; i++) {
          // var word = msg.match(regex)
          // @click.native.capture=method
          processedContent = processedContent.replace('&lt;tax&gt;', '<b style="color:#1976d2; cursor:pointer;" >@');
          processedContent = processedContent.replace('&lt;/tax&gt;', '</b>');
          processedContent = processedContent.replace('\t', '\xA0\xA0\xA0\xA0\xA0');
          // processedContent = processedContent.replace(' ', '&nbsp;')
        }
      }
      // console.log(processedContent)
      return processedContent;
    },
    convertURL: function convertURL(msg) {
      var urlRegex = /\bhttps?:\/\/\S+/gi;
      var linkmsg = msg.match(urlRegex);
      if (linkmsg !== null) {
        if (linkmsg.length !== 0) {
          // console.log(linkmsg.slice(0,5))
          linkmsg.length = 1;
          return linkmsg;
        }
        return '';
      } else {
        return '';
      }
      // console.log(msg.match(urlRegex) !== null);
    },
    clicklink_website: function clicklink_website(url) {
      // window.open(url)
      this.checkBrowser(url, '');
    },
    testtag: function testtag() {
      // console.log(this.sendmsg)
    },
    filterlistfriend: function filterlistfriend() {
      var _this45 = this;

      if (this.showmention === false && this.typeroom === 'group') {
        // const sectionMsg = this.sendmsg.split(' ')
        // const lastSection = sectionMsg[sectionMsg.length - 1]
        // // console.log(lastSection)
        // const isTag = lastSection.charAt(0) === '@'
        // // console.log(isTag)
        // if(lastSection.charAt(0) === '@' && this.listfriend.length > 1){
        //   var textToSearch = lastSection.slice(1)
        //   this.listfriend_filter = this.listfriend.filter(friend =>
        //     friend.name.toLowerCase().includes(textToSearch.toLowerCase())
        //   )
        //   this.status_tag = true
        //   // console.log(this.listfriend_filter)
        // } else {
        //   this.status_tag = false
        // }
        var sectionMsg = this.sendmsg.split(' ');
        var lastSection = sectionMsg[sectionMsg.length - 1];
        // console.log(lastSection)
        var isTag = lastSection.charAt(0) === '@';
        // console.log(isTag)
        if (isTag) {
          // var textToSearch = lastSection.slice(1)
          this.text_search = lastSection.slice(1);
          // console.log(this.listfriend)
          this.listfriend_filter = this.listfriend.filter(function (friend) {
            return friend.name.toLowerCase().includes(_this45.text_search.toLowerCase());
          });
          // console.log(textToSearch)
          this.status_tag = true;
        } else {
          this.status_tag = false;
        }
      }
    },
    tagFriend: function tagFriend(nametag) {
      this.status_tag = false;
      if (this.text_search == '') {
        this.sendmsg = this.sendmsg + nametag + " ";
      } else {
        if (nametag.toLowerCase().includes(this.text_search)) {
          // console.log()
          this.sendmsg = this.sendmsg.replace(this.text_search, nametag);
        }
      }

      // this.sendmsg = this.sendmsg + nametag + " "
      this.$refs.textareaChat.focus();
    },
    identifyMentionUsers: function identifyMentionUsers() {
      var _this46 = this;

      this.listfriend.map(function (item) {
        var condition = '^@' + item.name + '|\\s@' + item.name;
        var regex = new RegExp(condition, "g");
        var x = [];
        _this46.mentionUsers = _this46.sendmsg.match(regex);
        x.push(_this46.mentionUser);
        // console.log(x)
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "9ZMR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9bZE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9hKg":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ "9kuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/QrCodeRichMenuDialog.vue
var QrCodeRichMenuDialog = __webpack_require__("0JUz");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47ae7c12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/QrCodeRichMenuDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":"","fullscreen":"","persistent":"","overlay":false,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.dialogQrcodRichMenu),callback:function ($$v) {_vm.dialogQrcodRichMenu=$$v},expression:"dialogQrcodRichMenu"}},[_c('v-card',[_c('v-toolbar',{staticClass:"bg-toolbar"},[_c('v-toolbar-title',{staticClass:"ml-0"},[_vm._v(_vm._s(_vm.$t('Settings.Qrcode.header')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"black","flat":"","icon":"","dark":""},on:{"click":function($event){_vm.toPage()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-tabs',{attrs:{"slot":"extension","fixed-tabs":"","color":"transparent","icons-and-text":"","centered":""},slot:"extension",model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider'),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-1"}},[_vm._v("\n        "+_vm._s(_vm.$t('Settings.Qrcode.myQRcode'))+"\n        "),_c('v-icon',{staticStyle:{"color":"#2562af"}},[_vm._v("fas fa-qrcode")])],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-2"}},[_vm._v("\n        "+_vm._s(_vm.$t('Settings.Qrcode.scanQRcode'))+"\n        "),_c('v-icon',{staticStyle:{"color":"#2562af"}},[_vm._v("mdi-qrcode-scan")])],1)],1),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"overflow-y":"scroll","height":"calc(100vh - 164px)"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{attrs:{"id":"tab-1"}},[_c('v-layout',{staticClass:"mt-3",attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('qrcode',{staticClass:"mt-3",staticStyle:{"width":"180px","height":"180px"},attrs:{"value":_vm.tokenuserQR,"id":"downloadqruser"}}),_vm._v(" "),_c('p',{staticClass:"SettingQrNote ml-4"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.detailQRcode'))+"\n          "),_c('a',{staticClass:"button",attrs:{"href":"#","id":"btn-download-user","download":'qrcode_user_' + _vm.name + '.png'},on:{"click":function($event){_vm.loadqr()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.download')))])])],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[(_vm.alert_message !== 'NotAllowedError')?_c('div',[_c('qrcode-drop-zone',{on:{"decode":_vm.onDecode,"init":_vm.logErrors}},[_c('qrcode-stream',{attrs:{"camera":_vm.camera},on:{"decode":_vm.onDecode,"init":_vm.onInit}},[_c('v-btn',{staticStyle:{"float":"right","margin-top":"40px"},attrs:{"outlined":"","fab":"","small":""},on:{"click":_vm.switchCamera}},[_c('v-icon',{staticStyle:{"color":"#2562af","font-size":"24px"}},[_vm._v("switch_camera")])],1)],1)],1),_vm._v(" "),_c('qrcode-capture',{staticStyle:{"display":"none !important"},attrs:{"multiple":false,"type":"file","name":"image","accept":"image/*","capture":"environment","id":"qrcode-capture-mobile"},on:{"decode":_vm.onDecode}})],1):_c('div',[_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('h4',[_vm._v(_vm._s(_vm.$t('Settings.Qrcode.openCamera')))]),_vm._v(" "),_c('qrcode-capture',{staticStyle:{"display":"none !important"},attrs:{"multiple":false,"type":"file","name":"image","accept":"image/*","capture":"environment","id":"qrcode-capture-mobile"},on:{"decode":_vm.onDecode}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-btn',{staticClass:"btn-upfileqrcode",on:{"click":function($event){_vm.upfileqrcode()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.selectPicture')))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_QrCodeRichMenuDialog = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/QrCodeRichMenuDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("tx5O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47ae7c12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  QrCodeRichMenuDialog["a" /* default */],
  dialog_QrCodeRichMenuDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_QrCodeRichMenuDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9r52":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9x04":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A0Ju":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ACpf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BChE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BUqv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/richmenu/Richmenudialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Richmenudialog = ({
  props: {
    Richmenudialog: false,
    inforrichmenu: {},
    type_richmenu: Number
  },
  data: function data() {
    return {
      // type_richmenu: '6'
      list_menu: []
    };
  },
  created: function created() {
    // console.log(this.inforrichmenu)
    // console.log(this.type_richmenu)
    this.list_menu = this.inforrichmenu;
    // console.log(this.list_menu)
  },

  methods: {
    sendrichmenu: function sendrichmenu(item, index) {
      // console.log(item)
      // console.log(index)
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var hour = String(today.getHours() + 1).padStart(2, '0');
      var minute = String(today.getMinutes()).padStart(2, '0');
      var seconds = String(today.getSeconds()).padStart(2, '0');
      var milsec = today.getMilliseconds();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00';
        dd = String(today.getDate() + 1).padStart(2, '0');
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1';
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1';
            yyyy = today.getFullYear() + 1;
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0');
            // console.log(mm)
          }
        }
      }
      // else {
      //   dd = String(today.getDate()).padStart(2, '0')
      // }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
      // console.log(today)

      this.$emit('emitrichmenu', { infor: this.inforrichmenu[index], expired_date: today });
    }
  },
  watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fdc8d0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/richmenu/Richmenudialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type_richmenu === 1)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs4":"","md4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":item.picture,"aspect-ratio":"1.5","height":"125px"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)})):(_vm.type_richmenu === 2)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs6":"","md6":"","sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":item.picture,"aspect-ratio":"1.5","height":"125px"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)})):(_vm.type_richmenu === 3)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"pa-0",attrs:{"xs12":"","md12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[0].picture,"aspect-ratio":"3","height":"125px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[0], 0)}}})],1)],1),_vm._v(" "),_vm._l((_vm.list_menu),function(item,index){return (index !== 0)?_c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs4":"","md4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":item.picture,"aspect-ratio":"1","height":"125px"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1):_vm._e()})],2):(_vm.type_richmenu === 4)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"pa-0",attrs:{"xs8":"","md8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[0].picture,"aspect-ratio":"1","height":"250px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[0], 0)}}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-0",attrs:{"xs4":"","md4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',[_c('v-layout',{attrs:{"column":""}},_vm._l((_vm.list_menu),function(item,index){return (index !== 0)?_c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs12":"","md12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","height":"125px","src":item.picture,"aspect-ratio":"1"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1):_vm._e()}))],1)],1)],1):(_vm.type_richmenu === 5)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs12":"","md12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","height":"125px","src":item.picture,"aspect-ratio":"3"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)})):(_vm.type_richmenu === 6)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs6":"","md6":"","sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":item.picture,"height":"250px","aspect-ratio":"1.3","cover":""},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)})):(_vm.type_richmenu === 7)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"pa-0",attrs:{"xs12":"","md12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card',{staticClass:"cursor object-fit_fill"},[_c('v-img',{staticClass:"cursor object-fit_fill",attrs:{"cover":"","src":_vm.list_menu[0].picture,"aspect-ratio":"1.5","height":"250px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[0], 0)}}})],1)],1)],1):(_vm.type_richmenu === 8)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs4":"","md4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":item.picture,"aspect-ratio":"1","height":"125px"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)})):(_vm.type_richmenu === 9)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"pa-0",attrs:{"xs4":"","md4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[0].picture,"aspect-ratio":"1","height":"125px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[0], 0)}}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-0",attrs:{"xs8":"","md8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[1].picture,"aspect-ratio":"1","height":"125px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[1], 1)}}})],1)],1)],1):(_vm.type_richmenu === 10)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"pa-0",attrs:{"xs8":"","md8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[0].picture,"aspect-ratio":"1","height":"125px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[0], 0)}}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-0",attrs:{"xs4":"","md4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[1].picture,"aspect-ratio":"1","height":"125px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[1], 1)}}})],1)],1)],1):(_vm.type_richmenu === 11)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{staticClass:"pa-0",attrs:{"xs6":"","md6":"","sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":item.picture,"aspect-ratio":"1.5","height":"125px"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)})):(_vm.type_richmenu === 12)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"pa-0",attrs:{"xs12":"","md12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":_vm.list_menu[0].picture,"aspect-ratio":"3","height":"125px"},on:{"click":function($event){_vm.sendrichmenu(_vm.list_menu[0], 0)}}})],1)],1)],1):(_vm.type_richmenu === 13)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.list_menu),function(item,index){return _c('v-flex',{key:index,staticClass:"pa-0",attrs:{"xs3":"","md3":"","sm3":"","md3":"","lg3":"","xl3":""}},[_c('v-card',[_c('v-img',{staticClass:"cursor",attrs:{"cover":"","src":item.picture,"aspect-ratio":"1.5","height":"125px"},on:{"click":function($event){_vm.sendrichmenu(item, index)}}})],1)],1)})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var richmenu_Richmenudialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/richmenu/Richmenudialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("r8p6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fdc8d0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Richmenudialog,
  richmenu_Richmenudialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_richmenu_Richmenudialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bln8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bn06":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BzMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_pathify__ = __webpack_require__("YtWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("+vOg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import '/static/style/menu.scss'

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    detail: {}
  },
  data: function data() {
    return {
      // shownotes: false,
      // showalbum: false,
      token: '',
      text_project: '',
      show: false,
      listMenu: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
    var me = this;
    $(document).click(function (event) {
      var target = $(event.target);
      if (!target.closest('#headerMenubarUser').length && $('#headerMenubarUser').is(":visible")) {
        me.show = false;
      }
    });
  },

  methods: {
    // check_project_room () {
    //   this.axios.post(process.env.APIpub + '/v1/user/get_project_by_tokenroom', {
    //     tokenuser: this.token,
    //     tokenroom: this.$route.params.roomid
    //   }).then((response) => {
    //     // console.log(response.data)
    //     if (response.data.status === 'success') {
    //       this.text_project = 'ดูโปรเจค'
    //     } else {
    //       this.text_project = 'สร้างโปรเจค'
    //     }
    //   }).catch(error => {
    //     console.log(error.message)
    //     // if (error.message == 'Request failed with status code 404') {
    //     //   this.text_project = 'สร้างโปรเจค'
    //     // }
    //   })
    // },
    unBlock: function unBlock(item) {
      // console.log(item)
      item.tokenroom = this.$route.params.roomid;
      this.show = false;
      this.$emit('unblock', item);
    },
    setListMenu: function setListMenu() {
      this.listMenu = [{
        icon: 'group_add',
        title: this.$t('RightSide.menu.invite'),
        dialog: 'Invite',
        color: 'gray'
      }, {
        icon: 'settings',
        title: this.$t('RightSide.menu.setting'),
        dialog: 'ManageGroup',
        color: 'gray'
      }];
    },
    opentask: function opentask() {
      this.show = false;
      this.$router.push('/chat/room/project/' + this.$route.params.roomid);
    },
    openalbum: function openalbum() {
      this.show = false;
      this.$emit('openalbum', true);
    },
    opennotes: function opennotes() {
      this.show = false;
      this.$emit('opennotes', true);
    },
    blockfriend: function blockfriend(tokenuser, name) {
      this.show = false;
      this.$emit('blockfriend', tokenuser, name);
    },
    openQRcode: function openQRcode() {
      this.show = false;
      this.$emit('openQRcode', true);
    },
    openwallpaper: function openwallpaper() {
      this.show = false;
      this.$emit('openWallpaper', true);
    },
    ShowDialog: function ShowDialog(dialog) {
      this.show = false;
      this.$emit('ShowDialog', dialog);
    },
    leavegroup: function leavegroup() {
      this.show = false;
      this.$emit('leavegroup');
    },
    clearchat: function clearchat() {
      var _this2 = this;

      this.show = false;
      this.$swal({
        text: this.$t('Alert.Right.clearChat'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this2.chIsactive = _this2.$route.params.roomid;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex_pathify__["c" /* sync */])('*')),
  watch: {
    '$i18n.locale': function $i18nLocale() {
      this.setListMenu();
    },
    block_friend: function block_friend(data) {
      // console.log(data)
      if (data.event === 'unblock_friend') {
        this.detail.statemember = 'active';
      } else {
        this.detail.statemember = 'block';
      }
    }
  },
  created: function created() {
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.setListMenu();
    // this.check_project_room()
  },

  components: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "D81q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DJDA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dh98":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-read-more/components/ReadMoreComponent.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ReadMoreComponent = ({
	props: {
		moreStr: {
			type: String,
			default: 'read more'
		},
		lessStr: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			required: true
		},
		link: {
			type: String,
			default: '#'
		},
		maxChars: {
			type: Number,
			default: 100
		}
	},

	data: function data() {
		return {
			isReadMore: false
		};
	},


	computed: {
		formattedString: function formattedString() {
			var val_container = this.text;

			if (!this.isReadMore && this.text.length > this.maxChars) {
				val_container = val_container.substring(0, this.maxChars) + '...';
			}

			return val_container;
		}
	},

	methods: {
		triggerReadMore: function triggerReadMore(e, b) {
			if (this.link == '#') {
				e.preventDefault();
			}
			if (this.lessStr !== null || this.lessStr !== '') this.isReadMore = b;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ca2a6d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-read-more/components/ReadMoreComponent.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.formattedString)}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.text.length > _vm.maxChars),expression:"text.length > maxChars"}]},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isReadMore),expression:"!isReadMore"}],attrs:{"href":_vm.link,"id":"readmore"},on:{"click":function($event){_vm.triggerReadMore($event, true)}}},[_vm._v(_vm._s(_vm.moreStr))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.isReadMore),expression:"isReadMore"}],attrs:{"href":_vm.link,"id":"readmore"},on:{"click":function($event){_vm.triggerReadMore($event, false)}}},[_vm._v(_vm._s(_vm.lessStr))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_ReadMoreComponent = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-read-more/components/ReadMoreComponent.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ReadMoreComponent,
  components_ReadMoreComponent,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_read_more_components_ReadMoreComponent = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dp7v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./src/components/chat/dialog/manage_chat/WebviewBigDialog.vue + 2 modules
var WebviewBigDialog = __webpack_require__("khKU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/task/detail_task_dialog_mo.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var _ = __webpack_require__("M4fF");
/* harmony default export */ var detail_task_dialog_mo = ({
  props: {
    dialogDetailTask: false,
    taskid: '',
    roomid: ''
    // projectid: ''
  },
  components: {
    WebviewBigDialog: WebviewBigDialog["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      Webview_item: {},
      dialogWebviewbig: false,
      projectid: '',
      infor_task: {},
      edit: false,
      detail_task: '',
      token: '',
      subject_task: '',
      menu1: false,
      menu2: false,
      start_date: '',
      end_date: '',
      priority: null,
      member: [],
      selectemember: [],
      isloading: false,
      state: [],
      state_id: ''
    }, defineProperty_default()(_ref, 'member', []), defineProperty_default()(_ref, 'old_state', ''), defineProperty_default()(_ref, 'min_date', ''), defineProperty_default()(_ref, 'max_date', ''), defineProperty_default()(_ref, 'min_date_end', ''), defineProperty_default()(_ref, 'profilepicture', ''), defineProperty_default()(_ref, 'nickname', ''), defineProperty_default()(_ref, 'state_name', ''), defineProperty_default()(_ref, 'progress', false), defineProperty_default()(_ref, 'listcomment', []), defineProperty_default()(_ref, 'comment_task', ''), _ref;
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },
  mounted: function mounted() {},

  methods: {
    get_comment: function get_comment() {
      var _this = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_comment_by_id', {
        tokenuser: this.token,
        task_id: this.taskid
      }).then(function (response) {
        // console.log(response.data.data)
        if (response.data.status == 'success') {
          _this.listcomment = response.data.data;
          _this.listcomment = _.reverse(_.sortBy(_this.listcomment, function (dateObj) {
            return new Date(dateObj.timestamp);
          }));
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    add_comment: function add_comment() {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/comment_task', {
        tokenuser: this.token,
        task_id: this.taskid,
        comment: this.comment_task
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data.data)
          _this2.listcomment.unshift(response.data.data);
          _this2.$swal('', _this2.$t('Alert.Success.createComment'), 'success');
          _this2.comment_task = '';
          _this2.$emit('commenttask', { 'task_id': _this2.taskid, 'count_comment': _this2.listcomment.length, 'state_id': _this2.state_id, 'project_id': _this2.projectid });
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    delete_commemt: function delete_commemt(commentid) {
      var _this3 = this;

      this.$swal({
        text: this.$t('Alert.Task.removeComment'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this3.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/delete_comment', {
            tokenuser: _this3.token,
            comment_id: commentid
          }).then(function (response) {
            if (response.data.status === 'success') {
              var index = '';
              index = _.findIndex(_this3.listcomment, function (o) {
                return o.comment_id == commentid;
              });
              _this3.listcomment.splice(index, 1);
              _this3.$swal('', _this3.$t('Alert.Success.removeComment'), 'success');
              _this3.$emit('commenttask', { 'task_id': _this3.taskid, 'count_comment': _this3.listcomment.length, 'state_id': _this3.state_id, 'project_id': _this3.projectid });
            }
          }).catch(function (error) {
            console.log(error.message);
          });
        }
      });
    },
    sign_doc: function sign_doc(item) {
      // console.log(item)
      if (item.type == 'webview') {
        this.Webview_item = item;
        this.dialogWebviewbig = true;
        this.closeDialog();
      } else if (item.type == 'link') {
        window.open(item.url, '_blank');
      }
    },
    formatDate: function formatDate(input) {
      if (input.match(/\d+/g) !== null && input.match(/\d+/g) !== 'null') {
        var datePart = input.match(/\d+/g),
            year = datePart[0].substring(2),
            // get only two digits
        month = datePart[1],
            day = datePart[2];

        return day + '/' + month + '/' + year;
      } else {
        return '-';
      }
    },
    closeWebview: function closeWebview(value) {
      this.dialogWebviewbig = value;
    },
    allowedDates: function allowedDates(val) {
      this.min_date_end = this.start_date;
      if (this.start_date > this.end_date) {
        this.end_date = this.start_date;
      }
      return this.min_date_end;
    },
    allowedDatesEnd: function allowedDatesEnd(val) {
      this.min_date_end = this.start_date;
      if (this.min_date_end > this.end_date) {
        this.end_date = this.min_date_end;
      }
      return this.end_date;
    },
    closeDialog: function closeDialog() {
      this.selectemember = [];
      this.detail_task = '';
      this.subject_task = '';
      this.edit = false;
      this.state_id = '';
      this.$emit('closeDetailTask', false);
    },
    cancel_task: function cancel_task() {
      this.start_date = this.infor_task.time_start.split(' ')[0];
      this.end_date = this.infor_task.time_end.split(' ')[0];
      this.edit = false;
      this.isloading = false;
    },
    edit_task: function edit_task() {
      var _this4 = this;

      // var today = new Date();
      // var time = today.getHours() + "00:00:00" + today.getMinutes() + ":" + today.getSeconds();
      var time = "00:00:00.00";
      this.isloading = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/edit_task', {
        tokenuser: this.token,
        tokenroom: this.roomid,
        title: this.subject_task,
        detail: this.detail_task,
        state_id: this.state_id,
        time_start: this.start_date + ' ' + time,
        time_end: this.end_date + ' ' + time,
        priority: this.priority,
        project_id: this.projectid,
        assign: this.selectemember,
        task_id: this.taskid
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this4.isloading = false;
          _this4.$swal('', _this4.$t('Alert.Success.editTask'), 'success');
          _this4.$emit('edittask', { 'task_id': _this4.taskid, 'state_id': _this4.state_id, 'event': 'edit', 'old_state': _this4.old_state });
          _this4.closeDialog();
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    delete_task: function delete_task() {
      var _this5 = this;

      this.$swal({
        text: this.$t('Alert.Task.remove'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this5.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/delete_task', {
            tokenuser: _this5.token,
            tokenroom: _this5.roomid,
            list_task_id: [_this5.taskid]
          }).then(function (response) {
            if (response.data.status === 'success') {
              // console.log(response.data.data)
              // console.log(this.taskid)
              _this5.isloading = false;
              _this5.$swal('', _this5.$t('Alert.Success.removeTask'), 'success');
              _this5.$emit('deletetask', { 'task_id': _this5.taskid, 'state_id': _this5.old_state, 'event': 'delete', 'project_id': _this5.projectid });
              _this5.closeDialog();
            }
          }).catch(function (error) {
            console.log(error.message);
          });
        }
      });
    },
    get_member: function get_member() {
      var _this6 = this;

      // console.log(this.roomid)
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.roomid
      }).then(function (response) {
        if (response.data.status === 'success') {
          var member_active = [];
          member_active = response.data.data_room;
          _this6.member = _.filter(member_active, function (o) {
            return o.type !== 'bot' && o.type !== 'business' && o.statemember == 'active';
          });
          _this6.member.push({
            tokenuser: _this6.token,
            name: localStorage.getItem('name'),
            profilepicture: localStorage.getItem('profilepicture')
          });
          // intersection เพราะเวลาที่มีคนออกจากกลุ่มแล้วทำให้แก้ไข task ไม่ได้
          _this6.selectemember = _.map(_.intersectionBy(_this6.member, _this6.infor_task.assign, 'tokenuser'), 'tokenuser');
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    getstate: function getstate() {
      var _this7 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_state_by_project', {
        tokenuser: this.token,
        tokenroom: this.roomid,
        project_id: this.projectid
      }).then(function (response) {
        _this7.state = response.data.data.state;
        // this.state_id = response.data.data.state[0].state_id
      }).catch(function (error) {
        console.log(error.message);
      });
    }
  },
  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.date);
    }
  },
  watch: {
    selectemember: function selectemember() {
      // console.log(this.selectemember)
    },
    state_id: function state_id() {
      // console.log(this.state_id)
    },
    dialogDetailTask: function dialogDetailTask() {
      var _this8 = this;

      // this.infor_task = {}
      if (this.dialogDetailTask) {
        this.progress = true;
        this.infor_task = {};
        this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_by_id', {
          tokenuser: this.token,
          task_id: this.taskid
        }).then(function (response) {
          // console.log(response.data.data)
          if (response.data.status === 'success') {
            _this8.progress = false;
            _this8.infor_task = response.data.data;
            // console.log(this.infor_task.assign)
            _this8.old_state = _this8.infor_task.state.id;
            _this8.state_id = _this8.infor_task.state.id;
            _this8.projectid = _this8.infor_task.project_id;
            _this8.subject_task = _this8.infor_task.title;
            _this8.priority = _this8.infor_task.priority;
            _this8.start_date = _this8.infor_task.time_start.split(' ')[0];
            _this8.end_date = _this8.infor_task.time_end.split(' ')[0];
            _this8.detail_task = _this8.infor_task.detail;
            _this8.profilepicture = _this8.infor_task.owner_info.path_pic;
            _this8.nickname = _this8.infor_task.owner_info.nickname;
            _this8.state_name = _this8.infor_task.state.name;
            // this.selectemember = _.map(this.infor_task.assign, 'tokenuser')
            _this8.getstate();
            _this8.get_member();
            _this8.get_comment();
          }
        }).catch(function (error) {
          console.log(error.message);
          console.log(error.response.data.message);
          if (error.response.data.message == 'Not found task.') {
            _this8.progress = false;
            _this8.dialogDetailTask = false;
            _this8.closeDialog();
            _this8.$swal('', _this8.$t('Alert.Fail.Task.removed'), 'warning');
          }
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad74f7d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/task/detail_task_dialog_mo.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"CSChatThai",staticStyle:{"overflow-y":"hidden","border-radius":"15px"},attrs:{"persistent":"","max-width":"550"},model:{value:(_vm.dialogDetailTask),callback:function ($$v) {_vm.dialogDetailTask=$$v},expression:"dialogDetailTask"}},[_c('v-card',[_c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-toolbar',{staticClass:"toolbar-card-v2",attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"CSChatThai"},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.detail.header')))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.edit)?_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","flat":""},slot:"activator"},[_c('v-icon',{staticStyle:{"color":"black !important","font-size":"20px !important"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.edit = !_vm.edit}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('Task.detail.menu.edit')))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.delete_task()}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('Task.detail.menu.delete')))])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"black !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),(_vm.edit)?_c('v-card-text',{staticStyle:{"overflow-y":"scroll","height":"70vh"}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.subject'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject_task),expression:"subject_task"}],staticClass:"CSChatThai inputtaskweb",attrs:{"type":"text","placeholder":_vm.$t('Task.create.placeholderSubject')},domProps:{"value":(_vm.subject_task)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject_task=$event.target.value}}})]),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.priority'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-btn',{class:(_vm.priority=='1')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '1';}}},[_c('v-icon',{staticClass:"btn-pri1"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p1'))+"\n              ")],1),_vm._v(" "),_c('v-btn',{class:(_vm.priority=='2')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '2';}}},[_c('v-icon',{staticClass:"btn-pri2"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p2'))+"\n              ")],1),_vm._v(" "),_c('v-btn',{class:(_vm.priority=='3')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '3';}}},[_c('v-icon',{staticClass:"btn-pri3"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p3'))+"\n              ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.startDate'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-menu',{ref:"menu1",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.start_date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":""},on:{"update:returnValue":function($event){_vm.start_date=$event}},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"","readonly":""},slot:"activator",model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","allowed-dates":_vm.allowedDates},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu1 = false}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menu1.save(_vm.start_date)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.endDate'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-menu',{ref:"menu2",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.end_date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":""},on:{"update:returnValue":function($event){_vm.end_date=$event}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"","readonly":""},slot:"activator",model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","allowed-dates":_vm.allowedDatesEnd,"min":_vm.min_date_end},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu2 = false}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menu2.save(_vm.end_date)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.description'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-textarea',{staticStyle:{"width":"75%"},attrs:{"label":_vm.$t('Task.create.placeholderDescription'),"solo":"","no-resize":"","outline":"","height":"80","rows":"3","hide-details":""},model:{value:(_vm.detail_task),callback:function ($$v) {_vm.detail_task=$$v},expression:"detail_task"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.assign'))+" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-autocomplete',{staticStyle:{"width":"75%"},attrs:{"items":_vm.member,"label":_vm.$t('Task.create.placeholderAssign'),"item-text":"name","item-value":"tokenuser","multiple":"","chips":"","menu-props":{maxHeight:'auto'}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [(data.item.type !== 'bot')?_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selectemember,"close":""},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_c('v-avatar',[(data.item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":data.item.profilepicture}}):(data.item.type === 'company')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'government')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('span',{staticClass:"text-overflow-chip"},[_vm._v(_vm._s(data.item.name))])],1):_vm._e()]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[(data.item.type !== 'bot')?_c('v-list-tile-avatar',[(data.item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":data.item.profilepicture}}):(data.item.type === 'company')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'government')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[(data.item.type !== 'bot')?_c('v-list-tile-title',{staticClass:"text-overflow"},[_vm._v(_vm._s(data.item.name))]):_vm._e()],1)]]}}]),model:{value:(_vm.selectemember),callback:function ($$v) {_vm.selectemember=$$v},expression:"selectemember"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.status'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-select',{staticStyle:{"padding":"0","width":"100%"},attrs:{"items":_vm.state,"outlined":"","hide-details":"","item-text":"name","item-value":"state_id"},model:{value:(_vm.state_id),callback:function ($$v) {_vm.state_id=$$v},expression:"state_id"}})],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"margin-top":"15px"},attrs:{"row":"","wrap":"","align-end":"","justify-center":""}},[_c('v-btn',{staticClass:"btncancle",on:{"click":function($event){_vm.cancel_task()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"btncreate",attrs:{"loading":_vm.isloading,"disabled":_vm.subject_task == '' || _vm.priority == undefined || _vm.start_date == '' || _vm.end_date == ''},on:{"click":function($event){_vm.edit_task()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.keep')))])],1)],1):_c('v-card-text',{staticClass:"CSChatThai",staticStyle:{"overflow-y":"scroll","height":"70vh"}},[(_vm.progress)?_c('v-layout',{staticStyle:{"height":"100% !important"},attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":"100","color":"primary","indeterminate":_vm.progress}})],1):_c('v-layout',{staticClass:"mb-2",attrs:{"column":"","wrap":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm1":""}},[_c('v-icon',{class:'btn-pri'+ _vm.priority,staticStyle:{"padding-top":"10px"}},[_vm._v("mdi-checkbox-blank")])],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","sm11":"","xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","xs12":""}},[_c('h3',{staticStyle:{"color":"#003459"}},[_vm._v(_vm._s(_vm.infor_task.title))])]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","xs12":""}},[_c('v-chip',{staticClass:"ma-2",staticStyle:{"margin":"0 !important","background":"#e6ecf3 !important","color":"#51819e !important","font-weight":"700"},attrs:{"label":"","text-color":"white","small":""}},[_vm._v("\n                  "+_vm._s(_vm.state_name)+"\n                ")]),_vm._v(" "),(_vm.start_date || _vm.end_date)?_c('span',{staticClass:"mb-0",staticStyle:{"font-size":"12px","color":"#a6a6a6"}},[_vm._v(_vm._s(_vm.formatDate(_vm.start_date))+" "),(_vm.start_date && _vm.end_date)?_c('span',[_vm._v(" - ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.formatDate(_vm.end_date))+"\n                ")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),(_vm.infor_task.detail)?_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"sm12":"","md12":"","xl12":"","lg12":""}},[_c('div',{staticClass:"descriptionTask"},[_c('read-more',{staticClass:"mb-0 font-size-15",attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.infor_task.detail ? _vm.infor_task.detail: '-',"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":100}}),_vm._v(" "),(_vm.infor_task.sign_info != undefined)?_c('v-btn',{staticClass:"btn-sign-doc",attrs:{"small":""},on:{"click":function($event){_vm.sign_doc(_vm.infor_task.sign_info)}}},[_vm._v(_vm._s(_vm.infor_task.sign_info.label))]):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"textSubjectDetail",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',{staticClass:"font-size-15"},[_vm._v(_vm._s(_vm.$t('Task.detail.createBy'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px !important"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-chip',{staticStyle:{"background":"#e6ecf3 !important"}},[_c('v-avatar',[(_vm.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":_vm.profilepicture}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('span',{staticClass:"text-overflow-chip"},[_vm._v("\n              "+_vm._s(_vm.nickname)+"\n            ")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubjectDetail",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',{staticClass:"font-size-15"},[_vm._v(_vm._s(_vm.$t('Task.create.assign'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px !important"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},_vm._l((_vm.infor_task.assign),function(item,index){return _c('v-chip',{staticStyle:{"background":"#e6ecf3 !important"}},[_c('v-avatar',{staticClass:"teal"},[(item.path_pic)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.path_pic}}):(item.type == 'user')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}}):(item.type == 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('span',{staticClass:"text-overflow-chip"},[_vm._v("\n              "+_vm._s(item.nickname)+"\n            ")])],1)})),_vm._v(" "),_c('v-flex',{staticClass:"textSubjectDetail",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',{staticClass:"font-size-16"},[_vm._v(_vm._s(_vm.$t('Task.create.comment'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px !important"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-layout',{staticClass:"mb-2",attrs:{"row":"","wrap":"","align-center":"","justify-end":""}},[_c('v-textarea',{staticStyle:{"width":"75%","margin-right":"10px"},attrs:{"label":_vm.$t('Task.create.placeholderComment'),"solo":"","no-resize":"","outline":"","height":"80","rows":"3","hide-details":""},model:{value:(_vm.comment_task),callback:function ($$v) {_vm.comment_task=$$v},expression:"comment_task"}}),_vm._v(" "),_c('v-btn',{staticClass:"btncreate-comment",attrs:{"disabled":_vm.comment_task == ''},on:{"click":function($event){_vm.add_comment()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.keep')))])],1),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":""}},_vm._l((_vm.listcomment),function(item,index){return _c('v-card',{staticClass:"card-comment"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-3 ml-2",attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}},[_c('v-avatar',{attrs:{"size":"40px"}},[(item.path_pic)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.path_pic,"alt":"alt"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png","alt":"alt"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"ml-3",staticStyle:{"width":"100px"}},[_c('div',{staticClass:"text-overflow-comment"},[_vm._v(_vm._s(item.nickname))]),_vm._v(" "),_c('read-more',{staticClass:"mb-0 mr-5",staticStyle:{"width":"160px !important"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":item.comment,"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":80}})],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":"","xl2":"","lg2":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","color":"black","icon":"","flat":""},on:{"click":function($event){_vm.delete_commemt(item.comment_id)}},slot:"activator"},[_c('v-icon',{staticStyle:{"color":"rgba(0,0,0,.87)","font-size":"16px"}},[_vm._v("fas fa-trash")])],1)],1)],1)],1)}))],1)],1)],1),_vm._v(" "),_c('WebviewBigDialog',{attrs:{"dialogWebviewbig":_vm.dialogWebviewbig,"Webview_item":_vm.Webview_item},on:{"closeWebview":_vm.closeWebview}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var task_detail_task_dialog_mo = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/task/detail_task_dialog_mo.vue
function injectStyle (ssrContext) {
  __webpack_require__("Q6Iw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad74f7d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  detail_task_dialog_mo,
  task_detail_task_dialog_mo,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_task_detail_task_dialog_mo = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DyZE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E/iq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/ReadmoreDialogMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ReadmoreDialogMobile = ({
  props: {
    dialogReadmore: Boolean,
    detailReadmore: {}
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeReadmoreDialog', false);
    },
    convert: function convert(msg) {
      var linkifyStr = __webpack_require__("nN35");
      var str = msg;
      var processedContent = linkifyStr(str);
      var regex = /\s|<tax>+[\u0E00-\u0E7Fa-zA-Z'|/^\S+@\S+\.\S+$/]+<\/tax>/g;
      // var word = msg.match(regex)
      // console.log(word)
      if (msg.match(regex)) {
        for (var i = 0; i < msg.match(regex).length; i++) {
          // var word = msg.match(regex)
          // @click.native.capture=method
          processedContent = processedContent.replace('&lt;tax&gt;', '<b style="color:#1976d2; cursor:pointer;" >@');
          processedContent = processedContent.replace('&lt;/tax&gt;', '</b>');
        }
      }
      return processedContent;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e23dbb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/ReadmoreDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"border-radius":"20px"},attrs:{"persistent":"","scrollable":"","max-width":"300px"},model:{value:(_vm.dialogReadmore),callback:function ($$v) {_vm.dialogReadmore=$$v},expression:"dialogReadmore"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('h2',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Read.readmore')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"300px","overflow-y":"scroll"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.convert(_vm.detailReadmore.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.closeDialog()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_ReadmoreDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/ReadmoreDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("MnUx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e23dbb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ReadmoreDialogMobile,
  dialog_ReadmoreDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_ReadmoreDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E14g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EH9F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EQ18":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EhHL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ep6q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_homepage_Navbar__ = __webpack_require__("6n5U");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _ = __webpack_require__("M4fF");
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__components_homepage_Navbar__["a" /* default */]
  },
  data: function data() {
    return {
      dragAndDropCapable: false,
      phone: '',
      name: '',
      email: '',
      title: {},
      detail: '',
      items: [],
      files: [],
      filesmo: [],
      borderinputfile: 'border: 1px solid #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;',
      phoneRules: [function (v) {
        return !!v && v.length === 10 || 'กรุณากรอกหมายเลขโทรศัพท์ของคุณจำนวน 10 หลัก';
      }, function (v) {
        return !!v || 'กรุณากรอกข้อมูลเป็นตัวเลข';
      }, function (v) {
        return (/^0[0-9]{9}/.test(v) || 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง'
        );
      }],
      emailRules: [function (v) {
        return !!v || 'กรุณากรอกอีเมล';
      }, function (v) {
        return !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'รูปแบบอีเมลไม่ถูกต้อง';
      }],
      webdev: "https://uatchat.one.th:8089/docs"
      // dragAndDropCapable: false,
      // dragAndDropCapablemo: false
      // list_category: []
      // items: [
      //   { icon: 'phone', title: 'โทรศัพท์ : 0-2257-7000' },
      //   { title: 'โทรสาร : 0-2257-1379' },
      //   { title: 'ศูนย์บริการลูกค้า : 0-2257-7269' },
      //   { icon: 'email', title: 'one-platform@inet.co.th' }
      // ]
    };
  },
  created: function created() {
    this.getsubject();
  },

  watch: {
    files: function files() {
      if (this.files.length > 5) {
        this.$swal('', 'เลือกรูปภาพได้สูงสุด 5 รูป.', 'warning');
        _.pullAt(this.files, [5]);
      }
    },
    filesmo: function filesmo() {
      if (this.filesmo.length > 5) {
        this.$swal('', 'เลือกรูปภาพได้สูงสุด 5 รูป.', 'warning');
        _.pullAt(this.filesmo, [5]);
      }
    }
  },
  mounted: function mounted() {
    this.dragAndDropCapable = this.determineDragAndDropCapable();
    var me = this;
    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
        this.$refs.fileform.addEventListener(evt, function (e) {
          // console.log(evt)
          e.preventDefault();
          e.stopPropagation();
        });
      }.bind(this));
      this.$refs.fileform.addEventListener('dragover', function (e) {
        this.borderinputfile = 'border: 2px dotted #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;';
      }.bind(this));
      this.$refs.fileform.addEventListener('dragleave', function (e) {
        this.borderinputfile = 'border: 1px solid #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;';
      }.bind(this));
      this.$refs.fileform.addEventListener('drop', function (e) {
        for (var i = 0; i < e.dataTransfer.files.length; i++) {
          this.files.push({ file: e.dataTransfer.files[i], status: 'waiting' });
          this.getImagePreviews();
          // if ( e.target.className == "borderfile" ) {
          this.borderinputfile = 'border: 1px solid #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;';
          // }
        }
      }.bind(this));
    }
  },

  methods: {
    uppic: function uppic() {
      $('#files').click();
    },
    uppicmo: function uppicmo() {
      $('#filesmo').click();
    },
    sendfeedback: function sendfeedback() {
      var _this = this;

      var lengthfile = this.files.length;
      if (lengthfile === 0) {
        var formData = new FormData();
        formData.append('phone', this.phone);
        formData.append('email', this.email);
        formData.append('comment', this.detail);
        formData.append('name', this.name);
        formData.append('category_id', this.title.category_id);
        this.axios.post("https://uatchat-manage.one.th/manage" + '/feedbackcategory', formData).then(function (response) {
          // console.log(response.data)
          _this.$swal('', 'ส่งข้อความถึงเราสำเร็จ', 'success');
          _this.cancel();
        }, function () {
          _this.$swal('', 'ไม่สามารถส่งข้อความได้ กรุณาลองใหม่ภายหลัง', 'error');
        });
      } else {
        this.sendfeedbackfile();
        // for (var i = 0; i < lengthfile; i++) {
        //   this.sendfeedbackfile(i)
        // }
      }
    },
    sendfeedbackmo: function sendfeedbackmo() {
      var _this2 = this;

      var lengthfile = this.filesmo.length;
      if (lengthfile === 0) {
        var formData = new FormData();
        formData.append('phone', this.phone);
        formData.append('email', this.email);
        formData.append('comment', this.detail);
        formData.append('name', this.name);
        formData.append('category_id', this.title.category_id);
        this.axios.post("https://uatchat-manage.one.th/manage" + '/feedbackcategory', formData).then(function (response) {
          // console.log(response.data)
          _this2.$swal('', 'ส่งข้อความถึงเราสำเร็จ', 'success');
          _this2.cancel();
        }, function () {
          _this2.$swal('', 'ไม่สามารถส่งข้อความได้ กรุณาลองใหม่ภายหลัง', 'error');
        });
      } else {
        this.sendfeedbackfilemo();
        // for (var i = 0; i < lengthfile; i++) {
        //   this.sendfeedbackfile(i)
        // }
      }
    },
    sendfeedbackfile: function sendfeedbackfile() {
      var _this3 = this;

      var formData = new FormData();
      var lengthfile = this.files.length;
      for (var i = 0; i < lengthfile; i++) {
        var file = this.files[i].file;
        formData.append('file', file, file.name);
      }
      // console.log(formData)
      formData.append('phone', this.phone);
      formData.append('email', this.email);
      formData.append('comment', this.detail);
      formData.append('name', this.name);
      formData.append('category_id', this.title.category_id);
      this.axios.post("https://uatchat-manage.one.th/manage" + '/feedbackcategory', formData).then(function (response) {
        // console.log(response.data)
        _this3.$swal('', 'ส่งข้อความถึงเราสำเร็จ', 'success');
        _this3.cancel();
      }, function () {
        _this3.$swal('', 'ไม่สามารถส่งข้อความได้ กรุณาลองใหม่ภายหลัง', 'error');
      });
    },
    sendfeedbackfilemo: function sendfeedbackfilemo() {
      var _this4 = this;

      var formData = new FormData();
      var lengthfile = this.filesmo.length;
      for (var i = 0; i < lengthfile; i++) {
        var file = this.filesmo[i].file;
        formData.append('file', file, file.name);
      }
      // console.log(formData)
      formData.append('phone', this.phone);
      formData.append('email', this.email);
      formData.append('comment', this.detail);
      formData.append('name', this.name);
      formData.append('category_id', this.title.category_id);
      this.axios.post("https://uatchat-manage.one.th/manage" + '/feedbackcategory', formData).then(function (response) {
        // console.log(response.data)
        _this4.$swal('', 'ส่งข้อความถึงเราสำเร็จ', 'success');
        _this4.cancel();
      }, function () {
        _this4.$swal('', 'ไม่สามารถส่งข้อความได้ กรุณาลองใหม่ภายหลัง', 'error');
      });
    },
    removeFile: function removeFile(key) {
      this.files.splice(key, 1);
      this.getImagePreviews(key);
    },
    removeFilemo: function removeFilemo(key) {
      this.filesmo.splice(key, 1);
      this.getImagePreviewsmo(key);
    },
    getImagePreviews: function getImagePreviews(key) {
      var _this5 = this;

      var _loop = function _loop(i) {
        if (/\.(jpe?g|png|gif)$/i.test(_this5.files[i].file.name)) {
          var reader = new FileReader();
          reader.addEventListener('load', function () {
            this.$refs['preview' + parseInt(i)][0].src = reader.result;
          }.bind(_this5), false);
          reader.readAsDataURL(_this5.files[i].file);
        } else {}
      };

      for (var i = 0; i < this.files.length; i++) {
        _loop(i);
      }
    },
    getImagePreviewsmo: function getImagePreviewsmo(key) {
      var _this6 = this;

      var _loop2 = function _loop2(i) {
        if (/\.(jpe?g|png|gif)$/i.test(_this6.filesmo[i].file.name)) {
          var reader = new FileReader();
          reader.addEventListener('load', function () {
            this.$refs['preview' + parseInt(i)][0].src = reader.result;
          }.bind(_this6), false);
          reader.readAsDataURL(_this6.filesmo[i].file);
          // this.extension(this.files[i].name)
          // console.log(this.extension())
        } else {
            // this.$nextTick(function(){
            // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
            // });
            // console.log('mm')
          }
      };

      for (var i = 0; i < this.filesmo.length; i++) {
        _loop2(i);
      }
    },
    extension: function extension(files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase();
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
      var pdf = ['pdf'];
      var file = ['ai', 'ps', 'psd'];
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm'];
      var presentation = ['ppt', 'pps', 'pot', 'pptx'];
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff'];
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf';
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive';
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel';
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint';
      } else if (word.includes(extension)) {
        return 'fas fa-file-word';
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code';
      } else if (image.includes(extension)) {
        return 'fas fa-file-image';
      } else if (file.includes(extension)) {
        return 'fas fa-file';
      } else {
        return 'fas fa-file-alt';
      }
      // return extension[extension.length-1]
    },
    determineDragAndDropCapable: function determineDragAndDropCapable() {
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
    },
    handleFilesUpload: function handleFilesUpload(key) {
      var uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({ file: uploadedFiles[i], status: 'waiting' });
      }
      this.getImagePreviews(key);
      document.querySelector('#files').value = '';
    },
    handleFilesUploadmo: function handleFilesUploadmo(key) {
      var uploadedFiles = this.$refs.filesmo.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.filesmo.push({ file: uploadedFiles[i], status: 'waiting' });
      }
      this.getImagePreviewsmo(key);
      document.querySelector('#filesmo').value = '';
    },
    getsubject: function getsubject() {
      var _this7 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getcategory').then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          _this7.items = response.data;
        }
      });
    },
    cancel: function cancel() {
      this.phone = '';
      this.name = '';
      this.email = '';
      this.title = {};
      this.detail = '';
      this.files = [];
      this.filesmo = [];
    },
    clear: function clear() {
      var _this8 = this;

      if (this.name !== '' || this.email !== '' || this.title.category_TH || this.detail !== '') {
        this.$swal({
          title: 'คุณแน่ใจหรือไหม?',
          text: 'เรากำลังลบข้อมูลทั้งหมด ที่คุณกรอก',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'ใช่, ดำเนินการต่อ!',
          cancelButtonText: 'ไม่',
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-success',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then(function (result) {
          if (result.value) {
            _this8.cancel();
          }
        });
      }
    },
    sendme: function sendme() {
      var _this9 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/contactus', { name: this.name, email: this.email, title: this.title.category_TH, detail: this.detail, platform: 'webportal' }).then(function (response) {
        if (response.data.status === 'success') {
          _this9.$swal('ส่งข้อความถึงเรา', 'ส่งข้อความถึงเราสำเร็จ.', 'success');
          _this9.cancel();
        }
      }, function (response) {});
    },
    linkAPI: function linkAPI() {
      window.open('/docs', '_blank').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    linkregister: function linkregister() {
      window.open('/register').focus();
    },
    linkdownload: function linkdownload() {
      window.open('/download').focus();
    },
    toNewTab: function toNewTab() {
      window.open(this.webdev, '_blank').focus();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "Ez+3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F4Xa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F8NA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/consent/new_consent.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var new_consent = ({
    props: {
        newConsentDialog: Boolean,
        newConsentDetail: Object
    },
    data: function data() {
        return {
            dialog: true,
            checkbox: false,
            publicPath: Object({"NODE_ENV":"uat","API":"https://uatchat.one.th","APIQRcode":"https://uatchat.one.th","APIpub":"https://uatchat-manage.one.th/event","APIimage":"https://uatchat-manage.one.th/message","APIsocket":"https://uatchat-public.one.th:8998","APImanage":"https://uatchat-manage.one.th/manage","ONEID_API":"https://testoneid.inet.co.th/api","WEBchatdev":"https://uatchat.one.th:8089/docs","Bot_idPaperless":"B0df132b88f9a526691a0576bfdb24196","Bot_idcovid":"Bbe2c9fe1bcc956738a61c9ad0d91cb19","taxid_consent":"0107544000094","serviceid_consent":"SVC-1611218040238","formid_consent":"600956682f8678001cce54e8","AuthenOneid":"https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect","LogoutOneid":"https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage","redirect_url":"https://uatchat.one.th/authorization/redirect","Market_env":"staging","APInew_listchat":"https://uatchat-manage.one.th/go_api/api/v4/getListChat","APInew_getdict":"https://uatchat-manage.one.th/alpine/api/v1/getdictmessage","APInew_pushmessage":"https://uatchat-manage.one.th/alpine/api/v1/pushMessage","APInew_getaccesstoken":"https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken","APInew_getrichmenu":"https://uatchat-manage.one.th/go_api/api/v1/getRichmenuByTokenroom","APInew_addfriend":"https://uatchat-manage.one.th/go_api/api/v1/add-friend","APIcheck_consent":"https://uatapigw.appsdigit.inet.co.th/api/chat/service/check-consent","APInew_pushvideo":"https://uatchat-manage.one.th/media/api/v1/send-video","APInew_acceptfriend":"https://uatchat-manage.one.th/go_api/api/v1/accept-friend","APInew_creategroup":"https://uatchat-manage.one.th/go_api/api/v1/create-group","APIalpine":"https://uatchat-manage.one.th/alpine","APIgo_api":"https://uatchat-manage.one.th/go_api/api","WEBoneEmail":"https://testoneid.inet.co.th/preauth","WEBoneBox":"https://testoneid.inet.co.th/oauth/authorize?client_id=155&response_type=code&scope=account","WEBNews":"https://news.chat.korkla.in/checkauthen?authen=","WEB_Redirect_Onebox":"https://uatbox.one.th/loginbysharetoken?token=","WebAnonymous":"https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token=","Savelognews":"https://news.chat.one.th/backend/api/v1/page-analytics","urlEkyc":"https://uat-ekyc.id.th/redirect-share-token?shared_token=","linkonemeet":"https://meet-test.one.th/?sharetoken=","API_onemeet":"https://meet-test.one.th/","WEB_centrifuge":"wss://uatchat-manage.one.th/connection/websocket","centrifuge_key":'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs',"APIsearchfriend":"https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend","urlLoa":"https://testoneid.inet.co.th/login?redirect_url=https://testoneid.inet.co.th/portal_level&shared_token=","check_password":"https://uatchat-manage.one.th/bot-message/check"}).VUE_APP_BASE_PATH,
            url_new_consent: '/static/consent/OneCentric_Policy.pdf',
            // url_new_consent: ``,
            innerWidth: 0
        };
    },

    watch: {
        newConsentDialog: function newConsentDialog() {
            if (this.newConsentDialog) {
                this.innerWidth = window.innerWidth;
                // console.log(this.newConsentDetail);
            }
        }
    },
    methods: {
        close: function close() {
            this.$cookie.set('check-consent-' + this.newConsentDetail.token, true);
            this.$emit('closeNewConsent', { token: this.newConsentDetail.token, close: false });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e346040c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/consent/new_consent.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":_vm.innerWidth <= 960 ? '100%': '60%'},model:{value:(_vm.newConsentDialog),callback:function ($$v) {_vm.newConsentDialog=$$v},expression:"newConsentDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-h5 grey lighten-2",staticStyle:{"font-size":"18px","font-weight":"600"}},[_vm._v("\n                นโยบายความคุ้มครองข้อมูลส่วนบุคคล\n            ")]),_vm._v(" "),_c('v-card-text',{staticClass:"overflow-scrolling",staticStyle:{"height":"60vh"}},[_c('v-row',{staticClass:"justify-center align-center"},[_c('v-col',{attrs:{"cols":"12","align":"center"}},[_c('h3',[_vm._v("บริษัท วัน เช็นทริค จำกัด")])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","align":"center"}},[_c('h3',[_vm._v("One Centric Company Limited.")]),_vm._v(" "),_c('v-divider',{staticClass:"ma-2"})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","align":"center"}},[_c('h4',[_vm._v("ประกาศที่ 1/2566")])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","align":"center"}},[_c('h4',[_vm._v("เรื่อง “นโยบายการคุ้มครองข้อมูลส่วนบุคคลสำหรับลูกค้าและผู้ใช้บริการ\n                            (Data Protection Policy for Customers and Clients)”")]),_vm._v(" "),_c('p',[_vm._v("-------------------------------------------------------------------------------")])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","align":"start"}},[_c('p',[_vm._v("        บริษัท วัน เซ็นทริค จำกัด บริษัทใหญ่\n                            บริษัทย่อย บริษัทร่วม บริษัท\n                            ในเครือกิจการและเครือธุรกิจเดียวกัน (“บริษัท”) มีความมุ่งมั่นที่จะดำเนิน\n                            การตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 กฎหมาย\n                            ลำดับรอง ประกาศ ระเบียบ แนวทางและ/หรือคำสั่งของคณะกรรมการ\n                            คุ้มครองข้อมูลส่วนบุคคล จึงได้กำหนดหลักเกณฑ์และหลักปฏิบัติในการ\n                            เก็บรวบรวม ใช้ ประมวลผล และเปิดเผยข้อมูลส่วนบุคคลและการคุ้มครอง\n                            สิทธิของเจ้าของข้อมูลส่วนบุคคล บริษัทจึงขอประกาศนโยบายการ\n                            คุ้มครองข้อมูลส่วนบุคคลเพื่อใช้บังคับกับลูกค้าและผู้ใช้บริการของบริษัท\n                            ดังนี้ และขอให้ลูกค้าและผู้ใช้บริการของบริษัทศึกษารายละเอียดและ\n                            เงื่อนไขของนโยบายฉบับนี้โดยละเอียด")]),_vm._v(" "),_c('b',[_vm._v("1. คำนิยาม")]),_vm._v(" "),_c('p',[_vm._v("        "),_c('b',[_vm._v("“การประมวลผล”")]),_vm._v(" หมายถึง การดำเนินการใด ๆ\n                            ซึ่งกระทำต่อข้อมูล\n                            ส่วนบุคคลหรือชุดข้อมูลส่วนบุคคล ไม่ว่าจะโดยวิธีการอัตโนมัติหรือไม่\n                            เช่น การเก็บรวบรวม การบันทึก การแก้ไข การจัดระบบโครงสร้างการเก็บ\n                            รักษาเปลี่ยนแปลงหรือปรับเปลี่ยน การรับ พิจารณา การใช้ การเปิดเผย\n                            ไม่ว่าโดยการส่งต่อ โอน เผยแพร่ หรือการกระทำอื่นใดซึ่งทำให้เกิดความ\n                            พร้อมใช้งาน การจัดวางหรือผสมเข้าด้วยกัน การจำกัด การลบ การ\n                            ทำลาย")]),_vm._v(" "),_c('p',[_vm._v("        "),_c('b',[_vm._v("“ข้อมูลส่วนบุคคล”")]),_vm._v(" หมายถึง ข้อมูลใด ๆ\n                            ที่เกี่ยวกับบุคคลซึ่งทำให้\n                            สามารถระบุไปถึง “เจ้าของข้อมูลส่วนบุคคล (Data Subject)” ได้ไม่ว่าทางตรงหรือทางอ้อม\n                            รวมถึงข้อมูลทุกประเภทที่สามารถบ่งชี้ตัวตน ซึ่งรวมถึง\n                            แต่ไม่จำกัดเพียง ชื่อ นามสกุล ที่อยู่ หมายเลขโทรศัพท์ เลขประจำตัว\n                            ประชาชน เลขหนังสือเดินทาง ข้อมูลออนไลน์ ข้อมูลเอกลักษณ์ทาง\n                            กายภาพทางจิตใจ ทางสังคม เศรษฐกิจ วัฒนธรรม หรือข้อมูลอื่นใดที่\n                            สามารถระบุตัวตนได้ เป็นต้น (แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดย\n                            เฉพาะ)")]),_vm._v(" "),_c('p',[_vm._v("        "),_c('b',[_vm._v("“ข้อมูลส่วนบุคคลที่มีความอ่อนไหว”")]),_vm._v("\n                            หมายถึง ข้อมูลส่วนบุคคล\n                            ประเภทพิเศษ ตามมาตรา 26 ของพระราชบัญญัติคุ้มครองข้อมูลส่วน\n                            บุคคล พ.ศ. 2562 เช่น ข้อมูลส่วนบุคคลเกี่ยวกับเชื้อชาติ เผ่าพันธุ์ ความ\n                            คิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา พฤติกรรมทาง\n                            เพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ข้อมูลความพิการ ข้อมูล\n                            สหภาพแรงงาน ข้อมูลพันธุกรรม ข้อมูลชีวภาพ หรือข้อมูลอื่นใดที่มี\n                            ลักษณะเดียวกันตามที่คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลกำหนด")]),_vm._v(" "),_c('p',[_vm._v("        "),_c('b',[_vm._v("“เครือกิจการหรือเครือธุรกิจเดียวกัน”")]),_vm._v("\n                            หมายถึง กิจการที่ผู้ประกอบ\n                            กิจการที่มีอำนาจควบคุมบริหารจัดการเหนือกิจการอื่น หรือกิจการที่ถูก\n                            ควบคุมโดยผู้ประกอบกิจการที่มีอำนาจเหนือกิจการอื่น ในรูปแบบบริษัท\n                            ใหญ่ บริษัทย่อย บริษัทร่วม หรือบุคคลธรรมดาหรือนิติบุคคลที่มีความ\n                            เกี่ยวข้องกันทางกฎหมาย หรือเกี่ยวข้องกันเนื่องจากการประกอบกิจกรรม\n                            ทางเศรษฐกิจร่วมกัน โดยใช้หลักเกณฑ์การพิจารณาตามมาตรฐานทาง\n                            บัญชีอันเป็นที่ยอมรับโดยทั่วไป")]),_vm._v(" "),_c('p',[_vm._v("        "),_c('b',[_vm._v("“เจ้าของข้อมูลส่วนบุคคล (Data\n                                Subject)”")]),_vm._v(" หมายถึง บุคคล\n                            ธรรมดาซึ่งสามารถถูกระบุตัวตนได้โดยข้อมูลส่วนบุคคลนั้น ๆ ไม่ว่าโดย\n                            ทางตรงหรือทางอ้อม")]),_vm._v(" "),_c('p',[_vm._v("        "),_c('b',[_vm._v("“บริษัท”")]),_vm._v(" หมายถึง บริษัท วัน เซ็นทริค\n                            จำกัด บริษัทใหญ่ บริษัทย่อย\n                            บริษัทร่วม และ/หรือบริษัทในเครือกิจการและเครือธุรกิจเดียวกัน")]),_vm._v(" "),_c('p',[_vm._v("        "),_c('b',[_vm._v("“บริษัทย่อย”")]),_vm._v(" หมายถึง\n                            นิติบุคคลหรือบริษัทที่มีลักษณะใดลักษณะ\n                            หนึ่งดังต่อไปนี้")]),_vm._v(" "),_c('p',[_vm._v("        (ก) นิติบุคคลหรือบริษัทที่บริษัท วัน เซ็นทริค จำกัด หรือบริษัท\n                            อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน) มีอำนาจควบคุมกิจการ")]),_vm._v(" "),_c('p',[_vm._v("        (ข) นิติบุคคลหรือบริษัทที่นิติบุคคลหรือบริษัทตาม (ก) มีอำนาจ\n                                ควบคุมกิจการ")]),_vm._v(" "),_c('p',[_vm._v("        (ค) นิติบุคคลหรือบริษัทที่อยู่ภายใต้อำนาจควบคุมกิจการของบริษัท\nตาม (ข) ต่อไปเป็นทอด ๆ โดยเริ่มจากการอยู่ภายใต้อำนาจควบคุม\nกิจการของนิติบุคคลหรือบริษัทตาม (ข)")]),_vm._v(" "),_c('p',[_vm._v("        "),_c('b',[_vm._v("“บริษัทร่วม”")]),_vm._v("  หมายถึง นิติบุคคลหรือบริษัทที่มีลักษณะใดลักษณะ\n    หนึ่งดังต่อไปนี้")]),_vm._v(" "),_c('p',[_vm._v("        (ก) นิติบุคคลหรือบริษัทที่บริษัท วัน เซ็นทริค จำกัด หรือบริษัท\nอินเทอร์เน็ตประเทศไทย จำกัด (มหาชน) หรือบริษัทย่อยถือหุ้นไม่ว่า\nโดยตรงหรือโดยอ้อมรวมกันตั้งแต่ ร้อยละ 20 แต่ไม่เกินร้อยละ 50 ของ\nจำนวนหุ้นที่มีสิทธิออกเสียงทั้งหมด")]),_vm._v(" "),_c('p',[_vm._v("        (ข) นิติบุคคลหรือบริษัทที่บริษัท วัน เซ็นทริค จำกัด หรือบริษัท\nอินเทอร์เน็ตประเทศไทย จำกัด (มหาชน) หรือบริษัทย่อยมีอำนาจในการมี\nส่วนร่วมตัดสินใจเกี่ยวกับนโยบายทางการเงินและการดำเนินงาน แต่ไม่\nถึงระดับที่จะมีอำนาจควบคุมนโยบายดังกล่าว และไม่ถือเป็นบริษัทย่อย\nหรือกิจการร่วมค้า")]),_vm._v(" "),_c('p',[_vm._v("        "),_c('b',[_vm._v("“บริษัทใหญ่”")]),_vm._v(" หมายถึง นิติบุคคลหรือบริษัทที่มีลักษณะใดลักษณะ\n    หนึ่งดังต่อไปนี้")]),_vm._v(" "),_c('p',[_vm._v("        (ก) นิติบุคคลหรือบริษัทที่มีอำนาจควบคุมกิจการในบริษัท วัน เซ็น\n        ทริค จำกัด หรือบริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)")]),_vm._v(" "),_c('p',[_vm._v("        (ข) นิติบุคคลหรือบริษัทที่มีอำนาจควบคุมกิจการในนิติบุคคลหรือ\n            บริษัทตาม (ก)")]),_vm._v(" "),_c('p',[_vm._v("        (ค) นิติบุคคลหรือบริษัทที่มีอำนาจควบคุมกิจการในบริษัทตาม (ข)\nต่อไปเป็นทอด ๆ โดยเริ่มจากการมีอำนาจควบคุมกิจการในบริษัทตาม\n(ข)")]),_vm._v(" "),_c('p',[_vm._v("        "),_c('b',[_vm._v("“อำนาจควบคุมกิจการ”")]),_vm._v(" หมายถึง การมีความสัมพันธ์ในลักษณะใด\n    ลักษณะหนึ่งดังนี้")]),_vm._v(" "),_c('p',[_vm._v("        (ก) การถือหุ้นที่มีสิทธิออกเสียงในนิติบุคคลหรือบริษัทเกินกว่าร้อย\n        ละ 50 ของจำนวนสิทธิออกเสียงทั้งหมดของนิติบุคคลหรือบริษัทนั้น")]),_vm._v(" "),_c('p',[_vm._v("        (ข) การมีอำนาจควบคุมคะแนนเสียงส่วนใหญ่ในที่ประชุมผู้ถือหุ้น\nของนิติบุคคลหรือบริษัทไม่ว่าโดยตรงหรือโดยอ้อม หรือไม่ว่าเพราะเหตุ\nอื่นใด")]),_vm._v(" "),_c('p',[_vm._v("        (ค) การมีอำนาจควบคุมการแต่งตั้งหรือถอดถอนกรรมการตั้งแต่กึ่ง\n                หนึ่งของกรรมการทั้งหมด ไม่ว่าโดยตรงหรือโดยอ้อม")]),_vm._v(" "),_c('b',[_vm._v("2. ข้อมูลที่บริษัทเก็บรวบรวม")]),_vm._v(" "),_c('p',{staticClass:"mb-0 mt-2"},[_vm._v("2.1 ข้อมูลบุคคลทั่วไป")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        บริษัทจำเป็นต้องเก็บรวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคลของท่าน\n                    ซึ่งรวมถึงแต่ไม่จำกัดเพียง")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - ชื่อ - นามสกุล")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - วันเดือนปีเกิด")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - บัญชีผู้ใช้ (Account) สื่อสังคมออนไลน์ เช่น Facebook Google\nInstagram Twitter และ LINE บัญชีผู้ใช้งานและรหัสผ่านเพื่อเข้า\nใช้งานบริการใด ๆ ของบริษัท และข้อมูลคุกกี้ (Cookies)")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - รูปถ่าย")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - บัตรประชาชน หรือหนังสือเดินทาง")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - หมายเลขโทรศัพท์")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - หมายเลขโทรศัพท์มือถือ")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - อีเมลแอดเดรส")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เลขที่ประจำตัวผู้เสียภาษีอากร")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - ข้อมูลจราจรคอมพิวเตอร์ (Log File) เช่น หมายเลขไอพีแอดเดรส\n(IP Address) ของท่าน และวันที่และเวลาที่ท่านใช้โปรแกรม\nคอมพิวเตอร์ ซอฟต์แวร์ ฮาร์ดแวร์ เว็บไซต์ แอปพลิเคชัน โครง\nข่าย และ/หรือบริการอื่นใดของบริษัท")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - ตำแหน่งของท่าน (Location)")]),_vm._v(" "),_c('p',{staticClass:"mb-0 mt-2"},[_vm._v("2.2 ข้อมูลส่วนบุคคลที่มีความอ่อนไหว")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        บริษัทเก็บรวบรวมข้อมูลส่วนบุคคลที่มีความอ่อนไหวของท่าน ตาม\nมาตรา 26 ของพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 เช่น\nเชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือ\nปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ความ\nพิการ ข้อมูลสหภาพแรงงาน ข้อมูลพันธุกรรม ข้อมูลชีวภาพ หรือข้อมูลอื่น\nใดที่มีลักษณะเดียวกัน โดยบริษัทจะเข้าถึง เก็บรวบรวม ใช้ ประมวลผล\nเปิดเผยหรือควบคุมข้อมูลส่วนบุคคลด้วยความระมัดระวังตามขอบเขตที่\nกฎหมายกำหนด บริษัทจะแจ้งข้อมูลรายละเอียดการเก็บรวบรวม ใช้\nประมวลผล และ/หรือเปิดเผย ข้อมูลส่วนบุคคลที่มีความอ่อนไหวต่อท่าน\nก่อนหรือขณะที่บริษัทเก็บรวบรวมข้อมูลจากท่านภายใต้เงื่อนไขหลักเกณฑ์\nที่กฎหมายกำหนด")]),_vm._v(" "),_c('p',{staticClass:"mb-0 mt-2"},[_vm._v("2.3 ข้อมูลส่วนบุคคลที่เกี่ยวข้องกับการกระทำความผิดกฎหมาย")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        ท่านรับทราบว่า ในกรณีที่มีการกระทำความผิดตามกฎหมายเกิดขึ้น\nไม่ว่าจะเป็นความผิดในทางแพ่งหรือทางอาญาหรือกฎหมายอื่นใด บริษัท\nมีสิทธิเก็บรวบรวมหรือใช้ข้อมูลการกระทำความผิดกฎหมายของท่านได้โดยบริษัทจะเข้าถึง เก็บรวบรวม เปิดเผย หรือควบคุมข้อมูลส่วนบุคคล\nด้วยความระมัดระวังตามขอบเขตที่กฎหมายกำหนด")]),_vm._v(" "),_c('p',{staticClass:"mb-0 mt-2"},[_vm._v("2.4 บริษัทเก็บรวบรวม ประมวลผล ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคล\n    ดังต่อไปนี้จากบุคคลภายนอก")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        ท่านรับทราบและยินยอมให้บริษัทเก็บรวบรวม ประมวลผล ใช้\n                        ข้อมูลส่วนบุคคล ซึ่งรวมถึงแต่ไม่จำกัดเพียง")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - ข้อมูลจากแหล่งข้อมูลสาธารณะ อาทิเช่น ข้อมูลที่ท่านเปิดเผยในสื่อสังคมออนไลน์ หรือสื่อสาธารณะ (Facebook, Instagram,\nTwitter) และข้อมูลสาธารณะที่มีชื่อ อาชีพและข้อมูลติดต่อของท่าน")]),_vm._v(" "),_c('p',{},[_vm._v("        - ข้อมูลเกี่ยวกับชื่อ นามสกุล เลขบัตรประจำตัวประชาชน บัญชีผู้ใช้ (Account) สื่อสังคมออนไลน์ เช่น Facebook และ LINE รวมถึง\nอีเมลที่ผูกกับบัญชีผู้ใช้ IP Address ที่อยู่ วันเดือนปีเกิด เพศ รูปถ่าย อีเมล หมายเลขโทรศัพท์ ที่บริษัทอาจได้รับจากสถาบันการเงิน ตัวแทน หรือพันธมิตรทางธุรกิจของบริษัท เป็นต้น")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        บริษัทขอแจ้งให้ท่านทราบว่า เพื่อป้องกันและรักษาความปลอดภัยของบุคคลทั่วไป และเพื่อปกป้องผลประโยชน์ได้เสียของบริษัท บริษัทได้\nติดตั้งกล้องวงจรปิดเพื่อความปลอดภัยภายในบริเวณบริษัท บริษัทหรือผู้ให้บริการซึ่งเป็นบุคคลภายนอกที่บริษัทจัดหาอาจเก็บรวบรวม ใช้ประมวลผลข้อมูลจากภาพนิ่ง ภาพเคลื่อนไหว และ/หรือเสียงของท่านและข้อมูลส่วนบุคคลที่ท่านใช้และเข้ามาในบริเวณพื้นที่ของบริษัท")]),_vm._v(" "),_c('p',{},[_vm._v("        บริษัทอาจบันทึกเสียงบทสนทนาทางโทรศัพท์ เพื่อนำไปปรับปรุงและพัฒนาการให้บริการ รวมทั้งเพื่อการประชาสัมพันธ์")]),_vm._v(" "),_c('b',[_vm._v("3. ข้อมูลที่บริษัทประมวลผล")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        บริษัทประมวลผลข้อมูลส่วนบุคคลที่บริษัทรวบรวมจากท่านโดยตรง\nหรือเก็บรวบรวมข้อมูลส่วนบุคคลจากบุคคลภายนอกตามที่ระบุไว้ในข้อ 2. ในการให้บริการ การปฏิบัติตามสัญญา การปฏิบัติตามกฎหมาย เพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัท หรือเพื่อวัตถุประสงค์ที่ระบุในข้อ 4.")]),_vm._v(" "),_c('p',{},[_vm._v("        บริษัทใช้ขั้นตอนการตัดสินใจอัตโนมัติที่จะประมวลผลข้อมูลของท่านผ่านระบบคอมพิวเตอร์ในบางกรณี เช่น บริษัทอาจประเมินข้อมูลส่วน\nบุคคลเกี่ยวกับการให้บริการหรืออื่น ๆ ท่านอาจสอบถามรายละเอียดเพิ่มเติมโดยติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของบริษัทตามรายละเอียดที่กำหนดในข้อ 11.")]),_vm._v(" "),_c('b',[_vm._v("4. วัตถุประสงค์และเหตุผลทางกฎหมายในการเก็บรวบรวม ใช้ และเปิด\n    เผยข้อมูลของท่าน")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        บริษัทเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อ\n    วัตถุประสงค์ดังต่อไปนี้")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - ระบุตัวตนหรือยืนยันตัวตนของท่าน")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - การลงทะเบียนการติดต่อ การสมัครใช้บริการ และ/หรือการใช้บริการของท่าน")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - การซื้อขายสินค้าและ/หรือให้บริการแก่ท่าน")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - การเรียกและ/หรือชำระค่าสินค้าและ/หรือค่าบริการ รวมถึงการออกใบแจ้งหนี้ การออกใบเสร็จรับเงิน การติดตามทวงถามให้ชำระหนี้ การรับเงินและ/หรือการคืนเงิน เป็นต้น")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - การจัดส่งสินค้าและ/หรือบริการ รวมถึงของรางวัล ของที่ระลึกของสมนาคุณ เป็นต้น")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - การประเมินความพึงพอใจ")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - การพัฒนาสินค้าและ/หรือบริการ")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - การวิจัยและสถิติ")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - การเปิดบัญชีผู้ใช้งาน (Account) โปรแกรมคอมพิวเตอร์ซอฟต์แวร์ ฮาร์ดแวร์ เว็บไซต์ แอปพลิเคชัน โครงข่าย และ/หรือบริการอื่นใดของบริษัท รวมถึง การลงทะเบียนผู้ใช้งาน การ\nพิจารณาคุณสมบัติผู้ใช้งาน การประกาศรายชื่อผู้ใช้งาน การจัดทำทะเบียนผู้ใช้งาน การจัดให้มีสิทธิประโยชน์แก่ผู้ใช้งาน การจัดทำประวัติการใช้และ/หรือได้รับสิทธิประโยชน์ของผู้ใช้งาน และ/\nหรือการพัฒนาโปรแกรมคอมพิวเตอร์ ซอฟต์แวร์ ฮาร์ดแวร์เว็บไซต์ แอปพลิเคชัน โครงข่าย และ/หรือบริการอื่นใดของบริษัทเป็นต้น")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - การจัดส่ง นำเสนอ หรือประชาสัมพันธ์ ข้อมูลเกี่ยวกับการให้\nบริการของบริษัทที่เกี่ยวข้องกับบริการที่ท่านให้ความสนใจ ผ่านช่องทางการติดต่อต่าง ๆ ไม่ว่าจะเป็น ทางสื่อสังคมออนไลน์ ทางอีเมล หรือทางโทรศัพท์ เป็นต้น")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อส่งเสริม พัฒนา และปรับปรุงความสัมพันธ์ทางธุรกิจระหว่างท่านกับบริษัท")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อพิจารณา ประมวลผล ทดสอบ หรือวิเคราะห์ ความสนใจของท่านเพื่อส่งเสริม พัฒนา และปรับปรุงการให้บริการของบริษัทให้ตอบสนองกับความสนใจและความต้องการของท่านอย่างสูงสุด")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อฝึกอบรม ควบคุม หรือรับประกัน พนักงานและคุณภาพที่อาจเกี่ยวข้องกับการประสานงาน หรือการติดต่อผ่านช่องทางต่าง ๆ กับท่าน")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อจัดการ แก้ปัญหา ซักถาม และวิเคราะห์ ปัญหาที่อาจเกิดขึ้นจากการให้บริการของบริษัท โดยบริษัทจะใช้ข้อมูลดังกล่าวเพื่อความจำเป็นเท่านั้น")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อจัดการ ตอบคำถาม หรือตอบรับ การติดต่อสื่อสาร การร้องเรียนการใช้บริการ หรือการแสดงความคิดเห็นจากท่าน")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อชี้แจง บอกกล่าว หรือแจ้งให้ทราบถึงการปรับเปลี่ยนรูปแบบหรือข้อมูลที่เกี่ยวข้องกับการให้บริการของบริษัท")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อตรวจสอบ ปกป้อง หรือป้องกัน การกระทำใดอันไม่ถูกต้องการละเมิด การประพฤติผิด หรือการฝ่าฝืน กฎหมาย ระเบียบ ข้อบังคับ ข้อข้อตกลงและเงื่อนไขในการให้บริการ และเงื่อนไขอื่นใดของบริษัท")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อส่งเสริม หรือประชาสัมพันธ์ในการเข้าร่วมกิจกรรมโฆษณาและกิจกรรมส่งเสริมการขายอื่นใดภายใต้เงื่อนไขของบริษัท")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อวัตถุประสงค์ทางการตลาด เช่น การจัดส่งเอกสารเกี่ยวกับโปรโมชั่นต่าง ๆ การส่งข่าวสารเกี่ยวกับสินค้าบริการ งานกิจกรรม และ/หรือกิจกรรมส่งเสริมการขายของบริษัท ทางไปรษณีย์ อีเมล และ/หรือทางโทรศัพท์และด้วยวิธีการอื่นใด รวมถึงการดำเนินการด้านการตลาดแบบตรง เพื่อเพิ่มสิทธิประโยชน์ที่ท่านจะได้รับจากการเป็นลูกค้าของบริษัท ทั้งนี้ ท่านสามารถเลือกที่จะไม่รับการสื่อสารเพื่อวัตถุประสงค์ทางการตลาดจากบริษัทได้")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพของบุคคล")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อปฏิบัติตามกฎหมาย กฎเกณฑ์ ระเบียบ ประกาศต่าง ๆ ที่เกี่ยวข้อง")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อการปฏิบัติตามสัญญาระหว่างบริษัทกับท่าน หรือเพื่อใช้ในการดำเนินตามคำขอใช้บริการของท่านก่อนเข้าทำสัญญากับบริษัท")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อปฏิบัติหน้าที่ในการดำเนินภารกิจเพื่อประโยชน์สาธารณะของบริษัท หรือปฏิบัติหน้าที่ในการใช้อำนาจรัฐที่ได้มอบให้แก่บริษัท")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัทหรือบุคคลอื่น")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อประโยชน์ในการดำเนินกิจการของบริษัท")]),_vm._v(" "),_c('p',{},[_vm._v("        - เพื่อการดำเนินการอื่นใดที่ใกล้เคียงหรือมีลักษณะเดียวกันกับบรรดาวัตถุประสงค์ที่กำหนดไว้ข้างต้น")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        อนึ่ง ในกรณีที่บริษัทมีความจำเป็นในการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ในการปฏิบัติตามสัญญาระหว่างบริษัทกับท่าน หรือเพื่อใช้ในการดำเนินตามคำขอใช้บริการของท่านก่อนเข้าทำสัญญากับบริษัท หากปรากฏว่าท่านไม่ให้ข้อมูลส่วนบุคคลแก่บริษัทอาจส่งผลกระทบให้บริษัทไม่อาจปฏิบัติตามสัญญาหรือให้บริการแก่ท่านอย่างถูกต้องครบถ้วนตามที่กำหนดในสัญญาต่อไปได้")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        บริษัทอาจต้องเก็บรวบรวม ใช้ ประมวลผลและเปิดเผยข้อมูลส่วนบุคคลที่มีความอ่อนไหวโดยอาศัยฐานทางกฎหมาย ซึ่งกำหนดให้บริษัทมีสิทธิดำเนินการได้ ซึ่งรวมถึงแต่ไม่จำกัดเพียงฐานดังต่อไปนี้ หรือโดยได้รับความยินยอมจากท่านโดยชัดแจ้ง")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพของบุคคล ซึ่งเจ้าของข้อมูลส่วนบุคคล (Data Subject) ไม่สามารถให้ความยินยอมได้ ไม่ว่าด้วยเหตุใดก็ตาม")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เพื่อเป็นการดำเนินกิจกรรมโดยชอบด้วยกฎหมายที่มีการคุ้มครองที่เหมาะสมของมูลนิธิ สมาคม หรือองค์กรที่ไม่แสวงหากำไรที่มีวัตถุประสงค์เกี่ยวกับการเมือง ศาสนา ปรัชญา หรือสหภาพแรงงาน ให้แก่สมาชิก ผู้ซึ่งเคยเป็นสมาชิก หรือผู้ซึ่งมาติดต่ออย่างสม่ำเสมอกับมูลนิธิ สมาคม หรือองค์กรที่ไม่แสวงหากำไรตามวัตถุประสงค์ดังกล่าว โดยไม่เปิดเผยข้อมูลส่วนบุคคลออกภายนอก มูลนิธิ สมาคม หรือองค์กรไม่แสวงหากำไรนั้น")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เป็นข้อมูลที่เปิดเผยต่อสาธารณะด้วยความยินยอมโดยชัดแจ้งของเจ้าของข้อมูลส่วนบุคคล (Data Subject)")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - เป็นการจำเป็นเพื่อการก่อตั้งสิทธิเรียกร้องตามกฎหมาย การปฏิบัติตาม หรือการใช้สิทธิเรียกร้องตามกฎหมาย หรือการยกขึ้นต่อสู้สิทธิเรียกร้องตามกฎหมาย")]),_vm._v(" "),_c('p',{},[_vm._v("        - เป็นการจำเป็นในการปฏิบัติตามกฎหมายเพื่อให้บรรลุวัตถุประสงค์เกี่ยวกับ (ก) เวชศาสตร์ป้องกันหรืออาชีวเวชศาสตร์การประเมินความสามารถในการทำงานของลูกจ้าง การวินิจฉัยโรคทางการแพทย์ การให้บริการด้านสุขภาพหรือด้านสังคม การรักษาทางการแพทย์ การจัดการด้านสุขภาพ หรือระบบ และการให้บริการด้านสังคมสงเคราะห์ (ข) ประโยชน์สาธารณะด้านการสาธารณสุข (ค) การคุ้มครองแรงงาน การประกันสังคม หลักประกันสุขภาพแห่งชาติ สวัสดิการเกี่ยวกับการรักษาพยาบาลของผู้มีสิทธิตามกฎหมาย การคุ้มครองผู้ประสบภัยจากรถ หรือการคุ้มครองทางสังคม (ง ) การศึกษาวิจัยทางวิทยาศาสตร์ประวัติศาสตร์ หรือสถิติ หรือประโยชน์สาธารณะอื่น หรือ (จ)ประโยชน์สาธารณะที่สำคัญ")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        ท่านสามารถสอบถามข้อมูลเพิ่มเติมโดยการติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลเมื่อบริษัทเก็บรวบรวม ใช้ ประมวลผลและเปิดเผยข้อมูลส่วนบุคคลที่มีความอ่อนไหวของท่านเมื่อท่านได้ให้ความยินยอม ท่านอาจเพิกถอนความยินยอมได้ ณ เวลาใด ๆ โดยติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล ตามรายละเอียดที่กำหนดในข้อ 11. หากท่านเพิกถอนความยินยอม บริษัทยังอาจต้องประมวลผลข้อมูลส่วนบุคคลเพื่อปฏิบัติตามกฎหมายหรือเพื่อปกป้องประโยชน์ได้เสียของบริษัท ทั้งนี้บริษัทจะอธิบายให้ท่านทราบในเวลาที่มีการเพิกถอนความยินยอมว่าข้อมูลใดที่บริษัทยังคงมีหน้าที่ในการเก็บรวบรวมหรือประมวลผลข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ของการปฏิบัติตามกฎหมาย")]),_vm._v(" "),_c('p',{},[_vm._v("        นอกจากนี้ บริษัทเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์อื่น ๆ เพิ่มเติมที่สอดคล้องหรือเป็นไปในทำนองเดียวกับวัตถุประสงค์ที่ระบุข้างต้น รวมทั้งวัตถุประสงค์ในการทำการวิจัยทางประวัติศาสตร์ สถิติ หรือวิทยาศาสตร์ เพื่อวัตถุประสงค์ในการจัดเก็บข้อมูล (archives) เพื่อประโยชน์ส่วนรวม ในกรณีที่เป็นไปได้ บริษัทจะไม่ใช้ข้อมูลที่สามารถระบุตัวตนได้เพื่อวัตถุประสงค์ดังกล่าวข้างต้น หรือบริษัทจะดำเนินการตามขั้นตอนเพื่อจำกัดขอบเขตของข้อมูลส่วนบุคคลที่บริษัทจะใช้ในการทำการวิจัยหรือจัดเก็บข้อมูลสำรอง รวมทั้ง บริษัทอาจใช้ข้อมูลนามแฝง (pseudonymous) เพื่อหลีกเลี่ยงการใช้ข้อมูลส่วนบุคคลของท่าน")]),_vm._v(" "),_c('b',[_vm._v("5. ผู้รับข้อมูลส่วนบุคคลของท่าน")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        บริษัทตระหนักถึงความสำคัญในการทำให้มั่นใจถึงการป้องกันข้อมูลส่วนบุคคลที่เพียงพอ บริษัทพยายามที่จะจำกัดการเข้าถึงข้อมูลส่วนบุคคลให้แก่บุคคลที่มีความจำเป็นที่จะต้องเข้าถึงข้อมูลดังกล่าวเพื่อปฏิบัติหน้าที่ที่มีอยู่ พนักงาน บุคลากรของบริษัท บริษัทใหญ่ บริษัทย่อย บริษัทร่วม บริษัทในเครือกิจการหรือเครือธุรกิจเดียวกัน และ/หรือพันธมิตรทางธุรกิจของบริษัท รวมทั้งบุคคลภายนอกที่มีสัญญาให้บริการแก่บริษัทเกี่ยวกับการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลข้างต้นและคู่สัญญาอื่น ๆ ที่กระทำในนามบริษัทจะเป็นผู้ได้รับและเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่าน บริษัทจะเปิดเผยข้อมูลส่วนบุคคลแก่บริษัทเหล่านั้นเท่าที่จำเป็นเพื่อประมวลผลข้อมูลส่วนบุคคลเพื่อการให้บริการแก่ท่าน\nและเพื่อปกป้องส่วนได้เสียของบริษัทเท่านั้น และตกลงที่จะป้องกันข้อมูลส่วนบุคคลของท่านจากการใช้ การเข้าถึงหรือการเปิดเผยโดยไม่ได้รับอนุญาต ท่านอาจติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลตามรายละเอียดที่กำหนดในข้อ 11. เพื่อสอบถามข้อมูลเพิ่มเติมเกี่ยวกับประเภทของผู้ให้บริการที่บริษัทจะมีการเปิดเผยข้อมูลส่วนบุคคลของท่านให้ทราบบริษัทอาจเปิดเผยข้อมูลการติดต่อของท่านในสมุดรายชื่อเจ้าหน้าที่ให้แก่พนักงานของบริษัทและบุคคลทั่วไป อย่างไรก็ตาม ท่านมีสิทธิขอให้ลบข้อมูลของท่านออกจากบริษัท ภายใต้หลักเกณฑ์ เงื่อนไข ระยะเวลาที่บริษัทกำหนด")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        บริษัทอาจให้ข้อมูลส่วนบุคคลของท่าน แก่บริษัทอื่นใดหรือหน่วยงานใด ๆ เช่น หน่วยงานราชการ หน่วยงานภาครัฐ หน่วยงานที่กำกับดูแลการให้บริการ หรือหน่วยงานกำกับดูแลบริษัท หรือหน่วยงานที่บริษัทเป็นสมาชิก หน่วยงานราชการที่ควบคุมในเรื่องการตรวจคนเข้าเมือง ภาษีความมั่นคงของชาติและอาชญากรรม ตามที่กฎหมายกำหนด เพื่อดำเนินกิจการของบริษัท หรือการดำเนินกิจกรรมร่วมกัน การเดินทาง การจัดงานร่วมกัน และการวิจัย")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        นอกจากนี้ ท่านตกลงยินยอมให้บริษัทเปิดเผยหรือโอนข้อมูลส่วนบุคคลของท่านให้แก่บริษัทใหญ่ บริษัทย่อย บริษัทร่วม บริษัทในเครือกิจการหรือเครือธุรกิจเดียวกัน หรือพันธมิตรทางธุรกิจของบริษัทเพื่อวัตถุประสงค์ในการดำเนินการกิจการของบริษัท เพื่อการปฏิบัติตามนโยบายของบริษัท เพื่อปฏิบัติตามสัญญาหรือให้บริการระหว่างบริษัทกับท่าน เพื่อปกป้องประโยชน์ได้เสียหรือสิทธิโดยชอบด้วยกฎหมายของบริษัท เพื่อประโยชน์สาธารณะ หรือประกาศที่บริษัทจะกำหนดเป็นกรณี ๆไป")]),_vm._v(" "),_c('p',{},[_vm._v("        บริษัทขอเรียนให้ท่านทราบว่า เว็บไซต์ของบริษัทจะมีการเชื่อมต่อไปยังเว็บไซต์ของบุคคลที่สามซึ่งเว็บไซต์เหล่านั้นอาจมีนโยบายความเป็นส่วนตัวที่แตกต่างจากของบริษัท ท่านจึงควรศึกษานโยบายความเป็นส่วนตัวของเว็บไซต์นั้น ๆ เพื่อเข้าใจถึงรายละเอียดการคุ้มครองข้อมูลส่วนบุคคล และเพื่อตัดสินใจในการเปิดเผยข้อมูลส่วนบุคคลให้กับเว็บไซต์ของบุคคลที่สาม ทั้งนี้ บริษัทจะไม่รับผิดชอบต่อความสูญเสียหรือความเสียหายอย่างใด ๆ อันเกิดจากการกระทำของเว็บไซต์ของบุคคลที่สามทุกกรณี")]),_vm._v(" "),_c('b',[_vm._v("6. การโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ")]),_vm._v(" "),_c('p',{},[_vm._v("        บริษัทอาจโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศเพื่อวัตถุประสงค์ในการดำเนินกิจการของบริษัทเท่าที่จำเป็น ทั้งนี้ ท่านตกลงและยินยอมให้บริษัทส่งข้อมูลส่วนบุคคลของท่านออกนอกประเทศไทยไปยังบุคคลหรือหน่วยงานที่อยู่ในประเทศอื่น หรือภายใต้เขตอำนาจกฎหมายของประเทศอื่น ไม่ว่ากฎหมายคุ้มครองข้อมูลส่วนบุคคลในประเทศนั้นอาจถึงเกณฑ์หรือไม่ถึงเกณฑ์มาตรฐานของกฎหมายคุ้มครองข้อมูลส่วนบุคคลของประเทศไทย ทั้งนี้ บริษัทจะปฏิบัติตามขั้นตอนที่เหมาะสมในการคุ้มครองรักษาความปลอดภัยของข้อมูลส่วนบุคคลของท่านในระดับเดียวกับกฎหมายคุ้มครองข้อมูลส่วนบุคคลของประเทศไทย")]),_vm._v(" "),_c('b',[_vm._v("7. การรักษาความมั่นคงปลอดภัยและความลับของข้อมูลส่วนบุคคล")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        เพื่อสร้างความมั่นใจในการบริหารจัดการของบริษัท เพื่อการป้องกันความเสี่ยงอันอาจทำให้ข้อมูลส่วนบุคคลถูกเข้าถึงโดยมิชอบ รั่วไหล ถูกเปลี่ยนแปลงแก้ไข สูญหาย บริษัทได้จัดให้มีมาตรการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลที่เหมาะสมตามมาตรฐานที่กฎหมายกำหนด บริษัทถือปฏิบัติตามนโยบายความมั่นคงปลอดภัยสารสนเทศ(Information Security Policy) รวมทั้งปฏิบัติตามมาตรฐานสากลด้านการรักษาความปลอดภัยสารสนเทศที่เป็นที่ยอมรับ และการบริหารความต่อเนื่องทางธุรกิจ")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        บริษัทมีมาตรการปกป้องความเป็นส่วนตัวของท่าน โดยการจำกัดสิทธิการเข้าถึงข้อมูลส่วนบุคคลของท่าน จะกำหนดให้เฉพาะบุคคลที่จำเป็นต้องใช้ข้อมูลส่วนบุคคลดังกล่าวในการนำเสนอสินค้าและ/หรือบริการของบริษัท เพื่อการให้บริการของบริษัท และ/หรือเพื่อวัตถุประสงค์ที่กำหนดในข้อ 4. ข้างต้น เช่น พนักงานบริษัท ซึ่งเป็นบุคคลที่บริษัทอนุญาตให้เข้าถึงข้อมูลส่วนบุคคลนั้น จะต้องยึดมั่นและปฏิบัติตามมาตรการการปกป้องข้อมูลส่วนบุคคลของบริษัท อย่างเคร่งครัด ตลอดจนการรักษาความลับของข้อมูลส่วนบุคคลดังกล่าว โดยบริษัทมีมาตรการป้องกันทั้งทางกายภาพและทางอิเล็กทรอนิกส์เป็นไปตามมาตรฐานการกำกับดูแลที่บังคับใช้เพื่อปกป้องข้อมูลส่วนบุคคล")]),_vm._v(" "),_c('p',{},[_vm._v("        เมื่อบริษัททำสัญญา หรือ ข้อตกลงกับบุคคลที่สาม บริษัทจะกำหนดมาตรการรักษาความปลอดภัยของข้อมูลส่วนบุคคล การรักษาข้อมูลที่เป็นความลับที่เหมาะสม เพื่อสร้างความมั่นใจในความปลอดภัยของข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวม")]),_vm._v(" "),_c('b',[_vm._v("8. ระยะเวลาการเก็บข้อมูล")]),_vm._v(" "),_c('p',{},[_vm._v("        บริษัทจะเก็บรวบรวมข้อมูลส่วนบุคคลของท่านตามความจำเป็นและภายใต้กรอบระยะเวลาที่กฎหมายกำหนด ท่านสามารถตรวจสอบข้อมูลเกี่ยวกับระยะเวลาที่บริษัทเก็บรักษาข้อมูลส่วนบุคคลของท่าน โดยติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของบริษัทตามรายละเอียดที่กำหนดในข้อ 11.")]),_vm._v(" "),_c('b',[_vm._v("9. สิทธิของท่าน")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        ในเวลาใดก็ตาม ท่านมีสิทธิดังต่อไปนี้เกี่ยวกับข้อมูลส่วนบุคคลของท่าน")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - สิทธิในการเข้าถึงข้อมูลส่วนบุคคลของท่านที่บริษัทมีรวมทั้งสิทธิในการขอให้แก้ไขข้อมูลที่ไม่ถูกต้องหรือไม่ครบถ้วน")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - สิทธิในการขอสำเนาข้อมูลส่วนบุคคลในรูปแบบอิเล็กทรอนิกส์ที่ท่านอาจส่งให้บุคคลภายนอกหรือขอให้บริษัทส่งโดยตรง")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - สิทธิที่จะคัดค้านการประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ทางการตลาดและวัตถุประสงค์อื่นใดตามที่กฎหมายกำหนด")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - สิทธิที่จะขอให้ลบข้อมูลส่วนบุคคลของท่านเมื่อไม่มีความจำเป็นสำหรับวัตถุประสงค์ที่มีการจัดเก็บ รวมทั้งสิทธิที่จะจำกัด ขอบเขตการประมวลผลข้อมูลส่วนบุคคล ในกรณีที่ไม่สามารถให้ลบได้")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - สิทธิขอให้ผู้ควบคุมข้อมูลส่วนบุคคลระงับการใช้ข้อมูลส่วนบุคคลได้")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        - สิทธิร้องขอให้บริษัทดำเนินการให้ข้อมูลส่วนบุคคลนั้นถูกต้องเป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด")]),_vm._v(" "),_c('p',{},[_vm._v("        - สิทธิที่จะร้องเรียนกับหน่วยงานที่ควบคุมในกรณีที่ท่านเชื่อว่ามีการละเมิดสิทธิท่าน")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        ทั้งนี้ การใช้สิทธิของท่านจะต้องอยู่ภายข้อกำหนด ประกาศ ระเบียบที่บริษัทกำหนด ซึ่งจะเป็นไปตามหลักเกณฑ์ของกฎหมายคุ้มครองข้อมูลส่วนบุคคล รวมถึงนโยบายการคุ้มครองข้อมูลส่วนบุคคลของบริษัท และหลักเกณฑ์อื่น ๆ ที่บริษัทกำหนด โดยในการใช้สิทธิข้างต้น ท่านจะต้องส่งคำร้องเป็นลายลักษณ์อักษรมายังเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของบริษัทตามรายละเอียดที่กำหนดในข้อ 11. ของประกาศฉบับนี้ และการพิจารณาคำร้องดังกล่าวเป็นดุลยพินิจของบริษัทแต่เพียงผู้เดียว คำวินิจฉัยของบริษัทที่เกี่ยวข้องกับคำร้องขอใช้สิทธิของท่านถือเป็นที่สุด")]),_vm._v(" "),_c('p',{},[_vm._v("        ทั้งนี้ ในกรณีที่ท่านขอให้บริษัท ลบ ทำลาย จำกัดการเก็บรวบรวมใช้ ประมวลผลหรือเปิดเผยข้อมูลส่วนบุคคล ระงับการใช้ชั่วคราว แปลงข้อมูลส่วนบุคคลที่ไม่สามารถระบุตัวตนได้ หรือถอนความยินยอม อาจทำให้เกิดข้อจำกัดกับบริษัทในการทำธุรกรรมหรือให้บริการแก่ท่านได้")]),_vm._v(" "),_c('b',[_vm._v("10. การเพิกถอนความยินยอม")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        หากท่านไม่ประสงค์ให้บริษัทเก็บรวบรวม ใช้ ประมวลผล หรือเปิดเผยข้อมูลส่วนบุคคลของท่านอีกต่อไป ท่านสามารถเพิกถอนความยินยอมได้โดยการทำคำร้องแจ้งมายังเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของบริษัท")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        ทั้งนี้ การเพิกถอนความยินยอมข้อมูลส่วนบุคคลดังกล่าว จะต้องอยู่ภายใต้เงื่อนไข ข้อกำหนด ประกาศ หรือระเบียบที่กำหนดในกฎหมายคุ้มครองข้อมูลส่วนบุคคล รวมถึงนโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัท และหลักเกณฑ์อื่น ๆ ที่บริษัทกำหนด")]),_vm._v(" "),_c('p',{},[_vm._v("        อนึ่ง การถอนความยินยอม อาจทำให้เกิดข้อจำกัดกับบริษัทในการทำธุรกรรมหรือให้บริการแก่ท่านได้")]),_vm._v(" "),_c('b',[_vm._v("11. เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        หากท่านประสงค์จะใช้สิทธิตามที่กำหนดในข้อ 9. หรือต้องการเพิกถอนความยินยอมในข้อ 10. หรือมีข้อสงสัยเกี่ยวกับการเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคล โปรดติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลตามรายละเอียดด้านล่างนี้")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        ที่อยู่ : บริษัท วัน เซ็นทริค จำกัด 1768 อาคารไทยซัมมิท ทาวเวอร์ชั้น 16 ถ.เพชรบุรีตัดใหม่")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        หมายเลขโทรศัพท์ : 0 2257 7000")]),_vm._v(" "),_c('p',{},[_vm._v("        อีเมลแอดเดรส : DPOoffice@onecentric.co.th")]),_vm._v(" "),_c('b',[_vm._v("12.กรณีลูกค้าหรือผู้ใช้บริการเป็นบุคคลธรรมดาที่ยังไม่บรรลุนิติภาวะ")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        กรณีที่ท่านเป็นบุคคลธรรมดาและมีอายุยังไม่ครบ 20 ปีบริบูรณ์ หรือยังไม่บรรลุนิติภาวะตามกฎหมาย ท่านยืนยันว่า ท่านมีอายุเกินกว่า 15 ปีและสามารถทำนิติกรรมและการใด ๆ ซึ่งต้องทำเองเป็นการเฉพาะตัว หรือเป็นการสมแก่ฐานานุรูปแห่งตนด้วยตนเองได้โดยมีผลผูกพันตามกฎหมาย ซึ่งรวมถึงแต่ไม่จำกัดเพียงการซื้อสินค้า หรือใช้บริการใด ๆ จากบริษัท บริษัทใหญ่ บริษัทย่อย บริษัทร่วม บริษัทในเครือกิจการหรือเครือธุรกิจเดียวกัน และการรับทราบและยอมรับที่จะปฏิบัติตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้\n")]),_vm._v(" "),_c('p',{},[_vm._v("        กรณีที่ท่านเป็นบุคคลธรรมดาที่มีอายุไม่เกิน 15 ปี ท่านยืนยันว่าท่านได้รับความยินยอมจากผู้แทนโดยชอบธรรมตามกฎหมายในการซื้อขายสินค้า หรือใช้บริการใด ๆ จากบริษัท บริษัทใหญ่ บริษัทย่อย บริษัทร่วมบริษัทในเครือกิจการหรือเครือธุรกิจเดียวกัน โดยท่านและผู้แทนโดยชอบธรรมตามกฎหมายของท่านรับทราบและยอมรับที่จะปฏิบัติตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ และยินดีส่งหลักฐานที่เกี่ยวข้องให้แก่บริษัทตามที่บริษัทร้องขอ")]),_vm._v(" "),_c('b',[_vm._v("13. การแก้ไขเปลี่ยนแปลง")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        บริษัทขอสงวนสิทธิในการแก้ไขเปลี่ยนแปลงนโยบายนี้ไม่ว่าด้วยเหตุผลใดก็ตามที่เห็นสมควร รวมถึงในกรณีที่เป็นการปฏิบัติตามกฎหมายนโยบายของรัฐบาล กฎ ประกาศ ระเบียบ หรืออื่น ๆ ที่เกี่ยวข้อง เมื่อมีการเปลี่ยนแปลงใด ๆ บริษัทจะแจ้งผ่านทางอีเมลของท่านเป็นลายลักษณ์อักษร ซึ่งการแก้ไขเปลี่ยนแปลงดังกล่าวจะมีผลทันทีเมื่อมีการแจ้งเป็นลายลักษณ์อักษรแก่ท่าน และท่านรับทราบและยินยอมปฏิบัติตามนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับแก้ไขทุกประการ ท่านควรตรวจสอบและอ่านรายละเอียดของนโยบายคุ้มครองข้อมูลส่วนบุคคลที่บริษัทชี้แจงผ่านทางอีเมลเป็นประจำ")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("        ทั้งนี้ ให้ยกเลิกประกาศที่ 1/2563 และให้ประกาศฉบับนี้มีผลนับแต่วันที่ 1 มกราคม 2566 เป็นต้นไป หรือจนกว่าจะมีคำสั่งเปลี่ยนแปลง")])])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-checkbox',{attrs:{"label":"รับทราบนโยบายความคุ้มครองข้อมูลส่วนบุคคล"},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","color":"red","disabled":!_vm.checkbox},on:{"click":_vm.close}},[_vm._v("ปิด")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var consent_new_consent = (esExports);
// CONCATENATED MODULE: ./src/components/consent/new_consent.vue
function injectStyle (ssrContext) {
  __webpack_require__("sXCK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e346040c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  new_consent,
  consent_new_consent,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_consent_new_consent = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FN5h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FcrC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/AddImageDialogMobile.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import CreateAlbumsDialog from '@/components/chat/dialog/albums/CreateAlbumsDialog'
/* harmony default export */ var AddImageDialogMobile = ({
  props: {
    dialogAddImage: false,
    path_pic_albums: '',
    file_name: ''
  },
  components: {
    // CreateAlbumsDialog
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  data: function data() {
    return {
      tokenuser: '',
      tokenroom: '',
      listalbum: [],
      filter_infoalbum: [],
      lastindex_image: [],
      image_last: [],
      albumsname: '',
      loading: false,
      information_image: []
      // dialogCreatealbums: false
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    this.tokenroom = this.$route.params.roomid;
  },

  methods: {
    // closeCreatealbums(value) {
    //   this.dialogCreatealbums = value
    // },
    closeDialog: function closeDialog() {
      this.$emit('closeAddImage', false);
      this.$emit('path_pic_albums', '');
    },
    date: function date(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    time: function time(timestamp) {
      return services["c" /* Momenttime */].momenttimethai(timestamp);
    },
    addimage_albums: function addimage_albums(albums_id, albums_name) {
      var _this = this;

      // console.log(albums_id)
      this.$swal({
        // title: 'เพิ่มรูปในอัลบั้ม',
        // text: 'คุณต้องการเพิ่มรูปในอัลบั้ม ' + albums_name + ' ใช่หรือไม่?',
        text: this.$t('Alert.Album.textAddImageAlbum', { name: albums_name }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel')
      }).then(function (result) {
        if (result.value) {
          _this.axios.post("https://uatchat-manage.one.th/event" + '/addimage_chatroom_to_albums', {
            path_imgs: _this.path_pic_albums,
            tokenuser: _this.tokenuser,
            tokenroom: _this.tokenroom,
            albums_id: albums_id
          }).then(function (response) {
            // console.log(response.data.data)
            _this.$swal('', _this.$t('Alert.Success.savePhotoAlbum'), 'success');
            _this.closeDialog();
          }).catch(function (err) {
            console.log(err);
          });
        }
      });
    },
    create_albums: function create_albums() {
      var _this2 = this;

      this.loading = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/addimage_chatroom_to_albums', {
        path_imgs: this.path_pic_albums,
        tokenuser: this.tokenuser,
        tokenroom: this.tokenroom,
        albums_name: this.albumsname
      }).then(function (response) {
        _this2.loading = false;
        _this2.albumsname = '';
        _this2.$swal('', _this2.$t('Alert.Success.createAlbum'), 'success');
        _this2.$emit('closeAddImage', false);
      }).catch(function (err) {
        _this2.loading = false;
        _this2.albumsname = '';
        // this.$swal('', 'ไม่สามารถสร้างอัลบั้มได้ กรุณาลองใหม่ภายหลัง', 'error')
        _this2.$swal('Network error', _this2.$t('Alert.Fail.default.networkError'), 'error');
        console.log(err);
      });
    }
  },
  watch: {
    dialogAddImage: function dialogAddImage() {
      var _this3 = this;

      // console.log(this.path_pic_albums)
      this.tokenroom = this.$route.params.roomid;
      if (this.dialogAddImage) {
        this.axios.post("https://uatchat-manage.one.th/event" + '/getlist_albums', { tokenroom: this.tokenroom, tokenuser: this.tokenuser }).then(function (response) {
          // console.log(response.data.data)
          _this3.listalbum = response.data.data;
          // console.log(this.listalbum)
          for (var i = 0; i < _this3.listalbum.length; i++) {
            // console.log(this.listalbum[i]['information'])
            _this3.lastindex_image[i] = _.findLastIndex(_this3.listalbum[i].information, function (o) {
              return o.status == 'active';
            });
            // this.image_last[i] = this.listalbum[this.lastindex_image[i]].information
            // this.filter_infoalbum[i] = _.filter(this.listalbum[i].information, function (information) { return information.status === 'active' })
          }
          // console.log(this.image_last)
          // this.filter_infoalbum = _.filter(this.listalbum.information, function (information) { return information.status === 'active' })
        }).catch(function (error) {
          if (error.response.data.status === 'fail') {
            console.log(error);
          }
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b2e764","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/AddImageDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden","border-radius":"20px !important"},attrs:{"max-width":"500px","persistent":"","max-height":"500px"},model:{value:(_vm.dialogAddImage),callback:function ($$v) {_vm.dialogAddImage=$$v},expression:"dialogAddImage"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-images")]),_vm._v("  \n            "),_c('p',{staticClass:"mb-0",staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(_vm.$t('Dialog.album.headerAddImage')))])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"500px !important","overflow-y":"hidden"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',[_vm._v("fas fa-images")]),_vm._v(" "),_c('v-text-field',{staticClass:"ml-2",attrs:{"name":"albums_name","label":_vm.$t('Dialog.album.nameAlbum'),"id":"id"},model:{value:(_vm.albumsname),callback:function ($$v) {_vm.albumsname=$$v},expression:"albumsname"}}),_vm._v(" "),_c('v-btn',{staticClass:"btnalbums text-transform",attrs:{"loading":_vm.loading,"flat":"","disabled":_vm.albumsname == ''},on:{"click":function($event){_vm.create_albums()}}},[_vm._v(_vm._s(_vm.$t('Dialog.album.headerCreate')))])],1),_vm._v(" "),_c('v-layout',{staticStyle:{"height":"500px","overflow-y":"scroll"},attrs:{"row":"","wrap":""}},[(_vm.listalbum.length != 0)?_c('v-list',{staticStyle:{"width":"100% !important"},attrs:{"two-line":""}},[_vm._l((_vm.listalbum),function(item,index){return [(item.state['status'] !== 'delete')?_c('v-list-tile',{key:item.title,staticStyle:{"cursor":"pointer"},attrs:{"avatar":"","ripple":""}},[_c('v-list-tile-content',_vm._l((item.information),function(image,index){return _c('v-layout',{attrs:{"row":"","wrap":""}},[(image.status == 'active' && index === 0)?_c('img',{staticStyle:{"padding":"10px","height":"80px","border-radius":"15px"},attrs:{"src":image.link,"width":"80px"}}):(index === 0 && image.status == 'delete')?_c('img',{attrs:{"src":"/static/img/icons/image.png","alt":"","width":"80px"}}):_vm._e()])})),_vm._v(" "),_c('v-list-tile-content',{on:{"click":function($event){_vm.addimage_albums(item._id, item.albums_name)}}},[(item.albums_name !== '')?_c('v-list-tile-title',[_vm._v(_vm._s(item.albums_name))]):_c('v-list-tile-title',[_vm._v(_vm._s(_vm.date(item.create_date)))])],1),_vm._v(" "),_c('v-list-tile-action')],1):_vm._e(),_vm._v(" "),(index + 1 < _vm.listalbum.length && item.state['status'] !== 'delete')?_c('v-divider',{key:index}):_vm._e()]})],2):_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('h4',[_vm._v(_vm._s(_vm.$t('Dialog.album.noDataAlbum')))])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_AddImageDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/AddImageDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("WrTz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66b2e764"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  AddImageDialogMobile,
  dialog_AddImageDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_AddImageDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FucP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G0Ct":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GL+G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H5BG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HFu5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/AlbumsDialogMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _ = __webpack_require__("M4fF");
/* harmony default export */ var AlbumsDialogMobile = ({
  props: {
    dialogAlbums: false,
    albums_id: ''
  },
  data: function data() {
    return {
      dataalbums: {
        note_data: {
          text: ''
        }
      },
      token: '',
      edit: false,
      edittext: '',
      preedittext: '',
      progress: true,
      status: 'show',
      errormessage: '',
      infoalbums: [],
      albumsname: '',
      files: [],
      edit_name: false,
      add_image: false,
      new_name: '',
      loading: false,
      delete_image: false,
      selected: [],
      filter_infoalbum: [],
      path_pic: '',
      picSend: '',
      nicknameSend: '',
      filenameSend: '',
      dateSend: '',
      timeSend: '',
      tokenmsgSend: '',
      pathSend: '',
      typeuserSend: '',
      image_modal: false,
      typeuser: ''
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },

  methods: {
    showimagealbums: function showimagealbums(image) {
      var _this = this;

      // console.log(image)
      this.$swal({
        imageUrl: image.link,
        imageHeight: 250,
        // html: '<div><img style="width: 250px; height: 250px;" src="'+ image.link + '"><button id="btn-img">test</button></div>',
        showCloseButton: true,
        showConfirmButton: false,
        confirmButtonText: this.$t('AnswerQuestion.download'),
        // cancelButtonText: 'ส่งไป Onebox',
        showCancelButton: false
      }).then(function (result) {
        // console.log(result)
        if (result.value) {
          // console.log('showCloseButton')
          _this.downloadimage(image.link);
        } else if (result.dismiss == 'cancel') {
          // console.log('cancelButtonText')
          // this.sendimgonebox(tokenmessage)
        }
      });
    },
    downloadimage: function downloadimage(link) {
      var cnvs = link;
      console.log(cnvs);
      var button = '';
      var dataURL = cnvs[0].toDataURL('image/png');
      button.href = dataURL;
    },
    closemodal: function closemodal() {
      var modal = document.getElementById('myModalImageAlbums');
      modal.style.display = 'none';
    },
    dateMoment: function dateMoment(data) {
      return services["c" /* Momenttime */].momentdatethai(data);
    },
    timeMoment: function timeMoment(data) {
      return services["c" /* Momenttime */].momenttimethai(data);
    },
    zoom: function zoom(item) {
      var _this2 = this;

      // console.log(item)
      var modal = document.getElementById('myModalImageAlbums');
      var modalImg = document.getElementById('imgAlbums');
      // console.log(modalImg)
      modal.style.display = 'block';
      modalImg.src = item.link;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', { tokenuser: this.token, tokenfriend: item.upload_by }).then(function (response) {
        // console.log(response.data)
        _this2.picSend = response.data['user'].profilepicture;
        _this2.nicknameSend = response.data['user'].name;
        _this2.filenameSend = item.real_filename;
        _this2.pathSend = item.link;
        _this2.dateSend = _this2.dateMoment(item.timestamp);
        _this2.timeSend = _this2.timeMoment(item.timestamp);
      });
    },
    loadpic: function loadpic(filenameSend) {
      this.axios.get(this.pathSend, { responseType: 'blob' }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filenameSend);
        document.body.appendChild(link);
        link.click();
      });
    },
    deleteimage: function deleteimage() {
      var _this3 = this;

      var imageid = [];
      var index_image = [];
      for (var i = 0; i < this.selected.length; i++) {
        imageid[i] = this.selected[i]['image_id'];
        index_image[i] = this.selected[i]['index'];
      }
      // console.log(imageid)
      // console.log(index_image)
      this.loading = true;
      if (this.selected.length !== 0) {
        this.axios.post("https://uatchat-manage.one.th/event" + '/delete_image_albums', {
          tokenuser: this.token,
          tokenroom: this.$route.params.roomid,
          albums_id: this.albums_id,
          images_id: imageid
        }).then(function (response) {
          _this3.loading = false;
          for (var i = 0; i < index_image.length; i++) {
            var index = _this3.selected[i]['index'];
            // console.log(this.filter_infoalbum[index]['status'])
            _this3.filter_infoalbum[index]['status'] = 'delete';
          }
          // localStorage.setItem('albums_id', this.albums_id)
          _this3.filter_infoalbum = _.filter(_this3.filter_infoalbum, function (filter_infoalbum) {
            return filter_infoalbum.status === 'active';
          });
          _this3.$emit('editAlbums', { 'event': 'delete_image', 'albums_id': _this3.albums_id, 'index_image': index_image, 'image_id': imageid });
          _this3.$swal('', _this3.$t('Alert.Success.removePhoto'), 'success');
          _this3.selected = [];
          imageid = [];
          index_image = [];
          _this3.delete_image = false;
        });
      } else {
        this.$swal('', this.$t('Alert.Fail.Album.minFiles'), 'warning');
      }
    },
    addimage: function addimage() {
      var _this4 = this;

      var formData = new FormData();
      var lengthfile = this.files.length;
      var sizealums = [];
      for (var i = 0; i < lengthfile; i++) {
        var file = this.files[i].file;
        formData.append('file[]', file, file.name);
        sizealums[i] = this.files[i].file.size;
        // console.log(file)
      }
      if (_.sum(sizealums) / 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Album.maxSizeFile'), type: 'warning' });
        this.files = [];
        this.loading = false;
      } else {
        this.loading = true;
        formData.append('tokenuser', this.token);
        formData.append('tokenroom', this.$route.params.roomid);
        formData.append('albums_id', this.albums_id);
        this.axios.post("https://uatchat-manage.one.th/event" + '/addimage_albums', formData).then(function (response) {
          // console.log(response.data.data.image_add)
          _this4.loading = false;
          var infoalbums = {};
          infoalbums = response.data.data.image_add;
          // console.log(infoalbums)
          _this4.$swal('', _this4.$t('Alert.Success.savePhotoAlbum'), 'success');
          // this.$emit('editAlbums', {'event': 'add_image', 'albums_id': this.albums_id, 'info_albums': infoalbums})
          // console.log({'event': 'add_image', 'albums_id': this.albums_id, 'info_albums': infoalbums})
          _this4.files = [];
          _this4.edit = false;
          _this4.$emit('closeAlbums', false);
        }, function () {
          _this4.loading = false;
          // this.$swal('', 'ไม่สามารถเพิ่มรูปภาพได้ กรุณาลองใหม่ภายหลัง', 'error')
          _this4.$swal('Network error', _this4.$t('Alert.Fail.default.networkError'), 'error');
        });
      }
    },
    Edit_Name: function Edit_Name() {
      var _this5 = this;

      this.new_name = this.albumsname;
      this.loading = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/edit_albums_name', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        albums_id: this.albums_id,
        new_name: this.new_name
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status) {
          _this5.loading = false;
          _this5.$swal('', _this5.$t('Alert.Success.renameAlbum'), 'success');
          _this5.infoalbums.albums_name = _this5.new_name;
          _this5.edit_name = false;
          _this5.$emit('editAlbums', { 'event': 'edit_name', 'albums_name': _this5.albumsname, 'albums_id': _this5.albums_id });
        } else {
          _this5.loading = false;
          _this5.$swal('Network error', _this5.$t('Alert.Fail.default.networkError'), 'error');
        }
      }).catch(function (err) {
        // console.log(err)
        _this5.loading = false;
        if (err.response.data.message === 'New albums name cannot null.') {
          _this5.$swal('', _this5.$t('Alert.Fail.Album.emptyName'), 'warning');
        }
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('closeAlbums', false);
      this.edit = false;
      this.edit_name = false;
      this.delete_image = false;
    },
    remove: function remove() {
      var _this6 = this;

      this.$swal({
        // title: '<div class="CSChatThai">คุณต้องการลบอัลบั้มนี้ใช่หรือไม่</div>',
        text: this.$t('Alert.Album.deleteAlbum'),
        type: 'warning',
        confirmButtonColor: '#2562af',
        confirmButtonText: '<div class="CSChatThai" style="font-size: 12px;">' + this.$t('AnswerQuestion.ok') + '</div>',
        cancelButtonColor: '#9f9f9f',
        cancelButtonText: '<div class="CSChatThai" style="font-size: 12px;">' + this.$t('AnswerQuestion.cancel') + '</div>',
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then(function (result) {
        // console.log(result.value)
        if (result.value) {
          _this6.axios.post("https://uatchat-manage.one.th/event" + '/delete_albums', {
            albums_id: _this6.albums_id,
            tokenuser: _this6.token,
            tokenroom: _this6.$route.params.roomid
          }).then(function (response) {
            // console.log(response.data.status)
            if (response.data.status === 'success') {
              _this6.status = 'error';
              _this6.errormessage = _this6.$t('Alert.Fail.Album.removed');
              _this6.$emit('removeAlbums', _this6.albums_id);
              _this6.closeDialog();
            } else {
              _this6.$swal('Network error', _this6.$t('Alert.Fail.default.networkError'), 'error');
            }
          });
        }
      });
    },
    save: function save() {
      var _this7 = this;

      this.edit = false;
      if (this.edittext !== this.preedittext) {
        this.dataalbums.note_data.text = this.edittext;
        this.preedittext = this.edittext;
        this.axios.post("https://uatchat-manage.one.th/manage" + '/editnote', {
          note_id: this.note_id,
          tokenuser: this.token,
          text: this.edittext
        }).then(function (response) {
          if (response.data.status === 'success') {
            // console.log(response.data)
            _this7.$emit('editNote', _this7.edittext, _this7.note_id);
          } else {
            // this.$swal('', 'เกิดความผิดปกติบางอย่างขึ้น ไม่สามารถแก้ไขโน๊ตนี้ได้ กรุณาลองใหม่ในภายหลัง', 'error')
            _this7.$swal('Network error', _this7.$t('Alert.Fail.default.networkError'), 'error');
          }
        }, function () {
          // this.$swal('', 'เกิดความผิดปกติบางอย่างขึ้น ไม่สามารถแก้ไขโน๊ตนี้ได้ กรุณาลองใหม่ในภายหลัง', 'error')
          _this7.$swal('Network error', _this7.$t('Alert.Fail.default.networkError'), 'error');
        });
      }
    },
    cancel: function cancel() {
      this.edit = false;
      this.files = [];
      this.add_image = false;
      this.delete_image = false;
      this.edittext = this.preedittext;
      this.selected = [];
    },
    date: function date(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    time: function time(timestamp) {
      return services["c" /* Momenttime */].momenttimethai(timestamp);
    },
    convert: function convert(msg) {
      var text = msg;
      var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/\\%?=~_|!:,.;]*[-A-Z0-9+&@#/\\%=~_|])/ig;
      var text1 = text.replace(/</g, '&lt;');
      var text2 = text1.replace(/>/g, '&gt;');
      var text3 = text2.replace(exp, '<a target="_blank" href="$1">$1</a>');
      var exp2 = /(^|[^/\\])(www\.[\S]+(\b|$))/gim;
      var text4 = text3.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
      return text4;
    },
    extension: function extension(files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase();
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
      var pdf = ['pdf'];
      var file = ['ai', 'ps', 'psd'];
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm'];
      var presentation = ['ppt', 'pps', 'pot', 'pptx'];
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff'];
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf';
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive';
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel';
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint';
      } else if (word.includes(extension)) {
        return 'fas fa-file-word';
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code';
      } else if (image.includes(extension)) {
        return 'fas fa-file-image';
      } else if (file.includes(extension)) {
        return 'fas fa-file';
      } else {
        return 'fas fa-file-alt';
      }
      // return extension[extension.length-1]
    },
    handleFilesUpload: function handleFilesUpload(key) {
      var uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({
          file: uploadedFiles[i],
          status: 'waiting'
        });
      }
      this.getImagePreviews(key);
      document.querySelector('#files').value = '';
    },
    removeFile: function removeFile(key) {
      this.files.splice(key, 1);
      this.getImagePreviews(key);
    },
    getImagePreviews: function getImagePreviews(key) {
      var _this8 = this;

      var _loop = function _loop(i) {
        if (/\.(jpe?g|png|gif)$/i.test(_this8.files[i].file.name)) {
          var reader = new FileReader();
          reader.addEventListener('load', function () {
            this.$refs['preview' + parseInt(i)][0].src = reader.result;
            // console.log(this.$refs['preview' + parseInt(i)][0].src = reader.result)
          }.bind(_this8), false);
          reader.readAsDataURL(_this8.files[i].file);
          // this.extension(this.files[i].name)
          // console.log(this.extension())
        } else {
            // this.$nextTick(function(){
            // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
            // });
            // console.log('mm')
          }
      };

      for (var i = 0; i < this.files.length; i++) {
        _loop(i);
      }
    }
  },
  watch: {
    selected: function selected() {
      // console.log(this.selected)
    },
    files: function files() {
      if (this.files.length > 5) {
        this.$swal('', this.$t('Alert.Fail.Album.maxFiles'), 'warning');
        _.pullAt(this.files, [5]);
      }
    },
    dialogAlbums: function dialogAlbums() {
      var _this9 = this;

      // console.log(this.albums_id)
      if (this.dialogAlbums) {
        // this.dataalbums.note_data.text = 'test'
        this.progress = true;
        this.status = 'progress';
        this.axios.post("https://uatchat-manage.one.th/event" + '/get_albums', {
          albums_id: this.albums_id,
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token
        }).then(function (response) {
          _this9.progress = false;
          _this9.status = 'show';
          // if (response.data.list_note.length !== 0) {
          _this9.infoalbums = response.data.data;
          _this9.albumsname = _this9.infoalbums.albums_name;
          // console.log(this.infoalbums.information)
          _this9.filter_infoalbum = _.filter(_this9.infoalbums.information, function (information) {
            return information.status === 'active';
          });
          // console.log(this.infoalbums)
          //   this.edittext = response.data.list_note[0].note_data.text
          //   this.preedittext = response.data.list_note[0].note_data.text
          // } else {
          //   this.progress = false
          //   this.status = 'error'
          //   this.errormessage = 'ขออภัย!! โน๊ตนี้ถูกลบแล้ว'
          // }
        }).catch(function (error) {
          _this9.status = 'error';
          if (error.response.data.status === 'fail') {
            _this9.errormessage = _this9.$t('Alert.Fail.Album.removed');
          }
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fd7f58e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/AlbumsDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"max-width":"500px","persistent":"","max-height":"500px"},model:{value:(_vm.dialogAlbums),callback:function ($$v) {_vm.dialogAlbums=$$v},expression:"dialogAlbums"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-images")]),_vm._v("  \n            "),(_vm.infoalbums.albums_name != '' && _vm.status == 'show')?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.infoalbums.albums_name)+" ("+_vm._s(_vm.filter_infoalbum.length)+")")]):(_vm.status == 'error')?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t('Dialog.album.noAlbum')))]):_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.date(_vm.infoalbums.create_date)))])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.edit && !_vm.edit_name && !_vm.delete_image && _vm.status != 'error')?_c('div',[_c('v-menu',{attrs:{"bottom":"","offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","flat":"","row":"","wrap":""},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"15px !important"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{staticStyle:{"width":"165px"}},[_c('v-list-tile',{on:{"click":function($event){_vm.edit = !_vm.edit}}},[_c('v-icon',{staticStyle:{"font-size":"15px"},attrs:{"color":"grey"}},[_vm._v("fas fa-plus-circle")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('Dialog.album.btnAddImage')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.edit_name = !_vm.edit_name}}},[_c('v-icon',{staticStyle:{"font-size":"15px"},attrs:{"color":"grey"}},[_vm._v("fas fa-edit")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('Dialog.album.btnEdit')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.delete_image = !_vm.delete_image}}},[_c('v-icon',{staticStyle:{"font-size":"15px"},attrs:{"color":"grey"}},[_vm._v("far fa-trash-alt")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('Dialog.album.btnRemoveImage')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.remove}},[_c('v-icon',{staticStyle:{"font-size":"15px"},attrs:{"color":"grey"}},[_vm._v("far fa-trash-alt")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('Dialog.album.btnRemoveAlbum')))])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"30px"}},[(_vm.status == 'progress')?_c('v-progress-linear',{attrs:{"indeterminate":_vm.progress}}):(_vm.status == 'show')?_c('div',[(_vm.filter_infoalbum.length != 0)?_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[_c('v-container',_vm._b({staticStyle:{"padding":"2px !important"},attrs:{"fluid":""}},'v-container',( _obj = {}, _obj["grid-list-sm"] = true, _obj ),false),[_c('v-layout',{staticStyle:{"overflow-y":"scroll!important","max-height":"45vh"},attrs:{"row":"","wrap":""}},_vm._l((_vm.filter_infoalbum),function(image,index){return _c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-media',{attrs:{"src":image.link,"height":"15vh"},on:{"click":function($event){_vm.showimagealbums(image)}}},[(_vm.delete_image)?_c('v-checkbox',{staticStyle:{"float":"right"},attrs:{"value":{'image_id':image.id, 'index': index},"color":"info"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e()],1)],1)],1)}))],1)],1):_c('v-layout',{attrs:{"column":"","wrap":"","align-center":"","justify-center":""}},[_c('img',{attrs:{"src":"/static/img/icons/image.png","width":"150px"}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('Dialog.album.noImageAlbum')))])]),_vm._v(" "),_c('div',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"200px","min-height":"100px","margin-top":"10px","word-break":"break-all"}},[(_vm.edit)?_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"height":"190px","overflow-y":"hidden","margin-top":"10px"}},[_c('div',[_c('form',{ref:"fileform",staticStyle:{"float":"left"}},[_c('label',[_c('b',{staticClass:"CSChatThai",staticStyle:{"text-decoration":"underline","cursor":"pointer","text-indent":"5em"}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.selectPicture')))]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"files","multiple":"","accept":".png, .jpg, .jpeg, .gif, .bmp, .wbmp"},on:{"change":function($event){_vm.handleFilesUpload()}}})])]),_vm._v(" "),(_vm.files.length > 0 )?_c('v-flex',{staticClass:"containers",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","height":"40vh !important","width":"100% !important","display":"-webkit-inline-box","padding-top":"3px"},attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((_vm.files),function(file,key){return _c('div',{staticClass:"borderfile",staticStyle:{"justify-content":"center","margin-left":"2vw","padding-top":"1vh"}},[_c('a',{staticClass:"close-classic",staticStyle:{"float":"right","padding-right":"10px","font-size":"20px"},on:{"click":function($event){_vm.removeFile( key )}}}),_vm._v(" "),(_vm.extension(file.file.name) == 'fas fa-file-image')?_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center"}},[_c('img',{ref:'preview'+parseInt( key ),refInFor:true,staticClass:"preview",staticStyle:{"height":"18vh !important","width":"20vh !important","display":"flex","justify-content":"center","border-radius":"10px","border-color":"#8080808f","border-style":"solid","border-width":"thin"}})]):_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center"}},[_c('v-icon',{staticStyle:{"font-size":"60px !important","color":"#1a222c","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(file.file.name)))])],1)])})):_vm._e()],1)])]):(_vm.edit_name)?_c('div',{staticStyle:{"width":"100%"}},[_c('v-text-field',{attrs:{"name":"albumsname","label":_vm.$t('Alert.Fail.Album.emptyName'),"id":"albumsname"},model:{value:(_vm.albumsname),callback:function ($$v) {_vm.albumsname=$$v},expression:"albumsname"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-btn',{staticClass:"btncancel",on:{"click":function($event){_vm.edit_name = !_vm.edit_name}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v("\n                  \n              "),_c('v-btn',{staticClass:"btnallow ml-2",attrs:{"loading":_vm.loading,"disabled":_vm.albumsname == ''},on:{"click":function($event){_vm.Edit_Name()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1):_vm._e()]),_vm._v(" "),_c('div',[(_vm.edit)?_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{staticStyle:{"padding-right":"10px"},attrs:{"align-center":"","justify-end":"","row":"","wrap":""}},[(_vm.edit)?_c('v-btn',{staticClass:"btncancel",attrs:{"dark":""},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[(_vm.edit)?_c('v-btn',{staticClass:"btnallow",attrs:{"loading":_vm.loading,"disabled":_vm.files.length == 0},on:{"click":function($event){_vm.addimage()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                ")]):_vm._e()],1)],1)],1):(_vm.delete_image)?_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{staticStyle:{"padding-right":"10px"},attrs:{"align-center":"","justify-end":"","row":"","wrap":""}},[(_vm.delete_image)?_c('v-btn',{staticClass:"btncancel",attrs:{"dark":""},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[(_vm.delete_image)?_c('v-btn',{staticClass:"btnallow",attrs:{"loading":_vm.loading,"disabled":_vm.selected.length == 0},on:{"click":function($event){_vm.deleteimage()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                ")]):_vm._e()],1)],1)],1):_vm._e()],1)],1):(_vm.status == 'error')?_c('div',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#757575 !important","font-size":"80px !important"}},[_vm._v("error_outline")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"font-size":"20px","color":"#757575"}},[_vm._v(" "+_vm._s(_vm.errormessage)+" ")])],1):_vm._e()],1)],1)],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_AlbumsDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/AlbumsDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("VFen")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fd7f58e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  AlbumsDialogMobile,
  dialog_AlbumsDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_AlbumsDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HaTd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/LoginDialog.vue
var LoginDialog = __webpack_require__("Jy2c");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-615ee24d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/LoginDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden !important"},attrs:{"persistent":"","max-width":"500px","max-height":"600px"},model:{value:(_vm.dialogLogin),callback:function ($$v) {_vm.dialogLogin=$$v},expression:"dialogLogin"}},[_c('v-card',[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('span',{staticClass:"headline CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("assignment_ind")]),_vm._v("  ยืนยันตัวตน\n           ")],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('v-container',{attrs:{"grid-md":"","text-xs-center":""}},[_c('v-layout',{staticStyle:{"align-items":"center"},attrs:{"row":"","justify-center":"true"}},[(_vm.progress)?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[(_vm.progress)?_c('v-progress-circular',{staticStyle:{"margin":"auto"},attrs:{"size":250,"width":10,"indeterminate":"","color":"blue"}}):_vm._e()],1):_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[(_vm.type=='first')?_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('p',{staticStyle:{"color":"white","font-weight":"bold"}},[_vm._v("ยินดีต้อนรับเข้าสู่ OneChat "),_c('br'),_vm._v("กรุณาเลือกรูปแบบการลงชื่อเข้าใช้งาน")]),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid",on:{"click":function($event){_vm.type='username'}}},[_vm._v("เข้าสู่ระบบด้วย OneID")]),_vm._v(" "),_c('span',{staticClass:"textor"},[_vm._v("  หรีอ  ")]),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid_white",staticStyle:{"margin-bottom":"30px"},on:{"click":function($event){_vm.type='phone'}}},[_vm._v("เข้าสู่ระบบด้วยเบอร์โทรศัพท์")])],1)],1)],1):(_vm.type=='phone')?_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":"เบอร์โทรศัพท์","mask":"###-###-####","prepend-inner-icon":"phone"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.otp()}},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid",staticStyle:{"margin-bottom":"30px","width":"40%"},attrs:{"disabled":_vm.phone === '',"loading":_vm.loading},on:{"click":function($event){_vm.otp()}}},[_vm._v("ขอ OTP")])],1),_vm._v(" "),_c('span',{staticClass:"textor"},[_vm._v("  หรีอ  ")]),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid_white",staticStyle:{"margin-bottom":"30px"},on:{"click":function($event){_vm.type='username'}}},[_vm._v("เข้าสู่ระบบด้วย OneID")])],1)],1):(_vm.type=='otp')?_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('p',{staticStyle:{"color":"white"}},[_vm._v("เบอร์โทร: "+_vm._s(_vm.phone))]),_vm._v(" "),(_vm.Refcode)?_c('p',{staticStyle:{"color":"white"}},[_vm._v("Refcode: "+_vm._s(_vm.Refcode))]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":"otp","maxlength":"6"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.loginWithotp()}},model:{value:(_vm.otpCode),callback:function ($$v) {_vm.otpCode=$$v},expression:"otpCode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-btn',{staticClass:"btnloginwebOneid_white",staticStyle:{"width":"40%","margin-top":"-24px !important"},attrs:{"depressed":"","disabled":_vm.counting},on:{"click":function($event){_vm.otp()}}},[(_vm.counting)?_c('countdown',{attrs:{"time":60000},on:{"end":_vm.handleCountdownEnd},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.totalSeconds)+" วินาที ")]}}])}):_vm._e(),_vm._v(" "),(!_vm.counting)?_c('span',[_vm._v("ส่ง OTP ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid",staticStyle:{"margin-bottom":"30px","width":"40%"},attrs:{"disabled":_vm.otpCode.length != 6},on:{"click":function($event){_vm.loginWithotp()}}},[_vm._v("เข้าสู่ระบบ")])],1),_vm._v(" "),_c('span',{staticClass:"textor"},[_vm._v("  หรีอ  ")]),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid_white",staticStyle:{"margin-bottom":"30px"},on:{"click":function($event){_vm.type='phone'}}},[_vm._v("เข้าสู่ระบบด้วย OneID")])],1)],1)],1):(_vm.type=='username')?_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":"ชื่อผู้ใช้งาน","prepend-inner-icon":"person"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()},"keypress":function($event){_vm.isNumandaz($event)}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"},attrs:{"solo":"","label":"รหัสผ่าน","type":_vm.showPassword ? 'text' : 'password',"prepend-inner-icon":"lock","append-icon":_vm.showPassword ? 'mdi-eye' : 'mdi-eye-off'},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()},"keypress":function($event){_vm.isnotthai($event)},"click:append":function($event){_vm.showPassword = !_vm.showPassword}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),(_vm.status == 'fail' )?_c('div',{staticStyle:{"color":"#f9a1a1","width":"100%"}},[_c('v-icon',{staticStyle:{"color":"#f9a1a1"}},[_vm._v("info")]),_vm._v(" "+_vm._s(_vm.failmessage)+" ")],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"btnloginweb",on:{"click":function($event){_vm.login()}}},[_vm._v("เข้าสู่ระบบ")])],1),_vm._v(" "),_c('span',{staticClass:"textor"},[_vm._v("  หรีอ  ")]),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid_white",staticStyle:{"margin-bottom":"30px"},on:{"click":function($event){_vm.type='phone'}}},[_vm._v("เข้าสู่ระบบด้วยเบอร์โทรศัพท์")])],1)],1)],1):_vm._e()],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_LoginDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/LoginDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("P/6R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-615ee24d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  LoginDialog["a" /* default */],
  dialog_LoginDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var chat_dialog_LoginDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hruy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/agora_call/ans_call_v2.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ans_call_v2 = ({
  props: {
    AgoraCallDialog: Boolean,
    infor_call: {},
    tokenuser: String,
    AgoraOption: String
  },
  data: function data() {
    return {};
  },

  watch: {
    AgoraCallDialog: function AgoraCallDialog() {
      var soundRingtone = document.getElementById('soundRingtone');
      if (this.AgoraCallDialog) {
        console.log(this.infor_call);
        // soundRingtone.currentTime = 0
        // soundRingtone.autoplay;
        soundRingtone.currentTime = 0;
        soundRingtone.play();
        // soundRingtone.loop = true
      } else {
        soundRingtone.currentTime = 0;
        soundRingtone.pause();
      }
    }
  },
  methods: {
    closedialog: function closedialog() {
      var soundRingtone = document.getElementById('soundRingtone');
      soundRingtone.pause();
      soundRingtone.currentTime = 0;
      // this.$emit('decline_call', this.infor_call)
      this.$emit('closeAgoraDialog', false);
    },
    accept_call: function accept_call() {
      window.open('/chat/room/call/' + this.AgoraOption + '/?token=' + services["b" /* Encode */].encodeToken(this.infor_call.agora_token) + '&channel_name=' + services["b" /* Encode */].encodeToken(this.infor_call.channel) + '&user_infor=' + services["b" /* Encode */].encode(this.infor_call), '_blank');
      this.$emit('closeAgoraDialog', false);
      var soundRingtone = document.getElementById('soundRingtone');
      soundRingtone.pause();
      soundRingtone.currentTime = 0;
      // this.axios.post(process.env.APIalpine + `/api/v1/join-agora`, {
      //   tokenroom: this.infor_call.tokenroom,
      //   tokenmessage: this.infor_call.tokenmessage,
      //   tokenuser: this.tokenuser
      // }).then((response) => {
      //   this.$emit('closeAgoraDialog', false)
      //   window.open(`/chat/room/${this.AgoraOption}/${this.infor_call.tokenroom}/?token=${Encode.encodeToken(response.data.token)}&channel_name=${Encode.encodeToken(this.infor_call.tokenmessage)}`, '_blank')
      // }).catch(error => {
      //   console.log(error)
      // })
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f704490a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/agora_call/ans_call_v2.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"width":"500","persistent":""},model:{value:(_vm.AgoraCallDialog),callback:function ($$v) {_vm.AgoraCallDialog=$$v},expression:"AgoraCallDialog"}},[_c('v-card',{staticStyle:{"height":"350px !important"}},[_c('v-card-text',[_c('v-layout',{staticStyle:{"height":"230px !important"},attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":100}},[(_vm.infor_call.picture)?_c('img',{staticClass:"img-w-h",attrs:{"src":_vm.infor_call.picture}}):_c('img',{staticClass:"img-w-h",attrs:{"src":"/static/img/default_profile/bot-white.png"}})]),_vm._v(" "),_c('h2',{staticClass:"text-overflow mt-3"},[_vm._v(_vm._s(_vm.infor_call.nickname))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"border-radius text-transform",attrs:{"color":"primary"},on:{"click":function($event){_vm.accept_call()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.conference.joinCall')))]),_vm._v(" "),_c('v-btn',{staticClass:"border-radius text-transform",attrs:{"dark":"","color":"red"},on:{"click":function($event){_vm.closedialog()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1)],1)],1)],1),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{attrs:{"id":"soundRingtone","loop":""}},[_c('source',{attrs:{"src":"/static/sound/sound_1.mp3","type":"audio/mpeg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var agora_call_ans_call_v2 = (esExports);
// CONCATENATED MODULE: ./src/components/chat/agora_call/ans_call_v2.vue
function injectStyle (ssrContext) {
  __webpack_require__("jg0w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ans_call_v2,
  agora_call_ans_call_v2,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var chat_agora_call_ans_call_v2 = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hwln":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_chat/MapDialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import {gmapApi} from 'vue2-google-maps'
// import google from 'vue2-google-maps'


/* harmony default export */ var MapDialog = ({
  props: { dialogSendMap: false },
  data: function data() {
    return {
      map: '',
      x: 15,
      y: 30,
      lat: '',
      lng: '',
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      places: [],
      currentPlace: null,
      address: ''
    };
  },
  created: function created() {
    // this.tokenuser = this.$cookie.get('tokenuser')
    // this.typeuser = localStorage.getItem('type_user')
    // this.axios.get('https://maps.googleapis.com/maps/api/place/details/json?key=AIzaSyA0hGnGEcqu2w2eN5XtNUJsNF2Ylv1Vl2g&placeid=ChIJ4ZnvKX274jARFsZN_d404sI').then((response) => {
    //   alert(response.data)
    // })
  },

  components: {
    // google
  },
  mounted: function mounted() {
    this.geolocate();
    // this.this.geolocate()()
  },

  watch: {},
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  methods: {
    closeDialogs: function closeDialogs() {
      // console.log('closeDialog')
      this.lat = '';
      this.lng = '';
      this.address = '';
      this.$emit('closeSendMap', false);
    },
    SendMap: function SendMap() {
      // console.log(this.lat, this.lng, this.address)
      this.$emit('send_location', this.lat, this.lng, this.address);
      this.closeDialogs();
    },
    setPlaceandAdd: function setPlaceandAdd(place) {
      this.currentPlace = place;
      this.addMarkerplace(this.currentPlace);
    },
    setPlace: function setPlace(place) {
      // console.log(place)
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker: function addMarker() {
      // console.log(this.currentPlace)
      if (this.currentPlace) {
        var marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.lat = this.currentPlace.geometry.location.lat();
        this.lng = this.currentPlace.geometry.location.lng();
        this.address = this.currentPlace.name + ' ' + this.currentPlace.formatted_address;
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },
    addMarkerplace: function addMarkerplace(place) {
      console.log(place);
      if (place) {
        var marker = {
          lat: place.latLng.lat(),
          lng: place.latLng.lng()
        };
        this.lat = place.latLng.lat();
        this.lng = place.latLng.lng();
        this.markers.push({ position: marker });
        this.places.push(place);
        this.center = marker;
        this.currentPlace = null;
      }
      // let self = this
      // var geocoder = new google.maps.Geocoder()
      // console.log(place.placeId)
      // geocoder.geocode({'placeId': 'ChIJyXhX4TYayUwRpj5vNT88SSU'}, function (results, status) {
      //   console.log(results, status)
      //   if (status === 'OK') {
      //     if (results[0]) {
      //       self.address = results[0].formatted_address
      //     }
      //   }
      // })
    },
    geolocate: function geolocate() {
      var _this = this;

      // console.log('geolocate')
      navigator.geolocation.getCurrentPosition(function (position) {
        var marker = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        _this.lat = position.coords.latitude;
        _this.lng = position.coords.longitude;
        // let self = this
        // var geocoder = new google.maps.Geocoder()
        // var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
        // console.log(latlng)
        // geocoder.geocode({'latLng': latlng}, function (results, status) {
        //   if (status === 'OK') {
        //     if (results[0]) {
        //       self.address = results[0].formatted_address
        //     }
        //   }
        // })
        _this.markers.push({ position: marker });
        // console.log(marker)
        _this.center = marker;
        _this.currentPlace = null;
      });
    }
    // init () {
    //   this.map = new longdo.Map({
    //     placeholder: document.getElementById('map'),
    //     lastView: false
    //   })
    //   this.map.Ui.Keyboard.enable(true)
    //   var control3 = new longdo.TagPanel()
    //   this.map.Ui.add(control3)
    //   this.map.Ui.Crosshair.visible(false)
    //   this.map.Ui.LayerSelector.visible(false)
    // },
    // pin () {
    //   this.sendmap.Overlays.clear()
    //   var loc = this.sendmap.location(longdo.LocationMode.Pointer)
    //   // console.log(loc)
    //   this.showloc = loc
    //   var marker = new longdo.Marker(loc, {
    //     icon: {
    //       url: '/static/img/icons/pin.png',
    //       // html: '<em>icon</em>',
    //       offset: { x: this.x, y: this.y }
    //     },
    //     clickable: true,
    //     weight: longdo.OverlayWeight.Top
    //   })
    //   this.sendmap.Overlays.add(marker)
    // }

  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d6b1839","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_chat/MapDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"500px","persistent":"","fullscreen":""},model:{value:(_vm.dialogSendMap),callback:function ($$v) {_vm.dialogSendMap=$$v},expression:"dialogSendMap"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("location_on")]),_vm._v("   "+_vm._s(_vm.$t('Dialog.map.header'))+" ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialogs}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"30px"}},[_c('div',{staticStyle:{"background":"white","padding-top":"2vh"}},[_c('label',[_c('gmap-autocomplete',{staticClass:"inputmapweb",staticStyle:{"width":"30vw"},attrs:{"placeholder":_vm.$t('Dialog.map.placeholder')},on:{"place_changed":_vm.setPlace}}),_vm._v(" "),_c('button',{staticClass:"btnmapweb",on:{"click":_vm.SendMap}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.send')))])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('gmap-map',{staticStyle:{"width":"100%","height":"400px"},attrs:{"center":_vm.center,"zoom":15},on:{"click":_vm.setPlaceandAdd}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":_vm.center,"clickable":true,"draggable":true}})}))],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var manage_chat_MapDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_chat/MapDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("c8fY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d6b1839"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MapDialog,
  manage_chat_MapDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_manage_chat_MapDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "INn0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IWN4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/consent/consent_onechat_dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var consent_onechat_dialog = ({
  props: {
    consentOnechatDialog: Boolean,
    url_consent: String
  },
  data: function data() {
    return {};
  },

  watch: {
    consentOnechatDialog: function consentOnechatDialog() {
      if (this.consentOnechatDialog) {
        // console.log(this.url_consent)
      }
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeDialogConsentOnechat', false);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61a3e843","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/consent/consent_onechat_dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"600px","persistent":""},model:{value:(_vm.consentOnechatDialog),callback:function ($$v) {_vm.consentOnechatDialog=$$v},expression:"consentOnechatDialog"}},[_c('v-card',{attrs:{"calss":"pa-0"}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('RightSide.header.privatepolicy')))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',{staticClass:"scrolling-wrapper-y",staticStyle:{"height":"550px","background-color":"#2463af"}},[_c('iframe',{staticStyle:{"visibility":"visible","justify-content":"center","align-items":"center","width":"100%"},attrs:{"width":"500","height":"550","frameborder":"0","src":_vm.url_consent,"allow":"geolocation"}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var consent_consent_onechat_dialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/consent/consent_onechat_dialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("8Xnh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61a3e843"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  consent_onechat_dialog,
  consent_consent_onechat_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_consent_consent_onechat_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IuMq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./node_modules/vue-avatar-editor-improved/src/index.js
var src = __webpack_require__("yraf");

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/settings/Editpictureprofile.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import VueAvatar from '@/components/VueAvatar';
// import adapter from 'webrtc-adapter'




/* harmony default export */ var Editpictureprofile = ({
  props: { 'dialogEditpictureprofile': false },
  data: function data() {
    return {
      // return {
      //   constraints: window.constraints = {
      //     audio: false,
      //     video: true
      //   },
      rotation: 0,
      scale: 1,
      profilepicture: ''
      // infor_image: {}
      // }
    };
  },
  components: {
    VueAvatar: src["a" /* VueAvatar */]
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {
    myprofilepicture: function myprofilepicture() {
      this.profilepicture = localStorage.getItem('profilepicture');
    },
    dialogEditpictureprofile: function dialogEditpictureprofile() {
      if (this.dialogEditpictureprofile) {
        this.$refs.vueavatar.loadImage(this.profilepicture);
      }
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      // this.onImageReady()
      var canvas = document.getElementById('avatarEditorCanvas');
      var context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      this.$refs.vueavatar.redraw();
      this.scale = 1;
      this.rotation = 0;
      this.$refs.vueavatar.imageChanged();
      this.$emit('closeEditpictureprofile', false);
    },
    saveClicked: function saveClicked() {
      var img = this.$refs.vueavatar.getImageScaled();
      var me = this;
      var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      // this.token = decoded['tokenuser']
      img.toBlob(function (blob) {
        var uploadFile = new FormData();
        uploadFile.append('file', blob, 'filename.png');
        uploadFile.append('tokenuser', decoded['tokenuser']);
        uploadFile.append('type_user', 'user');
        me.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/set-picture-profile', uploadFile).then(function (response) {
          if (response.data.status === 'success') {
            me.profilepicture = response.data.filename;
            localStorage.setItem('profilepicture', response.data.filename);
            me.myprofilepicture = response.data.filename;
            me.closeDialog();
          }
        });
      });
    },
    onImageReady: function onImageReady() {
      this.scale = 1;
      this.rotation = 0;
    }
  },
  created: function created() {
    this.profilepicture = localStorage.getItem('profilepicture');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de9a2e3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/settings/Editpictureprofile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialogEditpictureprofile),callback:function ($$v) {_vm.dialogEditpictureprofile=$$v},expression:"dialogEditpictureprofile"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai",staticStyle:{"white-space":"nowrap","width":"100%","overflow":"hidden","text-overflow":"ellipsis"}},[_c('span',{staticClass:"headline CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-tooltip-image")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.pictureProfile'))+"\n           ")],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('v-container',{staticStyle:{"padding":"20px !important","padding-top":"10px !important","padding-bottom":"10px !important"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('vue-avatar',{ref:"vueavatar",staticStyle:{"text-align":"center"},attrs:{"width":400,"height":400,"rotation":_vm.rotation,"scale":_vm.scale,"border":0,"image":_vm.profilepicture},on:{"vue-avatar-editor:image-ready":_vm.onImageReady}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-slider',{attrs:{"label":"Zoom :","min":"1","max":"3","step":"0.02","thumb-label":"always","ticks":""},model:{value:(_vm.scale),callback:function ($$v) {_vm.scale=$$v},expression:"scale"}}),_vm._v(" "),_c('v-slider',{attrs:{"label":"Rotation :","min":"0","max":"360","step":"1","thumb-label":"always","ticks":""},model:{value:(_vm.rotation),callback:function ($$v) {_vm.rotation=$$v},expression:"rotation"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"button_cancel",staticStyle:{"float":"right"},attrs:{"flat":"","small":"","dark":""},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"buttonedit",staticStyle:{"float":"right"},attrs:{"flat":"","small":"","dark":""},on:{"click":_vm.saveClicked}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.keep')))])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var settings_Editpictureprofile = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/settings/Editpictureprofile.vue
function injectStyle (ssrContext) {
  __webpack_require__("K76Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-de9a2e3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Editpictureprofile,
  settings_Editpictureprofile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_settings_Editpictureprofile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JOQw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_picture_input__ = __webpack_require__("2f0p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_avatar_editor_improved__ = __webpack_require__("yraf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_pathify__ = __webpack_require__("YtWf");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var _ = __webpack_require__("M4fF");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  props: {
    dialogwallpaper: false
  },
  components: {
    PictureInput: __WEBPACK_IMPORTED_MODULE_2_vue_picture_input__["a" /* default */],
    VueAvatar: __WEBPACK_IMPORTED_MODULE_4_vue_avatar_editor_improved__["a" /* VueAvatar */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex_pathify__["c" /* sync */])('*')),
  data: function data() {
    return {
      rotation: 0,
      scale: 1,
      tokenuser: '',
      tokenroom: '',
      imageData: '',
      wallpaperInfo: {
        info: [{
          room: '',
          background: ''
        }]
      },
      check: false,
      img: 'https://image.flaticon.com/icons/png/512/118/118246.png',
      canvasWidth: 0,
      canvasHeight: 0
    };
  },
  created: function created() {
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    this.tokenroom = this.$route.params.roomid;
  },

  methods: {
    resetbg: function resetbg() {
      var _this = this;

      this.$swal({
        type: 'warning',
        text: this.$t('Alert.Right.removeWallpaper'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#999999',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          var wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
          var room = _this.$route.params.roomid;
          var index = _.findIndex(wallpaper.info, function (o) {
            return o.room === room;
          });
          wallpaper.info.splice(index, 1);
          localStorage.setItem('wallpaperInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(wallpaper));
          _this.$swal('', _this.$t('Alert.Success.deletebackground'), 'success');
          _this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
          _this.closeDialog();
        }
      });
    },
    uppic: function uppic() {
      // console.log('obj')
      $('#uppic').click();
    },
    saveClicked: function saveClicked() {
      // var img = this.$refs.vueavatar.getImage()
      // this.$refs.image.src = img.toDataURL();
      // this.setbg(img.toDataURL())
      var vm = this;
      var canvas = this.$refs.vueavatar.getImageScaled();
      canvas.toBlob(function (blob) {
        var reader = new FileReader();
        reader.onload = function (e) {
          vm.imageData = e.target.result;
          vm.setbg(vm.imageData);
        };
        reader.readAsDataURL(blob);
      });
    },
    onImageReady: function onImageReady() {
      var canvas = document.getElementById('avatarEditorCanvas');
      var context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      this.check = true;
      this.scale = 1;
      this.rotation = 0;
    },
    previewImage: function previewImage(event) {
      var _this2 = this;

      // console.log(event)
      var input = event.target;
      // console.log(input.files)
      // console.log(input.files[0])
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this2.imageData = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    setbg: function setbg(img) {
      this.imageData = img;
      // console.log(this.imageData)
      // console.log(this.$refs.vueavatar.getImageScaled())
      // this.img = this.$refs.vueavatar.getImageScaled()
      // this.imageData = this.img.toDataURL()
      var wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
      var room = this.$route.params.roomid;
      var index = _.findIndex(wallpaper.info, function (o) {
        return o.room === room;
      });
      if (index === -1) {
        wallpaper.info.push({
          room: this.$route.params.roomid,
          background: this.imageData
        });
        localStorage.setItem('wallpaperInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(wallpaper));
      } else {
        wallpaper.info.splice(index, 1);
        wallpaper.info.push({
          room: this.$route.params.roomid,
          background: this.imageData
        });
        localStorage.setItem('wallpaperInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(wallpaper));
      }
      this.imageData = '';
      this.$swal('', this.$t('Alert.Success.setbackground'), 'success');
      this.closeDialog();
      this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
    },
    closeDialog: function closeDialog() {
      // console.log(this.imageData)
      // this.canvasWidth = 0
      // this.canvasHeight = 0
      var canvas = document.getElementById('avatarEditorCanvas');
      var context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      this.$refs.vueavatar.state.image.resource = null;
      this.check = false;
      this.scale = 1;
      this.rotation = 0;
      this.imageData = '';
      this.$emit('closeWallpaper', false);
    },
    onChange: function onChange() {
      console.log('New picture selected!');
      if (this.$refs.pictureInput.image) {
        console.log('Picture loaded.');
      } else {
        console.log('FileReader API not supported: use the <form>, Luke!');
      }
    }
  },
  watch: {
    '$route.params.roomid': function $routeParamsRoomid() {
      if (JSON.parse(localStorage.getItem('wallpaperInfo')) === null) {
        localStorage.setItem('wallpaperInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.wallpaperInfo));
      }
    },
    dialogwallpaper: function dialogwallpaper() {
      // console.log(obj);
      this.check = false;
      this.imageData = '';
      var canvas = document.getElementById('avatarEditorCanvas');
      var context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      if (JSON.parse(localStorage.getItem('wallpaperInfo')) === null) {
        localStorage.setItem('wallpaperInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.wallpaperInfo));
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "JSpy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jy2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chenfengyuan_vue_countdown__ = __webpack_require__("aCbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chenfengyuan_vue_countdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__chenfengyuan_vue_countdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_homepage_Navbar__ = __webpack_require__("6n5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_pathify__ = __webpack_require__("YtWf");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import NewFooter from '@/components/home/NewFooter'
// import Vue from 'vue'


// import VueSocketio from 'vue-socket.io'
var _ = __webpack_require__("M4fF");
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_2__chenfengyuan_vue_countdown___default.a.name, __WEBPACK_IMPORTED_MODULE_2__chenfengyuan_vue_countdown___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dialogLogin: Boolean
  },
  data: function data() {
    var _this = this;

    return {

      usernameRules: [function (v) {
        return _this.regular_username_mobile();
      }],
      passwordRules: [function (v) {
        return _this.regular_pass_mobile();
      }],
      valid: '',
      username: '',
      password: '',
      status: '',
      friend: '',
      status_login: '',
      progress: false,
      failmessage: 'ชื่อผู้ใช้งาน หรือ รหัสผ่าน ไม่ถูกต้อง',
      webdev: "https://uatchat.one.th:8089/docs",
      showPassword: false,
      url_redirect: "https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect",
      validmobile: '',
      type: 'first',
      phone: '',
      otpCode: '',
      Refcode: '',
      mobile_ref_id: '',
      type_otp: '',
      counting: false,
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex_pathify__["c" /* sync */])('*')),
  created: function created() {},
  mounted: function mounted() {
    if (localStorage.tologin) {
      this.type = 'phone';
      this.phone = localStorage.tologin;
    }
  },

  methods: {
    open_link: function open_link(link) {
      window.open(link, '_blank');
    },
    closeDialog: function closeDialog() {
      this.progress = false;
      this.phone = '';
      this.username = '';
      this.password = '';
      this.type = 'first';
      this.$emit('closeLoginDialog', false);
    },
    handleCountdownEnd: function handleCountdownEnd() {
      this.OTP = '';
      this.counting = false;
    },
    otp: function otp() {
      var _this2 = this;

      this.loading = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/otp_login_and_regis', { phone: this.phone, type: 'login' }).then(function (response) {
        if (response.data['status'] === 'success') {
          // console.log(response.data)
          if (response.data.type_otp == 'login') {
            _this2.loading = false;
            _this2.Refcode = response.data.refcode;
            _this2.mobile_ref_id = response.data.mobile_ref_id;
            _this2.type_otp = response.data.type_otp;
            _this2.counting = true;
            _this2.type = "otp";
          } else {
            _this2.loading = false;
            _this2.phone = '';
            _this2.$swal('ขออภัย!', 'หมายเลขโทรศัพท์นี้ยังไม่ได้รับการลงทะเบียน กรุณาลงทะเบียนหรือกรอกหมายเลขโทรศัพท์อื่น', 'error');
          }
        } else if (response.data['message'] === 'No JSON object could be decoded') {
          _this2.loading = false;
          _this2.$swal('ขออภัย!', 'หมายเลขโทรศัพท์นี้ร้องขอ otp บ่อยเกินไป กรุณารอซักครู่แล้วเริ่มทำรายการใหม่', 'error');
        } else {
          _this2.status = 'fail';
          _this2.progress = false;
          // this.type='first'
          _this2.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.';
        }
      }, function (error) {
        console.log(error);
        _this2.status = 'fail';
        _this2.progress = false;
        _this2.type = 'first';
        _this2.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.';
      });
    },
    loginWithotp: function loginWithotp() {
      var _this3 = this;

      this.progress = true;
      var source = { type_otp: this.type_otp, phone: this.phone, otp: this.otpCode, mobile_ref_id: this.mobile_ref_id };
      this.axios.post("https://uatchat-manage.one.th/manage" + '/login_and_regis', source).then(function (response) {
        _this3.status = response.data['status'];
        // console.log(response.data)
        if (_this3.status === 'success') {
          var profile = response.data['account']['profile'];
          _this3.myprofilepicture = profile['profilepicture'];
          _this3.myname = profile['name'];
          _this3.$cookie.set('language', 'th');
          localStorage.setItem('Authenrization', __WEBPACK_IMPORTED_MODULE_4__services__["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
          localStorage.setItem('profilepicture', profile['profilepicture']);
          localStorage.setItem('name', profile['name']);
          localStorage.setItem('phone', profile['phone']);
          localStorage.setItem('email', profile['email']);
          localStorage.setItem('status', profile['status']);
          localStorage.setItem('type_user', profile['type']);
          if (profile['username'] === '' || profile['username'] === 'None') {
            localStorage.setItem('status_username', 'false');
          } else {
            localStorage.setItem('status_username', 'true');
          }
          _this3.progress = false;
          if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
            _this3.$router.push('/chat');
          } else {
            _this3.$router.push(localStorage.getItem('pathRoom'));
          }
          localStorage.removeItem("tologin");
          localStorage.removeItem("tologin_keep2");
        } else {
          _this3.$cookie.set('status_login', 'F');
          _this3.progress = false;
          _this3.$swal('ขออภัย!', 'กรอกรหัส OTP ไม่ถูกต้อง', 'error');
        }
        // this.status = response.data['status']
        if (_this3.status === 'success') {
          _this3.closeDialog();
        } else {
          _this3.$cookie.set('status_login', 'F');
          _this3.progress = false;
          _this3.$swal('ขออภัย!', 'กรอกรหัส OTP ไม่ถูกต้อง', 'error');
        }
      }, function (error) {
        console.log(error);
        _this3.status = 'fail';
        _this3.progress = false;
        _this3.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.';
      });
    },
    loginRedirect: function loginRedirect() {
      this.progress = true;
      window.open(this.url_redirect, '_parent');
    },
    redirectUrl: function redirectUrl(url) {
      try {
        var link = document.getElementById("iframename").contentWindow.location.href;
        // console.log(link)
        // console.log(_.includes(link, [process.env.redirect_url]))
        if (_.includes(link, ["https://uatchat.one.th/authorization/redirect"])) {
          window.open(link + '&passlogin=true', '_parent');
        }
      } catch (err) {
        console.log(err);
      }
    },
    regular_username_mobile: function regular_username_mobile() {
      // var str = this.username
      this.username = this.username.replace(/[^a-z-0-9@.]/i, '');
      this.username = this.username.toLowerCase();
    },
    regular_pass_mobile: function regular_pass_mobile() {
      this.password = this.password.replace(/^[ก-๛]+/i, '');
    },
    isNumandaz: function isNumandaz($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122) && keyCode != 46 && keyCode != 64) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    isnotthai: function isnotthai($event) {
      // console.log($event)
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // console.log(keyCode)
      if (keyCode >= 3585 && keyCode <= 3642 || keyCode >= 3647 && keyCode <= 3675) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    toNewTab: function toNewTab() {
      window.open(this.webdev, '_parent').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    isMobile: function isMobile() {
      if ($('#mobile').is(':hidden')) {
        return false;
      } else {
        return true;
      }
    },
    login: function login() {
      var _this4 = this;

      var addyear = 10;
      var newDate = new Date();
      newDate.setTime(newDate.getTime() + addyear * 365 * 24 * 60 * 60 * 1000);
      var expiresInTime = "expires=" + newDate.toUTCString();

      if (this.username === '' || this.password === '') {
        this.failmessage = 'กรุณากรอกชื่อผู้ใช้งานและรหัสผ่าน.';
      } else {
        this.progress = true;
        var source = __WEBPACK_IMPORTED_MODULE_4__services__["b" /* Encode */].encode({ 'username': this.username, 'password': this.password });
        this.axios.post("https://uatchat-manage.one.th/manage" + '/loginuserwithbusiness', { source: source }).then(function (response) {
          // console.log(response.data)
          _this4.status = response.data['status'];

          var profile = response.data['account']['profile'];
          _this4.myprofilepicture = profile['profilepicture'];
          _this4.myname = profile['name'];
          _this4.$cookie.set('language', 'th');
          localStorage.setItem('Authenrization', __WEBPACK_IMPORTED_MODULE_4__services__["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
          localStorage.setItem('profilepicture', profile['profilepicture']);
          localStorage.setItem('name', profile['name']);
          localStorage.setItem('phone', profile['phone']);
          localStorage.setItem('email', profile['email']);
          localStorage.setItem('status', profile['status']);
          localStorage.setItem('type_user', profile['type']);
          if (profile['username'] === '' || profile['username'] === 'None') {
            localStorage.setItem('status_username', 'false');
          } else {
            localStorage.setItem('status_username', 'true');
          }

          if (_this4.status === 'success') {
            _this4.closeDialog();
          } else {
            _this4.$cookie.set('status_login', 'F');
            _this4.progress = false;
            if (response.data['message'] === 'Wrong Username / Password') {
              _this4.failmessage = 'ชื่อผู้ใช้งานหรือรหัสผ่านผิด กรุณาตรวจสอบใหม่อีกครั้ง.';
            } else {
              _this4.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.';
            }
          }
        }, function (error) {
          console.log(error);
          _this4.status = 'fail';
          _this4.progress = false;
          _this4.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.';
        });
      }
    },
    searchFriend: function searchFriend(botid) {
      var _this5 = this;

      // console.log(`bot id : ${localStorage.getItem('botid_redirect')}`)
      if (localStorage.getItem('botid_redirect') !== null) {
        this.progress = true;
        var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
        this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend", {
          tokenbot: botid,
          tokenuser: decoded.tokenuser
        }).then(function (response) {
          _this5.progress = false;
          // console.log(response.data.listuser)
          if (response.data.listuser.length === 0) {
            if (window.innerWidth <= 960) {
              _this5.$router.push('/mobile/homepage');
            } else {
              _this5.$router.push('/chat');
            }
          } else {
            if (response.data.listuser.relation === 'friend') {
              localStorage.removeItem('botid_redirect');
              if (_this5.isMobile()) {
                _this5.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom);
              } else {
                _this5.$router.push('/chat/room/' + response.data.listuser.user.tokenroom);
              }
            } else {
              console.log('not friend');
              _this5.$router.push('/addbot/' + localStorage.getItem('botid_redirect'));
            }
          }
        }).catch(function (error) {
          console.log(error);
          localStorage.removeItem('botid_redirect');
          _this5.progress = false;
          // this.$swal('', 'ไม่มีข้อมูลบอทในระบบ กรุณาตรวจสอบข้อมูลให้ถูกต้อง', 'warning')
          if (window.innerWidth <= 960) {
            _this5.$router.push('/mobile/homepage');
          } else {
            _this5.$router.push('/chat');
          }
        });
      }
    }
  },
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_3__components_homepage_Navbar__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "K76Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KBma":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KeEH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_pathify__ = __webpack_require__("YtWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_100vh__ = __webpack_require__("hErE");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this,
        _ref;

    return _ref = {
      loading: false,
      phone: '',
      email: '',
      token: '',
      name: '',
      status: '',
      profilepicture: '',
      nameedit: '',
      statusedit: '',
      phoneedit: '',
      editname: false,
      editstatus: false,
      typeuser: '',
      alerterror: '',
      business_id: '',
      tokenuserQR: '',
      username: '',
      usernameedit: '',
      editusername: false,
      loadingname: false,
      password: '',
      confirmpassword: '',
      username_alerterror: '',
      password_alerterror: '',
      confirm_alerterror: '',
      editphone: false
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'phoneedit', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'chkUsernameDuplicate', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'msgUsernameDuplicate', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'e1', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'e2', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'usernameRules', [function (v) {
      return !!v || '' || _this.$t('Settings.messageError.UsernameRules1');
    }, function (v) {
      return !!v && v.length >= 6 || _this.$t('Settings.messageError.UsernameRules3');
    }, function (v) {
      return _this.checkUsernameDuplicate() || '';
    }, function (v) {
      return _this.regular_username_mobile();
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'passwordRules', [function (v) {
      return !!v || _this.$t('Settings.messageError.PasswordRules1');
    }, function (v) {
      return _this.regular_pass_mobile();
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'repasswordRules', [function (v) {
      return !!v || _this.$t('Settings.messageError.RePasswordRules1');
    }, function (v) {
      return v === _this.password || _this.$t('Settings.messageError.RePasswordRules2');
    }, function (v) {
      return _this.regular_repass_mobile();
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'status_username', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loadingUpdatePhone', false), _ref;
  },

  components: {
    vue100vh: __WEBPACK_IMPORTED_MODULE_4_vue_100vh__["a" /* default */]
  },
  methods: {
    regular_username_mobile: function regular_username_mobile() {
      this.username = this.username.replace(/[^a-z-0-9]/i, '');
      this.username = this.username.toLowerCase();
    },
    regular_pass_mobile: function regular_pass_mobile() {
      this.password = this.password.replace(/^[ก-๛]+/i, '');
    },
    regular_repass_mobile: function regular_repass_mobile() {
      this.confirmpassword = this.confirmpassword.replace(/^[ก-๛]+/i, '');
    },
    cancelusername: function cancelusername() {
      this.editusername = !this.editusername;
      // this.usernameedit = this.username
      this.username = '';
      this.password = '';
      this.confirmpassword = '';
    },
    updateusername: function updateusername() {
      var _this2 = this;

      var body = {
        'tokenuser': this.token,
        'username': this.username,
        'password': this.password
        // console.log(process.env.APImanage + '/set_username', body)
      };this.loadingname = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/set_username', body).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this2.$swal('', _this2.$t('Alert.Success.settingusername'), 'success');
          localStorage.setItem('status_username', 'true');
          _this2.status_username = 'true';
        } else {
          _this2.loadingname = false;
          _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
          localStorage.setItem('status_username', 'false');
          _this2.status_username = 'false';
          _this2.cancelusername();
        }
      }).catch(function (error) {
        console.log(error);
        _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
      });
    },
    checkData: function checkData() {
      return this.username === '' || this.password === '' || this.confirmpassword === '';
    },
    changeUsername: function changeUsername() {
      if (this.chkChangeUsername) {
        this.chkChangeUsername = false;
        this.msgUsernameDuplicate = [];
        this.chkUsernameDuplicate = false;
      }
    },
    checkUsernameDuplicate: function checkUsernameDuplicate() {
      var _this3 = this;

      // console.log(this.username)
      if (this.username !== '') {
        this.axios.get("https://testoneid.inet.co.th/api" + '/check_username?username=' + this.username).then(function (response) {
          // console.log(response.data)
          if (response.status === 200) {
            if (response.data.message === 'Success') {
              _this3.chkUsernameDuplicate = false;
              _this3.msgUsernameDuplicate = [];
            }
          }
        }, function (error) {
          if (error.response.status === 400) {
            if (error.response.data.errorMessage === 'username duplicate') {
              _this3.chkUsernameDuplicate = true;
              _this3.msgUsernameDuplicate = [_this3.$t('Settings.messageError.UsernameDuplicate')];
              _this3.valid = false;
            } else if (_this3.username === '') {
              _this3.msgUsernameDuplicate = [_this3.$t('Settings.messageError.UsernameRules1')];
            }
          }
        });
        return true;
      }
    },
    isNumandaz: function isNumandaz($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122)) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    isnotthai: function isnotthai($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode >= 3585 && keyCode <= 3642 || keyCode >= 3647 && keyCode <= 3675) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    toPage: function toPage(data) {
      this.$router.push(data);
    },
    uppictest: function uppictest() {
      $('#uploadpicprofilechat').click();
    },
    uppic: function uppic() {
      $('#uploadpicprofilechat').click();
    },
    cancelstatus: function cancelstatus() {
      this.editstatus = !this.editstatus;
      this.statusedit = this.status;
    },
    cancelname: function cancelname() {
      this.editname = !this.editname;
      this.nameedit = this.name;
    },
    updatename: function updatename() {
      var _this4 = this;

      this.editname = !this.editname;
      if (this.nameedit !== '') {
        this.loading = true;
        this.axios.post("https://uatchat-manage.one.th/manage" + '/setnameuser', { tokenuser: this.token, name: this.nameedit, business_id: this.business_id, type_user: this.typeuser }).then(function (response) {
          if (response.data.status === 'success') {
            _this4.name = _this4.nameedit;
            localStorage.setItem('name', _this4.nameedit);
            _this4.myname = _this4.nameedit;
            _this4.loading = false;
          }
        }, function (response) {});
      } else {
        this.nameedit = '';
        this.alerterror = 'กรุณากรอกชื่อผู้ใช้';
        this.editname = !this.editname;
        this.loading = false;
      }
    },
    updatestatus: function updatestatus() {
      var _this5 = this;

      this.loading = true;
      this.editstatus = !this.editstatus;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/setstatususer', { tokenuser: this.token, status: this.statusedit }).then(function (response) {
        if (response.data.status === 'success') {
          localStorage.setItem('status', _this5.statusedit);
          _this5.status = _this5.statusedit;
          _this5.loading = false;
        }
      }, function (response) {});
    },
    previewImageprofiles: function previewImageprofiles(data) {
      var _this6 = this;

      this.selectFile = data.target.files[0];
      var uploadFile = new FormData();
      uploadFile.append('file', this.selectFile, this.selectFile.name);
      uploadFile.append('tokenuser', this.token);
      uploadFile.append('business_id', this.business_id);
      uploadFile.append('type_user', this.typeuser);
      this.axios.post("https://uatchat-manage.one.th/manage" + '/setpictureprofileuser', uploadFile).then(function (response) {
        if (response.data.status === 'success') {
          _this6.profilepicture = response.data.filename;
          localStorage.setItem('profilepicture', _this6.profilepicture);
          _this6.myprofilepicture = _this6.profilepicture;
        }
      });
    },
    loadqr: function loadqr() {
      var cnvs = document.getElementById('downloadqr-profile');
      var button = document.getElementById('btn-download-profile');
      var dataURL = cnvs.toDataURL('image/png');
      button.href = dataURL;
    },
    disableupdatephone: function disableupdatephone() {
      if (this.phoneedit == '' || this.phoneedit == this.phone) {
        return true;
      } else {
        return false;
      }
    },
    updatephone: function updatephone() {
      var _this7 = this;

      this.loadingUpdatePhone = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/check_phone_login', {
        phone: this.phoneedit
      }).then(function (response) {
        // console.log(response.data.status)
        if (response.data.status === 'success') {
          _this7.loadingUpdatePhone = false;
          // console.log(response.data.message)
          if (response.data.message === 'non registered') {
            localStorage.typeAccount = true;
            // localStorage.phonRecent = this.phone
          } else if (response.data.message === 'registered') {
            localStorage.typeAccount = false;
            // localStorage.phonRecent = this.phone
          }
          localStorage.phonRecent = _this7.phone;
          localStorage.phoneEdit = _this7.phoneedit;
          _this7.editphone = !_this7.editphone;
          _this7.$router.push('/mobile/settings/profile/editphone');
        } else {}
      }).catch(function (err) {
        console.log(err);
      });
    },
    statusEditphone: function statusEditphone() {
      var _this8 = this;

      this.$swal({
        title: this.$t('Settings.messageEditPhone.ChangePhoneNumber'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        // console.log(result.value)
        if (result.value === true) {
          _this8.editphone = !_this8.editphone;
        } else {}
      });
    },
    cancelphone: function cancelphone() {
      this.editphone = !this.editphone;
      this.phoneedit = this.phone;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex_pathify__["c" /* sync */])('*')),
  watch: {
    myprofilepicture: function myprofilepicture() {
      this.profilepicture = localStorage.getItem('profilepicture');
    },
    myname: function myname() {
      this.name = localStorage.getItem('name');
    },
    mystatus: function mystatus() {
      this.status = localStorage.getItem('status');
    }
  },
  created: function created() {
    this.phone = localStorage.getItem('phone');
    this.email = localStorage.getItem('email');
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.status_username = localStorage.getItem('status_username');
    // this.status_username = 'true'
    // console.log(this.status_username)
    this.tokenuserQR = "https://uatchat.one.th" + '/qrcode/friend?id=' + btoa(this.token);
    this.name = localStorage.getItem('name');
    this.status = localStorage.getItem('status');
    this.profilepicture = localStorage.getItem('profilepicture');
    this.typeuser = localStorage.getItem('type_user');
    this.nameedit = this.name;
    this.phoneedit = this.phone;
    this.statusedit = this.status;
    this.business_id = localStorage.getItem('business_id');
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "KnS9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L6bM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LMel":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LNgp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LPTp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LW8+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/InviteGroupDialogMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState } from 'vuex'

/* harmony default export */ var InviteGroupDialogMobile = ({
  props: { dialogInvite: false, member: '', memberpending: '', group_id: '' },
  data: function data() {
    return {
      searchfriend: '',
      FriendList: [],
      token: '',
      selected: [],
      progress: false,
      business_id: '',
      businessidinvite: [],
      listmemberinvite: [],
      tokeninvite: [],
      typeuser: ''
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.business_id = localStorage.getItem('business_id');
    this.typeuser = localStorage.getItem('type_user');
  },

  computed: {
    FilterFriendList: function FilterFriendList() {
      var _this = this;

      if (this.searchfriend !== '' && this.searchfriend !== null) {
        return this.FriendList.filter(function (post) {
          return post.name.toLowerCase().includes(_this.searchfriend.toLowerCase());
        });
      } else {
        return this.FriendList;
      }
    }
  },
  watch: {
    dialogInvite: function dialogInvite() {
      if (this.dialogInvite) {
        this.getlist();
      }
    }
  },
  methods: {
    Close: function Close() {
      this.$emit('closeInvite', false);
      this.selected = [];
    },
    getlist: function getlist() {
      var _this2 = this;

      this.selected = [];
      var _ = __webpack_require__("M4fF");
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-friend', { tokenuser: this.token }).then(function (response) {
        _this2.FriendList = response.data['list_friend'];
        _this2.FriendList = _.differenceBy(_this2.FriendList, _this2.member, 'tokenuser');
        _this2.FriendList = _.differenceBy(_this2.FriendList, _this2.memberpending, 'tokenuser');
      });
    },

    // searchuser (data) {
    //   var _ = require('lodash')
    //   var user = []
    //   var list = this.FriendList
    //   _.forEach(data, function (value) {
    //     user.push(_.find(list, function (o) { return o.tokenuser === value }))
    //   })
    //   return user
    // },
    invitefriends: function invitefriends() {
      var _this3 = this;

      // for (var i = 0; i < this.selected.length; i++) {
      //   this.tokeninvite[i] = this.selected[i].tokenuser
      //   this.businessidinvite[i] = this.selected[i].business_id
      //   this.listmemberinvite[i] = {tokenuser: this.tokeninvite[i], business_id: this.businessidinvite[i]}
      //   if (i === this.selected.length - 1) {
      this.progress = true;
      // console.log(this.selected)
      // process.env.APIgo_api + '/v1/invite-group'
      // process.env.APImanage + '/invitemembergroup'
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/invite-group', { group_id: this.group_id, tokenuser: this.token, listmember: this.selected }).then(function (response) {
        if (response.data['status'] === 'success') {
          // console.log(response.data)
          _this3.progress = false;
          _this3.$swal('', _this3.$t('Alert.Success.inviteFriendGroup'), 'success');
          _this3.$emit('invitemembergroup');
          _this3.Close();
        } else {
          // console.log(response.data)
          _this3.progress = false;
          _this3.$swal('', _this3.$t('Alert.Fail.default.somethingWrong'), 'error');
          _this3.Close();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-538d5dd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/InviteGroupDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"500px","max-height":"350px"},model:{value:(_vm.dialogInvite),callback:function ($$v) {_vm.dialogInvite=$$v},expression:"dialogInvite"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("person_add")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.group.headerInvite')))],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.Close}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[(!_vm.progress)?_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"solo":"","append-icon":"search","label":_vm.$t('Dialog.group.searching'),"clearable":""},model:{value:(_vm.searchfriend),callback:function ($$v) {_vm.searchfriend=$$v},expression:"searchfriend"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(_vm.FilterFriendList.length != 0)?_c('v-list',{staticClass:"CSChatThai widthfull heightListSearch",staticStyle:{"padding":"0px","height":"160px"},attrs:{"two-line":""}},[_vm._l((_vm.FilterFriendList),function(item,index){return [_c('v-list-tile',{key:item.tokenuser,attrs:{"avatar":"","ripple":""}},[_c('v-list-tile-action',[_c('v-checkbox',{attrs:{"value":item.tokenuser},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_vm._v(" "),_c('v-list-tile-avatar',[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"textoverflow"},[_vm._v("\n                            "+_vm._s(item.name)+"\n                          ")])],1)],1),_vm._v(" "),(index + 1 < _vm.FriendList.length)?_c('v-divider',{key:index}):_vm._e()]})],2):_c('v-list',{staticStyle:{"justify-content":"center","display":"flex"}},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.progress}})],1)],1)],1)],1):_c('v-container',[_c('v-progress-linear',{attrs:{"indeterminate":_vm.progress}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{staticStyle:{"margin-right":"10px"},attrs:{"align-center":"","justify-end":"","row":"","wrap":""}},[_c('v-btn',{staticClass:"btncancel",on:{"click":function($event){_vm.Close()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[_c('v-btn',{staticClass:"btnallow",attrs:{"disabled":_vm.selected.length == 0},on:{"click":function($event){_vm.invitefriends()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_InviteGroupDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/InviteGroupDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("z+1B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-538d5dd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  InviteGroupDialogMobile,
  dialog_InviteGroupDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_InviteGroupDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ldof":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Liod":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LvjE":
/***/ (function(module, exports) {

module.exports = {"version":"2018g","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQob.c ME01.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|0121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00|32e5","Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|01232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00|20e4","Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|0123|-3tooq.U 18aoq.U 4i6N0","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|LMT CST CDT CWT CPT EST|66.s 60 50 50 50 50|01212345|-32B5R.w UFdR.w 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|LMT AST ADT AWT APT|3M.s 40 30 30 30|0121341|-3tokb.w 1nsqb.w 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 2en0|90e5","America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5","America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|LMT MST PST|7K.4 70 80|0121|-3togd.U 1jInd.U 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT|9h.E 90 80 80 80 70 80 70|01212134151676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|012323232323232323232323232323232323232323232323232323232323232323232323232343232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121212121565652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5","America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|012342525252525252525252525252525252676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|LMT EST EDT EWT EPT|5R.4 50 40 40 40|0121234121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B66.U UFd6.U 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5","America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.K 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.6 fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|LMT CST CDT CWT CPT|6i.g 60 50 50 50|0121234121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B5F.I UFdF.I 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|LMT SMT -05 -04 -03|4G.K 4G.K 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.e MJc0 fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452","America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|LMT CST EST EWT EPT EDT|5V 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-32B63 Avc3 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT|90.c 90 80 80 80 70 80 70|01212134151676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|-00 AEST AEDT +11|0 -a0 -b0 -b0|01210121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-2OPc0 Fb40 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|LMT CET CEST|-H -10 -20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32BcH Q4oH Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|LMT CST CDT|-85.H -80 -90|0121212121212121212121212121|-2M0U5.H 1zWo5.H Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00","Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212123434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azch.Q 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|18e5","Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azck.n 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|LMT IMT EET EEST +04 +03|-1T.Q -1U.U -20 -30 -40 -30|0123232323232323232323232323232323232323232323232323232345454545453232323232323232323232323232323232323232323232323232323232323235|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6K.K -6T.p -70 -7k -7u -90 -80|01234546|-2M0SK.K aILP.l 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Singapore|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so1u|56e5","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30","Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlA5.Q xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1zv xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry0d.8 xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1zv xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|LMT AEST AEDT|-9z.s -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109z.s Pk1z.s 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1zv xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PknP.s xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U RxXU.U xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlzE.Q xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PknI.o xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00","Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00","Europe/Dublin|LMT DMT IST GMT BST IST|p p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHbz 1ra20.l Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Etc/GMT-10|+10|-a0|0|","Etc/GMT-11|+11|-b0|0|","Etc/GMT-12|+12|-c0|0|","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Etc/GMT-7|+07|-70|0|","Etc/GMT-8|+08|-80|0|","Etc/GMT-9|+09|-90|0|","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+2|-02|20|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|LMT AMT NST +0120 +0020 CEST CET|-j.w -j.w -1j.w -1k -k -20 -10|0121212121212121212121212121212121212121212123434345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656|-5sHcj.w 3i200 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5","Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1M0 SNMh.u 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cWpg.k 12hbg.k 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|LMT CMT CET CEST|-O.k -O.k -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLAO.k 9Io0 SryO.k Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|LMT CET CEST CET CEST MSK MSD EEST EET +03|-1m -10 -20 -20 -30 -30 -40 -30 -20 -30|01212121212121343565656565656565657878787878787878787878787878787878787878787898|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5","Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|LMT PMT WET WEST WEMT CET CEST|-t.w -9.l 0 -10 -20 -10 -20|012323232323232323232323232323232323232323232323232343434343456565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3bQot.w ME0k.b cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQo8.l ME00 cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6","Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4","Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4bsoN.U 160LN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|LMT SET CET CEST|-1c.c -10.e -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3FyNc.c P80b.W DPb0.e TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|LMT CET CEST MSK MSD EET EEST|-1t.c -10 -20 -30 -40 -20 -30|0121212134343434343434343431565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3cWpt.c 20vCt.c 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|LMT +0220 EET MSK CEST CET MSD EEST|-2k.E -2k -20 -30 -20 -10 -40 -30|012345453636363636363636363637272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8Ok.E 1LUM0.E eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Christmas|LMT +07|-72.Q -70|01|-32oT2.Q|21e2","Indian/Cocos|LMT +0630|-6r.E -6u|01|-2OqSr.E|596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|LMT +11 -12 +12|-b9.k -b0 c0 -c0|0123|-2M0X9.k 2Lo09.k W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4","Pacific/Chuuk|LMT +10|-a7.8 -a0|01|-2M0W7.8|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|LMT -12 -11 +13|bo.k c0 b0 -d0|0123|-2M0Az.E 3bIMz.E B7X0|1","Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0|88e4","Pacific/Funafuti|LMT +12|-bU.Q -c0|01|-2M0XU.Q|45e2","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|LMT LMT GST ChST|el -9D -a0 -a0|0123|-54m9D 2glc0 43qnD|17e4","Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2","Pacific/Kosrae|LMT +11 +12|-aP.U -b0 -c0|0121|-2M0WP.U 2LnXP.U 1bdz0|66e2","Pacific/Majuro|LMT +11 +12|-bo.M -b0 -c0|012|-2M0Xo.M 2Lo0o.M|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|LMT -1120 -1130 -11|bj.E bk bu b0|0123|-2M0AE.k 21IM0.k 17y0a|12e2","Pacific/Norfolk|LMT +1112 +1130 +1230 +11|-bb.Q -bc -bu -cu -b0|012324|-2M0Xb.Q 21ILX.Q W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|LMT +09|-8V.U -90|01|-2M0UV.U|21e3","Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56","Pacific/Pohnpei|LMT +11|-aw.Q -b0|01|-2M0Ww.Q|34e3","Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4","Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-2M0Bk.U 39zzO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.k -ck -d0 -e0|01232323232|-2M10j.k 1BnXX.k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","Pacific/Wake|LMT +12|-b6.s -c0|01|-2M0X6.s|16e3","Pacific/Wallis|LMT +12|-cf.k -c0|01|-2M10f.k|94","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Singapore|Singapore","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Pohnpei|Pacific/Ponape"]}

/***/ }),

/***/ "MBWy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chat_dialog_ShowImage_ProfileDialog__ = __webpack_require__("sVBg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__("+vOg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _ = __webpack_require__("M4fF");
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dialogAlbums: false,
    albums_id: ''
  },
  data: function data() {
    return {
      dataalbums: {
        note_data: {
          text: ''
        }
      },
      show: false,
      token: '',
      edit: false,
      edittext: '',
      preedittext: '',
      progress: true,
      status: 'show',
      errormessage: '',
      infoalbums: [],
      albumsname: '',
      files: [],
      edit_name: false,
      add_image: false,
      new_name: '',
      loading: false,
      delete_image: false,
      selected: [],
      filter_infoalbum: [],
      path_pic: '',
      picSend: '',
      nicknameSend: '',
      filenameSend: '',
      dateSend: '',
      timeSend: '',
      tokenmsgSend: '',
      pathSend: '',
      typeuserSend: '',
      typeuser: '',
      pathpicture: '',
      typepathpicture: '',
      dialogshowimage_profile: false,
      dragAndDropCapable: false,
      borderinputfile: 'text-align:center;border: 1px solid #00000036; border-radius: 5px; width: 100px !important; height: 100px !important; position: relative; background: white;justify-content: center; margin-right: 10px; cursor: pointer;padding-top: 23px;',
      normal: 'text-align:center; border-radius: 5px; width: 100px !important; height: 100px !important; position: relative; background: white;justify-content: center; margin-right: 10px; cursor: pointer;padding-top: 23px;'
    };
  },
  created: function created() {
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },

  components: {
    ShowImageProfileDialog: __WEBPACK_IMPORTED_MODULE_0__components_chat_dialog_ShowImage_ProfileDialog__["a" /* default */]
  },
  methods: {
    clickedit: function clickedit() {
      this.edit = !this.edit;
      this.show = false;
    },
    clickeditname: function clickeditname() {
      this.edit_name = !this.edit_name;
      this.show = false;
    },
    clickdeleteimage: function clickdeleteimage() {
      this.delete_image = !this.delete_image;
      this.show = false;
    },
    determineDragAndDropCapable: function determineDragAndDropCapable() {
      // console.log('determineDragAndDropCapable')
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
    },
    dateMoment: function dateMoment(data) {
      return __WEBPACK_IMPORTED_MODULE_1__services__["c" /* Momenttime */].momentdatethai(data);
    },
    timeMoment: function timeMoment(data) {
      return __WEBPACK_IMPORTED_MODULE_1__services__["c" /* Momenttime */].momenttimethai(data);
    },
    zoom: function zoom(item) {
      // console.log(item)
      this.pathpicture = item.link;
      this.typepathpicture = 'none';
      this.dialogshowimage_profile = true;
    },
    closeDialogShowImage_Profile: function closeDialogShowImage_Profile(value) {
      this.dialogshowimage_profile = value;
    },
    deleteimage: function deleteimage() {
      var _this = this;

      var imageid = [];
      var index_image = [];
      for (var i = 0; i < this.selected.length; i++) {
        imageid[i] = this.selected[i]['image_id'];
        index_image[i] = this.selected[i]['index'];
      }
      if (this.selected.length !== 0) {
        this.$swal({
          text: this.$t('Alert.Album.deleteImage'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2562af',
          cancelButtonColor: '#9f9f9f',
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-success',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then(function (result) {
          // console.log(result.value)
          if (result.value) {
            _this.loading = true;
            _this.axios.post("https://uatchat-manage.one.th/event" + '/delete_image_albums', {
              tokenuser: _this.token,
              tokenroom: _this.$route.params.roomid,
              albums_id: _this.albums_id,
              images_id: imageid
            }).then(function (response) {
              _this.loading = false;
              for (var i = 0; i < index_image.length; i++) {
                var index = _this.selected[i]['index'];
                // console.log(this.filter_infoalbum[index]['status'])
                _this.filter_infoalbum[index]['status'] = 'delete';
              }
              // localStorage.setItem('albums_id', this.albums_id)
              _this.filter_infoalbum = _.filter(_this.filter_infoalbum, function (filter_infoalbum) {
                return filter_infoalbum.status === 'active';
              });
              _this.$emit('editAlbums', { 'event': 'delete_image', 'albums_id': _this.albums_id, 'index_image': index_image, 'image_id': imageid });
              _this.$swal('', _this.$t('Alert.Success.removePhoto'), 'success');
              _this.selected = [];
              imageid = [];
              index_image = [];
              _this.delete_image = false;
            });
          } else {
            console.log('else');
            _this.selected = [];
            imageid = [];
            index_image = [];
            _this.delete_image = false;
          }
        });
      } else {
        this.$swal('', this.$t('Alert.Fail.Album.minFiles'), 'warning');
      }
    },
    addimage: function addimage() {
      var _this2 = this;

      var formData = new FormData();
      var lengthfile = this.files.length;
      var sizealums = [];
      for (var i = 0; i < lengthfile; i++) {
        var file = this.files[i].file;
        formData.append('file[]', file, file.name);
        sizealums[i] = this.files[i].file.size;
        // console.log(file)
      }
      if (_.sum(sizealums) / 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Album.maxSizeFile'), type: 'warning' });
        this.files = [];
        this.loading = false;
      } else {
        this.loading = true;
        formData.append('tokenuser', this.token);
        formData.append('tokenroom', this.$route.params.roomid);
        formData.append('albums_id', this.albums_id);
        this.axios.post("https://uatchat-manage.one.th/event" + '/addimage_albums', formData).then(function (response) {
          _this2.loading = false;
          var infoalbums = {};
          infoalbums = response.data.data.image_add;
          _this2.$swal('', _this2.$t('Alert.Success.savePhotoAlbum'), 'success');
          _this2.files = [];
          _this2.edit = false;
          _this2.$emit('closeAlbums', false);
        }, function () {
          _this2.loading = false;
          _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
        });
      }
    },
    Edit_Name: function Edit_Name() {
      var _this3 = this;

      this.new_name = this.albumsname;
      this.loading = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/edit_albums_name', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        albums_id: this.albums_id,
        new_name: this.new_name
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status) {
          _this3.loading = false;
          _this3.$swal('', _this3.$t('Alert.Success.renameAlbum'), 'success');
          _this3.infoalbums.albums_name = _this3.new_name;
          _this3.edit_name = false;
          _this3.$emit('editAlbums', { 'event': 'edit_name', 'albums_name': _this3.albumsname, 'albums_id': _this3.albums_id });
        } else {
          _this3.loading = false;
          _this3.$swal('', _this3.$t('Alert.Fail.default.somethingWrong'), 'warning');
        }
      }).catch(function (err) {
        // console.log(err)
        _this3.loading = false;
        if (err.response.data.message === 'New albums name cannot null.') {
          _this3.$swal('', _this3.$t('Alert.Fail.Album.emptyName'), 'warning');
        }
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('closeAlbums', false);
      this.edit = false;
      this.edit_name = false;
      this.delete_image = false;
      this.files = [];
    },
    remove: function remove() {
      var _this4 = this;

      this.show = false;
      this.$swal({
        text: this.$t('Alert.Album.deleteAlbum'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this4.axios.post("https://uatchat-manage.one.th/event" + '/delete_albums', {
            albums_id: _this4.albums_id,
            tokenuser: _this4.token,
            tokenroom: _this4.$route.params.roomid
          }).then(function (response) {
            if (response.data.status === 'success') {
              _this4.status = 'error';
              _this4.errormessage = _this4.$t('Alert.Fail.Album.removed');
              _this4.$emit('removeAlbums', _this4.albums_id);
              _this4.closeDialog();
            } else {
              _this4.$swal('', _this4.$t('Alert.Fail.default.somethingWrong'), 'error');
            }
          });
        }
      });
    },
    save: function save() {
      var _this5 = this;

      this.edit = false;
      if (this.edittext !== this.preedittext) {
        this.dataalbums.note_data.text = this.edittext;
        this.preedittext = this.edittext;
        this.axios.post("https://uatchat-manage.one.th/manage" + '/editnote', {
          note_id: this.note_id,
          tokenuser: this.token,
          text: this.edittext
        }).then(function (response) {
          if (response.data.status === 'success') {
            // console.log(response.data)
            _this5.$emit('editNote', _this5.edittext, _this5.note_id);
          } else {
            _this5.$swal('', _this5.$t('Alert.Fail.default.somethingWrong'), 'error');
          }
        }, function () {
          _this5.$swal('', _this5.$t('Alert.Fail.default.somethingWrong'), 'error');
        });
      }
    },
    cancel: function cancel() {
      this.selected = [];
      this.edit = false;
      this.files = [];
      this.add_image = false;
      this.delete_image = false;
      this.edittext = this.preedittext;
    },
    date: function date(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_1__services__["c" /* Momenttime */].momentdatethai(timestamp);
    },
    time: function time(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_1__services__["c" /* Momenttime */].momenttimethai(timestamp);
    },
    convert: function convert(msg) {
      var text = msg;
      var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/\\%?=~_|!:,.;]*[-A-Z0-9+&@#/\\%=~_|])/ig;
      var text1 = text.replace(/</g, '&lt;');
      var text2 = text1.replace(/>/g, '&gt;');
      var text3 = text2.replace(exp, '<a target="_blank" href="$1">$1</a>');
      var exp2 = /(^|[^/\\])(www\.[\S]+(\b|$))/gim;
      var text4 = text3.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
      return text4;
    },
    extension: function extension(files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase();
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
      var pdf = ['pdf'];
      var file = ['ai', 'ps', 'psd'];
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm'];
      var presentation = ['ppt', 'pps', 'pot', 'pptx'];
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff'];
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf';
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive';
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel';
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint';
      } else if (word.includes(extension)) {
        return 'fas fa-file-word';
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code';
      } else if (image.includes(extension)) {
        return 'fas fa-file-image';
      } else if (file.includes(extension)) {
        return 'fas fa-file';
      } else {
        return 'fas fa-file-alt';
      }
      // return extension[extension.length-1]
    },
    uppic: function uppic() {
      $('#filesAlbum').click();
    },
    handleFilesAlbumUpload: function handleFilesAlbumUpload(key) {
      // console.log('handleFilesAlbumUpload')
      var uploadedFiles = this.$refs.filesAlbum.files;
      // console.log(uploadedFiles)
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({
          file: uploadedFiles[i],
          status: 'waiting'
        });
      }
      this.getImagePreviews(key);
      document.querySelector('#filesAlbum').value = '';
    },
    removeFile: function removeFile(key) {
      this.files.splice(key, 1);
      this.getImagePreviews(key);
    },
    getImagePreviews: function getImagePreviews(key) {
      var _this6 = this;

      var _loop = function _loop(i) {
        if (/\.(jpe?g|png|gif)$/i.test(_this6.files[i].file.name)) {
          var reader = new FileReader();
          reader.addEventListener('load', function () {
            this.$refs['preview' + parseInt(i)][0].src = reader.result;
          }.bind(_this6), false);
          reader.readAsDataURL(_this6.files[i].file);
        } else {
          _this6.removeFile(i);
          alert(_this6.$t('Alert.Fail.Album.supportType'));
        }
      };

      for (var i = 0; i < this.files.length; i++) {
        _loop(i);
      }
    },
    noneF: function noneF(value) {}
  },
  watch: {
    edit: function edit() {
      // console.log(this.selected)
      if (this.edit) {
        this.dragAndDropCapable = this.determineDragAndDropCapable();
        var me = this;
        // console.log(this.dragAndDropCapable)
        if (this.dragAndDropCapable) {
          ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
            this.$refs.fileformalbum.addEventListener(evt, function (e) {
              e.preventDefault();
              e.stopPropagation();
            });
          }.bind(this));
          this.$refs.fileformalbum.addEventListener('dragover', function (e) {
            // console.log('dragover')
            this.borderinputfile = this.normal + 'border: 2px dotted #00000036;';
          }.bind(this));
          this.$refs.fileformalbum.addEventListener('dragleave', function (e) {
            // console.log('dragleave')
            this.borderinputfile = this.normal + 'border: 1px solid #00000036;';
          }.bind(this));
          this.$refs.fileformalbum.addEventListener('drop', function (e) {
            // console.log('drop')
            for (var i = 0; i < e.dataTransfer.files.length; i++) {
              this.files.push({ file: e.dataTransfer.files[i], status: 'waiting' });
              this.getImagePreviews();
              this.borderinputfile = this.normal + 'border: 1px solid #00000036;';
              // }
            }
          }.bind(this));
        }
      }
    },
    files: function files() {
      if (this.files.length > 5) {
        this.$swal('', this.$t('Alert.Fail.Album.maxFiles'), 'warning');
        _.pullAt(this.files, [5]);
      }
    },
    dialogAlbums: function dialogAlbums() {
      var _this7 = this;

      // console.log(this.albums_id)
      if (this.dialogAlbums) {
        // this.dataalbums.note_data.text = 'test'
        this.progress = true;
        this.status = 'progress';
        this.axios.post("https://uatchat-manage.one.th/event" + '/get_albums', {
          albums_id: this.albums_id,
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token
        }).then(function (response) {
          _this7.progress = false;
          _this7.status = 'show';
          _this7.infoalbums = response.data.data;
          _this7.albumsname = _this7.infoalbums.albums_name;
          _this7.filter_infoalbum = _.filter(_this7.infoalbums.information, function (information) {
            return information.status === 'active';
          });
        }).catch(function (error) {
          _this7.status = 'error';
          if (error.response.data.status === 'fail') {
            _this7.errormessage = _this7.$t('Alert.Fail.Album.removed');
          }
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "MnUx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mstj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N3ma":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NDrL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pdf__ = __webpack_require__("dAhr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_offline__ = __webpack_require__("mbt8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chat_dialog_notes_NoteDialog__ = __webpack_require__("0j5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_chat_dialog_manage_chat_AccountDialog__ = __webpack_require__("32Ju");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_chat_dialog_LoginDialog__ = __webpack_require__("HaTd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_chat_dialog_manage_chat_ForwardDialog__ = __webpack_require__("cGNK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_chat_dialog_manage_chat_MapDialog__ = __webpack_require__("Hwln");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_chat_dialog_manage_chat_ApproveDialog__ = __webpack_require__("OCah");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_chat_dialog_albums_AlbumsDialog__ = __webpack_require__("xh2Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_chat_dialog_albums_AddImageDialog__ = __webpack_require__("at4G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_chat_dialog_settings_Openwebsite__ = __webpack_require__("gDCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_chat_dialog_ShowImageDialog__ = __webpack_require__("fIB/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_chat_dialog_ShowPDFDialog__ = __webpack_require__("blpm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_chat_dialog_mail_CreatemailDialog__ = __webpack_require__("qkiP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_chat_dialog_manage_chat_WebviewBigDialog__ = __webpack_require__("khKU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_chat_dialog_manage_chat_WebviewBigOcrDialog__ = __webpack_require__("aj2r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_chat_manage_task_detail_task_dialog__ = __webpack_require__("l1Ae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_chat_dialog_saveonebox_SaveoneboxDialog__ = __webpack_require__("rTZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_chat_dialog_richmenu_Richmenudialog__ = __webpack_require__("BUqv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_chat_dialog_CheckBrowserDialog__ = __webpack_require__("Se0g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_chat_dialog_settings_ShowQRCodeUserDialog__ = __webpack_require__("wgae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_chat_agora_call_ans_call__ = __webpack_require__("07H3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_link_prevue__ = __webpack_require__("mo46");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_link_prevue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_link_prevue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_context__ = __webpack_require__("IaZh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_hls_player__ = __webpack_require__("VfTH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_hls_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_hls_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_highlightable_input__ = __webpack_require__("6IPY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_at__ = __webpack_require__("2RyS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_at_dist_vue_at_textarea__ = __webpack_require__("Ve+4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_at_dist_vue_at_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vue_at_dist_vue_at_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuex_pathify__ = __webpack_require__("YtWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_mention__ = __webpack_require__("Ddm3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_highlights__ = __webpack_require__("1t5/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_highlights___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vue_highlights__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// import WebviewDialog from '@/components/chat/dialog/manage_chat/WebviewDialog'


















// Vue.use(VueCoreVideoPlayer)

// import ModalImg from '@/components/chat/modal/ModalImg'




var emojiGroups = __webpack_require__("WJD3");
var _ = __webpack_require__("M4fF");



__WEBPACK_IMPORTED_MODULE_32_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_33_vue_highlights___default.a.name, __WEBPACK_IMPORTED_MODULE_33_vue_highlights___default.a);

window.EventBus = new __WEBPACK_IMPORTED_MODULE_32_vue__["default"]({
  methods: {
    emit: function emit(payload) {
      this.$emit('$EventBusEvent', payload);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AgoraCallDialog: __WEBPACK_IMPORTED_MODULE_23__components_chat_agora_call_ans_call__["a" /* default */],
    vplayer: __WEBPACK_IMPORTED_MODULE_26_vue_hls_player__["vplayer"],
    QrcodeDialog: __WEBPACK_IMPORTED_MODULE_22__components_chat_dialog_settings_ShowQRCodeUserDialog__["a" /* default */],
    CheckBrowserDialog: __WEBPACK_IMPORTED_MODULE_21__components_chat_dialog_CheckBrowserDialog__["a" /* default */],
    LoginDialog: __WEBPACK_IMPORTED_MODULE_6__components_chat_dialog_LoginDialog__["a" /* default */],
    pdf: __WEBPACK_IMPORTED_MODULE_1_vue_pdf__["a" /* default */],
    // ModalImg,
    offline: __WEBPACK_IMPORTED_MODULE_2_v_offline__["a" /* default */],
    MapDialog: __WEBPACK_IMPORTED_MODULE_8__components_chat_dialog_manage_chat_MapDialog__["a" /* default */],
    NoteDialog: __WEBPACK_IMPORTED_MODULE_4__components_chat_dialog_notes_NoteDialog__["a" /* default */],
    AccountDialog: __WEBPACK_IMPORTED_MODULE_5__components_chat_dialog_manage_chat_AccountDialog__["a" /* default */],
    ForwardDialog: __WEBPACK_IMPORTED_MODULE_7__components_chat_dialog_manage_chat_ForwardDialog__["a" /* default */],
    // WebviewDialog,
    WebviewBigDialog: __WEBPACK_IMPORTED_MODULE_16__components_chat_dialog_manage_chat_WebviewBigDialog__["a" /* default */],
    WebviewBigOcrDialog: __WEBPACK_IMPORTED_MODULE_17__components_chat_dialog_manage_chat_WebviewBigOcrDialog__["a" /* default */],
    ApproveDialog: __WEBPACK_IMPORTED_MODULE_9__components_chat_dialog_manage_chat_ApproveDialog__["a" /* default */],
    AlbumsDialog: __WEBPACK_IMPORTED_MODULE_10__components_chat_dialog_albums_AlbumsDialog__["a" /* default */],
    AddImageDialog: __WEBPACK_IMPORTED_MODULE_11__components_chat_dialog_albums_AddImageDialog__["a" /* default */],
    Openwebsite: __WEBPACK_IMPORTED_MODULE_12__components_chat_dialog_settings_Openwebsite__["a" /* default */],
    VueContext: __WEBPACK_IMPORTED_MODULE_25_vue_context__["VueContext"],
    ShowImageDialog: __WEBPACK_IMPORTED_MODULE_13__components_chat_dialog_ShowImageDialog__["a" /* default */],
    ShowPDFDialog: __WEBPACK_IMPORTED_MODULE_14__components_chat_dialog_ShowPDFDialog__["a" /* default */],
    CreatemailDialog: __WEBPACK_IMPORTED_MODULE_15__components_chat_dialog_mail_CreatemailDialog__["a" /* default */],
    DetailTask: __WEBPACK_IMPORTED_MODULE_18__components_chat_manage_task_detail_task_dialog__["a" /* default */],
    SaveOnebox: __WEBPACK_IMPORTED_MODULE_19__components_chat_dialog_saveonebox_SaveoneboxDialog__["a" /* default */],
    Richmenudialog: __WEBPACK_IMPORTED_MODULE_20__components_chat_dialog_richmenu_Richmenudialog__["a" /* default */],
    LinkPrevue: __WEBPACK_IMPORTED_MODULE_24_link_prevue___default.a,
    HighlightableInput: __WEBPACK_IMPORTED_MODULE_27_vue_highlightable_input__["a" /* default */],
    Mentionable: __WEBPACK_IMPORTED_MODULE_31_vue_mention__["a" /* Mentionable */],
    At: __WEBPACK_IMPORTED_MODULE_28_vue_at___default.a,
    AtTa: __WEBPACK_IMPORTED_MODULE_29_vue_at_dist_vue_at_textarea___default.a
    // shareContactDialog
  },
  props: {
    extractUrlsWithoutProtocol: {
      type: Boolean,
      default: true
    },
    caretColor: {
      type: String,
      default: '#ccc'
    },
    placeholder: {
      type: String,
      default: 'What\'s Happening?'
    },
    value: String
  },
  data: function data() {
    return {
      AgoraCallDialog: false,
      AgoraOption: '',
      infor_call: {},
      typeroom: '',
      typemenu: 'richmenu',
      QrcodeInfor: '',
      dialogShowQRCode: false,
      ocr_detailItem: '',
      checkBrowserInfor: {},
      checkBrowserDialog: false,
      center_markermap: {},
      quickreplyStyle: 'position: absolute !important;top: calc(98vh - 160px);',
      itemdetail_quickreply: {},
      bot_id_richmenu: '',
      default_behavior: 0,
      richmenu_label: '',
      list_richmenu: [],
      tokenuser_friend: '',
      type_richmenu: 0,
      Richmenudialog: false,
      inforrichmenu: {},
      sheetrichmenu: false,
      RichmenuState: false,
      tokenmessage_savebox: '',
      extionfile: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
      taskid: '',
      files: [],
      nameFile: 'picture.png',
      dialogDetailTask: false,
      SelectedMessageDetail: {},
      rightclickdialog: false,
      showmention: false,
      picturechip: '',
      chip: false,
      Webview_item: {},
      Webview_item_ocr: {},
      selectedForward: [],
      DetailFile: {},
      DetailImage: {},
      progressLoadChatBox: false,
      showloc: '',
      ForwardState: false,
      dialogSaveOnebox: false,
      dialogshowimage: false,
      dialogshowfile: false,
      dialogForward: false,
      dialogApprove: false,
      dialogAccount: false,
      dialogMap: false,
      dialogSendMap: false,
      dialogNote: false,
      dialogWebview: false,
      dialogWebviewbig: false,
      dialogWebviewbig_ocr: false,
      dialogAlbums: false,
      dialogAddImage: false,
      dialogCreatemail: false,
      dialogopenwebsite: false,
      dialogLogin: false,
      id: '',
      type: '',
      statemember: '',
      imgShow: false,
      // messageQuickreply: true,
      Quickreply: {},
      datepicker: false,
      timepicker: false,
      dateselect: '',
      maxdate: '',
      mindate: '',
      timeselect: '',
      maxtime: '',
      mintime: '',
      typepicker: '',
      infodata: '',
      box_height: '',
      note_id: '',
      tabs: ['tab-1', 'tab-2', 'tab-3'],
      model: 'tab-2',
      filepdf: '',
      // shareContact: false,
      currentPage: 1,
      pageCount: 0,
      scrollMaxOld: 0,
      // firsttime: true,
      statePage: '',
      profile: '',
      offsetTop: 0, // test scroll
      // dialog: false,
      tokenrooomSelect: '',
      // alert: true,
      items: [],
      sendmsg: '',
      name: '',
      selectFile: null,
      statusload: false,
      place: null,
      sheet: false,
      lat: '',
      lng: '',
      address: '',
      nicknameSend: '',
      filenameSend: '',
      timeSend: '',
      picSend: '',
      dateSend: '',
      tokenmsgSend: '',
      pathSend: '',
      typeuserSend: '',
      activeEmoji: null,
      activeSticker: null,
      activetapEmo: null,
      sheetother: false,
      sheetsticker: false,
      chatlogsFlex: '',
      showmessagebottom: false,
      showmessage: '',
      sticker: [{
        'list_sticker': []
      }],
      typeuser: '',
      progressLoadChat: false,
      emojiGroups: emojiGroups,
      map: '',
      x: 15,
      y: 30,
      locationArray: [],
      locationName: '',
      sendmap: '',
      windowWidth: '',
      temp: [],
      online: true,
      ApproveDetail: {},
      albums_id: '',
      ListMenuRightClick: [],
      listannounce: [],
      show: false,
      less: false,
      announcedialog: false,
      announce_message: {},
      dragAndDropCapable: false,
      roomid: '',
      imageData: '',
      RichmenuState_first: false,
      listfriend_filter: [],
      listfriend: [],
      status_tag: false,
      msg: '',
      bot_id: '',
      highlight: [],
      highlightEnabled: true,
      mentionUsers: '',
      length_listfreind: 0,
      text_search: '',
      content: null,
      item_freind: [],
      one_id: '',
      block: '',
      tokenuser: '',
      token: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_30_vuex_pathify__["c" /* sync */])('*')),
  mounted: function mounted() {
    var _this = this;

    // this.map = new longdo.Map({
    //   placeholder: document.getElementById('map'),
    //   lastView: true
    // })
    EventBus.$on('$EventBusEvent', this.handleEventBusEvent);

    this.dragAndDropCapable = this.determineDragAndDropCapable();

    if (this.dragAndDropCapable) {
      // console.log('this.dragAndDropCapable->' + this.dragAndDropCapable)
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
        this.$refs.fileformChat.addEventListener(evt, function (e) {
          // console.log(e)
          e.preventDefault();
          e.stopPropagation();
        });
      }.bind(this));
      // this.$refs.fileformChat.addEventListener('dragover', function (e) {
      //   // console.log('dragover')
      // }.bind(this))
      // this.$refs.fileformChat.addEventListener('dragleave', function (e) {
      //   // console.log('dragleave')
      // }.bind(this))
      this.$refs.fileformChat.addEventListener('drop', function (e) {
        this.onFileDrag(e.dataTransfer.files);
      }.bind(this));
    }
    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
    var me = this;
    $(document).click(function (event) {
      var target = $(event.target);
      if (!target.closest('#menu-chat').length && $('#menu-chat').is(":visible")) {
        me.sheetother = false;
        // $('#menu-chat').fadeOut(1600);
      } else if (!target.closest('#menu-sticker').length && $('#menu-sticker').is(":visible")) {
        me.sheetsticker = false;
        // $('#menu-sticker').fadeOut(1600);
      }
    });
  },

  watch: {
    block_friend: function block_friend(data) {
      // console.log(data)
      if (data.event === 'unblock_friend') {
        this.statemember = 'active';
      } else {
        this.statemember = 'block';
      }
    },

    // items () {
    //   console.log(this.items)
    // },
    // sendmsg () {

    // },
    showmention: function showmention() {
      if (this.showmention == true) {
        this.status_tag = false;
        // console.log('eeeee')
      }
    },
    files: function files() {
      if (this.files.length != 0) {
        // this.chatlogsFlex = 'height:calc(98vh - 310px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 275px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 245px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 275px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 245px);';
        }
      } else {
        // this.chatlogsFlex = 'height:calc(98vh - 185px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
        }
      }
    },
    socket_close_webview: function socket_close_webview(data) {
      console.log('socket_close_webview');
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        this.Webview_item = {};
        this.dialogWebviewbig = false;
      }
      // this.Webview_item = {}
      // this.dialogWebviewbig = false
    },
    socketexpire_login: function socketexpire_login(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.dialogLogin = true;
      }
    },
    socket_official_template: function socket_official_template(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        // console.log(data)
        var index_target = data.target_index;
        var index = _.findIndex(this.items, function (o) {
          return o.tokenmessage == data.tokenmessage;
        });
        this.items[index].element.choice[index_target].disable = '1';
        // console.log(index_target)
      }
    },
    chat_wallpaper: function chat_wallpaper() {
      // console.log(this.chat_wallpaper.info)
      var room = this.$route.params.roomid;
      var index = _.findIndex(this.chat_wallpaper.info, function (o) {
        return o.room === room;
      });
      // console.log(index)
      if (index === -1) {
        this.imageData = '';
      } else {
        this.imageData = this.chat_wallpaper.info[index].background;
      }
      this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');';
      this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
      // console.log(this.imageData)
    },
    less: function less() {
      if (this.less) {
        this.$cookie.set(this.$route.params.roomid, 'less');
      } else {
        this.$cookie.delete(this.$route.params.roomid);
      }
    },
    socket_announce: function socket_announce(data) {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_announce_room_by_id', {
        tokenuser: this.token,
        token_announce: data.token_announce,
        tokenroom: this.tokenrooomSelect
      }).then(function (response) {
        _this2.listannounce.unshift(response.data.data);
      });
    },
    box_height: function box_height() {
      if (this.imageData === '') {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;';
        this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
      } else {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');';
        this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
      }
    },
    selectedForward: function selectedForward() {
      if (this.selectedForward.length > 5) {
        this.$swal('', this.$t('Alert.Fail.Chat.maxMessage'), 'error');
        _.pullAt(this.selectedForward, [5]);
      }
    },
    windowWidth: function windowWidth() {
      if (this.windowWidth <= 960) {
        // this.$router.push('/mobile/room/' + this.$route.params.roomid)
        this.$router.push('/mobile/progress/' + this.$route.params.roomid);
      }
    },
    dialogMap: function dialogMap() {
      if (this.dialogMap) {
        // this.initmapShow()
      }
    },
    sheetrichmenu: function sheetrichmenu() {
      // console.log(this.RichmenuState)
      // console.log(this.sheetrichmenu)
      // console.log(this.type_richmenu <= 7)
      if (this.type_richmenu <= 7) {
        if (this.sheetrichmenu) {
          setTimeout(this.scrollDown, 1);
          if (this.imageData === '') {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 370px) !important; background-color: #fdfdfd;';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 351px);';
          } else {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 370px) !important; background-image: url(' + this.imageData + ');';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 351px);';
          }
        } else {
          if (this.imageData === '') {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-color: #fdfdfd;';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);';
          } else {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-image: url(' + this.imageData + ');';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);';
          }
        }
      } else {
        if (this.sheetrichmenu) {
          setTimeout(this.scrollDown, 1);
          if (this.imageData === '') {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 245px) !important; background-color: #fdfdfd;';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 215px);';
          } else {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 245px) !important; background-image: url(' + this.imageData + ');';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 215px);';
          }
        } else {
          if (this.imageData === '') {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-color: #fdfdfd;';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);';
          } else {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-image: url(' + this.imageData + ');';
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);';
          }
        }
      }
    },
    RichmenuState: function RichmenuState() {
      // console.log(this.RichmenuState)
      // console.log(this.sheetrichmenu)
      // console.log(this.type_richmenu <= 7)
      setTimeout(this.scrollDown, 1);
      if (!this.RichmenuState && !this.sheetrichmenu) {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 195px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 165px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 195px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 165px);';
        }
      } else if (this.RichmenuState && !this.sheetrichmenu) {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);';
        }
      }
    },
    sheetsticker: function sheetsticker() {
      if (this.sheetsticker) {
        // this.chatlogsFlex = 'height:calc(98vh - 310px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 310px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 280px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 310px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 280px);';
        }
      } else {
        // this.chatlogsFlex = 'height:calc(98vh - 185px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
        }
      }
    },
    sheetother: function sheetother() {
      if (this.sheetother) {
        // this.chatlogsFlex = 'height:calc(98vh - 260px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 260px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 230px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 260px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 230px);';
        }
      } else {
        // this.chatlogsFlex = 'height: calc(98vh - 185px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');';
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
        }
      }
    },
    myprofile: function myprofile() {
      this.profile = localStorage.getItem('profilepicture');
    },
    layout: function layout() {
      this.tokenrooomSelect = this.$route.params.roomid;
    },
    '$route.params.roomid': function $routeParamsRoomid() {
      this.less = false;
      this.scrollMaxOldSet();
      this.statusload = false;
      this.ForwardState = false;
      this.selectedForward = [];
      var container = this.$el.querySelector('#myscroll');
      container.scrollTop = container.scrollHeight;
      this.tokenrooomSelect = this.$route.params.roomid;
      this.items = [];
      this.Quickreply = [];
      this.RichmenuState = false;
      this.sheetrichmenu = false;
      this.inforrichmenu = {};
      this.type_richmenu = 0;
      this.sendmsg = '';
      this.status_tag = false;
      this.getlistfriend();
      this.getroom();
      // this.get_list_richmenu(this.$route.params.roomid)
      this.getOldMessage('');
      this.getreply();
      this.getlistannounce();
      var announce = this.$cookie.get(this.$route.params.roomid);
      // console.log(announce)
      if (announce !== null) {
        this.less = true;
      }
      this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
      // console.log(this.chat_wallpaper)
      var room = this.tokenrooomSelect;
      var index = _.findIndex(this.chat_wallpaper.info, function (o) {
        return o.room === room;
      });
      // console.log(index)
      if (index === -1) {
        this.imageData = '';
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;';
        this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
      } else {
        this.imageData = this.chat_wallpaper.info[index].background;
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');';
        this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);';
      }
    },
    socketmessage: function socketmessage() {
      // console.log(this.socketmessage)
      // if (this.socketmessage.typeofmessage === 'agora_call' && this.socketmessage.tokenuser !== this.token) {
      //   console.log(`open dialog call`)
      //   this.infor_call = this.socketmessage
      //   var me = this
      //   setTimeout(function() {
      //     me.AgoraOption = me.typeAgoraCall
      //     me.AgoraCallDialog = true
      //     console.log(me.AgoraCallDialog)
      //   }, 1000);
      // }
      // this.Quickreply = []
      this.getMessageSocket(this.socketmessage);
    },
    typeAgoraCall: function typeAgoraCall(data) {
      this.typeAgoraCall = data;
      console.log(this.typeAgoraCall);
    },
    socket_accept_call: function socket_accept_call(data) {
      console.log('acctpt call');
      // console.log(data)
      // if (data.status === 'success') {
      //   this.infor_call = {}
      //   this.AgoraCallDialog = false
      // }
      // this.infor_call = {}
      this.AgoraCallDialog = false;
    },
    socket_update_agora: function socket_update_agora(data) {
      console.log('update agora');
      // console.log(data)
      if (data.status === 'end' || data.status === 'cancel') {
        this.infor_call = {};
        this.AgoraCallDialog = false;
      }
    },
    socketremove_friend: function socketremove_friend(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.statemember = 'unfriend';
      }
    },
    socket_kickmember: function socket_kickmember(data) {
      var self = this;
      data.listkick.forEach(function (item) {
        if (self.token === item) {
          self.statemember = 'leave';
        }
      });
    },
    socketactive_group: function socketactive_group(data) {
      if (this.token === data.tokenuser) {
        this.statemember = 'active';
      }
    },
    socketquickreply: function socketquickreply(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.getreply();
      }
    },
    socketdisablequickreply: function socketdisablequickreply(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        // this.Quickreply = ''
        this.getreply();
      }
    },
    socket_unsendmessage: function socket_unsendmessage(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        var indexid = _.findIndex(this.items, function (o) {
          return o.tokenmessage === data.tokenmessage;
        });
        var mentiontokenmessage = this.items[indexid].tokenmessage;
        var indexmentionmsg = _.findIndex(this.items, function (o) {
          return o.file_name === mentiontokenmessage;
        });
        if (indexmentionmsg === -1) {
          this.items[indexid].typeofmessage = 'unsend_message';
        } else {
          this.items[indexid].typeofmessage = 'unsend_message';
          this.items[indexmentionmsg].source_message.typeofmessage = 'unsend_message';
        }
      } else {}
    },
    socketdisableapprove: function socketdisableapprove(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        var indexid = _.findIndex(this.items, function (o) {
          return o.tokenmessage === data.tokenmessage && o.typeofmessage === 'approve_message';
        });
        this.items[indexid].disable = 'true';
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.box_height = screen.height - 64.0 - 120.0;
    // this.statemember = 'active'
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.tokenrooomSelect = this.$route.params.roomid;
    this.profile = localStorage.getItem('profilepicture');
    this.typeuser = localStorage.getItem('type_user');
    this.name = localStorage.getItem('name');
    this.getlistfriend();
    this.getroom();
    this.getOldMessage('');
    this.getreply();
    this.getlistannounce();
    this.axios.post("https://uatchat-manage.one.th/message" + '/sticker/gettitleallsticker', {
      tokenuser: this.token
    }).then(function (responsed) {
      _this3.sticker = responsed.data['data'];
    });
    var announce = this.$cookie.get(this.$route.params.roomid);
    if (announce !== null) {
      this.less = true;
    }
    this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
    var room = this.tokenrooomSelect;
    var index = _.findIndex(this.chat_wallpaper.info, function (o) {
      return o.room === room;
    });
    if (index === -1) {
      this.imageData = '';
    } else {
      this.imageData = this.chat_wallpaper.info[index].background;
    }
  },

  methods: {
    closeAgoraDialog: function closeAgoraDialog(value) {
      this.AgoraCallDialog = value;
    },
    decline_call: function decline_call(item) {
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/update-agora', {
        tokenuser: this.token,
        tokenroom: item.tokenroom,
        time: '',
        message: 'cancel'
      }).then(function (response) {
        console.log(response);
        // if (response.data.status === 'success') {
        //   this.one_id = response.data.one_id
        // }
      });
    },
    get_oneid: function get_oneid() {
      var _this4 = this;

      this.axios.get("https://uatchat-manage.one.th/go_api/api" + ('/v1/getOneID/' + this.token)).then(function (response) {
        if (response.data.status === 'success') {
          _this4.one_id = response.data.one_id;
        }
      });
    },
    ans_ekyc: function ans_ekyc(item) {
      var _this5 = this;

      // console.log(item)
      this.ans_quickreply(item, 'ekyc');
      this.axios.post("https://uatchat-manage.one.th/message" + '/api/v1/get_shared_token', { user_id: this.one_id }).then(function (response) {
        if (response.data.status === 'success') {
          var url = '' + "https://uat-ekyc.id.th/redirect-share-token?shared_token=" + response.data.data.shared_token;
          _this5.Webview_item = {
            label: item.label,
            url: url,
            size: 'full',
            type: 'ekyc',
            payload: ''
            // this.dialogWebviewbig = true
          };_this5.checkBrowser(url, _this5.Webview_item);
        }
      }).catch(function (error) {
        console.log(error);
        _this5.$swal('', _this5.$t('Alert.Fail.default.somethingWrong'), 'error');
      });
    },
    ans_ekyc_template: function ans_ekyc_template(item) {
      var _this6 = this;

      this.axios.post("https://uatchat-manage.one.th/message" + '/api/v1/get_shared_token', { user_id: this.one_id }).then(function (response) {
        if (response.data.status === 'success') {
          var url = '' + "https://uat-ekyc.id.th/redirect-share-token?shared_token=" + response.data.data.shared_token;
          _this6.Webview_item = {
            label: item.label,
            url: url,
            size: 'full',
            type: 'ekyc',
            payload: ''
            // this.dialogWebviewbig = true
          };_this6.checkBrowser(url, _this6.Webview_item);
        }
      }).catch(function (error) {
        console.log(error);
        _this6.$swal('', _this6.$t('Alert.Fail.default.somethingWrong'), 'error');
      });
    },
    handleEventBusEvent: function handleEventBusEvent(payload) {
      console.log(payload);
      // alert(payload);
    },

    // handleClick(e) {
    //   console.log(e.target.innerHTML)
    // },
    handleClickTest: function handleClickTest(e) {
      var _this7 = this;

      var username = e.target.innerHTML.substring(1);
      var myUser = localStorage.name;
      // console.log(myUser)
      if (username != myUser) {
        // const item = this.listfriend.filter(friend =>
        //   (friend.name.toLowerCase().replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`))
        //       .includes(username.toLowerCase().replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`))
        // )
        // console.log(item)

        this.listfriend.forEach(function (freind) {
          // var item = []
          var rex = /(?:[\xA9\xAE\u2122\u23E9-\u23EF\u23F3\u23F8-\u23FA\u24C2\u25B6\u2600-\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDE51\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDE80-\uDEFF]|\uD83E[\uDD00-\uDDFF])/g;
          var x = username.replace(rex, function (match) {
            return '[e-' + match.codePointAt(0).toString(16) + ']';
          });
          var y = freind.name.replace(rex, function (match) {
            return '[e-' + match.codePointAt(0).toString(16) + ']';
          });
          // console.log(x)
          // console.log(y)
          // console.log(x.includes(y))
          if (x.includes(y)) {
            // console.log(freind)
            var tokenUser = freind.tokenuser;
            _this7.detailFriend(tokenUser);
          }
        });
      } else {
        var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
        this.detailFriend(decoded.tokenuser);
      }
    },
    getlistfriend: function getlistfriend() {
      var _this8 = this;

      var tokenUser = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services__["a" /* Decode */].decode(localStorage.Authenrization)).tokenuser;
      var me = localStorage.name;
      var body = {
        tokenuser: tokenUser,
        tokenroom: this.$route.params.roomid
      };
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', body).then(function (response) {
        if (response.status === 200) {
          var listfriend = response.data.data_room;
          // console.log('length listfreind' , listfriend.length)
          _this8.listfriend = listfriend.filter(function (friend) {
            return friend.type == 'user' && friend.tokenuser !== tokenUser && friend.statemember === 'active';
          });
          // console.log(this.listfriend)
          // this.length_listfreind = this.listfriend
          // if(listfriend.length == 1){
          //   this.status_tag = false
          // }
        }
      });
    },
    getroom: function getroom() {
      var _this9 = this;

      var body = {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      };
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', body).then(function (response) {
        if (response.status === 200) {
          _this9.block = response.data.statemember;
          // console.log(response.data.data_room)
          _this9.typeroom = response.data.type;
          var me = _this9;
          _this9.listfriend = _.filter(response.data.data_room, function (o) {
            return o.tokenuser !== me.token && o.type === 'user' && o.statemember === 'active';
          });
          if (response.data.data_room.length == 1 && response.data.data_room[0].type == 'bot') {
            var bot_id = response.data.data_room[0].tokenuser;
            // console.log(this.bot_id)
            _this9.get_list_richmenu(bot_id);
          } else {
            _this9.list_richmenu = [];
          }
        }
      });
      this.get_oneid();
    },
    play: function play(e) {
      console.log(e);
    },
    closeShowQRCodeUser: function closeShowQRCodeUser(value) {
      this.dialogShowQRCode = value;
      // this.checktype = ''
      // this.tokenrooomSelect = ''
    },
    closeCheckBrowser: function closeCheckBrowser(value) {
      this.checkBrowserDialog = value;
      this.checkBrowserInfor = {};
    },
    btn_answer_carousel: function btn_answer_carousel(item) {
      // console.log(item)
      // if (item.type === 'text' || item.type === 'postback') {
      //   this.ans_carousel(item)
      // } else if (item.type === 'webview' || item.type === 'link') {
      //   var infor = {
      //     sign: item.sign,
      //     url: item.action,
      //     type: item.type,
      //     label: item.button,
      //     onechat_token: item.onechat_token,
      //     size: 'full'
      //   }
      //   this.check_get_accesstoken(infor)
      // } else {
      //   console.log(item.type)
      // }
      if (item.type === 'webview' || item.type === 'link') {
        var infor = {
          sign: item.sign,
          url: item.action,
          type: item.type,
          label: item.button,
          onechat_token: item.onechat_token,
          payload: item.payload,
          size: 'full'
        };
        this.check_get_accesstoken(infor);
      } else if (item.type === 'link_market') {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
      } else {
        this.ans_carousel(item);
      }
    },
    saveLogNews: function saveLogNews(item) {
      var _this10 = this;

      // console.log(item)
      this.axios.get("https://uatchat-manage.one.th/go_api/api" + '/v1/getOneID/' + this.token).then(function (response) {
        var one_id = response.data.one_id;
        // console.log(one_id)
        _this10.axios.post("https://news.chat.one.th/backend/api/v1/page-analytics", {
          'one_id': one_id,
          'news_id': item.payload.news_id,
          'news_index': item.payload.news_index.toString(),
          'page_name': item.payload.page_name
        }).then(function (response) {
          // console.log(response)
        }).catch(function (error) {
          console.log(error);
        });
      }, function (error) {
        console.log(error);
      });
    },
    ans_carousel: function ans_carousel(item) {
      var payload = {};
      if (item.payload !== undefined) {
        payload = item.payload;
      }
      var body = {
        tokenuser: this.token,
        tokenroom: this.tokenrooomSelect,
        action: item.action,
        type: item.type,
        payload: payload
        // console.log(body)
      };this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/ansCarousel', body).then(function (response) {
        // console.log(response.data)
      }).catch(function (error) {
        console.log(error);
      });
    },
    emitrichmenu: function emitrichmenu(item) {
      var _this11 = this;

      // console.log(item)
      var expireddate = Date.parse(item.expired_date);
      var body = __WEBPACK_IMPORTED_MODULE_3__services__["b" /* Encode */].encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate });
      var url = '';
      if (_.includes(item.infor.url, ['?'])) {
        url = '&';
      } else {
        url = '?';
      }
      var weburl = item.infor.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate;
      if (item.infor.type === 'text') {
        this.sendMessage(item.infor.message);
      } else if (item.infor.type === 'link') {
        if (item.infor.sign_share === 'true') {
          // window.open(weburl, '_blank')
          this.getSign(item.infor.url, item.infor, this.bot_id_richmenu);
        } else if (item.infor.sign === 'true') {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item);
        } else {
          // window.open(item.infor.url, '_blank')
          this.checkBrowser(item.infor.url, item);
        }
      } else if (item.infor.type === 'webview') {
        if (item.infor.sign_share === 'true') {
          // var infor_webview = {
          //   message: item.infor.message,
          //   picture: item.infor.picture,
          //   sign: item.infor.sign,
          //   size: item.infor.size,
          //   type: item.infor.type,
          //   url: weburl
          // }
          // this.Webview_item = infor_webview
          // this.dialogWebviewbig = true
          this.getSign(item.infor.url, item.infor, this.bot_id_richmenu);
        } else if (item.infor.sign === 'true') {
          var infor_webview = {
            message: item.infor.message,
            picture: item.infor.picture,
            sign: item.infor.sign,
            size: item.infor.size,
            type: item.infor.type,
            url: weburl
          };
          this.Webview_item = infor_webview;
          this.dialogWebviewbig = true;
          // console.log(this.Webview_item)
        } else {
          this.Webview_item = item.infor;
          this.dialogWebviewbig = true;
        }
      } else if (item.infor.type === 'link_market') {
        // console.log(item)
        // this.linkmarket = item.infor.url
        // this.$router.push('/chat/service/market?goto=link_market')
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
      } else if (item.infor.type === 'location') {
        // console.log('rich menu type location')
        this.sendlocation_quickreply();
      } else if (item.infor.type === 'qrcode' && item.infor.location_status === 'false') {
        console.log('rich menu type qrcode');
        this.dialogShowQRCode = true;
        this.QrcodeInfor = { status: item.infor.location_status, lat: '', lng: '', address: '' };
      } else if (item.infor.type === 'qrcode' && item.infor.location_status === 'true') {
        console.log('rich menu qrcode location');
        this.dialogShowQRCode = true;
        if (window.navigator.geolocation) {
          window.navigator.geolocation.getCurrentPosition(function (position) {
            _this11.QrcodeInfor = { status: item.infor.location_status, lat: position.coords.latitude, lng: position.coords.longitude, address: '' };
          });
        } else {
          console.log('error geo');
          this.QrcodeInfor = { status: item.infor.location_status, lat: '', lng: '', address: '' };
        }
      } else {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
      }
    },
    chsheetrichmenu: function chsheetrichmenu() {
      this.RichmenuState = true;
      this.Richmenudialog = true;
      this.sheetrichmenu = this.RichmenuState_first;
      // console.log(this.Richmenudialog)
      // console.log('click sheetrichmenu')
    },
    removeFile: function removeFile(key) {
      this.files.splice(key, 1);
    },
    onPaste: function onPaste(evt) {
      var items = (evt.clipboardData || evt.originalEvent.clipboardData).items;
      var index = 0;
      var me = this;
      this.nameFile = 'picture.png';
      for (index in items) {
        var item = items[index];
        if (item.kind === 'string') {
          this.nameFile = evt.clipboardData.getData('text/plain');
        } else if (item.kind === 'file') {
          var blob = item.getAsFile();
          var reader = new FileReader();
          reader.onload = function (evt) {
            me.sendmsg = me.sendmsg.replace(me.nameFile, '');
            me.files.push({
              file: blob,
              filebase64: evt.target.result,
              status: 'waiting',
              name: me.nameFile
            });
          };
          reader.readAsDataURL(blob);
        }
      }
    },
    determineDragAndDropCapable: function determineDragAndDropCapable() {
      console.log('determineDragAndDropCapable');
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
    },
    open_detail_task: function open_detail_task(taskid, tokenroom) {
      this.taskid = taskid;
      this.roomid = tokenroom;
      this.dialogDetailTask = true;
    },
    checkuserinassign: function checkuserinassign(item) {
      var tokenuser = this.token;
      var index = _.findIndex(item, function (o) {
        return o.tokenuser === tokenuser;
      });
      if (index >= 0) {
        return true;
      } else {
        return false;
      }
    },
    checkbutton: function checkbutton(color, bng) {
      var text = {
        'text-transform': 'none',
        'width': '100%',
        'margin': '0',
        'font-size': '13px',
        'border-radius': '20px'
        // [choice.color]? ('color': choice.color):('color':'black')
      };if (color) {
        text['color'] = color;
      } else {
        text['color'] = 'black';
      }
      if (bng) {
        text['background'] = bng;
      } else {
        text['background'] = 'none';
      }
      return text;
    },
    cancel_announce: function cancel_announce() {
      var _this12 = this;

      this.rightclickdialog = false;
      var token_announce = this.SelectedMessageDetail._id;
      this.$swal({
        text: this.$t('Alert.Chat.announce.cancel'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this12.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/disable_single_announce_room', {
            tokenuser: _this12.token,
            tokenroom: _this12.tokenrooomSelect,
            token_announce: token_announce }).then(function (responsed) {
            if (responsed.data.status == 'success') {
              var index = _.findIndex(_this12.listannounce, function (o) {
                return o._id === token_announce;
              });
              if (index >= 0) {
                _this12.listannounce.splice(index, 1);
              }
            } else {
              _this12.listannounce = [];
            }
          });
        }
      });
    },
    delete_announce: function delete_announce() {
      var _this13 = this;

      this.$swal({
        text: this.$t('Alert.Chat.announce.deleteAll'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this13.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/disable_announce_room', { tokenuser: _this13.token, tokenroom: _this13.tokenrooomSelect }).then(function (responsed) {
            if (responsed.data.status == 'success') {
              _this13.listannounce = [];
            } else {}
          });
        }
      });
    },
    announce_msg: function announce_msg() {
      var _this14 = this;

      this.rightclickdialog = false;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/announce_room', {
        tokenuser: this.token,
        tokenmessage: this.SelectedMessageDetail.tokenmessage,
        tokenroom: this.SelectedMessageDetail.tokenroom
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this14.$swal('', _this14.$t('Alert.Success.announce'), 'success');
        }
        _this14.show = false;
      });
    },
    getlistannounce: function getlistannounce() {
      var _this15 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_announce_room', { tokenuser: this.token, tokenroom: this.tokenrooomSelect }).then(function (responsed) {
        if (responsed.data.status == 'success') {
          _this15.listannounce = responsed.data.data;
          _this15.listannounce = _.reverse(_this15.listannounce);
        } else {
          _this15.listannounce = [];
        }
      }, function () {});
    },
    closeDialog: function closeDialog() {
      this.dialogopenwebsite = false;
    },
    add_image_albums: function add_image_albums() {
      this.dialogAddImage = true;
      this.rightclickdialog = false;
    },
    secondsToHms: function secondsToHms(d) {
      d = Number(d);
      var hours = Math.floor(d / 3600);
      var minutes = Math.floor((d - hours * 3600) / 60);
      var seconds = d - hours * 3600 - minutes * 60;
      var time = '';

      if (hours !== 0) {
        time = hours + ':';
      }
      if (minutes !== 0 || time !== '') {
        minutes = minutes < 10 && time !== '' ? '0' + minutes : String(minutes);
        time += minutes + ':';
      }
      if (time === '') {
        time = seconds + 's';
      } else {
        time += seconds < 10 ? '0' + seconds : String(seconds);
      }
      return time;
    },
    checktypeCall: function checktypeCall(call) {
      if (call === 'cancel') {
        return this.$t('AnswerQuestion.cancel');
      } else if (call === 'decline') {
        return this.$t('LeftSide.chat.call.missed');
      } else if (call === 'end') {
        return this.$t('LeftSide.chat.call.end');
      } else {
        return '';
      }
    },
    RightClickDialog: function RightClickDialog($event, list, item) {
      this.ListMenuRightClick = [];
      if (this.statemember === 'active') {
        if (list.includes("albums")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.addImageAlbum'), methods: 'add_albums' });
        }
        if (list.includes("mention")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.mention'), methods: 'mention' });
        }
        if (list.includes("sendmail")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.sendmail'), methods: 'sendmail' });
        }
        if (list.includes("cancel")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.cancelMsg'), methods: 'cancel' });
        }
        if (list.includes("announce")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.announce'), methods: 'announce' });
        }
        if (list.includes("cancel_announce")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.cancelAnnounce'), methods: 'cancel_announce' });
        }
        this.rightclickdialog = true;
        this.$refs.menu.open($event);
        this.SelectedMessageDetail = item;
      }
    },
    SelectMenuRightClick: function SelectMenuRightClick(selected) {
      // console.log(selected)
      if (selected == 'add_albums') {
        this.add_image_albums();
      } else if (selected == 'mention') {
        this.mention_message();
      } else if (selected == 'cancel') {
        this.unsendmessage();
      } else if (selected == 'sendmail') {
        this.sendemail();
      } else if (selected == 'announce') {
        this.announce_msg();
      } else if (selected == 'cancel_announce') {
        this.cancel_announce();
      }
    },
    sendemail: function sendemail() {
      this.dialogCreatemail = true;
    },
    closeCreatemail: function closeCreatemail(value) {
      this.dialogCreatemail = value;
    },
    mention_message: function mention_message() {
      if (this.statemember === 'active') {
        this.rightclickdialog = false;
        this.showmention = true;
        if (this.SelectedMessageDetail.path_pic === '') {
          if (this.SelectedMessageDetail.type === 'business') {
            this.SelectedMessageDetail.path_pic = '/static/img/default_profile/business-white.png';
          } else if (this.SelectedMessageDetail.type === 'bot') {
            this.SelectedMessageDetail.path_pic = '/static/img/default_profile/bot-white.png';
          } else {
            this.SelectedMessageDetail.path_pic = '/static/img/default_profile/man-white.png';
          }
        }
      }
    },
    unsendmessage: function unsendmessage() {
      var _this16 = this;

      this.rightclickdialog = false;
      this.$swal({
        text: this.$t('Alert.Chat.unsent'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this16.axios.post("https://uatchat-manage.one.th/message" + '/delete_message', {
            tokenuser: _this16.token,
            tokenmessage: _this16.SelectedMessageDetail.tokenmessage
          }).then(function (response) {
            if (response.data['status'] === 'success') {
              _this16.$swal('', _this16.$t('Alert.Success.unsent'), 'success');
            }
          });
        }
      });
    },
    backCall_conference_msg: function backCall_conference_msg(detail) {
      window.open(detail.urlroom);
    },
    joinCall_conference_msg: function joinCall_conference_msg(detail) {
      // console.log(detail)
      this.axios.post("https://uatchat-manage.one.th/message" + '/join_room_conference', {
        meetingid: detail.meetingid,
        name: localStorage.getItem('name'),
        option: detail.option,
        key: detail.key
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          window.open(response.data.data.urlroom);
        }
      });
    },
    openapprove: function openapprove(item) {
      this.ApproveDetail = item;
      this.dialogApprove = true;
    },
    checkBrowser: function checkBrowser(url, item) {
      // console.log(item)
      if (_.includes(url, 'https://chat.one.th/qrcode/friend?id=')) {
        var link = _.split(url, '?id=', 2);
        // console.log(link[1])
        // console.log(atob(link[1]))
        this.detailFriend(atob(link[1]));
      } else {
        // Get the user-agent string
        var userAgentString = navigator.userAgent;
        // Detect Chrome
        var chromeAgent = userAgentString.indexOf("Chrome") > -1;
        // Detect Internet Explorer
        var IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
        // Detect Firefox
        var firefoxAgent = userAgentString.indexOf("Firefox") > -1;
        // Detect Safari
        var safariAgent = userAgentString.indexOf("Safari") > -1;
        // Discard Safari since it also matches Chrome
        var operaAgent = userAgentString.indexOf("OP") > -1;
        // console.log('firefox = > ' + firefoxAgent)
        // console.log('ie = > ' + IExplorerAgent)
        // console.log('chrome = > ' + chromeAgent)
        // console.log('opera = > ' + operaAgent)
        // console.log('safari = > ' + safariAgent)
        if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
          if (item.payload !== undefined) {
            if (item.payload.news_id !== undefined) {
              this.checkBrowserInfor = {
                url: url,
                payload: item.payload
              };
            } else {
              this.checkBrowserInfor = {
                url: url
              };
            }
          } else {
            this.checkBrowserInfor = {
              url: url,
              payload: ''
            };
          }
          this.checkBrowserDialog = true;
        } else if (safariAgent === true && chromeAgent === true) {
          console.log('savelog');
          window.open(url, '_blank');
          if (item.payload.news_id !== undefined) {
            this.saveLogNews(item);
          }
        } else if (safariAgent === true) {
          // this.checkBrowserInfor =
          if (item.payload !== undefined) {
            if (item.payload.news_id !== undefined) {
              this.checkBrowserInfor = {
                url: url,
                payload: item.payload
              };
            } else {
              this.checkBrowserInfor = {
                url: url
              };
            }
          } else {
            this.checkBrowserInfor = {
              url: url,
              payload: ''
            };
          }
          this.checkBrowserDialog = true;
        } else {
          console.log('savelog');
          window.open(url, '_blank');
          if (item.payload.news_id !== undefined) {
            this.saveLogNews(item);
          }
        }
      }
    },
    check_get_accesstoken: function check_get_accesstoken(item) {
      var _this17 = this;

      // console.log(item)
      if (item.sign === 'true') {
        var body = {
          "tokenuser": this.token,
          "url": item.url
        };
        this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", body).then(function (response) {
          // console.log(response.data)
          if (response.data.data) {
            var new_url = response.data.data.url;
            if (item.type === 'link') {
              // item.url = response.data.data.url
              // window.open(new_url, '_blank')
              _this17.checkBrowser(new_url, item);
            } else if (item.type === 'webview') {
              _this17.Webview_item = {
                label: item.label,
                url: new_url,
                size: item.size,
                type: item.type
              };
              _this17.dialogWebviewbig = true;
              if (item.payload.news_id !== undefined) {
                _this17.saveLogNews(item);
              }
            }
          } else {
            _this17.dialogLogin = true;
          }
        }, function (error) {
          console.log(error);
        });
      } else if (item.onechat_token === 'true') {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var hour = String(today.getHours() + 1).padStart(2, '0');
        var minute = String(today.getMinutes()).padStart(2, '0');
        var seconds = String(today.getSeconds()).padStart(2, '0');
        var milsec = today.getMilliseconds();
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00';
          dd = String(today.getDate() + 1).padStart(2, '0');
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1';
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1';
              yyyy = today.getFullYear() + 1;
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0');
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
        // console.log(today)
        var expireddate = Date.parse(today);
        // console.log(expireddate)
        var body = __WEBPACK_IMPORTED_MODULE_3__services__["b" /* Encode */].encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate });
        var url = '';
        if (_.includes(item.url, ['?'])) {
          url = '&';
        } else {
          url = '?';
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate;

        if (item.type === 'link') {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item);
        } else if (item.type === 'webview') {
          this.Webview_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          };
          this.dialogWebviewbig = true;
          if (item.payload.news_id !== undefined) {
            this.saveLogNews(item);
          }
        }
      } else {
        if (item.type === 'link') {
          // window.open(item.url, '_blank')
          // console.log('Carousel')
          this.checkBrowser(item.url, item);
        } else if (item.type === 'webview') {
          this.Webview_item = item;
          this.dialogWebviewbig = true;
          // check payload news
          if (item.payload.news_id !== undefined) {
            this.saveLogNews(item);
          }
        }
      }
    },
    openlink_market: function openlink_market(item) {
      var message = {
        message: '',
        payload: ''
      };
      if (item.type === 'link_market') {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        this.ans_quickreply(message, 'link_market');
        // this.clearQuickreply()
      }
    },
    openlink: function openlink(item) {
      var message = {
        message: '',
        payload: ''
      };
      this.ans_quickreply(message, 'link');
      this.check_get_accesstoken(item);
    },
    openwebview: function openwebview(item) {
      // console.log(item)
      // console.log('openwebview')
      var message = {
        message: '',
        payload: ''
        // this.Webview_item = item
        // this.dialogWebviewbig = true
      };this.ans_quickreply(message, 'webview');
      this.check_get_accesstoken(item);
    },
    sendansApprove: function sendansApprove(item, tokenmessage) {
      var _this18 = this;

      var body = {
        tokenmessage: tokenmessage,
        tokenuser: this.token,
        answer: item
      };
      var indexid = _.findIndex(this.items, function (o) {
        return o.tokenmessage === tokenmessage && o.typeofmessage === 'approve_message';
      });
      this.items[indexid].disable = 'true';
      this.axios.post("https://uatchat-manage.one.th/message" + '/answer_approve', body).then(function (response) {
        // console.log(response.data)
        if (_.find(_this18.items, function (o) {
          return o.tokenmessage === response.data.data.tokenmessage;
        }) === undefined) {
          _this18.items.push(response.data.data);
          _this18.clearQuickreply();
          _this18.items = _.sortBy(_this18.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          _this18.items = _.unionBy(_this18.items, 'tokenmessage');
        }
        setTimeout(_this18.scrollDown, 1);
      }, function () {});
    },
    ans_quickreply: function ans_quickreply(item, type) {
      var _this19 = this;

      var body = {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token,
        type_reply: type,
        message: item.message,
        info_data: item.payload
      };
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/answer_quickreply', body).then(function (response) {
        // console.log(response.data.data)
        if (_.find(_this19.items, function (o) {
          return o.tokenmessage === response.data.tokenmessage;
        }) === undefined) {
          if (response.data.data !== undefined) {
            _this19.items.push(response.data.data);
          }
          _this19.clearQuickreply();
          _this19.items = _.sortBy(_this19.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          _this19.items = _.unionBy(_this19.items, 'tokenmessage');
        }
        setTimeout(_this19.scrollDown, 1);
      }, function () {});
    },
    selectfile_quickreply: function selectfile_quickreply(item) {
      if (item.type == 'image') {
        $('#uploadpic_quickreply').click();
      } else {
        $('#uploadfile_quickreply').click();
      }
      this.itemdetail_quickreply = item;
    },
    sendlocation_quickreply: function sendlocation_quickreply() {
      var _this20 = this;

      // console.log(navigator.geolocation)
      if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(function (position) {
          // console.log(position.coords.latitude, position.coords.longitude)
          _this20.send_location(position.coords.latitude, position.coords.longitude, '');
        });
      } else {
        console.log('error geo');
      }
    },
    btn_answer_question: function btn_answer_question(item, tokenmessage) {
      // console.log(item)
      this.ans_question(item, tokenmessage);
      if (item.type === 'link' || item.type === 'webview') {
        this.check_get_accesstoken(item);
      } else if (item.type === 'file') {
        this.downloadFileMenu(item);
      } else if (item.type === 'link_market') {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
      } else if (item.type === 'ekyc') {
        this.ans_ekyc_template(item);
      }
    },
    btn_official_template: function btn_official_template(item, tokenuserBot, tokenmessage) {
      // console.log(item)
      // if (item.type === 'link') {
      //   window.open(item.url, '_blank')
      // } else if (item.type === 'webview') {
      //   this.Webview_item = item
      //   this.dialogWebviewbig = true
      // }
      if (item.sign == 'true' && item.type !== 'text') {
        this.getSign(item.url, item, tokenuserBot);
      } else if (item.onechat_token === 'true' && item.type !== 'text') {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var hour = String(today.getHours() + 1).padStart(2, '0');
        var minute = String(today.getMinutes()).padStart(2, '0');
        var seconds = String(today.getSeconds()).padStart(2, '0');
        var milsec = today.getMilliseconds();
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00';
          dd = String(today.getDate() + 1).padStart(2, '0');
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1';
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1';
              yyyy = today.getFullYear() + 1;
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0');
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
        // console.log(today)

        var expireddate = Date.parse(today);
        var body = __WEBPACK_IMPORTED_MODULE_3__services__["b" /* Encode */].encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate });
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        // var weburl = item.url + url
        var url = '';
        if (_.includes(item.url, ['?'])) {
          url = '&';
        } else {
          url = '?';
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate;

        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item);
        } else if (item.type === 'webview') {
          this.Webview_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          };
          this.dialogWebviewbig = true;
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        }
      } else {
        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item);
        } else if (item.type === 'webview') {
          this.Webview_item = item;
          this.dialogWebviewbig = true;
        } else if (item.type === 'text') {
          this.ans_question(item, tokenmessage);
        } else if (item.type === 'file') {
          this.ans_question(item, tokenmessage);
          this.downloadFileMenu(item);
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        }
      }
    },
    btn_img_official_template: function btn_img_official_template(item, tokenuserBot) {
      // console.log(item)
      if (item.sign === 'true') {
        this.getSignImg(item.url, item, tokenuserBot);
      } else if (item.onechat_token === 'true') {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var hour = String(today.getHours() + 1).padStart(2, '0');
        var minute = String(today.getMinutes()).padStart(2, '0');
        var seconds = String(today.getSeconds()).padStart(2, '0');
        var milsec = today.getMilliseconds();
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00';
          dd = String(today.getDate() + 1).padStart(2, '0');
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1';
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1';
              yyyy = today.getFullYear() + 1;
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0');
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
        // console.log(today)
        var expireddate = Date.parse(today);
        var body = __WEBPACK_IMPORTED_MODULE_3__services__["b" /* Encode */].encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate });
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        // var weburl = item.url + url
        var url = '';
        if (_.includes(item.url, ['?'])) {
          url = '&';
        } else {
          url = '?';
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate;

        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item);
        } else if (item.type === 'webview') {
          this.Webview_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          };
          this.dialogWebviewbig = true;
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        }
      } else {
        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item);
        } else if (item.type === 'webview') {
          this.Webview_item = item;
          this.dialogWebviewbig = true;
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        }
      }
    },
    getSignImg: function getSignImg(url, item, tokenuserBot) {
      var _this21 = this;

      var body = {
        "tokenuser": this.token,
        "url": url
      };
      this.axios.post("https://uatchat-manage.one.th/event" + '/old/api/v1/getAccesstoken', body).then(function (response) {
        if (response.data.data) {
          var new_url = '';
          // console.log(response.data.data)
          new_url = response.data.data.url;
          // console.log(response.data.data.url)
          if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
            // window.open(new_url, '_blank')
            _this21.checkBrowser(new_url, item);
          } else if (item.type === 'webview') {
            _this21.Webview_item = {
              label: item.label,
              url: new_url,
              size: item.size,
              type: item.type
            };
            _this21.dialogWebviewbig = true;
          } else if (item.type === 'link_market') {
            _this21.$swal('', _this21.$t('Alert.Warning.link_market'), 'warning');
          }
        } else {
          _this21.dialogLogin = true;
        }
      }, function () {});
    },
    getSign: function getSign(url, item, tokenuserBot) {
      var _this22 = this;

      // console.log('getSign')
      var body = {
        "tokenuser": this.token,
        "url": url
        // console.log(tokenuserBot)
      };this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", body).then(function (response) {
        // console.log(response.data.data)
        if (response.data.data) {
          var new_url = '';
          new_url = response.data.data.url;
          if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
            // window.open(new_url, '_blank')
            _this22.checkBrowser(new_url, item);
          } else if (item.type === 'webview') {
            _this22.Webview_item = {
              label: item.label,
              url: new_url,
              size: item.size,
              type: item.type
            };
            _this22.dialogWebviewbig = true;
          } else if (item.type === 'link_market') {
            _this22.$swal('', _this22.$t('Alert.Warning.link_market'), 'warning');
          }
        } else {
          _this22.dialogLogin = true;
        }
      }, function () {});
    },
    downloadFileMenu: function downloadFileMenu(item) {
      var name = item.file.split('/')[item.file.split('/').length - 1];
      this.axios.get(item.file, {
        responseType: 'blob'
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
      });
    },
    ans_question: function ans_question(item, tokenmessage) {
      var _this23 = this;

      if (item.payload === undefined) {
        item.payload = '';
      }
      var body = {
        tokenmessage: tokenmessage,
        tokenuser: this.token,
        answer: item
        // console.log(item)
      };this.axios.post("https://uatchat-manage.one.th/message" + '/answer_question', body).then(function (response) {
        // console.log(response.data)
        if (item.type === 'text') {
          if (_.find(_this23.items, function (o) {
            return o.tokenmessage === response.data.data.tokenmessage;
          }) === undefined) {
            _this23.items.push(response.data.data);
            _this23.clearQuickreply();
            _this23.items = _.sortBy(_this23.items, function (dateObj) {
              return new Date(dateObj.timestamp);
            });
            _this23.items = _.unionBy(_this23.items, 'tokenmessage');
          }
          setTimeout(_this23.scrollDown, 1);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleConnectivityChange: function handleConnectivityChange(status) {
      this.online = status;
    },
    initmapShow: function initmapShow() {
      this.map = new longdo.Map({
        placeholder: document.getElementById('map'),
        lastView: true
      });
      this.map.Ui.Keyboard.enable(true);
      var control3 = new longdo.TagPanel();
      this.map.Ui.add(control3);
      // this.map.Ui.Crosshair.visible(false)
      this.map.Ui.LayerSelector.visible(false);
      var location = this.locationName.message.split(',');
      var marker = new longdo.Marker({
        lat: location[0],
        lon: location[1]
      }, {
        icon: {
          url: '../../../../static/img/icons/pin.png',
          offset: {
            x: this.x,
            y: this.y
          }
        },
        clickable: true
      });
      this.map.Overlays.add(marker);
      // this.GeometryOptions()
      // console.log(parseFloat(location[0]) - 1)
      // console.log(parseFloat(location[0]) + 1)
      this.map.bound({
        minLon: parseFloat(location[0]) - 1,
        minLat: parseFloat(location[1]) - 1,
        maxLon: parseFloat(location[0]) + 1,
        maxLat: parseFloat(location[1]) + 1
      }, {
        lat: location[0],
        lon: location[1]
      });
      // this.showloc = this.map.bound()
      this.map.zoom(15, true);
      // longdo.Search(this.map, true)
    },
    openlocation: function openlocation(item) {
      // console.log(item)
      this.center_markermap = {
        lat: parseFloat(item.message.split(',')[0]),
        lng: parseFloat(item.message.split(',')[1])
      };
      this.sheetother = false;
      this.dialogMap = true;
      this.locationName = item;
    },
    openmap: function openmap() {
      this.sheetother = false;
      // this.dialogMap = true
      this.dialogSendMap = true;
    },
    senddate: function senddate() {
      var _this24 = this;

      // var _ = require('lodash')
      if (this.typepicker === 'datepicker') {
        // api
        this.datepicker = false;
        this.$swal({
          title: this.$t('Alert.Chat.sendDatetime'),
          html: '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.dateselect) + '</div>',
          confirmButtonColor: '#3085d6',
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          cancelButtonColor: '#d33',
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          buttonsStyling: true,
          showCloseButton: true,
          showCancelButton: true,
          reverseButtons: true
        }).then(function (result) {
          if (result.value) {
            var item = {
              message: _this24.dateselect,
              payload: _this24.infodata
            };
            _this24.ans_quickreply(item, 'datepicker');
          }
        });
      } else if (this.typepicker === 'datetimepicker') {
        this.datepicker = false;
        this.timepicker = true;
        if (this.dateselect === this.mindate) {
          this.maxtime = '24:00';
        } else if (this.dateselect === this.maxdate) {
          this.mintime = '00:00';
        } else {
          this.maxtime = '24:00';
          this.mintime = '00:00';
        }
      }
    },
    sendtime: function sendtime() {
      var _this25 = this;

      this.$swal({
        title: this.$t('Alert.Chat.sendDatetime'),
        html: '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.dateselect) + ' เวลา ' + this.timeselect + '</div>',
        confirmButtonColor: '#3085d6',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          var item = {
            message: _this25.dateselect + 'T' + _this25.timeselect,
            payload: _this25.infodata
          };
          _this25.timepicker = false;
          _this25.ans_quickreply(item, 'datetimepicker');
        }
      });
    },
    setpicker: function setpicker(data) {
      // console.log(data)
      setTimeout(this.scrollDown, 1);
      if (data.type === 'datepicker') {
        this.typepicker = data.type;
        this.datepicker = true;
        this.maxdate = data.max;
        this.mindate = data.min;
        this.dateselect = data.initial;
        this.infodata = data.payload;
      } else if (data.type === 'datetimepicker') {
        this.typepicker = data.type;
        this.datepicker = true;
        this.maxdate = data.max.split('T')[0];
        this.mindate = data.min.split('T')[0];
        this.maxtime = data.max.split('T')[1];
        this.mintime = data.min.split('T')[1];
        this.dateselect = data.initial.split('T')[0];
        this.timeselect = data.initial.split('T')[1];
        this.infodata = data.payload;
      }
    },
    getreply: function getreply() {
      var _this26 = this;

      this.datepicker = false;
      this.timepicker = false;
      this.maxdate = '';
      this.mindate = '';
      this.maxtime = '';
      this.mintime = '';
      this.dateselect = '';
      this.timeselect = '';
      this.infodata = '';
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/get-quickreply', {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this26.Quickreply = response.data.data;
          setTimeout(_this26.scrollDown, 1);
          // console.log(this.Quickreply)
        }
      });
    },
    momentday: function momentday(data) {
      return __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momentdatetimethai(data);
    },
    checkShowmessagwBottom: function checkShowmessagwBottom(data) {
      var scroll = this.$el.querySelector('#myscroll');
      if (scroll.scrollTop >= scroll.scrollHeight - this.box_height - 70.0) {
        setTimeout(this.scrollDown, 1);
      } else {
        this.showmessagebottom = true;
        this.chip = true;
        this.picturechip = data.path_pic;
        if (data.typeofmessage !== 'message') {
          // this.showmessage = data.nickname + ': Send ' + data.typeofmessage + ' to you'
          this.showmessage = 'Send ' + data.typeofmessage + ' to you';
        } else {
          // this.showmessage = data.nickname + ':  ' + data.message
          this.showmessage = data.message;
        }
        // setTimeout(this.scrollDown, 1)
      }
    },
    lookmessage: function lookmessage() {
      this.chip = false;
      this.showmessagebottom = false;
      setTimeout(this.scrollDown, 1);
    },
    scrollFunction: function scrollFunction() {
      this.$refs.menu.close();
      var scroll = this.$el.querySelector('#myscroll');
      // console.log(scroll.scrollTop)
      // console.log(scroll.scrollHeight)
      if (scroll.scrollTop == 0 && this.progressLoadChat == false) {
        this.getOldMessage(this.items[0].timestamp);
      }
      // console.log(scroll.scrollTop >= ((scroll.scrollHeight - this.box_height - 70.0)))
      if (scroll.scrollTop >= scroll.scrollHeight - this.box_height - 70.0) {
        // เห็นข้อความแล้ว ไม่ต้องทำอะไร
        // setTimeout(this.scrollDown, 1)
        this.chip = false;
        this.showmessagebottom = false;
      }
    },
    chsheetother: function chsheetother() {
      // console.log(this.sheetother + '   ch')
      // this.sheetother = !this.sheetother
      if ($('#menu-chat').is(":visible")) {
        this.sheetother = false;
        // $('#menu-chat').fadeOut(1600);
        // this.sheetother = false
      } else {
        this.sheetother = true;
        // $('#menu-chat').fadeOut(1600);
      }
    },
    chsheetsticker: function chsheetsticker() {
      this.sheetsticker = !this.sheetsticker;
    },
    changelink: function changelink(path) {
      return path;
    },
    pushSticker: function pushSticker(stickerid) {
      var _this27 = this;

      this.axios.post("https://uatchat-manage.one.th/message" + '/push_sticker', {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token,
        message: stickerid,
        type: this.typeuser
      }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          if (_.find(_this27.items, function (o) {
            return o.tokenmessage === response.data.data.tokenmessage;
          }) === undefined) {
            var stickerSend = response.data.data;
            stickerSend['status'] = 'success';
            _this27.items.push(stickerSend);
            _this27.clearQuickreply();
          }
          _this27.sheetsticker = false;
          _this27.items = _.sortBy(_this27.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          _this27.items = _.unionBy(_this27.items, 'tokenmessage');
          setTimeout(_this27.scrollDown, 1);
        }
      });
    },
    extension: function extension(path) {
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase();
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
      var pdf = ['pdf'];
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm'];
      var presentation = ['ppt', 'pps', 'pot', 'pptx'];
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff'];
      var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4', 'divx', 'dat'];
      var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf'];
      if (pdf.includes(extension)) {
        return 'pdf';
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive';
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel';
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint';
      } else if (word.includes(extension)) {
        return 'fas fa-file-word';
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code';
      } else if (image.includes(extension)) {
        return 'fas fa-file-image';
      } else if (media.includes(extension)) {
        return 'media';
      } else if (audio.includes(extension)) {
        return 'audio';
      } else {
        return 'fas fa-file-alt';
      }
    },
    pushcontact: function pushcontact(item) {
      if (item.status === 'success') {
        if (_.find(this.items, function (o) {
          return o.tokenmessage === item.data.tokenmessage;
        }) === undefined) {
          this.items.push(item.data);
          this.clearQuickreply();
          this.items = _.sortBy(this.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          this.items = _.unionBy(this.items, 'tokenmessage');
          setTimeout(this.scrollDown, 1);
        }
      } else {
        this.items.push({
          tokenuser: this.token,
          message: item.data.tokenuser,
          tokenroom: this.$route.params.roomid,
          typeofmessage: 'contact',
          timestamp: __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp(),
          tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp()),
          path_pic: this.profile,
          nickname: '',
          file_name: '',
          nickname_contact: item.data.name,
          pic_contact: item.data.profilepicture,
          type_contact: item.data.type,
          status: 'no'
        });
      }
    },
    detailFriend: function detailFriend(user) {
      // console.log(user)
      this.id = user;
      this.type = 'friend';
      this.dialogopenwebsite = true;
    },
    chat: function chat(tokenroom) {
      this.$router.push('/chat/room/' + tokenroom);
    },
    AcceptReq: function AcceptReq(tokenFriend) {
      var _this28 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/accept-friend", {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this28.relation = 'friend';
        }
      });
    },
    RemoveReq: function RemoveReq(tokenFriend) {
      var _this29 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this29.relation = 'unknown';
        }
      });
    },
    AddFriend: function AddFriend(tokenFriend) {
      var _this30 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this30.$store.dispatch('sendRequest', tokenFriend);
        } else {
          alert('Error!!!');
        }
      });
    },
    unblock: function unblock(tokenFriend) {
      var _this31 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistblockfriend', {
        tokenuser: this.token
      }).then(function (response) {
        var room = response.data['listBlockFriend'][_this31.findWithAttr(response.data['listBlockFriend'], 'tokenuser', tokenFriend)]['tokenroom'];
        _this31.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', {
          tokenfriend: tokenFriend,
          tokenuser: _this31.token,
          tokenroom: room
        }).then(function (response) {
          if (response.data['status'] === 'success') {
            _this31.$swal('Unblocked!', _this31.$t('Alert.Success.unblock'), 'success');
            _this31.relation = 'friend';
            _this31.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistblockfriend', {
              tokenuser: _this31.token
            }).then(function (response) {
              _this31.$store.dispatch('listFriend', 'listBlockFriend' + tokenFriend);
            });
          }
        });
      });
    },
    findWithAttr: function findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
    append: function append(emoji) {
      // console.log(emoji)
      this.sendmsg += emoji;
    },
    forword: function forword() {
      if (this.currentPage < this.pageCount) {
        this.currentPage = this.currentPage + 1;
      }
    },
    back: function back() {
      if (this.currentPage !== 1) {
        this.currentPage = this.currentPage - 1;
      }
    },
    other_noti: function other_noti(group, title, msg, pic) {
      if (Notification.permission === 'granted') {
        var notification = new Notification(title, {
          body: msg,
          icon: pic,
          silent: true
        });
        notification.onclick = function () {};
      } else {
        Notification.requestPermission().then(function (result) {
          // console.log(result)
        });
      }
    },
    ocropen: function ocropen(item) {
      $('#uploadpic_ocr').click();
      this.ocr_detailItem = item;
    },
    uppic: function uppic() {
      $('#uploadpic').click();
    },
    upfile: function upfile() {
      $('#uploadfileChat').click();
      this.sheetother = false;
    },
    pasteIntoInput: function pasteIntoInput(el, text) {
      el.focus();
      if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
        var val = el.value;
        var selStart = el.selectionStart;
        el.value = val.slice(0, selStart) + text + val.slice(el.selectionEnd);
        el.selectionEnd = el.selectionStart = selStart + text.length;
      } else if (typeof document.selection !== 'undefined') {
        var textRange = document.selection.createRange();
        textRange.text = text;
        textRange.collapse(false);
        textRange.select();
      }
    },
    closemodal: function closemodal() {
      var myModalMap = document.getElementById('myModalMap');
      myModalMap.style.display = 'none';
    },
    zoomfile: function zoomfile(file, state) {
      if (state) {
        this.DetailFile = file;
        this.dialogshowfile = state;
      } else {
        this.axios.get(file.message, {
          responseType: 'blob'
        }).then(function (response) {
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', file.file_name);
          document.body.appendChild(link);
          link.click();
        });
      }
    },
    zoom: function zoom(image) {
      image['path'] = image['message'];
      image['file_owner'] = image['nickname'];
      image['typeuser'] = image['type'];
      image['pic_pro'] = image['path_pic'];
      this.DetailImage = image;
      this.dialogshowimage = true;
    },
    closeDialogShowFile: function closeDialogShowFile(value) {
      this.dialogshowfile = value;
      this.DetailFile = {};
    },
    closeDialogShowImage: function closeDialogShowImage(value) {
      this.dialogshowimage = value;
    },

    // sendimgonebox (tokenmessage) {
    //   this.axios.post(process.env.APIpub + '/save_onebox2', {
    //     tokenmessage: tokenmessage,
    //     tokenuser: this.token
    //   }).then((response) => {
    //     console.log(response.data)
    //     if (response.data['status'] === 'success') {
    //       this.$swal(
    //         this.$t('Alert.Success.sending'),
    //         this.$t('Alert.Success.sendFile'),
    //         'success'
    //       )
    //     }
    //   })
    // },
    sendimgonebox: function sendimgonebox(tokenmessage) {
      this.dialogSaveOnebox = true;
      this.tokenmessage_savebox = tokenmessage;
    },
    closeSaveOnebox: function closeSaveOnebox(value) {
      this.dialogSaveOnebox = false;
    },
    scrollMaxOldSet: function scrollMaxOldSet() {
      this.scrollMaxOld = 0;
    },
    scrollDown: function scrollDown() {
      var container = this.$el.querySelector('#myscroll');
      container.scrollTop = container.scrollHeight;
      this.scrollval = container.scrollTop;
    },
    loadchathistory: function loadchathistory() {
      this.progressLoadChat = true;
      this.temp = this.selectedForward;
      this.selectedForward = [];
      this.getOldMessage(this.items[0].timestamp);
    },
    getOldMessage: function getOldMessage(time) {
      var _this32 = this;

      this.progressLoadChat = true;
      if (time === '') {
        this.progressLoadChatBox = true;
      }
      this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getdictmessage", {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token,
        time_in: time
      }).then(function (response) {
        // this.tokenuser_friend = Decode.decodeToken(this.$cookie.get('tokenuser_friend'))
        // this.get_list_richmenu(this.$route.params.roomid)
        _this32.progressLoadChat = false;
        _this32.progressLoadChatBox = false;
        if (response.data['status'] === 'success') {
          // console.log(response.data)
          _this32.statemember = response.data.state_member;
          _this32.items.unshift.apply(_this32.items, response.data['data'].reverse());
          if (response.data.data.length === 20) {
            _this32.statusload = true;
          } else if (response.data.data.length < 20) {
            _this32.statusload = false;
          }
          _this32.selectedForward = _this32.temp;
          // setTimeout(this.scrollDown, 1)
          if (time === '') {
            setTimeout(_this32.scrollDown, 1);
          } else {
            var container = _this32.$el.querySelector('#myscroll');
            _this32.scrollval = container.scrollTop;
            if (_this32.scrollval < 20) {
              var scrollMaxNew = container.scrollHeight;
              container.scrollTop = scrollMaxNew - _this32.scrollMaxOld;
              _this32.scrollMaxOld = scrollMaxNew;
              _this32.scrollval = container.scrollTop;
            }
          }
        } else {
          if (response.data.message === 'not member.') {
            _this32.$router.push('/chat/not_permission');
          }
        }
      }).catch(function (error) {
        _this32.progressLoadChat = false;
        _this32.progressLoadChatBox = false;
        if (error.response.data.message === 'Tokenroom not found.') {
          _this32.$router.push('/chat/not_found');
        }
      });
    },
    get_list_richmenu: function get_list_richmenu(bot_id) {
      var _this33 = this;

      // console.log(typeroom)
      // if (typeroom !== 'group') {
      this.list_richmenu = [];
      this.inforrichmenu = {};
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-richmenu-by-botid', { bot_id: bot_id }).then(function (response) {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          _this33.list_richmenu = response.data.data.list_menu;
          _this33.type_richmenu = parseInt(response.data.data.type_menu);
          _this33.inforrichmenu = response.data.data.list_menu;
          _this33.richmenu_label = response.data.data.menu_label;
          _this33.bot_id_richmenu = response.data.data.bot_id;
          _this33.default_behavior = parseInt(response.data.data.default_behavior);
          if (_this33.default_behavior === 1) {
            _this33.RichmenuState = true;
            _this33.sheetrichmenu = true;
            _this33.RichmenuState_first = true;
          } else {
            _this33.RichmenuState = false;
            _this33.sheetrichmenu = false;
            _this33.RichmenuState_first = false;
          }
          // console.log(this.type_richmenu)
          // console.log(this.inforrichmenu)
        } else {
          // console.log(response.data)
          _this33.list_richmenu = [];
        }
      }).catch(function (error) {
        console.log(error);
      });
      // }
    },
    isBlank: function isBlank(str) {
      return !str || /^\s*$/.test(str);
    },
    isEmpty: function isEmpty(str) {
      return !str || str.length === 0;
    },
    dateMoment: function dateMoment(data) {
      return __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momentdatethai(data);
    },
    timeMoment: function timeMoment(data) {
      return __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimethai(data);
    },
    resendMessage: function resendMessage(data) {
      _.remove(this.items, function (n) {
        return n.tokenmessage === data.tokenmessage;
      });
      this.sendMessage(data.message);
    },
    resendContact: function resendContact(data) {
      _.remove(this.items, function (n) {
        return n.tokenmessage === data.tokenmessage;
      });
      this.sendContact(data);
    },
    sendContact: function sendContact(data) {
      var _this34 = this;

      this.axios.post("https://uatchat-manage.one.th/message" + '/push_contact', {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token,
        tokencontact: data.message,
        type: this.typeuser
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          if (_.find(_this34.items, function (o) {
            return o.tokenmessage === response.data.tokenmessage;
          }) === undefined) {
            _this34.items.push(response.data.data);
            _this34.clearQuickreply();
            _this34.items = _.sortBy(_this34.items, function (dateObj) {
              return new Date(dateObj.timestamp);
            });
            _this34.items = _.unionBy(_this34.items, 'tokenmessage');
            setTimeout(_this34.scrollDown, 1);
          }
          _this34.$swal('', _this34.$t('Alert.Success.account'), 'success');
        } else {
          _this34.items.push({
            tokenuser: _this34.token,
            message: data.tokenuser,
            tokenroom: _this34.$route.params.roomid,
            typeofmessage: 'contact',
            timestamp: __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp(),
            tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp()),
            path_pic: _this34.profile,
            nickname: '',
            file_name: '',
            nickname_contact: data.name,
            pic_contact: data.profilepicture,
            type_contact: data.type,
            status: 'no'
          });
          _this34.$swal('', _this34.$t('Alert.Fail.default.somethingWrong'), 'error');
        }
      }, function () {
        _this34.$swal('Network error', _this34.$t('Alert.Fail.default.networkError'), 'error');
      });
    },
    sendMessage: function sendMessage(data) {
      var _this35 = this;

      // console.log(data)
      this.status_tag = false;
      var index = 0;
      for (index in this.files) {
        this.pushfile(this.files[index].file, this.files[index].name);
        if (index == this.files.length - 1) {
          this.files = [];
          this.sendmsg = '';
        }
      }
      if (this.showmention === false) {
        try {
          if (!this.isBlank(data) && !this.isEmpty(data)) {
            // this.sendmsg = ''
            if (this.typeroom === 'group') {
              var result;
              this.listfriend.map(function (item) {
                // const condition = `^@${item.name}|\\s@${item.name}`
                // const regex = new RegExp(condition, "g")
                // var pattern3 = /\B@([\u0E00-\u0E7Fa-zA-Z'])+/gi
                var pattern3 = /\B@([^\u0000-\u007F]|[\a-zA-Z])+/gi;
                result = data.match(pattern3);
              });
              // console.log(result)
              if (result) {
                var test2 = [];
                for (var i = 0; i < result.length; i++) {
                  // console.log(result[i])
                  var test = this.listfriend.find(function (person) {
                    return person.name.includes(result[i].substring(1));
                  });
                  test2.push(test);
                  // console.log(test2)
                }
                // console.log(test2[0])
                for (var j = 0; j < test2.length; j++) {
                  if (test2[j] !== undefined) {
                    data = data.replace('@' + test2[j].name, '<tax>' + test2[j].tokenuser + '</tax>');
                  }
                }
              }
            }
            // console.log(data)
            this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/pushMessage", {
              tokenroom: this.$route.params.roomid,
              tokenuser: this.token,
              type: this.typeuser,
              message: data.trim()
            }).then(function (response) {
              // console.log(response)
              var messageSendChat = response.data.data;
              if (response.data.status === 'success') {
                messageSendChat['status'] = 'success';
                if (_.find(_this35.items, function (o) {
                  return o.tokenmessage === messageSendChat.tokenmessage;
                }) === undefined) {
                  _this35.items.push(messageSendChat);
                  _this35.clearQuickreply();
                  _this35.items = _.sortBy(_this35.items, function (dateObj) {
                    return new Date(dateObj.timestamp);
                  });
                  _this35.items = _.unionBy(_this35.items, 'tokenmessage');
                }
                setTimeout(_this35.scrollDown, 1);
                _this35.sendmsg = '';
              } else {
                _this35.items.push({
                  tokenuser: _this35.token,
                  message: data,
                  tokenroom: _this35.$route.params.roomid,
                  typeofmessage: 'message',
                  timestamp: __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp(),
                  tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp()),
                  path_pic: _this35.profile,
                  nickname: '',
                  file_name: '',
                  status: 'no'
                });
                _this35.sendmsg = '';
              }
            }, function (error) {
              _this35.items.push({
                tokenuser: _this35.token,
                message: data,
                tokenroom: _this35.$route.params.roomid,
                typeofmessage: 'message',
                timestamp: __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp(),
                tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp()),
                path_pic: _this35.profile,
                nickname: '',
                file_name: '',
                status: 'no'
              });
              _this35.sendmsg = '';
              _this35.$swal('Network error', _this35.$t('Alert.Fail.default.networkError'), 'error');
              console.log(error);
            });
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        this.sendMessageMention(data);
      }
    },
    sendMessageMention: function sendMessageMention(data) {
      var _this36 = this;

      this.showmention = false;
      try {
        if (!this.isBlank(data) && !this.isEmpty(data)) {
          // var result
          // this.listfriend.map((item) => {
          //   var pattern3 = /\B@([\u0E00-\u0E7Fa-zA-Z'])+/gi
          //   result = data.match(pattern3)
          // })
          //   // console.log(result)
          // if(result !== null){
          //   var test2 = []
          //   for(var i=0; i< result.length ; i++){
          //     const test = this.listfriend.find(person =>
          //       person.name.includes(result[i].substring(1)))
          //       test2.push(test)
          //     }
          //     for(var j=0 ; j<test2.length; j++){
          //       data = data.replace(('@'+ test2[j].name), '<tax>'+test2[j].tokenuser+'</tax>')
          //     }
          //   }

          // console.log(data)
          this.axios.post("https://uatchat-manage.one.th/message" + '/mention_message', {
            tokenuser: this.token,
            tokenmessage: this.SelectedMessageDetail.tokenmessage,
            tokenroom: this.$route.params.roomid,
            mention_message: data
          }).then(function (response) {
            var messageSendChat = response.data.data;
            if (response.data.status === 'success') {
              messageSendChat['status'] = 'success';
              if (_.find(_this36.items, function (o) {
                return o.tokenmessage === messageSendChat.tokenmessage;
              }) === undefined) {
                _this36.items.push(messageSendChat);
                _this36.clearQuickreply();
                _this36.items = _.sortBy(_this36.items, function (dateObj) {
                  return new Date(dateObj.timestamp);
                });
                _this36.items = _.unionBy(_this36.items, 'tokenmessage');
              }
              setTimeout(_this36.scrollDown, 1);
              _this36.sendmsg = '';
            } else {
              _this36.items.push({
                tokenuser: _this36.token,
                message: data,
                tokenroom: _this36.$route.params.roomid,
                typeofmessage: 'mention_message',
                timestamp: __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp(),
                tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp()),
                path_pic: _this36.profile,
                nickname: '',
                file_name: '',
                status: 'no'
              });
              _this36.sendmsg = '';
            }
          }, function (error) {
            _this36.items.push({
              tokenuser: _this36.token,
              message: data,
              tokenroom: _this36.$route.params.roomid,
              typeofmessage: 'mention_message',
              timestamp: __WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp(),
              tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_3__services__["c" /* Momenttime */].momenttimestamp()),
              path_pic: _this36.profile,
              nickname: '',
              file_name: '',
              status: 'no'
            });
            _this36.sendmsg = '';
            _this36.$swal('Network error', _this36.$t('Alert.Fail.default.networkError'), 'error');
            console.log(error);
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    checksen: function checksen(data) {
      if (!this.isBlank(data) && !this.isEmpty(data)) {
        return true;
      } else {
        return false;
      }
    },
    clearQuickreply: function clearQuickreply() {
      if (this.Quickreply.length !== 0) {
        // console.log('this.Quickreply')
        // console.log(this.Quickreply)
        // console.log(this.items[this.items.length - 1])
        if (this.Quickreply.timestamp < this.items[this.items.length - 1].timestamp) {
          this.Quickreply = [];
        }
      }
    },
    getMessageSocket: function getMessageSocket(data) {
      // console.log(data)
      // console.log(this.Quickreply)
      // console.log(this.items[this.items.length-1].timestamp)
      this.clearQuickreply();
      if (data.tokenroom === this.$route.params.roomid) {
        if (data.tokenuser !== this.token) {
          this.checkShowmessagwBottom(data);
        }
        if (_.find(this.items, function (o) {
          return o.tokenmessage === data.tokenmessage;
        }) === undefined) {
          this.items.push(data);
          // console.log(this.items)
          this.clearQuickreply();
          this.items = _.sortBy(this.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          this.items = _.unionBy(this.items, 'tokenmessage');
          // console.log(this.items)
          // setTimeout(this.scrollDown, 1)
          if (data.typeofmessage === 'file') {
            this.socketupdate_file = data;
          } else if (data.typeofmessage === 'image') {
            this.socketupdate_img = data;
          }
          if (data.tokenuser !== this.token) {
            this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/user-mark-read', {
              tokenuser: this.token,
              tokenroom: data.tokenroom
            }).then(function (response) {});
          }
        }
      }
    },
    onScroll: function onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    pushfile: function pushfile(file, filename) {
      var _this37 = this;

      var uploadFile = new FormData();
      uploadFile.append('file', file, filename);
      uploadFile.append('tokenroom', this.$route.params.roomid);
      uploadFile.append('tokenuser', this.token);
      uploadFile.append('type', this.typeuser);
      // this.headers = {headers: {'Authorization': this.tokenservice}}
      this.axios.post("https://uatchat-manage.one.th/message" + '/push_image', uploadFile).then(function (response) {
        if (response.data.status === 'success') {
          if (_.find(_this37.items, function (o) {
            return o.tokenmessage === response.data.data.tokenmessage;
          }) === undefined) {
            _this37.socketupdate_img = response.data.data;
            response.data.data.status = 'success';
            _this37.items.push(response.data.data);
            _this37.clearQuickreply();
            _this37.items = _.sortBy(_this37.items, function (dateObj) {
              return new Date(dateObj.timestamp);
            });
            _this37.items = _.unionBy(_this37.items, 'tokenmessage');
            document.querySelector('#uploadpic').value = '';
            document.querySelector('#uploadfileChat').value = '';
          }
          setTimeout(_this37.scrollDown, 1);
        } else {}
      }, function (error) {
        console.log(error);
        _this37.$swal('Network error', _this37.$t('Alert.Fail.default.networkError'), 'error');
      });
    },
    onimgSelected: function onimgSelected(data) {
      var _this38 = this;

      var uploadedFiles = data.target.files;
      var lengthfile = uploadedFiles.length;
      var sizefile = [];
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = uploadedFiles[i].size;
      }
      if (_.sum(sizefile) / 1024 / 1024 > 100) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile100'), type: 'warning' });
      } else {
        for (var _i = 0; _i < uploadedFiles.length; _i++) {
          if (data.target.files[_i].type === 'image/jpeg' || data.target.files[_i].type === 'image/png' || data.target.files[_i].type === 'image/jpg') {
            this.selectFile = data.target.files[_i];
            var uploadFile = new FormData();
            uploadFile.append('file', this.selectFile, this.selectFile.name);
            uploadFile.append('tokenroom', this.$route.params.roomid);
            uploadFile.append('tokenuser', this.token);
            uploadFile.append('type', this.typeuser);
            this.axios.post("https://uatchat-manage.one.th/message" + '/push_image', uploadFile).then(function (response) {
              if (response.data.status === 'success') {
                if (_.find(_this38.items, function (o) {
                  return o.tokenmessage === response.data.data.tokenmessage;
                }) === undefined) {
                  _this38.socketupdate_img = response.data.data;
                  response.data.data.status = 'success';
                  _this38.items.push(response.data.data);
                  _this38.clearQuickreply();
                  _this38.items = _.sortBy(_this38.items, function (dateObj) {
                    return new Date(dateObj.timestamp);
                  });
                  _this38.items = _.unionBy(_this38.items, 'tokenmessage');
                  document.querySelector('#uploadpic').value = '';
                  document.querySelector('#uploadfileChat').value = '';
                }
                setTimeout(_this38.scrollDown, 1);
              } else {}
            }, function (error) {
              console.log(error);
              _this38.$swal('Network error', _this38.$t('Alert.Fail.default.networkError'), 'error');
            });
          } else {
            this.onFileSelected(data);
          }
        }
      }
    },
    onimgSelected_ocr: function onimgSelected_ocr(data) {
      var uploadedFiles = data.target.files;
      var lengthfile = uploadedFiles.length;
      // console.log(this.ocr_detailItem)
      var me = this;
      var reader = new FileReader();
      reader.readAsDataURL(data.target.files[0]);
      reader.onloadend = function () {
        var body = {
          "tokenroom": me.$route.params.roomid,
          "tokenuser": me.token,
          "base64_image": reader.result,
          "multi_select": me.ocr_detailItem.multi_select
        };
        me.dialogWebviewbig_ocr = true;
        // me.Webview_item = {url: "https://chat-develop.one.th/ocr_scantext?id=Ua4KAHvPEqd2wOXF28cD9", label: ''}

        me.axios.post('https://l.one.th/onechat-ocr/api/v1/send-ocr-image', body).then(function (response) {
          // console.log(response.data.data.link)
          if (response.data.message === 'success') {
            // me.dialogWebviewbig = true
            me.Webview_item_ocr = { url: response.data.data.link, label: '' };
          }
        }, function () {
          me.$swal('ไม่สำเร็จ!', 'โปรดอัปโหลดรูปใหม่', 'warning');
        });
      };
    },
    onimgSelected_quickreply: function onimgSelected_quickreply(data) {
      var _this39 = this;

      var uploadedFiles = data.target.files;
      var lengthfile = uploadedFiles.length;
      this.selectFile = data.target.files[0];
      var uploadFile = new FormData();
      uploadFile.append('file', this.selectFile, this.selectFile.name);
      uploadFile.append('tokenroom', this.$route.params.roomid);
      uploadFile.append('tokenuser', this.token);
      uploadFile.append('type_reply', this.itemdetail_quickreply.type);
      uploadFile.append('info_data', this.itemdetail_quickreply.payload);
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/answer_quickreply', uploadFile).then(function (response) {
        if (response.data.status === 'success') {
          if (_.find(_this39.items, function (o) {
            return o.tokenmessage === response.data.data.tokenmessage;
          }) === undefined) {
            // this.socketupdate_img = response.data.data
            // response.data.data.status = 'success'
            _this39.items.push(response.data.data);
            _this39.clearQuickreply();
            _this39.items = _.sortBy(_this39.items, function (dateObj) {
              return new Date(dateObj.timestamp);
            });
            _this39.items = _.unionBy(_this39.items, 'tokenmessage');
            document.querySelector('#uploadfile_quickreply').value = '';
            document.querySelector('#uploadpic_quickreply').value = '';
          }
          setTimeout(_this39.scrollDown, 1);
        } else {}
      }, function (error) {
        console.log(error);
        _this39.$swal('Network error', _this39.$t('Alert.Fail.default.networkError'), 'error');
      });
    },
    clearImage: function clearImage() {
      $('#uploadpic_ocr').val("");
      $('#uploadpic_quickreply').val("");
    },
    onFileSelected: function onFileSelected(data) {
      var _this40 = this;

      // console.log(data)
      // console.log(data.target.files)
      // console.log(this.extension(data.target.files))
      this.sheetother = false;
      var uploadedFiles = data.target.files;
      var lengthfile = uploadedFiles.length;
      var sizefile = [];
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = uploadedFiles[i].size;
      }
      // if (data.target.files.type === 'image/jpeg' || data.target.files.type === 'image/png' || data.target.files.type === 'image/jpg') {
      //   this.onimgSelected(data)
      // } else {
      if (_.sum(sizefile) / 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile'), type: 'warning' });
      } else {
        for (var _i2 = 0; _i2 < uploadedFiles.length; _i2++) {
          if (uploadedFiles[_i2].type === 'image/jpeg' || uploadedFiles[_i2].type === 'image/png' || uploadedFiles[_i2].type === 'image/jpg') {
            var datas = [];
            datas.push(uploadedFiles[_i2]);
            this.onimgDrag(datas);
          } else if (this.extension(uploadedFiles[_i2].name) === 'media') {
            var file_video = [];
            file_video.push(uploadedFiles[_i2]);
            this.push_video(file_video);
          } else {
            this.selectFile = uploadedFiles[_i2];
            var uploadFile = new FormData();
            uploadFile.append('file', this.selectFile, this.selectFile.name);
            uploadFile.append('tokenroom', this.$route.params.roomid);
            uploadFile.append('tokenuser', this.token);
            uploadFile.append('type', this.typeuser);
            this.axios.post("https://uatchat-manage.one.th/message" + '/push_file', uploadFile).then(function (response) {
              // console.log(response.data)
              if (response.data.status === 'success') {
                if (_.find(_this40.items, function (o) {
                  return o.tokenmessage === response.data.data.tokenmessage;
                }) === undefined) {
                  response.data.data.status = 'success';
                  _this40.items.push(response.data.data);
                  _this40.clearQuickreply();
                  _this40.items = _.sortBy(_this40.items, function (dateObj) {
                    return new Date(dateObj.timestamp);
                  });
                  _this40.items = _.unionBy(_this40.items, 'tokenmessage');
                  document.querySelector('#uploadfileChat').value = '';
                  _this40.socketupdate_file = response.data.data;
                }
                setTimeout(_this40.scrollDown, 1);
              } else {}
            }, function (error) {
              console.log(error);
              _this40.$swal('Network error', _this40.$t('Alert.Fail.default.networkError'), 'error');
            });
          }
        }
        // }
      }
    },
    playvideo: function playvideo() {
      if (Hls.isSupported()) {
        var video2 = document.getElementById('livevideo');
        var hls = new Hls();
        hls.loadSource(video2.src); // GC GET VIDEO SRC
        hls.attachMedia(video2);
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          //video2.play();
        });
      }
    },
    push_video: function push_video(data) {
      var _this41 = this;

      this.sheetother = false;
      var lengthfile = data.length;
      var sizefile = [];
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = data[i].size;
      }
      if (_.sum(sizefile) / 1024 / 1024 > 100) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile100'), type: 'warning' });
      } else {
        for (var _i3 = 0; _i3 < data.length; _i3++) {
          // if (data[i].type === 'image/jpeg' || data[i].type === 'image/png' || data[i].type === 'image/jpg') {
          // console.log('it image')
          this.selectFile = data[_i3];
          var uploadFile = new FormData();
          uploadFile.append('file', this.selectFile, this.selectFile.name);
          uploadFile.append('tokenroom', this.$route.params.roomid);
          uploadFile.append('tokenuser', this.token);
          this.axios.post("https://uatchat-manage.one.th/media/api/v1/send-video", uploadFile).then(function (response) {
            if (response.data.status === 'success') {
              if (_.find(_this41.items, function (o) {
                return o.tokenmessage === response.data.data.tokenmessage;
              }) === undefined) {
                _this41.socketupdate_file = response.data.data;
                // console.log(response.data.data)
                response.data.data.status = 'success';
                _this41.items.push(response.data.data);
                _this41.clearQuickreply();
                _this41.items = _.sortBy(_this41.items, function (dateObj) {
                  return new Date(dateObj.timestamp);
                });
                _this41.items = _.unionBy(_this41.items, 'tokenmessage');
                document.querySelector('#uploadpic').value = '';
                document.querySelector('#uploadfileChat').value = '';
              }
              setTimeout(_this41.scrollDown, 1);
            } else {}
          }, function (error) {
            console.log(error);
            _this41.$swal('Network error', _this41.$t('Alert.Fail.default.networkError'), 'error');
          });
          // } else {
          // }
        }
      }
    },
    onimgDrag: function onimgDrag(data) {
      var _this42 = this;

      this.sheetother = false;
      var lengthfile = data.length;
      var sizefile = [];
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = data[i].size;
      }
      if (_.sum(sizefile) / 1024 / 1024 > 100) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile100'), type: 'warning' });
      } else {
        for (var _i4 = 0; _i4 < data.length; _i4++) {
          if (data[_i4].type === 'image/jpeg' || data[_i4].type === 'image/png' || data[_i4].type === 'image/jpg') {
            // console.log('it image')
            this.selectFile = data[_i4];
            var uploadFile = new FormData();
            uploadFile.append('file', this.selectFile, this.selectFile.name);
            uploadFile.append('tokenroom', this.$route.params.roomid);
            uploadFile.append('tokenuser', this.token);
            uploadFile.append('type', this.typeuser);
            this.axios.post("https://uatchat-manage.one.th/message" + '/push_image', uploadFile).then(function (response) {
              if (response.data.status === 'success') {
                if (_.find(_this42.items, function (o) {
                  return o.tokenmessage === response.data.data.tokenmessage;
                }) === undefined) {
                  _this42.socketupdate_img = response.data.data;
                  response.data.data.status = 'success';
                  _this42.items.push(response.data.data);
                  _this42.clearQuickreply();
                  _this42.items = _.sortBy(_this42.items, function (dateObj) {
                    return new Date(dateObj.timestamp);
                  });
                  _this42.items = _.unionBy(_this42.items, 'tokenmessage');
                  document.querySelector('#uploadpic').value = '';
                  document.querySelector('#uploadfileChat').value = '';
                }
                setTimeout(_this42.scrollDown, 1);
              } else {}
            }, function (error) {
              console.log(error);
              _this42.$swal('Network error', _this42.$t('Alert.Fail.default.networkError'), 'error');
            });
          } else {}
        }
      }
    },
    onFileDrag: function onFileDrag(data) {
      var _this43 = this;

      this.sheetother = false;
      var lengthfile = data.length;
      var sizefile = [];
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = data[i].size;
      }
      if (_.sum(sizefile) / 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile'), type: 'warning' });
      } else {
        for (var _i5 = 0; _i5 < data.length; _i5++) {
          if (data[_i5].type === 'image/jpeg' || data[_i5].type === 'image/png' || data[_i5].type === 'image/jpg') {
            var datas = [];
            datas.push(data[_i5]);
            this.onimgDrag(datas);
          } else {
            this.selectFile = data[_i5];
            var uploadFile = new FormData();
            uploadFile.append('file', this.selectFile, this.selectFile.name);
            uploadFile.append('tokenroom', this.$route.params.roomid);
            uploadFile.append('tokenuser', this.token);
            uploadFile.append('type', this.typeuser);
            this.axios.post("https://uatchat-manage.one.th/message" + '/push_file', uploadFile).then(function (response) {
              if (response.data.status === 'success') {
                if (_.find(_this43.items, function (o) {
                  return o.tokenmessage === response.data.data.tokenmessage;
                }) === undefined) {
                  response.data.data.status = 'success';
                  _this43.items.push(response.data.data);
                  _this43.clearQuickreply();
                  _this43.items = _.sortBy(_this43.items, function (dateObj) {
                    return new Date(dateObj.timestamp);
                  });
                  _this43.items = _.unionBy(_this43.items, 'tokenmessage');
                  document.querySelector('#uploadfileChat').value = '';
                  _this43.socketupdate_file = response.data.data;
                }
                setTimeout(_this43.scrollDown, 1);
              } else {}
            }, function (error) {
              console.log(error);
              _this43.$swal('Network error', _this43.$t('Alert.Fail.default.networkError'), 'error');
            });
          }
        }
        // }
      }
    },
    send_location: function send_location(lat, long, address) {
      var _this44 = this;

      // console.log(lat, long, address)
      if (lat !== '' && long !== '') {
        this.axios.post("https://uatchat-manage.one.th/event" + '/push_map', {
          'tokenroom': this.$route.params.roomid,
          'tokenuser': this.token,
          'lat': lat + '',
          'long': long + '',
          'address': address
        }).then(function (response) {
          // console.log(response.data)
          if (response.data.status === 'success') {
            if (_.find(_this44.items, function (o) {
              return o.tokenmessage === response.data.data.tokenmessage;
            }) === undefined) {
              response.data.data.status = 'success';
              _this44.items.push(response.data.data);
              _this44.clearQuickreply();
              _this44.items = _.sortBy(_this44.items, function (dateObj) {
                return new Date(dateObj.timestamp);
              });
              _this44.items = _.unionBy(_this44.items, 'tokenmessage');
            }
            setTimeout(_this44.scrollDown, 1);
          } else {}
        }, function (error) {
          console.log(error);
          _this44.$swal('Network error', _this44.$t('Alert.Fail.default.networkError'), 'error');
        });
      }
    },
    closeNote: function closeNote(value) {
      this.dialogNote = value;
    },
    closeAlbums: function closeAlbums(value) {
      this.dialogAlbums = value;
    },
    closeDetailTask: function closeDetailTask(value) {
      this.dialogDetailTask = value;
    },
    closeAddImage: function closeAddImage(value) {
      this.dialogAddImage = value;
    },
    closeApprove: function closeApprove(value) {
      this.dialogApprove = value;
    },
    closeAccount: function closeAccount(value) {
      this.dialogAccount = value;
    },
    closeSendMap: function closeSendMap(value) {
      this.dialogSendMap = value;
    },
    closeLoginDialog: function closeLoginDialog(value) {
      this.dialogLogin = value;
    },
    closeWebview: function closeWebview(value) {
      // console.log("closeWebview")
      // console.log(value)
      this.Webview_item = {};
      this.dialogWebview = value;
      this.dialogWebviewbig = value;
      this.dialogWebviewbig_ocr = value;
    },
    closeForward: function closeForward(value) {
      this.ForwardState = value;
      this.dialogForward = value;
      this.selectedForward = [];
    },
    detailNote: function detailNote(id) {
      this.dialogNote = true;
      this.note_id = id;
    },
    detailAlbums: function detailAlbums(id) {
      // console.log(id)
      this.dialogAlbums = true;
      this.albums_id = id;
    },
    convertMention: function convertMention(msg) {
      msg = msg.replace(/\<tax>/g, '<span style="color:#1976d2; cursor:pointer;">@');
      msg = msg.replace(/<\/tax>/g, '</span>');
      // console.log(msg)
      return msg;
    },
    convertMentionAnnounce: function convertMentionAnnounce(msg) {
      msg = msg.replace(/\<tax>/g, '<span style="color:white;">@');
      msg = msg.replace(/<\/tax>/g, '</span>');
      // console.log(msg)
      return msg;
    },
    convert: function convert(msg) {
      // var linkifyStr = require('linkifyjs/string')
      // var str = msg
      // var processedContent = linkifyStr(str)
      // processedContent = processedContent.replace('&lt;tax&gt;', '<b style="color:#1976d2;">@')
      // processedContent = processedContent.replace('&lt;/tax&gt;', '</b>')
      // return processedContent
      var linkifyStr = __webpack_require__("nN35");
      var str = msg;
      var processedContent = linkifyStr(str);
      var regex = /\s|<tax>+[\u0E00-\u0E7Fa-zA-Z'|/^\S+@\S+\.\S+$/]+<\/tax>/g;
      // var word = msg.match(regex)
      // console.log(word)
      if (msg.match(regex)) {
        for (var i = 0; i < msg.match(regex).length; i++) {
          // var word = msg.match(regex)
          // @click.native.capture=method
          processedContent = processedContent.replace('&lt;tax&gt;', '<b style="color:#1976d2; cursor:pointer;" >@');
          processedContent = processedContent.replace('&lt;/tax&gt;', '</b>');
        }
      }
      return processedContent;
    },
    convertURL: function convertURL(msg) {
      var urlRegex = /\bhttps?:\/\/\S+/gi;
      var linkmsg = msg.match(urlRegex);
      if (linkmsg !== null) {
        if (linkmsg.length !== 0) {
          // console.log(linkmsg.slice(0,5))
          linkmsg.length = 1;
          return linkmsg;
        }
        return '';
      } else {
        return '';
      }
      // console.log(msg.match(urlRegex) !== null);
    },
    clicklink_website: function clicklink_website(url) {
      // window.open(url)
      this.checkBrowser(url, '');
    },
    testtag: function testtag() {
      // console.log(this.sendmsg)
    },
    filterlistfriend: function filterlistfriend() {
      var _this45 = this;

      if (this.showmention === false && this.typeroom === 'group') {
        // const sectionMsg = this.sendmsg.split(' ')
        // const lastSection = sectionMsg[sectionMsg.length - 1]
        // // console.log(lastSection)
        // const isTag = lastSection.charAt(0) === '@'
        // // console.log(isTag)
        // if(lastSection.charAt(0) === '@' && this.listfriend.length > 1){
        //   var textToSearch = lastSection.slice(1)
        //   this.listfriend_filter = this.listfriend.filter(friend =>
        //     friend.name.toLowerCase().includes(textToSearch.toLowerCase())
        //   )
        //   this.status_tag = true
        //   // console.log(this.listfriend_filter)
        // } else {
        //   this.status_tag = false
        // }
        var sectionMsg = this.sendmsg.split(' ');
        var lastSection = sectionMsg[sectionMsg.length - 1];
        // console.log(lastSection)
        var isTag = lastSection.charAt(0) === '@';
        // console.log(isTag)
        if (isTag) {
          // var textToSearch = lastSection.slice(1)
          this.text_search = lastSection.slice(1);
          // console.log(this.listfriend)
          this.listfriend_filter = this.listfriend.filter(function (friend) {
            return friend.name.toLowerCase().includes(_this45.text_search.toLowerCase());
          });
          // console.log(textToSearch)
          this.status_tag = true;
        } else {
          this.status_tag = false;
        }
      }
    },
    tagFriend: function tagFriend(nametag) {
      this.status_tag = false;
      if (this.text_search == '') {
        this.sendmsg = this.sendmsg + nametag + " ";
      } else {
        if (nametag.toLowerCase().includes(this.text_search)) {
          // console.log()
          this.sendmsg = this.sendmsg.replace(this.text_search, nametag);
        }
      }

      // this.sendmsg = this.sendmsg + nametag + " "
      this.$refs.textareaChat.focus();
    },
    identifyMentionUsers: function identifyMentionUsers() {
      var _this46 = this;

      this.listfriend.map(function (item) {
        var condition = '^@' + item.name + '|\\s@' + item.name;
        var regex = new RegExp(condition, "g");
        var x = [];
        _this46.mentionUsers = _this46.sendmsg.match(regex);
        x.push(_this46.mentionUser);
        console.log(x);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e518c3d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"CSChatThai"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("iaWL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// CONCATENATED MODULE: ./src/pathify/pathify.js


// set options
vuex_pathify_esm["a" /* default */].options.mapping = 'simple';

// re-export
/* harmony default export */ var pathify = (vuex_pathify_esm["a" /* default */]);
// CONCATENATED MODULE: ./src/pathify/store.js


// import custom pathify config (this is optional!)


// import helper function


// setup store
var state = {
  picturegroup: '',
  groupname: '',
  tokenmsgforward: [],
  myname: '',
  myprofilepicture: '',
  mystatus: '',
  mybusiness_id: '',
  chIsactive: '',
  block_friend: {},
  pathsettings: '',
  socketmessage: {},
  socketexpire_login: {},
  socketquickreply: {},
  socketdisablequickreply: {},
  socketdisableapprove: {},
  socketnote: {},
  socketblock: {},
  socketfriend: {},
  socketaccept_friend: {},
  socketremove_request_friend: {},
  socketremove_friend: {},
  socketcreate_group: {},
  socketinvite_group: {},
  socketactive_group: {},
  socketcencel_group: {},
  socketleave_group: {},
  socketupdate_self: {},
  socketupdate_friend: {},
  socketupdate_img: {},
  socketupdate_file: {},
  socket_unsendmessage: {},
  socket_kickmember: {},
  socket_announce: {},
  socket_edittask: {},
  socket_deletetask: {},
  chat_wallpaper: [],
  socket_official_template: {},
  socket_close_webview: {},
  linkmarket: '',
  socket_update_agora: {},
  socket_accept_call: {},
  typeAgoraCall: '',
  socket_switch_richmenu: {},
  socket_switch_keyboard: {},
  socket_drop_menu: {},
  centrifuge_consent: {}
};

var mutations = vuex_pathify_esm["b" /* make */].mutations(state);
// use store
vue_esm["default"].use(vuex_esm["a" /* default */]);

// create store
/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({

  // use the plugin
  plugins: [pathify.plugin],

  // store properties
  state: state,
  mutations: mutations
}));
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/message/messageus.vue
var messageus = __webpack_require__("Ym2m");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23272b7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/message/messageus.vue
var messageus_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"700","persistent":""},model:{value:(_vm.dialogus),callback:function ($$v) {_vm.dialogus=$$v},expression:"dialogus"}},[_c('v-card',{staticClass:"elevation-0",staticStyle:{"width":"100% position:relative","border-radius":"10px"}},[_c('v-card-title',{staticClass:"layout justify-center",staticStyle:{"text-align":"left","position":"relative"},attrs:{"primary-title":""}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"0.5em","right":"0.5em"},on:{"click":function($event){_vm.closedialog()}}},[_vm._v("close")]),_vm._v(" "),_c('div',{staticClass:"headline CSChatThai"},[_vm._v(_vm._s(_vm.$t('Homepage.Dialog.titleSendMessage')))])],1),_vm._v(" "),_c('v-container',[_c('v-text-field',{staticClass:"InputEdit",attrs:{"label":_vm.$t('Homepage.Dialog.name'),"single-line":"","solo":"","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{staticClass:"InputEdit",attrs:{"label":_vm.$t('Homepage.Dialog.email'),"rules":_vm.emailRules,"single-line":"","solo":"","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{staticClass:"InputEdit",attrs:{"label":_vm.$t('Homepage.Dialog.phone'),"mask":"###-###-####","rules":_vm.phoneRules,"required":"","single-line":"","solo":""},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('v-menu',{staticClass:"InputEdit",staticStyle:{"width":"100%","height":"45px"},attrs:{"bottom":"","offset-y":""}},[_c('v-btn',{staticStyle:{"width":"100%","padding":"0","margin":"0","font-size":"14px"},attrs:{"slot":"activator","flat":"","row":"","wrap":""},slot:"activator"},[(!_vm.title.category_TH)?_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"10px","font":"14px","color":"#757575","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.title')))]):_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"10px","font":"14px","color":"black","text-transform":"none"}},[_vm._v(_vm._s((_vm.$i18n.locale == 'th')? _vm.title.category_TH:_vm.title.category_ENG))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"25px !important","color":"#929292"}},[_vm._v("expand_more")])],1),_vm._v(" "),_c('div',{staticStyle:{"background":"white","height":"300px"}},[_c('b',{staticClass:"CSChatThai",staticStyle:{"padding":"5px !important","font-size":"15px","color":"white","background":"#2562af"}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.report'))+" ::")]),_vm._v(" "),_c('v-list',_vm._l((_vm.items.list_report),function(item,index){return _c('v-list-tile',{staticStyle:{"background":"white"},on:{"click":function($event){_vm.title = item;}}},[_c('v-list-tile-title',{staticClass:"CSChatThai",staticStyle:{"font-size":"14px","text-transform":"none"}},[_vm._v(_vm._s((_vm.$i18n.locale == 'th')? item.category_TH:item.category_ENG))])],1)})),_vm._v(" "),_c('div',{staticStyle:{"background":"white"}},[_c('b',{staticClass:"CSChatThai",staticStyle:{"padding":"5px !important","font-size":"15px","color":"white","background":"#2562af"}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.suggestion'))+" ::")]),_vm._v(" "),_c('v-list',_vm._l((_vm.items.list_feedback),function(item,index){return _c('v-list-tile',{staticStyle:{"background":"white"},on:{"click":function($event){_vm.title = item;}}},[_c('v-list-tile-title',{staticClass:"CSChatThai",staticStyle:{"font-size":"14px","text-transform":"none"}},[_vm._v(_vm._s((_vm.$i18n.locale == 'th')? item.category_TH:item.category_ENG))])],1)}))],1)],1)],1)],1),_vm._v(" "),_c('v-textarea',{staticClass:"InputEdit",staticStyle:{"height":"120px","resize":"none","margin-bottom":"15px"},attrs:{"placeholder":_vm.$t('Settings.feedback.detail'),"counter":"","maxlength":"255","full-width":""},model:{value:(_vm.detail),callback:function ($$v) {_vm.detail=$$v},expression:"detail"}}),_vm._v(" "),_c('form',{ref:"fileform",staticStyle:{"display":"flex","justify-content":"center"}},[_c('v-flex',{staticClass:"containers hidden-sm-and-down listfile",attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_vm._l((_vm.files),function(file,key){return (key < 5)?_c('div',{staticClass:"borderfile",staticStyle:{"justify-content":"center","margin-left":"10px"}},[_c('a',{staticClass:"close-classic",on:{"click":function($event){_vm.removeFile( key )}}}),_vm._v(" "),(_vm.extension(file.file.name) == 'fas fa-file-image')?_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center","padding-top":"15px"}},[_c('img',{ref:'preview'+parseInt( key ),refInFor:true,staticClass:"preview",staticStyle:{"height":"30px !important","width":"30px !important","display":"flex","justify-content":"center","margin-left":"20px"}}),_vm._v(" "),_c('b',{staticClass:"text2"},[_vm._v(_vm._s(file.file.name))])]):_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center"}},[_c('v-icon',{staticStyle:{"font-size":"60px !important","color":"#1a222c","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(file.file.name)))]),_vm._v(" "),_c('b',{staticClass:"text2"},[_vm._v(_vm._s(file.file.name))])],1)]):_vm._e()}),_vm._v(" "),(_vm.files.length < 5)?_c('div',{style:(_vm.borderinputfile),on:{"click":function($event){_vm.uppic()}}},[_c('v-icon',{staticStyle:{"color":"#757575","justify-content":"center","align-items":"center","display":"flex"}},[_vm._v("mdi-plus-circle")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#757575","text-align":"center"}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.uploadPhoto'))+"\n              ")]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"files","multiple":"","accept":".png, .jpg, .jpeg, .gif, .bmp, .wbmp"},on:{"change":function($event){_vm.handleFilesUpload()}}})],1):_vm._e()],2)],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"padding-bottom":"20px"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[(_vm.name !== '' && _vm.email !== '' && _vm.title.category_TH && _vm.detail !== '')?_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"dark":"","color":"blue","loading":_vm.loading},on:{"click":function($event){_vm.sendfeedback()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.sendme')))])]):_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"disabled":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.sendme')))])]),_vm._v(" "),_c('v-btn',{staticStyle:{"color":"white !important","background":"gray","text-transform":"none"},attrs:{"dark":""},on:{"click":function($event){_vm.clear()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.clear')))])])],1)],1)],1)}
var messageus_staticRenderFns = []
var messageus_esExports = { render: messageus_render, staticRenderFns: messageus_staticRenderFns }
/* harmony default export */ var message_messageus = (messageus_esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/message/messageus.vue
function messageus_injectStyle (ssrContext) {
  __webpack_require__("8d7s")
}
var messageus_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var messageus___vue_template_functional__ = false
/* styles */
var messageus___vue_styles__ = messageus_injectStyle
/* scopeId */
var messageus___vue_scopeId__ = "data-v-23272b7a"
/* moduleIdentifier (server only) */
var messageus___vue_module_identifier__ = null
var messageus_Component = messageus_normalizeComponent(
  messageus["a" /* default */],
  message_messageus,
  messageus___vue_template_functional__,
  messageus___vue_styles__,
  messageus___vue_scopeId__,
  messageus___vue_module_identifier__
)

/* harmony default export */ var dialog_message_messageus = (messageus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/ProblemDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ProblemDialog = ({
  props: { dialogProblem: false },
  data: function data() {
    var _this = this;

    return {
      valid: false,
      name: '',
      email: '',
      subject: 'r1',
      detail: '',
      items: [],
      emailRules: [function (v) {
        return !!v || _this.$t('Homepage.Dialog.inputEmail');
      }, function (v) {
        return !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || _this.$t('Homepage.Dialog.inputEmailError');
      }],
      nameRules: [function (v) {
        return !!v || _this.$t('Homepage.Dialog.inputName');
      }],
      detailRules: [function (v) {
        return !!v || _this.$t('Homepage.Dialog.inputDetail');
      }]
    };
  },
  created: function created() {
    this.getsubject();
  },

  watch: {},
  computed: {},
  methods: {
    getsubject: function getsubject() {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getcategory').then(function (response) {
        if (response.data.status === 'success') {
          _this2.items = response.data;
        }
      });
    },
    closeDialog: function closeDialog() {
      this.valid = false;
      this.subject = 'r1';
      this.detail = '';
      this.$emit('closeDialogProblem', false);
    },
    report: function report() {
      var _this3 = this;

      var formData = new FormData();
      formData.append('phone', '');
      formData.append('email', this.email);
      formData.append('comment', this.detail);
      formData.append('name', this.name);
      formData.append('category_id', this.subject);
      this.axios.post("https://uatchat-manage.one.th/manage" + '/feedbackcategory', formData).then(function (response) {
        if (response.data.status === 'success') {
          _this3.$swal('', _this3.$t('Alert.Success.success'), 'success');
          _this3.closeDialog();
        } else {
          _this3.$swal('', _this3.$t('Alert.Fail.default.somethingWrong'), 'error');
          _this3.closeDialog();
        }
      }, function () {
        _this3.$swal('', _this3.$t('Alert.Fail.default.somethingWrong'), 'error');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11382c40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/ProblemDialog.vue
var ProblemDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"max-width":"500px","persistent":"","max-height":"500px"},model:{value:(_vm.dialogProblem),callback:function ($$v) {_vm.dialogProblem=$$v},expression:"dialogProblem"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai hidden-sm-and-down"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-bullhorn")]),_vm._v("   "+_vm._s(_vm.$t('Homepage.Dialog.titleReport'))+" ")],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text CSChatThai hidden-md-and-up"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-bullhorn")]),_vm._v("   "+_vm._s(_vm.$t('Homepage.Dialog.titleReport'))+" ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.closeDialog()}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"30px"}},[_c('div',{staticStyle:{"background":"white","padding-top":"2vh"}},[_c('v-layout',{attrs:{"align-center":"","row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-form',{ref:"form",staticClass:"CSChatThai labeltext",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"outline":"","label":_vm.$t('Homepage.Dialog.name'),"rules":_vm.nameRules,"prepend-inner-icon":"fas fa-user-circle"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outline":"","label":_vm.$t('Homepage.Dialog.email'),"rules":_vm.emailRules,"prepend-inner-icon":"fas fa-envelope-square"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.items.list_report,"outline":"","label":_vm.$t('Homepage.Dialog.subject'),"item-text":(_vm.$i18n.locale == 'th')? 'category_TH':'category_ENG',"item-value":"category_id","prepend-inner-icon":"fas fa-exclamation-circle"},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}}),_vm._v(" "),_c('v-textarea',{attrs:{"outline":"","rules":_vm.detailRules,"label":_vm.$t('Homepage.Dialog.detail')},model:{value:(_vm.detail),callback:function ($$v) {_vm.detail=$$v},expression:"detail"}}),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[(_vm.valid)?_c('v-btn',{staticStyle:{"background":"#2562af !important","border-radius":"30px"},attrs:{"dark":""},on:{"click":function($event){_vm.report()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.sendme')))])]):_c('v-btn',{staticStyle:{"border-radius":"30px"},attrs:{"disabled":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.sendme')))])]),_vm._v(" "),_c('v-btn',{staticStyle:{"color":"#2462ae !important","background":"white !important","border-radius":"30px"},attrs:{"dark":""},on:{"click":function($event){_vm.closeDialog()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])])],1)],1)],1)],1)],1)])],1)],1)}
var ProblemDialog_staticRenderFns = []
var ProblemDialog_esExports = { render: ProblemDialog_render, staticRenderFns: ProblemDialog_staticRenderFns }
/* harmony default export */ var homepage_ProblemDialog = (ProblemDialog_esExports);
// CONCATENATED MODULE: ./src/components/homepage/ProblemDialog.vue
function ProblemDialog_injectStyle (ssrContext) {
  __webpack_require__("sray")
}
var ProblemDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ProblemDialog___vue_template_functional__ = false
/* styles */
var ProblemDialog___vue_styles__ = ProblemDialog_injectStyle
/* scopeId */
var ProblemDialog___vue_scopeId__ = "data-v-11382c40"
/* moduleIdentifier (server only) */
var ProblemDialog___vue_module_identifier__ = null
var ProblemDialog_Component = ProblemDialog_normalizeComponent(
  ProblemDialog,
  homepage_ProblemDialog,
  ProblemDialog___vue_template_functional__,
  ProblemDialog___vue_styles__,
  ProblemDialog___vue_scopeId__,
  ProblemDialog___vue_module_identifier__
)

/* harmony default export */ var components_homepage_ProblemDialog = (ProblemDialog_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/login.vue
var login = __webpack_require__("20SD");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a6fffae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"CSChatThai",staticStyle:{"overflow-y":"hidden","background":"white"},attrs:{"id":"inspire"}},[_c('main',[_c('div',{staticClass:"mb-5"},[_c('Navbar')],1),_vm._v(" "),(_vm.url_redirect)?_c('v-content',{staticStyle:{"height":"calc(100vh - 64px)"}},[_c('v-layout',{staticClass:"white--text hidden-sm-and-down",staticStyle:{"background-color":"white !important","background-size":"100% 100%","height":"calc(100% - 5vh)","width":"100vw","background-repeat":"no-repeat","margin-top":"4vh","overflow-y":"hidden"},attrs:{"column":"","align-center":"","justify-center":"","id":"desktop"}},[_c('v-container',{attrs:{"grid-md":"","text-xs-center":""}},[_c('v-layout',{staticStyle:{"align-items":"center","margin-top":"10vh"},attrs:{"row":"","justify-center":"true"}},[_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}}),_vm._v(" "),(_vm.progress)?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[(_vm.progress)?_c('v-progress-circular',{staticStyle:{"margin":"auto"},attrs:{"size":250,"width":10,"indeterminate":"","color":"blue"}}):_vm._e()],1):(_vm.type=='first')?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"33vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"33vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('p',{staticStyle:{"color":"white","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('Login.titleLogin1'))+" "),_c('br'),_vm._v(_vm._s(_vm.$t('Login.titleLogin2')))]),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid text-transform",on:{"click":function($event){_vm.loginRedirect()}}},[_vm._v(_vm._s(_vm.$t('Login.typeLogin1')))]),_vm._v(" "),_c('span',{staticClass:"textor"},[_vm._v("  "+_vm._s(_vm.$t('Login.conjunction'))+"  ")]),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid_white text-transform",staticStyle:{"margin-bottom":"30px"},on:{"click":function($event){_vm.type='phone'}}},[_vm._v(_vm._s(_vm.$t('Login.typeLogin2')))])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1):(_vm.type=='phone')?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"33vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"33vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":_vm.$t('Login.phone'),"mask":"###-###-####","prepend-inner-icon":"phone"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.otp()}},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid text-transform",staticStyle:{"margin-bottom":"30px","width":"40%"},attrs:{"disabled":_vm.phone === '',"loading":_vm.loading},on:{"click":function($event){_vm.otp()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.sendotp')))])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1):(_vm.type=='otp')?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"33vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"33vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('p',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('Login.phone'))+": "+_vm._s(_vm.phone))]),_vm._v(" "),(_vm.Refcode)?_c('p',{staticStyle:{"color":"white"}},[_vm._v("Refcode: "+_vm._s(_vm.Refcode))]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":"otp","maxlength":"6"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.loginWithotp()}},model:{value:(_vm.otpCode),callback:function ($$v) {_vm.otpCode=$$v},expression:"otpCode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-btn',{staticClass:"btnloginwebOneid_white text-transform",staticStyle:{"width":"40%","margin-top":"-24px !important"},attrs:{"depressed":"","disabled":_vm.counting},on:{"click":function($event){_vm.otp()}}},[(_vm.counting)?_c('countdown',{attrs:{"time":60000},on:{"end":_vm.handleCountdownEnd},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.totalSeconds)+" "+_vm._s(_vm.$t('Login.Button.time'))+" ")]}}])}):_vm._e(),_vm._v(" "),(!_vm.counting)?_c('span',[_vm._v(_vm._s(_vm.$t('Login.Button.resend'))+" ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid",staticStyle:{"margin-bottom":"30px","width":"40%"},attrs:{"disabled":_vm.otpCode.length != 6},on:{"click":function($event){_vm.loginWithotp()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.login')))])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}})],1)],1),_vm._v(" "),_c('Download')],1),_vm._v(" "),_c('v-layout',{staticClass:"white--text hidden-md-and-up",staticStyle:{"background-color":"white !important","background-size":"100% 100%","height":"calc(100% - 5vh)","width":"100vw","background-repeat":"no-repeat","margin-top":"4vh","overflow-y":"hidden"},attrs:{"column":"","align-center":"","justify-center":"","id":"mobile"}},[_c('v-container',{staticStyle:{"overflow-y":"scroll"},attrs:{"grid-md":"","text-xs-center":""}},[_c('v-layout',{staticStyle:{"align-items":"center","margin-top":"10vh"},attrs:{"row":"","justify-center":"true"}},[_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}}),_vm._v(" "),(_vm.progress)?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[(_vm.progress)?_c('v-progress-circular',{staticStyle:{"margin":"auto"},attrs:{"size":50,"width":10,"indeterminate":"","color":"blue"}}):_vm._e()],1):(_vm.type=='first')?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"90vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"90vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('p',{staticStyle:{"color":"white","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('Login.titleLogin1'))+" "),_c('br'),_vm._v(_vm._s(_vm.$t('Login.titleLogin2')))]),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid",on:{"click":function($event){_vm.loginRedirect()}}},[_vm._v(_vm._s(_vm.$t('Login.typeLogin1')))]),_vm._v(" "),_c('span',{staticClass:"textor"},[_vm._v("  "+_vm._s(_vm.$t('Login.conjunction'))+"  ")]),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid_white",staticStyle:{"margin-bottom":"30px","width":"95%"},on:{"click":function($event){_vm.type='phone'}}},[_vm._v(_vm._s(_vm.$t('Login.typeLogin2')))])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1):(_vm.type=='phone')?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"90vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"90vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":_vm.$t('Login.phone'),"mask":"###-###-####","prepend-inner-icon":"phone"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.otp()}},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid",staticStyle:{"margin-bottom":"30px","width":"40%"},attrs:{"disabled":_vm.phone === '',"loading":_vm.loading},on:{"click":function($event){_vm.otp()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.sendotp')))])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1):(_vm.type=='otp')?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"90vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"90vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('p',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('Login.phone'))+": "+_vm._s(_vm.phone))]),_vm._v(" "),(_vm.Refcode)?_c('p',{staticStyle:{"color":"white"}},[_vm._v("Refcode: "+_vm._s(_vm.Refcode))]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":"otp","maxlength":"6"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.loginWithotp()}},model:{value:(_vm.otpCode),callback:function ($$v) {_vm.otpCode=$$v},expression:"otpCode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-btn',{staticClass:"btnloginwebOneid_white text-transform",staticStyle:{"width":"40%","margin-top":"-24px !important"},attrs:{"depressed":"","disabled":_vm.counting},on:{"click":function($event){_vm.otp()}}},[(_vm.counting)?_c('countdown',{attrs:{"time":60000},on:{"end":_vm.handleCountdownEnd},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.totalSeconds)+" "+_vm._s(_vm.$t('Login.Button.time'))+" ")]}}])}):_vm._e(),_vm._v(" "),(!_vm.counting)?_c('span',[_vm._v(_vm._s(_vm.$t('Login.Button.resend'))+" ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid text-transform",staticStyle:{"margin-bottom":"30px","width":"40%"},attrs:{"disabled":_vm.otpCode.length != 6},on:{"click":function($event){_vm.loginWithotp()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.login')))])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}})],1)],1),_vm._v(" "),_c('Download')],1)],1):_c('v-content',{staticStyle:{"height":"calc(100vh - 64px)"}},[_c('v-layout',{staticClass:"white--text hidden-sm-and-down",staticStyle:{"background-color":"white !important","background-size":"100% 100%","height":"calc(100% - 5vh)","width":"100vw","background-repeat":"no-repeat","margin-top":"4vh","overflow-y":"hidden"},attrs:{"column":"","align-center":"","justify-center":"","id":"desktop"}},[_c('v-container',{attrs:{"grid-md":"","text-xs-center":""}},[_c('v-layout',{staticStyle:{"align-items":"center","margin-top":"10vh"},attrs:{"row":"","justify-center":"true"}},[_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}}),_vm._v(" "),(_vm.progress)?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[(_vm.progress)?_c('v-progress-circular',{staticStyle:{"margin":"auto"},attrs:{"size":250,"width":10,"indeterminate":"","color":"blue"}}):_vm._e()],1):_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"33vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"33vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":_vm.$t('Login.username'),"prepend-inner-icon":"person"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()},"keypress":function($event){_vm.isNumandaz($event)}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"},attrs:{"solo":"","label":_vm.$t('Login.password'),"type":_vm.showPassword ? 'text' : 'password',"prepend-inner-icon":"lock","append-icon":_vm.showPassword ? 'mdi-eye' : 'mdi-eye-off'},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()},"keypress":function($event){_vm.isnotthai($event)},"click:append":function($event){_vm.showPassword = !_vm.showPassword}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),(_vm.status == 'fail' )?_c('div',{staticStyle:{"color":"#f9a1a1","width":"100%"}},[_c('v-icon',{staticStyle:{"color":"#f9a1a1"}},[_vm._v("info")]),_vm._v(" "+_vm._s(_vm.failmessage)+" ")],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"btnloginweb text-transform",on:{"click":function($event){_vm.login()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.login')))]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"5vh","padding-top":"1vh","text-align":"center"}},[_c('p',{staticClass:"CSChatThai text-transform",staticStyle:{"text-align":"right"}},[_c('b',[_c('span',{staticClass:"forgetpass",on:{"click":function($event){_vm.open_link('https://one.th/type_forgot_password')}}},[_vm._v(_vm._s(_vm.$t('Login.forgotpass'))+"?")])])])])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}})],1)],1),_vm._v(" "),_c('Download')],1),_vm._v(" "),_c('v-layout',{staticClass:"white--text hidden-md-and-up scrolling-wrapper",staticStyle:{"background-color":"white !important","background-size":"auto 100%","height":"calc(100vh - 64px)","width":"100vw","background-repeat":"no-repeat","margin-top":"4vh"},attrs:{"column":"","align-center":"","justify-center":"","id":"mobile"}},[(_vm.progress)?_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-progress-circular',{attrs:{"size":100,"width":7,"indeterminate":"","color":"blue"}})],1)],1):_c('v-container',{staticClass:"scrolling-wrapper",staticStyle:{"height":"calc(100vh - 64px)"},attrs:{"grid-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":""}},[_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"height":"auto","width":"auto","justify-content":"center","margin-top":"8vh","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"100%"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticClass:"CSChatThai",staticStyle:{"padding":"0px 10%"}},[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":_vm.$t('Login.username'),"rules":_vm.usernameRules,"prepend-inner-icon":"person"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"},attrs:{"solo":"","label":_vm.$t('Login.password'),"type":_vm.showPassword ? 'text' : 'password',"rules":_vm.passwordRules,"prepend-inner-icon":"lock","append-icon":_vm.showPassword ? 'mdi-eye' : 'mdi-eye-off'},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()},"click:append":function($event){_vm.showPassword = !_vm.showPassword}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),(_vm.status == 'fail' )?_c('div',{staticStyle:{"color":"#f9a1a1","width":"100%"}},[_c('v-icon',{staticStyle:{"color":"#f9a1a1"}},[_vm._v("info")]),_vm._v(" "+_vm._s(_vm.failmessage)+" ")],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-center CSChatThai",staticStyle:{"padding-bottom":"30px","padding-top":"0px","display":"flex","justify-content":"center"}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('v-btn',{staticClass:"btnloginmobile text-transform",attrs:{"disabled":_vm.username == '' || _vm.password == ''},on:{"click":function($event){_vm.login()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.login')))]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-end":""}},[_c('p',{staticClass:"CSChatThai text-transform"},[_c('b',[_c('span',{on:{"click":function($event){_vm.open_link('https://one.th/type_forgot_password')}}},[_vm._v(_vm._s(_vm.$t('Login.forgotpass'))+"?")])])])])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('Download')],1)],1),_vm._v(" "),_c('checkconsentOnechatDialog',{attrs:{"url_consent":_vm.url_consent,"consentOnechatDialog":_vm.consentOnechatDialog},on:{"closeDialogConsentOnechat":_vm.closeDialogConsentOnechat}}),_vm._v(" "),_c('newConsent',{attrs:{"newConsentDialog":_vm.newConsentDialog,"newConsentDetail":_vm.newConsentDetail},on:{"closeNewConsent":_vm.closeNewConsent}})],1)])}
var login_staticRenderFns = []
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var homepage_login = (login_esExports);
// CONCATENATED MODULE: ./src/components/homepage/login.vue
function login_injectStyle (ssrContext) {
  __webpack_require__("DJDA")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = "data-v-1a6fffae"
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  login["a" /* default */],
  homepage_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var components_homepage_login = (login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/qrcodeRedirect.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var qrcodeRedirect = ({
  data: function data() {
    var _ref;

    return _ref = {
      openedApp: false,
      snackbar: false,
      textsnackbar: 'ดาวน์โหลดแอปพลิเคชัน One Chat',
      deviceos: '',
      status_login: '',
      onechat: 'One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้'
    }, defineProperty_default()(_ref, 'deviceos', ''), defineProperty_default()(_ref, 'dialogProblem', false), defineProperty_default()(_ref, 'dialogus', false), defineProperty_default()(_ref, 'cardtext', [{ text: 'ส่งข้อความ, ไฟล์, เสียง, รูปภาพ และยังมีฟังก์ชันอื่น ๆ', icon: '/static/img/homepage/icon/chat2x.png' }, { text: 'บริการในตระกูล One Platform', icon: '/static/img/homepage/icon/one2x.png' }, { text: 'เชื่อมต่อกับ One E-mail ที่ให้บริการฟรีอีเมล', icon: '/static/img/homepage/icon/mail2x.png' }, { text: 'การใช้งาน Chat Bot', icon: '/static/img/homepage/icon/bot2x.png' }, { text: 'มีบริการ One Box ที่ให้บริการฟรีพื้นที่จัดเก็บไฟล์ข้อมูล', icon: '/static/img/homepage/icon/box2x.png' }, { text: 'ระบบความน่าเชื่อถือในตัวบุคคล', icon: '/static/img/homepage/icon/security2x.png' }]), defineProperty_default()(_ref, 'onechatDev', Object({"NODE_ENV":"uat","API":"https://uatchat.one.th","APIQRcode":"https://uatchat.one.th","APIpub":"https://uatchat-manage.one.th/event","APIimage":"https://uatchat-manage.one.th/message","APIsocket":"https://uatchat-public.one.th:8998","APImanage":"https://uatchat-manage.one.th/manage","ONEID_API":"https://testoneid.inet.co.th/api","WEBchatdev":"https://uatchat.one.th:8089/docs","Bot_idPaperless":"B0df132b88f9a526691a0576bfdb24196","Bot_idcovid":"Bbe2c9fe1bcc956738a61c9ad0d91cb19","taxid_consent":"0107544000094","serviceid_consent":"SVC-1611218040238","formid_consent":"600956682f8678001cce54e8","AuthenOneid":"https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect","LogoutOneid":"https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage","redirect_url":"https://uatchat.one.th/authorization/redirect","Market_env":"staging","APInew_listchat":"https://uatchat-manage.one.th/go_api/api/v4/getListChat","APInew_getdict":"https://uatchat-manage.one.th/alpine/api/v1/getdictmessage","APInew_pushmessage":"https://uatchat-manage.one.th/alpine/api/v1/pushMessage","APInew_getaccesstoken":"https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken","APInew_getrichmenu":"https://uatchat-manage.one.th/go_api/api/v1/getRichmenuByTokenroom","APInew_addfriend":"https://uatchat-manage.one.th/go_api/api/v1/add-friend","APIcheck_consent":"https://uatapigw.appsdigit.inet.co.th/api/chat/service/check-consent","APInew_pushvideo":"https://uatchat-manage.one.th/media/api/v1/send-video","APInew_acceptfriend":"https://uatchat-manage.one.th/go_api/api/v1/accept-friend","APInew_creategroup":"https://uatchat-manage.one.th/go_api/api/v1/create-group","APIalpine":"https://uatchat-manage.one.th/alpine","APIgo_api":"https://uatchat-manage.one.th/go_api/api","WEBoneEmail":"https://testoneid.inet.co.th/preauth","WEBoneBox":"https://testoneid.inet.co.th/oauth/authorize?client_id=155&response_type=code&scope=account","WEBNews":"https://news.chat.korkla.in/checkauthen?authen=","WEB_Redirect_Onebox":"https://uatbox.one.th/loginbysharetoken?token=","WebAnonymous":"https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token=","Savelognews":"https://news.chat.one.th/backend/api/v1/page-analytics","urlEkyc":"https://uat-ekyc.id.th/redirect-share-token?shared_token=","linkonemeet":"https://meet-test.one.th/?sharetoken=","API_onemeet":"https://meet-test.one.th/","WEB_centrifuge":"wss://uatchat-manage.one.th/connection/websocket","centrifuge_key":'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs',"APIsearchfriend":"https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend","urlLoa":"https://testoneid.inet.co.th/login?redirect_url=https://testoneid.inet.co.th/portal_level&shared_token=","check_password":"https://uatchat-manage.one.th/bot-message/check"}).ONECHATDEV + 'docs'), _ref;
  },

  components: {
    ProblemDialog: components_homepage_ProblemDialog,
    messageusDialog: dialog_message_messageus,
    Login: components_homepage_login
  },
  created: function created() {
    // this.$router.push('/not_found')
    if (this.$route.params.type === 'friend' || this.$route.params.type === 'group') {
      // this.redirectto('onechat://com.oneplatform/qrcode/' + this.$route.params.type + '?id=' + this.$route.query.id)
    } else if (this.$route.params.type === 'market') {
      this.redirectto('onechat://com.oneplatform/market/');
    } else if (this.$route.params.type === 'market_link') {
      this.redirectto('onechat://com.oneplatform/market_link?link=' + this.$route.query.link);
    } else if (this.$route.params.type === 'link-to-bot-room') {
      this.redirectto('onechat://com.oneplatform/link-to-bot-room?bot_token=' + this.$route.query.bot_token);
    } else if (this.$route.params.type === 'qrcode-go-room') {
      try {
        this.redirectto('onechat://com.oneplatform/qrcode-go-room?bot_token=' + this.$route.query.bot_token + '&data=' + this.$route.query.data);
      } catch (error) {
        alert('jam ' + error);
      }
    } else if (this.$route.params.type === 'go-ekyc') {
      this.redirectto('onechat://com.oneplatform/go-ekyc?bot_token=' + this.$route.query.bot_token);
    } else {
      this.$router.push('/not_found');
    }

    // this.$cookie.set('status_login', 'T')
    // var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    // this.status_login = decoded['status_login']
    // if (this.status_login === 'T') {
    //   this.$cookie.set('path_type', this.$route.params.type)
    //   this.$cookie.set('path_id', this.$route.query.id)
    //   this.$router.push('/chat')
    // } else {
    //   // console.log(this.$cookie.get('status_login'))
    // }

    // console.log(Decode.decode(localStorage.getItem('Authenrization')))

    try {
      // console.log(Decode.decode(localStorage.getItem('Authenrization')))
      var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      // console.log(decoded)
      this.status_login = decoded['status_login'];
    } catch (er) {
      console.log(er);
    }
    // console.log(this.status_login)

    if (this.$route.params.type == 'friend' || this.$route.params.type === 'weburl-go-room') {
      if (this.status_login === 'T') {
        this.$cookie.set('path_type', this.$route.params.type);
        this.$cookie.set('path_id', this.$route.query.id);
        console.log(window.innerWidth);
        if (window.innerWidth <= 960) {
          this.$router.push('/mobile/homepage');
        } else {
          this.$router.push('/chat');
        }
      } else {
        console.log('type: ' + this.$route.params.type);
        console.log('status login: ' + this.status_login);
        this.$cookie.set('path_type', this.$route.params.type);
        this.$cookie.set('path_id', this.$route.query.id);
        // this.$router.push('/login')
      }
    }
  },

  methods: {
    openAppOrStore: function openAppOrStore(url, store) {
      console.log(store);
      var me = this;
      setTimeout(function () {
        if (!me.openedApp) {
          window.location = store;
        }
      }, 25);
      try {
        window.location = url;
        if (window.location.href.indexOf("onechat://") !== -1) {
          me.openedApp = true;
        }
      } catch (e) {}
    },
    redirectto: function redirectto(url) {
      var me = this;
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // console.log(userAgent)
      setTimeout(function () {
        if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
          // console.log(me.$route.query.service)
          // console.log(me.$route.params.type)
          // console.log(me.$route.name)
          // if(me.$route.params.type && me.$route.query.service) {
          //   if (me.$route.params.type !== 'friend' || me.$route.query.service !== 'onemeet') {
          //     me.openAppOrStore(url, 'https://apps.apple.com/th/app/onechat/id1394435274#?platform=iphone');
          //   }
          // } else
          if (me.$route.params.type) {
            me.openAppOrStore(url, 'https://apps.apple.com/th/app/onechat/id1394435274#?platform=iphone');
          }
        } else {
          me.openAppOrStore(url, 'https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat');
        }
      }, 25);
    },
    redirectto2: function redirectto2(url) {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // if (/android/i.test(userAgent)) {
      //   setTimeout(function () { window.location = "https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat"; }, 25);
      //   window.location = url;
      // }
      // if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
      //   setTimeout(function () { window.location = "https://itunes.apple.com/th/app/onechat/id1394435274?mt=8"; }, 25);
      //   window.location = url;
      // }
      // return "unknown";


      if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
        var now = new Date().valueOf();
        setTimeout(function () {
          if (new Date().valueOf() - now > 100) return;
          window.location = "https://apps.apple.com/th/app/onechat/id1394435274#?platform=iphone";
        }, 25);
        window.location = url;
      } else {
        var now = new Date().valueOf();
        setTimeout(function () {
          if (new Date().valueOf() - now > 100) return;
          window.location = "https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat";
        }, 25);
        window.location = url;
      }
    },
    toNewTab: function toNewTab() {
      window.open("https://uatchat.one.th:8089/docs", '_blank').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    downloadios: function downloadios() {
      window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus();
    },
    downloadandroid: function downloadandroid() {
      window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus();
    },
    closedownload: function closedownload() {
      this.snackbar = false;
    },
    loadepage: function loadepage() {
      window.open('http://onelink.to/hpyvpk', '_blank');
    },
    closeDialogProblem: function closeDialogProblem(value) {
      this.dialogProblem = value;
    },
    closeDialogus: function closeDialogus(value) {
      this.dialogus = value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38d3caf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qrcodeRedirect.vue
var qrcodeRedirect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status_login !== '')?_c('div',{class:_vm.$vuetify.breakpoint.mdAndUp ? 'Background' : 'BackgroundMobile',staticStyle:{"background-color":"white","height":"100vh","padding-top":"64px","overflow-y":"auto","overflow-x":"hidden"},attrs:{"dark":"","id":"home"}},[_c('v-layout',{},[_c('div',{staticClass:"text"},[_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"height":"90vh"},attrs:{"align-center":"","row":"","wrap":"","justify-center":"","fill-height":""}},[_c('v-flex',{staticStyle:{"display":"grid"},attrs:{"xs12":"","sm12":"","md5":"","xl5":"","lg5":""}},[_c('v-img',{staticStyle:{"max-height":"90vh"},attrs:{"src":"/static/img/homepage/onechat_app.png","alt":"banner onechat"}}),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"4vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"200","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"200","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"4vh"},attrs:{"xs12":"","sm12":"","md7":"","xl7":"","lg7":""}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"2vh"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-img',{staticStyle:{"max-height":"100px","justify-content":"center","width":"256px"},attrs:{"src":"/static/img/icons/logoonechat_full.png","alt":"icon onechat"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"6vh","color":"black","font-size":"20px"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("\" แอปพลิเคชันแชทของคนไทยเพื่อคนไทย")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("เราจะทำให้ทุกการสนทนาของคุณปลอดภัย \"")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-sm-and-down",staticStyle:{"display":"flex","margin-top":"6vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-btn',{staticClass:"btnhover",attrs:{"to":"/register","round":"","dark":"","color":"#2562B0"}},[_vm._v("ร่วมเป็นส่วนหนึ่งกับพวกเรา")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"align-center":"","row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticStyle:{"margin-top":"6em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{attrs:{"src":"/static/img/icons/logoonechat_full.png","width":"120","height":"50"}}),_vm._v(" "),_c('h1',{staticStyle:{"color":"#2562B0","padding-left":"20px"}},[_vm._v("คือ อะไร?")])])],1),_vm._v(" "),(_vm.$vuetify.breakpoint.width <= 1028 && _vm.$vuetify.breakpoint.height >=1366)?_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"margin-top":"1.5em"},attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"700"}},[_c('p',{staticStyle:{"padding":"20px","margin-bottom":"0px","font-size":"20px"}},[_vm._v("\n                     One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้\n              ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10em","margin-right":"10em","margin-top":"140px"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"50vh"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","max-width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1),_vm._v(" "),_c('div',[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"20px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการฟรีอีเมล")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"margin-left":"20px"},attrs:{"round":"","color":"#2562B0","target":"_blank","href":" https://mail.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs122":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"190"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"370","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)])],1)],1)],1)],1):_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"margin-top":"1.5em","border-radius":"10px"},attrs:{"align-center":"","justify-space-around":"","row":"","wrap":"","fill-height":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"700"}},[_c('p',{staticStyle:{"padding":"20px","margin-bottom":"0px","font-size":"20px"}},[_vm._v("\n                     One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้\n              ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10em","margin-right":"10em","margin-top":"140px"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"50vh"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":"","align-center":"","fill-height":""}},[_c('div',[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","max-width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1),_vm._v(" "),_c('div',[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"20px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการฟรีอีเมล")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"margin-left":"20px"},attrs:{"round":"","color":"#2562B0","target":"_blank","href":" https://mail.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","margin-right":"100px"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0"},attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px","margin-left":"150px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh","margin-right":"10em"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"margin-left":"30px"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"190"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","margin-right":"120px"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"370","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh","margin-left":"80px"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"hidden-md-and-up",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticStyle:{"padding-top":"3em"},attrs:{"xs12":"","sm12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"max-height":"100px","justify-content":"center","width":"256px"},attrs:{"src":"/static/img/icons/logoonechat_full.png","alt":"icon onechat"}})])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"2em","color":"black","font-size":"15px"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("\" แอปพลิเคชันแชทของคนไทยเพื่อคนไทย")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("เราจะทำให้ทุกการสนทนาของคุณปลอดภัย \"")])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"6vh","margin-bottom":"3em","color":"black","justify-content":"center"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-btn',{attrs:{"to":"/register","round":"","dark":"","color":"#2562B0"}},[_vm._v("ร่วมเป็นส่วนหนึ่งกับพวกเรา")])],1),_vm._v(" "),_c('img',{staticClass:"hidden-md-and-up",staticStyle:{"max-height":"40vh"},attrs:{"src":"/static/img/homepage/onechat_app.png","alt":"banner onechat"}}),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"4vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",staticStyle:{"max-width":"150px"},attrs:{"src":"/static/img/download/rsz_googleplay.png","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",staticStyle:{"max-width":"150px"},attrs:{"src":"/static/img/download/rsz_appstore.png","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"hidden-md-and-up",staticStyle:{"margin-top":"6em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{attrs:{"src":"/static/img/icons/logoonechat_full.png","width":"120","height":"50"}}),_vm._v(" "),_c('h1',{staticStyle:{"color":"#2562B0","padding-left":"20px"}},[_vm._v("คือ อะไร?")])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"480"}},[_c('p',{staticStyle:{"padding":"20px","font-size":"18px","margin-bottom":"0px"}},[_vm._v("\n                       One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้\n                ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic","margin-bottom":"20px"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"150","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1),_vm._v(" "),_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"30px"},attrs:{"color":"#BFDBFF","tile":"","width":"150","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("บริการฟรีอีเมล")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"margin-left":"40px"},attrs:{"round":"","color":"#2562B0","target":"_blank","href":" https://mail.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"170"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic","max-height":"100vh"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"170"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat download"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('messageusDialog',{attrs:{"dialogus":_vm.dialogus},on:{"closeDialogus":_vm.closeDialogus}}),_vm._v(" "),_c('ProblemDialog',{attrs:{"dialogProblem":_vm.dialogProblem},on:{"closeDialogProblem":_vm.closeDialogProblem}})],1),_vm._v(" "),_c('div',{staticClass:"footer hidden-sm-and-down"},[_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{staticClass:"footertitle"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"justify-end":""}},[_c('img',{staticStyle:{"width":"260px"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{staticStyle:{"padding-left":"20px"},attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-start":""}},[_c('b',[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-start":""}},[_c('div',[_c('span',{staticStyle:{"display":"flex-inline"}},[_vm._v(" เวลาทำการ วันจันทร์ - ศุกร์ ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_vm._v("เวลา 09.00 - 17.00 น.")])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                       ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                      ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        เขตห้วยขวาง กรุงเทพมหานคร 10310\n                      ")])],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"align-start":"","row":"","wrap":"","justify-start":"","fill-height":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบายการใช้งาน")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v("ส่งข้อความถึงเรา")])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"problemIcon hidden-sm-and-down"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticStyle:{"background":"#2662af","height":"60px !important","width":"60px !important"},attrs:{"slot":"activator","fab":"","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogProblem = !_vm.dialogProblem}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"30px"}},[_vm._v("fas fa-bullhorn")])],1),_vm._v(" "),_c('span',[_vm._v("พบเจอปัญหา")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"footerMobile hidden-md-and-up"},[(_vm.$vuetify.breakpoint.width >= 768)?_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{staticClass:"footermobiletext"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"220px","height":"intrinsic"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{staticStyle:{"padding-left":"20px"},attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('b',[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{},[_vm._v(" เวลาทำการ วันจันทร์ - ศุกร์ ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("เวลา 09.00 - 17.00")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',[_vm._v("\n                          1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                          "),_c('br'),_vm._v("\n                          ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                          "),_c('br'),_vm._v("\n                          เขตห้วยขวาง กรุงเทพมหานคร 10310\n                        ")])])],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"align-start":"","row":"","wrap":"","justify-center":"","fill-height":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('a',{staticClass:"footerlink",staticStyle:{"color":"black !important"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบายการใช้งาน")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v("ส่งข้อความถึงเรา")])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1):_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"300px","height":"intrinsic"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticStyle:{"padding-left":"25px"}},[_c('v-flex',{staticStyle:{"margin-bottom":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('b',[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-bottom":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{},[_vm._v(" เวลาทำการ วันจันทร์ - ศุกร์ ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("เวลา 09.00 - 17.00")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',[_vm._v("\n                        1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                        "),_c('br'),_vm._v("\n                        ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                        "),_c('br'),_vm._v("\n                        เขตห้วยขวาง กรุงเทพมหานคร 10310\n                      ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"color":"black !important"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบายการใช้งาน")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v("ส่งข้อความถึงเรา")])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"problemIconMobile hidden-md-and-up"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticStyle:{"background":"#2662af","height":"40px !important","width":"40px !important"},attrs:{"slot":"activator","fab":"","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogProblem = !_vm.dialogProblem}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"20px"}},[_vm._v("fas fa-bullhorn")])],1),_vm._v(" "),_c('span',[_vm._v("พบเจอปัญหา")])],1)],1)],1):_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('Login')],1)}
var qrcodeRedirect_staticRenderFns = []
var qrcodeRedirect_esExports = { render: qrcodeRedirect_render, staticRenderFns: qrcodeRedirect_staticRenderFns }
/* harmony default export */ var components_qrcodeRedirect = (qrcodeRedirect_esExports);
// CONCATENATED MODULE: ./src/components/qrcodeRedirect.vue
function qrcodeRedirect_injectStyle (ssrContext) {
  __webpack_require__("js+G")
}
var qrcodeRedirect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var qrcodeRedirect___vue_template_functional__ = false
/* styles */
var qrcodeRedirect___vue_styles__ = qrcodeRedirect_injectStyle
/* scopeId */
var qrcodeRedirect___vue_scopeId__ = "data-v-38d3caf2"
/* moduleIdentifier (server only) */
var qrcodeRedirect___vue_module_identifier__ = null
var qrcodeRedirect_Component = qrcodeRedirect_normalizeComponent(
  qrcodeRedirect,
  components_qrcodeRedirect,
  qrcodeRedirect___vue_template_functional__,
  qrcodeRedirect___vue_styles__,
  qrcodeRedirect___vue_scopeId__,
  qrcodeRedirect___vue_module_identifier__
)

/* harmony default export */ var src_components_qrcodeRedirect = (qrcodeRedirect_Component.exports);

// EXTERNAL MODULE: ./src/components/homepage/Navbar.vue + 2 modules
var Navbar = __webpack_require__("6n5U");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Homepage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { Decode } from '@/services'
/* harmony default export */ var Homepage = ({
  data: function data() {
    return {
      onechat: 'One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้',
      snackbar: true,
      deviceos: '',
      dialogProblem: false,
      dialogus: false,
      cardtext: [{ text: 'ส่งข้อความ, ไฟล์, เสียง, รูปภาพ และยังมีฟังก์ชันอื่น ๆ', icon: '/static/img/homepage/icon/chat2x.png' }, { text: 'บริการในตระกูล One Platform', icon: '/static/img/homepage/icon/one2x.png' }, { text: 'เชื่อมต่อกับ One E-mail ที่ให้บริการฟรีอีเมล', icon: '/static/img/homepage/icon/mail2x.png' }, { text: 'การใช้งาน Chat Bot', icon: '/static/img/homepage/icon/bot2x.png' }, { text: 'มีบริการ One Box ที่ให้บริการฟรีพื้นที่จัดเก็บไฟล์ข้อมูล', icon: '/static/img/homepage/icon/box2x.png' }, { text: 'ระบบความน่าเชื่อถือในตัวบุคคล', icon: '/static/img/homepage/icon/security2x.png' }],
      onechatDev: Object({"NODE_ENV":"uat","API":"https://uatchat.one.th","APIQRcode":"https://uatchat.one.th","APIpub":"https://uatchat-manage.one.th/event","APIimage":"https://uatchat-manage.one.th/message","APIsocket":"https://uatchat-public.one.th:8998","APImanage":"https://uatchat-manage.one.th/manage","ONEID_API":"https://testoneid.inet.co.th/api","WEBchatdev":"https://uatchat.one.th:8089/docs","Bot_idPaperless":"B0df132b88f9a526691a0576bfdb24196","Bot_idcovid":"Bbe2c9fe1bcc956738a61c9ad0d91cb19","taxid_consent":"0107544000094","serviceid_consent":"SVC-1611218040238","formid_consent":"600956682f8678001cce54e8","AuthenOneid":"https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect","LogoutOneid":"https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage","redirect_url":"https://uatchat.one.th/authorization/redirect","Market_env":"staging","APInew_listchat":"https://uatchat-manage.one.th/go_api/api/v4/getListChat","APInew_getdict":"https://uatchat-manage.one.th/alpine/api/v1/getdictmessage","APInew_pushmessage":"https://uatchat-manage.one.th/alpine/api/v1/pushMessage","APInew_getaccesstoken":"https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken","APInew_getrichmenu":"https://uatchat-manage.one.th/go_api/api/v1/getRichmenuByTokenroom","APInew_addfriend":"https://uatchat-manage.one.th/go_api/api/v1/add-friend","APIcheck_consent":"https://uatapigw.appsdigit.inet.co.th/api/chat/service/check-consent","APInew_pushvideo":"https://uatchat-manage.one.th/media/api/v1/send-video","APInew_acceptfriend":"https://uatchat-manage.one.th/go_api/api/v1/accept-friend","APInew_creategroup":"https://uatchat-manage.one.th/go_api/api/v1/create-group","APIalpine":"https://uatchat-manage.one.th/alpine","APIgo_api":"https://uatchat-manage.one.th/go_api/api","WEBoneEmail":"https://testoneid.inet.co.th/preauth","WEBoneBox":"https://testoneid.inet.co.th/oauth/authorize?client_id=155&response_type=code&scope=account","WEBNews":"https://news.chat.korkla.in/checkauthen?authen=","WEB_Redirect_Onebox":"https://uatbox.one.th/loginbysharetoken?token=","WebAnonymous":"https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token=","Savelognews":"https://news.chat.one.th/backend/api/v1/page-analytics","urlEkyc":"https://uat-ekyc.id.th/redirect-share-token?shared_token=","linkonemeet":"https://meet-test.one.th/?sharetoken=","API_onemeet":"https://meet-test.one.th/","WEB_centrifuge":"wss://uatchat-manage.one.th/connection/websocket","centrifuge_key":'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs',"APIsearchfriend":"https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend","urlLoa":"https://testoneid.inet.co.th/login?redirect_url=https://testoneid.inet.co.th/portal_level&shared_token=","check_password":"https://uatchat-manage.one.th/bot-message/check"}).ONECHATDEV + 'docs'
      // status_login: ''
    };
  },

  components: {
    ProblemDialog: components_homepage_ProblemDialog,
    messageusDialog: dialog_message_messageus
  },
  methods: {
    toNewTab: function toNewTab() {
      window.open("https://uatchat.one.th:8089/docs", '_blank').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    downloadapp: function downloadapp() {
      if (this.deviceos === 'ios') {
        window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus();
      } else {
        window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus();
      }
    },
    downloadapp_ios: function downloadapp_ios() {
      window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus();
    },
    downloadapp_and: function downloadapp_and() {
      window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus();
    },
    closeDialogProblem: function closeDialogProblem(value) {
      this.dialogProblem = value;
    },
    closeDialogus: function closeDialogus(value) {
      this.dialogus = value;
    }
  },
  created: function created() {
    // console.log('kskksk')
    var device = __webpack_require__("GtN+").default;
    this.deviceos = device.os;
    // console.log(require('current-device').default.os)
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
    // this.$i18n.locale = 'th'
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561750b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Homepage.vue
var Homepage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$vuetify.breakpoint.mdAndUp ? 'Background' : 'BackgroundMobile',staticStyle:{"background-color":"white","height":"100vh","padding-top":"64px","overflow-y":"auto","overflow-x":"hidden"},attrs:{"dark":"","id":"home"}},[_c('v-layout',{},[_c('div',{staticClass:"text"},[_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"height":"90vh"},attrs:{"align-center":"","row":"","wrap":"","justify-center":"","fill-height":""}},[_c('v-flex',{staticStyle:{"display":"grid"},attrs:{"xs12":"","sm12":"","md5":"","xl5":"","lg5":""}},[_c('v-img',{staticStyle:{"max-height":"90vh"},attrs:{"src":"/static/img/homepage/onechat_app.png","alt":"banner onechat"}}),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"4vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"200","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"200","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"4vh"},attrs:{"xs12":"","sm12":"","md7":"","xl7":"","lg7":""}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"2vh"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-img',{staticStyle:{"max-height":"100px","justify-content":"center","width":"256px"},attrs:{"src":"/static/img/icons/logoonechat_full.png","alt":"icon onechat"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"6vh","color":"black","font-size":"20px"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("\" "+_vm._s(_vm.$t('Homepage.Title.title1')))])]),_vm._v(" "),_c('v-flex',{staticStyle:{"justify-content":"center","align-items":"center","display":"flex"},attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Homepage.Title.title2'))+" \"")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-sm-and-down",staticStyle:{"display":"flex","margin-top":"6vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-btn',{staticClass:"btnhover text-transform",attrs:{"to":"/register","round":"","dark":"","color":"#2562B0"}},[_vm._v(_vm._s(_vm.$t('Homepage.Button.join')))])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"align-center":"","row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticStyle:{"margin-top":"6em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{attrs:{"src":"/static/img/icons/logoonechat_full.png","width":"120","height":"50"}}),_vm._v(" "),_c('h1',{staticStyle:{"color":"#2562B0","padding-left":"20px"}},[_vm._v(_vm._s(_vm.$t('Homepage.Title.title3')))])])],1),_vm._v(" "),(_vm.$vuetify.breakpoint.width <= 1028 && _vm.$vuetify.breakpoint.height >=1366)?_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"margin-top":"1.5em"},attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"700"}},[_c('p',{staticStyle:{"padding":"20px","margin-bottom":"0px","font-size":"20px"}},[_vm._v("\n                    "+_vm._s(_vm.$t('Homepage.Detail.detailOnechat'))+"\n              ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10em","margin-right":"10em","margin-top":"140px"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"50vh"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","max-width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOneplatform')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnebox')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticClass:"text-transform",attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v(_vm._s(_vm.$t('Homepage.Button.moredetail')))])],1)],1),_vm._v(" "),_c('div',[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"20px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnemail')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticClass:"linkmail text-transform",staticStyle:{"margin-left":"20px"},attrs:{"round":"","color":"#2562B0","target":"_blank","href":" https://mail.one.th/"}},[_vm._v(_vm._s(_vm.$t('Homepage.Button.moredetail')))])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnechatFn1')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs122":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"190"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnechatFn2'))+"\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"370","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnechatFn3')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"text-transform",staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('Homepage.Button.moredetail')))])],1)])],1)],1)],1)],1):_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"margin-top":"1.5em","border-radius":"10px"},attrs:{"align-center":"","justify-space-around":"","row":"","wrap":"","fill-height":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"700"}},[_c('p',{staticStyle:{"padding":"20px","margin-bottom":"0px","font-size":"20px"}},[_vm._v("\n                     "+_vm._s(_vm.$t('Homepage.Detail.detailOnechat'))+"\n              ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10em","margin-right":"10em","margin-top":"140px"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"50vh"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":"","align-center":"","fill-height":""}},[_c('div',[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","max-width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOneplatform')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnebox')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticClass:"text-transform",attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v("\n                            "+_vm._s(_vm.$t('Homepage.Button.moredetail'))+"\n                            ")])],1)],1),_vm._v(" "),_c('div',[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"20px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnemail')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticClass:"text-transform",staticStyle:{"margin-left":"20px"},attrs:{"round":"","color":"#2562B0","target":"_blank","dark":"","href":" https://mail.one.th/"}},[_vm._v(_vm._s(_vm.$t('Homepage.Button.moredetail')))])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","margin-right":"100px"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0"},attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnechatFn1')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px","margin-left":"150px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh","margin-right":"10em"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"margin-left":"30px"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"190"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnechatFn2'))+"\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","margin-right":"120px"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"370","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnechatFn3')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"text-transform",staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('Homepage.Button.moredetail')))])],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh","margin-left":"80px"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"hidden-md-and-up",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticStyle:{"padding-top":"3em"},attrs:{"xs12":"","sm12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"max-height":"100px","justify-content":"center","width":"256px"},attrs:{"src":"/static/img/icons/logoonechat_full.png","alt":"icon onechat"}})])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"2em","color":"black","font-size":"15px"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("\" "+_vm._s(_vm.$t('Homepage.Title.title1')))])]),_vm._v(" "),_c('v-flex',{staticStyle:{"justify-content":"center","align-items":"center","display":"flex"},attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Homepage.Title.title2'))+" \"")])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"6vh","margin-bottom":"3em","color":"black","justify-content":"center"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-btn',{staticClass:"text-transform",attrs:{"to":"/register","round":"","dark":"","color":"#2562B0"}},[_vm._v(_vm._s(_vm.$t('Homepage.Button.join')))])],1),_vm._v(" "),_c('img',{staticClass:"hidden-md-and-up",staticStyle:{"max-height":"40vh"},attrs:{"src":"/static/img/homepage/onechat_app.png","alt":"banner onechat"}}),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"4vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",staticStyle:{"max-width":"150px"},attrs:{"src":"/static/img/download/rsz_googleplay.png","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",staticStyle:{"max-width":"150px"},attrs:{"src":"/static/img/download/rsz_appstore.png","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"hidden-md-and-up",staticStyle:{"margin-top":"6em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{attrs:{"src":"/static/img/icons/logoonechat_full.png","width":"120","height":"50"}}),_vm._v(" "),_c('h1',{staticStyle:{"color":"#2562B0","padding-left":"20px"}},[_vm._v(_vm._s(_vm.$t('Homepage.Title.title3')))])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"480"}},[_c('p',{staticStyle:{"padding":"20px","font-size":"18px","margin-bottom":"0px"}},[_vm._v("\n                       "+_vm._s(_vm.$t('Homepage.Detail.detailOnechat'))+"\n                ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic","margin-bottom":"20px"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOneplatform')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"150","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnebox')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticClass:"text-transform",attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v(_vm._s(_vm.$t('Homepage.Button.moredetail')))])],1)],1),_vm._v(" "),_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"30px"},attrs:{"color":"#BFDBFF","tile":"","width":"150","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnemail')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticClass:"text-transform",staticStyle:{"margin-left":"40px"},attrs:{"round":"","color":"#2562B0","target":"_blank","dark":"","href":" https://mail.one.th/"}},[_vm._v(_vm._s(_vm.$t('Homepage.Button.moredetail')))])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"170"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnechatFn1')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"170"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnechatFn2'))+"\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat download"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v(_vm._s(_vm.$t('Homepage.Detail.detailOnechatFn3')))]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"text-transform",staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('Homepage.Button.moredetail')))])],1)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('messageusDialog',{attrs:{"dialogus":_vm.dialogus},on:{"closeDialogus":_vm.closeDialogus}}),_vm._v(" "),_c('ProblemDialog',{attrs:{"dialogProblem":_vm.dialogProblem},on:{"closeDialogProblem":_vm.closeDialogProblem}})],1),_vm._v(" "),_c('div',{staticClass:"footer hidden-sm-and-down"},[_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{staticClass:"footertitle"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"justify-end":""}},[_c('img',{staticStyle:{"width":"260px"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{staticStyle:{"padding-left":"20px"},attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-start":""}},[_c('b',[_vm._v(_vm._s(_vm.$t('Homepage.Footer.companyname')))])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-start":""}},[_c('div',[_c('span',{staticStyle:{"display":"flex"}},[_vm._v(_vm._s(_vm.$t('Homepage.Footer.date')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_vm._v(_vm._s(_vm.$t('Homepage.Footer.time')))])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        "+_vm._s(_vm.$t('Homepage.Footer.address1'))+"\n                    ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        "+_vm._s(_vm.$t('Homepage.Footer.address2'))+"\n                    ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        "+_vm._s(_vm.$t('Homepage.Footer.address3'))+"\n                    ")])],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"align-start":"","row":"","wrap":"","justify-start":"","fill-height":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('a',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v(_vm._s(_vm.$t('Homepage.Footer.policy')))])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v(_vm._s(_vm.$t('Homepage.Footer.sendmsg')))])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"problemIcon hidden-sm-and-down"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticClass:"text-transform",staticStyle:{"background":"#2662af","height":"60px !important","width":"60px !important"},attrs:{"slot":"activator","fab":"","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogProblem = !_vm.dialogProblem}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"30px"}},[_vm._v("fas fa-bullhorn")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Homepage.Footer.report')))])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"footerMobile hidden-md-and-up"},[(_vm.$vuetify.breakpoint.width >= 768)?_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{staticClass:"footermobiletext"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"220px","height":"intrinsic"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{staticStyle:{"padding-left":"20px"},attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('b',[_vm._v(_vm._s(_vm.$t('Homepage.Footer.companyname')))])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{},[_vm._v(_vm._s(_vm.$t('Homepage.Footer.date')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Homepage.Footer.time')))])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',[_vm._v("\n                          "+_vm._s(_vm.$t('Homepage.Footer.address1'))+"\n                          "),_c('br'),_vm._v("\n                          "+_vm._s(_vm.$t('Homepage.Footer.address2'))+"\n                          "),_c('br'),_vm._v("\n                          "+_vm._s(_vm.$t('Homepage.Footer.address3'))+"\n                        ")])])],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"align-start":"","row":"","wrap":"","justify-center":"","fill-height":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('a',{staticClass:"footerlink",staticStyle:{"color":"black !important"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v(_vm._s(_vm.$t('Homepage.Footer.policy')))])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v(_vm._s(_vm.$t('Homepage.Footer.sendmsg')))])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1):_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"300px","height":"intrinsic"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticStyle:{"padding-left":"25px"}},[_c('v-flex',{staticStyle:{"margin-bottom":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('b',[_vm._v(_vm._s(_vm.$t('Homepage.Footer.companyname')))])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-bottom":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{},[_vm._v(_vm._s(_vm.$t('Homepage.Footer.date')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Homepage.Footer.time')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',[_vm._v("\n                        "+_vm._s(_vm.$t('Homepage.Footer.address1'))+"\n                        "),_c('br'),_vm._v("\n                        "+_vm._s(_vm.$t('Homepage.Footer.address2'))+"\n                        "),_c('br'),_vm._v("\n                        "+_vm._s(_vm.$t('Homepage.Footer.address3'))+"\n                      ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('a',{staticClass:"footerlink",staticStyle:{"color":"black !important"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v(_vm._s(_vm.$t('Homepage.Footer.policy')))])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v(_vm._s(_vm.$t('Homepage.Footer.sendmsg')))])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"problemIconMobile hidden-md-and-up"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticClass:"text-transform",staticStyle:{"background":"#2662af","height":"40px !important","width":"40px !important"},attrs:{"slot":"activator","fab":"","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogProblem = !_vm.dialogProblem}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"20px"}},[_vm._v("fas fa-bullhorn")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Homepage.Footer.report')))])],1)],1)],1)}
var Homepage_staticRenderFns = []
var Homepage_esExports = { render: Homepage_render, staticRenderFns: Homepage_staticRenderFns }
/* harmony default export */ var homepage_Homepage = (Homepage_esExports);
// CONCATENATED MODULE: ./src/components/homepage/Homepage.vue
function Homepage_injectStyle (ssrContext) {
  __webpack_require__("s68P")
}
var Homepage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Homepage___vue_template_functional__ = false
/* styles */
var Homepage___vue_styles__ = Homepage_injectStyle
/* scopeId */
var Homepage___vue_scopeId__ = "data-v-561750b3"
/* moduleIdentifier (server only) */
var Homepage___vue_module_identifier__ = null
var Homepage_Component = Homepage_normalizeComponent(
  Homepage,
  homepage_Homepage,
  Homepage___vue_template_functional__,
  Homepage___vue_styles__,
  Homepage___vue_scopeId__,
  Homepage___vue_module_identifier__
)

/* harmony default export */ var components_homepage_Homepage = (Homepage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Home.vue
//
//
//
//
//
//



/* harmony default export */ var Home = ({
  components: {
    Navbar: Navbar["a" /* default */],
    Homepage: components_homepage_Homepage
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-339e2b92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_vm._v(" "),_c('Homepage')],1)}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var homepage_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/homepage/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("r7AF")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-339e2b92"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  homepage_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var components_homepage_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Aboutus.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Aboutus = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26135cba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Aboutus.vue
var Aboutus_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"CSChatThai hidden-sm-and-down",staticStyle:{"height":"calc(100vh - 37px)","background-color":"white"}},[_c('v-layout',{attrs:{"id":"about","column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-2",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h1',{staticClass:"display-2 CSChatThai",staticStyle:{"margin-top":"7vw"}},[_vm._v("เกี่ยวกับ One Chat")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"CSChatThai",staticStyle:{"text-align":"justify","margin-left":"120px","margin-right":"120px","font-size":"20px"}},[_vm._v("    "),_c('strong',[_vm._v("One Chat")]),_vm._v(" เป็นแอปพลิเคชันหนึ่งในตระกูลของ "),_c('strong',[_c('a',{attrs:{"href":"https://one.th/","target":"_blank"}},[_vm._v("One Platform")])]),_vm._v(" ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้ ซึ่ง One Chat สามารถส่งข้อความ, ไฟล์, รูปภาพ และยังมีฟังก์ชันอื่น ๆ อีกมากมาย ปัจจุบันสามารถใช้ One Chat ได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS) ที่สำคัญ One Chat ยังเชื่อมต่อกับ "),_c('strong',[_c('a',{attrs:{"href":"https://mail.one.th/","target":"_blank"}},[_vm._v("One E-mail")])]),_vm._v(" ที่ให้บริการฟรีอีเมล, "),_c('strong',[_c('a',{attrs:{"href":"https://box.one.th/login","target":"_blank"}},[_vm._v("One Box")])]),_vm._v(" ที่ให้บริการฟรีพื้นที่จัดเก็บไฟล์ข้อมูล และแอปพลิเคชันอื่น ๆ ในตระกูล One Platform อีกด้วย\n        ")])]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"CSChatThai hidden-md-and-up",staticStyle:{"background-color":"white"}},[_c('v-layout',{attrs:{"id":"aboutmo","column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-2",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h1',{staticClass:"display-2",staticStyle:{"margin-top":"14vw","font-size":"25px !important"}},[_vm._v("เกี่ยวกับ One Chat")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline CSChatThai",staticStyle:{"margin":"10px !important","font-size":"16px !important","text-align":"justify"}},[_vm._v("    "),_c('strong',[_vm._v("One Chat")]),_vm._v(" เป็นแอปพลิเคชันหนึ่งในตระกูลของ "),_c('strong',[_c('a',{attrs:{"href":"https://one.th/","target":"_blank"}},[_vm._v("One Platform")])]),_vm._v(" ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้ ซึ่ง One Chat สามารถส่งข้อความ, ไฟล์, รูปภาพ และยังมีฟังก์ชันอื่น ๆ อีกมากมาย ปัจจุบันสามารถใช้ One Chat ได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS) ที่สำคัญ One Chat ยังเชื่อมต่อกับ "),_c('strong',[_c('a',{attrs:{"href":"https://mail.one.th/","target":"_blank"}},[_vm._v("One E-mail")])]),_vm._v(" ที่ให้บริการฟรีอีเมล, "),_c('strong',[_c('a',{attrs:{"href":"https://box.one.th/login","target":"_blank"}},[_vm._v("One Box")])]),_vm._v(" ที่ให้บริการฟรีพื้นที่จัดเก็บไฟล์ข้อมูล และแอปพลิเคชันอื่น ๆ ในตระกูล One Platform อีกด้วย ")])]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"})],1)],1)],1)],1)],1)],1)],1)])}
var Aboutus_staticRenderFns = []
var Aboutus_esExports = { render: Aboutus_render, staticRenderFns: Aboutus_staticRenderFns }
/* harmony default export */ var homepage_Aboutus = (Aboutus_esExports);
// CONCATENATED MODULE: ./src/components/homepage/Aboutus.vue
function Aboutus_injectStyle (ssrContext) {
  __webpack_require__("0l21")
}
var Aboutus_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Aboutus___vue_template_functional__ = false
/* styles */
var Aboutus___vue_styles__ = Aboutus_injectStyle
/* scopeId */
var Aboutus___vue_scopeId__ = "data-v-26135cba"
/* moduleIdentifier (server only) */
var Aboutus___vue_module_identifier__ = null
var Aboutus_Component = Aboutus_normalizeComponent(
  Aboutus,
  homepage_Aboutus,
  Aboutus___vue_template_functional__,
  Aboutus___vue_styles__,
  Aboutus___vue_scopeId__,
  Aboutus___vue_module_identifier__
)

/* harmony default export */ var components_homepage_Aboutus = (Aboutus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Footer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Footer = ({
  data: function data() {
    return {
      snackbar: false,
      textsnackbar: 'ดาวน์โหลดแอปพลิเคชัน One Chat',
      deviceos: '',
      webdev: "https://uatchat.one.th:8089/docs"
    };
  },

  methods: {
    toNewTab: function toNewTab() {
      window.open(this.webdev, '_blank').focus();
    },
    linkAPI: function linkAPI() {
      window.open('/docs', '_blank').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    linkregister: function linkregister() {
      window.open('/register').focus();
    },
    linkdownload: function linkdownload() {
      window.open('/download').focus();
    },
    downloadios: function downloadios() {
      window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus();
    },
    downloadandroid: function downloadandroid() {
      window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus();
    },
    closedownload: function closedownload() {
      this.snackbar = false;
    }
  },
  created: function created() {
    var device = __webpack_require__("GtN+").default;
    this.deviceos = device.os;
    // console.log(this.deviceos)
    this.snackbar = true;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bc1009d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Footer.vue
var Footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"footer hidden-sm-and-down"},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/about')}}},[_vm._v("เกี่ยวกับเรา")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toNewTab()}}},[_vm._v("API")])])]),_vm._v(" "),_c('p',{staticStyle:{"padding-left":"20px","padding-right":"20px","color":"black"}},[_c('b',[_vm._v("© "+_vm._s(new Date().getFullYear())+" One Centric Company Limited")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบาย")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/contactus')}}},[_vm._v("ติดต่อเรา")])])])])],1),_vm._v(" "),_c('div',{staticClass:"footermobile hidden-md-and-up"},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/about')}}},[_vm._v("เกี่ยวกับเรา")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toNewTab()}}},[_vm._v("API")]),_vm._v(" |")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบาย")]),_vm._v(" |")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/contactus')}}},[_vm._v("ติดต่อเรา")])])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('p',{staticStyle:{"padding-left":"20px","padding-right":"20px","color":"black"}},[_c('b',[_vm._v("© "+_vm._s(new Date().getFullYear())+" One Centric Company Limited")])])])],1)],1)])}
var Footer_staticRenderFns = []
var Footer_esExports = { render: Footer_render, staticRenderFns: Footer_staticRenderFns }
/* harmony default export */ var homepage_Footer = (Footer_esExports);
// CONCATENATED MODULE: ./src/components/homepage/Footer.vue
function Footer_injectStyle (ssrContext) {
  __webpack_require__("+quJ")
}
var Footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Footer___vue_template_functional__ = false
/* styles */
var Footer___vue_styles__ = Footer_injectStyle
/* scopeId */
var Footer___vue_scopeId__ = "data-v-2bc1009d"
/* moduleIdentifier (server only) */
var Footer___vue_module_identifier__ = null
var Footer_Component = Footer_normalizeComponent(
  Footer,
  homepage_Footer,
  Footer___vue_template_functional__,
  Footer___vue_styles__,
  Footer___vue_scopeId__,
  Footer___vue_module_identifier__
)

/* harmony default export */ var components_homepage_Footer = (Footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Aboutuspage.vue
//
//
//
//
//
//
//




/* harmony default export */ var Aboutuspage = ({
  components: {
    Navbar: Navbar["a" /* default */],
    Aboutus: components_homepage_Aboutus,
    Footer: components_homepage_Footer
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d9c5015","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Aboutuspage.vue
var Aboutuspage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_vm._v(" "),_c('Aboutus'),_vm._v(" "),_c('Footer')],1)}
var Aboutuspage_staticRenderFns = []
var Aboutuspage_esExports = { render: Aboutuspage_render, staticRenderFns: Aboutuspage_staticRenderFns }
/* harmony default export */ var homepage_Aboutuspage = (Aboutuspage_esExports);
// CONCATENATED MODULE: ./src/components/homepage/Aboutuspage.vue
function Aboutuspage_injectStyle (ssrContext) {
  __webpack_require__("4tR0")
}
var Aboutuspage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Aboutuspage___vue_template_functional__ = false
/* styles */
var Aboutuspage___vue_styles__ = Aboutuspage_injectStyle
/* scopeId */
var Aboutuspage___vue_scopeId__ = "data-v-2d9c5015"
/* moduleIdentifier (server only) */
var Aboutuspage___vue_module_identifier__ = null
var Aboutuspage_Component = Aboutuspage_normalizeComponent(
  Aboutuspage,
  homepage_Aboutuspage,
  Aboutuspage___vue_template_functional__,
  Aboutuspage___vue_styles__,
  Aboutuspage___vue_scopeId__,
  Aboutuspage___vue_module_identifier__
)

/* harmony default export */ var components_homepage_Aboutuspage = (Aboutuspage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Download.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import NewFooter from '@/components/home/NewFooter'
/* harmony default export */ var Download = ({
  data: function data() {
    return {
      webdev: "https://uatchat.one.th:8089/docs"
    };
  },
  components: {
    Navbar: Navbar["a" /* default */],
    Footer: components_homepage_Footer
  },
  methods: {
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    toNewTab: function toNewTab() {
      window.open(this.webdev, '_blank').focus();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-023dc112","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Download.vue
var Download_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"white","overflow-y":"hidden","width":"100%","height":"100%"}},[_c('Navbar'),_vm._v(" "),_c('v-container',{staticStyle:{"background":"white","padding":"16px !important","font-family":"'CS ChatThaiUI' !important","text-align":"center","height":"calc(100vh - 64px)"},attrs:{"id":"policy","mt-5":""}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"hidden-sm-and-down",staticStyle:{"height":"calc(100% - 10vh)"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":"","xl12":"","lg12":""}},[_c('img',{staticStyle:{"margin-top":"0vw","width":"30vw"},attrs:{"src":"/static/img/onechat/banner-homepage.jpg"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('a',{staticClass:"mr-4",attrs:{"href":"https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat","target":"_blank"}},[_c('img',{staticStyle:{"margin-top":"0vw","width":"15vw"},attrs:{"src":"/static/img/download/googleplay.png"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://itunes.apple.com/th/app/onechat/id1394435274?mt=8","target":"_blank"}},[_c('img',{staticStyle:{"margin-top":"0vw","width":"15vw"},attrs:{"src":"/static/img/download/appstore.png"}})])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"hidden-md-and-up scrolling-wrapper",staticStyle:{"height":"calc(100% - 10vh)"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":""}},[_c('img',{staticStyle:{"margin-top":"10vh","width":"70vw"},attrs:{"src":"/static/img/onechat/banner-homepage.jpg"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat","target":"_blank"}},[_c('img',{staticStyle:{"margin-top":"0vw","width":"35vw"},attrs:{"src":"/static/img/download/googleplay.png"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://itunes.apple.com/th/app/onechat/id1394435274?mt=8","target":"_blank"}},[_c('img',{staticStyle:{"margin-top":"0vw","width":"35vw"},attrs:{"src":"/static/img/download/appstore.png"}})])])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"footermo",attrs:{"align-center":"","column":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/about')}}},[_vm._v("เกี่ยวกับเรา")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toNewTab()}}},[_vm._v("API")]),_vm._v(" |")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบาย")]),_vm._v(" |")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/contactus')}}},[_vm._v("ติดต่อเรา")])])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('p',{staticStyle:{"padding-left":"20px","padding-right":"20px","color":"black !important"}},[_c('b',[_vm._v("© "+_vm._s(new Date().getFullYear())+" One Centric Company Limited")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"footer hidden-sm-and-down"},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/about')}}},[_vm._v("เกี่ยวกับเรา")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toNewTab()}}},[_vm._v("API")])])]),_vm._v(" "),_c('p',{staticStyle:{"padding-left":"20px","padding-right":"20px","color":"black"}},[_c('b',[_vm._v("© "+_vm._s(new Date().getFullYear())+" One Centric Company Limited")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบาย")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"5px"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/contactus')}}},[_vm._v("ติดต่อเรา")])])])])],1)])],1)}
var Download_staticRenderFns = []
var Download_esExports = { render: Download_render, staticRenderFns: Download_staticRenderFns }
/* harmony default export */ var homepage_Download = (Download_esExports);
// CONCATENATED MODULE: ./src/components/homepage/Download.vue
function Download_injectStyle (ssrContext) {
  __webpack_require__("fWUN")
}
var Download_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Download___vue_template_functional__ = false
/* styles */
var Download___vue_styles__ = Download_injectStyle
/* scopeId */
var Download___vue_scopeId__ = "data-v-023dc112"
/* moduleIdentifier (server only) */
var Download___vue_module_identifier__ = null
var Download_Component = Download_normalizeComponent(
  Download,
  homepage_Download,
  Download___vue_template_functional__,
  Download___vue_styles__,
  Download___vue_scopeId__,
  Download___vue_module_identifier__
)

/* harmony default export */ var components_homepage_Download = (Download_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-100vh/src/vue100vh/index.js
var vue100vh = __webpack_require__("hErE");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/settings/PolicyMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PolicyMobile = ({
  data: function data() {
    return {
      // policydialog: true
    };
  },

  components: {
    vue100vh: vue100vh["a" /* default */]
  },
  created: function created() {
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
  },

  methods: {
    toPage: function toPage(data) {
      this.$router.push(data);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-464ba44a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/settings/PolicyMobile.vue
var PolicyMobile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('div',{staticStyle:{"overflow-y":"hidden"}},[_c('v-card',[_c('v-card-text',{staticStyle:{"height":"100vh","overflow-y":"scroll","margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('h2',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","text-decoration":"underline","margin-top":"50px"}},[_vm._v(_vm._s(_vm.$t('Settings.policy.header'))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject1.introDetail'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro1'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro2'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro3'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro4'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro5'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro6'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro7'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro8'))+"\n      ")]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject2.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject2.subHeaderScopeA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeA1'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeA2'))),_c('br'),_vm._v(" "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject2.subHeaderScopeB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeB1'))+"\n      ")]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject3.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subHeaderTypeA')))]),_vm._v("\n         "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubHeaderA'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectA1')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA1'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectA2')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA2'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA21'))),_c('br'),_vm._v(" "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subHeaderTypeB')))]),_vm._v("\n         "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubHeaderB'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB1')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB1'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB2'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB2')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB2'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB3')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB3'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB4')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB41'))+"\n        "),_c('br'),_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB42'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB5')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB51'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB52'))+"\n\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB6')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB6'))+"\n          "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB7')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB71'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB72'))+"\n\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB8')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB8'))+"\n\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB9')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB91'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB92'))+"\n         \n        "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject4.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"font-size":"13px","padding":"1vw"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA'))+"\n\n\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA1'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA2'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA3'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA4'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA5'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA6'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA7'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA8'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA9'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA10'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA11'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA12'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA13'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA14'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA15'))+"\n\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA16'))+"\n\n         "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectB1'))+"\n\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectB2'))+"\n\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectC')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectC'))+"\n         "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectD')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD1'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD2'))+"\n        "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD3'))+"\n        "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD4'))+"\n        "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD5'))+"\n        "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD6'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectE')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectE'))+"\n         "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectF')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectF'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectG')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG1'))+"\n        "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG2'))+"\n        "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG3'))+"\n        "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG4'))+"\n        "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG5'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG6'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG7'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG8'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG9'))+"\n        "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject5.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.detailHeader'))+"\n          "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA1'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA2'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA3'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA4'))+" \n         "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB1'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB2'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB3'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB4'))+"\n        "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject6.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject6.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectA'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject6.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectB1'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectB2'))+"\n\n        "),_c('br')]),_vm._v(" "),_c('br')])],1)],1)])}
var PolicyMobile_staticRenderFns = []
var PolicyMobile_esExports = { render: PolicyMobile_render, staticRenderFns: PolicyMobile_staticRenderFns }
/* harmony default export */ var settings_PolicyMobile = (PolicyMobile_esExports);
// CONCATENATED MODULE: ./src/components/mobile/settings/PolicyMobile.vue
function PolicyMobile_injectStyle (ssrContext) {
  __webpack_require__("h/Jn")
}
var PolicyMobile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PolicyMobile___vue_template_functional__ = false
/* styles */
var PolicyMobile___vue_styles__ = PolicyMobile_injectStyle
/* scopeId */
var PolicyMobile___vue_scopeId__ = "data-v-464ba44a"
/* moduleIdentifier (server only) */
var PolicyMobile___vue_module_identifier__ = null
var PolicyMobile_Component = PolicyMobile_normalizeComponent(
  PolicyMobile,
  settings_PolicyMobile,
  PolicyMobile___vue_template_functional__,
  PolicyMobile___vue_styles__,
  PolicyMobile___vue_scopeId__,
  PolicyMobile___vue_module_identifier__
)

/* harmony default export */ var mobile_settings_PolicyMobile = (PolicyMobile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Policy.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import Footer from '@/components/home/Footer'
/* harmony default export */ var Policy = ({
  components: {
    Navbar: Navbar["a" /* default */],
    Footer: components_homepage_Footer,
    PolicyMobile: mobile_settings_PolicyMobile
    // ,Footer
  },
  created: function created() {
    // this.$i18n.locale = 'th'
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
  },

  methods: {
    linkAPI: function linkAPI() {
      window.open('/docs', '_blank').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    linkregister: function linkregister() {
      window.open('/register').focus();
    },
    linkdownload: function linkdownload() {
      window.open('/download').focus();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f0add2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Policy.vue
var Policy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_vm._v(" "),_c('v-container',{staticClass:"hidden-sm-and-down",staticStyle:{"height":"calc(100vh - 70px)","overflow-y":"scroll","background":"white","font-size":"16px","padding":"16px !important","font-family":"'CS ChatThaiUI' !important"},attrs:{"id":"policy","mt-5":""}},[_c('br'),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center","text-decoration":"underline"}},[_vm._v(_vm._s(_vm.$t('Settings.policy.header'))+"\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject1.introDetail'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro1'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro2'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro3'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro4'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro5'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro6'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro7'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro8'))+"\n    ")]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject2.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject2.subHeaderScopeA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeA1'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeA2'))),_c('br'),_vm._v(" "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject2.subHeaderScopeB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeB1'))+"\n    ")]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject3.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subHeaderTypeA')))]),_vm._v("\n       "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubHeaderA'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectA1')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA1'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectA2')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA2'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA21'))),_c('br'),_vm._v(" "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subHeaderTypeB')))]),_vm._v("\n       "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubHeaderB'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB1')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB1'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB12'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB2')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB2'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB3')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB3'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB4')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB41'))+"\n      "),_c('br'),_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB42'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB5')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB51'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB52'))+"\n\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB6')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB6'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB7')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB71'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB72'))+"\n\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB8')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB8'))+"\n\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB9')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB91'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB92'))+"\n       \n      "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject4.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"font-size":"13px","padding":"1vw"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA'))+"\n\n\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA1'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA2'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA3'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA4'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA5'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA6'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA7'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA8'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA9'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA10'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA11'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA12'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA13'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA14'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA15'))+"\n\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA16'))+"\n\n       "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectB1'))+"\n\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectB2'))+"\n\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectC')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectC'))+"\n       "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectD')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD1'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD2'))+"\n      "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD3'))+"\n      "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD4'))+"\n      "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD5'))+"\n      "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD6'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectE')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectE'))+"\n       "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectF')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectF'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectG')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG1'))+"\n      "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG2'))+"\n      "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG3'))+"\n      "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG4'))+"\n      "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG5'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG6'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG7'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG8'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG9'))+"\n      "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject5.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.detailHeader'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA1'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA2'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA3'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA4'))+"\n       "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB1'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB2'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB3'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB4'))+"\n      "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject6.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject6.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectA'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject6.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectB1'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectB2'))+"\n\n      "),_c('br')]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-card-text',{staticClass:"hidden-md-and-up"},[_c('PolicyMobile')],1)],1)}
var Policy_staticRenderFns = []
var Policy_esExports = { render: Policy_render, staticRenderFns: Policy_staticRenderFns }
/* harmony default export */ var homepage_Policy = (Policy_esExports);
// CONCATENATED MODULE: ./src/components/homepage/Policy.vue
function Policy_injectStyle (ssrContext) {
  __webpack_require__("l5uE")
}
var Policy_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Policy___vue_template_functional__ = false
/* styles */
var Policy___vue_styles__ = Policy_injectStyle
/* scopeId */
var Policy___vue_scopeId__ = "data-v-6f0add2e"
/* moduleIdentifier (server only) */
var Policy___vue_module_identifier__ = null
var Policy_Component = Policy_normalizeComponent(
  Policy,
  homepage_Policy,
  Policy___vue_template_functional__,
  Policy___vue_styles__,
  Policy___vue_scopeId__,
  Policy___vue_module_identifier__
)

/* harmony default export */ var components_homepage_Policy = (Policy_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Contact.vue
var Contact = __webpack_require__("Ep6q");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09567faf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Contact.vue
var Contact_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CSChatThai"},[_c('Navbar'),_vm._v(" "),_c('div',{staticClass:"CSChatThai hidden-sm-and-down",staticStyle:{"width":"100%","height":"100vh","align-content":"center","background-color":"white"}},[_c('v-card',{staticClass:"lighten-1 white--text text-xs-center",attrs:{"flat":"","tile":"","id":"contact"}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{staticClass:"CSChatThai",staticStyle:{"margin-top":"10vh"},attrs:{"xs12":"","sm4":"","offset-sm1":""}},[_c('v-layout',{staticStyle:{"height":"100%"},attrs:{"align-center":"","column":"","justify-center":""}},[_c('v-card',{staticClass:"elevation-0 transparent",staticStyle:{"width":"100%"}},[_c('v-card-title',{staticClass:"layout justify-center",staticStyle:{"text-align":"left"},attrs:{"primary-title":""}},[_c('div',{staticClass:"headline CSChatThai"},[_vm._v("ส่งข้อความถึงเรา")])]),_vm._v(" "),_c('v-text-field',{staticClass:"InputEdit",attrs:{"label":"ชื่อ","single-line":"","solo":"","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{staticClass:"InputEdit",attrs:{"label":"อีเมล","rules":_vm.emailRules,"single-line":"","solo":"","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{staticClass:"InputEdit",attrs:{"label":"หมายเลขโทรศัพท์","mask":"###-###-####","rules":_vm.phoneRules,"required":"","single-line":"","solo":""},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('v-menu',{staticClass:"InputEdit",staticStyle:{"width":"100%","height":"45px"},attrs:{"bottom":"","offset-y":""}},[_c('v-btn',{staticStyle:{"width":"100%","padding":"0","margin":"0","font-size":"14px"},attrs:{"slot":"activator","flat":"","row":"","wrap":""},slot:"activator"},[(!_vm.title.category_TH)?_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0vw","font":"14px","color":"#757575"}},[_vm._v("หัวข้อ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0vw","font":"14px","color":"black"},attrs:{"else":""}},[_vm._v(_vm._s(_vm.title.category_TH))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"25px !important","color":"#929292"}},[_vm._v("expand_more")])],1),_vm._v(" "),_c('div',{staticStyle:{"background":"white","height":"300px"}},[_c('b',{staticClass:"CSChatThai",staticStyle:{"padding":"5px !important","font-size":"15px","color":"white","background":"#2562af"}},[_vm._v("รายงานปัญหา ::")]),_vm._v(" "),_c('v-list',_vm._l((_vm.items.list_report),function(item,index){return _c('v-list-tile',{staticStyle:{"background":"white"},on:{"click":function($event){_vm.title = item;}}},[_c('v-list-tile-title',{staticClass:"CSChatThai",staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(item.category_TH))])],1)})),_vm._v(" "),_c('div',{staticStyle:{"background":"white"}},[_c('b',{staticClass:"CSChatThai",staticStyle:{"padding":"5px !important","font-size":"15px","color":"white","background":"#2562af"}},[_vm._v("ข้อเสนอแนะ ::")]),_vm._v(" "),_c('v-list',_vm._l((_vm.items.list_feedback),function(item,index){return _c('v-list-tile',{staticStyle:{"background":"white"},on:{"click":function($event){_vm.title = item;}}},[_c('v-list-tile-title',{staticClass:"CSChatThai",staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(item.category_TH))])],1)}))],1)],1)],1)],1),_vm._v(" "),_c('v-textarea',{staticClass:"InputEdit",staticStyle:{"height":"120px","resize":"none","margin-bottom":"15px"},attrs:{"placeholder":"รายละเอียด","counter":"","maxlength":"255","full-width":""},model:{value:(_vm.detail),callback:function ($$v) {_vm.detail=$$v},expression:"detail"}}),_vm._v(" "),_c('form',{ref:"fileform"},[_c('v-flex',{staticClass:"containers hidden-sm-and-down listfile",attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_vm._l((_vm.files),function(file,key){return (key < 5)?_c('div',{staticClass:"borderfile",staticStyle:{"justify-content":"center","margin-left":"10px"}},[_c('a',{staticClass:"close-classic",on:{"click":function($event){_vm.removeFile( key )}}}),_vm._v(" "),(_vm.extension(file.file.name) == 'fas fa-file-image')?_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center","padding-top":"15px"}},[_c('img',{ref:'preview'+parseInt( key ),refInFor:true,staticClass:"preview",staticStyle:{"height":"30px !important","width":"30px !important","display":"flex","justify-content":"center","margin-left":"20px"}}),_vm._v(" "),_c('b',{staticClass:"text2"},[_vm._v(_vm._s(file.file.name))])]):_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center"}},[_c('v-icon',{staticStyle:{"font-size":"60px !important","color":"#1a222c","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(file.file.name)))]),_vm._v(" "),_c('b',{staticClass:"text2"},[_vm._v(_vm._s(file.file.name))])],1)]):_vm._e()}),_vm._v(" "),(_vm.files.length < 5)?_c('div',{style:(_vm.borderinputfile),on:{"click":function($event){_vm.uppic()}}},[_c('v-icon',{staticStyle:{"color":"#757575"}},[_vm._v("mdi-plus-circle")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#757575"}},[_vm._v("\n                    อัปโหลดรูปภาพ\n                  ")]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"files","multiple":"","accept":".png, .jpg, .jpeg, .gif, .bmp, .wbmp"},on:{"change":function($event){_vm.handleFilesUpload()}}})],1):_vm._e()],2)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[(_vm.name !== '' && _vm.email !== '' && _vm.title.category_TH && _vm.detail !== '')?_c('v-btn',{attrs:{"dark":"","color":"blue"},on:{"click":function($event){_vm.sendfeedback()}}},[_c('span',[_vm._v("ส่งถึงเรา")])]):_c('v-btn',{attrs:{"disabled":""}},[_c('span',[_vm._v("ส่งถึงเรา")])]),_vm._v(" "),_c('v-btn',{staticStyle:{"color":"white !important","background":"#2662af"},attrs:{"dark":""},on:{"click":function($event){_vm.clear()}}},[_c('span',[_vm._v("ยกเลิก")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"CSChatThai",attrs:{"xs12":"","sm4":"","offset-sm1":""}},[_c('v-card',{staticClass:"elevation-0 transparent",staticStyle:{"margin-top":"7vh"}},[_c('v-card-title',{staticClass:"layout justify-center",staticStyle:{"text-align":"left"},attrs:{"primary-title":""}},[_c('div',{staticClass:"headline CSChatThai"},[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])]),_vm._v(" "),_c('v-card-media',{attrs:{"height":"20vw","src":"/static/img/onechat/map.png"}}),_vm._v(" "),_c('v-layout',[_c('v-icon',{staticClass:"blue--text text--lighten-2"},[_vm._v("place")]),_vm._v(" "),_c('v-card-text',{staticClass:"CSChatThai",staticStyle:{"text-align":"left"}},[_vm._v("\n                  บริษัท วัน เซ็นทริค จำกัด "),_c('br'),_vm._v("1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                  ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                  เขตห้วยขวาง กรุงเทพมหานคร 10310\n                ")])],1),_vm._v(" "),_c('v-layout',[_c('v-icon',{staticClass:"blue--text text--lighten-2"},[_vm._v("email")]),_vm._v(" "),_c('v-card-text',{staticClass:"CSChatThai maildata",staticStyle:{"text-align":"left"}},[_c('a',{attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"footer hidden-sm-and-down"},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/about')}}},[_vm._v("เกี่ยวกับเรา")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toNewTab()}}},[_vm._v("API")])])]),_vm._v(" "),_c('p',{staticStyle:{"padding-left":"20px","padding-right":"20px","color":"black"}},[_c('b',[_vm._v("© "+_vm._s(new Date().getFullYear())+" One Centric Company Limited")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบาย")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"5px"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/contactus')}}},[_vm._v("ติดต่อเรา")])])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"CSChatThai hidden-md-and-up",attrs:{"id":"contactmo"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","background-color:":"","white":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-layout',{staticStyle:{"height":"100%"},attrs:{"align-center":"","column":"","justify-center":""}},[_c('v-card',{staticClass:"elevation-0 transparent",staticStyle:{"width":"100%","margin-top":"10vh","padding-left":"10px"}},[_c('v-card-title',{staticClass:"layout justify-center",staticStyle:{"text-align":"left"},attrs:{"primary-title":""}},[_c('div',{staticClass:"headline CSChatThai"},[_vm._v("ส่งข้อความถึงเรา")])]),_vm._v(" "),_c('v-text-field',{staticClass:"InputEdit",attrs:{"label":"ชื่อ","single-line":"","solo":"","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{staticClass:"InputEdit",attrs:{"label":"อีเมล","rules":_vm.emailRules,"single-line":"","solo":"","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{staticClass:"InputEdit",attrs:{"label":"หมายเลขโทรศัพท์","mask":"###-###-####","rules":_vm.phoneRules,"required":"","single-line":"","solo":""},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('div',{staticClass:"InputEdit",staticStyle:{"width":"100%"}},[_c('v-menu',{staticStyle:{"width":"100%","height":"20px","margin-bottom":"7px"},attrs:{"bottom":"","offset-y":""}},[_c('v-btn',{staticStyle:{"width":"100%","padding":"0","margin":"0"},attrs:{"slot":"activator","flat":"","row":"","wrap":""},slot:"activator"},[(!_vm.title.category_TH)?_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0vw","font":"14px","color":"#757575"}},[_vm._v("หัวข้อ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0vw","font":"14px","color":"black"},attrs:{"else":""}},[_vm._v(_vm._s(_vm.title.category_TH))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"25px !important","color":"#929292"}},[_vm._v("expand_more")])],1),_vm._v(" "),_c('div',{staticStyle:{"background":"white","height":"300px"}},[_c('div',{staticStyle:{"background-color":"#2562af","color":"white","font-size":"16px","font-weight":"800"}},[_c('span',{staticClass:"CSChatThai",staticStyle:{"padding":"5px !important"}},[_vm._v("รายงานปัญหา")])]),_vm._v(" "),_c('v-list',_vm._l((_vm.items.list_report),function(item,index){return _c('v-list-tile',{staticStyle:{"background":"white"},on:{"click":function($event){_vm.title = item;}}},[_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(item.category_TH))])],1)})),_vm._v(" "),_c('div',{staticStyle:{"background":"white"}},[_c('div',{staticStyle:{"background-color":"#2562af","color":"white","font-size":"16px","font-weight":"800"}},[_c('span',{staticClass:"CSChatThai",staticStyle:{"padding":"5px !important"}},[_vm._v("ข้อเสนอแนะ")])]),_vm._v(" "),_c('v-list',_vm._l((_vm.items.list_feedback),function(item,index){return _c('v-list-tile',{staticStyle:{"background":"white"},on:{"click":function($event){_vm.title = item;}}},[_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(item.category_TH))])],1)}))],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-textarea',{staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#e5e9eb","border-radius":"4px","height":"90px !important"},attrs:{"placeholder":"รายละเอียด","counter":"","maxlength":"255","full-width":"","single-line":"","solo":"","height":"85"},model:{value:(_vm.detail),callback:function ($$v) {_vm.detail=$$v},expression:"detail"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{ref:"fileformmo",staticStyle:{"float":"left","display":"none"}},[_c('label',[_c('b',{staticClass:"CSChatThai",staticStyle:{"text-decoration":"underline","cursor":"pointer","text-indent":"5em"}},[_vm._v("เลือกรูปภาพ")]),_vm._v(" "),_c('input',{ref:"filesmo",staticStyle:{"display":"none"},attrs:{"type":"file","id":"filesmo","multiple":"","accept":".png, .jpg, .jpeg, .gif, .bmp, .wbmp"},on:{"change":function($event){_vm.handleFilesUploadmo()}}})])]),_vm._v(" "),_c('h4',[_vm._v("เลือกรูปภาพ")]),_vm._v(" "),_c('v-layout',{staticClass:"containers hidden-md-and-up layoutimagemo",attrs:{"row":"","wrap":"","align-center":""}},[_c('div',{staticStyle:{"justify-content":"center","margin-left":"2vw","padding-top":"1vh","align-items":"center","display":"flex"}},[_c('v-btn',{staticStyle:{"height":"70px","border-radius":"10px"},attrs:{"color":"primary"},on:{"click":function($event){_vm.uppicmo()}}},[_c('v-icon',{staticStyle:{"font-size":"40px"}},[_vm._v("mdi-plus-circle")])],1)],1),_vm._v(" "),_vm._l((_vm.filesmo),function(file,key){return _c('div',{staticStyle:{"justify-content":"center","margin-left":"2vw","padding-top":"1vh","align-items":"center"}},[(_vm.extension(file.file.name) == 'fas fa-file-image')?_c('div',{staticClass:"previewimgmobile"},[_c('v-btn',{staticStyle:{"margin-left":"100px"},attrs:{"color":"primary","icon":"","flat":""},on:{"click":function($event){_vm.removeFilemo( key )}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('img',{ref:'preview'+parseInt( key ),refInFor:true,staticStyle:{"height":"80px !important","width":"80px !important","display":"flex","justify-content":"center","margin-top":"10px","align-items":"center !important","margin-left":"30px","margin-bottom":"10px"}}),_vm._v(" "),_c('b',{staticClass:"text2",staticStyle:{"margin-left":"30px"}},[_vm._v(_vm._s(file.file.name))])],1):_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center"}},[_c('v-icon',{staticStyle:{"font-size":"60px !important","color":"#1a222c","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(file.file.name)))]),_vm._v(" "),_c('b',{staticClass:"text2"},[_vm._v(_vm._s(file.file.name))])],1)])})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[(_vm.name !== '' && _vm.email !== '' && _vm.title.category_TH && _vm.detail !== '')?_c('v-btn',{attrs:{"dark":"","color":"blue"},on:{"click":function($event){_vm.sendfeedbackmo()}}},[_c('span',[_vm._v("ส่งถึงเรา")])]):_c('v-btn',{attrs:{"disabled":""}},[_c('span',[_vm._v("ส่งถึงเรา")])]),_vm._v(" "),_c('v-btn',{staticStyle:{"color":"white !important","background":"#2662af"},attrs:{"dark":""},on:{"click":function($event){_vm.clear()}}},[_c('span',[_vm._v("ยกเลิก")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"CSChatThai",attrs:{"xs12":"","sm4":"","offset-sm1":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',{staticClass:"layout justify-center",staticStyle:{"text-align":"left"},attrs:{"primary-title":""}},[_c('div',{staticClass:"headline CSChatThai"},[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])]),_vm._v(" "),_c('v-card-media',{attrs:{"height":"65vw","src":"/static/img/onechat/map.png"}}),_vm._v(" "),_c('v-layout',[_c('v-icon',{staticClass:"blue--text text--lighten-2"},[_vm._v("place")]),_vm._v(" "),_c('v-card-text',{staticClass:"CSChatThai",staticStyle:{"text-align":"left"}},[_vm._v("\n                  บริษัท วัน เซ็นทริค จำกัด 1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                  ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                  เขตห้วยขวาง กรุงเทพมหานคร 10310\n                ")])],1),_vm._v(" "),_c('v-layout',[_c('v-icon',{staticClass:"blue--text text--lighten-2"},[_vm._v("email")]),_vm._v(" "),_c('v-card-text',{staticClass:"CSChatThai",staticStyle:{"text-align":"left"}},[_c('a',{staticClass:"maildata",attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"background-color":"white !important"},attrs:{"align-center":"","column":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/about')}}},[_vm._v("เกี่ยวกับเรา")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toNewTab()}}},[_vm._v("API")]),_vm._v(" |")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบาย")]),_vm._v(" |")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/contactus')}}},[_vm._v("ติดต่อเรา")])])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('p',{staticStyle:{"padding-left":"20px","padding-right":"20px","color":"black !important"}},[_c('b',[_vm._v("© "+_vm._s(new Date().getFullYear())+" One Centric Company Limited")])])])],1)],1)],1)}
var Contact_staticRenderFns = []
var Contact_esExports = { render: Contact_render, staticRenderFns: Contact_staticRenderFns }
/* harmony default export */ var homepage_Contact = (Contact_esExports);
// CONCATENATED MODULE: ./src/components/homepage/Contact.vue
function Contact_injectStyle (ssrContext) {
  __webpack_require__("LMel")
}
var Contact_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Contact___vue_template_functional__ = false
/* styles */
var Contact___vue_styles__ = Contact_injectStyle
/* scopeId */
var Contact___vue_scopeId__ = "data-v-09567faf"
/* moduleIdentifier (server only) */
var Contact___vue_module_identifier__ = null
var Contact_Component = Contact_normalizeComponent(
  Contact["a" /* default */],
  homepage_Contact,
  Contact___vue_template_functional__,
  Contact___vue_styles__,
  Contact___vue_scopeId__,
  Contact___vue_module_identifier__
)

/* harmony default export */ var components_homepage_Contact = (Contact_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Login.vue
var Login = __webpack_require__("5ARt");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9388a864","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"CSChatThai",staticStyle:{"overflow-y":"hidden","background":"white"},attrs:{"id":"inspire"}},[_c('main',[_c('div',{staticClass:"mb-5"},[_c('Navbar')],1),_vm._v(" "),(_vm.url_redirect)?_c('v-content',{staticStyle:{"height":"calc(100vh - 64px)"}},[_c('v-layout',{staticClass:"white--text hidden-sm-and-down",staticStyle:{"background-color":"white !important","background-size":"100% 100%","height":"calc(100% - 5vh)","width":"100vw","background-repeat":"no-repeat","margin-top":"4vh","overflow-y":"hidden"},attrs:{"column":"","align-center":"","justify-center":"","id":"desktop"}},[_c('v-container',{attrs:{"grid-md":"","text-xs-center":""}},[_c('v-layout',{staticStyle:{"align-items":"center","margin-top":"10vh"},attrs:{"row":"","justify-center":"true"}},[_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}}),_vm._v(" "),(_vm.progress)?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[(_vm.progress)?_c('v-progress-circular',{staticStyle:{"margin":"auto"},attrs:{"size":250,"width":10,"indeterminate":"","color":"blue"}}):_vm._e()],1):(_vm.type=='first')?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"33vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"33vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('p',{staticStyle:{"color":"white","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('Login.titleLogin1'))+" "),_c('br'),_vm._v(_vm._s(_vm.$t('Login.titleLogin2')))]),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid text-transform",on:{"click":function($event){_vm.loginRedirect()}}},[_vm._v(_vm._s(_vm.$t('Login.typeLogin1')))]),_vm._v(" "),_c('span',{staticClass:"textor"},[_vm._v("  "+_vm._s(_vm.$t('Login.conjunction'))+"  ")]),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid_white text-transform",staticStyle:{"margin-bottom":"30px"},on:{"click":function($event){_vm.type='phone'}}},[_vm._v(_vm._s(_vm.$t('Login.typeLogin2')))])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1):(_vm.type=='phone')?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"33vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"33vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":_vm.$t('Login.phone'),"mask":"###-###-####","prepend-inner-icon":"phone"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.otp()}},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid text-transform",staticStyle:{"margin-bottom":"30px","width":"40%"},attrs:{"disabled":_vm.phone === '',"loading":_vm.loading},on:{"click":function($event){_vm.otp()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.sendotp')))])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1):(_vm.type=='otp')?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"33vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"33vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('p',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('Login.phone'))+": "+_vm._s(_vm.phone))]),_vm._v(" "),(_vm.Refcode)?_c('p',{staticStyle:{"color":"white"}},[_vm._v("Refcode: "+_vm._s(_vm.Refcode))]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":"otp","maxlength":"6"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.loginWithotp()}},model:{value:(_vm.otpCode),callback:function ($$v) {_vm.otpCode=$$v},expression:"otpCode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-btn',{staticClass:"btnloginwebOneid_white text-transform",staticStyle:{"width":"40%","margin-top":"-24px !important"},attrs:{"depressed":"","disabled":_vm.counting},on:{"click":function($event){_vm.otp()}}},[(_vm.counting)?_c('countdown',{attrs:{"time":60000},on:{"end":_vm.handleCountdownEnd},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.totalSeconds)+" "+_vm._s(_vm.$t('Login.Button.time'))+" ")]}}])}):_vm._e(),_vm._v(" "),(!_vm.counting)?_c('span',[_vm._v(_vm._s(_vm.$t('Login.Button.resend'))+" ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid",staticStyle:{"margin-bottom":"30px","width":"40%"},attrs:{"disabled":_vm.otpCode.length != 6},on:{"click":function($event){_vm.loginWithotp()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.login')))])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}})],1)],1),_vm._v(" "),_c('Download')],1),_vm._v(" "),_c('v-layout',{staticClass:"white--text hidden-md-and-up",staticStyle:{"background-color":"white !important","background-size":"100% 100%","height":"calc(100% - 5vh)","width":"100vw","background-repeat":"no-repeat","margin-top":"4vh","overflow-y":"hidden"},attrs:{"column":"","align-center":"","justify-center":"","id":"mobile"}},[_c('v-container',{staticStyle:{"overflow-y":"scroll"},attrs:{"grid-md":"","text-xs-center":""}},[_c('v-layout',{staticStyle:{"align-items":"center","margin-top":"10vh"},attrs:{"row":"","justify-center":"true"}},[_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}}),_vm._v(" "),(_vm.progress)?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[(_vm.progress)?_c('v-progress-circular',{staticStyle:{"margin":"auto"},attrs:{"size":50,"width":10,"indeterminate":"","color":"blue"}}):_vm._e()],1):(_vm.type=='first')?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"90vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"90vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('p',{staticStyle:{"color":"white","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('Login.titleLogin1'))+" "),_c('br'),_vm._v(_vm._s(_vm.$t('Login.titleLogin2')))]),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid",on:{"click":function($event){_vm.loginRedirect()}}},[_vm._v(_vm._s(_vm.$t('Login.typeLogin1')))]),_vm._v(" "),_c('span',{staticClass:"textor"},[_vm._v("  "+_vm._s(_vm.$t('Login.conjunction'))+"  ")]),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid_white",staticStyle:{"margin-bottom":"30px","width":"95%"},on:{"click":function($event){_vm.type='phone'}}},[_vm._v(_vm._s(_vm.$t('Login.typeLogin2')))])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1):(_vm.type=='phone')?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"90vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"90vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":_vm.$t('Login.phone'),"mask":"###-###-####","prepend-inner-icon":"phone"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.otp()}},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid",staticStyle:{"margin-bottom":"30px","width":"40%"},attrs:{"disabled":_vm.phone === '',"loading":_vm.loading},on:{"click":function($event){_vm.otp()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.sendotp')))])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1):(_vm.type=='otp')?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"90vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"90vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('p',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('Login.phone'))+": "+_vm._s(_vm.phone))]),_vm._v(" "),(_vm.Refcode)?_c('p',{staticStyle:{"color":"white"}},[_vm._v("Refcode: "+_vm._s(_vm.Refcode))]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":"otp","maxlength":"6"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.loginWithotp()}},model:{value:(_vm.otpCode),callback:function ($$v) {_vm.otpCode=$$v},expression:"otpCode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-btn',{staticClass:"btnloginwebOneid_white text-transform",staticStyle:{"width":"40%","margin-top":"-24px !important"},attrs:{"depressed":"","disabled":_vm.counting},on:{"click":function($event){_vm.otp()}}},[(_vm.counting)?_c('countdown',{attrs:{"time":60000},on:{"end":_vm.handleCountdownEnd},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.totalSeconds)+" "+_vm._s(_vm.$t('Login.Button.time'))+" ")]}}])}):_vm._e(),_vm._v(" "),(!_vm.counting)?_c('span',[_vm._v(_vm._s(_vm.$t('Login.Button.resend'))+" ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid text-transform",staticStyle:{"margin-bottom":"30px","width":"40%"},attrs:{"disabled":_vm.otpCode.length != 6},on:{"click":function($event){_vm.loginWithotp()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.login')))])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}})],1)],1),_vm._v(" "),_c('Download')],1)],1):_c('v-content',{staticStyle:{"height":"calc(100vh - 64px)"}},[_c('v-layout',{staticClass:"white--text hidden-sm-and-down",staticStyle:{"background-color":"white !important","background-size":"100% 100%","height":"calc(100% - 5vh)","width":"100vw","background-repeat":"no-repeat","margin-top":"4vh","overflow-y":"hidden"},attrs:{"column":"","align-center":"","justify-center":"","id":"desktop"}},[_c('v-container',{attrs:{"grid-md":"","text-xs-center":""}},[_c('v-layout',{staticStyle:{"align-items":"center","margin-top":"10vh"},attrs:{"row":"","justify-center":"true"}},[_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}}),_vm._v(" "),(_vm.progress)?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[(_vm.progress)?_c('v-progress-circular',{staticStyle:{"margin":"auto"},attrs:{"size":250,"width":10,"indeterminate":"","color":"blue"}}):_vm._e()],1):_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"33vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"33vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":_vm.$t('Login.username'),"prepend-inner-icon":"person"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()},"keypress":function($event){_vm.isNumandaz($event)}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"},attrs:{"solo":"","label":_vm.$t('Login.password'),"type":_vm.showPassword ? 'text' : 'password',"prepend-inner-icon":"lock","append-icon":_vm.showPassword ? 'mdi-eye' : 'mdi-eye-off'},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()},"keypress":function($event){_vm.isnotthai($event)},"click:append":function($event){_vm.showPassword = !_vm.showPassword}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),(_vm.status == 'fail' )?_c('div',{staticStyle:{"color":"#f9a1a1","width":"100%"}},[_c('v-icon',{staticStyle:{"color":"#f9a1a1"}},[_vm._v("info")]),_vm._v(" "+_vm._s(_vm.failmessage)+" ")],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"btnloginweb text-transform",on:{"click":function($event){_vm.login()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.login')))]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"5vh","padding-top":"1vh","text-align":"center"}},[_c('p',{staticClass:"CSChatThai text-transform",staticStyle:{"text-align":"right"}},[_c('b',[_c('span',{staticClass:"forgetpass",on:{"click":function($event){_vm.open_link('https://one.th/type_forgot_password')}}},[_vm._v(_vm._s(_vm.$t('Login.forgotpass'))+"?")])])])])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}})],1)],1),_vm._v(" "),_c('Download')],1),_vm._v(" "),_c('v-layout',{staticClass:"white--text hidden-md-and-up scrolling-wrapper",staticStyle:{"background-color":"white !important","background-size":"auto 100%","height":"calc(100vh - 64px)","width":"100vw","background-repeat":"no-repeat","margin-top":"4vh"},attrs:{"column":"","align-center":"","justify-center":"","id":"mobile"}},[(_vm.progress)?_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-progress-circular',{attrs:{"size":100,"width":7,"indeterminate":"","color":"blue"}})],1)],1):_c('v-container',{staticClass:"scrolling-wrapper",staticStyle:{"height":"calc(100vh - 64px)"},attrs:{"grid-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":""}},[_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"height":"auto","width":"auto","justify-content":"center","margin-top":"8vh","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"100%"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticClass:"CSChatThai",staticStyle:{"padding":"0px 10%"}},[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":_vm.$t('Login.username'),"rules":_vm.usernameRules,"prepend-inner-icon":"person"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"},attrs:{"solo":"","label":_vm.$t('Login.password'),"type":_vm.showPassword ? 'text' : 'password',"rules":_vm.passwordRules,"prepend-inner-icon":"lock","append-icon":_vm.showPassword ? 'mdi-eye' : 'mdi-eye-off'},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()},"click:append":function($event){_vm.showPassword = !_vm.showPassword}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),(_vm.status == 'fail' )?_c('div',{staticStyle:{"color":"#f9a1a1","width":"100%"}},[_c('v-icon',{staticStyle:{"color":"#f9a1a1"}},[_vm._v("info")]),_vm._v(" "+_vm._s(_vm.failmessage)+" ")],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-center CSChatThai",staticStyle:{"padding-bottom":"30px","padding-top":"0px","display":"flex","justify-content":"center"}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('v-btn',{staticClass:"btnloginmobile text-transform",attrs:{"disabled":_vm.username == '' || _vm.password == ''},on:{"click":function($event){_vm.login()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.login')))]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-end":""}},[_c('p',{staticClass:"CSChatThai text-transform"},[_c('b',[_c('span',{on:{"click":function($event){_vm.open_link('https://one.th/type_forgot_password')}}},[_vm._v(_vm._s(_vm.$t('Login.forgotpass'))+"?")])])])])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('Download')],1)],1),_vm._v(" "),_c('checkconsentOnechatDialog',{attrs:{"url_consent":_vm.url_consent,"consentOnechatDialog":_vm.consentOnechatDialog},on:{"closeDialogConsentOnechat":_vm.closeDialogConsentOnechat}}),_vm._v(" "),_c('newConsent',{attrs:{"newConsentDialog":_vm.newConsentDialog,"newConsentDetail":_vm.newConsentDetail},on:{"closeNewConsent":_vm.closeNewConsent}})],1)])}
var Login_staticRenderFns = []
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var homepage_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/components/homepage/Login.vue
function Login_injectStyle (ssrContext) {
  __webpack_require__("EQ18")
}
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = Login_injectStyle
/* scopeId */
var Login___vue_scopeId__ = "data-v-9388a864"
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login["a" /* default */],
  homepage_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var components_homepage_Login = (Login_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/RegisterPhone.vue
var RegisterPhone = __webpack_require__("mS+9");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5b9e3c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/RegisterPhone.vue
var RegisterPhone_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrolling-wrapper",staticStyle:{"background-color":"white"}},[_c('div',{staticClass:"mb-5"},[_c('Navbar')],1),_vm._v(" "),_c('v-container',{staticStyle:{"height":"calc(100vh - 64px)"}},[_c('v-layout',{staticStyle:{"justify-content":"center !important"}},[_c('v-flex',{staticClass:"hidden-md-and-down",staticStyle:{"padding-top":"60px"},attrs:{"md6":""}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"4vh"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('img',{staticStyle:{"height":"70px","justify-content":"right"},attrs:{"src":"/static/img/icons/logoonechat_full.png"}})]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"4vh","color":"black","display":"flex","justify-content":"center"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('h1',[_vm._v(_vm._s(_vm.$t('Register.title1')))])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"4vh"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-container',{staticClass:"setBolderRegister"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"centerDiv",attrs:{"xs12":""}},[_c('span',{staticClass:"CSChatThai",staticStyle:{"font-size":"25px"}},[_vm._v(_vm._s(_vm.$t('Register.title2')))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerDiv",attrs:{"xs12":""}},[_c('span',{staticClass:"CSChatThai",staticStyle:{"font-size":"25px"}},[_vm._v(_vm._s(_vm.$t('Register.title4')))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerDiv pl-5",staticStyle:{"color":"#2562af"},attrs:{"xs5":""}},[_c('span',{staticClass:"CSChatThai",staticStyle:{"font-size":"50px"}},[_vm._v(_vm._s(_vm.$t('Register.span1')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('v-flex',{staticClass:"CSChatThai",attrs:{"xs12":""}},[_c('v-icon',{staticClass:"pt-0 pr-3",staticStyle:{"color":"#2562af"},attrs:{"large":""}},[_vm._v("mail")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"25px"}},[_vm._v(_vm._s(_vm.$t('Register.span2')))])],1),_vm._v(" "),_c('v-flex',{staticClass:"CSChatThai",attrs:{"xs12":""}},[_c('v-icon',{staticClass:"pt-0 pr-3 ",staticStyle:{"color":"#2562af"},attrs:{"large":""}},[_vm._v("cloud")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"25px"}},[_vm._v(_vm._s(_vm.$t('Register.span3')))])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}}),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"10px"},attrs:{"xs12":"","md5":""}},[_c('div',{staticStyle:{"padding-top":"10px"}}),_vm._v(" "),_c('v-card',{staticClass:"setBolderRegister",staticStyle:{"background-color":"white"}},[_c('v-card-text',{staticStyle:{"margin-top":"0","padding-left":"40px","padding-right":"40px"}},[_c('h2',{staticClass:"centerDiv CSChatThai",staticStyle:{"color":"black"}},[_vm._v(_vm._s(_vm.$t('Register.title3')))]),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"form",staticClass:"CSChatThai labeltext",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[(_vm.type=='first')?_c('div',{staticStyle:{"margin-top":"30px","text-align":"center"}},[_c('v-text-field',{staticStyle:{"width":"100% !important","color":"#2562af !important"},attrs:{"label":_vm.$t('Login.phone'),"mask":"###-###-####","rules":_vm.phoneRules,"required":"","prepend-icon":"phone","single-line":""},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}}),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid_white text-transform",staticStyle:{"justify-self":"center","margin-bottom":"30px","width":"20%"},attrs:{"disabled":_vm.phoneNumber === ''},on:{"click":function($event){_vm.getotp()}}},[_vm._v(_vm._s(_vm.$t('Login.Button.sendotp')))])],1):(_vm.type=='otp')?_c('div',{staticStyle:{"margin-top":"30px","text-align":"center"}},[_c('p',[_vm._v(_vm._s(_vm.$t('Login.phone'))+": "+_vm._s(_vm.phoneNumber))]),_vm._v(" "),(_vm.Refcode)?_c('p',[_vm._v("Refcode: "+_vm._s(_vm.Refcode))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('v-text-field',{staticStyle:{"width":"100% !important","color":"#2562af !important"},attrs:{"label":"OTP","required":"","single-line":"","maxlength":"6"},model:{value:(_vm.otpCode),callback:function ($$v) {_vm.otpCode=$$v},expression:"otpCode"}}),_vm._v(" "),_c('v-btn',{staticClass:"btnloginwebOneid_white text-transform",staticStyle:{"width":"25%","margin-top":"5px !important"},attrs:{"depressed":"","disabled":_vm.counting},on:{"click":function($event){_vm.getotp()}}},[(_vm.counting)?_c('countdown',{attrs:{"time":60000},on:{"end":_vm.handleCountdownEnd},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.totalSeconds)+" "+_vm._s(_vm.$t('Login.Button.time'))+" ")]}}])}):_vm._e(),_vm._v(" "),(!_vm.counting)?_c('span',[_vm._v(_vm._s(_vm.$t('Login.Button.resend'))+" ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-checkbox',{attrs:{"rules":[function (v) { return !!v || 'You must agree to continue!'; }],"dark":""},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}},[_c('div',{staticClass:"text-transform",staticStyle:{"color":"#2562af !important"},attrs:{"slot":"label"},slot:"label"},[_vm._v("\n                      "+_vm._s(_vm.$t('Register.Button.accept'))+"\n                      "),_c('a',{staticStyle:{"color":"gray !important","text-decoration":"underline"},on:{"click":function($event){$event.stopPropagation();_vm.conditions = true}}},[_vm._v(_vm._s(_vm.$t('Register.Button.policy')))])])]),_vm._v(" "),_c('v-dialog',{attrs:{"width":"70%"},model:{value:(_vm.conditions),callback:function ($$v) {_vm.conditions=$$v},expression:"conditions"}},[_c('v-card',[_c('v-card-title',{staticClass:"title text-transform"},[_vm._v(_vm._s(_vm.$t('Register.Button.policy')))]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"text-transform",attrs:{"flat":"","color":"blue"},on:{"click":function($event){_vm.conditions = false}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"justify-content":"center","align-items":"center","display":"flex","margin-bottom":"5vh"}},[_c('v-btn',{staticClass:"text-transform",staticStyle:{"color":"white !important","border-radius":"20px"},attrs:{"color":"blue-grey"},on:{"click":function($event){_vm.backtoInputphone()}}},[_vm._v(_vm._s(_vm.$t('Register.Button.back')))]),_vm._v(" "),_c('v-btn',{staticClass:"text-transform",staticStyle:{"border-radius":"20px"},attrs:{"disabled":!(_vm.valid && _vm.otpCode.length==6),"color":"success","loading":_vm.isLoading},on:{"click":function($event){_vm.loginWithotp()}}},[_vm._v("\n                    "+_vm._s(_vm.$t('Register.Button.register'))+"\n                  ")])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"justify-content":"center","display":"flex"}},[_c('span',{staticStyle:{"color":"#004869","font-size":"12px"}},[_vm._v(" Powered By ")]),_vm._v("    \n            "),_c('img',{staticStyle:{"height":"30px","cursor":"pointer"},attrs:{"src":"/static/img/oneplatform/logo_one_platform.png"},on:{"click":function($event){_vm.openlink('https://one.th/')}}})])])],1)],1)],1)],1)],1),_vm._v(" "),_c('Dialogselectaccount',{attrs:{"dialogSelectaccount":_vm.dialogSelectaccount,"list_accounts":_vm.list_accounts,"phoneNumber":_vm.phoneNumber},on:{"closeSelectaccount":_vm.closeSelectaccount}})],1)],1)],1)}
var RegisterPhone_staticRenderFns = []
var RegisterPhone_esExports = { render: RegisterPhone_render, staticRenderFns: RegisterPhone_staticRenderFns }
/* harmony default export */ var homepage_RegisterPhone = (RegisterPhone_esExports);
// CONCATENATED MODULE: ./src/components/homepage/RegisterPhone.vue
function RegisterPhone_injectStyle (ssrContext) {
  __webpack_require__("f723")
}
var RegisterPhone_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RegisterPhone___vue_template_functional__ = false
/* styles */
var RegisterPhone___vue_styles__ = RegisterPhone_injectStyle
/* scopeId */
var RegisterPhone___vue_scopeId__ = "data-v-a5b9e3c8"
/* moduleIdentifier (server only) */
var RegisterPhone___vue_module_identifier__ = null
var RegisterPhone_Component = RegisterPhone_normalizeComponent(
  RegisterPhone["a" /* default */],
  homepage_RegisterPhone,
  RegisterPhone___vue_template_functional__,
  RegisterPhone___vue_styles__,
  RegisterPhone___vue_scopeId__,
  RegisterPhone___vue_module_identifier__
)

/* harmony default export */ var components_homepage_RegisterPhone = (RegisterPhone_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/RedirectService.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var RedirectService = ({
  data: function data() {
    return {
      windowWidth: '',
      progress: false,
      profile_dialog: false,
      profile_infor: {},
      tokenroom: '',
      tokenuser: '',
      status_username: ''
    };
  },
  created: function created() {
    console.log('created');
    // this.profile_dialog = true
    // var tokenuser = Encode.encode('Uba7cb86c384f5fa5b3eae7269b4993ce')
    // console.log(tokenuser)
    // var tokenuser = '=%3DM0UuZXTkFmMyIjMmlTOzcjN3gTM4YmZjVjZkRmZ4MjZ3YmZiRWVgPm8SOZSzu'
    // console.log(window.location.href)
    this.windowWidth = window.innerWidth;
    var url_string = window.location.href;
    var url = new URL(url_string);
    this.tokenuser = url.searchParams.get('user_id');
    this.tokenroom = url.searchParams.get('room_id');
    this.status_username = url.searchParams.get('stateusername');
    console.log('url: ' + url.searchParams.get('logouturl'));
    this.$cookie.set('logouturl', url.searchParams.get('logouturl'));

    // this.tokenroom = this.tokenroom.replace(/['"]+/g, '')
    // this.tokenuser = this.tokenuser.replace(/['"]+/g, '')
    // this.status_username = this.status_username.replace(/['"]+/g, '')
    // console.log(this.tokenuser)
    // console.log(this.tokenroom)
    // console.log(this.tokenuser)
    // console.log(tokenuser)
    // console.log(Decode.decode(tokenuser))

    // var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    // var old_token = decoded['tokenuser']
    // console.log(old_token)
    // if (old_token !== undefined || old_token !== '' || old_token !== null) {
    //   this.$socket.emit('leave', {room: old_token, type: 'web'})
    //   localStorage.clear()
    // }
    this.get_user(services["a" /* Decode */].decodeToken(this.tokenuser));
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        console.log('mounted');
        _this.windowWidth = window.innerWidth;
      });
    });
  },

  watch: {
    windowWidth: function windowWidth() {
      console.log('watch');
      // console.log(this.windowWidth)
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/room/' + this.tokenroom);
      } else {
        this.$router.push('/chat/room/' + this.tokenroom);
      }
    }
  },
  methods: {
    get_user: function get_user(tokenuser) {
      var _this2 = this;

      console.log('getuser');
      // console.log(tokenuser)
      this.$cookie.delete("tokenuser");
      this.$cookie.delete("status_login");
      // this.$cookie.delete("logouturl")
      localStorage.clear();
      this.progress = true;
      var encodeAuth = services["b" /* Encode */].encode({ 'tokenuser': tokenuser, 'status_login': 'T', 'type_user': 'user' });
      localStorage.setItem('Authenrization', encodeAuth);
      // console.log(`oneid: ${localStorage.getItem('oneid')}`)
      this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', { tokenuser: tokenuser.replace(/['"]+/g, ''), tokenfriend: tokenuser.replace(/['"]+/g, '') }).then(function (response) {
        // console.log(response.data.user)
        if (response.data.status === 'success') {
          _this2.progress = false;
          _this2.profile_infor = response.data.user;
          // localStorage.setItem('Authenrization', encodeAuth)
          localStorage.setItem('profilepicture', _this2.profile_infor['profilepicture']);
          localStorage.setItem('name', _this2.profile_infor['name']);
          localStorage.setItem('phone', _this2.profile_infor['phone']);
          localStorage.setItem('email', _this2.profile_infor['email']);
          localStorage.setItem('status', _this2.profile_infor['status']);
          localStorage.setItem('type_user', _this2.profile_infor['type']);
          _this2.axios.get("https://uatchat-manage.one.th/go_api/api" + ('/v1/getOneID/' + tokenuser)).then(function (response) {
            if (response.data.status === 'success') {
              // console.log(this.one_id)
              localStorage.setItem('oneid', response.data.one_id);
              localStorage.setItem('tokenuser', services["b" /* Encode */].encodeToken(tokenuser));
              // localStorage.setItem('Authenrization', Encode.encode({
              //   'tokenuser': this.profile_infor['tokenuser'],
              //   'status_login': 'T',
              //   'type_user': this.profile_infor['type'],
              //   'oneid': response.data.one_id
              // }))
            }
          });
          if (_this2.status_username === 'false') {
            localStorage.setItem('status_username', 'false');
          } else {
            localStorage.setItem('status_username', 'true');
          }
          // console.log(this.windowWidth)
          if (_this2.windowWidth <= 960) {
            _this2.$router.push('/mobile/room/' + _this2.tokenroom);
          } else {
            _this2.$router.push('/chat/room/' + _this2.tokenroom);
          }
        } else {
          _this2.progress = false;
          _this2.$swal('', 'ขออภัยระบบไม่สามารถใช้งานได้ กรุณาลองใหม่อีกครั้งภายหลัง', 'warning');
        }
      }).catch(function (error) {
        _this2.progress = false;
        _this2.$swal('', 'ขออภัยระบบไม่สามารถใช้งานได้ กรุณาลองใหม่อีกครั้งภายหลัง', 'warning');
        console.log(error);
      });
    },
    check_profile: function check_profile() {
      var _this3 = this;

      this.$swal({
        title: '',
        text: "คุณต้องการไปยังห้องแชทใช่หรือไม่?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then(function (result) {
        if (result.value) {
          localStorage.setItem('Authenrization', services["b" /* Encode */].encode({ 'tokenuser': _this3.profile_infor['tokenuser'], 'status_login': 'T', 'type_user': _this3.profile_infor['type'] }));
          localStorage.setItem('profilepicture', _this3.profile_infor['profilepicture']);
          localStorage.setItem('name', _this3.profile_infor['name']);
          localStorage.setItem('phone', _this3.profile_infor['phone']);
          localStorage.setItem('email', _this3.profile_infor['email']);
          localStorage.setItem('status', _this3.profile_infor['status']);
          localStorage.setItem('type_user', _this3.profile_infor['type']);
          if (_this3.status_username === 'false') {
            localStorage.setItem('status_username', 'false');
          } else {
            localStorage.setItem('status_username', 'true');
          }
          if (_this3.windowWidth <= 960) {
            _this3.$router.push('/mobile/room/' + _this3.tokenroom);
          } else {
            _this3.$router.push('/chat/room/' + _this3.tokenroom);
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2295132","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/RedirectService.vue
var RedirectService_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.progress)?_c('v-layout',{staticStyle:{"height":"100vh"},attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":"80","indeterminate":_vm.progress,"color":"primary"}})],1):_vm._e()],1)}
var RedirectService_staticRenderFns = []
var RedirectService_esExports = { render: RedirectService_render, staticRenderFns: RedirectService_staticRenderFns }
/* harmony default export */ var homepage_RedirectService = (RedirectService_esExports);
// CONCATENATED MODULE: ./src/components/homepage/RedirectService.vue
function RedirectService_injectStyle (ssrContext) {
  __webpack_require__("LPTp")
}
var RedirectService_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RedirectService___vue_template_functional__ = false
/* styles */
var RedirectService___vue_styles__ = RedirectService_injectStyle
/* scopeId */
var RedirectService___vue_scopeId__ = "data-v-a2295132"
/* moduleIdentifier (server only) */
var RedirectService___vue_module_identifier__ = null
var RedirectService_Component = RedirectService_normalizeComponent(
  RedirectService,
  homepage_RedirectService,
  RedirectService___vue_template_functional__,
  RedirectService___vue_styles__,
  RedirectService___vue_scopeId__,
  RedirectService___vue_module_identifier__
)

/* harmony default export */ var components_homepage_RedirectService = (RedirectService_Component.exports);

// EXTERNAL MODULE: ./src/components/chat/dialog/consent/check_consent_dialog.vue + 2 modules
var check_consent_dialog = __webpack_require__("zPBl");

// EXTERNAL MODULE: ./src/components/chat/dialog/LoginDialog.vue + 1 modules
var LoginDialog = __webpack_require__("HaTd");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Check_consent.vue
//
//
//
//
//
//
//
//




/* harmony default export */ var Check_consent = ({
  data: function data() {
    return {
      progress: false,
      token: '',
      checkconsentDialog: false,
      url_consent: '',
      share_token: '',
      dataConsent: '',
      dialogLogin: false
    };
  },

  components: {
    checkconsentdialog: check_consent_dialog["a" /* default */],
    LoginDialog: LoginDialog["a" /* default */]
  },
  created: function created() {
    this.progress = true;
    if (localStorage.getItem('Authenrization') !== undefined && localStorage.getItem('Authenrization') !== null) {
      var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      this.token = decoded['tokenuser'];
      // console.log(this.$route.query.data_consent)
      this.dataConsent = JSON.parse(services["a" /* Decode */].decode(this.$route.query.data_consent));
      this.getAccesstoken();
    } else {
      this.dialogLogin = true;
    }
  },

  methods: {
    closeLoginDialog: function closeLoginDialog() {
      this.dialogLogin = false;
      if (localStorage.getItem('Authenrization') !== undefined && localStorage.getItem('Authenrization') !== null) {
        var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
        this.token = decoded['tokenuser'];
        // console.log(this.$route.query.data_consent)
        this.dataConsent = JSON.parse(services["a" /* Decode */].decode(this.$route.query.data_consent));
        this.getAccesstoken();
      } else {
        this.dialogLogin = true;
      }
      // this.getAccesstoken()
    },
    closeDialogConsent: function closeDialogConsent() {
      var _this = this;

      this.checkconsentDialog = false;
      this.progress = true;
      this.axios.post(this.dataConsent.endpoint, {
        tax_id: this.dataConsent.tax_id,
        shared_token: this.share_token,
        service_id: this.dataConsent.service_id,
        consent_form_id: this.dataConsent.consent_form_id
      }).then(function (response) {
        if (response.data.result === 'success') {
          _this.progress = false;
          _this.url_consent = '';
          if (response.data.data.status !== 'approved') {
            _this.url_consent = response.data.data.response.elements.choice.url + _this.share_token;
            // console.log(response.data.data)
            if (window.innerWidth <= 960) {
              _this.$router.push('/mobile/homepage');
            } else {
              _this.$router.push('/chat/not_permission');
            }
          } else {
            _this.updateConsent(_this.dataConsent.bot_id);
            if (window.innerWidth <= 960) {
              _this.$router.push('/mobile/room/' + _this.$route.params.tokenroom);
            } else {
              _this.$router.push('/chat/room/' + _this.$route.params.tokenroom);
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getAccesstoken: function getAccesstoken() {
      var _this2 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", {
        tokenuser: this.token,
        url: ''
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this2.progress = false;
          _this2.share_token = response.data.data.url;
          _this2.check_consent(response.data.data.url);
        } else if (response.data.status === 'fail') {
          _this2.progress = false;
          if (response.data.message === 'Autherization fail.') {
            _this2.$swal({
              text: "ขออภัย autherization ของคุณหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
              type: "warning",
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'ตกลง'
            }).then(function (result) {
              if (result) {
                _this2.dialogLogin = true;
              }
            });
          } else if (response.data.message === 'not found account') {
            _this2.$swal({
              text: "ขออภัย ไม่พบข้อมูลผู้ใช้ในระบบ กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
              type: "warning",
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'ตกลง'
            }).then(function (result) {
              if (result) {
                _this2.dialogLogin = true;
              }
            });
          }
        } else {
          _this2.progress = false;
          if (window.innerWidth <= 960) {
            _this2.$router.push('/mobile/homepage');
          } else {
            _this2.$router.push('/chat/not_permission');
          }
        }
      }).catch(function (error) {
        _this2.progress = false;
        console.log(error);
      });
    },
    logout: function logout() {
      localStorage.clear();
      if (true) {
        window.open("https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage", '_parent');
      } else {
        this.$router.push({ path: '/login', force: true });
      }
    },
    check_consent: function check_consent(token) {
      var _this3 = this;

      // console.log(token)
      this.progress = true;
      this.axios.post(this.dataConsent.endpoint, {
        tax_id: this.dataConsent.tax_id,
        shared_token: token,
        service_id: this.dataConsent.service_id,
        consent_form_id: this.dataConsent.consent_form_id
        // consent_form_id: null
      }).then(function (response) {
        if (response.data.result === 'success') {
          _this3.progress = false;
          _this3.url_consent = '';
          if (response.data.data.status !== 'approved') {
            _this3.checkconsentDialog = true;
            _this3.url_consent = response.data.data.response.elements.choice.url + token;
            // console.log(response.data.data)
          } else {
            _this3.updateConsent(_this3.dataConsent.bot_id);
            if (window.innerWidth <= 960) {
              _this3.$router.push('/mobile/room/' + _this3.$route.params.tokenroom);
            } else {
              _this3.$router.push('/chat/room/' + _this3.$route.params.tokenroom);
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
        console.log(error.response !== undefined);
        _this3.progress = false;
        if (error.response !== undefined) {
          if (error.response.data.error === "Cannot read property 'consent_form' of null") {
            // this.getAccesstoken()
            _this3.check_consent(token);
          } else {
            console.log(error.response.data);
            _this3.$swal('', _this3.$t('Alert.Fail.default.somethingWrong'), 'error');
            if (window.innerWidth <= 960) {
              _this3.$router.push('/mobile/homepage');
            } else {
              _this3.$router.push('/chat/homepage');
            }
          }
        } else {
          if (window.innerWidth <= 960) {
            _this3.$router.push('/mobile/homepage');
          } else {
            _this3.$router.push('/chat/homepage');
          }
        }
      });
    },
    updateConsent: function updateConsent(botid) {
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/update-consent-bot', {
        bot_id: botid,
        tokenuser: this.token
      }).then(function (response) {
        // update consent
        console.log('update consent: ' + response.data.staus);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45b3a10e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Check_consent.vue
var Check_consent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"layout-height",attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"color":"primary","size":"100","indeterminate":_vm.progress}}),_vm._v(" "),_c('checkconsentdialog',{attrs:{"checkconsentDialog":_vm.checkconsentDialog,"url_consent":_vm.url_consent},on:{"closeDialogConsent":_vm.closeDialogConsent}}),_vm._v(" "),_c('LoginDialog',{attrs:{"dialogLogin":_vm.dialogLogin},on:{"closeLoginDialog":_vm.closeLoginDialog}})],1)}
var Check_consent_staticRenderFns = []
var Check_consent_esExports = { render: Check_consent_render, staticRenderFns: Check_consent_staticRenderFns }
/* harmony default export */ var homepage_Check_consent = (Check_consent_esExports);
// CONCATENATED MODULE: ./src/components/homepage/Check_consent.vue
function Check_consent_injectStyle (ssrContext) {
  __webpack_require__("Urw1")
}
var Check_consent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Check_consent___vue_template_functional__ = false
/* styles */
var Check_consent___vue_styles__ = Check_consent_injectStyle
/* scopeId */
var Check_consent___vue_scopeId__ = "data-v-45b3a10e"
/* moduleIdentifier (server only) */
var Check_consent___vue_module_identifier__ = null
var Check_consent_Component = Check_consent_normalizeComponent(
  Check_consent,
  homepage_Check_consent,
  Check_consent___vue_template_functional__,
  Check_consent___vue_styles__,
  Check_consent___vue_scopeId__,
  Check_consent___vue_module_identifier__
)

/* harmony default export */ var components_homepage_Check_consent = (Check_consent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/redirect_addfriend.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import { Decode } from '@/services'
/* harmony default export */ var redirect_addfriend = ({
  data: function data() {
    return {
      status_login: '',
      onechat: 'One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้',
      snackbar: true,
      deviceos: '',
      dialogProblem: false,
      dialogus: false,
      cardtext: [{ text: 'ส่งข้อความ, ไฟล์, เสียง, รูปภาพ และยังมีฟังก์ชันอื่น ๆ', icon: '/static/img/homepage/icon/chat2x.png' }, { text: 'บริการในตระกูล One Platform', icon: '/static/img/homepage/icon/one2x.png' }, { text: 'เชื่อมต่อกับ One E-mail ที่ให้บริการฟรีอีเมล', icon: '/static/img/homepage/icon/mail2x.png' }, { text: 'การใช้งาน Chat Bot', icon: '/static/img/homepage/icon/bot2x.png' }, { text: 'มีบริการ One Box ที่ให้บริการฟรีพื้นที่จัดเก็บไฟล์ข้อมูล', icon: '/static/img/homepage/icon/box2x.png' }, { text: 'ระบบความน่าเชื่อถือในตัวบุคคล', icon: '/static/img/homepage/icon/security2x.png' }],
      onechatDev: Object({"NODE_ENV":"uat","API":"https://uatchat.one.th","APIQRcode":"https://uatchat.one.th","APIpub":"https://uatchat-manage.one.th/event","APIimage":"https://uatchat-manage.one.th/message","APIsocket":"https://uatchat-public.one.th:8998","APImanage":"https://uatchat-manage.one.th/manage","ONEID_API":"https://testoneid.inet.co.th/api","WEBchatdev":"https://uatchat.one.th:8089/docs","Bot_idPaperless":"B0df132b88f9a526691a0576bfdb24196","Bot_idcovid":"Bbe2c9fe1bcc956738a61c9ad0d91cb19","taxid_consent":"0107544000094","serviceid_consent":"SVC-1611218040238","formid_consent":"600956682f8678001cce54e8","AuthenOneid":"https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect","LogoutOneid":"https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage","redirect_url":"https://uatchat.one.th/authorization/redirect","Market_env":"staging","APInew_listchat":"https://uatchat-manage.one.th/go_api/api/v4/getListChat","APInew_getdict":"https://uatchat-manage.one.th/alpine/api/v1/getdictmessage","APInew_pushmessage":"https://uatchat-manage.one.th/alpine/api/v1/pushMessage","APInew_getaccesstoken":"https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken","APInew_getrichmenu":"https://uatchat-manage.one.th/go_api/api/v1/getRichmenuByTokenroom","APInew_addfriend":"https://uatchat-manage.one.th/go_api/api/v1/add-friend","APIcheck_consent":"https://uatapigw.appsdigit.inet.co.th/api/chat/service/check-consent","APInew_pushvideo":"https://uatchat-manage.one.th/media/api/v1/send-video","APInew_acceptfriend":"https://uatchat-manage.one.th/go_api/api/v1/accept-friend","APInew_creategroup":"https://uatchat-manage.one.th/go_api/api/v1/create-group","APIalpine":"https://uatchat-manage.one.th/alpine","APIgo_api":"https://uatchat-manage.one.th/go_api/api","WEBoneEmail":"https://testoneid.inet.co.th/preauth","WEBoneBox":"https://testoneid.inet.co.th/oauth/authorize?client_id=155&response_type=code&scope=account","WEBNews":"https://news.chat.korkla.in/checkauthen?authen=","WEB_Redirect_Onebox":"https://uatbox.one.th/loginbysharetoken?token=","WebAnonymous":"https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token=","Savelognews":"https://news.chat.one.th/backend/api/v1/page-analytics","urlEkyc":"https://uat-ekyc.id.th/redirect-share-token?shared_token=","linkonemeet":"https://meet-test.one.th/?sharetoken=","API_onemeet":"https://meet-test.one.th/","WEB_centrifuge":"wss://uatchat-manage.one.th/connection/websocket","centrifuge_key":'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs',"APIsearchfriend":"https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend","urlLoa":"https://testoneid.inet.co.th/login?redirect_url=https://testoneid.inet.co.th/portal_level&shared_token=","check_password":"https://uatchat-manage.one.th/bot-message/check"}).ONECHATDEV + 'docs'
      // status_login: ''
    };
  },

  components: {
    ProblemDialog: components_homepage_ProblemDialog,
    messageusDialog: dialog_message_messageus,
    Navbar: Navbar["a" /* default */]
  },
  methods: {
    toNewTab: function toNewTab() {
      window.open("https://uatchat.one.th:8089/docs", '_blank').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    downloadapp: function downloadapp() {
      if (this.deviceos === 'ios') {
        window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus();
      } else {
        window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus();
      }
    },
    downloadapp_ios: function downloadapp_ios() {
      window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus();
    },
    downloadapp_and: function downloadapp_and() {
      window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus();
    },
    closeDialogProblem: function closeDialogProblem(value) {
      this.dialogProblem = value;
    },
    closeDialogus: function closeDialogus(value) {
      this.dialogus = value;
    }
  },
  created: function created() {
    // console.log('kskksk')
    var device = __webpack_require__("GtN+").default;
    this.deviceos = device.os;
    // console.log(require('current-device').default.os)
    try {
      var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      // console.log(decoded)
      this.status_login = decoded['status_login'];
    } catch (er) {
      console.log(er);
    }
    // console.log('this.status_login -- ' , this.status_login)
    if (this.status_login === 'T') {
      this.$cookie.set('path_type', 'friend');
      this.$cookie.set('path_id', this.$route.query.id);
      this.$router.push('/chat');
    } else {
      // console.log(this.$cookie.get('status_login'))
      this.$cookie.set('path_type', 'friend');
      this.$cookie.set('path_id', this.$route.query.id);
      this.$router.push('/login');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acafc98e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/redirect_addfriend.vue
var redirect_addfriend_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$vuetify.breakpoint.mdAndUp ? 'Background' : 'BackgroundMobile',staticStyle:{"background-color":"white","height":"100vh","padding-top":"64px","overflow-y":"auto","overflow-x":"hidden"},attrs:{"dark":"","id":"home"}},[_c('Navbar'),_vm._v(" "),_c('v-layout',{},[_c('div',{staticClass:"text"},[_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"height":"90vh"},attrs:{"align-center":"","row":"","wrap":"","justify-center":"","fill-height":""}},[_c('v-flex',{staticStyle:{"display":"grid"},attrs:{"xs12":"","sm12":"","md5":"","xl5":"","lg5":""}},[_c('v-img',{staticStyle:{"max-height":"90vh"},attrs:{"src":"/static/img/homepage/onechat_app.png","alt":"banner onechat"}}),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"4vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"200","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"200","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"4vh"},attrs:{"xs12":"","sm12":"","md7":"","xl7":"","lg7":""}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"2vh"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-img',{staticStyle:{"max-height":"100px","justify-content":"center","width":"256px"},attrs:{"src":"/static/img/icons/logoonechat_full.png","alt":"icon onechat"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"6vh","color":"black","font-size":"20px"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("\" แอปพลิเคชันแชทของคนไทยเพื่อคนไทย")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("เราจะทำให้ทุกการสนทนาของคุณปลอดภัย \"")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-sm-and-down",staticStyle:{"display":"flex","margin-top":"6vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-btn',{staticClass:"btnhover",attrs:{"to":"/register","round":"","dark":"","color":"#2562B0"}},[_vm._v("ร่วมเป็นส่วนหนึ่งกับพวกเรา")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"align-center":"","row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticStyle:{"margin-top":"6em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{attrs:{"src":"/static/img/icons/logoonechat_full.png","width":"120","height":"50"}}),_vm._v(" "),_c('h1',{staticStyle:{"color":"#2562B0","padding-left":"20px"}},[_vm._v("คือ อะไร?")])])],1),_vm._v(" "),(_vm.$vuetify.breakpoint.width <= 1028 && _vm.$vuetify.breakpoint.height >=1366)?_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"margin-top":"1.5em"},attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"700"}},[_c('p',{staticStyle:{"padding":"20px","margin-bottom":"0px","font-size":"20px"}},[_vm._v("\n                     One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้\n              ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10em","margin-right":"10em","margin-top":"140px"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"50vh"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","max-width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1),_vm._v(" "),_c('div',[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"20px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการฟรีอีเมล")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticClass:"linkmail",staticStyle:{"margin-left":"20px"},attrs:{"round":"","color":"#2562B0","target":"_blank","href":" https://mail.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs122":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"190"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"370","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)])],1)],1)],1)],1):_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"margin-top":"1.5em","border-radius":"10px"},attrs:{"align-center":"","justify-space-around":"","row":"","wrap":"","fill-height":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"700"}},[_c('p',{staticStyle:{"padding":"20px","margin-bottom":"0px","font-size":"20px"}},[_vm._v("\n                     One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้\n              ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10em","margin-right":"10em","margin-top":"140px"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"50vh"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":"","align-center":"","fill-height":""}},[_c('div',[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","max-width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v("\n                            ดูข้อมูลเพิ่มเติม\n                            ")])],1)],1),_vm._v(" "),_c('div',[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"20px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการฟรีอีเมล")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"margin-left":"20px"},attrs:{"round":"","color":"#2562B0","target":"_blank","dark":"","href":" https://mail.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","margin-right":"100px"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0"},attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px","margin-left":"150px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh","margin-right":"10em"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"margin-left":"30px"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"190"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","margin-right":"120px"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"370","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh","margin-left":"80px"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"hidden-md-and-up",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticStyle:{"padding-top":"3em"},attrs:{"xs12":"","sm12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"max-height":"100px","justify-content":"center","width":"256px"},attrs:{"src":"/static/img/icons/logoonechat_full.png","alt":"icon onechat"}})])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"2em","color":"black","font-size":"15px"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("\" แอปพลิเคชันแชทของคนไทยเพื่อคนไทย")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("เราจะทำให้ทุกการสนทนาของคุณปลอดภัย \"")])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"6vh","margin-bottom":"3em","color":"black","justify-content":"center"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-btn',{attrs:{"to":"/register","round":"","dark":"","color":"#2562B0"}},[_vm._v("ร่วมเป็นส่วนหนึ่งกับพวกเรา")])],1),_vm._v(" "),_c('img',{staticClass:"hidden-md-and-up",staticStyle:{"max-height":"40vh"},attrs:{"src":"/static/img/homepage/onechat_app.png","alt":"banner onechat"}}),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"4vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",staticStyle:{"max-width":"150px"},attrs:{"src":"/static/img/download/rsz_googleplay.png","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",staticStyle:{"max-width":"150px"},attrs:{"src":"/static/img/download/rsz_appstore.png","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"hidden-md-and-up",staticStyle:{"margin-top":"6em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{attrs:{"src":"/static/img/icons/logoonechat_full.png","width":"120","height":"50"}}),_vm._v(" "),_c('h1',{staticStyle:{"color":"#2562B0","padding-left":"20px"}},[_vm._v("คือ อะไร?")])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"480"}},[_c('p',{staticStyle:{"padding":"20px","font-size":"18px","margin-bottom":"0px"}},[_vm._v("\n                       One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้\n                ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic","margin-bottom":"20px"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"150","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1),_vm._v(" "),_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"30px"},attrs:{"color":"#BFDBFF","tile":"","width":"150","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("บริการฟรีอีเมล")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"margin-left":"40px"},attrs:{"round":"","color":"#2562B0","target":"_blank","dark":"","href":" https://mail.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"170"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"170"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat download"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('messageusDialog',{attrs:{"dialogus":_vm.dialogus},on:{"closeDialogus":_vm.closeDialogus}}),_vm._v(" "),_c('ProblemDialog',{attrs:{"dialogProblem":_vm.dialogProblem},on:{"closeDialogProblem":_vm.closeDialogProblem}})],1),_vm._v(" "),_c('div',{staticClass:"footer hidden-sm-and-down"},[_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{staticClass:"footertitle"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"justify-end":""}},[_c('img',{staticStyle:{"width":"260px"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{staticStyle:{"padding-left":"20px"},attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-start":""}},[_c('b',[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-start":""}},[_c('div',[_c('span',{staticStyle:{"display":"flex-inline"}},[_vm._v(" เวลาทำการ วันจันทร์ - ศุกร์ ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_vm._v("เวลา 09.00 - 17.00 น.")])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                       ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                      ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        เขตห้วยขวาง กรุงเทพมหานคร 10310\n                      ")])],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"align-start":"","row":"","wrap":"","justify-start":"","fill-height":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('a',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบายการใช้งาน")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v("ส่งข้อความถึงเรา")])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"problemIcon hidden-sm-and-down"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticStyle:{"background":"#2662af","height":"60px !important","width":"60px !important"},attrs:{"slot":"activator","fab":"","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogProblem = !_vm.dialogProblem}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"30px"}},[_vm._v("fas fa-bullhorn")])],1),_vm._v(" "),_c('span',[_vm._v("พบเจอปัญหา")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"footerMobile hidden-md-and-up"},[(_vm.$vuetify.breakpoint.width >= 768)?_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{staticClass:"footermobiletext"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"220px","height":"intrinsic"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{staticStyle:{"padding-left":"20px"},attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('b',[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{},[_vm._v(" เวลาทำการ วันจันทร์ - ศุกร์ ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("เวลา 09.00 - 17.00")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',[_vm._v("\n                          1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                          "),_c('br'),_vm._v("\n                          ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                          "),_c('br'),_vm._v("\n                          เขตห้วยขวาง กรุงเทพมหานคร 10310\n                        ")])])],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"align-start":"","row":"","wrap":"","justify-center":"","fill-height":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('a',{staticClass:"footerlink",staticStyle:{"color":"black !important"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบายการใช้งาน")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v("ส่งข้อความถึงเรา")])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1):_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"300px","height":"intrinsic"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticStyle:{"padding-left":"25px"}},[_c('v-flex',{staticStyle:{"margin-bottom":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('b',[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-bottom":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{},[_vm._v(" เวลาทำการ วันจันทร์ - ศุกร์ ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("เวลา 09.00 - 17.00")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',[_vm._v("\n                        1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                        "),_c('br'),_vm._v("\n                        ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                        "),_c('br'),_vm._v("\n                        เขตห้วยขวาง กรุงเทพมหานคร 10310\n                      ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('a',{staticClass:"footerlink",staticStyle:{"color":"black !important"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบายการใช้งาน")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v("ส่งข้อความถึงเรา")])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"problemIconMobile hidden-md-and-up"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticStyle:{"background":"#2662af","height":"40px !important","width":"40px !important"},attrs:{"slot":"activator","fab":"","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogProblem = !_vm.dialogProblem}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"20px"}},[_vm._v("fas fa-bullhorn")])],1),_vm._v(" "),_c('span',[_vm._v("พบเจอปัญหา")])],1)],1)],1)}
var redirect_addfriend_staticRenderFns = []
var redirect_addfriend_esExports = { render: redirect_addfriend_render, staticRenderFns: redirect_addfriend_staticRenderFns }
/* harmony default export */ var homepage_redirect_addfriend = (redirect_addfriend_esExports);
// CONCATENATED MODULE: ./src/components/homepage/redirect_addfriend.vue
function redirect_addfriend_injectStyle (ssrContext) {
  __webpack_require__("9r52")
}
var redirect_addfriend_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var redirect_addfriend___vue_template_functional__ = false
/* styles */
var redirect_addfriend___vue_styles__ = redirect_addfriend_injectStyle
/* scopeId */
var redirect_addfriend___vue_scopeId__ = "data-v-acafc98e"
/* moduleIdentifier (server only) */
var redirect_addfriend___vue_module_identifier__ = null
var redirect_addfriend_Component = redirect_addfriend_normalizeComponent(
  redirect_addfriend,
  homepage_redirect_addfriend,
  redirect_addfriend___vue_template_functional__,
  redirect_addfriend___vue_styles__,
  redirect_addfriend___vue_scopeId__,
  redirect_addfriend___vue_module_identifier__
)

/* harmony default export */ var components_homepage_redirect_addfriend = (redirect_addfriend_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/layout/Layout.vue
var Layout = __webpack_require__("2TYA");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c139a3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/layout/Layout.vue
var Layout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background":"#1a222c","overflow":"hidden !important"},attrs:{"id":"inspire"}},[_c('offline',{on:{"detected-condition":_vm.handleConnectivityChange}}),_vm._v(" "),_c('v-card',{staticClass:"hidden-sm-and-down",staticStyle:{"padding":"0 !important","width":"100%","z-index":"10 !important","-webkit-app-region":"drag !important"},attrs:{"flat":""}},[_c('v-container',{staticStyle:{"padding":"0 !important"},attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('div',{staticStyle:{"width":"100vw"}},[_c('v-toolbar',{staticStyle:{"color":"#5eca33","background-color":"#2562af"}},[_c('v-toolbar-title',{staticClass:"ml-0 pl-0"}),_vm._v(" "),_c('v-toolbar-items',{staticClass:" borderXwidth"},[_c('img',{staticStyle:{"height":"55px","border-radius":"10px","margin-left":"4vw","cursor":"pointer"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"},on:{"click":function($event){_vm.toPage('/homepage')}}})]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.num_listalert != 0)?_c('v-badge',{staticStyle:{"display":"inline-grid !important"},attrs:{"color":"red","overlap":""},model:{value:(_vm.show_bell),callback:function ($$v) {_vm.show_bell=$$v},expression:"show_bell"}},[(_vm.num_listalert < 100)?_c('span',{staticStyle:{"display":"inline-grid !important"},attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.num_listalert))]):_c('span',{staticStyle:{"display":"inline-grid !important"},attrs:{"slot":"badge"},slot:"badge"},[_vm._v("99+")]),_vm._v(" "),_c('v-menu',{staticStyle:{"z-index":"11"},attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","fab":"","medium":""},slot:"activator"},[_c('v-icon',{staticStyle:{"color":"white"}},[_vm._v("mdi-bell-ring-outline")])],1),_vm._v(" "),_c('v-list',{staticStyle:{"min-width":"210px"}},_vm._l((_vm.listalert_bell),function(item){return _c('v-list-tile',{key:item.announce_id,class:(item.state == 'true')? 'activelistbell': '',staticStyle:{"width":"100% !important","height":"37px"}},[(item.state == 'true')?_c('v-list-tile-title',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.dialog_bell(item)}}},[_c('v-icon',{staticStyle:{"font-size":"18px"}},[_vm._v("mdi-bell-ring-outline")]),_vm._v(" "),_c('span',{staticClass:"text-span",staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(item.message))])],1):(item.state == 'false')?_c('v-list-tile-title',[_c('v-icon',{staticStyle:{"color":"#aeb5bb !important","font-size":"18px"}},[_vm._v("mdi-bell-off-outline")]),_vm._v(" "),_c('span',{staticClass:"text-span-dis",staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(item.message))])],1):_vm._e()],1)}))],1)],1):_c('v-menu',{staticStyle:{"z-index":"11"},attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","fab":"","medium":""},slot:"activator"},[_c('v-icon',{staticStyle:{"color":"white"}},[_vm._v("mdi-bell-ring-outline")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.listalert_bell),function(item){return _c('v-list-tile',{key:item.announce_id,class:(item.state == 'true')? 'activelistbell': '',staticStyle:{"width":"100% !important","height":"37px"}},[(item.state == 'true')?_c('v-list-tile-title',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.dialog_bell(item)}}},[_c('v-icon',[_vm._v("mdi-bell-ring-outline")]),_vm._v(" "),_c('span',{staticClass:"text-span"},[_vm._v(_vm._s(item.message))])],1):(item.state == 'false')?_c('v-list-tile-title',[_c('v-icon',{staticStyle:{"color":"#aeb5bb !important"}},[_vm._v("mdi-bell-off-outline")]),_vm._v(" "),_c('span',{staticClass:"text-span-dis"},[_vm._v(_vm._s(item.message))])],1):_vm._e()],1)}))],1),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{staticClass:"fontset",attrs:{"flat":""},on:{"click":function($event){_vm.toPage('/chat/settings/profile')}}},[_c('v-avatar',{staticStyle:{"margin-right":"1vw !important"},attrs:{"size":"50px"}},[(_vm.profilepicture != '')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.profilepicture}}):(_vm.typeuser === 'company')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.typeuser === 'government')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer"},attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"textlayoutnavbar"},[_vm._v(_vm._s(_vm.name))])],1),_vm._v(" "),_c('header',{staticClass:"header",staticStyle:{"z-index":"8 !important"},attrs:{"id":"headerMenubar"}},[_c('nav',{staticClass:"header__nav"},[_c('ul',{staticClass:"header__navbar"},[_c('li',{staticClass:"header__item"},[_c('a',{staticClass:"header__link"},[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.show)?_c('button',{key:"on",staticClass:"header--btn",on:{"click":function($event){_vm.show = false}}},[_c('v-icon',{staticClass:"header--icon"},[_vm._v("clear")])],1):_c('button',{key:"off",staticClass:"header--btn",on:{"click":function($event){_vm.show = true}}},[_c('v-icon',{staticClass:"header--icon"},[_vm._v("arrow_drop_down")])],1)])],1),_vm._v(" "),_c('transition',{attrs:{"name":"dropdown"}},[(_vm.show)?_c('div',{staticClass:"header__dropdown-menu",class:{ active: _vm.show }},[_c('ul',{staticClass:"header__dropdown-menu-nav"},[_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.openQRcode()}}},[_c('a',{staticClass:"header__dropdown-menu-link"},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"meduim":""}},[_vm._v("mdi-qrcode")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('HeaderMenubar.qrcode'))+"\n                    ")])])]),_vm._v(" "),_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.openloa()}}},[_c('a',{staticClass:"header__dropdown-menu-link"},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"small":""}},[_vm._v("fas fa-user-shield")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('HeaderMenubar.loa'))+"\n                    ")])])]),_vm._v(" "),_vm._l((_vm.listmenu),function(item,index){return _c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.toPage(item.dialog)}}},[_c('a',{staticClass:"header__dropdown-menu-link"},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"meduim":""}},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(item.title)+"\n                    ")])])])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.logout()}}},[_c('a',{staticClass:"header__dropdown-menu-link"},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"meduim":""}},[_vm._v("lock_open")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('HeaderMenubar.logout'))+"\n                    ")])])])],2)]):_vm._e()])],1)])])]),_vm._v(" "),_c('div',[_c('v-menu',{staticStyle:{"z-index":"11"},attrs:{"offset-y":""}},[(_vm.$i18n.locale == 'th')?_c('img',{staticClass:"iconLanguage",attrs:{"slot":"activator","src":"/static/flag/thailand.svg"},slot:"activator"}):(_vm.$i18n.locale == 'en')?_c('img',{staticClass:"iconLanguage",attrs:{"slot":"activator","src":"/static/flag/united-kingdom.svg"},slot:"activator"}):_vm._e(),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.changeLan('th')}}},[_c('v-list-tile-title',[_c('img',{staticStyle:{"height":"20px"},attrs:{"src":"/static/flag/thailand.svg"}}),_vm._v("  ไทย\n      ")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeLan('en')}}},[_c('v-list-tile-title',[_c('img',{staticStyle:{"height":"20px"},attrs:{"src":"/static/flag/united-kingdom.svg"}}),_vm._v("  ENG\n      ")])],1)],1)],1)],1)],1)],1)],1)])],1)],1),_vm._v(" "),(_vm.$router.currentRoute.path !== '/onemeeting')?_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"md3":"","lg3":"","xl3":""}},[_c('LeftSide')],1),_vm._v(" "),_c('v-flex',{staticStyle:{"overflow":"hidden !important","background-color":"white !important","height":"calc(100vh - 64px) !important"},attrs:{"md9":"","lg9":"","xl9":""}},[_c('router-view')],1)],1):_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-col',{staticStyle:{"width":"4vw"},attrs:{"cols":"1","sm":"1","md":"1","lg":"1"}},[_c('LeftSideOnemeet')],1),_vm._v(" "),_c('v-col',{staticStyle:{"overflow":"hidden !important","background-color":"white !important","height":"calc(100vh - 64px) !important","width":"96vw"},attrs:{"cols":"11","sm":"11","md":"11","lg":"11"}},[_c('router-view')],1)],1),_vm._v(" "),_c('ShowQRCodeUser',{attrs:{"dialogShowQRCode":_vm.dialogShowQRCode},on:{"closeShowQRCodeUser":_vm.closeShowQRCodeUser}}),_vm._v(" "),_c('AgoraCallDialog',{attrs:{"AgoraCallDialog":_vm.AgoraCallDialog,"AgoraOption":_vm.AgoraOption,"infor_call":_vm.infor_call,"tokenuser":_vm.token},on:{"decline_call":_vm.decline_call,"closeAgoraDialog":_vm.closeAgoraDialog}}),_vm._v(" "),_c('checkconsentOnechatDialog',{attrs:{"url_consent":_vm.url_consent,"consentOnechatDialog":_vm.consentOnechatDialog},on:{"closeDialogConsentOnechat":_vm.closeDialogConsentOnechat}}),_vm._v(" "),_c('newConsent',{attrs:{"newConsentDialog":_vm.newConsentDialog,"newConsentDetail":_vm.newConsentDetail},on:{"closeNewConsent":_vm.closeNewConsent}})],1)}
var Layout_staticRenderFns = []
var Layout_esExports = { render: Layout_render, staticRenderFns: Layout_staticRenderFns }
/* harmony default export */ var layout_Layout = (Layout_esExports);
// CONCATENATED MODULE: ./src/components/chat/layout/Layout.vue
function Layout_injectStyle (ssrContext) {
  __webpack_require__("c4nx")
}
var Layout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Layout___vue_template_functional__ = false
/* styles */
var Layout___vue_styles__ = Layout_injectStyle
/* scopeId */
var Layout___vue_scopeId__ = "data-v-5c139a3a"
/* moduleIdentifier (server only) */
var Layout___vue_module_identifier__ = null
var Layout_Component = Layout_normalizeComponent(
  Layout["a" /* default */],
  layout_Layout,
  Layout___vue_template_functional__,
  Layout___vue_styles__,
  Layout___vue_scopeId__,
  Layout___vue_module_identifier__
)

/* harmony default export */ var chat_layout_Layout = (Layout_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/layout/CenterSide.vue
var CenterSide = __webpack_require__("9K65");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85021f40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/layout/CenterSide.vue
var CenterSide_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"centerbox CSChatThai",staticStyle:{"overflow":"hidden !important"},attrs:{"row":"","wrap":""}},[_c('offline',{on:{"detected-condition":_vm.handleConnectivityChange}}),_vm._v(" "),_c('div',{staticClass:"chatbox"},[_c('vue-context',{ref:"menu",staticStyle:{"z-index":"1500"}},_vm._l((_vm.ListMenuRightClick),function(list){return _c('li',[_c('a',{on:{"click":function($event){_vm.SelectMenuRightClick(list.methods)}}},[_vm._v(_vm._s(list.message))])])})),_vm._v(" "),_c('ShowPDFDialog',{attrs:{"dialogshowfile":_vm.dialogshowfile,"DetailFile":_vm.DetailFile},on:{"closeDialogShowFile":_vm.closeDialogShowFile}}),_vm._v(" "),_c('ShowImageDialog',{attrs:{"dialogshowimage":_vm.dialogshowimage,"DetailImage":_vm.DetailImage},on:{"closeDialogShowImage":_vm.closeDialogShowImage}}),_vm._v(" "),_c('form',{ref:"fileformChat"},[_c('div',{staticClass:"chatlogs",style:(_vm.chatlogsFlex),attrs:{"id":"myscroll"},on:{"scroll":_vm.scrollFunction}},[(_vm.listannounce.length != 0)?_c('div',[(_vm.less)?_c('v-btn',{staticStyle:{"position":"fixed","right":"26%","z-index":"2","background":"#2562afd4"},attrs:{"fab":"","dark":"","small":""},on:{"click":function($event){_vm.less = !_vm.less;_vm.show = false;}}},[_c('v-icon',{staticStyle:{"font-size":"15px"}},[_vm._v("fas fa-bullhorn")])],1):_c('v-card',{staticStyle:{"position":"fixed","width":"calc(100vw - calc(50% - -20px))","z-index":"2","margin-left":"-15px","margin-top":"-5px","background":"none"},attrs:{"id":"list_height"}},[_c('v-slide-y-transition',[_c('v-card-text',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticStyle:{"padding":"0px !important"}},[_c('v-list',{staticClass:"scrolling-wrapper-y",staticStyle:{"max-height":"200px"}},[_vm._l((_vm.listannounce),function(item,index){return [_c('v-list-tile',{key:item.index,staticClass:"list-announce",on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['cancel_announce'], item)}}},[_c('v-list-tile-action',[_c('v-icon',{staticStyle:{"font-size":"18px"}},[_vm._v("fas fa-bullhorn")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"font-size":"13px"},domProps:{"innerHTML":_vm._s(_vm.convertMention(item.message_info.message))}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(item.nickname))])],1)],1),_vm._v(" "),(index + 1 < _vm.listannounce.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1)],1),_vm._v(" "),(!_vm.show)?_c('v-card-actions',{staticStyle:{"background":"#2562afa6","height":"40px"}},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#1b232c"}},[_vm._v("fas fa-bullhorn")]),_vm._v(" "),_c('p',{staticClass:"mb-0",staticStyle:{"color":"black","padding-left":"20px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap","width":"100%","cursor":"pointer","font-size":"13px"},domProps:{"innerHTML":_vm._s(_vm.convertMentionAnnounce(_vm.listannounce[0].message_info.message))},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['cancel_announce'], _vm.listannounce[0])}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.show = !_vm.show}}},[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1)],1):_vm._e(),_vm._v(" "),(_vm.show)?_c('v-card-actions',{staticStyle:{"color":"white","background":"#2562af","height":"40px"}},[_c('p',{staticClass:"p-announce",on:{"click":function($event){_vm.delete_announce()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.announce.delete')))]),_vm._v("\n          |\n          "),_c('p',{staticClass:"p-announce",on:{"click":function($event){_vm.less = !_vm.less}}},[_vm._v(_vm._s(_vm.$t('ChatSide.announce.minimize')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.show = !_vm.show}}},[_c('v-icon',{staticStyle:{"color":"white"}},[_vm._v("keyboard_arrow_up")])],1)],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.progressLoadChat)?_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":_vm.progressLoadChat}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item,i){return (!_vm.ForwardState)?_c('div',{key:item.id},[(i == 0)?_c('div',[(_vm.tokenrooomSelect===item.tokenroom)?_c('div',{staticClass:"conversation-start",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.dateMoment(item.timestamp)))])]):_vm._e()]):(_vm.dateMoment(item.timestamp) != _vm.dateMoment(_vm.items[i-1].timestamp))?_c('div',[_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[(_vm.tokenrooomSelect===item.tokenroom)?_c('div',{staticClass:"conversation-start",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.dateMoment(item.timestamp)))])]):_vm._e()])],1):_vm._e(),_vm._v(" "),(item.tokenuser != _vm.token && _vm.tokenrooomSelect == item.tokenroom && i == 0 && item.typeofmessage != 'unsend_message' && item.typeofmessage != 'system' && item.typeofmessage != 'system_action' && item.typeofmessage != 'system_action_albums' && item.typeofmessage != 'system_action_task')?_c('p',{staticClass:"text",staticStyle:{"text-align":"left","margin-left":"calc(48px + 1vw)","margin-bottom":"0px","color":"#8e8e8e","font-size":"10px"}},[_vm._v(_vm._s(item.nickname))]):(item.typeofmessage != 'system_action' && item.typeofmessage != 'system' && item.typeofmessage != 'unsend_message' && item.typeofmessage != 'system_action_albums' && item.typeofmessage != 'system_action_task' && item.tokenuser != _vm.token && _vm.tokenrooomSelect == item.tokenroom && (_vm.dateMoment(item.timestamp) != _vm.dateMoment(_vm.items[i-1].timestamp) || _vm.items[i-1].tokenuser != item.tokenuser))?_c('p',{staticClass:"text",staticStyle:{"text-align":"left","margin-left":"calc(48px + 1vw)","margin-bottom":"0px","color":"#8e8e8e","font-size":"10px"}},[_vm._v("\n          "+_vm._s(item.nickname))]):_vm._e(),_vm._v(" "),(item.tokenuser === _vm.token && _vm.tokenrooomSelect===item.tokenroom)?_c('div',{staticClass:"chat self"},[(item.typeofmessage === 'unsend_message')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.cancelMsg'))+"\n            ")])]):(item.typeofmessage === 'system_action_albums')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_name_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.editNameAlbum'))+"\n            ")]):(item.message == 'create_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.createAlbum',{name: item.albums_name}))+"\n            ")]):(item.message == 'delete_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.deleteAlbum'))+"\n            ")]):(item.message == 'delete_images_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.deleteImageAlbum'))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system_action_task')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_task')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.editTask'))+"\n            ")]):(item.message == 'create_project')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.createProject'))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(item.message)+"\n            ")])]):(item.typeofmessage === 'system_action')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxself_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" น.")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message === 'active')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.self.joinGroup'))+"\n              ")]):(item.message === 'kick')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'invite')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'leave')?_c('span',[_vm._v("\n               "+_vm._s(_vm.$t('ChatSide.system.self.leftGroup'))+"\n              ")]):_vm._e()])]):_c('v-flex',{staticStyle:{"padding-right":"0px"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":"","align-end":""}},[_c('span',{staticClass:"pr-2",staticStyle:{"font-size":"10px","color":"#424242"}},[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),(item.typeofmessage === 'message')?_c('div',{ref:"testTT",refInFor:true,staticClass:"boxself",staticStyle:{"height":"100%"},attrs:{"id":"testTT"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention', 'cancel', 'announce'], item)}}},[_c('p',{staticStyle:{"margin":"0 !important"},attrs:{"slot":"activator"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))},on:{"click":_vm.handleClickTest},slot:"activator"}),_vm._v(" "),_vm._l((_vm.convertURL(item.message)),function(x){return (_vm.convertURL(item.message))?_c('div',[_c('link-prevue',{attrs:{"url":x},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"row":"","wrap":""},on:{"click":function($event){_vm.clicklink_website(props.url)}}},[_c('v-flex',{staticClass:"border_website",attrs:{"xl9":"","lg9":"","md9":"","sm9":""}},[_c('p',{staticClass:"title_website"},[_vm._v(_vm._s(props.title)+"  ")]),_vm._v(" "),_c('span',{staticClass:"description_website"},[_vm._v(_vm._s(props.description))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerimg_website",attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[(props.img)?_c('img',{staticClass:"img_website",attrs:{"src":props.img}}):_vm._e()])],1)]}}])},[_c('template',{slot:"loading"},[_c('span')])],2)],1):_vm._e()})],2):(item.typeofmessage === 'mention_message')?_c('p',{staticClass:"boxself",attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention'], item)}},slot:"activator"},[(item.source_message.typeofmessage !== 'unsend_message')?_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(item.source_message.owner_source_message.path_pic)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":item.source_message.owner_source_message.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"40px"},attrs:{"xs11":""}},[(item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.convertMention(item.source_message.message))},on:{"click":_vm.handleClickTest}})]):(item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.typeofmessage === 'image')?_c('span',[_vm._v("\n                          "+_vm._s(_vm.$t('ChatSide.image'))+"\n                        ")]):_c('span',[_vm._v("\n                        "+_vm._s(_vm.$t('ChatSide.sticker'))+"\n                      ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"10px","float":"right"},attrs:{"src":item.source_message.message}})])],1):(item.source_message.typeofmessage === 'file')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(_vm.extension(item.source_message.message) === 'pdf')?_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v(_vm._s(_vm.extension(item.source_message.message)))])],1)],1):(item.source_message.typeofmessage === 'video')?_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.extension(item.source_message.message) === 'media')?_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"150","height":"150","controls":""}},[_c('source',{attrs:{"src":item.source_message.message,"type":'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]}})]):_c('div',{staticStyle:{"width":"100%","height":"150px","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"150px !important"},attrs:{"playerOptions":{
                              type: 'application/x-mpegURL',
                              src: item.source_message.message,
                              preload: true,
                              autoplay: false,
                              isLoop: false,
                              playsinline: false,
                              poster: '',
                              controls: 'progress,current,durration,volume',
                              crossOrigin: false
                            }},on:{"onplay":_vm.play}})],1)])],1):(item.source_message.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.address !== '')?_c('span',[_vm._v(_vm._s(item.source_message.address))]):_c('span',[_vm._v(_vm._s(item.source_message.message))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-map-marker-alt")])],1)],1):_vm._e()],1)],1):_c('v-layout',{staticStyle:{"padding-bottom":"10px","color":"#6f6f6f"},attrs:{"row":"","wrap":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.noMsg')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))},on:{"click":_vm.handleClickTest}})],1):(item.typeofmessage === 'official_template')?_c('div',{staticClass:"boxselfquestion",staticStyle:{"overflow":"hidden","display":"-webkit-inline-box","background":"none"}},[_c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px","background":"#b4d1f5 !important"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562af","padding-left":"12px","padding-top":"10px","padding-bottom":"10px"}},[_vm._v(_vm._s(item.element.title))]),_vm._v(" "),(item.element.image)?_c('v-img',{staticStyle:{"height":"160px"},attrs:{"src":item.element.image,"contain":""}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('read-more',{staticClass:"mb-0",staticStyle:{"color":"#343433"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":100}}),_vm._v(" "),(!item.element.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((item.element.choice),function(choice,index){return _c('div',[_c('v-btn',{style:(_vm.checkbutton(choice.color,choice.background)),attrs:{"flat":"","disabled":(choice.disable == '0')? false: true},on:{"click":function($event){_vm.btn_official_template(choice, item.tokenuser, item.tokenmessage)}}},[_vm._v("\n                            "+_vm._s(choice.label)+"\n                          ")])],1)})],2)])],1)],1)]):(item.typeofmessage === 'image')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"250px"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['albums', 'mention', 'cancel', 'sendmail'], item)}},slot:"activator"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"none","border-radius":"10px","display":"flex","justify-content":"center","cursor":"pointer"}},[_c('v-card-media',{staticClass:"white--text ",attrs:{"height":"200px","src":item.message},on:{"click":function($event){_vm.zoom(item)}}})],1)],1)],1)],1):(item.typeofmessage === 'sticker')?_c('div',{staticClass:"boxselfsticker",attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention', 'cancel'], item)}},slot:"activator"},[_c('img',{staticStyle:{"width":"150px","cursor":"pointer"},attrs:{"src":item.file_name}})]):(item.typeofmessage === 'albums_message' && item.image_add.length === 0)?_c('div',{staticStyle:{"display":"none"},attrs:{"slot":"activator"},slot:"activator"}):(item.typeofmessage === 'albums_message' && item.image_add.length !== 0)?_c('div',{staticClass:"boxself_createablums",staticStyle:{"width":"240px"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailAlbums(item.file_name)}},slot:"activator"},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#3a506d !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#3a506d !important"}},[_vm._v("\n                  "+_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', {name: item.albums_name}))+"\n                ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"color":"#3a506d91 !important"}},[_vm._v("\n                  "+_vm._s(_vm.$t('ChatSide.Album.numberImage', {count: item.image_add.length}))+"\n                ")]),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"#31394121 !important"}}),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',{staticStyle:{"color":"#4c6281 !important"}},[_vm._v(_vm._s(item.albums_name))]):_c('h4',{staticStyle:{"color":"#4c6281 !important"}},[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px","color":"#4c6281 !important"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'web')?_c('div',{staticClass:"boxself",attrs:{"slot":"activator"},slot:"activator"},[_c('iframe',{staticStyle:{"visibility":"visible"},attrs:{"width":"300","height":"400","frameborder":"0","src":item.message}})]):(item.typeofmessage === 'note')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailNote(item.note_id)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',{staticStyle:{"color":"black"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length == 20)?_c('p',[_vm._v(" ...")]):_vm._e()])],1),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#4c6281 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#4c6281 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'create_task')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#3a506d"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#3a506db3"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#6981a1 !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()}),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"#e6ecf3","outline":"","text-color":"#3a506d"}},[_vm._v("\n                        "+_vm._s(item.task_info.state.name)+"\n                      ")])],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#6981a1 !important"}},[_vm._v("\n                      "+_vm._s(_vm.$t('ChatSide.Task.viewDetail'))+"\n                    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#6981a1 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'assign_task')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#3a506d"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#3a506db3"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#6981a1 !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()})],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#6981a1 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Task.editAssign')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#6981a1 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'contact')?_c('div',{staticClass:"boxself",staticStyle:{"font-weight":"500","cursor":"pointer","border-radius":"15px !important"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailFriend(item.message)}},slot:"activator"},[_c('v-avatar',{staticClass:"user-photo"},[(item.pic_contact)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.pic_contact}}):(item.type_contact === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"textchat",staticStyle:{"margin-right":"15px"}},[_vm._v(_vm._s(item.nickname_contact))]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"50%","-ms-transform":"translateY(-50%)","transform":"translateY(-50%)","right":"0"}},[_c('v-icon',[_vm._v("navigate_next")])],1)],1):(item.typeofmessage === 'file' && (_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media' || _vm.extension(item.file_name) === 'audio'))?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"300px"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)}},slot:"activator"},[_c('v-card',{staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","width":"100%"}},[(_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media')?_c('v-card-media',{staticStyle:{"border-radius":"10px","cursor":"pointer"},attrs:{"height":"200px"},on:{"click":function($event){_vm.zoomfile(item, true)},"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)}}},[(_vm.extension(item.file_name) === 'pdf')?_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":item.message,"page":1},on:{"password":function($event){_vm.passwordPdf($event, i, item)},"error":_vm.errorPdf}}):(_vm.extension(item.file_name) === 'media')?_c('video',{staticStyle:{"border-radius":"10px","height":"190px","cursor":"pointer"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_vm._e()],1):(_vm.extension(item.file_name) === 'audio')?_c('v-card-media',{staticStyle:{"width":"280px","border-radius":"10px","cursor":"pointer"},attrs:{"height":"55px"}},[_c('audio',{staticStyle:{"border-radius":"10px","width":"260px","display":"flex"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_vm._e(),_vm._v(" "),(_vm.extension(item.file_name) !== 'audio')?_c('v-card-title',{staticStyle:{"padding-top":"10px","padding-left":"0px","padding-bottom":"10px","cursor":"pointer"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"14px","color":"white"}},[_vm._v("("+_vm._s(item.file_name)+")\n                    ")])]):_vm._e()],1)],1):(item.typeofmessage === 'pdf_password' && (_vm.extension(item.file_name) === 'pdf'))?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"300px"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)}},slot:"activator"},[_c('v-card',{staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","width":"100%"}},[(_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media')?_c('v-card-media',{staticStyle:{"border-radius":"10px","cursor":"pointer"},attrs:{"height":"200px"},on:{"click":function($event){_vm.zoomfile(item, true)},"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)}}},[_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":"https://testchat.one.th/alpine/api/v1/file/J0CDcdbm1zUba7cb86c384f5fa5b3eae7269b4993ce_2022-08-17_18:29:28:894891.pdf","page":1},on:{"error":_vm.errorPdf}})],1):_vm._e(),_vm._v(" "),(_vm.extension(item.file_name) !== 'audio')?_c('v-card-title',{staticStyle:{"padding-top":"10px","padding-left":"0px","padding-bottom":"10px","cursor":"pointer"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"14px","color":"white"}},[_vm._v("("+_vm._s(item.file_name)+")\n                    ")])]):_vm._e()],1)],1):(item.typeofmessage === 'file')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"300px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"70px !important","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(item.file_name))+"\n                      ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card-title',{staticStyle:{"text-align":"left"},attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"width":"160px","word-break":"break-all !important"}},[_vm._v(_vm._s(item.file_name))])])])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticStyle:{"margin-right":"10px"},attrs:{"slot":"activator","flat":"","icon":"","color":"white"},on:{"click":function($event){_vm.zoomfile(item, false)}},slot:"activator"},[_c('v-icon',[_vm._v("file_download")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.download')))])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"white"},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}},slot:"activator"},[_c('v-icon',[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.sendOnebox')))])],1)],1)],1)],1):(item.typeofmessage === 'video')?_c('div',{staticClass:"boxselffile",staticStyle:{"max-height":"250px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.zoomfile(item, true)},"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)}},slot:"activator"},[(_vm.extension(item.message) === 'media')?_c('video',{attrs:{"slot":"activator","width":"100%","height":"250","controls":""},slot:"activator"},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_c('vplayer',{attrs:{"playerOptions":{
                    type: 'application/x-mpegURL',
                    src: item.message,
                    preload: true,
                    autoplay: false,
                    isLoop: false,
                    playsinline: false,
                    poster: item.thumbnail,
                    controls: 'progress,current,durration,volume',
                    crossOrigin: false
                  }},on:{"onplay":_vm.play}})],1):(item.typeofmessage === 'location')?_c('div',{staticClass:"boxselffile",staticStyle:{"max-width":"250px","min-width":"150px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.openlocation(item)},"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'cancel'], item)}},slot:"activator"},[_c('v-card',{staticStyle:{"background":"#b4d1f5 !important","border-radius":"20px","padding":"10px","padding-bottom":"10px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"},attrs:{"raw":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"}},[_vm._v("place")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"color":"black","padding-left":"10px"},attrs:{"xs10":"","sm10":"","md10":"","lg10":"","xl10":""}},[(item.file_name != '')?_c('span',[_vm._v(" "+_vm._s(item.file_name))]):_c('span',[_vm._v(" somewhere")])])],1)],1)],1):(item.typeofmessage === 'date')?_c('p',{staticClass:"boxself",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n              ")],1):(item.typeofmessage === 'datetime')?_c('p',{staticClass:"boxself",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n                "),_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v(" far fa-clock")]),_vm._v("   เวลา "+_vm._s(item.message.split('T')[1])+" น.\n              ")],1):(item.typeofmessage === 'call')?_c('div',{staticClass:"boxself",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='decline')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel' || item.message =='decline')?_c('span',[_vm._v("\n                  "+_vm._s(_vm.checktypeCall(item.message))+"\n                ")]):_c('span',[_vm._v(_vm._s(_vm.secondsToHms(item.time_count)))])],1):(item.typeofmessage === 'agora_call')?_c('div',{staticClass:"boxself",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='end')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel')?_c('span',[_vm._v("\n                  "+_vm._s(_vm.checktypeCall(item.message))+"\n                ")]):_c('span',[_vm._v(_vm._s(item.time))])],1):(item.typeofmessage === 'conference_msg')?_c('div',{staticClass:"boxself",staticStyle:{"text-align":"center","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.information.option == 'voice')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startCall')))],1):(item.information.option == 'video')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("videocam")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startVideo')))],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"joinBtn",on:{"click":function($event){_vm.backCall_conference_msg(item.information)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.conference.joinCall'))+" ")])],1):_c('p',{staticClass:"boxself",staticStyle:{"color":"#6d6d6d !important"},attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.notSupportVersion'))+"\n              ")])]),_vm._v(" "),(item.status=='no' && item.typeofmessage == 'message')?_c('v-tooltip',{attrs:{"top":""}},[_c('span',{staticStyle:{"text-align":"right","margin-bottom":"0px","color":"#616161","font-size":"10px","margin-left":"10vw","float":"right"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.resendMessage(item)}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"7px !important","cursor":"pointer"}},[_vm._v("autorenew")])],1),_vm._v(" "),_c('span',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('ChatSide.resend'))+" ")])]):(item.status=='no' && item.typeofmessage == 'contact')?_c('v-tooltip',{attrs:{"top":""}},[_c('span',{staticStyle:{"text-align":"right","margin-bottom":"0px","color":"#616161","font-size":"10px","margin-left":"10vw","float":"right"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.resendContact(item)}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"7px !important","cursor":"pointer"}},[_vm._v("autorenew")])],1),_vm._v(" "),_c('span',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('ChatSide.resend'))+" ")])]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(item.tokenuser !== _vm.token && _vm.tokenrooomSelect === item.tokenroom)?_c('div',{staticClass:"chat friend"},[(item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system' && item.typeofmessage !== 'system_action' && item.typeofmessage !== 'system_action_albums' && item.typeofmessage !== 'system_action_task')?_c('v-flex',{staticStyle:{"cursor":"pointer","margin-top":"1vh"},attrs:{"xl1":"","lg1":"","md1":"","sm1":""}},[((item.typeofmessage != 'albums_message' || item.image_add.length != 0))?_c('v-avatar',{staticClass:"user-photo",on:{"click":function($event){_vm.detailFriend(item.tokenuser)}}},[(item.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.path_pic}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):_vm._e()],1):_vm._e(),_vm._v(" "),(item.typeofmessage === 'unsend_message')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.cancelMsg', {name: item.nickname}))+"\n            ")])]):(item.typeofmessage === 'system_action_albums')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_name_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.editNameAlbum', {name: item.nickname}))+"\n            ")]):(item.message == 'create_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.createAlbum', {name: item.nickname, albums_name:item.albums_name}))+"\n            ")]):(item.message == 'delete_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.deleteAlbum', {name: item.nickname}))+"\n            ")]):(item.message == 'delete_images_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.deleteImageAlbum', {name: item.nickname}))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system_action_task')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_task')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.editTask', {name: item.nickname}))+"\n            ")]):(item.message == 'create_project')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.createProject', {name: item.nickname}))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxother_system"},[_vm._v("\n              "+_vm._s(item.message)+"\n            ")])]):(item.typeofmessage === 'system_action')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxother_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" น.")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message === 'active')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.other.joinGroup', {name: item.nickname}))+"\n              ")]):(item.message === 'kick')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'invite')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'leave')?_c('span',[_vm._v("\n                 "+_vm._s(_vm.$t('ChatSide.system.other.leftGroup', {name: item.nickname}))+"\n              ")]):_vm._e()])]):_c('v-flex',{staticStyle:{"padding-right":"0px","margin-left":"1vw"},attrs:{"xl8":"","lg8":"","md8":"","sm8":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-end":"","justify-start":""}},[(item.typeofmessage === 'message')?_c('div',{staticClass:"boxfriend",on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention', 'announce'], item)}}},[_c('p',{staticStyle:{"margin":"0 !important"},attrs:{"slot":"activator"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))},on:{"click":_vm.handleClickTest},slot:"activator"}),_vm._v(" "),_vm._l((_vm.convertURL(item.message)),function(x){return (_vm.convertURL(item.message))?_c('div',[_c('link-prevue',{attrs:{"url":x},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"row":"","wrap":""},on:{"click":function($event){_vm.clicklink_website(props.url)}}},[_c('v-flex',{staticClass:"border_website",attrs:{"xl9":"","lg9":"","md9":"","sm9":""}},[_c('p',{staticClass:"title_website"},[_vm._v(_vm._s(props.title))]),_vm._v(" "),_c('span',{staticClass:"description_website"},[_vm._v(_vm._s(props.description))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerimg_website",attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[(props.img)?_c('img',{staticClass:"img_website",attrs:{"src":props.img}}):_vm._e()])],1)]}}])},[_c('template',{slot:"loading"},[_c('span')])],2)],1):_vm._e()})],2):(item.typeofmessage === 'mention_message')?_c('p',{staticClass:"boxfriend",attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention'], item)}},slot:"activator"},[(item.source_message.typeofmessage !== 'unsend_message')?_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(item.source_message.owner_source_message.path_pic)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":item.source_message.owner_source_message.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"40px"},attrs:{"xs11":""}},[(item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.convertMention(item.source_message.message))},on:{"click":_vm.handleClickTest}})]):(item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.typeofmessage === 'image')?_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.image')))]):_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.sticker')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"10px","float":"right"},attrs:{"src":item.source_message.message}})])],1):(item.source_message.typeofmessage === 'file')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(_vm.extension(item.source_message.message) === 'pdf')?_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v(_vm._s(_vm.extension(item.source_message.message)))])],1)],1):(item.source_message.typeofmessage === 'video')?_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.extension(item.source_message.message) === 'media')?_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"150","height":"150","controls":""}},[_c('source',{attrs:{"src":item.source_message.message,"type":'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]}})]):_c('div',{staticStyle:{"height":"150px","width":"100%","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"150px !important"},attrs:{"playerOptions":{
                              type: 'application/x-mpegURL',
                              src: item.source_message.message,
                              preload: true,
                              autoplay: false,
                              isLoop: false,
                              playsinline: false,
                              poster: '',
                              controls: 'progress,current,durration,volume',
                              crossOrigin: false
                            }},on:{"onplay":_vm.play}})],1)])],1):(item.source_message.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.address !== '')?_c('span',[_vm._v(_vm._s(item.source_message.address))]):_c('span',[_vm._v(_vm._s(item.source_message.message))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-map-marker-alt")])],1)],1):_vm._e()],1)],1):_c('v-layout',{staticStyle:{"padding-bottom":"10px","color":"#6f6f6f"},attrs:{"row":"","wrap":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.noMsg')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):(item.typeofmessage === 'albums_message' && item.image_add.length === 0)?_c('div',{staticStyle:{"display":"none"},attrs:{"slot":"activator"},slot:"activator"}):(item.typeofmessage === 'albums_message' && item.image_add.length != 0)?_c('div',{staticClass:"boxother_createablums",staticStyle:{"width":"240px"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailAlbums(item.file_name)}},slot:"activator"},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#444444 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#444444 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', {name: item.albums_name})))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"color":"#848484 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', {count: item.image_add.length})))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',{staticStyle:{"color":"#737373 !important"}},[_vm._v(_vm._s(item.albums_name))]):_c('h4',{staticStyle:{"color":"#737373 !important"}},[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px","color":"#737373 !important"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'image')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"250px"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['albums','mention', 'sendmail'], item)}},slot:"activator"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"none","border-radius":"10px","display":"flex","justify-content":"center","cursor":"pointer"}},[_c('v-card-media',{staticClass:"white--text ",attrs:{"height":"200px","src":item.message},on:{"click":function($event){_vm.zoom(item)}}})],1)],1)],1)],1):(item.typeofmessage == 'web')?_c('div',{staticClass:"boxfriendfile",attrs:{"slot":"activator"},slot:"activator"},[_c('iframe',{staticStyle:{"visibility":"visible"},attrs:{"width":"300","height":"400","frameborder":"0","src":item.message}})]):(item.typeofmessage === 'note')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailNote(item.note_id)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',{staticStyle:{"color":"black"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length == 20)?_c('p',[_vm._v(" ...")]):_vm._e()])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#737373 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#737373 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'create_task')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#444444"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#444444c2"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#7c7c7c !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()}),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"#dcd9d9","outline":"","text-color":"#3a506d"}},[_vm._v("\n                        "+_vm._s(item.task_info.state.name)+"\n                      ")])],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#818181 !important"}},[_vm._v("\n                      "+_vm._s(_vm.$t('ChatSide.Task.viewDetail'))+"\n                    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#818181 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'assign_task')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#444444"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#444444c2"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#7c7c7c !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()})],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#818181 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Task.editAssign')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#818181 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'sticker')?_c('div',{staticClass:"boxfriendsticker",attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention'], item)}},slot:"activator"},[_c('img',{staticStyle:{"width":"150px"},attrs:{"src":item.file_name}})]):(item.typeofmessage === 'file' && (_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media' || _vm.extension(item.file_name) === 'audio'))?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"300px"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'sendmail'], item)}},slot:"activator"},[_c('v-card',{staticStyle:{"background-color":"#4a4a4a","border-radius":"10px","padding":"10px","width":"100%"}},[(_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media')?_c('v-card-media',{staticStyle:{"border-radius":"10px","cursor":"pointer"},attrs:{"height":"200px"},on:{"click":function($event){_vm.zoomfile(item, true)}}},[(_vm.extension(item.file_name) === 'pdf')?_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":item.message,"page":1},on:{"password":function($event){_vm.passwordPdf($event, i, item)},"error":_vm.errorPdf}}):(_vm.extension(item.file_name) === 'media')?_c('video',{staticStyle:{"border-radius":"10px","height":"190px"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_vm._e()],1):(_vm.extension(item.file_name) === 'audio')?_c('v-card-media',{staticStyle:{"width":"280px","border-radius":"10px"},attrs:{"height":"55px"}},[_c('audio',{staticStyle:{"border-radius":"10px","width":"260px","display":"flex"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_vm._e(),_vm._v(" "),(_vm.extension(item.file_name) !== 'audio')?_c('v-card-title',{staticStyle:{"padding-top":"10px","padding-left":"0px","padding-bottom":"10px","cursor":"pointer"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"14px","color":"white"}},[_vm._v("("+_vm._s(item.file_name)+")\n                    ")])]):_vm._e()],1)],1):(item.typeofmessage === 'pdf_password' && (_vm.extension(item.file_name) === 'pdf'))?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"300px"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'sendmail'], item)}},slot:"activator"},[_c('v-card',{staticStyle:{"background-color":"#4a4a4a","border-radius":"10px","padding":"10px","width":"100%"}},[(_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media')?_c('v-card-media',{staticStyle:{"border-radius":"10px","cursor":"pointer"},attrs:{"height":"200px"},on:{"click":function($event){_vm.zoomfile(item, true)}}},[_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":"https://testchat.one.th/alpine/api/v1/file/J0CDcdbm1zUba7cb86c384f5fa5b3eae7269b4993ce_2022-08-17_18:29:28:894891.pdf","page":1},on:{"error":_vm.errorPdf}})],1):_vm._e(),_vm._v(" "),(_vm.extension(item.file_name) !== 'audio')?_c('v-card-title',{staticStyle:{"padding-top":"10px","padding-left":"0px","padding-bottom":"10px","cursor":"pointer"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"14px","color":"white"}},[_vm._v("("+_vm._s(item.file_name)+")\n                    ")])]):_vm._e()],1)],1):(item.typeofmessage === 'file' || item.typeofmessage == 'password_file')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"300px"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'sendmail'], item)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{staticClass:"mb-4",attrs:{"xs4":"","sm4":"","md4":"","lg4":"","xl4":""}},[(_vm.extension(item.file_name) === 'pdf')?_c('v-icon',{staticStyle:{"color":"white","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"white","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v(_vm._s(_vm.extension(item.file_name)))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card-title',{staticStyle:{"text-align":"left"},attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"width":"160px","word-break":"break-all !important"}},[_vm._v("\n                            "+_vm._s(item.file_name)+"\n                            ")])])])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[(item.typeofmessage == 'password_file')?_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-lock")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticStyle:{"margin-right":"10px"},attrs:{"slot":"activator","flat":"","icon":"","color":"white"},on:{"click":function($event){_vm.zoomfile(item, false)}},slot:"activator"},[(_vm.extension(item.file_name) == 'pdf')?_c('v-icon',[_vm._v("visibility")]):_c('v-icon',[_vm._v("file_download")])],1),_vm._v(" "),(_vm.extension(item.file_name) == 'pdf')?_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.openfile')))]):_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.download')))])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"white"},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}},slot:"activator"},[_c('v-icon',[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.sendOnebox')))])],1)],1)],1)],1):(item.typeofmessage === 'video')?_c('div',{staticClass:"boxfriendfile",staticStyle:{"max-height":"250px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.zoomfile(item, true)},"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'sendmail'], item)}},slot:"activator"},[(_vm.extension(item.message) === 'media')?_c('video',{attrs:{"slot":"activator","width":"100%","height":"250","controls":""},slot:"activator"},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_c('vplayer',{attrs:{"playerOptions":{
                    type: 'application/x-mpegURL',
                    src: item.message,
                    preload: true,
                    autoplay: false,
                    isLoop: false,
                    playsinline: false,
                    poster: item.thumbnail,
                    controls: 'progress,current,durration,volume',
                    crossOrigin: false
                  }},on:{"onplay":_vm.play}})],1):(item.typeofmessage === 'location')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"max-width":"250px","min-width":"150px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.openlocation(item)},"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention'], item)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#efefef","border-radius":"20px","padding":"10px","padding-bottom":"10px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"}},[_vm._v("place")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"color":"black","padding-left":"10px"},attrs:{"xs10":"","sm10":"","md10":"","lg10":"","xl10":""}},[(item.file_name != '')?_c('span',[_vm._v(" "+_vm._s(item.file_name))]):_c('span',[_vm._v(" somewhere")])])],1)],1)],1):(item.typeofmessage === 'date')?_c('p',{staticClass:"boxfriend",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n              ")],1):(item.typeofmessage === 'datetime')?_c('p',{staticClass:"boxfriend",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n                "),_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v(" far fa-clock")]),_vm._v("   เวลา "+_vm._s(item.message.split('T')[1])+" น.\n              ")],1):(item.typeofmessage === 'contact')?_c('div',{staticClass:"boxfriend",staticStyle:{"font-weight":"500","cursor":"pointer","border-radius":"15px !important"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailFriend(item.message)}},slot:"activator"},[_c('v-avatar',{staticClass:"user-photo"},[(item.pic_contact)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.pic_contact}}):(item.type_contact === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"textchat",staticStyle:{"margin-right":"15px"}},[_vm._v(_vm._s(item.nickname_contact))]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"50%","-ms-transform":"translateY(-50%)","transform":"translateY(-50%)","right":"0"}},[_c('v-icon',[_vm._v("navigate_next ")])],1)],1):(item.typeofmessage === 'template')?_c('div',{staticClass:"boxfriendquestion scrolling-wrapper-template",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","display":"flex","background":"none","align-items":"end"},attrs:{"slot":"activator"},slot:"activator"},_vm._l((item.info_ans),function(info_ans,index){return _c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px"}},[(info_ans.image)?_c('v-img',{staticStyle:{"height":"120px"},attrs:{"src":info_ans.image,"aspect-ratio":"2.75"}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562ae"}},[_vm._v(_vm._s(info_ans.title))]),_vm._v(" "),_c('p',{staticClass:"mb-0",staticStyle:{"display":"-webkit-box","-webkit-line-clamp":"2","-webkit-box-orient":"vertical","overflow":"hidden","text-overflow":"ellipsis"},domProps:{"innerHTML":_vm._s(_vm.convert(info_ans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(info_ans.detail.length >= 40)?_c('a',{on:{"click":function($event){_vm.clickReadmore(info_ans)}}},[_c('b',[_vm._v(_vm._s(_vm.$t('ChatSide.Read.readmore')))])]):_vm._e(),_vm._v(" "),(!info_ans.image)?_c('v-divider',{staticClass:"mt-2",attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((info_ans.choice),function(choice,index){return _c('div',[(choice.type=='file')?_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px"},attrs:{"block":"","flat":"","color":"primary"},on:{"click":function($event){_vm.btn_answer_question(choice, item)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-download")]),_vm._v("    "),_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.btn_answer_question(choice, item)}}},[_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})])],1)})],2)])],1)],1)})):(item.typeofmessage === 'official_template')?_c('div',{staticClass:"boxfriendquestion",staticStyle:{"overflow":"hidden","display":"-webkit-inline-box","background":"none"},attrs:{"slot":"activator"},slot:"activator"},[_c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px","background":"#efefef !important"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562af","padding-left":"12px","padding-top":"10px","padding-bottom":"10px"}},[_vm._v(_vm._s(item.element.title))]),_vm._v(" "),(item.element.image)?_c('v-img',{staticStyle:{"height":"160px","cursor":"pointer"},attrs:{"src":item.element.image,"contain":""},on:{"click":function($event){_vm.btn_img_official_template(item.element.onclick_img, item.tokenuser)}}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('read-more',{staticClass:"mb-0",staticStyle:{"color":"#343433"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":100}}),_vm._v(" "),(!item.element.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((item.element.choice),function(choice,index){return _c('div',[_c('v-btn',{style:(_vm.checkbutton(choice.color,choice.background)),attrs:{"flat":"","disabled":(choice.disable == '0')? false: true},on:{"click":function($event){_vm.btn_official_template(choice, item.tokenuser, item.tokenmessage)}}},[_vm._v("\n                          "+_vm._s(choice.label)+"\n                        ")])],1)})],2)])],1)],1)]):(item.typeofmessage === 'approve_message' && item.disable === 'false')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.openapprove(item)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"white","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticStyle:{"color":"#2562ae !important"}},[_vm._v(_vm._s(item.info_ans[0].title))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#9d9d9d !important"}},[_vm._v(_vm._s(item.info_ans[0].short_detail))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('span',{staticStyle:{"color":"#2562ae !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.viewDetail'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#2562ae !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'approve_message'  && item.disable === 'true')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px"},attrs:{"slot":"activator"},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"white","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticStyle:{"color":"#757575 !important"}},[_vm._v(_vm._s(item.info_ans[0].title))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#9d9d9d !important"}},[_vm._v(_vm._s(item.info_ans[0].short_detail))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('span',{staticStyle:{"color":"#757575 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.receiveAns'))+" ")])])],1)],1):(item.typeofmessage === 'call')?_c('div',{staticClass:"boxfriend",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='decline')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel' || item.message =='decline')?_c('span',[_vm._v("\n                  "+_vm._s(_vm.checktypeCall(item.message))+"\n                ")]):_c('span',[_vm._v(_vm._s(_vm.secondsToHms(item.time_count)))])],1):(item.typeofmessage === 'agora_call')?_c('div',{staticClass:"boxfriend",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='end')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel')?_c('span',[_vm._v("\n                  "+_vm._s(_vm.checktypeCall(item.message))+"\n                ")]):_c('span',[_vm._v(_vm._s(item.time))])],1):(item.typeofmessage === 'conference_msg')?_c('div',{staticClass:"boxfriend",staticStyle:{"text-align":"center","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.information.option == 'voice')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startCall')))],1):(item.information.option == 'video')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("videocam")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startVideo')))],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"joinBtn",on:{"click":function($event){_vm.joinCall_conference_msg(item.information)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.conference.joinCall'))+" ")])],1):(item.typeofmessage === 'carousel')?_c('div',{staticClass:"boxfriendcarousel scrolling-wrapper-template",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","display":"-webkit-inline-box","background":"none"}},_vm._l((item.elements),function(info_carousel,index){return _c('div',[_c('v-card',{staticStyle:{"border-radius":"20px","width":"250px","margin-right":"10px"}},[(info_carousel.image)?_c('v-img',{staticStyle:{"height":"250px","cursor":"pointer"},attrs:{"src":info_carousel.image,"aspect-ratio":16/9},on:{"click":function($event){_vm.btn_answer_carousel(info_carousel)}}},[(info_carousel.type !== 'image')?_c('v-layout',{staticStyle:{"height":"250px"},attrs:{"row":"","wrap":"","align-end":"","justify-center":""}},[(info_carousel.button)?_c('v-btn',{attrs:{"round":"","color":"#0000009c","dark":""}},[_c('span',{staticClass:"text-transform"},[_vm._v(_vm._s(info_carousel.button))])]):_vm._e()],1):_vm._e()],1):_vm._e()],1)],1)})):_c('p',{staticClass:"boxfriend",staticStyle:{"color":"#757575 !important"},attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.notSupportVersion'))+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"pl-2",staticStyle:{"font-size":"10px","color":"#424242"}},[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xl1":"","lg1":"","md1":"","sm1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xl2":"","lg2":"","md2":"","sm2":""}})],1):_vm._e()]):_vm._e()}),_vm._v(" "),_vm._l((_vm.items),function(item,i){return (_vm.ForwardState)?_c('div',{key:item.id},[(i == 0)?_c('div',[(_vm.tokenrooomSelect == item.tokenroom)?_c('div',{staticClass:"conversation-start",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.dateMoment(item.timestamp)))])]):_vm._e()]):(_vm.dateMoment(item.timestamp) !== _vm.dateMoment(_vm.items[i-1].timestamp))?_c('div',[_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[(_vm.tokenrooomSelect == item.tokenroom)?_c('div',{staticClass:"conversation-start",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.dateMoment(item.timestamp)))])]):_vm._e()])],1):_vm._e(),_vm._v(" "),(item.tokenuser != _vm.token && _vm.tokenrooomSelect == item.tokenroom && i == 0 && item.typeofmessage != 'unsend_message' && item.typeofmessage != 'system' && item.typeofmessage != 'system_action' && item.typeofmessage !='system_action_albums' && item.typeofmessage !='system_action_task')?_c('p',{staticClass:"text",staticStyle:{"text-align":"left","margin-left":"calc(48px + 1vw)","margin-bottom":"0px","color":"#8e8e8e","font-size":"10px"}},[_vm._v(_vm._s(item.nickname))]):(item.typeofmessage != 'system_action_albums' && item.typeofmessage != 'system_action_task' && item.typeofmessage != 'system_action' && item.typeofmessage != 'system' && item.typeofmessage != 'unsend_message' && item.tokenuser != _vm.token && _vm.tokenrooomSelect == item.tokenroom && (_vm.dateMoment(item.timestamp) != _vm.dateMoment(_vm.items[i-1].timestamp) || _vm.items[i-1].tokenuser != item.tokenuser))?_c('p',{staticClass:"text",staticStyle:{"text-align":"left","margin-left":"calc(48px + 1vw)","margin-bottom":"0px","color":"#8e8e8e","font-size":"10px"}},[_vm._v("\n          "+_vm._s(item.nickname))]):_vm._e(),_vm._v(" "),(item.tokenuser == _vm.token && _vm.tokenrooomSelect == item.tokenroom)?_c('div',{staticClass:"chat self"},[(item.typeofmessage === 'unsend_message')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.cancelMsg'))+"\n            ")])]):(item.typeofmessage === 'system_action_albums')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_name_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.editNameAlbum'))+"\n            ")]):(item.message == 'create_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.createAlbum',{name: item.albums_name}))+"\n            ")]):(item.message == 'delete_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.deleteAlbum'))+"\n            ")]):(item.message == 'delete_images_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.deleteImageAlbum'))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system_action_task')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_task')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.editTask'))+"\n            ")]):(item.message == 'create_project')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.createProject'))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(item.message)+"\n            ")])]):(item.typeofmessage === 'system_action')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxself_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" น.")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message === 'active')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.self.joinGroup'))+"\n              ")]):(item.message === 'kick')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'invite')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'leave')?_c('span',[_vm._v("\n                 "+_vm._s(_vm.$t('ChatSide.system.self.leftGroup'))+"\n              ")]):_vm._e()])]):_c('v-flex',{staticStyle:{"padding-right":"0px"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[((item.typeofmessage === 'message' || item.typeofmessage == 'image' || item.typeofmessage === 'file' || item.typeofmessage === 'pdf_password' || item.typeofmessage === 'video' || item.typeofmessage === 'location') && item.status != 'no')?_c('v-checkbox',{staticStyle:{"float":"right"},attrs:{"value":item.tokenmessage},model:{value:(_vm.selectedForward),callback:function ($$v) {_vm.selectedForward=$$v},expression:"selectedForward"}}):_vm._e(),_vm._v(" "),(item.typeofmessage === 'message')?_c('div',{staticClass:"boxself",staticStyle:{"height":"100%"}},[_c('p',{staticStyle:{"margin":"0 !important"},attrs:{"slot":"activator"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))},slot:"activator"}),_vm._v(" "),_vm._l((_vm.convertURL(item.message)),function(x){return (_vm.convertURL(item.message))?_c('div',[_c('link-prevue',{attrs:{"url":x},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"row":"","wrap":""},on:{"click":function($event){_vm.clicklink_website(props.url)}}},[_c('v-flex',{staticClass:"border_website",attrs:{"xl9":"","lg9":"","md9":"","sm9":""}},[_c('p',{staticClass:"title_website"},[_vm._v(_vm._s(props.title))]),_vm._v(" "),_c('span',{staticClass:"description_website"},[_vm._v(_vm._s(props.description))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerimg_website",attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[(props.img)?_c('img',{staticClass:"img_website",attrs:{"src":props.img}}):_vm._e()])],1)]}}])},[_c('template',{slot:"loading"},[_c('span')])],2)],1):_vm._e()})],2):(item.typeofmessage === 'official_template')?_c('div',{staticClass:"boxselfquestion",staticStyle:{"overflow":"hidden","display":"-webkit-inline-box","background":"none"}},[_c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px","background":"#b4d1f5 !important"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562af","padding-left":"12px","padding-top":"10px","padding-bottom":"10px"}},[_vm._v(_vm._s(item.element.title))]),_vm._v(" "),(item.element.image)?_c('v-img',{staticStyle:{"height":"160px"},attrs:{"src":item.element.image,"contain":""}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('read-more',{staticClass:"mb-0",staticStyle:{"color":"#343433"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":100}}),_vm._v(" "),(!item.element.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((item.element.choice),function(choice,index){return _c('div',[_c('v-btn',{style:(_vm.checkbutton(choice.color,choice.background)),attrs:{"flat":"","disabled":""}},[_vm._v("\n                          "+_vm._s(choice.label)+"\n                        ")])],1)})],2)])],1)],1)]):(item.typeofmessage === 'mention_message')?_c('p',{staticClass:"boxself",attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention'], item)}},slot:"activator"},[(item.source_message.typeofmessage !== 'unsend_message')?_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(item.source_message.owner_source_message.path_pic)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":item.source_message.owner_source_message.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"40px"},attrs:{"xs11":""}},[(item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.source_message.message))])]):(item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.typeofmessage === 'image')?_c('span',[_vm._v("รูปภาพ")]):_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.sticker')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"10px","float":"right"},attrs:{"src":item.source_message.message}})])],1):(item.source_message.typeofmessage === 'file')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(_vm.extension(item.source_message.message) === 'pdf')?_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v(_vm._s(_vm.extension(item.source_message.message)))])],1)],1):(item.source_message.typeofmessage === 'video')?_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.extension(item.source_message.message) === 'media')?_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"150","height":"150","controls":""}},[_c('source',{attrs:{"src":item.source_message.message,"type":'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]}})]):_c('div',{staticStyle:{"width":"100%","height":"150px","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"150px !important"},attrs:{"playerOptions":{
                            type: 'application/x-mpegURL',
                            src: item.source_message.message,
                            preload: true,
                            autoplay: false,
                            isLoop: false,
                            playsinline: false,
                            poster: '',
                            controls: 'progress,current,durration,volume',
                            crossOrigin: false
                          }},on:{"onplay":_vm.play}})],1)])],1):(item.source_message.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.address !== '')?_c('span',[_vm._v(_vm._s(item.source_message.address))]):_c('span',[_vm._v(_vm._s(item.source_message.message))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-map-marker-alt")])],1)],1):_vm._e()],1)],1):_c('v-layout',{staticStyle:{"padding-bottom":"10px","color":"#6f6f6f"},attrs:{"row":"","wrap":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.noMsg')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):(item.typeofmessage == 'albums_message' && item.image_add.length == 0)?_c('div',{staticStyle:{"display":"none"}}):(item.typeofmessage == 'albums_message' && item.image_add.length != 0)?_c('div',{staticClass:"boxself_createablums",staticStyle:{"width":"240px"}},[(item.message != 'addimage_albums')?_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#3a506d !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#3a506d !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', {name: item.albums_name})))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"color":"#3a506d91 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', {count: item.image_add.length})))]),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"#31394121 !important"}}),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',{staticStyle:{"color":"#4c6281 !important"}},[_vm._v(_vm._s(item.albums_name))]):_c('h4',{staticStyle:{"color":"#4c6281 !important"}},[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px","color":"#4c6281 !important"},attrs:{"color":"black"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'image')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"250px"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"none","border-radius":"10px","display":"flex","justify-content":"center"}},[_c('v-card-media',{staticClass:"white--text ",attrs:{"height":"200px","src":item.message}})],1)],1)],1)],1):(item.typeofmessage === 'sticker')?_c('div',{staticClass:"boxselfsticker"},[_c('img',{staticStyle:{"width":"150px"},attrs:{"src":item.file_name}})]):(item.typeofmessage === 'web')?_c('div',{staticClass:"boxself"},[_c('iframe',{staticStyle:{"visibility":"visible"},attrs:{"width":"300","height":"400","frameborder":"0","src":item.message}})]):(item.typeofmessage === 'note')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"200px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5 !important","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',{staticStyle:{"color":"black"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length == 20)?_c('p',[_vm._v(" ...")]):_vm._e()])],1),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#4c6281 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#4c6281 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'create_task')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#3a506d"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#3a506db3"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#6981a1 !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()}),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"#e6ecf3","outline":"","text-color":"#3a506d"}},[_vm._v("\n                      "+_vm._s(item.task_info.state.name)+"\n                    ")])],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#6981a1 !important"}},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.Task.viewDetail'))+"\n                  ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#6981a1 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'assign_task')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#3a506d"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#3a506db3"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#6981a1 !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()})],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#6981a1 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Task.editAssign')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#6981a1 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'contact')?_c('div',{staticClass:"boxself",staticStyle:{"font-weight":"500","border-radius":"15px !important"}},[_c('v-avatar',{staticClass:"user-photo"},[(item.pic_contact)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.pic_contact}}):(item.type_contact === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"textchat",staticStyle:{"margin-right":"15px"}},[_vm._v(_vm._s(item.nickname_contact))]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"50%","-ms-transform":"translateY(-50%)","transform":"translateY(-50%)","right":"0"}},[_c('v-icon',[_vm._v("navigate_next ")])],1)],1):(item.typeofmessage === 'file' && (_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media' || _vm.extension(item.file_name) === 'audio'))?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"300px"}},[_c('v-card',{staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","width":"100%"}},[(_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media')?_c('v-card-media',{staticStyle:{"border-radius":"10px"},attrs:{"height":"200px"}},[(_vm.extension(item.file_name) === 'pdf')?_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":item.message,"page":1},on:{"pass":function($event){_vm.passwordPdf($event, i, item)},"error":_vm.errorPdf}}):(_vm.extension(item.file_name) === 'media')?_c('video',{staticStyle:{"border-radius":"10px","height":"190px"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_vm._e()],1):(_vm.extension(item.file_name) === 'audio')?_c('v-card-media',{staticStyle:{"width":"280px","border-radius":"10px"},attrs:{"height":"55px"}},[_c('audio',{staticStyle:{"border-radius":"10px","width":"260px","display":"flex"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_vm._e(),_vm._v(" "),(_vm.extension(item.file_name) !== 'audio')?_c('v-card-title',{staticStyle:{"padding-top":"10px","padding-left":"0px","padding-bottom":"10px"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"14px","color":"white"}},[_vm._v("("+_vm._s(item.file_name)+")\n                  ")])]):_vm._e()],1)],1):(item.typeofmessage === 'pdf_password' && (_vm.extension(item.file_name) === 'pdf'))?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"300px"},attrs:{"slot":"activator"},slot:"activator"},[_c('v-card',{staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","width":"100%"}},[(_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media')?_c('v-card-media',{staticStyle:{"border-radius":"10px"},attrs:{"height":"200px"}},[_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":"https://testchat.one.th/alpine/api/v1/file/J0CDcdbm1zUba7cb86c384f5fa5b3eae7269b4993ce_2022-08-17_18:29:28:894891.pdf","page":1},on:{"error":_vm.errorPdf}})],1):_vm._e(),_vm._v(" "),(_vm.extension(item.file_name) !== 'audio')?_c('v-card-title',{staticStyle:{"padding-top":"10px","padding-left":"0px","padding-bottom":"10px"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"14px","color":"white"}},[_vm._v("("+_vm._s(item.file_name)+")\n                  ")])]):_vm._e()],1)],1):(item.typeofmessage === 'file')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"300px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"70px !important","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(item.file_name))+"\n                    ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card-title',{staticStyle:{"text-align":"left"},attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"width":"160px","word-break":"break-all !important"}},[_vm._v(_vm._s(item.file_name))])])])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-right":"10px"},attrs:{"flat":"","icon":"","color":"white","disabled":""}},[_c('v-icon',[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":""}},[_c('v-icon',[_vm._v("cloud_upload")])],1)],1)],1)],1):(item.typeofmessage === 'video')?_c('div',{staticClass:"boxselffile",staticStyle:{"max-height":"250px"}},[(_vm.extension(item.message) === 'media')?_c('video',{attrs:{"width":"100%","height":"250","controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_c('vplayer',{attrs:{"playerOptions":{
                  type: 'application/x-mpegURL',
                  src: item.message,
                  preload: true,
                  autoplay: false,
                  isLoop: false,
                  playsinline: false,
                  poster: item.thumbnail,
                  controls: 'progress,current,durration,volume',
                  crossOrigin: false
                }},on:{"onplay":_vm.play}})],1):(item.typeofmessage === 'location')?_c('p',{staticClass:"boxselffile",staticStyle:{"max-width":"250px","min-width":"150px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5 !important","border-radius":"20px","padding":"10px","padding-bottom":"10px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"}},[_vm._v("place")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"color":"black","padding-left":"10px"},attrs:{"xs10":"","sm10":"","md10":"","lg10":"","xl10":""}},[(item.file_name != '')?_c('span',[_vm._v(" "+_vm._s(item.file_name))]):_c('span',[_vm._v(" somewhere")])])],1)],1)],1):(item.typeofmessage === 'date')?_c('p',{staticClass:"boxself"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n            ")],1):(item.typeofmessage === 'datetime')?_c('p',{staticClass:"boxself"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n              "),_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v(" far fa-clock")]),_vm._v("   เวลา "+_vm._s(item.message.split('T')[1])+" น.\n            ")],1):(item.typeofmessage === 'call')?_c('div',{staticClass:"boxself",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"}},[(item.message =='cancel' || item.message =='decline')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel' || item.message =='decline')?_c('span',[_vm._v("\n                "+_vm._s(_vm.checktypeCall(item.message))+"\n              ")]):_c('span',[_vm._v(_vm._s(_vm.secondsToHms(item.time_count)))])],1):(item.typeofmessage === 'agora_call')?_c('div',{staticClass:"boxself",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"}},[(item.message =='cancel' || item.message =='end')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel')?_c('span',[_vm._v("\n                "+_vm._s(_vm.checktypeCall(item.message))+"\n              ")]):_c('span',[_vm._v(_vm._s(item.time))])],1):(item.typeofmessage === 'conference_msg')?_c('div',{staticClass:"boxself",staticStyle:{"text-align":"center","font-weight":"500 !important"}},[(item.information.option == 'voice')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startCall')))],1):(item.information.option == 'video')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("videocam")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startVideo')))],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"joinBtn",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.$t('ChatSide.conference.joinCall'))+" ")])],1):_c('p',{staticClass:"boxself",staticStyle:{"color":"#6d6d6d !important"}},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.notSupportVersion'))+"\n            ")])],1)],1):_vm._e(),_vm._v(" "),(item.tokenuser !== _vm.token && _vm.tokenrooomSelect === item.tokenroom)?_c('div',{staticClass:"chat friend"},[(item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system' && item.typeofmessage !== 'system_action' && item.typeofmessage !== 'system_action_albums' && item.typeofmessage !== 'system_action_task')?_c('v-flex',{staticStyle:{"cursor":"pointer","margin-top":"1vh"},attrs:{"xl1":"","lg1":"","md1":"","sm1":""}},[((item.typeofmessage != 'albums_message' || item.image_add.length != 0))?_c('v-avatar',{staticClass:"user-photo"},[(item.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.path_pic}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):_vm._e()],1):_vm._e(),_vm._v(" "),(item.typeofmessage === 'unsend_message')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.cancelMsg', {name: item.nickname}))+"\n            ")])]):(item.typeofmessage === 'system_action_albums')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_name_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.editNameAlbum', {name: item.nickname}))+"\n            ")]):(item.message == 'create_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.createAlbum', {name: item.nickname, albums_name:item.albums_name}))+"\n            ")]):(item.message == 'delete_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.deleteAlbum', {name: item.nickname}))+"\n            ")]):(item.message == 'delete_images_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.deleteImageAlbum', {name: item.nickname}))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system_action_task')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_task')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.editTask', {name: item.nickname}))+"\n            ")]):(item.message == 'create_project')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.createProject', {name: item.nickname}))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxother_system"},[_vm._v("\n              "+_vm._s(item.message)+"\n            ")])]):(item.typeofmessage === 'system_action')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxother_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" น.")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message === 'active')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.other.joinGroup', {name: item.nickname}))+"\n              ")]):(item.message === 'kick')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'invite')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'leave')?_c('span',[_vm._v("\n               "+_vm._s(_vm.$t('ChatSide.system.other.leftGroup', {name: item.nickname}))+"\n              ")]):_vm._e()])]):_c('v-flex',{staticStyle:{"padding-right":"0px","padding-left":"1vw"},attrs:{"xl8":"","lg8":"","md8":"","sm8":""}},[(item.typeofmessage === 'message')?_c('div',{staticClass:"boxfriend"},[_c('p',{staticStyle:{"margin":"0 !important"},attrs:{"slot":"activator"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))},slot:"activator"}),_vm._v(" "),_vm._l((_vm.convertURL(item.message)),function(x){return (_vm.convertURL(item.message))?_c('div',[_c('link-prevue',{attrs:{"url":x},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"row":"","wrap":""},on:{"click":function($event){_vm.clicklink_website(props.url)}}},[_c('v-flex',{staticClass:"border_website",attrs:{"xl9":"","lg9":"","md9":"","sm9":""}},[_c('p',{staticClass:"title_website"},[_vm._v(_vm._s(props.title))]),_vm._v(" "),_c('span',{staticClass:"description_website"},[_vm._v(_vm._s(props.description))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerimg_website",attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[(props.img)?_c('img',{staticClass:"img_website",attrs:{"src":props.img}}):_vm._e()])],1)]}}])},[_c('template',{slot:"loading"},[_c('span')])],2)],1):_vm._e()})],2):(item.typeofmessage === 'mention_message')?_c('p',{staticClass:"boxfriend",attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention'], item)}},slot:"activator"},[(item.source_message.typeofmessage !== 'unsend_message')?_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(item.source_message.owner_source_message.path_pic)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":item.source_message.owner_source_message.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"40px"},attrs:{"xs11":""}},[(item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.source_message.message))])]):(item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.typeofmessage === 'image')?_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.image')))]):_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.sticker')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"10px","float":"right"},attrs:{"src":item.source_message.message}})])],1):(item.source_message.typeofmessage === 'file')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(_vm.extension(item.source_message.message) === 'pdf')?_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v(_vm._s(_vm.extension(item.source_message.message)))])],1)],1):(item.source_message.typeofmessage === 'video')?_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.extension(item.source_message.message) === 'media')?_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"150","height":"150","controls":""}},[_c('source',{attrs:{"src":item.source_message.message,"type":'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]}})]):_c('div',{staticStyle:{"width":"100%","height":"150px","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"150px !important"},attrs:{"playerOptions":{
                            type: 'application/x-mpegURL',
                            src: item.source_message.message,
                            preload: true,
                            autoplay: false,
                            isLoop: false,
                            playsinline: false,
                            poster: '',
                            controls: 'progress,current,durration,volume',
                            crossOrigin: false
                          }},on:{"onplay":_vm.play}})],1)])],1):(item.source_message.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.address !== '')?_c('span',[_vm._v(_vm._s(item.source_message.address))]):_c('span',[_vm._v(_vm._s(item.source_message.message))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-map-marker-alt")])],1)],1):_vm._e()],1)],1):_c('v-layout',{staticStyle:{"padding-bottom":"10px","color":"#6f6f6f"},attrs:{"row":"","wrap":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.noMsg')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):(item.typeofmessage === 'albums_message' && item.image_add.length === 0)?_c('div',{staticStyle:{"display":"none"}}):(item.typeofmessage === 'albums_message' && item.image_add.length !== 0)?_c('div',{staticClass:"boxother_createablums",staticStyle:{"width":"240px"}},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#444444 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#444444 !important"}},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', {name: item.albums_name}))+"\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"color":"#848484 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', {count: item.image_add.length})))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',{staticStyle:{"color":"#737373 !important"}},[_vm._v(_vm._s(item.albums_name))]):_c('h4',{staticStyle:{"color":"#737373 !important"}},[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px","color":"#737373 !important"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'image')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"250px"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"none","border-radius":"10px","display":"flex","justify-content":"center"}},[_c('v-card-media',{staticClass:"white--text ",attrs:{"height":"200px","src":item.message}})],1)],1)],1)],1):(item.typeofmessage == 'web')?_c('div',{staticClass:"boxfriendfile"},[_c('iframe',{staticStyle:{"visibility":"visible"},attrs:{"width":"300","height":"400","frameborder":"0","src":item.message}})]):(item.typeofmessage === 'note')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',{staticStyle:{"color":"black"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length == 20)?_c('p',[_vm._v(" ...")]):_vm._e()])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#5a616b !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#5a616b !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'create_task')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#444444"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#444444c2"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#7c7c7c !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()}),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"#dcd9d9","outline":"","text-color":"#3a506d"}},[_vm._v("\n                      "+_vm._s(item.task_info.state.name)+"\n                    ")])],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#818181 !important"}},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.Task.viewDetail'))+"\n                  ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#818181 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'assign_task')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#444444"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#444444c2"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#7c7c7c !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()})],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#818181 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Task.editAssign')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#818181 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'sticker')?_c('div',{staticClass:"boxfriendsticker"},[_c('img',{staticStyle:{"width":"150px"},attrs:{"src":item.file_name}})]):(item.typeofmessage === 'file' && (_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media' || _vm.extension(item.file_name) === 'audio'))?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"300px"}},[_c('v-card',{staticStyle:{"background-color":"#4a4a4a","border-radius":"10px","padding":"10px","width":"100%"}},[(_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media')?_c('v-card-media',{staticStyle:{"border-radius":"10px"},attrs:{"height":"200px"}},[(_vm.extension(item.file_name) === 'pdf')?_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":item.message,"page":1},on:{"password":function($event){_vm.passwordPdf($event, i, item)},"error":_vm.errorPdf}}):(_vm.extension(item.file_name) === 'media')?_c('video',{staticStyle:{"border-radius":"10px","height":"190px"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_vm._e()],1):(_vm.extension(item.file_name) === 'audio')?_c('v-card-media',{staticStyle:{"width":"280px","border-radius":"10px"},attrs:{"height":"55px"}},[_c('audio',{staticStyle:{"border-radius":"10px","width":"260px","display":"flex"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_vm._e(),_vm._v(" "),(_vm.extension(item.file_name) !== 'audio')?_c('v-card-title',{staticStyle:{"padding-top":"10px","padding-left":"0px","padding-bottom":"10px"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"14px","color":"white"}},[_vm._v("("+_vm._s(item.file_name)+")\n                  ")])]):_vm._e()],1)],1):(item.typeofmessage === 'pdf_password' && (_vm.extension(item.file_name) === 'pdf'))?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"300px"},attrs:{"slot":"activator"},slot:"activator"},[_c('v-card',{staticStyle:{"background-color":"#4a4a4a","border-radius":"10px","padding":"10px","width":"100%"}},[(_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media')?_c('v-card-media',{staticStyle:{"border-radius":"10px"},attrs:{"height":"200px"}},[_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":"https://testchat.one.th/alpine/api/v1/file/J0CDcdbm1zUba7cb86c384f5fa5b3eae7269b4993ce_2022-08-17_18:29:28:894891.pdf","page":1},on:{"error":_vm.errorPdf}})],1):_vm._e(),_vm._v(" "),(_vm.extension(item.file_name) !== 'audio')?_c('v-card-title',{staticStyle:{"padding-top":"10px","padding-left":"0px","padding-bottom":"10px"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"14px","color":"white"}},[_vm._v("("+_vm._s(item.file_name)+")\n                  ")])]):_vm._e()],1)],1):(item.typeofmessage === 'file' || item.typeofmessage === 'password_file')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"300px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":"","lg4":"","xl4":""}},[(_vm.extension(item.file_name) === 'pdf')?_c('v-icon',{staticStyle:{"color":"white","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"white","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v(_vm._s(_vm.extension(item.file_name)))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card-title',{staticStyle:{"text-align":"left"},attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"width":"160px","word-break":"break-all !important"}},[_vm._v(_vm._s(item.file_name))])])])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[(item.typeofmessage == 'password_file')?_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-lock")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-right":"10px"},attrs:{"flat":"","icon":"","color":"white","disabled":""}},[(_vm.extension(item.file_name) == 'pdf')?_c('v-icon',[_vm._v("visibility")]):_c('v-icon',[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":""}},[_c('v-icon',[_vm._v("cloud_upload")])],1)],1)],1)],1):(item.typeofmessage === 'video')?_c('div',{staticClass:"boxfriendfile",staticStyle:{"max-height":"250px"}},[(_vm.extension(item.typeofmessage) === 'media')?_c('video',{attrs:{"width":"100%","height":"250","controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_c('vplayer',{attrs:{"playerOptions":{
                  type: 'application/x-mpegURL',
                  src: item.message,
                  preload: true,
                  autoplay: false,
                  isLoop: false,
                  playsinline: false,
                  poster: item.thumbnail,
                  controls: 'progress,current,durration,volume',
                  crossOrigin: false
                }},on:{"onplay":_vm.play}})],1):(item.typeofmessage === 'location')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"max-width":"250px","min-width":"150px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#efefef","border-radius":"20px","padding":"10px","padding-bottom":"10px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"}},[_vm._v("place")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"color":"black","padding-left":"10px"},attrs:{"xs10":"","sm10":"","md10":"","lg10":"","xl10":""}},[(item.file_name != '')?_c('span',[_vm._v(" "+_vm._s(item.file_name))]):_c('span',[_vm._v(" somewhere")])])],1)],1)],1):(item.typeofmessage === 'date')?_c('p',{staticClass:"boxfriend"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n            ")],1):(item.typeofmessage === 'datetime')?_c('p',{staticClass:"boxfriend"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n              "),_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v(" far fa-clock")]),_vm._v("   เวลา "+_vm._s(item.message.split('T')[1])+" น.\n            ")],1):(item.typeofmessage === 'contact')?_c('div',{staticClass:"boxfriend",staticStyle:{"font-weight":"500","border-radius":"15px !important"}},[_c('v-avatar',{staticClass:"user-photo"},[(item.pic_contact)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.pic_contact}}):(item.type_contact === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"textchat",staticStyle:{"margin-right":"15px"}},[_vm._v(_vm._s(item.nickname_contact))]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"50%","-ms-transform":"translateY(-50%)","transform":"translateY(-50%)","right":"0"}},[_c('v-icon',[_vm._v("navigate_next ")])],1)],1):(item.typeofmessage === 'template')?_c('div',{staticClass:"boxfriendquestion scrolling-wrapper-template",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","display":"flex","background":"none","align-items":"end"}},_vm._l((item.info_ans),function(info_ans,index){return _c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px"}},[(info_ans.image)?_c('v-img',{staticStyle:{"height":"120px"},attrs:{"src":info_ans.image,"aspect-ratio":"2.75"}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#61666d"}},[_vm._v(_vm._s(info_ans.title))]),_vm._v(" "),_c('p',{staticClass:"mb-0",staticStyle:{"display":"-webkit-box","-webkit-line-clamp":"2","-webkit-box-orient":"vertical","overflow":"hidden","text-overflow":"ellipsis"},domProps:{"innerHTML":_vm._s(_vm.convert(info_ans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(info_ans.detail.length >= 40)?_c('a',{on:{"click":function($event){_vm.clickReadmore(info_ans)}}},[_c('b',[_vm._v(_vm._s(_vm.$t('ChatSide.Read.readmore')))])]):_vm._e(),_vm._v(" "),(!info_ans.image)?_c('v-divider',{staticClass:"mt-2",attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((info_ans.choice),function(choice,index){return _c('div',[(choice.type=='file')?_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px"},attrs:{"flat":"","disabled":""}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-download")]),_vm._v("    "),_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px"},attrs:{"flat":"","disabled":""}},[_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})])],1)})],2)])],1)],1)})):(item.typeofmessage === 'official_template')?_c('div',{staticClass:"boxfriendquestion",staticStyle:{"overflow":"hidden","display":"-webkit-inline-box","background":"none"}},[_c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px","background":"#efefef !important"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562af","padding-left":"12px","padding-top":"10px","padding-bottom":"10px"}},[_vm._v(_vm._s(item.element.title))]),_vm._v(" "),(item.element.image)?_c('v-img',{staticStyle:{"height":"160px"},attrs:{"src":item.element.image,"contain":""}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('read-more',{staticClass:"mb-0",staticStyle:{"color":"#343433"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":100}}),_vm._v(" "),(!item.element.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((item.element.choice),function(choice,index){return _c('div',[_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px","border-radius":"20px"},attrs:{"flat":"","disabled":""}},[_vm._v("\n                          "+_vm._s(choice.label)+"\n                        ")])],1)})],2)])],1)],1)]):(item.typeofmessage === 'approve_message')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"white","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticStyle:{"color":"#757575 !important"}},[_vm._v(_vm._s(item.info_ans[0].title))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#9d9d9d !important"}},[_vm._v(_vm._s(item.info_ans[0].short_detail))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),(item.disable === 'false')?_c('v-card-actions',[_c('span',{staticStyle:{"color":"#757575 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.viewDetail'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#757575 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1):_c('v-card-actions',[_c('span',{staticStyle:{"color":"#757575 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.receiveAns'))+" ")])])],1)],1):(item.typeofmessage === 'call')?_c('div',{staticClass:"boxfriend",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"}},[(item.message =='cancel' || item.message =='decline')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel' || item.message =='decline')?_c('span',[_vm._v("\n                "+_vm._s(_vm.checktypeCall(item.message))+"\n              ")]):_c('span',[_vm._v(_vm._s(_vm.secondsToHms(item.time_count)))])],1):(item.typeofmessage === 'agora_call')?_c('div',{staticClass:"boxfriend",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"}},[(item.message =='cancel' || item.message =='end')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel')?_c('span',[_vm._v("\n                "+_vm._s(_vm.checktypeCall(item.message))+"\n              ")]):_c('span',[_vm._v(_vm._s(item.time))])],1):(item.typeofmessage === 'conference_msg')?_c('div',{staticClass:"boxfriend",staticStyle:{"text-align":"center","font-weight":"500 !important"}},[(item.information.option == 'voice')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startCall')))],1):(item.information.option == 'video')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("videocam")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startVideo')))],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"joinBtn",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.$t('ChatSide.conference.joinCall')))])],1):(item.typeofmessage === 'carousel')?_c('div',{staticClass:"boxfriendcarousel scrolling-wrapper-template",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","display":"-webkit-inline-box","background":"none"}},_vm._l((item.elements),function(info_carousel,index){return _c('div',[_c('v-card',{staticStyle:{"border-radius":"20px","width":"250px","margin-right":"10px"}},[(info_carousel.image)?_c('v-img',{staticStyle:{"height":"250px"},attrs:{"src":info_carousel.image,"aspect-ratio":"2.75"}},[(info_carousel.type !== 'image')?_c('v-layout',{staticStyle:{"height":"250px"},attrs:{"row":"","wrap":"","align-end":"","justify-center":""}},[(info_carousel.button)?_c('v-btn',{attrs:{"round":"","color":"#0000009c","dark":"","disabled":""}},[_c('span',{staticClass:"text-transform"},[_vm._v(_vm._s(info_carousel.button))])]):_vm._e()],1):_vm._e()],1):_vm._e()],1)],1)})):_c('p',{staticClass:"boxfriend",staticStyle:{"color":"#757575 !important"}},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.notSupportVersion'))+"\n            ")])]),_vm._v(" "),(item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system' && item.typeofmessage !== 'system_action' && item.typeofmessage !== 'system_action_albums' && item.typeofmessage !== 'system_action_task')?_c('v-flex',{attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[((item.typeofmessage === 'message' || item.typeofmessage === 'image' || item.typeofmessage === 'file' || item.typeofmessage === 'pdf_password' || item.typeofmessage === 'video' || item.typeofmessage === 'location') && item.status!='no')?_c('v-checkbox',{staticStyle:{"float":"right"},attrs:{"value":item.tokenmessage},model:{value:(_vm.selectedForward),callback:function ($$v) {_vm.selectedForward=$$v},expression:"selectedForward"}}):_c('v-checkbox',{staticStyle:{"float":"right"},attrs:{"disabled":""}})],1):_vm._e()],1):_vm._e()]):_vm._e()}),_vm._v(" "),(_vm.datepicker)?_c('v-date-picker',{attrs:{"max":_vm.maxdate,"min":_vm.mindate,"landscape":true},model:{value:(_vm.dateselect),callback:function ($$v) {_vm.dateselect=$$v},expression:"dateselect"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.datepicker = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.senddate()}}},[_vm._v("OK")])],1):_vm._e(),_vm._v(" "),(_vm.timepicker)?_c('v-time-picker',{attrs:{"max":_vm.maxtime,"min":_vm.mintime,"format":"24hr","landscape":true},model:{value:(_vm.timeselect),callback:function ($$v) {_vm.timeselect=$$v},expression:"timeselect"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timepicker = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.sendtime()}}},[_vm._v("OK")])],1):_vm._e()],2),_vm._v(" "),(_vm.ForwardState === false &&_vm.Quickreply)?_c('v-flex',{staticStyle:{"margin":"0"},attrs:{"lg12":"","md12":"","sm12":"","xl12":""}},[_c('div',{staticClass:"chat-messages clearfix scrolling-wrapper",style:(_vm.quickreplyStyle + 'background: none !important;margin-left: 20px;overflow-y: hidden;display: flex;height: 50px; width: 45% !important;overflow-x:scroll !important;')},_vm._l((_vm.Quickreply.quick_reply),function(item,index){return _c('a',{},[(item.type == 'text')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.ans_quickreply(item, 'text')}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'ocr')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.ocropen(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'file')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.selectfile_quickreply(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'image')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.selectfile_quickreply(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'location')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.sendlocation_quickreply(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'datepicker' || item.type == 'datetimepicker')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.setpicker(item)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-calendar-alt")]),_vm._v("   "),_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])],1):(item.type == 'link')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.openlink(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'webview')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.openwebview(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'link_market')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.openlink_market(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'ekyc')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.ans_ekyc(item, _vm.Quickreply)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):_vm._e()],1)}))]):_vm._e(),_vm._v(" "),(_vm.ForwardState)?_c('v-flex',{staticStyle:{"margin":"0"},attrs:{"lg12":"","md12":"","sm12":"","xl12":""}},[_c('div',{staticClass:"chat-messages clearfix",staticStyle:{"width":"100%"}},[_c('p',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('ChatSide.numberMsgSent'))+" ("+_vm._s(_vm.selectedForward.length)+")")]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"disabled":(_vm.selectedForward.length==0)},on:{"click":function($event){_vm.dialogForward = true;}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.forward')))]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},on:{"click":function($event){_vm.dialogForward = false; _vm.ForwardState = false; _vm.selectedForward = []}}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n        ")])],1)]):_vm._e(),_vm._v(" "),(_vm.RichmenuState)?_c('v-flex',{staticStyle:{"margin":"0"},attrs:{"lg12":"","md12":"","sm12":"","xl12":""}},[(!_vm.sheetrichmenu)?_c('div',{staticClass:"chat-messages-richmenu clearfix"},[_c('v-layout',{staticStyle:{"height":"100%"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{staticStyle:{"border-right-style":"solid","border-right-color":"white","border-right-width":"thin"},attrs:{"xs1":"","md1":"","sm1":"","xl1":"","lg1":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.RichmenuState = false; _vm.sheetrichmenu = false}}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-keyboard")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-2 pr-2",attrs:{"xs11":"","md11":"","sm11":"","xl11":"","lg11":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"block":"","flat":"","color":"white"},on:{"click":function($event){_vm.sheetrichmenu = true}}},[_vm._v(_vm._s(_vm.richmenu_label))])],1)],1)],1)],1):_c('div',[(_vm.type_richmenu <= 7)?_c('div',{staticClass:"chat-messages-richmenu-sheet clearfix"},[_c('v-layout',{staticStyle:{"height":"89%","width":"375px","margin":"auto"},attrs:{"row":"","wrap":"","align-start":"","justify-center":""}},[_c('v-flex',{staticStyle:{"height":"100%"},attrs:{"xs12":"","md12":"","sm12":"","lg12":"","xl12":""}},[_c('Richmenudialog',{attrs:{"type_richmenu":_vm.type_richmenu,"inforrichmenu":_vm.inforrichmenu,"Richmenudialog":_vm.Richmenudialog},on:{"emitrichmenu":_vm.emitrichmenu}})],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"bottom":"0","position":"fixed","width":"50%","padding-right":"10px"},attrs:{"row":"","wrap":"","align-end":"","justify-center":""}},[_c('v-flex',{staticStyle:{"border-right-style":"solid","border-right-color":"white","border-right-width":"thin","margin-bottom":"7px"},attrs:{"xs1":"","md1":"","sm1":"","xl1":"","lg1":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.RichmenuState = false; _vm.sheetrichmenu = false}}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-keyboard")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-2 pr-2",attrs:{"xs11":"","md11":"","sm11":"","xl11":"","lg11":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"block":"","flat":"","color":"white"},on:{"click":function($event){_vm.sheetrichmenu = false}}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-sort-down")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.richmenu_label))])],1)],1)],1)],1)],1)],1):_c('div',{staticClass:"chat-messages-richmenu-sheet-row clearfix"},[_c('v-layout',{staticStyle:{"width":"375px","margin":"auto"},attrs:{"row":"","wrap":"","align-start":"","justify-center":""}},[_c('v-flex',{staticStyle:{"height":"100%"},attrs:{"xs12":"","md12":"","sm12":"","lg12":"","xl12":""}},[_c('Richmenudialog',{attrs:{"type_richmenu":_vm.type_richmenu,"inforrichmenu":_vm.inforrichmenu,"Richmenudialog":_vm.Richmenudialog},on:{"emitrichmenu":_vm.emitrichmenu}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-end":"","justify-center":""}},[_c('v-flex',{staticStyle:{"border-right-style":"solid","border-right-color":"white","border-right-width":"thin","margin-bottom":"7px"},attrs:{"xs1":"","md1":"","sm1":"","xl1":"","lg1":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.RichmenuState = false; _vm.sheetrichmenu = false}}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-keyboard")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-2 pr-2",attrs:{"xs11":"","md11":"","sm11":"","xl11":"","lg11":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"block":"","flat":"","color":"white"},on:{"click":function($event){_vm.sheetrichmenu = false}}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-sort-down")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.richmenu_label))])],1)],1)],1)],1)],1)],1)])]):(!_vm.ForwardState)?_c('v-flex',{staticStyle:{"margin":"0"},attrs:{"lg12":"","md12":"","sm12":"","xl12":""}},[(_vm.files.length > 0)?_c('div',{staticClass:"listfile"},_vm._l((_vm.files),function(file,key){return (_vm.files.length > 0)?_c('div',{staticClass:"borderfile",staticStyle:{"justify-content":"center","margin-left":"10px"}},[_c('a',{staticClass:"close-classic",on:{"click":function($event){_vm.removeFile( key )}}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center","padding-top":"15px"}},[_c('img',{ref:'preview'+parseInt( key ),refInFor:true,staticClass:"preview",staticStyle:{"height":"60px !important","width":"60px !important","display":"flex","justify-content":"center","object-fit":"cover","object-position":"center"},attrs:{"src":file.filebase64}})])]):_vm._e()})):_vm._e(),_vm._v(" "),(_vm.progressLoadChatBox)?_c('div',{staticClass:"chat-messages clearfix",staticStyle:{"width":"100%"}},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.progressLoadChatBox}})],1):_c('div',{staticClass:"chat-messages clearfix",staticStyle:{"width":"100%"}},[(_vm.statemember == 'active' && _vm.online)?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendmsg),expression:"sendmsg"}],ref:"textareaChat",staticClass:"textareabg CSChatThai",attrs:{"placeholder":_vm.$t('ChatSide.textarea.normal'),"rows":"3","id":"textareaChat"},domProps:{"value":(_vm.sendmsg)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.sendmsg=$event.target.value},function($event){_vm.filterlistfriend()}],"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.sendMessage(_vm.sendmsg)},"paste":_vm.onPaste}},[_vm._v("        <!-- @keyup.enter.exact=\"sendMessage(sendmsg)\" -->\n          ")]):(_vm.statemember !='active' && _vm.online)?_c('textarea',{staticClass:"textareabg CSChatThai",staticStyle:{"background-color":"#1a222c !important"},attrs:{"disabled":"","placeholder":_vm.$t('ChatSide.textarea.inactive'),"rows":"3","id":"textareaChat"}}):_c('textarea',{staticClass:"textareabg CSChatThai",staticStyle:{"background-color":"#1a222c !important"},attrs:{"disabled":"","placeholder":"Network error","rows":"3","id":"textareaChat"}}),_vm._v(" "),(_vm.statemember=='active' && _vm.online)?_c('div',{staticStyle:{"margin-top":"-2px"}},[(_vm.list_richmenu.length !== 0)?_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":_vm.chsheetrichmenu}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-list")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":_vm.chsheetother}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-plus")])],1),_vm._v(" "),_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":_vm.uppic}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"23px !important"}},[_vm._v("insert_photo")])],1),_vm._v(" "),_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":_vm.chsheetsticker}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"23px !important"}},[_vm._v("face")])],1)],1):_c('div',{staticStyle:{"margin-top":"-2px"}},[(_vm.list_richmenu.length !== 0)?_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","margin":"0","margin-left":"-2px"},attrs:{"disabled":"","icon":"","dark":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-list")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","margin":"0","margin-left":"-2px"},attrs:{"disabled":"","icon":"","dark":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-plus")])],1),_vm._v(" "),_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","margin":"0","margin-left":"-2px"},attrs:{"disabled":"","icon":"","dark":""}},[_c('v-icon',{staticStyle:{"color":"gray","font-size":"23px !important"}},[_vm._v("insert_photo")])],1),_vm._v(" "),_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","margin":"0","margin-left":"-2px"},attrs:{"disabled":"","icon":"","dark":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"23px !important"}},[_vm._v("face")])],1)],1),_vm._v(" "),(_vm.statemember=='active' && _vm.online && _vm.sheetother)?_c('v-card',{staticStyle:{"margin-left":"-9px","margin-right":"-9px","bottom":"196px  !important","height":"78px","background":"#27303e","box-shadow":"none"},attrs:{"tile":"","id":"menu-chat"}},[_c('div',{staticClass:"sidebar-menu"},[_c('ul',[_c('li',[_c('a',{staticStyle:{"padding-top":"3px"},attrs:{"title":"File"},on:{"click":_vm.upfile}},[_c('v-icon',{staticStyle:{"font-size":"20px !important","background":"#2662af","border-radius":"50%","display":"flex","justify-content":"center","align-items":"center","color":"white"}},[_vm._v("attach_file")]),_vm._v(" "),_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])],1)]),_vm._v(" "),_c('li',[_c('a',{staticStyle:{"padding-top":"3px"},attrs:{"title":"Account"},on:{"click":function($event){_vm.dialogAccount = true; _vm.sheetother = false}}},[_c('v-icon',{staticClass:"acount",staticStyle:{"font-size":"20px !important","background":"#23ad54","border-radius":"50%","display":"flex","justify-content":"center","align-items":"center","color":"white"}},[_vm._v("mdi-account")]),_vm._v(" "),_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('ChatSide.friend')))])],1)]),_vm._v(" "),_c('li',[_c('a',{staticStyle:{"padding-top":"3px"},attrs:{"title":"Location"},on:{"click":function($event){_vm.openmap()}}},[_c('v-icon',{staticClass:"acount",staticStyle:{"font-size":"20px !important","background":"#cd2b01","border-radius":"50%","display":"flex","justify-content":"center","align-items":"center","color":"white"}},[_vm._v("location_on")]),_vm._v(" "),_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('ChatSide.location')))])],1)]),_vm._v(" "),_c('li',[_c('a',{staticStyle:{"padding-top":"3px"},attrs:{"title":"Forward"},on:{"click":function($event){_vm.ForwardState = true; _vm.sheetother = false}}},[_c('v-icon',{staticClass:"acount",staticStyle:{"font-size":"20px !important","background":"#d02788","border-radius":"50%","display":"flex","justify-content":"center","align-items":"center","color":"white"}},[_vm._v("far fa-share-square ")]),_vm._v(" "),_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('ChatSide.forward')))])],1)])])])]):_vm._e(),_vm._v(" "),(_vm.statemember=='active' && _vm.online && _vm.sheetsticker)?_c('v-card',{staticStyle:{"margin-left":"-9px","margin-right":"-9px","bottom":"248px !important","background":"#27303e","height":"130px"},attrs:{"tile":"","id":"menu-sticker"}},[_c('v-card-text',{staticStyle:{"padding-top":"0vh","text-transform":"none"}},[_c('v-tabs',{staticStyle:{"background":"#27303e !important","text-transform":"none"},attrs:{"slot":"extension","centered":""},slot:"extension",model:{value:(_vm.activetapEmo),callback:function ($$v) {_vm.activetapEmo=$$v},expression:"activetapEmo"}},[_c('v-tab',{staticStyle:{"font-size":"13px","text-transform":"none !important","overflow-y":"hidden","background":"#27303e !important"},attrs:{"href":"#tab-Emo"}},[_c('p',{staticClass:"textemo"},[_vm._v(_vm._s(_vm.$t('ChatSide.emoji')))])]),_vm._v(" "),_c('v-tab',{staticStyle:{"font-size":"13px","text-transform":"none !important","overflow-y":"hidden","background":"#27303e !important"},attrs:{"href":"#tab-Stick"}},[_c('p',{staticClass:"textemo"},[_vm._v(_vm._s(_vm.$t('ChatSide.sticker')))])])],1),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"margin-top":"0.2vh","background":"#27303e !important"},model:{value:(_vm.activetapEmo),callback:function ($$v) {_vm.activetapEmo=$$v},expression:"activetapEmo"}},[_c('v-tab-item',{staticClass:"scrolling-wrapper-y",staticStyle:{"height":"105px","text-transform":"none","background":"#27303e !important"},attrs:{"id":"tab-Emo"}},[_c('div',{staticStyle:{"background":"#27303e !important"}},[_c('v-tabs',{staticStyle:{"background":"#27303e !important"},attrs:{"slot":"extension","centered":""},slot:"extension",model:{value:(_vm.activeEmoji),callback:function ($$v) {_vm.activeEmoji=$$v},expression:"activeEmoji"}},_vm._l((_vm.emojiGroups),function(emojiGroup,category){return _c('v-tab',{staticStyle:{"font-size":"20px"},attrs:{"href":'#tab-'+ category}},[_vm._v("\n                        "+_vm._s(emojiGroup['smile'])+"\n                        "+_vm._s(emojiGroup['bear'])+"\n                        "+_vm._s(emojiGroup['soccer'])+"\n                        "+_vm._s(emojiGroup['house_with_garden'])+"\n                        "+_vm._s(emojiGroup['heart_decoration'])+"\n                      ")])})),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"margin-top":"0.2vh"},model:{value:(_vm.activeEmoji),callback:function ($$v) {_vm.activeEmoji=$$v},expression:"activeEmoji"}},_vm._l((_vm.emojiGroups),function(emojiGroup,category){return _c('v-tab-item',{staticClass:"scrolling-wrapper-y",staticStyle:{"height":"75px"},attrs:{"id":'tab-'+category}},[_c('div',{staticClass:"emojis"},_vm._l((emojiGroup),function(emoji,emojiName){return _c('span',{key:emojiName,attrs:{"title":emojiName},on:{"click":function($event){_vm.append(emoji)}}},[_vm._v(_vm._s(emoji))])}))])}))],1)]),_vm._v(" "),_c('v-tab-item',{staticClass:"scrolling-wrapper-y",staticStyle:{"height":"105px","text-transform":"none"},attrs:{"id":"tab-Stick"}},[_c('div',{staticStyle:{"background":"#27303e !important"}},[_c('v-tabs',{staticStyle:{"background":"#27303e !important"},attrs:{"slot":"extension","centered":""},slot:"extension",model:{value:(_vm.activeSticker),callback:function ($$v) {_vm.activeSticker=$$v},expression:"activeSticker"}},_vm._l((_vm.sticker),function(item,index){return _c('v-tab',{key:item.token_sticker,staticStyle:{"font-size":"20px"},attrs:{"href":'#tabsticker-'+item.token_sticker}},[_c('img',{staticStyle:{"width":"30px"},attrs:{"src":item.path_title}})])})),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"margin-top":"0.2vh","background":"#27303e"},model:{value:(_vm.activeSticker),callback:function ($$v) {_vm.activeSticker=$$v},expression:"activeSticker"}},_vm._l((_vm.sticker),function(item,index){return _c('v-tab-item',{key:index,staticClass:"scrolling-wrapper-y",staticStyle:{"height":"75px"},attrs:{"id":'tabsticker-'+item.token_sticker}},[_c('v-container',{staticStyle:{"padding":"0"},attrs:{"wrap":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((item.list_sticker),function(items,index){return _c('v-flex',{staticStyle:{"justify-content":"center"},attrs:{"sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-layout',{staticStyle:{"justify-content":"center","display":"flex","text-align":"center"}},[_c('img',{staticStyle:{"width":"70px","height":"70px","cursor":"pointer"},attrs:{"src":items.s3_name},on:{"click":function($event){_vm.pushSticker(items.message)}}})])],1)}))],1)],1)}))],1)])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showmessagebottom)?_c('v-flex',{staticStyle:{"margin":"0","bottom":"170px","position":"fixed","width":"50%","height":"4vh","padding":"5px !important","cursor":"pointer"},attrs:{"lg12":"","md12":"","sm12":"","xl12":""},on:{"click":_vm.lookmessage}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-chip',{staticStyle:{"cursor":"pointer"},attrs:{"close":""},on:{"click":function($event){_vm.chip = false;}},model:{value:(_vm.chip),callback:function ($$v) {_vm.chip=$$v},expression:"chip"}},[_c('v-avatar',[(_vm.picturechip)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.picturechip}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('span',{staticClass:"text2"},[_vm._v(_vm._s(_vm.showmessage))])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showmention)?_c('v-flex',{staticClass:"showmention",attrs:{"lg12":"","md12":"","sm12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(_vm.SelectedMessageDetail.path_pic !== '')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"height":"40px","width":"40px"},attrs:{"src":_vm.SelectedMessageDetail.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"height":"40px","width":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10px"},attrs:{"xs10":""}},[(_vm.SelectedMessageDetail.typeofmessage == 'message' || _vm.SelectedMessageDetail.typeofmessage == 'mention_message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"30vw","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.SelectedMessageDetail.nickname))]),_vm._v(" "),(_vm.SelectedMessageDetail.message)?_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"30vw","overflow":"hidden","text-overflow":"ellipsis"},domProps:{"innerHTML":_vm._s(_vm.convertMention(_vm.SelectedMessageDetail.message))}}):_vm._e()]):(_vm.SelectedMessageDetail.typeofmessage === 'image' || _vm.SelectedMessageDetail.typeofmessage === 'sticker' || _vm.SelectedMessageDetail.typeofmessage === 'file' || _vm.SelectedMessageDetail.typeofmessage === 'pdf_password')?_c('v-layout',{attrs:{"row":""}},[_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"30vw","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.SelectedMessageDetail.nickname))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.SelectedMessageDetail.typeofmessage === 'image')?_c('img',{staticStyle:{"height":"40px","width":"40px","border-radius":"10px"},attrs:{"src":_vm.SelectedMessageDetail.message}}):(_vm.SelectedMessageDetail.typeofmessage === 'sticker')?_c('img',{staticStyle:{"height":"40px","width":"40px","border-radius":"10px"},attrs:{"src":_vm.SelectedMessageDetail.file_name}}):(_vm.extension(_vm.SelectedMessageDetail.file_name) === 'pdf')?_c('v-icon',{staticStyle:{"color":"white","font-size":"35px"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"white","font-size":"35px"}},[_vm._v(_vm._s(_vm.extension(_vm.SelectedMessageDetail.file_name)))])],1):(_vm.SelectedMessageDetail.typeofmessage === 'video')?_c('v-layout',{attrs:{"row":""}},[_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"30vw","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.SelectedMessageDetail.nickname))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.extension(_vm.SelectedMessageDetail.message) === 'media')?_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"40","height":"40","controls":""}},[_c('source',{attrs:{"src":_vm.SelectedMessageDetail.message,"type":'video/' + _vm.SelectedMessageDetail.message.split('.')[_vm.SelectedMessageDetail.message.split('.').length - 1]}})]):_c('img',{staticStyle:{"width":"40px","height":"40px","justify-content":"center","align-items":"center"},attrs:{"src":_vm.SelectedMessageDetail.thumbnail}})],1):(_vm.SelectedMessageDetail.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"50vw","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.SelectedMessageDetail.nickname))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"white","font-size":"35px"}},[_vm._v("fas fa-map-marker-alt")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"15px","padding-bottom":"20px"},attrs:{"xs1":""}},[_c('v-icon',{attrs:{"color":"white"},on:{"click":function($event){_vm.showmention = false;}}},[_vm._v("close")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.checksen(_vm.sendmsg))?_c('v-btn',{staticClass:"buttonsend",staticStyle:{"bottom":"4px","position":"fixed","margin-left":"42vw"},attrs:{"small":"","flat":""},on:{"click":function($event){_vm.sendMessage(_vm.sendmsg)}}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"15px !important"}},[_vm._v("send")]),_vm._v(" Send\n        ")],1):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.status_tag === true)?_c('v-card',{staticClass:"friendList"},[_c('div',_vm._l((_vm.listfriend_filter),function(item,index){return _c('v-list',{key:index},[_c('v-list-tile',{on:{"click":function($event){_vm.tagFriend(item.name)}}},[_c('v-list-tile-avatar',[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.name)}})],1)],1)],1)}))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('input',{attrs:{"type":"file","id":"uploadpic_ocr","accept":"image/*"},on:{"change":function($event){_vm.onimgSelected_ocr($event)},"click":function($event){_vm.clearImage()}}}),_vm._v(" "),_c('input',{attrs:{"multiple":"","type":"file","id":"uploadpic","accept":"image/*"},on:{"change":function($event){_vm.onimgSelected($event)}}}),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"uploadpic_quickreply","accept":"image/*"},on:{"change":function($event){_vm.onimgSelected_quickreply($event)},"click":function($event){_vm.clearImage()}}}),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"uploadfile_quickreply"},on:{"change":function($event){_vm.onimgSelected_quickreply($event)},"click":function($event){_vm.clearImage()}}}),_vm._v(" "),_c('input',{attrs:{"multiple":"","type":"file","id":"uploadfileChat"},on:{"change":_vm.onFileSelected}})])],1)],1),_vm._v(" "),_c('ReadmoreDialog',{attrs:{"dialogReadmore":_vm.dialogReadmore,"detailReadmore":_vm.detailReadmore},on:{"closeReadmoreDialog":_vm.closeReadmoreDialog}}),_vm._v(" "),_c('LoginDialog',{attrs:{"dialogLogin":_vm.dialogLogin},on:{"closeLoginDialog":_vm.closeLoginDialog}}),_vm._v(" "),_c('AccountDialog',{attrs:{"dialogAccount":_vm.dialogAccount},on:{"closeAccount":_vm.closeAccount,"pushcontact":_vm.pushcontact}}),_vm._v(" "),_c('MapDialog',{attrs:{"dialogSendMap":_vm.dialogSendMap},on:{"closeSendMap":_vm.closeSendMap,"send_location":_vm.send_location}}),_vm._v(" "),_c('NoteDialog',{attrs:{"dialogNote":_vm.dialogNote,"note_id":_vm.note_id,"statemember":_vm.statemember},on:{"closeNote":_vm.closeNote}}),_vm._v(" "),_c('AlbumsDialog',{attrs:{"dialogAlbums":_vm.dialogAlbums,"albums_id":_vm.albums_id},on:{"closeAlbums":_vm.closeAlbums}}),_vm._v(" "),_c('AddImageDialog',{attrs:{"dialogAddImage":_vm.dialogAddImage,"path_pic_albums":_vm.SelectedMessageDetail.message,"file_name":_vm.SelectedMessageDetail.file_name},on:{"closeAddImage":_vm.closeAddImage}}),_vm._v(" "),_c('CreatemailDialog',{attrs:{"dialogCreatemail":_vm.dialogCreatemail,"message":_vm.SelectedMessageDetail},on:{"closeCreatemail":_vm.closeCreatemail}}),_vm._v(" "),_c('WebviewBigDialog',{attrs:{"token":_vm.token,"tokenrooomSelect":_vm.tokenrooomSelect,"dialogWebviewbig":_vm.dialogWebviewbig,"Webview_item":_vm.Webview_item},on:{"closeWebview":_vm.closeWebview}}),_vm._v(" "),_c('WebviewBigOcrDialog',{attrs:{"token":_vm.token,"tokenrooomSelect":_vm.tokenrooomSelect,"dialogWebviewbig_ocr":_vm.dialogWebviewbig_ocr,"Webview_item":_vm.Webview_item_ocr},on:{"closeWebview":_vm.closeWebview}}),_vm._v(" "),_c('ApproveDialog',{attrs:{"dialogApprove":_vm.dialogApprove,"ApproveDetail":_vm.ApproveDetail},on:{"sendansApprove":_vm.sendansApprove,"closeApprove":_vm.closeApprove}}),_vm._v(" "),_c('ForwardDialog',{attrs:{"dialogForward":_vm.dialogForward,"selectedForward":_vm.selectedForward},on:{"closeForward":_vm.closeForward}}),_vm._v(" "),_c('Openwebsite',{attrs:{"dialogopenwebsite":_vm.dialogopenwebsite,"id":_vm.id,"type":_vm.type},on:{"closeDialog":_vm.closeDialog}}),_vm._v(" "),_c('DetailTask',{attrs:{"dialogDetailTask":_vm.dialogDetailTask,"taskid":_vm.taskid,"roomid":_vm.roomid},on:{"closeDetailTask":_vm.closeDetailTask}}),_vm._v(" "),_c('SaveOnebox',{attrs:{"dialogSaveOnebox":_vm.dialogSaveOnebox,"tokenmessage_savebox":_vm.tokenmessage_savebox},on:{"closeSaveOnebox":_vm.closeSaveOnebox}}),_vm._v(" "),_c('CheckBrowserDialog',{attrs:{"checkBrowserDialog":_vm.checkBrowserDialog,"checkBrowserInfor":_vm.checkBrowserInfor},on:{"closeCheckBrowser":_vm.closeCheckBrowser}}),_vm._v(" "),_c('QrcodeDialog',{attrs:{"QrcodeInfor":_vm.QrcodeInfor,"typemenu":_vm.typemenu,"dialogShowQRCode":_vm.dialogShowQRCode,"tokenroom":_vm.tokenrooomSelect},on:{"closeShowQRCodeUser":_vm.closeShowQRCodeUser}}),_vm._v(" "),_c('AgoraCallDialog',{attrs:{"AgoraCallDialog":_vm.AgoraCallDialog,"AgoraOption":_vm.AgoraOption,"infor_call":_vm.infor_call,"tokenuser":_vm.token},on:{"decline_call":_vm.decline_call,"closeAgoraDialog":_vm.closeAgoraDialog}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":""},model:{value:(_vm.dialogMap),callback:function ($$v) {_vm.dialogMap=$$v},expression:"dialogMap"}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[(_vm.locationName.file_name != '')?_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v(" 🚩  "+_vm._s(_vm.locationName.file_name)+" ")]):_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v(" 🚩  somewhere ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":function($event){_vm.dialogMap = false}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('gmap-map',{staticStyle:{"width":"100%","height":"calc(100vh - 64px)"},attrs:{"center":_vm.center_markermap,"zoom":15}},[_c('gmap-marker',{attrs:{"position":_vm.center_markermap}})],1)],1),_vm._v(" "),_c('DialogGetpassword',{attrs:{"dialogGetPassword":_vm.dialogGetPassword,"DetailFile":_vm.DetailFile},on:{"closeDialogpassword":_vm.closeDialogpassword}})],1)}
var CenterSide_staticRenderFns = []
var CenterSide_esExports = { render: CenterSide_render, staticRenderFns: CenterSide_staticRenderFns }
/* harmony default export */ var layout_CenterSide = (CenterSide_esExports);
// CONCATENATED MODULE: ./src/components/chat/layout/CenterSide.vue
function CenterSide_injectStyle (ssrContext) {
  __webpack_require__("Mstj")
}
var CenterSide_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CenterSide___vue_template_functional__ = false
/* styles */
var CenterSide___vue_styles__ = CenterSide_injectStyle
/* scopeId */
var CenterSide___vue_scopeId__ = "data-v-85021f40"
/* moduleIdentifier (server only) */
var CenterSide___vue_module_identifier__ = null
var CenterSide_Component = CenterSide_normalizeComponent(
  CenterSide["a" /* default */],
  layout_CenterSide,
  CenterSide___vue_template_functional__,
  CenterSide___vue_styles__,
  CenterSide___vue_scopeId__,
  CenterSide___vue_module_identifier__
)

/* harmony default export */ var chat_layout_CenterSide = (CenterSide_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_group/InviteGroupDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState } from 'vuex'


/* harmony default export */ var InviteGroupDialog = ({
  props: { dialogInvite: false, member: '', memberpending: '', group_id: '' },
  data: function data() {
    return {
      FriendList: [],
      token: '',
      selected: [],
      progress: false,
      businessidinvite: [],
      listmemberinvite: [],
      tokeninvite: []
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },

  computed: {},
  watch: {
    dialogInvite: function dialogInvite() {
      if (this.dialogInvite) {
        this.getlist();
      }
    }
  },
  methods: {
    Close: function Close() {
      this.$emit('closeInvite', false);
      this.selected = [];
    },
    getlist: function getlist() {
      var _this = this;

      var _ = __webpack_require__("M4fF");
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-friend', { tokenuser: this.token }).then(function (response) {
        _this.FriendList = response.data['list_friend'];
        _this.FriendList = _.differenceBy(_this.FriendList, _this.member, 'tokenuser');
        _this.FriendList = _.differenceBy(_this.FriendList, _this.memberpending, 'tokenuser');
      });
    },
    invitefriends: function invitefriends() {
      var _this2 = this;

      this.progress = true;
      // console.log(this.listmemberinvite)
      // process.env.APIgo_api + '/v1/invite-group'
      // process.env.APImanage + '/invitemembergroup'
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/invite-group', { group_id: this.group_id, tokenuser: this.token, listmember: this.selected }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          _this2.progress = false;
          _this2.$swal('', _this2.$t('Alert.Success.inviteFriendGroup'), 'success');
          _this2.$emit('invitemembergroup');
          _this2.Close();
        } else {
          _this2.progress = false;
          _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
          _this2.Close();
        }
      }, function () {
        _this2.progress = false;
        _this2.$swal('Network error', _this2.$t('Alert.Fail.default.networkError'), 'error');
        _this2.Close();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fafa3c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_group/InviteGroupDialog.vue
var InviteGroupDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"500px"},model:{value:(_vm.dialogInvite),callback:function ($$v) {_vm.dialogInvite=$$v},expression:"dialogInvite"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("person_add")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.group.headerInvite')))],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.Close}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"300px","background-color":"white"}},[(!_vm.progress)?_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"CSChatThai",attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-select',{attrs:{"label":_vm.$t('Dialog.group.chooseFriend'),"items":_vm.FriendList,"item-text":"name","item-value":"tokenuser","multiple":"","chips":"","max-height":"55vh","autocomplete":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi CSChatThai",attrs:{"close":"","selected":data.selected},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_c('v-avatar',[(data.item.profilepicture)?_c('img',{attrs:{"src":data.item.profilepicture}}):(data.item.type === 'company')?_c('img',{attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'government')?_c('img',{attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'bot')?_c('img',{attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v("\n                    "+_vm._s(data.item.name)+"\n                  ")],1)]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-avatar',[(data.item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":data.item.profilepicture}}):(data.item.type === 'company')?_c('img',{attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'government')?_c('img',{attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'bot')?_c('img',{attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(data.item.name)}})],1)]]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1):_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":_vm.progress}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"CSChatThai",staticStyle:{"text-transform":"none"},attrs:{"color":"red darken-1","flat":""},on:{"click":function($event){_vm.Close()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"CSChatThai",staticStyle:{"text-transform":"none"},attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.invitefriends()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1)}
var InviteGroupDialog_staticRenderFns = []
var InviteGroupDialog_esExports = { render: InviteGroupDialog_render, staticRenderFns: InviteGroupDialog_staticRenderFns }
/* harmony default export */ var manage_group_InviteGroupDialog = (InviteGroupDialog_esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_group/InviteGroupDialog.vue
function InviteGroupDialog_injectStyle (ssrContext) {
  __webpack_require__("eMjO")
}
var InviteGroupDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var InviteGroupDialog___vue_template_functional__ = false
/* styles */
var InviteGroupDialog___vue_styles__ = InviteGroupDialog_injectStyle
/* scopeId */
var InviteGroupDialog___vue_scopeId__ = "data-v-2fafa3c6"
/* moduleIdentifier (server only) */
var InviteGroupDialog___vue_module_identifier__ = null
var InviteGroupDialog_Component = InviteGroupDialog_normalizeComponent(
  InviteGroupDialog,
  manage_group_InviteGroupDialog,
  InviteGroupDialog___vue_template_functional__,
  InviteGroupDialog___vue_styles__,
  InviteGroupDialog___vue_scopeId__,
  InviteGroupDialog___vue_module_identifier__
)

/* harmony default export */ var dialog_manage_group_InviteGroupDialog = (InviteGroupDialog_Component.exports);

// EXTERNAL MODULE: ./node_modules/@xkeshi/vue-qrcode/dist/vue-qrcode.esm.js
var vue_qrcode_esm = __webpack_require__("8Vd+");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_group/ShowQRCodeGroupDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



vue_esm["default"].component(vue_qrcode_esm["a" /* default */].name, vue_qrcode_esm["a" /* default */]);

/* harmony default export */ var ShowQRCodeGroupDialog = ({
  props: { 'dialogShowQRCode': false, detail: {} },
  data: function data() {
    return {
      tokenuserQR: ''
    };
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeShowQRCodeGroup', false);
    },
    loadqr: function loadqr() {
      var cnvs = document.getElementById('downloadqrgroup');
      var button = document.getElementById('btn-download');
      var dataURL = cnvs.toDataURL('image/png');
      // console.log(cnvs)
      button.href = dataURL;
    }
  },

  computed: {},
  watch: {
    detail: function detail() {
      // console.log(this.detail.group_id)
      // this.tokenuserQR = 'https://com.oneplatform.android.onechat.group/u/' + btoa(this.detail.group_id)
      this.tokenuserQR = "https://uatchat.one.th" + '/qrcode/group?id=' + btoa(this.detail.group_id);
      // console.log(this.tokenuserQR)
      // var token = Decode.decodeToken(this.$cookie.get('tokenuser'))
      // this.tokenuserQR = process.env.APIQRcode + '/qrcode/friend?id=' + btoa(token)
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-042286d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_group/ShowQRCodeGroupDialog.vue
var ShowQRCodeGroupDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialogShowQRCode),callback:function ($$v) {_vm.dialogShowQRCode=$$v},expression:"dialogShowQRCode"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai",staticStyle:{"white-space":"nowrap","width":"100%","overflow":"hidden","text-overflow":"ellipsis"}},[_c('span',{staticClass:"headline CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("group")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.group.group'))+" "+_vm._s(_vm.detail.group_name)+"\n          ")],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',[_c('p',{staticStyle:{"text-align":"center"}},[_c('qrcode',{staticStyle:{"margin":"0 !important","height":"220px","width":"220px","padding":"5px","border":"3px solid","border-radius":"10px"},attrs:{"value":_vm.tokenuserQR,"id":"downloadqrgroup"}})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('Dialog.group.detailQrcode'))+"\n                      "),_c('a',{staticClass:"button",attrs:{"href":"#","id":"btn-download","download":'qrcode_group_' + _vm.detail.group_name + '.png'},on:{"click":function($event){_vm.loadqr()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.download')))])])])])],1)],1)],1)],1)],1)}
var ShowQRCodeGroupDialog_staticRenderFns = []
var ShowQRCodeGroupDialog_esExports = { render: ShowQRCodeGroupDialog_render, staticRenderFns: ShowQRCodeGroupDialog_staticRenderFns }
/* harmony default export */ var manage_group_ShowQRCodeGroupDialog = (ShowQRCodeGroupDialog_esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_group/ShowQRCodeGroupDialog.vue
function ShowQRCodeGroupDialog_injectStyle (ssrContext) {
  __webpack_require__("9ZMR")
}
var ShowQRCodeGroupDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ShowQRCodeGroupDialog___vue_template_functional__ = false
/* styles */
var ShowQRCodeGroupDialog___vue_styles__ = ShowQRCodeGroupDialog_injectStyle
/* scopeId */
var ShowQRCodeGroupDialog___vue_scopeId__ = "data-v-042286d6"
/* moduleIdentifier (server only) */
var ShowQRCodeGroupDialog___vue_module_identifier__ = null
var ShowQRCodeGroupDialog_Component = ShowQRCodeGroupDialog_normalizeComponent(
  ShowQRCodeGroupDialog,
  manage_group_ShowQRCodeGroupDialog,
  ShowQRCodeGroupDialog___vue_template_functional__,
  ShowQRCodeGroupDialog___vue_styles__,
  ShowQRCodeGroupDialog___vue_scopeId__,
  ShowQRCodeGroupDialog___vue_module_identifier__
)

/* harmony default export */ var dialog_manage_group_ShowQRCodeGroupDialog = (ShowQRCodeGroupDialog_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_group/ManageGroupDialog.vue
var ManageGroupDialog = __webpack_require__("mQQs");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-398cf32f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_group/ManageGroupDialog.vue
var ManageGroupDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialogManageGroup),callback:function ($$v) {_vm.dialogManageGroup=$$v},expression:"dialogManageGroup"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-users")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.group.headerSetting')))],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeManageGroup}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"350px"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"sm12":"","md12":""}},[(_vm.detail.statemember == 'active')?_c('v-badge',{staticStyle:{"height":"22vh !important"},attrs:{"color":"orange darken-1","overlap":"","bottom":""}},[_c('v-icon',{staticStyle:{"font-size":"8px !important","cursor":"pointer"},attrs:{"slot":"badge","dark":"","small":""},on:{"click":_vm.uppic},slot:"badge"},[_vm._v("\n                  add_a_photo\n                ")]),_vm._v(" "),_c('v-avatar',{staticStyle:{"margin-top":"3vh","border":"2px #1a222c !important","border-style":"solid !important"},attrs:{"size":"20vh"}},[(_vm.detail.picture == '')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border":"2px #1a222c !important","border-style":"solid !important","cursor":"pointer"},attrs:{"src":"/static/img/default_profile/group-white.png"},on:{"click":_vm.uppic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"border":"2px #1a222c !important","border-style":"solid !important","cursor":"pointer"},attrs:{"src":_vm.detail.picture},on:{"click":_vm.uppic}}),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('input',{staticClass:"CSChatThai",attrs:{"type":"file","name":"file1","accept":"image/*","id":"uploadpicturegroup"},on:{"change":_vm.previewImagegroup}})])])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticStyle:{"justify-content":"center","margin-top":"2vh"},attrs:{"xs12":"","sm12":"","md12":""}},[(!_vm.edit)?_c('div',{staticClass:"CSChatThai",staticStyle:{"width":"100%"}},[_vm._v("\n                    "+_vm._s(_vm.$t('Dialog.group.groupName'))+" :   \n                    "),_c('div',{staticClass:"groupnameEdit",on:{"click":function($event){_vm.editprofile()}}},[_vm._v("  "+_vm._s(_vm.detail.group_name)+"\n                      "),_c('div',{staticClass:"messageedit",staticStyle:{"color":"#757575","font-size":"13px !important","cursor":"pointer","float":"right"}},[_c('v-icon',{staticStyle:{"font-size":"10px","color":"#757575"}},[_vm._v("settings")]),_vm._v(" "),_vm._v("\n                      "+_vm._s(_vm.$t('AnswerQuestion.edit'))+"\n                    ")],1)])]):_c('div',{staticClass:"CSChatThai",staticStyle:{"width":"100%"}},[_vm._v("\n                    "+_vm._s(_vm.$t('Dialog.group.groupName'))+" :   \n                      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nameedit),expression:"nameedit"}],staticClass:"CSChatThai",staticStyle:{"width":"100%"},attrs:{"type":"texteditgroup","placeholder":_vm.$t('Dialog.group.groupName')},domProps:{"value":(_vm.nameedit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nameedit=$event.target.value}}}),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('v-btn',{staticStyle:{"width":"19%","text-transform":"none"},attrs:{"dark":"","color":"blue darken-1"},on:{"click":function($event){_vm.changeprofile()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.update')))]),_vm._v(" "),_c('v-btn',{staticStyle:{"width":"19%","background-color":"#607d8b","text-transform":"none"},attrs:{"dark":""},on:{"click":function($event){_vm.editprofile()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1)])])],1)],1)],1)],1)],1)}
var ManageGroupDialog_staticRenderFns = []
var ManageGroupDialog_esExports = { render: ManageGroupDialog_render, staticRenderFns: ManageGroupDialog_staticRenderFns }
/* harmony default export */ var manage_group_ManageGroupDialog = (ManageGroupDialog_esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_group/ManageGroupDialog.vue
function ManageGroupDialog_injectStyle (ssrContext) {
  __webpack_require__("WC/7")
}
var ManageGroupDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ManageGroupDialog___vue_template_functional__ = false
/* styles */
var ManageGroupDialog___vue_styles__ = ManageGroupDialog_injectStyle
/* scopeId */
var ManageGroupDialog___vue_scopeId__ = "data-v-398cf32f"
/* moduleIdentifier (server only) */
var ManageGroupDialog___vue_module_identifier__ = null
var ManageGroupDialog_Component = ManageGroupDialog_normalizeComponent(
  ManageGroupDialog["a" /* default */],
  manage_group_ManageGroupDialog,
  ManageGroupDialog___vue_template_functional__,
  ManageGroupDialog___vue_styles__,
  ManageGroupDialog___vue_scopeId__,
  ManageGroupDialog___vue_module_identifier__
)

/* harmony default export */ var dialog_manage_group_ManageGroupDialog = (ManageGroupDialog_Component.exports);

// EXTERNAL MODULE: ./src/components/chat/dialog/notes/NoteDialog.vue + 2 modules
var NoteDialog = __webpack_require__("0j5f");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/notes/CreateNoteDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { Momenttime } from '@/services'


/* harmony default export */ var CreateNoteDialog = ({
  props: { dialogCreatenote: false, tokenroom: '' },
  data: function data() {
    return {
      token: '',
      edittext: '',
      loading: false
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },

  methods: {
    closeDialog: function closeDialog() {
      this.edittext = '';
      this.$emit('closeCreatenote', false);
    },
    save: function save() {
      var _this = this;

      this.loading = true;
      if (/\S/.test(this.edittext)) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/createnote', { tokenuser: this.token, text: this.edittext, tokenroom: this.tokenroom }).then(function (response) {
          // console.log(response.data)
          if (response.data.status === 'success') {
            _this.loading = false;
            _this.$swal('', _this.$t('Alert.Success.createNote'), 'success');
            _this.$emit('CreateNote', 'success', response.data.create_date, response.data.note_id, response.data.tokenroom, response.data.update_date, _this.edittext);
            _this.closeDialog();
          } else {
            _this.$swal('', _this.$t('Alert.Fail.default.somethingWrong'), 'error');
          }
        }, function () {
          _this.loading = false;
          _this.$swal('', _this.$t('Alert.Fail.default.somethingWrong'), 'error');
        });
      }
    }
  },
  watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-925dfd84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/notes/CreateNoteDialog.vue
var CreateNoteDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"persistent":"","max-width":"500px","max-height":"500px"},model:{value:(_vm.dialogCreatenote),callback:function ($$v) {_vm.dialogCreatenote=$$v},expression:"dialogCreatenote"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-sticky-note")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.note.headerCreate')))],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"25px","padding-right":"25px"}},[_c('div',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"200px","min-height":"100px","margin-top":"10px"}},[_c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.edittext),expression:"edittext"}],staticStyle:{"width":"100%","height":"190px","background":"#1a222b12","padding":"20px","resize":"none","border-radius":"15px"},domProps:{"value":(_vm.edittext)},on:{"input":function($event){if($event.target.composing){ return; }_vm.edittext=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[_c('v-btn',{staticClass:"btncancel CSChatThai",attrs:{"dark":""},on:{"click":_vm.closeDialog}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n        ")]),_vm._v(" "),(/\S/.test(_vm.edittext))?_c('v-btn',{staticClass:"btnallow CSChatThai",attrs:{"dark":"","loading":_vm.loading},on:{"click":_vm.save}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n        ")]):_c('v-btn',{staticClass:"btnallow CSChatThai",attrs:{"disabled":""}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n        ")])],1)])],1)],1)}
var CreateNoteDialog_staticRenderFns = []
var CreateNoteDialog_esExports = { render: CreateNoteDialog_render, staticRenderFns: CreateNoteDialog_staticRenderFns }
/* harmony default export */ var notes_CreateNoteDialog = (CreateNoteDialog_esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/notes/CreateNoteDialog.vue
function CreateNoteDialog_injectStyle (ssrContext) {
  __webpack_require__("INn0")
}
var CreateNoteDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateNoteDialog___vue_template_functional__ = false
/* styles */
var CreateNoteDialog___vue_styles__ = CreateNoteDialog_injectStyle
/* scopeId */
var CreateNoteDialog___vue_scopeId__ = "data-v-925dfd84"
/* moduleIdentifier (server only) */
var CreateNoteDialog___vue_module_identifier__ = null
var CreateNoteDialog_Component = CreateNoteDialog_normalizeComponent(
  CreateNoteDialog,
  notes_CreateNoteDialog,
  CreateNoteDialog___vue_template_functional__,
  CreateNoteDialog___vue_styles__,
  CreateNoteDialog___vue_scopeId__,
  CreateNoteDialog___vue_module_identifier__
)

/* harmony default export */ var dialog_notes_CreateNoteDialog = (CreateNoteDialog_Component.exports);

// EXTERNAL MODULE: ./src/components/chat/dialog/albums/AlbumsDialog.vue + 1 modules
var AlbumsDialog = __webpack_require__("xh2Q");

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/albums/CreateAlbumsDialog.vue
var CreateAlbumsDialog = __webpack_require__("W4Xu");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-356f024a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/albums/CreateAlbumsDialog.vue
var CreateAlbumsDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"persistent":"","max-width":"500px","max-height":"500px"},model:{value:(_vm.dialogCreatealbums),callback:function ($$v) {_vm.dialogCreatealbums=$$v},expression:"dialogCreatealbums"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-images")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.album.headerCreate'))+"\n        ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"30px"}},[_c('div',{staticStyle:{"height":"275px","overflow-y":"hidden","margin-top":"10px"}},[_c('div',{},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.albumsname),expression:"albumsname"}],staticClass:"CSChatThai inputnamealbum",attrs:{"type":"text","placeholder":_vm.$t('Dialog.album.nameAlbum')},domProps:{"value":(_vm.albumsname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.albumsname=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('form',{ref:"fileform"},[_c('v-flex',{staticClass:"containers hidden-sm-and-down listfile",attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_vm._l((_vm.files),function(file,key){return (key < 5)?_c('div',{staticClass:"borderfile",staticStyle:{"justify-content":"center","margin-left":"10px"}},[_c('div',{staticStyle:{"text-align":"right","padding-right":"10px"}},[_c('a',{staticClass:"close-classic",on:{"click":function($event){_vm.removeFile( key )}}})]),_vm._v(" "),(_vm.extension(file.file.name) == 'fas fa-file-image')?_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center","padding-left":"10px","padding-right":"10px"}},[_c('img',{ref:'preview' + parseInt( key ),refInFor:true,staticClass:"preview",staticStyle:{"height":"60px !important","width":"60px !important","display":"flex","justify-content":"center"}})]):_vm._e()]):_vm._e()}),_vm._v(" "),(_vm.files.length < 5)?_c('div',{style:(_vm.borderinputfile),on:{"click":function($event){_vm.uppic()}}},[_c('v-icon',{staticStyle:{"color":"#757575"}},[_vm._v("mdi-plus")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#757575"}},[_vm._v("\n                    "+_vm._s(_vm.$t('AnswerQuestion.uploadPhoto'))+"\n                  ")]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"files","multiple":"","accept":".png, .jpg, .jpeg, .gif, .bmp, .wbmp"},on:{"change":function($event){_vm.handleFilesUpload()}}})],1):_vm._e()],2)],1)])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"btncancle",attrs:{"dark":""},on:{"click":_vm.closeDialog}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n        ")]),_vm._v(" "),(_vm.files.length > 0 && _vm.albumsname)?_c('v-btn',{staticClass:"btncreate",attrs:{"dark":"","loading":_vm.loading},on:{"click":function($event){_vm.createalbums()}}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n        ")]):_c('v-btn',{staticClass:"btncreate",attrs:{"disabled":""}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n        ")])],1)],1)],1)],1)}
var CreateAlbumsDialog_staticRenderFns = []
var CreateAlbumsDialog_esExports = { render: CreateAlbumsDialog_render, staticRenderFns: CreateAlbumsDialog_staticRenderFns }
/* harmony default export */ var albums_CreateAlbumsDialog = (CreateAlbumsDialog_esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/albums/CreateAlbumsDialog.vue
function CreateAlbumsDialog_injectStyle (ssrContext) {
  __webpack_require__("in91")
}
var CreateAlbumsDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateAlbumsDialog___vue_template_functional__ = false
/* styles */
var CreateAlbumsDialog___vue_styles__ = CreateAlbumsDialog_injectStyle
/* scopeId */
var CreateAlbumsDialog___vue_scopeId__ = "data-v-356f024a"
/* moduleIdentifier (server only) */
var CreateAlbumsDialog___vue_module_identifier__ = null
var CreateAlbumsDialog_Component = CreateAlbumsDialog_normalizeComponent(
  CreateAlbumsDialog["a" /* default */],
  albums_CreateAlbumsDialog,
  CreateAlbumsDialog___vue_template_functional__,
  CreateAlbumsDialog___vue_styles__,
  CreateAlbumsDialog___vue_scopeId__,
  CreateAlbumsDialog___vue_module_identifier__
)

/* harmony default export */ var dialog_albums_CreateAlbumsDialog = (CreateAlbumsDialog_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/layout/RightMenuSide.vue
var RightMenuSide = __webpack_require__("BzMx");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-413b69ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/layout/RightMenuSide.vue
var RightMenuSide_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"headerUser",staticStyle:{"z-index":"8 !important"},attrs:{"id":"headerMenubarUser"}},[_c('nav',{staticClass:"headerUser__nav"},[_c('ul',{staticClass:"headerUser__navbar"},[_c('li',{staticClass:"headerUser__item"},[_c('a',{staticClass:"headerUser__link"},[_c('button',{key:"off",staticClass:"headerUser--btn",on:{"click":function($event){_vm.show = !_vm.show}}},[_c('v-icon',{staticClass:"headerUser--icon"},[_vm._v("more_vert")])],1)]),_vm._v(" "),(_vm.detail.statemember == 'active' && _vm.detail.type=='user')?_c('transition',{attrs:{"name":"dropdown"}},[(_vm.show)?_c('div',{staticClass:"headerUser__dropdown-menu",class:{ active: _vm.show }},[_c('ul',{staticClass:"headerUser__dropdown-menu-nav"},[_c('li',{staticClass:"headerUser__dropdown-menu-item",on:{"click":function($event){_vm.opentask()}}},[_c('a',{staticClass:"headerUser__dropdown-menu-link"},[_c('div',{staticClass:"headerUser__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"meduim":""}},[_vm._v("fas fa-tasks")])],1),_vm._v(" "),_c('div',{staticClass:"headerUser__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.project'))+"\n                    ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('li',{staticClass:"headerUser__dropdown-menu-item",on:{"click":function($event){_vm.openalbum()}}},[_c('a',{staticClass:"headerUser__dropdown-menu-link"},[_c('div',{staticClass:"headerUser__dropdown-menu-svg"},[_c('v-icon',{staticClass:"headerUser--icon--menu",attrs:{"meduim":""}},[_vm._v("fas fa-images")])],1),_vm._v(" "),_c('div',{staticClass:"headerUser__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.album'))+"\n                    ")])])]),_vm._v(" "),_c('li',{staticClass:"headerUser__dropdown-menu-item",on:{"click":function($event){_vm.opennotes()}}},[_c('a',{staticClass:"headerUser__dropdown-menu-link"},[_c('div',{staticClass:"headerUser__dropdown-menu-svg"},[_c('v-icon',{staticClass:"headerUser--icon--menu",attrs:{"meduim":""}},[_vm._v("fas fa-sticky-note")])],1),_vm._v(" "),_c('div',{staticClass:"headerUser__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.note'))+"\n                    ")])])]),_vm._v(" "),_c('li',{staticClass:"headerUser__dropdown-menu-item",on:{"click":function($event){_vm.clearchat()}}},[_c('a',{staticClass:"headerUser__dropdown-menu-link"},[_c('div',{staticClass:"headerUser__dropdown-menu-svg"},[_c('v-icon',{staticClass:"headerUser--icon--menu",attrs:{"meduim":""}},[_vm._v("fas fa-trash")])],1),_vm._v(" "),_c('div',{staticClass:"headerUser__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.clearChat'))+"\n                    ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('li',{staticClass:"headerUser__dropdown-menu-item",on:{"click":function($event){_vm.openwallpaper()}}},[_c('a',{staticClass:"headerUser__dropdown-menu-link"},[_c('div',{staticClass:"headerUser__dropdown-menu-svg"},[_c('v-icon',{staticClass:"headerUser--icon--menu",attrs:{"meduim":""}},[_vm._v("fas fa-images")])],1),_vm._v(" "),_c('div',{staticClass:"headerUser__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.setwall'))+"\n                    ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('li',{staticClass:"headerUser__dropdown-menu-item",on:{"click":function($event){_vm.blockfriend(_vm.detail.data_room[0].tokenuser,_vm.detail.data_room[0].name)}}},[_c('a',{staticClass:"headerUser__dropdown-menu-link"},[_c('div',{staticClass:"headerUser__dropdown-menu-svg"},[_c('v-icon',{staticClass:"headerUser--icon--menu",attrs:{"meduim":""}},[_vm._v("mdi-block-helper")])],1),_vm._v(" "),_c('div',{staticClass:"headerUser__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.block'))+"\n                    ")])])])])]):_vm._e()]):(_vm.detail.statemember == 'active' && _vm.detail.type=='group')?_c('transition',{attrs:{"name":"dropdown"}},[(_vm.show)?_c('div',{staticClass:"header__dropdown-menu",class:{ active: _vm.show }},[_c('ul',{staticClass:"header__dropdown-menu-nav"},[_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.openQRcode()}}},[_c('a',{staticClass:"header__dropdown-menu-link"},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"meduim":""}},[_vm._v("mdi-qrcode")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.qrCode'))+"\n                    ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.opentask()}}},[_c('a',{staticClass:"header__dropdown-menu-link"},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"meduim":""}},[_vm._v("fas fa-tasks")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.project'))+"\n                     ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.openalbum()}}},[_c('a',{staticClass:"header__dropdown-menu-link"},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"meduim":""}},[_vm._v("fas fa-images")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.album'))+"\n                    ")])])]),_vm._v(" "),_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.opennotes()}}},[_c('a',{staticClass:"header__dropdown-menu-link"},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"meduim":""}},[_vm._v("fas fa-sticky-note")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.note'))+"\n                    ")])])]),_vm._v(" "),_vm._l((_vm.listMenu),function(item,index){return _c('li',{key:index,staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.ShowDialog(item.dialog)}}},[_c('a',{staticClass:"header__dropdown-menu-link"},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"meduim":""}},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(item.title)+"\n                    ")])])])}),_vm._v(" "),_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.clearchat()}}},[_c('a',{staticClass:"header__dropdown-menu-link"},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"meduim":""}},[_vm._v("fas fa-trash")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.clearChat'))+"\n                    ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.openwallpaper()}}},[_c('a',{staticClass:"header__dropdown-menu-link"},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"meduim":""}},[_vm._v("fas fa-images")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.setwall'))+"\n                    ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.leavegroup()}}},[_c('a',{staticClass:"header__dropdown-menu-link"},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"meduim":""}},[_vm._v("call_missed_outgoing")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.leave'))+"\n                    ")])])])],2)]):_vm._e()]):_c('transition',{attrs:{"name":"dropdown"}},[(_vm.show)?_c('div',{staticClass:"headerOut__dropdown-menu",class:{ active: _vm.show }},[_c('ul',{staticClass:"headerOut__dropdown-menu-nav"},[_c('li',{staticClass:"headerOut__dropdown-menu-item",on:{"click":function($event){_vm.clearchat()}}},[_c('a',{staticClass:"headerOut__dropdown-menu-link"},[_c('div',{staticClass:"headerOut__dropdown-menu-svg"},[_c('v-icon',{staticClass:"headerOut--icon--menu",attrs:{"meduim":""}},[_vm._v("fas fa-trash")])],1),_vm._v(" "),_c('div',{staticClass:"headerOut__dropdown-menu-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('RightSide.menu.clearChat'))+"\n                    ")])])]),_vm._v(" "),(_vm.detail.statemember == 'block')?_c('hr'):_vm._e(),_vm._v(" "),(_vm.detail.statemember == 'block')?_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.unBlock(_vm.detail.data_room[0])}}},[_c('a',{staticClass:"header__dropdown-menu-link"},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu",attrs:{"meduim":""}},[_vm._v("mdi-lock-open")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                     "+_vm._s(_vm.$t('RightSide.menu.unblock'))+"\n                   ")])])]):_vm._e()])]):_vm._e()])],1)])])])])}
var RightMenuSide_staticRenderFns = []
var RightMenuSide_esExports = { render: RightMenuSide_render, staticRenderFns: RightMenuSide_staticRenderFns }
/* harmony default export */ var layout_RightMenuSide = (RightMenuSide_esExports);
// CONCATENATED MODULE: ./src/components/chat/layout/RightMenuSide.vue
function RightMenuSide_injectStyle (ssrContext) {
  __webpack_require__("glUL")
}
var RightMenuSide_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RightMenuSide___vue_template_functional__ = false
/* styles */
var RightMenuSide___vue_styles__ = RightMenuSide_injectStyle
/* scopeId */
var RightMenuSide___vue_scopeId__ = "data-v-413b69ba"
/* moduleIdentifier (server only) */
var RightMenuSide___vue_module_identifier__ = null
var RightMenuSide_Component = RightMenuSide_normalizeComponent(
  RightMenuSide["a" /* default */],
  layout_RightMenuSide,
  RightMenuSide___vue_template_functional__,
  RightMenuSide___vue_styles__,
  RightMenuSide___vue_scopeId__,
  RightMenuSide___vue_module_identifier__
)

/* harmony default export */ var chat_layout_RightMenuSide = (RightMenuSide_Component.exports);

// EXTERNAL MODULE: ./src/components/chat/dialog/ShowImageDialog.vue + 2 modules
var ShowImageDialog = __webpack_require__("fIB/");

// EXTERNAL MODULE: ./src/components/chat/dialog/ShowImage_ProfileDialog.vue + 2 modules
var ShowImage_ProfileDialog = __webpack_require__("sVBg");

// EXTERNAL MODULE: ./src/components/chat/dialog/settings/Openwebsite.vue + 2 modules
var Openwebsite = __webpack_require__("gDCn");

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/wallpaper/wallpaper_dialog.vue
var wallpaper_dialog = __webpack_require__("JOQw");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac479c82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/wallpaper/wallpaper_dialog.vue
var wallpaper_dialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden","border-radius":"20px !important"},attrs:{"max-width":"500px","persistent":"","max-height":"550px"},model:{value:(_vm.dialogwallpaper),callback:function ($$v) {_vm.dialogwallpaper=$$v},expression:"dialogwallpaper"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-images")]),_vm._v("  \n            "),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t('Dialog.wallpaper.headerWallpaper')))])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"550px !important","overflow-y":"hidden"}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('vue-avatar',{ref:"vueavatar",staticStyle:{"border":"solid thin #eee","height":"300px","margin-bottom":"10px","background-image":"url(https://image.flaticon.com/icons/png/512/1250/1250734.png)","background-size":"100px, 100px, cover","background-position":"center"},attrs:{"image":_vm.imageData,"width":450,"height":450,"rotation":_vm.rotation,"scale":_vm.scale,"border":0},on:{"vue-avatar-editor:image-ready":_vm.onImageReady}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-slider',{attrs:{"label":"Zoom :","min":"1","max":"3","step":"0.02","thumb-label":"always","ticks":""},model:{value:(_vm.scale),callback:function ($$v) {_vm.scale=$$v},expression:"scale"}}),_vm._v(" "),_c('v-slider',{attrs:{"label":"Rotation :","min":"0","max":"360","step":"1","thumb-label":"always","ticks":""},model:{value:(_vm.rotation),callback:function ($$v) {_vm.rotation=$$v},expression:"rotation"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":"","align-center":""}},[_c('v-btn',{staticClass:"btnwallpaper",attrs:{"disabled":!_vm.check},on:{"click":function($event){_vm.saveClicked()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.setbackground')))]),_vm._v(" "),_c('v-btn',{staticClass:"btnresetwallpaper",on:{"click":function($event){_vm.resetbg()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.resetbackground')))])],1)],1)],1)],1)}
var wallpaper_dialog_staticRenderFns = []
var wallpaper_dialog_esExports = { render: wallpaper_dialog_render, staticRenderFns: wallpaper_dialog_staticRenderFns }
/* harmony default export */ var wallpaper_wallpaper_dialog = (wallpaper_dialog_esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/wallpaper/wallpaper_dialog.vue
function wallpaper_dialog_injectStyle (ssrContext) {
  __webpack_require__("0xXd")
}
var wallpaper_dialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var wallpaper_dialog___vue_template_functional__ = false
/* styles */
var wallpaper_dialog___vue_styles__ = wallpaper_dialog_injectStyle
/* scopeId */
var wallpaper_dialog___vue_scopeId__ = "data-v-ac479c82"
/* moduleIdentifier (server only) */
var wallpaper_dialog___vue_module_identifier__ = null
var wallpaper_dialog_Component = wallpaper_dialog_normalizeComponent(
  wallpaper_dialog["a" /* default */],
  wallpaper_wallpaper_dialog,
  wallpaper_dialog___vue_template_functional__,
  wallpaper_dialog___vue_styles__,
  wallpaper_dialog___vue_scopeId__,
  wallpaper_dialog___vue_module_identifier__
)

/* harmony default export */ var dialog_wallpaper_wallpaper_dialog = (wallpaper_dialog_Component.exports);

// EXTERNAL MODULE: ./src/components/chat/dialog/saveonebox/SaveoneboxDialog.vue + 2 modules
var SaveoneboxDialog = __webpack_require__("rTZ8");

// EXTERNAL MODULE: ./src/components/chat/dialog/CheckBrowserDialog.vue + 2 modules
var CheckBrowserDialog = __webpack_require__("Se0g");

// CONCATENATED MODULE: ./src/components/chat/gallery-slideshow.vue
var gallery_slideshow_normalizeComponent = __webpack_require__("VU/8")
/* script */
var gallery_slideshow___vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var gallery_slideshow___vue_template_functional__ = false
/* styles */
var gallery_slideshow___vue_styles__ = null
/* scopeId */
var gallery_slideshow___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var gallery_slideshow___vue_module_identifier__ = null
var gallery_slideshow_Component = gallery_slideshow_normalizeComponent(
  gallery_slideshow___vue_script__,
  __vue_template__,
  gallery_slideshow___vue_template_functional__,
  gallery_slideshow___vue_styles__,
  gallery_slideshow___vue_scopeId__,
  gallery_slideshow___vue_module_identifier__
)

/* harmony default export */ var gallery_slideshow = (gallery_slideshow_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/layout/RightSide.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















// import DetailFriend from '@/components/chat/DetailFriend'
// import VueGallerySlideshow from 'vue-gallery-slideshow'

var RightSide__ = __webpack_require__("M4fF");
// import '/static/style/menu.scss'

/* harmony default export */ var RightSide = ({
  data: function data() {
    return {
      checkBrowserInfor: {},
      checkBrowserDialog: false,
      dataConsent: '',
      isAccept: false,
      checkconsentDialog: false,
      url_consent: '',
      share_token: '',
      Bot_idcovid: "Bbe2c9fe1bcc956738a61c9ad0d91cb19",
      images: [],
      index: null,
      dialogshowimage: false,
      dialogshowimage_profile: false,
      dialogAlbums: false,
      dialogCreatealbums: false,
      progressNote: false,
      detail: {},
      showmorefile: false,
      showmoreimage: false,
      showmorealbums: false,
      dialogNote: false,
      dialogManageGroup: false,
      note_id: '',
      albums_id: '',
      friend: '',
      token: '',
      // noti: false,
      members: {},
      membersGroup: {},
      member: [],
      memberpending: [],
      dialogInvite: false,
      dialogShowQRCode: false,
      LeaveGroup: false,
      SetpicGroup: false,
      edit: false,
      room: '',
      activeinfo: 'tab-1',
      // DetailFriend: '',
      relation: '',
      tokenMember: [],
      tokenMemberpending: [],
      listimageinroom: [],
      listfileinroom: [],
      listnote: [],
      selectFile: '',
      dateSend: '',
      timeSend: '',
      nicknameSend: '',
      filenameSend: '',
      tokenmsgSend: '',
      pathSend: '',
      picSend: '',
      name: '',
      typeuser: '',
      shownotes: false,
      dialogCreatenote: false,
      dialogopenwebsite: false,
      dialogSaveOnebox: false,
      id: '',
      type: '',
      showalbum: false,
      listalbum: [],
      filter_infoalbum: [],
      show: false,
      DetailImage: {},
      pathpicture: '',
      typepathpicture: '',
      dialogwallpaper: false,
      tokenmessage_savebox: '',
      // memberpending: [],
      memberactive: [],
      pagemember: 0,
      pagepending: 0,
      limit: 10,
      oneid_user: '',
      oneid_friend: '',
      base_env: "uat"
    };
  },
  methods: {
    closeDialogConsent: function closeDialogConsent(value) {
      this.url_consent = '';
      this.checkconsentDialog = value;
    },
    delete_albums: function delete_albums(albumsid) {
      var _this = this;

      this.$swal({
        text: this.$t('Alert.Album.deleteAlbum'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this.axios.post("https://uatchat-manage.one.th/event" + '/delete_albums', {
            albums_id: albumsid,
            tokenuser: _this.token,
            tokenroom: _this.$route.params.roomid
          }).then(function (response) {
            if (response.data.status === 'success') {
              var index = RightSide__.findIndex(_this.listalbum, function (o) {
                return o._id == albumsid;
              });
              _this.listalbum.splice(index, 1);
            } else {
              _this.$swal('', _this.$t('Alert.Fail.default.somethingWrong'), 'error');
            }
          });
        }
      });
    },
    closeSaveOnebox: function closeSaveOnebox(value) {
      this.dialogSaveOnebox = value;
    },
    openPictureProfile: function openPictureProfile(picture, type) {
      this.pathpicture = picture;
      this.typepathpicture = type;
      this.dialogshowimage_profile = true;
    },
    openalbum: function openalbum(value) {
      this.showalbum = value;
    },
    openWallpaper: function openWallpaper(value) {
      // console.log(value)
      this.dialogwallpaper = value;
    },
    opennotes: function opennotes(value) {
      this.shownotes = value;
    },
    clearchat: function clearchat() {
      var _this2 = this;

      this.$swal({
        text: this.$t('Alert.Right.clearChat'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this2.chIsactive = _this2.$route.params.roomid;
        }
      });
    },
    openQRcode: function openQRcode(value) {
      this.dialogShowQRCode = value;
    },
    getOneIDUser: function getOneIDUser(tokenuser) {
      var _this3 = this;

      this.axios.get("https://uatchat-manage.one.th/go_api/api" + ('/v1/getOneID/' + tokenuser)).then(function (response) {
        if (response.data.status === 'success') {
          _this3.oneid_user = response.data.one_id;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getOneIDFriend: function getOneIDFriend(tokenuser) {
      var _this4 = this;

      this.axios.get("https://uatchat-manage.one.th/go_api/api" + ('/v1/getOneID/' + tokenuser)).then(function (response) {
        if (response.data.status === 'success') {
          _this4.oneid_friend = response.data.one_id;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    openCall_v2: function openCall_v2(typecall, detailroom) {
      console.log(typecall);
      var option_call = '';
      if (typecall === 'audio') {
        option_call = 'voice';
      } else {
        option_call = typecall;
      }
      var headers = { headers: { Authorization: 'Bearer Abe49824c8f7d5416a840541ded27fe67dc8aa755ef1a4c99a162513727b5d8c1fd327a9554ba4476b14514092c6635aa12' } };
      var body = { sender: this.oneid_user, to: this.oneid_friend, option: option_call };
      var infor_call = {
        picture: detailroom.data_room[0].profilepicture,
        nickname: detailroom.data_room[0].name,
        one_id: this.oneid_user,
        option: option_call
      };
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/gen-token-agora', body, headers).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          // console.log(response.data.agora_token)
          window.open('/chat/room/call/' + typecall + '/?token=' + services["b" /* Encode */].encodeToken(response.data.agora_token) + '&channel_name=' + services["b" /* Encode */].encodeToken(response.data.channel_name) + '&user_infor=' + services["b" /* Encode */].encode(infor_call), '_blank');
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    openCall: function openCall(typecall, detailroom) {
      var _this5 = this;

      // console.log(detailroom.type)
      var name = '';
      if (detailroom.type === 'group') {
        name = detailroom.group_name;
      }
      // this.axios.post(process.env.APIimage + '/push_conference', {
      //   tokenuser: this.token,
      //   tokenroom: detailroom.tokenroom,
      //   // room_name: name,
      //   type_call: typecall
      // }).then((response) => {
      //   // console.log(response.data)
      //   if (response.data['status'] === 'success') {
      //     window.open(response.data.data.information.urlroom)
      //   }
      // })
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/call-agora', {
        tokenuser: this.token,
        tokenroom: detailroom.tokenroom,
        // room_name: name,
        option: typecall
      }).then(function (response) {
        console.log(response.data);
        if (response.data['status'] === 'success') {
          // window.open('/chat/room/test/'+typecall +'/'+detailroom.tokenroom+'/?token=' + Encode.encodeToken(this.token) +'&channel_name=' +
          //   Encode.encodeToken(response.data.tokenmessage),'_blank')
          var url = '/chat/room/test/' + typecall + '/' + detailroom.tokenroom + '/?token=' + services["b" /* Encode */].encodeToken(response.data.token) + '&channel_name=' + services["b" /* Encode */].encodeToken(response.data.tokenmessage);
          _this5.checkBrowser(url);
        }
      });

      // localStorage.setItem('stateCall', 'true')
      // localStorage.setItem('detailroomCall', JSON.stringify(detailroom))
      // this.$router.push({
      //   path: '/video_call/' + typecall + '/' + this.room,
      //   force: true
      // })
      // this.$router.push({path: '/video_call/' + this.room, force: true})
    },
    closeCheckBrowser: function closeCheckBrowser(value) {
      this.checkBrowserDialog = value;
      this.checkBrowserInfor = {};
    },
    checkBrowser: function checkBrowser(url) {
      // console.log(url)
      // Get the user-agent string
      var userAgentString = navigator.userAgent;
      // Detect Chrome
      var chromeAgent = userAgentString.indexOf("Chrome") > -1;
      // Detect Internet Explorer
      var IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
      // Detect Firefox
      var firefoxAgent = userAgentString.indexOf("Firefox") > -1;
      // Detect Safari
      var safariAgent = userAgentString.indexOf("Safari") > -1;
      // Discard Safari since it also matches Chrome
      var operaAgent = userAgentString.indexOf("OP") > -1;
      // console.log('firefox = > ' + firefoxAgent)
      // console.log('ie = > ' + IExplorerAgent)
      // console.log('chrome = > ' + chromeAgent)
      // console.log('opera = > ' + operaAgent)
      // console.log('safari = > ' + safariAgent)
      if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
        this.checkBrowserInfor = {
          url: url,
          payload: ''
        };
        this.checkBrowserDialog = true;
      } else if (safariAgent === true && chromeAgent === true) {
        window.open(url, '_blank');
      } else if (safariAgent === true) {
        this.checkBrowserInfor = {
          url: url,
          payload: ''
        };
        this.checkBrowserDialog = true;
      } else {
        window.open(url, '_blank');
      }
    },
    invitemembergroup: function invitemembergroup() {
      // console.log('invitemembergroup')
      // this.getdataroom()
    },
    closeNote: function closeNote(value) {
      this.dialogNote = value;
    },
    closeAlbums: function closeAlbums(value) {
      this.dialogAlbums = value;
    },
    closeWallpaper: function closeWallpaper(value) {
      this.dialogwallpaper = value;
    },
    closeManageGroup: function closeManageGroup(value) {
      this.dialogManageGroup = value;
    },
    closeShowQRCodeGroup: function closeShowQRCodeGroup(value) {
      this.dialogShowQRCode = value;
    },
    closeCreatenote: function closeCreatenote(value) {
      this.dialogCreatenote = value;
    },
    closeCreatealbums: function closeCreatealbums(value) {
      this.dialogCreatealbums = value;
    },
    editNote: function editNote(msg, id) {
      var indexid = RightSide__.findIndex(this.listnote, function (o) {
        return o.note_id === id;
      });
      this.listnote[indexid]['note_data']['text'] = msg;
    },
    editAlbums: function editAlbums(data) {
      if (data.event === 'edit_name') {
        var indexid = RightSide__.findIndex(this.listalbum, function (o) {
          return o._id === data.albums_id;
        });
        this.listalbum[indexid]['albums_name'] = data.albums_name;
      } else if (data.event === 'add_image') {
        var indexidadd = RightSide__.findIndex(this.listalbum, function (o) {
          return o._id === data.albums_id;
        });
        for (var i = 0; i < data.info_albums.length; i++) {
          this.listalbum[indexidadd]['information'].unshift(data.info_albums[i]);
        }
      } else if (data.event === 'delete_image') {
        var index_id_delete = RightSide__.findIndex(this.listalbum, function (o) {
          return o._id === data.albums_id;
        });
        for (var i = 0; i < data.image_id.length; i++) {
          var index_image = RightSide__.findIndex(this.listalbum[index_id_delete]['information'], function (o) {
            return o.id === data.image_id[i];
          });
          this.listalbum[index_id_delete]['information'].splice(index_image, 1);
        }
      }
    },
    removeAlbums: function removeAlbums(id) {
      RightSide__.remove(this.listalbum, function (o) {
        return o._id === id;
      });
    },
    removeNote: function removeNote(id) {
      RightSide__.remove(this.listnote, function (o) {
        return o.note_id === id;
      });
    },
    detailNote: function detailNote(id) {
      this.dialogNote = true;
      this.note_id = id;
    },
    detailAlbums: function detailAlbums(id, index) {
      this.dialogAlbums = true;
      this.albums_id = id;
    },
    cancelsendinvite: function cancelsendinvite(tokenuser, name) {
      var _this6 = this;

      this.$swal({
        text: this.$t('Alert.Right.cancelInvite', { name: name }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          // this.removeinvite(tokenuser)
          _this6.axios.post("https://uatchat-manage.one.th/manage" + '/cancelsendinvite', {
            tokenuser: _this6.token,
            tokenfriend: tokenuser,
            group_id: _this6.detail.group_id
          }).then(function (response) {
            if (response.data['status'] === 'success') {
              _this6.$swal('', _this6.$t('Alert.Success.cancelInvite'), 'success');
              var indexCancelInvite = RightSide__.findIndex(_this6.memberpending, function (o) {
                return o.tokenuser === tokenuser;
              });
              if (indexCancelInvite !== -1) {
                _this6.memberpending[indexCancelInvite].statemember = 'leave';
              }
            }
          });
        }
      });
    },
    closemodal: function closemodal() {
      var modal = document.getElementById('myModalR');
      modal.style.display = 'none';
    },
    closeDialogShowImage: function closeDialogShowImage(value) {
      this.dialogshowimage = value;
    },
    closeDialogShowImage_Profile: function closeDialogShowImage_Profile(value) {
      this.dialogshowimage_profile = value;
    },
    zoom: function zoom(image) {
      this.DetailImage = image;
      this.dialogshowimage = true;
    },
    sendonebox: function sendonebox(tokenmessage) {
      this.dialogSaveOnebox = true;
      this.tokenmessage_savebox = tokenmessage;
      // this.axios.post(process.env.APIpub + '/save_onebox2', {
      //   tokenmessage: tokenmessage,
      //   tokenuser: this.token
      // }).then((response) => {
      //   if (response.data['status'] === 'success') {
      //     this.$swal(
      //       this.$t('Alert.Success.success'),
      //       this.$t('Alert.Success.sendFiletoOnebox'),
      //       'success'
      //     )
      //   } else {}
      // })
    },
    loadpic: function loadpic(filenameSend) {
      this.axios.get(this.pathSend, {
        responseType: 'blob'
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filenameSend);
        document.body.appendChild(link);
        link.click();
      });
    },
    ShowDialog: function ShowDialog(dialog) {
      if (dialog === 'Invite') {
        this.dialogInvite = true;
      } else if (dialog === 'Leave') {
        this.LeaveGroup = true;
      } else if (dialog === 'ManageGroup') {
        this.dialogManageGroup = true;
      }
    },
    findWithAttr: function findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
    closeInvite: function closeInvite(value) {
      this.dialogInvite = value;
    },
    CloseLeave: function CloseLeave(value) {
      this.LeaveGroup = value;
    },
    detailFriend: function detailFriend(user) {
      this.id = user.tokenuser;
      this.type = 'friend';
      this.dialogopenwebsite = true;
    },
    closeDialog: function closeDialog() {
      this.dialogopenwebsite = false;
    },
    chat: function chat(tokenroom) {
      localStorage.setItem('room', tokenroom);
      this.$router.push('/chat/room/' + tokenroom);
    },
    AcceptReq: function AcceptReq(tokenFriend) {
      var _this7 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/accept-friend", {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this7.relation = 'friend';
        }
      });
    },
    RemoveReq: function RemoveReq(tokenFriend) {
      var _this8 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this8.relation = 'unknown';
        }
      });
    },
    AddFriend: function AddFriend(tokenFriend) {
      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        if (response.data['status'] === 'success') {} else {
          alert('Error!!!');
        }
      });
    },
    unblock: function unblock(item) {
      var _this9 = this;

      // console.log(item)
      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistblockfriend', {
        tokenuser: this.token
      }).then(function (response) {
        var room = response.data['listBlockFriend'][_this9.findWithAttr(response.data['listBlockFriend'], 'tokenuser', item.tokenuser)]['tokenroom'];
        _this9.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', {
          tokenfriend: item.tokenuser,
          tokenuser: _this9.token,
          tokenroom: room
        }).then(function (response) {
          // console.log(response.data)
          if (response.data['status'] === 'success') {
            _this9.$swal('', _this9.$t('Alert.Success.unblock'), 'success');
            item.event = 'unblock_friend';
            item.tokenroom = _this9.$route.params.roomid;
            item.state = 'active';
            _this9.block_friend = item;
            _this9.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistblockfriend', {
              tokenuser: _this9.token
            }).then(function (response) {});
          }
        });
      });
    },
    leavegroupFriend: function leavegroupFriend(tokenuser, name, index) {
      var _this10 = this;

      this.$swal({
        text: this.$t('Alert.Right.deleteFriendGroup', { name: name }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          // process.env.APIgo_api + '/v1/kick-group'
          // process.env.APImanage + '/kickmember'
          _this10.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/kick-group', {
            group_id: _this10.detail.group_id,
            tokenuser: _this10.token,
            listmember: [tokenuser]
          }).then(function (response) {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              _this10.$swal('', _this10.$t('Alert.Success.removeFriendGroup'), 'success');
              // if (index >= 0) {
              //   this.memberactive[index].statemember = 'leave'
              //   this.memberactive.splice(index, 1)
              // }
            }
          });
        }
      });
    },
    blockfriend: function blockfriend(tokenuserfriend, name) {
      var _this11 = this;

      this.$swal({
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Blocking', { name: name }),
        type: 'warning',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          // console.log(tokenuserfriend)
          _this11.axios.post("https://uatchat-manage.one.th/manage" + '/blockfriend', {
            tokenfriend: tokenuserfriend,
            tokenuser: _this11.token,
            tokenroom: _this11.$route.params.roomid
          }).then(function (response) {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              _this11.$swal('', _this11.$t('Alert.Success.block'), 'success');
              _this11.block_friend = {
                tokenuser: tokenuserfriend,
                timestamp: response.data.timestamp,
                event: 'block_friend',
                tokenroom: _this11.$route.params.roomid
              };
              _this11.relation = 'block';
              // this.$router.push('/chat/homepage')
            }
          });
        }
      });
    },
    clickedit: function clickedit() {
      this.edit = !this.edit;
      this.activeinfo = 'tab-1';
    },
    leavegroup: function leavegroup() {
      var _this12 = this;

      this.$swal({
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Right.leaveGroup'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          // process.env.APImanage + '/leavegroup'
          // process.env.APIgo_api + '/v1/leave-group'
          _this12.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/leave-group', {
            group_id: _this12.detail.group_id,
            tokenuser: _this12.token,
            listmember: [_this12.token]
          }).then(function (response) {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              _this12.$router.push('/chat/homepage');
            }
          });
        }
      });
    },
    getimage: function getimage(time) {
      var _this13 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/file/twe_img', {
        tokenuser: this.token,
        tokenroom: this.room,
        time_in: time,
        type: this.typeuser
      }).then(function (response) {
        if (response.data['data'].length === 20) {
          _this13.showmoreimage = true;
        } else {
          _this13.showmoreimage = false;
        }
        if (time === '') {
          _this13.listimageinroom = response.data['data'];
        } else {
          _this13.listimageinroom.push.apply(_this13.listimageinroom, response.data['data']);
        }
      });
    },
    getfile: function getfile(time) {
      var _this14 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/file/twe_file', {
        tokenuser: this.token,
        tokenroom: this.room,
        time_in: time,
        type: this.typeuser
      }).then(function (response) {
        if (response.data['data'].length === 20) {
          _this14.showmorefile = true;
        } else {
          _this14.showmorefile = false;
        }
        if (time === '') {
          _this14.listfileinroom = response.data['data'];
        } else {
          _this14.listfileinroom.push.apply(_this14.listfileinroom, response.data['data']);
        }
      });
    },
    zoomgroup: function zoomgroup(src) {
      this.$swal({
        imageUrl: src,
        showCloseButton: true,
        animation: true,
        showCancelButton: false,
        showConfirmButton: false
      });
    },
    extension: function extension(path) {
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase();
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
      var pdf = ['pdf'];
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm'];
      var presentation = ['ppt', 'pps', 'pot', 'pptx'];
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff'];
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf';
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive';
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel';
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint';
      } else if (word.includes(extension)) {
        return 'fas fa-file-word';
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code';
      } else if (image.includes(extension)) {
        return 'fas fa-file-image';
      } else {
        return 'fas fa-file-alt';
      }
    },

    // count_memberpendingactive(member) {
    //   return _.filter(member, function(member) {
    //     return member.statemember === 'pending'
    //   })
    // },
    // (member) {
    //   return _.filter(member, function(member) {
    //     return member.statemember === 'active'
    //   })
    // },

    getmember: function getmember() {
      var _this15 = this;

      // get member from api jame keep in this.memberpending and this.memberactive
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v2/get-user-group', {
        group_id: this.detail.group_id,
        page: this.pagemember,
        limit: this.limit,
        filter: 'active'
      }).then(function (response) {
        if (response.data.status === 'success') {
          if (_this15.pagemember == 0) {
            _this15.memberactive = response.data.member;
          } else {
            _this15.memberactive.push.apply(_this15.memberactive, response.data.member);
          }
          _this15.pagemember = _this15.pagemember + 1;
        } else {
          // this.progressNote = false
        }
      });
    },
    getpending: function getpending() {
      var _this16 = this;

      // get member from api jame keep in this.memberpending and this.memberactive
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v2/get-user-group', {
        group_id: this.detail.group_id,
        page: this.pagepending,
        limit: this.limit,
        filter: 'pending'
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          if (_this16.pagemember == 0) {
            _this16.memberpending = response.data.member;
          } else {
            _this16.memberpending.push.apply(_this16.memberpending, response.data.member);
          }
          _this16.pagepending = _this16.pagepending + 1;
        } else {
          // this.progressNote = false
        }
      });
    },
    convert: function convert(msg) {
      var text = msg;
      var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/\\%?=~_|!:,.;]*[-A-Z0-9+&@#/\\%=~_|])/ig;
      var text1 = text.replace(/</g, '&lt;');
      var text2 = text1.replace(/>/g, '&gt;');
      var text3 = text2.replace(exp, '<a target="_blank" href="$1">$1</a>');
      var exp2 = /(^|[^/\\])(www\.[\S]+(\b|$))/gim;
      var text4 = text3.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
      return text4;
    },
    CreateNote: function CreateNote(status, createdate, noteid, tokenroom, updatedate, text) {
      if (status === 'success') {
        if (RightSide__.find(this.listnote, function (o) {
          return o.note_id === noteid;
        }) === undefined) {
          this.listnote.unshift({
            create_date: createdate,
            nickname: localStorage.getItem('name'),
            note_data: {
              image: [],
              text: text
            },
            note_id: noteid,
            owner: this.token,
            profilepicture: localStorage.getItem('profilepicture'),
            tokenroom: tokenroom,
            type: localStorage.getItem('type_user'),
            update_date: updatedate
          });
          this.listnote = RightSide__.orderBy(this.listnote, 'create_date', 'desc');
          this.listnote = RightSide__.unionBy(this.listnote, 'note_id');
        }
      }
    },
    CreateAlbums: function CreateAlbums(status, infoalbums) {
      if (status === 'success') {
        this.listalbum.unshift(infoalbums);
      }
    },
    getnote: function getnote() {
      var _this17 = this;

      this.listnote = [];
      this.progressNote = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getlistnote2', {
        tokenuser: this.token,
        tokenroom: this.room
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this17.progressNote = false;
          _this17.listnote = response.data.list_note;
          // var _ = require('lodash')
          _this17.listnote = RightSide__.orderBy(_this17.listnote, 'create_date', 'desc');
          _this17.listnote = RightSide__.unionBy(_this17.listnote, 'note_id');
        } else {
          _this17.progressNote = false;
        }
      });
    },
    date: function date(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    time: function time(timestamp) {
      return services["c" /* Momenttime */].momenttimethai(timestamp);
    },
    getdataroom: function getdataroom() {
      var _this18 = this;

      this.shownotes = false;
      this.detail = {};
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this18.detail = response.data;
          // console.log(this.detail.data_room[0])
          if (_this18.detail.data_room[0].type === 'bot') {
            _this18.getConsent(_this18.detail.data_room[0].tokenuser, _this18.$route.params.roomid);
          } else {
            // get oneid friend not bot
            _this18.getOneIDFriend(_this18.detail.data_room[0].tokenuser);
          }
          // else {
          _this18.getimage('');
          _this18.getfile('');
          _this18.getmember();
          _this18.getpending();
          if (response.data.statemember === 'active') {
            _this18.getnote();
            _this18.getListAlbums();
          }
          // }
        }
      });
    },
    getConsent: function getConsent(botid, tokenroom) {
      var _this19 = this;

      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/get-consent-bot', {
        tokenuser: this.token,
        bot_id: botid
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          if (response.data.isConsent === true && response.data.isAccept === false) {
            var dataConsent = services["b" /* Encode */].encode(response.data.data);
            _this19.$router.push('/check-consent/' + tokenroom + ('/?data_consent=' + dataConsent));
          } else {
            _this19.dataConsent = response.data.data;
            _this19.isAccept = response.data.isAccept;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getAccesstoken: function getAccesstoken() {
      var _this20 = this;

      this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", {
        tokenuser: this.token,
        url: ''
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this20.share_token = response.data.data.url;
          _this20.check_consent(response.data.data.url);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    check_consent: function check_consent(token) {
      var _this21 = this;

      this.axios.post(this.dataConsent.endpoint, {
        tax_id: this.dataConsent.tax_id,
        shared_token: token,
        service_id: this.dataConsent.service_id,
        consent_form_id: this.dataConsent.consent_form_id
      }).then(function (response) {
        if (response.data.result === 'success') {
          _this21.url_consent = '';
          // localStorage.setItem('check_consent', response.data.data.status)
          if (response.data.data.status === 'approved') {
            _this21.checkconsentDialog = true;
            _this21.url_consent = response.data.data.response.elements.choice.url + token;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getListAlbums: function getListAlbums() {
      var _this22 = this;

      this.listalbum = [];
      this.progressNote = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/getlist_albums', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this22.progressNote = false;
          _this22.listalbum = response.data.data;
        }
      });
    },
    getnoteid: function getnoteid(id) {
      var _this23 = this;

      if (RightSide__.find(this.listnote, function (o) {
        return o.note_id === id;
      }) === undefined) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getnote', {
          note_id: id
        }).then(function (response) {
          if (response.data.status === 'success') {
            _this23.listnote.unshift({
              create_date: response.data.list_note[0].create_date,
              nickname: response.data.list_note[0].nickname,
              note_data: {
                image: [],
                text: response.data.list_note[0].note_data.text
              },
              note_id: response.data.list_note[0].note_id,
              owner: response.data.list_note[0].owner,
              profilepicture: response.data.list_note[0].profilepicture,
              tokenroom: response.data.list_note[0].tokenroom,
              type: response.data.list_note[0].type,
              update_date: response.data.list_note[0].update_date
            });
            _this23.listnote = RightSide__.orderBy(_this23.listnote, 'create_date', 'desc');
            _this23.listnote = RightSide__.unionBy(_this23.listnote, 'note_id');
          }
        });
      }
    }
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {
    socketmessage: function socketmessage() {
      var _this24 = this;

      // console.log(this.socketmessage)

      var albums_id = this.socketmessage.file_name;
      if (this.socketmessage.message === 'addimage_albums') {
        // console.log(this.listalbum)
        var indexidadd = RightSide__.findIndex(this.listalbum, function (o) {
          return o._id === albums_id;
        });
        if (indexidadd >= 0) {
          for (var i = 0; i < this.socketmessage.image_add.length; i++) {
            this.listalbum[indexidadd]['information'].unshift(this.socketmessage.image_add[i]);
          }
        }
      } else if (this.socketmessage.message === 'delete_images_albums') {
        var albums_id_delete = this.socketmessage.albums_id;
        var index_id_delete = RightSide__.findIndex(this.listalbum, function (o) {
          return o._id === albums_id_delete;
        });
        this.axios.post("https://uatchat-manage.one.th/event" + '/get_albums', {
          albums_id: albums_id_delete,
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token
        }).then(function (response) {
          _this24.listalbum[index_id_delete]['information'] = response.data.data.information;
          for (var i = 0; i < _this24.listalbum[index_id_delete]['information'].length; i++) {
            var index_image = RightSide__.findIndex(_this24.listalbum[index_id_delete]['information'], function (o) {
              return o.status === 'delete';
            });
            _this24.listalbum[index_id_delete]['information'].splice(index_image, 1);
          }
        }).catch(function (error) {
          if (error.response.data.status === 'fail') {
            console.log(error);
          }
        });
      } else if (this.socketmessage.message === 'create_albums') {
        // console.log('create_albums')
        this.axios.post("https://uatchat-manage.one.th/event" + '/get_albums', {
          albums_id: albums_id,
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token
        }).then(function (response) {
          _this24.listalbum.unshift(response.data.data);
          _this24.listalbum = RightSide__.unionBy(_this24.listalbum, '_id');
        }).catch(function (error) {
          if (error.response.data.status === 'fail') {
            console.log(error);
          }
        });
      }
    },
    socketnote: function socketnote() {
      var id = this.socketnote.note_id;
      this.getnoteid(id);
    },
    socketupdate_file: function socketupdate_file() {
      this.listfileinroom.unshift({
        file_name: this.socketupdate_file.file_name,
        file_owner: this.socketupdate_file.nickname,
        path: this.socketupdate_file.message,
        pic_pro: this.socketupdate_file.path_pic,
        timestamp: this.socketupdate_file.timestamp,
        tokenmessage: this.socketupdate_file.tokenmessage,
        tokenuser: this.socketupdate_file.tokenuser,
        typeuser: this.socketupdate_file.type
      });
    },
    socketupdate_img: function socketupdate_img() {
      this.listimageinroom.unshift({
        file_name: this.socketupdate_img.file_name,
        file_owner: this.socketupdate_img.nickname,
        path: this.socketupdate_img.message,
        pic_pro: this.socketupdate_img.path_pic,
        timestamp: this.socketupdate_img.timestamp,
        tokenmessage: this.socketupdate_img.tokenmessage,
        tokenuser: this.socketupdate_img.tokenuser,
        typeuser: this.socketupdate_img.type
      });
    },
    socketremove_friend: function socketremove_friend(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.detail.statemember = 'unfriend';
      }
    },
    socketinvite_group: function socketinvite_group(data) {
      var _this25 = this;

      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', {
          owner: this.token,
          tokenuser: data.list_invite
        }).then(function (response) {
          // console.log(response.data.user)
          // console.log(this.detail.data_room)
          for (var i = 0; i < response.data.user.length; i++) {
            var user = response.data.user[i];
            if (response.data.user[i].type === 'user') {
              user.statemember = 'pending';
              // this.detail.data_room.push(user)
              user.nickname = response.data.user[i].name;
              _this25.memberpending.push(user);
              _this25.memberpending = RightSide__.unionBy(_this25.memberpending, 'tokenuser');
              _this25.detail.count_pending = parseInt(_this25.detail.count_pending) + 1;
            } else {
              user.statemember = 'active';
              // this.detail.data_room.push(user)
              user.nickname = response.data.user[i].name;
              _this25.memberactive.push(user);
              _this25.memberactive = RightSide__.unionBy(_this25.memberactive, 'tokenuser');
              // this.detail.count_member = parseInt(this.detail.count_member) + 1
            }
          }
        });
      }
    },
    socketleave_group: function socketleave_group(data) {
      // console.log(data)
      // if (data.tokenroom === this.$route.params.roomid) {
      //   var self = this
      //   data.listkick.forEach(function(item) {
      //     // console.log(element)
      //     if (self.token === item) {
      //       self.detail.statemember = 'leave'
      //     }
      //     var index = _.findIndex(self.detail.data_room, function(o) {
      //       return o.tokenuser === item
      //     })
      //     if (index >= 0) {
      //       self.detail.data_room.splice(index, 1)
      //     }
      //   })
      // }

      if (data.tokenroom === this.$route.params.roomid) {
        // ลบ list user active
        var index = RightSide__.findIndex(this.memberactive, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        if (index >= 0) {
          this.memberactive.splice(index, 1);
        }
        this.detail.count_member = parseInt(this.detail.count_member) - 1;
      }
    },
    socket_kickmember: function socket_kickmember(data) {
      // console.log(data)
      // var self = this
      // data.listkick.forEach(function(item) {
      //   if (self.token === item) {
      //     self.detail.statemember = 'leave'
      //   }
      //   var index = _.findIndex(self.detail.data_room, function(o) {
      //     return o.tokenuser === item
      //   })
      //   if (index >= 0) {
      //     self.detail.data_room[index].statemember = 'leave'
      //     self.detail.data_room.splice(index, 1)
      //   }
      // })
      var self = this;
      data.listkick.forEach(function (item) {
        // console.log(self.token === item)
        // console.log(item)
        if (self.token === item) {
          self.memberactive.statemember = 'leave';
          self.detail.statemember = 'leave';
        }
        var index = RightSide__.findIndex(self.memberactive, function (o) {
          return o.tokenuser === item;
        });
        // console.log(index)
        if (index >= 0) {
          self.memberactive[index].statemember = 'leave';
          self.memberactive.splice(index, 1);
        }
      });
      this.detail.count_member = parseInt(this.detail.count_member) - 1;
    },
    '$route.params.roomid': function $routeParamsRoomid() {
      this.room = this.$route.params.roomid;
      this.memberactive = [];
      this.memberpending = [];
      this.pagemember = 0;
      this.pagepending = 0;
      this.activeinfo = 'tab-1';
      this.getdataroom();
    },
    socketactive_group: function socketactive_group(data) {
      var _this26 = this;

      // console.log(data)
      // if (this.detail.type === 'group' && this.detial.count_pending !== '0' && this.detail.group_id === data.groupid) {
      //   var index = _.findIndex(this.detail.data_room, function(o) {
      //     return o.tokenuser === data.tokenuser
      //   })
      //   if (index >= 0) {
      //     this.detail.data_room[index].statemember = 'active'
      //     this.detail.statemember = 'active'
      //   }
      // }
      if (this.detail.group_id === data.groupid) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', { owner: this.token, tokenuser: [data.tokenuser] }).then(function (response) {
          // console.log(response.data.user[0])
          console.log('state member: ' + _this26.detail.statemember);
          _this26.detail.statemember = 'active';
          // หาข้อมูล user active
          var user = response.data.user[0];
          user.statemember = 'active';
          user.nickname = response.data.user[0].name;
          _this26.memberactive.push(user);
          _this26.memberactive = RightSide__.unionBy(_this26.memberactive, 'tokenuser');
          // ลบ list user pending ที่เพิ่ง active
          var index = RightSide__.findIndex(_this26.memberpending, function (o) {
            return o.tokenuser === data.tokenuser;
          });
          if (index >= 0) {
            _this26.memberpending.splice(index, 1);
          }
          console.log('member old: ' + _this26.detail.count_member);
          _this26.detail.count_member = parseInt(_this26.detail.count_member) + 1;
          if (response.data.user[0].type !== 'bot') {
            _this26.detail.count_pending = parseInt(_this26.detail.count_pending) - 1;
          }
          console.log('member new: ' + _this26.detail.count_member);
        });
      }
    },
    socketcencel_group: function socketcencel_group(data) {
      // if (this.detail.type === 'group' && this.detial.count_pending !== '0' && this.detail.group_id === data.group_id) {
      //   var index = _.findIndex(this.detail.data_room, function(o) {
      //     return o.tokenuser === data.tokenuser
      //   })
      //   if (index >= 0) {
      //     this.detail.data_room.splice(index, 1)
      //   }
      // }

      // ลบ list user pending
      var index = RightSide__.findIndex(this.memberpending, function (o) {
        return o.tokenuser === data.tokenuser;
      });
      if (index >= 0) {
        this.memberpending.splice(index, 1);
      }
      this.detail.count_pending = parseInt(this.detail.count_pending) - 1;
    }
  },
  created: function created() {
    this.typeuser = localStorage.getItem('type_user');
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.room = this.$route.params.roomid;
    this.shownotes = false;
    this.showalbum = false;
    this.getdataroom();
    // get oneid user
    this.getOneIDUser(this.token);
  },

  components: {
    InviteGroup: dialog_manage_group_InviteGroupDialog,
    NoteDialog: NoteDialog["a" /* default */],
    CreateNoteDialog: dialog_notes_CreateNoteDialog,
    ManageGroup: dialog_manage_group_ManageGroupDialog,
    vuegalleryslideshow: gallery_slideshow,
    ShowQRCodeGroup: dialog_manage_group_ShowQRCodeGroupDialog,
    AlbumsDialog: AlbumsDialog["a" /* default */],
    CreateAlbumsDialog: dialog_albums_CreateAlbumsDialog,
    RightMenu: chat_layout_RightMenuSide,
    ShowImageDialog: ShowImageDialog["a" /* default */],
    ShowImageProfileDialog: ShowImage_ProfileDialog["a" /* default */],
    Openwebsite: Openwebsite["a" /* default */],
    Wallpaper: dialog_wallpaper_wallpaper_dialog,
    SaveOnebox: SaveoneboxDialog["a" /* default */],
    checkconsentdialog: check_consent_dialog["a" /* default */],
    CheckBrowserDialog: CheckBrowserDialog["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-791ec3dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/layout/RightSide.vue
var RightSide_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detail)?_c('v-layout',{staticClass:"rightbox CSChatThai ",staticStyle:{"border":"solid","border-width":"1px","border-color":"#1a222c","border-bottom":"none","border-top":"none","background":"#1a222c","overflow":"hidden","height":"100%"},attrs:{"row":"","wrap":""}},[_c('ShowImageDialog',{attrs:{"dialogshowimage":_vm.dialogshowimage,"DetailImage":_vm.DetailImage},on:{"closeDialogShowImage":_vm.closeDialogShowImage}}),_vm._v(" "),(_vm.shownotes)?_c('v-flex',{attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-card',{staticStyle:{"background":"#1a222c"},attrs:{"flat":""}},[(!_vm.progressNote)?_c('v-container',{staticStyle:{"background":"#1a222c","padding":"5px"}},[_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":function($event){_vm.shownotes = !_vm.shownotes}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("fas fa-arrow-left")])],1),_vm._v(" "),_c('div',{staticClass:"scrolling-wrapper",staticStyle:{"height":"80vh"}},_vm._l((_vm.listnote),function(item,index){return _c('div',{staticClass:"noteslist",staticStyle:{"padding":"5px","padding-bottom":"0px","padding-top":"20px"},on:{"click":function($event){_vm.detailNote(item.note_id)}}},[_c('v-avatar',{staticClass:"user-photonote",staticStyle:{"padding-left":"20px"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"35px !important","height":"35px !important"},attrs:{"src":item.profilepicture}}):(item.type ==='business')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"35px !important","height":"35px !important"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type ==='bot')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"35px !important","height":"35px !important"},attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"35px !important","height":"35px !important"},attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"15px","color":"white","padding-left":"10px"}},[_vm._v(_vm._s(item.nickname))]),_vm._v(" "),(item.note_data.text.length > 20)?_c('p',{staticStyle:{"color":"#BDBDBD","padding-top":"10px","font-size":"13px","padding-left":"20px"},domProps:{"innerHTML":_vm._s(_vm.convert(item.note_data.text.substring(0, 20) + '...' ).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}):_c('p',{staticStyle:{"color":"#BDBDBD","padding-top":"10px","font-size":"13px","padding-left":"20px"},domProps:{"innerHTML":_vm._s(_vm.convert(item.note_data.text).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[_c('span',{staticStyle:{"font-size":"10px","color":"#BDBDBD !important"}},[_vm._v("\n              "+_vm._s(_vm.date(item.create_date))+" "+_vm._s(_vm.time(item.create_date))+"\n            ")])]),_vm._v(" "),_c('v-divider',{staticStyle:{"background-color":"#bdbdbd5e !important","width":"100%"}})],1)})),_vm._v(" "),_c('v-fab-transition',[_c('v-btn',{staticStyle:{"background":"#2562ae"},attrs:{"fab":"","dark":"","small":"","fixed":"","bottom":"","right":""},on:{"click":function($event){_vm.dialogCreatenote = true}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1):_c('v-container',{staticStyle:{"background":"#1a222c","padding":"5px"}},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.progressNote}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showalbum)?_c('v-flex',{attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-card',{staticStyle:{"background":"#1a222c"},attrs:{"flat":""}},[(!_vm.progressNote)?_c('v-container',{staticStyle:{"background":"#1a222c","padding":"5px"}},[_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":function($event){_vm.showalbum = !_vm.showalbum}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("fas fa-arrow-left")])],1),_vm._v(" "),_c('div',{staticClass:"scrolling-wrapper",staticStyle:{"height":"80vh"}},_vm._l((_vm.listalbum),function(item,index){return (item.state['status'] != 'delete')?_c('div',{staticClass:"noteslist",staticStyle:{"padding":"5px","padding-bottom":"0px","padding-top":"20px"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(item.albums_name !== '')?_c('h3',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(item.albums_name))]):_c('h3',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.date(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[_c('span',{staticStyle:{"font-size":"10px","color":"#BDBDBD !important"}},[_vm._v("\n                  "+_vm._s(_vm.date(item.create_date))+" "+_vm._s(_vm.time(item.create_date))+"\n                ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white"},on:{"click":function($event){_vm.delete_albums(item._id)}}},[_c('v-icon',{staticStyle:{"font-size":"16px !important"}},[_vm._v("far fa-trash-alt")])],1)],1)],1),_vm._v(" "),(item.information.length !== 0)?_c('v-layout',{on:{"click":function($event){_vm.detailAlbums(item._id, index)}}},[_c('v-container',_vm._b({staticStyle:{"padding":"2px !important"},attrs:{"fluid":""}},'v-container',( _obj = {}, _obj["grid-list-sm"] = true, _obj ),false),[_c('v-layout',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"35vh"},attrs:{"row":"","wrap":""}},_vm._l((item.information),function(image,index){return (image.status == 'active')?_c('v-flex',{attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-media',{attrs:{"src":image.link,"height":"15vh"}})],1)],1):_vm._e()}))],1)],1):_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('h4',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('Dialog.album.noImageAlbum'))+" ")])]),_vm._v(" "),_c('v-divider',{staticStyle:{"background-color":"#bdbdbd5e !important","width":"100%"}})],1):_vm._e()
var _obj;})),_vm._v(" "),_c('v-fab-transition',[_c('v-btn',{staticStyle:{"background":"#2562ae"},attrs:{"fab":"","dark":"","small":"","fixed":"","bottom":"","right":""},on:{"click":function($event){_vm.dialogCreatealbums = true}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1):_c('v-container',{staticStyle:{"background":"#1a222c","padding":"5px"}},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.progressNote}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.detail.type === 'user' && !_vm.shownotes && !_vm.showalbum)?_c('v-flex',{staticStyle:{"overflow-y":"hidden"},attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-card',{staticStyle:{"background":"#1a222c"},attrs:{"flat":""}},[_c('v-container',{staticStyle:{"background":"#1a222c","padding-bottom":"0px !important","padding-top":"0px"}},[_c('div',{staticStyle:{"text-align":"right"}},[_c('RightMenu',{attrs:{"detail":_vm.detail},on:{"opennotes":_vm.opennotes,"openalbum":_vm.openalbum,"blockfriend":_vm.blockfriend,"openWallpaper":_vm.openWallpaper,"unblock":_vm.unblock}})],1),_vm._v(" "),_c('v-layout',{staticStyle:{"background":"#1a222c"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{staticStyle:{"justify-content":"center","display":"flex"},attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-avatar',{staticClass:"user-photo",staticStyle:{"cursor":"pointer !important"},attrs:{"size":"150px"},on:{"click":function($event){_vm.openPictureProfile(_vm.detail.data_room[0].profilepicture, _vm.detail.data_room[0].type)}}},[(_vm.detail.data_room[0].profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.detail.data_room[0].profilepicture}}):(_vm.detail.data_room[0].type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.detail.data_room[0].type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"center","margin-top":"10px"},attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('p',{staticClass:"text2",staticStyle:{"font-size":"20px","color":"white","margin-bottom":"0px !important"}},[_vm._v(_vm._s(_vm.detail.data_room[0].name))]),_vm._v(" "),(_vm.detail.data_room[0].type === 'user')?_c('p',{staticClass:"text2",staticStyle:{"color":"#bcbcbc","font-size":"12px","margin-bottom":"7px !important"}},[_vm._v(_vm._s(_vm.detail.data_room[0].status? _vm.detail.data_room[0].status:'-'))]):_c('p',{staticClass:"text2",staticStyle:{"color":"#bcbcbc","font-size":"12px"}},[_vm._v(_vm._s(_vm.detail.data_room[0].status? _vm.detail.data_room[0].status:'-'))]),_vm._v(" "),(_vm.detail.data_room[0].type === 'user' && _vm.base_env === 'development')?_c('v-btn',{staticStyle:{"background":"green"},attrs:{"icon":"","disabled":_vm.detail.data_room[0].statemember !== 'active'}},[_c('v-icon',{staticStyle:{"font-size":"20px !important"},attrs:{"color":"white"},on:{"click":function($event){_vm.openCall_v2('audio',_vm.detail)}}},[_vm._v("phone")])],1):_vm._e(),_vm._v(" "),(_vm.detail.data_room[0].type === 'user' && _vm.base_env === 'development')?_c('v-btn',{staticStyle:{"background":"#1976d2"},attrs:{"icon":"","disabled":_vm.detail.data_room[0].statemember !== 'active'}},[_c('v-icon',{staticStyle:{"font-size":"20px !important"},attrs:{"color":"white"},on:{"click":function($event){_vm.openCall_v2('video',_vm.detail)}}},[_vm._v("fas fa-video")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-container',{staticStyle:{"padding-top":"2px !important"}},[_c('v-tabs',{staticClass:"layoutsearchweb tabsright",attrs:{"slot":"extension","centered":"","dark":""},slot:"extension",model:{value:(_vm.activeinfo),callback:function ($$v) {_vm.activeinfo=$$v},expression:"activeinfo"}},[_c('v-tab',{key:"1",staticClass:"headerlist tabsright",staticStyle:{"justify-content":"center !important"},attrs:{"href":"#tab-1"}},[_c('v-icon',{staticStyle:{"font-size":"20px !important"}},[_vm._v("account_box")])],1),_vm._v(" "),(_vm.isAccept === true)?_c('v-tab',{key:"4",staticClass:"headerlist tabsright",staticStyle:{"justify-content":"center !important"},attrs:{"href":"#tab-4"}},[_c('img',{staticStyle:{"width":"20px !important"},attrs:{"src":"/static/img/icons/privacy-policy.png"}})]):_vm._e()],1),_vm._v(" "),_c('v-tabs-items',{staticClass:"layoutsearchweb CSChatThai",model:{value:(_vm.activeinfo),callback:function ($$v) {_vm.activeinfo=$$v},expression:"activeinfo"}},[_c('v-tab-item',{key:"1",staticClass:"layoutsearchweb",attrs:{"id":"tab-1"}},[_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"background":"none !important","margin-top":"4px !important"},attrs:{"dense":""}},[_c('v-subheader',{staticStyle:{"color":"white","font-weight":"900"}},[_vm._v(_vm._s(_vm.$t('RightSide.header.profile')))]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',{staticStyle:{"color":"#1da1f2"},attrs:{"large":""}},[_vm._v("email")])],1),_vm._v(" "),_c('v-list-tile-content',[(_vm.detail.data_room[0].email === '')?_c('v-list-tile-title',{staticStyle:{"color":"white !important"}},[_vm._v("-")]):_c('v-list-tile-title',{staticStyle:{"color":"white !important"}},[_c('span',{staticClass:"EndpointUrl"},[_vm._v("\n                      "+_vm._s(_vm.detail.data_room[0].email)+"\n                      "),_c('v-icon',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.detail.data_room[0].email),expression:"detail.data_room[0].email",arg:"copy"}],staticClass:"urlcopymessage",staticStyle:{"color":"white","font-size":"13px !important","cursor":"pointer"}},[_vm._v("file_copy")])],1)])],1)],1),_vm._v(" "),_c('v-divider')],1)],1),_vm._v(" "),_c('v-tab-item',{key:"2",staticClass:"layoutsearchweb",staticStyle:{"overflow-y":"hidden"},attrs:{"id":"tab-2"}},[_c('v-subheader',{staticStyle:{"color":"white","font-weight":"900"}},[_vm._v(_vm._s(_vm.$t('RightSide.header.image')))]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[(_vm.listimageinroom.length != 0)?_c('div',{staticStyle:{"background":"#1b232d","box-shadow":"none !important"}},[_c('v-container',_vm._b({staticStyle:{"padding":"2px !important"},attrs:{"fluid":""}},'v-container',( _obj = {}, _obj["grid-list-sm"] = true, _obj ),false),[_c('v-layout',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"35vh"},attrs:{"row":"","wrap":""}},[_vm._l((_vm.listimageinroom),function(memb,i){return _c('v-flex',{staticStyle:{"cursor":"pointer"},attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-media',{attrs:{"src":memb.path,"height":"15vh"},on:{"click":function($event){_vm.zoom(memb)}}})],1)],1)}),_vm._v(" "),(_vm.showmoreimage)?_c('v-flex',{staticStyle:{"cursor":"pointer"},attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',{staticStyle:{"background":"none"},attrs:{"flat":"","tile":""}},[_c('v-card-media',{staticStyle:{"color":"white","text-align":"center","display":"flex","justify-content":"center"},attrs:{"height":"15vh"},on:{"click":function($event){_vm.getimage(_vm.listimageinroom[_vm.listimageinroom.length - 1].timestamp)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('ChatSide.Read.readmore'))+"\n                        ")])],1)],1):_vm._e()],2)],1)],1):_c('p',{staticStyle:{"color":"white","text-align":"center"}},[_vm._v(_vm._s(_vm.$t('RightSide.noImage')))])])],1),_vm._v(" "),_c('v-tab-item',{key:"3",staticClass:"layoutsearchweb",attrs:{"id":"tab-3"}},[_c('v-subheader',{staticStyle:{"color":"white","font-weight":"900"}},[_vm._v(_vm._s(_vm.$t('RightSide.header.file')))]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[(_vm.listfileinroom.length != 0)?_c('div',{staticClass:"scrolling-wrapper",staticStyle:{"background":"#1b232d","max-height":"35vh"}},[_vm._l((_vm.listfileinroom),function(memb,index){return _c('v-list',{staticClass:"layoutsearchweb",attrs:{"two-line":"","dense":"","dark":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',{attrs:{"href":memb.path,"target":"_blank"}},[_c('v-icon',{staticStyle:{"color":"#1da1f2"},attrs:{"large":""}},[_vm._v(" "+_vm._s(_vm.extension(memb.path)))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"color":"white !important","white-space":"nowrap","width":"15em","overflow":"hidden","text-overflow":"ellipsis"},attrs:{"href":memb.path,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(memb.file_name))])]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"CSChatThai"},[_c('v-btn',{staticClass:"btnallow",attrs:{"depressed":"","small":"","href":memb.path,"target":"_blank"}},[_vm._v("\n                          "+_vm._s(_vm.$t('AnswerQuestion.download'))+"\n                        ")]),_vm._v(" "),_c('v-btn',{staticClass:"btncancel",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.sendonebox(memb.tokenmessage)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('AnswerQuestion.Onebox'))+"\n                        ")])],1)],1)],1),_vm._v(" "),(index != _vm.listfileinroom.length-1)?_c('v-divider'):_vm._e()],1)}),_vm._v(" "),(_vm.showmorefile)?_c('div',{staticStyle:{"display":"flex","justify-content":"center","width":"100%"}},[_c('v-btn',{staticClass:"btncancel",staticStyle:{"display":"flex","justify-content":"center","text-transform":"none","color":"white !important","text-align":"center"},attrs:{"depressed":"","dark":""},on:{"click":function($event){_vm.getfile(_vm.listfileinroom[_vm.listfileinroom.length - 1].timestamp)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.Read.readmore'))+"\n                  ")])],1):_vm._e()],2):_c('p',{staticStyle:{"color":"white","text-align":"center"}},[_vm._v(_vm._s(_vm.$t('RightSide.noFile')))])])],1),_vm._v(" "),_c('v-tab-item',{key:"4",staticClass:"layoutsearchweb",attrs:{"id":"tab-4"}},[_c('v-subheader',{staticStyle:{"color":"white","font-weight":"900"}},[_vm._v(_vm._s(_vm.$t('RightSide.header.privatepolicy')))]),_vm._v(" "),_c('v-flex',{staticStyle:{"justify-content":"center","align-items":"center","width":"100%","display":"flex"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-btn',{attrs:{"outline":"","rounded":"","color":"white"},on:{"click":function($event){_vm.getAccesstoken()}}},[_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('RightSide.header.privatepolicy')))])])],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.detail.type === 'group' && !_vm.shownotes && !_vm.showalbum)?_c('v-flex',{attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-card',{staticStyle:{"background":"#1a222c"},attrs:{"flat":""}},[_c('v-container',{staticStyle:{"background":"#1a222c","padding-top":"0px","padding-bottom":"0px"}},[_c('div',{staticStyle:{"text-align":"right"}},[_c('RightMenu',{attrs:{"detail":_vm.detail},on:{"openQRcode":_vm.openQRcode,"opennotes":_vm.opennotes,"openalbum":_vm.openalbum,"ShowDialog":_vm.ShowDialog,"leavegroup":_vm.leavegroup,"openWallpaper":_vm.openWallpaper}})],1),_vm._v(" "),_c('v-layout',{staticStyle:{"background":"#1a222c"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{staticStyle:{"justify-content":"center","display":"flex","height":"150px"},attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-avatar',{staticStyle:{"cursor":"pointer !important"},attrs:{"size":"150px"},on:{"click":function($event){_vm.openPictureProfile(_vm.detail.picture, 'group')}}},[(_vm.detail.picture)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border":"2px #1a222c !important","border-style":"solid !important","cursor":"pointer"},attrs:{"src":_vm.detail.picture}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"border":"2px #1a222c !important","border-style":"solid !important","cursor":"pointer"},attrs:{"src":"/static/img/default_profile/group-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"1px","text-align":"center","margin-bottom":"1px"},attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('p',{staticClass:"text2",staticStyle:{"font-size":"20px","color":"white","margin-top":"10px","margin-bottom":"10px"}},[_vm._v(" "+_vm._s(_vm.$t('RightSide.group'))+" : "+_vm._s(_vm.detail.group_name)+"\n            ")])])],1)],1),_vm._v(" "),_c('v-container',{staticStyle:{"padding-top":"2px"}},[(_vm.detail.statemember == 'active')?_c('v-tabs',{staticClass:"layoutsearchweb tabsright",attrs:{"slot":"extension","centered":"","dark":""},slot:"extension",model:{value:(_vm.activeinfo),callback:function ($$v) {_vm.activeinfo=$$v},expression:"activeinfo"}},[_c('v-tabs-slider',{attrs:{"color":"#2562af"}}),_vm._v(" "),_c('v-tab',{key:"1",staticClass:"headerlist tabsright",staticStyle:{"justify-content":"center !important"},attrs:{"href":"#tab-1"}},[_c('v-icon',{staticStyle:{"font-size":"20px !important"}},[_vm._v("supervised_user_circle")])],1),_vm._v(" "),(_vm.detail.count_pending != '0')?_c('v-tab',{key:"2",staticClass:"headerlist tabsright",staticStyle:{"justify-content":"center !important"},attrs:{"href":"#tab-2"}},[_c('v-icon',{staticStyle:{"font-size":"20px !important"}},[_vm._v("schedule")])],1):_vm._e()],1):_c('v-tabs',{staticClass:"layoutsearchweb tabsright",attrs:{"centered":"","dark":""}},[_c('v-tabs-slider',{staticStyle:{"display":"none"}}),_vm._v(" "),_c('v-tab',{staticClass:"headerlistDisabled tabsright",staticStyle:{"justify-content":"center !important"},attrs:{"disabled":""}},[_c('v-icon',{staticStyle:{"font-size":"20px !important","color":"#1a222b !important"}},[_vm._v("supervised_user_circle")])],1),_vm._v(" "),_c('v-tab',{staticClass:"headerlistDisabled tabsright",staticStyle:{"justify-content":"center !important"},attrs:{"disabled":""}},[_c('v-icon',{staticStyle:{"font-size":"20px !important","color":"#1a222b !important"}},[_vm._v("schedule")])],1)],1),_vm._v(" "),(_vm.detail.statemember == 'active')?_c('v-tabs-items',{staticClass:"layoutsearchweb",model:{value:(_vm.activeinfo),callback:function ($$v) {_vm.activeinfo=$$v},expression:"activeinfo"}},[_c('v-tab-item',{key:"1",staticClass:"layoutsearchweb",staticStyle:{"margin-top":"1vh !important"},attrs:{"id":"tab-1"}},[(_vm.detail.count_member != '0')?_c('v-subheader',{staticStyle:{"color":"white","font-weight":"900"}},[_c('v-layout',{staticStyle:{"background":"#1a222c"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xl6":"","md6":"","sm6":"","lg6":""}},[_vm._v("\n            "+_vm._s(_vm.$t('RightSide.member'))+" ("+_vm._s(_vm.detail.count_member)+")\n          ")]),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"right"},attrs:{"xl6":"","md6":"","sm6":"","lg6":""}},[_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"outline":"","small":"","rounded":"","color":"white"},on:{"click":function($event){_vm.ShowDialog('Invite')}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"white"}},[_vm._v("group_add")]),_vm._v(" "),_c('span',{staticStyle:{"color":"white","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('RightSide.menu.invite')))])],1)],1)],1)],1):_c('v-subheader',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('RightSide.noMember'))+"  ")]),_vm._v(" "),_c('div',{staticClass:"scrolling-wrapper",staticStyle:{"height":"35vh !important"}},[_vm._l((_vm.memberactive),function(membactive,index){return (_vm.detail.count_member != '0')?_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"background":"none !important","cursor":"pointer"},attrs:{"two-line":"","dense":""}},[_c('v-list-tile',{staticStyle:{"padding-left":"1vh !important","padding-right":"1vh !important"}},[_c('v-list-tile-avatar',{on:{"click":function($event){_vm.detailFriend(membactive)}}},[(membactive.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":membactive.profilepicture}}):(membactive.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(membactive.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"color":"white","white-space":"nowrap !important","width":"10em","word-break":"break-all !important"},on:{"click":function($event){_vm.detailFriend(membactive)}}},[_vm._v("\n                      "+_vm._s(membactive.nickname)+"\n                    ")]),_vm._v(" "),(membactive.tokenuser !== _vm.token && _vm.detail.statemember === 'active')?_c('v-list-tile-sub-title',[_c('v-btn',{staticClass:"btnkickgroup",attrs:{"depressed":"","small":"","dark":""},on:{"click":function($event){_vm.leavegroupFriend(membactive.tokenuser,membactive.name,index)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.kickMemberGroup')))])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-divider')],1):_vm._e()}),_vm._v(" "),(_vm.memberactive.length < parseInt(_vm.detail.count_member))?_c('v-btn',{staticClass:"CSChatThai loadmore",on:{"click":function($event){_vm.getmember()}}},[_vm._v("\n                "+_vm._s(_vm.$t('RightSide.loadmore'))+"\n              ")]):_vm._e()],2),_vm._v(" "),(_vm.edit === true)?_c('v-container',{staticStyle:{"padding-left":"15vw !important"}},[_c('v-btn',{staticClass:"CSChatThai",on:{"click":function($event){_vm.clickedit()}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n              ")])],1):_vm._e()],1),_vm._v(" "),(_vm.detail.count_pending != '0')?_c('v-tab-item',{key:"2",staticClass:"layoutsearchweb",staticStyle:{"margin-top":"1vh !important"},attrs:{"id":"tab-2"}},[(_vm.detail.count_pending != '0')?_c('v-subheader',{staticStyle:{"color":"white","font-weight":"900"}},[_vm._v(_vm._s(_vm.$t('RightSide.pending'))+" ("+_vm._s(_vm.detail.count_pending)+")")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"scrolling-wrapper",staticStyle:{"height":"35vh !important"}},[_vm._l((_vm.memberpending),function(membpending,index){return (_vm.detail.count_pending != '0')?_c('v-list',{key:membpending.tokenuser,staticClass:"layoutsearchweb",staticStyle:{"background":"none !important","cursor":"pointer"},attrs:{"two-line":"","dense":""}},[_c('v-list-tile',{staticStyle:{"padding-left":"1vh !important","padding-right":"1vh !important"}},[_c('v-list-tile-avatar',{on:{"click":function($event){_vm.detailFriend(membpending)}}},[(membpending.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":membpending.profilepicture}}):(membpending.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(membpending.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"color":"white","white-space":"nowrap !important","width":"10em","word-break":"break-all !important"},on:{"click":function($event){_vm.detailFriend(membpending)}}},[_vm._v("\n                      "+_vm._s(membpending.nickname)+"\n                    ")]),_vm._v(" "),(_vm.detail.statemember == 'active')?_c('v-list-tile-sub-title',[_c('v-btn',{staticClass:"btnallow",attrs:{"depressed":"","small":"","dark":""},on:{"click":function($event){_vm.cancelsendinvite(membpending.tokenuser,membpending.name)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancelInvite')))])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-divider')],1):_vm._e()}),_vm._v(" "),(_vm.memberpending.length < parseInt(_vm.detail.count_pending))?_c('v-btn',{staticClass:"CSChatThai loadmore",on:{"click":function($event){_vm.getpending()}}},[_vm._v("\n                "+_vm._s(_vm.$t('RightSide.loadmore'))+"\n              ")]):_vm._e()],2)],1):_vm._e(),_vm._v(" "),_c('v-tab-item',{key:"3",staticClass:"layoutsearchweb",staticStyle:{"margin-top":"1vh !important"},attrs:{"id":"tab-3"}},[_c('v-subheader',{staticStyle:{"color":"white","font-weight":"900"}},[_vm._v(_vm._s(_vm.$t('RightSide.header.image')))]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[(_vm.listimageinroom.length != 0)?_c('v-card',{staticStyle:{"background":"#1b232d","box-shadow":"none !important"}},[_c('v-container',_vm._b({staticStyle:{"padding":"0px !important"},attrs:{"fluid":""}},'v-container',( _obj$1 = {}, _obj$1["grid-list-sm"] = true, _obj$1 ),false),[_c('v-layout',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"38vh"},attrs:{"row":"","wrap":""}},[_vm._l((_vm.listimageinroom),function(image,index){return _c('v-flex',{staticStyle:{"cursor":"pointer"},attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-media',{attrs:{"src":image.path,"height":"15vh"},on:{"click":function($event){_vm.zoom(image)}}})],1)],1)}),_vm._v(" "),(_vm.showmoreimage)?_c('v-flex',{staticStyle:{"cursor":"pointer"},attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-card',{staticStyle:{"background":"none"},attrs:{"flat":"","tile":""}},[_c('v-card-media',{staticStyle:{"color":"white","text-align":"center","display":"flex","justify-content":"center"},attrs:{"height":"15vh"},on:{"click":function($event){_vm.getimage(_vm.listimageinroom[_vm.listimageinroom.length - 1].timestamp)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('ChatSide.Read.readmore'))+"\n                        ")])],1)],1):_vm._e()],2)],1)],1):_c('p',{staticStyle:{"color":"white","text-align":"center"}},[_vm._v(" "+_vm._s(_vm.$t('RightSide.noImage')))])],1)],1),_vm._v(" "),_c('v-tab-item',{key:"4",staticClass:"layoutsearchweb",staticStyle:{"margin-top":"1vh !important"},attrs:{"id":"tab-4"}},[_c('v-subheader',{staticStyle:{"color":"white","font-weight":"900"}},[_vm._v(_vm._s(_vm.$t('RightSide.header.file')))]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[(_vm.listfileinroom.length != 0)?_c('v-card',{staticClass:"scrolling-wrapper",staticStyle:{"background":"#1b232d","max-height":"35vh"}},[_vm._l((_vm.listfileinroom),function(file,index){return _c('v-list',{staticClass:"layoutsearchweb",attrs:{"dark":"","two-line":"","dense":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',{attrs:{"href":file.path,"target":"_blank"}},[_c('v-icon',{staticStyle:{"color":"#1da1f2"},attrs:{"large":""}},[_vm._v(_vm._s(_vm.extension(file.path)))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"color":"white !important","white-space":"nowrap","width":"15em","overflow":"hidden","text-overflow":"ellipsis"},attrs:{"href":file.path,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(file.file_name))])]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"CSChatThai"},[_c('v-btn',{staticClass:"btnallow",attrs:{"depressed":"","small":"","href":file.path,"target":"_blank"}},[_vm._v("\n                          "+_vm._s(_vm.$t('AnswerQuestion.download'))+"\n                        ")]),_vm._v(" "),_c('v-btn',{staticClass:"btncancel",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.sendonebox(file.tokenmessage)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('AnswerQuestion.Onebox'))+"\n                        ")])],1)],1)],1),_vm._v(" "),(index != _vm.listfileinroom.length-1)?_c('v-divider'):_vm._e()],1)}),_vm._v(" "),(_vm.showmorefile)?_c('div',{staticStyle:{"display":"flex","justify-content":"center","width":"100%"}},[_c('v-btn',{staticClass:"btncancel",staticStyle:{"display":"flex","justify-content":"center","text-transform":"none","color":"white !important","text-align":"center"},attrs:{"depressed":"","dark":""},on:{"click":function($event){_vm.getfile(_vm.listfileinroom[_vm.listfileinroom.length - 1].timestamp)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.Read.readmore'))+"\n                  ")])],1):_vm._e()],2):_c('p',{staticStyle:{"color":"white","text-align":"center"}},[_vm._v(" "+_vm._s(_vm.$t('RightSide.noFile')))])],1)],1)],1):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),_c('Openwebsite',{attrs:{"dialogopenwebsite":_vm.dialogopenwebsite,"id":_vm.id,"type":_vm.type},on:{"closeDialog":_vm.closeDialog}}),_vm._v(" "),_c('InviteGroup',{attrs:{"dialogInvite":_vm.dialogInvite,"memberpending":_vm.memberpending,"member":_vm.memberactive,"group_id":_vm.detail.group_id},on:{"closeInvite":_vm.closeInvite,"invitemembergroup":_vm.invitemembergroup}}),_vm._v(" "),_c('ManageGroup',{attrs:{"dialogManageGroup":_vm.dialogManageGroup,"detail":_vm.detail},on:{"closeManageGroup":_vm.closeManageGroup}}),_vm._v(" "),_c('ShowQRCodeGroup',{attrs:{"dialogShowQRCode":_vm.dialogShowQRCode,"detail":_vm.detail},on:{"closeShowQRCodeGroup":_vm.closeShowQRCodeGroup}}),_vm._v(" "),_c('NoteDialog',{attrs:{"dialogNote":_vm.dialogNote,"note_id":_vm.note_id},on:{"closeNote":_vm.closeNote,"editNote":_vm.editNote,"removeNote":_vm.removeNote}}),_vm._v(" "),_c('CreateNoteDialog',{attrs:{"dialogCreatenote":_vm.dialogCreatenote,"tokenroom":_vm.room},on:{"closeCreatenote":_vm.closeCreatenote,"CreateNote":_vm.CreateNote}}),_vm._v(" "),_c('AlbumsDialog',{attrs:{"dialogAlbums":_vm.dialogAlbums,"albums_id":_vm.albums_id},on:{"closeAlbums":_vm.closeAlbums,"editAlbums":_vm.editAlbums,"removeAlbums":_vm.removeAlbums}}),_vm._v(" "),_c('CreateAlbumsDialog',{attrs:{"dialogCreatealbums":_vm.dialogCreatealbums,"tokenroom":_vm.room},on:{"closeCreatealbums":_vm.closeCreatealbums,"CreateAlbums":_vm.CreateAlbums}}),_vm._v(" "),_c('ShowImageProfileDialog',{attrs:{"dialogshowimage_profile":_vm.dialogshowimage_profile,"pathpicture":_vm.pathpicture,"typepathpicture":_vm.typepathpicture},on:{"closeDialogShowImage_Profile":_vm.closeDialogShowImage_Profile}}),_vm._v(" "),_c('Wallpaper',{attrs:{"dialogwallpaper":_vm.dialogwallpaper},on:{"closeWallpaper":_vm.closeWallpaper}}),_vm._v(" "),_c('SaveOnebox',{attrs:{"dialogSaveOnebox":_vm.dialogSaveOnebox,"tokenmessage_savebox":_vm.tokenmessage_savebox},on:{"closeSaveOnebox":_vm.closeSaveOnebox}}),_vm._v(" "),_c('checkconsentdialog',{attrs:{"checkconsentDialog":_vm.checkconsentDialog,"url_consent":_vm.url_consent},on:{"closeDialogConsent":_vm.closeDialogConsent}}),_vm._v(" "),_c('CheckBrowserDialog',{attrs:{"checkBrowserDialog":_vm.checkBrowserDialog,"checkBrowserInfor":_vm.checkBrowserInfor},on:{"closeCheckBrowser":_vm.closeCheckBrowser}})],1):_c('v-layout',{staticClass:"rightbox CSChatThai",attrs:{"row":"","wrap":""}})
var _obj;
var _obj$1;}
var RightSide_staticRenderFns = []
var RightSide_esExports = { render: RightSide_render, staticRenderFns: RightSide_staticRenderFns }
/* harmony default export */ var layout_RightSide = (RightSide_esExports);
// CONCATENATED MODULE: ./src/components/chat/layout/RightSide.vue
function RightSide_injectStyle (ssrContext) {
  __webpack_require__("dXC7")
}
var RightSide_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RightSide___vue_template_functional__ = false
/* styles */
var RightSide___vue_styles__ = RightSide_injectStyle
/* scopeId */
var RightSide___vue_scopeId__ = "data-v-791ec3dc"
/* moduleIdentifier (server only) */
var RightSide___vue_module_identifier__ = null
var RightSide_Component = RightSide_normalizeComponent(
  RightSide,
  layout_RightSide,
  RightSide___vue_template_functional__,
  RightSide___vue_styles__,
  RightSide___vue_scopeId__,
  RightSide___vue_module_identifier__
)

/* harmony default export */ var chat_layout_RightSide = (RightSide_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/layout/LayoutChat.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var LayoutChat = ({
  data: function data() {
    return {
      // status_login: ''
    };
  },

  components: {
    CenterSide: chat_layout_CenterSide,
    RightSide: chat_layout_RightSide
  },
  created: function created() {
    // this.status_login = this.$cookie.get('status_login')
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c113218","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/layout/LayoutChat.vue
var LayoutChat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"overflow":"hidden !important"},attrs:{"fluid":""}},[_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"z-index":"8"},attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('CenterSide',{staticStyle:{"z-index":"8"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"z-index":"0"},attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('RightSide')],1)],1)],1)}
var LayoutChat_staticRenderFns = []
var LayoutChat_esExports = { render: LayoutChat_render, staticRenderFns: LayoutChat_staticRenderFns }
/* harmony default export */ var layout_LayoutChat = (LayoutChat_esExports);
// CONCATENATED MODULE: ./src/components/chat/layout/LayoutChat.vue
function LayoutChat_injectStyle (ssrContext) {
  __webpack_require__("QAlu")
}
var LayoutChat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LayoutChat___vue_template_functional__ = false
/* styles */
var LayoutChat___vue_styles__ = LayoutChat_injectStyle
/* scopeId */
var LayoutChat___vue_scopeId__ = "data-v-9c113218"
/* moduleIdentifier (server only) */
var LayoutChat___vue_module_identifier__ = null
var LayoutChat_Component = LayoutChat_normalizeComponent(
  LayoutChat,
  layout_LayoutChat,
  LayoutChat___vue_template_functional__,
  LayoutChat___vue_styles__,
  LayoutChat___vue_scopeId__,
  LayoutChat___vue_module_identifier__
)

/* harmony default export */ var chat_layout_LayoutChat = (LayoutChat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/onemeet/LayoutOnemeet.vue
//
//
//
//
//
//
//


/* harmony default export */ var LayoutOnemeet = ({
  data: function data() {
    return {
      linkonemeet: '',
      progress: false,
      token: '',
      one_id: ''
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    // console.log(decoded)
    this.token = decoded['tokenuser'];
    this.get_oneid();
  },

  methods: {
    get_oneid: function get_oneid() {
      var _this = this;

      this.progress = true;
      this.axios.get("https://uatchat-manage.one.th/go_api/api" + ('/v1/getOneID/' + this.token)).then(function (response) {
        if (response.data.status === 'success') {
          _this.one_id = response.data.one_id;
          // get_encode_shared_token
          _this.axios.post("https://uatchat-manage.one.th/message" + '/api/v1/get_shared_token', { user_id: _this.one_id }).then(function (response) {
            if (response.data.status === 'success') {
              _this.progress = false;
              _this.linkonemeet = '' + "https://meet-test.one.th/?sharetoken=" + response.data.data.shared_token;
              // this.linkonemeet = `${process.env.linkonemeet}${response.data.data.encode_shared_token}`
              // console.log(this.linkonemeet)
            }
          }).catch(function (error) {
            console.log(error);
            _this.$swal('', _this.$t('Alert.Fail.default.somethingWrong'), 'error');
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this.$swal('', _this.$t('Alert.Fail.default.somethingWrong'), 'error');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dac150d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/onemeet/LayoutOnemeet.vue
var LayoutOnemeet_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"height":"100%"},attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(_vm.progress)?_c('v-progress-circular',{attrs:{"size":100,"color":"primary","width":8,"indeterminate":_vm.progress}}):_c('iframe',{staticStyle:{"width":"100vw !important","height":"calc(100vh - 64px) !important","border-width":"0px !important"},attrs:{"src":_vm.linkonemeet,"allow":"camera *; microphone; autoplay; display-capture;"}})],1)}
var LayoutOnemeet_staticRenderFns = []
var LayoutOnemeet_esExports = { render: LayoutOnemeet_render, staticRenderFns: LayoutOnemeet_staticRenderFns }
/* harmony default export */ var onemeet_LayoutOnemeet = (LayoutOnemeet_esExports);
// CONCATENATED MODULE: ./src/components/chat/onemeet/LayoutOnemeet.vue
function LayoutOnemeet_injectStyle (ssrContext) {
  __webpack_require__("Qok8")
}
var LayoutOnemeet_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LayoutOnemeet___vue_template_functional__ = false
/* styles */
var LayoutOnemeet___vue_styles__ = LayoutOnemeet_injectStyle
/* scopeId */
var LayoutOnemeet___vue_scopeId__ = "data-v-1dac150d"
/* moduleIdentifier (server only) */
var LayoutOnemeet___vue_module_identifier__ = null
var LayoutOnemeet_Component = LayoutOnemeet_normalizeComponent(
  LayoutOnemeet,
  onemeet_LayoutOnemeet,
  LayoutOnemeet___vue_template_functional__,
  LayoutOnemeet___vue_styles__,
  LayoutOnemeet___vue_scopeId__,
  LayoutOnemeet___vue_module_identifier__
)

/* harmony default export */ var chat_onemeet_LayoutOnemeet = (LayoutOnemeet_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/onemeet/ChatSideOnemeet.vue
var ChatSideOnemeet = __webpack_require__("NDrL");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-163d15db","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/onemeet/ChatSideOnemeet.vue
var ChatSideOnemeet_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"centerbox CSChatThai",staticStyle:{"overflow":"hidden !important"},attrs:{"row":"","wrap":""}},[_c('offline',{on:{"detected-condition":_vm.handleConnectivityChange}}),_vm._v(" "),_c('div',{staticClass:"chatbox"},[_c('vue-context',{ref:"menu",staticStyle:{"z-index":"1500"}},_vm._l((_vm.ListMenuRightClick),function(list){return _c('li',[_c('a',{on:{"click":function($event){_vm.SelectMenuRightClick(list.methods)}}},[_vm._v(_vm._s(list.message))])])})),_vm._v(" "),_c('ShowPDFDialog',{attrs:{"dialogshowfile":_vm.dialogshowfile,"DetailFile":_vm.DetailFile},on:{"closeDialogShowFile":_vm.closeDialogShowFile}}),_vm._v(" "),_c('ShowImageDialog',{attrs:{"dialogshowimage":_vm.dialogshowimage,"DetailImage":_vm.DetailImage},on:{"closeDialogShowImage":_vm.closeDialogShowImage}}),_vm._v(" "),_c('form',{ref:"fileformChat"},[_c('div',{staticClass:"chatlogs",style:(_vm.chatlogsFlex),attrs:{"id":"myscroll"},on:{"scroll":_vm.scrollFunction}},[(_vm.listannounce.length != 0)?_c('div',[(_vm.less)?_c('v-btn',{staticStyle:{"position":"fixed","right":"26%","z-index":"2","background":"#2562afd4"},attrs:{"fab":"","dark":"","small":""},on:{"click":function($event){_vm.less = !_vm.less;_vm.show = false;}}},[_c('v-icon',{staticStyle:{"font-size":"15px"}},[_vm._v("fas fa-bullhorn")])],1):_c('v-card',{staticStyle:{"position":"fixed","width":"calc(100vw - calc(50% - -20px))","z-index":"2","margin-left":"-15px","margin-top":"-5px","background":"none"},attrs:{"id":"list_height"}},[_c('v-slide-y-transition',[_c('v-card-text',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticStyle:{"padding":"0px !important"}},[_c('v-list',{staticClass:"scrolling-wrapper-y",staticStyle:{"max-height":"200px"}},[_vm._l((_vm.listannounce),function(item,index){return [_c('v-list-tile',{key:item.index,staticClass:"list-announce",attrs:{"avatar":""},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['cancel_announce'], item)}}},[_c('v-list-tile-action',[_c('v-icon',{staticStyle:{"font-size":"18px"}},[_vm._v("fas fa-bullhorn")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"font-size":"13px"},domProps:{"innerHTML":_vm._s(_vm.convertMention(item.message_info.message))}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(item.nickname))])],1)],1),_vm._v(" "),(index + 1 < _vm.listannounce.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1)],1),_vm._v(" "),(!_vm.show)?_c('v-card-actions',{staticStyle:{"background":"#2562afa6","height":"40px"}},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#1b232c"}},[_vm._v("fas fa-bullhorn")]),_vm._v(" "),_c('p',{staticClass:"mb-0",staticStyle:{"color":"black","padding-left":"20px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap","width":"100%","cursor":"pointer","font-size":"13px"},domProps:{"innerHTML":_vm._s(_vm.convertMentionAnnounce(_vm.listannounce[0].message_info.message))},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['cancel_announce'], _vm.listannounce[0])}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.show = !_vm.show}}},[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1)],1):_vm._e(),_vm._v(" "),(_vm.show)?_c('v-card-actions',{staticStyle:{"color":"white","background":"#2562af","height":"40px"}},[_c('p',{staticClass:"p-announce",on:{"click":function($event){_vm.delete_announce()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.announce.delete')))]),_vm._v("\n          |\n          "),_c('p',{staticClass:"p-announce",on:{"click":function($event){_vm.less = !_vm.less}}},[_vm._v(_vm._s(_vm.$t('ChatSide.announce.minimize')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.show = !_vm.show}}},[_c('v-icon',{staticStyle:{"color":"white"}},[_vm._v("keyboard_arrow_up")])],1)],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.progressLoadChat)?_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":_vm.progressLoadChat}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item,i){return (!_vm.ForwardState)?_c('div',{key:item.id},[(i == 0)?_c('div',[(_vm.tokenrooomSelect===item.tokenroom)?_c('div',{staticClass:"conversation-start",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.dateMoment(item.timestamp)))])]):_vm._e()]):(_vm.dateMoment(item.timestamp) != _vm.dateMoment(_vm.items[i-1].timestamp))?_c('div',[_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[(_vm.tokenrooomSelect===item.tokenroom)?_c('div',{staticClass:"conversation-start",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.dateMoment(item.timestamp)))])]):_vm._e()])],1):_vm._e(),_vm._v(" "),(item.tokenuser != _vm.token && _vm.tokenrooomSelect == item.tokenroom && i == 0 && item.typeofmessage != 'unsend_message' && item.typeofmessage != 'system' && item.typeofmessage != 'system_action' && item.typeofmessage != 'system_action_albums' && item.typeofmessage != 'system_action_task')?_c('p',{staticClass:"text",staticStyle:{"text-align":"left","margin-left":"calc(48px + 1vw)","margin-bottom":"0px","color":"#8e8e8e","font-size":"10px"}},[_vm._v(_vm._s(item.nickname))]):(item.typeofmessage != 'system_action' && item.typeofmessage != 'system' && item.typeofmessage != 'unsend_message' && item.typeofmessage != 'system_action_albums' && item.typeofmessage != 'system_action_task' && item.tokenuser != _vm.token && _vm.tokenrooomSelect == item.tokenroom && (_vm.dateMoment(item.timestamp) != _vm.dateMoment(_vm.items[i-1].timestamp) || _vm.items[i-1].tokenuser != item.tokenuser))?_c('p',{staticClass:"text",staticStyle:{"text-align":"left","margin-left":"calc(48px + 1vw)","margin-bottom":"0px","color":"#8e8e8e","font-size":"10px"}},[_vm._v("\n          "+_vm._s(item.nickname))]):_vm._e(),_vm._v(" "),(item.tokenuser === _vm.token && _vm.tokenrooomSelect===item.tokenroom)?_c('div',{staticClass:"chat self"},[(item.typeofmessage === 'unsend_message')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.cancelMsg'))+"\n            ")])]):(item.typeofmessage === 'system_action_albums')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_name_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.editNameAlbum'))+"\n            ")]):(item.message == 'create_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.createAlbum',{name: item.albums_name}))+"\n            ")]):(item.message == 'delete_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.deleteAlbum'))+"\n            ")]):(item.message == 'delete_images_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.deleteImageAlbum'))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system_action_task')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_task')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.editTask'))+"\n            ")]):(item.message == 'create_project')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.createProject'))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(item.message)+"\n            ")])]):(item.typeofmessage === 'system_action')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxself_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" น.")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message === 'active')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.self.joinGroup'))+"\n              ")]):(item.message === 'kick')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'invite')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'leave')?_c('span',[_vm._v("\n               "+_vm._s(_vm.$t('ChatSide.system.self.leftGroup'))+"\n              ")]):_vm._e()])]):_c('v-flex',{staticStyle:{"padding-right":"0px"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":"","align-end":""}},[_c('span',{staticClass:"pr-2",staticStyle:{"font-size":"10px","color":"#424242"}},[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),(item.typeofmessage === 'message')?_c('div',{ref:"testTT",refInFor:true,staticClass:"boxself",staticStyle:{"height":"100%"},attrs:{"id":"testTT"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention', 'cancel', 'announce'], item)}}},[_c('p',{staticStyle:{"margin":"0 !important"},attrs:{"slot":"activator"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))},on:{"click":_vm.handleClickTest},slot:"activator"}),_vm._v(" "),_vm._l((_vm.convertURL(item.message)),function(x){return (_vm.convertURL(item.message))?_c('div',[_c('link-prevue',{attrs:{"url":x},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"row":"","wrap":""},on:{"click":function($event){_vm.clicklink_website(props.url)}}},[_c('v-flex',{staticClass:"border_website",attrs:{"xl9":"","lg9":"","md9":"","sm9":""}},[_c('p',{staticClass:"title_website"},[_vm._v(_vm._s(props.title)+"  ")]),_vm._v(" "),_c('span',{staticClass:"description_website"},[_vm._v(_vm._s(props.description))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerimg_website",attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[(props.img)?_c('img',{staticClass:"img_website",attrs:{"src":props.img}}):_vm._e()])],1)]}}])},[_c('template',{slot:"loading"},[_c('span')])],2)],1):_vm._e()})],2):(item.typeofmessage === 'mention_message')?_c('p',{staticClass:"boxself",attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention'], item)}},slot:"activator"},[(item.source_message.typeofmessage !== 'unsend_message')?_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(item.source_message.owner_source_message.path_pic)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":item.source_message.owner_source_message.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"40px"},attrs:{"xs11":""}},[(item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.convertMention(item.source_message.message))},on:{"click":_vm.handleClickTest}})]):(item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.typeofmessage === 'image')?_c('span',[_vm._v("\n                          "+_vm._s(_vm.$t('ChatSide.image'))+"\n                        ")]):_c('span',[_vm._v("\n                        "+_vm._s(_vm.$t('ChatSide.sticker'))+"\n                      ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"10px","float":"right"},attrs:{"src":item.source_message.message}})])],1):(item.source_message.typeofmessage === 'file')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(_vm.extension(item.source_message.message) === 'pdf')?_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v(_vm._s(_vm.extension(item.source_message.message)))])],1)],1):(item.source_message.typeofmessage === 'video')?_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.extension(item.source_message.message) === 'media')?_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"150","height":"150","controls":""}},[_c('source',{attrs:{"src":item.source_message.message,"type":'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]}})]):_c('div',{staticStyle:{"width":"100%","height":"150px","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"150px !important"},attrs:{"playerOptions":{
                              type: 'application/x-mpegURL',
                              src: item.source_message.message,
                              preload: true,
                              autoplay: false,
                              isLoop: false,
                              playsinline: false,
                              poster: '',
                              controls: 'progress,current,durration,volume',
                              crossOrigin: false
                            }},on:{"onplay":_vm.play}})],1)])],1):(item.source_message.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.address !== '')?_c('span',[_vm._v(_vm._s(item.source_message.address))]):_c('span',[_vm._v(_vm._s(item.source_message.message))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-map-marker-alt")])],1)],1):_vm._e()],1)],1):_c('v-layout',{staticStyle:{"padding-bottom":"10px","color":"#6f6f6f"},attrs:{"row":"","wrap":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.noMsg')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))},on:{"click":_vm.handleClickTest}})],1):(item.typeofmessage === 'official_template')?_c('div',{staticClass:"boxselfquestion",staticStyle:{"overflow":"hidden","display":"-webkit-inline-box","background":"none"}},[_c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px","background":"#b4d1f5 !important"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562af","padding-left":"12px","padding-top":"10px","padding-bottom":"10px"}},[_vm._v(_vm._s(item.element.title))]),_vm._v(" "),(item.element.image)?_c('v-img',{staticStyle:{"height":"160px"},attrs:{"src":item.element.image,"contain":""}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('read-more',{staticClass:"mb-0",staticStyle:{"color":"#343433"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":100}}),_vm._v(" "),(!item.element.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((item.element.choice),function(choice,index){return _c('div',[_c('v-btn',{style:(_vm.checkbutton(choice.color,choice.background)),attrs:{"flat":"","disabled":(choice.disable == '0')? false: true},on:{"click":function($event){_vm.btn_official_template(choice, item.tokenuser, item.tokenmessage)}}},[_vm._v("\n                            "+_vm._s(choice.label)+"\n                          ")])],1)})],2)])],1)],1)]):(item.typeofmessage === 'image')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"250px"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['albums', 'mention', 'cancel', 'sendmail'], item)}},slot:"activator"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"none","border-radius":"10px","display":"flex","justify-content":"center","cursor":"pointer"}},[_c('v-card-media',{staticClass:"white--text ",attrs:{"height":"200px","src":item.message},on:{"click":function($event){_vm.zoom(item)}}})],1)],1)],1)],1):(item.typeofmessage === 'sticker')?_c('div',{staticClass:"boxselfsticker",attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention', 'cancel'], item)}},slot:"activator"},[_c('img',{staticStyle:{"width":"150px","cursor":"pointer"},attrs:{"src":item.file_name}})]):(item.typeofmessage === 'albums_message' && item.image_add.length === 0)?_c('div',{staticStyle:{"display":"none"},attrs:{"slot":"activator"},slot:"activator"}):(item.typeofmessage === 'albums_message' && item.image_add.length !== 0)?_c('div',{staticClass:"boxself_createablums",staticStyle:{"width":"240px"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailAlbums(item.file_name)}},slot:"activator"},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#3a506d !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#3a506d !important"}},[_vm._v("\n                  "+_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', {name: item.albums_name}))+"\n                ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"color":"#3a506d91 !important"}},[_vm._v("\n                  "+_vm._s(_vm.$t('ChatSide.Album.numberImage', {count: item.image_add.length}))+"\n                ")]),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"#31394121 !important"}}),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',{staticStyle:{"color":"#4c6281 !important"}},[_vm._v(_vm._s(item.albums_name))]):_c('h4',{staticStyle:{"color":"#4c6281 !important"}},[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px","color":"#4c6281 !important"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'web')?_c('div',{staticClass:"boxself",attrs:{"slot":"activator"},slot:"activator"},[_c('iframe',{staticStyle:{"visibility":"visible"},attrs:{"width":"300","height":"400","frameborder":"0","src":item.message}})]):(item.typeofmessage === 'note')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailNote(item.note_id)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',{staticStyle:{"color":"black"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length == 20)?_c('p',[_vm._v(" ...")]):_vm._e()])],1),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#4c6281 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#4c6281 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'create_task')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#3a506d"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#3a506db3"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#6981a1 !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()}),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"#e6ecf3","outline":"","text-color":"#3a506d"}},[_vm._v("\n                        "+_vm._s(item.task_info.state.name)+"\n                      ")])],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#6981a1 !important"}},[_vm._v("\n                      "+_vm._s(_vm.$t('ChatSide.Task.viewDetail'))+"\n                    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#6981a1 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'assign_task')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#3a506d"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#3a506db3"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#6981a1 !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()})],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#6981a1 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Task.editAssign')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#6981a1 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'contact')?_c('div',{staticClass:"boxself",staticStyle:{"font-weight":"500","cursor":"pointer","border-radius":"15px !important"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailFriend(item.message)}},slot:"activator"},[_c('v-avatar',{staticClass:"user-photo"},[(item.pic_contact)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.pic_contact}}):(item.type_contact === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"textchat",staticStyle:{"margin-right":"15px"}},[_vm._v(_vm._s(item.nickname_contact))]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"50%","-ms-transform":"translateY(-50%)","transform":"translateY(-50%)","right":"0"}},[_c('v-icon',[_vm._v("navigate_next")])],1)],1):(item.typeofmessage === 'file' && (_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media' || _vm.extension(item.file_name) === 'audio'))?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"300px"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)}},slot:"activator"},[_c('v-card',{staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","width":"100%"}},[(_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media')?_c('v-card-media',{staticStyle:{"border-radius":"10px","cursor":"pointer"},attrs:{"height":"200px"},on:{"click":function($event){_vm.zoomfile(item, true)},"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)}}},[(_vm.extension(item.file_name) === 'pdf')?_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":item.message,"page":1}}):(_vm.extension(item.file_name) === 'media')?_c('video',{staticStyle:{"border-radius":"10px","height":"190px","cursor":"pointer"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_vm._e()],1):(_vm.extension(item.file_name) === 'audio')?_c('v-card-media',{staticStyle:{"width":"280px","border-radius":"10px","cursor":"pointer"},attrs:{"height":"55px"}},[_c('audio',{staticStyle:{"border-radius":"10px","width":"260px","display":"flex"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_vm._e(),_vm._v(" "),(_vm.extension(item.file_name) !== 'audio')?_c('v-card-title',{staticStyle:{"padding-top":"10px","padding-left":"0px","padding-bottom":"10px","cursor":"pointer"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"14px","color":"white"}},[_vm._v("("+_vm._s(item.file_name)+")\n                    ")])]):_vm._e()],1)],1):(item.typeofmessage === 'file')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"300px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"70px !important","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(item.file_name))+"\n                      ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card-title',{staticStyle:{"text-align":"left"},attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"width":"160px","word-break":"break-all !important"}},[_vm._v(_vm._s(item.file_name))])])])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticStyle:{"margin-right":"10px"},attrs:{"slot":"activator","flat":"","icon":"","color":"white"},on:{"click":function($event){_vm.zoomfile(item, false)}},slot:"activator"},[_c('v-icon',[_vm._v("file_download")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.download')))])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"white"},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}},slot:"activator"},[_c('v-icon',[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.sendOnebox')))])],1)],1)],1)],1):(item.typeofmessage === 'video')?_c('div',{staticClass:"boxselffile",staticStyle:{"max-height":"250px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.zoomfile(item, true)},"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)}},slot:"activator"},[(_vm.extension(item.message) === 'media')?_c('video',{attrs:{"slot":"activator","width":"100%","height":"250","controls":""},slot:"activator"},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_c('vplayer',{attrs:{"playerOptions":{
                    type: 'application/x-mpegURL',
                    src: item.message,
                    preload: true,
                    autoplay: false,
                    isLoop: false,
                    playsinline: false,
                    poster: item.thumbnail,
                    controls: 'progress,current,durration,volume',
                    crossOrigin: false
                  }},on:{"onplay":_vm.play}})],1):(item.typeofmessage === 'location')?_c('div',{staticClass:"boxselffile",staticStyle:{"max-width":"250px","min-width":"150px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.openlocation(item)},"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'cancel'], item)}},slot:"activator"},[_c('v-card',{staticStyle:{"background":"#b4d1f5 !important","border-radius":"20px","padding":"10px","padding-bottom":"10px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"},attrs:{"raw":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"}},[_vm._v("place")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"color":"black","padding-left":"10px"},attrs:{"xs10":"","sm10":"","md10":"","lg10":"","xl10":""}},[(item.file_name != '')?_c('span',[_vm._v(" "+_vm._s(item.file_name))]):_c('span',[_vm._v(" somewhere")])])],1)],1)],1):(item.typeofmessage === 'date')?_c('p',{staticClass:"boxself",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n              ")],1):(item.typeofmessage === 'datetime')?_c('p',{staticClass:"boxself",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n                "),_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v(" far fa-clock")]),_vm._v("   เวลา "+_vm._s(item.message.split('T')[1])+" น.\n              ")],1):(item.typeofmessage === 'call')?_c('div',{staticClass:"boxself",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='decline')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel' || item.message =='decline')?_c('span',[_vm._v("\n                  "+_vm._s(_vm.checktypeCall(item.message))+"\n                ")]):_c('span',[_vm._v(_vm._s(_vm.secondsToHms(item.time_count)))])],1):(item.typeofmessage === 'agora_call')?_c('div',{staticClass:"boxself",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='end')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel')?_c('span',[_vm._v("\n                  "+_vm._s(_vm.checktypeCall(item.message))+"\n                ")]):_c('span',[_vm._v(_vm._s(item.time))])],1):(item.typeofmessage === 'conference_msg')?_c('div',{staticClass:"boxself",staticStyle:{"text-align":"center","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.information.option == 'voice')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startCall')))],1):(item.information.option == 'video')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("videocam")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startVideo')))],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"joinBtn",on:{"click":function($event){_vm.backCall_conference_msg(item.information)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.conference.joinCall'))+" ")])],1):_c('p',{staticClass:"boxself",staticStyle:{"color":"#6d6d6d !important"},attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.notSupportVersion'))+"\n              ")])]),_vm._v(" "),(item.status=='no' && item.typeofmessage == 'message')?_c('v-tooltip',{attrs:{"top":""}},[_c('span',{staticStyle:{"text-align":"right","margin-bottom":"0px","color":"#616161","font-size":"10px","margin-left":"10vw","float":"right"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.resendMessage(item)}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"7px !important","cursor":"pointer"}},[_vm._v("autorenew")])],1),_vm._v(" "),_c('span',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('ChatSide.resend'))+" ")])]):(item.status=='no' && item.typeofmessage == 'contact')?_c('v-tooltip',{attrs:{"top":""}},[_c('span',{staticStyle:{"text-align":"right","margin-bottom":"0px","color":"#616161","font-size":"10px","margin-left":"10vw","float":"right"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.resendContact(item)}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"7px !important","cursor":"pointer"}},[_vm._v("autorenew")])],1),_vm._v(" "),_c('span',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('ChatSide.resend'))+" ")])]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(item.tokenuser !== _vm.token && _vm.tokenrooomSelect === item.tokenroom)?_c('div',{staticClass:"chat friend"},[(item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system' && item.typeofmessage !== 'system_action' && item.typeofmessage !== 'system_action_albums' && item.typeofmessage !== 'system_action_task')?_c('v-flex',{staticStyle:{"cursor":"pointer","margin-top":"1vh"},attrs:{"xl1":"","lg1":"","md1":"","sm1":""}},[((item.typeofmessage != 'albums_message' || item.image_add.length != 0))?_c('v-avatar',{staticClass:"user-photo",on:{"click":function($event){_vm.detailFriend(item.tokenuser)}}},[(item.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.path_pic}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):_vm._e()],1):_vm._e(),_vm._v(" "),(item.typeofmessage === 'unsend_message')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.cancelMsg', {name: item.nickname}))+"\n            ")])]):(item.typeofmessage === 'system_action_albums')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_name_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.editNameAlbum', {name: item.nickname}))+"\n            ")]):(item.message == 'create_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.createAlbum', {name: item.nickname, albums_name:item.albums_name}))+"\n            ")]):(item.message == 'delete_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.deleteAlbum', {name: item.nickname}))+"\n            ")]):(item.message == 'delete_images_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.deleteImageAlbum', {name: item.nickname}))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system_action_task')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_task')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.editTask', {name: item.nickname}))+"\n            ")]):(item.message == 'create_project')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.createProject', {name: item.nickname}))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxother_system"},[_vm._v("\n              "+_vm._s(item.message)+"\n            ")])]):(item.typeofmessage === 'system_action')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxother_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" น.")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message === 'active')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.other.joinGroup', {name: item.nickname}))+"\n              ")]):(item.message === 'kick')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'invite')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'leave')?_c('span',[_vm._v("\n                 "+_vm._s(_vm.$t('ChatSide.system.other.leftGroup', {name: item.nickname}))+"\n              ")]):_vm._e()])]):_c('v-flex',{staticStyle:{"padding-right":"0px","margin-left":"1vw"},attrs:{"xl8":"","lg8":"","md8":"","sm8":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-end":"","justify-start":""}},[(item.typeofmessage === 'message')?_c('div',{staticClass:"boxfriend",on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention', 'announce'], item)}}},[_c('p',{staticStyle:{"margin":"0 !important"},attrs:{"slot":"activator"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))},on:{"click":_vm.handleClickTest},slot:"activator"}),_vm._v(" "),_vm._l((_vm.convertURL(item.message)),function(x){return (_vm.convertURL(item.message))?_c('div',[_c('link-prevue',{attrs:{"url":x},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"row":"","wrap":""},on:{"click":function($event){_vm.clicklink_website(props.url)}}},[_c('v-flex',{staticClass:"border_website",attrs:{"xl9":"","lg9":"","md9":"","sm9":""}},[_c('p',{staticClass:"title_website"},[_vm._v(_vm._s(props.title))]),_vm._v(" "),_c('span',{staticClass:"description_website"},[_vm._v(_vm._s(props.description))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerimg_website",attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[(props.img)?_c('img',{staticClass:"img_website",attrs:{"src":props.img}}):_vm._e()])],1)]}}])},[_c('template',{slot:"loading"},[_c('span')])],2)],1):_vm._e()})],2):(item.typeofmessage === 'mention_message')?_c('p',{staticClass:"boxfriend",attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention'], item)}},slot:"activator"},[(item.source_message.typeofmessage !== 'unsend_message')?_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(item.source_message.owner_source_message.path_pic)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":item.source_message.owner_source_message.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"40px"},attrs:{"xs11":""}},[(item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.convertMention(item.source_message.message))},on:{"click":_vm.handleClickTest}})]):(item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.typeofmessage === 'image')?_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.image')))]):_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.sticker')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"10px","float":"right"},attrs:{"src":item.source_message.message}})])],1):(item.source_message.typeofmessage === 'file')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(_vm.extension(item.source_message.message) === 'pdf')?_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v(_vm._s(_vm.extension(item.source_message.message)))])],1)],1):(item.source_message.typeofmessage === 'video')?_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.extension(item.source_message.message) === 'media')?_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"150","height":"150","controls":""}},[_c('source',{attrs:{"src":item.source_message.message,"type":'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]}})]):_c('div',{staticStyle:{"height":"150px","width":"100%","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"150px !important"},attrs:{"playerOptions":{
                              type: 'application/x-mpegURL',
                              src: item.source_message.message,
                              preload: true,
                              autoplay: false,
                              isLoop: false,
                              playsinline: false,
                              poster: '',
                              controls: 'progress,current,durration,volume',
                              crossOrigin: false
                            }},on:{"onplay":_vm.play}})],1)])],1):(item.source_message.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.address !== '')?_c('span',[_vm._v(_vm._s(item.source_message.address))]):_c('span',[_vm._v(_vm._s(item.source_message.message))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-map-marker-alt")])],1)],1):_vm._e()],1)],1):_c('v-layout',{staticStyle:{"padding-bottom":"10px","color":"#6f6f6f"},attrs:{"row":"","wrap":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.noMsg')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):(item.typeofmessage === 'albums_message' && item.image_add.length === 0)?_c('div',{staticStyle:{"display":"none"},attrs:{"slot":"activator"},slot:"activator"}):(item.typeofmessage === 'albums_message' && item.image_add.length != 0)?_c('div',{staticClass:"boxother_createablums",staticStyle:{"width":"240px"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailAlbums(item.file_name)}},slot:"activator"},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#444444 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#444444 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', {name: item.albums_name})))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"color":"#848484 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', {count: item.image_add.length})))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',{staticStyle:{"color":"#737373 !important"}},[_vm._v(_vm._s(item.albums_name))]):_c('h4',{staticStyle:{"color":"#737373 !important"}},[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px","color":"#737373 !important"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'image')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"250px"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['albums','mention', 'sendmail'], item)}},slot:"activator"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"none","border-radius":"10px","display":"flex","justify-content":"center","cursor":"pointer"}},[_c('v-card-media',{staticClass:"white--text ",attrs:{"height":"200px","src":item.message},on:{"click":function($event){_vm.zoom(item)}}})],1)],1)],1)],1):(item.typeofmessage == 'web')?_c('div',{staticClass:"boxfriendfile",attrs:{"slot":"activator"},slot:"activator"},[_c('iframe',{staticStyle:{"visibility":"visible"},attrs:{"width":"300","height":"400","frameborder":"0","src":item.message}})]):(item.typeofmessage === 'note')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailNote(item.note_id)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',{staticStyle:{"color":"black"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length == 20)?_c('p',[_vm._v(" ...")]):_vm._e()])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#737373 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#737373 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'create_task')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#444444"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#444444c2"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#7c7c7c !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()}),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"#dcd9d9","outline":"","text-color":"#3a506d"}},[_vm._v("\n                        "+_vm._s(item.task_info.state.name)+"\n                      ")])],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#818181 !important"}},[_vm._v("\n                      "+_vm._s(_vm.$t('ChatSide.Task.viewDetail'))+"\n                    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#818181 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'assign_task')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#444444"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#444444c2"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#7c7c7c !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()})],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#818181 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Task.editAssign')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#818181 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'sticker')?_c('div',{staticClass:"boxfriendsticker",attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention'], item)}},slot:"activator"},[_c('img',{staticStyle:{"width":"150px"},attrs:{"src":item.file_name}})]):(item.typeofmessage === 'file' && (_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media' || _vm.extension(item.file_name) === 'audio'))?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"300px"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'sendmail'], item)}},slot:"activator"},[_c('v-card',{staticStyle:{"background-color":"#4a4a4a","border-radius":"10px","padding":"10px","width":"100%"}},[(_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media')?_c('v-card-media',{staticStyle:{"border-radius":"10px","cursor":"pointer"},attrs:{"height":"200px"},on:{"click":function($event){_vm.zoomfile(item, true)}}},[(_vm.extension(item.file_name) === 'pdf')?_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":item.message,"page":1}}):(_vm.extension(item.file_name) === 'media')?_c('video',{staticStyle:{"border-radius":"10px","height":"190px"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_vm._e()],1):(_vm.extension(item.file_name) === 'audio')?_c('v-card-media',{staticStyle:{"width":"280px","border-radius":"10px"},attrs:{"height":"55px"}},[_c('audio',{staticStyle:{"border-radius":"10px","width":"260px","display":"flex"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_vm._e(),_vm._v(" "),(_vm.extension(item.file_name) !== 'audio')?_c('v-card-title',{staticStyle:{"padding-top":"10px","padding-left":"0px","padding-bottom":"10px","cursor":"pointer"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"14px","color":"white"}},[_vm._v("("+_vm._s(item.file_name)+")\n                    ")])]):_vm._e()],1)],1):(item.typeofmessage === 'file')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"300px"},attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'sendmail'], item)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"70px !important","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(item.file_name))+"\n                      ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card-title',{staticStyle:{"text-align":"left"},attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"width":"160px","word-break":"break-all !important"}},[_vm._v(_vm._s(item.file_name))])])])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticStyle:{"margin-right":"10px"},attrs:{"slot":"activator","flat":"","icon":"","color":"white"},on:{"click":function($event){_vm.zoomfile(item, false)}},slot:"activator"},[_c('v-icon',[_vm._v("file_download")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.download')))])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"white"},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}},slot:"activator"},[_c('v-icon',[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.sendOnebox')))])],1)],1)],1)],1):(item.typeofmessage === 'video')?_c('div',{staticClass:"boxfriendfile",staticStyle:{"max-height":"250px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.zoomfile(item, true)},"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention', 'sendmail'], item)}},slot:"activator"},[(_vm.extension(item.message) === 'media')?_c('video',{attrs:{"slot":"activator","width":"100%","height":"250","controls":""},slot:"activator"},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_c('vplayer',{attrs:{"playerOptions":{
                    type: 'application/x-mpegURL',
                    src: item.message,
                    preload: true,
                    autoplay: false,
                    isLoop: false,
                    playsinline: false,
                    poster: item.thumbnail,
                    controls: 'progress,current,durration,volume',
                    crossOrigin: false
                  }},on:{"onplay":_vm.play}})],1):(item.typeofmessage === 'location')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"max-width":"250px","min-width":"150px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.openlocation(item)},"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['mention'], item)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#efefef","border-radius":"20px","padding":"10px","padding-bottom":"10px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"}},[_vm._v("place")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"color":"black","padding-left":"10px"},attrs:{"xs10":"","sm10":"","md10":"","lg10":"","xl10":""}},[(item.file_name != '')?_c('span',[_vm._v(" "+_vm._s(item.file_name))]):_c('span',[_vm._v(" somewhere")])])],1)],1)],1):(item.typeofmessage === 'date')?_c('p',{staticClass:"boxfriend",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n              ")],1):(item.typeofmessage === 'datetime')?_c('p',{staticClass:"boxfriend",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n                "),_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v(" far fa-clock")]),_vm._v("   เวลา "+_vm._s(item.message.split('T')[1])+" น.\n              ")],1):(item.typeofmessage === 'contact')?_c('div',{staticClass:"boxfriend",staticStyle:{"font-weight":"500","cursor":"pointer","border-radius":"15px !important"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailFriend(item.message)}},slot:"activator"},[_c('v-avatar',{staticClass:"user-photo"},[(item.pic_contact)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.pic_contact}}):(item.type_contact === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"textchat",staticStyle:{"margin-right":"15px"}},[_vm._v(_vm._s(item.nickname_contact))]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"50%","-ms-transform":"translateY(-50%)","transform":"translateY(-50%)","right":"0"}},[_c('v-icon',[_vm._v("navigate_next ")])],1)],1):(item.typeofmessage === 'template')?_c('div',{staticClass:"boxfriendquestion scrolling-wrapper-template",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","display":"-webkit-inline-box","background":"none"},attrs:{"slot":"activator"},slot:"activator"},_vm._l((item.info_ans),function(info_ans,index){return _c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px"}},[(info_ans.image)?_c('v-img',{staticStyle:{"height":"120px"},attrs:{"src":info_ans.image,"aspect-ratio":"2.75"}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562ae"}},[_vm._v(_vm._s(info_ans.title))]),_vm._v(" "),_c('read-more',{staticClass:"mb-0",staticStyle:{"margin-bottom":"0px !important"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(info_ans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":100}}),_vm._v(" "),(!info_ans.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((info_ans.choice),function(choice,index){return _c('div',[(choice.type=='file')?_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.btn_answer_question(choice, item.tokenmessage)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-download")]),_vm._v("    "),_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.btn_answer_question(choice, item.tokenmessage)}}},[_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})])],1)})],2)])],1)],1)})):(item.typeofmessage === 'official_template')?_c('div',{staticClass:"boxfriendquestion",staticStyle:{"overflow":"hidden","display":"-webkit-inline-box","background":"none"},attrs:{"slot":"activator"},slot:"activator"},[_c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px","background":"#efefef !important"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562af","padding-left":"12px","padding-top":"10px","padding-bottom":"10px"}},[_vm._v(_vm._s(item.element.title))]),_vm._v(" "),(item.element.image)?_c('v-img',{staticStyle:{"height":"160px","cursor":"pointer"},attrs:{"src":item.element.image,"contain":""},on:{"click":function($event){_vm.btn_img_official_template(item.element.onclick_img, item.tokenuser)}}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('read-more',{staticClass:"mb-0",staticStyle:{"color":"#343433"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":100}}),_vm._v(" "),(!item.element.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((item.element.choice),function(choice,index){return _c('div',[_c('v-btn',{style:(_vm.checkbutton(choice.color,choice.background)),attrs:{"flat":"","disabled":(choice.disable == '0')? false: true},on:{"click":function($event){_vm.btn_official_template(choice, item.tokenuser, item.tokenmessage)}}},[_vm._v("\n                          "+_vm._s(choice.label)+"\n                        ")])],1)})],2)])],1)],1)]):(item.typeofmessage === 'approve_message' && item.disable === 'false')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.openapprove(item)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"white","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticStyle:{"color":"#2562ae !important"}},[_vm._v(_vm._s(item.info_ans[0].title))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#9d9d9d !important"}},[_vm._v(_vm._s(item.info_ans[0].short_detail))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('span',{staticStyle:{"color":"#2562ae !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.viewDetail'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#2562ae !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'approve_message'  && item.disable === 'true')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px"},attrs:{"slot":"activator"},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"white","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticStyle:{"color":"#757575 !important"}},[_vm._v(_vm._s(item.info_ans[0].title))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#9d9d9d !important"}},[_vm._v(_vm._s(item.info_ans[0].short_detail))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('span',{staticStyle:{"color":"#757575 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.receiveAns'))+" ")])])],1)],1):(item.typeofmessage === 'call')?_c('div',{staticClass:"boxfriend",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='decline')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel' || item.message =='decline')?_c('span',[_vm._v("\n                  "+_vm._s(_vm.checktypeCall(item.message))+"\n                ")]):_c('span',[_vm._v(_vm._s(_vm.secondsToHms(item.time_count)))])],1):(item.typeofmessage === 'agora_call')?_c('div',{staticClass:"boxfriend",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='end')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel')?_c('span',[_vm._v("\n                  "+_vm._s(_vm.checktypeCall(item.message))+"\n                ")]):_c('span',[_vm._v(_vm._s(item.time))])],1):(item.typeofmessage === 'conference_msg')?_c('div',{staticClass:"boxfriend",staticStyle:{"text-align":"center","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.information.option == 'voice')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startCall')))],1):(item.information.option == 'video')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("videocam")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startVideo')))],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"joinBtn",on:{"click":function($event){_vm.joinCall_conference_msg(item.information)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.conference.joinCall'))+" ")])],1):(item.typeofmessage === 'carousel')?_c('div',{staticClass:"boxfriendcarousel scrolling-wrapper-template",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","display":"-webkit-inline-box","background":"none"}},_vm._l((item.elements),function(info_carousel,index){return _c('div',[_c('v-card',{staticStyle:{"border-radius":"20px","width":"250px","margin-right":"10px"}},[(info_carousel.image)?_c('v-img',{staticStyle:{"height":"250px","cursor":"pointer"},attrs:{"src":info_carousel.image,"aspect-ratio":16/9},on:{"click":function($event){_vm.btn_answer_carousel(info_carousel)}}},[(info_carousel.type !== 'image')?_c('v-layout',{staticStyle:{"height":"250px"},attrs:{"row":"","wrap":"","align-end":"","justify-center":""}},[(info_carousel.button)?_c('v-btn',{attrs:{"round":"","color":"#0000009c","dark":""}},[_c('span',{staticClass:"text-transform"},[_vm._v(_vm._s(info_carousel.button))])]):_vm._e()],1):_vm._e()],1):_vm._e()],1)],1)})):_c('p',{staticClass:"boxfriend",staticStyle:{"color":"#757575 !important"},attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.notSupportVersion'))+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"pl-2",staticStyle:{"font-size":"10px","color":"#424242"}},[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xl1":"","lg1":"","md1":"","sm1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xl2":"","lg2":"","md2":"","sm2":""}})],1):_vm._e()]):_vm._e()}),_vm._v(" "),_vm._l((_vm.items),function(item,i){return (_vm.ForwardState)?_c('div',{key:item.id},[(i == 0)?_c('div',[(_vm.tokenrooomSelect == item.tokenroom)?_c('div',{staticClass:"conversation-start",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.dateMoment(item.timestamp)))])]):_vm._e()]):(_vm.dateMoment(item.timestamp) !== _vm.dateMoment(_vm.items[i-1].timestamp))?_c('div',[_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[(_vm.tokenrooomSelect == item.tokenroom)?_c('div',{staticClass:"conversation-start",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.dateMoment(item.timestamp)))])]):_vm._e()])],1):_vm._e(),_vm._v(" "),(item.tokenuser != _vm.token && _vm.tokenrooomSelect == item.tokenroom && i == 0 && item.typeofmessage != 'unsend_message' && item.typeofmessage != 'system' && item.typeofmessage != 'system_action' && item.typeofmessage !='system_action_albums' && item.typeofmessage !='system_action_task')?_c('p',{staticClass:"text",staticStyle:{"text-align":"left","margin-left":"calc(48px + 1vw)","margin-bottom":"0px","color":"#8e8e8e","font-size":"10px"}},[_vm._v(_vm._s(item.nickname))]):(item.typeofmessage != 'system_action_albums' && item.typeofmessage != 'system_action_task' && item.typeofmessage != 'system_action' && item.typeofmessage != 'system' && item.typeofmessage != 'unsend_message' && item.tokenuser != _vm.token && _vm.tokenrooomSelect == item.tokenroom && (_vm.dateMoment(item.timestamp) != _vm.dateMoment(_vm.items[i-1].timestamp) || _vm.items[i-1].tokenuser != item.tokenuser))?_c('p',{staticClass:"text",staticStyle:{"text-align":"left","margin-left":"calc(48px + 1vw)","margin-bottom":"0px","color":"#8e8e8e","font-size":"10px"}},[_vm._v("\n          "+_vm._s(item.nickname))]):_vm._e(),_vm._v(" "),(item.tokenuser == _vm.token && _vm.tokenrooomSelect == item.tokenroom)?_c('div',{staticClass:"chat self"},[(item.typeofmessage === 'unsend_message')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.cancelMsg'))+"\n            ")])]):(item.typeofmessage === 'system_action_albums')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_name_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.editNameAlbum'))+"\n            ")]):(item.message == 'create_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.createAlbum',{name: item.albums_name}))+"\n            ")]):(item.message == 'delete_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.deleteAlbum'))+"\n            ")]):(item.message == 'delete_images_albums')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.deleteImageAlbum'))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system_action_task')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_task')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.editTask'))+"\n            ")]):(item.message == 'create_project')?_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.self.createProject'))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n              "+_vm._s(item.message)+"\n            ")])]):(item.typeofmessage === 'system_action')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxself_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" น.")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message === 'active')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.self.joinGroup'))+"\n              ")]):(item.message === 'kick')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'invite')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'leave')?_c('span',[_vm._v("\n                 "+_vm._s(_vm.$t('ChatSide.system.self.leftGroup'))+"\n              ")]):_vm._e()])]):_c('v-flex',{staticStyle:{"padding-right":"0px"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[((item.typeofmessage === 'message' || item.typeofmessage == 'image' || item.typeofmessage === 'file' || item.typeofmessage === 'video' || item.typeofmessage === 'location') && item.status != 'no')?_c('v-checkbox',{staticStyle:{"float":"right"},attrs:{"value":item.tokenmessage},model:{value:(_vm.selectedForward),callback:function ($$v) {_vm.selectedForward=$$v},expression:"selectedForward"}}):_vm._e(),_vm._v(" "),(item.typeofmessage === 'message')?_c('div',{staticClass:"boxself",staticStyle:{"height":"100%"}},[_c('p',{staticStyle:{"margin":"0 !important"},attrs:{"slot":"activator"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))},slot:"activator"}),_vm._v(" "),_vm._l((_vm.convertURL(item.message)),function(x){return (_vm.convertURL(item.message))?_c('div',[_c('link-prevue',{attrs:{"url":x},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"row":"","wrap":""},on:{"click":function($event){_vm.clicklink_website(props.url)}}},[_c('v-flex',{staticClass:"border_website",attrs:{"xl9":"","lg9":"","md9":"","sm9":""}},[_c('p',{staticClass:"title_website"},[_vm._v(_vm._s(props.title))]),_vm._v(" "),_c('span',{staticClass:"description_website"},[_vm._v(_vm._s(props.description))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerimg_website",attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[(props.img)?_c('img',{staticClass:"img_website",attrs:{"src":props.img}}):_vm._e()])],1)]}}])},[_c('template',{slot:"loading"},[_c('span')])],2)],1):_vm._e()})],2):(item.typeofmessage === 'official_template')?_c('div',{staticClass:"boxselfquestion",staticStyle:{"overflow":"hidden","display":"-webkit-inline-box","background":"none"}},[_c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px","background":"#b4d1f5 !important"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562af","padding-left":"12px","padding-top":"10px","padding-bottom":"10px"}},[_vm._v(_vm._s(item.element.title))]),_vm._v(" "),(item.element.image)?_c('v-img',{staticStyle:{"height":"160px"},attrs:{"src":item.element.image,"contain":""}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('read-more',{staticClass:"mb-0",staticStyle:{"color":"#343433"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":100}}),_vm._v(" "),(!item.element.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((item.element.choice),function(choice,index){return _c('div',[_c('v-btn',{style:(_vm.checkbutton(choice.color,choice.background)),attrs:{"flat":"","disabled":""}},[_vm._v("\n                          "+_vm._s(choice.label)+"\n                        ")])],1)})],2)])],1)],1)]):(item.typeofmessage === 'mention_message')?_c('p',{staticClass:"boxself",attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention'], item)}},slot:"activator"},[(item.source_message.typeofmessage !== 'unsend_message')?_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(item.source_message.owner_source_message.path_pic)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":item.source_message.owner_source_message.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"40px"},attrs:{"xs11":""}},[(item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.source_message.message)+" ooooooooooooooooooooo")])]):(item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.typeofmessage === 'image')?_c('span',[_vm._v("รูปภาพ")]):_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.sticker')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"10px","float":"right"},attrs:{"src":item.source_message.message}})])],1):(item.source_message.typeofmessage === 'file')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(_vm.extension(item.source_message.message) === 'pdf')?_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v(_vm._s(_vm.extension(item.source_message.message)))])],1)],1):(item.source_message.typeofmessage === 'video')?_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.extension(item.source_message.message) === 'media')?_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"150","height":"150","controls":""}},[_c('source',{attrs:{"src":item.source_message.message,"type":'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]}})]):_c('div',{staticStyle:{"width":"100%","height":"150px","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"150px !important"},attrs:{"playerOptions":{
                            type: 'application/x-mpegURL',
                            src: item.source_message.message,
                            preload: true,
                            autoplay: false,
                            isLoop: false,
                            playsinline: false,
                            poster: '',
                            controls: 'progress,current,durration,volume',
                            crossOrigin: false
                          }},on:{"onplay":_vm.play}})],1)])],1):(item.source_message.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.address !== '')?_c('span',[_vm._v(_vm._s(item.source_message.address))]):_c('span',[_vm._v(_vm._s(item.source_message.message))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-map-marker-alt")])],1)],1):_vm._e()],1)],1):_c('v-layout',{staticStyle:{"padding-bottom":"10px","color":"#6f6f6f"},attrs:{"row":"","wrap":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.noMsg')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):(item.typeofmessage == 'albums_message' && item.image_add.length == 0)?_c('div',{staticStyle:{"display":"none"}}):(item.typeofmessage == 'albums_message' && item.image_add.length != 0)?_c('div',{staticClass:"boxself_createablums",staticStyle:{"width":"240px"}},[(item.message != 'addimage_albums')?_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#3a506d !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#3a506d !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', {name: item.albums_name})))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"color":"#3a506d91 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', {count: item.image_add.length})))]),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"#31394121 !important"}}),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',{staticStyle:{"color":"#4c6281 !important"}},[_vm._v(_vm._s(item.albums_name))]):_c('h4',{staticStyle:{"color":"#4c6281 !important"}},[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px","color":"#4c6281 !important"},attrs:{"color":"black"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'image')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"250px"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"none","border-radius":"10px","display":"flex","justify-content":"center"}},[_c('v-card-media',{staticClass:"white--text ",attrs:{"height":"200px","src":item.message}})],1)],1)],1)],1):(item.typeofmessage === 'sticker')?_c('div',{staticClass:"boxselfsticker"},[_c('img',{staticStyle:{"width":"150px"},attrs:{"src":item.file_name}})]):(item.typeofmessage === 'web')?_c('div',{staticClass:"boxself"},[_c('iframe',{staticStyle:{"visibility":"visible"},attrs:{"width":"300","height":"400","frameborder":"0","src":item.message}})]):(item.typeofmessage === 'note')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"200px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5 !important","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',{staticStyle:{"color":"black"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length == 20)?_c('p',[_vm._v(" ...")]):_vm._e()])],1),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#4c6281 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#4c6281 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'create_task')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#3a506d"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#3a506db3"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#6981a1 !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()}),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"#e6ecf3","outline":"","text-color":"#3a506d"}},[_vm._v("\n                      "+_vm._s(item.task_info.state.name)+"\n                    ")])],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#6981a1 !important"}},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.Task.viewDetail'))+"\n                  ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#6981a1 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'assign_task')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#3a506d"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#3a506db3"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#6981a1 !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()})],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#6981a1 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Task.editAssign')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#6981a1 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'contact')?_c('div',{staticClass:"boxself",staticStyle:{"font-weight":"500","border-radius":"15px !important"}},[_c('v-avatar',{staticClass:"user-photo"},[(item.pic_contact)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.pic_contact}}):(item.type_contact === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"textchat",staticStyle:{"margin-right":"15px"}},[_vm._v(_vm._s(item.nickname_contact))]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"50%","-ms-transform":"translateY(-50%)","transform":"translateY(-50%)","right":"0"}},[_c('v-icon',[_vm._v("navigate_next ")])],1)],1):(item.typeofmessage === 'file' && (_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media' || _vm.extension(item.file_name) === 'audio'))?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"300px"}},[_c('v-card',{staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","width":"100%"}},[(_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media')?_c('v-card-media',{staticStyle:{"border-radius":"10px"},attrs:{"height":"200px"}},[(_vm.extension(item.file_name) === 'pdf')?_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":item.message,"page":1}}):(_vm.extension(item.file_name) === 'media')?_c('video',{staticStyle:{"border-radius":"10px","height":"190px"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_vm._e()],1):(_vm.extension(item.file_name) === 'audio')?_c('v-card-media',{staticStyle:{"width":"280px","border-radius":"10px"},attrs:{"height":"55px"}},[_c('audio',{staticStyle:{"border-radius":"10px","width":"260px","display":"flex"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_vm._e(),_vm._v(" "),(_vm.extension(item.file_name) !== 'audio')?_c('v-card-title',{staticStyle:{"padding-top":"10px","padding-left":"0px","padding-bottom":"10px"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"14px","color":"white"}},[_vm._v("("+_vm._s(item.file_name)+")\n                  ")])]):_vm._e()],1)],1):(item.typeofmessage === 'file')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"300px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"70px !important","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(item.file_name))+"\n                    ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card-title',{staticStyle:{"text-align":"left"},attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"width":"160px","word-break":"break-all !important"}},[_vm._v(_vm._s(item.file_name))])])])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-right":"10px"},attrs:{"flat":"","icon":"","color":"white","disabled":""}},[_c('v-icon',[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":""}},[_c('v-icon',[_vm._v("cloud_upload")])],1)],1)],1)],1):(item.typeofmessage === 'video')?_c('div',{staticClass:"boxselffile",staticStyle:{"max-height":"250px"}},[(_vm.extension(item.message) === 'media')?_c('video',{attrs:{"width":"100%","height":"250","controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_c('vplayer',{attrs:{"playerOptions":{
                  type: 'application/x-mpegURL',
                  src: item.message,
                  preload: true,
                  autoplay: false,
                  isLoop: false,
                  playsinline: false,
                  poster: item.thumbnail,
                  controls: 'progress,current,durration,volume',
                  crossOrigin: false
                }},on:{"onplay":_vm.play}})],1):(item.typeofmessage === 'location')?_c('p',{staticClass:"boxselffile",staticStyle:{"max-width":"250px","min-width":"150px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5 !important","border-radius":"20px","padding":"10px","padding-bottom":"10px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"}},[_vm._v("place")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"color":"black","padding-left":"10px"},attrs:{"xs10":"","sm10":"","md10":"","lg10":"","xl10":""}},[(item.file_name != '')?_c('span',[_vm._v(" "+_vm._s(item.file_name))]):_c('span',[_vm._v(" somewhere")])])],1)],1)],1):(item.typeofmessage === 'date')?_c('p',{staticClass:"boxself"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n            ")],1):(item.typeofmessage === 'datetime')?_c('p',{staticClass:"boxself"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n              "),_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v(" far fa-clock")]),_vm._v("   เวลา "+_vm._s(item.message.split('T')[1])+" น.\n            ")],1):(item.typeofmessage === 'call')?_c('div',{staticClass:"boxself",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"}},[(item.message =='cancel' || item.message =='decline')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel' || item.message =='decline')?_c('span',[_vm._v("\n                "+_vm._s(_vm.checktypeCall(item.message))+"\n              ")]):_c('span',[_vm._v(_vm._s(_vm.secondsToHms(item.time_count)))])],1):(item.typeofmessage === 'agora_call')?_c('div',{staticClass:"boxself",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"}},[(item.message =='cancel' || item.message =='end')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel')?_c('span',[_vm._v("\n                "+_vm._s(_vm.checktypeCall(item.message))+"\n              ")]):_c('span',[_vm._v(_vm._s(item.time))])],1):(item.typeofmessage === 'conference_msg')?_c('div',{staticClass:"boxself",staticStyle:{"text-align":"center","font-weight":"500 !important"}},[(item.information.option == 'voice')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startCall')))],1):(item.information.option == 'video')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("videocam")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startVideo')))],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"joinBtn",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.$t('ChatSide.conference.joinCall'))+" ")])],1):_c('p',{staticClass:"boxself",staticStyle:{"color":"#6d6d6d !important"}},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.notSupportVersion'))+"\n            ")])],1)],1):_vm._e(),_vm._v(" "),(item.tokenuser !== _vm.token && _vm.tokenrooomSelect === item.tokenroom)?_c('div',{staticClass:"chat friend"},[(item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system' && item.typeofmessage !== 'system_action' && item.typeofmessage !== 'system_action_albums' && item.typeofmessage !== 'system_action_task')?_c('v-flex',{staticStyle:{"cursor":"pointer","margin-top":"1vh"},attrs:{"xl1":"","lg1":"","md1":"","sm1":""}},[((item.typeofmessage != 'albums_message' || item.image_add.length != 0))?_c('v-avatar',{staticClass:"user-photo"},[(item.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.path_pic}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):_vm._e()],1):_vm._e(),_vm._v(" "),(item.typeofmessage === 'unsend_message')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.cancelMsg', {name: item.nickname}))+"\n            ")])]):(item.typeofmessage === 'system_action_albums')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_name_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.editNameAlbum', {name: item.nickname}))+"\n            ")]):(item.message == 'create_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.createAlbum', {name: item.nickname, albums_name:item.albums_name}))+"\n            ")]):(item.message == 'delete_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.deleteAlbum', {name: item.nickname}))+"\n            ")]):(item.message == 'delete_images_albums')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.deleteImageAlbum', {name: item.nickname}))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system_action_task')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_task')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.editTask', {name: item.nickname}))+"\n            ")]):(item.message == 'create_project')?_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.system.other.createProject', {name: item.nickname}))+"\n            ")]):_vm._e()]):(item.typeofmessage === 'system')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxother_system"},[_vm._v("\n              "+_vm._s(item.message)+"\n            ")])]):(item.typeofmessage === 'system_action')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"2vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('p',{staticClass:"boxother_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" น.")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message === 'active')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.other.joinGroup', {name: item.nickname}))+"\n              ")]):(item.message === 'kick')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'invite')?_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n              ")]):(item.message === 'leave')?_c('span',[_vm._v("\n               "+_vm._s(_vm.$t('ChatSide.system.other.leftGroup', {name: item.nickname}))+"\n              ")]):_vm._e()])]):_c('v-flex',{staticStyle:{"padding-right":"0px","padding-left":"1vw"},attrs:{"xl8":"","lg8":"","md8":"","sm8":""}},[(item.typeofmessage === 'message')?_c('div',{staticClass:"boxfriend"},[_c('p',{staticStyle:{"margin":"0 !important"},attrs:{"slot":"activator"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))},slot:"activator"}),_vm._v(" "),_vm._l((_vm.convertURL(item.message)),function(x){return (_vm.convertURL(item.message))?_c('div',[_c('link-prevue',{attrs:{"url":x},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"row":"","wrap":""},on:{"click":function($event){_vm.clicklink_website(props.url)}}},[_c('v-flex',{staticClass:"border_website",attrs:{"xl9":"","lg9":"","md9":"","sm9":""}},[_c('p',{staticClass:"title_website"},[_vm._v(_vm._s(props.title))]),_vm._v(" "),_c('span',{staticClass:"description_website"},[_vm._v(_vm._s(props.description))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerimg_website",attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[(props.img)?_c('img',{staticClass:"img_website",attrs:{"src":props.img}}):_vm._e()])],1)]}}])},[_c('template',{slot:"loading"},[_c('span')])],2)],1):_vm._e()})],2):(item.typeofmessage === 'mention_message')?_c('p',{staticClass:"boxfriend",attrs:{"slot":"activator"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event,['mention'], item)}},slot:"activator"},[(item.source_message.typeofmessage !== 'unsend_message')?_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(item.source_message.owner_source_message.path_pic)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":item.source_message.owner_source_message.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"40px"},attrs:{"xs11":""}},[(item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.source_message.message))])]):(item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.typeofmessage === 'image')?_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.image')))]):_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.sticker')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"10px","float":"right"},attrs:{"src":item.source_message.message}})])],1):(item.source_message.typeofmessage === 'file')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(_vm.extension(item.source_message.message) === 'pdf')?_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v(_vm._s(_vm.extension(item.source_message.message)))])],1)],1):(item.source_message.typeofmessage === 'video')?_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.extension(item.source_message.message) === 'media')?_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"150","height":"150","controls":""}},[_c('source',{attrs:{"src":item.source_message.message,"type":'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]}})]):_c('div',{staticStyle:{"width":"100%","height":"150px","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"150px !important"},attrs:{"playerOptions":{
                            type: 'application/x-mpegURL',
                            src: item.source_message.message,
                            preload: true,
                            autoplay: false,
                            isLoop: false,
                            playsinline: false,
                            poster: '',
                            controls: 'progress,current,durration,volume',
                            crossOrigin: false
                          }},on:{"onplay":_vm.play}})],1)])],1):(item.source_message.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.address !== '')?_c('span',[_vm._v(_vm._s(item.source_message.address))]):_c('span',[_vm._v(_vm._s(item.source_message.message))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-map-marker-alt")])],1)],1):_vm._e()],1)],1):_c('v-layout',{staticStyle:{"padding-bottom":"10px","color":"#6f6f6f"},attrs:{"row":"","wrap":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.noMsg')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):(item.typeofmessage === 'albums_message' && item.image_add.length === 0)?_c('div',{staticStyle:{"display":"none"}}):(item.typeofmessage === 'albums_message' && item.image_add.length !== 0)?_c('div',{staticClass:"boxother_createablums",staticStyle:{"width":"240px"}},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#444444 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1",staticStyle:{"color":"#444444 !important"}},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', {name: item.albums_name}))+"\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"color":"#848484 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', {count: item.image_add.length})))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',{staticStyle:{"color":"#737373 !important"}},[_vm._v(_vm._s(item.albums_name))]):_c('h4',{staticStyle:{"color":"#737373 !important"}},[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px","color":"#737373 !important"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'image')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"250px"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"none","border-radius":"10px","display":"flex","justify-content":"center"}},[_c('v-card-media',{staticClass:"white--text ",attrs:{"height":"200px","src":item.message}})],1)],1)],1)],1):(item.typeofmessage == 'web')?_c('div',{staticClass:"boxfriendfile"},[_c('iframe',{staticStyle:{"visibility":"visible"},attrs:{"width":"300","height":"400","frameborder":"0","src":item.message}})]):(item.typeofmessage === 'note')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',{staticStyle:{"color":"black"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length == 20)?_c('p',[_vm._v(" ...")]):_vm._e()])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#5a616b !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#5a616b !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'create_task')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#444444"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#444444c2"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#7c7c7c !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()}),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"#dcd9d9","outline":"","text-color":"#3a506d"}},[_vm._v("\n                      "+_vm._s(item.task_info.state.name)+"\n                    ")])],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#818181 !important"}},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.Task.viewDetail'))+"\n                  ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#818181 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'assign_task')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#444444"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#444444c2"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#7c7c7c !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()})],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#818181 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Task.editAssign')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#818181 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'sticker')?_c('div',{staticClass:"boxfriendsticker"},[_c('img',{staticStyle:{"width":"150px"},attrs:{"src":item.file_name}})]):(item.typeofmessage === 'file' && (_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media' || _vm.extension(item.file_name) === 'audio'))?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"300px"}},[_c('v-card',{staticStyle:{"background-color":"#4a4a4a","border-radius":"10px","padding":"10px","width":"100%"}},[(_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media')?_c('v-card-media',{staticStyle:{"border-radius":"10px"},attrs:{"height":"200px"}},[(_vm.extension(item.file_name) === 'pdf')?_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":item.message,"page":1}}):(_vm.extension(item.file_name) === 'media')?_c('video',{staticStyle:{"border-radius":"10px","height":"190px"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_vm._e()],1):(_vm.extension(item.file_name) === 'audio')?_c('v-card-media',{staticStyle:{"width":"280px","border-radius":"10px"},attrs:{"height":"55px"}},[_c('audio',{staticStyle:{"border-radius":"10px","width":"260px","display":"flex"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_vm._e(),_vm._v(" "),(_vm.extension(item.file_name) !== 'audio')?_c('v-card-title',{staticStyle:{"padding-top":"10px","padding-left":"0px","padding-bottom":"10px"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"14px","color":"white"}},[_vm._v("("+_vm._s(item.file_name)+")\n                  ")])]):_vm._e()],1)],1):(item.typeofmessage === 'file')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"300px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#404d63","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"70px !important","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(item.file_name))+"\n                    ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-card-title',{staticStyle:{"text-align":"left"},attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"width":"160px","word-break":"break-all !important"}},[_vm._v(_vm._s(item.file_name))])])])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-right":"10px"},attrs:{"flat":"","icon":"","color":"white","disabled":""}},[_c('v-icon',[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":""}},[_c('v-icon',[_vm._v("cloud_upload")])],1)],1)],1)],1):(item.typeofmessage === 'video')?_c('div',{staticClass:"boxfriendfile",staticStyle:{"max-height":"250px"}},[(_vm.extension(item.typeofmessage) === 'media')?_c('video',{attrs:{"width":"100%","height":"250","controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})]):_c('vplayer',{attrs:{"playerOptions":{
                  type: 'application/x-mpegURL',
                  src: item.message,
                  preload: true,
                  autoplay: false,
                  isLoop: false,
                  playsinline: false,
                  poster: item.thumbnail,
                  controls: 'progress,current,durration,volume',
                  crossOrigin: false
                }},on:{"onplay":_vm.play}})],1):(item.typeofmessage === 'location')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"max-width":"250px","min-width":"150px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#efefef","border-radius":"20px","padding":"10px","padding-bottom":"10px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"}},[_vm._v("place")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"color":"black","padding-left":"10px"},attrs:{"xs10":"","sm10":"","md10":"","lg10":"","xl10":""}},[(item.file_name != '')?_c('span',[_vm._v(" "+_vm._s(item.file_name))]):_c('span',[_vm._v(" somewhere")])])],1)],1)],1):(item.typeofmessage === 'date')?_c('p',{staticClass:"boxfriend"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n            ")],1):(item.typeofmessage === 'datetime')?_c('p',{staticClass:"boxfriend"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n              "),_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v(" far fa-clock")]),_vm._v("   เวลา "+_vm._s(item.message.split('T')[1])+" น.\n            ")],1):(item.typeofmessage === 'contact')?_c('div',{staticClass:"boxfriend",staticStyle:{"font-weight":"500","border-radius":"15px !important"}},[_c('v-avatar',{staticClass:"user-photo"},[(item.pic_contact)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.pic_contact}}):(item.type_contact === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"textchat",staticStyle:{"margin-right":"15px"}},[_vm._v(_vm._s(item.nickname_contact))]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"50%","-ms-transform":"translateY(-50%)","transform":"translateY(-50%)","right":"0"}},[_c('v-icon',[_vm._v("navigate_next ")])],1)],1):(item.typeofmessage === 'template')?_c('div',{staticClass:"boxfriendquestion scrolling-wrapper-template",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","display":"-webkit-inline-box","background":"none"}},_vm._l((item.info_ans),function(info_ans,index){return _c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px"}},[(info_ans.image)?_c('v-img',{staticStyle:{"height":"120px"},attrs:{"src":info_ans.image,"aspect-ratio":"2.75"}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('h2',{staticClass:"mb-0",staticStyle:{"color":"#61666d"}},[_vm._v(_vm._s(info_ans.title))]),_vm._v(" "),_c('read-more',{staticClass:"mb-0",attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(info_ans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":100}}),_vm._v(" "),(!info_ans.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((info_ans.choice),function(choice,index){return _c('div',[(choice.type=='file')?_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px"},attrs:{"flat":"","disabled":""}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-download")]),_vm._v("    "),_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px"},attrs:{"flat":"","disabled":""}},[_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})])],1)})],2)])],1)],1)})):(item.typeofmessage === 'official_template')?_c('div',{staticClass:"boxfriendquestion",staticStyle:{"overflow":"hidden","display":"-webkit-inline-box","background":"none"}},[_c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px","background":"#efefef !important"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562af","padding-left":"12px","padding-top":"10px","padding-bottom":"10px"}},[_vm._v(_vm._s(item.element.title))]),_vm._v(" "),(item.element.image)?_c('v-img',{staticStyle:{"height":"160px"},attrs:{"src":item.element.image,"contain":""}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('read-more',{staticClass:"mb-0",staticStyle:{"color":"#343433"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":100}}),_vm._v(" "),(!item.element.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((item.element.choice),function(choice,index){return _c('div',[_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px","border-radius":"20px"},attrs:{"flat":"","disabled":""}},[_vm._v("\n                          "+_vm._s(choice.label)+"\n                        ")])],1)})],2)])],1)],1)]):(item.typeofmessage === 'approve_message')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"200px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"white","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticStyle:{"color":"#757575 !important"}},[_vm._v(_vm._s(item.info_ans[0].title))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#9d9d9d !important"}},[_vm._v(_vm._s(item.info_ans[0].short_detail))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),(item.disable === 'false')?_c('v-card-actions',[_c('span',{staticStyle:{"color":"#757575 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.viewDetail'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#757575 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1):_c('v-card-actions',[_c('span',{staticStyle:{"color":"#757575 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.receiveAns'))+" ")])])],1)],1):(item.typeofmessage === 'call')?_c('div',{staticClass:"boxfriend",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"}},[(item.message =='cancel' || item.message =='decline')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel' || item.message =='decline')?_c('span',[_vm._v("\n                "+_vm._s(_vm.checktypeCall(item.message))+"\n              ")]):_c('span',[_vm._v(_vm._s(_vm.secondsToHms(item.time_count)))])],1):(item.typeofmessage === 'agora_call')?_c('div',{staticClass:"boxfriend",staticStyle:{"text-align":"center","width":"100px","font-weight":"500 !important"}},[(item.message =='cancel' || item.message =='end')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel')?_c('span',[_vm._v("\n                "+_vm._s(_vm.checktypeCall(item.message))+"\n              ")]):_c('span',[_vm._v(_vm._s(item.time))])],1):(item.typeofmessage === 'conference_msg')?_c('div',{staticClass:"boxfriend",staticStyle:{"text-align":"center","font-weight":"500 !important"}},[(item.information.option == 'voice')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startCall')))],1):(item.information.option == 'video')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("videocam")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startVideo')))],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"joinBtn",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.$t('ChatSide.conference.joinCall')))])],1):(item.typeofmessage === 'carousel')?_c('div',{staticClass:"boxfriendcarousel scrolling-wrapper-template",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","display":"-webkit-inline-box","background":"none"}},_vm._l((item.elements),function(info_carousel,index){return _c('div',[_c('v-card',{staticStyle:{"border-radius":"20px","width":"250px","margin-right":"10px"}},[(info_carousel.image)?_c('v-img',{staticStyle:{"height":"250px"},attrs:{"src":info_carousel.image,"aspect-ratio":"2.75"}},[(info_carousel.type !== 'image')?_c('v-layout',{staticStyle:{"height":"250px"},attrs:{"row":"","wrap":"","align-end":"","justify-center":""}},[(info_carousel.button)?_c('v-btn',{attrs:{"round":"","color":"#0000009c","dark":"","disabled":""}},[_c('span',{staticClass:"text-transform"},[_vm._v(_vm._s(info_carousel.button))])]):_vm._e()],1):_vm._e()],1):_vm._e()],1)],1)})):_c('p',{staticClass:"boxfriend",staticStyle:{"color":"#757575 !important"}},[_vm._v("\n              "+_vm._s(_vm.$t('ChatSide.notSupportVersion'))+"\n            ")])]),_vm._v(" "),(item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system' && item.typeofmessage !== 'system_action' && item.typeofmessage !== 'system_action_albums' && item.typeofmessage !== 'system_action_task')?_c('v-flex',{attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[((item.typeofmessage === 'message' || item.typeofmessage === 'image' || item.typeofmessage === 'file' || item.typeofmessage === 'video' || item.typeofmessage === 'location') && item.status!='no')?_c('v-checkbox',{staticStyle:{"float":"right"},attrs:{"value":item.tokenmessage},model:{value:(_vm.selectedForward),callback:function ($$v) {_vm.selectedForward=$$v},expression:"selectedForward"}}):_c('v-checkbox',{staticStyle:{"float":"right"},attrs:{"disabled":""}})],1):_vm._e()],1):_vm._e()]):_vm._e()}),_vm._v(" "),(_vm.datepicker)?_c('v-date-picker',{attrs:{"max":_vm.maxdate,"min":_vm.mindate,"landscape":true},model:{value:(_vm.dateselect),callback:function ($$v) {_vm.dateselect=$$v},expression:"dateselect"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.datepicker = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.senddate()}}},[_vm._v("OK")])],1):_vm._e(),_vm._v(" "),(_vm.timepicker)?_c('v-time-picker',{attrs:{"max":_vm.maxtime,"min":_vm.mintime,"format":"24hr","landscape":true},model:{value:(_vm.timeselect),callback:function ($$v) {_vm.timeselect=$$v},expression:"timeselect"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timepicker = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.sendtime()}}},[_vm._v("OK")])],1):_vm._e()],2),_vm._v(" "),(_vm.ForwardState === false &&_vm.Quickreply)?_c('v-flex',{staticStyle:{"margin":"0"},attrs:{"lg12":"","md12":"","sm12":"","xl12":""}},[_c('div',{staticClass:"chat-messages clearfix scrolling-wrapper",style:(_vm.quickreplyStyle + 'background: none !important;margin-left: 20px;overflow-y: hidden;display: flex;height: 50px; width: 45% !important;overflow-x:scroll !important;')},_vm._l((_vm.Quickreply.quick_reply),function(item,index){return _c('a',{},[(item.type == 'text')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.ans_quickreply(item, 'text')}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'ocr')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.ocropen(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'file')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.selectfile_quickreply(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'image')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.selectfile_quickreply(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'location')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.sendlocation_quickreply(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'datepicker' || item.type == 'datetimepicker')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.setpicker(item)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-calendar-alt")]),_vm._v("   "),_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])],1):(item.type == 'link')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.openlink(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'webview')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.openwebview(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'link_market')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.openlink_market(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'ekyc')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.ans_ekyc(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):_vm._e()],1)}))]):_vm._e(),_vm._v(" "),(_vm.ForwardState)?_c('v-flex',{staticStyle:{"margin":"0"},attrs:{"lg12":"","md12":"","sm12":"","xl12":""}},[_c('div',{staticClass:"chat-messages clearfix",staticStyle:{"width":"100%"}},[_c('p',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('ChatSide.numberMsgSent'))+" ("+_vm._s(_vm.selectedForward.length)+")")]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"disabled":(_vm.selectedForward.length==0)},on:{"click":function($event){_vm.dialogForward = true;}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.forward')))]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},on:{"click":function($event){_vm.dialogForward = false; _vm.ForwardState = false; _vm.selectedForward = []}}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n        ")])],1)]):_vm._e(),_vm._v(" "),(_vm.RichmenuState)?_c('v-flex',{staticStyle:{"margin":"0"},attrs:{"lg12":"","md12":"","sm12":"","xl12":""}},[(!_vm.sheetrichmenu)?_c('div',{staticClass:"chat-messages-richmenu clearfix"},[_c('v-layout',{staticStyle:{"height":"100%"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{staticStyle:{"border-right-style":"solid","border-right-color":"white","border-right-width":"thin"},attrs:{"xs1":"","md1":"","sm1":"","xl1":"","lg1":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.RichmenuState = false; _vm.sheetrichmenu = false}}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-keyboard")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-2 pr-2",attrs:{"xs11":"","md11":"","sm11":"","xl11":"","lg11":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"block":"","flat":"","color":"white"},on:{"click":function($event){_vm.sheetrichmenu = true}}},[_vm._v(_vm._s(_vm.richmenu_label))])],1)],1)],1)],1):_c('div',[(_vm.type_richmenu <= 7)?_c('div',{staticClass:"chat-messages-richmenu-sheet clearfix"},[_c('v-layout',{staticStyle:{"height":"89%","width":"375px","margin":"auto"},attrs:{"row":"","wrap":"","align-start":"","justify-center":""}},[_c('v-flex',{staticStyle:{"height":"100%"},attrs:{"xs12":"","md12":"","sm12":"","lg12":"","xl12":""}},[_c('Richmenudialog',{attrs:{"type_richmenu":_vm.type_richmenu,"inforrichmenu":_vm.inforrichmenu,"Richmenudialog":_vm.Richmenudialog},on:{"emitrichmenu":_vm.emitrichmenu}})],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"bottom":"0","position":"fixed","width":"50%","padding-right":"10px"},attrs:{"row":"","wrap":"","align-end":"","justify-center":""}},[_c('v-flex',{staticStyle:{"border-right-style":"solid","border-right-color":"white","border-right-width":"thin","margin-bottom":"7px"},attrs:{"xs1":"","md1":"","sm1":"","xl1":"","lg1":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.RichmenuState = false; _vm.sheetrichmenu = false}}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-keyboard")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-2 pr-2",attrs:{"xs11":"","md11":"","sm11":"","xl11":"","lg11":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"block":"","flat":"","color":"white"},on:{"click":function($event){_vm.sheetrichmenu = false}}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-sort-down")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.richmenu_label))])],1)],1)],1)],1)],1)],1):_c('div',{staticClass:"chat-messages-richmenu-sheet-row clearfix"},[_c('v-layout',{staticStyle:{"width":"375px","margin":"auto"},attrs:{"row":"","wrap":"","align-start":"","justify-center":""}},[_c('v-flex',{staticStyle:{"height":"100%"},attrs:{"xs12":"","md12":"","sm12":"","lg12":"","xl12":""}},[_c('Richmenudialog',{attrs:{"type_richmenu":_vm.type_richmenu,"inforrichmenu":_vm.inforrichmenu,"Richmenudialog":_vm.Richmenudialog},on:{"emitrichmenu":_vm.emitrichmenu}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-end":"","justify-center":""}},[_c('v-flex',{staticStyle:{"border-right-style":"solid","border-right-color":"white","border-right-width":"thin","margin-bottom":"7px"},attrs:{"xs1":"","md1":"","sm1":"","xl1":"","lg1":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.RichmenuState = false; _vm.sheetrichmenu = false}}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-keyboard")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-2 pr-2",attrs:{"xs11":"","md11":"","sm11":"","xl11":"","lg11":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"block":"","flat":"","color":"white"},on:{"click":function($event){_vm.sheetrichmenu = false}}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-sort-down")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.richmenu_label))])],1)],1)],1)],1)],1)],1)])]):(!_vm.ForwardState)?_c('v-flex',{staticStyle:{"margin":"0"},attrs:{"lg12":"","md12":"","sm12":"","xl12":""}},[(_vm.files.length > 0)?_c('div',{staticClass:"listfile"},_vm._l((_vm.files),function(file,key){return (_vm.files.length > 0)?_c('div',{staticClass:"borderfile",staticStyle:{"justify-content":"center","margin-left":"10px"}},[_c('a',{staticClass:"close-classic",on:{"click":function($event){_vm.removeFile( key )}}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center","padding-top":"15px"}},[_c('img',{ref:'preview'+parseInt( key ),refInFor:true,staticClass:"preview",staticStyle:{"height":"60px !important","width":"60px !important","display":"flex","justify-content":"center","object-fit":"cover","object-position":"center"},attrs:{"src":file.filebase64}})])]):_vm._e()})):_vm._e(),_vm._v(" "),(_vm.progressLoadChatBox)?_c('div',{staticClass:"chat-messages clearfix",staticStyle:{"width":"100%"}},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.progressLoadChatBox}})],1):_c('div',{staticClass:"chat-messages clearfix",staticStyle:{"width":"100%"}},[(_vm.statemember == 'active' && _vm.online)?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendmsg),expression:"sendmsg"}],ref:"textareaChat",staticClass:"textareabg CSChatThai",attrs:{"placeholder":_vm.$t('ChatSide.textarea.normal'),"rows":"3","id":"textareaChat"},domProps:{"value":(_vm.sendmsg)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.sendmsg=$event.target.value},function($event){_vm.filterlistfriend()}],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }_vm.sendMessage(_vm.sendmsg)},"paste":_vm.onPaste}}):(_vm.statemember !='active' && _vm.online)?_c('textarea',{staticClass:"textareabg CSChatThai",staticStyle:{"background-color":"#1a222c !important"},attrs:{"disabled":"","placeholder":_vm.$t('ChatSide.textarea.inactive'),"rows":"3","id":"textareaChat"}}):_c('textarea',{staticClass:"textareabg CSChatThai",staticStyle:{"background-color":"#1a222c !important"},attrs:{"disabled":"","placeholder":"Network error","rows":"3","id":"textareaChat"}}),_vm._v(" "),(_vm.statemember=='active' && _vm.online)?_c('div',{staticStyle:{"margin-top":"-2px"}},[(_vm.list_richmenu.length !== 0)?_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":_vm.chsheetrichmenu}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-list")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":_vm.chsheetother}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-plus")])],1),_vm._v(" "),_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":_vm.uppic}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"23px !important"}},[_vm._v("insert_photo")])],1),_vm._v(" "),_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","cursor":"pointer","margin":"0","margin-left":"-2px"},attrs:{"icon":"","dark":""},on:{"click":_vm.chsheetsticker}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"23px !important"}},[_vm._v("face")])],1)],1):_c('div',{staticStyle:{"margin-top":"-2px"}},[(_vm.list_richmenu.length !== 0)?_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","margin":"0","margin-left":"-2px"},attrs:{"disabled":"","icon":"","dark":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-list")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","margin":"0","margin-left":"-2px"},attrs:{"disabled":"","icon":"","dark":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("fas fa-plus")])],1),_vm._v(" "),_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","margin":"0","margin-left":"-2px"},attrs:{"disabled":"","icon":"","dark":""}},[_c('v-icon',{staticStyle:{"color":"gray","font-size":"23px !important"}},[_vm._v("insert_photo")])],1),_vm._v(" "),_c('v-btn',{staticClass:"iconchat",staticStyle:{"font-size":"16px","color":"gray","margin":"0","margin-left":"-2px"},attrs:{"disabled":"","icon":"","dark":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"23px !important"}},[_vm._v("face")])],1)],1),_vm._v(" "),(_vm.statemember=='active' && _vm.online && _vm.sheetother)?_c('v-card',{staticStyle:{"margin-left":"-9px","margin-right":"-9px","bottom":"196px  !important","height":"78px","background":"#062e63","box-shadow":"none"},attrs:{"tile":"","id":"menu-chat"}},[_c('div',{staticClass:"sidebar-menu"},[_c('ul',[_c('li',[_c('a',{staticStyle:{"padding-top":"3px"},attrs:{"title":"File"},on:{"click":_vm.upfile}},[_c('v-icon',{staticStyle:{"font-size":"20px !important","background":"#2662af","border-radius":"50%","display":"flex","justify-content":"center","align-items":"center","color":"white"}},[_vm._v("attach_file")]),_vm._v(" "),_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])],1)]),_vm._v(" "),_c('li',[_c('a',{staticStyle:{"padding-top":"3px"},attrs:{"title":"Account"},on:{"click":function($event){_vm.dialogAccount = true; _vm.sheetother = false}}},[_c('v-icon',{staticClass:"acount",staticStyle:{"font-size":"20px !important","background":"#23ad54","border-radius":"50%","display":"flex","justify-content":"center","align-items":"center","color":"white"}},[_vm._v("mdi-account")]),_vm._v(" "),_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('ChatSide.friend')))])],1)]),_vm._v(" "),_c('li',[_c('a',{staticStyle:{"padding-top":"3px"},attrs:{"title":"Location"},on:{"click":function($event){_vm.openmap()}}},[_c('v-icon',{staticClass:"acount",staticStyle:{"font-size":"20px !important","background":"#cd2b01","border-radius":"50%","display":"flex","justify-content":"center","align-items":"center","color":"white"}},[_vm._v("location_on")]),_vm._v(" "),_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('ChatSide.location')))])],1)]),_vm._v(" "),_c('li',[_c('a',{staticStyle:{"padding-top":"3px"},attrs:{"title":"Forward"},on:{"click":function($event){_vm.ForwardState = true; _vm.sheetother = false}}},[_c('v-icon',{staticClass:"acount",staticStyle:{"font-size":"20px !important","background":"#d02788","border-radius":"50%","display":"flex","justify-content":"center","align-items":"center","color":"white"}},[_vm._v("far fa-share-square ")]),_vm._v(" "),_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('ChatSide.forward')))])],1)])])])]):_vm._e(),_vm._v(" "),(_vm.statemember=='active' && _vm.online && _vm.sheetsticker)?_c('v-card',{staticStyle:{"margin-left":"-9px","margin-right":"-9px","bottom":"248px !important","background":"#062e63","height":"130px"},attrs:{"tile":"","id":"menu-sticker"}},[_c('v-card-text',{staticStyle:{"padding-top":"0vh","text-transform":"none"}},[_c('v-tabs',{staticStyle:{"background":"#062e63 !important","text-transform":"none"},attrs:{"slot":"extension","centered":""},slot:"extension",model:{value:(_vm.activetapEmo),callback:function ($$v) {_vm.activetapEmo=$$v},expression:"activetapEmo"}},[_c('v-tab',{staticStyle:{"font-size":"13px","text-transform":"none !important","overflow-y":"hidden","background":"#062e63 !important"},attrs:{"href":"#tab-Emo"}},[_c('p',{staticClass:"textemo"},[_vm._v(_vm._s(_vm.$t('ChatSide.emoji')))])]),_vm._v(" "),_c('v-tab',{staticStyle:{"font-size":"13px","text-transform":"none !important","overflow-y":"hidden","background":"#062e63 !important"},attrs:{"href":"#tab-Stick"}},[_c('p',{staticClass:"textemo"},[_vm._v(_vm._s(_vm.$t('ChatSide.sticker')))])])],1),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"margin-top":"0.2vh","background":"#062e63 !important"},model:{value:(_vm.activetapEmo),callback:function ($$v) {_vm.activetapEmo=$$v},expression:"activetapEmo"}},[_c('v-tab-item',{staticClass:"scrolling-wrapper-y",staticStyle:{"height":"105px","text-transform":"none","background":"#062e63 !important"},attrs:{"id":"tab-Emo"}},[_c('div',{staticStyle:{"background":"#062e63 !important"}},[_c('v-tabs',{staticStyle:{"background":"#062e63 !important"},attrs:{"slot":"extension","centered":""},slot:"extension",model:{value:(_vm.activeEmoji),callback:function ($$v) {_vm.activeEmoji=$$v},expression:"activeEmoji"}},_vm._l((_vm.emojiGroups),function(emojiGroup,category){return _c('v-tab',{staticStyle:{"font-size":"20px"},attrs:{"href":'#tab-'+ category}},[_vm._v("\n                        "+_vm._s(emojiGroup['smile'])+"\n                        "+_vm._s(emojiGroup['bear'])+"\n                        "+_vm._s(emojiGroup['soccer'])+"\n                        "+_vm._s(emojiGroup['house_with_garden'])+"\n                        "+_vm._s(emojiGroup['heart_decoration'])+"\n                      ")])})),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"margin-top":"0.2vh"},model:{value:(_vm.activeEmoji),callback:function ($$v) {_vm.activeEmoji=$$v},expression:"activeEmoji"}},_vm._l((_vm.emojiGroups),function(emojiGroup,category){return _c('v-tab-item',{staticClass:"scrolling-wrapper-y",staticStyle:{"height":"75px"},attrs:{"id":'tab-'+category}},[_c('div',{staticClass:"emojis"},_vm._l((emojiGroup),function(emoji,emojiName){return _c('span',{key:emojiName,attrs:{"title":emojiName},on:{"click":function($event){_vm.append(emoji)}}},[_vm._v(_vm._s(emoji))])}))])}))],1)]),_vm._v(" "),_c('v-tab-item',{staticClass:"scrolling-wrapper-y",staticStyle:{"height":"105px","text-transform":"none"},attrs:{"id":"tab-Stick"}},[_c('div',{staticStyle:{"background":"#062e63 !important"}},[_c('v-tabs',{staticStyle:{"background":"#062e63 !important"},attrs:{"slot":"extension","centered":""},slot:"extension",model:{value:(_vm.activeSticker),callback:function ($$v) {_vm.activeSticker=$$v},expression:"activeSticker"}},_vm._l((_vm.sticker),function(item,index){return _c('v-tab',{key:item.token_sticker,staticStyle:{"font-size":"20px"},attrs:{"href":'#tabsticker-'+item.token_sticker}},[_c('img',{staticStyle:{"width":"30px"},attrs:{"src":item.path_title}})])})),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"margin-top":"0.2vh","background":"#062e63"},model:{value:(_vm.activeSticker),callback:function ($$v) {_vm.activeSticker=$$v},expression:"activeSticker"}},_vm._l((_vm.sticker),function(item,index){return _c('v-tab-item',{staticClass:"scrolling-wrapper-y",staticStyle:{"height":"75px"},attrs:{"id":'tabsticker-'+item.token_sticker}},[_c('v-container',{staticStyle:{"padding":"0"},attrs:{"wrap":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((item.list_sticker),function(items,index){return _c('v-flex',{staticStyle:{"justify-content":"center"},attrs:{"sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-layout',{staticStyle:{"justify-content":"center","display":"flex","text-align":"center"}},[_c('img',{staticStyle:{"width":"70px","height":"70px","cursor":"pointer"},attrs:{"src":items.s3_name},on:{"click":function($event){_vm.pushSticker(items.message)}}})])],1)}))],1)],1)}))],1)])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showmessagebottom)?_c('v-flex',{staticStyle:{"margin":"0","bottom":"170px","position":"fixed","width":"50%","height":"4vh","padding":"5px !important","cursor":"pointer"},attrs:{"lg12":"","md12":"","sm12":"","xl12":""},on:{"click":_vm.lookmessage}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-chip',{staticStyle:{"cursor":"pointer"},attrs:{"close":""},on:{"click":function($event){_vm.chip = false;}},model:{value:(_vm.chip),callback:function ($$v) {_vm.chip=$$v},expression:"chip"}},[_c('v-avatar',[(_vm.picturechip)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.picturechip}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('span',{staticClass:"text2"},[_vm._v(_vm._s(_vm.showmessage))])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showmention)?_c('v-flex',{staticClass:"showmention",attrs:{"lg12":"","md12":"","sm12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(_vm.SelectedMessageDetail.path_pic !== '')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"height":"40px","width":"40px"},attrs:{"src":_vm.SelectedMessageDetail.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"height":"40px","width":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10px"},attrs:{"xs10":""}},[(_vm.SelectedMessageDetail.typeofmessage == 'message' || _vm.SelectedMessageDetail.typeofmessage == 'mention_message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"30vw","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.SelectedMessageDetail.nickname))]),_vm._v(" "),(_vm.SelectedMessageDetail.message)?_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"30vw","overflow":"hidden","text-overflow":"ellipsis"},domProps:{"innerHTML":_vm._s(_vm.convertMention(_vm.SelectedMessageDetail.message))}}):_vm._e()]):(_vm.SelectedMessageDetail.typeofmessage === 'image' || _vm.SelectedMessageDetail.typeofmessage === 'sticker' || _vm.SelectedMessageDetail.typeofmessage === 'file')?_c('v-layout',{attrs:{"row":""}},[_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"30vw","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.SelectedMessageDetail.nickname))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.SelectedMessageDetail.typeofmessage === 'image')?_c('img',{staticStyle:{"height":"40px","width":"40px","border-radius":"10px"},attrs:{"src":_vm.SelectedMessageDetail.message}}):(_vm.SelectedMessageDetail.typeofmessage === 'sticker')?_c('img',{staticStyle:{"height":"40px","width":"40px","border-radius":"10px"},attrs:{"src":_vm.SelectedMessageDetail.file_name}}):(_vm.extension(_vm.SelectedMessageDetail.file_name) === 'pdf')?_c('v-icon',{staticStyle:{"color":"white","font-size":"35px"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"white","font-size":"35px"}},[_vm._v(_vm._s(_vm.extension(_vm.SelectedMessageDetail.file_name)))])],1):(_vm.SelectedMessageDetail.typeofmessage === 'video')?_c('v-layout',{attrs:{"row":""}},[_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"30vw","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.SelectedMessageDetail.nickname))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.extension(_vm.SelectedMessageDetail.message) === 'media')?_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"40","height":"40","controls":""}},[_c('source',{attrs:{"src":_vm.SelectedMessageDetail.message,"type":'video/' + _vm.SelectedMessageDetail.message.split('.')[_vm.SelectedMessageDetail.message.split('.').length - 1]}})]):_c('img',{staticStyle:{"width":"40px","height":"40px","justify-content":"center","align-items":"center"},attrs:{"src":_vm.SelectedMessageDetail.thumbnail}})],1):(_vm.SelectedMessageDetail.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"50vw","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.SelectedMessageDetail.nickname))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"white","font-size":"35px"}},[_vm._v("fas fa-map-marker-alt")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"15px","padding-bottom":"20px"},attrs:{"xs1":""}},[_c('v-icon',{attrs:{"color":"white"},on:{"click":function($event){_vm.showmention = false;}}},[_vm._v("close")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.checksen(_vm.sendmsg))?_c('v-btn',{staticClass:"buttonsend",staticStyle:{"bottom":"4px","position":"fixed","margin-left":"66vw"},attrs:{"small":"","flat":""},on:{"click":function($event){_vm.sendMessage(_vm.sendmsg)}}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"15px !important"}},[_vm._v("send")]),_vm._v(" Send\n        ")],1):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.status_tag === true)?_c('v-card',{staticClass:"friendList"},[_c('div',_vm._l((_vm.listfriend_filter),function(item,index){return _c('v-list',{key:index},[_c('v-list-tile',{on:{"click":function($event){_vm.tagFriend(item.name)}}},[_c('v-list-tile-avatar',[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.name)}})],1)],1)],1)}))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('input',{attrs:{"type":"file","id":"uploadpic_ocr","accept":"image/*"},on:{"change":function($event){_vm.onimgSelected_ocr($event)},"click":function($event){_vm.clearImage()}}}),_vm._v(" "),_c('input',{attrs:{"multiple":"","type":"file","id":"uploadpic","accept":"image/*"},on:{"change":function($event){_vm.onimgSelected($event)}}}),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"uploadpic_quickreply","accept":"image/*"},on:{"change":function($event){_vm.onimgSelected_quickreply($event)},"click":function($event){_vm.clearImage()}}}),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"uploadfile_quickreply"},on:{"change":function($event){_vm.onimgSelected_quickreply($event)},"click":function($event){_vm.clearImage()}}}),_vm._v(" "),_c('input',{attrs:{"multiple":"","type":"file","id":"uploadfileChat"},on:{"change":_vm.onFileSelected}})])],1)],1),_vm._v(" "),_c('LoginDialog',{attrs:{"dialogLogin":_vm.dialogLogin},on:{"closeLoginDialog":_vm.closeLoginDialog}}),_vm._v(" "),_c('AccountDialog',{attrs:{"dialogAccount":_vm.dialogAccount},on:{"closeAccount":_vm.closeAccount,"pushcontact":_vm.pushcontact}}),_vm._v(" "),_c('MapDialog',{attrs:{"dialogSendMap":_vm.dialogSendMap},on:{"closeSendMap":_vm.closeSendMap,"send_location":_vm.send_location}}),_vm._v(" "),_c('NoteDialog',{attrs:{"dialogNote":_vm.dialogNote,"note_id":_vm.note_id,"statemember":_vm.statemember},on:{"closeNote":_vm.closeNote}}),_vm._v(" "),_c('AlbumsDialog',{attrs:{"dialogAlbums":_vm.dialogAlbums,"albums_id":_vm.albums_id},on:{"closeAlbums":_vm.closeAlbums}}),_vm._v(" "),_c('AddImageDialog',{attrs:{"dialogAddImage":_vm.dialogAddImage,"path_pic_albums":_vm.SelectedMessageDetail.message,"file_name":_vm.SelectedMessageDetail.file_name},on:{"closeAddImage":_vm.closeAddImage}}),_vm._v(" "),_c('CreatemailDialog',{attrs:{"dialogCreatemail":_vm.dialogCreatemail,"message":_vm.SelectedMessageDetail},on:{"closeCreatemail":_vm.closeCreatemail}}),_vm._v(" "),_c('WebviewBigDialog',{attrs:{"token":_vm.token,"tokenrooomSelect":_vm.tokenrooomSelect,"dialogWebviewbig":_vm.dialogWebviewbig,"Webview_item":_vm.Webview_item},on:{"closeWebview":_vm.closeWebview}}),_vm._v(" "),_c('WebviewBigOcrDialog',{attrs:{"token":_vm.token,"tokenrooomSelect":_vm.tokenrooomSelect,"dialogWebviewbig_ocr":_vm.dialogWebviewbig_ocr,"Webview_item":_vm.Webview_item_ocr},on:{"closeWebview":_vm.closeWebview}}),_vm._v(" "),_c('ApproveDialog',{attrs:{"dialogApprove":_vm.dialogApprove,"ApproveDetail":_vm.ApproveDetail},on:{"sendansApprove":_vm.sendansApprove,"closeApprove":_vm.closeApprove}}),_vm._v(" "),_c('ForwardDialog',{attrs:{"dialogForward":_vm.dialogForward,"selectedForward":_vm.selectedForward},on:{"closeForward":_vm.closeForward}}),_vm._v(" "),_c('Openwebsite',{attrs:{"dialogopenwebsite":_vm.dialogopenwebsite,"id":_vm.id,"type":_vm.type},on:{"closeDialog":_vm.closeDialog}}),_vm._v(" "),_c('DetailTask',{attrs:{"dialogDetailTask":_vm.dialogDetailTask,"taskid":_vm.taskid,"roomid":_vm.roomid},on:{"closeDetailTask":_vm.closeDetailTask}}),_vm._v(" "),_c('SaveOnebox',{attrs:{"dialogSaveOnebox":_vm.dialogSaveOnebox,"tokenmessage_savebox":_vm.tokenmessage_savebox},on:{"closeSaveOnebox":_vm.closeSaveOnebox}}),_vm._v(" "),_c('CheckBrowserDialog',{attrs:{"checkBrowserDialog":_vm.checkBrowserDialog,"checkBrowserInfor":_vm.checkBrowserInfor},on:{"closeCheckBrowser":_vm.closeCheckBrowser}}),_vm._v(" "),_c('QrcodeDialog',{attrs:{"QrcodeInfor":_vm.QrcodeInfor,"typemenu":_vm.typemenu,"dialogShowQRCode":_vm.dialogShowQRCode,"tokenroom":_vm.tokenrooomSelect},on:{"closeShowQRCodeUser":_vm.closeShowQRCodeUser}}),_vm._v(" "),_c('AgoraCallDialog',{attrs:{"AgoraCallDialog":_vm.AgoraCallDialog,"AgoraOption":_vm.AgoraOption,"infor_call":_vm.infor_call,"tokenuser":_vm.token},on:{"decline_call":_vm.decline_call,"closeAgoraDialog":_vm.closeAgoraDialog}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":""},model:{value:(_vm.dialogMap),callback:function ($$v) {_vm.dialogMap=$$v},expression:"dialogMap"}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[(_vm.locationName.file_name != '')?_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v(" 🚩  "+_vm._s(_vm.locationName.file_name)+" ")]):_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v(" 🚩  somewhere ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":function($event){_vm.dialogMap = false}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('gmap-map',{staticStyle:{"width":"100%","height":"calc(100vh - 64px)"},attrs:{"center":_vm.center_markermap,"zoom":15}},[_c('gmap-marker',{attrs:{"position":_vm.center_markermap}})],1)],1)],1)}
var ChatSideOnemeet_staticRenderFns = []
var ChatSideOnemeet_esExports = { render: ChatSideOnemeet_render, staticRenderFns: ChatSideOnemeet_staticRenderFns }
/* harmony default export */ var onemeet_ChatSideOnemeet = (ChatSideOnemeet_esExports);
// CONCATENATED MODULE: ./src/components/chat/onemeet/ChatSideOnemeet.vue
function ChatSideOnemeet_injectStyle (ssrContext) {
  __webpack_require__("Se/A")
}
var ChatSideOnemeet_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChatSideOnemeet___vue_template_functional__ = false
/* styles */
var ChatSideOnemeet___vue_styles__ = ChatSideOnemeet_injectStyle
/* scopeId */
var ChatSideOnemeet___vue_scopeId__ = "data-v-163d15db"
/* moduleIdentifier (server only) */
var ChatSideOnemeet___vue_module_identifier__ = null
var ChatSideOnemeet_Component = ChatSideOnemeet_normalizeComponent(
  ChatSideOnemeet["a" /* default */],
  onemeet_ChatSideOnemeet,
  ChatSideOnemeet___vue_template_functional__,
  ChatSideOnemeet___vue_styles__,
  ChatSideOnemeet___vue_scopeId__,
  ChatSideOnemeet___vue_module_identifier__
)

/* harmony default export */ var chat_onemeet_ChatSideOnemeet = (ChatSideOnemeet_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/settings/CreateGroup_anoDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var CreateGroup_anoDialog = ({
  props: { dialogGroup: false, anoGroupDetail: {} },
  data: function data() {
    return {
      GroupName: '',
      token: '',
      checkbox: true
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },

  watch: {
    anoGroupDetail: function anoGroupDetail() {
      this.GroupName = this.anoGroupDetail.pseudonym;
    }
  },
  methods: {
    closeDialogCreateGroup_ano: function closeDialogCreateGroup_ano() {
      this.$emit('closeDialogCreateGroup_ano', false);
    },
    createGroup_ano: function createGroup_ano() {
      var _this = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/create-group-anonymous', {
        tokenuser: this.token,
        group_ref_id: this.anoGroupDetail.group_ref_id,
        add_owner: this.checkbox + '',
        group_name: this.GroupName
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this.$swal('สร้างกลุ่มแชทสำเร็จแล้ว', '', 'success');
          _this.closeDialogCreateGroup_ano();
        }
      }, function () {
        console.log('error');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f59cc2f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/settings/CreateGroup_anoDialog.vue
var CreateGroup_anoDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialogGroup),callback:function ($$v) {_vm.dialogGroup=$$v},expression:"dialogGroup"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("group")]),_vm._v("  สร้างกลุ่มแชท")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialogCreateGroup_ano}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',[_vm._v("ตั้งชื่อกลุ่ม")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.GroupName),expression:"GroupName"}],staticClass:"CSChatThai inputgroupweb",attrs:{"type":"text","placeholder":"ชื่อกลุ่ม"},domProps:{"value":(_vm.GroupName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.GroupName=$event.target.value}}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"ดึงตัวเองเข้ากลุ่ม"},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"blue darken-1","flat":"flat","disabled":_vm.GroupName==''},on:{"click":function($event){_vm.createGroup_ano()}}},[_vm._v("สร้าง")])],1)],1)],1)],1)}
var CreateGroup_anoDialog_staticRenderFns = []
var CreateGroup_anoDialog_esExports = { render: CreateGroup_anoDialog_render, staticRenderFns: CreateGroup_anoDialog_staticRenderFns }
/* harmony default export */ var settings_CreateGroup_anoDialog = (CreateGroup_anoDialog_esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/settings/CreateGroup_anoDialog.vue
function CreateGroup_anoDialog_injectStyle (ssrContext) {
  __webpack_require__("gRgH")
}
var CreateGroup_anoDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateGroup_anoDialog___vue_template_functional__ = false
/* styles */
var CreateGroup_anoDialog___vue_styles__ = CreateGroup_anoDialog_injectStyle
/* scopeId */
var CreateGroup_anoDialog___vue_scopeId__ = "data-v-f59cc2f4"
/* moduleIdentifier (server only) */
var CreateGroup_anoDialog___vue_module_identifier__ = null
var CreateGroup_anoDialog_Component = CreateGroup_anoDialog_normalizeComponent(
  CreateGroup_anoDialog,
  settings_CreateGroup_anoDialog,
  CreateGroup_anoDialog___vue_template_functional__,
  CreateGroup_anoDialog___vue_styles__,
  CreateGroup_anoDialog___vue_scopeId__,
  CreateGroup_anoDialog___vue_module_identifier__
)

/* harmony default export */ var dialog_settings_CreateGroup_anoDialog = (CreateGroup_anoDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/layout/anonymousone_group.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var anonymousone_group = ({
  data: function data() {
    return {
      list_anonymous_joined: [],
      list_anonymous_owner: [],
      token: '',
      dialogGroup: false,
      anoGroupDetail: {}
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.get_anonymousjoined();
    this.get_anonymousowner();
  },

  components: {
    createGroupAno: dialog_settings_CreateGroup_anoDialog
  },
  methods: {
    closeDialogCreateGroup_ano: function closeDialogCreateGroup_ano() {
      this.dialogGroup = false;
    },
    openCreateGroup: function openCreateGroup(item) {
      this.dialogGroup = true;
      this.anoGroupDetail = item;
    },
    get_anonymousjoined: function get_anonymousjoined() {
      var _this = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-anonymous-joined', {
        tokenuser: this.token
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          _this.list_anonymous_joined = response.data.group_joined;
        }
      }, function () {
        console.log('error');
      });
    },
    get_anonymousowner: function get_anonymousowner() {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-anonymous-owner', {
        tokenuser: this.token
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          _this2.list_anonymous_owner = response.data.group_owner;
        }
      }, function () {
        console.log('error');
      });
    },
    openCreateBiz: function openCreateBiz(item) {
      // var url = 'https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token='
      var body = {
        "tokenuser": this.token,
        "url": "https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token="
      };
      this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", body).then(function (response) {
        window.open("https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token=" + response.data.data.accesstoken, '_blank');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-082538ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/layout/anonymousone_group.vue
var anonymousone_group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v(_vm._s(_vm.$t('Anonymous.manageGroup')))]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-container',{staticStyle:{"max-height":"35vh","overflow":"scroll"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.list_anonymous_owner.length > 0)?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},_vm._l((_vm.list_anonymous_owner),function(item,index){return _c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"rgb(255, 255, 255) !important","max-width":"100% !important","cursor":"auto"},attrs:{"two-line":"","subheader":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"}},[_vm._v("\n                "+_vm._s(item.pseudonym)+"\n\n              ")])],1),_vm._v(" "),_c('v-list-tile-action',{staticStyle:{"width":"30%","display":"inline","margin-top":"30px"}},[_c('v-btn',{staticStyle:{"background-color":"white","border-radius":"50px","color":"#536475","padding-left":"9px","padding-right":"9px","text-transform":"none","border":"#536475 solid 1px"},attrs:{"depressed":""},on:{"click":function($event){_vm.openCreateGroup(item)}}},[_vm._v("\n                "+_vm._s(_vm.$t('Anonymous.createGroup'))+"\n              ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"background-color":"#536475","border-radius":"50px","color":"white","padding-left":"9px","padding-right":"9px","border":"#bebec1 1px solid","text-transform":"none"},attrs:{"depressed":""},on:{"click":function($event){_vm.openCreateBiz(item)}}},[_vm._v("\n                "+_vm._s(_vm.$t('Anonymous.createBusiness'))+"\n              ")])],1)],1),_vm._v(" "),_c('v-divider')],1)})):_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',[_vm._v(_vm._s(_vm.$t('Anonymous.noManageGroup')))])])],1)],1),_vm._v(" "),_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v(_vm._s(_vm.$t('Anonymous.yourGroup')))]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-container',{staticStyle:{"max-height":"35vh","overflow":"scroll"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.list_anonymous_joined.length > 0)?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},_vm._l((_vm.list_anonymous_joined),function(item,index){return _c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"rgb(255, 255, 255) !important","max-width":"100% !important","cursor":"auto"},attrs:{"two-line":"","subheader":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"}},[_vm._v("\n                "+_vm._s(item.pseudonym)+"\n\n              ")])],1),_vm._v(" "),_c('v-list-tile-action',{staticStyle:{"width":"30%","display":"inline","margin-top":"30px"}})],1),_vm._v(" "),_c('v-divider')],1)})):_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',[_vm._v(_vm._s(_vm.$t('Anonymous.noYourManageGroup')))])])],1)],1),_vm._v(" "),_c('createGroupAno',{attrs:{"dialogGroup":_vm.dialogGroup,"anoGroupDetail":_vm.anoGroupDetail},on:{"closeDialogCreateGroup_ano":_vm.closeDialogCreateGroup_ano}})],1)}
var anonymousone_group_staticRenderFns = []
var anonymousone_group_esExports = { render: anonymousone_group_render, staticRenderFns: anonymousone_group_staticRenderFns }
/* harmony default export */ var layout_anonymousone_group = (anonymousone_group_esExports);
// CONCATENATED MODULE: ./src/components/chat/layout/anonymousone_group.vue
function anonymousone_group_injectStyle (ssrContext) {
  __webpack_require__("a8MN")
}
var anonymousone_group_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var anonymousone_group___vue_template_functional__ = false
/* styles */
var anonymousone_group___vue_styles__ = anonymousone_group_injectStyle
/* scopeId */
var anonymousone_group___vue_scopeId__ = "data-v-082538ee"
/* moduleIdentifier (server only) */
var anonymousone_group___vue_module_identifier__ = null
var anonymousone_group_Component = anonymousone_group_normalizeComponent(
  anonymousone_group,
  layout_anonymousone_group,
  anonymousone_group___vue_template_functional__,
  anonymousone_group___vue_styles__,
  anonymousone_group___vue_scopeId__,
  anonymousone_group___vue_module_identifier__
)

/* harmony default export */ var chat_layout_anonymousone_group = (anonymousone_group_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_friend/DetailFriendDialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var DetailFriendDialog = ({
  props: {
    'dialogdetailfriend': false,
    relation: '',
    result: {},
    pictureFriend: '',
    pictureGroup: '',
    status: '',
    id: '',
    type: ''
  },
  data: function data() {
    return {
      token: '',
      result_search: {},
      relation_friend: '',
      picture_Friend: '',
      picture_Group: '',
      status_search: 'loading',
      id_friend: '',
      type_friend: '',
      dialogshowimage_profile: false,
      pathpicture: '',
      typepathpicture: ''
    };
  },
  components: {
    ShowImageProfileDialog: ShowImage_ProfileDialog["a" /* default */]
  },
  watch: {
    dialogdetailfriend: function dialogdetailfriend() {
      console.log(this.dialogdetailfriend);
      this.result_search = this.result;
      this.relation_friend = this.relation;
      this.picture_Friend = this.pictureFriend;
      this.picture_Group = this.pictureGroup;
      this.status_search = this.status;
      this.id_friend = this.id;
      this.type_friend = this.type;
    }
  },
  methods: {
    openPictureProfile: function openPictureProfile() {
      this.pathpicture = this.result_search.profilepicture;
      this.typepathpicture = this.result_search.type;
      this.dialogshowimage_profile = true;
    },
    openPictureGroup: function openPictureGroup() {
      this.pathpicture = this.result_search.picture;
      this.typepathpicture = 'group';
      this.dialogshowimage_profile = true;
    },
    closeDialogShowImage_Profile: function closeDialogShowImage_Profile(value) {
      this.dialogshowimage_profile = value;
    },
    AcceptGroup: function AcceptGroup(group_id) {
      var _this = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/joingroup', {
        group_id: group_id,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response)
        _this.socketactive_group = { timestamp: '', groupid: group_id, tokenuser: _this.token };
        _this.closeDialog();
      });
    },
    chat: function chat(tokenroom) {
      this.$router.push('/chat/room/' + tokenroom);
      this.closeDialog();
    },
    AcceptReq: function AcceptReq(tokenFriend) {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/accept-friend", {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this2.relation_friend = 'friend';
          _this2.result_search['tokenroom'] = response.data.tokenroom;
          _this2.socketaccept_friend = { tokenuser: _this2.token, tokenfriend: tokenFriend, tokenroom: response.data.tokenroom
            // this.closeDialog()
          };
        }
      });
    },
    RemoveReq: function RemoveReq(tokenFriend) {
      var _this3 = this;

      // console.log(tokenFriend)
      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          _this3.relation_friend = 'unknown';
          _this3.socketremove_request_friend = {
            tokenuser: tokenFriend,
            tokenfriend: _this3.token
            // this.closeDialog()
          };
        }
      });
    },
    AddFriend: function AddFriend(tokenFriend) {
      var _this4 = this;

      // console.log(tokenFriend)
      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this4.relation_friend = 'sendrequest';
          _this4.socketfriend = { tokenfriend: [tokenFriend], konAdd: _this4.token
            // console.log(this.socketfriend)
            // this.$store.dispatch('sendRequest', tokenFriend)
            // this.closeDialog()
          };
        } else {
          alert('Error!!!');
        }
      });
    },
    unblock: function unblock(tokenFriend, tokenroom) {
      var _this5 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token,
        tokenroom: tokenroom
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this5.$swal('Unblocked!', _this5.$t('Alert.Success.unblock'), 'success');
          _this5.relation_friend = 'friend';
          _this5.result_search['state'] = 'friend';
          _this5.result_search['event'] = 'unblock_friend';
          _this5.block_friend = _this5.result_search;
        }
      });
    },
    findWithAttr: function findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
    closeDialog: function closeDialog() {
      this.status_search = 'loading';
      this.result_search = {};
      this.relation_friend = '';
      this.picture_Friend = '';
      this.picture_Group = '';
      this.id_friend = '', this.type_friend = '';
      this.$emit('closeDialog', false);
    }
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    // console.log(this.tokenuserQR)
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a70bf80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_friend/DetailFriendDialog.vue
var DetailFriendDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialogdetailfriend),callback:function ($$v) {_vm.dialogdetailfriend=$$v},expression:"dialogdetailfriend"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[(_vm.type_friend=='friend' && _vm.status_search=='success')?_c('div',[_c('img',{staticClass:"pictureProfile",attrs:{"src":_vm.picture_Friend},on:{"click":function($event){_vm.openPictureProfile()}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"}},[_c('h3',[_vm._v(_vm._s(_vm.result_search.name))]),_vm._v("\n               "+_vm._s(_vm.result_search.status)+"\n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.relation_friend=='friend')?_c('v-btn',{staticClass:"chatbtn",on:{"click":function($event){_vm.chat(_vm.result_search.tokenroom)}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.chat'))+"\n              ")]):(_vm.relation_friend=='request')?_c('v-btn',{staticClass:"chatbtn",on:{"click":function($event){_vm.AcceptReq(_vm.result_search.tokenuser)}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.acceptFriend'))+"\n              ")]):(_vm.relation_friend=='sendrequest')?_c('v-btn',{staticClass:"canclebtn",on:{"click":function($event){_vm.RemoveReq(_vm.result_search.tokenuser)}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.cancelRequest'))+"\n              ")]):(_vm.relation_friend=='self')?_c('v-btn',{staticClass:"chatbtn",on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n              ")]):(_vm.relation_friend=='unknown' || _vm.relation_friend=='unfriend')?_c('v-btn',{staticClass:"chatbtn",on:{"click":function($event){_vm.AddFriend(_vm.result_search.tokenuser)}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.addFriend'))+"\n              ")]):(_vm.relation_friend=='block')?_c('v-btn',{staticClass:"canclebtn",on:{"click":function($event){_vm.unblock(_vm.result_search.tokenuser, _vm.result_search.tokenroom)}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.unblock'))+"\n              ")]):_vm._e()],1):(_vm.type_friend=='group' && _vm.status_search=='success')?_c('div',[_c('img',{staticClass:"pictureProfile",attrs:{"src":_vm.picture_Group},on:{"click":function($event){_vm.openPictureGroup()}}}),_vm._v(" "),_c('div',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"}},[_c('h3',[_vm._v(_vm._s(_vm.result_search.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.result_search.state != 'active')?_c('v-btn',{staticClass:"chatbtn",on:{"click":function($event){_vm.AcceptGroup(_vm.result_search.group_id)}}},[_vm._v("\n              "+_vm._s(_vm.$t('AnswerQuestion.joinGroup'))+"\n            ")]):_c('v-btn',{staticClass:"chatbtn",on:{"click":function($event){_vm.chat(_vm.result_search.tokenroom)}}},[_vm._v("\n              "+_vm._s(_vm.$t('AnswerQuestion.chat'))+"\n            ")])],1):(_vm.status_search === 'loading')?_c('div',[_c('v-progress-linear',{attrs:{"color":"light-blue darken-4","indeterminate":"","height":"6"}})],1):_c('div',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"}},[_c('h3',[_vm._v("ไม่พบข้อมูล")])])])],1)],1)],1)],1),_vm._v(" "),_c('ShowImageProfileDialog',{attrs:{"dialogshowimage_profile":_vm.dialogshowimage_profile,"pathpicture":_vm.pathpicture,"typepathpicture":_vm.typepathpicture},on:{"closeDialogShowImage_Profile":_vm.closeDialogShowImage_Profile}})],1)}
var DetailFriendDialog_staticRenderFns = []
var DetailFriendDialog_esExports = { render: DetailFriendDialog_render, staticRenderFns: DetailFriendDialog_staticRenderFns }
/* harmony default export */ var manage_friend_DetailFriendDialog = (DetailFriendDialog_esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_friend/DetailFriendDialog.vue
function DetailFriendDialog_injectStyle (ssrContext) {
  __webpack_require__("w74u")
}
var DetailFriendDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DetailFriendDialog___vue_template_functional__ = false
/* styles */
var DetailFriendDialog___vue_styles__ = DetailFriendDialog_injectStyle
/* scopeId */
var DetailFriendDialog___vue_scopeId__ = "data-v-7a70bf80"
/* moduleIdentifier (server only) */
var DetailFriendDialog___vue_module_identifier__ = null
var DetailFriendDialog_Component = DetailFriendDialog_normalizeComponent(
  DetailFriendDialog,
  manage_friend_DetailFriendDialog,
  DetailFriendDialog___vue_template_functional__,
  DetailFriendDialog___vue_styles__,
  DetailFriendDialog___vue_scopeId__,
  DetailFriendDialog___vue_module_identifier__
)

/* harmony default export */ var dialog_manage_friend_DetailFriendDialog = (DetailFriendDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/pagedefault/HomepageChat.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var HomepageChat = ({
  data: function data() {
    return {
      dialogdetailfriend: false,
      result: {},
      relation: '',
      pictureFriend: '',
      pictureGroup: '',
      status: 'loading',
      dialogshowimage_profile: false,
      pathpicture: '',
      typepathpicture: '',
      DetailFriendialog: false,
      status_login: '',
      windowWidth: '',
      tokenuser: '',
      tokenfriend: '',
      type: '',
      id: '',
      infor_user: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    if (this.$cookie.get('path_id') !== 'null' || this.$cookie.get('path_id') !== null) {
      this.id = atob(this.$cookie.get('path_id'));
      this.type = this.$cookie.get('path_type');
      this.searchfriend();
    }
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.status_login = decoded['status_login'];
    if (window.innerWidth <= 960) {
      this.$router.push('/mobile/homepage');
    } else {
      this.$router.push('/chat');
    }
  },

  components: {
    DetailFriendialog: dialog_manage_friend_DetailFriendDialog
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {
    windowWidth: function windowWidth() {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage');
      } else {
        this.$router.push('/chat');
      }
    }
  },
  methods: {
    closeDialog: function closeDialog(value) {
      this.dialogdetailfriend = value;
    },
    searchfriend: function searchfriend() {
      var _this2 = this;

      if (this.type === 'friend') {
        this.status = 'loading';
        this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', {
          tokenuser: this.tokenuser,
          tokenfriend: this.id
        }).then(function (response) {
          // console.log(response.data)
          _this2.status = response.data.status;
          if (response.data.status === 'success') {
            _this2.$cookie.delete('path_type');
            _this2.$cookie.delete('path_id');
            _this2.relation = response.data.relation;
            _this2.result = response.data.user;
            if (_this2.result.profilepicture === '') {
              if (_this2.result.type === 'business') {
                _this2.pictureFriend = '/static/img/default_profile/business-white.png';
              } else if (_this2.result.type === 'bot') {
                _this2.pictureFriend = '/static/img/default_profile/bot-white.png';
              } else {
                _this2.pictureFriend = '/static/img/default_profile/man-white.png';
              }
            } else {
              _this2.pictureFriend = _this2.result.profilepicture;
            }
          }
          _this2.dialogdetailfriend = true;
        });
      } else if (this.type === 'group') {
        this.status = 'loading';
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', {
          tokenuser: this.tokenuser,
          group_id: this.id
        }).then(function (response) {
          _this2.status = response.data.status;
          if (response.data.status === 'success') {
            _this2.$cookie.delete('path_type');
            _this2.$cookie.delete('path_id');
            _this2.result = response.data.group;
            if (_this2.result.picture === '') {
              _this2.pictureGroup = '/static/img/default_profile/group-white.png';
            } else {
              _this2.pictureGroup = _this2.result.picture;
            }
          }
          _this2.dialogdetailfriend = true;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59fa81bf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/pagedefault/HomepageChat.vue
var HomepageChat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"overflow":"hidden !important"},attrs:{"fluid":""}},[(_vm.status_login === 'T')?_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"chatboxnonselect"},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('img',{attrs:{"src":"/static/img/icons/logoonechat_full.png","width":"600"}})])],1)]),_vm._v(" "),_c('DetailFriendialog',{attrs:{"dialogdetailfriend":_vm.dialogdetailfriend,"result":_vm.result,"relation":_vm.relation,"pictureFriend":_vm.pictureFriend,"pictureGroup":_vm.pictureGroup,"status":_vm.status,"id":_vm.id,"type":_vm.type},on:{"closeDialog":_vm.closeDialog}})],1):_vm._e()],1)}
var HomepageChat_staticRenderFns = []
var HomepageChat_esExports = { render: HomepageChat_render, staticRenderFns: HomepageChat_staticRenderFns }
/* harmony default export */ var pagedefault_HomepageChat = (HomepageChat_esExports);
// CONCATENATED MODULE: ./src/components/chat/pagedefault/HomepageChat.vue
function HomepageChat_injectStyle (ssrContext) {
  __webpack_require__("KnS9")
}
var HomepageChat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HomepageChat___vue_template_functional__ = false
/* styles */
var HomepageChat___vue_styles__ = HomepageChat_injectStyle
/* scopeId */
var HomepageChat___vue_scopeId__ = "data-v-59fa81bf"
/* moduleIdentifier (server only) */
var HomepageChat___vue_module_identifier__ = null
var HomepageChat_Component = HomepageChat_normalizeComponent(
  HomepageChat,
  pagedefault_HomepageChat,
  HomepageChat___vue_template_functional__,
  HomepageChat___vue_styles__,
  HomepageChat___vue_scopeId__,
  HomepageChat___vue_module_identifier__
)

/* harmony default export */ var chat_pagedefault_HomepageChat = (HomepageChat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/pagedefault/NotFound.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NotFound = ({
  data: function data() {
    return {
      status_login: ''
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.status_login = decoded['status_login'];
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40f833a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/pagedefault/NotFound.vue
var NotFound_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"overflow":"hidden !important"},attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"chatboxnonselect"},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('img',{attrs:{"src":"/static/img/pagedefault/notfound.jpg","width":"400"}})])],1)])],1)],1)}
var NotFound_staticRenderFns = []
var NotFound_esExports = { render: NotFound_render, staticRenderFns: NotFound_staticRenderFns }
/* harmony default export */ var pagedefault_NotFound = (NotFound_esExports);
// CONCATENATED MODULE: ./src/components/chat/pagedefault/NotFound.vue
function NotFound_injectStyle (ssrContext) {
  __webpack_require__("cnF5")
}
var NotFound_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NotFound___vue_template_functional__ = false
/* styles */
var NotFound___vue_styles__ = NotFound_injectStyle
/* scopeId */
var NotFound___vue_scopeId__ = "data-v-40f833a5"
/* moduleIdentifier (server only) */
var NotFound___vue_module_identifier__ = null
var NotFound_Component = NotFound_normalizeComponent(
  NotFound,
  pagedefault_NotFound,
  NotFound___vue_template_functional__,
  NotFound___vue_styles__,
  NotFound___vue_scopeId__,
  NotFound___vue_module_identifier__
)

/* harmony default export */ var chat_pagedefault_NotFound = (NotFound_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/pagedefault/NotPermission.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NotPermission = ({
  data: function data() {
    return {
      status_login: ''
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.status_login = decoded['status_login'];
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-159c94ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/pagedefault/NotPermission.vue
var NotPermission_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"overflow":"hidden !important"},attrs:{"fluid":""}},[(_vm.status_login === 'T')?_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"chatboxnonselect"},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"/static/img/pagedefault/notpermission.jpg","width":"200"}}),_vm._v(" "),_c('h2',[_vm._v(" คุณไม่สามารถเข้าถึงข้อมูลดังต่อไปนี้ได้")])])]),_vm._v(" "),_c('br')],1)])],1):_vm._e()],1)}
var NotPermission_staticRenderFns = []
var NotPermission_esExports = { render: NotPermission_render, staticRenderFns: NotPermission_staticRenderFns }
/* harmony default export */ var pagedefault_NotPermission = (NotPermission_esExports);
// CONCATENATED MODULE: ./src/components/chat/pagedefault/NotPermission.vue
function NotPermission_injectStyle (ssrContext) {
  __webpack_require__("xY0P")
}
var NotPermission_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NotPermission___vue_template_functional__ = false
/* styles */
var NotPermission___vue_styles__ = NotPermission_injectStyle
/* scopeId */
var NotPermission___vue_scopeId__ = "data-v-159c94ee"
/* moduleIdentifier (server only) */
var NotPermission___vue_module_identifier__ = null
var NotPermission_Component = NotPermission_normalizeComponent(
  NotPermission,
  pagedefault_NotPermission,
  NotPermission___vue_template_functional__,
  NotPermission___vue_styles__,
  NotPermission___vue_scopeId__,
  NotPermission___vue_module_identifier__
)

/* harmony default export */ var chat_pagedefault_NotPermission = (NotPermission_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/settings/EditProfile.vue
var EditProfile = __webpack_require__("gOkJ");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38debc0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/settings/EditProfile.vue
var EditProfile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CSChatThai BGwhite"},[_c('v-card-text',{staticClass:"scrolling-wrapper",staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important","max-height":"94vh","color":"rgb(74, 74, 74) !important"}},[_c('v-container',{staticStyle:{"padding-left":"90px","padding-right":"90px"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"List_item_body"},[_c('div',{staticClass:"SettingImg"},[_c('div',{staticClass:"SettingImgWrap"},[_c('div',[(_vm.profilepicture !== '')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer","width":"160px","height":"160px"},attrs:{"src":_vm.profilepicture},on:{"click":_vm.Editpictureprofile}}):(_vm.typeuser === 'business')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer","width":"160px","height":"160px"},attrs:{"src":"/static/img/default_profile/business-white.png"},on:{"click":_vm.Editpictureprofile}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer","width":"160px","height":"160px"},attrs:{"src":"/static/img/default_profile/man-white.png"},on:{"click":_vm.Editpictureprofile}}),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('input',{staticClass:"CSChatThai",attrs:{"type":"file","name":"file1","accept":"image/*","id":"uploadpicprofilechat"},on:{"change":_vm.previewImageprofiles}})]),_vm._v(" "),_c('label',{staticClass:"SettingImgBtn",attrs:{"for":"SettingImg"},on:{"click":_vm.Editpictureprofile}},[_vm._v("\n                    "+_vm._s(_vm.$t('Settings.editProfile.changePictureProfile'))+"\n                  ")])])])]),_vm._v(" "),_c('p',{staticClass:"EditAreaNote"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.support'))+" .JPEG/.PNG/.GIF")]),_c('p',{staticClass:"EditAreaNote"}),_c('p',{staticClass:"EditAreaNote"})])]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.profile')))])]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"Setting"},[_c('div',{staticClass:"SettingBlock"},[_c('p',{staticClass:"SettingTtl"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.displayName')))]),_vm._v(" "),_c('div',[(!_vm.editname)?_c('div',{staticClass:"EditArea"},[(!_vm.loadingname)?_c('div',{staticClass:"EditAreaCont BreakWord"},[_vm._v(_vm._s(_vm.name))]):_c('div',{staticClass:"EditAreaCont BreakWord"},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.loadingname}})],1),_vm._v(" "),_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":"","dark":""},on:{"click":function($event){_vm.editname = !_vm.editname}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.edit')))])])],1):_c('div',{staticClass:"EditArea"},[_c('div',{staticClass:"EditAreaCont"},[_c('div',{staticClass:"EditAreaContFlex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nameedit),expression:"nameedit"}],staticClass:"InputEdit",attrs:{"type":"text","placeholder":_vm.$t('Settings.editProfile.displayName')},domProps:{"value":(_vm.nameedit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nameedit=$event.target.value}}})]),_vm._v(" "),(_vm.nameedit == '')?_c('p',{staticClass:"EditAreaNote",staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.alerterror))]):_vm._e()]),_vm._v(" "),_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":"","dark":""},on:{"click":function($event){_vm.updatename()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.update')))])]),_vm._v(" "),_c('v-btn',{staticClass:"buttoncancel",attrs:{"flat":"","small":""},on:{"click":function($event){_vm.cancelname()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])])],1)])]),_vm._v(" "),_c('div',{staticClass:"SettingBlock"},[_c('p',{staticClass:"SettingTtl"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.status')))]),_vm._v(" "),_c('div',[(!_vm.editstatus)?_c('div',{staticClass:"EditArea"},[(_vm.status !== '')?_c('div',{staticClass:"EditAreaCont BreakWord"},[_vm._v(_vm._s(_vm.status))]):_c('div',{staticClass:"EditAreaCont BreakWord"},[_vm._v("-")]),_vm._v(" "),_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":"","dark":""},on:{"click":function($event){_vm.editstatus = !_vm.editstatus}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.edit')))])])],1):_c('div',{staticClass:"EditArea"},[_c('div',{staticClass:"EditAreaCont"},[_c('div',{staticClass:"EditAreaContFlex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.statusedit),expression:"statusedit"}],staticClass:"InputEdit",attrs:{"type":"text","placeholder":_vm.$t('Settings.editProfile.status')},domProps:{"value":(_vm.statusedit)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.updatestatus()},"input":function($event){if($event.target.composing){ return; }_vm.statusedit=$event.target.value}}})])]),_vm._v(" "),_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":"","dark":""},on:{"click":function($event){_vm.updatestatus()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.update')))])]),_vm._v(" "),_c('v-btn',{staticClass:"buttoncancel",attrs:{"flat":"","small":""},on:{"click":function($event){_vm.cancelstatus()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])])],1)])]),_vm._v(" "),_c('div',{staticClass:"SettingBlock"},[_c('p',{staticClass:"SettingTtl"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.phone')))]),_vm._v(" "),(!_vm.editphone)?_c('div',{staticClass:"EditArea"},[(!_vm.loadingphone)?_c('div',{staticClass:"EditAreaCont BreakWord"},[_vm._v(_vm._s(_vm.phone))]):_c('div',{staticClass:"EditAreaCont BreakWord"},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.loadingphone}})],1),_vm._v(" "),_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":"","dark":""},on:{"click":function($event){_vm.statusEditphone()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.edit')))])])],1):_c('div',{staticClass:"EditArea"},[_c('div',{staticClass:"EditAreaCont"},[_c('div',{staticClass:"EditAreaContFlex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneedit),expression:"phoneedit"}],staticClass:"InputEdit",attrs:{"type":"text","placeholder":_vm.$t('Settings.editProfile.phone')},domProps:{"value":(_vm.phoneedit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phoneedit=$event.target.value}}})]),_vm._v(" "),(_vm.nameedit == '')?_c('p',{staticClass:"EditAreaNote",staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.alerterror))]):_vm._e()]),_vm._v(" "),_c('v-btn',{staticClass:"buttonedit",staticStyle:{"color":"white"},attrs:{"flat":"","small":"","dark":"","loading":_vm.loadingUpdatePhone,"disabled":_vm.disableupdatephone()},on:{"click":function($event){_vm.updatephone()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.update')))])]),_vm._v(" "),_c('v-btn',{staticClass:"buttoncancel",attrs:{"flat":"","small":""},on:{"click":function($event){_vm.cancelphone()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])])],1)]),_vm._v(" "),_c('div',{staticClass:"SettingBlock"},[_c('p',{staticClass:"SettingTtl"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.email')))]),_vm._v(" "),_c('div',[_c('div',{staticClass:"EditArea"},[_c('div',{staticClass:"EditAreaCont BreakWord"},[_vm._v(_vm._s(_vm.email))])])])])])]),_vm._v(" "),(_vm.status_username === 'false')?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.settingusername')))])]):_vm._e(),_vm._v(" "),(_vm.status_username === 'false')?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"Setting"},[_c('div',{staticClass:"SettingBlock"},[_c('div',[(!_vm.editusername)?_c('div',{staticClass:"EditArea"},[(!_vm.loadingname)?_c('div',{staticClass:"EditAreaCont BreakWord"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.usernamepassword')))]):_c('div',{staticClass:"EditAreaCont BreakWord"},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.loadingname}})],1),_vm._v(" "),_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":"","dark":""},on:{"click":function($event){_vm.editusername = !_vm.editusername}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.edit')))])])],1):_c('div',{staticClass:"EditArea",staticStyle:{"align-items":"start !important"}},[_c('div',{staticClass:"EditAreaCont"},[_c('v-text-field',{attrs:{"placeholder":_vm.$t('Settings.editProfile.username'),"rules":_vm.usernameRules,"error":_vm.chkUsernameDuplicate,"error-messages":_vm.msgUsernameDuplicate,"autocapitalize":"off","required":"","solo":""},on:{"input":_vm.changeUsername,"keypress":function($event){_vm.isNumandaz($event)}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{attrs:{"placeholder":_vm.$t('Settings.editProfile.password'),"append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'text' : 'password',"rules":_vm.passwordRules,"required":"","solo":""},on:{"keypress":function($event){_vm.isnotthai($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"placeholder":_vm.$t('Settings.editProfile.confirmpassword'),"append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'text' : 'password',"rules":_vm.repasswordRules,"required":"","solo":""},on:{"keypress":function($event){_vm.isnotthai($event)}},model:{value:(_vm.confirmpassword),callback:function ($$v) {_vm.confirmpassword=$$v},expression:"confirmpassword"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":"","dark":"","disabled":_vm.checkData()},on:{"click":function($event){_vm.updateusername()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.update')))])]),_vm._v(" "),_c('v-btn',{staticClass:"buttoncancel",attrs:{"flat":"","small":""},on:{"click":function($event){_vm.cancelusername()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])])],1)])])])]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.qrcodeForAddFriend')))])]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"Setting"},[_c('div',{staticClass:"SettingBlock"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('p',{},[_c('qrcode',{staticStyle:{"margin":"0 !important","height":"200px","width":"200px","padding":"5px","border":"3px solid","border-radius":"10px"},attrs:{"value":_vm.tokenuserQR,"id":"downloadqr-web"}})],1),_vm._v(" "),_c('p',{},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.detailQRcode'))+"\n              "),_c('a',{staticClass:"button",attrs:{"href":"#","id":"btn-download-web","download":'qrcode_user_' + _vm.name + '.png'},on:{"click":function($event){_vm.loadqr()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.download')))])])])])])])],1)],1)],1),_vm._v(" "),_c('Editpictureprofile',{attrs:{"dialogEditpictureprofile":_vm.dialogEditpictureprofile},on:{"closeEditpictureprofile":_vm.closeEditpictureprofile}}),_vm._v(" "),_c('Dialogeditphone',{attrs:{"dialogeditphone":_vm.dialogeditphone,"phoneedit":_vm.phoneedit,"phone":_vm.phone},on:{"closeDialogEditPhone":_vm.closeDialogEditPhone,"newphonnum":_vm.newphonnum}})],1)}
var EditProfile_staticRenderFns = []
var EditProfile_esExports = { render: EditProfile_render, staticRenderFns: EditProfile_staticRenderFns }
/* harmony default export */ var settings_EditProfile = (EditProfile_esExports);
// CONCATENATED MODULE: ./src/components/chat/settings/EditProfile.vue
function EditProfile_injectStyle (ssrContext) {
  __webpack_require__("turh")
}
var EditProfile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditProfile___vue_template_functional__ = false
/* styles */
var EditProfile___vue_styles__ = EditProfile_injectStyle
/* scopeId */
var EditProfile___vue_scopeId__ = "data-v-38debc0e"
/* moduleIdentifier (server only) */
var EditProfile___vue_module_identifier__ = null
var EditProfile_Component = EditProfile_normalizeComponent(
  EditProfile["a" /* default */],
  settings_EditProfile,
  EditProfile___vue_template_functional__,
  EditProfile___vue_styles__,
  EditProfile___vue_scopeId__,
  EditProfile___vue_module_identifier__
)

/* harmony default export */ var chat_settings_EditProfile = (EditProfile_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/settings/Dropfile.vue
var Dropfile = __webpack_require__("tTlU");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fc59ffd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/settings/Dropfile.vue
var Dropfile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-layout',{staticStyle:{"overflow":"hidden !important"},attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"3vh","height":"25vh"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('div',{ref:"fileform",staticStyle:{"width":"600px","border-radius":"5px","border-style":"dotted","border-color":"#f5f5f5","background-color":"#009aff3d","text-align":"center"}},[_c('img',{staticStyle:{"margin-top":"10vh"},attrs:{"src":"/static/img/onechat/box.png","width":"65"}}),_vm._v(" "),_c('p',{staticStyle:{"font-size":"13px","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.selectmultipleFiles')))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"13px","font-weight":"bold"}},[_vm._v("── "+_vm._s(_vm.$t('Settings.feedback.or'))+" ──")]),_vm._v(" "),_c('label',{staticStyle:{"text-align":"center","cursor":"pointer","margin-bottom":"10vh"}},[_c('v-btn',{staticStyle:{"margin-bottom":"10vh","font-weight":"bold"},attrs:{"color":"primary","small":""},on:{"click":_vm.openFileimage}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.selectFile'))+"\n              ")]),_vm._v(" "),_c('input',{ref:"files",attrs:{"type":"file","id":"files","multiple":""},on:{"change":function($event){_vm.handleFilesUpload()}}})],1)])])],1),_vm._v(" "),_c('v-layout',{attrs:{"align-end":"","justify-center":""}},[(_vm.files.length > 0 )?_c('v-btn',{attrs:{"round":"","outline":"","color":"primary","dark":""},on:{"click":function($event){_vm.submitallFiles()}}},[_c('i',{staticClass:"fas fa-upload",staticStyle:{"margin-bottom":"3px"}}),_vm._v("  "+_vm._s(_vm.$t('AnswerQuestion.uploadAll')))]):_vm._e()],1),_vm._v(" "),(_vm.files.length > 0 )?_c('v-flex',{staticClass:"containers",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","height":"29vh !important","max-width":"70vw !important","display":"-webkit-inline-box","background":"rgb(234, 234, 234)","padding-top":"5vh"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},_vm._l((_vm.files),function(file,key){return _c('div',{staticClass:"borderfile",staticStyle:{"justify-content":"center","margin-left":"2vw","padding-top":"1vh"}},[_c('a',{staticClass:"close-classic",on:{"click":function($event){_vm.removeFile( key )}}}),_vm._v(" "),(_vm.extension(file.file.name) == 'fas fa-file-image')?_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center","margin-top":"2vh"}},[_c('img',{ref:'preview'+parseInt( key ),refInFor:true,staticClass:"preview",staticStyle:{"height":"10vh !important","width":"20vh !important","display":"flex","justify-content":"center","object-fit":"cover"}}),_vm._v(" "),_c('b',{staticClass:"text2"},[_vm._v(_vm._s(file.file.name))]),_vm._v(" "),(file.status !== 'success' && file.status !== 'process')?_c('a',{staticStyle:{"text-align":"center"},on:{"click":function($event){_vm.submitFiles( key )}}},[(file.status == 'fail')?_c('p',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.newuUpload'))+" "),_c('v-icon',{staticStyle:{"color":"red"},attrs:{"small":""}},[_vm._v("fas fa-exclamation-triangle")])],1):(file.status == 'success')?_c('p',[_c('v-icon',{staticStyle:{"color":"green"},attrs:{"small":""}},[_vm._v("fas fa-check")])],1):_c('p',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.upload')))])]):_vm._e(),_vm._v(" "),(file.status == 'process')?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e()],1):_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center","margin-top":"2vh"}},[_c('v-icon',{staticStyle:{"font-size":"60px !important","color":"#1a222c","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(file.file.name)))]),_vm._v(" "),_c('b',{staticClass:"text2"},[_vm._v(_vm._s(file.file.name)+"\n              ")]),_vm._v(" "),(file.status !== 'success' && file.status !== 'process')?_c('a',{staticStyle:{"text-align":"center"},on:{"click":function($event){_vm.submitFiles( key )}}},[(file.status == 'fail')?_c('p',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.newuUpload'))+" "),_c('v-icon',{staticStyle:{"color":"red"},attrs:{"small":""}},[_vm._v("fas fa-exclamation-triangle")])],1):(file.status == 'success')?_c('p',[_c('v-icon',{staticStyle:{"color":"green"},attrs:{"small":""}},[_vm._v("fas fa-check")])],1):_c('p',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.upload')))])]):_vm._e(),_vm._v(" "),(file.status == 'process')?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e()],1)])})):_vm._e()],1)],1)}
var Dropfile_staticRenderFns = []
var Dropfile_esExports = { render: Dropfile_render, staticRenderFns: Dropfile_staticRenderFns }
/* harmony default export */ var settings_Dropfile = (Dropfile_esExports);
// CONCATENATED MODULE: ./src/components/chat/settings/Dropfile.vue
function Dropfile_injectStyle (ssrContext) {
  __webpack_require__("S3wp")
}
var Dropfile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Dropfile___vue_template_functional__ = false
/* styles */
var Dropfile___vue_styles__ = Dropfile_injectStyle
/* scopeId */
var Dropfile___vue_scopeId__ = "data-v-6fc59ffd"
/* moduleIdentifier (server only) */
var Dropfile___vue_module_identifier__ = null
var Dropfile_Component = Dropfile_normalizeComponent(
  Dropfile["a" /* default */],
  settings_Dropfile,
  Dropfile___vue_template_functional__,
  Dropfile___vue_styles__,
  Dropfile___vue_scopeId__,
  Dropfile___vue_module_identifier__
)

/* harmony default export */ var chat_settings_Dropfile = (Dropfile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/settings/Feedback.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var Feedback__ = __webpack_require__("M4fF");
/* harmony default export */ var Feedback = ({
  data: function data() {
    return {
      files: [],
      name: '',
      email: '',
      phone: '',
      items: [],
      detail: '',
      title: {},
      token: '',
      comment: '',
      status: '',
      conditions: false,
      content: '',
      delimiters: ['${', '}'], // Avoid Twig conflicts
      data: {
        filelist: [] // Store our uploaded files
      }
      // phoneRules: [
      //   v => (!!v && v.length === 10) || 'กรุณากรอกตัวเลขให้ครบ 10 หลัก',
      //   v => !!v || 'กรุณากรอกข้อมูลเป็นตัวเลข',
      //   v => /^0[0-9]{9}/.test(v) || 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง'
      // ],
      // emailRules: [
      //   v => !!v || 'กรุณากรอกอีเมล',
      //   v => !v || (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || 'รูปแบบอีเมลไม่ถูกต้อง'
      // ]
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.email = localStorage.getItem('email');
    this.phone = localStorage.getItem('phone');
    this.name = localStorage.getItem('name');
    this.getsubject();
    this.content = '<b>' + this.$t('Settings.helpCenter.company') + '</b> <br>' + this.$t('Settings.helpCenter.address') + ' <br>' + this.$t('Settings.helpCenter.email') + ' <a style="text-decoration: none;" href="mailto:onechat@one.th">onechat@one.th</a>';
  },

  watch: {
    files: function files() {
      if (this.files.length > 5) {
        this.$swal('', this.$t('Alert.Fail.feedback.maxFiles'), 'warning');
        Feedback__.pullAt(this.files, [5]);
      }
    }
  },
  methods: {
    openFileimage: function openFileimage() {
      this.$refs.files.click();
    },
    remove: function remove(i) {
      this.filelist.splice(i, 1);
    },
    dragover: function dragover(event) {
      event.preventDefault();
    },
    dragleave: function dragleave(event) {
      // Clean up
    },
    drop: function drop(event) {
      event.preventDefault();
      this.$refs.files.files = event.dataTransfer.files;
      this.handleFilesUpload(); // Trigger the onChange event manually
    },
    extension: function extension(files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase();
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
      var pdf = ['pdf'];
      var file = ['ai', 'ps', 'psd'];
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm'];
      var presentation = ['ppt', 'pps', 'pot', 'pptx'];
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff'];
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf';
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive';
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel';
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint';
      } else if (word.includes(extension)) {
        return 'fas fa-file-word';
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code';
      } else if (image.includes(extension)) {
        return 'fas fa-file-image';
      } else if (file.includes(extension)) {
        return 'fas fa-file';
      } else {
        return 'fas fa-file-alt';
      }
      // return extension[extension.length-1]
    },
    handleFilesUpload: function handleFilesUpload(key) {
      var uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({ file: uploadedFiles[i], status: 'waiting' });
      }
      this.getImagePreviews(key);
      document.querySelector('#files').value = '';
    },
    removeFile: function removeFile(key) {
      this.files.splice(key, 1);
      this.getImagePreviews(key);
    },
    getImagePreviews: function getImagePreviews(key) {
      var _this = this;

      var _loop = function _loop(i) {
        if (/\.(jpe?g|png|gif)$/i.test(_this.files[i].file.name)) {
          var reader = new FileReader();
          reader.addEventListener('load', function () {
            this.$refs['preview' + parseInt(i)][0].src = reader.result;
            // console.log(this.$refs['preview' + parseInt(i)][0].src = reader.result)
          }.bind(_this), false);
          reader.readAsDataURL(_this.files[i].file);
          // this.extension(this.files[i].name)
          // console.log(this.extension())
        } else {
            // this.$nextTick(function(){
            // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
            // });
            // console.log('mm')
          }
      };

      for (var i = 0; i < this.files.length; i++) {
        _loop(i);
      }
    },
    cancel: function cancel() {
      // this.name = ''
      this.title = {};
      this.detail = '';
      this.files = [];
    },
    clear: function clear() {
      var _this2 = this;

      if (this.name !== '' || this.title.category_TH || this.detail !== '') {
        this.$swal({
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Clear'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: this.$t('AnswerQuestion.sure'),
          cancelButtonText: this.$t('AnswerQuestion.no'),
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-success',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then(function (result) {
          if (result.value) {
            _this2.cancel();
            // window.open('/login').focus()
            _this2.$router.push('/login');
          }
        });
      }
    },
    getsubject: function getsubject() {
      var _this3 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getcategory').then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          _this3.items = response.data;
        }
      });
    },
    sendfeedback: function sendfeedback() {
      var _this4 = this;

      var lengthfile = this.files.length;
      if (lengthfile === 0) {
        var formData = new FormData();
        formData.append('phone', this.phone);
        formData.append('email', this.email);
        formData.append('comment', this.detail);
        formData.append('name', this.name);
        formData.append('category_id', this.title.category_id);
        this.axios.post("https://uatchat-manage.one.th/manage" + '/feedbackcategory', formData).then(function (response) {
          // console.log(response.data)
          _this4.$swal('', _this4.$t('Alert.Success.feedback'), 'success');
          _this4.cancel();
        }, function () {
          _this4.$swal('', _this4.$t('Alert.Fail.feedback.connectError'), 'error');
        });
      } else {
        this.sendfeedbackfile();
        // for (var i = 0; i < lengthfile; i++) {
        //   this.sendfeedbackfile(i)
        // }
      }
    },
    sendfeedbackfile: function sendfeedbackfile() {
      var _this5 = this;

      var formData = new FormData();
      var lengthfile = this.files.length;
      for (var i = 0; i < lengthfile; i++) {
        var file = this.files[i].file;
        formData.append('file', file, file.name);
      }
      // console.log(formData)
      formData.append('phone', this.phone);
      formData.append('email', this.email);
      formData.append('comment', this.detail);
      formData.append('name', this.name);
      formData.append('category_id', this.title.category_id);
      this.axios.post("https://uatchat-manage.one.th/manage" + '/feedbackcategory', formData).then(function (response) {
        // console.log(response.data)
        _this5.$swal('', _this5.$t('Alert.Success.feedback'), 'success');
        _this5.cancel();
      }, function () {
        _this5.$swal('', _this5.$t('Alert.Fail.feedback.connectError'), 'error');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c05b78c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/settings/Feedback.vue
var Feedback_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"color":"grey lighten-4","flat":""}},[_c('v-card-text',{staticClass:"scrolling-wrapper",staticStyle:{"height":"calc(100vh - 64px)","padding-left":"70px","padding-right":"70px"}},[_c('v-flex',{staticStyle:{"justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-icon',{staticStyle:{"font-size":"60px !important"},attrs:{"color":"black"}},[_vm._v("feedback")])],1),_vm._v(" "),_c('h1',{staticClass:"CSChatThai",staticStyle:{"font-size":"24px","display":"flex","justify-content":"center"}},[_c('b',[_vm._v(_vm._s(_vm.$t('Settings.feedback.suggestion'))+" ")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"CSChatThai",staticStyle:{"font-size":"14px","color":"black"}},[_c('b',[_vm._v("\n          "+_vm._s(_vm.$t('Settings.feedback.headerFeedback'))+"\n        ")])])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"CSChatThai",staticStyle:{"font-size":"14px","color":"black"}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.titleFeedback'))+" "),_c('a',{attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")]),_vm._v(" "+_vm._s(_vm.$t('Conjunction.or'))+" "),_c('span',{staticStyle:{"text-decoration":"underline","color":"#1e88e5","cursor":"pointer"},attrs:{"href":"javascript:;"},on:{"click":function($event){$event.stopPropagation();_vm.conditions = true}}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.contact')))])]),_vm._v(" "),_c('v-dialog',{attrs:{"width":"70%"},model:{value:(_vm.conditions),callback:function ($$v) {_vm.conditions=$$v},expression:"conditions"}},[_c('v-card',[_c('v-card-title',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Settings.feedback.contact')))]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"blue"},on:{"click":function($event){_vm.conditions = false}}},[_vm._v("\n              "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n            ")])],1)],1)],1)],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"InputEdit",attrs:{"placeholder":_vm.$t('Settings.feedback.name')},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"InputEdit",staticStyle:{"width":"100%"}},[_c('v-menu',{staticStyle:{"width":"100%","height":"20px","margin-bottom":"7px"},attrs:{"bottom":"","offset-y":""}},[_c('v-btn',{staticStyle:{"width":"100%","padding":"0","margin":"0","font-size":"14px"},attrs:{"slot":"activator","flat":"","row":"","wrap":""},slot:"activator"},[(!_vm.title.category_TH)?_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0vw","font":"14px","color":"#757575","text-transform":"none","margin-top":"12px"}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.title'))+" ")]):_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0vw","font":"14px","color":"black","text-transform":"none","margin-top":"12px"}},[_vm._v(_vm._s((_vm.$i18n.locale == 'th')? _vm.title.category_TH:_vm.title.category_ENG))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"25px !important","color":"#929292"}},[_vm._v("expand_more")])],1),_vm._v(" "),_c('div',{staticStyle:{"background":"white","height":"300px"}},[_c('b',{staticClass:"CSChatThai",staticStyle:{"padding":"5px !important","font-size":"15px","color":"#2662af"}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.report')))]),_vm._v(" "),_c('v-list',_vm._l((_vm.items.list_report),function(item,index){return _c('v-list-tile',{staticStyle:{"background":"white"},on:{"click":function($event){_vm.title = item;}}},[_c('v-list-tile-title',{staticClass:"CSChatThai",staticStyle:{"font-size":"13px"}},[_vm._v("\n                "+_vm._s((_vm.$i18n.locale == 'th')? item.category_TH:item.category_ENG)+"\n              ")])],1)})),_vm._v(" "),_c('div',{staticStyle:{"background":"white"}},[_c('b',{staticClass:"CSChatThai",staticStyle:{"padding":"5px !important","font-size":"15px","color":"#2662af"}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.suggestion')))]),_vm._v(" "),_c('v-list',_vm._l((_vm.items.list_feedback),function(item,index){return _c('v-list-tile',{staticStyle:{"background":"white"},on:{"click":function($event){_vm.title = item;}}},[_c('v-list-tile-title',{staticClass:"CSChatThai",staticStyle:{"font-size":"13px"}},[_vm._v("\n                "+_vm._s((_vm.$i18n.locale == 'th')? item.category_TH:item.category_ENG)+"\n              ")])],1)}))],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-textarea',{staticClass:"InputEdit",staticStyle:{"height":"120px","resize":"none"},attrs:{"placeholder":_vm.$t('Settings.feedback.detail'),"counter":"","maxlength":"255","full-width":""},model:{value:(_vm.detail),callback:function ($$v) {_vm.detail=$$v},expression:"detail"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"borderfileupload",on:{"dragover":_vm.dragover,"dragleave":_vm.dragleave,"drop":_vm.drop}},[_c('input',{ref:"files",staticStyle:{"display":"none"},attrs:{"type":"file","id":"files","name":"fields[files][]","multiple":"","accept":".png, .jpg, .jpeg, .gif, .bmp, .wbmp"},on:{"change":function($event){_vm.handleFilesUpload()}}}),_vm._v(" "),(_vm.files.length === 0 )?_c('div',{staticStyle:{"text-align":"center","height":"20vh","margin-top":"10px"},attrs:{"id":"files"}},[_c('label',{staticStyle:{"text-align":"center","cursor":"pointer"},attrs:{"for":"files"}},[_c('v-icon',{staticStyle:{"font-size":"40px !important","color":"#1a222c","display":"flex","justify-content":"center"},attrs:{"color":"primary"}},[_vm._v("mdi-package-variant")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"13px"}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.selcetmultipleImage'))+" "+_vm._s(_vm.$t('Settings.editProfile.support'))+" .JPEG/.PNG/.GIF")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"13px"}},[_vm._v("── "+_vm._s(_vm.$t('Settings.feedback.or'))+" ──")]),_vm._v(" "),_c('div',[_c('v-btn',{attrs:{"color":"primary","small":"","outline":""},on:{"click":_vm.openFileimage}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.uploadPhoto'))+"\n              ")])],1)],1)]):_c('v-flex',{staticClass:"containers",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","height":"30vh !important","width":"100% !important","display":"-webkit-inline-box","padding-top":"10px"},attrs:{"xs12":"","sm12":"","md12":""}},[_vm._l((_vm.files),function(file,key){return _c('div',{staticClass:"borderfile",staticStyle:{"justify-content":"center","margin-left":"2vw","padding-top":"10px"},attrs:{"id":"files"}},[_c('v-icon',{staticStyle:{"float":"right","padding-right":"10px"},attrs:{"small":"","color":"primary"},on:{"click":function($event){_vm.removeFile( key )}}},[_vm._v("close")]),_vm._v(" "),(_vm.extension(file.file.name) == 'fas fa-file-image')?_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center","margin-top":"25px"}},[_c('img',{ref:'preview'+parseInt( key ),refInFor:true,staticClass:"preview",staticStyle:{"height":"15vh !important","width":"20vh !important","display":"flex","justify-content":"center","object-fit":"cover"}}),_vm._v(" "),_c('b',{staticClass:"text2"},[_vm._v(_vm._s(file.file.name))])]):_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center","margin-top":"25px"}},[_c('v-icon',{staticStyle:{"font-size":"100px !important","color":"#1a222c","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(file.file.name)))]),_vm._v(" "),_c('b',{staticClass:"text2",staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(file.file.name))])],1)],1)}),_vm._v(" "),(_vm.files.length !== 0 && _vm.files.length !== 5)?_c('div',{staticStyle:{"justify-content":"center","margin-left":"2vw","padding-top":"1vh","align-items":"center","display":"flex"}},[_c('v-btn',{staticStyle:{"height":"70px","border-radius":"10px"},attrs:{"outline":"","color":"primary"},on:{"click":_vm.openFileimage}},[_c('v-icon',{staticStyle:{"font-size":"40px"}},[_vm._v("mdi-image-plus")])],1)],1):_vm._e()],2)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('v-btn',{staticStyle:{"color":"white !important","text-transform":"none"},attrs:{"dark":"","color":"blue-grey"},on:{"click":function($event){_vm.clear()}}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n        ")]),_vm._v(" "),(_vm.name !== '' && _vm.email !== '' && _vm.title.category_TH && _vm.detail !== '')?_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"dark":"","color":"blue"},on:{"click":function($event){_vm.sendfeedback()}}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.sendme'))+"\n        ")]):_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"disabled":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.sendme')))])])],1)],1)],1)],1)}
var Feedback_staticRenderFns = []
var Feedback_esExports = { render: Feedback_render, staticRenderFns: Feedback_staticRenderFns }
/* harmony default export */ var settings_Feedback = (Feedback_esExports);
// CONCATENATED MODULE: ./src/components/chat/settings/Feedback.vue
function Feedback_injectStyle (ssrContext) {
  __webpack_require__("tjwz")
}
var Feedback_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Feedback___vue_template_functional__ = false
/* styles */
var Feedback___vue_styles__ = Feedback_injectStyle
/* scopeId */
var Feedback___vue_scopeId__ = "data-v-2c05b78c"
/* moduleIdentifier (server only) */
var Feedback___vue_module_identifier__ = null
var Feedback_Component = Feedback_normalizeComponent(
  Feedback,
  settings_Feedback,
  Feedback___vue_template_functional__,
  Feedback___vue_styles__,
  Feedback___vue_scopeId__,
  Feedback___vue_module_identifier__
)

/* harmony default export */ var chat_settings_Feedback = (Feedback_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/settings/Contact.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var settings_Contact = ({
  data: function data() {
    return {};
  },
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45bc0fe6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/settings/Contact.vue
var settings_Contact_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("info")]),_vm._v("  "+_vm._s(_vm.$t('Settings.helpCenter.header'))+" ")],1),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"padding":"3vw","padding-left":"10vw","padding-right":"10vw"}},[_c('b',{staticClass:"CSChatThai",staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(_vm.$t('Settings.helpCenter.company')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',{staticClass:"CSChatThai",staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(_vm.$t('Settings.helpCenter.address')))]),_c('br'),_c('br'),_vm._v(" "),_c('b',{staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(_vm.$t('Settings.helpCenter.email'))+": "),_c('a',{attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])])],1)}
var settings_Contact_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"/static/img/onechat/map.png","width":"400"}})])}]
var settings_Contact_esExports = { render: settings_Contact_render, staticRenderFns: settings_Contact_staticRenderFns }
/* harmony default export */ var chat_settings_Contact = (settings_Contact_esExports);
// CONCATENATED MODULE: ./src/components/chat/settings/Contact.vue
function settings_Contact_injectStyle (ssrContext) {
  __webpack_require__("Qng6")
}
var settings_Contact_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var settings_Contact___vue_template_functional__ = false
/* styles */
var settings_Contact___vue_styles__ = settings_Contact_injectStyle
/* scopeId */
var settings_Contact___vue_scopeId__ = "data-v-45bc0fe6"
/* moduleIdentifier (server only) */
var settings_Contact___vue_module_identifier__ = null
var settings_Contact_Component = settings_Contact_normalizeComponent(
  settings_Contact,
  chat_settings_Contact,
  settings_Contact___vue_template_functional__,
  settings_Contact___vue_styles__,
  settings_Contact___vue_scopeId__,
  settings_Contact___vue_module_identifier__
)

/* harmony default export */ var components_chat_settings_Contact = (settings_Contact_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-090d7562","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/settings/Policy.vue
var settings_Policy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-y":"hidden"}},[_c('v-card',[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('span',{staticClass:"headline CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("assignment_ind")]),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.header'))+"\n          ")],1)]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"scrolling-wrapper",staticStyle:{"height":"80vh","margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('h2',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","text-decoration":"underline"}},[_vm._v(_vm._s(_vm.$t('Settings.policy.header'))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject1.introDetail'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro1'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro2'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro3'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro4'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro5'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro6'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro7'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro8'))+"\n      ")]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject2.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject2.subHeaderScopeA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeA1'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeA2'))),_c('br'),_vm._v(" "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject2.subHeaderScopeB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeB1'))+"\n      ")]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject3.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subHeaderTypeA')))]),_vm._v("\n         "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubHeaderA'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectA1')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA1'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectA2')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA2'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA21'))),_c('br'),_vm._v(" "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subHeaderTypeB')))]),_vm._v("\n         "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubHeaderB'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB1')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB1'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB12'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB2')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB2'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB3')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB3'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB4')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB41'))+"\n        "),_c('br'),_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB42'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB5')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB51'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB52'))+"\n\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB6')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB6'))+"\n          "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB7')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB71'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB72'))+"\n\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB8')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB8'))+"\n\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB9')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB91'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB92'))+"\n         \n        "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject4.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"font-size":"13px","padding":"1vw"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA'))+"\n\n\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA1'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA2'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA3'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA4'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA5'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA6'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA7'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA8'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA9'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA10'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA11'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA12'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA13'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA14'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA15'))+"\n\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA16'))+"\n\n         "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectB1'))+"\n\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectB2'))+"\n\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectC')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectC'))+"\n         "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectD')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD1'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD2'))+"\n        "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD3'))+"\n        "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD4'))+"\n        "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD5'))+"\n        "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD6'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectE')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectE'))+"\n         "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectF')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectF'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectG')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG1'))+"\n        "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG2'))+"\n        "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG3'))+"\n        "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG4'))+"\n        "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG5'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG6'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG7'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG8'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG9'))+"\n        "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject5.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.detailHeader'))+"\n          "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA1'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA2'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA3'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA4'))+"\n         "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB1'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB2'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB3'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB4'))+"\n        "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject6.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject6.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectA'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject6.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectB1'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectB2'))+"\n\n        "),_c('br')]),_vm._v(" "),_c('br')])],1)],1)}
var settings_Policy_staticRenderFns = []
var settings_Policy_esExports = { render: settings_Policy_render, staticRenderFns: settings_Policy_staticRenderFns }
/* harmony default export */ var settings_Policy = (settings_Policy_esExports);
// CONCATENATED MODULE: ./src/components/chat/settings/Policy.vue
function settings_Policy_injectStyle (ssrContext) {
  __webpack_require__("PW2i")
}
var settings_Policy_normalizeComponent = __webpack_require__("VU/8")
/* script */
var Policy___vue_script__ = null
/* template */

/* template functional */
var settings_Policy___vue_template_functional__ = false
/* styles */
var settings_Policy___vue_styles__ = settings_Policy_injectStyle
/* scopeId */
var settings_Policy___vue_scopeId__ = "data-v-090d7562"
/* moduleIdentifier (server only) */
var settings_Policy___vue_module_identifier__ = null
var settings_Policy_Component = settings_Policy_normalizeComponent(
  Policy___vue_script__,
  settings_Policy,
  settings_Policy___vue_template_functional__,
  settings_Policy___vue_styles__,
  settings_Policy___vue_scopeId__,
  settings_Policy___vue_module_identifier__
)

/* harmony default export */ var chat_settings_Policy = (settings_Policy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/settings/terms_of_service.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var terms_of_service = ({
  data: function data() {
    return {
      languages: ''
    };
  },

  watch: {
    '$i18n.locale': function $i18nLocale() {
      this.languages = this.$i18n.locale;
    }
  },
  created: function created() {
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
    this.languages = this.$i18n.locale;
    console.log(this.languages);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0204c66f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/settings/terms_of_service.vue
var terms_of_service_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-y":"hidden"}},[(_vm.languages === 'th')?_c('v-card',[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('span',{staticClass:"headline CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("assignment_ind")]),_vm._v("  เงื่อนไขและข้อตกลงการให้บริการ\n          ")],1)]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"scrolling-wrapper CSChatThai",staticStyle:{"height":"80vh","margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('h2',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","text-decoration":"underline"}},[_vm._v("เงื่อนไขและข้อตกลงการให้บริการ\n      ")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"50px"}},[_c('strong',[_vm._v("1.การใช้บริการของเรา")]),_vm._v(" "),_c('br'),_vm._v("   1.1 การใช้บริการของเราไม่ได้ทำให้คุณเป็นเจ้าของสิทธิในทรัพย์สินทางปัญญาใดๆ ในบริการหรือเนื้อหาที่คุณเข้าถึง\n        "),_c('br'),_vm._v("   1.2 การใช้บริการจากเรา เราอาจส่งประกาศเกี่ยวกับบริการ ข่าวสารเกี่ยวกับการบริหารจัดการ และข้อมูลอื่นๆ ให้แก่คุณ คุณสามารถเลือกไม่รับการสื่อสารเหล่านี้บางรายการได้\n        "),_c('br'),_vm._v("   1.3 บริการบางอย่างของเราสามารถใช้บนอุปกรณ์เคลื่อนทึ่ห้ามใช้บริการดังกล่าวในลักษณะที่ทำให้คุณเสียสมาธิและทำให้ไม่สามารถปฏิบัติตามกฎจราจรหรือกฎหมายด้านความปลอดภัย\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("2. บัญชี One Platform ของคุณ ")]),_vm._v(" "),_c('br'),_vm._v("   2.1 คุณอาจต้องมีบัญชี One Platform เพื่อที่จะใช้บริการบางส่วนของเราอาจมีข้อกำหนดอื่นหรือเพิ่มเติมบังคับใช้กับคุณ และผู้ดูแลระบบของคุณอาจสามารถเข้าถึงหรือปิดการใช้งานบัญชีของคุณได้\n        "),_c('br'),_vm._v("   2.2 เพื่อปกป้องบัญชี One Platform ของคุณ โปรดเก็บรักษารหัสผ่านเป็นความลับ คุณมีความรับผิดชอบต่อกิจกรรมที่เกิดขึ้นบนหรือผ่านบัญชี One Platform ของคุณ พยายามไม่ใช้รหัสผ่านบัญชี One Platform ซ้ำบนแอปพลิเคชันของบุคคลที่สาม\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("3. การคุ้มครองข้อมูลส่วนบุคคลและลิขสิทธิ์")]),_vm._v(" "),_c('br'),_vm._v("   3.1 เมื่อคุณใช้บริการของเรา ถือว่าคุณยินยอมให้ One Platform ใช้ข้อมูลดังกล่าวตามนโยบายส่วนบุคคลนั้น\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("4. การปรับเปลี่ยนและการยุติการให้บริการของเรา ")]),_vm._v(" "),_c('br'),_vm._v("   4.1 เราทำการเปลี่ยนแปลงและปรับปรุงบริการของเราอย่างสม่ำเสมอ เราอาจเพิ่มหรือนำ "),_c('br'),_vm._v("ระบบการทำงานหรือคุณลักษณะบางอย่างออก และเราอาจระงับหรือหยุดให้บริการใดบริการหนึ่งโดยสิ้นเชิง\n        "),_c('br'),_vm._v("   4.2 คุณสามารถหยุดใช้บริการของเราได้ทุกเมื่อ\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("5. การใช้บริการของเราในทางธุรกิจ ")]),_vm._v(" "),_c('br'),_vm._v("   5.1 หากคุณใช้บริการของเราในนามของธุรกิจ ธุรกิจนั้นจะต้องยอมรับข้อกำหนดเหล่านี้\n        "),_c('br'),_vm._v("   5.2 ธุรกิจจะไม่เรียกร้องให้ One Platform และบริษัทในเครือ เจ้าหน้าที่ ตัวแทน และพนักงานของ One Platform ชดใช้ค่าเสียหายให้แก่คุณ\n        และคุณจะไม่ฟ้องร้องคดีหรือดำเนินการใดๆอันเกิดจากหรือเกี่ยวกับการใช้บริการหรือการละเมิดข้อกำหนดเหล่านี้รวมถึงไม่ให้บุคคลดังกล่าวมีความรับผิดหรือต้องชำระค่าใช้จ่ายใดๆ ที่เกิดจากการเรียกร้องค่าสินไหมทดแทน การสูญเสีย ความเสียหาย การฟ้องร้องคดี\n        การตัดสินคดี ค่าใช้จ่ายในการดำเนินคดี และค่าทนายความ "),_c('br')])])],1):_c('v-card',[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('span',{staticClass:"headline CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("assignment_ind")]),_vm._v("  Terms and Conditions of Service\n          ")],1)]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"scrolling-wrapper CSChatThai",staticStyle:{"height":"80vh","margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('h2',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","text-decoration":"underline"}},[_vm._v("Terms and Conditions of Service\n      ")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"50px"}},[_c('strong',[_vm._v("1. Using of our services")]),_vm._v(" "),_c('br'),_vm._v("   1.1 Your using of our services does not give you ownership of any intellectual property rights in the services or content you access.\n        "),_c('br'),_vm._v("   1.2 By providing services from us, we may send service announcements; provide you with administrative news and other information to you.  You can opt-out of some of these communications.\n        "),_c('br'),_vm._v("   1.3 Some of our services can be used on mobile devices so do not use them in a way that distracts  and prevents you from complying with traffic or safety laws.\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("2. Your One Platform account")]),_vm._v(" "),_c('br'),_vm._v("   2.1 You may need a One Platform account in order to use some of our services, other or additional terms may apply to you and your administrator may be able to access or disable your account.\n        "),_c('br'),_vm._v("   2.2 To protect your One Platform account, please keep your password confidential. You are responsible for any activities that occur on through your One Platform account. Try not to reuse your One Platform account password on any third-party applications.\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("3. Protection of personal data and copyright")]),_vm._v(" "),_c('br'),_vm._v("   3.1 By using our services, you consent to the use of such information by One Platform in accordance with that Privacy Policy.\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("4. Modifications and Terminations of our Services")]),_vm._v(" "),_c('br'),_vm._v("   4.1 We make changes and improvements to our services regularly, we may add or remove certain functionality or features and we may suspend or discontinue any service altogether.\n        "),_c('br'),_vm._v("   4.2 You can stop using our services at any time.\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("5. Business use of our services")]),_vm._v(" "),_c('br'),_vm._v("   5.1 If you use our services on behalf of a business, that business must agree to these terms.\n        "),_c('br'),_vm._v("   5.2 The business will not demand that One Platform and its affiliates, officers, agents and employees indemnify to you and you will not litigate or take action arising out of or in connection with your use of the service or breach of these terms including that such person shall not be liable or have to pay any expenses arising from claims, losses, damages, litigation, judgments, litigation costs and attorney fees.\n        "),_c('br')])])],1)],1)}
var terms_of_service_staticRenderFns = []
var terms_of_service_esExports = { render: terms_of_service_render, staticRenderFns: terms_of_service_staticRenderFns }
/* harmony default export */ var settings_terms_of_service = (terms_of_service_esExports);
// CONCATENATED MODULE: ./src/components/chat/settings/terms_of_service.vue
function terms_of_service_injectStyle (ssrContext) {
  __webpack_require__("Ez+3")
}
var terms_of_service_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var terms_of_service___vue_template_functional__ = false
/* styles */
var terms_of_service___vue_styles__ = terms_of_service_injectStyle
/* scopeId */
var terms_of_service___vue_scopeId__ = "data-v-0204c66f"
/* moduleIdentifier (server only) */
var terms_of_service___vue_module_identifier__ = null
var terms_of_service_Component = terms_of_service_normalizeComponent(
  terms_of_service,
  settings_terms_of_service,
  terms_of_service___vue_template_functional__,
  terms_of_service___vue_styles__,
  terms_of_service___vue_scopeId__,
  terms_of_service___vue_module_identifier__
)

/* harmony default export */ var chat_settings_terms_of_service = (terms_of_service_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/settings/Managefriend.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// var _ = require('lodash')

/* harmony default export */ var Managefriend = ({
  data: function data() {
    return {
      token: '',
      listblock: []
    };
  },
  methods: {
    getlistblock: function getlistblock() {
      var _this = this;

      // console.log('getlistblock')
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-block', { tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          _this.listblock = response.data['list_block_friend'];
        }
      });
    },
    unblock: function unblock(item, index) {
      var _this2 = this;

      this.$swal({
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Unblocking', { name: item.name }),
        type: 'warning',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        console.log(result);
        if (result.value) {
          _this2.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', { tokenfriend: item.tokenuser, tokenuser: _this2.token, tokenroom: item.tokenroom }).then(function (response) {
            if (response.data['status'] === 'success') {
              _this2.getlistblock();
              item.event = 'unblock_friend';
              _this2.block_friend = item;
              _this2.$swal('', _this2.$t('Alert.Success.unblock'), 'success');
            }
          });
        }
      });
    },
    remove_friend: function remove_friend(item) {
      var _this3 = this;

      this.$swal({
        title: this.$t('Alert.Sure'),
        // text: 'เรากำลังทำการลบ ' + item.name + ' !',
        text: this.$t('Alert.RemoveFriend', { name: item.name }),
        type: 'warning',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        // confirmButtonText: 'ใช่, ฉันต้องการลบ!',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        // cancelButtonText: 'ไม่, ยกเลิกการลบ!',
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this3.axios.post("https://uatchat-manage.one.th/manage" + '/removefriend', { tokenfriend: item.tokenuser, tokenuser: _this3.token, tokenroom: item.tokenroom }).then(function (response) {
            if (response.data['status'] === 'success') {
              _this3.$swal('Deleted!', _this3.$t('Alert.Success.removefriend'), 'success');
              _this3.getlistblock();
              // this.$router.push('/chat/homepage')
            }
          });
        }
      });
    },
    detailFriend: function detailFriend(user) {
      var _this4 = this;

      var title = 'ข้อมูลส่วนตัว';
      var picture = user.profilepicture;
      if (user.profilepicture === '') {
        if (user.type === 'business') {
          picture = '/static/img/default_profile/business-white.png';
        } else if (user.type === 'bot') {
          picture = '/static/img/default_profile/bot-white.png';
        } else {
          picture = '/static/img/default_profile/man-white.png';
        }
      } else {
        picture = user.profilepicture;
      }
      var name = user.name;
      this.$swal({
        title: '<div class="CSChatThai">' + title + '</div>',
        html: '<br><img src="' + picture + '" style=" width: 140px; height: 140px; background: #a84909; border-radius: 50%; object-fit: cover; object-position: 50% 0;"><br><br><br>' + '<div class="CSChatThai" style="text-align:left">ชื่อ: ' + name + '<br><br><br><button id="unblock" style="background-color: #536475;border: #bebec1 1px solid;border-radius: 50px; padding: 9px;color: white;right: 10px; float:right;   margin-left: 10px;"> ยกเลิกการบล็อก </button>' + '<button id="unfriend" style="background-color: #fb3e3e;border-radius: 50px; padding: 9px;color: white; right:0; float:right;"> ลบเพื่อน </button>' + '</div>',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true,
        showCancelButton: false,
        showConfirmButton: false,
        onBeforeOpen: function onBeforeOpen() {
          var content = _this4.$swal.getContent();
          var $ = content.querySelector.bind(content);
          var unblock = $('#unblock');
          unblock.addEventListener('click', function () {
            console.log('increase');
            _this4.getlistblock();
          });
        }
      });
    }
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  // watch: {
  // },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.getlistblock();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8ea0e10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/settings/Managefriend.vue
var Managefriend_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CSChatThai BGwhite"},[_c('v-card-text',{staticClass:"scrolling-wrapper",staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important","max-height":"94vh","color":"rgb(74, 74, 74) !important"}},[_c('v-container',{attrs:{"grid-list-md":""}},[(_vm.listblock.length != 0)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticClass:"headerBlock"},[_vm._v(_vm._s(_vm.$t('Settings.manageFriend.headerManageFriend'))+" ("+_vm._s(_vm.listblock.length)+")")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},_vm._l((_vm.listblock),function(item,index){return _c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"rgb(255, 255, 255) !important","width":"100%","cursor":"auto"},attrs:{"two-line":"","subheader":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"}},[_vm._v("\n                    "+_vm._s(item.name)+"\n                  ")])],1),_vm._v(" "),_c('v-list-tile-action',{staticStyle:{"width":"30%","display":"inline","margin-top":"30px"}},[_c('v-btn',{staticStyle:{"background-color":"#fb3e3e","border-radius":"50px","color":"white","padding-left":"9px","padding-right":"9px","text-transform":"none"},attrs:{"depressed":""},on:{"click":function($event){_vm.remove_friend(item)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('AnswerQuestion.removeFriend'))+"\n                    ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"background-color":"#536475","border-radius":"50px","color":"white","padding-left":"9px","padding-right":"9px","border":"#bebec1 1px solid","text-transform":"none"},attrs:{"depressed":""},on:{"click":function($event){_vm.unblock(item)}}},[_vm._v("\n                       "+_vm._s(_vm.$t('AnswerQuestion.unblock'))+"\n                    ")])],1)],1),_vm._v(" "),_c('v-divider')],1)}))],1):_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticClass:"headerBlock"},[_vm._v(_vm._s(_vm.$t('Settings.manageFriend.headerManageFriend')))])]),_vm._v(" "),_c('v-flex',{staticStyle:{"justify-content":"center","display":"flex"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_vm._v("\n          "+_vm._s(_vm.$t('Settings.manageFriend.nodata'))+"\n        ")])],1)],1)],1)],1)}
var Managefriend_staticRenderFns = []
var Managefriend_esExports = { render: Managefriend_render, staticRenderFns: Managefriend_staticRenderFns }
/* harmony default export */ var settings_Managefriend = (Managefriend_esExports);
// CONCATENATED MODULE: ./src/components/chat/settings/Managefriend.vue
function Managefriend_injectStyle (ssrContext) {
  __webpack_require__("3FVG")
}
var Managefriend_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Managefriend___vue_template_functional__ = false
/* styles */
var Managefriend___vue_styles__ = Managefriend_injectStyle
/* scopeId */
var Managefriend___vue_scopeId__ = "data-v-f8ea0e10"
/* moduleIdentifier (server only) */
var Managefriend___vue_module_identifier__ = null
var Managefriend_Component = Managefriend_normalizeComponent(
  Managefriend,
  settings_Managefriend,
  Managefriend___vue_template_functional__,
  Managefriend___vue_styles__,
  Managefriend___vue_scopeId__,
  Managefriend___vue_module_identifier__
)

/* harmony default export */ var chat_settings_Managefriend = (Managefriend_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./src/components/chat/dialog/consent/consent_onechat_dialog.vue + 2 modules
var consent_onechat_dialog = __webpack_require__("IWN4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/QrcodeuserDialogMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState } from 'vuex'
// var _ = require('lodash')



vue_esm["default"].component(vue_qrcode_esm["a" /* default */].name, vue_qrcode_esm["a" /* default */]);

/* harmony default export */ var QrcodeuserDialogMobile = ({
  props: {
    'dialogShowQRCode': false
  },
  data: function data() {
    return {
      token: '',
      name: '',
      tokenuserQR: ''
    };
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeShowQRCodeUser', false);
    },
    loadqr: function loadqr() {
      var cnvs = document.getElementById('downloadqr');
      var button = document.getElementById('btn-download');
      var dataURL = cnvs.toDataURL('image/png');
      button.href = dataURL;
    }
  },
  computed: {},
  created: function created() {
    this.name = localStorage.getItem('name');
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    // this.tokenuserQR = 'https://com.oneplatform.android.onechat/u/' + btoa(this.$cookie.get('tokenuser'))
    this.tokenuserQR = "https://uatchat.one.th" + '/qrcode/friend?id=' + btoa(this.token);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e40709d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/QrcodeuserDialogMobile.vue
var QrcodeuserDialogMobile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialogShowQRCode),callback:function ($$v) {_vm.dialogShowQRCode=$$v},expression:"dialogShowQRCode"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai",staticStyle:{"white-space":"nowrap","width":"100%","overflow":"hidden","text-overflow":"ellipsis"}},[_c('span',{staticClass:"headline CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-qrcode")]),_vm._v("  "+_vm._s(_vm.$t('Settings.Qrcode.header'))+"\n          ")],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.qrcodeForAddFriend')))])]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',[_c('p',{staticStyle:{"justify-content":"center","display":"flex"}},[_c('qrcode',{staticStyle:{"width":"150px","height":"150px"},attrs:{"value":_vm.tokenuserQR,"id":"downloadqr"}})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('Settings.editProfile.detailQRcode'))+"\n                "),_c('a',{staticClass:"button",attrs:{"href":"#","id":"btn-download","download":'qrcode_user_' + _vm.name + '.png'},on:{"click":function($event){_vm.loadqr()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.download')))])])])])],1)],1)],1)],1)],1)}
var QrcodeuserDialogMobile_staticRenderFns = []
var QrcodeuserDialogMobile_esExports = { render: QrcodeuserDialogMobile_render, staticRenderFns: QrcodeuserDialogMobile_staticRenderFns }
/* harmony default export */ var dialog_QrcodeuserDialogMobile = (QrcodeuserDialogMobile_esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/QrcodeuserDialogMobile.vue
function QrcodeuserDialogMobile_injectStyle (ssrContext) {
  __webpack_require__("if18")
}
var QrcodeuserDialogMobile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var QrcodeuserDialogMobile___vue_template_functional__ = false
/* styles */
var QrcodeuserDialogMobile___vue_styles__ = QrcodeuserDialogMobile_injectStyle
/* scopeId */
var QrcodeuserDialogMobile___vue_scopeId__ = "data-v-e40709d8"
/* moduleIdentifier (server only) */
var QrcodeuserDialogMobile___vue_module_identifier__ = null
var QrcodeuserDialogMobile_Component = QrcodeuserDialogMobile_normalizeComponent(
  QrcodeuserDialogMobile,
  dialog_QrcodeuserDialogMobile,
  QrcodeuserDialogMobile___vue_template_functional__,
  QrcodeuserDialogMobile___vue_styles__,
  QrcodeuserDialogMobile___vue_scopeId__,
  QrcodeuserDialogMobile___vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_QrcodeuserDialogMobile = (QrcodeuserDialogMobile_Component.exports);

// EXTERNAL MODULE: ./src/components/mobile/dialog/DownloadAppMobile.vue + 2 modules
var DownloadAppMobile = __webpack_require__("a6yM");

// EXTERNAL MODULE: ./src/components/chat/agora_call/ans_call_v2.vue + 2 modules
var ans_call_v2 = __webpack_require__("Hruy");

// EXTERNAL MODULE: ./src/components/consent/new_consent.vue + 2 modules
var new_consent = __webpack_require__("F8NA");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/layout/LayoutMobile.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import LeftSideMobile from '@/components/mobile/LeftSideMobile'







var Centrifuge = __webpack_require__("9wbP");
var centrifuge = new Centrifuge("wss://uatchat-manage.one.th/connection/websocket");
// var _ = lodash()
/* harmony default export */ var LayoutMobile = ({
  data: function data() {
    return {
      newConsentDialog: false,
      newConsentDetail: {},
      AgoraCallDialog: false,
      AgoraOption: '',
      infor_call: {},
      one_id: '',
      dilogDownload: true,
      show_alert: false,
      num_listalert: 0,
      list_alert: [],
      textsnackbar: '',
      snackbar: false,
      typeuser: '',
      room: '',
      profilepicture: '',
      name: '',
      token: '',
      business_id: '',
      status_login: '',
      business: [],
      citizen: {},
      listmenu: [{
        title: 'แก้ไขโปรไฟล์',
        icon: 'person',
        dialog: '/mobile/settings/profile'
      }, {
        title: 'ส่งไฟล์ไป One box',
        icon: 'file_upload',
        dialog: '/mobile/settings/uploadfile/onebox'
      }, {
        title: 'ข้อเสนอแนะ',
        icon: 'feedback',
        dialog: '/mobile/settings/feedback'
      }, {
        title: 'ศูนย์ช่วยเหลือ',
        icon: 'contact_support',
        dialog: '/mobile/settings/support'
      }, {
        title: 'นโยบายความเป็นส่วนตัว',
        icon: 'book',
        dialog: '/mobile/settings/policy'
      }],
      groupnameTest: '',
      windowWidth: '',
      dialogShowQRCode: false,
      consentOnechatDialog: false,
      url_consent: ''
    };
  },
  props: {
    source: String
  },
  methods: {
    closeNewConsent: function closeNewConsent(value) {
      console.log("close new consent", value);
      this.newConsentDialog = value.close;
      this.newConsentDetail = {};
    },
    closeDialogConsentOnechat: function closeDialogConsentOnechat(value) {
      this.consentOnechatDialog = value;
    },
    check_consent: function check_consent(token) {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var hour = String(today.getHours() + 1).padStart(2, '0');
      var minute = String(today.getMinutes()).padStart(2, '0');
      var seconds = String(today.getSeconds()).padStart(2, '0');
      var milsec = today.getMilliseconds();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00';
        dd = String(today.getDate() + 1).padStart(2, '0');
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1';
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1';
            yyyy = today.getFullYear() + 1;
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0');
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
      // console.log(today)
      var expireddate = Date.parse(today);
      // console.log(expireddate)
      var body = services["b" /* Encode */].encodeRichmenu({ 'userid': token, 'expired_date': expireddate });
      // console.log(body)
      this.progress = true;
      // check new consent
      if (this.$cookie.get('check-consent-' + token) === null || this.$cookie.get('check-consent-' + token) === undefined) {
        // test new consent
        this.progress = false;
        this.newConsentDialog = true;
        this.newConsentDetail = { token: token };
      } else {
        this.progress = false;
      }
      // this.axios.post(process.env.APIgo_api + `/v1/get-consent`, { onechat_token: body }).then((response) => {
      //   // console.log(response.data)
      //   if (response.data.status === 'success') {
      //     this.progress = false
      //     if (response.data.data.consent_check === 'false') {
      //       this.consentOnechatDialog = true
      //       this.url_consent = response.data.data.consent_url
      //     }
      //   }
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    get_oneid: function get_oneid() {
      var _this = this;

      this.axios.get("https://uatchat-manage.one.th/go_api/api" + ('/v1/getOneID/' + this.token)).then(function (response) {
        if (response.data.status === 'success') {
          _this.one_id = response.data.one_id;
        }
      });
    },
    decline_call: function decline_call(data) {
      console.log(data);
    },
    closeAgoraDialog: function closeAgoraDialog(value) {
      this.AgoraCallDialog = value;
    },
    dialog_alert: function dialog_alert(item) {
      this.show_alert = false;
      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        text: item.message,
        type: 'warning',
        showCloseButton: true,
        reverseButtons: true,
        confirmButtonText: 'ตกลง'
      });
    },
    getlistalert: function getlistalert() {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getlistannounce', {}).then(function (response) {
        _this2.list_alert = response.data.list_announce;
        _this2.num_listalert = _this2.lengthstateactive(_this2.list_alert);
        _this2.show_alert = true;
        // if (this.num_listalert.length !== 0) {
        //   this.show_alert = true
        // } else {
        //   this.show_alert = true
        // }
        // console.log(response.data)
      });
    },
    lengthstateactive: function lengthstateactive(list) {
      return _.filter(list, function (list) {
        return list.state === 'true';
      }).length;
    },
    openQRcode: function openQRcode() {
      this.dialogShowQRCode = true;
    },
    closeShowQRCodeUser: function closeShowQRCodeUser(value) {
      this.dialogShowQRCode = value;
    },
    switchuser: function switchuser(item, name, type) {
      localStorage.setItem('profilepicture', item['profilepicture']);
      localStorage.setItem('name', name);
      localStorage.setItem('business_id', item['business_id']);
      localStorage.setItem('usertype', type);
      this.myprofilepicture = item['profilepicture'];
      this.myname = name;
      this.mybusiness_id = item['business_id'];
      this.business_id = item['business_id'];
      this.typeuser = type;
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    clickservice: function clickservice() {
      window.open('/homepage#oneplatform', '_blank');
    },
    logout: function logout() {
      this.$cookie.delete("tokenuser");
      this.$cookie.delete("status_login");
      localStorage.clear();
      // this.$router.push({
      //   path: '/login',
      //   force: true
      // })
      // if (process.env.LogoutOneid) {
      //   window.open(process.env.LogoutOneid, '_parent')
      // } else {
      //   this.$router.push({path: '/login', force: true})
      // }
      var logouturl = this.$cookie.get('logouturl');
      if (true) {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent');
          this.$cookie.delete('logouturl');
        } else {
          window.open("https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage", '_parent');
        }
      } else {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent');
          this.$cookie.delete('logouturl');
        } else {
          this.$router.push({ path: '/login', force: true });
        }
      }
    },
    noti_msg: function noti_msg(name, notimsg, room, pic, type) {
      if (pic === '') {
        if (type === 'company') {
          pic = '/static/img/default_profile/business-white.png';
        } else if (type === 'bot') {
          pic = '/static/img/default_profile/bot-white.png';
        } else if (type === 'government') {
          pic = '/static/img/default_profile/business-white.png';
        } else {
          pic = '/static/img/default_profile/man-white.png';
        }
      }
      if (Notification.permission === 'granted') {
        var notification = new Notification('New message from ' + name, {
          body: notimsg,
          icon: pic,
          silent: true
        });
        notification.onclick = function () {
          window.open('/mobile/room/' + room, '_parent').focus();
        };
      } else {
        Notification.requestPermission().then(function (result) {
          // console.log(result)
        });
      }
    },
    other_noti: function other_noti(title, notimsg, pic) {
      if (pic === '') {
        pic = '/static/img/default_profile/man-white.png';
      }
      if (Notification.permission === 'granted') {
        var notification = new Notification(title, {
          body: notimsg,
          icon: pic,
          silent: true
        });
        notification.onclick = function () {};
      } else {
        Notification.requestPermission().then(function (result) {
          // console.log(result)
        });
      }
    },
    open: function open(typecall, tokenroom) {
      // console.log(detailroom)
      // localStorage.setItem('detailroomCall', JSON.stringify(detailroom))
      // window.open('/video_call/answer/' + typecall + '/' + tokenroom, '_parent').focus()
      this.$router.push({
        path: '/video_callmo/answer/' + typecall + '/' + tokenroom,
        force: true
      });
    }
  },
  components: {
    // LeftSideMobile
    Qrcodeuser: mobile_dialog_QrcodeuserDialogMobile,
    vue100vh: vue100vh["a" /* default */],
    Download: DownloadAppMobile["a" /* default */],
    AgoraCallDialog: ans_call_v2["a" /* default */],
    checkconsentOnechatDialog: consent_onechat_dialog["a" /* default */],
    newConsent: new_consent["a" /* default */]
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this3.windowWidth = window.innerWidth;
      });
    });
  },

  watch: {
    myprofilepicture: function myprofilepicture() {
      this.profilepicture = localStorage.getItem('profilepicture');
    },
    myname: function myname() {
      this.name = localStorage.getItem('name');
      // console.log(this.name)
    },
    windowWidth: function windowWidth() {
      // console.log(this.windowWidth)
      if (this.windowWidth > 960) {
        if (window.location.pathname === '/mobile/settings/profile') {
          this.$router.push('/chat/settings/profile');
        } else if (window.location.pathname === '/mobile/settings/uploadfile/onebox') {
          this.$router.push('/chat/settings/uploadfile/onebox');
        } else if (window.location.pathname === '/mobile/settings/feedback') {
          this.$router.push('/chat/settings/feedback');
        } else if (window.location.pathname === '/mobile/settings/support') {
          this.$router.push('/chat/settings/support');
        } else if (window.location.pathname === '/mobile/settings/policy') {
          this.$router.push('/chat/settings/policy');
        } else if (window.location.pathname === '/mobile/settings/managefriend') {
          this.$router.push('/chat/settings/managefriend');
        } else if (window.location.pathname === '/mobile/room/' + this.$route.params.roomid) {
          this.$router.push('/chat/room/' + this.$route.params.roomid);
        } else {
          this.$router.push('/chat');
        }
      }
    }
  },
  sockets: {
    connect: function connect() {
      console.log('socket connected');
      this.$socket.emit('join', {
        room: this.token,
        type: 'web'
      });
      this.snackbar = true;
      this.textsnackbar = 'server connected';
    },

    disconnect: function disconnect() {
      // console.log('disconnect')
      this.snackbar = true;
      this.textsnackbar = 'server disconnected';
    },
    // message(data) {
    //   console.log('socket message mobile')
    //   // console.log(data)
    //   if (data.hasOwnProperty('tokenuser')) {
    //     this.axios.post(process.env.APIalpine + '/api/v3/getmessage', {
    //       tokenmessage: data.tokenmessage,
    //       tokenuser: this.token
    //     }).then((response) => {
    //       this.socketmessage = response.data.source
    //       // console.log(this.socketmessage)
    //       if (data.tokenroom !== this.$route.params.roomid && data.tokenuser !== this.token) {
    //         if (response.data.source.typeofmessage !== 'message') {
    //           // this.noti_msg(response.data.source.nickname, 'Send:  ' + response.data.source.typeofmessage + ' to you', response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type)
    //         } else {
    //           // this.noti_msg(response.data.source.nickname, 'Message:  ' + response.data.source.message, response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type)
    //         }
    //       }
    //     })
    //   }
    // },
    announce_room: function announce_room(data) {
      this.socket_announce = data;
    },
    event_unsend: function event_unsend(data) {
      // console.log('event_unsend')
      this.socket_unsendmessage = data;
    },

    // quick_reply(data) {
    //   // console.log(data)
    //   // console.log('quick_reply')
    //   this.socketquickreply = data
    // },
    // disable_quick_reply(data) {
    //   // console.log(data)
    //   // console.log('disable_quick_reply')
    //   this.socketdisablequickreply = data
    // },
    // disable_approve(data) {
    //   // console.log('disable_approve')
    //   this.socketdisableapprove = data
    // },
    event_note: function event_note(data) {
      // console.log('event_note')
      if (data.tokenroom !== this.$route.params.roomid && data.owner !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', {
          owner: this.token,
          tokenuser: data.owner
        }).then(function (response) {
          // this.noti_msg(response.data.source.nickname, 'Note:  ' + data.note_info.text, response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type)
        });
      } else {
        this.socketnote = data;
      }
    },
    event_block: function event_block(data) {
      // console.log('event_block')
      if (data.hasOwnProperty('tokenuser')) {
        this.socketblock = data;
      }
    },
    event_friend: function event_friend(data) {
      // console.log(data)
      // console.log('event_friend')
      // this.name = data.tokenfriend[0]
      this.socketfriend = data;
      if (data.konAdd !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', {
          owner: this.token,
          tokenuser: data.tokenfriend
        }).then(function (response) {
          // console.log(response.data)
          if (response.data['user'][0]['type'] !== 'business') {
            // this.other_noti('Friend Request', 'Request friend from ' + response.data['user'][0]['name'], response.data['user'][0]['profilepicture'])
          }
        });
      }
    },
    event_accept_friend: function event_accept_friend(data) {
      // console.log('event_accept_friend')
      this.socketaccept_friend = data;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', {
        owner: this.token,
        tokenuser: [data.tokenfriend]
      }).then(function (response) {
        if (response.data['user'][0]['type'] !== 'business') {
          // this.other_noti('Accept Friend', 'You and ' + response.data['user'][0]['name'] + ' are friend.', response.data['user'][0]['profilepicture'])
        }
      });
    },
    event_remove_request_friend: function event_remove_request_friend(data) {
      // console.log('event_remove_request_friend')
      this.socketremove_request_friend = data;
    },
    event_remove_friend: function event_remove_friend(data) {
      // console.log('event_remove_friend')
      this.socketremove_friend = data;
    },
    event_create_group: function event_create_group(data) {
      var _this4 = this;

      // console.log('event_create_group')
      this.socketcreate_group = data;
      if (data.fromtokenuser !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', {
          group_id: data.groupid,
          tokenuser: data.fromtokenuser
        }).then(function (response) {
          // console.log(response.data)
          _this4.groupnameTest = response.data.group.name;
          _this4.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', {
            owner: _this4.token,
            tokenuser: [data.fromtokenuser]
          }).then(function (responsed) {
            // console.log(responsed.data)
            // this.other_noti('Create group', 'Invite group', responsed.data['user'][0]['name'] + ' invite you to group ' + this.groupnameTest, responsed.data['user'][0]['profilepicture'])
          });
        });
      }
    },
    event_invite_group: function event_invite_group(data) {
      var _this5 = this;

      // console.log('event_invite_group: mobile')
      // console.log(data)
      this.socketinvite_group = data;
      // console.log(this.socketinvite_group)
      if (data.userinvited !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', {
          group_id: data.groupid,
          tokenuser: data.userinvited
        }).then(function (response) {
          _this5.groupnameTest = response.data.group.name;
          if (data.userinvited !== _this5.token) {
            _this5.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', {
              owner: _this5.token,
              tokenuser: [data.userinvited]
            }).then(function (responsed) {
              // this.other_noti('Invite group', responsed.data['user'][0]['name'] + ' invite you to group ' + this.groupnameTest, responsed.data['user'][0]['profilepicture'])
            });
          }
        });
      }
    },
    event_active_group: function event_active_group(data) {
      var _this6 = this;

      // console.log('event_active_group')
      this.socketactive_group = data;
      if (data.tokenuser !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', {
          group_id: data.groupid,
          tokenuser: this.token
        }).then(function (response) {
          // console.log(response.data)
          _this6.groupnameTest = response.data.group.name;
          _this6.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', {
            owner: _this6.token,
            tokenuser: [data.tokenuser]
          }).then(function (responsed) {
            // this.other_noti('Accept group', responsed.data['user'][0]['name'] + ' accept group ' + this.groupnameTest, responsed.data['user'][0]['profilepicture'])
          });
        });
      }
    },
    event_cancel_group: function event_cancel_group(data) {
      // console.log('event_cancel_group')
      this.socketcencel_group = data;
    },
    event_leave_group: function event_leave_group(data) {
      // console.log('event_leave_group')
      this.socketleave_group = data;
    },
    event_kick_group: function event_kick_group(data) {
      // console.log('event_kick_group')
      this.socket_kickmember = data;
    },
    event_update_user: function event_update_user(data) {
      // console.log('event_update_user')
      // console.log(data)
      if (data.tokenuser === this.token) {
        this.socketupdate_self = data;
        if (data.type_update === 'status') {
          this.mystatus = data.update_data;
          localStorage.setItem('status', data.update_data);
        } else if (data.type_update === 'pictureprofile') {
          this.myprofilepicture = data.update_data;
          localStorage.setItem('profilepicture', data.update_data);
        } else if (data.type_update === 'name') {
          this.myname = data.update_data;
          localStorage.setItem('name', data.update_data);
        }
      } else {
        this.socketupdate_friend = data;
      }
    },

    signaling_message: function signaling_message(data) {
      var me = this;
      // console.log(data)
      var message = JSON.parse(data.message);
      // console.log('signaling_message')
      // if (data.type === 'SDP' && data.typesend === 'offer' && localStorage.getItem('Calling') !== 'true') {
      if (data.type === 'SDP' && data.typesend === 'offer') {
        if (message.sdp.type === 'offer' && data.name !== this.token) {
          // this.socketsignaling_message = data
          localStorage.setItem('stateCall', 'true');
          localStorage.setItem('socketsignaling_message', stringify_default()(data));
          this.other_noti('มีสายเรียกเข้า', data.fullname + ' ต้องการสนทนากับคุณ', data.picture);
          this.open(data.typecall, data.room);
        }
      }
    },
    // disable_official_template (data) {
    //   this.socket_official_template = data
    // },
    // close_webview (data) {
    //   this.socket_close_webview = data
    // },
    // switch_keyboard (data) {
    //   console.log('switch_keyboard')
    //   // console.log(data)
    // },
    message_read: function message_read(data) {
      // console.log('message read')
      // console.log(data)
    }
  },
  created: function created() {
    // if (this.$cookie.get('status_login') !== 'T' || this.$cookie.get('status_login') === null) {
    // localStorage.setItem('pathRoom', this.$router.currentRoute.path)
    // this.$router.push('/login')
    // }
    this.business = JSON.parse(localStorage.getItem('business'));
    this.citizen = JSON.parse(localStorage.getItem('citizen'));
    this.room = this.$router.currentRoute.path;
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.$socket.emit('connect');
    this.profilepicture = localStorage.getItem('profilepicture');
    this.name = localStorage.getItem('name');
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
    // this.status_login = this.$cookie.get('status_login')
    this.typeuser = localStorage.getItem('type_user');
    this.business_id = localStorage.getItem('business_id');
    this.getlistalert();
    this.get_oneid();
    this.check_consent(this.token);
    var me = this;
    var events = '';
    var data_msg = '';
    // centrifuge.setToken(process.env.centrifuge_key);
    centrifuge.setToken('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs');
    centrifuge.subscribe(me.token, function (message) {
      // console.log(message)
      events = message.data.event;
      data_msg = message.data.data;
      // console.log(data_msg)
      console.log('centrifuge mobile: ' + events);
      if (events === 'message') {
        if (data_msg.last_tokenmessage !== undefined) {
          // event unsend
          me.socket_unsendmessage = data_msg;
        } else {
          // ถ้าข้อความเป็น type official_template, system เก็ทข้อความแบบเดิม ส่วน type อื่นรับปกติ
          if (data_msg.typeofmessage === 'official_template' || data_msg.typeofmessage === 'system' || data_msg.typeofmessage === 'system_action_albums') {
            me.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v3/getmessage', { tokenmessage: data_msg.tokenmessage, tokenuser: me.token }).then(function (response) {
              me.socketmessage = response.data.source;
            });
          } else {
            // event message
            me.socketmessage = data_msg;
          }
          // console.log(me.socketmessage)
          // if (data_msg.option !== undefined) {
          //     me.typeAgoraCall = data_msg.option
          // }
        }
        if (me.socketmessage.tokenroom !== me.$route.params.roomid && me.socketmessage.tokenuser !== me.token) {
          if (me.socketmessage.typeofmessage !== 'message') {
            me.noti_msg(me.socketmessage.nickname, 'Send:  ' + me.socketmessage.typeofmessage + ' to you', me.socketmessage.tokenroom, me.socketmessage.path_pic, me.socketmessage.type);
          } else {
            // can't use this.convertMention
            me.noti_msg(me.socketmessage.nickname, 'Message:  ' + me.socketmessage.message.replace(/\<tax>/g, '@').replace(/<\/tax>/g, ''), me.socketmessage.tokenroom, me.socketmessage.path_pic, me.socketmessage.type);
          }
        }
      } else if (events === 'disable_quick_reply') {
        me.socketdisablequickreply = data_msg;
      } else if (events === 'update-agora') {
        me.socket_update_agora = data_msg;
      } else if (events === 'accept_call') {
        me.socket_accept_call = data_msg;
      } else if (events === 'service_call_agora') {
        // keep type option agora call
        if (false) {
          // ถ้ายังไม่ได้กดเข้าห้องแชทแต่มันการ call
          // if (me.$router.currentRoute.path === '/mobile/homepage') {
          // call agora
          setTimeout(function () {
            var infor = {
              agora_token: data_msg.agora_token,
              channel: data_msg.channel,
              nickname: data_msg.nickname,
              option: data_msg.option,
              picture: data_msg.picture,
              tokenroom: data_msg.tokenroom,
              one_id: me.one_id
            };
            me.infor_call = infor;
            me.AgoraOption = data_msg.option;
            me.AgoraCallDialog = true;
            // console.log(me.AgoraCallDialog)
            // console.log(me.infor_call)
          }, 1000);
          // } else {
          // me.typeAgoraCall = data_msg
          // }
          // console.log(me.typeAgoraCall)
        }
      } else if (events === 'message_read') {
        // console.log('message_read')
      } else if (events === 'disable_approve') {
        me.socketdisableapprove = data_msg;
      } else if (events === 'quick_reply') {
        me.socketquickreply = data_msg;
      } else if (events === 'close_webview') {
        me.socket_close_webview = data_msg;
      } else if (events === 'switch_keyboard') {
        me.socket_switch_keyboard = data_msg;
      } else if (events === 'switch_richmenu') {
        me.socket_switch_richmenu = data_msg;
      } else if (events === 'disable_official_template') {
        me.socket_official_template = data_msg;
      } else if (events === 'drop_menu') {
        me.socket_drop_menu = data_msg;
      } else if (events === 'consent') {
        // me.consentOnechatDialog = false
        me.centrifuge_consent = data_msg;
      }
    });

    centrifuge.on('connect', function () {
      console.log("connected mobile");
    });
    centrifuge.on('disconnect', function () {
      console.log("disconnected mobile");
    });
    centrifuge.connect();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ebb1f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/layout/LayoutMobile.vue
var LayoutMobile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%","overflow-y":"hidden !important"}},[_c('v-app',{staticStyle:{"background":"#fff","overflow-y":"hidden !important"},attrs:{"id":"inspire"}},[_c('v-card',{staticClass:"hidden-md-and-up",staticStyle:{"padding":"0 !important","width":"100%"},attrs:{"flat":""}},[_c('v-container',{staticStyle:{"padding":"0 !important"},attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('div',{staticStyle:{"width":"100vw"}})])],1)],1),_vm._v(" "),_c('v-content',{staticClass:"hidden-md-and-up",staticStyle:{"background-color":"#fff !important","overflow-y":"hidden !important"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"height":"calc(100vh - 64px) !important","overflow-y":"hidden !important"},attrs:{"xs12":"","sm12":""}},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('Download',{attrs:{"dilogDownload":_vm.dilogDownload}}),_vm._v(" "),_c('Qrcodeuser',{attrs:{"dialogShowQRCode":_vm.dialogShowQRCode},on:{"closeShowQRCodeUser":_vm.closeShowQRCodeUser}}),_vm._v(" "),_c('AgoraCallDialog',{attrs:{"AgoraCallDialog":_vm.AgoraCallDialog,"AgoraOption":_vm.AgoraOption,"infor_call":_vm.infor_call,"tokenuser":_vm.token},on:{"decline_call":_vm.decline_call,"closeAgoraDialog":_vm.closeAgoraDialog}}),_vm._v(" "),_c('checkconsentOnechatDialog',{attrs:{"url_consent":_vm.url_consent,"consentOnechatDialog":_vm.consentOnechatDialog},on:{"closeDialogConsentOnechat":_vm.closeDialogConsentOnechat}}),_vm._v(" "),_c('newConsent',{attrs:{"newConsentDialog":_vm.newConsentDialog,"newConsentDetail":_vm.newConsentDetail},on:{"closeNewConsent":_vm.closeNewConsent}})],1)],1)}
var LayoutMobile_staticRenderFns = []
var LayoutMobile_esExports = { render: LayoutMobile_render, staticRenderFns: LayoutMobile_staticRenderFns }
/* harmony default export */ var layout_LayoutMobile = (LayoutMobile_esExports);
// CONCATENATED MODULE: ./src/components/mobile/layout/LayoutMobile.vue
function LayoutMobile_injectStyle (ssrContext) {
  __webpack_require__("15At")
}
var LayoutMobile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LayoutMobile___vue_template_functional__ = false
/* styles */
var LayoutMobile___vue_styles__ = LayoutMobile_injectStyle
/* scopeId */
var LayoutMobile___vue_scopeId__ = "data-v-64ebb1f2"
/* moduleIdentifier (server only) */
var LayoutMobile___vue_module_identifier__ = null
var LayoutMobile_Component = LayoutMobile_normalizeComponent(
  LayoutMobile,
  layout_LayoutMobile,
  LayoutMobile___vue_template_functional__,
  LayoutMobile___vue_styles__,
  LayoutMobile___vue_scopeId__,
  LayoutMobile___vue_module_identifier__
)

/* harmony default export */ var mobile_layout_LayoutMobile = (LayoutMobile_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/ShowFriendDialogMobile.vue
var ShowFriendDialogMobile = __webpack_require__("grGk");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c64f0ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/ShowFriendDialogMobile.vue
var ShowFriendDialogMobile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialogShowfriend),callback:function ($$v) {_vm.dialogShowfriend=$$v},expression:"dialogShowfriend"}},[_c('v-card',{staticStyle:{"border-radius":"20px","overflow":"hidden"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai",staticStyle:{"white-space":"nowrap","width":"100%","overflow":"hidden","text-overflow":"ellipsis"}},[(_vm.member.length !== 0)?_c('span',{staticClass:"headline CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("group")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.ShowFriendDialog.header',{groupname: _vm.name}))+"\n            "),_c('span',{staticStyle:{"font-size":"13px"}},[_vm._v("("+_vm._s(_vm.member.length)+")")])],1):_c('span',{staticClass:"headline CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("group")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.ShowFriendDialog.header',{groupname: _vm.name}))+"\n          ")],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_vm._l((_vm.member),function(item,index){return (_vm.member.length !== 0)?_c('v-flex',{staticStyle:{"justify-content":"center"},attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-layout',{staticStyle:{"justify-content":"center","display":"flex"}},[_c('v-avatar',{staticClass:"user-photo"},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'user')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","white-space":"nowrap","width":"100%","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v("\n              "+_vm._s(item.name)+"\n            ")])],1):_vm._e()}),_vm._v(" "),(_vm.member.length == 0)?_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_vm._v("\n            "+_vm._s(_vm.$t('Dialog.ShowFriendDialog.noMember'))+"\n          ")]):_vm._e()],2)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-end":"","row":"","fill-height":"","wrap":""}},[_c('v-btn',{staticClass:"btnallow text-transform",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.AcceptReq_GroupReq()}}},[_vm._v("\n            "+_vm._s(_vm.$t('AnswerQuestion.joinGroup'))+"\n          ")])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"1vw"},attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","fill-height":"","wrap":""}},[_c('v-btn',{staticClass:"btncancel text-transform",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.RemoveReq_GroupReq()}}},[_vm._v("\n            "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n          ")])],1)],1)],1)],1)],1)}
var ShowFriendDialogMobile_staticRenderFns = []
var ShowFriendDialogMobile_esExports = { render: ShowFriendDialogMobile_render, staticRenderFns: ShowFriendDialogMobile_staticRenderFns }
/* harmony default export */ var dialog_ShowFriendDialogMobile = (ShowFriendDialogMobile_esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/ShowFriendDialogMobile.vue
function ShowFriendDialogMobile_injectStyle (ssrContext) {
  __webpack_require__("8zZB")
}
var ShowFriendDialogMobile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ShowFriendDialogMobile___vue_template_functional__ = false
/* styles */
var ShowFriendDialogMobile___vue_styles__ = ShowFriendDialogMobile_injectStyle
/* scopeId */
var ShowFriendDialogMobile___vue_scopeId__ = "data-v-0c64f0ef"
/* moduleIdentifier (server only) */
var ShowFriendDialogMobile___vue_module_identifier__ = null
var ShowFriendDialogMobile_Component = ShowFriendDialogMobile_normalizeComponent(
  ShowFriendDialogMobile["a" /* default */],
  dialog_ShowFriendDialogMobile,
  ShowFriendDialogMobile___vue_template_functional__,
  ShowFriendDialogMobile___vue_styles__,
  ShowFriendDialogMobile___vue_scopeId__,
  ShowFriendDialogMobile___vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_ShowFriendDialogMobile = (ShowFriendDialogMobile_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/manage/Creategroup.vue
var Creategroup = __webpack_require__("qtw1");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-244d9515","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/manage/Creategroup.vue
var Creategroup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('div',[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage()}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('LeftSide.createGroup.header')))])],1),_vm._v(" "),_c('v-stepper',{model:{value:(_vm.step_creategroup),callback:function ($$v) {_vm.step_creategroup=$$v},expression:"step_creategroup"}},[_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('h4',{staticStyle:{"padding-left":"10px"}},[_vm._v(_vm._s(_vm.$t('Dialog.group.chooseFriend')))]),_vm._v(" "),_c('v-container',{staticStyle:{"padding-top":"0px","height":"calc(100vh - 100px)","overflow-y":"scroll"},attrs:{"wrap":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"borderlistfriend",attrs:{"sm12":"","xs12":""}},[_c('v-text-field',{attrs:{"solo":"","hide-details":"","append-icon":"search","label":_vm.$t('LeftSide.createGroup.searching'),"clearable":""},model:{value:(_vm.searchfriend),callback:function ($$v) {_vm.searchfriend=$$v},expression:"searchfriend"}}),_vm._v(" "),(_vm.FilterFriendList.length != 0)?_c('v-list',{staticClass:"CSChatThai widthfull scrolling-wrapper",staticStyle:{"padding":"0px","margin-top":"10px"}},[_vm._l((_vm.FilterFriendList),function(item,index){return [_c('v-list-tile',{key:item.tokenuser,attrs:{"avatar":"","ripple":""}},[_c('v-list-tile-avatar',[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'company')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"textoverflow"},[_vm._v("\n                                "+_vm._s(item.name)+"\n                              ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-checkbox',{staticStyle:{"color":"#2562af !important"},attrs:{"value":item},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)]})],2):_c('v-container',[_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.showDialog('AddFriend')}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"CSChatThai ",staticStyle:{"font-size":"12px","text-align":"center","color":"black"}},[_c('v-icon',{staticStyle:{"color":"black","font-size":"18px !important"}},[_vm._v("add_circle")]),_vm._v("\n                                "+_vm._s(_vm.$t('AnswerQuestion.addFriend'))+"\n                              ")],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"borderlistfriendSelect",attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"setBorder ml-1"},[_c('v-layout',{staticClass:"setPaddingButtomListFriendInGroup",staticStyle:{"margin-top":"5px"},attrs:{"row":"","wrap":""}},[(_vm.selected.length != 0)?_c('h4',{staticStyle:{"padding-left":"12px"}},[_vm._v(_vm._s(_vm.$t('RightSide.member'))+" ("+_vm._s(_vm.selected.length)+")")]):_vm._e()]),_vm._v(" "),(_vm.selected.length != 0)?_c('div',{staticClass:"scrolling-wrapperx"},[_c('v-item-group',_vm._l((_vm.selected),function(i,index){return _c('v-item',{key:index,scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
return _c('v-chip',{attrs:{"selected":active,"close":""},on:{"input":function($event){_vm.removeListAddGroup(i)}}},[_c('v-avatar',[(i.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":i.profilepicture,"alt":i.name}}):(i.type === 'company')?_c('img',{attrs:{"src":"/static/img/default_profile/business-white.png","alt":i.name}}):(i.type === 'government')?_c('img',{attrs:{"src":"/static/img/default_profile/business-white.png","alt":i.name}}):(i.type === 'bot')?_c('img',{attrs:{"src":"/static/img/default_profile/bot-white.png","alt":i.name}}):_c('img',{attrs:{"src":"/static/img/default_profile/man-white.png","alt":i.name}})]),_vm._v("\n                              "+_vm._s(i.name)+"\n                            ")],1)}}])})}))],1):_c('div',{staticStyle:{"margin-top":"40px"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":"","row":""}},[_c('h5',[_vm._v(_vm._s(_vm.$t('LeftSide.createGroup.noneSelect')))])])],1)],1)])],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","warp":""}},[_c('v-flex',{staticClass:"text-xs-left"},[_c('v-btn',{staticClass:"CSChatThai btncanclegroup",on:{"click":function($event){_vm.toPage()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel'))+" ")])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"CSChatThai btncreategroup",attrs:{"color":"primary","disabled":!(_vm.selected.length !== 0)},on:{"click":function($event){_vm.step_creategroup = 2}}},[_vm._v(_vm._s(_vm.$t('Task.allTask.next')))])],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('h4',{staticStyle:{"padding-left":"10px"}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.createGroup')))]),_vm._v(" "),_c('v-container',{staticStyle:{"padding-top":"0px","height":"calc(100vh - 100px)","overflow-y":"scroll"},attrs:{"wrap":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"sm12":"","xs12":"","md12":""}},[_c('div',{staticClass:"List_item_body"},[_c('div',{staticClass:"SettingImg"},[_c('div',{staticClass:"SettingImgWrap"},[_c('div',[(_vm.imageData == '')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer","width":"130px","height":"130px"},attrs:{"src":"/static/img/default_profile/group-white.png"},on:{"click":_vm.uppic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer","width":"130px","height":"130px"},attrs:{"src":_vm.imageData},on:{"click":_vm.uppic}}),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('input',{staticClass:"CSChatThai",attrs:{"type":"file","name":"file1","accept":"image/*","id":"uploadpicgroupweb"},on:{"change":_vm.previewImageweb}})]),_vm._v(" "),_c('label',{staticClass:"SettingImgBtn",attrs:{"for":"SettingImg"},on:{"click":function($event){_vm.uppic()}}},[_vm._v("\n                              "+_vm._s(_vm.$t('AnswerQuestion.selectPicture'))+"\n                            ")])])])]),_vm._v(" "),_c('p',{staticClass:"EditAreaNote"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.support'))+" .JPEG/.PNG/.GIF")]),_c('p',{staticClass:"EditAreaNote"}),_c('p',{staticClass:"EditAreaNote"})])]),_vm._v(" "),_c('v-flex',{staticClass:"mt-2",attrs:{"sm12":"","xs12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.GroupName),expression:"GroupName"}],staticClass:"CSChatThai inputgroupweb",attrs:{"type":"text","placeholder":_vm.$t('LeftSide.createGroup.detailSearch')},domProps:{"value":(_vm.GroupName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.GroupName=$event.target.value}}})])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-left"},[[_c('v-btn',{staticClass:"CSChatThai btncanclegroup",on:{"click":function($event){_vm.step_creategroup = 1}}},[_vm._v(_vm._s(_vm.$t('Register.Button.back')))])]],2),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"CSChatThai btncreategroup",attrs:{"loading":_vm.loading,"disabled":!(_vm.selected.length !== 0 && _vm.GroupName !== '')},on:{"click":function($event){_vm.submit()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.createGroup')))])],1)],1)],1)],1)],1)],1)],1)])}
var Creategroup_staticRenderFns = []
var Creategroup_esExports = { render: Creategroup_render, staticRenderFns: Creategroup_staticRenderFns }
/* harmony default export */ var manage_Creategroup = (Creategroup_esExports);
// CONCATENATED MODULE: ./src/components/mobile/manage/Creategroup.vue
function Creategroup_injectStyle (ssrContext) {
  __webpack_require__("NgZZ")
}
var Creategroup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Creategroup___vue_template_functional__ = false
/* styles */
var Creategroup___vue_styles__ = Creategroup_injectStyle
/* scopeId */
var Creategroup___vue_scopeId__ = "data-v-244d9515"
/* moduleIdentifier (server only) */
var Creategroup___vue_module_identifier__ = null
var Creategroup_Component = Creategroup_normalizeComponent(
  Creategroup["a" /* default */],
  manage_Creategroup,
  Creategroup___vue_template_functional__,
  Creategroup___vue_styles__,
  Creategroup___vue_scopeId__,
  Creategroup___vue_module_identifier__
)

/* harmony default export */ var mobile_manage_Creategroup = (Creategroup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/manage/Addfriend.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Addfriend = ({
  data: function data() {
    return {
      statussearch: '',
      search: '',
      token: '',
      TypeSearch: 'email',
      tokenFriend: '',
      filename: '',
      webbackend: '',
      listuser: [],
      listbot: [],
      listbusiness: [],
      listgoverment: [],
      business_id_user: '',
      type: '',
      dialogPassword: false,
      message_error: '',
      password: '',
      infor_bot: {},
      loading: false
    };
  },
  components: {
    vue100vh: vue100vh["a" /* default */]
  },
  methods: {
    check_password_bot: function check_password_bot() {
      var _this = this;

      this.message_error = '';
      this.loading = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/check_password_bot', { tokenBot: this.infor_bot.tokenbot, password: this.password }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          if (response.data.message === 'correct password') {
            _this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", { tokenfriend: _this.infor_bot.tokenbot, tokenuser: _this.token }).then(function (response) {
              if (response.data.status === 'success') {
                _this.dialogPassword = false;
                _this.loading = false;
                _this.password = '';
                _this.listbot[_this.infor_bot.index].relation = 'friend';
                _this.listbot[_this.infor_bot.index].user.tokenroom = response.data.tokenroom;
              }
            });
          } else {
            _this.loading = false;
            _this.message_error = _this.$t('LeftSide.addFiend.messageCheckbot');
            // console.log(response.data.message)
          }
        }
      });
    },
    close_dialog_pass: function close_dialog_pass() {
      this.dialogPassword = false;
      this.message_error = '';
      this.password = '';
      this.infor_bot = {};
    },
    clear_dialog_pass: function clear_dialog_pass() {
      this.message_error = '';
      this.password = '';
    },
    toPage: function toPage() {
      this.$router.go(-1);
    },
    closeDialog: function closeDialog() {
      this.$emit('closeDialogAddFriend', false);
      this.search = '';
      this.tokenFriend = '';
      this.statussearch = '';
    },
    searchuser: function searchuser() {
      var _this2 = this;

      this.listbot = [];
      this.listuser = [];
      this.axios.post("https://uatchat-manage.one.th/manage" + '/searchusernontype3', { tokenuser: this.token, key: this.search }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          if (response.data['listuser'].length !== 0 || response.data['listBot'].length !== 0) {
            _this2.listuser = response.data['listuser'];
            _this2.listbot = response.data['listBot'];
            _this2.statussearch = 'found';
          } else {
            _this2.statussearch = 'not found';
          }
        } else {
          _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'warning');
        }
      });
    },
    AcceptReq: function AcceptReq(index, item) {
      var _this3 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/accept-friend", { tokenfriend: item.user.tokenuser, tokenuser: this.token }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this3.listuser[index].relation = 'friend';
          _this3.$emit('updatelistreq', {
            event: 'accept',
            tokenuser: item.user.tokenuser,
            name: item.user.name,
            profilepicture: item.user.profilepicture,
            email: item.user.email,
            state: 'friend',
            status: item.user.status,
            type: item.user.type,
            tokenroom: response.data.tokenroom,
            timestamp: response.data.timestamp
          });
          // this.$store.dispatch('listFriend', JSON.stringify(this.listSearch))
          // this.$store.dispatch('Request', 'acceptrequest' + this.listSearch + ' ' + Math.random())
        } else {
          _this3.$swal('', _this3.$t('Alert.Fail.default.somethingWrong'), 'warning');
        }
      });
    },
    RemoveReq: function RemoveReq(index, item) {
      var _this4 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', { tokenfriend: item.user.tokenuser, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          _this4.listuser[index].relation = 'unknown';
          _this4.$emit('updatelistreq', {
            event: 'removeReq',
            tokenuser: item.user.tokenuser
          });
          // this.$emit('updatelistreq', tokenfriend)
          // this.$store.dispatch('sendRequest', 'removerequestfriend' + tokenfriend)
        }
      });
    },
    AddFriend: function AddFriend(index, tokenfriend, typeuser, item) {
      var _this5 = this;

      if (typeuser === 'user') {
        this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", { tokenfriend: tokenfriend, tokenuser: this.token }).then(function (response) {
          if (response.data.status === 'success') {
            if (typeuser === 'user') {
              _this5.listuser[index].relation = 'sendrequest';
            }
          }
        });
      } else if (typeuser === 'bot' && item.user.is_password !== '0') {
        this.dialogPassword = true;
        this.infor_bot = { 'tokenbot': tokenfriend, 'index': index };
      } else {
        this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", { tokenfriend: tokenfriend, tokenuser: this.token }).then(function (response) {
          if (response.data.status === 'success') {
            _this5.listbot[index].relation = 'friend';
            _this5.listbot[index].user.tokenroom = response.data.tokenroom;
          }
        });
      }
    },
    AddFriendCollab: function AddFriendCollab(index, item, state) {
      var _this6 = this;

      // console.log(item)
      // console.log(index)
      this.loading = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/add-friend-accept', { tokenfriend: item.tokenuser, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          _this6.loading = false;
          if (state === 'true') {
            _this6.chat(response.data.tokenroom);
          } else {
            _this6.listuser[index].relation = 'friend';
            _this6.listuser[index].user.tokenroom = response.data.tokenroom;
          }
        } else {
          _this6.loading = false;
          _this6.$swal('', _this6.$t('Alert.Fail.default.somethingWrong'), 'warning');
        }
      }).catch(function (error) {
        console.log(error);
        _this6.loading = false;
        _this6.$swal('', _this6.$t('Alert.Fail.default.somethingWrong'), 'warning');
      });
    },
    chat: function chat(room) {
      // this.$emit('closeFriend', false)
      // this.$store.dispatch('tokenRoom', room)
      // localStorage.setItem('room', room)
      // this.closeDialog()
      this.$router.push('/mobile/room/' + room);
      // this.$store.dispatch('changeFriend', room)
      // this.$store.dispatch('changeRightTool', 'Friend')
    },
    findWithAttr: function findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
    unblock: function unblock(index, item, type) {
      var _this7 = this;

      this.$swal({
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Unblocking', { name: item.user.name }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this7.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', { tokenfriend: item.user.tokenuser, tokenuser: _this7.token, tokenroom: item.user.tokenroom }).then(function (response) {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              _this7.$swal('Unblocked!', _this7.$t('Alert.Success.unblock'), 'success');
              // this.listSearch[index].relation = 'friend'
              // this.$http.post(process.env.APImanage + '/web/getlistblockfriend', {tokenuser: this.token}).then((response) => {
              //   this.$store.dispatch('listFriend', 'listBlockFriend' + tokenfriend)
              // })
              if (type === 'user') {
                _this7.listuser[index].relation = 'friend';
              } else if (type === 'bot') {
                _this7.listbot[index].relation = 'friend';
              }
              // emit ย้อนกลับได้
              var itemfriend = item.user;
              itemfriend.event = 'unblock_friend';
              _this7.$emit('blockevent', itemfriend);
            }
          });
        }
      });
    }
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.filename = localStorage.getItem('profilepicture');
    this.webbackend = "https://uatchat.one.th";
    this.type = localStorage.getItem('type_user');
    this.business_id_user = localStorage.getItem('business_id');
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
  },

  watch: {
    search: function search() {
      this.listuser = [];
      this.listbot = [];
      this.statussearch = '';
    },
    event_accept_friend: function event_accept_friend(data) {
      // console.log(data)
      this.socketaccept_friend = data;
    }
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*'))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7afb5a24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/manage/Addfriend.vue
var Addfriend_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('div',{staticClass:"CSChatThai BGwhite"},[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage()}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('LeftSide.friend.addFriend')))])],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"overflow-y":"scroll","height":"calc(100vh - 64px)"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center","margin-top":"1vh"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-text-field',{staticClass:"bgsearch",staticStyle:{"color":"white !important"},attrs:{"append-icon":"search","label":_vm.$t('LeftSide.addFiend.searching'),"solo":"","clearable":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.searchuser()},"click:append":function($event){_vm.searchuser()}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(_vm.statussearch == '')?_c('v-flex',{staticClass:"CSChatThai",attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[_c('img',{staticStyle:{"width":"170px"},attrs:{"src":"/static/img/onechat/search.jpg"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('LeftSide.addFiend.detailSearch')))])])],1):(_vm.statussearch == 'not found')?_c('v-flex',{staticClass:"CSChatThai",attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[_c('img',{staticStyle:{"width":"120px","margin-bottom":"20px"},attrs:{"src":"/static/img/onechat/nosearch.png"}}),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.$t('LeftSide.addFiend.nodata', {key: _vm.search})))])])],1):_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-tabs',{attrs:{"centered":"","color":"cyan","dark":"","icons-and-text":""}},[_c('v-tabs-slider',{attrs:{"color":"info"}}),_vm._v(" "),(_vm.listuser.length !== 0)?_c('v-tab',{key:1,staticStyle:{"color":"black !important"},attrs:{"href":"#tab-1"}},[_vm._v("User\n                  "),_c('v-badge',{attrs:{"color":"#2562af"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.listuser.length))]),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"black !important","font-size":"25px !important"}},[_vm._v("person")])],1)],1):_vm._e(),_vm._v(" "),(_vm.listbot.length !== 0)?_c('v-tab',{key:2,staticStyle:{"color":"black !important"},attrs:{"href":"#tab-2"}},[_vm._v("Bot\n                  "),_c('v-badge',{attrs:{"color":"#2562af"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.listbot.length))]),_vm._v(" "),_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"30px"},attrs:{"src":"/static/img/icons/bot.svg"}})])],1):_vm._e(),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',{attrs:{"id":"tab-1"}},[(_vm.listuser.length !== 0)?_c('v-list',{staticStyle:{"overflow-y":"scroll","max-height":"40vh"},attrs:{"two-line":""}},[_vm._l((_vm.listuser),function(item,index){return [_c('v-list-tile',[_c('v-list-tile-avatar',[(item.user.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.user.profilepicture}}):(item.user.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"text2",domProps:{"innerHTML":_vm._s(item.user.name)}})],1),_vm._v(" "),_c('v-list-tile-action',[(item.relation == 'friend')?_c('v-btn',{staticClass:"CSChatThai text-transform",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.chat(item.user.tokenroom)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.chat')))]):(item.relation == 'request')?_c('v-btn',{staticClass:"CSChatThai text-transform",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.AcceptReq(index,item)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.acceptFriend')))]):(item.relation == 'sendrequest')?_c('v-btn',{staticClass:"CSChatThai text-transform",attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.RemoveReq(index,item)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancelRequest')))]):(item.relation == 'block')?_c('v-btn',{staticClass:"CSChatThai text-transform",attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.unblock(index,item,'user')}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.unblock')))]):(item.relation == 'self')?_c('v-btn',{staticClass:"CSChatThai text-transform",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))]):((item.relation == 'unknown' || item.relation == 'unfriend') && item.collab_mail == 'true')?_c('v-btn',{staticClass:"CSChatThai text-transform",attrs:{"color":"blue darken-1","flat":"","loading":_vm.loading},nativeOn:{"click":function($event){_vm.AddFriendCollab(index, item.user, item.collab_mail)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.chat')))]):((item.relation == 'unknown' || item.relation == 'unfriend') && item.collab_mail == 'false')?_c('v-btn',{staticClass:"CSChatThai text-transform",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.AddFriendCollab(index, item.user, item.collab_mail)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.addFriend')))]):_vm._e()],1)],1),_vm._v(" "),_c('v-divider')]})],2):_c('v-list',[_c('h4',{staticStyle:{"margin-top":"40px","justify-content":"center","display":"flex"}},[_vm._v(_vm._s(_vm.$t('LeftSide.addFiend.nodata', {key: ''})))])])],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[(_vm.listbot.length !== 0)?_c('v-list',{staticStyle:{"overflow-y":"scroll","max-height":"40vh"},attrs:{"two-line":""}},[_vm._l((_vm.listbot),function(item,index){return [_c('v-list-tile',[_c('v-list-tile-avatar',[(item.user.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.user.profilepicture}}):(item.user.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"text2",domProps:{"innerHTML":_vm._s(item.user.name)}})],1),_vm._v(" "),_c('v-list-tile-action',[(item.relation == 'friend')?_c('v-btn',{staticClass:"CSChatThai text-transform",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.chat(item.user.tokenroom)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.chat')))]):(item.relation == 'request')?_c('v-btn',{staticClass:"CSChatThai text-transform",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.AcceptReq(index,item)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.acceptFriend')))]):(item.relation == 'sendrequest')?_c('v-btn',{staticClass:"CSChatThai text-transform",attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.RemoveReq(index,item)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancelRequest')))]):(item.relation == 'block')?_c('v-btn',{staticClass:"CSChatThai text-transform",attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.unblock(index,item,'bot')}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.unblock')))]):(item.relation == 'self')?_c('v-btn',{staticClass:"CSChatThai text-transform",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))]):(item.relation == 'unknown' || item.relation == 'unfriend')?_c('v-btn',{staticClass:"CSChatThai text-transform",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.AddFriend(index,item.user.tokenuser,item.user.type, item)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.addFriend')))]):_vm._e()],1)],1),_vm._v(" "),_c('v-divider')]})],2):_c('v-list',[_c('h4',{staticStyle:{"margin-top":"40px","justify-content":"center","display":"flex"}},[_vm._v(_vm._s(_vm.$t('LeftSide.addFiend.nodata', {key: ''})))])])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialogPassword),callback:function ($$v) {_vm.dialogPassword=$$v},expression:"dialogPassword"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('LeftSide.addFiend.headerCheckpass'))+"\n                  "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.close_dialog_pass}},[_c('v-icon',{staticStyle:{"color":"black !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"solo":"","label":_vm.$t('LeftSide.addFiend.placeholderPassword'),"clearable":"","hide-details":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.check_password_bot($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"red","padding-left":"10px"}},[_vm._v(_vm._s(_vm.message_error))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"btncancle",on:{"click":_vm.clear_dialog_pass}},[_vm._v("\n                    "+_vm._s(_vm.$t('AnswerQuestion.clear'))+"\n                  ")]),_vm._v(" "),_c('v-btn',{staticClass:"btnaddfriend",attrs:{"loading":_vm.loading},on:{"click":_vm.check_password_bot}},[_vm._v("\n                    "+_vm._s(_vm.$t('AnswerQuestion.addFriend'))+"\n                  ")])],1)],1)],1)],1)],1)],1)],1)],1)])}
var Addfriend_staticRenderFns = []
var Addfriend_esExports = { render: Addfriend_render, staticRenderFns: Addfriend_staticRenderFns }
/* harmony default export */ var manage_Addfriend = (Addfriend_esExports);
// CONCATENATED MODULE: ./src/components/mobile/manage/Addfriend.vue
function Addfriend_injectStyle (ssrContext) {
  __webpack_require__("+27f")
}
var Addfriend_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Addfriend___vue_template_functional__ = false
/* styles */
var Addfriend___vue_styles__ = Addfriend_injectStyle
/* scopeId */
var Addfriend___vue_scopeId__ = "data-v-7afb5a24"
/* moduleIdentifier (server only) */
var Addfriend___vue_module_identifier__ = null
var Addfriend_Component = Addfriend_normalizeComponent(
  Addfriend,
  manage_Addfriend,
  Addfriend___vue_template_functional__,
  Addfriend___vue_styles__,
  Addfriend___vue_scopeId__,
  Addfriend___vue_module_identifier__
)

/* harmony default export */ var mobile_manage_Addfriend = (Addfriend_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-context/dist/js/vue-context.js
var vue_context = __webpack_require__("IaZh");
var vue_context_default = /*#__PURE__*/__webpack_require__.n(vue_context);

// EXTERNAL MODULE: ./node_modules/vue-screen-size/dist/vue-screen-size.esm.js
var vue_screen_size_esm = __webpack_require__("B8hy");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/layout/LeftSideMobileTest.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











// import CenterSideMobile from '@/components/mobile/layout/CenterSideMobile'
var LeftSideMobileTest__ = __webpack_require__("M4fF");
/* harmony default export */ var LeftSideMobileTest = ({
  mixins: [vue_screen_size_esm["a" /* default */].VueScreenSizeMixin],
  data: function data() {
    return {
      // infofriend: false,
      // statemember: '',
      checkBrowserDialog: false,
      checkBrowserInfor: {},
      show_alert: false,
      num_listalert: 0,
      list_alert: [],
      rightclickdialog: false,
      num_friendreq: '',
      num_friendsendreq: '',
      num_groupreq: '',
      num_managefriend: '',
      showcountread: false,
      num_countread: '',
      showgroup: false,
      ShowFriend: false,
      listgroup: [],
      listfriend: [],
      listchat: [],
      FriendReq: [],
      FriendSendReq: [],
      GroupReq: [],
      ProgressListFriend: false,
      show: false,
      actionF: '',
      ProgressListChat: false,
      search: '',
      tokenuser: '',
      tabs: null,
      listmenuchat: [
        // {
        //   title: 'คิวอาร์โค้ด',
        //   icon: 'fas fa-qrcode',
        //   path: '/mobile/qrcode'
        // },
        // {
        //   title: 'เพิ่มเพื่อน',
        //   icon: 'fas fa-user',
        //   path: '/mobile/addfriend'
        // },
        // {
        //   title: 'สร้างกลุ่ม',
        //   icon: 'fas fa-users',
        //   path: '/mobile/creategroup'
        // }
      ],
      listmenufriend: [
        // {
        //   title: 'คิวอาร์โค้ด',
        //   icon: 'fas fa-qrcode',
        //   path: '/mobile/qrcode'
        // },
        // {
        //   title: 'เพิ่มเพื่อน',
        //   icon: 'fas fa-user',
        //   path: '/mobile/addfriend'
        // },
        // {
        //   title: 'สร้างกลุ่ม',
        //   icon: 'fas fa-users',
        //   path: '/mobile/creategroup'
        // },
        // {
        //   title: 'โปรเจค',
        //   icon: 'fas fa-tasks',
        //   path: '/mobile/task/project'
        // },
        // {
        //   title: 'ปฏิทิน',
        //   icon: 'fas fa-calendar',
        //   path: '/mobile/task/calendar'
        // }
      ],
      listsetting: [],
      listservice: [{
        title: 'OneEmail',
        icon: '',
        img: '/static/img/oneplatform/oneemail2.png',
        path: "https://testoneid.inet.co.th/preauth",
        type: 'link'
      }, {
        title: 'OneBox',
        icon: '',
        img: '/static/img/oneplatform/onebox.png',
        path: "https://testoneid.inet.co.th/oauth/authorize?client_id=155&response_type=code&scope=account",
        type: 'share_token_onebox'
      },
      // {
      //   title: 'OneChat News',
      //   icon: '',
      //   img: '/static/img/oneplatform/onechat_news.jpg',
      //   path: process.env.WEBNews,
      //   type: 'function_news'
      // },
      {
        title: 'One Anonymous',
        icon: '',
        img: '/static/img/oneplatform/anonymousone.png',
        path: '/mobile/settings/anonymousone_group',
        type: 'route'
      }],
      listother: [],
      SelectedMessageDetail: {},
      ListMenuRightClick: [],
      profilepicture: '',
      name: '',
      status_user: '',
      heightlistchat: '',
      heightlistfriend: '',
      heightlistsetting: '',
      encodeToken_News: '',
      one_id: '',
      consentOnechatDialog: false,
      url_consent: ''
    };
  },
  created: function created() {
    // this.heightlistchat = 'height: ' + (this.$vssHeight - ((34.0 + 40.0 + 82.0) - 10.0)) + 'px;'
    // this.heightlistchat = 'height: ' + (this.$vssHeight - 210.0) + 'px;'
    // this.heightlistfriend = 'height: ' + (this.$vssHeight - 405.0) + 'px;'
    this.heightlistchat = 'height: ' + (this.$vssHeight - 170.0) + 'px;';
    this.heightlistfriend = 'height: ' + (this.$vssHeight - 335.0) + 'px;';
    this.heightlistsetting = 'height: ' + (this.$vssHeight - 110.0) + 'px;';
    this.actionF = this.$route.params.roomid;
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    this.tabs = localStorage.getItem('tabs');
    this.profilepicture = localStorage.getItem('profilepicture');
    this.name = localStorage.getItem('name');
    this.status_user = localStorage.getItem('status');
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
    this.changeLangMenu();
    this.getlistchat();
    this.getlistfriend();
    this.getlistgroup();
    this.getlistalert();
    this.getOneid();
    this.getlistpending();
    // console.log(this.$cookie.get('language'))
  },

  components: {
    ShowFriendDialog: mobile_dialog_ShowFriendDialogMobile,
    CreateGroupMobile: mobile_manage_Creategroup,
    Addfriend: mobile_manage_Addfriend,
    VueContext: vue_context["VueContext"],
    vue100vh: vue100vh["a" /* default */],
    CheckBrowserDialog: CheckBrowserDialog["a" /* default */],
    checkconsentOnechatDialog: consent_onechat_dialog["a" /* default */]
    // Editprofile
    // CenterSideMobile
  },
  computed: extends_default()({
    FilterFriendList: function FilterFriendList() {
      var _this = this;

      if (this.search !== '' && this.search !== null) {
        return this.listfriend.filter(function (post) {
          return post.name.toLowerCase().includes(_this.search.toLowerCase());
        });
      } else {
        return this.listfriend;
      }
    },
    FilterGroupList: function FilterGroupList() {
      var _this2 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listgroup.filter(function (post) {
          return post.name.toLowerCase().includes(_this2.search.toLowerCase());
        });
      } else {
        return this.listgroup;
      }
    },
    FilterChatList: function FilterChatList() {
      var _this3 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listchat.filter(function (post) {
          return post.name.toLowerCase().includes(_this3.search.toLowerCase());
        });
      } else {
        return this.listchat;
      }
    }
  }, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {
    '$i18n.locale': function $i18nLocale() {
      this.changeLangMenu();
    },
    '$vssHeight': function $vssHeight() {
      // this.box_height = (this.$vssHeight - ((34.0 + 40.0 + 82.0) - 10.0))
      // console.log('height center ==> '+ this.$vssHeight)
      // this.heightlistchat = 'height: ' + (this.$vssHeight - 210.0) + 'px;'
      // this.heightlistfriend = 'height: ' + (this.$vssHeight - 405.0) + 'px;'
      this.heightlistchat = 'height: ' + (this.$vssHeight - 170.0) + 'px;';
      this.heightlistfriend = 'height: ' + (this.$vssHeight - 335.0) + 'px;';
      this.heightlistsetting = 'height: ' + (this.$vssHeight - 110.0) + 'px;';
      // console.log(this.$vssHeight)
    },
    myprofilepicture: function myprofilepicture() {
      this.profilepicture = localStorage.getItem('profilepicture');
    },
    myname: function myname() {
      this.name = localStorage.getItem('name');
      // console.log(this.name)
    },
    mystatus: function mystatus() {
      this.status_user = localStorage.getItem('status');
    },
    tabs: function tabs() {
      localStorage.setItem('tabs', this.tabs);
    },
    chIsactive: function chIsactive(data) {
      var _this4 = this;

      var indexmsg = LeftSideMobileTest__.findIndex(this.listchat, function (o) {
        return o.tokenroom === data;
      });
      this.listchat[indexmsg].is_active = false;
      this.$router.push('/mobile/homepage');
      this.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', { tokenroom: data, tokenuser: this.tokenuser, pin: 'false' }).then(function (response) {
        var listpin = [];
        var linstunpin = [];
        _this4.listchat[indexmsg].pin = 'false';
        _this4.listchat = LeftSideMobileTest__.partition(_this4.listchat, function (o) {
          return o.pin == 'true';
        });
        listpin = LeftSideMobileTest__.orderBy(_this4.listchat[0], 'timestamp', 'desc');
        linstunpin = LeftSideMobileTest__.orderBy(_this4.listchat[1], 'timestamp', 'desc');
        _this4.listchat = LeftSideMobileTest__.union(listpin, linstunpin);
      });
    },
    block_friend: function block_friend(data) {
      // console.log(data)
      this.blockevent(data);
    },
    centrifuge_consent: function centrifuge_consent(data) {
      if (data.consent_version !== undefined) {
        this.consentOnechatDialog = false;
      }
    },
    socket_unsendmessage: function socket_unsendmessage(data) {
      var _this5 = this;

      // console.log(data)
      this.axios.post("https://uatchat-manage.one.th/event" + '/getmessage', { tokenmessage: data.last_tokenmessage, tokenuser: this.tokenuser }).then(function (response) {
        // console.log(response.data.source)
        var dataunsend = {};
        dataunsend = response.data.source;
        var indexmsg = LeftSideMobileTest__.findIndex(_this5.listchat, function (o) {
          return o.tokenroom === data.tokenroom;
        });
        if (indexmsg !== -1) {
          _this5.listchat[indexmsg].is_active = 'true';
          // var message = dataunsend.message
          if (data.tokenroom !== _this5.actionF) {
            _this5.listchat[indexmsg].count_read = parseInt(_this5.listchat[indexmsg].count_read) + 1;
          }
          if (indexmsg === 0) {
            _this5.listchat[0].message = dataunsend.message;
            _this5.listchat[0].timestamp = dataunsend.timestamp;
            _this5.listchat[0].nickname = dataunsend.nickname;
            _this5.listchat[0].typeofmessage = dataunsend.typeofmessage;
            _this5.listchat[0].time_count = dataunsend.time_count;
            _this5.listchat[0].file_name = dataunsend.file_name;
            _this5.listchat[0].tokenuser = dataunsend.tokenuser;
          } else {
            var dataindex = _this5.listchat[indexmsg];
            dataindex.message = dataunsend.message;
            dataindex.timestamp = dataunsend.timestamp;
            dataindex.nickname = dataunsend.nickname;
            dataindex.typeofmessage = dataunsend.typeofmessage;
            dataindex.time_count = dataunsend.time_count;
            dataindex.file_name = dataunsend.file_name;
            dataindex.tokenuser = dataunsend.tokenuser;
            LeftSideMobileTest__.pullAt(_this5.listchat, indexmsg); // ลบ listchat เดิม
            _this5.listchat.unshift(dataindex); // เพิ่ม lischat ใหม่เข้าไป
          }
        }
      });
    },
    socketmessage: function socketmessage(data) {
      // console.log(data)
      // console.log(data.message)
      // var _ = require('lodash')
      var indexmsg = LeftSideMobileTest__.findIndex(this.listchat, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (indexmsg !== -1) {
        this.listchat[indexmsg].is_active = 'true';
      }
      var message = data.message;
      // if (data.typeofmessage !== 'message') {
      //   message = 'Send ' + data.typeofmessage
      // }
      if (data.tokenroom !== this.actionF && data.tokenuser != this.tokenuser) {
        this.listchat[indexmsg].count_read = (parseInt(this.listchat[indexmsg].count_read) + 1).toString();
        this.num_countread = this.num_countread + 1;
        var indexblock = [];
        var indexmessage = [];
        var indexactive = [];
        indexmessage = LeftSideMobileTest__.filter(this.listchat, function (listchat) {
          return listchat.message === '';
        });
        indexblock = LeftSideMobileTest__.filter(this.listchat, function (listchat) {
          return listchat.state !== 'active';
        });
        indexactive = LeftSideMobileTest__.filter(this.listchat, function (listchat) {
          return listchat.is_active !== 'true';
        });
        var countmsg = LeftSideMobileTest__.sumBy(indexmessage, function (o) {
          return parseInt(o.count_read);
        });
        var countblock = LeftSideMobileTest__.sumBy(indexblock, function (o) {
          return parseInt(o.count_read);
        });
        var countactive = LeftSideMobileTest__.sumBy(indexactive, function (o) {
          return parseInt(o.count_read);
        });
        var count = LeftSideMobileTest__.sumBy(this.listchat, function (o) {
          return parseInt(o.count_read);
        });
        this.num_countread = count - (countblock + countmsg + countactive);
        if (this.num_countread > 0) {
          this.showcountread = true;
        } else {
          this.showcountread = false;
        }
      }
      if (indexmsg === 0) {
        this.listchat[0].message = message;
        this.listchat[0].timestamp = data.timestamp;
        this.listchat[0].nickname = data.nickname;
        this.listchat[0].typeofmessage = data.typeofmessage;
        this.listchat[0].time_count = data.time_count;
        this.listchat[0].file_name = data.file_name;
        this.listchat[0].tokenuser = data.tokenuser;
      } else {
        var dataindex = this.listchat[indexmsg];
        dataindex.message = message;
        dataindex.timestamp = data.timestamp;
        dataindex.nickname = data.nickname;
        dataindex.typeofmessage = data.typeofmessage;
        dataindex.time_count = data.time_count;
        dataindex.file_name = data.file_name;
        dataindex.tokenuser = data.tokenuser;
        LeftSideMobileTest__.pullAt(this.listchat, indexmsg); // ลบ listchat เดิม
        this.listchat.unshift(dataindex); // เพิ่ม lischat ใหม่เข้าไป
      }
      // เรียงแชทใหม่ กรณที่มีการ pin
      var listpin = [];
      var linstunpin = [];
      this.listchat = LeftSideMobileTest__.partition(this.listchat, function (o) {
        return o.pin == 'true';
      });
      listpin = LeftSideMobileTest__.orderBy(this.listchat[0], 'timestamp', 'desc');
      linstunpin = LeftSideMobileTest__.orderBy(this.listchat[1], 'timestamp', 'desc');
      this.listchat = LeftSideMobileTest__.union(listpin, linstunpin);
    },
    socketactive_group: function socketactive_group(data) {
      var _this6 = this;

      // console.log(data)
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', { group_id: data.groupid, tokenuser: this.tokenuser }).then(function (response) {
        // console.log(response.data)
        var indexgroup = LeftSideMobileTest__.findIndex(_this6.GroupReq, function (o) {
          return o.group_id === response.data.group.group_id;
        }); // หาตำแหน่งของ group req ที่ต้องการจะลบ
        if (indexgroup >= 0) {
          LeftSideMobileTest__.pullAt(_this6.GroupReq, indexgroup); // ลบ GroupReq เดิม
          _this6.num_groupreq = _this6.GroupReq.length; // จำนวน group req
        }
        // update listgroup
        if (LeftSideMobileTest__.find(_this6.listgroup, function (o) {
          return o.group_id === response.data.group.group_id;
        }) === undefined) {
          var group = response.data.group;
          group.timestamp = data.timestamp;
          _this6.listgroup.unshift(group);
          _this6.listgroup = LeftSideMobileTest__.orderBy(_this6.listgroup, ['name'], ['asc']);
        }
        // update listchat
        // if (_.find(this.listchat, function (o) { return o.group_id === response.data.group.group_id }) === undefined) {
        //   var chat = response.data.group
        //   chat.timestamp = data.timestamp
        //   chat.count_read = ''
        //   chat.nickname = ''
        //   chat.is_active = 'true'
        //   this.listchat.unshift(chat)
        // }
        if (data.tokenuser === _this6.token) {
          var indexchat = LeftSideMobileTest__.findIndex(_this6.listchat, function (o) {
            return o.group_id === response.data.group.group_id;
          }); // หาตำแหน่งของ group req ที่ต้องการจะลบ
          // console.log(indexchat)
          _this6.listchat[indexchat].state = 'active';
        }
      });
    },
    socketinvite_group: function socketinvite_group(data) {
      var _this7 = this;

      // console.log(data)
      var index = LeftSideMobileTest__.findIndex(this.listgroup, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (index < 0) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', { group_id: data.groupid, tokenuser: data.userinvited }).then(function (response) {
          // console.log(response.data.group)
          _this7.GroupReq.unshift(response.data.group);
          _this7.GroupReq = LeftSideMobileTest__.orderBy(_this7.GroupReq, ['create_date'], ['asc']);
          _this7.num_groupreq = _this7.GroupReq.length;
        });
      }
    },
    socketcencel_group: function socketcencel_group(data) {
      // console.log(data)
      if (this.GroupReq.length !== 0) {
        // ลบ group req
        this.GroupReq.splice(this.findWithAttr(this.GroupReq, 'group_id', data.group_id), 1);
        this.num_groupreq = this.GroupReq.length;
        // console.log(this.num_groupreq)
      }
    },
    socketleave_group: function socketleave_group(data) {
      // console.log(data)
      var self = this;
      data.listkick.forEach(function (item) {
        if (item === self.token) {
          var index = LeftSideMobileTest__.findIndex(self.listgroup, function (o) {
            return o.tokenroom === data.tokenroom;
          });
          if (index >= 0) {
            self.listgroup.splice(index, 1);
          }
          var indexchat = LeftSideMobileTest__.findIndex(self.listchat, function (o) {
            return o.tokenroom === data.tokenroom;
          });
          if (indexchat >= 0) {
            self.listchat[indexchat].state = 'leave';
          }
        }
      });
    },
    socket_kickmember: function socket_kickmember(data) {
      var self = this;
      data.listkick.forEach(function (item) {
        if (item === self.tokenuser) {
          var index = LeftSideMobileTest__.findIndex(self.listgroup, function (o) {
            return o.tokenroom === data.tokenroom;
          });
          if (index >= 0) {
            self.listgroup.splice(index, 1);
          }
          var indexchat = LeftSideMobileTest__.findIndex(self.listchat, function (o) {
            return o.tokenroom === data.tokenroom;
          });
          if (indexchat >= 0) {
            self.listchat[indexchat].state = 'leave';
            var indexblock = [];
            indexblock = LeftSideMobileTest__.filter(self.listchat, function (listchat) {
              return listchat.state !== 'active';
            });
            var countblock = LeftSideMobileTest__.sumBy(indexblock, function (o) {
              return parseInt(o.count_read);
            });
            var count = LeftSideMobileTest__.sumBy(self.listchat, function (o) {
              return parseInt(o.count_read);
            });
            self.num_countread = count - countblock;
          }
        }
      });
    },
    socketremove_request_friend: function socketremove_request_friend(data) {
      // console.log(data)
      // var _ = require('lodash')
      var indexReq = LeftSideMobileTest__.findIndex(this.FriendReq, function (o) {
        return o.tokenuser === data.tokenuser;
      });
      var indexSendReq = LeftSideMobileTest__.findIndex(this.FriendSendReq, function (o) {
        return o.tokenuser === data.tokenuser;
      });
      if (indexReq >= 0) {
        this.FriendReq.splice(indexReq, 1);
        this.num_friendreq = this.FriendReq.length;
      }
      if (indexSendReq >= 0) {
        this.FriendSendReq.splice(indexSendReq, 1);
        this.num_friendsendreq = this.FriendSendReq.length;
      }
    },
    socketaccept_friend: function socketaccept_friend(data) {
      var _this8 = this;

      // console.log(data)
      var tokenfriend = data.tokenfriend;
      if (this.tokenuser === data.tokenfriend) {
        tokenfriend = data.tokenuser;
        var indexSendReq = LeftSideMobileTest__.findIndex(this.FriendSendReq, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        if (indexSendReq >= 0) {
          this.FriendSendReq.splice(indexSendReq, 1);
          this.num_friendsendreq = this.FriendSendReq.length;
        }
      }
      this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', { tokenuser: this.tokenuser, tokenfriend: tokenfriend }).then(function (response) {
        if (LeftSideMobileTest__.find(_this8.listfriend, function (o) {
          return o.tokenuser === response.data.user.tokenuser;
        }) === undefined) {
          _this8.listfriend.unshift(response.data.user);
          _this8.listfriend = LeftSideMobileTest__.orderBy(_this8.listfriend, ['name'], ['asc']);
        }
        // update listchat
        var indexchat = LeftSideMobileTest__.findIndex(_this8.listchat, function (o) {
          return o.tokenroom === data.tokenroom;
        });
        var json = response.data.user;
        json.nickname = '';
        json.picture = response.data.user.profilepicture;
        json.state = 'user';
        json.timestamp = data.timestamp;
        json.count_read = 0;
        json.is_active = 'true';
        // console.log(json)
        if (indexchat >= 0) {
          _this8.listchat.splice(indexchat, 1);
          _this8.listchat.unshift(json);
          // console.log(this.listchat)
        } else {
          _this8.listchat.unshift(json);
          // console.log(this.listchat)
        }
      });
      // เรียงแชทใหม่ กรณที่มีการ pin
      var listpin = [];
      var linstunpin = [];
      this.listchat = LeftSideMobileTest__.partition(this.listchat, function (o) {
        return o.pin == 'true';
      });
      listpin = LeftSideMobileTest__.orderBy(this.listchat[0], 'timestamp', 'desc');
      linstunpin = LeftSideMobileTest__.orderBy(this.listchat[1], 'timestamp', 'desc');
      this.listchat = LeftSideMobileTest__.union(listpin, linstunpin);
    },
    socketremove_friend: function socketremove_friend(data) {
      // console.log(data)
      var index = LeftSideMobileTest__.findIndex(this.listfriend, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (index >= 0) {
        this.listfriend.splice(index, 1);
      }
      var indexchat = LeftSideMobileTest__.findIndex(this.listchat, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (indexchat >= 0) {
        this.listchat[indexchat].state = 'unfriend';
      }
    },
    socketfriend: function socketfriend(data) {
      var _this9 = this;

      // console.log(data)
      // console.log(process.env.APImanage + '/getuser', {owner: this.token, tokenuser: data.tokenfriend})
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', { owner: this.tokenuser, tokenuser: data.tokenfriend }).then(function (response) {
        // var _ = require('lodash')
        if (data.konAdd !== _this9.tokenuser) {
          // update Friend request
          if (LeftSideMobileTest__.find(_this9.FriendReq, function (o) {
            return o.tokenuser === response.data.user[0].tokenuser;
          }) === undefined) {
            _this9.FriendReq.unshift({
              email: response.data.user[0].email,
              name: response.data.user[0].name,
              phone: response.data.user[0].phone,
              profilepicture: response.data.user[0].profilepicture,
              state: response.data.user[0].state,
              status: response.data.user[0].status,
              tokenuser: response.data.user[0].tokenuser,
              type: response.data.user[0].type
            });
            _this9.FriendReq = LeftSideMobileTest__.orderBy(_this9.FriendReq, ['name'], ['asc']).reverse();
            _this9.num_friendreq = _this9.FriendReq.length;
          }
        } else {
          if (LeftSideMobileTest__.find(_this9.FriendSendReq, function (o) {
            return o.tokenuser === response.data.user[0].tokenuser;
          }) === undefined) {
            _this9.FriendSendReq.unshift({
              email: response.data.user[0].email,
              name: response.data.user[0].name,
              phone: response.data.user[0].phone,
              profilepicture: response.data.user[0].profilepicture,
              state: response.data.user[0].state,
              status: response.data.user[0].status,
              tokenuser: response.data.user[0].tokenuser,
              type: response.data.user[0].type
            });
            _this9.FriendSendReq = LeftSideMobileTest__.orderBy(_this9.FriendSendReq, ['name'], ['asc']).reverse();
            _this9.num_friendsendreq = _this9.FriendSendReq.length;
          }
        }
      });
    },
    socketcreate_group: function socketcreate_group(data) {
      var _this10 = this;

      if (data.fromtokenuser !== this.tokenuser) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', { group_id: data.groupid, tokenuser: data.fromtokenuser }).then(function (response) {
          // console.log(response.data)
          // var _ = require('lodash')
          if (LeftSideMobileTest__.find(_this10.GroupReq, function (o) {
            return o.group_id === response.data.group.group_id;
          }) === undefined) {
            _this10.GroupReq.unshift({
              create_date: response.data.group.create_date,
              group_id: response.data.group.group_id,
              member: response.data.group.member,
              name: response.data.group.name,
              picture: response.data.group.picture,
              state: response.data.group.state,
              tokenroom: response.data.group.tokenroom,
              type: response.data.group.type,
              status: response.data.group.status,
              tokenuser: response.data.group.tokenuser,
              timestamp: response.data.group.create_date,
              count_read: '',
              nickname: ''
            });
            _this10.GroupReq = LeftSideMobileTest__.orderBy(_this10.GroupReq, ['create_date'], ['asc']);
            _this10.num_groupreq = _this10.GroupReq.length;
          }
        });
      }
    },
    '$route.params.roomid': function $routeParamsRoomid() {
      this.actionF = this.$route.params.roomid;
    }
  },
  methods: {
    openloa: function openloa() {
      var _this11 = this;

      var url = "https://testoneid.inet.co.th/login?redirect_url=https://testoneid.inet.co.th/portal_level&shared_token=";
      var body = {
        "tokenuser": this.tokenuser,
        "url": url
      };
      this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", body).then(function (response) {
        // window.open(url + response.data.data.accesstoken, '_blank')
        _this11.checkBrowser(url + response.data.data.accesstoken);
      });
    },
    changeLangMenu: function changeLangMenu() {
      this.listother = [{
        title: this.$t('HeaderMenubar.languages'),
        icon: 'fas fa-globe',
        dialog: '/mobile/settings/languages'
      }, {
        title: this.$t('HeaderMenubar.feedback'),
        icon: 'feedback',
        dialog: '/mobile/settings/feedback'
      }, {
        title: this.$t('HeaderMenubar.support'),
        icon: 'contact_support',
        dialog: '/mobile/settings/support'
      }, {
        title: this.$t('HeaderMenubar.policy'),
        icon: 'book',
        dialog: '/mobile/settings/policy'
      }, {
        title: this.$t('HeaderMenubar.terms_of_service'),
        icon: 'book',
        dialog: '/mobile/settings/terms_of_service'
      }];
      this.listsetting = [{
        title: this.$t('HeaderMenubar.editProfile'),
        icon: 'person',
        dialog: '/mobile/settings/profile'
      }, {
        title: this.$t('HeaderMenubar.managefriend'),
        icon: 'group',
        dialog: '/mobile/settings/managefriend'
        // {
        //   title: this.$t('HeaderMenubar.loa'),
        //   icon: 'fas fa-user-shield',
        //   dialog: ''
        // }
      }];
      this.listmenufriend = [{
        title: this.$t('LeftSide.header.qrcode'),
        icon: 'fas fa-qrcode',
        path: '/mobile/qrcode'
      }, {
        title: this.$t('LeftSide.addFiend.header'),
        icon: 'fas fa-user',
        path: '/mobile/addfriend'
      }, {
        title: this.$t('LeftSide.createGroup.header'),
        icon: 'fas fa-users',
        path: '/mobile/creategroup'
      }, {
        title: this.$t('LeftSide.header.project'),
        icon: 'fas fa-tasks',
        path: '/mobile/task/project'
      }, {
        title: this.$t('LeftSide.header.calendar'),
        icon: 'fas fa-calendar',
        path: '/mobile/task/calendar'
      }];
      this.listmenuchat = [{
        title: this.$t('LeftSide.header.qrcode'),
        icon: 'fas fa-qrcode',
        path: '/mobile/qrcode'
      }, {
        title: this.$t('LeftSide.addFiend.header'),
        icon: 'fas fa-user',
        path: '/mobile/addfriend'
      }, {
        title: this.$t('LeftSide.createGroup.header'),
        icon: 'fas fa-users',
        path: '/mobile/creategroup'
      }];
    },
    getlistpending: function getlistpending() {
      var _this12 = this;

      // this.axios.post(process.env.APImanage + '/web/getlistrequestfriend', {tokenuser: this.tokenuser}).then((response) => {
      //   this.FriendReq = response.data['listrequestfriend']
      //   this.num_friendreq = response.data['listrequestfriend'].length
      // })
      // this.axios.post(process.env.APImanage + '/web/getlistpendingfriend', {tokenuser: this.tokenuser}).then((response) => {
      //   this.FriendSendReq = response.data['listpendingfriend']
      //   this.num_friendsendreq = response.data['listpendingfriend'].length
      // })
      // this.axios.post(process.env.APImanage + '/web/getlistpendinggroup', {tokenuser: this.tokenuser}).then((response) => {
      //   this.GroupReq = response.data['listpendinggroup']
      //   this.num_groupreq = response.data['listpendinggroup'].length
      // })
      // if (this.num_groupreq || this.num_friendsendreq || this.num_friendreq !== 0) {
      //   this.show = true
      // } else {
      //   this.show = false
      // }

      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-pending', { tokenuser: this.tokenuser }).then(function (response) {
        _this12.FriendSendReq = response.data['list_send_request_friend'];
        _this12.FriendReq = response.data['list_request_friend'];
        _this12.GroupReq = response.data['list_pending_group'];

        _this12.num_friendreq = response.data['list_request_friend'].length;
        _this12.num_groupreq = response.data['list_pending_group'].length;
        _this12.num_friendsendreq = response.data['list_send_request_friend'].length;

        if (_this12.num_groupreq || _this12.num_friendsendreq || _this12.num_friendreq !== 0) {
          _this12.show = true;
        } else {
          _this12.show = false;
        }
      });
    },
    closeCheckBrowser: function closeCheckBrowser(value) {
      this.checkBrowserDialog = value;
      this.checkBrowserInfor = {};
    },
    getOneid: function getOneid() {
      var _this13 = this;

      this.axios.get("https://uatchat-manage.one.th/go_api/api" + '/v1/getOneID/' + this.tokenuser).then(function (response) {
        // console.log(response.data.one_id)
        _this13.one_id = response.data.one_id;
      }, function () {
        console.log('error');
      });
    },
    changepathservice: function changepathservice(path, type) {
      var _this14 = this;

      // console.log('type' + type)
      if (type == 'link') {
        window.open(path);
      } else if (type == 'route') {
        this.toPage(path);
      } else if (type == 'function_news') {
        // console.log('test')
        // console.log(Momenttime.momenttimestamp())
        var test = {
          one_id: this.one_id,
          createdDate: services["c" /* Momenttime */].momentCreateDate()
        };
        this.encodeToken_News = services["b" /* Encode */].encodeAuthen_news(test);
        window.open(path + this.encodeToken_News);
      } else if (type === 'share_token_onebox') {
        this.axios.post("https://uatchat-manage.one.th/message" + '/api/v1/get_encode_shared_token', {
          user_id: this.one_id
        }).then(function (response) {
          // console.log(response.data.data.encode_shared_token)
          var url = "https://uatbox.one.th/loginbysharetoken?token=" + response.data.data.encode_shared_token;
          _this14.checkBrowser(url);
        });
      }
    },
    checkBrowser: function checkBrowser(url) {
      // console.log(url)
      // console.log('check browser')
      // Get the user-agent string
      var userAgentString = navigator.userAgent;
      // Detect Chrome
      var chromeAgent = userAgentString.indexOf("Chrome") > -1;
      // Detect Internet Explorer
      var IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
      // Detect Firefox
      var firefoxAgent = userAgentString.indexOf("Firefox") > -1;
      // Detect Safari
      var safariAgent = userAgentString.indexOf("Safari") > -1;
      // Discard Safari since it also matches Chrome
      var operaAgent = userAgentString.indexOf("OP") > -1;
      // console.log('firefox = > ' + firefoxAgent)
      // console.log('ie = > ' + IExplorerAgent)
      // console.log('chrome = > ' + chromeAgent)
      // console.log('opera = > ' + operaAgent)
      // console.log('safari = > ' + safariAgent)
      if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
        this.checkBrowserInfor = {
          url: url,
          payload: ''
        };
        this.checkBrowserDialog = true;
      } else if (safariAgent === true && chromeAgent === true) {
        window.open(url, '_blank');
      } else if (safariAgent === true) {
        this.checkBrowserInfor = {
          url: url,
          payload: ''
        };
        this.checkBrowserDialog = true;
      } else {
        window.open(url, '_blank');
      }
    },
    convertMention: function convertMention(msg) {
      msg = msg.replace(/\<tax>/g, '<span style="color:#1976d2;">@');
      msg = msg.replace(/<\/tax>/g, '</span>');
      // console.log(msg)
      return msg;
    },
    logout: function logout() {
      this.$cookie.delete('tokenuser');
      this.$cookie.delete('status_login');
      localStorage.clear();
      // this.$router.push({
      //   path: '/login',
      //   force: true
      // })
      // console.log(`logout mo: ${this.$cookie.get('logouturl')}`)
      // if (process.env.LogoutOneid) {
      //   window.open(process.env.LogoutOneid, '_parent')
      // } else {
      //   this.$router.push({path: '/login', force: true})
      // }
      var logouturl = this.$cookie.get('logouturl');
      if (true) {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent');
          this.$cookie.delete('logouturl');
        } else {
          window.open("https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage", '_parent');
        }
      } else {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent');
          this.$cookie.delete('logouturl');
        } else {
          this.$router.push({ path: '/login', force: true });
        }
      }
    },
    dialog_alert: function dialog_alert(item) {
      this.show_alert = false;
      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        text: item.message,
        type: 'warning',
        showCloseButton: true,
        reverseButtons: true,
        confirmButtonText: 'ตกลง'
      });
    },
    getlistalert: function getlistalert() {
      var _this15 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getlistannounce', {}).then(function (response) {
        _this15.list_alert = response.data.list_announce;
        _this15.num_listalert = _this15.lengthstateactive(_this15.list_alert);
        _this15.show_alert = true;
      });
    },
    lengthstateactive: function lengthstateactive(list) {
      return LeftSideMobileTest__.filter(list, function (list) {
        return list.state === 'true';
      }).length;
    },
    RightClickDialog: function RightClickDialog($event, list, item) {
      // console.log(list)
      // console.log(item)
      this.ListMenuRightClick = [];
      if (item.state == 'active') {
        if (list.includes("pinchat")) {
          if (item.pin == "false") {
            this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.pinChat'), methods: 'pinchat' });
          } else if (item.pin == "true") {
            this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.unpinChat'), methods: 'unpinchat' });
          }
        }
        this.rightclickdialog = true;
        this.$refs.menu.open($event);
        this.SelectedMessageDetail = item;
      }
    },
    SelectMenuRightClick: function SelectMenuRightClick(selected) {
      // console.log(selected)
      if (selected == 'pinchat') {
        this.pin_chat();
      } else if (selected == 'unpinchat') {
        this.unpin_chat();
      }
    },
    pin_chat: function pin_chat() {
      var _this16 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', {
        tokenuser: this.tokenuser,
        tokenroom: this.SelectedMessageDetail.tokenroom,
        pin: 'true'
      }).then(function (response) {
        if (response.data.status === 'success') {
          // pinchat
          var tokenroom = _this16.SelectedMessageDetail.tokenroom;
          var index = '';
          index = LeftSideMobileTest__.findIndex(_this16.listchat, function (o) {
            return o.tokenroom == tokenroom;
          });
          _this16.listchat[index].pin = 'true';
          var listpin = [];
          var linstunpin = [];
          _this16.listchat = LeftSideMobileTest__.partition(_this16.listchat, function (o) {
            return o.pin == 'true';
          });
          listpin = LeftSideMobileTest__.orderBy(_this16.listchat[0], 'timestamp', 'desc');
          linstunpin = LeftSideMobileTest__.orderBy(_this16.listchat[1], 'timestamp', 'desc');
          _this16.listchat = LeftSideMobileTest__.union(listpin, linstunpin);
          // console.log(this.listchat)
        }
      }, function () {
        console.log('error');
      });
    },
    unpin_chat: function unpin_chat() {
      var _this17 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', {
        tokenuser: this.tokenuser,
        tokenroom: this.SelectedMessageDetail.tokenroom,
        pin: 'false'
      }).then(function (response) {
        if (response.data.status === 'success') {
          // pinchat
          var tokenroom = _this17.SelectedMessageDetail.tokenroom;
          var index = '';
          index = LeftSideMobileTest__.findIndex(_this17.listchat, function (o) {
            return o.tokenroom == tokenroom;
          });
          _this17.listchat[index].pin = 'false';
          var listpin = [];
          var linstunpin = [];
          _this17.listchat = LeftSideMobileTest__.partition(_this17.listchat, function (o) {
            return o.pin == 'true';
          });
          listpin = LeftSideMobileTest__.orderBy(_this17.listchat[0], 'timestamp', 'desc');
          linstunpin = LeftSideMobileTest__.orderBy(_this17.listchat[1], 'timestamp', 'desc');
          _this17.listchat = LeftSideMobileTest__.union(listpin, linstunpin);
          // console.log(this.listchat)
        }
      }, function () {
        console.log('error');
      });
    },
    secondsToHms: function secondsToHms(d) {
      d = Number(d);
      var hours = Math.floor(d / 3600);
      var minutes = Math.floor((d - hours * 3600) / 60);
      var seconds = d - hours * 3600 - minutes * 60;
      var time = '';

      if (hours !== 0) {
        time = hours + ':';
      }
      if (minutes !== 0 || time !== '') {
        minutes = minutes < 10 && time !== '' ? '0' + minutes : String(minutes);
        time += minutes + ':';
      }
      if (time === '') {
        time = seconds + ' วินาที';
      } else {
        time += seconds < 10 ? '0' + seconds : String(seconds);
      }
      return time;
    },
    blockevent: function blockevent(data) {
      var _this18 = this;

      // console.log(data)
      if (data.event === 'block_friend') {
        var indexmsg = LeftSideMobileTest__.findIndex(this.listchat, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        this.listchat[indexmsg].timestamp = data.timestamp;
        this.listchat[indexmsg].state = 'block';
        // this.listchat = _.orderBy(this.listchat, ['timestamp'], ['asc']).reverse()
        // indexmsg = _.findIndex(this.listfriend, function (o) { return o.tokenuser === data.tokenuser })
        // _.pullAt(this.listfriend, indexmsg)
        this.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', { tokenroom: data.tokenroom, tokenuser: this.tokenuser, pin: 'false' }).then(function (response) {
          var listpin = [];
          var linstunpin = [];
          _this18.listchat[indexmsg].pin = 'false';
          _this18.listchat = LeftSideMobileTest__.partition(_this18.listchat, function (o) {
            return o.pin == 'true';
          });
          listpin = LeftSideMobileTest__.orderBy(_this18.listchat[0], 'timestamp', 'desc');
          linstunpin = LeftSideMobileTest__.orderBy(_this18.listchat[1], 'timestamp', 'desc');
          _this18.listchat = LeftSideMobileTest__.union(listpin, linstunpin);
        });
      } else if (data.event === 'unblock_friend') {
        this.listfriend.push(data);
        this.listfriend = LeftSideMobileTest__.orderBy(this.listfriend, ['name'], ['asc']);
        indexmsg = LeftSideMobileTest__.findIndex(this.listchat, function (o) {
          return o.tokenroom === data.tokenroom;
        });
        this.listchat[indexmsg].state = 'active';
        this.listchat[indexmsg].nickname = '';
      }
    },
    AcceptReq_FriendReq: function AcceptReq_FriendReq(item) {
      var _this19 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/accept-friend", { tokenfriend: item.tokenuser, tokenuser: this.tokenuser }).then(function (response) {
        if (response.data.status === 'success') {
          _this19.FriendReq.splice(LeftSideMobileTest__.findIndex(_this19.FriendReq, function (o) {
            return o.tokenuser === item.tokenuser;
          }), 1);
          _this19.$router.push('/mobile/room/' + response.data.tokenroom);
          localStorage.setItem('room', response.data.tokenroom);
          var data = response.data.source;
          data['tokenroom'] = response.data.tokenroom;
        } else {
          // this.$swal('', 'ไม่สามารถตอบรับเพื่อนได้ กรุณาลองใหม่ภายหลัง', 'warnning')
          _this19.$swal('', _this19.$t('Alert.Fail.default.somethingWrong'), 'warning');
        }
      });
    },
    RemoveReq_FriendReq: function RemoveReq_FriendReq(item) {
      var _this20 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', { tokenfriend: item.tokenuser, tokenuser: this.tokenuser }).then(function (response) {
        if (response.data.status === 'success') {
          _this20.FriendReq.splice(LeftSideMobileTest__.findIndex(_this20.FriendReq, function (o) {
            return o.tokenuser === item.tokenuser;
          }), 1);
          _this20.num_friendreq = _this20.FriendReq.length;
          // localStorage.setItem('FriendReq', Friend)
        }
      });
    },
    RemoveReq_FriendSendReq: function RemoveReq_FriendSendReq(item) {
      var _this21 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', { tokenfriend: item.tokenuser, tokenuser: this.tokenuser }).then(function (response) {
        if (response.data.status === 'success') {
          _this21.FriendSendReq.splice(LeftSideMobileTest__.findIndex(_this21.FriendSendReq, function (o) {
            return o.tokenuser === item.tokenuser;
          }), 1);
          _this21.num_friendsendreq = _this21.FriendSendReq.length;
        }
      });
    },
    AcceptReq_GroupReq: function AcceptReq_GroupReq(group) {
      var _this22 = this;

      // process.env.APImanage + '/activeinvitegroup'
      // process.env.APIgo_api + '/v1/accept-group'
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/accept-group', { group_id: group.group_id, tokenuser: this.tokenuser }).then(function (response) {
        // console.log(response)
        if (response.data.status === 'success') {
          var tokenuser = _this22.tokenuser;
          var indexgroup = LeftSideMobileTest__.findIndex(response.data.group.member, function (o) {
            return o.tokenuser === tokenuser;
          });
          if (indexgroup >= 0) {
            _this22.socketactive_group = { timestamp: response.data.group.member[indexgroup].timestamp_in, groupid: group.group_id, tokenuser: _this22.token };
          } else {
            _this22.socketactive_group = { timestamp: '', groupid: group.group_id, tokenuser: _this22.token };
          }
        }
      });
    },
    RemoveReq_GroupReq: function RemoveReq_GroupReq(group) {
      var _this23 = this;

      // console.log(group)
      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        text: this.$t('Alert.Group.cancelGroup', { name: group.name }),
        type: 'warning',
        // imageUrl: '../assets/image/block.png',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this23.axios.post("https://uatchat-manage.one.th/manage" + '/cancelinvitegroup', { group_id: group.group_id, tokenuser: _this23.tokenuser }).then(function (response) {
            if (response.data.status === 'success') {
              // console.log(response.data)
              _this23.$swal('', _this23.$t('Alert.Success.success'), 'success');
              // this.socketcencel_group = group.group_id
              // console.log(this.socketcencel_group)
              // this.GroupReq.splice(this.GroupReq.indexOf(group), 1) // ลบ GroupReq ตอนยกเลิกเข้ากลุ่ม
              // this.$store.dispatch('groupReq', 'groupremove' + group)
            } else {
              _this23.$swal('', _this23.$t('Alert.Fail.default.somethingWrong'), 'warning');
            }
          });
        }
      });
    },
    updatelistreq: function updatelistreq(data) {
      // console.log(data)
      if (data.event === 'accept') {
        this.FriendReq.splice(LeftSideMobileTest__.findIndex(this.FriendReq, function (o) {
          return o.tokenuser === data.tokenuser;
        }), 1);
        if (LeftSideMobileTest__.find(this.listfriend, function (o) {
          return o.tokenuser === data.tokenuser;
        }) === undefined) {
          this.listfriend.unshift({
            email: data.email,
            name: data.name,
            // phone: data.phone,
            profilepicture: data.profilepicture,
            state: data.state,
            status: data.status,
            tokenuser: data.tokenuser,
            type: data.type,
            tokenroom: data.tokenroom
          });
          this.listfriend = LeftSideMobileTest__.orderBy(this.listfriend, ['name'], ['asc']);
        }
        if (LeftSideMobileTest__.find(this.listchat, function (o) {
          return o.tokenuser === data.tokenuser;
        }) === undefined) {
          // console.log('listchat')
          this.listchat.unshift({
            email: data.email,
            name: data.name,
            // phone: response.data.user[0].phone,
            is_active: 'true',
            profilepicture: data.profilepicture,
            state: data.state,
            status: data.status,
            tokenuser: data.tokenuser,
            type: data.type,
            tokenroom: data.tokenroom,
            nickname: '',
            timestamp: data.timestamp,
            count_read: ''
          });
        }
      } else if (data.event === 'removeReq') {
        this.FriendSendReq.splice(LeftSideMobileTest__.findIndex(this.FriendSendReq, function (o) {
          return o.tokenuser === data.tokenuser;
        }), 1);
      }
    },
    updatecreategroup: function updatecreategroup(data, filename) {
      if (LeftSideMobileTest__.find(this.listgroup, function (o) {
        return o.group_id === data.group_id;
      }) === undefined) {
        this.listgroup.unshift({
          count_read: '',
          create_date: data.create_date,
          group_id: data.group_id,
          member: data.member,
          name: data.name,
          picture: filename,
          state: data.state,
          timestamp: data.timestamp,
          tokenroom: data.tokenroom,
          type: data.type
        });
        this.listgroup = LeftSideMobileTest__.orderBy(this.listgroup, ['name'], ['asc']);
      }
    },
    updatelistchat: function updatelistchat(data, filename) {
      // console.log('data')
      if (LeftSideMobileTest__.find(this.listchat, function (o) {
        return o.group_id === data.group_id;
      }) === undefined) {
        this.listchat.unshift({
          count_read: '',
          create_date: data.create_date,
          group_id: data.group_id,
          member: data.member,
          name: data.name,
          nickname: '',
          picture: filename,
          state: data.state,
          timestamp: data.create_date,
          tokenroom: data.tokenroom,
          type: data.type
        });
      }
    },
    toTab: function toTab(tab) {
      if (tab === 1) {
        this.tabs = 'tab-1';
        // console.log(this.tabs)
      } else if (tab === 2) {
        this.tabs = 'tab-2';
        // console.log(this.tabs)
      } else if (tab === 3) {
        this.tabs = 'tab-3';
        // console.log(this.tabs)
      }
    },
    toPage: function toPage(data) {
      this.$router.push(data);
    },
    time: function time(timestamp) {
      if (this.$i18n.locale == 'th') {
        return services["c" /* Momenttime */].momenttimethaiformnow(timestamp);
      } else if (this.$i18n.locale == 'cn') {
        return services["c" /* Momenttime */].momenttimethaiformnowcn(timestamp);
      } else {
        return services["c" /* Momenttime */].momenttimethaiformnowen(timestamp);
      }
      // return Momenttime.momenttimethaiformnow(timestamp)
    },
    routeChat: function routeChat(data) {
      // console.log(data.tokenroom)
      this.actionF = data.tokenroom;
      this.$router.push('/mobile/room/' + data.tokenroom);
      this.$emit('data', true);
      var indexmsg = LeftSideMobileTest__.findIndex(this.listchat, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      this.listchat[indexmsg].is_active = 'true';
      this.listchat[indexmsg].count_read = 0;
      this.mark_read(data);
    },
    mark_read: function mark_read(data) {
      // console.log(data)
      if (data.count_read !== '0' && data.count_read !== '') {
        this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/user-mark-read', { tokenuser: this.tokenuser, tokenroom: data.tokenroom }).then(function (response) {
          // console.log(response.data)
        });
      }
    },
    getlistfriend: function getlistfriend() {
      var _this24 = this;

      this.ProgressListFriend = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-friend', { tokenuser: this.tokenuser }).then(function (response) {
        if (response.data.status === 'success') {
          _this24.ProgressListFriend = false;
          _this24.listfriend = response.data['list_friend'];
          // console.log(this.listfriend)
        } else {
          _this24.ProgressListFriend = false;
        }
      });
    },
    getlistgroup: function getlistgroup() {
      var _this25 = this;

      this.ProgressListGroup = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-group', { tokenuser: this.tokenuser }).then(function (response) {
        if (response.data.status === 'success') {
          _this25.ProgressListGroup = false;
          _this25.listgroup = response.data['list_active_group'];
        } else {
          _this25.ProgressListGroup = false;
        }
      });
    },
    getlistchat: function getlistchat() {
      var _this26 = this;

      this.ProgressListChat = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api/v4/getListChat", { tokenuser: this.tokenuser }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this26.ProgressListChat = false;
          _this26.listchat = response.data['listchat'];
          // pinchat
          var listpin = [];
          var linstunpin = [];
          _this26.listchat = LeftSideMobileTest__.partition(_this26.listchat, function (o) {
            return o.pin == 'true';
          });
          listpin = LeftSideMobileTest__.orderBy(_this26.listchat[0], 'timestamp', 'desc');
          linstunpin = LeftSideMobileTest__.orderBy(_this26.listchat[1], 'timestamp', 'desc');
          _this26.listchat = LeftSideMobileTest__.union(listpin, linstunpin);
          // num_countread
          var indexblock = [];
          var indexmessage = [];
          var indexactive = [];
          indexmessage = LeftSideMobileTest__.filter(_this26.listchat, function (listchat) {
            return listchat.message === '';
          });
          indexblock = LeftSideMobileTest__.filter(_this26.listchat, function (listchat) {
            return listchat.state !== 'active';
          });
          indexactive = LeftSideMobileTest__.filter(_this26.listchat, function (listchat) {
            return listchat.is_active !== 'true';
          });
          var countmsg = LeftSideMobileTest__.sumBy(indexmessage, function (o) {
            return parseInt(o.count_read);
          });
          var countblock = LeftSideMobileTest__.sumBy(indexblock, function (o) {
            return parseInt(o.count_read);
          });
          var countactive = LeftSideMobileTest__.sumBy(indexactive, function (o) {
            return parseInt(o.count_read);
          });
          var count = LeftSideMobileTest__.sumBy(_this26.listchat, function (o) {
            return parseInt(o.count_read);
          });
          _this26.num_countread = count - (countblock + countmsg + countactive);
          if (_this26.num_countread > 0) {
            _this26.showcountread = true;
          } else {
            _this26.showcountread = false;
          }
        } else {
          _this26.ProgressListChat = false;
        }
        // check consent onechat
        // เปลี่ยนไปเช็คที่ layout แทน
        // this.check_consent(this.tokenuser)
      });
    },
    closeDialogConsentOnechat: function closeDialogConsentOnechat(value) {
      this.consentOnechatDialog = value;
    },
    check_consent: function check_consent(token) {
      var _this27 = this;

      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var hour = String(today.getHours() + 1).padStart(2, '0');
      var minute = String(today.getMinutes()).padStart(2, '0');
      var seconds = String(today.getSeconds()).padStart(2, '0');
      var milsec = today.getMilliseconds();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00';
        dd = String(today.getDate() + 1).padStart(2, '0');
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1';
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1';
            yyyy = today.getFullYear() + 1;
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0');
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
      // console.log(today)
      var expireddate = Date.parse(today);
      // console.log(expireddate)
      var body = services["b" /* Encode */].encodeRichmenu({ 'userid': token, 'expired_date': expireddate });
      // console.log(body)
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-consent', { onechat_token: body }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          if (response.data.data.consent_check === 'false') {
            _this27.consentOnechatDialog = true;
            _this27.url_consent = response.data.data.consent_url;
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    lengthactive: function lengthactive(member, key) {
      var num = 0;
      for (var i = 0; i < member.length; i += 1) {
        if (member[i][key] === 'active') {
          num = num + 1;
        }
      }
      return num;
    },
    showUserInGroup: function showUserInGroup(item) {
      // console.log(item)
      this.showgroup = item;
      this.showDialog('ShowFriend');
    },
    showDialog: function showDialog(dialog) {
      if (dialog === 'ShowFriend') {
        this.ShowFriend = true;
      }
    },
    closeDialogShowFriend: function closeDialogShowFriend(value) {
      this.ShowFriend = value;
    },
    findWithAttr: function findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49ea556e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/layout/LeftSideMobileTest.vue
var LeftSideMobileTest_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%","overflow-y":"hidden !important"}},[_c('div',{staticClass:"leftbox",staticStyle:{"overflow-y":"hidden !important"}},[_c('v-tabs',{staticStyle:{"position":"fixed","bottom":"0","width":"100%","z-index":"1"},attrs:{"slot":"extension","fixed-tabs":"","color":"#2562af","icons-and-text":"","centered":""},slot:"extension",model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('v-tabs-slider'),_vm._v(" "),_c('v-tab',{key:1,attrs:{"href":"#tab-1"},on:{"click":function($event){_vm.toTab(1)}}},[_c('span',{staticStyle:{"color":"white","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('LeftSide.header.homepage')))]),_vm._v(" "),((_vm.num_groupreq + _vm.num_friendsendreq + _vm.num_friendreq) !== 0)?_c('v-badge',{attrs:{"color":"red"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.num_groupreq + _vm.num_friendsendreq + _vm.num_friendreq))]),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"22px !important","color":"#ffffff !important"}},[_vm._v("home")])],1):_c('v-icon',{staticStyle:{"font-size":"22px !important","color":"#ffffff !important"}},[_vm._v("home")])],1),_vm._v(" "),_c('v-tab',{key:2,attrs:{"href":"#tab-2"},on:{"click":function($event){_vm.toTab(2)}}},[_c('span',{staticStyle:{"color":"white","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('LeftSide.header.chat')))]),_vm._v(" "),(_vm.num_countread > 0)?_c('v-badge',{attrs:{"color":"red"},model:{value:(_vm.showcountread),callback:function ($$v) {_vm.showcountread=$$v},expression:"showcountread"}},[(_vm.num_countread >= 1000)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v("999+")]):_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.num_countread))]),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"22px !important","color":"#ffffff !important"}},[_vm._v("chat")])],1):_c('v-icon',{staticStyle:{"font-size":"22px !important","color":"#ffffff !important"}},[_vm._v("chat")])],1),_vm._v(" "),_c('v-tab',{key:3,attrs:{"href":"#tab-3"},on:{"click":function($event){_vm.toTab(3)}}},[_c('span',{staticStyle:{"color":"white","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('LeftSide.header.setting')))]),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"22px !important","color":"#ffffff !important"}},[_vm._v("settings")])],1)],1),_vm._v(" "),_c('v-tabs-items',{staticClass:"white elevation-1",model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('v-tab-item',{staticStyle:{"height":"100vh"},attrs:{"id":"tab-1"}},[_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"padding-top":"0px"},attrs:{"dense":""}},[_c('v-container',{staticClass:"layoutsearchweb"},[_c('v-layout',{staticClass:"layoutsearchweb",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('h2',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.$t('LeftSide.header.homepage')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.num_listalert != 0)?_c('v-badge',{attrs:{"color":"red","overlap":""},model:{value:(_vm.show_alert),callback:function ($$v) {_vm.show_alert=$$v},expression:"show_alert"}},[(_vm.num_listalert < 100)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.num_listalert))]):_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v("99+")]),_vm._v(" "),_c('v-menu',{attrs:{"offset-x":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","fab":"","medium":""},slot:"activator"},[_c('v-icon',{staticStyle:{"color":"#848383"}},[_vm._v("mdi-bell-ring-outline")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.list_alert),function(item){return _c('v-list-tile',{key:item.announce_id,staticStyle:{"width":"140px !important"}},[(item.state == 'true')?_c('v-list-tile-title',{on:{"click":function($event){_vm.dialog_alert(item)}}},[_c('v-icon',[_vm._v("mdi-bell-ring-outline")]),_vm._v(" "),_c('span',{staticClass:"text-span"},[_vm._v(_vm._s(item.message))])],1):(item.state == 'false')?_c('v-list-tile-title',[_c('v-icon',{staticStyle:{"color":"#aeb5bb !important"}},[_vm._v("mdi-bell-off-outline")]),_vm._v(" "),_c('span',{staticClass:"text-span-dis"},[_vm._v(_vm._s(item.message))])],1):_vm._e()],1)}))],1)],1):_c('v-menu',{attrs:{"offset-x":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","fab":"","medium":""},slot:"activator"},[_c('v-icon',{staticStyle:{"color":"#848383"}},[_vm._v("mdi-bell-ring-outline")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.list_alert),function(item){return _c('v-list-tile',{key:item.announce_id,staticStyle:{"width":"140px !important"}},[(item.state == 'true')?_c('v-list-tile-title',{on:{"click":function($event){_vm.dialog_alert(item)}}},[_c('v-icon',[_vm._v("mdi-bell-ring-outline")]),_vm._v(" "),_c('span',{staticClass:"text-span"},[_vm._v(_vm._s(item.message))])],1):(item.state == 'false')?_c('v-list-tile-title',[_c('v-icon',{staticStyle:{"color":"#aeb5bb !important"}},[_vm._v("mdi-bell-off-outline")]),_vm._v(" "),_c('span',{staticClass:"text-span-dis"},[_vm._v(_vm._s(item.message))])],1):_vm._e()],1)}))],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","md2":"","sm2":"","lg2":"","xl2":""}},[_c('v-avatar',{attrs:{"slot":"activator","size":"50px"},slot:"activator"},[(_vm.profilepicture !== '')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.profilepicture}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","md10":"","sm10":"","lg10":"","xl10":""}},[_c('v-layout',{staticClass:"ml-3",attrs:{"column":"","wrap":""}},[_c('h4',{staticStyle:{"text-overflow":"ellipsis","width":"200px","white-space":"nowrap","overflow":"hidden"}},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('span',{staticStyle:{"text-overflow":"ellipsis","width":"200px","white-space":"nowrap","overflow":"hidden"}},[_vm._v(_vm._s(_vm.status_user))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-text-field',{staticClass:"bgsearchweb CSChatThai",staticStyle:{"color":"white !important"},attrs:{"append-icon":"search","label":_vm.$t('LeftSide.searching'),"solo":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-layout',{staticClass:"scrolling-wrapper",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},_vm._l((_vm.listmenufriend),function(item,index){return _c('v-flex',{key:index,staticStyle:{"justify-content":"center","align-items":"center","display":"flex"}},[_c('div',[_c('v-btn',{staticStyle:{"background-color":"#2562af29"},attrs:{"fab":"","small":"","outlined":""},on:{"click":function($event){_vm.toPage(item.path)}}},[_c('v-icon',{staticStyle:{"justify-content":"center","display":"flex","font-size":"15px","color":"#2562af"}},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('p',{staticClass:"mb-0",staticStyle:{"justify-content":"center","display":"flex","font-size":"12px"}},[_vm._v(_vm._s(item.title))])],1)])}))],1),_vm._v(" "),_c('v-flex',{staticClass:"scroll-y",style:(_vm.heightlistfriend),attrs:{"xs12":"","xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-content',{staticClass:"expansion_container"},[(_vm.GroupReq.length != 0)?_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.groupInvite'))+" ("+_vm._s(_vm.GroupReq.length)+")")]):_vm._e(),_vm._v(" "),_vm._l((_vm.GroupReq),function(item,index){return (_vm.GroupReq.length != 0)?_c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"#fff !important","width":"100%","cursor":"pointer"},attrs:{"two-line":"","subheader":""}},[_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"},on:{"click":function($event){_vm.showUserInGroup(item)}}},[(item.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.picture}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/group-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"},on:{"click":function($event){_vm.showUserInGroup(item)}}},[_vm._v("\n                                "+_vm._s(item.name)+"\n                              ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat ",on:{"click":function($event){_vm.showUserInGroup(item)}}},[_c('span',{staticClass:"fontselectchat ",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                  "+_vm._s(_vm.$t('LeftSide.friend.haveMember', {count: _vm.lengthactive(item.member, 'statemember')}))+"\n                                ")])]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"CSChatThai"},[_c('v-btn',{staticClass:"btnallow text-transform",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.AcceptReq_GroupReq(item)}}},[_vm._v("\n                                    "+_vm._s(_vm.$t('AnswerQuestion.joinGroup'))+"\n                                  ")]),_vm._v(" "),_c('v-btn',{staticClass:"btncancel text-transform",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.RemoveReq_GroupReq(item)}}},[_vm._v("\n                                    "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                                  ")])],1)],1)],1)],1),_vm._v(" "),(index + 1 < _vm.GroupReq.length)?_c('v-divider',{key:("divider-" + index)}):_vm._e()],1):_vm._e()})],2)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',{staticClass:"expansion_container"},[(_vm.FriendSendReq.length != 0)?_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.sendFriendInvite'))+" ("+_vm._s(_vm.FriendSendReq.length)+")")]):_vm._e(),_vm._v(" "),(_vm.FriendSendReq.length != 0)?_c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"#fff !important","width":"100%"},attrs:{"two-line":"","subheader":""}},[_vm._l((_vm.FriendSendReq),function(item,index){return [_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"}},[_vm._v("\n                                "+_vm._s(item.name)+"\n                              ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat "},[_c('span',{staticClass:"fontselectchat ",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                  "+_vm._s(_vm.$t('LeftSide.friend.waitingRequestFriend'))+"\n                                ")])]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"CSChatThai"},[_c('v-btn',{staticClass:"btncancel text-transform",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.RemoveReq_FriendSendReq(item)}}},[_vm._v("\n                                   "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                                ")])],1)],1)],1)],1),_vm._v(" "),(index + 1 < _vm.FriendSendReq.length)?_c('v-divider',{key:("divider-" + index)}):_vm._e()]})],2):_vm._e()],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',{staticClass:"expansion_container"},[(_vm.FriendReq.length != 0)?_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.friendInvite'))+" ("+_vm._s(_vm.FriendReq.length)+")")]):_vm._e(),_vm._v(" "),(_vm.FriendReq.length != 0)?_c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"#fff !important","width":"100%"},attrs:{"two-line":"","subheader":""}},[_vm._l((_vm.FriendReq),function(item,index){return [_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"15px"}},[_vm._v("\n                                "+_vm._s(item.name)+"\n                              ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat "},[_c('span',{staticClass:"fontselectchat ",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                  "+_vm._s(_vm.$t('LeftSide.friend.wantToBeFriend'))+"\n                                ")])]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"CSChatThai"},[_c('v-btn',{staticClass:"btnallow text-transform",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.AcceptReq_FriendReq(item)}}},[_vm._v("\n                                  "+_vm._s(_vm.$t('AnswerQuestion.acceptFriend'))+"\n                                ")]),_vm._v(" "),_c('v-btn',{staticClass:"btncancel text-transform",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.RemoveReq_FriendReq(item)}}},[_vm._v("\n                                   "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                                ")])],1)],1)],1)],1),_vm._v(" "),(index + 1 < _vm.FriendReq.length)?_c('v-divider',{key:("divider-" + index)}):_vm._e()]})],2):_vm._e()],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',{staticClass:"expansion_container"},[(_vm.FilterFriendList.length != 0)?_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.friend'))+" ("+_vm._s(_vm.FilterFriendList.length)+")")]):_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.friend')))]),_vm._v(" "),(!_vm.ProgressListFriend)?_c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"#fff !important","width":"100%"},attrs:{"subheader":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.toPage('/mobile/addfriend')}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"CSChatThai ",staticStyle:{"font-size":"12px","text-align":"center","color":"black"}},[_c('v-icon',{staticStyle:{"color":"black","font-size":"18px !important"}},[_vm._v("add_circle")]),_vm._v("\n                            "+_vm._s(_vm.$t('LeftSide.friend.addFriend'))+"\n                          ")],1)],1)],1),_vm._v(" "),_vm._l((_vm.FilterFriendList),function(item,index){return (_vm.FilterFriendList.length != 0)?[_c('div',{staticStyle:{"padding-top":"0px","cursor":"pointer"},attrs:{"avatar":""},on:{"click":function($event){_vm.routeChat(item)}}},[(_vm.actionF == item.tokenroom)?_c('v-list-tile',{staticClass:"selectF",attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"}},[_vm._v("\n                                "+_vm._s(item.name)+"\n                              ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat "},[(item.status !== '')?_c('span',{staticClass:"text--primary fontselectchat ",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                  "+_vm._s(item.status)+"\n                                ")]):_vm._e()])],1),_vm._v(" "),(item.type === 'bot')?_c('v-list-tile-action',[_c('v-icon',{staticStyle:{"font-size":"16px !important"},attrs:{"color":"grey lighten-1"}},[_vm._v("fas fa-robot")])],1):_vm._e()],1):_c('v-list-tile',{staticClass:"nonselectF",attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"font-size":"13px","color":"black !important"}},[_vm._v("\n                                "+_vm._s(item.name)+"\n                              ")]),_vm._v(" "),_c('v-list-tile-sub-title',[(item.status !== '')?_c('span',{staticClass:"text--primary  ",staticStyle:{"color":"#7a7a7a !important","font-size":"10px!important"}},[_vm._v("\n                                  "+_vm._s(item.status)+"\n                                ")]):_vm._e()])],1),_vm._v(" "),(item.type === 'bot')?_c('v-list-tile-action',[_c('v-icon',{staticStyle:{"font-size":"16px !important"},attrs:{"color":"grey lighten-1"}},[_vm._v("fas fa-robot")])],1):_vm._e()],1)],1),_vm._v(" "),(index + 1 < _vm.FilterFriendList.length)?_c('v-divider',{key:("divider-" + index)}):_vm._e()]:_vm._e()})],2):_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":_vm.ProgressListFriend}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',{staticClass:"expansion_container"},[(_vm.FilterGroupList.length != 0)?_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.group'))+" ("+_vm._s(_vm.FilterGroupList.length)+")")]):_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.group')))]),_vm._v(" "),(!_vm.ProgressListGroup)?_c('div',{attrs:{"subheader":""}},[_c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"#fff !important","width":"100%","cursor":"pointer"},attrs:{"subheader":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.toPage('/mobile/creategroup')}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"CSChatThai ",staticStyle:{"font-size":"12px","text-align":"center","color":"black"}},[_c('v-icon',{staticStyle:{"color":"black","font-size":"18px !important"}},[_vm._v("add_circle")]),_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.friend.createGroup'))+"\n                            ")],1)],1)],1),_vm._v(" "),_vm._l((_vm.FilterGroupList),function(item,index){return (_vm.FilterGroupList.length != 0)?[_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""},on:{"click":function($event){_vm.routeChat(item)}}},[(_vm.actionF == item.tokenroom)?_c('v-list-tile',{staticClass:"selectF",attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.picture}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/group-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"}},[_vm._v("\n                                  "+_vm._s(item.name)+"\n                                ")])],1)],1):_c('v-list-tile',{staticClass:"nonselectF",attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.picture}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/group-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"font-size":"13px","color":"black !important"}},[_vm._v("\n                                  "+_vm._s(item.name)+"\n                                ")])],1)],1)],1),_vm._v(" "),(index + 1 < _vm.FilterGroupList.length)?_c('v-divider',{key:("divider-" + index)}):_vm._e()]:_vm._e()})],2)],1):_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":_vm.ProgressListGroup}})],1)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"padding-top":"0px !important"},attrs:{"dense":""}},[_c('v-container',{staticClass:"layoutsearchweb"},[_c('v-layout',{staticClass:"layoutsearchweb",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('h2',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.$t('LeftSide.header.chat')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""}},[_c('template',{slot:"activator"},[_c('v-btn',{attrs:{"icon":"","small":""}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("fas fa-plus-circle")])],1)],1),_vm._v(" "),_c('v-list',_vm._l((_vm.listmenuchat),function(item,index){return _c('v-list-tile',{key:index,on:{"click":function($event){_vm.toPage(item.path)}}},[_c('v-list-tile-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-icon',{staticStyle:{"font-size":"15px","color":"#2562af"}},[_vm._v(_vm._s(item.icon))]),_vm._v(" "),_c('span',{staticClass:"ml-3"},[_vm._v(" "+_vm._s(item.title)+" ")])],1)],1)],1)}))],2)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-text-field',{staticClass:"bgsearchweb CSChatThai",attrs:{"append-icon":"search","label":_vm.$t('LeftSide.searching'),"solo":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(!_vm.ProgressListChat)?_c('v-flex',{staticClass:"scroll-y",style:(_vm.heightlistchat),attrs:{"xs12":"","xl12":"","md12":"","sm12":"","lg12":""}},[_c('vue-context',{ref:"menu",staticStyle:{"z-index":"1500"}},_vm._l((_vm.ListMenuRightClick),function(list){return _c('li',[_c('a',{on:{"click":function($event){_vm.SelectMenuRightClick(list.methods)}}},[_vm._v(_vm._s(list.message))])])})),_vm._v(" "),_c('v-list',{staticClass:"backgroundlistchat",attrs:{"two-line":"","subheader":""}},[(_vm.FilterChatList.length === 0)?[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":""}},[_c('h4',[_vm._v(_vm._s(_vm.$t('LeftSide.noDataSearching')))])])]:_vm._l((_vm.FilterChatList),function(item,index){return [(item.is_active == 'true')?_c('div',{key:index,staticStyle:{"padding-top":"0px"},attrs:{"avatar":""},on:{"click":function($event){_vm.routeChat(item)}}},[(_vm.actionF == item.tokenroom)?_c('v-list-tile',{staticClass:"selectF",attrs:{"avatar":""},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['pinchat'], item)}}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.picture}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'group')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/group-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/man-white.png"}}),_vm._v(" "),(item.pin == 'true')?_c('v-badge',{attrs:{"color":"primary"}},[_c('img',{staticClass:"img-pin",staticStyle:{"width":"16px","height":"16px"},attrs:{"slot":"badge","src":"/static/img/icons/pin@3x.png"},slot:"badge"})]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"fontselect"},[_vm._v("\n                            "+_vm._s(item.name)+"\n                          ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat"},[(item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.leftChat'))+"\n                            ")]):(item.typeofmessage === 'message')?_c('span',{staticClass:"fontselectchat text2",staticStyle:{"font-size":"11px!important"},domProps:{"innerHTML":_vm._s(_vm.convertMention(item.message))}}):(item.typeofmessage === 'sticker')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendSticker'))+"\n                            ")]):(item.typeofmessage === 'file' || item.typeofmessage == 'password_file')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                             "+_vm._s(_vm.$t('LeftSide.chat.sendFile'))+"\n                            ")]):(item.typeofmessage === 'location')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendLocation'))+"\n                            ")]):(item.typeofmessage === 'contact')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendContact'))+"\n                            ")]):(item.typeofmessage === 'image')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendPicture'))+"\n                            ")]):(item.typeofmessage === 'note')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendNote'))+"\n                            ")]):(item.typeofmessage === 'video')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendVideo'))+"\n                            ")]):(item.typeofmessage === 'mention_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendReply'))+"\n                            ")]):(item.typeofmessage === 'albums_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.createAlbum'))+"\n                            ")]):(item.typeofmessage === 'task_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.createTask'))+"\n                            ")]):(item.typeofmessage === 'system_action_task')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.createProject'))+"\n                            ")]):(item.typeofmessage === 'unsend_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(item.message)+"\n                            ")]):(item.typeofmessage === 'carousel')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendCarousel'))+"\n                            ")]):(item.typeofmessage === 'conference_msg')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendConference_msg'))+"\n                            ")]):(item.typeofmessage === 'system' || item.typeofmessage === 'template' || item.typeofmessage === 'date' || item.typeofmessage === 'datetime')?_c('span',{staticClass:"fontselectchat text2",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(item.message)+"\n                            ")]):(item.typeofmessage === 'call')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[(item.message === 'success')?_c('div',{staticClass:"text2"},[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone fa-rotate-90")]),_vm._v(" "+_vm._s(_vm.$t('LeftSide.chat.call.time'))+" "+_vm._s(_vm.secondsToHms(item.time_count))+"\n                              ")],1):(item.message === 'decline' && item.tokenuser === _vm.tokenuser)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.noResponse'))+"\n                              ")],1):(item.message === 'decline' && item.tokenuser !== _vm.tokenuser)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                              ")],1):(item.message === 'cancle' && item.tokenuser === _vm.tokenuser)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                              ")],1):(item.message === 'cancle' && item.tokenuser !== _vm.tokenuser)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.missed'))+"\n                              ")],1):(item.message === 'cancel' && item.tokenuser === _vm.tokenuser)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                              ")],1):(item.message === 'cancel' && item.tokenuser !== _vm.tokenuser)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.missed'))+"\n                              ")],1):_vm._e()]):(item.typeofmessage === 'system_action')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[(item.message === 'invite')?_c('div',{staticClass:"text2"},[_vm._v("\n                                "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n                              ")]):(item.message === 'kick')?_c('div',{staticClass:"text2"},[_vm._v("\n                                "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n                              ")]):(item.message === 'leave' && item.tokenuser === _vm.tokenuser)?_c('div',[_vm._v("\n                                "+_vm._s(_vm.$t('ChatSide.system.self.leftGroup'))+"\n                              ")]):(item.message === 'leave' && item.tokenuser !== _vm.tokenuser)?_c('div',{staticClass:"text2"},[_vm._v("\n                                "+_vm._s(_vm.$t('ChatSide.system.other.leftGroup', { name: item.nickname} ))+"\n                              ")]):(item.message === 'active' && item.tokenuser === _vm.tokenuser)?_c('div',[_vm._v("\n                                "+_vm._s(_vm.$t('ChatSide.system.self.joinGroup'))+"\n                              ")]):(item.message === 'active' && item.tokenuser !== _vm.tokenuser)?_c('div',{staticClass:"text2"},[_vm._v("\n                                "+_vm._s(_vm.$t('ChatSide.system.other.joinGroup', { name: item.nickname} ))+"\n                              ")]):_vm._e()]):(item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user' && item.typeofmessage !== 'message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.startChat'))+"\n                            ")]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile-action',[(item.timestamp !== '' && (item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user'))?_c('p',{staticStyle:{"color":"rgb(82, 82, 82) !important","font-size":"11px"}},[_vm._v("\n                            "+_vm._s(_vm.time(item.timestamp))+"\n                          ")]):_vm._e(),_vm._v(" "),(item.state == 'friend' || item.state == 'active' || item.state == 'group' || item.state == 'user')?_c('p',{staticStyle:{"margin-right":"2vw"}},[_c('v-badge',{attrs:{"color":"red"}},[(parseInt(item.count_read) >= 1000)?_c('span',{staticClass:"Kanit",staticStyle:{"font-size":"12px"},attrs:{"slot":"badge"},slot:"badge"},[_vm._v("999+")]):(item.count_read != '' && parseInt(item.count_read) != 0 && item.message != '')?_c('span',{staticClass:"Kanit",staticStyle:{"font-size":"11px","text-align":"center"},attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(item.count_read))]):_vm._e()])],1):_vm._e()])],1):_c('v-list-tile',{staticClass:"nonselectF",attrs:{"avatar":""},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['pinchat'], item)}}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.picture}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'group')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/group-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/man-white.png"}}),_vm._v(" "),(item.pin == 'true')?_c('v-badge',{attrs:{"color":"primary"}},[_c('img',{staticClass:"img-pin",staticStyle:{"width":"16px","height":"16px"},attrs:{"slot":"badge","src":"/static/img/icons/pin@3x.png"},slot:"badge"})]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"nonfontselect"},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('p',{staticStyle:{"width":"110px","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(item.timestamp !== '' && (item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user'))?_c('p',{staticStyle:{"color":"rgb(82, 82, 82) !important","font-size":"11px"}},[_vm._v("\n                                "+_vm._s(_vm.time(item.timestamp))+"\n                              ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat"},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[(item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.leftChat'))+"\n                            ")]):(item.typeofmessage === 'message')?_c('span',{staticClass:"fontselectchat text2",staticStyle:{"font-size":"11px!important"},domProps:{"innerHTML":_vm._s(_vm.convertMention(item.message))}}):(item.typeofmessage === 'sticker')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendSticker'))+"\n                            ")]):(item.typeofmessage === 'file' || item.typeofmessage === 'password_file' )?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendFile'))+"\n                            ")]):(item.typeofmessage === 'location')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendLocation'))+"\n                            ")]):(item.typeofmessage === 'contact')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendContact'))+"\n                            ")]):(item.typeofmessage === 'image')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendPicture'))+"\n                            ")]):(item.typeofmessage === 'note')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendNote'))+"\n                            ")]):(item.typeofmessage === 'video')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendVideo'))+"\n                            ")]):(item.typeofmessage === 'mention_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendReply'))+"\n                            ")]):(item.typeofmessage === 'albums_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.createAlbum'))+"\n                            ")]):(item.typeofmessage === 'task_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.createTask'))+"\n                            ")]):(item.typeofmessage === 'system_action_task')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.createProject'))+"\n                            ")]):(item.typeofmessage === 'unsend_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(item.message)+"\n                            ")]):(item.typeofmessage === 'carousel')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendCarousel'))+"\n                            ")]):(item.typeofmessage === 'conference_msg')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.sendConference_msg'))+"\n                            ")]):(item.typeofmessage === 'system' || item.typeofmessage === 'template' || item.typeofmessage === 'date' || item.typeofmessage === 'datetime')?_c('span',{staticClass:"fontselectchat text2",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(item.message)+"\n                            ")]):(item.typeofmessage === 'call')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[(item.message === 'success')?_c('div',{staticClass:"text2"},[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone fa-rotate-90")]),_vm._v(" "+_vm._s(_vm.$t('LeftSide.chat.call.time'))+"  "+_vm._s(_vm.secondsToHms(item.time_count))+"\n                              ")],1):(item.message === 'decline' && item.tokenuser === _vm.tokenuser)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.noResponse'))+"\n                              ")],1):(item.message === 'decline' && item.tokenuser !== _vm.tokenuser)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                              ")],1):(item.message === 'cancle' && item.tokenuser === _vm.tokenuser)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                              ")],1):(item.message === 'cancle' && item.tokenuser !== _vm.tokenuser)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.missed'))+"\n                              ")],1):(item.message === 'cancel' && item.tokenuser === _vm.tokenuser)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                              ")],1):(item.message === 'cancel' && item.tokenuser !== _vm.tokenuser)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"#716262","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.missed'))+"\n                              ")],1):_vm._e()]):(item.typeofmessage === 'system_action')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[(item.message === 'invite')?_c('div',{staticClass:"text2"},[_vm._v("\n                                "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n                              ")]):(item.message === 'kick')?_c('div',{staticClass:"text2"},[_vm._v("\n                                "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n                              ")]):(item.message === 'leave' && item.tokenuser === _vm.tokenuser)?_c('div',[_vm._v("\n                                "+_vm._s(_vm.$t('ChatSide.system.self.leftGroup'))+"\n                              ")]):(item.message === 'leave' && item.tokenuser !== _vm.tokenuser)?_c('div',{staticClass:"text2"},[_vm._v("\n                                "+_vm._s(_vm.$t('ChatSide.system.other.leftGroup', { name: item.nickname} ))+"\n                              ")]):(item.message === 'active' && item.tokenuser === _vm.tokenuser)?_c('div',[_vm._v("\n                                "+_vm._s(_vm.$t('ChatSide.system.self.joinGroup'))+"\n                              ")]):(item.message === 'active' && item.tokenuser !== _vm.tokenuser)?_c('div',{staticClass:"text2"},[_vm._v("\n                                "+_vm._s(_vm.$t('ChatSide.system.other.joinGroup', { name: item.nickname} ))+"\n                              ")]):_vm._e()]):(item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user' && item.typeofmessage !== 'message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                              "+_vm._s(_vm.$t('LeftSide.chat.startChat'))+"\n                            ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(item.state == 'friend' || item.state == 'active' || item.state == 'group' || item.state == 'user')?_c('p',{staticStyle:{"margin-right":"5vw"}},[_c('v-badge',{attrs:{"color":"red"}},[(parseInt(item.count_read) >= 100)?_c('span',{staticClass:"Kanit",staticStyle:{"font-size":"12px"},attrs:{"slot":"badge"},slot:"badge"},[_vm._v("99+")]):(item.count_read != '' && parseInt(item.count_read) != 0 && item.message != '')?_c('span',{staticClass:"Kanit",staticStyle:{"font-size":"11px","text-align":"center"},attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(item.count_read))]):_vm._e()])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),(index < _vm.FilterChatList.length - 1)?_c('v-divider',{key:("divider-" + index)}):_vm._e()],1):_vm._e()]})],2)],1):_c('v-flex',{staticClass:"scroll-y",staticStyle:{"max-height":"80vh"},attrs:{"xs12":"","xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":""}},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.ProgressListChat,"color":"primary"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-3"}},[_c('v-layout',{staticClass:"mt-3 ml-3",attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v(_vm._s(_vm.$t('LeftSide.header.setting')))])]),_vm._v(" "),_c('v-layout',{staticClass:"scrolling-wrapper-setting",style:(_vm.heightlistsetting),attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-list',{staticStyle:{"width":"100%"},attrs:{"dense":"","two-line":""}},[_c('v-subheader',{staticStyle:{"background-color":"#efefef !important","color":"black !important","font-size":"14px !important"}},[_vm._v(_vm._s(_vm.$t('HeaderMenubar.profile')))]),_vm._v(" "),_vm._l((_vm.listsetting),function(item,index){return [_c('v-list-tile',{key:item.title,on:{"click":function($event){_vm.toPage(item.dialog)}}},[_c('v-icon',{attrs:{"meduim":""}},[_vm._v(_vm._s(item.icon))]),_vm._v("  \n                  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(item.title))])],1),_vm._v(" "),(index + 1 < _vm.listsetting.length)?_c('v-divider',{key:index}):_vm._e()]}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.openloa()}}},[_c('v-icon',{staticStyle:{"font-size":"18px"}},[_vm._v("fas fa-user-shield")]),_vm._v("  \n              "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('HeaderMenubar.loa')))])],1)],2),_vm._v(" "),_c('v-list',{staticStyle:{"width":"100%"},attrs:{"dense":"","two-line":""}},[_c('v-subheader',{staticStyle:{"background-color":"#efefef !important","color":"black !important","font-size":"14px !important"}},[_vm._v("One Platform Service")]),_vm._v(" "),_vm._l((_vm.listservice),function(item,index){return [_c('v-list-tile',{key:item.title,on:{"click":function($event){_vm.changepathservice(item.path, item.type)}}},[(item.icon !== '')?_c('v-icon',{attrs:{"meduim":""}},[_vm._v(_vm._s(item.icon))]):_c('img',{attrs:{"src":item.img,"alt":"","width":"30","height":"30"}}),_vm._v("\n                \n                "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(item.title))])],1),_vm._v(" "),(index + 1 < _vm.listservice.length)?_c('v-divider',{key:index}):_vm._e()]})],2),_vm._v(" "),_c('v-list',{staticStyle:{"width":"100%"},attrs:{"dense":"","two-line":""}},[_c('v-subheader',{staticStyle:{"background-color":"#efefef !important","color":"black !important","font-size":"14px !important"}},[_vm._v(_vm._s(_vm.$t('HeaderMenubar.general')))]),_vm._v(" "),_vm._l((_vm.listother),function(item,index){return [_c('v-list-tile',{key:item.title,on:{"click":function($event){_vm.toPage(item.dialog)}}},[_c('v-icon',{attrs:{"meduim":""}},[_vm._v(_vm._s(item.icon))]),_vm._v("  \n                "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(item.title))])],1),_vm._v(" "),(index + 1 < _vm.listother.length)?_c('v-divider',{key:index}):_vm._e()]}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.logout()}}},[_c('v-icon',{attrs:{"meduim":""}},[_vm._v("lock_open")]),_vm._v("  \n              "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('HeaderMenubar.logout')))])],1)],2)],1)],1),_vm._v(" "),_c('ShowFriendDialog',{attrs:{"dialogShowfriend":_vm.ShowFriend,"showgroup":_vm.showgroup},on:{"closeDialogShowFriend":_vm.closeDialogShowFriend}}),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('CreateGroupMobile',{on:{"updatecreategroup":_vm.updatecreategroup,"updatelistchat":_vm.updatelistchat}}),_vm._v(" "),_c('Addfriend',{on:{"updatelistreq":_vm.updatelistreq,"blockevent":_vm.blockevent}})],1)],1),_vm._v(" "),_c('checkconsentOnechatDialog',{attrs:{"url_consent":_vm.url_consent,"consentOnechatDialog":_vm.consentOnechatDialog},on:{"closeDialogConsentOnechat":_vm.closeDialogConsentOnechat}}),_vm._v(" "),_c('CheckBrowserDialog',{attrs:{"checkBrowserDialog":_vm.checkBrowserDialog,"checkBrowserInfor":_vm.checkBrowserInfor},on:{"closeCheckBrowser":_vm.closeCheckBrowser}})],1)])}
var LeftSideMobileTest_staticRenderFns = []
var LeftSideMobileTest_esExports = { render: LeftSideMobileTest_render, staticRenderFns: LeftSideMobileTest_staticRenderFns }
/* harmony default export */ var layout_LeftSideMobileTest = (LeftSideMobileTest_esExports);
// CONCATENATED MODULE: ./src/components/mobile/layout/LeftSideMobileTest.vue
function LeftSideMobileTest_injectStyle (ssrContext) {
  __webpack_require__("D81q")
}
var LeftSideMobileTest_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LeftSideMobileTest___vue_template_functional__ = false
/* styles */
var LeftSideMobileTest___vue_styles__ = LeftSideMobileTest_injectStyle
/* scopeId */
var LeftSideMobileTest___vue_scopeId__ = "data-v-49ea556e"
/* moduleIdentifier (server only) */
var LeftSideMobileTest___vue_module_identifier__ = null
var LeftSideMobileTest_Component = LeftSideMobileTest_normalizeComponent(
  LeftSideMobileTest,
  layout_LeftSideMobileTest,
  LeftSideMobileTest___vue_template_functional__,
  LeftSideMobileTest___vue_styles__,
  LeftSideMobileTest___vue_scopeId__,
  LeftSideMobileTest___vue_module_identifier__
)

/* harmony default export */ var mobile_layout_LeftSideMobileTest = (LeftSideMobileTest_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/layout/CenterSideTest.vue
var CenterSideTest = __webpack_require__("ui8T");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40b50cfb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/layout/CenterSideTest.vue
var CenterSideTest_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%","overflow-y":"hidden"}},[_c('div',[(_vm.showphone === false)?_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/homepage')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),(_vm.infofriend.type === 'user')?_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[(_vm.infofriend.data_room[0].profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.infofriend.data_room[0].profilepicture}}):(_vm.infofriend.data_room[0].profilepicture === '' && _vm.infofriend.data_room[0].type === 'user')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/man-white.png"}}):(_vm.infofriend.data_room[0].profilepicture === '' && _vm.infofriend.data_room[0].type === 'business')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.infofriend.data_room[0].profilepicture === '' && _vm.infofriend.data_room[0].type === 'bot')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):(_vm.infofriend.type === 'group')?_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[(_vm.infofriend.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.infofriend.picture}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#dde1e3"},attrs:{"src":"/static/img/default_profile/group-white.png"}})]):_vm._e(),_vm._v(" "),(_vm.infofriend.type ==='user')?_c('v-toolbar-title',[_vm._v(_vm._s(_vm.infofriend.data_room[0].name)+"\n      ")]):_c('v-toolbar-title',[_vm._v(_vm._s(_vm.infofriend.group_name)+"\n      ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPageinfo()}}},[_c('v-icon',[_vm._v("more_vert")])],1)],1):_vm._e(),_vm._v(" "),_c('v-toolbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.showphone),expression:"showphone"}],staticStyle:{"background-color":"white !important","height":"90px !important"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{staticStyle:{"justify-content":"center","display":"flex"},attrs:{"xs5":""}},[_c('v-layout',{staticClass:"mt-4",attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{attrs:{"small":"","color":"green","fab":"","icon":""},on:{"click":function($event){_vm.openCall('voice',_vm.infofriend)}}},[_c('v-icon',{staticStyle:{"color":"white"}},[_vm._v("fas fa-phone")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.conference.startCall')))])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"justify-content":"center","display":"flex"},attrs:{"xs5":""}},[_c('v-layout',{staticClass:"mt-4",attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{attrs:{"small":"","color":"primary","fab":"","icon":""},on:{"click":function($event){_vm.openCall('video',_vm.infofriend)}}},[_c('v-icon',[_vm._v("fas fa-video")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.conference.startVideo')))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeshow}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),(_vm.listannounce.length != 0)?_c('div',[(_vm.less)?_c('v-btn',{staticStyle:{"position":"fixed","right":"0%","z-index":"2","background":"#2562afd4"},attrs:{"fab":"","dark":"","small":""},on:{"click":function($event){_vm.less = !_vm.less; _vm.show = false;}}},[_c('v-icon',{staticStyle:{"font-size":"15px"}},[_vm._v("fas fa-bullhorn")])],1):_c('v-card',{staticStyle:{"position":"fixed","width":"100%","z-index":"2","background":"none"},attrs:{"id":"list_height"}},[_c('v-slide-y-transition',[_c('v-card-text',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticStyle:{"padding":"0px !important"}},[_c('v-list',{staticStyle:{"max-height":"200px","overflow-y":"scroll"}},[_vm._l((_vm.listannounce),function(item,index){return [_c('v-list-tile',{key:item.index,staticClass:"list-announce",on:{"click":function($event){_vm.announce_dialog(item)}}},[_c('v-list-tile-action',[_c('v-icon',{staticStyle:{"font-size":"18px"}},[_vm._v("fas fa-bullhorn")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"font-size":"13px"},domProps:{"innerHTML":_vm._s(_vm.convertMention(item.message_info.message))}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(item.nickname))])],1)],1),_vm._v(" "),(index + 1 < _vm.listannounce.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1)],1),_vm._v(" "),(!_vm.show)?_c('v-card-actions',{staticStyle:{"background":"#2562afa6","height":"40px"}},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#1b232c"}},[_vm._v("fas fa-bullhorn")]),_vm._v(" "),_c('p',{staticClass:"mb-0",staticStyle:{"color":"black","padding-left":"20px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap","width":"100%","cursor":"pointer","font-size":"13px"},domProps:{"innerHTML":_vm._s(_vm.convertMentionAnnounce(_vm.listannounce[0].message_info.message))},on:{"click":function($event){_vm.announce_dialog(_vm.item)}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.show = !_vm.show}}},[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1)],1):_vm._e(),_vm._v(" "),(_vm.show)?_c('v-card-actions',{staticStyle:{"color":"white","background":"#2562af","height":"40px"}},[_c('p',{staticClass:"p-announce",on:{"click":function($event){_vm.delete_announce()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.announce.delete')))]),_vm._v("\n        |\n        "),_c('p',{staticClass:"p-announce",on:{"click":function($event){_vm.less = !_vm.less}}},[_vm._v(_vm._s(_vm.$t('ChatSide.announce.minimize')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.show = !_vm.show}}},[_c('v-icon',{staticStyle:{"color":"white"}},[_vm._v("keyboard_arrow_up")])],1)],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"centerbox",attrs:{"row":"","wrap":""}},[_c('div',{staticClass:"chatbox"},[_c('vue-context',{ref:"menucontext",staticStyle:{"z-index":"1500"}},_vm._l((_vm.ListMenuRightClick),function(list,index){return _c('li',{key:index},[_c('a',{on:{"click":function($event){_vm.SelectMenuRightClick(list.methods)}}},[_vm._v(_vm._s(list.message))])])})),_vm._v(" "),_c('div',{staticClass:"modalc",attrs:{"id":"myModalFile"}},[_c('div',{attrs:{"id":"headcaption"}},[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"text-align":"right","padding-right":"2vw"},attrs:{"xs2":"","md2":"","sm2":""}},[_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[(_vm.picSend)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.picSend}}):(_vm.typeuser === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.typeuser === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","md9":"","sm9":""}},[_c('p',{staticStyle:{"font-size":"14px","white-space":"nowrap","width":"16em","overflow":"hidden","text-overflow":"ellipsis","font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.filenameSend))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px","white-space":"nowrap","width":"20em","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(" "+_vm._s(_vm.$t('Dialog.showImage.by'))+" "+_vm._s(_vm.nicknameSend)+"\n                  ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$t('Dialog.showImage.date'))+"  "+_vm._s(_vm.dateSend)+" "),_c('v-icon',{staticStyle:{"font-size":"7px !important","color":"white !important"}},[_vm._v("schedule")]),_vm._v(_vm._s(_vm.timeSend)+"\n                  ")],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","md1":"","sm1":""}},[_c('span',{staticClass:"close",on:{"click":function($event){_vm.closemodal()}}},[_vm._v("×")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-left":"15vw"},attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-btn',{staticClass:"btnallow text-transform",attrs:{"depressed":"","small":"","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.loadfile(_vm.infor_file)}}},[_c('v-icon',[_vm._v("file_download")]),_vm._v(" \n                      "+_vm._s(_vm.$t('AnswerQuestion.keep'))+"\n                  ")],1),_vm._v(" "),_c('v-btn',{staticClass:"btncancel text-transform",attrs:{"depressed":"","small":"","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.sendimgonebox(_vm.tokenmsgSend)}}},[_c('v-icon',[_vm._v("cloud_upload")]),_vm._v("  \n                      "+_vm._s(_vm.$t('AnswerQuestion.sendOnebox'))+"\n                  ")],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","height":"90%"}},[_c('div',{staticClass:"app-content"},[_c('vue-pdf-embed',{ref:"myPdfComponent",attrs:{"source":_vm.filepdf,"page":_vm.page},on:{"password-requested":_vm.handlePasswordRequest,"rendered":_vm.handleDocumentRender}})],1)])]),_vm._v(" "),_c('div',{staticClass:"modalc",attrs:{"id":"myModalImage"}},[_c('div',{attrs:{"id":"headcaption"}},[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"text-align":"right","padding-right":"2vw"},attrs:{"xs2":"","md2":"","sm2":""}},[_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[(_vm.picSend)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.picSend}}):(_vm.typeuser === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.typeuser === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","md9":"","sm9":""}},[_c('p',{staticStyle:{"font-size":"14px","white-space":"nowrap","width":"16em","overflow":"hidden","text-overflow":"ellipsis","font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.filenameSend)+" ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px","white-space":"nowrap","width":"20em","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(" "+_vm._s(_vm.$t('Dialog.showImage.by'))+" "+_vm._s(_vm.nicknameSend)+"\n                  ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$t('Dialog.showImage.date'))+"  "+_vm._s(_vm.dateSend)+" "),_c('v-icon',{staticStyle:{"font-size":"7px !important","color":"white !important"}},[_vm._v("schedule")]),_vm._v(_vm._s(_vm.timeSend)+"\n                  ")],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","md1":"","sm1":""}},[_c('span',{staticClass:"close",on:{"click":function($event){_vm.closemodal()}}},[_vm._v("×")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-left":"15vw"},attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-btn',{staticClass:"btnallow text-transform",attrs:{"depressed":"","small":"","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.loadpic(_vm.filenameSend)}}},[_c('v-icon',[_vm._v("file_download")]),_vm._v(" \n                      "+_vm._s(_vm.$t('AnswerQuestion.keep'))+"\n                  ")],1),_vm._v(" "),_c('v-btn',{staticClass:"btncancel text-transform",attrs:{"depressed":"","small":"","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.sendimgonebox(_vm.tokenmsgSend)}}},[_c('v-icon',[_vm._v("cloud_upload")]),_vm._v("  \n                      "+_vm._s(_vm.$t('AnswerQuestion.sendOnebox'))+"\n                  ")],1)],1)],1)],1)],1),_vm._v(" "),_c('img',{staticClass:"modal-contentc",attrs:{"id":"img01"}})]),_vm._v(" "),_c('div',{staticClass:"chatlogs",style:(_vm.chatlogsFlex),attrs:{"id":"myscroll"},on:{"scroll":_vm.scrollFunction}},[(_vm.progressLoadChat)?_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":_vm.progressLoadChat}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item,i){return (!_vm.selected)?_c('div',{key:item.id},[_c('v-layout',{attrs:{"justify-center":"","row":"","align-center":""}},[(i == 0)?_c('div',[(_vm.statusload)?_c('div',{staticClass:"text-xs-center",on:{"click":_vm.loadchathistory}},[_c('v-btn',{staticStyle:{"background":"#ff000000 !important","text-transform":"none"},attrs:{"round":"","outline":"","color":"primary"}},[_c('v-icon',{staticStyle:{"font-size":"18px !important"},attrs:{"left":""},on:{"click":_vm.loadchathistory}},[_vm._v("refresh")]),_vm._v(_vm._s(_vm.$t('ChatSide.loadHistory')))],1)],1):_vm._e(),_vm._v(" "),(_vm.tokenrooomSelect === item.tokenroom)?_c('div',{staticClass:"conversation-start",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.dateMoment(item.timestamp))+" ")])]):_vm._e()]):(_vm.dateMoment(item.timestamp) !== _vm.dateMoment(_vm.items[i-1].timestamp))?_c('div',[_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","md12":"","sm12":""}},[(_vm.tokenrooomSelect === item.tokenroom)?_c('div',{staticClass:"conversation-start",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.dateMoment(item.timestamp)))])]):_vm._e()])],1):_vm._e()]),_vm._v(" "),(item.tokenuser === _vm.token && _vm.tokenrooomSelect === item.tokenroom)?_c('div',{ref:item.tokenmessage,refInFor:true,staticClass:"chat self",attrs:{"id":item.tokenmessage}},[(item.typeofmessage === 'unsend_message' || item.typeofmessage === 'system_action' || item.typeofmessage === 'system' || item.typeofmessage === 'system_action_albums' || item.typeofmessage === 'system_action_task')?_c('v-layout',{attrs:{"align-center":"","justify-end":"","row":""}},[(item.typeofmessage === 'unsend_message')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.cancelMsg'))+"\n                  ")])]):(item.typeofmessage === 'system')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n                    "+_vm._s(item.message)+"\n                  ")])]):(item.typeofmessage === 'system_action')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[(item.message === 'active')?_c('p',{staticClass:"boxself_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.joinGroup'))+"\n                  ")]):(item.message === 'kick')?_c('p',{staticClass:"boxself_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n                  ")]):(item.message === 'invite')?_c('p',{staticClass:"boxself_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n                  ")]):(item.message === 'leave')?_c('p',{staticClass:"boxself_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.leftGroup'))+"\n                  ")]):_vm._e()]):(item.typeofmessage === 'system_action_albums')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[(item.message == 'edit_name_albums')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.editNameAlbum'))+"\n                  ")]):(item.message == 'create_albums')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.createAlbum', { name: item.albums_name }))+"\n                  ")]):(item.message == 'delete_albums')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.deleteAlbum'))+"\n                  ")]):(item.message == 'delete_images_albums')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.deleteImageAlbum'))+"\n                  ")]):_vm._e()]):(item.typeofmessage === 'system_action_task')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[(item.message == 'edit_task')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.editTask'))+"\n                  ")]):(item.message == 'create_project')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.createProject'))+"\n                  ")]):_vm._e()]):_vm._e()],1):_c('v-layout',{staticStyle:{"margin-bottom":"15px","margin-top":"15px"},attrs:{"align-center":"","justify-end":"","row":""}},[(item.status == 'no' && item.typeofmessage == 'message')?_c('v-flex',{attrs:{"xs2":""}},[_c('v-layout',{attrs:{"align-end":"","justify-end":"","wrap":"","row":""}},[_c('p',{staticStyle:{"padding-right":"5px","color":"#ff0000cc","font-size":"10px","cursor":"pointer","text-decoration":"underline"},on:{"click":function($event){_vm.resendMessage(item)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.system.resend')))])])],1):(item.status == 'no' && item.typeofmessage == 'contact')?_c('v-flex',{attrs:{"xs2":""}},[_c('v-layout',{attrs:{"align-end":"","justify-end":"","wrap":"","row":""}},[_c('p',{staticStyle:{"padding-right":"5px","color":"#ff0000cc","font-size":"10px","cursor":"pointer","text-decoration":"underline"},on:{"click":function($event){_vm.resendMessage(item)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.system.resend')))])])],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticStyle:{"float":"right"},attrs:{"xs10":""}},[_c('v-layout',{staticStyle:{"float":"right"},attrs:{"row":"","wrap":"","align-end":""}},[(item.typeofmessage === 'albums_message' && item.image_add.length === 0)?_c('span',{staticStyle:{"font-size":"10px","color":"#616161","margin-bottom":"0px","display":"none"}},[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" ")]):_c('span',{staticStyle:{"font-size":"10px","color":"#616161","margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" ")]),_vm._v(" "),(item.typeofmessage === 'message')?_c('div',{directives:[{name:"longclick",rawName:"v-longclick",value:(function () { return (item, 'forwardunsend'); }),expression:"() =>  (item, 'forwardunsend')"}],staticClass:"chat_self",staticStyle:{"height":"100%"},attrs:{"slot":"activator","data-long-press-delay":"500"},slot:"activator"},[_c('p',{staticStyle:{"margin":"0 !important"},attrs:{"slot":"activator"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))},on:{"click":_vm.handleClickTest},slot:"activator"}),_vm._v(" "),_vm._l((_vm.convertURL(item.message)),function(x){return (_vm.convertURL(item.message))?_c('div',[_c('link-prevue',{attrs:{"url":x},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"row":"","wrap":""},on:{"click":function($event){_vm.clicklink_website(props.url)}}},[_c('v-flex',{staticClass:"border_website",attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[_c('p',{staticClass:"title_website"},[_vm._v(_vm._s(props.title)+"  ")]),_vm._v(" "),_c('span',{staticClass:"description_website"},[_vm._v(_vm._s(props.description))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerimg_website",attrs:{"xl9":"","lg9":"","md9":"","sm9":""}},[(props.img)?_c('img',{staticClass:"img_website",attrs:{"src":props.img}}):_vm._e()])],1)]}}])},[_c('template',{slot:"loading"},[_c('span')])],2)],1):_vm._e()})],2):(item.typeofmessage === 'mention_message')?_c('p',{directives:[{name:"longclick",rawName:"v-longclick",value:(function () { return _vm.setting_dialog(item, 'forwardunsend'); }),expression:"() => setting_dialog(item, 'forwardunsend')"}],staticClass:"chat_self",attrs:{"slot":"activator"},slot:"activator"},[(item.source_message.typeofmessage !== 'unsend_message')?_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(item.source_message.owner_source_message.path_pic)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":item.source_message.owner_source_message.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"40px"},attrs:{"xs11":""}},[(item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.convertMention(item.source_message.message))},on:{"click":_vm.handleClickTest}})]):(item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.typeofmessage === 'image')?_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.image')))]):_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.sticker')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"10px","float":"right"},attrs:{"src":item.source_message.message}})])],1):(item.source_message.typeofmessage === 'file')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(_vm.extension(item.source_message.message) === 'pdf')?_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v(_vm._s(_vm.extension(item.source_message.message)))])],1)],1):(item.source_message.typeofmessage === 'video')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.extension(item.source_message.message) === 'media')?_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"150","height":"150","controls":""}},[_c('source',{attrs:{"src":item.source_message.message,"type":'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]}})]):_c('div',{staticStyle:{"width":"100%","height":"150px","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"150px !important"},attrs:{"playerOptions":{
                                    type: 'application/x-mpegURL',
                                    src: item.source_message.message,
                                    preload: true,
                                    autoplay: false,
                                    isLoop: false,
                                    playsinline: false,
                                    poster: '',
                                    controls: 'progress,current,durration,volume',
                                    crossOrigin: false
                                  }},on:{"onplay":_vm.play}})],1)])],1):(item.source_message.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.address !== '')?_c('span',[_vm._v(_vm._s(item.source_message.address))]):_c('span',[_vm._v(_vm._s(item.source_message.message))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-map-marker-alt")])],1)],1):_vm._e()],1)],1):_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.noMsg')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):(item.typeofmessage === 'task_message' && item.message === 'create_task')?_c('p',{staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#3a506d"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#3a506db3"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#6981a1 !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()}),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"#e6ecf3","outline":"","text-color":"#3a506d"}},[_vm._v("\n                              "+_vm._s(item.task_info.state.name)+"\n                            ")])],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#6981a1 !important"}},[_vm._v("\n                            "+_vm._s(_vm.$t('ChatSide.Task.viewDetail'))+"\n                          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#6981a1 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'assign_task')?_c('p',{staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#3a506d"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#3a506db3"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#6981a1 !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()})],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#6981a1 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Task.editAssign')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#6981a1 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'image')?_c('p',{staticClass:"boxselfimage",staticStyle:{"width":"500px"},on:{"click":function($event){_vm.setting_dialog(item, 'addimage')}}},[_c('v-img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.message,"height":"200px"}})],1):(item.typeofmessage === 'sticker')?_c('p',{staticStyle:{"margin-top":"0","height":"100%"},on:{"click":function($event){_vm.setting_dialog(item, 'unsend')}}},[_c('img',{staticClass:"boxselfsticker",attrs:{"src":item.file_name}})]):(item.typeofmessage === 'web')?_c('div',{staticClass:"boxselffile",staticStyle:{"width":"500px"}},[_c('iframe',{staticStyle:{"visibility":"visible","max-width":"55vw !important"},attrs:{"height":"400","frameborder":"0","src":item.message}})]):(item.typeofmessage === 'note' && _vm.statemember === 'active')?_c('div',{staticClass:"chat_self",staticStyle:{"font-weight":"500","cursor":"pointer","width":"200px !important","margin-bottom":"10px"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailNote(item.note_id)}},slot:"activator"},[_c('p',{staticClass:"textchat",domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length ==20)?_c('p',[_vm._v(" ...")]):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"color":"#5a616b !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#5a616b !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1):(item.typeofmessage === 'note' && _vm.statemember !== 'active')?_c('div',{staticClass:"chat_self",staticStyle:{"font-weight":"500","width":"200px !important","margin-bottom":"10px"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailNote(item.note_id)}},slot:"activator"},[_c('p',{staticClass:"textchat",staticStyle:{"color":"#5a616b !important"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length ==20)?_c('p',[_vm._v(" ...")]):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"color":"#5a616b !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#5a616b !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1):(item.typeofmessage === 'contact')?_c('v-layout',{staticClass:"chat_selfcontact",staticStyle:{"font-weight":"500","cursor":"pointer","margin-top":"15px"},attrs:{"slot":"activator","row":"","align-center":"","justify-start":""},on:{"click":function($event){_vm.setting_dialog(item, 'forwardunsend')}},slot:"activator"},[_c('v-flex',{attrs:{"xs5":"","md5":"","sm5":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[(item.pic_contact)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.pic_contact}}):(item.type_contact === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","md5":"","sm5":""}},[_c('v-layout',{staticStyle:{"margin-top":"12px"},attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('p',{staticClass:"text2"},[_vm._v(_vm._s(item.nickname_contact))])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","md2":"","sm2":""}},[_c('v-layout',{attrs:{"align-center":"","justify-end":"","row":"","wrap":""}},[_c('v-icon',[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'video')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"500px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.setting_dialog(item, 'forward')}},slot:"activator"},[(_vm.extension(item.message) === 'media')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('video',{attrs:{"width":"180","height":"130","controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):(_vm.extension(item.file_name) === 'audio')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticStyle:{"width":"100%","height":"150px","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"150px !important"},attrs:{"playerOptions":{
                              type: 'application/x-mpegURL',
                              src: item.message,
                              preload: true,
                              autoplay: false,
                              isLoop: false,
                              playsinline: false,
                              poster: '',
                              controls: 'progress,current,durration,volume',
                              crossOrigin: false
                            }},on:{"onplay":_vm.play}})],1)]),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white"}},[_vm._v(_vm._s(item.file_name))])])]),_vm._v(" "),(_vm.extension(item.file_name) !== 'pdf')?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white"},on:{"click":function($event){_vm.setting_dialog(item, 'download')}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"blue"},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("cloud_upload")])],1)],1):_vm._e()],1):(item.typeofmessage === 'file' && (_vm.extension(item.file_name) === 'pdf' || _vm.extension(item.file_name) === 'media' || _vm.extension(item.file_name) === 'audio'))?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"500px","cursor":"pointer"},attrs:{"slot":"activator"},slot:"activator"},[(_vm.extension(item.file_name) === 'pdf')?_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center","cursor":"pointer"},attrs:{"xs12":""},on:{"click":function($event){_vm.setting_dialog(item, 'forwardunsend')}}},[_c('v-card-media',{staticStyle:{"width":"45vw","border-radius":"10px"},attrs:{"height":"70px"}},[_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":item.message,"page":1},on:{"password":function($event){_vm.passwordPdf($event, i, item)},"error":_vm.errorPdf}})],1)],1):(_vm.extension(item.file_name) === 'media')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""},on:{"click":function($event){_vm.setting_dialog(item, 'forward')}}},[_c('video',{attrs:{"width":"200","height":"130","controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):(_vm.extension(item.file_name) === 'audio')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""},on:{"click":function($event){_vm.setting_dialog(item, 'forward')}}},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_c('v-flex',{attrs:{"xs12":""}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v(_vm._s(_vm.extension(item.file_name)))])],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white !important"}},[_vm._v(_vm._s(item.file_name))])])]),_vm._v(" "),(_vm.extension(item.file_name) !== 'pdf')?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.setting_dialog(item, 'download')}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"blue","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("cloud_upload")])],1)],1):_vm._e()],1):(item.typeofmessage === 'file')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"500px"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.setting_dialog(item, 'forwardunsend')}},slot:"activator"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v(_vm._s(_vm.extension(item.file_name)))])],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white !important"}},[_vm._v(_vm._s(item.file_name))])])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.extension(item.file_name) == 'pdf')?_c('v-icon',{attrs:{"dark":""},on:{"click":function($event){_vm.setting_dialog(item, 'forward')}}},[_vm._v("visibility")]):_c('v-icon',{attrs:{"dark":""},on:{"click":function($event){_vm.setting_dialog(item, 'download')}}},[_vm._v("file_download")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"blue","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("cloud_upload")])],1)],1)],1):(item.typeofmessage === 'location')?_c('p',{staticStyle:{"width":"180px","cursor":"pointer","margin-top":"15px"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.setting_dialog(item, 'forwardunsend')}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#b4d1f5","border-radius":"20px","padding":"10px","padding-bottom":"10px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"},attrs:{"raw":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"}},[_vm._v("place")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"color":"black","padding-left":"5px"},attrs:{"xs10":"","sm10":"","md10":""}},[(item.file_name != '')?_c('span',[_vm._v(" "+_vm._s(item.file_name))]):_c('span',[_vm._v("  "+_vm._s(_vm.$t('ChatSide.location')))])])],1)],1)],1):(item.typeofmessage === 'pdf_password')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"500px","cursor":"pointer"},attrs:{"slot":"activator"},slot:"activator"},[(_vm.extension(item.file_name) === 'pdf')?_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center","cursor":"pointer"},attrs:{"xs12":""},on:{"click":function($event){_vm.setting_dialog(item, 'forwardunsend')}}},[_c('v-card-media',{staticStyle:{"width":"45vw","border-radius":"10px"},attrs:{"height":"70px"}},[_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":"https://testchat.one.th/alpine/api/v1/file/J0CDcdbm1zUba7cb86c384f5fa5b3eae7269b4993ce_2022-08-17_18:29:28:894891.pdf","page":1}})],1)],1):_vm._e(),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white !important"}},[_vm._v(_vm._s(item.file_name))])])])],1):(item.typeofmessage=='date')?_c('p',{staticClass:"chat_self",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message)))],1):(item.typeofmessage=='datetime')?_c('p',{staticClass:"chat_self",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))),_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v(" far fa-clock")]),_vm._v("   "+_vm._s(item.message.split('T')[1])+" ")],1):(item.typeofmessage === 'call')?_c('p',{staticClass:"chat_self",staticStyle:{"text-align":"center","width":"100px"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='decline')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel' || item.message =='decline')?_c('span',[_vm._v("\n                        "+_vm._s(_vm.checktypeCall(item.message))+"\n                      ")]):_c('span',[_vm._v(_vm._s(_vm.secondsToHms(item.time_count)))])],1):(item.typeofmessage === 'conference_msg')?_c('div',{staticClass:"chat_self",staticStyle:{"text-align":"center","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.information.option == 'voice')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startCall')))],1):(item.information.option == 'video')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("videocam")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startVideo')))],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"joinBtn",on:{"click":function($event){_vm.backCall_conference_msg(item.information)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.conference.joinCall'))+" ")])],1):(item.typeofmessage === 'agora_call')?_c('div',{staticClass:"chat_self",staticStyle:{"text-align":"center","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='end')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel')?_c('span',[_vm._v("\n                        "+_vm._s(_vm.checktypeCall(item.message))+"\n                      ")]):_c('span',[_vm._v(_vm._s(item.time))])],1):(item.typeofmessage === 'albums_message' && item.image_add.length === 0)?_c('div',{staticClass:"chat_self_createablums",staticStyle:{"width":"180px","display":"none"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailAlbums(item.file_name)}},slot:"activator"},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', {count: item.image_add.length})))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',[_vm._v(_vm._s(item.albums_name))]):_c('h4',[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"},attrs:{"color":"black"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'albums_message' && item.image_add.length !== 0)?_c('div',{staticClass:"chat_self_createablums",staticStyle:{"width":"180px"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailAlbums(item.file_name)}},slot:"activator"},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', {count: item.image_add.length})))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',[_vm._v(_vm._s(item.albums_name))]):_c('h4',[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"},attrs:{"color":"black"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'official_template')?_c('div',{staticClass:"chat_self",staticStyle:{"overflow":"hidden","display":"-webkit-inline-box","background":"none"}},[_c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","margin-right":"10px","background":"#b4d1f5 !important"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562af","padding-left":"12px","padding-top":"10px","padding-bottom":"10px"}},[_vm._v(_vm._s(item.element.title))]),_vm._v(" "),(item.element.image)?_c('v-img',{staticStyle:{"height":"120px"},attrs:{"src":item.element.image,"contain":""}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"150px"}},[_c('read-more',{staticClass:"mb-0",staticStyle:{"color":"#343433"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":20}}),_vm._v(" "),(!item.element.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((item.element.choice),function(choice,index){return _c('div',[_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px","border-radius":"20px"},attrs:{"flat":""}},[_vm._v("\n                                  "+_vm._s(choice.label)+"\n                                ")])],1)})],2)])],1)],1)]):_c('p',{staticClass:"chat_self",attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                      "+_vm._s(_vm.$t('ChatSide.notSupportVersion'))+"\n                    ")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(item.tokenuser !== _vm.token && _vm.tokenrooomSelect === item.tokenroom)?_c('div',{ref:item.tokenmessage,refInFor:true,staticClass:"chat other",staticStyle:{"margin-bottom":"10px"},attrs:{"id":item.tokenmessage}},[(item.typeofmessage === 'unsend_message' || item.typeofmessage === 'system_action' || item.typeofmessage === 'system' || item.typeofmessage === 'system_action_albums' || item.typeofmessage === 'system_action_task')?_c('v-layout',{attrs:{"align-center":"","row":"","wrap":""}},[(item.typeofmessage === 'unsend_message')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n                      "+_vm._s(_vm.$t('ChatSide.system.other.cancelMsg', { name: item.nickname}))+"\n                    ")])])],1):(item.typeofmessage === 'system')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n                      "+_vm._s(item.message)+"\n                    ")])])],1):(item.typeofmessage === 'system_action')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[(item.message === 'active')?_c('p',{staticClass:"boxother_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.joinGroup', { name: item.nickname}))+"\n                  ")]):(item.message === 'kick')?_c('p',{staticClass:"boxother_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', { name_active: item.nickname, name_passive: item.file_name}))+"\n                  ")]):(item.message === 'invite')?_c('p',{staticClass:"boxother_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', { name_active: item.nickname, name_passive: item.file_name}))+"\n                  ")]):(item.message === 'leave')?_c('p',{staticClass:"boxother_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.leftGroup', { name: item.nickname}))+"\n                  ")]):_vm._e()]):(item.typeofmessage === 'system_action_albums')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[(item.message == 'edit_name_albums')?_c('p',{staticClass:"boxother_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.editNameAlbum', { name: item.nickname}))+"\n                  ")]):(item.message == 'create_albums')?_c('p',{staticClass:"boxother_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.createAlbum', { name: item.nickname, album_name: item.albums_name }))+"\n                  ")]):(item.message == 'delete_albums')?_c('p',{staticClass:"boxother_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.deleteAlbum', { name: item.nickname}))+"\n                  ")]):(item.message == 'delete_images_albums')?_c('p',{staticClass:"boxother_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.deleteImageAlbum', { name: item.nickname}))+"\n                  ")]):_vm._e()]):(item.typeofmessage === 'system_action_task')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[(item.message == 'edit_task')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.editTask', {name: item.nickname}))+"\n                  ")]):(item.message == 'create_project')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.createProject', {name: item.nickname}))+"\n                  ")]):_vm._e()]):_vm._e()],1):_c('v-layout',{staticStyle:{"margin-top":"15px"},attrs:{"justify-start":"","row":""}},[(item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system' && item.typeofmessage !== 'system_action')?_c('v-flex',{staticStyle:{"cursor":"pointer","padding-right":"10px"},attrs:{"xs2":"","sm2":"","md2":""},on:{"click":function($event){_vm.detailFriend(item.tokenuser)}}},[(item.typeofmessage == 'albums_message' && item.image_add.length == 0)?_c('div',{staticStyle:{"display":"none"}}):_c('div',[(item.path_pic !== '')?_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.path_pic}})]):_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[(item.type === 'user')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):(item.type === 'company')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{staticStyle:{"float":"left"},attrs:{"xs10":""}},[_c('v-layout',{staticStyle:{"float":"left","padding-left":"0px"},attrs:{"row":"","wrap":"","align-end":""}},[(item.typeofmessage === 'message')?_c('div',{directives:[{name:"longclick",rawName:"v-longclick",value:(function () { return _vm.setting_dialog(item, 'forward'); }),expression:"() => setting_dialog(item, 'forward')"}],staticClass:"chat_other",attrs:{"slot":"activator"},slot:"activator"},[_c('p',{staticStyle:{"margin":"0 !important"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))},on:{"click":_vm.handleClickTest}}),_vm._v(" "),_vm._l((_vm.convertURL(item.message)),function(x){return (_vm.convertURL(item.message))?_c('div',[_c('link-prevue',{attrs:{"url":x},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"row":"","wrap":""},on:{"click":function($event){_vm.clicklink_website(props.url)}}},[_c('v-flex',{staticClass:"border_website",attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[_c('p',{staticClass:"title_website"},[_vm._v(_vm._s(props.title))]),_vm._v(" "),_c('span',{staticClass:"description_website"},[_vm._v(_vm._s(props.description))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerimg_website",attrs:{"xl9":"","lg9":"","md9":"","sm9":""}},[(props.img)?_c('img',{staticClass:"img_website",attrs:{"src":props.img}}):_vm._e()])],1)]}}])},[_c('template',{slot:"loading"},[_c('span')])],2)],1):_vm._e()})],2):(item.typeofmessage === 'image')?_c('p',{staticClass:"boxfriendimage",staticStyle:{"width":"500px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.setting_dialog(item, 'forwardimagedialog')}},slot:"activator"},[_c('v-img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.message,"height":"200px"}})],1):(item.typeofmessage === 'template')?_c('div',{staticClass:"boxfriendquestion scrolling-wrapper-template",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","display":"flex","background":"none","width":"275px","padding":"10px","align-items":"end"},attrs:{"slot":"activator"},slot:"activator"},_vm._l((item.info_ans),function(info_ans,index){return _c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px"}},[(info_ans.image)?_c('v-img',{staticStyle:{"height":"120px"},attrs:{"src":info_ans.image,"aspect-ratio":"2.75"}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562ae"}},[_vm._v(_vm._s(info_ans.title))]),_vm._v(" "),_c('p',{staticClass:"mb-0",staticStyle:{"display":"-webkit-box","-webkit-line-clamp":"2","-webkit-box-orient":"vertical","overflow":"hidden","text-overflow":"ellipsis"},domProps:{"innerHTML":_vm._s(_vm.convert(info_ans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(info_ans.detail.length >= 40)?_c('a',{on:{"click":function($event){_vm.clickReadmore(info_ans)}}},[_c('b',[_vm._v(_vm._s(_vm.$t('ChatSide.Read.readmore')))])]):_vm._e(),_vm._v(" "),(!info_ans.image)?_c('v-divider',{staticClass:"mt-2",attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((info_ans.choice),function(choice,index){return _c('div',[(choice.type=='file')?_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px"},attrs:{"block":"","flat":"","color":"primary"},on:{"click":function($event){_vm.ans_question(choice, item.tokenmessage, item.tokenuser)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-download")]),_vm._v("    "),_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.ans_question(choice, item.tokenmessage, item.tokenuser)}}},[_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})])],1)})],2)])],1)],1)})):(item.typeofmessage === 'mention_message')?_c('p',{directives:[{name:"longclick",rawName:"v-longclick",value:(function () { return _vm.setting_dialog(item, 'forwardunsend'); }),expression:"() => setting_dialog(item, 'forwardunsend')"}],staticClass:"chat_other",attrs:{"slot":"activator"},slot:"activator"},[(item.source_message.typeofmessage !== 'unsend_message')?_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(item.source_message.owner_source_message.path_pic)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":item.source_message.owner_source_message.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"40px"},attrs:{"xs11":""}},[(item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.convertMention(item.source_message.message))},on:{"click":_vm.handleClickTest}})]):(item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.typeofmessage === 'image')?_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.image')))]):_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.sticker')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"10px","float":"right"},attrs:{"src":item.source_message.message}})])],1):(item.source_message.typeofmessage === 'file')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(_vm.extension(item.source_message.message) === 'pdf')?_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v(_vm._s(_vm.extension(item.source_message.message)))])],1)],1):(item.source_message.typeofmessage === 'video')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.extension(item.source_message.message) === 'media')?_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"150","height":"150","controls":""}},[_c('source',{attrs:{"src":item.source_message.message,"type":'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]}})]):_c('div',{staticStyle:{"width":"100%","height":"150px","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"150px !important"},attrs:{"playerOptions":{
                                  type: 'application/x-mpegURL',
                                  src: item.source_message.message,
                                  preload: true,
                                  autoplay: false,
                                  isLoop: false,
                                  playsinline: false,
                                  poster: '',
                                  controls: 'progress,current,durration,volume',
                                  crossOrigin: false
                                }},on:{"onplay":_vm.play}})],1)])],1):(item.source_message.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.address !== '')?_c('span',[_vm._v(_vm._s(item.source_message.address))]):_c('span',[_vm._v(_vm._s(item.source_message.message))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-map-marker-alt")])],1)],1):_vm._e()],1)],1):_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.noMsg')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):(item.typeofmessage === 'task_message' && item.message === 'create_task')?_c('p',{staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#444444"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#444444c2"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#7c7c7c !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()}),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"#dcd9d9","outline":"","text-color":"#3a506d"}},[_vm._v("\n                            "+_vm._s(item.task_info.state.name)+"\n                          ")])],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#818181 !important"}},[_vm._v("\n                          "+_vm._s(_vm.$t('ChatSide.Task.viewDetail'))+"\n                        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#818181 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'assign_task')?_c('p',{staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.open_detail_task(item.task_id, item.tokenroom)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#444444"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#444444c2"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#7c7c7c !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()})],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#818181 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Task.editAssign')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#818181 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'approve_message' && item.disable === 'false' && _vm.selected === false)?_c('p',{staticStyle:{"cursor":"pointer","width":"150px"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.openapprove(item)}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"white","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"145px"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',{staticStyle:{"color":"#2562ae !important"}},[_vm._v(_vm._s(item.info_ans[0].title))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#9d9d9d !important"}},[_vm._v(_vm._s(item.info_ans[0].short_detail))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('span',{staticStyle:{"color":"#2562ae !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.viewDetail'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#2562ae !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'approve_message' && item.disable === 'true' && _vm.selected === false)?_c('p',{staticStyle:{"width":"150px"},attrs:{"slot":"activator"},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"white","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"145px"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',{staticStyle:{"color":"#757575 !important"}},[_vm._v(_vm._s(item.info_ans[0].title))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#9d9d9d !important"}},[_vm._v(_vm._s(item.info_ans[0].short_detail))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('span',{staticStyle:{"color":"#757575 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.receiveAns'))+" ")])])],1)],1):(item.typeofmessage === 'approve_message' && _vm.selected === true)?_c('p',{staticStyle:{"width":"150px"},attrs:{"slot":"activator"},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"white","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"145px"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',{staticStyle:{"color":"#757575 !important"}},[_vm._v(_vm._s(item.info_ans[0].title))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#9d9d9d !important"}},[_vm._v(_vm._s(item.info_ans[0].short_detail))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),(item.disable === 'false')?_c('v-card-actions',[_c('span',{staticStyle:{"color":"#757575 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.viewDetail'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#757575 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1):_c('v-card-actions',[_c('span',{staticStyle:{"color":"#757575 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.receiveAns'))+" ")])])],1)],1):(item.typeofmessage == 'date')?_c('p',{staticClass:"chat_other",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n                  ")],1):(item.typeofmessage == 'datetime')?_c('p',{staticClass:"chat_other",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("  "+_vm._s(_vm.momentday(item.message))),_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v(" far fa-clock")]),_vm._v("   "+_vm._s(item.message.split('T')[1])+"\n                  ")],1):(item.typeofmessage == 'web')?_c('div',{staticClass:"boxfriendfile",staticStyle:{"width":"500px"},attrs:{"slot":"activator"},slot:"activator"},[_c('iframe',{staticStyle:{"visibility":"visible","max-width":"55vw !important"},attrs:{"height":"400","frameborder":"0","src":item.message}})]):(item.typeofmessage === 'note' && _vm.statemember === 'active')?_c('div',{staticClass:"chat_other",staticStyle:{"font-weight":"500","cursor":"pointer","width":"200px !important","margin-bottom":"10px"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailNote(item.note_id)}},slot:"activator"},[_c('p',{staticClass:"textchat",domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length == 20)?_c('p',[_vm._v(" ...")]):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"color":"#5a616b !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#5a616b !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1):(item.typeofmessage === 'note' && _vm.statemember !== 'active')?_c('div',{staticClass:"chat_other",staticStyle:{"font-weight":"500","width":"200px !important","margin-bottom":"10px"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailNote(item.note_id)}},slot:"activator"},[_c('p',{staticClass:"textchat",staticStyle:{"color":"#5a616b !important"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length == 20)?_c('p',[_vm._v(" ...")]):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"color":"#5a616b !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#5a616b !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1):(item.typeofmessage === 'sticker')?_c('p',{staticStyle:{"margin-top":"0","height":"100%"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.setting_dialog(item, 'mention')}},slot:"activator"},[_c('img',{staticClass:"boxfriendsticker",attrs:{"src":item.file_name}})]):(item.typeofmessage === 'video')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"500px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.setting_dialog(item, 'forward')}},slot:"activator"},[(_vm.extension(item.message) === 'media')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('video',{attrs:{"width":"180","height":"130","controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):(_vm.extension(item.file_name) === 'audio')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticStyle:{"width":"100%","height":"150px","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"150px !important"},attrs:{"playerOptions":{
                            type: 'application/x-mpegURL',
                            src: item.message,
                            preload: true,
                            autoplay: false,
                            isLoop: false,
                            playsinline: false,
                            poster: '',
                            controls: 'progress,current,durration,volume',
                            crossOrigin: false
                          }},on:{"onplay":_vm.play}})],1)]),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white"}},[_vm._v(_vm._s(item.file_name))])])]),_vm._v(" "),(_vm.extension(item.file_name) !== 'pdf')?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.loadfile(item)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"blue"},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("cloud_upload")])],1)],1):_vm._e()],1):(item.typeofmessage === 'file' && (_vm.extension(item.file_name) === 'pdf'))?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"500px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.setting_dialog(item, 'forward')}},slot:"activator"},[(_vm.extension(item.file_name) === 'pdf')?_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center","cursor":"pointer"},attrs:{"xs12":""}},[_c('v-card-media',{staticStyle:{"width":"45vw","border-radius":"10px"},attrs:{"height":"70px"}},[_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":item.message,"page":1},on:{"password":function($event){_vm.passwordPdf($event, i, item)},"error":_vm.errorPdf}})],1)],1):(_vm.extension(item.file_name) === 'media')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('video',{attrs:{"width":"200","height":"130","controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):(_vm.extension(item.file_name) === 'audio')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_c('v-flex',{attrs:{"xs12":""}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v(_vm._s(_vm.extension(item.file_name)))])],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white !important"}},[_vm._v(_vm._s(item.file_name))])])]),_vm._v(" "),(_vm.extension(item.file_name) !== 'pdf')?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.loadfile(item)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"blue","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("cloud_upload")])],1)],1):_vm._e()],1):(item.typeofmessage === 'file' || item.typeofmessage === 'password_file' )?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"500px"},attrs:{"slot":"activator"},slot:"activator"},[_c('v-flex',{attrs:{"xs12":""},on:{"click":function($event){_vm.setting_dialog(item, 'forward')}}},[(_vm.extension(item.file_name) === 'pdf')?_c('v-icon',{staticStyle:{"color":"white","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"white","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v(_vm._s(_vm.extension(item.file_name)))])],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white !important"}},[_vm._v(_vm._s(item.file_name))])])]),_vm._v(" "),_c('v-card-actions',[(item.typeofmessage == 'password_file')?_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-lock")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":_vm.statemember !== 'active'}},[(_vm.extension(item.file_name) == 'pdf')?_c('v-icon',{on:{"click":function($event){_vm.setting_dialog(item, 'forward')}}},[_vm._v("visibility")]):_c('v-icon',{on:{"click":function($event){_vm.setting_dialog(item, 'download')}}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"blue","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("cloud_upload")])],1)],1)],1):(item.typeofmessage === 'pdf_password')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"500px","cursor":"pointer"},attrs:{"slot":"activator"},slot:"activator"},[(_vm.extension(item.file_name) === 'pdf')?_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center","cursor":"pointer"},attrs:{"xs12":""},on:{"click":function($event){_vm.setting_dialog(item, 'forward')}}},[_c('v-card-media',{staticStyle:{"width":"45vw","border-radius":"10px"},attrs:{"height":"70px"}},[_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":"https://testchat.one.th/alpine/api/v1/file/J0CDcdbm1zUba7cb86c384f5fa5b3eae7269b4993ce_2022-08-17_18:29:28:894891.pdf","page":1}})],1)],1):_vm._e(),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white !important"}},[_vm._v(_vm._s(item.file_name))])])])],1):(item.typeofmessage === 'location')?_c('p',{staticStyle:{"width":"180px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.setting_dialog(item, 'forward')}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#efefef","border-radius":"20px","padding":"10px","padding-bottom":"10px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"}},[_vm._v("place")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"color":"black","padding-left":"5px"},attrs:{"xs10":"","sm10":"","md10":""}},[(item.file_name != '')?_c('span',[_vm._v(" "+_vm._s(item.file_name))]):_c('span',[_vm._v("  "+_vm._s(_vm.$t('ChatSide.location')))])])],1)],1)],1):(item.typeofmessage === 'contact')?_c('v-layout',{staticClass:"chat_othercontact",staticStyle:{"font-weight":"500","cursor":"pointer","margin-bottom":"15px"},attrs:{"slot":"activator","row":"","align-center":"","justify-start":""},on:{"click":function($event){_vm.setting_dialog(item, 'forwardunsend')}},slot:"activator"},[_c('v-flex',{attrs:{"xs5":"","md5":"","sm5":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[(item.pic_contact)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.pic_contact}}):(item.type_contact === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","md5":"","sm5":""}},[_c('v-layout',{staticStyle:{"margin-top":"12px"},attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('p',{staticClass:"text2"},[_vm._v(_vm._s(item.nickname_contact))])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","md2":"","sm2":""}},[_c('v-layout',{attrs:{"align-center":"","justify-end":"","row":"","wrap":""}},[_c('v-icon',[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'call')?_c('p',{staticClass:"chat_other",staticStyle:{"text-align":"center","width":"100px"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='decline')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel' || item.message =='decline')?_c('span',[_vm._v("\n                      "+_vm._s(_vm.checktypeCall(item.message))+"\n                    ")]):_c('span',[_vm._v(_vm._s(_vm.secondsToHms(item.time_count)))])],1):(item.typeofmessage === 'conference_msg')?_c('div',{staticClass:"chat_other",staticStyle:{"text-align":"center","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.information.option == 'voice')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startCall')))],1):(item.information.option == 'video')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("videocam")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startVideo')))],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"joinBtn",on:{"click":function($event){_vm.joinCall_conference_msg(item.information)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.conference.joinCall'))+" ")])],1):(item.typeofmessage === 'agora_call')?_c('div',{staticClass:"chat_other",staticStyle:{"text-align":"center","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='end')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel')?_c('span',[_vm._v("\n                      "+_vm._s(_vm.checktypeCall(item.message))+"\n                    ")]):_c('span',[_vm._v(_vm._s(item.time))])],1):(item.typeofmessage === 'albums_message' && item.image_add.length === 0)?_c('div',{staticClass:"chat_other_createablums",staticStyle:{"width":"180px","display":"none"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailAlbums(item.file_name)}},slot:"activator"},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', { count: item.image_add.length })))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',[_vm._v(_vm._s(item.albums_name))]):_c('h4',[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"},attrs:{"color":"black"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'albums_message' && item.image_add.length !== 0)?_c('div',{staticClass:"chat_other_createablums",staticStyle:{"width":"180px"},attrs:{"slot":"activator"},on:{"click":function($event){_vm.detailAlbums(item.file_name)}},slot:"activator"},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', { count: item.image_add.length })))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',[_vm._v(_vm._s(item.albums_name))]):_c('h4',[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"},attrs:{"color":"black"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'official_template')?_c('div',{staticClass:"chat_other",staticStyle:{"overflow":"hidden","display":"-webkit-inline-box","background":"none"},attrs:{"slot":"activator"},slot:"activator"},[_c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","margin-right":"10px","background":"#efefef !important"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562af","padding-left":"12px","padding-top":"10px","padding-bottom":"10px"}},[_vm._v(_vm._s(item.element.title))]),_vm._v(" "),(item.element.image)?_c('v-img',{staticStyle:{"height":"120px","cursor":"pointer"},attrs:{"src":item.element.image,"contain":""},on:{"click":function($event){_vm.btn_img_official_template(item.element.onclick_img, item.tokenuser)}}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"150px"}},[_c('read-more',{staticClass:"mb-0",staticStyle:{"color":"#343433"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":20}}),_vm._v(" "),(!item.element.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((item.element.choice),function(choice,index){return _c('div',[_c('v-btn',{style:(_vm.checkbutton(choice.color,choice.background)),attrs:{"flat":"","disabled":(choice.disable == '0')? false: true},on:{"click":function($event){_vm.btn_official_template(choice, item.tokenuser, item.tokenmessage)}}},[_vm._v("\n                               "+_vm._s(choice.label)+"\n                             ")])],1)})],2)])],1)],1)]):(item.typeofmessage === 'carousel')?_c('div',{staticClass:"chat_other",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","display":"-webkit-inline-box","background":"none"}},_vm._l((item.elements),function(info_carousel,index){return _c('div',[_c('v-card',{staticStyle:{"border-radius":"20px","width":"200px","margin-right":"10px"}},[(info_carousel.image)?_c('v-img',{staticStyle:{"height":"180px","cursor":"pointer"},attrs:{"src":info_carousel.image,"aspect-ratio":16/9},on:{"click":function($event){_vm.btn_answer_carousel(info_carousel)}}},[(info_carousel.type !== 'image')?_c('v-layout',{staticStyle:{"height":"180px"},attrs:{"row":"","wrap":"","align-end":"","justify-center":""}},[(info_carousel.button)?_c('v-btn',{attrs:{"round":"","color":"#0000009c","dark":""}},[_c('span',{staticClass:"text-transform"},[_vm._v(_vm._s(info_carousel.button))])]):_vm._e()],1):_vm._e()],1):_vm._e()],1)],1)})):_c('p',{staticClass:"chat_other",staticStyle:{"color":"#757575 !important"},attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.notSupportVersion'))+"\n                  ")]),_vm._v(" "),(item.typeofmessage === 'albums_message' && item.image_add.length === 0)?_c('span',{staticStyle:{"font-size":"10px","color":"#616161","margin-bottom":"0px","display":"none"}},[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" ")]):_c('span',{staticStyle:{"font-size":"10px","color":"#616161","margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" ")])],1)],1)],1)],1):_vm._e()],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.items),function(item,i){return (_vm.selected)?_c('div',{key:item.id},[_c('v-layout',{attrs:{"justify-center":"","row":"","align-center":""}},[(i == 0)?_c('div',[(_vm.statusload)?_c('div',{staticClass:"text-xs-center",on:{"click":_vm.loadchathistory}},[_c('v-btn',{staticStyle:{"background":"#ff000000 !important","text-transform":"none"},attrs:{"round":"","outline":"","color":"primary"}},[_c('v-icon',{staticStyle:{"font-size":"18px !important"},attrs:{"left":""},on:{"click":_vm.loadchathistory}},[_vm._v("refresh")]),_vm._v("โหลดข้อความเพิ่ม")],1)],1):_vm._e(),_vm._v(" "),(_vm.tokenrooomSelect === item.tokenroom)?_c('div',{staticClass:"conversation-start",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.dateMoment(item.timestamp))+" ")])]):_vm._e()]):(_vm.dateMoment(item.timestamp) !== _vm.dateMoment(_vm.items[i-1].timestamp))?_c('div',[_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","md12":"","sm12":""}},[(_vm.tokenrooomSelect === item.tokenroom)?_c('div',{staticClass:"conversation-start",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.dateMoment(item.timestamp)))])]):_vm._e()])],1):_vm._e()]),_vm._v(" "),(item.tokenuser === _vm.token && _vm.tokenrooomSelect === item.tokenroom)?_c('div',{ref:item.tokenmessage,refInFor:true,staticClass:"chat self",attrs:{"id":item.tokenmessage}},[(item.typeofmessage === 'unsend_message' || item.typeofmessage === 'system_action' || item.typeofmessage === 'system' || item.typeofmessage === 'system_action_albums' || item.typeofmessage === 'system_action_task')?_c('v-layout',{attrs:{"align-center":"","justify-end":"","row":""}},[(item.typeofmessage === 'unsend_message')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.cancelMsg'))+"\n                  ")])]):(item.typeofmessage === 'system')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('p',{staticClass:"boxself_unsend"},[_vm._v("\n                    "+_vm._s(item.message)+"\n                  ")])]):(item.typeofmessage === 'system_action')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[(item.message === 'active')?_c('p',{staticClass:"boxself_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.joinGroup'))+"\n                  ")]):(item.message === 'kick')?_c('p',{staticClass:"boxself_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', { name_active: item.nickname, name_passive: item.file_name}))+"\n                  ")]):(item.message === 'invite')?_c('p',{staticClass:"boxself_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', { name_active: item.nickname, name_passive: item.file_name}))+"\n                  ")]):(item.message === 'leave')?_c('p',{staticClass:"boxself_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.leftGroup'))+"\n                  ")]):_vm._e()]):_vm._e(),_vm._v(" "),(item.typeofmessage === 'system_action_albums')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"1vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_name_albums')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.editNameAlbum'))+"\n                  ")]):(item.message == 'create_albums')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.createAlbum', { name: item.albums_name}))+"\n                  ")]):(item.message == 'delete_albums')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.deleteAlbum'))+"\n                  ")]):(item.message == 'delete_images_albums')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.deleteImageAlbum'))+"\n                  ")]):_vm._e()]):_vm._e(),_vm._v(" "),(item.typeofmessage === 'system_action_task')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"1vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_task')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.editTask'))+"\n                  ")]):(item.message == 'create_project')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.self.editTask'))+"\n                  ")]):_vm._e()]):_vm._e()],1):_c('v-layout',{staticStyle:{"margin-bottom":"15px","margin-top":"15px"},attrs:{"align-center":"","justify-end":"","row":""}},[_c('v-flex',{staticStyle:{"float":"right"},attrs:{"xs10":""}},[_c('v-layout',{staticStyle:{"float":"right"},attrs:{"row":"","wrap":"","align-end":""}},[(item.typeofmessage == 'albums_message' && item.image_add.length == 0)?_c('span',{staticStyle:{"font-size":"10px","color":"#616161","margin-bottom":"0px","display":"none"}},[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" ")]):_c('span',{staticStyle:{"font-size":"10px","color":"#616161","margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" ")]),_vm._v(" "),(item.typeofmessage === 'message')?_c('div',{staticClass:"chat_self",attrs:{"slot":"activator"},slot:"activator"},[_c('p',{staticStyle:{"margin":"0 !important"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),_vm._l((_vm.convertURL(item.message)),function(x){return (_vm.convertURL(item.message))?_c('div',[_c('link-prevue',{attrs:{"url":x},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"row":"","wrap":""},on:{"click":function($event){_vm.clicklink_website(props.url)}}},[_c('v-flex',{staticClass:"border_website",attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[_c('p',{staticClass:"title_website"},[_vm._v(_vm._s(props.title))]),_vm._v(" "),_c('span',{staticClass:"description_website"},[_vm._v(_vm._s(props.description))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerimg_website",attrs:{"xl9":"","lg9":"","md9":"","sm9":""}},[(props.img)?_c('img',{staticClass:"img_website",attrs:{"src":props.img}}):_vm._e()])],1)]}}])},[_c('template',{slot:"loading"},[_c('span')])],2)],1):_vm._e()})],2):(item.typeofmessage === 'mention_message')?_c('p',{staticClass:"chat_self",attrs:{"slot":"activator"},slot:"activator"},[(item.source_message.typeofmessage !== 'unsend_message')?_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(item.source_message.owner_source_message.path_pic)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":item.source_message.owner_source_message.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"40px"},attrs:{"xs11":""}},[(item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.source_message.message))])]):(item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.typeofmessage === 'image')?_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.image')))]):_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.sticker')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"10px","float":"right"},attrs:{"src":item.source_message.message}})])],1):(item.source_message.typeofmessage === 'file')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(_vm.extension(item.source_message.message) === 'pdf')?_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v(_vm._s(_vm.extension(item.source_message.message)))])],1)],1):(item.source_message.typeofmessage === 'video')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"100","height":"100","controls":""}},[_c('source',{attrs:{"src":item.source_message.message,"type":'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]}})])])],1):(item.source_message.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.address !== '')?_c('span',[_vm._v(_vm._s(item.source_message.address))]):_c('span',[_vm._v(_vm._s(item.source_message.message))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-map-marker-alt")])],1)],1):_vm._e()],1)],1):_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.noMsg')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):(item.typeofmessage === 'task_message' && item.message === 'create_task')?_c('p',{staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#3a506d"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#3a506db3"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#6981a1 !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()}),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"#e6ecf3","outline":"","text-color":"#3a506d"}},[_vm._v("\n                              "+_vm._s(item.task_info.state.name)+"\n                            ")])],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#6981a1 !important"}},[_vm._v("\n                            "+_vm._s(_vm.$t('ChatSide.Task.viewDetail'))+"\n                          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#6981a1 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'assign_task')?_c('p',{staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#b4d1f5","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#3a506d"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#3a506db3"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#6981a1 !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#cde1f9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()})],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#6981a1 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Task.editAssign')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#6981a1 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'image')?_c('p',{staticClass:"boxselfimage",staticStyle:{"width":"500px"}},[_c('v-img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.message,"height":"200px"}})],1):(item.typeofmessage === 'sticker')?_c('p',{staticStyle:{"margin-top":"0","height":"100%"}},[_c('img',{staticClass:"boxselfsticker",attrs:{"src":item.file_name}})]):(item.typeofmessage === 'web')?_c('div',{staticClass:"boxselffile",staticStyle:{"width":"500px"}},[_c('iframe',{staticStyle:{"visibility":"visible","max-width":"55vw !important"},attrs:{"height":"400","frameborder":"0","src":item.message}})]):(item.typeofmessage === 'note')?_c('div',{staticClass:"chat_self",staticStyle:{"font-weight":"500","width":"200px !important","margin-bottom":"10px"}},[_c('p',{staticClass:"textchat",staticStyle:{"color":"#5a616b !important"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length ==20)?_c('p',[_vm._v(" ...")]):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"color":"#5a616b !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#5a616b !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1):(item.typeofmessage === 'contact')?_c('v-layout',{staticClass:"chat_selfcontact",staticStyle:{"font-weight":"500","margin-top":"15px"},attrs:{"row":"","align-center":"","justify-start":""}},[_c('v-flex',{attrs:{"xs5":"","md5":"","sm5":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[(item.pic_contact)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.pic_contact}}):(item.type_contact === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","md5":"","sm5":""}},[_c('v-layout',{staticStyle:{"margin-top":"12px"},attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('p',{staticClass:"text2"},[_vm._v(_vm._s(item.nickname_contact))])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","md2":"","sm2":""}},[_c('v-layout',{attrs:{"align-center":"","justify-end":"","row":"","wrap":""}},[_c('v-icon',[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'video')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"500px","cursor":"pointer"}},[(_vm.extension(item.message) === 'media')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('video',{attrs:{"width":"180","height":"130","controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):(_vm.extension(item.file_name) === 'audio')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticStyle:{"width":"100%","height":"130px","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"130px !important"},attrs:{"playerOptions":{
                              type: 'application/x-mpegURL',
                              src: item.message,
                              preload: true,
                              autoplay: false,
                              isLoop: false,
                              playsinline: false,
                              poster: '',
                              controls: 'progress,current,durration,volume',
                              crossOrigin: false
                            }},on:{"onplay":_vm.play}})],1)]),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white"}},[_vm._v(_vm._s(item.file_name))])])]),_vm._v(" "),(_vm.extension(item.file_name) !== 'pdf')?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.loadfile(item)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"blue"},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("cloud_upload")])],1)],1):_vm._e()],1):(item.typeofmessage === 'file' && (_vm.extension(item.file_name) === 'pdf'))?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"500px"}},[(_vm.extension(item.file_name) === 'pdf')?_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('v-card-media',{staticStyle:{"width":"45vw","border-radius":"10px"},attrs:{"height":"70px"}},[_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":item.message,"page":1},on:{"password":function($event){_vm.passwordPdf($event, i, item)},"error":_vm.errorPdf}})],1)],1):(_vm.extension(item.file_name) === 'media')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('video',{attrs:{"width":"200","height":"130","controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):(_vm.extension(item.file_name) === 'audio')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_c('v-flex',{attrs:{"xs12":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v(_vm._s(_vm.extension(item.file_name)))])],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white !important"}},[_vm._v(_vm._s(item.file_name))])])]),_vm._v(" "),(_vm.extension(item.file_name) !== 'pdf')?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":""},on:{"click":function($event){_vm.loadfile(item)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"blue","disabled":""},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("cloud_upload")])],1)],1):_vm._e()],1):(item.typeofmessage === 'file')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"500px"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v(_vm._s(_vm.extension(item.file_name)))])],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white !important"}},[_vm._v(_vm._s(item.file_name))])])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":""},on:{"click":function($event){_vm.loadfile(item)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"blue","disabled":""},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("cloud_upload")])],1)],1)],1):(item.typeofmessage === 'pdf_password')?_c('p',{staticClass:"boxselffile",staticStyle:{"width":"500px","cursor":"pointer"},attrs:{"slot":"activator"},slot:"activator"},[(_vm.extension(item.file_name) === 'pdf')?_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center","cursor":"pointer"},attrs:{"xs12":""}},[_c('v-card-media',{staticStyle:{"width":"45vw","border-radius":"10px"},attrs:{"height":"70px"}},[_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":"https://testchat.one.th/alpine/api/v1/file/J0CDcdbm1zUba7cb86c384f5fa5b3eae7269b4993ce_2022-08-17_18:29:28:894891.pdf","page":1}})],1)],1):_vm._e(),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white !important"}},[_vm._v(_vm._s(item.file_name))])])])],1):(item.typeofmessage === 'location')?_c('p',{staticStyle:{"width":"180px","margin-top":"15px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#b4d1f5","border-radius":"20px","padding":"10px","padding-bottom":"10px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"},attrs:{"raw":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"}},[_vm._v("place")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"color":"black","padding-left":"5px"},attrs:{"xs10":"","sm10":"","md10":""}},[(item.file_name != '')?_c('span',[_vm._v(" "+_vm._s(item.file_name))]):_c('span',[_vm._v("  "+_vm._s(_vm.$t('ChatSide.location')))])])],1)],1)],1):(item.typeofmessage=='date')?_c('p',{staticClass:"chat_self"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message)))],1):(item.typeofmessage=='datetime')?_c('p',{staticClass:"chat_self"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))),_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v(" far fa-clock")]),_vm._v("   "+_vm._s(item.message.split('T')[1]))],1):(item.typeofmessage === 'call')?_c('p',{staticClass:"chat_self",staticStyle:{"text-align":"center","width":"100px"}},[(item.message =='cancel' || item.message =='decline')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel' || item.message =='decline')?_c('span',[_vm._v("\n                        "+_vm._s(_vm.checktypeCall(item.message))+"\n                      ")]):_c('span',[_vm._v(_vm._s(_vm.secondsToHms(item.time_count)))])],1):(item.typeofmessage === 'conference_msg')?_c('div',{staticClass:"chat_self",staticStyle:{"text-align":"center","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.information.option == 'voice')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startCall')))],1):(item.information.option == 'video')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("videocam")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startVideo')))],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"joinBtn",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.$t('ChatSide.conference.joinCall'))+" ")])],1):(item.typeofmessage === 'agora_call')?_c('div',{staticClass:"chat_self",staticStyle:{"text-align":"center","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='end')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel')?_c('span',[_vm._v("\n                        "+_vm._s(_vm.checktypeCall(item.message))+"\n                      ")]):_c('span',[_vm._v(_vm._s(item.time))])],1):(item.typeofmessage === 'albums_message' && item.image_add.length === 0)?_c('div',{staticClass:"chat_self_createablums",staticStyle:{"width":"180px","display":"none"}},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', { count: item.image_add.length })))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',[_vm._v(_vm._s(item.albums_name))]):_c('h4',[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"},attrs:{"color":"black"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'albums_message' && item.image_add.length !== 0)?_c('div',{staticClass:"chat_self_createablums",staticStyle:{"width":"180px"}},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', { count: item.image_add.length })))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',[_vm._v(_vm._s(item.albums_name))]):_c('h4',[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"},attrs:{"color":"black"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'official_template')?_c('div',{staticClass:"chat_self",staticStyle:{"overflow":"hidden","display":"-webkit-inline-box","background":"none"}},[_c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","margin-right":"10px","background":"#b4d1f5 !important"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562af","padding-left":"12px","padding-top":"10px","padding-bottom":"10px"}},[_vm._v(_vm._s(item.element.title))]),_vm._v(" "),(item.element.image)?_c('v-img',{staticStyle:{"height":"120px"},attrs:{"src":item.element.image,"contain":""}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"150px"}},[_c('read-more',{staticClass:"mb-0",staticStyle:{"color":"#343433"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":20}}),_vm._v(" "),(!item.element.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((item.element.choice),function(choice,index){return _c('div',[_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px","border-radius":"20px"},attrs:{"flat":"","disabled":""}},[_vm._v("\n                                  "+_vm._s(choice.label)+"\n                                ")])],1)})],2)])],1)],1)]):_c('p',{staticClass:"chat_self"},[_vm._v("\n                      "+_vm._s(_vm.$t('ChatSide.notSupportVersion'))+"\n                    ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[(item.typeofmessage == 'message' || item.typeofmessage == 'image' || item.typeofmessage == 'file' || item.typeofmessage == 'pdf_password' || item.typeofmessage == 'location' || item.typeofmessage == 'video')?_c('v-checkbox',{staticStyle:{"float":"right"},attrs:{"value":item.tokenmessage},model:{value:(_vm.selectedmessage),callback:function ($$v) {_vm.selectedmessage=$$v},expression:"selectedmessage"}}):(item.typeofmessage == 'albums_message' && item.image_add.length === 0)?_c('v-checkbox',{staticStyle:{"float":"right","display":"none"}}):_c('v-checkbox',{staticStyle:{"float":"right"},attrs:{"disabled":""}})],1)],1)],1):_vm._e(),_vm._v(" "),(item.tokenuser !== _vm.token && _vm.tokenrooomSelect === item.tokenroom)?_c('div',{ref:item.tokenmessage,refInFor:true,staticClass:"chat other",staticStyle:{"margin-bottom":"10px"},attrs:{"id":item.tokenmessage}},[(item.typeofmessage === 'unsend_message' || item.typeofmessage === 'system_action' || item.typeofmessage === 'system' || item.typeofmessage === 'system_action_albums' || item.typeofmessage === 'system_action_task')?_c('v-layout',{attrs:{"align-center":"","row":"","wrap":""}},[(item.typeofmessage === 'unsend_message')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n                      "+_vm._s(_vm.$t('ChatSide.system.other.cancelMsg', { name: item.nickname }))+"\n                    ")])])],1):(item.typeofmessage === 'system')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('p',{staticClass:"boxother_unsend"},[_vm._v("\n                      "+_vm._s(item.message)+"\n                    ")])])],1):(item.typeofmessage === 'system_action')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"25px","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[(item.message === 'active')?_c('p',{staticClass:"boxother_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.joinGroup', { name: item.nickname }))+"\n                  ")]):(item.message === 'kick')?_c('p',{staticClass:"boxother_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', { name_active: item.nickname, name_passive: item.file_name }))+"\n                  ")]):(item.message === 'invite')?_c('p',{staticClass:"boxother_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp)))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', { name_active: item.nickname, name_passive: item.file_name }))+"\n                  ")]):(item.message === 'leave')?_c('p',{staticClass:"boxother_system"},[_c('span',[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.leftGroup', { name: item.nickname }))+"\n                  ")]):_vm._e()]):_vm._e(),_vm._v(" "),(item.typeofmessage === 'system_action_albums')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"1vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_name_albums')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.editNameAlbum', { name: item.nickname }))+"\n                  ")]):(item.message == 'create_albums')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.createAlbum', { name: item.nickname, album_name: item.albums_name }))+"\n                  ")]):(item.message == 'delete_albums')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.deleteAlbum', { name: item.nickname }))+"\n                  ")]):(item.message == 'delete_images_albums')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.deleteImageAlbum', { name: item.nickname }))+"\n                  ")]):_vm._e()]):_vm._e(),_vm._v(" "),(item.typeofmessage === 'system_action_task')?_c('v-flex',{staticStyle:{"padding-right":"0px","margin-top":"1vh","margin-bottom":"0","justify-content":"center","display":"flex"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[(item.message == 'edit_task')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.editTask', {name: item.nickname}))+"\n                  ")]):(item.message == 'create_project')?_c('p',{staticClass:"boxself_system"},[_vm._v("\n                    "+_vm._s(_vm.$t('ChatSide.system.other.editTask', {name: item.nickname}))+"\n                  ")]):_vm._e()]):_vm._e()],1):_c('v-layout',{staticStyle:{"margin-top":"15px"},attrs:{"justify-start":"","row":""}},[(item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system')?_c('v-flex',{staticStyle:{"padding-right":"10px"},attrs:{"xs1":""}},[(item.typeofmessage == 'albums_message' && item.image_add.length == 0)?_c('div',{staticStyle:{"display":"none"}},[(item.path_pic !== '')?_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.path_pic}})]):_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[(item.type === 'user')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):(item.type === 'company')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1):_c('div',[(item.path_pic !== '')?_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.path_pic}})]):_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[(item.type === 'user')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):(item.type === 'company')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{staticStyle:{"float":"left"},attrs:{"xs10":""}},[_c('v-layout',{staticStyle:{"float":"left","padding-left":"0px"},attrs:{"row":"","wrap":"","align-end":""}},[(item.typeofmessage === 'message')?_c('div',{staticClass:"chat_other",attrs:{"slot":"activator"},slot:"activator"},[_c('p',{staticStyle:{"margin":"0 !important"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),_vm._l((_vm.convertURL(item.message)),function(x){return (_vm.convertURL(item.message))?_c('div',[_c('link-prevue',{attrs:{"url":x},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"row":"","wrap":""},on:{"click":function($event){_vm.clicklink_website(props.url)}}},[_c('v-flex',{staticClass:"border_website",attrs:{"xl3":"","lg3":"","md3":"","sm3":""}},[_c('p',{staticClass:"title_website"},[_vm._v(_vm._s(props.title))]),_vm._v(" "),_c('span',{staticClass:"description_website"},[_vm._v(_vm._s(props.description))])]),_vm._v(" "),_c('v-flex',{staticClass:"centerimg_website",attrs:{"xl9":"","lg9":"","md9":"","sm9":""}},[(props.img)?_c('img',{staticClass:"img_website",attrs:{"src":props.img}}):_vm._e()])],1)]}}])},[_c('template',{slot:"loading"},[_c('span')])],2)],1):_vm._e()})],2):(item.typeofmessage === 'image')?_c('p',{staticClass:"boxfriendimage",staticStyle:{"width":"500px"}},[_c('v-img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.message,"height":"200px"}})],1):(item.typeofmessage === 'template')?_c('div',{staticClass:"boxfriendquestion scrolling-wrapper-template",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","display":"flex","background":"none","width":"275px","padding":"10px","align-items":"end"},attrs:{"slot":"activator"},slot:"activator"},_vm._l((item.info_ans),function(info_ans,index){return _c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","width":"200px","margin-right":"10px"}},[(info_ans.image)?_c('v-img',{staticStyle:{"height":"120px"},attrs:{"src":info_ans.image,"aspect-ratio":"2.75"}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"176px"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562ae"}},[_vm._v(_vm._s(info_ans.title))]),_vm._v(" "),_c('p',{staticClass:"mb-0",staticStyle:{"display":"-webkit-box","-webkit-line-clamp":"2","-webkit-box-orient":"vertical","overflow":"hidden","text-overflow":"ellipsis"},domProps:{"innerHTML":_vm._s(_vm.convert(info_ans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(info_ans.detail.length >= 40)?_c('a',{on:{"click":function($event){_vm.clickReadmore(info_ans)}}},[_c('b',[_vm._v(_vm._s(_vm.$t('ChatSide.Read.readmore')))])]):_vm._e(),_vm._v(" "),(!info_ans.image)?_c('v-divider',{staticClass:"mt-2",attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((info_ans.choice),function(choice,index){return _c('div',[(choice.type=='file')?_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px"},attrs:{"disabled":"","block":"","flat":"","color":"primary"},on:{"click":function($event){_vm.ans_question(choice, item.tokenmessage, item.tokenuser)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-download")]),_vm._v("    "),_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px"},attrs:{"disabled":"","flat":"","color":"primary"},on:{"click":function($event){_vm.ans_question(choice, item.tokenmessage, item.tokenuser)}}},[_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})])],1)})],2)])],1)],1)})):(item.typeofmessage === 'mention_message')?_c('p',{staticClass:"chat_other",attrs:{"slot":"activator"},slot:"activator"},[(item.source_message.typeofmessage !== 'unsend_message')?_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(item.source_message.owner_source_message.path_pic)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":item.source_message.owner_source_message.path_pic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"40px"},attrs:{"xs11":""}},[(item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(item.source_message.message))])]):(item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.typeofmessage === 'image')?_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.image')))]):_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.sticker')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"10px","float":"right"},attrs:{"src":item.source_message.message}})])],1):(item.source_message.typeofmessage === 'file')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(_vm.extension(item.source_message.message) === 'pdf')?_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v(_vm._s(_vm.extension(item.source_message.message)))])],1)],1):(item.source_message.typeofmessage === 'video')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"100","height":"100","controls":""}},[_c('source',{attrs:{"src":item.source_message.message,"type":'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]}})])])],1):(item.source_message.typeofmessage === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(item.source_message.owner_source_message.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(item.source_message.address !== '')?_c('span',[_vm._v(_vm._s(item.source_message.address))]):_c('span',[_vm._v(_vm._s(item.source_message.message))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-icon',{staticStyle:{"color":"black","width":"40px","height":"40px","float":"right"}},[_vm._v("fas fa-map-marker-alt")])],1)],1):_vm._e()],1)],1):_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","wrap":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('ChatSide.noMsg')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})],1):(item.typeofmessage === 'task_message' && item.message === 'create_task')?_c('p',{staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#444444"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#444444c2"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#7c7c7c !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()}),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"#dcd9d9","outline":"","text-color":"#3a506d"}},[_vm._v("\n                              "+_vm._s(item.task_info.state.name)+"\n                            ")])],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#818181 !important"}},[_vm._v("\n                            "+_vm._s(_vm.$t('ChatSide.Task.viewDetail'))+"\n                          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#818181 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'task_message' && item.message === 'assign_task')?_c('p',{staticStyle:{"width":"200px","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){}},slot:"activator"},[_c('v-card',{staticClass:"white--text",staticStyle:{"background":"#efefef","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[(item.task_info.priority == '1')?_c('v-flex',{staticStyle:{"background-color":"rgb(179, 73, 61)","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '2')?_c('v-flex',{staticStyle:{"background-color":"#fcbe54","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):(item.task_info.priority == '3')?_c('v-flex',{staticStyle:{"background-color":"#a0a1a3","border-radius":"10px","height":"50px","margin-right":"10px"},attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":"","lg11":"","xl11":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('h2',{staticStyle:{"margin-right":"15px","color":"#444444"}},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-right":"15px","color":"#444444c2"}},[_vm._v(_vm._s(item.task_info.title))])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",staticStyle:{"border-color":"#31394121 !important"},attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('p',{staticClass:"text-task-detail",domProps:{"innerHTML":_vm._s(_vm.convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.task_info.assign)?_c('p',{staticStyle:{"color":"#7c7c7c !important","margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.Task.assign'))+":")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","text-align":"left"}},[(_vm.checkuserinassign(item.task_info.assign))?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(_vm.profile)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e(),_vm._v(" "),_vm._l((item.task_info.assign),function(assign){return (assign.tokenuser != _vm.token)?_c('v-chip',{staticStyle:{"background":"#dcd9d9 !important"},attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":"","color":"#2662af"}},[(assign.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":assign.path_pic}}):_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(assign.nickname[0]))])]),_vm._v(" "),_c('span',{staticClass:"test-overflow-chip"},[_vm._v(_vm._s(assign.nickname))])],1):_vm._e()})],2)]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-left":"0px !important"}},[_c('span',{staticStyle:{"color":"#818181 !important"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Task.editAssign')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#818181 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'approve_message' && item.disable === 'false' && _vm.selected === false)?_c('p',{staticStyle:{"width":"150px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"white","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"145px"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',{staticStyle:{"color":"#2562ae !important"}},[_vm._v(_vm._s(item.info_ans[0].title))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#9d9d9d !important"}},[_vm._v(_vm._s(item.info_ans[0].short_detail))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('span',{staticStyle:{"color":"#2562ae !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.viewDetail'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#2562ae !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'approve_message' && item.disable === 'true' && _vm.selected === false)?_c('p',{staticStyle:{"width":"150px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"white","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"145px"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',{staticStyle:{"color":"#757575 !important"}},[_vm._v(_vm._s(item.info_ans[0].title))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#9d9d9d !important"}},[_vm._v(_vm._s(item.info_ans[0].short_detail))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',[_c('span',{staticStyle:{"color":"#757575 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.receiveAns'))+" ")])])],1)],1):(item.typeofmessage === 'approve_message' && _vm.selected === true)?_c('p',{staticStyle:{"width":"150px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"white","border-radius":"10px","padding":"10px","padding-bottom":"0px","width":"145px"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',{staticStyle:{"color":"#757575 !important"}},[_vm._v(_vm._s(item.info_ans[0].title))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#9d9d9d !important"}},[_vm._v(_vm._s(item.info_ans[0].short_detail))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),(item.disable === 'false')?_c('v-card-actions',[_c('span',{staticStyle:{"color":"#757575 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.viewDetail'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#757575 !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1):_c('v-card-actions',[_c('span',{staticStyle:{"color":"#757575 !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.approve_message.receiveAns'))+" ")])])],1)],1):(item.typeofmessage === 'official_template')?_c('div',{staticClass:"chat_other",staticStyle:{"overflow":"hidden","display":"-webkit-inline-box","background":"none"}},[_c('div',[_c('v-card',{staticStyle:{"border-radius":"10px","margin-right":"10px","background":"#efefef !important"}},[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#2562af","padding-left":"12px","padding-top":"10px","padding-bottom":"10px"}},[_vm._v(_vm._s(item.element.title))]),_vm._v(" "),(item.element.image)?_c('v-img',{staticStyle:{"height":"120px"},attrs:{"src":item.element.image,"contain":""}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticStyle:{"padding-top":"15px !important"},attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"150px"}},[_c('read-more',{staticClass:"mb-0",staticStyle:{"color":"#343433"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'),"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":20}}),_vm._v(" "),(!item.element.image)?_c('v-divider',{attrs:{"light":""}}):_vm._e(),_vm._v(" "),_vm._l((item.element.choice),function(choice,index){return _c('div',[_c('v-btn',{staticStyle:{"text-transform":"none","width":"100%","margin":"0","font-size":"13px","border-radius":"20px"},attrs:{"flat":"","disabled":""}},[_vm._v("\n                                  "+_vm._s(choice.label)+"\n                                ")])],1)})],2)])],1)],1)]):(item.typeofmessage == 'date')?_c('p',{staticClass:"chat_other"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("   "+_vm._s(_vm.momentday(item.message))+"\n                    ")],1):(item.typeofmessage == 'datetime')?_c('p',{staticClass:"chat_other"},[_c('v-icon',{staticStyle:{"font-size":"18px","color":"#4065b4"}},[_vm._v(" far fa-calendar-alt")]),_vm._v("  "+_vm._s(_vm.momentday(item.message))),_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v(" far fa-clock")]),_vm._v("   "+_vm._s(item.message.split('T')[1])+"\n                    ")],1):(item.typeofmessage == 'web')?_c('div',{staticClass:"boxfriendfile",staticStyle:{"width":"500px"}},[_c('iframe',{staticStyle:{"visibility":"visible","max-width":"55vw !important"},attrs:{"height":"400","frameborder":"0","src":item.message}})]):(item.typeofmessage === 'note')?_c('div',{staticClass:"chat_other",staticStyle:{"font-weight":"500","width":"200px !important","margin-bottom":"10px"}},[_c('p',{staticClass:"textchat",staticStyle:{"color":"#5a616b !important"},domProps:{"innerHTML":_vm._s(_vm.convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),(item.message.length == 20)?_c('p',[_vm._v(" ...")]):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticStyle:{"color":"#5a616b !important"}},[_vm._v(" "+_vm._s(_vm.$t('ChatSide.note'))+" ")]),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#5a616b !important","right":"0","position":"absolute"}},[_vm._v("navigate_next ")])],1):(item.typeofmessage === 'sticker')?_c('p',{staticStyle:{"margin-top":"0","height":"100%"}},[_c('img',{staticClass:"boxfriendsticker",attrs:{"src":item.file_name}})]):(item.typeofmessage === 'video')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"500px"}},[(_vm.extension(item.message) === 'media')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('video',{attrs:{"width":"180","height":"130","controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):(_vm.extension(item.file_name) === 'audio')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticStyle:{"width":"100%","height":"150px","justify-content":"center","align-items":"center"}},[_c('vplayer',{staticStyle:{"height":"150px !important"},attrs:{"playerOptions":{
                              type: 'application/x-mpegURL',
                              src: item.message,
                              preload: true,
                              autoplay: false,
                              isLoop: false,
                              playsinline: false,
                              poster: '',
                              controls: 'progress,current,durration,volume',
                              crossOrigin: false
                            }},on:{"onplay":_vm.play}})],1)]),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white"}},[_vm._v(_vm._s(item.file_name))])])]),_vm._v(" "),(_vm.extension(item.file_name) !== 'pdf')?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":""},on:{"click":function($event){_vm.loadfile(item)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"blue","disabled":""},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("cloud_upload")])],1)],1):_vm._e()],1):(item.typeofmessage === 'file' && (_vm.extension(item.file_name)) === 'pdf')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"500px"}},[(_vm.extension(item.file_name) === 'pdf')?_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('v-card-media',{staticStyle:{"width":"45vw","border-radius":"10px"},attrs:{"height":"70px"}},[_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":item.message,"page":1},on:{"password":function($event){_vm.passwordPdf($event, i, item)},"error":_vm.errorPdf}})],1)],1):(_vm.extension(item.message) === 'media')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('video',{attrs:{"width":"200","height":"130","controls":""}},[_c('source',{attrs:{"src":item.message,"type":'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):(_vm.extension(item.file_name) === 'audio')?_c('v-flex',{staticStyle:{"margin-top":"1vh","display":"flex","justify-content":"center"},attrs:{"xs12":""}},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":item.message,"type":'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]}})])]):_c('v-flex',{attrs:{"xs12":""}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v(_vm._s(_vm.extension(item.file_name)))])],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white !important"}},[_vm._v(_vm._s(item.file_name))])])]),_vm._v(" "),(_vm.extension(item.file_name) !== 'pdf')?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":""},on:{"click":function($event){_vm.loadfile(item)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"blue","disabled":""},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("cloud_upload")])],1)],1):_vm._e()],1):(item.typeofmessage === 'file' || item.typeofmessage === 'password_file' )?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"500px"}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.extension(item.file_name) === 'pdf')?_c('v-icon',{staticStyle:{"color":"white","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"white","font-size":"60px !important","display":"flex","justify-content":"center","margin-top":"1vh"}},[_vm._v(_vm._s(_vm.extension(item.file_name)))])],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white !important"}},[_vm._v(_vm._s(item.file_name))])])]),_vm._v(" "),_c('v-card-actions',[(item.typeofmessage == 'password_file')?_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-lock")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"white","disabled":""},on:{"click":function($event){_vm.loadfile(item)}}},[(_vm.extension(item.file_name) == 'pdf')?_c('v-icon',[_vm._v("visibility")]):_c('v-icon',[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"blue","disabled":""},on:{"click":function($event){_vm.sendimgonebox(item.tokenmessage)}}},[_c('v-icon',{staticStyle:{"color":"inherit","font-size":"25px !important"}},[_vm._v("cloud_upload")])],1)],1)],1):(item.typeofmessage === 'pdf_password')?_c('p',{staticClass:"boxfriendfile",staticStyle:{"width":"500px","cursor":"pointer"},attrs:{"slot":"activator"},slot:"activator"},[(_vm.extension(item.file_name) === 'pdf')?_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center","cursor":"pointer"},attrs:{"xs12":""}},[_c('v-card-media',{staticStyle:{"width":"45vw","border-radius":"10px"},attrs:{"height":"70px"}},[_c('pdf',{ref:"myPdfComponent",refInFor:true,attrs:{"src":"https://testchat.one.th/alpine/api/v1/file/J0CDcdbm1zUba7cb86c384f5fa5b3eae7269b4993ce_2022-08-17_18:29:28:894891.pdf","page":1}})],1)],1):_vm._e(),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","word-break":"break-all !important","font-size":"12px","color":"white !important"}},[_vm._v(_vm._s(item.file_name))])])])],1):(item.typeofmessage === 'location')?_c('p',{staticStyle:{"width":"180px"}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#efefef","border-radius":"20px","padding":"10px","padding-bottom":"10px","width":"100%"}},[_c('v-layout',{staticStyle:{"text-align":"left"}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-icon',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"}},[_vm._v("place")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"color":"black","padding-left":"5px"},attrs:{"xs10":"","sm10":"","md10":""}},[(item.file_name != '')?_c('span',[_vm._v(" "+_vm._s(item.file_name))]):_c('span',[_vm._v("  "+_vm._s(_vm.$t('ChatSide.location')))])])],1)],1)],1):(item.typeofmessage === 'contact')?_c('v-layout',{staticClass:"chat_othercontact",staticStyle:{"font-weight":"500","margin-bottom":"15px"},attrs:{"slot":"activator","row":"","align-center":"","justify-start":""},slot:"activator"},[_c('v-flex',{attrs:{"xs5":"","md5":"","sm5":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"40px"}},[(item.pic_contact)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.pic_contact}}):(item.type_contact === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type_contact === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","md5":"","sm5":""}},[_c('v-layout',{staticStyle:{"margin-top":"12px"},attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('p',{staticClass:"text2"},[_vm._v(_vm._s(item.nickname_contact))])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","md2":"","sm2":""}},[_c('v-layout',{attrs:{"align-center":"","justify-end":"","row":"","wrap":""}},[_c('v-icon',[_vm._v("navigate_next ")])],1)],1)],1):(item.typeofmessage === 'call')?_c('p',{staticClass:"chat_other",staticStyle:{"text-align":"center","width":"100px"}},[(item.message == 'cancel' || item.message == 'decline')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#676767"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message == 'cancel' || item.message == 'decline')?_c('span',[_vm._v("\n                        "+_vm._s(_vm.checktypeCall(item.message))+"\n                      ")]):_c('span',[_vm._v(_vm._s(_vm.secondsToHms(item.time_count)))])],1):(item.typeofmessage === 'conference_msg')?_c('div',{staticClass:"chat_other",staticStyle:{"text-align":"center","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.information.option == 'voice')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startCall')))],1):(item.information.option == 'video')?_c('span',[_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("videocam")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.$t('ChatSide.conference.startVideo')))],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"joinBtn",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.$t('ChatSide.conference.joinCall'))+" ")])],1):(item.typeofmessage === 'agora_call')?_c('div',{staticClass:"chat_other",staticStyle:{"text-align":"center","font-weight":"500 !important"},attrs:{"slot":"activator"},slot:"activator"},[(item.message =='cancel' || item.message =='end')?_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone")]):_c('v-icon',{staticStyle:{"font-size":"30px","color":"#4065b4"}},[_vm._v("phone_in_talk")]),_vm._v(" "),_c('br'),_vm._v(" "),(item.message =='cancel')?_c('span',[_vm._v("\n                        "+_vm._s(_vm.checktypeCall(item.message))+"\n                      ")]):_c('span',[_vm._v(_vm._s(item.time))])],1):(item.typeofmessage === 'albums_message' && item.image_add.length === 0)?_c('div',{staticClass:"chat_other_createablums",staticStyle:{"width":"180px","display":"none"}},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', { count: item.image_add.length })))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',[_vm._v(_vm._s(item.albums_name))]):_c('h4',[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"},attrs:{"color":"black"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'albums_message' && item.image_add.length !== 0)?_c('div',{staticClass:"chat_other_createablums",staticStyle:{"width":"180px"}},[(item.message !== 'addimage_albums')?_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.createAlbumHeader')))]):_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.image_add.length!=0)?_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.image_add[0].link,"height":"150px","width":"130px"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0"},[_vm._v(_vm._s(_vm.$t('ChatSide.Album.numberImage', { count: item.image_add.length })))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(item.albums_name != '')?_c('h4',[_vm._v(_vm._s(item.albums_name))]):_c('h4',[_vm._v(_vm._s(_vm.dateMoment(item.create_date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"16px"},attrs:{"color":"black"}},[_vm._v("fas fa-chevron-right")])],1)],1):(item.typeofmessage === 'carousel')?_c('div',{staticClass:"chat_other",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","display":"-webkit-inline-box","background":"none"}},_vm._l((item.elements),function(info_carousel,index){return _c('div',[_c('v-card',{staticStyle:{"border-radius":"20px","width":"200px","margin-right":"10px"}},[(info_carousel.image)?_c('v-img',{staticStyle:{"height":"180px","cursor":"pointer"},attrs:{"src":info_carousel.image,"aspect-ratio":16/9}},[(info_carousel.type !== 'image')?_c('v-layout',{staticStyle:{"height":"180px"},attrs:{"row":"","wrap":"","align-end":"","justify-center":""}},[(info_carousel.button)?_c('v-btn',{attrs:{"round":"","color":"#0000009c","dark":"","disabled":""}},[_c('span',{staticClass:"text-transform"},[_vm._v(_vm._s(info_carousel.button))])]):_vm._e()],1):_vm._e()],1):_vm._e()],1)],1)})):_c('p',{staticClass:"chat_other",staticStyle:{"color":"#757575 !important"},attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                      "+_vm._s(_vm.$t('ChatSide.noMsg'))+"\n                    ")]),_vm._v(" "),(item.typeofmessage == 'albums_message' && item.image_add.length == 0)?_c('span',{staticStyle:{"font-size":"10px","color":"#616161","margin-bottom":"0px","display":"none"}},[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" ")]):_c('span',{staticStyle:{"font-size":"10px","color":"#616161","margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.timeMoment(item.timestamp))+" ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[(item.typeofmessage == 'message' || item.typeofmessage == 'image' || item.typeofmessage == 'file' || item.typeofmessage == 'pdf_password' || item.typeofmessage == 'location' || item.typeofmessage == 'video')?_c('v-checkbox',{staticStyle:{"float":"right"},attrs:{"value":item.tokenmessage},model:{value:(_vm.selectedmessage),callback:function ($$v) {_vm.selectedmessage=$$v},expression:"selectedmessage"}}):(item.typeofmessage == 'albums_message' && item.image_add.length === 0)?_c('v-checkbox',{staticStyle:{"float":"right","display":"none"}}):_c('v-checkbox',{staticStyle:{"float":"right"},attrs:{"disabled":""}})],1)],1)],1):_vm._e()],1):_vm._e()}),_vm._v(" "),(_vm.datepicker)?_c('v-date-picker',{attrs:{"max":_vm.maxdate,"min":_vm.mindate,"landscape":_vm.landscape},model:{value:(_vm.dateselect),callback:function ($$v) {_vm.dateselect=$$v},expression:"dateselect"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.datepicker = false}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.senddate()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1):_vm._e(),_vm._v(" "),(_vm.timepicker)?_c('v-time-picker',{attrs:{"max":_vm.maxtime,"min":_vm.mintime,"format":"24hr","landscape":_vm.landscape},model:{value:(_vm.timeselect),callback:function ($$v) {_vm.timeselect=$$v},expression:"timeselect"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timepicker = false}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.sendtime()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1):_vm._e(),_vm._v(" "),(_vm.selected === false)?_c('div',{staticClass:"scrolling-wrapper"},_vm._l((_vm.Quickreply.quick_reply),function(item,index){return _c('a',{key:index},[(item.type == 'text')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.ans_quickreply(item, 'text')}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):_vm._e(),_vm._v(" "),(item.type == 'datepicker' || item.type == 'datetimepicker')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.setpicker(item)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-calendar-alt")]),_vm._v("    "),_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])],1):_vm._e(),_vm._v(" "),(item.type == 'link')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.ans_quicklink(item)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-link")]),_vm._v("    "),_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])],1):_vm._e(),_vm._v(" "),(item.type == 'link_market')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.ans_quicklink_market(item)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-link")]),_vm._v("    "),_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])],1):_vm._e(),_vm._v(" "),(item.type == 'webview')?_c('v-btn',{staticClass:"quick_reply",attrs:{"slot":"activator","round":"","small":""},on:{"click":function($event){_vm.ans_quickwebview(item)}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("web")]),_vm._v("    "+_vm._s(item.label)+"\n              ")],1):(item.type == 'ocr')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.ocropen(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'file')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.selectfile_quickreply(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'image')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.selectfile_quickreply(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'location')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.sendlocation_quickreply(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):_vm._e(),_vm._v(" "),(item.type == 'ekyc')?_c('v-btn',{staticClass:"quick_reply",attrs:{"round":"","small":""},on:{"click":function($event){_vm.ans_ekyc(item, _vm.Quickreply)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-id-card")]),_vm._v("    "),_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])],1):_vm._e()],1)})):_vm._e(),_vm._v(" "),(_vm.selected === true)?_c('div',{staticClass:"scrolling-wrapper"},_vm._l((_vm.Quickreply.quick_reply),function(item,index){return _c('a',{key:index},[(item.type == 'text')?_c('v-btn',{staticClass:"quick_replydis",attrs:{"round":"","small":"","disabled":""},on:{"click":function($event){_vm.ans_quickreply(item, 'text')}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):_vm._e(),_vm._v(" "),(item.type == 'datepicker' || item.type == 'datetimepicker')?_c('v-btn',{staticClass:"quick_replydis",attrs:{"round":"","small":"","disabled":""},on:{"click":function($event){_vm.setpicker(item)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-calendar-alt")]),_vm._v("    "),_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])],1):_vm._e(),_vm._v(" "),(item.type == 'link')?_c('v-btn',{staticClass:"quick_replydis",attrs:{"round":"","small":"","disabled":""},on:{"click":function($event){_vm.ans_quicklink(item)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-link")]),_vm._v("    "),_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])],1):_vm._e(),_vm._v(" "),(item.type == 'link_market')?_c('v-btn',{staticClass:"quick_replydis",attrs:{"round":"","small":"","disabled":""},on:{"click":function($event){_vm.ans_quicklink_market(item)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-link")]),_vm._v("    "),_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])],1):_vm._e(),_vm._v(" "),(item.type == 'webview')?_c('v-btn',{staticClass:"quick_replydis",attrs:{"slot":"activator","round":"","small":"","disabled":""},on:{"click":function($event){_vm.ans_quickwebview(item)}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("web")]),_vm._v("    "+_vm._s(item.label)+"\n              ")],1):(item.type == 'ocr')?_c('v-btn',{staticClass:"quick_reply",attrs:{"disabled":"","round":"","small":""},on:{"click":function($event){_vm.ocropen(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'file')?_c('v-btn',{staticClass:"quick_reply",attrs:{"disabled":"","round":"","small":""},on:{"click":function($event){_vm.selectfile_quickreply(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type == 'image')?_c('v-btn',{staticClass:"quick_reply",attrs:{"disabled":"","round":"","small":""},on:{"click":function($event){_vm.selectfile_quickreply(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):(item.type === 'location')?_c('v-btn',{staticClass:"quick_reply",attrs:{"disabled":"","round":"","small":""},on:{"click":function($event){_vm.sendlocation_quickreply(item)}}},[_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])]):_vm._e(),_vm._v(" "),(item.type == 'ekyc')?_c('v-btn',{staticClass:"quick_reply",attrs:{"disabled":"","round":"","small":""},on:{"click":function($event){_vm.ans_ekyc(item, _vm.Quickreply)}}},[_c('v-icon',{staticStyle:{"font-size":"12px"}},[_vm._v("fas fa-id-card")]),_vm._v("    "),_c('span',{staticClass:"text-overflow-quickreply"},[_vm._v(_vm._s(item.label))])],1):_vm._e()],1)})):_vm._e()],2),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.settingdialog),callback:function ($$v) {_vm.settingdialog=$$v},expression:"settingdialog"}},[_c('v-card',[_c('v-list',[(_vm.announce_message.typeofmessage == 'file' && _vm.extension(_vm.announce_message.message) != 'pdf')?_c('v-list-tile',{on:{"click":function($event){_vm.loadfile(_vm.announce_message)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.openfile')))]):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'file' && _vm.extension(_vm.announce_message.message) != 'pdf')?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'file' || _vm.announce_message.typeofmessage == 'pdf_password' && _vm.extension(_vm.announce_message.message) == 'pdf')?_c('v-list-tile',{on:{"click":function($event){_vm.zoomfile(false, _vm.announce_message)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.openfile')))]):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'file' || _vm.announce_message.typeofmessage == 'pdf_password' && _vm.extension(_vm.announce_message.message) == 'pdf')?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'location')?_c('v-list-tile',{on:{"click":function($event){_vm.openlocation(_vm.announce_message)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.openlocation')))]):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'location')?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage !== 'mention_message' && _vm.announce_message.typeofmessage !== 'contact')?_c('v-list-tile',{on:{"click":function($event){_vm.farwardmessage()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.forward')))]):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage !== 'mention_message' && _vm.announce_message.typeofmessage !== 'contact')?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage !== 'contact')?_c('v-list-tile',{on:{"click":function($event){_vm.mention_message()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.mention')))]):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage !== 'contact')?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'file' || _vm.announce_message.typeofmessage == 'pdf_password')?_c('v-list-tile',{on:{"click":function($event){_vm.SelectBotMessage('sendmail')}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.sendmail')))]):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'file' || _vm.announce_message.typeofmessage == 'pdf_password')?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage === 'contact')?_c('v-list-tile',{on:{"click":function($event){_vm.detailFriend(_vm.announce_message.message)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.profile')))]):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage === 'contact' && _vm.announce_message.tokenuser === _vm.token)?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'message')?_c('v-list-tile',{on:{"click":function($event){_vm.announce_msg()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.announce')))]):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'message')?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.announce_message.tokenuser === _vm.token)?_c('v-list-tile',{on:{"click":function($event){_vm.unsendmessage()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.cancelMsg')))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.imagealbumsdialog),callback:function ($$v) {_vm.imagealbumsdialog=$$v},expression:"imagealbumsdialog"}},[_c('v-card',[_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.zoom()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.openimage')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.farwardmessage()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.forward')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.SelectBotMessage('sendmail')}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.sendmail')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.mention_message()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.mention')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.add_image_albums()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.addImageAlbum')))]),_vm._v(" "),(_vm.announce_message.tokenuser === _vm.token)?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.announce_message.tokenuser === _vm.token)?_c('v-list-tile',{on:{"click":function($event){_vm.unsendmessage()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.cancelMsg')))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.unsenddialog),callback:function ($$v) {_vm.unsenddialog=$$v},expression:"unsenddialog"}},[_c('v-card',[_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.mention_message()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.mention')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.unsendmessage()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.cancelMsg')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.forwarddialog),callback:function ($$v) {_vm.forwarddialog=$$v},expression:"forwarddialog"}},[_c('v-card',[_c('v-list',[(_vm.announce_message.typeofmessage == 'image')?_c('v-list-tile',{on:{"click":function($event){_vm.zoom()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.image')))]):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'image')?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'file' || _vm.announce_message.typeofmessage == 'pdf_password' && _vm.extension(_vm.announce_message.message) == 'pdf')?_c('v-list-tile',{on:{"click":function($event){_vm.zoomfile(false, _vm.announce_message)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.openfile')))]):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'file' || _vm.announce_message.typeofmessage == 'pdf_password' && _vm.extension(_vm.announce_message.message) == 'pdf')?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'location')?_c('v-list-tile',{on:{"click":function($event){_vm.openlocation(_vm.announce_message)}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.openlocation')))]):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'location')?_c('v-divider'):_vm._e(),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.mention_message()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.mention')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.announce_message.typeofmessage == 'file' || _vm.announce_message.typeofmessage == 'pdf_password')?_c('v-list-tile',{on:{"click":function($event){_vm.SelectBotMessage('sendmail')}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.sendmail')))]):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'file' || _vm.announce_message.typeofmessage == 'pdf_password')?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'message')?_c('v-list-tile',{on:{"click":function($event){_vm.announce_msg()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.announce')))]):_vm._e(),_vm._v(" "),(_vm.announce_message.typeofmessage == 'message')?_c('v-divider'):_vm._e(),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.farwardmessage()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.forward')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.forwardimagedialog),callback:function ($$v) {_vm.forwardimagedialog=$$v},expression:"forwardimagedialog"}},[_c('v-card',[_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.zoom()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.openimage')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.mention_message()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.mention')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.add_image_albums()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.addImageAlbum')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.farwardmessage()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.forward')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.SelectBotMessage('sendmail')}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.sendmail')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.mentiondialog),callback:function ($$v) {_vm.mentiondialog=$$v},expression:"mentiondialog"}},[_c('v-card',[_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.mention_message()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.mention')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.announcedialog),callback:function ($$v) {_vm.announcedialog=$$v},expression:"announcedialog"}},[_c('v-card',[_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.cancel_announce()}}},[_vm._v(_vm._s(_vm.$t('ChatSide.RightClickMenu.cancelAnnounce')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.bot_dialog_message),callback:function ($$v) {_vm.bot_dialog_message=$$v},expression:"bot_dialog_message"}},[_c('v-card',_vm._l((_vm.bot_dialog_list),function(item,index){return _c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.SelectBotMessage(item.methods)}}},[_vm._v("\n                "+_vm._s(item.message)+"\n              ")]),_vm._v(" "),(index < _vm.bot_dialog_list.length - 1)?_c('v-divider'):_vm._e()],1)}))],1),_vm._v(" "),(_vm.showmessagebottom)?_c('v-flex',{staticStyle:{"margin":"0","bottom":"170px","position":"fixed","width":"100%","height":"4vh","padding":"5px !important","cursor":"pointer"},attrs:{"xs12":"","sm12":"","md12":""},on:{"click":_vm.lookmessage}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-chip',{staticStyle:{"cursor":"pointer"},attrs:{"close":""},on:{"click":_vm.closechip},model:{value:(_vm.chip),callback:function ($$v) {_vm.chip=$$v},expression:"chip"}},[_c('v-avatar',[(_vm.picturechip)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.picturechip}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('span',{staticClass:"text2"},[_vm._v(_vm._s(_vm.showmessage))])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showmention)?_c('v-flex',{staticClass:"showmention",style:(_vm.tabShowmention),attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-avatar',[(_vm.mentionpathpic !== '')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"height":"40px","width":"40px"},attrs:{"src":_vm.mentionpathpic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"height":"40px","width":"40px"},attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"22px"},attrs:{"xs10":""}},[(_vm.mentiontypemsg == 'message' || _vm.mentiontypemsg == 'mention_message')?_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"50vw","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.mentionname))]),_vm._v(" "),(_vm.mentionmessage)?_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"50vw","overflow":"hidden","text-overflow":"ellipsis"},domProps:{"innerHTML":_vm._s(_vm.convertMention(_vm.mentionmessage))}}):_vm._e()]):(_vm.mentiontypemsg === 'image' || _vm.mentiontypemsg === 'sticker' || _vm.mentiontypemsg === 'file' || _vm.mentiontypemsg === 'pdf_password')?_c('v-layout',{attrs:{"row":""}},[_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"50vw","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.mentionname))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.mentiontypemsg === 'image')?_c('img',{staticStyle:{"height":"40px","width":"40px","border-radius":"10px"},attrs:{"src":_vm.mentionmessage}}):(_vm.mentiontypemsg === 'sticker')?_c('img',{staticStyle:{"height":"40px","width":"40px","border-radius":"10px"},attrs:{"src":_vm.mentionimage}}):(_vm.extension(_vm.mentionimage) === 'pdf')?_c('v-icon',{staticStyle:{"color":"white","font-size":"35px"}},[_vm._v("fas fa-file-pdf")]):_c('v-icon',{staticStyle:{"color":"white","font-size":"35px"}},[_vm._v(_vm._s(_vm.extension(_vm.mentionimage)))])],1):(_vm.mentiontypemsg === 'video')?_c('v-layout',{attrs:{"row":""}},[_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"50vw","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.mentionname))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('video',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"width":"40","height":"40","autoplay":""}},[_c('source',{attrs:{"src":_vm.mentionmessage,"type":'video/' + _vm.mentionmessage.split('.')[_vm.mentionmessage.split('.').length - 1]}})])],1):(_vm.mentiontypemsg === 'location')?_c('v-layout',{attrs:{"row":""}},[_c('span',{staticStyle:{"color":"ghostwhite","white-space":"nowrap","width":"50vw","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.mentionname))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"white","font-size":"35px"}},[_vm._v("fas fa-map-marker-alt")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"9px","padding-bottom":"20px"},attrs:{"xs1":""}},[_c('v-icon',{attrs:{"color":"white"},on:{"click":_vm.closemention}},[_vm._v("close")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.status_tag)?_c('v-flex',{staticClass:"friendList",attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',_vm._l((_vm.listfriend_filter),function(item,index){return _c('v-list',{key:index,attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.tagFriend(item.name)}}},[_c('v-list-tile-avatar',[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"pl-2"},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.name)}})],1)],1)],1)}))]):_vm._e(),_vm._v(" "),(_vm.selected === false)?_c('v-flex',{staticStyle:{"bottom":"0","position":"fixed","width":"100%","border-width":"thin","border-top-style":"solid","border-color":"#80808099"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[(_vm.statemember === 'active')?_c('v-layout',{attrs:{"align-center":"","justify-center":"","wrap":""}},[(!_vm.RichmenuState)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{staticStyle:{"margin-top":"6px"},attrs:{"align-center":"","justify-center":"","row":""}},[(_vm.list_richmenu.length !== 0)?_c('v-btn',{staticStyle:{"margin-bottom":"30px","argin-right":"0px"},attrs:{"flat":"","icon":""},on:{"click":_vm.chsheetrichmenu}},[_c('v-icon',{staticStyle:{"font-size":"20px !important"}},[_vm._v("fas fa-list")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-bottom":"30px","margin-left":"0px","margin-right":"0px"},attrs:{"flat":"","icon":""},on:{"click":_vm.chsheetother}},[_c('v-icon',{staticStyle:{"font-size":"25px !important"}},[_vm._v("add_circle_outline")])],1),_vm._v(" "),_c('v-text-field',{ref:"textareaChat",staticClass:"mr-2",attrs:{"append-icon":_vm.marker ? 'insert_emoticon' : 'insert_emoticon',"append-outer-icon":_vm.sendmsg ? 'send' : '',"solo":"","clear-icon":"clear","label":_vm.$t('ChatSide.textarea.normal'),"type":"text","id":"textareaChat"},on:{"click:append":_vm.chsheetsticker,"click:append-outer":function($event){_vm.sendMessage(_vm.sendmsg)},"click:clear":_vm.clearMessage,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.sendMessage(_vm.sendmsg)},"input":function($event){_vm.filterlistfriend()}},model:{value:(_vm.sendmsg),callback:function ($$v) {_vm.sendmsg=$$v},expression:"sendmsg"}})],1)],1):_c('v-flex',{staticStyle:{"bottom":"0","width":"100%"},attrs:{"xs12":"","sm12":"","md12":""}},[(_vm.sheetrichmenu)?_c('Richmenudialogmobile',{attrs:{"type_richmenu":_vm.type_richmenu,"Richmenudialog":_vm.Richmenudialog,"inforrichmenu":_vm.inforrichmenu},on:{"emitrichmenu":_vm.emitrichmenu}}):_vm._e(),_vm._v(" "),(!_vm.sheetrichmenu)?_c('v-layout',{staticStyle:{"margin-top":"6px"},attrs:{"align-center":"","justify-center":"","row":""}},[_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":function($event){_vm.RichmenuState = false; _vm.sheetrichmenu = false}}},[_c('v-icon',{staticStyle:{"font-size":"20px !important"}},[_vm._v("fas fa-keyboard")])],1),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none","margin-right":"5px"},attrs:{"block":"","outline":"","color":"#2561af"},on:{"click":function($event){_vm.sheetrichmenu = true}}},[_vm._v(_vm._s(_vm.richmenu_label))])],1):_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"align-center":"","justify-center":"","row":""}},[_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":function($event){_vm.RichmenuState = false; _vm.sheetrichmenu = false}}},[_c('v-icon',{staticStyle:{"font-size":"20px !important"}},[_vm._v("fas fa-keyboard")])],1),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none","margin-right":"5px"},attrs:{"block":"","outline":"","color":"#2561af"},on:{"click":function($event){_vm.sheetrichmenu = false}}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"color":"#2561af","font-size":"14px !important"}},[_vm._v("fas fa-sort-down")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.richmenu_label))])],1)],1)],1)],1)],1):_c('v-layout',{attrs:{"align-center":"","justify-end":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{staticStyle:{"margin-top":"6px"},attrs:{"align-center":"","justify-center":"","row":""}},[(_vm.list_richmenu.length !== 0)?_c('v-btn',{staticStyle:{"margin-right":"0px","margin-bottom":"30px"},attrs:{"flat":"","icon":"","disabled":""}},[_c('v-icon',{staticStyle:{"font-size":"25px !important"}},[_vm._v("fas fa-list")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-bottom":"30px","margin-left":"0px","margin-right":"0px"},attrs:{"flat":"","icon":"","disabled":""},on:{"click":_vm.chsheetother}},[_c('v-icon',{staticStyle:{"font-size":"25px !important"}},[_vm._v("add_circle_outline")])],1),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","append-icon":_vm.marker ? 'insert_emoticon' : 'insert_emoticon',"append-outer-icon":_vm.sendmsg ? 'send' : '',"solo":"","clear-icon":"clear","clearable":"","label":_vm.$t('ChatSide.textarea.inactive'),"type":"text"},on:{"click:append":_vm.chsheetsticker,"click:append-outer":function($event){_vm.sendMessage(_vm.sendmsg)},"click:clear":_vm.clearMessage,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.sendMessage(_vm.sendmsg)}},model:{value:(_vm.sendmsg),callback:function ($$v) {_vm.sendmsg=$$v},expression:"sendmsg"}})],1)],1)],1)],1):_c('v-flex',{staticStyle:{"border-width":"thin","border-top-style":"solid","border-color":"#80808099"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[(_vm.selectedmessage.length === 0)?_c('span',{staticStyle:{"font-size":"16px","font-weight":"200px"}},[_vm._v(_vm._s(_vm.$t('ChatSide.numberMsgSent')))]):_c('span',{staticStyle:{"font-size":"16px","font-weight":"200px"}},[_vm._v(_vm._s(_vm.$t('ChatSide.numberMsgSent'))+" ("+_vm._s(_vm.selectedmessage.length)+")")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":"","row":"","wrap":""}},[(_vm.selectedmessage.length === 0)?_c('v-btn',{staticClass:"btncreategroup",attrs:{"disabled":"","small":"","round":""}},[_vm._v("\n                    "+_vm._s(_vm.$t('AnswerQuestion.forward'))+"\n                  ")]):_c('v-btn',{staticClass:"btncreategroup",attrs:{"small":"","round":""},on:{"click":function($event){_vm.toPageForward(_vm.selectedmessage.tokenmessage)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('AnswerQuestion.forward'))+"\n                  ")]),_vm._v(" "),_c('v-btn',{staticClass:"btncanclegroup",attrs:{"small":"","round":""},on:{"click":function($event){_vm.closeSeleted()}}},[_vm._v("\n                    "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                  ")])],1)],1)],1)],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('input',{attrs:{"multiple":"","type":"file","id":"uploadpic","accept":"image/*"},on:{"change":_vm.onFileSelected}}),_vm._v(" "),_c('input',{attrs:{"multiple":"","type":"file","id":"uploadfileChat"},on:{"change":_vm.onFileSelected}}),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"uploadpic_ocr","accept":"image/*"},on:{"change":function($event){_vm.onimgSelected_ocr($event)},"click":function($event){_vm.clearImage()}}}),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"uploadpic_quickreply","accept":"image/*"},on:{"change":function($event){_vm.onimgSelected_quickreply($event)},"click":function($event){_vm.clearImage()}}}),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"uploadfile_quickreply"},on:{"change":function($event){_vm.onimgSelected_quickreply($event)},"click":function($event){_vm.clearImage()}}})]),_vm._v(" "),_c('v-bottom-sheet',{model:{value:(_vm.sheetwebviewmenu),callback:function ($$v) {_vm.sheetwebviewmenu=$$v},expression:"sheetwebviewmenu"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v("  "+_vm._s(_vm.inforwebview.label))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":"","href":_vm.inforwebview.url,"target":"_blank"}},[_c('v-icon',{staticStyle:{"font-size":"18px !important"},attrs:{"color":"white"}},[_vm._v("far fa-window-restore")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.closewebviewmenu}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.inforwebview.size == 'compact')?_c('iframe',{staticStyle:{"width":"100%","height":"280px","visibility":"visible"},attrs:{"frameborder":"0","src":_vm.inforwebview.url}}):(_vm.inforwebview.size == 'tall')?_c('iframe',{staticStyle:{"width":"100%","height":"500px","visibility":"visible"},attrs:{"frameborder":"0","src":_vm.inforwebview.url}}):(_vm.inforwebview.size == 'full')?_c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 110px)","visibility":"visible"},attrs:{"frameborder":"0","src":_vm.inforwebview.url}}):_vm._e()],1)],1),_vm._v(" "),_c('v-bottom-sheet',{model:{value:(_vm.sheetwebview),callback:function ($$v) {_vm.sheetwebview=$$v},expression:"sheetwebview"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v("  "+_vm._s(_vm.inforquickreply.label))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":"","href":_vm.inforquickreply.url,"target":"_blank"}},[_c('v-icon',{staticStyle:{"font-size":"18px !important"},attrs:{"color":"white"}},[_vm._v("far fa-window-restore")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.closewebview}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.inforquickreply.size == 'compact')?_c('iframe',{staticStyle:{"width":"100%","height":"280px","visibility":"visible"},attrs:{"frameborder":"0","src":_vm.inforquickreply.url}}):(_vm.inforquickreply.size == 'tall')?_c('iframe',{staticStyle:{"width":"100%","height":"500px","visibility":"visible"},attrs:{"frameborder":"0","src":_vm.inforquickreply.url}}):(_vm.inforquickreply.size == 'full')?_c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 110px)","visibility":"visible"},attrs:{"frameborder":"0","src":_vm.inforquickreply.url}}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[(_vm.statemember=='active')?_c('v-bottom-sheet',{attrs:{"id":"tabother"},model:{value:(_vm.sheetother),callback:function ($$v) {_vm.sheetother=$$v},expression:"sheetother"}},[_c('v-card',{staticStyle:{"text-transform":"none !important"},attrs:{"tile":""}},[_c('v-card-text',{staticStyle:{"padding-top":"0vh","text-transform":"none","height":"225px"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","md4":"","sm4":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","wrap":"","column":""}},[_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":_vm.uppic}},[_c('v-icon',{staticStyle:{"font-size":"25px !important"}},[_vm._v("photo")])],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('ChatSide.image')))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","md4":"","sm4":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":"","wrap":""}},[_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":_vm.upfile}},[_c('v-icon',{staticStyle:{"font-size":"25px !important"}},[_vm._v("attach_file")])],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('ChatSide.file')))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","md4":"","sm4":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":"","wrap":""}},[_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":function($event){_vm.dialogAccount = true; _vm.sheetother = false}}},[_c('v-icon',{staticStyle:{"font-size":"25px !important"}},[_vm._v("contacts")])],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('ChatSide.friend')))])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","md4":"","sm4":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":"","wrap":""}},[_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":_vm.openmap}},[_c('v-icon',{staticStyle:{"font-size":"25px !important"}},[_vm._v("location_on")])],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('ChatSide.location')))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","md4":"","sm4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","md4":"","sm4":""}})],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[(_vm.statemember=='active')?_c('v-bottom-sheet',{attrs:{"id":"tabsticker"},model:{value:(_vm.sheetsticker),callback:function ($$v) {_vm.sheetsticker=$$v},expression:"sheetsticker"}},[_c('v-card',{staticStyle:{"text-transform":"none !important"},attrs:{"tile":""}},[_c('v-card-text',{staticStyle:{"padding-top":"0vh","text-transform":"none","height":"225px"}},[_c('v-tabs',{staticStyle:{"background":"white !important","text-transform":"none"},attrs:{"slot":"extension","centered":""},slot:"extension",model:{value:(_vm.activetapEmo),callback:function ($$v) {_vm.activetapEmo=$$v},expression:"activetapEmo"}},[_c('v-tab',{staticStyle:{"font-size":"20px","text-transform":"none !important","overflow-y":"hidden"},attrs:{"href":"#tab-Emo"}},[_c('p',{staticClass:"textemo"},[_vm._v(_vm._s(_vm.$t('ChatSide.emoji')))])]),_vm._v(" "),_c('v-tab',{staticStyle:{"font-size":"20px","text-transform":"none !important","overflow-y":"hidden"},attrs:{"href":"#tab-Stick"}},[_c('p',{staticClass:"textemo"},[_vm._v(_vm._s(_vm.$t('ChatSide.sticker')))])])],1),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"margin-top":"0.2vh"},model:{value:(_vm.activetapEmo),callback:function ($$v) {_vm.activetapEmo=$$v},expression:"activetapEmo"}},[_c('v-tab-item',{staticStyle:{"height":"50vh","overflow-y":"scroll","text-transform":"none"},attrs:{"id":"tab-Emo"}},[_c('div',{staticStyle:{"background":"white !important"}},[_c('v-tabs',{staticStyle:{"background":"white !important"},attrs:{"slot":"extension","centered":""},slot:"extension",model:{value:(_vm.activeEmoji),callback:function ($$v) {_vm.activeEmoji=$$v},expression:"activeEmoji"}},_vm._l((_vm.emojiGroups),function(emojiGroup,category){return _c('v-tab',{key:category,staticStyle:{"font-size":"20px"},attrs:{"href":'#tab-'+ category}},[_vm._v("\n                        "+_vm._s(emojiGroup['smile'])+"\n                        "+_vm._s(emojiGroup['bear'])+"\n                        "+_vm._s(emojiGroup['soccer'])+"\n                        "+_vm._s(emojiGroup['house_with_garden'])+"\n                        "+_vm._s(emojiGroup['heart_decoration'])+"\n                      ")])})),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"margin-top":"0.2vh"},model:{value:(_vm.activeEmoji),callback:function ($$v) {_vm.activeEmoji=$$v},expression:"activeEmoji"}},_vm._l((_vm.emojiGroups),function(emojiGroup,category){return _c('v-tab-item',{key:category,staticStyle:{"height":"30vh","overflow-y":"scroll"},attrs:{"id":'tab-'+category}},[_c('div',{staticClass:"emojis"},_vm._l((emojiGroup),function(emoji,emojiName){return _c('span',{key:emojiName,attrs:{"title":emojiName},on:{"click":function($event){_vm.append(emoji)}}},[_vm._v(_vm._s(emoji))])}))])}))],1)]),_vm._v(" "),_c('v-tab-item',{staticStyle:{"height":"50vh","overflow-y":"scroll","text-transform":"none"},attrs:{"id":"tab-Stick"}},[_c('div',{staticStyle:{"background":"white !important"}},[_c('v-tabs',{staticStyle:{"background":"white !important"},attrs:{"slot":"extension","centered":""},slot:"extension",model:{value:(_vm.activeSticker),callback:function ($$v) {_vm.activeSticker=$$v},expression:"activeSticker"}},_vm._l((_vm.sticker),function(item,index){return _c('v-tab',{key:item.token_sticker,staticStyle:{"font-size":"20px"},attrs:{"href":'#tabsticker-'+item.token_sticker}},[_c('img',{staticStyle:{"width":"30px"},attrs:{"src":item.path_title}})])})),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"margin-top":"0.2vh"},model:{value:(_vm.activeSticker),callback:function ($$v) {_vm.activeSticker=$$v},expression:"activeSticker"}},_vm._l((_vm.sticker),function(item,index){return _c('v-tab-item',{key:index,staticStyle:{"height":"100px","overflow-y":"scroll"},attrs:{"id":'tabsticker-'+item.token_sticker}},[_c('v-container',{staticStyle:{"padding-top":"0px"},attrs:{"wrap":""}},[_c('v-layout',{staticStyle:{"flex-wrap":"wrap"},attrs:{"wrap":""}},_vm._l((item.list_sticker),function(items,index){return _c('v-flex',{key:index,staticStyle:{"justify-content":"center"},attrs:{"sm4":"","md4":"","xs4":""}},[_c('v-layout',{staticStyle:{"justify-content":"center","display":"flex","text-align":"center"}},[_c('img',{staticStyle:{"width":"80px","height":"80px"},attrs:{"src":items.s3_name},on:{"click":function($event){_vm.pushSticker(items.message)}}})])],1)}))],1)],1)}))],1)])],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('DialogGetpassword',{attrs:{"dialogGetPassword":_vm.dialogGetPassword,"DetailFile":_vm.DetailFile},on:{"closeDialogpassword":_vm.closeDialogpassword}}),_vm._v(" "),_c('ReadmoreDialog',{attrs:{"dialogReadmore":_vm.dialogReadmore,"detailReadmore":_vm.detailReadmore},on:{"closeReadmoreDialog":_vm.closeReadmoreDialog}}),_vm._v(" "),_c('AccountDialog',{attrs:{"dialogAccount":_vm.dialogAccount},on:{"closeAccount":_vm.closeAccount,"pushcontact":_vm.pushcontact}}),_vm._v(" "),_c('NoteDialog',{attrs:{"dialogNote":_vm.dialogNote,"note_id":_vm.note_id,"status_block":_vm.status_block},on:{"closeNote":_vm.closeNote}}),_vm._v(" "),_c('MapDialogMobile',{attrs:{"dialogSendMap":_vm.dialogSendMap},on:{"closeSendMap":_vm.closeSendMap,"send_location":_vm.send_location}}),_vm._v(" "),_c('ApproveDialogMobile',{attrs:{"dialogApprove":_vm.dialogApprove,"ApproveDetail":_vm.ApproveDetail},on:{"sendansApprove":_vm.sendansApprove,"closeApprove":_vm.closeApprove}}),_vm._v(" "),_c('AlbumsDialogMobile',{attrs:{"dialogAlbums":_vm.dialogAlbums,"albums_id":_vm.albums_id},on:{"closeAlbums":_vm.closeAlbums}}),_vm._v(" "),_c('AddImageDialogMobile',{attrs:{"dialogAddImage":_vm.dialogAddImage,"path_pic_albums":_vm.path_pic_albums,"file_name":_vm.file_name},on:{"closeAddImage":_vm.closeAddImage}}),_vm._v(" "),_c('InforfriendDialogMobile',{attrs:{"inforfrienddialog":_vm.inforfrienddialog,"tokeninforfriend":_vm.tokeninforfriend},on:{"closeInforfriend":_vm.closeInforfriend}}),_vm._v(" "),_c('DetailTask',{attrs:{"dialogDetailTask":_vm.dialogDetailTask,"taskid":_vm.taskid,"roomid":_vm.roomid},on:{"closeDetailTask":_vm.closeDetailTask}}),_vm._v(" "),_c('SaveOnebox',{attrs:{"dialogSaveOnebox":_vm.dialogSaveOnebox,"tokenmessage_savebox":_vm.tokenmessage_savebox},on:{"closeSaveOnebox":_vm.closeSaveOnebox}}),_vm._v(" "),_c('WebviewBigOcrDialog',{attrs:{"token":_vm.token,"tokenrooomSelect":_vm.tokenrooomSelect,"dialogWebviewbig_ocr":_vm.dialogWebviewbig_ocr,"Webview_item":_vm.Webview_item_ocr},on:{"closewebview":_vm.closewebview}}),_vm._v(" "),_c('CheckBrowserDialog',{attrs:{"checkBrowserDialog":_vm.checkBrowserDialog,"checkBrowserInfor":_vm.checkBrowserInfor},on:{"closeCheckBrowser":_vm.closeCheckBrowser}}),_vm._v(" "),_c('QrCodeRichMenuDialog',{attrs:{"dialogQrcodRichMenu":_vm.dialogQrcodRichMenu,"tokenroom":_vm.tokenrooomSelect,"QrcodeInfor":_vm.QrcodeInfor},on:{"closedialogQrcode":_vm.closedialogQrcode}}),_vm._v(" "),_c('CreateMailMobileDialog',{attrs:{"dialogCreatemailMobile":_vm.dialogCreatemailMobile,"message":_vm.SelectedMessageDetail},on:{"closeCreatemail":_vm.closeCreatemail}}),_vm._v(" "),_c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"fullscreen":""},model:{value:(_vm.dialogMap),callback:function ($$v) {_vm.dialogMap=$$v},expression:"dialogMap"}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[(_vm.locationName.file_name != '')?_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v(" 🚩  "+_vm._s(_vm.locationName.file_name)+" ")]):_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v(" 🚩  "+_vm._s(_vm.$t('ChatSide.location'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":function($event){_vm.dialogMap = false}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"map"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":""},model:{value:(_vm.official_sheet),callback:function ($$v) {_vm.official_sheet=$$v},expression:"official_sheet"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v("  "+_vm._s(_vm.official_item.label))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},nativeOn:{"click":function($event){return _vm.newtab($event)}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("far fa-window-restore")])],1),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},nativeOn:{"click":function($event){return _vm.closeDialog_official($event)}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),(_vm.official_item.size == 'compact')?_c('iframe',{staticStyle:{"width":"100%","height":"280px","visibility":"visible"},attrs:{"frameborder":"0","src":_vm.official_item.url}}):(_vm.official_item.size == 'tall')?_c('iframe',{staticStyle:{"width":"100%","height":"500px","visibility":"visible"},attrs:{"frameborder":"0","src":_vm.official_item.url}}):(_vm.official_item.size == 'full')?_c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 140px)","visibility":"visible"},attrs:{"frameborder":"0","src":_vm.official_item.url}}):_c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 140px)","visibility":"visible"},attrs:{"frameborder":"0","src":_vm.official_item.url}})],1)],1)],1)])}
var CenterSideTest_staticRenderFns = []
var CenterSideTest_esExports = { render: CenterSideTest_render, staticRenderFns: CenterSideTest_staticRenderFns }
/* harmony default export */ var layout_CenterSideTest = (CenterSideTest_esExports);
// CONCATENATED MODULE: ./src/components/mobile/layout/CenterSideTest.vue
function CenterSideTest_injectStyle (ssrContext) {
  __webpack_require__("SsPv")
}
var CenterSideTest_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CenterSideTest___vue_template_functional__ = false
/* styles */
var CenterSideTest___vue_styles__ = CenterSideTest_injectStyle
/* scopeId */
var CenterSideTest___vue_scopeId__ = "data-v-40b50cfb"
/* moduleIdentifier (server only) */
var CenterSideTest___vue_module_identifier__ = null
var CenterSideTest_Component = CenterSideTest_normalizeComponent(
  CenterSideTest["a" /* default */],
  layout_CenterSideTest,
  CenterSideTest___vue_template_functional__,
  CenterSideTest___vue_styles__,
  CenterSideTest___vue_scopeId__,
  CenterSideTest___vue_module_identifier__
)

/* harmony default export */ var mobile_layout_CenterSideTest = (CenterSideTest_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/layout/RightSideMobile.vue
var RightSideMobile = __webpack_require__("pP2O");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02b46020","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/layout/RightSideMobile.vue
var RightSideMobile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detail)?_c('v-layout',{staticClass:"rightbox CSChatThai ",staticStyle:{"border":"solid","border-width":"1px","border-color":"#fff","border-bottom":"none","border-top":"none","background":"#fff","height":"calc(100vh - 64px)"},attrs:{"row":"","wrap":""}},[_c('div',{staticClass:"modal",attrs:{"id":"myModalR"}},[_c('div',{attrs:{"id":"headcaption"}},[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"text-align":"right","padding-right":"2vw"},attrs:{"xs2":"","md2":"","sm2":""}},[_c('v-avatar',{staticClass:"user-photo"},[(_vm.picSend)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.picSend}}):(_vm.typeuser === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.typeuser === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","md9":"","sm9":""}},[_c('p',{staticStyle:{"font-size":"14px","white-space":"nowrap","width":"16em","overflow":"hidden","text-overflow":"ellipsis","font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.filenameSend)+" ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px","white-space":"nowrap","width":"20em","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(" "+_vm._s(_vm.$t('Dialog.showImage.by'))+" "+_vm._s(_vm.nicknameSend)+"\n              ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$t('Dialog.showImage.date'))+"  "+_vm._s(_vm.dateSend)+" "),_c('v-icon',{staticStyle:{"font-size":"7px !important","color":"white !important"}},[_vm._v("schedule")]),_vm._v(_vm._s(_vm.timeSend)+"\n              ")],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","md1":"","sm1":""}},[_c('span',{staticClass:"closeR",on:{"click":function($event){_vm.closemodal()}}},[_vm._v("×")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-left":"15vw"},attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-btn',{staticClass:"btnallow text-transform",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.loadpic(_vm.filenameSend)}}},[_c('v-icon',[_vm._v("file_download")]),_vm._v(" \n                  "+_vm._s(_vm.$t('AnswerQuestion.keep'))+"\n              ")],1),_vm._v(" "),_c('v-btn',{staticClass:"btncancel text-transform",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.sendimgonebox(_vm.tokenmsgSend)}}},[_c('v-icon',[_vm._v("cloud_upload")]),_vm._v("  \n                  "+_vm._s(_vm.$t('AnswerQuestion.sendOnebox'))+"\n              ")],1)],1)],1)],1)],1),_vm._v(" "),_c('img',{staticClass:"modal-content",attrs:{"id":"img02"}})]),_vm._v(" "),(_vm.shownotes)?_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-card',{staticStyle:{"background":"#fff"},attrs:{"flat":""}},[(!_vm.progressNote)?_c('v-container',{staticStyle:{"background":"#fff","padding":"0px"}},[_c('v-toolbar',{staticStyle:{"background-color":"white"}},[_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":function($event){_vm.shownotes = !_vm.shownotes}}},[_c('v-icon',{staticStyle:{"color":"black !important","font-size":"25px !important"}},[_vm._v("chevron_left")])],1),_vm._v(" "),(_vm.listnote.length !== 0)?_c('span',{staticStyle:{"font-size":"18px","color":"black"}},[_vm._v(_vm._s(_vm.$t('RightSide.menu.note'))+" ("+_vm._s(_vm.listnote.length)+")")]):_c('span',{staticStyle:{"font-size":"18px","color":"black"}},[_vm._v(_vm._s(_vm.$t('RightSide.noNote')))])],1),_vm._v(" "),_c('div',{staticClass:"scrolling-wrapper-right",staticStyle:{"height":"calc(100vh - 128px)"}},_vm._l((_vm.listnote),function(item,index){return _c('div',{staticClass:"noteslist",staticStyle:{"padding":"5px","padding-bottom":"0px","width":"100%"},on:{"click":function($event){_vm.detailNote(item.note_id)}}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[_c('v-avatar',{staticClass:"user-photonote"},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type ==='business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type ==='bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"text2",staticStyle:{"padding-left":"15px","padding-top":"10px","width":"170px"}},[_vm._v(_vm._s(item.nickname))])],1),_vm._v(" "),(item.note_data.text.length > 20)?_c('p',{staticStyle:{"color":"#787878","padding-top":"2px"},domProps:{"innerHTML":_vm._s(_vm.convert(item.note_data.text.substring(0, 20) + '...' ).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}):_c('p',{staticStyle:{"color":"#787878","padding-top":"2px"},domProps:{"innerHTML":_vm._s(_vm.convert(item.note_data.text).replace(/(?:\r\n|\r|\n)/g, '<br>'))}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"9px","color":"#787878 !important"}},[_vm._v("\n            "+_vm._s(_vm.date(item.create_date))+" "+_vm._s(_vm.time(item.create_date))+"\n          ")]),_vm._v(" "),_c('v-divider',{staticStyle:{"background-color":"#bdbdbd5e !important","width":"100%"}})],1)})),_vm._v(" "),_c('v-fab-transition',[_c('v-btn',{staticStyle:{"background":"#2562ae"},attrs:{"fab":"","dark":"","small":"","fixed":"","bottom":"","right":""},on:{"click":function($event){_vm.dialogCreatenote = true}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1):_c('v-container',{staticStyle:{"background":"#1a222c","padding":"5px"}},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.progressNote}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showalbum)?_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-card',{attrs:{"flat":""}},[(!_vm.progressNote)?_c('v-container',{staticStyle:{"padding":"0px"}},[_c('v-toolbar',{staticStyle:{"background-color":"white"}},[_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":function($event){_vm.showalbum = !_vm.showalbum}}},[_c('v-icon',{staticStyle:{"color":"black !important","font-size":"20px !important"}},[_vm._v("chevron_left")])],1),_vm._v(" "),(_vm.listalbum.length !== 0)?_c('span',{staticStyle:{"font-size":"18px","color":"black"}},[_vm._v(_vm._s(_vm.$t('RightSide.menu.album'))+" ("+_vm._s(_vm.filter_infoalbum.length)+")")]):_c('span',{staticStyle:{"font-size":"18px","color":"black"}},[_vm._v(_vm._s(_vm.$t('Dialog.album.noDataAlbum')))])],1),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","height":"80vh"}},_vm._l((_vm.listalbum),function(item,index){return (item.state['status'] != 'delete')?_c('div',{staticClass:"noteslist",staticStyle:{"padding":"5px","padding-bottom":"0px","padding-top":"20px"},on:{"click":function($event){_vm.detailAlbums(item._id, index)}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(item.albums_name !== '')?_c('h3',{staticStyle:{"color":"black"}},[_vm._v(_vm._s(item.albums_name))]):_c('h3',{staticStyle:{"color":"black"}},[_vm._v(_vm._s(_vm.date(item.create_date)))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),(item.information.length !== 0)?_c('v-layout',[_c('v-container',_vm._b({staticStyle:{"padding":"2px !important"},attrs:{"fluid":""}},'v-container',( _obj = {}, _obj["grid-list-sm"] = true, _obj ),false),[_c('v-layout',{staticStyle:{"overflow-y":"scroll!important","max-height":"35vh"},attrs:{"row":"","wrap":""}},_vm._l((item.information),function(image,index){return (image.status == 'active')?_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-media',{attrs:{"src":image.link,"height":"15vh"}})],1)],1):_vm._e()}))],1)],1):_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('h4',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('Dialog.album.noDataAlbum')))])]),_vm._v(" "),_c('v-divider',{staticStyle:{"background-color":"#bdbdbd5e !important","width":"100%"}})],1):_vm._e()
var _obj;})),_vm._v(" "),_c('v-fab-transition',[_c('v-btn',{staticStyle:{"background":"#2562ae"},attrs:{"fab":"","dark":"","small":"","fixed":"","bottom":"","right":""},on:{"click":function($event){_vm.dialogCreatealbums = true}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1):_c('v-container',{staticStyle:{"background":"#1a222c","padding":"5px"}},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.progressNote}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.detail.type === 'user' && !_vm.shownotes && !_vm.showalbum)?_c('v-flex',{staticStyle:{"height":"calc(100vh - 64px)","overflow-y":"auto"},attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-container',[_c('v-layout',{attrs:{"align-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":""}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage()}}},[_c('v-icon',[_vm._v("chevron_left")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-end":""}},[(_vm.statemember == 'active')?_c('v-menu',[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"20px !important","color":"black !important"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{staticClass:"CSChatThai",staticStyle:{"width":"100%","padding":"1vh"}},[_c('v-list-tile',{on:{"click":function($event){_vm.toPageTask('/mobile/room/project/')}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("fas fa-tasks")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.project')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.showalbum = !_vm.showalbum}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("fas fa-images")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.album')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.shownotes = !_vm.shownotes}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("fas fa-sticky-note")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.note')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.wallpaper()}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("fas fa-images")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.setwall')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.daletechat(_vm.$route.params.roomid, _vm.detail.data_room[0].name)}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("delete")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.clearChat')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.block(_vm.detail.data_room[0].tokenuser,_vm.detail.data_room[0].name)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("remove_circle_outline")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.block')))])],1)],1)],1):_c('v-menu',[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"20px !important","color":"black !important"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{staticClass:"CSChatThai",staticStyle:{"width":"100%","padding":"1vh"}},[_c('v-list-tile',{on:{"click":function($event){_vm.daletechat(_vm.$route.params.roomid, _vm.detail.data_room[0].name)}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("delete")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.clearChat')))])],1)],1),_vm._v(" "),(_vm.statemember === 'block')?_c('v-list',{staticClass:"CSChatThai",staticStyle:{"width":"100%","padding":"1vh"}},[_c('v-list-tile',{on:{"click":function($event){_vm.unblockfriend(_vm.detail.data_room[0])}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("mdi-lock-open")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.unblock')))])],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"background":"#fff"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{staticStyle:{"justify-content":"center","display":"flex"},attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"90px"},on:{"click":function($event){_vm.detailimageFriend(_vm.detail.data_room[0])}}},[(_vm.detail.data_room[0].profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.detail.data_room[0].profilepicture}}):(_vm.detail.data_room[0].type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.detail.data_room[0].type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"center","margin-top":"10px"},attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[_c('p',{staticClass:"text2",staticStyle:{"color":"black","font-size":"20px","width":"170px"}},[_vm._v(_vm._s(_vm.detail.data_room[0].name))]),_vm._v(" "),_c('p',{staticClass:"text2",staticStyle:{"color":"#bcbcbc","font-size":"16px","width":"170px"}},[_vm._v(_vm._s(_vm.detail.data_room[0].status))])])],1)],1)],1),_vm._v(" "),_c('v-container',{staticStyle:{"padding-top":"2px !important","padding-left":"0px","padding-right":"0px"}},[_c('v-tabs',{attrs:{"slot":"extension","fixed-tabs":"","color":"transparent","icons-and-text":"","centered":""},slot:"extension",model:{value:(_vm.activeinfo),callback:function ($$v) {_vm.activeinfo=$$v},expression:"activeinfo"}},[_c('v-tabs-slider'),_vm._v(" "),_c('v-tab',{key:1,attrs:{"href":"#tab-1","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.toTab(1)}}},[_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('RightSide.header.profile')))]),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"25px !important","color":"#2562af !important"}},[_vm._v("account_box")])],1),_vm._v(" "),(_vm.isAccept === true)?_c('v-tab',{key:4,attrs:{"href":"#tab-4","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.toTab(4)}}},[_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('RightSide.header.privatepolicy')))]),_vm._v(" "),_c('img',{staticStyle:{"width":"25px !important"},attrs:{"src":"/static/img/icons/privacy-policy-blue.png"}})]):_vm._e()],1),_vm._v(" "),_c('v-tabs-items',{staticClass:"layoutsearchweb CSChatThai",model:{value:(_vm.activeinfo),callback:function ($$v) {_vm.activeinfo=$$v},expression:"activeinfo"}},[_c('v-tab-item',{key:"1",staticClass:"layoutsearchweb",attrs:{"id":"tab-1"}},[_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"background":"none !important","margin-top":"4px !important"},attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',{staticStyle:{"color":"#2562af","font-size":"25px !important"},attrs:{"large":""}},[_vm._v("email")])],1),_vm._v(" "),_c('v-list-tile-content',[(_vm.detail.data_room[0].email === '')?_c('v-list-tile-title',{staticStyle:{"color":"black !important"}},[_vm._v("-")]):_c('v-list-tile-title',{staticStyle:{"color":"black !important"}},[_c('span',{staticClass:"EndpointUrl"},[_vm._v("\n                        "+_vm._s(_vm.detail.data_room[0].email)+"\n                        "),_c('v-icon',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.detail.data_room[0].email),expression:"detail.data_room[0].email",arg:"copy"}],staticClass:"urlcopymessage",staticStyle:{"color":"black","font-size":"13px !important","cursor":"pointer"}},[_vm._v("file_copy")])],1)])],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"2",staticClass:"layoutsearchweb",staticStyle:{"overflow-y":"hidden"},attrs:{"id":"tab-2"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(_vm.listimageinroom.length != 0)?_c('div',{staticStyle:{"background":"#fff","box-shadow":"none !important"}},[_c('v-container',_vm._b({staticStyle:{"padding":"2px !important"},attrs:{"fluid":""}},'v-container',( _obj = {}, _obj["grid-list-sm"] = true, _obj ),false),[_c('v-layout',{staticStyle:{"overflow-y":"scroll!important","max-height":"35vh"},attrs:{"row":"","wrap":""}},[_vm._l((_vm.listimageinroom),function(memb,i){return _c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-media',{attrs:{"src":memb.path,"height":"15vh"},on:{"click":function($event){_vm.zoom(memb)}}})],1)],1)}),_vm._v(" "),(_vm.showmoreimage)?_c('v-flex',{staticStyle:{"cursor":"pointer"},attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-media',{attrs:{"height":"15vh"},on:{"click":_vm.getmoreimage}},[_vm._v("\n                           .."+_vm._s(_vm.$t('ChatSide.Read.readmore'))+"..\n                          ")])],1)],1):_vm._e()],2)],1)],1):_c('h4',{staticStyle:{"color":"black","text-align":"center","margin-top":"20px"}},[_vm._v(" "+_vm._s(_vm.$t('RightSide.noImage')))])])],1),_vm._v(" "),_c('v-tab-item',{key:"3",staticClass:"layoutsearchweb",attrs:{"id":"tab-3"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(_vm.listfileinroom.length != 0)?_c('div',{staticStyle:{"background":"#fff","overflow-y":"scroll!important","max-height":"40vh"}},[_vm._l((_vm.listfileinroom),function(memb,index){return _c('v-list',{staticClass:"layoutsearchweb",attrs:{"two-line":"","dense":"","dark":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',{attrs:{"href":memb.path,"target":"_blank"}},[_c('v-icon',{staticStyle:{"color":"#2562af"},attrs:{"large":""}},[_vm._v(" "+_vm._s(_vm.extension(memb.path)))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"color":"black !important","white-space":"nowrap","width":"15em","overflow":"hidden","text-overflow":"ellipsis"},attrs:{"href":memb.path,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(memb.file_name))])]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"CSChatThai"},[_c('v-btn',{staticClass:"btnallow",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.loadfile(memb)}}},[_vm._v("\n                              "+_vm._s(_vm.$t('AnswerQuestion.keep'))+"\n                            ")]),_vm._v(" "),_c('v-btn',{staticClass:"btncancel",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.sendimgonebox(memb.tokenmessage)}}},[_vm._v("\n                              "+_vm._s(_vm.$t('AnswerQuestion.sendOnebox'))+"\n                            ")])],1)],1)],1),_vm._v(" "),_c('v-divider')],1)}),_vm._v(" "),(_vm.showmorefile)?_c('div',{staticStyle:{"display":"flex","justify-content":"center","width":"100%"}},[_c('v-btn',{staticClass:"btncancel",staticStyle:{"display":"flex","justify-content":"center","text-transform":"none","color":"black !important","text-align":"center"},attrs:{"depressed":"","dark":""},on:{"click":_vm.getmorefile}},[_vm._v("\n                    .."+_vm._s(_vm.$t('ChatSide.Read.readmore'))+"..\n                  ")])],1):_vm._e()],2):_c('h4',{staticStyle:{"color":"black","text-align":"center","margin-top":"20px"}},[_vm._v(" "+_vm._s(_vm.$t('RightSide.noFile')))])])],1),_vm._v(" "),_c('v-tab-item',{key:"4",staticClass:"layoutsearchweb",attrs:{"id":"tab-4"}},[_c('v-subheader',{staticStyle:{"color":"white","font-weight":"900"}},[_vm._v(_vm._s(_vm.$t('RightSide.header.privatepolicy')))]),_vm._v(" "),_c('v-flex',{staticStyle:{"justify-content":"center","align-items":"center","width":"100%","display":"flex"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-btn',{staticClass:"btnallow",staticStyle:{"font-size":"14px"},attrs:{"depressed":""},on:{"click":function($event){_vm.getAccesstoken()}}},[_vm._v(_vm._s(_vm.$t('RightSide.header.privatepolicy')))])],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.detail.type === 'group' && !_vm.shownotes && !_vm.showalbum)?_c('v-flex',{staticStyle:{"height":"calc(100vh - 64px)","overflow-y":"auto"},attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-card',{staticStyle:{"background":"#fff"},attrs:{"flat":""}},[_c('v-container',{staticStyle:{"background":"#fff","padding-top":"0px"}},[_c('v-layout',{attrs:{"align-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":""}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage()}}},[_c('v-icon',[_vm._v("chevron_left")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-end":""}},[(_vm.detail.statemember == 'active')?_c('v-menu',[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"20px !important","color":"black !important"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{staticStyle:{"width":"100%","padding-top":"1vh"}},[_c('v-list-tile',{on:{"click":function($event){_vm.ShowDialog('dialogQrcode')}}},[_c('img',{staticStyle:{"width":"22px"},attrs:{"src":"/static/img/icons/qr-code.svg"}}),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.qrCode')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.toPageTask('/mobile/room/project/')}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("fas fa-tasks")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.project')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.shownotes = !_vm.shownotes}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("fas fa-sticky-note")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.note')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.showalbum = !_vm.showalbum}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("fas fa-images")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.album')))])],1),_vm._v(" "),_vm._l((_vm.listMenu),function(item,index){return _c('v-list-tile',{key:index,on:{"click":function($event){_vm.ShowDialog(item.dialog)}}},[_c('v-icon',{attrs:{"color":item.color}},[_vm._v(_vm._s(item.icon))]),_vm._v("  \n                    "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(item.title))])],1)}),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.daletechat(_vm.$route.params.roomid, _vm.detail.group_name)}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("delete")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.clearChat')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.wallpaper()}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("fas fa-images")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.setwall')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.leavegroup()}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("call_missed_outgoing")]),_vm._v("  \n                    "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.leave')))])],1)],2)],1):_c('v-menu',[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"20px !important","color":"black !important"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{staticClass:"CSChatThai",staticStyle:{"width":"100%","padding":"1vh"}},[_c('v-list-tile',{on:{"click":function($event){_vm.daletechat(_vm.$route.params.roomid, _vm.detail.group_name)}}},[_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("delete")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('RightSide.menu.clearChat')))])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"background":"#fff"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{staticStyle:{"justify-content":"center","display":"flex"},attrs:{"xs12":"","md12":"","sm12":""}},[(_vm.detail.statemember == 'active')?_c('v-avatar',{staticClass:"user-photo",attrs:{"size":"90px"},on:{"click":function($event){_vm.detailGroup(_vm.detail)}}},[(_vm.detail.picture)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.detail.picture}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer","border-color":"#e2e2e2","border-style":"solid","border-width":"thin"},attrs:{"src":"/static/img/default_profile/group-white.png"},on:{"click":_vm.uppic}})]):_c('v-avatar',{attrs:{"size":"90px"},on:{"click":function($event){_vm.detailGroup(_vm.detail)}}},[(_vm.detail.picture)?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border":"0px #1a222c !important","border-style":"solid !important","cursor":"pointer"},attrs:{"src":_vm.detail.picture}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"border":"1px #1a222c !important","border-style":"solid !important","cursor":"pointer"},attrs:{"src":"/static/img/default_profile/group-white.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"50px","margin-bottom":"1px"},attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text2",staticStyle:{"font-size":"20px"}},[_vm._v(" "+_vm._s(_vm.$t('RightSide.group'))+" : "+_vm._s(_vm.detail.group_name))])])],1)],1),_vm._v(" "),_c('v-container',{staticStyle:{"padding-top":"2px","padding-left":"0px","padding-right":"0px"}},[_c('v-tabs',{attrs:{"slot":"extension","fixed-tabs":"","color":"transparent","icons-and-text":"","centered":""},slot:"extension",model:{value:(_vm.activeinfo),callback:function ($$v) {_vm.activeinfo=$$v},expression:"activeinfo"}},[_c('v-tabs-slider'),_vm._v(" "),_c('v-tab',{key:1,attrs:{"href":"#tab-1","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.toTab(1)}}},[_c('span',{staticClass:"text-transform"},[_vm._v(_vm._s(_vm.$t('RightSide.group')))]),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"25px !important","color":"#2562af !important"}},[_vm._v("supervised_user_circle")])],1),_vm._v(" "),(_vm.detail.count_pending != '0')?_c('v-tab',{key:2,attrs:{"href":"#tab-2","disabled":_vm.statemember !== 'active'},on:{"click":function($event){_vm.toTab(2)}}},[_c('span',{staticClass:"text-transform"},[_vm._v(_vm._s(_vm.$t('RightSide.pending')))]),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"25px !important","color":"#2562af !important"}},[_vm._v("schedule")])],1):_vm._e()],1),_vm._v(" "),_c('v-tabs-items',{staticClass:"layoutsearchweb",model:{value:(_vm.activeinfo),callback:function ($$v) {_vm.activeinfo=$$v},expression:"activeinfo"}},[_c('v-tab-item',{key:"1",staticClass:"layoutsearchweb",staticStyle:{"margin-top":"1vh !important"},attrs:{"id":"tab-1"}},[(_vm.detail.count_member != '0')?_c('v-subheader',{staticStyle:{"color":"black","font-weight":"900"}},[_vm._v(_vm._s(_vm.$t('RightSide.member'))+" ("+_vm._s(_vm.detail.count_member)+")")]):_c('v-subheader',{staticStyle:{"color":"black","justify-content":"center"}},[_vm._v(_vm._s(_vm.$t('RightSide.noMember')))]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll!important","height":"35vh !important"}},[_vm._l((_vm.memberactive),function(membactive,index){return (_vm.detail.count_member !== '0')?_c('v-list',{key:membactive.tokenuser,staticClass:"layoutsearchweb",staticStyle:{"background":"none !important","cursor":"pointer"},attrs:{"dense":""}},[_c('v-list-tile',{staticStyle:{"padding":"1vh !important"}},[_c('v-list-tile-avatar',{on:{"click":function($event){_vm.detailFriendDialog(membactive)}}},[(membactive.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":membactive.profilepicture}}):(membactive.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(membactive.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{on:{"click":function($event){_vm.detailFriendDialog(membactive)}}},[_c('v-list-tile-title',{staticStyle:{"color":"black","white-space":"nowrap !important","width":"10em","word-break":"break-all !important"}},[_vm._v("\n                      "+_vm._s(membactive.nickname)+"\n                    ")])],1),_vm._v(" "),(_vm.token !== membactive.tokenuser && _vm.detail.statemember === 'active')?_c('v-list-tile-action',[_c('v-btn',{staticClass:"btnkickgroup text-transform",attrs:{"depressed":"","small":"","dark":""},on:{"click":function($event){_vm.leavegroupFriend(membactive.tokenuser,membactive.nickname,index)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.kickMemberGroup')))])],1):_vm._e()],1),_vm._v(" "),_c('v-divider')],1):_vm._e()}),_vm._v(" "),(_vm.memberactive.length < parseInt(_vm.detail.count_member))?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"CSChatThai btnallow text-transform",attrs:{"depressed":"","small":"","dark":""},on:{"click":function($event){_vm.getmember()}}},[_vm._v("\n                 "+_vm._s(_vm.$t('RightSide.loadmore'))+"\n                ")])],1):_vm._e()],2),_vm._v(" "),(_vm.edit === true)?_c('v-container',{staticStyle:{"padding-left":"15vw !important"}},[_c('v-btn',{staticClass:"CSChatThai text-transform",on:{"click":function($event){_vm.clickedit()}}},[_vm._v("\n                  "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                ")])],1):_vm._e()],1),_vm._v(" "),(_vm.detail.count_pending != '0')?_c('v-tab-item',{key:"2",staticClass:"layoutsearchweb",staticStyle:{"margin-top":"1vh !important"},attrs:{"id":"tab-2"}},[(_vm.detail.count_pending != '0')?_c('v-subheader',{staticStyle:{"color":"black","font-weight":"900","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('RightSide.pending'))+" ("+_vm._s(_vm.detail.count_pending)+")")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll!important","height":"35vh !important"}},[_vm._l((_vm.memberpending),function(membpending,index){return (_vm.detail.count_pending != '0')?_c('v-list',{key:membpending.tokenuser,staticClass:"layoutsearchweb",staticStyle:{"background":"none !important","cursor":"pointer"},attrs:{"dense":""}},[_c('v-list-tile',{staticStyle:{"padding":"1vh !important"}},[_c('v-list-tile-avatar',{on:{"click":function($event){_vm.detailFriendDialog(membpending)}}},[(membpending.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":membpending.profilepicture}}):(membpending.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(membpending.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{on:{"click":function($event){_vm.detailFriendDialog(membpending)}}},[_c('v-list-tile-title',{staticStyle:{"color":"black","white-space":"nowrap !important","width":"10em","word-break":"break-all !important"}},[_vm._v("\n                      "+_vm._s(membpending.nickname)+"\n                    ")])],1),_vm._v(" "),(_vm.detail.statemember == 'active')?_c('v-btn',{staticClass:"btnallow text-transform",attrs:{"depressed":"","small":"","dark":""},on:{"click":function($event){_vm.cancelsendinvite(membpending.tokenuser,membpending.nickname)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancelInvite')))]):_vm._e()],1),_vm._v(" "),_c('v-divider')],1):_vm._e()}),_vm._v(" "),(_vm.memberpending.length < parseInt(_vm.detail.count_pending))?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"CSChatThai btnallow text-transform",attrs:{"depressed":"","small":"","dark":""},on:{"click":function($event){_vm.getpending()}}},[_vm._v("\n                 "+_vm._s(_vm.$t('RightSide.loadmore'))+"\n                ")])],1):_vm._e()],2)],1):_vm._e(),_vm._v(" "),_c('v-tab-item',{key:"3",staticClass:"layoutsearchweb",staticStyle:{"margin-top":"1vh !important"},attrs:{"id":"tab-3"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(_vm.listimageinroom.length != 0)?_c('v-card',{staticStyle:{"background":"#fff","box-shadow":"none !important"}},[_c('v-container',_vm._b({attrs:{"fluid":""}},'v-container',( _obj$1 = {}, _obj$1["grid-list-sm"] = true, _obj$1 ),false),[_c('v-layout',{staticStyle:{"overflow-y":"scroll!important","max-height":"40vh"},attrs:{"row":"","wrap":""}},[_vm._l((_vm.listimageinroom),function(image,index){return _c('v-flex',{staticStyle:{"cursor":"pointer"},attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-media',{attrs:{"src":image.path,"height":"15vh"},on:{"click":function($event){_vm.zoom(image)}}})],1)],1)}),_vm._v(" "),(_vm.showmoreimage)?_c('v-flex',{staticStyle:{"cursor":"pointer"},attrs:{"sm4":"","md4":"","xs4":""}},[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-media',{attrs:{"height":"15vh"},on:{"click":_vm.getmoreimage}},[_vm._v("\n                            .."+_vm._s(_vm.$t('ChatSide.Read.readmore'))+"..\n                          ")])],1)],1):_vm._e()],2)],1)],1):_c('h4',{staticStyle:{"color":"black","text-align":"center","margin-top":"20px","text-transform":"none"}},[_vm._v(" "+_vm._s(_vm.$t('RightSide.noImage')))])],1)],1),_vm._v(" "),_c('v-tab-item',{key:"4",staticClass:"layoutsearchweb",staticStyle:{"margin-top":"1vh !important"},attrs:{"id":"tab-4"}},[_c('v-flex',{attrs:{"sm12":"","md12":"","xs12":""}},[(_vm.listfileinroom.length != 0)?_c('v-card',{staticStyle:{"background":"#fff","overflow-y":"scroll!important","max-height":"40vh"}},[_vm._l((_vm.listfileinroom),function(file,index){return _c('v-list',{staticClass:"layoutsearchweb",attrs:{"dark":"","two-line":"","dense":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',{attrs:{"href":file.path,"target":"_blank"}},[_c('v-icon',{staticStyle:{"color":"#2562af"},attrs:{"large":""}},[_vm._v(_vm._s(_vm.extension(file.path)))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"color":"black !important","white-space":"nowrap","width":"15em","overflow":"hidden","text-overflow":"ellipsis"},attrs:{"href":file.path,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(file.file_name))])]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"CSChatThai"},[_c('v-btn',{staticClass:"btnallow text-transform",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.loadfile(file)}}},[_vm._v("\n                              "+_vm._s(_vm.$t('AnswerQuestion.keep'))+"\n                            ")]),_vm._v(" "),_c('v-btn',{staticClass:"btncancel text-transform",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.sendimgonebox(file.tokenmessage)}}},[_vm._v("\n                               "+_vm._s(_vm.$t('AnswerQuestion.sendOnebox'))+"\n                            ")])],1)],1)],1),_vm._v(" "),_c('v-divider')],1)}),_vm._v(" "),(_vm.showmorefile)?_c('div',{staticStyle:{"display":"flex","justify-content":"center","width":"100%"}},[_c('v-btn',{staticClass:"btncancel",staticStyle:{"display":"flex","justify-content":"center","text-transform":"none","color":"black !important","text-align":"center"},attrs:{"depressed":"","dark":""},on:{"click":_vm.getmorefile}},[_vm._v("\n                    .."+_vm._s(_vm.$t('ChatSide.Read.readmore'))+"..\n                  ")])],1):_vm._e()],2):_c('h4',{staticStyle:{"color":"black","text-align":"center","margin-top":"20px","text-transform":"none"}},[_vm._v(" "+_vm._s(_vm.$t('RightSide.noFile')))])],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('InviteGroup',{attrs:{"dialogInvite":_vm.dialogInvite,"memberpending":_vm.memberpending,"member":_vm.memberactive,"group_id":_vm.detail.group_id},on:{"closeInvite":_vm.closeInvite,"invitemembergroup":_vm.invitemembergroup}}),_vm._v(" "),_c('ManageGroup',{attrs:{"dialogManageGroup":_vm.dialogManageGroup,"detail":_vm.detail},on:{"closeManageGroup":_vm.closeManageGroup}}),_vm._v(" "),_c('NoteDialog',{attrs:{"dialogNote":_vm.dialogNote,"note_id":_vm.note_id},on:{"closeNote":_vm.closeNote,"editNote":_vm.editNote,"removeNote":_vm.removeNote}}),_vm._v(" "),_c('CreateNoteDialog',{attrs:{"dialogCreatenote":_vm.dialogCreatenote,"tokenroom":_vm.room},on:{"closeCreatenote":_vm.closeCreatenote,"CreateNote":_vm.CreateNote}}),_vm._v(" "),_c('QrcodeGroup',{attrs:{"dialogQrcode":_vm.dialogQrcode,"detail":_vm.detail},on:{"closeQrcode":_vm.closeQrcode}}),_vm._v(" "),_c('AlbumsDialogMobile',{attrs:{"dialogAlbums":_vm.dialogAlbums,"albums_id":_vm.albums_id},on:{"closeAlbums":_vm.closeAlbums,"editAlbums":_vm.editAlbums,"removeAlbums":_vm.removeAlbums}}),_vm._v(" "),_c('CreateAlbumsDialogMobile',{attrs:{"dialogCreatealbums":_vm.dialogCreatealbums,"tokenroom":_vm.room},on:{"closeCreatealbums":_vm.closeCreatealbums,"CreateAlbums":_vm.CreateAlbums}}),_vm._v(" "),_c('InforfriendDialogMobile',{attrs:{"inforfrienddialog":_vm.inforfrienddialog,"tokeninforfriend":_vm.tokeninforfriend},on:{"closeInforfriend":_vm.closeInforfriend}}),_vm._v(" "),_c('SaveOnebox',{attrs:{"dialogSaveOnebox":_vm.dialogSaveOnebox,"tokenmessage_savebox":_vm.tokenmessage_savebox},on:{"closeSaveOnebox":_vm.closeSaveOnebox}}),_vm._v(" "),_c('checkconsentdialog',{attrs:{"checkconsentDialog":_vm.checkconsentDialog,"url_consent":_vm.url_consent},on:{"closeDialogConsent":_vm.closeDialogConsent}})],1):_c('v-layout',{staticClass:"rightbox CSChatThai",attrs:{"row":"","wrap":""}})
var _obj;
var _obj$1;}
var RightSideMobile_staticRenderFns = []
var RightSideMobile_esExports = { render: RightSideMobile_render, staticRenderFns: RightSideMobile_staticRenderFns }
/* harmony default export */ var layout_RightSideMobile = (RightSideMobile_esExports);
// CONCATENATED MODULE: ./src/components/mobile/layout/RightSideMobile.vue
function RightSideMobile_injectStyle (ssrContext) {
  __webpack_require__("Yd74")
}
var RightSideMobile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RightSideMobile___vue_template_functional__ = false
/* styles */
var RightSideMobile___vue_styles__ = RightSideMobile_injectStyle
/* scopeId */
var RightSideMobile___vue_scopeId__ = "data-v-02b46020"
/* moduleIdentifier (server only) */
var RightSideMobile___vue_module_identifier__ = null
var RightSideMobile_Component = RightSideMobile_normalizeComponent(
  RightSideMobile["a" /* default */],
  layout_RightSideMobile,
  RightSideMobile___vue_template_functional__,
  RightSideMobile___vue_styles__,
  RightSideMobile___vue_scopeId__,
  RightSideMobile___vue_module_identifier__
)

/* harmony default export */ var mobile_layout_RightSideMobile = (RightSideMobile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/layout/LayoutChatMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import CenterSideMobile from '@/components/mobile/layout/CenterSideMobile'



/* harmony default export */ var LayoutChatMobile = ({
  components: {
    LeftSideMobile: mobile_layout_LeftSideMobileTest,
    // CenterSideMobile,
    CenterSideTest: mobile_layout_CenterSideTest,
    RightSideMobile: mobile_layout_RightSideMobile,
    vue100vh: vue100vh["a" /* default */]
  },
  created: function created() {
    this.isShowFriendList = false;
    // this.status_login = this.$cookie.get('status_login')
    localStorage.setItem('room', this.$route.params.roomid);
    // console.log('created')
    // console.log(this.$route.params.room)
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
  },
  data: function data() {
    return {
      status_login: '',
      isShowFriendList: true,
      isShowChat: true,
      isShowInfo: false,
      bgchat: 'background-color: #fff;',
      windowWidth: ''
    };
  },

  watch: {
    windowWidth: function windowWidth() {
      if (this.windowWidth > 960) {
        if (!this.isShowFriendList) {
          this.$router.push('/chat/room/' + this.$route.params.roomid);
        } else {
          this.$router.push('/');
        }
      }
    }
  },
  methods: {
    logout: function logout() {
      localStorage.clear();
      // this.$router.push('/')
      if (true) {
        window.open("https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage", '_parent');
      } else {
        this.$router.push({ path: '/', force: true });
      }
    },
    hideFrindList: function hideFrindList(status) {
      // console.log(status)
      // console.log('test3')
      this.isShowFriendList = status;
      this.isShowChat = false;
      this.isShowInfo = false;
      this.bgchat = 'background-color: #fff;';
    },
    hideChat: function hideChat(status) {
      // console.log(status)
      // console.log('test2')
      this.isShowChat = status;
      this.isShowFriendList = false;
      this.isShowInfo = false;
      this.bgchat = 'background-color: white;';
    },
    hideInfo: function hideInfo(status) {
      // console.log(status)
      // console.log('miew')
      this.isShowInfo = status;
      this.isShowChat = false;
      this.isShowFriendList = false;
      this.bgchat = 'background-color: white;';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a39d4c3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/layout/LayoutChatMobile.vue
var LayoutChatMobile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%","overflow-y":"hidden !important"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{staticClass:"hidden-md-and-up",style:(_vm.bgchat),attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowFriendList === true),expression:"isShowFriendList === true"}],attrs:{"xs12":"","sm12":"","md12":""}},[_c('LeftSideMobile',{on:{"data":_vm.hideChat}})],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowFriendList === false && _vm.isShowInfo == false),expression:"isShowFriendList === false && isShowInfo == false"}],attrs:{"xs12":"","sm12":"","md12":""}},[_c('CenterSideTest',{on:{"data":_vm.hideFrindList,"profile":_vm.hideInfo}})],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowFriendList === false && _vm.isShowChat === false && _vm.isShowInfo == true),expression:"isShowFriendList === false && isShowChat === false && isShowInfo == true"}],attrs:{"xs12":"","sm12":"","md12":""}},[_c('RightSideMobile',{on:{"chat":_vm.hideChat,"data":_vm.hideFrindList}})],1)],1)],1)],1)}
var LayoutChatMobile_staticRenderFns = []
var LayoutChatMobile_esExports = { render: LayoutChatMobile_render, staticRenderFns: LayoutChatMobile_staticRenderFns }
/* harmony default export */ var layout_LayoutChatMobile = (LayoutChatMobile_esExports);
// CONCATENATED MODULE: ./src/components/mobile/layout/LayoutChatMobile.vue
function LayoutChatMobile_injectStyle (ssrContext) {
  __webpack_require__("eQDG")
}
var LayoutChatMobile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LayoutChatMobile___vue_template_functional__ = false
/* styles */
var LayoutChatMobile___vue_styles__ = LayoutChatMobile_injectStyle
/* scopeId */
var LayoutChatMobile___vue_scopeId__ = "data-v-a39d4c3e"
/* moduleIdentifier (server only) */
var LayoutChatMobile___vue_module_identifier__ = null
var LayoutChatMobile_Component = LayoutChatMobile_normalizeComponent(
  LayoutChatMobile,
  layout_LayoutChatMobile,
  LayoutChatMobile___vue_template_functional__,
  LayoutChatMobile___vue_styles__,
  LayoutChatMobile___vue_scopeId__,
  LayoutChatMobile___vue_module_identifier__
)

/* harmony default export */ var mobile_layout_LayoutChatMobile = (LayoutChatMobile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/RedirectChatRoom.vue
//
//
//
//
//
//


/* harmony default export */ var RedirectChatRoom = ({
  data: function data() {
    return {
      progress: true,
      decoded: '',
      token: '',
      windowWidth: '',
      url_redirect: "https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect"
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
  },
  created: function created() {
    this.windowWidth = window.innerWidth;
    console.log('authen: ' + "https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect");
    localStorage.setItem('botid_redirect', this.$route.params.botid);
    this.$cookie.set('logouturl', this.$route.query.logouturl);
    console.log('url: ' + this.$route.query.logouturl);
    if (localStorage.getItem('Authenrization') !== null) {
      this.decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      if (this.decoded.status_login !== 'T') {
        if (true) {
          window.open(this.url_redirect, '_parent');
        } else {
          this.$router.push('/login');
        }
      } else {
        // this.token = this.decoded['tokenuser']
        this.searchFriend(this.$route.params.botid, this.decoded['tokenuser']);
      }
    } else {
      // this.$router.push('/login')
      if (true) {
        window.open(this.url_redirect, '_parent');
      } else {
        console.log('to login');
        this.$router.push('/login');
      }
    }
  },

  methods: {
    searchFriend: function searchFriend(botid, token) {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend", {
        tokenbot: botid,
        tokenuser: token
      }).then(function (response) {
        // console.log(response.data.listuser)
        if (response.data.listuser.length === 0) {
          _this2.progress = false;
          localStorage.removeItem('botid_redirect');
          // this.$swal('', 'ไม่มีข้อมูลบอทในระบบ กรุณาตรวจสอบข้อมูลให้ถูกต้อง', 'warning')
          if (_this2.windowWidth <= 960) {
            _this2.$router.push('/mobile/homepage');
          } else {
            _this2.$router.push('/chat');
          }
        } else {
          if (response.data.listuser.relation === 'friend') {
            _this2.progress = false;
            localStorage.removeItem('botid_redirect');
            if (_this2.windowWidth <= 960) {
              _this2.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom);
            } else {
              _this2.$router.push('/chat/room/' + response.data.listuser.user.tokenroom);
            }
          } else {
            console.log('not friend');
            _this2.$router.push('/addbot/' + _this2.$route.params.botid);
          }
        }
      }).catch(function (error) {
        console.log(error);
        console.log(error.response);
        _this2.progress = false;
        localStorage.removeItem('botid_redirect');
        // this.$swal('', 'ไม่มีข้อมูลบอทในระบบ กรุณาตรวจสอบข้อมูลให้ถูกต้อง', 'warning')
        if (_this2.windowWidth <= 960) {
          _this2.$router.push('/mobile/homepage');
        } else {
          _this2.$router.push('/chat');
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c2b6bbe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/RedirectChatRoom.vue
var RedirectChatRoom_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"height":"100vh"},attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"width":8,"size":80,"color":"primary","indeterminate":_vm.progress}})],1)}
var RedirectChatRoom_staticRenderFns = []
var RedirectChatRoom_esExports = { render: RedirectChatRoom_render, staticRenderFns: RedirectChatRoom_staticRenderFns }
/* harmony default export */ var homepage_RedirectChatRoom = (RedirectChatRoom_esExports);
// CONCATENATED MODULE: ./src/components/homepage/RedirectChatRoom.vue
function RedirectChatRoom_injectStyle (ssrContext) {
  __webpack_require__("A0Ju")
}
var RedirectChatRoom_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RedirectChatRoom___vue_template_functional__ = false
/* styles */
var RedirectChatRoom___vue_styles__ = RedirectChatRoom_injectStyle
/* scopeId */
var RedirectChatRoom___vue_scopeId__ = "data-v-7c2b6bbe"
/* moduleIdentifier (server only) */
var RedirectChatRoom___vue_module_identifier__ = null
var RedirectChatRoom_Component = RedirectChatRoom_normalizeComponent(
  RedirectChatRoom,
  homepage_RedirectChatRoom,
  RedirectChatRoom___vue_template_functional__,
  RedirectChatRoom___vue_styles__,
  RedirectChatRoom___vue_scopeId__,
  RedirectChatRoom___vue_module_identifier__
)

/* harmony default export */ var components_homepage_RedirectChatRoom = (RedirectChatRoom_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/AddBot.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var AddBot = ({
  data: function data() {
    return {
      progress: false,
      decoded: '',
      infor_bot: {},
      relation: '',
      tokenuser: '',
      dialogPassword: false,
      loading: false,
      password: '',
      message_error: '',
      windowWidth: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
  },
  created: function created() {
    this.windowWidth = window.innerWidth;
    this.decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = this.decoded.tokenuser;
    this.searchFriend(this.$route.params.botid);
  },

  methods: {
    searchFriend: function searchFriend(botid) {
      var _this2 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend", {
        tokenbot: botid,
        tokenuser: this.tokenuser
      }).then(function (response) {
        _this2.progress = false;
        // console.log(response.data.listuser)
        if (response.data.listuser) {
          localStorage.removeItem('botid_redirect');
          _this2.infor_bot = response.data.listuser;
          // console.log(`obj: ${this.infor_bot.relation}`)
          if (_this2.infor_bot.relation === 'unknow' || _this2.infor_bot.relation === 'unfriend' || _this2.infor_bot.relation === 'unknown') {
            _this2.relation = 'เพิ่มเพื่อน';
            // console.log(`re: ${this.relation}`)
          } else if (_this2.infor_bot.relation === 'block') {
            _this2.relation = 'ยกเลิกบล็อค';
          } else if (_this2.infor_bot.relation === 'friend') {
            _this2.relation = 'แชท';
            // if (this.windowWidth <= 960) {
            //   this.$router.push('/mobile/room/' + response.data.tokenroom)
            // } else {
            //   this.$router.push('/chat/room/' + response.data.tokenroom)
            // }
          }
        } else {
          _this2.progress = false;
          if (_this2.windowWidth <= 960) {
            _this2.$router.push('/mobile/homepage');
          } else {
            _this2.$router.push('/chat');
          }
        }
      }).catch(function (error) {
        _this2.progress = false;
        console.log(error);
      });
    },
    check_password_bot: function check_password_bot() {
      var _this3 = this;

      this.message_error = '';
      this.loading = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/check_password_bot', {
        tokenBot: this.infor_bot.user.tokenuser,
        password: this.password
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          if (response.data.message === 'correct password') {
            _this3.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", {
              tokenfriend: _this3.infor_bot.user.tokenuser,
              tokenuser: _this3.tokenuser
            }).then(function (response) {
              if (response.data.status === 'success') {
                _this3.dialogPassword = false;
                _this3.loading = false;
                _this3.password = '';
                if (_this3.windowWidth <= 960) {
                  _this3.$router.push('/mobile/room/' + response.data.tokenroom);
                } else {
                  _this3.$router.push('/chat/room/' + response.data.tokenroom);
                }
              }
            });
          } else {
            _this3.loading = false;
            _this3.message_error = _this3.$t('LeftSide.addFiend.messageCheckbot');
            // console.log(response.data.message)
          }
        }
      });
    },
    clear_dialog_pass: function clear_dialog_pass() {
      this.message_error = '';
      this.password = '';
    },
    close_dialog_pass: function close_dialog_pass() {
      this.dialogPassword = false;
      this.message_error = '';
      this.password = '';
    },
    close: function close() {
      // ถ้ามีค่า bot redirect url แต่ปิด dialog add friend จะลบค่าออก
      // เวลาเข้าห้องแชทจะไม่มีการแสดง webview
      if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
        localStorage.removeItem('botid_redirect_url');
      }
      this.progress = true;
      if (this.windowWidth <= 960) {
        this.progress = false;
        this.$router.push('/mobile/homepage');
      } else {
        this.progress = false;
        this.$router.push('/chat');
      }
    },
    addFriend: function addFriend() {
      var _this4 = this;

      console.log('add friend');
      if (this.infor_bot.user.is_password !== '0') {
        console.log('is_password');
        this.dialogPassword = true;
        // this.infor_bot = { 'tokenbot': tokenfriend, 'index': index }
      } else {
        this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", {
          tokenfriend: this.infor_bot.user.tokenuser,
          tokenuser: this.tokenuser
        }).then(function (response) {
          if (response.data.status === 'success') {
            if (_this4.windowWidth <= 960) {
              _this4.$router.push('/mobile/room/' + response.data.tokenroom);
            } else {
              _this4.$router.push('/chat/room/' + response.data.tokenroom);
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    unBlock: function unBlock() {
      var _this5 = this;

      this.$swal({
        title: 'คุณแน่ใจหรือไหม?',
        text: 'เรากำลังยกเลิกการบล็อค ' + this.infor_bot.user.name + ' !',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this5.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', {
            tokenfriend: _this5.infor_bot.user.tokenuser,
            tokenuser: _this5.tokenuser,
            tokenroom: _this5.infor_bot.user.tokenroom }).then(function (response) {
            if (response.data['status'] === 'success') {
              _this5.$swal('', 'ยกเลิกการบล็อคสำเร็จ.', 'success');
              _this5.infor_bot.relation = 'friend';
              _this5.relation = 'แชท';
            }
          });
        }
      });
    },
    Chat: function Chat() {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/room/' + this.infor_bot.user.tokenroom);
      } else {
        this.$router.push('/chat/room/' + this.infor_bot.user.tokenroom);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ac2d6d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/AddBot.vue
var AddBot_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.progress)?_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":80,"width":8,"color":"primary","indeterminate":_vm.progress}})],1):_c('v-layout',{attrs:{"column":"","wrap":"","justify-start":"","align-center":""}},[_c('div',{staticClass:"div-right"},[_c('v-btn',{attrs:{"color":"primary","icon":"","flat":""},on:{"click":function($event){_vm.close()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":"80"}},[(_vm.infor_bot.user.profilepicture)?_c('img',{attrs:{"src":_vm.infor_bot.user.profilepicture}}):_c('img',{attrs:{"src":"/static/img/default_profile/bot-white.png"}})]),_vm._v(" "),_c('div',{staticClass:"mt-3 div-center"},[_c('h3',{staticClass:"text2"},[_vm._v(_vm._s(_vm.infor_bot.user.nickname))])]),_vm._v(" "),(_vm.infor_bot.relation === 'unknow' || _vm.infor_bot.relation === 'unfriend' || _vm.infor_bot.relation === 'unknown')?_c('v-btn',{staticClass:"mt-4",attrs:{"dark":"","color":"primary","round":""},on:{"click":function($event){_vm.addFriend()}}},[_c('span',[_vm._v(_vm._s(_vm.relation))])]):(_vm.infor_bot.relation === 'block')?_c('v-btn',{staticClass:"mt-4",attrs:{"dark":"","color":"red","round":""},on:{"click":function($event){_vm.unBlock()}}},[_c('span',[_vm._v(_vm._s(_vm.relation))])]):_vm._e(),_vm._v(" "),(_vm.infor_bot.relation === 'friend')?_c('v-btn',{staticClass:"mt-4",attrs:{"dark":"","color":"primary","round":""},on:{"click":function($event){_vm.Chat()}}},[_c('span',[_vm._v(_vm._s(_vm.relation))])]):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialogPassword),callback:function ($$v) {_vm.dialogPassword=$$v},expression:"dialogPassword"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('LeftSide.addFiend.headerCheckpass'))+"\n            "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.close_dialog_pass}},[_c('v-icon',{staticStyle:{"color":"black !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"solo":"","label":_vm.$t('LeftSide.addFiend.placeholderPassword'),"clearable":"","hide-details":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.check_password_bot($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"red","padding-left":"10px"}},[_vm._v(_vm._s(_vm.message_error))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"btncancle",on:{"click":_vm.clear_dialog_pass}},[_vm._v("\n              "+_vm._s(_vm.$t('AnswerQuestion.clear'))+"\n            ")]),_vm._v(" "),_c('v-btn',{staticClass:"btnaddfriend",attrs:{"loading":_vm.loading},on:{"click":_vm.check_password_bot}},[_vm._v("\n              "+_vm._s(_vm.$t('AnswerQuestion.addFriend'))+"\n            ")])],1)],1)],1)],1)],1)}
var AddBot_staticRenderFns = []
var AddBot_esExports = { render: AddBot_render, staticRenderFns: AddBot_staticRenderFns }
/* harmony default export */ var homepage_AddBot = (AddBot_esExports);
// CONCATENATED MODULE: ./src/components/homepage/AddBot.vue
function AddBot_injectStyle (ssrContext) {
  __webpack_require__("XuE6")
}
var AddBot_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AddBot___vue_template_functional__ = false
/* styles */
var AddBot___vue_styles__ = AddBot_injectStyle
/* scopeId */
var AddBot___vue_scopeId__ = "data-v-2ac2d6d2"
/* moduleIdentifier (server only) */
var AddBot___vue_module_identifier__ = null
var AddBot_Component = AddBot_normalizeComponent(
  AddBot,
  homepage_AddBot,
  AddBot___vue_template_functional__,
  AddBot___vue_styles__,
  AddBot___vue_scopeId__,
  AddBot___vue_module_identifier__
)

/* harmony default export */ var components_homepage_AddBot = (AddBot_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/settings/Editprofile.vue
var Editprofile = __webpack_require__("KeEH");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bd997ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/settings/Editprofile.vue
var Editprofile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('div',{staticClass:"CSChatThai BGwhite"},[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/homepage')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('HeaderMenubar.editProfile')))])],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important","overflow-y":"scroll","max-height":"94vh","color":"rgb(74, 74, 74) !important"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"display":"flex !important","justify-content":"center !important"},attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('ul',{staticClass:"List_Register"},[_c('li',{staticClass:"List_item"},[_c('div',{staticClass:"List_item_body"},[_c('div',{staticClass:"SettingImg",staticStyle:{"justify-content":"center","display":"flex"}},[_c('div',{staticClass:"SettingImgWrap"},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[(_vm.profilepicture !== '')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer","width":"100px","height":"100px"},attrs:{"src":_vm.profilepicture},on:{"click":_vm.uppic}}):(_vm.typeuser === 'user')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer","width":"100px","height":"100px"},attrs:{"src":"/static/img/default_profile/man-white.png"},on:{"click":_vm.uppic}}):(_vm.typeuser === 'government')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer","width":"100px","height":"100px"},attrs:{"src":"/static/img/default_profile/business-white.png"},on:{"click":_vm.uppic}}):(_vm.typeuser === 'business')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer","width":"100px","height":"100px"},attrs:{"src":"/static/img/default_profile/business-white.png"},on:{"click":_vm.uppic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer","width":"100px","height":"100px"},attrs:{"src":"/static/img/default_profile/man-white.png"},on:{"click":_vm.uppic}}),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('input',{staticClass:"CSChatThai",attrs:{"type":"file","name":"file1","accept":"image/*","id":"uploadpicprofilechat"},on:{"change":_vm.previewImageprofiles}})]),_vm._v(" "),_c('label',{staticClass:"SettingImgBtn",attrs:{"for":"SettingImg"},on:{"click":_vm.uppictest}},[_vm._v("\n                                  "+_vm._s(_vm.$t('Settings.editProfile.changePictureProfile'))+"\n                                ")])]),_vm._v(" "),_c('input',{staticClass:"SettingImgInput",attrs:{"data-v-0c521aa4":"","type":"file","name":"file","id":"uploadpicprofilechat"},on:{"change":_vm.previewImageprofiles}})],1)]),_vm._v(" "),_c('p',{staticClass:"EditAreaNote"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.support'))+" .JPEG/.PNG/.GIF")]),_c('p',{staticClass:"EditAreaNote"}),_c('p',{staticClass:"EditAreaNote"})])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.profile')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"Setting"},[_c('div',{staticClass:"SettingBlock"},[_c('p',{staticClass:"SettingTtl"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.displayName')))]),_vm._v(" "),_c('div',[(!_vm.editname)?_c('div',{staticClass:"EditArea"},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[_c('div',{staticClass:"EditAreaCont BreakWord"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":""},on:{"click":function($event){_vm.editname = !_vm.editname}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.edit')))])])],1)],1):_c('div',{staticClass:"EditArea"},[_c('div',{staticClass:"EditAreaCont"},[_c('div',{staticClass:"EditAreaContFlex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nameedit),expression:"nameedit"}],staticClass:"InputEdit",attrs:{"type":"text","placeholder":"ชื่อผู้ใช้"},domProps:{"value":(_vm.nameedit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nameedit=$event.target.value}}})]),_vm._v(" "),(_vm.nameedit == '')?_c('p',{staticClass:"EditAreaNote",staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.alerterror))]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":""}},[_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":"","loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){_vm.updatename()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.update')))])]),_vm._v(" "),_c('v-btn',{staticClass:"buttoncancel",attrs:{"flat":"","small":""},on:{"click":function($event){_vm.cancelname()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"SettingBlock"},[_c('p',{staticClass:"SettingTtl"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.status')))]),_vm._v(" "),_c('div',[(!_vm.editstatus)?_c('div',{staticClass:"EditArea"},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[(_vm.status !== '')?_c('div',{staticClass:"EditAreaCont BreakWord"},[_vm._v(_vm._s(_vm.status))]):_c('div',{staticClass:"EditAreaCont BreakWord"},[_vm._v("-")]),_vm._v(" "),_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":""},on:{"click":function($event){_vm.editstatus = !_vm.editstatus}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.edit')))])])],1)],1):_c('div',{staticClass:"EditArea"},[_c('div',{staticClass:"EditAreaCont"},[_c('div',{staticClass:"EditAreaContFlex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.statusedit),expression:"statusedit"}],staticClass:"InputEdit",attrs:{"type":"text","placeholder":"สถานะ"},domProps:{"value":(_vm.statusedit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.statusedit=$event.target.value}}})]),_vm._v(" "),(_vm.statusedit == '')?_c('p',{staticClass:"EditAreaNote",staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.alerterror))]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":""}},[_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":"","loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){_vm.updatestatus()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.update')))])]),_vm._v(" "),_c('v-btn',{staticClass:"buttoncancel",attrs:{"flat":"","small":""},on:{"click":function($event){_vm.cancelstatus()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"SettingBlock"},[_c('p',{staticClass:"SettingTtl"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.phone')))]),_vm._v(" "),_c('div',[(!_vm.editphone)?_c('div',{staticClass:"EditArea"},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[_c('div',{staticClass:"EditAreaCont BreakWord"},[_vm._v(_vm._s(_vm.phone))]),_vm._v(" "),_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":""},on:{"click":function($event){_vm.statusEditphone()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.edit')))])])],1)],1):_c('div',{staticClass:"EditArea"},[_c('div',{staticClass:"EditAreaCont"},[_c('div',{staticClass:"EditAreaContFlex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneedit),expression:"phoneedit"}],staticClass:"InputEdit",attrs:{"type":"text","placeholder":_vm.$t('Settings.editProfile.phone')},domProps:{"value":(_vm.phoneedit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phoneedit=$event.target.value}}})]),_vm._v(" "),(_vm.phoneedit == '')?_c('p',{staticClass:"EditAreaNote",staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.alerterror))]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":""}},[_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":"","dark":"","loading":_vm.loadingUpdatePhone,"disabled":_vm.disableupdatephone()},on:{"click":function($event){_vm.updatephone()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.update')))])]),_vm._v(" "),_c('v-btn',{staticClass:"buttoncancel",attrs:{"flat":"","small":""},on:{"click":function($event){_vm.cancelphone()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"SettingBlock"},[_c('p',{staticClass:"SettingTtl"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.email')))]),_vm._v(" "),_c('div',[_c('div',{staticClass:"EditArea"},[_c('div',{staticClass:"EditAreaCont BreakWord"},[_vm._v(_vm._s(_vm.email))])])])])])]),_vm._v(" "),(_vm.status_username === 'false')?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.settingusername')))])]):_vm._e(),_vm._v(" "),(_vm.status_username === 'false')?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"Setting"},[_c('div',{staticClass:"SettingBlock"},[_c('div',[(!_vm.editusername)?_c('div',{staticClass:"EditArea"},[_c('v-layout',{attrs:{"column":"","justify-center":"","align-center":""}},[(!_vm.loadingname)?_c('div',{staticClass:"EditAreaCont BreakWord"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.usernamepassword')))]):_c('div',{staticClass:"EditAreaCont BreakWord"},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.loadingname}})],1),_vm._v(" "),_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":"","dark":""},on:{"click":function($event){_vm.editusername = !_vm.editusername}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.edit')))])])],1)],1):_c('div',{staticClass:"EditArea",staticStyle:{"align-items":"start !important"}},[_c('div',{staticClass:"EditAreaCont"},[_c('v-layout',{attrs:{"column":"","justify-center":"","alignCenter":""}},[_c('v-text-field',{attrs:{"placeholder":_vm.$t('Settings.editProfile.username'),"rules":_vm.usernameRules,"error":_vm.chkUsernameDuplicate,"error-messages":_vm.msgUsernameDuplicate,"autocapitalize":"off","required":"","solo":""},on:{"input":_vm.changeUsername,"keypress":function($event){_vm.isNumandaz($event)}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{attrs:{"placeholder":_vm.$t('Settings.editProfile.password'),"append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'text' : 'password',"rules":_vm.passwordRules,"required":"","solo":""},on:{"keypress":function($event){_vm.isnotthai($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"placeholder":_vm.$t('Settings.editProfile.confirmpassword'),"append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'text' : 'password',"rules":_vm.repasswordRules,"required":"","solo":""},on:{"keypress":function($event){_vm.isnotthai($event)}},model:{value:(_vm.confirmpassword),callback:function ($$v) {_vm.confirmpassword=$$v},expression:"confirmpassword"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"buttonedit",attrs:{"flat":"","small":"","dark":"","loading":_vm.loadingname,"disabled":_vm.checkData()},on:{"click":function($event){_vm.updateusername()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.update')))])]),_vm._v(" "),_c('v-btn',{staticClass:"buttoncancel",attrs:{"flat":"","small":""},on:{"click":function($event){_vm.cancelusername()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])])],1)],1)],1)])])])])]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","xs12":""}},[_c('h3',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.qrcodeForAddFriend')))])]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","xs12":""}},[_c('div',{staticClass:"Setting"},[_c('div',{staticClass:"SettingBlock"},[_c('div',{staticClass:"SettingQr"},[_c('p',{staticClass:"SettingQrImg"},[_c('qrcode',{staticStyle:{"width":"180px","height":"180px"},attrs:{"value":_vm.tokenuserQR,"id":"downloadqr-profile"}})],1)]),_vm._v(" "),_c('p',{staticClass:"SettingQrNote"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.detailQRcode'))+"\n                        "),_c('a',{staticClass:"button",attrs:{"href":"#","id":"btn-download-profile","download":'qrcode_user_' + _vm.name + '.png'},on:{"click":function($event){_vm.loadqr()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.download')))])])])])])],1)],1)],1)],1)],1)],1)],1)])}
var Editprofile_staticRenderFns = []
var Editprofile_esExports = { render: Editprofile_render, staticRenderFns: Editprofile_staticRenderFns }
/* harmony default export */ var settings_Editprofile = (Editprofile_esExports);
// CONCATENATED MODULE: ./src/components/mobile/settings/Editprofile.vue
function Editprofile_injectStyle (ssrContext) {
  __webpack_require__("9bZE")
}
var Editprofile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Editprofile___vue_template_functional__ = false
/* styles */
var Editprofile___vue_styles__ = Editprofile_injectStyle
/* scopeId */
var Editprofile___vue_scopeId__ = "data-v-3bd997ee"
/* moduleIdentifier (server only) */
var Editprofile___vue_module_identifier__ = null
var Editprofile_Component = Editprofile_normalizeComponent(
  Editprofile["a" /* default */],
  settings_Editprofile,
  Editprofile___vue_template_functional__,
  Editprofile___vue_styles__,
  Editprofile___vue_scopeId__,
  Editprofile___vue_module_identifier__
)

/* harmony default export */ var mobile_settings_Editprofile = (Editprofile_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/settings/Feedback.vue
var mobile_settings_Feedback = __webpack_require__("iVuR");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f06c2a78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/settings/Feedback.vue
var settings_Feedback_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('div',[_c('v-toolbar',{staticStyle:{"background":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/homepage')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s(_vm.$t('Settings.feedback.suggestion')))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"overflow-y":"scroll","height":"calc(100vh - 127px)"}},[_c('v-layout',{attrs:{"column":"","justify-center":""}},[_c('v-icon',{staticStyle:{"font-size":"60px !important"},attrs:{"color":"black"}},[_vm._v("feedback")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('p',{staticClass:"CSChatThai",staticStyle:{"font-size":"14px","color":"black"}},[_vm._v("  "+_vm._s(_vm.$t('Settings.feedback.titleFeedback'))+" "),_c('a',{attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")]),_vm._v(" "+_vm._s(_vm.$t('Conjunction.or'))+"\n          "),_c('span',{staticStyle:{"text-decoration":"underline","color":"#1e88e5","cursor":"pointer"},attrs:{"href":"javascript:;"},on:{"click":function($event){$event.stopPropagation();_vm.conditions = true}}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.contact')))])]),_vm._v(" "),_c('v-dialog',{attrs:{"width":"70%"},model:{value:(_vm.conditions),callback:function ($$v) {_vm.conditions=$$v},expression:"conditions"}},[_c('v-card',[_c('v-card-title',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Settings.feedback.contact')))]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"blue"},on:{"click":function($event){_vm.conditions = false}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"placeholder":_vm.$t('Settings.feedback.name'),"single-line":"","solo":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('div',{staticClass:"InputEdit",staticStyle:{"width":"100%"}},[_c('v-menu',{staticStyle:{"width":"100%","height":"20px","margin-bottom":"7px"},attrs:{"bottom":"","offset-y":""}},[_c('v-btn',{staticStyle:{"width":"100%","padding":"0","margin":"0"},attrs:{"slot":"activator","flat":"","row":"","wrap":""},slot:"activator"},[(!_vm.title.category_TH)?_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0vw","font":"14px","color":"#757575"}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.title')))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0vw","font":"14px","color":"black"},attrs:{"else":""}},[_vm._v(_vm._s((_vm.$i18n.locale == 'th')? _vm.title.category_TH:_vm.title.category_ENG))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"25px !important","color":"#929292"}},[_vm._v("expand_more")])],1),_vm._v(" "),_c('div',{staticStyle:{"background":"white","height":"300px"}},[_c('div',{staticStyle:{"background-color":"#2562af","color":"white","font-size":"16px","font-weight":"700"}},[_c('span',{staticClass:"CSChatThai",staticStyle:{"padding":"5px !important"}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.report')))])]),_vm._v(" "),_c('v-list',_vm._l((_vm.items.list_report),function(item,index){return _c('v-list-tile',{staticStyle:{"background":"white"},on:{"click":function($event){_vm.title = item;}}},[_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s((_vm.$i18n.locale == 'th')? item.category_TH:item.category_ENG))])],1)})),_vm._v(" "),_c('div',{staticStyle:{"background":"white"}},[_c('div',{staticStyle:{"background-color":"#2562af","color":"white","font-size":"16px","font-weight":"700"}},[_c('span',{staticClass:"CSChatThai",staticStyle:{"padding":"5px !important"}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.suggestion')))])]),_vm._v(" "),_c('v-list',_vm._l((_vm.items.list_feedback),function(item,index){return _c('v-list-tile',{staticStyle:{"background":"white"},on:{"click":function($event){_vm.title = item;}}},[_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(_vm._s((_vm.$i18n.locale == 'th')? item.category_TH:item.category_ENG))])],1)}))],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-textarea',{staticStyle:{"height":"90px !important"},attrs:{"placeholder":_vm.$t('Settings.feedback.detail'),"counter":"","maxlength":"255","full-width":"","single-line":"","solo":"","height":"85"},model:{value:(_vm.detail),callback:function ($$v) {_vm.detail=$$v},expression:"detail"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{ref:"fileformmo",staticStyle:{"float":"left","display":"none"}},[_c('label',[_c('b',{staticClass:"CSChatThai",staticStyle:{"text-decoration":"underline","cursor":"pointer","text-indent":"5em"}},[_vm._v(_vm._s(_vm.$t('Settings.feedback.selectPicture')))]),_vm._v(" "),_c('input',{ref:"filesmo",staticStyle:{"display":"none"},attrs:{"type":"file","id":"filesmo","multiple":"","accept":".png, .jpg, .jpeg, .gif, .bmp, .wbmp"},on:{"change":function($event){_vm.handleFilesUploadmo()}}})])]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('Settings.feedback.selectPicture')))]),_vm._v(" "),_c('v-layout',{staticClass:"containers hidden-md-and-up layoutimagemo",attrs:{"row":"","wrap":"","align-center":""}},[(_vm.filesmo.length === 0)?_c('div',{staticStyle:{"text-align":"center","height":"20vh","margin":"auto"}},[_c('label',{staticStyle:{"text-align":"center","cursor":"pointer"}},[_c('v-icon',{staticStyle:{"font-size":"40px !important","color":"#1a222c","display":"flex","justify-content":"center"},attrs:{"color":"primary"}},[_vm._v("mdi-package-variant")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"13px"}},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.support'))+" .JPEG/.PNG/.GIF")]),_vm._v(" "),_c('div',[_c('v-btn',{attrs:{"color":"primary","small":"","outline":""},on:{"click":function($event){_vm.uppicmo()}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.uploadPhoto'))+"\n              ")])],1)],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"containers",staticStyle:{"overflow-y":"scroll","height":"195px","display":"-webkit-inline-box","padding-top":"10px","width":"100%"},attrs:{"xs12":"","sm12":"","md12":""}},[_vm._l((_vm.filesmo),function(file,key){return _c('div',{staticStyle:{"justify-content":"center","margin-left":"2vw","padding-top":"1vh","align-items":"center"}},[(_vm.extension(file.file.name) == 'fas fa-file-image')?_c('div',{staticClass:"previewimgmobile",staticStyle:{"text-align":"center","display":"grid","justify-content":"center"}},[_c('v-icon',{staticStyle:{"margin-left":"100px"},attrs:{"color":"primary"},on:{"click":function($event){_vm.removeFilemo( key )}}},[_vm._v("close")]),_vm._v(" "),_c('img',{ref:'preview'+parseInt( key ),refInFor:true,staticStyle:{"margin-left":"20px","height":"80px !important","width":"80px !important","display":"flex","justify-content":"center","margin-top":"10px","align-items":"center !important","margin-bottom":"10px","object-fit":"cover"}}),_vm._v(" "),_c('b',{staticClass:"text2",staticStyle:{"margin-left":"25px"}},[_vm._v(_vm._s(file.file.name))])],1):_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center"}},[_c('v-icon',{staticStyle:{"font-size":"60px !important","color":"#1a222c","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(file.file.name)))]),_vm._v(" "),_c('b',{staticClass:"text2"},[_vm._v(_vm._s(file.file.name))])],1)])}),_vm._v(" "),(_vm.filesmo.length !== 0 && _vm.filesmo.length !== 5)?_c('div',{staticStyle:{"justify-content":"center","margin-left":"2vw","padding-top":"1vh","align-items":"center","display":"flex"}},[_c('v-btn',{staticStyle:{"height":"70px","border-radius":"10px"},attrs:{"outline":"","color":"primary"},on:{"click":function($event){_vm.uppicmo()}}},[_c('v-icon',{staticStyle:{"font-size":"40px"}},[_vm._v("mdi-image-plus")])],1)],1):_vm._e()],2)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[(_vm.name !== '' && _vm.email !== '' && _vm.title.category_TH && _vm.detail !== '')?_c('v-btn',{attrs:{"dark":"","color":"blue"},on:{"click":function($event){_vm.sendfeedbackmo()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.sendme')))])]):_c('v-btn',{attrs:{"disabled":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.sendme')))])]),_vm._v(" "),_c('v-btn',{staticStyle:{"color":"white !important"},attrs:{"dark":"","color":"blue-grey"},on:{"click":function($event){_vm.cancel()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])])],1)],1)],1)],1)])}
var settings_Feedback_staticRenderFns = []
var settings_Feedback_esExports = { render: settings_Feedback_render, staticRenderFns: settings_Feedback_staticRenderFns }
/* harmony default export */ var components_mobile_settings_Feedback = (settings_Feedback_esExports);
// CONCATENATED MODULE: ./src/components/mobile/settings/Feedback.vue
function settings_Feedback_injectStyle (ssrContext) {
  __webpack_require__("N3ma")
}
var settings_Feedback_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var settings_Feedback___vue_template_functional__ = false
/* styles */
var settings_Feedback___vue_styles__ = settings_Feedback_injectStyle
/* scopeId */
var settings_Feedback___vue_scopeId__ = "data-v-f06c2a78"
/* moduleIdentifier (server only) */
var settings_Feedback___vue_module_identifier__ = null
var settings_Feedback_Component = settings_Feedback_normalizeComponent(
  mobile_settings_Feedback["a" /* default */],
  components_mobile_settings_Feedback,
  settings_Feedback___vue_template_functional__,
  settings_Feedback___vue_styles__,
  settings_Feedback___vue_scopeId__,
  settings_Feedback___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_settings_Feedback = (settings_Feedback_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/settings/Contact.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var mobile_settings_Contact = ({
  data: function data() {
    return {};
  },
  methods: {
    toPage: function toPage(data) {
      this.$router.push(data);
    }
  },
  components: {
    vue100vh: vue100vh["a" /* default */]
  },
  created: function created() {
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ca9413b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/settings/Contact.vue
var mobile_settings_Contact_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('div',{staticStyle:{"height":"calc(100vh - 64px)","overflow-x":"hidden","overflow-y":"scroll"}},[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/homepage')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('Settings.helpCenter.header')))])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"40px"}},[_c('img',{attrs:{"src":"/static/img/onechat/map.png","width":"400"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"padding":"3vw"}},[_c('b',{staticClass:"CSChatThai",staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(_vm.$t('Settings.helpCenter.company'))),_c('br'),_vm._v(" "+_vm._s(_vm.$t('Settings.helpCenter.address')))])]),_vm._v(" "),_c('div',{staticClass:"CSChatThai",staticStyle:{"padding-left":"3vw","font-size":"16px"}},[_c('b',[_vm._v(_vm._s(_vm.$t('Settings.helpCenter.email'))+": "),_c('a',{attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])])],1)])}
var mobile_settings_Contact_staticRenderFns = []
var mobile_settings_Contact_esExports = { render: mobile_settings_Contact_render, staticRenderFns: mobile_settings_Contact_staticRenderFns }
/* harmony default export */ var components_mobile_settings_Contact = (mobile_settings_Contact_esExports);
// CONCATENATED MODULE: ./src/components/mobile/settings/Contact.vue
function mobile_settings_Contact_injectStyle (ssrContext) {
  __webpack_require__("Nnh+")
}
var mobile_settings_Contact_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var mobile_settings_Contact___vue_template_functional__ = false
/* styles */
var mobile_settings_Contact___vue_styles__ = mobile_settings_Contact_injectStyle
/* scopeId */
var mobile_settings_Contact___vue_scopeId__ = "data-v-3ca9413b"
/* moduleIdentifier (server only) */
var mobile_settings_Contact___vue_module_identifier__ = null
var mobile_settings_Contact_Component = mobile_settings_Contact_normalizeComponent(
  mobile_settings_Contact,
  components_mobile_settings_Contact,
  mobile_settings_Contact___vue_template_functional__,
  mobile_settings_Contact___vue_styles__,
  mobile_settings_Contact___vue_scopeId__,
  mobile_settings_Contact___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_settings_Contact = (mobile_settings_Contact_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/settings/Policy.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var mobile_settings_Policy = ({
  data: function data() {
    return {
      // policydialog: true
    };
  },

  methods: {
    toPage: function toPage(data) {
      this.$router.push(data);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fff0eda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/settings/Policy.vue
var mobile_settings_Policy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-y":"hidden"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/homepage')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('Settings.policy.header')))])],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"80vh","overflow-y":"scroll","margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('h2',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","text-decoration":"underline","margin-top":"50px"}},[_vm._v(_vm._s(_vm.$t('Settings.policy.header'))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject1.introDetail'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro1'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro2'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro3'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro4'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro5'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro6'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro7'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro8'))+"\n      ")]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject2.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject2.subHeaderScopeA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeA1'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeA2'))),_c('br'),_vm._v(" "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject2.subHeaderScopeB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeB1'))+"\n      ")]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject3.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subHeaderTypeA')))]),_vm._v("\n         "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubHeaderA'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectA1')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA1'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectA2')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA2'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA21'))),_c('br'),_vm._v(" "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subHeaderTypeB')))]),_vm._v("\n         "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubHeaderB'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB1')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB1'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB2'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB2')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB2'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB3')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB3'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB4')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB41'))+"\n        "),_c('br'),_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB42'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB5')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB51'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB52'))+"\n\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB6')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB6'))+"\n          "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB7')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB71'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB72'))+"\n\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB8')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB8'))+"\n\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB9')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB91'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB92'))+"\n         \n        "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject4.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"font-size":"13px","padding":"1vw"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA'))+"\n\n\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA1'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA2'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA3'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA4'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA5'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA6'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA7'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA8'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA9'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA10'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA11'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA12'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA13'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA14'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA15'))+"\n\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA16'))+"\n\n         "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectB1'))+"\n\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectB2'))+"\n\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectC')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectC'))+"\n         "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectD')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD1'))+"\n        "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD2'))+"\n        "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD3'))+"\n        "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD4'))+"\n        "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD5'))+"\n        "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD6'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectE')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectE'))+"\n         "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectF')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectF'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectG')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG1'))+"\n        "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG2'))+"\n        "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG3'))+"\n        "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG4'))+"\n        "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG5'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG6'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG7'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG8'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG9'))+"\n        "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject5.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.detailHeader'))+"\n          "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA1'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA2'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA3'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA4'))+" \n         "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB1'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB2'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB3'))+"\n        "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB4'))+"\n        "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject6.header')))]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject6.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectA'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject6.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectB1'))+"\n        "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectB2'))+"\n\n        "),_c('br')]),_vm._v(" "),_c('br')])],1)],1)}
var mobile_settings_Policy_staticRenderFns = []
var mobile_settings_Policy_esExports = { render: mobile_settings_Policy_render, staticRenderFns: mobile_settings_Policy_staticRenderFns }
/* harmony default export */ var components_mobile_settings_Policy = (mobile_settings_Policy_esExports);
// CONCATENATED MODULE: ./src/components/mobile/settings/Policy.vue
function mobile_settings_Policy_injectStyle (ssrContext) {
  __webpack_require__("rfCq")
}
var mobile_settings_Policy_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var mobile_settings_Policy___vue_template_functional__ = false
/* styles */
var mobile_settings_Policy___vue_styles__ = mobile_settings_Policy_injectStyle
/* scopeId */
var mobile_settings_Policy___vue_scopeId__ = "data-v-8fff0eda"
/* moduleIdentifier (server only) */
var mobile_settings_Policy___vue_module_identifier__ = null
var mobile_settings_Policy_Component = mobile_settings_Policy_normalizeComponent(
  mobile_settings_Policy,
  components_mobile_settings_Policy,
  mobile_settings_Policy___vue_template_functional__,
  mobile_settings_Policy___vue_styles__,
  mobile_settings_Policy___vue_scopeId__,
  mobile_settings_Policy___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_settings_Policy = (mobile_settings_Policy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/settings/TermsofService.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TermsofService = ({
  data: function data() {
    return {
      languages: ''
    };
  },

  watch: {
    '$i18n.locale': function $i18nLocale() {
      this.languages = this.$i18n.locale;
    }
  },
  created: function created() {
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
    this.languages = this.$i18n.locale;
    // console.log(this.languages)
  },

  methods: {
    toPage: function toPage(data) {
      this.$router.push(data);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e851dba6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/settings/TermsofService.vue
var TermsofService_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-y":"hidden"}},[(_vm.languages === 'th')?_c('v-card',[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/homepage')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("เงื่อนไขและข้อตกลงการให้บริการ")])],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"calc(100vh - 100px)","overflow-y":"scroll","margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('h2',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","text-decoration":"underline"}},[_vm._v("เงื่อนไขและข้อตกลงการให้บริการ\n      ")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"50px"}},[_c('strong',[_vm._v("1.การใช้บริการของเรา")]),_vm._v(" "),_c('br'),_vm._v("   1.1 การใช้บริการของเราไม่ได้ทำให้คุณเป็นเจ้าของสิทธิในทรัพย์สินทางปัญญาใดๆ ในบริการหรือเนื้อหาที่คุณเข้าถึง\n        "),_c('br'),_vm._v("   1.2 การใช้บริการจากเรา เราอาจส่งประกาศเกี่ยวกับบริการ ข่าวสารเกี่ยวกับการบริหารจัดการ และข้อมูลอื่นๆ ให้แก่คุณ คุณสามารถเลือกไม่รับการสื่อสารเหล่านี้บางรายการได้\n        "),_c('br'),_vm._v("   1.3 บริการบางอย่างของเราสามารถใช้บนอุปกรณ์เคลื่อนทึ่ห้ามใช้บริการดังกล่าวในลักษณะที่ทำให้คุณเสียสมาธิและทำให้ไม่สามารถปฏิบัติตามกฎจราจรหรือกฎหมายด้านความปลอดภัย\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("2. บัญชี One Platform ของคุณ ")]),_vm._v(" "),_c('br'),_vm._v("   2.1 คุณอาจต้องมีบัญชี One Platform เพื่อที่จะใช้บริการบางส่วนของเราอาจมีข้อกำหนดอื่นหรือเพิ่มเติมบังคับใช้กับคุณ และผู้ดูแลระบบของคุณอาจสามารถเข้าถึงหรือปิดการใช้งานบัญชีของคุณได้\n        "),_c('br'),_vm._v("   2.2 เพื่อปกป้องบัญชี One Platform ของคุณ โปรดเก็บรักษารหัสผ่านเป็นความลับ คุณมีความรับผิดชอบต่อกิจกรรมที่เกิดขึ้นบนหรือผ่านบัญชี One Platform ของคุณ พยายามไม่ใช้รหัสผ่านบัญชี One Platform ซ้ำบนแอปพลิเคชันของบุคคลที่สาม\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("3. การคุ้มครองข้อมูลส่วนบุคคลและลิขสิทธิ์")]),_vm._v(" "),_c('br'),_vm._v("   3.1 เมื่อคุณใช้บริการของเรา ถือว่าคุณยินยอมให้ One Platform ใช้ข้อมูลดังกล่าวตามนโยบายส่วนบุคคลนั้น\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("4. การปรับเปลี่ยนและการยุติการให้บริการของเรา ")]),_vm._v(" "),_c('br'),_vm._v("   4.1 เราทำการเปลี่ยนแปลงและปรับปรุงบริการของเราอย่างสม่ำเสมอ เราอาจเพิ่มหรือนำ "),_c('br'),_vm._v("ระบบการทำงานหรือคุณลักษณะบางอย่างออก และเราอาจระงับหรือหยุดให้บริการใดบริการหนึ่งโดยสิ้นเชิง\n        "),_c('br'),_vm._v("   4.2 คุณสามารถหยุดใช้บริการของเราได้ทุกเมื่อ\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("5. การใช้บริการของเราในทางธุรกิจ ")]),_vm._v(" "),_c('br'),_vm._v("   5.1 หากคุณใช้บริการของเราในนามของธุรกิจ ธุรกิจนั้นจะต้องยอมรับข้อกำหนดเหล่านี้\n        "),_c('br'),_vm._v("   5.2 ธุรกิจจะไม่เรียกร้องให้ One Platform และบริษัทในเครือ เจ้าหน้าที่ ตัวแทน และพนักงานของ One Platform ชดใช้ค่าเสียหายให้แก่คุณ\n        และคุณจะไม่ฟ้องร้องคดีหรือดำเนินการใดๆอันเกิดจากหรือเกี่ยวกับการใช้บริการหรือการละเมิดข้อกำหนดเหล่านี้รวมถึงไม่ให้บุคคลดังกล่าวมีความรับผิดหรือต้องชำระค่าใช้จ่ายใดๆ ที่เกิดจากการเรียกร้องค่าสินไหมทดแทน การสูญเสีย ความเสียหาย การฟ้องร้องคดี\n        การตัดสินคดี ค่าใช้จ่ายในการดำเนินคดี และค่าทนายความ "),_c('br')])])],1):_c('v-card',[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/homepage')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Terms and Conditions of Service")])],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"calc(100vh - 100px)","overflow-y":"scroll","margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('h2',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","text-decoration":"underline"}},[_vm._v("Terms and Conditions of Service\n      ")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"50px"}},[_c('strong',[_vm._v("1. Using of our services")]),_vm._v(" "),_c('br'),_vm._v("   1.1 Your using of our services does not give you ownership of any intellectual property rights in the services or content you access.\n        "),_c('br'),_vm._v("   1.2 By providing services from us, we may send service announcements; provide you with administrative news and other information to you.  You can opt-out of some of these communications.\n        "),_c('br'),_vm._v("   1.3 Some of our services can be used on mobile devices so do not use them in a way that distracts  and prevents you from complying with traffic or safety laws.\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("2. Your One Platform account")]),_vm._v(" "),_c('br'),_vm._v("   2.1 You may need a One Platform account in order to use some of our services, other or additional terms may apply to you and your administrator may be able to access or disable your account.\n        "),_c('br'),_vm._v("   2.2 To protect your One Platform account, please keep your password confidential. You are responsible for any activities that occur on through your One Platform account. Try not to reuse your One Platform account password on any third-party applications.\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("3. Protection of personal data and copyright")]),_vm._v(" "),_c('br'),_vm._v("   3.1 By using our services, you consent to the use of such information by One Platform in accordance with that Privacy Policy.\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("4. Modifications and Terminations of our Services")]),_vm._v(" "),_c('br'),_vm._v("   4.1 We make changes and improvements to our services regularly, we may add or remove certain functionality or features and we may suspend or discontinue any service altogether.\n        "),_c('br'),_vm._v("   4.2 You can stop using our services at any time.\n        "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("5. Business use of our services")]),_vm._v(" "),_c('br'),_vm._v("   5.1 If you use our services on behalf of a business, that business must agree to these terms.\n        "),_c('br'),_vm._v("   5.2 The business will not demand that One Platform and its affiliates, officers, agents and employees indemnify to you and you will not litigate or take action arising out of or in connection with your use of the service or breach of these terms including that such person shall not be liable or have to pay any expenses arising from claims, losses, damages, litigation, judgments, litigation costs and attorney fees.\n        "),_c('br')])])],1)],1)}
var TermsofService_staticRenderFns = []
var TermsofService_esExports = { render: TermsofService_render, staticRenderFns: TermsofService_staticRenderFns }
/* harmony default export */ var settings_TermsofService = (TermsofService_esExports);
// CONCATENATED MODULE: ./src/components/mobile/settings/TermsofService.vue
function TermsofService_injectStyle (ssrContext) {
  __webpack_require__("rn0h")
}
var TermsofService_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TermsofService___vue_template_functional__ = false
/* styles */
var TermsofService___vue_styles__ = TermsofService_injectStyle
/* scopeId */
var TermsofService___vue_scopeId__ = "data-v-e851dba6"
/* moduleIdentifier (server only) */
var TermsofService___vue_module_identifier__ = null
var TermsofService_Component = TermsofService_normalizeComponent(
  TermsofService,
  settings_TermsofService,
  TermsofService___vue_template_functional__,
  TermsofService___vue_styles__,
  TermsofService___vue_scopeId__,
  TermsofService___vue_module_identifier__
)

/* harmony default export */ var mobile_settings_TermsofService = (TermsofService_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/settings/Sendfileonebox.vue
var Sendfileonebox = __webpack_require__("7CGg");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55c542c1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/settings/Sendfileonebox.vue
var Sendfileonebox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('v-app',{staticStyle:{"overflow":"hidden"}},[_c('v-toolbar',{staticStyle:{"background-color":"white !important","overflow":"hidden !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/homepage')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('HeaderMenubar.sendOnebox')))])],1),_vm._v(" "),_c('v-layout',{staticStyle:{"overflow":"hidden !important"},attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"3vh","height":"25vh"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[_c('div',{ref:"fileform",staticStyle:{"width":"300px","border-radius":"5px","border-style":"dotted","border-color":"#f5f5f5","background-color":"#009aff3d","text-align":"center"}},[_c('img',{staticStyle:{"margin-top":"2vh"},attrs:{"src":"/static/img/onechat/box.png","width":"45"}}),_c('br'),_vm._v(" "),_c('label',{staticStyle:{"text-align":"center","cursor":"pointer"}},[_c('v-btn',{staticStyle:{"margin-bottom":"2vh","font-weight":"bold"},attrs:{"color":"primary","small":""},on:{"click":_vm.openFileimage}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.selectFile'))+"\n              ")]),_vm._v(" "),_c('input',{ref:"files",attrs:{"type":"file","id":"files","multiple":""},on:{"change":function($event){_vm.handleFilesUpload()}}})],1)])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{staticClass:"text-xs-center text-sm-center",staticStyle:{"padding-top":"6vh"},attrs:{"xs12":"","sm12":"","md12":""}},[(_vm.files.length > 0 )?_c('v-btn',{attrs:{"small":"","round":"","outline":"","color":"primary","dark":""},on:{"click":function($event){_vm.submitallFiles()}}},[_c('i',{staticClass:"fas fa-upload",staticStyle:{"margin-bottom":"3px"}}),_vm._v("  "+_vm._s(_vm.$t('AnswerQuestion.uploadAll')))]):_vm._e()],1),_vm._v(" "),(_vm.files.length > 0 )?_c('v-flex',{staticClass:"containers",staticStyle:{"overflow-x":"scroll","overflow-y":"hidden","height":"45vh !important","max-width":"70vw !important","display":"-webkit-inline-box","padding-top":"5vh"},attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((_vm.files),function(file,key){return _c('div',{staticClass:"borderfile",staticStyle:{"justify-content":"center","margin-left":"2vw","padding-top":"1vh"}},[_c('a',{staticClass:"close-classic",on:{"click":function($event){_vm.removeFile( key )}}}),_vm._v(" "),(_vm.extension(file.file.name) == 'fas fa-file-image')?_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center","padding-top":"1vh"}},[_c('img',{ref:'preview'+parseInt( key ),refInFor:true,staticClass:"preview",staticStyle:{"object-fit":"cover","height":"10vh !important","width":"15vh !important","display":"flex","justify-content":"center"}}),_vm._v(" "),_c('b',{staticClass:"text2"},[_vm._v(_vm._s(file.file.name))]),_vm._v(" "),(file.status == 'fail')?_c('v-icon',{staticStyle:{"color":"red"}},[_vm._v("fas fa-exclamation-triangle")]):(file.status == 'success')?_c('v-icon',{staticStyle:{"color":"green"}},[_vm._v("fas fa-check")]):_vm._e(),_vm._v(" "),(file.status !== 'success' && file.status !== 'process')?_c('a',{staticStyle:{"text-align":"center"},on:{"click":function($event){_vm.submitFiles( key )}}},[_vm._v("  "+_vm._s(_vm.$t('AnswerQuestion.upload')))]):_vm._e(),_vm._v(" "),(file.status == 'process')?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e()],1):_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center"}},[_c('v-icon',{staticStyle:{"font-size":"35px !important","color":"#1a222c","display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.extension(file.file.name)))]),_vm._v(" "),_c('b',{staticClass:"text2"},[_vm._v(_vm._s(file.file.name))]),_vm._v(" "),(file.status == 'fail')?_c('v-icon',{staticStyle:{"color":"red"}},[_vm._v("fas fa-exclamation-triangle")]):(file.status == 'success')?_c('v-icon',{staticStyle:{"color":"green"}},[_vm._v("fas fa-check")]):_vm._e(),_vm._v(" "),(file.status !== 'success' && file.status !== 'process')?_c('a',{staticStyle:{"text-align":"center"},on:{"click":function($event){_vm.submitFiles( key )}}},[_vm._v(" "+_vm._s(_vm.$t('AnswerQuestion.upload')))]):_vm._e(),_vm._v(" "),(file.status == 'process')?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e()],1)])})):_vm._e()],1)],1)],1)],1)}
var Sendfileonebox_staticRenderFns = []
var Sendfileonebox_esExports = { render: Sendfileonebox_render, staticRenderFns: Sendfileonebox_staticRenderFns }
/* harmony default export */ var settings_Sendfileonebox = (Sendfileonebox_esExports);
// CONCATENATED MODULE: ./src/components/mobile/settings/Sendfileonebox.vue
function Sendfileonebox_injectStyle (ssrContext) {
  __webpack_require__("qo2O")
}
var Sendfileonebox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Sendfileonebox___vue_template_functional__ = false
/* styles */
var Sendfileonebox___vue_styles__ = Sendfileonebox_injectStyle
/* scopeId */
var Sendfileonebox___vue_scopeId__ = "data-v-55c542c1"
/* moduleIdentifier (server only) */
var Sendfileonebox___vue_module_identifier__ = null
var Sendfileonebox_Component = Sendfileonebox_normalizeComponent(
  Sendfileonebox["a" /* default */],
  settings_Sendfileonebox,
  Sendfileonebox___vue_template_functional__,
  Sendfileonebox___vue_styles__,
  Sendfileonebox___vue_scopeId__,
  Sendfileonebox___vue_module_identifier__
)

/* harmony default export */ var mobile_settings_Sendfileonebox = (Sendfileonebox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/settings/Managefriend.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// var _ = require('lodash')

/* harmony default export */ var mobile_settings_Managefriend = ({
  data: function data() {
    return {
      listblock: [],
      token: '',
      progress: false
    };
  },
  components: {
    vue100vh: vue100vh["a" /* default */]
  },
  methods: {
    toPage: function toPage(data) {
      this.$router.push(data);
    },
    getlistblock: function getlistblock() {
      var _this = this;

      // console.log('getlistblock')
      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-block', { tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          _this.progress = false;
          _this.listblock = response.data['list_block_friend'];
          // console.log(this.listblock)
        }
      }).catch(function (error) {
        console.log(error);
        _this.progress = false;
      });
    },
    unblock: function unblock(item, index) {
      var _this2 = this;

      // console.log(item)
      this.$swal({
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Unblocking', { name: item.name }),
        type: 'warning',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this2.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', { tokenfriend: item.tokenuser, tokenuser: _this2.token, tokenroom: item.tokenroom }).then(function (response) {
            if (response.data['status'] === 'success') {
              // this.getlistblock()
              _this2.listblock.splice(index, 1);
              item.event = 'unblock_friend';
              // this.unblock_friend = item
              _this2.block_friend = item;
              _this2.$swal('', _this2.$t('Alert.Success.unblock'), 'success');
            }
          });
        }
      });
    },
    remove_friend: function remove_friend(item, index) {
      var _this3 = this;

      // console.log('remove_friend')
      this.$swal({
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.RemoveFriend', { name: item.name }),
        type: 'warning',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this3.axios.post("https://uatchat-manage.one.th/manage" + '/removefriend', { tokenfriend: item.tokenuser, tokenuser: _this3.token, tokenroom: item.tokenroom }).then(function (response) {
            if (response.data['status'] === 'success') {
              _this3.$swal('', _this3.$t('Alert.Success.removefriend'), 'success');
              _this3.listblock.splice(index, 1);
              // this.getlistblock()
              // this.$router.push('/chat/homepage')
            }
          });
        }
      });
    },
    detailFriend: function detailFriend(user) {
      var _this4 = this;

      var title = 'ข้อมูลส่วนตัว';
      var picture = user.profilepicture;
      if (user.profilepicture === '') {
        if (user.type === 'business') {
          picture = '/static/img/default_profile/business-white.png';
        } else if (user.type === 'bot') {
          picture = '/static/img/default_profile/bot-white.png';
        } else {
          picture = '/static/img/default_profile/man-white.png';
        }
      } else {
        picture = user.profilepicture;
      }
      var name = user.name;
      this.$swal({
        title: '<div class="CSChatThai">' + title + '</div>',
        html: '<br><img src="' + picture + '" style=" width: 140px; height: 140px; background: #a84909; border-radius: 50%; object-fit: cover; object-position: 50% 0;"><br><br><br>' + '<div class="CSChatThai" style="text-align:left">ชื่อ: ' + name + '<br><br><br><button id="unblock" style="background-color: #536475;border: #bebec1 1px solid;border-radius: 50px; padding: 9px;color: white;right: 10px; float:right;   margin-left: 10px;"> ยกเลิกการบล็อค </button>' + '<button id="unfriend" style="background-color: #fb3e3e;border-radius: 50px; padding: 9px;color: white; right:0; float:right;"> ลบเพื่อน </button>' + '</div>',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true,
        showCancelButton: false,
        showConfirmButton: false,
        onBeforeOpen: function onBeforeOpen() {
          var content = _this4.$swal.getContent();
          var $ = content.querySelector.bind(content);
          var unblock = $('#unblock');
          unblock.addEventListener('click', function () {
            // console.log('increase')
            _this4.getlistblock();
          });
        }
      });
    }
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  // watch: {
  // },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.getlistblock();
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29ebb032","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/settings/Managefriend.vue
var settings_Managefriend_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('div',{staticClass:"CSChatThai BGwhite"},[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/homepage')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('HeaderMenubar.managefriend')))])],1),_vm._v(" "),(_vm.progress)?_c('v-card-text',{staticStyle:{"align-items":"center","display":"flex","margin-top":"70px","justify-content":"center"}},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1):_c('v-card-text',{staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important","overflow-y":"scroll","height":"calc(100vh - 64px)","color":"rgb(74, 74, 74) !important"}},[(_vm.listblock.length !== 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-list',{attrs:{"two-line":""}},_vm._l((_vm.listblock),function(item,index){return _c('v-list-tile',{key:item.tokenuser,attrs:{"avatar":""}},[_c('v-list-tile-avatar',[(item.profilepicture !== '')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#efefef"},attrs:{"src":"/static/img/default_profile/bot-white.png"}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#efefef"},attrs:{"src":"/static/img/default_profile/business-white.png"}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"border-style":"solid","border-width":"thin","border-color":"#efefef"},attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"text2",domProps:{"innerHTML":_vm._s(item.name)}})],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-menu',{attrs:{"offset-x":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","dark":"","small":"","color":"grey darken-1"},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.remove_friend(item, index)}}},[_c('v-list-tile-title',[_c('v-icon',{staticStyle:{"font-size":"20px"},attrs:{"dark":"","color":"grey darken-1"}},[_vm._v("fas fa-user-minus")]),_vm._v("\n                        "+_vm._s(_vm.$t('AnswerQuestion.removeFriend'))+"\n                    ")],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.unblock(item, index)}}},[_c('v-list-tile-title',[_c('v-icon',{staticStyle:{"font-size":"20px"},attrs:{"dark":"","color":"grey darken-1"}},[_vm._v("lock_open")]),_vm._v("\n                        "+_vm._s(_vm.$t('AnswerQuestion.unblock'))+"\n                    ")],1)],1)],1)],1)],1)],1)}))],1):_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":""}},[_c('h4',{staticStyle:{"display":"flex","justify-content":"center"}},[_vm._v(_vm._s(_vm.$t('Settings.manageFriend.nodata')))])])],1)],1)])}
var settings_Managefriend_staticRenderFns = []
var settings_Managefriend_esExports = { render: settings_Managefriend_render, staticRenderFns: settings_Managefriend_staticRenderFns }
/* harmony default export */ var components_mobile_settings_Managefriend = (settings_Managefriend_esExports);
// CONCATENATED MODULE: ./src/components/mobile/settings/Managefriend.vue
function settings_Managefriend_injectStyle (ssrContext) {
  __webpack_require__("uEgb")
}
var settings_Managefriend_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var settings_Managefriend___vue_template_functional__ = false
/* styles */
var settings_Managefriend___vue_styles__ = settings_Managefriend_injectStyle
/* scopeId */
var settings_Managefriend___vue_scopeId__ = "data-v-29ebb032"
/* moduleIdentifier (server only) */
var settings_Managefriend___vue_module_identifier__ = null
var settings_Managefriend_Component = settings_Managefriend_normalizeComponent(
  mobile_settings_Managefriend,
  components_mobile_settings_Managefriend,
  settings_Managefriend___vue_template_functional__,
  settings_Managefriend___vue_styles__,
  settings_Managefriend___vue_scopeId__,
  settings_Managefriend___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_settings_Managefriend = (settings_Managefriend_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/@bachdgvn/vue-otp-input/dist/vueOtpInput.common.js
var vueOtpInput_common = __webpack_require__("gD2W");
var vueOtpInput_common_default = /*#__PURE__*/__webpack_require__.n(vueOtpInput_common);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/@chenfengyuan/vue-countdown/dist/vue-countdown.js
var vue_countdown = __webpack_require__("aCbg");
var vue_countdown_default = /*#__PURE__*/__webpack_require__.n(vue_countdown);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/settings/EditPhoneMo.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






vue_esm["default"].component(vue_countdown_default.a.name, vue_countdown_default.a);
/* harmony default export */ var EditPhoneMo = ({
  components: {
    OtpInput: vueOtpInput_common_default.a
  },
  data: function data() {
    var _ref;

    return _ref = {
      e1: 1,
      radios: ''
    }, defineProperty_default()(_ref, 'e1', 1), defineProperty_default()(_ref, 'radios2', ''), defineProperty_default()(_ref, 'complete', ''), defineProperty_default()(_ref, 'otp_off', false), defineProperty_default()(_ref, 'phoneRecent', ''), defineProperty_default()(_ref, 'phoneEdit', ''), defineProperty_default()(_ref, 'refcode_terminate', ''), defineProperty_default()(_ref, 'countingmo', false), defineProperty_default()(_ref, 'counting2mo', false), defineProperty_default()(_ref, 'phonenewtologin', ''), defineProperty_default()(_ref, 'progress', false), defineProperty_default()(_ref, 'progressTerminate', false), defineProperty_default()(_ref, 'loadingOtpNewno', false), defineProperty_default()(_ref, 'loadingotpTerminate', false), _ref;
  },
  computed: {
    // time () {
    //   return this.date.format('mm:ss')
    // }
  },
  created: function created() {
    var _this = this;

    this.phoneRecent = localStorage.phonRecent, this.phoneEdit = localStorage.phoneEdit;
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.progress = true;
    var type_account = localStorage.typeAccount;
    if (type_account === 'true') {
      this.axios.post("https://uatchat-manage.one.th/manage" + '/otp_change_phone', {
        new_phone: localStorage.phoneEdit,
        tokenuser: this.token
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this.progress = false;
          _this.refcode_terminate = response.data.refcode;
        } else if (response.data.message === 'refresh_token expire') {
          _this.progress = false;
          _this.$swal({
            title: _this.$t('Settings.messageEditPhone.MsgTokenExpire'),
            type: 'warning'
          });
        } else if (response.data.message === 'too many requests.') {
          _this.refcode_terminate = '';
          _this.$swal({
            title: _this.$t('Settings.messageEditPhone.MsgTooManyRequest'),
            type: 'warning'
          });
        }
        // this.refcode_terminate = response.data.refcode
      });
      this.e1 = 4;
      this.countingmo = true;
      // this.countdown()
    } else {
      this.e1 = 1;
    }
  },
  mounted: function mounted() {
    this.phonenewtologin = localStorage.phoneEdit;
    this.phoneRecent = localStorage.phonRecent, this.phoneEdit = localStorage.phoneEdit;
    // console.log(this.phonenewtologin)
    // this.phoneRecent = localStorage.phonRecent,
    // this.phoneEdit = localStorage.phoneEdit
  },

  watch: {
    // time() {
    //   if(this.date.format('mm:ss') === '00:00'){
    //     clearInterval(this.interv)
    //     this.otp_off = true
    //   }
    // },
    e1: function e1() {
      if (this.e1 === 4) {
        this.countingmo = true;
      } else if (this.e1 === 3) {
        this.counting2mo = true;
      }
    }
  },
  methods: {
    sendOTP: function sendOTP() {
      var _this2 = this;

      this.loadingOtpNewno = true;
      var type_account = localStorage.typeAccount;
      if (type_account === 'true') {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/confirm_otp_change_phone', {
          new_phone: localStorage.phoneEdit,
          otp: this.otpInput,
          tokenuser: this.token
        }).then(function (response) {
          if (response.data.message === 'login success') {
            // this.loadingOtpNewno = false
            _this2.$swal({
              title: _this2.$t('Settings.messageEditPhone.MsgChangePhoneSuccess'),
              type: 'success'
            }).then(function (result) {
              if (result) {
                _this2.$router.push('/mobile/settings/profile');
                clearInterval(_this2.interv);
                _this2.date = moment_default()(60 * 5 * 1000);
                _this2.$refs.otpInput.clearInput();
                _this2.radios = '';
                _this2.radios2 = '';
                localStorage.removeItem("typeAccount");
                localStorage.phone = localStorage.phoneEdit;
                _this2.loadingOtpNewno = false;
              }
            });
          } else if (response.data.message === 'OTP Invalid') {
            _this2.loadingOtpNewno = false;
            _this2.$swal({
              title: _this2.$t('Settings.messageEditPhone.OTPInvalid'),
              type: 'error'
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        if (this.radios2 !== '') {
          // console.log('ปิด account')
          this.$swal({
            title: this.$t('Settings.messageEditPhone.MsgLoginPhoneAgain'),
            type: 'warning'
          }).then(function (result) {
            if (result) {
              _this2.$router.push('/mobile/settings/profile');
              clearInterval(_this2.interv);
              _this2.date = moment_default()(60 * 5 * 1000);
              _this2.$refs.otpInput.clearInput();
              _this2.radios = '';
              _this2.radios2 = '';
              localStorage.removeItem("typeAccount");
              _this2.logout();
            }
          });
        }
      }
    },
    sendOTPterminate: function sendOTPterminate() {
      var _this3 = this;

      // console.log('otp terminate')
      // console.log(this.otpinput_terminate)
      this.loadingotpTerminate = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/terminate_phone', {
        phone: localStorage.phonRecent,
        otp: this.otpinput_terminate
      }).then(function (response) {
        // console.log(response)
        if (response.data.message === 'terminate success') {
          _this3.$swal({
            title: _this3.$t('Settings.messageEditPhone.MsgLoginPhoneAgain'),
            type: 'warning'
          }).then(function (result) {
            if (result) {
              _this3.$refs.otpInputTerminate.clearInput();
              _this3.loadingotpTerminate = false;
              _this3.radios = '';
              _this3.radios2 = '';
              localStorage.removeItem("typeAccount");
              _this3.logout();
              localStorage.tologin = _this3.phonenewtologin;
            }
          });
        } else {
          _this3.loadingotpTerminate = false;
          _this3.$swal({
            title: _this3.$t('Settings.messageEditPhone.OTPInvalid'),
            type: 'error'
          });
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    handleOnChange: function handleOnChange(value) {
      this.otpInput = value;
      if (value.length < 6) {
        this.complete = false;
      }
      // console.log('OTP changed: ', value);
    },
    handleOnComplete: function handleOnComplete(value) {
      this.complete = true;
    },
    handleOnChangeTerminate: function handleOnChangeTerminate(value) {
      // console.log('OTP changed: ', value);
      this.otpinput_terminate = value;
      if (value.length < 6) {
        this.complete = false;
      }
    },
    handleOnCompleteTerminate: function handleOnCompleteTerminate(value) {
      // console.log('OTP completed: ', value);
      this.complete = true;
    },
    Terminate: function Terminate() {
      var _this4 = this;

      this.progressTerminate = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/otp_login_and_regis', {
        phone: this.phoneRecent
      }).then(function (response) {
        // console.log(response)
        if (response.data.message === 'too many requests.') {
          _this4.progressTerminate = false;
          _this4.refcode_terminate = '';
          _this4.$swal({
            title: _this4.$t('Settings.messageEditPhone.MsgTooManyRequest'),
            type: 'warning'
          });
        } else if (response.data.status === 'success') {
          _this4.progressTerminate = false;
          _this4.refcode_terminate = response.data.refcode;
        }
        _this4.e1 = 3;
      }).catch(function (err) {
        console.log(err);
      });
    },
    checkValue: function checkValue() {
      var _this5 = this;

      if (this.radios === 'closeRecent') {
        this.e1 = 2;
      } else {
        this.$swal({
          title: this.$t('Settings.messageEditPhone.MsgSwitchAccount'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '',
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-success',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then(function (result) {
          // console.log(result.value)
          if (result.value === true) {
            _this5.$swal({
              title: _this5.$t('Settings.messageEditPhone.MsgLoginPhoneAgain'),
              type: 'warning'
            }).then(function (result) {
              if (result) {
                _this5.$router.push('/mobile/settings/profile');
                clearInterval(_this5.interv);
                _this5.date = moment_default()(60 * 5 * 1000);
                _this5.$refs.otpInput.clearInput();
                _this5.radios = '';
                _this5.radios2 = '';
                localStorage.removeItem("typeAccount");
                _this5.logout();
                // localStorage.tologin_keep2 = true
                localStorage.tologin = _this5.phonenewtologin;
              }
            });
          }
        });
      }
    },
    cancle: function cancle() {
      var _this6 = this;

      this.$swal({
        title: this.$t('Alert.Right.cancleEditPhone'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        // console.log(result.value)
        if (result.value === true) {
          _this6.$router.push('/mobile/settings/profile');
          _this6.handleCountdownEnd2mo();
          _this6.handleCountdownEndmo();
          _this6.date = moment_default()(60 * 5 * 1000);
          _this6.$refs.otpInput.clearInput();
          _this6.radios = '';
          _this6.radios2 = '';
          localStorage.removeItem("typeAccount");
        }
      });
    },
    disablebtnST1: function disablebtnST1() {
      if (this.radios === '') {
        return true;
      } else {
        return false;
      }
    },
    disablebtnST2: function disablebtnST2() {
      if (this.radios2 === '') {
        return true;
      } else {
        return false;
      }
    },
    disableBtn: function disableBtn() {
      // return true
      if (this.complete === true) {
        return false;
      } else {
        return true;
      }
    },
    logout: function logout() {
      this.$cookie.delete('tokenuser');
      this.$cookie.delete('status_login');
      localStorage.clear();
      this.$router.push({ path: '/login', force: true });
      // this.$router.push({
      //   path: '/login',
      //   force: true
      // })
      // if (process.env.LogoutOneid) {
      //   window.open(process.env.LogoutOneid, '_parent')
      // } else {
      //   this.$router.push({path: '/login', force: true})
      // }
    },
    newOtpmo2: function newOtpmo2() {
      var _this7 = this;

      this.counting2mo = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/otp_login_and_regis', {
        phone: this.phoneRecent
      }).then(function (response) {
        // console.log(response)
        _this7.refcode_terminate = response.data.refcode;
        _this7.e1 = 3;
      }).catch(function (err) {
        console.log(err);
      });
    },
    newOtpmo: function newOtpmo() {
      var _this8 = this;

      this.countingmo = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/otp_change_phone', {
        new_phone: localStorage.phoneEdit,
        tokenuser: this.token
      }).then(function (response) {
        _this8.refcode_terminate = response.data.refcode;
      });
    },
    handleCountdownEndmo: function handleCountdownEndmo() {
      this.countingmo = false;
    },
    handleCountdownEnd2mo: function handleCountdownEnd2mo() {
      this.counting2mo = false;
    },
    handleCountdownProgressmo: function handleCountdownProgressmo(data) {
      // console.log(data.days);
      // console.log(data.hours);
      // console.log(data.minutes);
      // console.log(data.seconds);
      // console.log(data.milliseconds);
      // console.log(data.totalDays);
      // console.log(data.totalHours);
      // console.log(data.totalMinutes);
      // console.log(data.totalSeconds);
      // console.log(data.totalMilliseconds);
    },
    transform: function transform(props) {
      entries_default()(props).forEach(function (_ref2) {
        var _ref3 = slicedToArray_default()(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        // Adds leading zero
        var digits = value < 10 ? '0' + value : value;
        // uses singular form when the value is less than 2
        var word = value < 2 ? key.replace(/s$/, '') : key;
        props[key] = '' + digits;
      });
      return props;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-648a001e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/settings/EditPhoneMo.vue
var EditPhoneMo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stepper',{staticStyle:{"height":"100vh"},model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('span',{staticClass:"headerType"},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgPhoneRegistered')))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgDetectPhone'))+" "+_vm._s(_vm.phoneEdit)+" "+_vm._s(_vm.$t('Settings.messageEditPhone.MsgDetectPhonenext'))+"\n        ")]),_vm._v(" "),_c('v-radio-group',{staticClass:"pl-3",attrs:{"column":""},model:{value:(_vm.radios),callback:function ($$v) {_vm.radios=$$v},expression:"radios"}},[_c('v-radio',{attrs:{"value":"closeRecent"}},[_c('template',{slot:"label"},[_c('div',[_c('strong',{staticStyle:{"color":"black","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgCloseAccountSelect')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"black","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgCloseAccountSpan'))+" "+_vm._s(_vm.phoneRecent))])])])],2),_vm._v(" "),_c('v-radio',{attrs:{"value":"keepAccount"}},[_c('template',{slot:"label"},[_c('div',[_c('strong',{staticStyle:{"color":"black","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgKeepAccountSelect')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"black","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgKeepAccountSpan')))])])])],2)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","round":"","block":"","disabled":_vm.disablebtnST1()},on:{"click":function($event){_vm.checkValue()}}},[_vm._v("\n        "+_vm._s(_vm.$t('AnswerQuestion.continue'))+"\n      ")]),_vm._v(" "),_c('v-btn',{staticClass:"mt-2",attrs:{"block":"","round":"","color":"red","dark":""},on:{"click":function($event){_vm.cancle()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[(_vm.radios === 'closeRecent')?_c('v-card',{staticClass:"mb-5",attrs:{"flat":"","height":"200px"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"previcon",attrs:{"icon":"","flat":""},on:{"click":function($event){_vm.e1 = 1}}},[_c('v-icon',{staticStyle:{"font-size":"14px !important","cursor":"pointer"}},[_vm._v("fas fa-chevron-left")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","sm10":"","md10":""}},[_c('span',{staticClass:"headerType"},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgCloseOnechatAccount')))])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('p',{staticStyle:{"padding-left":"26px","font-size":"16px"}},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgCloseOnechatAccountSpan')))])]),_vm._v(" "),_c('v-radio-group',{staticClass:"pl-3",attrs:{"column":""},model:{value:(_vm.radios2),callback:function ($$v) {_vm.radios2=$$v},expression:"radios2"}},[_c('v-radio',{attrs:{"value":"closeAccount"}},[_c('template',{slot:"label"},[_c('div',[_c('span',{staticStyle:{"color":"black","font-size":"14px"}},[_vm._v("\n                "+_vm._s(_vm.$t('Settings.messageEditPhone.MsgCloseOnechatAccountSelect'))+"\n              ")])])])],2)],1)],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":"","round":"","disabled":_vm.disablebtnST2()},on:{"click":function($event){_vm.Terminate()}}},[_vm._v("\n        "+_vm._s(_vm.$t('AnswerQuestion.continue'))+"\n      ")]),_vm._v(" "),_c('v-btn',{staticClass:"mt-2",staticStyle:{"color":"white"},attrs:{"block":"","dark":"","round":"","color":"red"},on:{"click":function($event){_vm.cancle()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('span',{staticClass:"headerContent"},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgConfirmCloseAccount')))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgSendOTP'))+" "+_vm._s(_vm.phoneRecent))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px"}},[_vm._v("\n        refcode :\n          "),(_vm.progressTerminate === true)?_c('v-progress-circular',{attrs:{"indeterminate":_vm.progressTerminate,"color":"grey","size":"20"}}):_c('span',[_vm._v(_vm._s(_vm.refcode_terminate))])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"16px","padding-bottom":"0px"}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('OtpInput',{ref:"otpInputTerminate",attrs:{"input-classes":"otp-input","separator":"-","num-inputs":6,"should-auto-focus":true,"is-input-num":true},on:{"on-change":_vm.handleOnChangeTerminate,"on-complete":_vm.handleOnCompleteTerminate}})],1),_vm._v(" "),_c('v-layout',{staticClass:"pt-3",attrs:{"row":""}},[(_vm.counting2mo === false)?_c('span',[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgOTPAgain')))]):_c('span',[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgOTPNotrecieve')))]),_vm._v(" "),(_vm.counting2mo === false)?_c('v-icon',{staticClass:"pl-2",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.newOtpmo2()}}},[_vm._v("mdi-refresh")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.counting2mo === true)?_c('countdown',{attrs:{"time":300000,"transform":_vm.transform},on:{"end":_vm.handleCountdownEnd2mo,"progress":_vm.handleCountdownProgressmo},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(" "+_vm._s(_vm.$t('Settings.messageEditPhone.MsgResendOTP'))+" "+_vm._s(props.minutes)+":"+_vm._s(props.seconds)+" ")]}}])}):_vm._e()],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"block":"","round":"","color":"primary","loading":_vm.loadingotpTerminate,"disabled":_vm.disableBtn()},on:{"click":function($event){_vm.sendOTPterminate()}}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.continue'))+"\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","block":"","round":"","color":"red"},on:{"click":function($event){_vm.cancle()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgVerifyPhone')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgSendOTP'))+" "+_vm._s(_vm.phoneEdit))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","margin-bottom":"0px"}},[_vm._v("\n          refcode :\n          "),(_vm.progress === true)?_c('v-progress-circular',{attrs:{"indeterminate":_vm.progress,"color":"grey","size":"20"}}):_c('span',[_vm._v(_vm._s(_vm.refcode_terminate))])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('OtpInput',{ref:"otpInput",staticClass:"pt-5 pb-2",attrs:{"input-classes":"otp-input","separator":"-","num-inputs":6,"should-auto-focus":true,"is-input-num":true},on:{"on-change":_vm.handleOnChange,"on-complete":_vm.handleOnComplete}})],1),_vm._v(" "),_c('v-layout',{staticClass:"pt-3 pb-3",attrs:{"row":""}},[(_vm.countingmo === true)?_c('span',[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgOTPNotrecieve')))]):_c('span',[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgOTPAgain')))]),_vm._v(" "),(_vm.countingmo === false)?_c('v-icon',{staticClass:"pl-2",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.newOtpmo()}}},[_vm._v("mdi-refresh")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.countingmo === true)?_c('countdown',{attrs:{"time":300000,"transform":_vm.transform},on:{"end":_vm.handleCountdownEndmo,"progress":_vm.handleCountdownProgressmo},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(" "+_vm._s(_vm.$t('Settings.messageEditPhone.MsgResendOTP'))+" "+_vm._s(props.minutes)+":"+_vm._s(props.seconds)+" ")]}}])}):_vm._e()],1),_vm._v(" "),_c('v-btn',{attrs:{"block":"","round":"","loading":_vm.loadingOtpNewno,"color":"primary","disabled":_vm.disableBtn()},on:{"click":function($event){_vm.sendOTP()}}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.continue'))+"\n        ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"color":"white"},attrs:{"block":"","color":"red","round":"","dark":""},on:{"click":function($event){_vm.cancle()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1)],1)],1)}
var EditPhoneMo_staticRenderFns = []
var EditPhoneMo_esExports = { render: EditPhoneMo_render, staticRenderFns: EditPhoneMo_staticRenderFns }
/* harmony default export */ var settings_EditPhoneMo = (EditPhoneMo_esExports);
// CONCATENATED MODULE: ./src/components/mobile/settings/EditPhoneMo.vue
function EditPhoneMo_injectStyle (ssrContext) {
  __webpack_require__("BChE")
}
var EditPhoneMo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditPhoneMo___vue_template_functional__ = false
/* styles */
var EditPhoneMo___vue_styles__ = EditPhoneMo_injectStyle
/* scopeId */
var EditPhoneMo___vue_scopeId__ = "data-v-648a001e"
/* moduleIdentifier (server only) */
var EditPhoneMo___vue_module_identifier__ = null
var EditPhoneMo_Component = EditPhoneMo_normalizeComponent(
  EditPhoneMo,
  settings_EditPhoneMo,
  EditPhoneMo___vue_template_functional__,
  EditPhoneMo___vue_styles__,
  EditPhoneMo___vue_scopeId__,
  EditPhoneMo___vue_module_identifier__
)

/* harmony default export */ var mobile_settings_EditPhoneMo = (EditPhoneMo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/CreateGroup_anoDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var dialog_CreateGroup_anoDialog = ({
  props: {
    dialogGroup: false,
    anoGroupDetail: {}
  },
  data: function data() {
    return {
      GroupName: '',
      token: '',
      checkbox: true
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },

  watch: {
    anoGroupDetail: function anoGroupDetail() {
      this.GroupName = this.anoGroupDetail.pseudonym;
    }
  },
  methods: {
    closeDialogCreateGroup_ano: function closeDialogCreateGroup_ano() {
      this.$emit('closeDialogCreateGroup_ano', false);
    },
    createGroup_ano: function createGroup_ano() {
      var _this = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/create-group-anonymous', {
        tokenuser: this.token,
        group_ref_id: this.anoGroupDetail.group_ref_id,
        add_owner: this.checkbox + '',
        group_name: this.GroupName
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this.$swal('', _this.$t('Alert.Success.createGroupChat'), 'success');
          _this.closeDialogCreateGroup_ano();
        }
      }, function () {
        console.log('error');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed0f4d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/CreateGroup_anoDialog.vue
var dialog_CreateGroup_anoDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialogGroup),callback:function ($$v) {_vm.dialogGroup=$$v},expression:"dialogGroup"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("group")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.anonymous.headerCreate'))+"\n        ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialogCreateGroup_ano}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',[_vm._v(_vm._s(_vm.$t('Dialog.anonymous.createGroupName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.GroupName),expression:"GroupName"}],staticClass:"CSChatThai inputgroupweb",attrs:{"type":"text","placeholder":_vm.$t('Dialog.anonymous.groupName')},domProps:{"value":(_vm.GroupName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.GroupName=$event.target.value}}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":_vm.$t('Dialog.anonymous.addMember')},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"blue darken-1","flat":"flat","disabled":_vm.GroupName==''},on:{"click":function($event){_vm.createGroup_ano()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.createGroup')))])],1)],1)],1)],1)}
var dialog_CreateGroup_anoDialog_staticRenderFns = []
var dialog_CreateGroup_anoDialog_esExports = { render: dialog_CreateGroup_anoDialog_render, staticRenderFns: dialog_CreateGroup_anoDialog_staticRenderFns }
/* harmony default export */ var mobile_dialog_CreateGroup_anoDialog = (dialog_CreateGroup_anoDialog_esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/CreateGroup_anoDialog.vue
function dialog_CreateGroup_anoDialog_injectStyle (ssrContext) {
  __webpack_require__("G0Ct")
}
var dialog_CreateGroup_anoDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialog_CreateGroup_anoDialog___vue_template_functional__ = false
/* styles */
var dialog_CreateGroup_anoDialog___vue_styles__ = dialog_CreateGroup_anoDialog_injectStyle
/* scopeId */
var dialog_CreateGroup_anoDialog___vue_scopeId__ = "data-v-1ed0f4d2"
/* moduleIdentifier (server only) */
var dialog_CreateGroup_anoDialog___vue_module_identifier__ = null
var dialog_CreateGroup_anoDialog_Component = dialog_CreateGroup_anoDialog_normalizeComponent(
  dialog_CreateGroup_anoDialog,
  mobile_dialog_CreateGroup_anoDialog,
  dialog_CreateGroup_anoDialog___vue_template_functional__,
  dialog_CreateGroup_anoDialog___vue_styles__,
  dialog_CreateGroup_anoDialog___vue_scopeId__,
  dialog_CreateGroup_anoDialog___vue_module_identifier__
)

/* harmony default export */ var components_mobile_dialog_CreateGroup_anoDialog = (dialog_CreateGroup_anoDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/settings/Anonymousone.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Anonymousone = ({
  data: function data() {
    return {
      list_anonymous_joined: [],
      list_anonymous_owner: [],
      token: '',
      dialogGroup: false,
      anoGroupDetail: {}
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.get_anonymousjoined();
    this.get_anonymousowner();
  },

  components: {
    createGroupAno: components_mobile_dialog_CreateGroup_anoDialog,
    vue100vh: vue100vh["a" /* default */]
  },
  methods: {
    toPage: function toPage(path) {
      this.$router.push(path);
    },
    closeDialogCreateGroup_ano: function closeDialogCreateGroup_ano() {
      this.dialogGroup = false;
    },
    openCreateGroup: function openCreateGroup(item) {
      this.dialogGroup = true;
      this.anoGroupDetail = item;
    },
    get_anonymousjoined: function get_anonymousjoined() {
      var _this = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-anonymous-joined', {
        tokenuser: this.token
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          _this.list_anonymous_joined = response.data.group_joined;
        }
      }, function () {
        console.log('error');
      });
    },
    get_anonymousowner: function get_anonymousowner() {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-anonymous-owner', {
        tokenuser: this.token
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          _this2.list_anonymous_owner = response.data.group_owner;
        }
      }, function () {
        console.log('error');
      });
    },
    openCreateBiz: function openCreateBiz(item) {
      // var url = 'https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token='
      var body = {
        "tokenuser": this.token,
        "url": "https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token="
      };
      this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", body).then(function (response) {
        window.open("https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token=" + response.data.data.accesstoken, '_blank');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95a7e472","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/settings/Anonymousone.vue
var Anonymousone_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('div',{staticClass:"CSChatThai BGwhite"},[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/homepage')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"ml-0"},[_vm._v("One Anonymous")])],1),_vm._v(" "),_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v(_vm._s(_vm.$t('Anonymous.manageGroup')))]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-container',{staticStyle:{"max-height":"35vh","overflow":"scroll"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.list_anonymous_owner.length > 0)?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},_vm._l((_vm.list_anonymous_owner),function(item,index){return _c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"rgb(255, 255, 255) !important","max-width":"100% !important","cursor":"auto"},attrs:{"two-line":"","subheader":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"}},[_vm._v("\n                      "+_vm._s(item.pseudonym)+"\n\n                    ")])],1),_vm._v(" "),_c('v-list-tile-action',{staticStyle:{"width":"30%","display":"inline","margin-top":"30px"}},[_c('v-btn',{staticStyle:{"background-color":"white","border-radius":"50px","color":"#536475","padding-left":"9px","padding-right":"9px","text-transform":"none","border":"#536475 solid 1px"},attrs:{"depressed":""},on:{"click":function($event){_vm.openCreateGroup(item)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('Anonymous.createGroup'))+"\n                      ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"background-color":"#536475","border-radius":"50px","color":"white","padding-left":"9px","padding-right":"9px","border":"#bebec1 1px solid","text-transform":"none"},attrs:{"depressed":""},on:{"click":function($event){_vm.openCreateBiz(item)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('Anonymous.createBusiness'))+"\n                      ")])],1)],1),_vm._v(" "),_c('v-divider')],1)})):_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',[_vm._v(_vm._s(_vm.$t('Anonymous.noManageGroup')))])])],1)],1),_vm._v(" "),_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v(_vm._s(_vm.$t('Anonymous.yourGroup')))]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-container',{staticStyle:{"max-height":"35vh","overflow":"scroll"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.list_anonymous_joined.length > 0)?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},_vm._l((_vm.list_anonymous_joined),function(item,index){return _c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"rgb(255, 255, 255) !important","max-width":"100% !important","cursor":"auto"},attrs:{"two-line":"","subheader":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"}},[_vm._v("\n                      "+_vm._s(item.pseudonym)+"\n\n                    ")])],1),_vm._v(" "),_c('v-list-tile-action',{staticStyle:{"width":"30%","display":"inline","margin-top":"30px"}})],1),_vm._v(" "),_c('v-divider')],1)})):_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',[_vm._v(_vm._s(_vm.$t('Anonymous.noYourManageGroup')))])])],1)],1),_vm._v(" "),_c('createGroupAno',{attrs:{"dialogGroup":_vm.dialogGroup,"anoGroupDetail":_vm.anoGroupDetail},on:{"closeDialogCreateGroup_ano":_vm.closeDialogCreateGroup_ano}})],1)])}
var Anonymousone_staticRenderFns = []
var Anonymousone_esExports = { render: Anonymousone_render, staticRenderFns: Anonymousone_staticRenderFns }
/* harmony default export */ var settings_Anonymousone = (Anonymousone_esExports);
// CONCATENATED MODULE: ./src/components/mobile/settings/Anonymousone.vue
function Anonymousone_injectStyle (ssrContext) {
  __webpack_require__("fHqe")
}
var Anonymousone_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Anonymousone___vue_template_functional__ = false
/* styles */
var Anonymousone___vue_styles__ = Anonymousone_injectStyle
/* scopeId */
var Anonymousone___vue_scopeId__ = "data-v-95a7e472"
/* moduleIdentifier (server only) */
var Anonymousone___vue_module_identifier__ = null
var Anonymousone_Component = Anonymousone_normalizeComponent(
  Anonymousone,
  settings_Anonymousone,
  Anonymousone___vue_template_functional__,
  Anonymousone___vue_styles__,
  Anonymousone___vue_scopeId__,
  Anonymousone___vue_module_identifier__
)

/* harmony default export */ var mobile_settings_Anonymousone = (Anonymousone_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/settings/Languages.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Languages = ({
  data: function data() {
    return {
      language: ''
    };
  },
  methods: {
    toPage: function toPage(data) {
      this.$router.push(data);
    },
    changeLan: function changeLan(lang) {
      this.$i18n.locale = lang;
      this.$cookie.set('language', lang);
      this.language = lang;
      // this.changeLangMenu()
    }
  },
  components: {
    vue100vh: vue100vh["a" /* default */]
  },
  created: function created() {
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
    this.language = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
    // console.log(this.$cookie.get('language'))
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-669fc2a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/settings/Languages.vue
var Languages_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('div',{staticStyle:{"height":"calc(100vh - 64px)","overflow-x":"hidden","overflow-y":"scroll"}},[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/homepage')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('HeaderMenubar.languages')))])],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('v-list',[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.changeLan('th')}}},[_c('v-list-tile-action',[_c('img',{staticStyle:{"height":"35px"},attrs:{"src":"/static/flag/thailand.svg"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"pl-2"},[_vm._v("ไทย")])],1),_vm._v(" "),(_vm.language === 'th')?_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("mdi-checkbox-marked-circle")])],1):_vm._e()],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.changeLan('en')}}},[_c('v-list-tile-action',[_c('img',{staticStyle:{"height":"35px"},attrs:{"src":"/static/flag/united-kingdom.svg"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"pl-2"},[_vm._v("ENG")])],1),_vm._v(" "),(_vm.language === 'en')?_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("mdi-checkbox-marked-circle")])],1):_vm._e()],1)],1)],1)],1)])}
var Languages_staticRenderFns = []
var Languages_esExports = { render: Languages_render, staticRenderFns: Languages_staticRenderFns }
/* harmony default export */ var settings_Languages = (Languages_esExports);
// CONCATENATED MODULE: ./src/components/mobile/settings/Languages.vue
function Languages_injectStyle (ssrContext) {
  __webpack_require__("uS+H")
}
var Languages_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Languages___vue_template_functional__ = false
/* styles */
var Languages___vue_styles__ = Languages_injectStyle
/* scopeId */
var Languages___vue_scopeId__ = "data-v-669fc2a6"
/* moduleIdentifier (server only) */
var Languages___vue_module_identifier__ = null
var Languages_Component = Languages_normalizeComponent(
  Languages,
  settings_Languages,
  Languages___vue_template_functional__,
  Languages___vue_styles__,
  Languages___vue_scopeId__,
  Languages___vue_module_identifier__
)

/* harmony default export */ var mobile_settings_Languages = (Languages_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/manage/Forwardmessage.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var Forwardmessage__ = __webpack_require__("M4fF");
/* harmony default export */ var Forwardmessage = ({
  data: function data() {
    return {
      tabs: '',
      selectedgroup: [],
      selectedfriend: [],
      listblock: [],
      token: '',
      search: '',
      listfriend: [],
      listgroup: [],
      listchat: [],
      ProgressListFriend: false,
      ProgressListGroup: false,
      ProgressListChat: false,
      listtokenroom: [],
      chips: []
    };
  },
  components: {
    vue100vh: vue100vh["a" /* default */]
  },
  methods: {
    closeSeleted: function closeSeleted() {
      this.selectedfriend = [];
    },
    sendforward: function sendforward() {
      var _this = this;

      for (var i = 0; i < this.selectedfriend.length; i++) {
        this.listtokenroom[i] = this.selectedfriend[i].tokenroom;
      }
      // console.log(this.tokenmsgforward)
      // console.log(this.listtokenroom)
      if (this.tokenmsgforward.length !== 0) {
        this.axios.post("https://uatchat-manage.one.th/message" + '/forward_file_message', { list_tokenroom: this.listtokenroom, tokenuser: this.token, list_tokenmessage: this.tokenmsgforward }).then(function (response) {
          // console.log(response.data)
          if (response.data['status'] === 'success') {
            _this.$swal('', _this.$t('Alert.Success.success'), 'success');
            _this.tokenmsgforward = [];
            _this.listtokenroom = [];
            _this.selectedfriend = [];
            _this.toPage();
            // this.$router.push('/mobile/homepage/')
            // for (var i = 0; i < response.data.data.length; i++) {
            //   var tokenroomforward = ''
            //   tokenroomforward = response.data.data[0].tokenroom
            // }
            // this.$router.push('/mobile/room/' + tokenroomforward)
          } else {
            _this.$swal('', _this.$t('Alert.Fail.default.somethingWrong'), 'warnning');
          }
        }, function () {
          _this.$swal('', _this.$t('Alert.Fail.default.somethingWrong'), 'warnning');
        });
      } else {
        this.$swal('', this.$t('Alert.Fail.forward.selectMessage'), 'warning');
      }
    },
    removeListAddGroup: function removeListAddGroup(item) {
      this.selectedfriend.splice(this.selectedfriend.indexOf(item), 1);
    },
    toPage: function toPage() {
      this.$router.push('/mobile/room/' + this.$route.params.roomid);
    },
    getlistfriend: function getlistfriend() {
      var _this2 = this;

      this.ProgressListFriend = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-friend', { tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          _this2.ProgressListFriend = false;
          _this2.listfriend = response.data['list_friend'];
          // console.log(this.listfriend)
        } else {
          _this2.ProgressListFriend = false;
        }
      });
    },
    getlistgroup: function getlistgroup() {
      var _this3 = this;

      this.ProgressListGroup = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-group', { tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          _this3.ProgressListGroup = false;
          _this3.listgroup = response.data['list_active_group'];
          // console.log(this.listgroup)
        } else {
          _this3.ProgressListGroup = false;
        }
      });
    },
    getlistchat: function getlistchat() {
      var _this4 = this;

      this.ProgressListChat = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistchat', { tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          _this4.ProgressListChat = false;
          _this4.listchat = response.data['listchat'];
          // console.log(this.listchat)
        } else {
          _this4.ProgressListChat = false;
        }
      });
    }
  },
  computed: extends_default()({
    FilterFriendList: function FilterFriendList() {
      var _this5 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listfriend.filter(function (post) {
          return post.name.toLowerCase().includes(_this5.search.toLowerCase());
        });
      } else {
        return this.listfriend;
      }
    },
    FilterGroupList: function FilterGroupList() {
      var _this6 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listgroup.filter(function (post) {
          return post.name.toLowerCase().includes(_this6.search.toLowerCase());
        });
      } else {
        return this.listgroup;
      }
    },
    FilterChatList: function FilterChatList() {
      var _this7 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listchat.filter(function (post) {
          return post.name.toLowerCase().includes(_this7.search.toLowerCase());
        });
      } else {
        return this.listchat;
      }
    }
  }, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {
    // selectedmessage (data) {
    //   this.listtokenmsg = data
    // },
    selectedfriend: function selectedfriend() {
      if (this.selectedfriend.length > 5) {
        this.$swal('', this.$t('Alert.Fail.forward.maxChatRoom'), 'error');
        Forwardmessage__.pullAt(this.selectedfriend, [5]);
      }
    }
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.getlistchat();
    this.getlistfriend();
    this.getlistgroup();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ace946c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/manage/Forwardmessage.vue
var Forwardmessage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('div',{staticClass:"CSChatThai BGwhite"},[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage()}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('ChatSide.forward')))])],1),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('v-card-text',{staticStyle:{"margin-top":"7px","margin-bottom":"0vh","justify-content":"center !important","color":"rgb(74, 74, 74) !important"}},[_c('v-tabs',{staticStyle:{"height":"20px"},attrs:{"centered":"","fixed-tabs":""}},[_c('v-tabs-slider',{attrs:{"color":"blue"}}),_vm._v(" "),_c('v-tab',{staticClass:"text-transform",attrs:{"href":"#tab-1"}},[_vm._v(_vm._s(_vm.$t('Dialog.forward.friend')))]),_vm._v(" "),_c('v-tab',{staticClass:"text-transform",attrs:{"href":"#tab-2"}},[_vm._v(_vm._s(_vm.$t('Dialog.forward.group')))]),_vm._v(" "),_c('v-tabs-items',{staticClass:"white elevation-1",model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('v-tab-item',{staticStyle:{"height":"calc(100vh - 128px)"},attrs:{"id":"tab-1"}},[_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"padding-top":"0px"},attrs:{"dense":""}},[_c('v-container',{staticClass:"layoutsearchweb"},[_c('v-layout',{staticClass:"layoutsearchweb",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-text-field',{staticStyle:{"color":"white !important"},attrs:{"append-icon":"search","label":_vm.$t('Dialog.group.searching'),"solo":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"scroll-y",staticStyle:{"max-height":"calc(100vh - 260px)","overflow-y":"scroll"},attrs:{"xs12":"","xl12":"","md12":"","sm12":"","lg12":""}},[(_vm.FilterFriendList.length != 0)?_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('Dialog.forward.friend'))+" ("+_vm._s(_vm.FilterFriendList.length)+")")]):_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('Dialog.forward.friend')))]),_vm._v(" "),(!_vm.ProgressListFriend)?_c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"#fff !important","width":"100%"},attrs:{"subheader":""}},[_vm._l((_vm.FilterFriendList),function(item,index){return (_vm.FilterFriendList.length != 0)?[_c('div',{staticStyle:{"padding-top":"0px","cursor":"pointer"},attrs:{"avatar":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"}},[_vm._v("\n                                "+_vm._s(item.name)+"\n                              ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat "},[(item.status !== '')?_c('span',{staticClass:"text--primary fontselectchat ",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                  "+_vm._s(item.status)+"\n                                ")]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-checkbox',{attrs:{"value":item},model:{value:(_vm.selectedfriend),callback:function ($$v) {_vm.selectedfriend=$$v},expression:"selectedfriend"}})],1)],1)],1),_vm._v(" "),_c('v-divider')]:_vm._e()})],2):_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":_vm.ProgressListFriend}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{staticStyle:{"height":"calc(100vh - 128px)"},attrs:{"id":"tab-2"}},[_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"padding-top":"0px"},attrs:{"dense":""}},[_c('v-container',{staticClass:"layoutsearchweb"},[_c('v-layout',{staticClass:"layoutsearchweb",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-text-field',{staticStyle:{"color":"white !important"},attrs:{"append-icon":"search","label":_vm.$t('Dialog.forward.searchgroup'),"solo":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"scroll-y",staticStyle:{"max-height":"calc(100vh - 260px)","overflow-y":"scroll"},attrs:{"xs12":"","xl12":"","md12":"","sm12":"","lg12":""}},[(_vm.FilterGroupList.length != 0)?_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('Dialog.forward.group'))+" ("+_vm._s(_vm.FilterGroupList.length)+")")]):_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('Dialog.forward.group')))]),_vm._v(" "),(!_vm.ProgressListGroup)?_c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"#fff !important","width":"100%"},attrs:{"subheader":""}},[_vm._l((_vm.FilterGroupList),function(item,index){return (_vm.FilterGroupList.length != 0)?[_c('div',{staticStyle:{"padding-top":"0px","cursor":"pointer"},attrs:{"avatar":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.picture}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):(item.type === 'group')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/group-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"}},[_vm._v("\n                                "+_vm._s(item.name)+"\n                              ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat "},[(item.status !== '')?_c('span',{staticClass:"text--primary fontselectchat ",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                  "+_vm._s(item.status)+"\n                                ")]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-checkbox',{attrs:{"value":item},model:{value:(_vm.selectedfriend),callback:function ($$v) {_vm.selectedfriend=$$v},expression:"selectedfriend"}})],1)],1)],1),_vm._v(" "),_c('v-divider')]:_vm._e()})],2):_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":_vm.ProgressListGroup}})],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"scrolling-wrapper"},_vm._l((_vm.selectedfriend),function(i){return _c('v-chip',{attrs:{"close":""},on:{"input":function($event){_vm.removeListAddGroup(i)}}},[_c('v-avatar',[(i.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":i.profilepicture,"alt":i.tokenroom}}):(i.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":i.picture,"alt":i.tokenroom}}):(i.type === 'business')?_c('img',{attrs:{"src":"/static/img/default_profile/business-white.png","alt":i.tokenroom}}):(i.type === 'government')?_c('img',{attrs:{"src":"/static/img/default_profile/business-white.png","alt":i.tokenroom}}):(i.type === 'bot')?_c('img',{attrs:{"src":"/static/img/default_profile/bot-white.png","alt":i.tokenroom}}):(i.type === 'group')?_c('img',{attrs:{"src":"/static/img/default_profile/group-white.png","alt":i.tokenroom}}):_c('img',{attrs:{"src":"/static/img/default_profile/man-white.png","alt":i.tokenroom}})]),_vm._v(" "),_c('span',{staticClass:"text2"},[_vm._v(_vm._s(i.name))])],1)})),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(_vm.selectedfriend.length === 0)?_c('v-layout',{staticStyle:{"margin-top":"15px"},attrs:{"justify-center":"","align-center":"","row":"","wrap":""}},[_c('v-btn',{staticClass:"btncreategroup text-transform",attrs:{"disabled":"","small":"","round":""}},[_vm._v("\n            "+_vm._s(_vm.$t('AnswerQuestion.forward'))+"\n          ")]),_vm._v(" "),_c('v-btn',{staticClass:"btncanclegroup text-transform",attrs:{"small":"","round":""},on:{"click":function($event){_vm.closeSeleted()}}},[_vm._v("\n            "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n          ")])],1):_c('v-layout',{attrs:{"justify-center":"","align-center":"","row":"","wrap":""}},[_c('v-btn',{staticClass:"btncreategroup text-transform",attrs:{"small":"","round":""},on:{"click":function($event){_vm.sendforward()}}},[_vm._v("\n            "+_vm._s(_vm.$t('AnswerQuestion.forward'))+"\n          ")]),_vm._v(" "),_c('v-btn',{staticClass:"btncanclegroup text-transform",attrs:{"small":"","round":""},on:{"click":function($event){_vm.closeSeleted()}}},[_vm._v("\n            "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n          ")])],1)],1)],1)],1)],1)])}
var Forwardmessage_staticRenderFns = []
var Forwardmessage_esExports = { render: Forwardmessage_render, staticRenderFns: Forwardmessage_staticRenderFns }
/* harmony default export */ var manage_Forwardmessage = (Forwardmessage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/manage/Forwardmessage.vue
function Forwardmessage_injectStyle (ssrContext) {
  __webpack_require__("zdN6")
}
var Forwardmessage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Forwardmessage___vue_template_functional__ = false
/* styles */
var Forwardmessage___vue_styles__ = Forwardmessage_injectStyle
/* scopeId */
var Forwardmessage___vue_scopeId__ = "data-v-7ace946c"
/* moduleIdentifier (server only) */
var Forwardmessage___vue_module_identifier__ = null
var Forwardmessage_Component = Forwardmessage_normalizeComponent(
  Forwardmessage,
  manage_Forwardmessage,
  Forwardmessage___vue_template_functional__,
  Forwardmessage___vue_styles__,
  Forwardmessage___vue_scopeId__,
  Forwardmessage___vue_module_identifier__
)

/* harmony default export */ var mobile_manage_Forwardmessage = (Forwardmessage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/manage/Profilefriend.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var Profilefriend__ = __webpack_require__("M4fF");
/* harmony default export */ var Profilefriend = ({
  props: {},
  data: function data() {
    return {
      token: '',
      tokenfriend: '',
      inforfriend: {},
      relation: '',
      btntext: '',
      progress: false,
      typefriend: '',
      statefriend: ''
    };
  },

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  components: {
    vue100vh: vue100vh["a" /* default */]
  },
  watch: {
    socketremove_request_friend: function socketremove_request_friend(data) {
      // console.log(data)
      this.relation = 'unknown';
      this.btntext = this.$t('AnswerQuestion.addFiend');
    },
    socketaccept_friend: function socketaccept_friend(data) {
      // console.log(data)
      this.relation = 'friend';
      this.btntext = this.$t('AnswerQuestion.chat');
    },
    socketfriend: function socketfriend(data) {
      // console.log(data)
      if (data.konAdd != this.token) {
        this.relation = 'request';
        this.btntext = this.$t('AnswerQuestion.acceptFriend');
      } else {
        this.relation = 'sendrequest';
        this.btntext = this.$t('AnswerQuestion.cancelRequest');
      }
    },
    socketremove_friend: function socketremove_friend(data) {
      // console.log(data)
      this.relation = 'unfriend';
      this.btntext = this.$t('AnswerQuestion.addFiend');
    },
    socketblock: function socketblock(data) {
      // console.log(data)
    }
  },
  created: function created() {
    this.typefriend = localStorage.getItem('typefriend');
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    // this.tokenfriend = Decode.decodeToken(localStorage.getItem('tokenfriend'))
    this.searchuser();
  },

  methods: {
    detailimageFriend: function detailimageFriend(detailfriend) {
      // console.log(detailfriend)
      var picture = '';
      if (detailfriend.type !== 'group') {
        picture = detailfriend.profilepicture;
        if (picture == '') {
          if (detailfriend.type == 'user') {
            picture = '/static/img/default_profile/man-white.png';
          } else if (detailfriend.type == 'bot') {
            picture = '/static/img/default_profile/bot-white.png';
          } else if (detailfriend.type == 'business') {
            picture = '/static/img/default_profile/business-white.png';
          } else {
            picture = '/static/img/default_profile/man-white.png';
          }
        }
      } else {
        picture = detailfriend.picture;
        if (picture == '') {
          picture = '/static/img/default_profile/group-white.png';
        } else {
          picture = detailfriend.picture;
        }
      }

      this.$swal({
        imageUrl: picture,
        imageHeight: 250,
        showCloseButton: true,
        showConfirmButton: false
      });
    },
    toPage: function toPage() {
      // console.log(this.inforfriend)
      // console.log(this.$router.push(-1))
      this.$router.go(-1);
      // this.$router.push('/mobile/room/' + this.inforfriend.tokenroom)
    },
    toPageQrcode: function toPageQrcode() {
      this.$router.push('/mobile/qrcode');
    },
    searchuser: function searchuser() {
      var _this = this;

      if (this.typefriend !== 'group') {
        this.progress = true;
        this.statefriend = 'friend';
        this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', { tokenuser: this.token, tokenfriend: this.$route.params.profileid }).then(function (response) {
          // console.log(response.data)
          if (response.data.status === 'success') {
            _this.progress = false;
            _this.relation = response.data.relation;
            _this.inforfriend = response.data.user;
            if (_this.relation == 'friend') {
              _this.btntext = _this.$t('AnswerQuestion.chat');
            } else if (_this.relation == 'request') {
              _this.btntext = _this.$t('AnswerQuestion.acceptFriend');
            } else if (_this.relation == 'request') {
              _this.btntext = _this.$t('AnswerQuestion.acceptFriend');
            } else if (_this.relation == 'sendrequest') {
              _this.btntext = _this.$t('AnswerQuestion.cancelRequest');
            } else if (_this.relation == 'unknown') {
              _this.btntext = _this.$t('AnswerQuestion.addFriend');
            } else if (_this.relation == 'self') {
              _this.btntext = _this.$t('AnswerQuestion.ok');
            } else if (_this.relation == 'unfriend') {
              _this.btntext = _this.$t('AnswerQuestion.addFiend');
            } else if (_this.relation == 'block') {
              _this.btntext = _this.$t('AnswerQuestion.unblock');
            }
          }
        });
      } else {
        this.progress = true;
        this.statefriend = 'group';
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', { tokenuser: this.token, group_id: this.$route.params.profileid }).then(function (response) {
          // console.log(response.data)
          if (response.data.status === 'success') {
            _this.progress = false;
            _this.relation = response.data.group.state;
            _this.inforfriend = response.data.group;
            if (_this.relation == 'group' || _this.relation == 'active') {
              _this.btntext = _this.$t('AnswerQuestion.chat');
            } else {
              _this.btntext = _this.$t('AnswerQuestion.joinGroup');
            }
          }
        });
      }
    },
    actionclick: function actionclick(inforfriend) {
      // console.log(inforfriend)
      // console.log(this.relation)
      if (this.relation == 'friend') {
        this.$router.push('/mobile/room/' + inforfriend.tokenroom);
      } else if (this.relation == 'unknown' || this.relation == 'unfriend') {
        this.addfriend(inforfriend.tokenuser);
      } else if (this.relation == 'sendrequest') {
        this.remove_send_request(inforfriend.tokenuser);
      } else if (this.relation == 'request') {
        this.acceptfriend(inforfriend.tokenuser);
      } else if (this.relation == 'block') {
        this.unblock(inforfriend.tokenuser, inforfriend.name, inforfriend.tokenroom);
      } else if (this.relation == 'group' || this.relation == 'active') {
        // console.log(this.relation)
        this.$router.push('/mobile/room/' + inforfriend.tokenroom);
        // console.log(inforfriend)
      } else if (this.relation == 'leave') {
        // console.log(this.relation)
        this.acceptgroupclick(inforfriend);
        // console.log(inforfriend)
      } else if (this.relation == 'self') {
        this.$router.go(-1);
      }
    },
    acceptgroupclick: function acceptgroupclick(inforfriend) {
      var _this2 = this;

      // console.log(inforfriend)
      this.axios.post("https://uatchat-manage.one.th/manage" + '/joingroup', { group_id: inforfriend.group_id, tokenuser: this.token }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this2.relation = response.data.group.state;
          _this2.btntext = _this2.$t('AnswerQuestion.chat');
          _this2.$swal('', _this2.$t('Alert.Success.success'), 'success');
          var tokenuser = _this2.token;
          var indexgroup = Profilefriend__.findIndex(response.data.group.member, function (o) {
            return o.tokenuser === tokenuser;
          });
          if (indexgroup >= 0) {
            _this2.socketactive_group = { timestamp: response.data.group.member[indexgroup].timestamp_in, groupid: inforfriend.group_id, tokenuser: _this2.token };
          } else {
            _this2.socketactive_group = { timestamp: '', groupid: inforfriend.group_id, tokenuser: _this2.token };
          }
          _this2.$router.push('/mobile/room/' + response.data.group.tokenroom);
        }
      });
    },
    canclegroupclick: function canclegroupclick(inforfriend) {
      var _this3 = this;

      // console.log(inforfriend)
      this.$swal({
        // text: 'คุณต้องการยกเลิกเข้าร่วมกลุ่ม ' + inforfriend.name +' ใช่หรือไม่?',
        text: this.$t('Alert.Group.cancelGroup', { name: inforfriend.name }),
        type: 'warning',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this3.axios.post("https://uatchat-manage.one.th/manage" + '/cancelinvitegroup', { group_id: inforfriend.group_id, tokenuser: _this3.token }).then(function (response) {
            if (response.data.status === 'success') {
              _this3.$swal('', _this3.$t('Alert.Success.success'), 'success');
              _this3.$router.push('/mobile/qrcode');
            } else {
              _this3.$swal('', _this3.$t('Alert.Fail.default.somethingWrong'), 'warnning');
            }
          });
        }
      });
    },
    addfriend: function addfriend(tokenuser) {
      var _this4 = this;

      // this.axios.post(process.env.APInew_addfriend, {tokenfriend: tokenuser, tokenuser: this.token}).then((response) => {
      //   if (response.data['status'] === 'success') {
      //   }
      // })
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/add-friend-accept', { tokenfriend: tokenuser, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          _this4.relation = 'friend';
          _this4.btntext = _this4.$t('AnswerQuestion.chat');
          _this4.inforfriend.tokenroom = response.data.tokenroom;
        } else {
          // this.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning')
          _this4.$swal('', _this4.$t('Alert.Fail.default.somethingWrong'), 'warnning');
        }
      }).catch(function (error) {
        console.log(error);
        // this.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning')
        _this4.$swal('', _this4.$t('Alert.Fail.default.somethingWrong'), 'warnning');
      });
    },
    remove_send_request: function remove_send_request(tokenuser) {
      var _this5 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', { tokenfriend: tokenuser, tokenuser: this.token }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this5.relation = 'unknown';
          _this5.btntext = _this5.$t('AnswerQuestion.addFriend');
        }
      });
    },
    acceptfriend: function acceptfriend(tokenuser) {
      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/accept-friend", { tokenfriend: tokenuser, tokenuser: this.token }).then(function (response) {
        if (response.data['status'] === 'success') {
          // console.log(response.data)
        }
      });
    },
    unblock: function unblock(tokenuser, name, tokenroom) {
      var _this6 = this;

      this.$swal({
        // text: 'คุณต้องการยกเลิกการบล็อก ' + name + ' ใช่หรือไม่?',
        text: this.$t('Alert.Unblocking', { name: name }),
        type: 'warning',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this6.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', { tokenfriend: tokenuser, tokenuser: _this6.token, tokenroom: tokenroom }).then(function (response) {
            if (response.data['status'] === 'success') {
              // console.log(response.data)
              _this6.$swal('', _this6.$t('Alert.Success.unblock'), 'success');
              _this6.relation = 'friend';
              _this6.btntext = _this6.$t('AnswerQuestion.chat');
            }
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78b07413","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/manage/Profilefriend.vue
var Profilefriend_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[(_vm.progress)?_c('v-layout',{staticClass:"layout-height",attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"size":80,"indeterminate":_vm.progress,"color":"primary"}})],1):_c('div',{staticClass:"layout-height"},[(_vm.statefriend !== 'group')?_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('v-toolbar',{staticClass:"bg-toolbar"},[_c('v-btn',{attrs:{"color":"black","flat":"","icon":"","dark":""},on:{"click":function($event){_vm.toPage()}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"ml-0"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.profile')))])],1),_vm._v(" "),(_vm.inforfriend.profilepicture)?_c('img',{staticClass:"img-w-h",attrs:{"src":_vm.inforfriend.profilepicture},on:{"click":function($event){_vm.detailimageFriend(_vm.inforfriend)}}}):(_vm.inforfriend.type == 'bot')?_c('img',{staticClass:"img-w-h",attrs:{"src":"/static/img/default_profile/bot-white.png"},on:{"click":function($event){_vm.detailimageFriend(_vm.inforfriend)}}}):(_vm.inforfriend.type == 'business')?_c('img',{staticClass:"img-w-h",attrs:{"src":"/static/img/default_profile/business-white.png"},on:{"click":function($event){_vm.detailimageFriend(_vm.inforfriend)}}}):_c('img',{staticClass:"img-w-h",attrs:{"src":"/static/img/default_profile/man-white.png"},on:{"click":function($event){_vm.detailimageFriend(_vm.inforfriend)}}}),_vm._v(" "),_c('v-layout',{staticClass:"width-100",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"btn-action text-transform",on:{"click":function($event){_vm.actionclick(_vm.inforfriend)}}},[_vm._v(_vm._s(_vm.btntext))])],1),_vm._v(" "),_c('v-system-bar',{staticClass:"width-100"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.displayName')))]),_vm._v(" "),_c('span',{staticClass:"mb-2 mt-2 ml-3 font-16 text-hidden"},[_vm._v(_vm._s(_vm.inforfriend.name))]),_vm._v(" "),_c('v-system-bar',{staticClass:"width-100"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.status')))]),_vm._v(" "),(_vm.inforfriend.status != '')?_c('span',{staticClass:"mb-2 mt-2 ml-3 font-16 text-hidden"},[_vm._v(_vm._s(_vm.inforfriend.status))]):(_vm.inforfriend.status == '')?_c('span',{staticClass:"mb-2 mt-2 ml-3 font-16 text-hidden"},[_vm._v("-")]):_vm._e(),_vm._v(" "),(_vm.relation == 'friend')?_c('v-system-bar',{staticClass:"width-100"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.phone')))]):_vm._e(),_vm._v(" "),(_vm.relation == 'friend' && _vm.inforfriend.phone != '')?_c('span',{staticClass:"mb-2 mt-2 ml-3 font-16"},[_vm._v(_vm._s(_vm.inforfriend.phone))]):(_vm.relation == 'friend' && _vm.inforfriend.phone == '')?_c('span',{staticClass:"mb-2 mt-2 ml-3 font-16"},[_vm._v("-")]):_vm._e(),_vm._v(" "),_c('v-system-bar',{staticClass:"width-100"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.email')))]),_vm._v(" "),(_vm.inforfriend.email)?_c('span',{staticClass:"mb-2 mt-2 ml-3 font-16"},[_vm._v(_vm._s(_vm.inforfriend.email))]):_c('span',{staticClass:"mb-2 mt-2 ml-3 font-16"},[_vm._v("-")])],1):_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('v-toolbar',{staticClass:"bg-toolbar"},[_c('v-btn',{attrs:{"color":"black","flat":"","icon":"","dark":""},on:{"click":function($event){_vm.toPageQrcode()}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"ml-0"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.group')))])],1),_vm._v(" "),(_vm.inforfriend.picture)?_c('img',{staticClass:"img-w-h",attrs:{"src":_vm.inforfriend.picture},on:{"click":function($event){_vm.detailimageFriend(_vm.inforfriend)}}}):_c('img',{staticClass:"img-w-h",attrs:{"src":"/static/img/default_profile/group-white.png"},on:{"click":function($event){_vm.detailimageFriend(_vm.inforfriend)}}}),_vm._v(" "),(_vm.relation == 'group' || _vm.relation == 'active')?_c('v-layout',{staticClass:"width-100",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-btn',{staticClass:"btn-action text-transform",on:{"click":function($event){_vm.actionclick(_vm.inforfriend)}}},[_vm._v(_vm._s(_vm.btntext))])],1)],1):_c('v-layout',{staticClass:"width-100",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":""}},[_c('v-btn',{staticClass:"btn-action text-transform",on:{"click":function($event){_vm.acceptgroupclick(_vm.inforfriend)}}},[_vm._v(_vm._s(_vm.btntext))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":""}},[_c('v-btn',{staticClass:"btn-action-profile text-transform",on:{"click":function($event){_vm.canclegroupclick(_vm.inforfriend)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1)],1),_vm._v(" "),_c('v-system-bar',{staticClass:"width-100"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.groupName')))]),_vm._v(" "),_c('span',{staticClass:"mb-2 mt-2 ml-3 font-16 text-hidden"},[_vm._v(_vm._s(_vm.inforfriend.name))]),_vm._v(" "),_c('v-system-bar',{staticClass:"width-100"},[_vm._v(_vm._s(_vm.$t('RightSide.member')))]),_vm._v(" "),(_vm.inforfriend.member.length !== 0)?_c('v-list',_vm._l((_vm.inforfriend.member),function(item){return (item.statemember == 'active')?_c('v-list-tile',{key:item.tokenuser},[(item.statemember == 'active')?_c('v-list-tile-avatar',[_c('v-img',{attrs:{"src":item.profile}})],1):_vm._e(),_vm._v(" "),(item.statemember == 'active')?_c('v-list-tile-content',[_c('v-list-tile-title',[_c('p',{staticClass:"text-title mb-0 ml-3"},[_vm._v(_vm._s(item.name))])])],1):_vm._e()],1):_vm._e()})):_c('h4',[_vm._v(_vm._s(_vm.$t('RightSide.noMember')))])],1)],1)],1)}
var Profilefriend_staticRenderFns = []
var Profilefriend_esExports = { render: Profilefriend_render, staticRenderFns: Profilefriend_staticRenderFns }
/* harmony default export */ var manage_Profilefriend = (Profilefriend_esExports);
// CONCATENATED MODULE: ./src/components/mobile/manage/Profilefriend.vue
function Profilefriend_injectStyle (ssrContext) {
  __webpack_require__("1K1W")
}
var Profilefriend_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Profilefriend___vue_template_functional__ = false
/* styles */
var Profilefriend___vue_styles__ = Profilefriend_injectStyle
/* scopeId */
var Profilefriend___vue_scopeId__ = "data-v-78b07413"
/* moduleIdentifier (server only) */
var Profilefriend___vue_module_identifier__ = null
var Profilefriend_Component = Profilefriend_normalizeComponent(
  Profilefriend,
  manage_Profilefriend,
  Profilefriend___vue_template_functional__,
  Profilefriend___vue_styles__,
  Profilefriend___vue_scopeId__,
  Profilefriend___vue_module_identifier__
)

/* harmony default export */ var mobile_manage_Profilefriend = (Profilefriend_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/manage/Qrcodepage.vue
var Qrcodepage = __webpack_require__("0p/L");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cbfbca7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/manage/Qrcodepage.vue
var Qrcodepage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('div',{},[_c('v-toolbar',{staticClass:"bg-toolbar"},[_c('v-btn',{attrs:{"color":"black","flat":"","icon":"","dark":""},on:{"click":function($event){_vm.toPage()}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"ml-0"},[_vm._v(_vm._s(_vm.$t('Settings.Qrcode.header')))])],1),_vm._v(" "),_c('v-tabs',{attrs:{"slot":"extension","fixed-tabs":"","color":"transparent","icons-and-text":"","centered":""},slot:"extension",model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider'),_vm._v(" "),_c('v-tab',{staticClass:"text-transform",attrs:{"href":"#tab-1"}},[_vm._v("\n          "+_vm._s(_vm.$t('Settings.Qrcode.myQRcode'))+"\n          "),_c('v-icon',{staticStyle:{"color":"#2562af"}},[_vm._v("fas fa-qrcode")])],1),_vm._v(" "),_c('v-tab',{staticClass:"text-transform",attrs:{"href":"#tab-2"}},[_vm._v("\n          "+_vm._s(_vm.$t('Settings.Qrcode.scanQRcode'))+"\n          "),_c('v-icon',{staticStyle:{"color":"#2562af"}},[_vm._v("mdi-qrcode-scan")])],1)],1),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"overflow-y":"scroll","height":"calc(100vh - 164px)"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{attrs:{"id":"tab-1"}},[_c('v-layout',{staticClass:"mt-3",attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('qrcode',{staticClass:"mt-3",staticStyle:{"width":"180px","height":"180px"},attrs:{"value":_vm.tokenuserQR,"id":"downloadqruser"}}),_vm._v(" "),_c('p',{staticClass:"SettingQrNote ml-4"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.detailQRcode'))+"\n            "),_c('a',{staticClass:"button",attrs:{"href":"#","id":"btn-download-user","download":'qrcode_user_' + _vm.name + '.png'},on:{"click":function($event){_vm.loadqr()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.download')))])])],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[(_vm.alert_message !== 'NotAllowedError')?_c('div',[_c('qrcode-drop-zone',{on:{"decode":_vm.onDecode,"init":_vm.logErrors}},[_c('qrcode-stream',{attrs:{"camera":_vm.camera},on:{"decode":_vm.onDecode,"init":_vm.onInit}},[_c('v-btn',{staticStyle:{"float":"right","margin-top":"40px"},attrs:{"outlined":"","fab":"","small":""},on:{"click":_vm.switchCamera}},[_c('v-icon',{staticStyle:{"color":"#2562af","font-size":"24px"}},[_vm._v("switch_camera")])],1)],1)],1),_vm._v(" "),_c('qrcode-capture',{staticStyle:{"display":"none !important"},attrs:{"multiple":false,"type":"file","name":"image","accept":"image/*","capture":"environment","id":"qrcode-capture-mobile"},on:{"decode":_vm.onDecode}})],1):_c('div',[_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('h4',[_vm._v(_vm._s(_vm.$t('Settings.Qrcode.openCamera')))]),_vm._v(" "),_c('qrcode-capture',{staticStyle:{"display":"none !important"},attrs:{"multiple":false,"type":"file","name":"image","accept":"image/*","capture":"environment","id":"qrcode-capture-mobile"},on:{"decode":_vm.onDecode}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-btn',{staticClass:"btn-upfileqrcode text-transform",on:{"click":function($event){_vm.upfileqrcode()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.selectPicture')))])],1)],1)],1),_vm._v(" "),_c('InforfriendDialogMobile',{attrs:{"inforfrienddialog":_vm.inforfrienddialog,"tokeninforfriend":_vm.tokeninforfriend,"type":_vm.type},on:{"closeInforfriend":_vm.closeInforfriend}})],1)])}
var Qrcodepage_staticRenderFns = []
var Qrcodepage_esExports = { render: Qrcodepage_render, staticRenderFns: Qrcodepage_staticRenderFns }
/* harmony default export */ var manage_Qrcodepage = (Qrcodepage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/manage/Qrcodepage.vue
function Qrcodepage_injectStyle (ssrContext) {
  __webpack_require__("nwzZ")
}
var Qrcodepage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Qrcodepage___vue_template_functional__ = false
/* styles */
var Qrcodepage___vue_styles__ = Qrcodepage_injectStyle
/* scopeId */
var Qrcodepage___vue_scopeId__ = "data-v-3cbfbca7"
/* moduleIdentifier (server only) */
var Qrcodepage___vue_module_identifier__ = null
var Qrcodepage_Component = Qrcodepage_normalizeComponent(
  Qrcodepage["a" /* default */],
  manage_Qrcodepage,
  Qrcodepage___vue_template_functional__,
  Qrcodepage___vue_styles__,
  Qrcodepage___vue_scopeId__,
  Qrcodepage___vue_module_identifier__
)

/* harmony default export */ var mobile_manage_Qrcodepage = (Qrcodepage_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-avatar-editor-improved/src/index.js
var src = __webpack_require__("yraf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/manage/Wallpaper.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var Wallpaper__ = __webpack_require__("M4fF");
/* harmony default export */ var Wallpaper = ({
  data: function data() {
    return {
      rotation: 0,
      scale: 1,
      tokenuser: '',
      tokenroom: '',
      imageData: '',
      wallpaperInfo: {
        info: [{
          room: '',
          background: ''
        }]
      },
      check: false,
      img: 'https://image.flaticon.com/icons/png/512/118/118246.png',
      canvasWidth: 0,
      canvasHeight: 0
    };
  },

  components: {
    VueAvatar: src["a" /* VueAvatar */],
    vue100vh: vue100vh["a" /* default */]
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {
    '$route.params.roomid': function $routeParamsRoomid() {
      var canvas = document.getElementById('avatarEditorCanvas');
      var context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      if (JSON.parse(localStorage.getItem('wallpaperInfo')) === null) {
        localStorage.setItem('wallpaperInfo', stringify_default()(this.wallpaperInfo));
      }
    }
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    this.tokenroom = this.$route.params.roomid;
  },

  methods: {
    resetbg: function resetbg() {
      var _this = this;

      this.$swal({
        type: 'warning',
        text: this.$t('Alert.Right.removeWallpaper'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#999999',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          var wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
          var room = _this.$route.params.roomid;
          var index = Wallpaper__.findIndex(wallpaper.info, function (o) {
            return o.room === room;
          });
          wallpaper.info.splice(index, 1);
          localStorage.setItem('wallpaperInfo', stringify_default()(wallpaper));
          _this.$swal('', _this.$t('Alert.Success.deletebackground'), 'success');
          _this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
          _this.closeDialog();
        }
      });
    },
    saveClicked: function saveClicked() {
      var vm = this;
      var canvas = this.$refs.vueavatar.getImageScaled();
      canvas.toBlob(function (blob) {
        var reader = new FileReader();
        reader.onload = function (e) {
          vm.imageData = e.target.result;
          vm.setbg(vm.imageData);
        };
        reader.readAsDataURL(blob);
      });
    },
    onImageReady: function onImageReady() {
      // var canvas = document.getElementById('avatarEditorCanvas')
      // var context = canvas.getContext('2d')
      // context.clearRect(0, 0, canvas.width, canvas.height)
      this.check = true;
      this.scale = 1;
      this.rotation = 0;
    },
    setbg: function setbg(img) {
      this.imageData = img;
      var wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
      var room = this.$route.params.roomid;
      var index = Wallpaper__.findIndex(wallpaper.info, function (o) {
        return o.room === room;
      });
      if (index === -1) {
        wallpaper.info.push({
          room: this.$route.params.roomid,
          background: this.imageData
        });
        localStorage.setItem('wallpaperInfo', stringify_default()(wallpaper));
      } else {
        wallpaper.info.splice(index, 1);
        wallpaper.info.push({
          room: this.$route.params.roomid,
          background: this.imageData
        });
        localStorage.setItem('wallpaperInfo', stringify_default()(wallpaper));
      }
      this.imageData = '';
      this.$swal('', this.$t('Alert.Success.setbackground'), 'success');
      // this.closeDialog()
      this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
      this.$router.push('/mobile/room/' + this.$route.params.roomid);
    },
    closeDialog: function closeDialog() {
      // console.log(this.imageData)
      // this.canvasWidth = 0
      // this.canvasHeight = 0
      var canvas = document.getElementById('avatarEditorCanvas');
      var context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      this.$refs.vueavatar.state.image.resource = null;
      this.check = false;
      this.scale = 1;
      this.rotation = 0;
      this.imageData = '';
      this.$emit('closeWallpaper', false);
    },
    toPage: function toPage() {
      // this.$router.go(-1)
      this.$router.push('/mobile/room/' + this.$route.params.roomid);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9fffd6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/manage/Wallpaper.vue
var Wallpaper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('div',{staticClass:"CSChatThai BGwhite"},[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage()}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('Dialog.wallpaper.headerWallpaper')))])],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"overflow-y":"scroll","height":"calc(100vh - 128px)","overflow-x":"hidden"}},[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('vue-avatar',{ref:"vueavatar",staticStyle:{"border":"solid thin #eee","height":"300px","margin-bottom":"10px","background-size":"100px, 100px, cover","background-position":"center"},attrs:{"image":_vm.imageData,"width":450,"height":450,"rotation":_vm.rotation,"scale":_vm.scale,"border":0},on:{"vue-avatar-editor:image-ready":_vm.onImageReady}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-slider',{attrs:{"label":"Zoom :","min":"1","max":"3","step":"0.02","thumb-label":"always","ticks":""},model:{value:(_vm.scale),callback:function ($$v) {_vm.scale=$$v},expression:"scale"}}),_vm._v(" "),_c('v-slider',{attrs:{"label":"Rotation :","min":"0","max":"360","step":"1","thumb-label":"always","ticks":""},model:{value:(_vm.rotation),callback:function ($$v) {_vm.rotation=$$v},expression:"rotation"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"btnwallpaper text-transform",attrs:{"disabled":!_vm.check},on:{"click":function($event){_vm.saveClicked()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.setbackground')))]),_vm._v(" "),_c('v-btn',{staticClass:"btnresetwallpaper text-transform",on:{"click":function($event){_vm.resetbg()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.resetbackground')))])],1)],1)],1)],1)])}
var Wallpaper_staticRenderFns = []
var Wallpaper_esExports = { render: Wallpaper_render, staticRenderFns: Wallpaper_staticRenderFns }
/* harmony default export */ var manage_Wallpaper = (Wallpaper_esExports);
// CONCATENATED MODULE: ./src/components/mobile/manage/Wallpaper.vue
function Wallpaper_injectStyle (ssrContext) {
  __webpack_require__("y86/")
}
var Wallpaper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Wallpaper___vue_template_functional__ = false
/* styles */
var Wallpaper___vue_styles__ = Wallpaper_injectStyle
/* scopeId */
var Wallpaper___vue_scopeId__ = "data-v-f9fffd6e"
/* moduleIdentifier (server only) */
var Wallpaper___vue_module_identifier__ = null
var Wallpaper_Component = Wallpaper_normalizeComponent(
  Wallpaper,
  manage_Wallpaper,
  Wallpaper___vue_template_functional__,
  Wallpaper___vue_styles__,
  Wallpaper___vue_scopeId__,
  Wallpaper___vue_module_identifier__
)

/* harmony default export */ var mobile_manage_Wallpaper = (Wallpaper_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/layout/ProgressLayout.vue
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ProgressLayout = ({
  mixins: [vue_screen_size_esm["a" /* default */].VueScreenSizeMixin],
  components: {
    VueScreenSize: vue_screen_size_esm["a" /* default */]
  },
  data: function data() {
    return {
      progress: true
    };
  },
  mounted: function mounted() {
    var me = this;
    setInterval(function () {
      // console.log('update tokenuser')
      // console.log(this.$vssHeight)
      if (window.innerWidth < 960) {
        if (window.location.pathname === '/mobile/progress/' + me.$route.params.roomid) {
          me.$router.push('/mobile/room/' + me.$route.params.roomid);
        }
      } else {
        if (window.location.pathname === '/mobile/progress/' + me.$route.params.roomid) {
          me.$router.push('/chat/room/' + me.$route.params.roomid);
        }
      }
    }, 4000);
  },
  created: function created() {
    this.progress = true;
    // var me = this
    // setInterval(function () {
    //   if (window.innerWidth < 960) {
    //     if (window.location.pathname === '/mobile/progress/' + me.$route.params.roomid) {
    //       me.$router.push('/mobile/room/' + me.$route.params.roomid)
    //     }
    //   } else {
    //     if (window.location.pathname === '/mobile/progress/' + me.$route.params.roomid) {
    //       me.$router.push('/chat/room/' + me.$route.params.roomid)
    //     }
    //   }
    // }, 3000);
  },

  watch: {
    '$vssHeight': function $vssHeight() {
      // console.log(this.$vssHeight)
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b382742","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/layout/ProgressLayout.vue
var ProgressLayout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh"}},[_c('v-layout',{staticStyle:{"height":"100vh"},attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"width":8,"size":"90","color":"primary","indeterminate":_vm.progress}})],1)],1)}
var ProgressLayout_staticRenderFns = []
var ProgressLayout_esExports = { render: ProgressLayout_render, staticRenderFns: ProgressLayout_staticRenderFns }
/* harmony default export */ var layout_ProgressLayout = (ProgressLayout_esExports);
// CONCATENATED MODULE: ./src/components/mobile/layout/ProgressLayout.vue
function ProgressLayout_injectStyle (ssrContext) {
  __webpack_require__("sfrc")
}
var ProgressLayout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ProgressLayout___vue_template_functional__ = false
/* styles */
var ProgressLayout___vue_styles__ = ProgressLayout_injectStyle
/* scopeId */
var ProgressLayout___vue_scopeId__ = "data-v-5b382742"
/* moduleIdentifier (server only) */
var ProgressLayout___vue_module_identifier__ = null
var ProgressLayout_Component = ProgressLayout_normalizeComponent(
  ProgressLayout,
  layout_ProgressLayout,
  ProgressLayout___vue_template_functional__,
  ProgressLayout___vue_styles__,
  ProgressLayout___vue_scopeId__,
  ProgressLayout___vue_module_identifier__
)

/* harmony default export */ var mobile_layout_ProgressLayout = (ProgressLayout_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/redirecttest.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var redirecttest = ({
  created: function created() {
    // this.$router.push('/not_found')
    window.location.replace('onechat://com.oneplatform/xxxx');
    // if (this.$route.params.type === 'friend' || this.$route.params.type === 'group') {
    //   window.location.replace('onechat://com.oneplatform/qrcode/' + this.$route.params.type + '?id=' + this.$route.query.id)
    // } else {
    //   this.$router.push('/not_found')
    // }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d84dabea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/redirecttest.vue
var redirecttest_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-parallax',{staticStyle:{"background-color":"white","height":"100vh"},attrs:{"dark":"","id":"home"}},[_c('div',{staticClass:"text hidden-sm-and-down"},[_c('v-layout',{attrs:{"align-center":"","row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticStyle:{"justify-content":"right","display":"grid"},attrs:{"xs5":"","sm5":"","md5":"","xl5":"","lg5":""}},[_c('img',{staticStyle:{"height":"70vh"},attrs:{"src":"/static/img/onechat/banner-homepage.jpg"}})]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"4vh"},attrs:{"xs7":"","sm7":"","md7":"","xl7":"","lg7":""}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"4vh"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('img',{staticStyle:{"height":"100px","justify-content":"right"},attrs:{"src":"/static/img/icons/logoonechat_full.png"}})]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"4vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('h1',[_vm._v("ร่วมเป็นส่วนหนึ่งกับพวกเรา One Chat")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"4vh"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-btn',{staticClass:"buttonblue",on:{"click":function($event){_vm.toPage('/register')}}},[_vm._v("สมัครสมาชิก")]),_vm._v(" "),_c('v-btn',{staticClass:"buttonblue",on:{"click":function($event){_vm.toPage('/download')}}},[_vm._v("ดาวน์โหลด")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"textmo hidden-md-and-up"},[_c('v-layout',{attrs:{"align-center":"","column":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('img',{staticStyle:{"height":"30vh","justify-content":"right"},attrs:{"src":"/static/img/onechat/banner-homepage.jpg"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3vh"},attrs:{"xs12":"","sm12":""}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('v-flex',{staticStyle:{"margin-top":"1vh","color":"black"},attrs:{"xs12":"","sm12":""}},[_c('h3',[_vm._v("ร่วมเป็นส่วนหนึ่งกับพวกเรา")])])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"1vh"},attrs:{"xs12":"","sm12":""}},[_c('v-layout',{attrs:{"align-center":"","row":"","wrap":"","justify-center":""}},[_c('v-btn',{staticClass:"buttonblue",staticStyle:{"width":"40%"},on:{"click":function($event){_vm.toPage('/register')}}},[_vm._v("สมัครสมาชิก")]),_vm._v(" "),_c('v-btn',{staticClass:"buttonblue",staticStyle:{"width":"40%"},on:{"click":function($event){_vm.toPage('/download')}}},[_vm._v("ดาวน์โหลด")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"footer hidden-sm-and-down"},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/about')}}},[_vm._v("เกี่ยวกับเรา")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toNewTab('https://chat-develop.one.th/docs')}}},[_vm._v("API")])])]),_vm._v(" "),_c('p',{staticStyle:{"padding-left":"20px","padding-right":"20px","color":"black"}},[_c('b',[_vm._v("© "+_vm._s(new Date().getFullYear())+" One Centric Company Limited")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบาย")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"5px"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/contactus')}}},[_vm._v("ติดต่อเรา")])])])])],1),_vm._v(" "),_c('div',{staticClass:"footer hidden-md-and-up"},[(_vm.snackbar === true)?_c('v-layout',{staticStyle:{"margin-bottom":"9vh"},attrs:{"align-center":"","column":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/about')}}},[_vm._v("เกี่ยวกับเรา")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toNewTab('https://chat-develop.one.th/docs')}}},[_vm._v("API")]),_vm._v(" |")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบาย")]),_vm._v(" |")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/contactus')}}},[_vm._v("ติดต่อเรา")])])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('p',{staticStyle:{"padding-left":"20px","padding-right":"20px","color":"black !important"}},[_c('b',[_vm._v("© "+_vm._s(new Date().getFullYear())+" One Centric Company Limited")])])])],1):_c('v-layout',{staticStyle:{"margin-bottom":"0vh"},attrs:{"align-center":"","column":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black !important"},on:{"click":function($event){_vm.toPage('/about')}}},[_vm._v("เกี่ยวกับเรา")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black !important"},on:{"click":function($event){_vm.toNewTab('https://chat-develop.one.th/docs')}}},[_vm._v("API")]),_vm._v(" |")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black !important"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบาย")]),_vm._v(" |")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black !important"},on:{"click":function($event){_vm.toPage('/contactus')}}},[_vm._v("ติดต่อเรา")])])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('p',{staticStyle:{"padding-left":"20px","color":"black","padding-right":"20px"}},[_c('b',[_vm._v("© "+_vm._s(new Date().getFullYear())+" One Centric Company Limited")])])])],1),_vm._v(" "),(_vm.snackbar)?_c('v-flex',{staticClass:"CSChatThai",staticStyle:{"background":"#414141","margin":"0","bottom":"0px","position":"fixed","width":"100%","height":"12vh","padding":"5px !important"},attrs:{"xs12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-flex',{attrs:{"xs2":"","md2":""}},[_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){_vm.closedownload()}}},[_c('v-icon',{staticStyle:{"font-size":"18px !important"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","md5":""}},[_vm._v("\n            "+_vm._s(_vm.textsnackbar)+"\n          ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","md5":""}},[(_vm.deviceos === 'ios')?_c('v-btn',{attrs:{"color":"info","drak":""},on:{"click":function($event){_vm.downloadios()}}},[_vm._v("ดาวน์โหลด")]):_c('v-btn',{attrs:{"color":"info","drak":""},on:{"click":function($event){_vm.downloadandroid()}}},[_vm._v("ดาวน์โหลด")])],1)],1)],1):_vm._e()],1)])],1)}
var redirecttest_staticRenderFns = []
var redirecttest_esExports = { render: redirecttest_render, staticRenderFns: redirecttest_staticRenderFns }
/* harmony default export */ var components_redirecttest = (redirecttest_esExports);
// CONCATENATED MODULE: ./src/components/redirecttest.vue
function redirecttest_injectStyle (ssrContext) {
  __webpack_require__("RG12")
}
var redirecttest_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var redirecttest___vue_template_functional__ = false
/* styles */
var redirecttest___vue_styles__ = redirecttest_injectStyle
/* scopeId */
var redirecttest___vue_scopeId__ = "data-v-d84dabea"
/* moduleIdentifier (server only) */
var redirecttest___vue_module_identifier__ = null
var redirecttest_Component = redirecttest_normalizeComponent(
  redirecttest,
  components_redirecttest,
  redirecttest___vue_template_functional__,
  redirecttest___vue_styles__,
  redirecttest___vue_scopeId__,
  redirecttest___vue_module_identifier__
)

/* harmony default export */ var src_components_redirecttest = (redirecttest_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/authenCallbackOneid.vue


//
//
//
//
//
//
//
//
//
//
//
//





// import NewFooter from '@/components/home/NewFooter'
// import Vue from 'vue'


// import VueSocketio from 'vue-socket.io'
var authenCallbackOneid__ = __webpack_require__("M4fF");
var authenCallbackOneid_Centrifuge = __webpack_require__("9wbP");
var authenCallbackOneid_centrifuge = new authenCallbackOneid_Centrifuge("wss://uatchat-manage.one.th/connection/websocket");
/* harmony default export */ var authenCallbackOneid = ({
  data: function data() {
    return {
      newConsentDialog: false,
      newConsentDetail: {},
      url_consent: '',
      consentOnechatDialog: false,
      progress: true,
      code: '',
      status: '',
      passlogin: ''
    };
  },

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  created: function created() {
    this.code = this.$route.query.code;
    // this.passlogin = this.$route.query.passlogin
    // if(this.passlogin) {
    // this.getcode()
    if (this.code) {
      this.getcode();
    } else {
      console.log('error: access_denied');
      // https://chat.one.th/login
      this.$router.push('/login');
    }
    // }
  },

  // mounted () {
  //   this.code = this.$route.query.code
  //   console.log('mounted authen')
  //   if (this.code) {
  //     this.getcode()
  //   } else {
  //     console.log('error: access_denied')
  //     this.$router.push('/login')
  //   }
  // },
  methods: {
    closeNewConsent: function closeNewConsent(value) {
      console.log("close new consent", value);
      this.newConsentDialog = value.close;
      this.newConsentDetail = {};
      // set localStorage authorization
      this.progress = true;
      localStorage.setItem('Authenrization', services["b" /* Encode */].encode({ 'tokenuser': value.token, 'status_login': 'T', 'type_user': 'user' }));
      if (localStorage.getItem('botid_redirect') !== null) {
        this.progress = false;
        this.searchFriend(localStorage.getItem('botid_redirect'));
      } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
        this.progress = false;
        // redirect bot room with url
        var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
        this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + '&url=' + data.url);
      } else {
        this.progress = false;
        // console.log(`this.isMobile(): ${this.isMobile()}`)
        if (window.innerWidth <= 960) {
          this.$router.push('/mobile/homepage');
        } else {
          this.$router.push('/chat');
        }
      }
    },
    closeDialogConsentOnechat: function closeDialogConsentOnechat(value) {
      this.consentOnechatDialog = value;
    },
    connectCentrifuge: function connectCentrifuge(token) {
      var me = this;
      var events = '';
      var data_msg = '';
      authenCallbackOneid_centrifuge.setToken('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs');
      authenCallbackOneid_centrifuge.subscribe(token, function (message) {
        console.log(message.data.event);
        events = message.data.event;
        if (events === 'consent') {
          // consent close dialog
          me.consentOnechatDialog = false;
          me.getOnechatToken(token);
        }
      });
      authenCallbackOneid_centrifuge.on('connect', function () {
        console.log("connected centrifuge authen login");
      });
      authenCallbackOneid_centrifuge.on('disconnect', function () {
        console.log("disconnected centrifuge authen login");
      });
      authenCallbackOneid_centrifuge.connect();
    },
    getOnechatToken: function getOnechatToken(token) {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var hour = String(today.getHours() + 1).padStart(2, '0');
      var minute = String(today.getMinutes()).padStart(2, '0');
      var seconds = String(today.getSeconds()).padStart(2, '0');
      var milsec = today.getMilliseconds();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00';
        dd = String(today.getDate() + 1).padStart(2, '0');
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1';
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1';
            yyyy = today.getFullYear() + 1;
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0');
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
      // console.log(today)
      var expireddate = Date.parse(today);
      // console.log(expireddate)
      var body = services["b" /* Encode */].encodeRichmenu({ 'userid': token, 'expired_date': expireddate });
      // console.log(body)
      // console.log(body.split('=')[1]);

      // check new consent
      if (this.$cookie.get('check-consent-' + token) === null || this.$cookie.get('check-consent-' + token) === undefined) {
        // test new consent
        this.progress = false;
        this.newConsentDialog = true;
        this.newConsentDetail = { token: token };
      } else {
        this.progress = false;
        // set localStorage authorization
        localStorage.setItem('Authenrization', services["b" /* Encode */].encode({ 'tokenuser': token, 'status_login': 'T', 'type_user': 'user' }));
        if (localStorage.getItem('botid_redirect') !== null) {
          this.searchFriend(localStorage.getItem('botid_redirect'));
        } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
          // redirect bot room with url
          var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
          this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + '&url=' + data.url);
        } else {
          // console.log(`this.isMobile(): ${this.isMobile()}`)
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage');
          } else {
            this.$router.push('/chat');
          }
        }
      }

      // this.axios.post(process.env.APIgo_api + `/v1/get-consent`, { onechat_token: body }).then((response) => {
      //   // console.log(response.data)
      //   if (response.data.status === 'success') {
      //     this.progress = false
      //     if (response.data.data.consent_check === 'true') {
      //       this.progress = false
      //       // set localStorage authorization
      //       localStorage.setItem('Authenrization', Encode.encode({'tokenuser': token, 'status_login': 'T', 'type_user': 'user'}))
      //       if (localStorage.getItem('botid_redirect') !== null) {
      //         this.searchFriend(localStorage.getItem('botid_redirect'))
      //       } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
      //         // redirect bot room with url
      //         var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
      //         this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
      //       } else {
      //         if (window.innerWidth <= 960) {
      //           this.$router.push('/mobile/homepage')
      //         } else {
      //           this.$router.push('/chat')
      //         }
      //       }
      //     } else {
      //       // show dialog consent
      //       this.consentOnechatDialog = true
      //       this.url_consent = response.data.data.consent_url
      //       // clear localStorage autherization
      //       localStorage.removeItem('Authenrization')
      //     }
      //   }
      // }).catch(err => {
      //   console.log(err)
      //   this.progress = false
      // })
    },
    getcode: function getcode() {
      var _this = this;

      this.progress = true;
      var source = {
        'code': this.code,
        'redirect_uri': "https://uatchat.one.th/authorization/redirect"
        // var source = {
        //   'code': this.code
        // }
      };var addyear = 10;
      var newDate = new Date();
      newDate.setTime(newDate.getTime() + addyear * 365 * 24 * 60 * 60 * 1000);
      var expiresInTime = "expires=" + newDate.toUTCString();
      // /v2/authorization_code
      this.axios.post("https://uatchat-manage.one.th/manage" + '/v2/authorization_code', source).then(function (response) {
        _this.status = response.data['status'];
        _this.progress = false;
        if (_this.status === 'success') {
          var profile = response.data['account']['profile'];
          _this.myprofilepicture = profile['profilepicture'];
          _this.myname = profile['name'];
          // this.$cookie.set('status_login', 'T')
          // this.$cookie.set('tokenuser', Encode.encodeToken(profile['tokenuser']))
          // this.$cookie.set('language', 'th')
          _this.$i18n.locale = _this.$cookie.get('language') ? _this.$cookie.get('language') : 'th';
          // document.cookie = "status_login=T;" + expiresInTime + ";"
          // document.cookie = "tokenuser=" + Encode.encodeToken(profile['tokenuser']) + ";" + expiresInTime + ";"
          // document.cookie = "language=th;" + expiresInTime + ";"
          localStorage.setItem('Authenrization', services["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
          localStorage.setItem('profilepicture', profile['profilepicture']);
          localStorage.setItem('name', profile['name']);
          localStorage.setItem('phone', profile['phone']);
          localStorage.setItem('email', profile['email']);
          localStorage.setItem('status', profile['status']);
          localStorage.setItem('type_user', profile['type']);
          localStorage.setItem('wallpaperInfo', stringify_default()({
            'info': [{
              'room': '',
              'background': ''
            }]
          }));
          _this.progress = false;
          // connect centrifuge
          _this.connectCentrifuge(profile['tokenuser']);
          if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
            _this.getOnechatToken(profile['tokenuser']);
            // if (localStorage.getItem('botid_redirect') !== null) {
            //   this.searchFriend(localStorage.getItem('botid_redirect'))
            // } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
            //   // redirect bot room with url
            //   var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
            //   this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
            // } else {
            //   if (window.innerWidth <= 960) {
            //     this.$router.push('/mobile/homepage')
            //   } else {
            //     this.$router.push('/chat')
            //   }
            // }
          } else {
            _this.$router.push(localStorage.getItem('pathRoom'));
          }
        } else {
          _this.$cookie.set('status_login', 'F');
          // document.cookie = "status_login=F;" + expiresInTime + ";"
          _this.progress = false;
          if (response.data['message'] === 'The request is missing a required parameter, includes an invalid parameter value, includes a parameter more than once, or is otherwise malformed.') {
            // var token = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))['tokenuser']
            // this.connectCentrifuge(token)
            // this.getOnechatToken(token)
            _this.logout();
          } else {
            _this.$router.push('/not_found');
          }
          // if (response.data['message'] === 'Wrong Username / Password') {
          //   this.failmessage = 'ชื่อผู้ใช้งานหรือรหัสผ่านผิด กรุณาตรวจสอบใหม่อีกครั้ง.'
          // } else {
          //   this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
          // }
        }
      }, function (error) {
        console.log(error);
        _this.status = 'fail';
        _this.progress = false;
        _this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.';
      });
    },
    logout: function logout() {
      localStorage.clear();
      var logouturl = this.$cookie.get('logouturl');
      if (true) {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent');
          this.$cookie.delete('logouturl');
        } else {
          window.open("https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage", '_parent');
        }
      } else {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent');
          this.$cookie.delete('logouturl');
        } else {
          this.$router.push({ path: '/login', force: true });
        }
      }
    },
    searchFriend: function searchFriend(botid) {
      var _this2 = this;

      var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend", {
        tokenbot: botid,
        tokenuser: decoded.tokenuser
      }).then(function (response) {
        // console.log(response.data.listuser)
        if (response.data.listuser.length === 0) {
          localStorage.removeItem('botid_redirect');
          if (window.innerWidth <= 960) {
            _this2.$router.push('/mobile/homepage');
          } else {
            _this2.$router.push('/chat');
          }
        } else {
          if (response.data.listuser.relation === 'friend') {
            localStorage.removeItem('botid_redirect');
            if (window.innerWidth <= 960) {
              _this2.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom);
            } else {
              _this2.$router.push('/chat/room/' + response.data.listuser.user.tokenroom);
            }
          } else {
            console.log('not friend');
            _this2.$router.push('/addbot/' + localStorage.getItem('botid_redirect'));
          }
        }
      }).catch(function (error) {
        console.log(error);
        localStorage.removeItem('botid_redirect');
        if (window.innerWidth <= 960) {
          _this2.$router.push('/mobile/homepage');
        } else {
          _this2.$router.push('/chat');
        }
      });
    }
  },
  components: {
    Navbar: Navbar["a" /* default */],
    checkconsentOnechatDialog: consent_onechat_dialog["a" /* default */],
    newConsent: new_consent["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-152ce54a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/authenCallbackOneid.vue
var authenCallbackOneid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"CSChatThai",staticStyle:{"overflow-y":"hidden","background":"white"},attrs:{"id":"inspire"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(_vm.progress)?_c('v-progress-circular',{staticStyle:{"margin":"auto"},attrs:{"size":250,"width":10,"indeterminate":"","color":"blue"}}):_vm._e(),_vm._v(" "),_c('checkconsentOnechatDialog',{attrs:{"url_consent":_vm.url_consent,"consentOnechatDialog":_vm.consentOnechatDialog},on:{"closeDialogConsentOnechat":_vm.closeDialogConsentOnechat}}),_vm._v(" "),_c('newConsent',{attrs:{"newConsentDialog":_vm.newConsentDialog,"newConsentDetail":_vm.newConsentDetail},on:{"closeNewConsent":_vm.closeNewConsent}})],1)],1)}
var authenCallbackOneid_staticRenderFns = []
var authenCallbackOneid_esExports = { render: authenCallbackOneid_render, staticRenderFns: authenCallbackOneid_staticRenderFns }
/* harmony default export */ var components_authenCallbackOneid = (authenCallbackOneid_esExports);
// CONCATENATED MODULE: ./src/components/authenCallbackOneid.vue
function authenCallbackOneid_injectStyle (ssrContext) {
  __webpack_require__("lNvL")
}
var authenCallbackOneid_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var authenCallbackOneid___vue_template_functional__ = false
/* styles */
var authenCallbackOneid___vue_styles__ = authenCallbackOneid_injectStyle
/* scopeId */
var authenCallbackOneid___vue_scopeId__ = "data-v-152ce54a"
/* moduleIdentifier (server only) */
var authenCallbackOneid___vue_module_identifier__ = null
var authenCallbackOneid_Component = authenCallbackOneid_normalizeComponent(
  authenCallbackOneid,
  components_authenCallbackOneid,
  authenCallbackOneid___vue_template_functional__,
  authenCallbackOneid___vue_styles__,
  authenCallbackOneid___vue_scopeId__,
  authenCallbackOneid___vue_module_identifier__
)

/* harmony default export */ var src_components_authenCallbackOneid = (authenCallbackOneid_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/test.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import LinkPrevue from 'link-prevue'
var test_moment = __webpack_require__("PJh5");

/* harmony default export */ var components_test = ({
  data: function data() {
    return {
      localtz: '',
      date: '',
      time: ''
    };
  },
  components: {
    // LinkPrevue
  },
  created: function created() {
    this.time = test_moment().toDate().getTime();
    this.localtz = test_moment.tz.guess(); // user's timezone
    this.date = test_moment(this.time).tz(this.localtz).lang('th').format('LT');
  },

  methods: {
    // convert(msg) {
    //   var linkifyStr = require('linkifyjs/string')
    //   var str = msg
    //   var processedContent = linkifyStr(str)
    //   return processedContent
    // },
    // convertURL (msg) {
    //   var urlRegex = /\bhttps?:\/\/\S+/gi;
    //   if (msg.match(urlRegex) !== null) {
    //     if (msg.match(urlRegex).length !== 0 ) {
    //       return msg.match(urlRegex)[0]
    //     }
    //     return ''
    //   } else {
    //     return ''
    //   }
    //   // console.log(msg.match(urlRegex) !== null);
    // }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98dba2e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/test.vue
var test_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"overflow":"hidden !important"},attrs:{"row":"","wrap":""}},[_vm._v("\n\n  test- "+_vm._s(_vm.localtz)+"- "+_vm._s(_vm.date)+" - "+_vm._s(_vm.time)+"\n \n")])}
var test_staticRenderFns = []
var test_esExports = { render: test_render, staticRenderFns: test_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_test = (test_esExports);
// CONCATENATED MODULE: ./src/components/test.vue
function test_injectStyle (ssrContext) {
  __webpack_require__("ACpf")
}
var test_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var test___vue_template_functional__ = false
/* styles */
var test___vue_styles__ = test_injectStyle
/* scopeId */
var test___vue_scopeId__ = "data-v-98dba2e0"
/* moduleIdentifier (server only) */
var test___vue_module_identifier__ = null
var test_Component = test_normalizeComponent(
  components_test,
  selectortype_template_index_0_src_components_test,
  test___vue_template_functional__,
  test___vue_styles__,
  test___vue_scopeId__,
  test___vue_module_identifier__
)

/* harmony default export */ var src_components_test = (test_Component.exports);

// EXTERNAL MODULE: ./node_modules/link-prevue/dist/link-prevue.umd.min.js
var link_prevue_umd_min = __webpack_require__("mo46");
var link_prevue_umd_min_default = /*#__PURE__*/__webpack_require__.n(link_prevue_umd_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/test2.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import AddDialog from '@/components/chat/dialog/manage_friend/AddFriendDialog'




// import vueHeadful from 'vue-headful'
//
// Vue.component('vue-headful', vueHeadful)
var test2__ = __webpack_require__("M4fF");
// import VueTrix from "vue-trix"

/* harmony default export */ var test2 = ({
  props: {
    'dialogGroup': false
  },
  data: function data() {
    return {
      url_test: 'https://testchat.one.th/test2',
      url: "https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect",
      news: {
        "id": 105,
        "companyname": "กฟผ. การไฟฟ้าฝ่ายผลิต",
        "headannounces": "ข่าวใหม่",
        "imagesurl": "https://services.thaijobjob.com/thai/assets/images/brand_logo/set2.png",
        "opendate": "2020-08-16T22:44:07.238303Z",
        "closedate": "2020-10-16T22:44:07.238303Z",
        "createat": "2020-08-25T06:37:51Z",
        "urlannounces": "https://www.egat.co.th/index.php",
        "nametypejob": "งานรัฐวิสาหกิจ",
        "typenameid": 0,
        "imagecompany": "https://www.jobbkk.com/upload/variety/goverment/20160627_3453.png"
      }
    };
  },
  mounted: function mounted() {
    // this.createFirst()
  },

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  created: function created() {
    console.log(this.url);
    console.log(this.news);
    this.test_plugin();
  },

  components: {
    // VueTrix
    LinkPrevue: link_prevue_umd_min_default.a
  },
  methods: {
    test_plugin: function test_plugin() {
      var bot_id = 'Bc020e95179a450548a3c1905d2280f15';
      var div_chatbot = document.createElement('div');
      document.getElementsByTagName('body')[0].appendChild(div_chatbot);
      div_chatbot.outerHTML = "<div id='botChat' style='border-radius: 10px; position: absolute;margin-top: 0px; margin-right: 0px; margin-bottom: 0px; padding: 0px; border: 0px; background: transparent; overflow: hidden; position: fixed; z-index: 16000004; left: 10px; bottom: 10px;display: none; width: 290px; height: 425px; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 3px 2px;'><div id='botTitleBar' style='z-index: 16000005;height: 27px; width: 380px; position:fixed; cursor: pointer; border-top-left-radius: 10px; border-top-right-radius: 10px;'></div><iframe frameborder='0' style='background-color: transparent; vertical-align: text-bottom; position: relative; width: 100%; height: 100%; min-width: 100%; min-height: 100%; max-width: 100%; max-height: 100%; margin: 0px; overflow: hidden; display: block;'src='https://chat.one.th/chatplugin/register/chatme/" + bot_id + "'></iframe></div><div id='minBotChat' style='border-radius: 10px;margin-top: 0px; margin-right: 0px; margin-bottom: 0px; padding: 0px; border: 0px; background: transparent;position: fixed; z-index: 16000002; width: 100px; height: 100px; left: 10px; bottom: 15px;'><div id='minBotChatTitle' style='z-index: 16000003;height: 100px; width: 100px; position:fixed; cursor: pointer;'></div><iframe id='iconweb' frameborder='0' style='background-color: transparent; vertical-align: text-bottom; position: relative; width: 100%; height: 100%; min-width: 100%; min-height: 100%; max-width: 100%; max-height: 100%; margin: 0px; overflow: hidden; display: block;' src='https://chat.one.th/chatplugin/minchat/chatme/" + bot_id + "'></iframe></div>";
      document.querySelector('body').addEventListener('click', function (e) {
        e.target.matches = e.target.matches || e.target.msMatchesSelector;
        if (e.target.matches('#botTitleBar')) {
          document.getElementById("botChat").style.display = "none";
          document.getElementById("minBotChat").style.display = "block";
        } else if (e.target.matches('#minBotChatTitle')) {
          document.getElementById("botChat").style.display = "block";
          document.getElementById("minBotChat").style.display = "none";
        }
      });
    },
    onClick: function onClick(prevue) {
      console.log('click', prevue.images, prevue.title, prevue.url, prevue.description);
    },
    Share_FB: function Share_FB() {
      var id = 'https://testchat.one.th/test2';
      FB.ui({
        method: 'share',
        href: id
      }, function (response) {
        console.log(response);
      });
      // FB.ui({
      //   method: 'share',
      //   href: id,
      //   action_type: 'og.shares',
      //   action_properties: JSON.stringify({
      //     object: {
      //       'og:url': id,
      //       'og:title': this.news.headannounces,
      //       'og:image:width': 476,
      //       'og:image:height': 476,
      //       'og:image:url': this.news.imagesurl
      //     }
      //   })
      // }, function (response) {
      //   console.log(response)
      // })
    },
    convertURL: function convertURL(msg) {
      var urlRegex = /\bhttps?:\/\/\S+/gi;
      var linkmsg = msg.match(urlRegex);
      if (linkmsg !== null) {
        if (linkmsg.length !== 0) {
          // console.log(linkmsg.slice(0,5))
          linkmsg.length = 1;
          return linkmsg;
        }
        return '';
      } else {
        return '';
      }
      // console.log(msg.match(urlRegex) !== null);
    },
    changeLan: function changeLan() {
      // window.location.replace("http://www.w3schools.com")
      // this.$i18n.locale = 'en'
      // window.open('/chat/room/R5e174d3e1e8c15002c7b208f3d35a5cb64525ef29e9687d60245b937', '_parent').focus()
    },
    redirectUrl: function redirectUrl(url) {
      var link = document.getElementById("iframename").contentWindow.location.href;
      // console.log(link)
      // console.log(_.includes(link, [process.env.redirect_url]))
      if (test2__.includes(link, ["https://uatchat.one.th/authorization/redirect"])) {
        window.open(link, '_parent');
      }
      // window.open(url,'_parent')
    }
    // createFirst () {
    //   console.log('createFirst')
    //   this.iframe = document.getElementById('my_iframe').contentWindow.document;
    //   // this.iframe = document.getElementById("my_iframe").contentDocument.getElementById("iframe_div").innerHTML
    //   var url = 'https://one.th'
    //   var header = {Authorization:'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiIyZGY4Mzk0Ni1iNDM1LTQ1YWYtYmFmMi03OWM0MzEzOGYzNDAiLCJyb2xlIjoic3VwZXJhZG1pbiIsImNvbXBhbnlfaWQiOiI4N2QxOTEyNy0wZTA1LTQ2OWMtOTZiYS1lYjAyYzUxODRhNmMiLCJjcmVhdGVfYXQiOjE1ODIyMTkzODM2OTcsImlhdCI6MTU4MjIxOTM4M30.e1XPh4QJSsaId3hQSog5J8Gna-Vbtg25Eiju3dCsBhU'}
    //   // this.axios.get(url, {headers:header}).then((response) => {
    //   //       iframe.write(response.data);
    //   //   }.catch((error) => {
    //   //       console.log(error);
    //   //   })
    //   this.axios.get(url).then((response) => {
    //     console.log(response.data)
    //     this.iframe.write(response.data)
    //   })
    // }

  }
  // created () {
  //   // // this.token = Decode.decodeToken(localStorage.getItem('tokenuser'))
  //   // this.token = Decode.decodeToken(this.$cookie.get('tokenuser'))
  //   // // this.sender = localStorage.getItem('email')
  //   // this.getlistfriend()
  // }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03c14fc1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/test2.vue
var test2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container fluid"},[_c('iframe',{attrs:{"src":_vm.url,"id":"iframename","width":"500","height":"550"},on:{"load":function($event){_vm.redirectUrl('Test');}}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.Share_FB()}}},[_vm._v("text")]),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.news.headannounces,"description":_vm.news.companyname,"url":_vm.url_test,"image":_vm.news.imagesurl}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.news.companyname))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.news.imagesurl,"alt":"","width":"100px","height":"100px"}}),_vm._v(" "),_c('link-prevue',{attrs:{"url":"https://www.thaijobsgov.com/jobs/307909"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"card",staticStyle:{"width":"20rem"}},[_c('img',{staticClass:"card-img-top",attrs:{"src":props.img,"alt":props.title}}),_vm._v(" "),_c('div',{staticClass:"card-block"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(props.title))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(props.description))]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":props.url}},[_vm._v("More")])])])]}}])})],1)}
var test2_staticRenderFns = []
var test2_esExports = { render: test2_render, staticRenderFns: test2_staticRenderFns }
/* harmony default export */ var components_test2 = (test2_esExports);
// CONCATENATED MODULE: ./src/components/test2.vue
function test2_injectStyle (ssrContext) {
  __webpack_require__("FN5h")
}
var test2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var test2___vue_template_functional__ = false
/* styles */
var test2___vue_styles__ = test2_injectStyle
/* scopeId */
var test2___vue_scopeId__ = "data-v-03c14fc1"
/* moduleIdentifier (server only) */
var test2___vue_module_identifier__ = null
var test2_Component = test2_normalizeComponent(
  test2,
  components_test2,
  test2___vue_template_functional__,
  test2___vue_styles__,
  test2___vue_scopeId__,
  test2___vue_module_identifier__
)

/* harmony default export */ var src_components_test2 = (test2_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-hls-player/lib/vue-hls-player.js
var vue_hls_player = __webpack_require__("VfTH");
var vue_hls_player_default = /*#__PURE__*/__webpack_require__.n(vue_hls_player);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/test3.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var test3 = ({
  data: function data() {
    return {
      // url_test: 'https://bitmovin-a.akamaihd.net/content/playhouse-vr/m3u8s/105560.m3u8'
      // url_test: 'http://localhost:8081/bachgavotteshort/outputlist.m3u8'
      // url_test: 'http://203.150.34.140:3000/video/4guTPD_QBS9aOZwdwyd_z/output.m3u8'
      url_test: 'https://player.onenews.sdi.one.th/live/test.m3u8'
      // url_test: 'https://chat-api.one.th/alpine/api/v1/file/XlTZWHDZaMUba7cb86c384f5fa5b3eae7269b4993ce_2021-01-26_11:37:51:850753.mp4'
    };
  },
  created: function created() {},

  components: { vplayer: vue_hls_player["vplayer"] },
  methods: {
    play: function play(e) {
      console.log(e);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf3da6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/test3.vue
var test3_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container fluid",staticStyle:{"overflow-y":"scroll","height":"60vh"}},[_c('vplayer',{attrs:{"playerOptions":{
        type: 'application/x-mpegURL',//媒体类型，m3u8请给application/x-mpegURL或者application/vnd.apple.mpegURL，其他的会默认为普通音视频，注：微信不支持m3u8
        src: _vm.url_test,//视频地址
        preload: true,//是否预下载，默认为true
        autoplay: false,//是否自动播放（兼容性不太好），默认为false
        isLoop: false,//是否循环，默认不循环
        playsinline: false, //h5是否行内播放，默认false，有兼容性问题
        poster: 'https://oimdztrab.qnssl.com/Frp4SyVe5PosdkUKRaE-krjK7B5z',
        controls: 'progress,current,durration,volume', //显示的控件,volume只有视频有，没有配置controls项则全部显示。
        crossOrigin: false //设置视频的 CORS 设置。
      }},on:{"onplay":_vm.play}})],1)}
var test3_staticRenderFns = []
var test3_esExports = { render: test3_render, staticRenderFns: test3_staticRenderFns }
/* harmony default export */ var components_test3 = (test3_esExports);
// CONCATENATED MODULE: ./src/components/test3.vue
function test3_injectStyle (ssrContext) {
  __webpack_require__("hF+m")
}
var test3_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var test3___vue_template_functional__ = false
/* styles */
var test3___vue_styles__ = test3_injectStyle
/* scopeId */
var test3___vue_scopeId__ = "data-v-6cf3da6a"
/* moduleIdentifier (server only) */
var test3___vue_module_identifier__ = null
var test3_Component = test3_normalizeComponent(
  test3,
  components_test3,
  test3___vue_template_functional__,
  test3___vue_styles__,
  test3___vue_scopeId__,
  test3___vue_module_identifier__
)

/* harmony default export */ var src_components_test3 = (test3_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/manage_task/created_task_dialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import DateRangePicker from 'vue2-daterange-picker'
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
var created_task_dialog__ = __webpack_require__("M4fF");
/* harmony default export */ var created_task_dialog = ({
  props: {
    dialogCreateTask: false,
    projectid: ''
  },
  data: function data() {
    return {
      detail_task: '',
      token: '',
      subject_task: '',
      radios: '1',
      menu1: false,
      menu2: false,
      start_date: new Date().toISOString().substr(0, 10),
      end_date: new Date().toISOString().substr(0, 10),
      min_date: '',
      max_date: '',
      priority: '1',
      member: [],
      state: [],
      state_id: '',
      selectemember: [],
      subject_taskRules: [function (v) {
        return !!v || 'กรุณากรอกหัวข้อการ์ดงาน';
      }],
      isloading: false,
      min_date_end: '',
      max_date_end: '',
      subject_checklist: '',
      check_list: [],
      check_list_select: [],
      eventchecklist: {}
      // dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10))
    };
  },
  components: {
    // DateRangePicker
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },
  mounted: function mounted() {},

  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.date);
    }
  },
  watch: {
    dialogCreateTask: function dialogCreateTask() {
      // console.log(this.dialogCreateTask)
      if (this.dialogCreateTask) {
        this.getroom();
        this.getstate();
      }
    }
  },
  methods: {
    delete_checklist: function delete_checklist(index) {
      var _this = this;

      this.$swal({
        text: this.$t('Alert.Task.removeChecklist'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this.check_list = [];
          _this.check_list_select = [];
          _this.check_list = JSON.parse(localStorage.getItem('check_list'));
          _this.check_list.splice(index, 1);
          localStorage.setItem('check_list', stringify_default()(_this.check_list));
        }
      });
    },
    add_checklist: function add_checklist() {
      this.check_list.unshift({
        'check': 'false',
        'label': this.subject_checklist
      });
      this.subject_checklist = '';
      this.check_list_select = this.check_list;
      localStorage.setItem('check_list', stringify_default()(this.check_list_select));
    },
    onModifyClick: function onModifyClick(_ref, index) {
      var type = _ref.type,
          target = _ref.target;

      var event = {
        type: type,
        isCheckbox: target.type === 'checkbox',
        target: {
          value: target.value,
          checked: target.checked
        }
      };
      this.check_list[index].check = event.target.checked.toString();
    },
    allowedDates: function allowedDates(val) {
      this.min_date_end = this.start_date;
      if (this.start_date > this.end_date) {
        this.end_date = this.start_date;
      }
      return this.min_date_end;
    },
    allowedDatesEnd: function allowedDatesEnd(val) {
      this.min_date_end = this.start_date;
      if (this.min_date_end > this.end_date) {
        this.end_date = this.min_date_end;
      }
      return this.end_date;
    },
    closeDialog: function closeDialog() {
      this.selectemember = [];
      this.check_list = [];
      this.check_list_select = [];
      this.priority = '1';
      this.detail_task = '';
      this.subject_task = '';
      this.subject_checklist = '';
      this.start_date = new Date().toISOString().substr(0, 10), this.end_date = new Date().toISOString().substr(0, 10), this.$emit('closeCreateTask', false);
    },
    getstate: function getstate() {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_state_by_project', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_id: this.projectid
      }).then(function (response) {
        _this2.state = response.data.data.state;
        _this2.state_id = response.data.data.state[0].state_id;
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    cancel_task: function cancel_task() {
      var _this3 = this;

      this.$swal({
        text: this.$t('Alert.Task.removeData'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this3.check_list = [];
          _this3.selectemember = [];
          _this3.check_list_select = [];
          _this3.priority = '1';
          _this3.detail_task = '';
          _this3.subject_task = '';
          _this3.subject_checklist = '';
          _this3.start_date = new Date().toISOString().substr(0, 10), _this3.end_date = new Date().toISOString().substr(0, 10);
        }
      });
    },
    add_task: function add_task() {
      var _this4 = this;

      this.isloading = true;
      // console.log(this.check_list)
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/create_task', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        title: this.subject_task,
        detail: this.detail_task,
        state_id: this.state_id,
        time_start: this.start_date + ' 00:00:00',
        time_end: this.end_date + ' 00:00:00',
        priority: this.priority,
        project_id: this.projectid,
        assign: this.selectemember,
        check_list: this.check_list
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data.data)
          _this4.isloading = false;
          _this4.$swal('', _this4.$t('Alert.Success.createTask'), 'success');
          _this4.$emit('createdtask', { 'task_id': response.data.data.task_id, 'state_id': _this4.state_id, 'event': 'create' });
          _this4.closeDialog();
        }
      }).catch(function (error) {
        _this4.isloading = false;
        console.log(error.message);
        _this4.$swal('', error.message, 'warning');
      });
    },
    getroom: function getroom() {
      var _this5 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        if (response.data.status === 'success') {
          var member_active = [];
          member_active = response.data.data_room;
          _this5.member = created_task_dialog__.filter(member_active, function (o) {
            return o.type !== 'bot' && o.statemember == 'active';
          });
          _this5.member.push({
            tokenuser: _this5.token,
            name: localStorage.getItem('name'),
            profilepicture: localStorage.getItem('profilepicture')
          });
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d0fb43","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/manage_task/created_task_dialog.vue
var created_task_dialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"CSChatThai",attrs:{"persistent":"","max-width":"720"},model:{value:(_vm.dialogCreateTask),callback:function ($$v) {_vm.dialogCreateTask=$$v},expression:"dialogCreateTask"}},[_c('v-card',[_c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-toolbar',{staticClass:"toolbar-card-v2",attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"CSChatThai"},[_vm._v("\n          "+_vm._s(_vm.$t('Task.create.header'))+"\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"black !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('v-system-bar',{staticClass:"system-bar"})],1),_vm._v(" "),_c('v-card-text',{staticClass:"CSChatThai scrolling-wrapper",staticStyle:{"height":"70vh"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.subject'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject_task),expression:"subject_task"}],staticClass:"CSChatThai inputtaskweb",attrs:{"type":"text","placeholder":_vm.$t('Task.create.placeholderSubject')},domProps:{"value":(_vm.subject_task)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject_task=$event.target.value}}})]),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.priority'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-btn',{class:(_vm.priority=='1')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '1';}}},[_c('v-icon',{staticClass:"btn-pri1"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p1'))+"\n              ")],1),_vm._v(" "),_c('v-btn',{class:(_vm.priority=='2')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '2';}}},[_c('v-icon',{staticClass:"btn-pri2"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p2'))+"\n              ")],1),_vm._v(" "),_c('v-btn',{class:(_vm.priority=='3')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '3';}}},[_c('v-icon',{staticClass:"btn-pri3"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p3'))+"\n              ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.startDate'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-menu',{ref:"menu1",staticStyle:{"width":"25%"},attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.start_date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":""},on:{"update:returnValue":function($event){_vm.start_date=$event}},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"","readonly":""},slot:"activator",model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","allowed-dates":_vm.allowedDates,"locale":_vm.$t('Task.allTask.localepicker')},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu1 = false}}},[_vm._v("\n                  "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menu1.save(_vm.start_date)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.endDate'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-menu',{ref:"menu2",staticStyle:{"width":"25%"},attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.end_date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":""},on:{"update:returnValue":function($event){_vm.end_date=$event}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"","readonly":""},slot:"activator",model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","allowed-dates":_vm.allowedDatesEnd,"min":_vm.min_date_end,"locale":_vm.$t('Task.allTask.localepicker')},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu2 = false}}},[_vm._v("\n                  "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menu2.save(_vm.end_date)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.description'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-textarea',{staticStyle:{"width":"75%"},attrs:{"label":_vm.$t('Task.create.placeholderDescription'),"solo":"","no-resize":"","outline":"","height":"80","rows":"3","hide-details":""},model:{value:(_vm.detail_task),callback:function ($$v) {_vm.detail_task=$$v},expression:"detail_task"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.assign'))+" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-autocomplete',{staticStyle:{"width":"75%"},attrs:{"items":_vm.member,"label":_vm.$t('Task.create.placeholderAssign'),"item-text":"name","item-value":"tokenuser","multiple":"","chips":"","max-height":"auto"},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [(data.item.type !== 'bot')?_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selectemember,"close":""},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_c('v-avatar',[(data.item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":data.item.profilepicture}}):(data.item.type === 'company')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'government')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"text-overflow-chip"},[_vm._v(_vm._s(data.item.name))])],1):_vm._e()]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[(data.item.type !== 'bot')?_c('v-list-tile-avatar',[(data.item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":data.item.profilepicture}}):(data.item.type === 'company')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'government')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[(data.item.type !== 'bot')?_c('v-list-tile-title',{staticClass:"text-overflow"},[_vm._v(_vm._s(data.item.name))]):_vm._e()],1)]]}}]),model:{value:(_vm.selectemember),callback:function ($$v) {_vm.selectemember=$$v},expression:"selectemember"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.status'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-select',{staticStyle:{"padding":"0","width":"25%"},attrs:{"items":_vm.state,"outlined":"","hide-details":"","item-text":"name","item-value":"state_id"},model:{value:(_vm.state_id),callback:function ($$v) {_vm.state_id=$$v},expression:"state_id"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.checklist'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-layout',{staticClass:"mr-1",attrs:{"row":"","wrap":"","align-start":"","justify-start":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject_checklist),expression:"subject_checklist"}],staticClass:"CSChatThai inputchecklistweb",attrs:{"type":"text","placeholder":_vm.$t('Task.create.placeholderChecklist')},domProps:{"value":(_vm.subject_checklist)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject_checklist=$event.target.value}}})]),_vm._v(" "),_c('v-layout',{staticClass:"mr-2",attrs:{"row":"","wrap":"","align-end":"","justify-end":""}},[_c('v-btn',{staticClass:"btncreate",attrs:{"disabled":_vm.subject_checklist == ''},on:{"click":function($event){_vm.add_checklist()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.keep')))])],1),_vm._v(" "),_vm._l((_vm.check_list),function(item,index){return (_vm.check_list.length != 0)?_c('v-layout',{staticClass:"mt-2 border-checklist",attrs:{"row":"","wrap":"","justify-center":""}},[_c('div',{staticClass:"item"},[(item.check == 'true')?_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":item.check},on:{"change":function($event){_vm.onModifyClick($event, index)}}}):_c('input',{attrs:{"type":"checkbox"},on:{"change":function($event){_vm.onModifyClick($event, index)}}}),_vm._v(" "),(item.check == 'true')?_c('p',[_vm._v(_vm._s(item.label))]):_c('p',[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","color":"grey","flat":"","icon":"","small":""},on:{"click":function($event){_vm.delete_checklist(index)}},slot:"activator"},[_c('v-icon',{staticClass:"font-size15"},[_vm._v("fas fa-trash-alt")])],1)],1)]):_vm._e()})],2)],1),_vm._v(" "),_c('v-layout',{staticClass:"mr-5",staticStyle:{"margin-top":"15px"},attrs:{"row":"","wrap":"","align-end":"","justify-end":""}},[_c('v-btn',{staticClass:"btncancle",on:{"click":function($event){_vm.cancel_task()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"btncreate",attrs:{"loading":_vm.isloading,"disabled":_vm.subject_task == '' || _vm.priority == undefined || _vm.start_date == '' || _vm.end_date == ''},on:{"click":function($event){_vm.add_task()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1)],1)}
var created_task_dialog_staticRenderFns = []
var created_task_dialog_esExports = { render: created_task_dialog_render, staticRenderFns: created_task_dialog_staticRenderFns }
/* harmony default export */ var manage_task_created_task_dialog = (created_task_dialog_esExports);
// CONCATENATED MODULE: ./src/components/chat/manage_task/created_task_dialog.vue
function created_task_dialog_injectStyle (ssrContext) {
  __webpack_require__("fM4f")
}
var created_task_dialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var created_task_dialog___vue_template_functional__ = false
/* styles */
var created_task_dialog___vue_styles__ = created_task_dialog_injectStyle
/* scopeId */
var created_task_dialog___vue_scopeId__ = "data-v-40d0fb43"
/* moduleIdentifier (server only) */
var created_task_dialog___vue_module_identifier__ = null
var created_task_dialog_Component = created_task_dialog_normalizeComponent(
  created_task_dialog,
  manage_task_created_task_dialog,
  created_task_dialog___vue_template_functional__,
  created_task_dialog___vue_styles__,
  created_task_dialog___vue_scopeId__,
  created_task_dialog___vue_module_identifier__
)

/* harmony default export */ var chat_manage_task_created_task_dialog = (created_task_dialog_Component.exports);

// EXTERNAL MODULE: ./src/components/chat/manage_task/detail_task_dialog.vue + 2 modules
var detail_task_dialog = __webpack_require__("l1Ae");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/manage_task/homepage_task.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import DetailTask from '@/components/chat/manage_task/detail_task_dialog'


var homepage_task__ = __webpack_require__("M4fF");
/* harmony default export */ var homepage_task = ({
  props: {
    source: String
  },
  components: {
    Rightside: chat_layout_RightSide,
    CreateTask: chat_manage_task_created_task_dialog,
    DetailTask: detail_task_dialog["a" /* default */]
  },
  data: function data() {
    return {
      dialogDetailProject: false,
      dialogDetailTask: false,
      dialogCreateTask: false,
      status_login: '',
      windowWidth: '',
      mini: true,
      dialog: false,
      drawer: true,
      search: '',
      detail: {},
      token: '',
      detail_project: {},
      progress: false,
      projectid: '',
      state_id: '',
      member: [],
      taskid: '',
      roomid: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.status_login = decoded['status_login'];
    this.get_data_room();
  },

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {
    windowWidth: function windowWidth() {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage');
      }
    },
    socketmessage: function socketmessage(data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        if (data.message == 'create_task') {
          this.get_task_by_id(data.task_id, data.state.state_id, 'create');
        }
      }
    },
    socket_deletetask: function socket_deletetask(data) {
      var _this2 = this;

      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_id', {
          tokenuser: this.token,
          tokenroom: this.$route.params.roomid,
          project_id: this.projectid
        }).then(function (responsed) {
          // console.log(responsed.data.data)
          if (responsed.data.status == 'success') {
            _this2.detail_project = responsed.data.data;
          }
        });
      }
    },
    socket_edittask: function socket_edittask(data) {
      var _this3 = this;

      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_by_id', {
          tokenuser: this.token,
          task_id: data.task_id
        }).then(function (responsed) {
          if (responsed.data.status == 'success') {
            // console.log(responsed.data.data)
            var new_state = responsed.data.data.state.id;
            var old_index = '';
            var index_member = '';
            var index = '';
            old_index = homepage_task__.findIndex(_this3.detail_project.state, function (o) {
              return o.state_id == data.state_id.id;
            });
            index_member = homepage_task__.findIndex(_this3.detail_project.state[old_index].member, function (o) {
              return o._id == data.task_id;
            });
            index = homepage_task__.findIndex(_this3.detail_project.state, function (o) {
              return o.state_id == new_state;
            });
            _this3.detail_project.state[old_index].member.splice(index_member, 1);
            _this3.detail_project.state[index].member.unshift(responsed.data.data);
          }
        });
      }
    }
  },
  methods: {
    commenttask: function commenttask(data) {
      // console.log(data)
      var index = homepage_task__.findIndex(this.detail_project.state, function (o) {
        return o.state_id == data.state_id;
      });
      var index_member = homepage_task__.findIndex(this.detail_project.state[index].member, function (o) {
        return o._id == data.task_id;
      });
      this.detail_project.state[index].member[index_member].count_comment = data.count_comment;
      // console.log(this.detail_project.state[index].member[index_member].count_comment)
    },
    checkpriorityTask: function checkpriorityTask(priority) {
      if (priority == '1' || priority == '2' || priority == '3') {
        return 'card-task-pri' + priority;
      } else {
        return 'card-task-pri3';
      }
    },
    createdtask: function createdtask(value) {
      this.get_task_by_id(value.task_id, value.state_id, value.event);
    },
    closeCreateTask: function closeCreateTask(value) {
      this.dialogCreateTask = value;
    },
    edittask: function edittask(data) {
      // console.log(data)
      this.get_task_by_id(data.task_id, data.state_id, data.event, data.old_state);
    },
    deletetask: function deletetask(data) {
      // console.log(data)
      var index = homepage_task__.findIndex(this.detail_project.state, function (o) {
        return o.state_id == data.state_id;
      });
      var index_member = homepage_task__.findIndex(this.detail_project.state[index].member, function (o) {
        return o._id == data.task_id;
      });
      this.detail_project.state[index].member.splice(index_member, 1);
    },
    closeDetailTask: function closeDetailTask(value) {
      this.dialogDetailTask = value;
    },
    open_create_task: function open_create_task() {
      this.dialogCreateTask = true;
    },
    open_detail_task: function open_detail_task(taskid, tokenroom) {
      // console.log(tokenroom)
      this.taskid = taskid;
      this.roomid = tokenroom;
      // console.log(this.StateId)
      this.dialogDetailTask = true;
    },
    toChatroom: function toChatroom() {
      // this.$router.push('/chat/room/project/' + this.$route.params.roomid)
      this.$router.go(-1);
    },
    get_data_room: function get_data_room() {
      var _this4 = this;

      this.detail = {};
      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this4.progress = false;
          _this4.detail = response.data;
          var member = [];
          member = response.data.data_room;
          _this4.member = homepage_task__.filter(member, function (o) {
            return o.statemember == 'active';
          });
          _this4.get_project_by_id(_this4.$route.params.projectid);
        }
      });
    },
    get_project_by_id: function get_project_by_id(projectid) {
      var _this5 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_id', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_id: projectid
      }).then(function (responsed) {
        // console.log(responsed.data.data)
        if (responsed.data.status == 'success') {
          _this5.projectid = projectid;
          _this5.detail_project = responsed.data.data;
        }
      });
    },
    get_task_by_id: function get_task_by_id(taskid, stateid, stateevent, oldstate) {
      var _this6 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_by_id', {
        tokenuser: this.token,
        task_id: taskid
      }).then(function (responsed) {
        if (responsed.data.status == 'success') {
          // console.log(responsed.data.data)
          var old_index = '';
          var index_member = '';
          var index = '';
          if (stateevent == 'edit') {
            // console.log(this.detail_project)
            old_index = homepage_task__.findIndex(_this6.detail_project.state, function (o) {
              return o.state_id == oldstate;
            });
            index_member = homepage_task__.findIndex(_this6.detail_project.state[old_index].member, function (o) {
              return o._id == taskid;
            });
            index = homepage_task__.findIndex(_this6.detail_project.state, function (o) {
              return o.state_id == stateid;
            });
            _this6.detail_project.state[old_index].member.splice(index_member, 1);
            _this6.detail_project.state[index].member.unshift(responsed.data.data);
            // console.log(this.detail_project.state[index].member)
          } else if (stateevent == 'create') {
            index = homepage_task__.findIndex(_this6.detail_project.state, function (o) {
              return o.state_id == stateid;
            });
            _this6.detail_project.state[index].member.unshift(responsed.data.data);
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f555d214","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/manage_task/homepage_task.vue
var homepage_task_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"CSChatThai",staticStyle:{"overflow":"hidden !important"},attrs:{"fluid":""}},[(_vm.status_login === 'T')?_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","wrap":""}},[(_vm.progress)?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{staticClass:"height-100vh",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":100,"indeterminate":_vm.progress,"color":"primary"}})],1)],1):_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-navigation-drawer',{staticStyle:{"margin-top":"60px !important","background-color":"#1b232d !important"},attrs:{"app":"","right":"","mini-variant":_vm.mini},on:{"update:miniVariant":function($event){_vm.mini=$event}},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{staticClass:"transparent",attrs:{"flat":""}},[_c('v-list',{staticClass:"pa-0"},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-btn',{staticClass:"btn-nav",attrs:{"fab":"","dark":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.mini = !_vm.mini}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v(_vm._s(_vm.mini ? 'fas fa-chevron-left' : 'fas fa-chevron-right'))])],1)],1),_vm._v(" "),_c('v-spacer')],1)],1)],1),_vm._v(" "),(_vm.mini)?_c('Rightside',{staticStyle:{"display":"none !important"}}):_c('Rightside')],1),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{staticClass:"chatboxnonselect",attrs:{"justify-center":"","column":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-btn',{staticClass:"btn-color",on:{"click":function($event){_vm.toChatroom()}}},[_c('v-icon',{staticClass:"icon-color",attrs:{"left":""}},[_vm._v("fas fa-chevron-left")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Task.allTask.back')))])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"ml-50",attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[(_vm.detail.group_name !== '')?_c('p',{staticClass:"text-overflow-groupname"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.group'))+" "+_vm._s(_vm.detail.group_name))]):_vm._e()])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"ml-3",attrs:{"sm2":"","md2":"","lg2":"","xl2":""}},[_c('h2',{staticClass:"text-overflow-projectname"},[_vm._v(_vm._s(_vm.detail_project.project_name))])]),_vm._v(" "),(_vm.member.length !== 0)?_c('v-flex',{attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_vm._l((_vm.member),function(item,index){return (index < 3)?_c('v-avatar',{staticClass:"ml-2",attrs:{"size":"40"}},[(item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.profilepicture}}):(item.type == 'user')?_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}}):(item.type == 'bot')?_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):_vm._e()}),_vm._v(" "),((_vm.member.length - 3) > 0)?_c('v-avatar',{staticClass:"btn-plus-user",attrs:{"size":"40px"}},[_c('span',[_vm._v("+"+_vm._s(_vm.member.length - 3))])]):_vm._e(),_vm._v(" "),(_vm.detail_project.detail !== '')?_c('v-dialog',{staticStyle:{"overflow-x":"hidden !important"},attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialogDetailProject),callback:function ($$v) {_vm.dialogDetailProject=$$v},expression:"dialogDetailProject"}},[_c('v-chip',{attrs:{"slot":"activator","outline":"","color":"primary darken-1"},slot:"activator"},[_vm._v(_vm._s(_vm.$t('Task.allTask.projectDetail')))]),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"font-size18"},[_vm._v(_vm._s(_vm.$t('Task.allTask.projectDetail')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"word-break":"break-all !important"}},[_vm._v(_vm._s(_vm.detail_project.detail))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"round":"","color":"primary darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogDetailProject = false}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1):_vm._e()],2):_c('v-flex',{attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-avatar',{attrs:{"size":"40"}},[(_vm.detail_project.owner_info.path_pic)?_c('img',{staticClass:"object-fit-img",attrs:{"src":_vm.detail_project.owner_info.path_pic}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),(_vm.detail_project.detail !== '')?_c('v-dialog',{staticStyle:{"overflow-x":"hidden !important"},attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialogDetailProject),callback:function ($$v) {_vm.dialogDetailProject=$$v},expression:"dialogDetailProject"}},[_c('v-chip',{attrs:{"slot":"activator","outline":"","color":"primary darken-1"},slot:"activator"},[_vm._v(_vm._s(_vm.$t('Task.allTask.projectDetail')))]),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"font-size18"},[_vm._v(_vm._s(_vm.$t('Task.allTask.projectDetail')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"word-break":"break-all !important"}},[_vm._v(_vm._s(_vm.detail_project.detail))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"round":"","color":"primary darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogDetailProject = false}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","md3":"","lg3":"","xl3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-btn',{staticClass:"btn-create-task",on:{"click":function($event){_vm.open_create_task()}}},[_c('v-icon',{staticClass:"icon-create-task",attrs:{"left":""}},[_vm._v("fas fa-plus")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Task.allTask.createTask')))])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"scrolling-wrapper",attrs:{"sm12":"","md12":"","xl12":"","lg12":""}},_vm._l((_vm.detail_project.state),function(item,index){return _c('div',[_c('v-layout',{staticClass:"ml-3",attrs:{"column":"","wrap":""}},[_c('v-flex',{attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticClass:"ml-2 font-size-14 mt-2 color-numtask"},[_vm._v("\n                        "+_vm._s(_vm.$t('Task.allTask.numTask',{count: item.member.length}))+"\n                      ")])]),_vm._v(" "),(item.name.includes('Todo') || item.name.includes('todo'))?_c('v-system-bar',{staticClass:"system-barTodo"}):(item.name.includes('Doing') || item.name.includes('doing'))?_c('v-system-bar',{staticClass:"system-barDoing"}):(item.name.includes('Done') ||item.name.includes('done'))?_c('v-system-bar',{staticClass:"system-barDone"}):_c('v-system-bar',{staticClass:"system-barEtc"})],1),_vm._v(" "),_c('div',{staticClass:"color-card-task"},[_c('v-container',{staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},_vm._l((item.member),function(member,indexmem){return _c('v-flex',{attrs:{"xs12":""}},[_c('div',{class:_vm.checkpriorityTask(member.priority),on:{"click":function($event){_vm.open_detail_task(member._id, _vm.detail_project.tokenroom)}}},[_c('p',{staticClass:"mb-0 font-title-task ml-2"},[_vm._v(_vm._s(member.title))]),_vm._v(" "),_c('v-layout',{staticClass:"mr-2 mt-2",attrs:{"row":"","wrap":"","justify-end":""}},[(member.count_comment != '0' && member.count_comment != undefined)?_c('v-icon',{staticClass:"ml-3",attrs:{"color":"#d8d8d8"}},[_vm._v("fas fa-comment-dots")]):_vm._e(),_vm._v(" "),(member.count_comment != '0' && member.count_comment != undefined)?_c('span',{staticClass:"ml-2 pt-1"},[_vm._v(_vm._s(member.count_comment))]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._l((member.assign),function(item,index){return (index < 3)?_c('v-avatar',{staticStyle:{"margin-left":"2px!important"},attrs:{"size":"30"}},[(item.path_pic)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.path_pic}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):_vm._e()}),_vm._v(" "),((member.assign.length - 3) > 0)?_c('span',{staticClass:"mt-1 ml-2"},[_vm._v("+"+_vm._s(member.assign.length - 3))]):_vm._e()],2)],1)])}))],1)],1)],1)}))],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('CreateTask',{attrs:{"dialogCreateTask":_vm.dialogCreateTask,"projectid":_vm.projectid},on:{"closeCreateTask":_vm.closeCreateTask,"createdtask":_vm.createdtask}}),_vm._v(" "),_c('DetailTask',{attrs:{"dialogDetailTask":_vm.dialogDetailTask,"taskid":_vm.taskid,"roomid":_vm.roomid},on:{"closeDetailTask":_vm.closeDetailTask,"edittask":_vm.edittask,"deletetask":_vm.deletetask,"commenttask":_vm.commenttask}})],1)}
var homepage_task_staticRenderFns = []
var homepage_task_esExports = { render: homepage_task_render, staticRenderFns: homepage_task_staticRenderFns }
/* harmony default export */ var manage_task_homepage_task = (homepage_task_esExports);
// CONCATENATED MODULE: ./src/components/chat/manage_task/homepage_task.vue
function homepage_task_injectStyle (ssrContext) {
  __webpack_require__("h7JD")
}
var homepage_task_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var homepage_task___vue_template_functional__ = false
/* styles */
var homepage_task___vue_styles__ = homepage_task_injectStyle
/* scopeId */
var homepage_task___vue_scopeId__ = "data-v-f555d214"
/* moduleIdentifier (server only) */
var homepage_task___vue_module_identifier__ = null
var homepage_task_Component = homepage_task_normalizeComponent(
  homepage_task,
  manage_task_homepage_task,
  homepage_task___vue_template_functional__,
  homepage_task___vue_styles__,
  homepage_task___vue_scopeId__,
  homepage_task___vue_module_identifier__
)

/* harmony default export */ var chat_manage_task_homepage_task = (homepage_task_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/manage_task/created_project_dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import DateRangePicker from 'vue2-daterange-picker'
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
var created_project_dialog__ = __webpack_require__("M4fF");
/* harmony default export */ var created_project_dialog = ({
  props: {
    dialogCreateProject: false,
    projectid: ''
  },
  data: function data() {
    return {
      detail_project: '',
      token: '',
      subject_project: '',
      radios: '1',
      menu1: false,
      menu2: false,
      start_date: new Date().toISOString().substr(0, 10),
      end_date: new Date().toISOString().substr(0, 10),
      min_date: '',
      max_date: '',
      priority: '1',
      member: [],
      state: [],
      state_id: '',
      selectemember: [],
      subject_projectRules: [function (v) {
        return !!v || 'กรุณากรอกหัวข้อการ์ด';
      }],
      isloading: false,
      min_date_end: '',
      max_date_end: ''
      // dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10))
    };
  },
  components: {
    // DateRangePicker
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },
  mounted: function mounted() {},

  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.date);
    }
  },
  watch: {
    dialogCreateProject: function dialogCreateProject() {
      // console.log(this.dialogCreateTask)
      if (this.dialogCreateProject) {
        // this.getroom()
        // this.getstate()
      }
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.selectemember = [];
      this.priority = '1';
      this.detail_project = '';
      this.subject_project = '';
      this.start_date = new Date().toISOString().substr(0, 10), this.end_date = new Date().toISOString().substr(0, 10), this.$emit('closeCreateProject', false);
    },
    cancel_task: function cancel_task() {
      this.selectemember = [];
      this.priority = '1';
      this.detail_project = '';
      this.subject_project = '';
      this.isloading = false;
    },
    create_project: function create_project() {
      var _this = this;

      this.isloading = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/create_project', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_name: this.subject_project,
        detail: this.detail_project
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data.data)
          _this.isloading = false;
          // this.$swal('','สร้างโปรเจคสำเร็จ', 'success')
          _this.$swal({ title: _this.$t('Alert.Success.createProject'), type: 'success' });
          _this.$emit('createdproject', { 'project_id': response.data.data._id, 'event': 'create_project' });
          _this.closeDialog();
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eff3926","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/manage_task/created_project_dialog.vue
var created_project_dialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"CSChatThai",attrs:{"persistent":"","max-width":"720"},model:{value:(_vm.dialogCreateProject),callback:function ($$v) {_vm.dialogCreateProject=$$v},expression:"dialogCreateProject"}},[_c('v-card',[_c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-toolbar',{staticClass:"toolbar-card-v2",attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"CSChatThai"},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("fas fa-tasks")]),_vm._v("  "+_vm._s(_vm.$t('Task.allTask.createProject'))+"\n        ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"black !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('v-system-bar',{staticClass:"system-bar"})],1),_vm._v(" "),_c('v-card-text',{staticClass:"CSChatThai scrolling-wrapper",staticStyle:{"height":"40vh","justify-content":"center","align-items":"center","display":"grid"}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.projectSubject'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject_project),expression:"subject_project"}],staticClass:"CSChatThai inputtaskweb",attrs:{"type":"text","placeholder":_vm.$t('Task.create.placeholderSubjectProject')},domProps:{"value":(_vm.subject_project)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject_project=$event.target.value}}})]),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.description'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-textarea',{staticStyle:{"width":"75%"},attrs:{"label":_vm.$t('Task.create.placeholderDescription'),"solo":"","no-resize":"","outline":"","height":"80","rows":"3","rules":[function (v) { return v.length <= 250 || ''; }],"counter":250},model:{value:(_vm.detail_project),callback:function ($$v) {_vm.detail_project=$$v},expression:"detail_project"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mr-5",attrs:{"row":"","wrap":"","align-end":"","justify-end":""}},[_c('v-btn',{staticClass:"btncancle",on:{"click":function($event){_vm.cancel_task()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"btncreate",attrs:{"loading":_vm.isloading,"disabled":_vm.subject_project == '' || _vm.detail_project.length > 250},on:{"click":function($event){_vm.create_project()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1)],1)}
var created_project_dialog_staticRenderFns = []
var created_project_dialog_esExports = { render: created_project_dialog_render, staticRenderFns: created_project_dialog_staticRenderFns }
/* harmony default export */ var manage_task_created_project_dialog = (created_project_dialog_esExports);
// CONCATENATED MODULE: ./src/components/chat/manage_task/created_project_dialog.vue
function created_project_dialog_injectStyle (ssrContext) {
  __webpack_require__("WXa+")
}
var created_project_dialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var created_project_dialog___vue_template_functional__ = false
/* styles */
var created_project_dialog___vue_styles__ = created_project_dialog_injectStyle
/* scopeId */
var created_project_dialog___vue_scopeId__ = "data-v-7eff3926"
/* moduleIdentifier (server only) */
var created_project_dialog___vue_module_identifier__ = null
var created_project_dialog_Component = created_project_dialog_normalizeComponent(
  created_project_dialog,
  manage_task_created_project_dialog,
  created_project_dialog___vue_template_functional__,
  created_project_dialog___vue_styles__,
  created_project_dialog___vue_scopeId__,
  created_project_dialog___vue_module_identifier__
)

/* harmony default export */ var chat_manage_task_created_project_dialog = (created_project_dialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/manage_task/homepage_project.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var homepage_project__ = __webpack_require__("M4fF");
/* harmony default export */ var homepage_project = ({
  // props: {
  //   source: String
  // },
  components: {
    Rightside: chat_layout_RightSide,
    CreateProject: chat_manage_task_created_project_dialog
  },
  data: function data() {
    return {
      listproject: [],
      dialogCreateProject: false,
      status_login: '',
      windowWidth: '',
      mini: true,
      dialog: false,
      drawer: true,
      search: '',
      detail: {},
      token: '',
      progress: false,
      projectid: '',
      member: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.status_login = decoded['status_login'];
    this.get_data_room();
    this.get_project_room();
  },

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*'), {
    pages: function pages() {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 0;

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    },
    FilterListProject: function FilterListProject() {
      var _this2 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listproject.filter(function (post) {
          return post.project_name.toLowerCase().includes(_this2.search.toLowerCase());
        });
      } else {
        return this.listproject;
      }
    }
  }),
  watch: {
    windowWidth: function windowWidth() {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage');
      }
    },
    socketmessage: function socketmessage(data) {
      // console.log(data)
    },
    socket_deletetask: function socket_deletetask(data) {
      // console.log(data)
    },
    socket_edittask: function socket_edittask(data) {
      // console.log(data)
    }
  },
  methods: {
    formatDate: function formatDate(input) {
      var datePart = input.match(/\d+/g),
          year = datePart[0].substring(2),
          // get only two digits
      month = datePart[1],
          day = datePart[2];

      return day + '/' + month + '/' + year;
    },
    datetime: function datetime(timestamp) {
      return this.$i18n.locale == 'th' ? services["c" /* Momenttime */].momentdatethai(timestamp) : services["c" /* Momenttime */].momentdateen(timestamp);
    },
    topage_task: function topage_task(projectid, tokenroom) {
      // console.log(projectid)
      this.$router.push('/chat/task/' + projectid + '/' + tokenroom);
    },
    momentday: function momentday(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    createdproject: function createdproject(value) {
      this.get_project_by_id(value.project_id, value.event);
    },
    closeCreateProject: function closeCreateProject(value) {
      this.dialogCreateProject = value;
    },
    open_create_project: function open_create_project() {
      this.dialogCreateProject = true;
    },
    toChatroom: function toChatroom() {
      this.$router.push('/chat/room/' + this.$route.params.roomid);
      // this.$router.go(-1)
    },
    get_data_room: function get_data_room() {
      var _this3 = this;

      this.detail = {};
      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this3.progress = false;
          _this3.detail = response.data;
          var member = [];
          member = response.data.data_room;
          _this3.member = homepage_project__.filter(member, function (o) {
            return o.statemember == 'active';
          });
        }
      });
    },
    get_project_room: function get_project_room() {
      var _this4 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_tokenroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          _this4.listproject = response.data.data;
          _this4.listproject = homepage_project__.reverse(_this4.listproject);
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    get_project_by_id: function get_project_by_id(projectid, events) {
      var _this5 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_id', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_id: projectid
      }).then(function (responsed) {
        // console.log(responsed.data.data)
        if (responsed.data.status == 'success') {
          if (events == 'create_project') {
            _this5.listproject.unshift({
              'project_name': responsed.data.data.project_name,
              'timestamp': responsed.data.data.timestamp,
              'count_task': '0',
              '_id': responsed.data.data._id,
              'detail': responsed.data.data.detail,
              'tokenroom': responsed.data.data.tokenroom,
              'state': responsed.data.data.state,
              'path_pic': responsed.data.data.owner_info.path_pic
            });
            // this.listproject.unshift(responsed.data.data)
          }
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2db7e01c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/manage_task/homepage_project.vue
var homepage_project_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"CSChatThai",staticStyle:{"overflow":"hidden !important"},attrs:{"fluid":""}},[(_vm.status_login === 'T')?_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","wrap":""}},[(_vm.progress)?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{staticClass:"height-100vh",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":100,"indeterminate":_vm.progress,"color":"primary"}})],1)],1):_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-navigation-drawer',{staticStyle:{"margin-top":"60px !important","background-color":"#1b232d !important"},attrs:{"app":"","right":"","mini-variant":_vm.mini},on:{"update:miniVariant":function($event){_vm.mini=$event}},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{staticClass:"transparent",attrs:{"flat":""}},[_c('v-list',{staticClass:"pa-0"},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-btn',{staticClass:"btn-nav",attrs:{"fab":"","dark":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.mini = !_vm.mini}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v(_vm._s(_vm.mini ? 'fas fa-chevron-left' : 'fas fa-chevron-right'))])],1)],1),_vm._v(" "),_c('v-spacer')],1)],1)],1),_vm._v(" "),(_vm.mini)?_c('Rightside',{staticStyle:{"display":"none !important"}}):_c('Rightside')],1),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{staticClass:"chatboxnonselect",attrs:{"justify-center":"","column":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-btn',{staticClass:"btn-color",on:{"click":function($event){_vm.toChatroom()}}},[_c('v-icon',{staticClass:"icon-color",attrs:{"left":""}},[_vm._v("fas fa-chevron-left")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Task.allTask.back')))])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"ml-3",attrs:{"sm2":"","md2":"","lg2":"","xl2":""}},[_c('h2',[_vm._v(_vm._s(_vm.$t('Task.allTask.myProject',{count: _vm.listproject.length})))])]),_vm._v(" "),_c('v-flex',{attrs:{"sm4":"","md4":"","lg4":"","xl4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","md3":"","lg3":"","xl3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-btn',{staticClass:"btn-create-task",on:{"click":function($event){_vm.open_create_project()}}},[_c('v-icon',{staticClass:"icon-create-task",attrs:{"left":""}},[_vm._v("fas fa-plus")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Task.allTask.createProject')))])],1)],1)],1),_vm._v(" "),(_vm.listproject.length !== 0)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"ml-50",attrs:{"sm5":"","md5":"","lg5":"","xl5":""}},[_c('v-text-field',{attrs:{"solo":"","label":_vm.$t('Task.allTask.placeholderSearchProject'),"clearable":"","append-icon":"search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-3",attrs:{"sm4":"","md4":"","lg4":"","xl4":""}})],1):_vm._e(),_vm._v(" "),(_vm.listproject.length != 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-card',{staticClass:"card-tabs"},[_c('v-container',{staticClass:"scrolling-wrapper",staticStyle:{"min-height":"0","height":"calc(100vh - 270px) !important"},attrs:{"grid-list-lg":"","fluid":""}},[_c('v-layout',{staticClass:"mt-3 mr-2 ml-2",attrs:{"row":"","wrap":""}},_vm._l((_vm.FilterListProject),function(item,index){return _c('v-flex',{key:index,attrs:{"xs4":""}},[_c('v-card',{staticClass:"d-flex card-project"},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":"","lg12":"","xl12":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":""}},[_c('div',{staticClass:"font-size-20 text-overflow-project"},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"color-grey mt-1"},[_vm._v("\n                                  "+_vm._s(_vm.$t('Task.allTask.createDate',{date: _vm.formatDate(item.timestamp)}))+"\n                                ")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{staticClass:"ml-1 mr-1",attrs:{"wrap":"","column":""}},[_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":""}},[_vm._l((item.state),function(i){return _c('v-chip',{attrs:{"text-color":"primary","outline":"","label":""}},[_vm._v("\n                                    "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                                  ")])}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-avatar',{staticClass:"mr-1",attrs:{"size":"40px"}},[(item.path_pic)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.path_pic,"alt":"alt","class":"object-fit-img"}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png","alt":""}})])],2)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-3",attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",staticStyle:{"cursor":"pointer","margin-bottom":"5px !important"},attrs:{"row":"","wrap":""},on:{"click":function($event){_vm.topage_task(item._id, item.tokenroom)}}},[_c('span',{staticClass:"pl-3 pr-3"},[_vm._v("\n                                "+_vm._s(_vm.$t('Task.allTask.detailProject'))+"\n                              ")]),_vm._v(" "),_c('v-icon',[_vm._v("fas fa-angle-right")])],1)],1)],1)],1)],1)}))],1)],1)],1):_c('v-flex',{staticClass:"flex-center",attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('h4',[_vm._v(_vm._s(_vm.$t('Task.allTask.noProjectList')))])])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('CreateProject',{attrs:{"dialogCreateProject":_vm.dialogCreateProject,"projectid":_vm.projectid},on:{"closeCreateProject":_vm.closeCreateProject,"createdproject":_vm.createdproject}})],1)}
var homepage_project_staticRenderFns = []
var homepage_project_esExports = { render: homepage_project_render, staticRenderFns: homepage_project_staticRenderFns }
/* harmony default export */ var manage_task_homepage_project = (homepage_project_esExports);
// CONCATENATED MODULE: ./src/components/chat/manage_task/homepage_project.vue
function homepage_project_injectStyle (ssrContext) {
  __webpack_require__("x2ZK")
}
var homepage_project_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var homepage_project___vue_template_functional__ = false
/* styles */
var homepage_project___vue_styles__ = homepage_project_injectStyle
/* scopeId */
var homepage_project___vue_scopeId__ = "data-v-2db7e01c"
/* moduleIdentifier (server only) */
var homepage_project___vue_module_identifier__ = null
var homepage_project_Component = homepage_project_normalizeComponent(
  homepage_project,
  manage_task_homepage_project,
  homepage_project___vue_template_functional__,
  homepage_project___vue_styles__,
  homepage_project___vue_scopeId__,
  homepage_project___vue_module_identifier__
)

/* harmony default export */ var chat_manage_task_homepage_project = (homepage_project_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/manage_task/homepage_all_project.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var homepage_all_project__ = __webpack_require__("M4fF");
/* harmony default export */ var homepage_all_project = ({
  // props: {
  //   source: String
  // },
  components: {},
  data: function data() {
    return {
      tabs: '',
      listproject: [],
      status_login: '',
      windowWidth: '',
      token: '',
      progress: false,
      search: '',
      search_group: '',
      listproject_user: [],
      listproject_group: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.status_login = decoded['status_login'];
    this.get_project_room();
  },

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*'), {
    pages: function pages() {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 0;

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    },
    FilterListProject: function FilterListProject() {
      var _this2 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listproject_user.filter(function (post) {
          return post.project_name.toLowerCase().includes(_this2.search.toLowerCase());
        });
      } else {
        return this.listproject_user;
      }
    },
    FilterListProjectGroup: function FilterListProjectGroup() {
      var _this3 = this;

      if (this.search_group !== '' && this.search_group !== null) {
        return this.listproject_group.filter(function (post) {
          return post.project_name.toLowerCase().includes(_this3.search_group.toLowerCase());
        });
      } else {
        return this.listproject_group;
      }
    }
  }),
  watch: {
    windowWidth: function windowWidth() {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage');
      }
    }
  },
  methods: {
    topage_task: function topage_task(projectid, tokenroom) {
      // console.log(projectid)
      this.$router.push('/chat/task/' + projectid + '/' + tokenroom);
    },
    momentday: function momentday(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    datetime: function datetime(timestamp) {
      return this.$i18n.locale == 'th' ? services["c" /* Momenttime */].momentdatethai(timestamp) : services["c" /* Momenttime */].momentdateen(timestamp);
    },
    toChatroom: function toChatroom() {
      // this.$router.push('/chat/room/' + this.$route.params.roomid)
      this.$router.go(-1);
    },
    get_project_room: function get_project_room() {
      var _this4 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_tokenuser', {
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          _this4.progress = false;
          _this4.listproject = response.data.data;
          _this4.listproject = homepage_all_project__.reverse(homepage_all_project__.sortBy(_this4.listproject, function (dateObj) {
            return new Date(dateObj.timestamp);
          }));
          // console.log(this.listproject)
          _this4.listproject_group = homepage_all_project__.filter(_this4.listproject, function (o) {
            return o.tokenroom.startsWith('G');
          });
          _this4.listproject_user = homepage_all_project__.filter(_this4.listproject, function (o) {
            return o.tokenroom.startsWith('R');
          });
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04cdc67a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/manage_task/homepage_all_project.vue
var homepage_all_project_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"CSChatThai",staticStyle:{"overflow":"hidden !important"},attrs:{"fluid":""}},[(_vm.status_login === 'T')?_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","wrap":""}},[(_vm.progress)?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{staticClass:"height-100vh",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":100,"indeterminate":_vm.progress,"color":"primary"}})],1)],1):_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{staticClass:"chatboxnonselect",attrs:{"justify-center":"","column":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}})],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-tabs',{staticClass:"mt-2",attrs:{"left":"","color":"white","dark":"","icons-and-text":""},model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('v-tabs-slider',{attrs:{"color":"#232b35"}}),_vm._v(" "),_c('v-tab',{key:1,attrs:{"href":"#tab-1"}},[_c('p',{staticStyle:{"color":"#232b35","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.friend')))]),_vm._v(" "),_c('v-icon',{attrs:{"color":"#232b35"}},[_vm._v("fas fa-user")])],1),_vm._v(" "),_c('v-tab',{key:2,attrs:{"href":"#tab-2"}},[_c('p',{staticStyle:{"color":"#232b35","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.group')))]),_vm._v(" "),_c('v-icon',{attrs:{"color":"#232b35"}},[_vm._v("fas fa-users")])],1),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',{attrs:{"id":"tab-1"}},[(_vm.listproject_user.length != 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-card',{staticClass:"card-tabs",attrs:{"color":"primary"}},[_c('v-container',{staticClass:"scrolling-wrapper",staticStyle:{"min-height":"0","height":"calc(100vh - 180px) !important"},attrs:{"grid-list-lg":"","fluid":""}},[_c('v-layout',{staticClass:"mt-4 mr-5 ml-5",attrs:{"row":"","wrap":""}},_vm._l((_vm.FilterListProject),function(item,index){return _c('v-flex',{key:index,staticClass:"mt-1 mb-2",attrs:{"xs6":""}},[_c('v-card',{staticClass:"card-project",on:{"click":function($event){_vm.topage_task(item._id, item.tokenroom)}}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":"","lg12":"","xl12":""},on:{"click":function($event){_vm.topage_task(item._id, item.tokenroom)}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('div',{staticClass:"font-size-20 font-weight-bold text-overflow-project ml-4 mt-2"},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"color-grey mr-4 mt-3",staticStyle:{"font-size":"12px"}},[_vm._v("\n                                        "+_vm._s(_vm.datetime(item.timestamp))+"\n                                      ")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{staticClass:"ml-2 mt-0",attrs:{"column":"","justify-end":""}},[_c('div',{staticClass:"text-overflow-detail",staticStyle:{"font-size":"13px"}},[_vm._v("\n                                          "+_vm._s(item.detail)+"\n                                        ")])]),_vm._v(" "),_vm._l((item.state),function(i){return [(i.name.includes('Todo') || i.name.includes('todo'))?_c('v-chip',{staticClass:"chipColorTodo",attrs:{"small":"","label":""}},[_vm._v("\n                                          "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                                        ")]):(i.name.includes('Doing') || i.name.includes('doing'))?_c('v-chip',{staticClass:"chipColorDoing",attrs:{"small":"","label":""}},[_vm._v("\n                                          "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                                        ")]):(i.name.includes('Done') ||i.name.includes('done'))?_c('v-chip',{staticClass:"chipColorDone",attrs:{"small":"","label":""}},[_vm._v("\n                                          "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                                        ")]):_c('v-chip',{staticClass:"chipColorEtc",attrs:{"small":"","label":""}},[_vm._v("\n                                          "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                                        ")])]})],2),_vm._v(" "),_c('v-layout',{staticClass:"ml-3 mb-2",attrs:{"row":"","wrap":""}},[_c('v-avatar',{attrs:{"size":"35px"}},[(item.path_pic)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.path_pic}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"text-overflow-project mt-2 ml-2",staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(item.room_name))])],1)],1)],1)],1)],1)}))],1)],1)],1):_c('v-flex',{staticClass:"flex-center cal-height-100vh",attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"font-size":"60px !important"}},[_vm._v("fas fa-tasks")]),_vm._v(" "),_c('h4',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$t('Task.allTask.noProjectList')))])],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[(_vm.listproject_group.length != 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-card',{staticClass:"card-tabs"},[_c('v-container',{staticClass:"scrolling-wrapper",staticStyle:{"min-height":"0","height":"calc(100vh - 180px) !important"},attrs:{"grid-list-lg":"","fluid":""}},[_c('v-layout',{staticClass:"mt-4 mr-5 ml-5",attrs:{"row":"","wrap":""}},_vm._l((_vm.FilterListProjectGroup),function(item,index){return _c('v-flex',{key:index,staticClass:"mt-1 mb-2",attrs:{"xs6":""}},[_c('v-card',{staticClass:"card-project",on:{"click":function($event){_vm.topage_task(item._id, item.tokenroom)}}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":"","lg12":"","xl12":""},on:{"click":function($event){_vm.topage_task(item._id, item.tokenroom)}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('div',{staticClass:"font-size-20 font-weight-bold text-overflow-project ml-4 mt-2"},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"color-grey mr-4 mt-3",staticStyle:{"font-size":"12px"}},[_vm._v("\n                                        "+_vm._s(_vm.datetime(item.timestamp))+"\n                                      ")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{staticClass:"ml-2 mt-0",attrs:{"column":"","justify-end":""}},[_c('div',{staticClass:"text-overflow-detail",staticStyle:{"font-size":"13px"}},[_vm._v("\n                                          "+_vm._s(item.detail)+"\n                                        ")])]),_vm._v(" "),_vm._l((item.state),function(i){return [(i.name.includes('Todo') || i.name.includes('todo'))?_c('v-chip',{staticClass:"chipColorTodo",attrs:{"small":"","label":""}},[_vm._v("\n                                          "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                                        ")]):(i.name.includes('Doing') || i.name.includes('doing'))?_c('v-chip',{staticClass:"chipColorDoing",attrs:{"small":"","label":""}},[_vm._v("\n                                          "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                                        ")]):(i.name.includes('Done') ||i.name.includes('done'))?_c('v-chip',{staticClass:"chipColorDone",attrs:{"small":"","label":""}},[_vm._v("\n                                          "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                                        ")]):_c('v-chip',{staticClass:"chipColorEtc",attrs:{"small":"","label":""}},[_vm._v("\n                                          "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                                        ")])]})],2),_vm._v(" "),_c('v-layout',{staticClass:"ml-3 mb-2",attrs:{"row":"","wrap":""}},[_c('v-avatar',{attrs:{"size":"35px"}},[(item.path_pic)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.path_pic}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"text-overflow-project mt-2 ml-2",staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(item.room_name))])],1)],1)],1)],1)],1)}))],1)],1)],1):_c('v-flex',{staticClass:"flex-center cal-height-100vh",attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"font-size":"60px !important"}},[_vm._v("fas fa-tasks")]),_vm._v(" "),_c('h4',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$t('Task.allTask.noProjectList')))])],1)],1)],1)],1),_vm._v(" "),(_vm.tabs == 'tab-1')?_c('v-layout',{staticClass:"ml-3 mr-4 bg-white",attrs:{"row":"","wrap":"","align-center":"","justify-end":""}},[(_vm.listproject_user.length != 0)?_c('v-flex',{staticClass:"ml-3 mt-3",attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-text-field',{attrs:{"solo":"","label":_vm.$t('Task.allTask.placeholderSearchProject'),"clearable":"","append-icon":"search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1):_vm._e()],1):_c('v-layout',{staticClass:"ml-3 mr-4 bg-white",attrs:{"row":"","wrap":"","align-center":"","justify-end":""}},[(_vm.listproject_group.length != 0)?_c('v-flex',{staticClass:"ml-3 mt-3",attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-text-field',{attrs:{"solo":"","label":_vm.$t('Task.allTask.placeholderSearchProject'),"clearable":"","append-icon":"search"},model:{value:(_vm.search_group),callback:function ($$v) {_vm.search_group=$$v},expression:"search_group"}})],1):_vm._e()],1)],1)],1)],1)],1)],1)],1)],1)],1):_vm._e()],1)}
var homepage_all_project_staticRenderFns = []
var homepage_all_project_esExports = { render: homepage_all_project_render, staticRenderFns: homepage_all_project_staticRenderFns }
/* harmony default export */ var manage_task_homepage_all_project = (homepage_all_project_esExports);
// CONCATENATED MODULE: ./src/components/chat/manage_task/homepage_all_project.vue
function homepage_all_project_injectStyle (ssrContext) {
  __webpack_require__("mHWE")
}
var homepage_all_project_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var homepage_all_project___vue_template_functional__ = false
/* styles */
var homepage_all_project___vue_styles__ = homepage_all_project_injectStyle
/* scopeId */
var homepage_all_project___vue_scopeId__ = "data-v-04cdc67a"
/* moduleIdentifier (server only) */
var homepage_all_project___vue_module_identifier__ = null
var homepage_all_project_Component = homepage_all_project_normalizeComponent(
  homepage_all_project,
  manage_task_homepage_all_project,
  homepage_all_project___vue_template_functional__,
  homepage_all_project___vue_styles__,
  homepage_all_project___vue_scopeId__,
  homepage_all_project___vue_module_identifier__
)

/* harmony default export */ var chat_manage_task_homepage_all_project = (homepage_all_project_Component.exports);

// EXTERNAL MODULE: ./src/components/chat/dialog/manage_group/CreateGroupDialog.vue + 1 modules
var CreateGroupDialog = __webpack_require__("sHvA");

// EXTERNAL MODULE: ./src/components/chat/dialog/manage_friend/AddFriendDialog.vue + 2 modules
var AddFriendDialog = __webpack_require__("sSPP");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/manage_task/homepage_created_project.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var homepage_created_project__ = __webpack_require__("M4fF");
/* harmony default export */ var homepage_created_project = ({
  // props: {
  //   source: String
  // },
  components: {
    Rightside: chat_layout_RightSide,
    CreateProject: chat_manage_task_created_project_dialog,
    CreateGroupDialog: CreateGroupDialog["a" /* default */],
    AddDialog: AddFriendDialog["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      AddFriend: false,
      radios: '',
      tabs: '',
      text: 'mm',
      listproject: [],
      dialogDetailTask: false,
      dialogCreateProject: false,
      status_login: '',
      windowWidth: '',
      mini: true,
      dialog: false,
      drawer: true,
      detail: {},
      token: '',
      detail_project: {},
      progress: false,
      projectid: '',
      state_id: '',
      member: [],
      taskid: '',
      search: '',
      search_group: '',
      listproject_user: [],
      listproject_group: [],
      listfriend: [],
      listgroup: [],
      project_name: ''
    }, defineProperty_default()(_ref, 'detail_project', ''), defineProperty_default()(_ref, 'isloading', false), defineProperty_default()(_ref, 'CreateGroup', false), defineProperty_default()(_ref, 'showtextCreateProject', true), defineProperty_default()(_ref, 'stepSelect', 1), defineProperty_default()(_ref, 'create_project', null), _ref;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.status_login = decoded['status_login'];
    // this.get_project_room()
    this.get_list_friend();
    this.get_list_group();
  },

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*'), {
    pages: function pages() {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 0;

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    },
    FilterListFriend: function FilterListFriend() {
      var _this2 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listfriend.filter(function (post) {
          return post.name.toLowerCase().includes(_this2.search.toLowerCase());
        });
      } else {
        return this.listfriend;
      }
    },
    FilterListGroup: function FilterListGroup() {
      var _this3 = this;

      if (this.search_group !== '' && this.search_group !== null) {
        return this.listgroup.filter(function (post) {
          return post.name.toLowerCase().includes(_this3.search_group.toLowerCase());
        });
      } else {
        return this.listgroup;
      }
    }
  }),
  watch: {
    windowWidth: function windowWidth() {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage');
      }
    },
    socketmessage: function socketmessage(data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        if (data.message == 'create_task') {
          this.get_task_by_id(data.task_id, data.state.state_id, 'create');
        }
      }
    },
    create_project: function create_project() {
      var _this4 = this;

      var l = this.create_project;
      this[l] = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/create_project', {
        tokenuser: this.token,
        tokenroom: this.radios,
        project_name: this.project_name,
        detail: this.detail_project
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data.data)
          _this4[l] = false;
          _this4.cancel_project();
          _this4.$swal('', _this4.$t('Alert.Success.createProject'), 'success');
          _this4.projectid = response.data.data._id;
          _this4.$router.push('/chat/task/' + _this4.projectid + '/' + response.data.data.tokenroom);
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    socket_deletetask: function socket_deletetask(data) {
      var _this5 = this;

      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_id', {
          tokenuser: this.token,
          tokenroom: this.$route.params.roomid,
          project_id: this.projectid
        }).then(function (responsed) {
          // console.log(responsed.data.data)
          if (responsed.data.status == 'success') {
            _this5.detail_project = responsed.data.data;
          }
        });
      }
    },
    socket_edittask: function socket_edittask(data) {
      var _this6 = this;

      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_by_id', {
          tokenuser: this.token,
          task_id: data.task_id
        }).then(function (responsed) {
          if (responsed.data.status == 'success') {
            // console.log(responsed.data.data)
            var new_state = responsed.data.data.state.id;
            var old_index = '';
            var index_member = '';
            var index = '';
            old_index = homepage_created_project__.findIndex(_this6.detail_project.state, function (o) {
              return o.state_id == data.state_id.id;
            });
            index_member = homepage_created_project__.findIndex(_this6.detail_project.state[old_index].member, function (o) {
              return o._id == data.task_id;
            });
            index = homepage_created_project__.findIndex(_this6.detail_project.state, function (o) {
              return o.state_id == new_state;
            });
            _this6.detail_project.state[old_index].member.splice(index_member, 1);
            _this6.detail_project.state[index].member.unshift(responsed.data.data);
          }
        });
      }
    },
    socketaccept_friend: function socketaccept_friend(data) {
      var _this7 = this;

      var tokenfriend = data.tokenfriend;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', { tokenuser: this.token, tokenfriend: tokenfriend }).then(function (response) {
        if (homepage_created_project__.find(_this7.listfriend, function (o) {
          return o.tokenuser === response.data.user.tokenuser;
        }) === undefined) {
          _this7.listfriend.unshift(response.data.user);
          _this7.radios = '';
        }
      });
    },
    socketremove_friend: function socketremove_friend(data) {
      // console.log(data)
      var index = homepage_created_project__.findIndex(this.listfriend, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (index >= 0) {
        this.listfriend.splice(index, 1);
      }
    },
    block_friend: function block_friend(data) {
      this.blockevent(data);
    }
  },
  methods: {
    blockevent: function blockevent(data) {
      // console.log(data)
      if (data.event === 'unblock_friend') {
        this.listfriend.push(data);
      }
    },
    open_add_friend: function open_add_friend() {
      this.AddFriend = true;
    },
    open_create_group: function open_create_group() {
      this.CreateGroup = true;
    },
    closeDialogCreateGroup: function closeDialogCreateGroup(value) {
      this.CreateGroup = value;
    },
    closeDialogAddFriend: function closeDialogAddFriend(value) {
      this.AddFriend = value;
    },
    updatecreategroup: function updatecreategroup(data, filename) {
      if (homepage_created_project__.find(this.listgroup, function (o) {
        return o.group_id === data.group_id;
      }) === undefined) {
        this.listgroup.unshift({
          count_read: '',
          create_date: data.create_date,
          group_id: data.group_id,
          member: data.member,
          name: data.name,
          picture: filename,
          state: data.state,
          timestamp: data.timestamp,
          tokenroom: data.tokenroom,
          type: data.type
        });
        this.listgroup = homepage_created_project__.reverse(homepage_created_project__.sortBy(this.listgroup, function (dateObj) {
          return new Date(dateObj.create_date);
        }));
      }
    },
    cancel_project: function cancel_project() {
      this.project_name = '';
      this.detail_project = '';
      // this.radios = ''
    },
    cancel_radios: function cancel_radios() {
      this.radios = '';
    },
    get_list_friend: function get_list_friend() {
      var _this8 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistfriend', {
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          _this8.progress = false;
          _this8.listfriend = response.data['listfriend'];
          // console.log(this.listfriend)
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    get_list_group: function get_list_group() {
      var _this9 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistgroup2', {
        tokenuser: this.token
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this9.progress = false;
          _this9.listgroup = response.data['listgroup'];
          // console.log(this.listgroup)
          _this9.listgroup = homepage_created_project__.reverse(homepage_created_project__.sortBy(_this9.listgroup, function (dateObj) {
            return new Date(dateObj.create_date);
          }));
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    topage_task: function topage_task(projectid, tokenroom) {
      // console.log(projectid)
      this.$router.push('/chat/task/' + projectid + '/' + tokenroom);
    },
    momentday: function momentday(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    createdproject: function createdproject(value) {
      this.get_project_by_id(value.project_id, value.event);
    },
    closeCreateProject: function closeCreateProject(value) {
      this.dialogCreateProject = value;
    },
    edittask: function edittask(data) {
      // console.log(data)
      this.get_task_by_id(data.task_id, data.state_id, data.event, data.old_state);
    },
    deletetask: function deletetask(data) {
      // console.log(data)
      var index = homepage_created_project__.findIndex(this.detail_project.state, function (o) {
        return o.state_id == data.state_id;
      });
      var index_member = homepage_created_project__.findIndex(this.detail_project.state[index].member, function (o) {
        return o._id == data.task_id;
      });
      this.detail_project.state[index].member.splice(index_member, 1);
    },
    closeDetailTask: function closeDetailTask(value) {
      this.dialogDetailTask = value;
    },
    open_create_project: function open_create_project() {
      this.dialogCreateProject = true;
    },
    open_detail_task: function open_detail_task(taskid) {
      this.taskid = taskid;
      // console.log(this.StateId)
      this.dialogDetailTask = true;
    },
    toChatroom: function toChatroom() {
      // this.$router.push('/chat/room/' + this.$route.params.roomid)
      this.$router.go(-1);
    },
    get_data_room: function get_data_room() {
      var _this10 = this;

      this.detail = {};
      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this10.progress = false;
          _this10.detail = response.data;
          // console.log(this.detail)
          var member = [];
          member = response.data.data_room;
          _this10.member = homepage_created_project__.filter(member, function (o) {
            return o.statemember == 'active';
          });
          // this.check_project_room()
        }
      });
    },
    get_project_room: function get_project_room() {
      var _this11 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_tokenuser', {
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          _this11.progress = false;
          _this11.listproject = response.data.data;
          _this11.listproject = homepage_created_project__.reverse(homepage_created_project__.sortBy(_this11.listproject, function (dateObj) {
            return new Date(dateObj.timestamp);
          }));
          _this11.listproject_group = homepage_created_project__.filter(_this11.listproject, function (o) {
            return o.tokenroom.startsWith('G');
          });
          _this11.listproject_user = homepage_created_project__.filter(_this11.listproject, function (o) {
            return o.tokenroom.startsWith('R');
          });
          // console.log(this.listproject_group)
          // console.log(this.listproject_user)
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },

    // created_project () {
    //   this.isLoading = true
    //   this.axios.post(process.env.APIpub + '/v1/user/create_project', {
    //     tokenuser: this.token,
    //     tokenroom: this.radios,
    //     project_name: this.project_name,
    //     detail: this.detail_project
    //   }).then((response) => {
    //     if (response.data.status === 'success') {
    //       // console.log(response.data.data)
    //       this.isLoading = false
    //       this.cancel_project()
    //       this.$swal('', this.$t('Alert.Success.createProject'), 'success')
    //       this.projectid = response.data.data._id
    //       this.$router.push('/chat/task/' + this.projectid + '/' + response.data.data.tokenroom)
    //     }
    //   }).catch(error => {
    //     console.log(error.message)
    //   })
    // },
    get_project_by_id: function get_project_by_id(projectid, events) {
      var _this12 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_id', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_id: projectid
      }).then(function (responsed) {
        // console.log(responsed.data.data)
        if (responsed.data.status == 'success') {
          if (events == 'create_project') {
            _this12.listproject.unshift(responsed.data.data);
          }
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    get_task_by_id: function get_task_by_id(taskid, stateid, stateevent, oldstate) {
      var _this13 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_by_id', {
        tokenuser: this.token,
        task_id: taskid
      }).then(function (responsed) {
        if (responsed.data.status == 'success') {
          // console.log(responsed.data.data)
          var old_index = '';
          var index_member = '';
          var index = '';
          if (stateevent == 'edit') {
            old_index = homepage_created_project__.findIndex(_this13.detail_project.state, function (o) {
              return o.state_id == oldstate;
            });
            index_member = homepage_created_project__.findIndex(_this13.detail_project.state[old_index].member, function (o) {
              return o._id == taskid;
            });
            index = homepage_created_project__.findIndex(_this13.detail_project.state, function (o) {
              return o.state_id == stateid;
            });
            _this13.detail_project.state[old_index].member.splice(index_member, 1);
            _this13.detail_project.state[index].member.unshift(responsed.data.data);
            // console.log(this.detail_project.state[index].member)
          } else if (stateevent == 'create') {
            index = homepage_created_project__.findIndex(_this13.detail_project.state, function (o) {
              return o.state_id == stateid;
            });
            _this13.detail_project.state[index].member.unshift(responsed.data.data);
          }
        }
      });
    },
    TestClick: function TestClick() {
      console.log('eeeeeeeeeeeee');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-529d8784","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/manage_task/homepage_created_project.vue
var homepage_created_project_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"CSChatThai",staticStyle:{"overflow":"hidden !important"},attrs:{"fluid":""}},[(_vm.status_login === 'T')?_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","wrap":""}},[(_vm.progress)?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{staticClass:"height-100vh",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":100,"indeterminate":_vm.progress,"color":"primary"}})],1)],1):_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{staticClass:"chatboxnonselect",attrs:{"justify-center":"","column":""}},[_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.stepSelect),callback:function ($$v) {_vm.stepSelect=$$v},expression:"stepSelect"}},[_c('v-layout',{staticClass:"ml-4 mt-3",attrs:{"row":"","wrap":""}},[_c('strong',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.$t('Task.allTask.createProject')))])]),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepSelect > 1,"step":"1"}},[_vm._v("\n                "+_vm._s(_vm.$t('Task.create.placeholderSubjectProject'))+"\n              ")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-layout',{staticClass:"mt-2",attrs:{"column":"","justify-center":""}},[[_c('v-flex',{staticClass:"layoutfield"},[_c('v-text-field',{attrs:{"name":"projectname","label":_vm.$t('Task.create.placeholderSubjectProject'),"id":"id","solo":""},model:{value:(_vm.project_name),callback:function ($$v) {_vm.project_name=$$v},expression:"project_name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"layoutfield"},[_c('v-textarea',{attrs:{"label":_vm.$t('Task.create.description'),"name":"descriptionproject","no-resize":"","solo":"","rules":[function (v) { return v.length <= 250 || ''; }],"counter":250},model:{value:(_vm.detail_project),callback:function ($$v) {_vm.detail_project=$$v},expression:"detail_project"}})],1)]],2),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":"","align-end":""}},[[_c('v-btn',{staticClass:"btnclear",on:{"click":function($event){_vm.cancel_project()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.clear')))]),_vm._v(" "),_c('v-btn',{staticClass:"btncancle",attrs:{"outline":"","disabled":_vm.project_name == ''},on:{"click":function($event){_vm.stepSelect = 2}}},[_vm._v(_vm._s(_vm.$t('Task.allTask.next')))])]],2)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepSelect > 2,"step":"2"}},[_vm._v("\n                "+_vm._s(_vm.$t('Task.create.select'))+"\n              ")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-layout',{staticClass:"mt-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-tabs',{staticClass:"mt-2",attrs:{"left":"","color":"white","dark":"","icons-and-text":""},model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('v-tabs-slider',{attrs:{"color":"#232b35"}}),_vm._v(" "),_c('v-tab',{key:1,attrs:{"href":"#tab-1"}},[_c('p',{staticStyle:{"color":"#232b35","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.friend')))]),_vm._v(" "),_c('v-icon',{attrs:{"color":"#232b35"}},[_vm._v("fas fa-user")])],1),_vm._v(" "),_c('v-tab',{key:2,attrs:{"href":"#tab-2"}},[_c('p',{staticStyle:{"color":"#232b35","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.group')))]),_vm._v(" "),_c('v-icon',{attrs:{"color":"#232b35"}},[_vm._v("fas fa-users")])],1),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',{attrs:{"id":"tab-1"}},[(_vm.listfriend.length != 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-card',{staticClass:"card-tabs"},[_c('v-container',{staticClass:"scrolling-wrapper",staticStyle:{"min-height":"0","height":"calc(100vh - 430px) !important"}},[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('div',{staticClass:"listFrinend"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.FilterListFriend),function(item,index){return [_c('v-flex',{key:index,attrs:{"xs12":"","sm4":"","md4":"","xl4":"","lg4":""}},[_c('v-card',{staticClass:"cardOfFriendList",nativeOn:{"click":function($event){_vm.radios=item.tokenroom}}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"md4":"","sm12":"","xs12":"","d-flex":""}},[_c('v-avatar',{staticStyle:{"margin-top":"5px"},attrs:{"size":"45px"}},[(item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.profilepicture}}):(item.type == 'user')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}}):(item.type == 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):(item.type == 'business')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":"","sm12":"","xs12":"","d-flex":""}},[_c('strong',{staticClass:"textWrap",staticStyle:{"margin-bottom":"20px","margin-top":"20px","font-size":"13px"}},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('v-flex',{attrs:{"md2":"","d-flex":""}},[_c('v-radio-group',{staticStyle:{"margin-bottom":"20px"},attrs:{"mandatory":false},model:{value:(_vm.radios),callback:function ($$v) {_vm.radios=$$v},expression:"radios"}},[_c('v-radio',{staticClass:"radioPosition",attrs:{"value":item.tokenroom}})],1)],1)],1)],1)],1)]})],2)],1)])],1)],1)],1):_c('v-flex',{staticClass:"flex-center cal-height-100vh",attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"font-size":"60px !important"}},[_vm._v("fas fa-user-friends")]),_vm._v(" "),_c('h4',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$t('Task.allTask.noListFriend')))])],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[(_vm.listgroup.length != 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-card',{staticClass:"card-tabs"},[_c('v-container',{staticClass:"scrolling-wrapper",staticStyle:{"min-height":"0","height":"calc(100vh - 430px) !important"}},[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('div',{staticClass:"listFrinend"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.FilterListGroup),function(item,index){return [_c('v-flex',{key:index,attrs:{"xs12":"","sm4":"","md4":"","xl4":"","lg4":""}},[_c('v-card',{staticClass:"cardOfFriendList",nativeOn:{"click":function($event){_vm.radios=item.tokenroom}}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"md4":"","sm12":"","xs12":"","d-flex":""}},[_c('v-avatar',{staticStyle:{"margin-top":"5px"},attrs:{"size":"45px"}},[(item.picture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.picture}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/group-white.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":"","sm12":"","xs12":"","d-flex":""}},[_c('strong',{staticClass:"textWrap",staticStyle:{"margin-bottom":"20px","margin-top":"20px","font-size":"16px"}},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('v-flex',{attrs:{"md2":"","d-flex":""}},[_c('v-radio-group',{staticStyle:{"margin-bottom":"20px"},attrs:{"mandatory":false},model:{value:(_vm.radios),callback:function ($$v) {_vm.radios=$$v},expression:"radios"}},[_c('v-radio',{staticClass:"radioPosition",attrs:{"value":item.tokenroom}})],1)],1)],1)],1)],1)]})],2)],1)])],1)],1)],1):_c('v-flex',{staticClass:"flex-center mt-3 cal-height-100vh",attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"font-size":"60px !important"}},[_vm._v("fas fa-users")]),_vm._v(" "),_c('h4',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$t('Task.allTask.noListGroup')))])],1)],1)],1)],1),_vm._v(" "),(_vm.tabs == 'tab-1')?_c('v-layout',{staticClass:"ml-1 mr-5 bg-white",attrs:{"row":"","wrap":"","align-center":"","justify-end":""}},[(_vm.listfriend.length == 0)?_c('v-flex',{staticClass:"mt-2 mr-4",attrs:{"xs2":"","sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-btn',{staticClass:"btncreate",on:{"click":function($event){_vm.open_add_friend()}}},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.addFriend')))])],1):_c('v-flex',{staticClass:"ml-3 mt-3",attrs:{"sm5":"","md5":"","lg5":"","xl5":""}},[_c('v-text-field',{attrs:{"solo":"","label":_vm.$t('Task.allTask.placeholderSearchFriend'),"clearable":"","append-icon":"search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1):_c('v-layout',{staticClass:"ml-1 mr-5 bg-white",attrs:{"row":"","wrap":"","align-center":"","justify-end":""}},[_c('v-btn',{staticClass:"btncreate",on:{"click":function($event){_vm.open_create_group()}}},[_vm._v(_vm._s(_vm.$t('Task.allTask.newGroup')))]),_vm._v(" "),(_vm.listgroup.length !== 0)?_c('v-flex',{staticClass:"ml-3 mt-3",attrs:{"sm5":"","md5":"","lg5":"","xl5":""}},[_c('v-text-field',{attrs:{"solo":"","label":_vm.$t('Task.allTask.placeholderSearchGroup'),"clearable":"","append-icon":"search"},model:{value:(_vm.search_group),callback:function ($$v) {_vm.search_group=$$v},expression:"search_group"}})],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-left"},[[_c('v-btn',{staticClass:"btncancle",attrs:{"outline":""},on:{"click":function($event){_vm.stepSelect = 1}}},[_vm._v(_vm._s(_vm.$t('Register.Button.back')))])]],2),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"btnclear",staticStyle:{"margin-right":"60px"},on:{"click":function($event){_vm.cancel_radios()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.clear')))]),_vm._v(" "),_c('v-btn',{staticClass:"btncreate",attrs:{"loading":_vm.isloading,"disabled":_vm.project_name == '' || _vm.radios == ''},on:{"click":function($event){_vm.create_project = 'isloading'}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1)],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('CreateProject',{attrs:{"dialogCreateProject":_vm.dialogCreateProject,"projectid":_vm.projectid},on:{"closeCreateProject":_vm.closeCreateProject,"createdproject":_vm.createdproject}}),_vm._v(" "),_c('CreateGroupDialog',{attrs:{"dialogGroup":_vm.CreateGroup},on:{"closeDialogCreateGroup":_vm.closeDialogCreateGroup,"updatecreategroup":_vm.updatecreategroup}}),_vm._v(" "),_c('AddDialog',{attrs:{"dialogAdd":_vm.AddFriend},on:{"closeDialogAddFriend":_vm.closeDialogAddFriend,"blockevent":_vm.blockevent}})],1)}
var homepage_created_project_staticRenderFns = []
var homepage_created_project_esExports = { render: homepage_created_project_render, staticRenderFns: homepage_created_project_staticRenderFns }
/* harmony default export */ var manage_task_homepage_created_project = (homepage_created_project_esExports);
// CONCATENATED MODULE: ./src/components/chat/manage_task/homepage_created_project.vue
function homepage_created_project_injectStyle (ssrContext) {
  __webpack_require__("GL+G")
}
var homepage_created_project_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var homepage_created_project___vue_template_functional__ = false
/* styles */
var homepage_created_project___vue_styles__ = homepage_created_project_injectStyle
/* scopeId */
var homepage_created_project___vue_scopeId__ = "data-v-529d8784"
/* moduleIdentifier (server only) */
var homepage_created_project___vue_module_identifier__ = null
var homepage_created_project_Component = homepage_created_project_normalizeComponent(
  homepage_created_project,
  manage_task_homepage_created_project,
  homepage_created_project___vue_template_functional__,
  homepage_created_project___vue_styles__,
  homepage_created_project___vue_scopeId__,
  homepage_created_project___vue_module_identifier__
)

/* harmony default export */ var chat_manage_task_homepage_created_project = (homepage_created_project_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/manage_task/created_task_calendar_dialog.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import DateRangePicker from 'vue2-daterange-picker'
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
var created_task_calendar_dialog__ = __webpack_require__("M4fF");
/* harmony default export */ var created_task_calendar_dialog = ({
  props: {
    dialogCreateTaskCalendar: false
  },
  data: function data() {
    return {
      search_group: '',
      search: '',
      radios: null,
      e1: 1,
      steps: 2,
      detail_task: '',
      token: '',
      subject_task: '',
      menu1: false,
      menu2: false,
      start_date: new Date().toISOString().substr(0, 10),
      end_date: new Date().toISOString().substr(0, 10),
      min_date: '',
      max_date: '',
      priority: '1',
      member: [],
      state: [],
      state_id: '',
      selectemember: [],
      subject_taskRules: [function (v) {
        return !!v || 'กรุณากรอกหัวข้อการ์ดงาน';
      }],
      isloading: false,
      min_date_end: '',
      max_date_end: '',
      subject_checklist: '',
      listprojectfriend: [],
      listprojectgroup: [],
      tokenroom: '',
      projectid: '',
      tabs: 'tab-1',
      progress: false,
      check_list: [],
      check_list_select: []
      // dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10))
    };
  },
  components: {
    // DateRangePicker
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },
  mounted: function mounted() {},

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*'), {
    FilterListProject: function FilterListProject() {
      var _this = this;

      if (this.search !== '' && this.search !== null) {
        return this.listprojectfriend.filter(function (post) {
          return post.project_name.toLowerCase().includes(_this.search.toLowerCase());
        });
      } else {
        return this.listprojectfriend;
      }
    },
    FilterListProjectGroup: function FilterListProjectGroup() {
      var _this2 = this;

      if (this.search_group !== '' && this.search_group !== null) {
        return this.listprojectgroup.filter(function (post) {
          return post.project_name.toLowerCase().includes(_this2.search_group.toLowerCase());
        });
      } else {
        return this.listprojectgroup;
      }
    }
  }),
  watch: {
    dialogCreateTaskCalendar: function dialogCreateTaskCalendar() {
      // console.log(this.projectid)
      if (this.dialogCreateTaskCalendar) {
        this.start_date = localStorage.getItem('datestart');
        this.end_date = localStorage.getItem('datestart');
        this.get_list_project();
      }
    },
    steps: function steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    }
  },
  methods: {
    delete_checklist: function delete_checklist(index) {
      var _this3 = this;

      this.$swal({
        text: this.$t('Alert.Task.removeChecklist'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this3.check_list = [];
          _this3.check_list_select = [];
          _this3.check_list = JSON.parse(localStorage.getItem('check_list'));
          _this3.check_list.splice(index, 1);
          localStorage.setItem('check_list', stringify_default()(_this3.check_list));
        }
      });
    },
    add_checklist: function add_checklist() {
      this.check_list.unshift({
        'check': 'false',
        'label': this.subject_checklist
      });
      this.subject_checklist = '';
      this.check_list_select = this.check_list;
      localStorage.setItem('check_list', stringify_default()(this.check_list_select));
    },
    onModifyClick: function onModifyClick(_ref, index) {
      var type = _ref.type,
          target = _ref.target;

      var event = {
        type: type,
        isCheckbox: target.type === 'checkbox',
        target: {
          value: target.value,
          checked: target.checked
        }
      };
      this.check_list[index].check = event.target.checked.toString();
      // this.check_list_select = this.check_list
      // console.log(this.check_list)
    },
    get_list_project: function get_list_project() {
      var _this4 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_tokenuser', {
        tokenuser: this.token
      }).then(function (response) {
        if (response.data.status == 'success') {
          _this4.progress = false;
          _this4.listprojectgroup = created_task_calendar_dialog__.filter(response.data.data, function (o) {
            return o.tokenroom.startsWith('G');
          });
          _this4.listprojectfriend = created_task_calendar_dialog__.filter(response.data.data, function (o) {
            return o.tokenroom.startsWith('R');
          });
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    onInput: function onInput(val) {
      this.steps = parseInt(val);
    },
    nextStep: function nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1;
        this.start_date = localStorage.getItem('datestart');
        this.end_date = localStorage.getItem('datestart');
        this.tabs = 'tab-1';
        // this.radios = null
        // this.projectid = ''
        this.selectemember = [];
        this.priority = '1';
        this.detail_task = '';
        this.subject_task = '';
        this.subject_checklist = '';
        this.check_list = [];
        this.check_list_select = [];
      } else {
        this.e1 = n + 1;
      }
    },
    allowedDates: function allowedDates(val) {
      this.min_date_end = this.start_date;
      if (this.start_date > this.end_date) {
        this.end_date = this.start_date;
      }
      return this.min_date_end;
    },
    allowedDatesEnd: function allowedDatesEnd(val) {
      this.min_date_end = this.start_date;
      if (this.min_date_end > this.end_date) {
        this.end_date = this.min_date_end;
      }
      return this.end_date;
    },
    closeDialog: function closeDialog() {
      this.check_list = [];
      this.check_list_select = [];
      this.e1 = 1;
      this.tabs = 'tab-1';
      this.radios = null;
      this.projectid = '';
      this.selectemember = [];
      this.priority = '1';
      this.detail_task = '';
      this.subject_task = '';
      this.subject_checklist = '';
      this.start_date = new Date().toISOString().substr(0, 10), this.end_date = new Date().toISOString().substr(0, 10), this.$emit('closeCreateTask', false);
    },
    getstate: function getstate(item) {
      var _this5 = this;

      this.tokenroom = item.tokenroom;
      this.projectid = item.project_id;
      // console.log(item)
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_state_by_project', {
        tokenuser: this.token,
        tokenroom: this.tokenroom,
        project_id: this.projectid
      }).then(function (response) {
        _this5.state = response.data.data.state;
        _this5.state_id = response.data.data.state[0].state_id;
        _this5.getroom();
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    cancel_task: function cancel_task() {
      this.radios = null;
      this.selectemember = [];
      this.priority = '1';
      this.detail_task = '';
      this.subject_task = '';
      this.subject_checklist = '';
      this.start_date = new Date().toISOString().substr(0, 10), this.end_date = new Date().toISOString().substr(0, 10);
      this.projectid = '';
    },
    add_task: function add_task() {
      var _this6 = this;

      this.isloading = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/create_task', {
        tokenuser: this.token,
        tokenroom: this.tokenroom,
        title: this.subject_task,
        detail: this.detail_task,
        state_id: this.state_id,
        time_start: this.start_date + ' 00:00:00',
        time_end: this.end_date + ' 00:00:00',
        priority: this.priority,
        project_id: this.projectid,
        assign: this.selectemember,
        check_list: this.check_list
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data.data)
          _this6.isloading = false;
          _this6.$swal('', _this6.$t('Alert.Success.createTask'), 'success');
          _this6.$emit('createdtask', { 'task_id': response.data.data.task_id,
            'state_id': _this6.state_id,
            'event': 'create',
            'tokenroom': _this6.tokenroom,
            'projectid': _this6.projectid,
            'date_end': _this6.end_date,
            'date_start': _this6.start_date
          });
          _this6.closeDialog();
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    getroom: function getroom() {
      var _this7 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.tokenroom
      }).then(function (response) {
        if (response.data.status === 'success') {
          var member_active = [];
          member_active = response.data.data_room;
          _this7.member = created_task_calendar_dialog__.filter(member_active, function (o) {
            return o.type !== 'bot' && o.statemember == 'active';
          });
          _this7.member.push({
            tokenuser: _this7.token,
            name: localStorage.getItem('name'),
            profilepicture: localStorage.getItem('profilepicture')
          });
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b855f2da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/manage_task/created_task_calendar_dialog.vue
var created_task_calendar_dialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"CSChatThai",attrs:{"persistent":"","max-width":"720"},model:{value:(_vm.dialogCreateTaskCalendar),callback:function ($$v) {_vm.dialogCreateTaskCalendar=$$v},expression:"dialogCreateTaskCalendar"}},[_c('v-card',[_c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-toolbar',{staticClass:"toolbar-card-v2",attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"CSChatThai"},[_vm._v("\n          "+_vm._s(_vm.$t('Task.create.header'))+"\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"black !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('v-system-bar',{staticClass:"system-bar"})],1),_vm._v(" "),_c('v-card-text',{staticClass:"CSChatThai scrolling-wrapper",staticStyle:{"height":"80vh"}},[_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[[_c('v-stepper-step',{key:"1-step",attrs:{"step":"1","complete":_vm.e1 > 1}},[_vm._v("\n                "+_vm._s(_vm.$t('Task.allTask.selectProject'))+"\n              ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{key:"2-step",attrs:{"step":"2","complete":_vm.e1 > 2}},[_vm._v("\n                "+_vm._s(_vm.$t('Task.allTask.createProject'))+"\n              ")])]],2),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{key:"1-content",attrs:{"step":"1"}},[(_vm.progress)?_c('v-card',{attrs:{"color":"white","height":"500px"}},[_c('v-layout',{staticStyle:{"height":"500px"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"size":"80","color":"primary","indeterminate":_vm.progress}})],1)],1):_c('v-card',{attrs:{"color":"white","height":"500px"}},[_c('v-tabs',{attrs:{"icons-and-text":"","left":"","dark":"","color":"white"},model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('v-tabs-slider',{attrs:{"color":"#232b35"}}),_vm._v(" "),_c('v-tab',{key:1,attrs:{"href":"#tab-1"}},[_c('span',{staticStyle:{"color":"#232b35","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.friend')))]),_vm._v(" "),_c('v-icon',{attrs:{"color":"#232b35"}},[_vm._v("fas fa-user")])],1),_vm._v(" "),_c('v-tab',{key:2,attrs:{"href":"#tab-2"}},[_c('span',{staticStyle:{"color":"#232b35","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.group')))]),_vm._v(" "),_c('v-icon',{attrs:{"color":"#232b35"}},[_vm._v("fas fa-users")])],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-1"}},[_c('v-card',{staticClass:"scrolling-wrapper",staticStyle:{"height":"400px"},attrs:{"flat":""}},[_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.FilterListProject),function(item,index){return [_c('v-list-tile',{key:item._id,attrs:{"avatar":"","ripple":""}},[_c('v-list-tile-avatar',[(item.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.path_pic}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.project_name))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-radio-group',{attrs:{"mandatory":false},on:{"click":function($event){_vm.getstate(item)}},model:{value:(_vm.radios),callback:function ($$v) {_vm.radios=$$v},expression:"radios"}},[_c('v-radio',{attrs:{"value":item}})],1)],1)],1),_vm._v(" "),(index + 1 < _vm.listprojectfriend.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[_c('v-card',{staticClass:"scrolling-wrapper",staticStyle:{"height":"400px"},attrs:{"flat":""}},[_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.FilterListProjectGroup),function(item,index){return [_c('v-list-tile',{key:item._id,attrs:{"avatar":"","ripple":""}},[_c('v-list-tile-avatar',[(item.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.path_pic}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/group-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.project_name))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-radio-group',{attrs:{"mandatory":false},on:{"click":function($event){_vm.getstate(item)}},model:{value:(_vm.radios),callback:function ($$v) {_vm.radios=$$v},expression:"radios"}},[_c('v-radio',{attrs:{"value":item}})],1)],1)],1),_vm._v(" "),(index + 1 < _vm.listprojectgroup.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1)],1),_vm._v(" "),(_vm.tabs == 'tab-1')?_c('v-layout',{staticClass:"ml-3 mr-4 bg-white",attrs:{"row":"","wrap":"","align-center":"","justify-end":""}},[(_vm.listprojectfriend.length != 0)?_c('v-flex',{staticClass:"ml-3 mt-3",attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"CSChatThai inputtaskweb-search",attrs:{"type":"text","placeholder":_vm.$t('Task.allTask.placeholderSearchProject')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]):_vm._e()],1):_c('v-layout',{staticClass:"ml-3 mr-4 bg-white",attrs:{"row":"","wrap":"","align-center":"","justify-end":""}},[(_vm.listprojectgroup.length != 0)?_c('v-flex',{staticClass:"ml-3 mt-3",attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_group),expression:"search_group"}],staticClass:"CSChatThai inputtaskweb-search",attrs:{"type":"text","placeholder":_vm.$t('Task.allTask.placeholderSearchProject')},domProps:{"value":(_vm.search_group)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search_group=$event.target.value}}})]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"btncreate",attrs:{"disabled":_vm.projectid == ''},on:{"click":function($event){_vm.nextStep(1)}}},[_vm._v(_vm._s(_vm.$t('Task.allTask.next')))])],1),_vm._v(" "),_c('v-stepper-content',{key:"2-content",attrs:{"step":"2"}},[_c('v-card',{staticClass:"scrolling-wrapper",staticStyle:{"height":"500px"},attrs:{"color":"white"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.subject'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject_task),expression:"subject_task"}],staticClass:"CSChatThai inputtaskweb",attrs:{"type":"text","placeholder":_vm.$t('Task.create.placeholderSubject')},domProps:{"value":(_vm.subject_task)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject_task=$event.target.value}}})]),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.priority'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-btn',{class:(_vm.priority=='1')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '1';}}},[_c('v-icon',{staticClass:"btn-pri1"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p1'))+"\n                      ")],1),_vm._v(" "),_c('v-btn',{class:(_vm.priority=='2')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '2';}}},[_c('v-icon',{staticClass:"btn-pri2"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p2'))+"\n                      ")],1),_vm._v(" "),_c('v-btn',{class:(_vm.priority=='3')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '3';}}},[_c('v-icon',{staticClass:"btn-pri3"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p3'))+"\n                      ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.startDate'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-menu',{ref:"menu1",staticStyle:{"width":"25%"},attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.start_date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":""},on:{"update:returnValue":function($event){_vm.start_date=$event}},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"","readonly":""},slot:"activator",model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","allowed-dates":_vm.allowedDates,"locale":_vm.$t('Task.allTask.localepicker')},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu1 = false}}},[_vm._v("\n                          "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                        ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menu1.save(_vm.start_date)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                        ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.endDate'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-menu',{ref:"menu2",staticStyle:{"width":"25%"},attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.end_date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":""},on:{"update:returnValue":function($event){_vm.end_date=$event}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"","readonly":""},slot:"activator",model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","allowed-dates":_vm.allowedDatesEnd,"min":_vm.min_date_end,"locale":_vm.$t('Task.allTask.localepicker')},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu2 = false}}},[_vm._v("\n                          "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                        ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menu2.save(_vm.end_date)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                        ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.description'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-textarea',{staticStyle:{"width":"75%"},attrs:{"label":_vm.$t('Task.create.placeholderDescription'),"solo":"","no-resize":"","outline":"","height":"80","rows":"3","hide-details":""},model:{value:(_vm.detail_task),callback:function ($$v) {_vm.detail_task=$$v},expression:"detail_task"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.assign'))+" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-autocomplete',{staticStyle:{"width":"75%"},attrs:{"items":_vm.member,"label":_vm.$t('Task.create.placeholderAssign'),"item-text":"name","item-value":"tokenuser","multiple":"","chips":"","max-height":"auto"},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [(data.item.type !== 'bot')?_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selectemember,"close":""},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_c('v-avatar',[(data.item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":data.item.profilepicture}}):(data.item.type === 'company')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'government')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"text-overflow-chip"},[_vm._v(_vm._s(data.item.name))])],1):_vm._e()]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[(data.item.type !== 'bot')?_c('v-list-tile-avatar',[(data.item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":data.item.profilepicture}}):(data.item.type === 'company')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'government')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[(data.item.type !== 'bot')?_c('v-list-tile-title',{staticClass:"text-overflow"},[_vm._v(_vm._s(data.item.name))]):_vm._e()],1)]]}}]),model:{value:(_vm.selectemember),callback:function ($$v) {_vm.selectemember=$$v},expression:"selectemember"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.status'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-select',{staticStyle:{"padding":"0","width":"25%"},attrs:{"items":_vm.state,"outlined":"","hide-details":"","item-text":"name","item-value":"state_id"},model:{value:(_vm.state_id),callback:function ($$v) {_vm.state_id=$$v},expression:"state_id"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.checklist'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-layout',{staticClass:"mr-1",attrs:{"row":"","wrap":"","align-start":"","justify-start":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject_checklist),expression:"subject_checklist"}],staticClass:"CSChatThai inputchecklistweb",attrs:{"type":"text","placeholder":_vm.$t('Task.create.placeholderChecklist')},domProps:{"value":(_vm.subject_checklist)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject_checklist=$event.target.value}}})]),_vm._v(" "),_c('v-layout',{staticClass:"mr-2",attrs:{"row":"","wrap":"","align-end":"","justify-end":""}},[_c('v-btn',{staticClass:"btncreate",attrs:{"disabled":_vm.subject_checklist == ''},on:{"click":function($event){_vm.add_checklist()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.keep')))])],1),_vm._v(" "),_vm._l((_vm.check_list),function(item,index){return (_vm.check_list.length != 0)?_c('v-layout',{staticClass:"mt-2 border-checklist",attrs:{"row":"","wrap":"","justify-center":""}},[_c('div',{staticClass:"item"},[(item.check == 'true')?_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":item.check},on:{"change":function($event){_vm.onModifyClick($event, index)}}}):_c('input',{attrs:{"type":"checkbox"},on:{"change":function($event){_vm.onModifyClick($event, index)}}}),_vm._v(" "),(item.check == 'true')?_c('p',[_vm._v(_vm._s(item.label))]):_c('p',[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","color":"grey","flat":"","icon":"","small":""},on:{"click":function($event){_vm.delete_checklist(index)}},slot:"activator"},[_c('v-icon',{staticClass:"font-size15"},[_vm._v("fas fa-trash-alt")])],1)],1)]):_vm._e()})],2)],1),_vm._v(" "),_c('v-layout',{staticClass:"mr-5",staticStyle:{"margin-top":"15px"},attrs:{"row":"","wrap":"","align-end":"","justify-end":""}},[_c('v-btn',{staticClass:"btncancle",on:{"click":function($event){_vm.cancel_task()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"btncreate",attrs:{"loading":_vm.isloading,"disabled":_vm.subject_task == '' || _vm.priority == undefined || _vm.start_date == '' || _vm.end_date == ''},on:{"click":function($event){_vm.add_task()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"btncreate",on:{"click":function($event){_vm.nextStep(2)}}},[_vm._v(_vm._s(_vm.$t('Task.allTask.back')))])],1)],1)],1)],1)],1)],1)}
var created_task_calendar_dialog_staticRenderFns = []
var created_task_calendar_dialog_esExports = { render: created_task_calendar_dialog_render, staticRenderFns: created_task_calendar_dialog_staticRenderFns }
/* harmony default export */ var manage_task_created_task_calendar_dialog = (created_task_calendar_dialog_esExports);
// CONCATENATED MODULE: ./src/components/chat/manage_task/created_task_calendar_dialog.vue
function created_task_calendar_dialog_injectStyle (ssrContext) {
  __webpack_require__("YtfS")
}
var created_task_calendar_dialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var created_task_calendar_dialog___vue_template_functional__ = false
/* styles */
var created_task_calendar_dialog___vue_styles__ = created_task_calendar_dialog_injectStyle
/* scopeId */
var created_task_calendar_dialog___vue_scopeId__ = "data-v-b855f2da"
/* moduleIdentifier (server only) */
var created_task_calendar_dialog___vue_module_identifier__ = null
var created_task_calendar_dialog_Component = created_task_calendar_dialog_normalizeComponent(
  created_task_calendar_dialog,
  manage_task_created_task_calendar_dialog,
  created_task_calendar_dialog___vue_template_functional__,
  created_task_calendar_dialog___vue_styles__,
  created_task_calendar_dialog___vue_scopeId__,
  created_task_calendar_dialog___vue_module_identifier__
)

/* harmony default export */ var chat_manage_task_created_task_calendar_dialog = (created_task_calendar_dialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/manage_task/homepage_calendar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import DetailTask from '@/components/chat/manage_task/test_detail_task_dialog'

var homepage_calendar__ = __webpack_require__("M4fF");
var homepage_calendar_moment = __webpack_require__("PJh5");
/* harmony default export */ var homepage_calendar = ({
  props: {
    source: String
  },
  components: {
    Rightside: chat_layout_RightSide,
    CreateTask: chat_manage_task_created_task_calendar_dialog,
    DetailTask: detail_task_dialog["a" /* default */]
  },
  data: function data() {
    return {
      dialogDetailProject: false,
      dialogDetailTask: false,
      dialogCreateTaskCalendar: false,
      status_login: '',
      windowWidth: '',
      mini: true,
      dialog: false,
      drawer: true,
      search: '',
      detail: {},
      token: '',
      detail_project: {},
      progress: false,
      projectid: '',
      state_id: '',
      member: [],
      taskid: '',
      roomid: '',
      arrayEvents: null,
      date1: null,
      date2: new Date().toISOString().substr(0, 10),
      listproject: [],
      time_now: new Date().toISOString().substr(0, 10),
      time_day: new Date().toISOString().substr(0, 10),
      progress_project: false,
      date: new Date().toISOString().substr(0, 10),
      list_date_task: [],
      monthLater: '',
      list_project_month: [],
      listdateCalendar: [],

      start: new Date().toISOString().substr(0, 10),
      listdataTask: [],
      listGetproject: [],
      checkListstr: [],
      checkdates: new Date().toISOString().substr(0, 10),
      checkroomname: '',
      progress_task: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
  },
  created: function created() {

    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.status_login = decoded['status_login'];
    this.progress_project = true;
    this.get_task_in_month(this.time_now);
    // this.get_data_room()
    // this.get_task_in_day()
  },

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*'), {
    FilterListProject: function FilterListProject() {
      var _this2 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listproject.filter(function (post) {
          return post.project_name.toLowerCase().includes(_this2.search.toLowerCase());
        });
      } else {
        return this.listproject;
      }
    }
  }),
  watch: {
    date2: function date2() {
      if (this.date.split('-')[1] !== this.date2.split('-')[1]) {
        this.progress_project = true;
        this.checkdates = this.date;
        this.date = this.date2;
        this.time_day = this.date2;
        localStorage.setItem('datestart', this.time_day);
        this.get_task_in_month(this.time_day);
        // this.get_task_in_day()
        // this.check_range_date()
      } else {
        this.date = this.date2;
        this.checkdates = this.date2;
      }
    },
    windowWidth: function windowWidth() {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage');
      }
    },
    socketmessage: function socketmessage(data) {
      // console.log(data)
      // if (data.tokenuser !== this.token) {
      //   if (data.message == 'create_task') {
      //     this.get_task_by_id(data.task_id, data.state.state_id, 'create')
      //   }
      // }
    },
    socket_deletetask: function socket_deletetask(data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.get_task_in_month(this.time_day);
        // this.get_task_in_day()
      }
    },
    socket_edittask: function socket_edittask(data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.get_task_in_month(this.time_day);
        // this.get_task_in_day()
      }
    }
  },
  methods: {
    open_create_project: function open_create_project() {
      this.$router.push('/chat/project/create_project');
    },
    datetimecheck: function datetimecheck(timecheck) {
      if (timecheck.split('-')[1] !== this.checkdates.split('-')[1]) {
        var timeTH = services["c" /* Momenttime */].momentdatethai(timecheck).split(' ')[1] + ' ' + services["c" /* Momenttime */].momentdatethai(timecheck).split(' ')[2];
        var timeEN = services["c" /* Momenttime */].momentdateen(timecheck).split(' ')[0] + ' ' + services["c" /* Momenttime */].momentdateen(timecheck).split(' ')[2];
        return this.$i18n.locale == 'th' ? timeTH : timeEN;
      } else {
        return this.$i18n.locale == 'th' ? services["c" /* Momenttime */].momentdatethai(timecheck) : services["c" /* Momenttime */].momentdateen(timecheck);
      }
    },
    datetime: function datetime(timestamp) {
      return this.$i18n.locale == 'th' ? services["c" /* Momenttime */].momentdatethai(timestamp) : services["c" /* Momenttime */].momentdateen(timestamp);
    },
    get_task_in_month: function get_task_in_month(time_now) {
      var _this3 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_in_month', {
        tokenuser: this.token,
        time_now: time_now + ' 00:00:00.000000'
      }).then(function (response) {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          _this3.list_project_month = response.data.data;
          _this3.check_range_date();
        }
      });
    },
    get_task_in_day: function get_task_in_day(time, projectname) {
      var _this4 = this;

      this.listproject = [];
      this.progress_task = true;
      // this.progress_project = true
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_in_day', {
        tokenuser: this.token,
        time_day: time + ' 00:00:00.000000'
      }).then(function (response) {
        if (response.data.status === 'success') {
          // this.progress_project = false
          localStorage.setItem('datestart', _this4.time_day);
          if (projectname) {
            _this4.checkroomname = projectname;
            var checkroomname = response.data.data;
            var arrtask = checkroomname.filter(function (task) {
              return task.room_name == projectname;
            });
            _this4.listproject = arrtask;
            _this4.progress_task = false;
          } else {
            _this4.checkroomname = '';
            _this4.listproject = response.data.data;
            _this4.progress_task = false;
          }
          // console.log(this.listproject)
        }
      });
    },
    functionEvents: function functionEvents(date) {
      // console.log(date)
      var month = date.split('-')[0] + '-' + date.split('-')[1];
      if (month !== this.monthLater) {
        this.monthLater = month;
        this.time_now = month + '-01';
        this.get_task_in_month(this.time_now);
        return this.checkdate(date);
      } else {
        return this.checkdate(date);
      }
    },
    functionEventsColor: function functionEventsColor() {
      return 'green darken-1';
    },
    check_range_date: function check_range_date() {
      // console.log(this.list_date_task)
      this.listGetproject = [];
      this.listdataTask = [];
      this.listdateCalendar = [];
      var time_end = '',
          time_start = '';
      for (var i = 0; i < this.list_project_month.length; i++) {
        for (var j = 0; j < this.list_project_month[i].state.length; j++) {
          for (var k = 0; k < this.list_project_month[i].state[j].member.length; k++) {
            time_start = this.list_project_month[i].state[j].member[k].time_start.split(' ')[0];
            time_end = this.list_project_month[i].state[j].member[k].time_end.split(' ')[0];
            this.listdateCalendar = homepage_calendar__.union(this.listdateCalendar.concat(this.getDates(time_start, time_end, this.list_project_month[i].room_name)));
            // this.get_user_create(this.listdateCalendar)
          }
        }
      }
      this.checkIncludes();
    },
    getDates: function getDates(startDate, stopDate, project) {
      // console.log(startDate, stopDate)
      var dateArray = [];
      var currentDate = homepage_calendar_moment(startDate);
      var stopDate = homepage_calendar_moment(stopDate);
      while (currentDate <= stopDate) {
        this.listGetproject.push({
          task: project,
          time: homepage_calendar_moment(currentDate).format('YYYY-MM-DD'),
          dialog: false
        });
        dateArray.push(homepage_calendar_moment(currentDate).format('YYYY-MM-DD'));
        currentDate = homepage_calendar_moment(currentDate).add(1, 'days');
      }
      return dateArray;
    },
    checkIncludes: function checkIncludes() {
      var arr = [];
      arr = this.listGetproject.filter(function (value, index, self) {
        return index === self.findIndex(function (t, i) {
          return t.task === value.task && t.time === value.time;
        });
      });

      var output = [];
      var existingIndex = [];
      arr.forEach(function (item) {
        var existing = output.filter(function (v, i) {
          return v.time == item.time;
        });
        if (existing.length) {
          existingIndex = output.indexOf(existing[0]);
          output[existingIndex].task = output[existingIndex].task.concat(item.task);
        } else {
          if (typeof item.task == 'string') item.task = [item.task];
          output.push(item);
        }
      });

      this.listdataTask = output;
      this.progress_project = false;
    },
    checkdate: function checkdate(date) {
      // console.log(date)
      // console.log(this.listdateCalendar)
      var test = [];
      test = this.listdateCalendar;
      if (test.includes(date) || test.includes(date)) {
        return true;
      } else {
        return false;
      }
    },
    momentday: function momentday(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    commenttask: function commenttask(data) {
      var index = homepage_calendar__.findIndex(this.listproject, function (o) {
        return o._id == data.project_id;
      });
      var index_state = homepage_calendar__.findIndex(this.listproject[index].state, function (o) {
        return o.state_id == data.state_id;
      });
      var index_member = homepage_calendar__.findIndex(this.listproject[index].state[index_state].member, function (o) {
        return o._id == data.task_id;
      });
      this.listproject[index].state[index_state].member[index_member].count_comment = data.count_comment;
    },
    checkpriorityTask: function checkpriorityTask(priority) {
      if (priority == '1' || priority == '2' || priority == '3') {
        return 'card-task-pri' + priority;
      } else {
        return 'card-task-pri3';
      }
    },
    createdtask: function createdtask(data) {
      // console.log(data)
      this.get_project_by_id(data);
      // console.log(this.list_project_month)
    },
    closeCreateTask: function closeCreateTask(value) {
      this.dialogCreateTaskCalendar = value;
    },
    edittask: function edittask(data) {
      // console.log(data)
      // console.log(this.list_project_month)
      // this.get_task_in_day()
      var date = data.date_end + ' 00:00:00';
      var date_start = data.date_start + ' 00:00:00';
      var index = homepage_calendar__.findIndex(this.list_project_month, function (o) {
        return o._id == data.project_id;
      });
      var index_state = homepage_calendar__.findIndex(this.list_project_month[index].state, function (o) {
        return o.state_id == data.state_id;
      });
      var index_member = homepage_calendar__.findIndex(this.list_project_month[index].state[index_state].member, function (o) {
        return o._id == data.task_id;
      });
      this.list_project_month[index].state[index_state].member[index_member].time_end = date;
      this.list_project_month[index].state[index_state].member[index_member].time_start = date_start;
      this.check_range_date();
    },
    deletetask: function deletetask(data) {
      // this.get_task_in_day()
      var date = data.date_end;
      date = date.split(' ')[0];
      var indexcalendar = homepage_calendar__.findIndex(this.listdateCalendar, function (o) {
        return o == date;
      });
      var index = homepage_calendar__.findIndex(this.list_project_month, function (o) {
        return o._id == data.project_id;
      });
      var index_state = homepage_calendar__.findIndex(this.list_project_month[index].state, function (o) {
        return o.state_id == data.state_id;
      });
      var index_member = homepage_calendar__.findIndex(this.list_project_month[index].state[index_state].member, function (o) {
        return o._id == data.task_id;
      });
      this.list_project_month[index].state[index_state].member.splice(index_member, 1);
      // console.log(this.list_project_month)
      this.check_range_date();
    },
    closeDetailTask: function closeDetailTask(value) {
      this.dialogDetailTask = value;
    },
    open_create_task: function open_create_task() {
      this.dialogCreateTaskCalendar = true;
    },
    open_detail_task: function open_detail_task(taskid, tokenroom) {
      this.dialog = false;
      // console.log(tokenroom)
      this.taskid = taskid;
      this.roomid = tokenroom;
      // console.log(this.StateId)
      this.dialogDetailTask = true;
    },
    toChatroom: function toChatroom() {
      this.$router.push('/chat/room/project/' + this.$route.params.roomid);
    },
    get_data_room: function get_data_room() {
      var _this5 = this;

      this.detail = {};
      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this5.progress = false;
          _this5.detail = response.data;
          var member = [];
          member = response.data.data_room;
          _this5.member = homepage_calendar__.filter(member, function (o) {
            return o.statemember == 'active';
          });
          _this5.get_task_in_day();
          // this.get_project_by_id(this.$route.params.projectid)
        }
      });
    },
    get_project_by_id: function get_project_by_id(data) {
      var _this6 = this;

      // console.log(data)
      this.listGetproject = [];
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_id', {
        tokenuser: this.token,
        tokenroom: data.tokenroom,
        project_id: data.projectid
      }).then(function (responsed) {
        if (responsed.data.status == 'success') {
          _this6.projectid = data.projectid;
          // this.detail_project = responsed.data.data
          _this6.list_project_month.unshift(responsed.data.data);
          // console.log(this.listproject)
          // console.log(this.list_project_month)
          var date = data.date_end + ' 00:00:00';
          var date_start = data.date_start + ' 00:00:00';
          var index = homepage_calendar__.findIndex(_this6.list_project_month, function (o) {
            return o._id == data.projectid;
          });
          var index_state = homepage_calendar__.findIndex(_this6.list_project_month[index].state, function (o) {
            return o.state_id == data.state_id;
          });
          var index_member = homepage_calendar__.findIndex(_this6.list_project_month[index].state[index_state].member, function (o) {
            return o._id == data.task_id;
          });
          _this6.list_project_month[index].state[index_state].member[index_member].time_end = date;
          _this6.list_project_month[index].state[index_state].member[index_member].time_start = date_start;
          _this6.get_task_in_day();
          _this6.get_task_in_month(_this6.date2);
          // this.check_range_date()
          // console.log(this.listproject)
        }
      });
    },
    get_task_by_id: function get_task_by_id(taskid, stateid, stateevent, oldstate) {
      var _this7 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_by_id', {
        tokenuser: this.token,
        task_id: taskid
      }).then(function (responsed) {
        if (responsed.data.status == 'success') {
          // console.log(responsed.data.data)
          // this.list_project_month.unshift(responsed.data.data)
          var old_index = '';
          var index_member = '';
          var index = '';
          if (stateevent == 'edit') {
            old_index = homepage_calendar__.findIndex(_this7.detail_project.state, function (o) {
              return o.state_id == oldstate;
            });
            index_member = homepage_calendar__.findIndex(_this7.detail_project.state[old_index].member, function (o) {
              return o._id == taskid;
            });
            index = homepage_calendar__.findIndex(_this7.detail_project.state, function (o) {
              return o.state_id == stateid;
            });
            _this7.detail_project.state[old_index].member.splice(index_member, 1);
            _this7.detail_project.state[index].member.unshift(responsed.data.data);
          } else if (stateevent == 'create') {
            index = homepage_calendar__.findIndex(_this7.detail_project.state, function (o) {
              return o.state_id == stateid;
            });
            _this7.detail_project.state[index].member.unshift(responsed.data.data);
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18c7a260","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/manage_task/homepage_calendar.vue
var homepage_calendar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"CSChatThai",staticStyle:{"overflow":"hidden !important"},attrs:{"fluid":""}},[(_vm.status_login === 'T')?_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","wrap":""}},[(_vm.progress)?_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{staticClass:"height-100vh",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":100,"indeterminate":_vm.progress,"color":"primary"}})],1)],1):_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{staticClass:"chatboxnonselect mt-2",attrs:{"justify-center":"","column":""}},[_c('v-layout',{staticClass:"mt-3",attrs:{"justify-center":"","wrap":"","row":"","align-center":""}},[_c('v-flex',{staticClass:"color-card-task ml-3 mr-3",attrs:{"xs10":"","sm10":"","md10":"","lg10":"","xl10":""}},[_c('v-layout',{staticClass:"mb-2 mt-3 ml-4 mr-4",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('h2',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.datetimecheck(_vm.date)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"btn-create-task mb-3 ml-2",on:{"click":function($event){_vm.open_create_task()}}},[_c('v-icon',{staticClass:"icon-create-task",attrs:{"left":""}},[_vm._v("fas fa-plus")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Task.allTask.createTask')))])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mb-2 mt-0 ml-2",attrs:{"xs12":""}},[(!_vm.progress_project)?_c('v-sheet',{attrs:{"height":"500"}},[_c('v-calendar',{ref:"calendar",attrs:{"now":_vm.start,"value":_vm.date,"locale":_vm.$t('Task.allTask.localepicker'),"color":"primary"},scopedSlots:_vm._u([{key:"day",fn:function(date){return [_vm._l((_vm.listdataTask),function(member,index){return [(member.time == date.date)?_c('v-layout',{key:index,attrs:{"row":"","wrap":""}},[_c('v-menu',{staticStyle:{"width":"100%"},attrs:{"nudge-width":300,"close-on-content-click":false},model:{value:(member.dialog),callback:function ($$v) {_vm.$set(member, "dialog", $$v)},expression:"member.dialog"}},[_c('div',{staticStyle:{"width":"100%"},attrs:{"slot":"activator"},slot:"activator"},[_vm._l((member.task),function(roomname,index2){return [(index2 < 2)?_c('div',{key:index2,staticClass:"my-event",domProps:{"innerHTML":_vm._s(roomname)},on:{"click":function($event){_vm.get_task_in_day(member.time, roomname)}}}):_vm._e()]}),_vm._v(" "),(member.task.length > 2)?_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.get_task_in_day(member.time)}}},[_c('p',{staticStyle:{"font-size":"11px"}},[_vm._v(_vm._s(_vm.$t('Task.allTask.detailProject')))])]):_vm._e()],2),_vm._v(" "),_c('v-card',[_c('v-toolbar',{attrs:{"dense":"","dark":"","color":"#1a222c"}},[(_vm.checkroomname)?_c('p',{staticClass:"mt-3",staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm.checkroomname)+" ("+_vm._s(_vm.datetime(date))+")")]):_c('p',{staticClass:"mt-3",staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('HeaderMenubar.project'))+" ("+_vm._s(_vm.datetime(date))+")")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{attrs:{"right":""},on:{"click":function($event){member.dialog = false}}},[_vm._v("\n                                        mdi-close\n                                      ")])],1),_vm._v(" "),_c('v-layout',{staticClass:"ml-3 mt-3"},[_c('v-text-field',{staticClass:"searchBox",attrs:{"solo":"","label":_vm.$t('Task.allTask.placeholderSearchProject'),"clearable":"","append-icon":"search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-layout',{staticClass:"mr-3 ml-3 mt-1",staticStyle:{"background-color":"#f4f1f1","border-radius":"20px"},attrs:{"wrap":"","align-center":"","justify-center":"","fill-height":""}},[_c('v-layout',{staticClass:"taskScroll",staticStyle:{"height":"calc(100vh - 530px) !important","overflow-y":"auto"},attrs:{"align-start":"","justify-end":"","row":"","fill-height":""}},[_c('v-flex',[(_vm.progress_task)?_c('v-layout',{staticStyle:{"height":"25vh !important"},attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":40,"indeterminate":_vm.progress_task,"color":"primary"}})],1):(_vm.listproject.length != 0)?_vm._l((_vm.FilterListProject),function(item,i){return _c('v-layout',{key:i,staticClass:"mr-3 ml-3 mb-2",attrs:{"column":""}},[(_vm.listproject.length != 0)?_c('v-layout',{staticClass:"mb-2 mt-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-left"},[_c('h3',{staticClass:"text-overflow-projectname"},[_vm._v(_vm._s(item.project_name))])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right mt-1"},[_c('span',{staticClass:"text-overflow-groupname"},[_vm._v(_vm._s(item.room_name))])])],1):_vm._e(),_vm._v(" "),_c('v-expansion-panel',_vm._l((item.state),function(state,index){return (state.member.length != 0)?_c('v-expansion-panel-content',{attrs:{"expand-icon":"mdi-menu-down"}},[(state.member.length != 0)?_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(state.name)+"\n                                                    "),_c('span',{staticClass:"span-numtask"},[_vm._v(_vm._s(_vm.$t('Task.allTask.numTask',{count: state.member.length})))])]):_vm._e(),_vm._v(" "),_c('v-card',[_c('v-list',[_vm._l((state.member),function(member,indexmember){return [_c('v-list-tile',{key:member._id,class:_vm.checkpriorityTask(member.priority),attrs:{"avatar":""},on:{"click":function($event){_vm.open_detail_task(member._id, _vm.listproject[i].tokenroom)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('span',{staticClass:"pl-2"},[_vm._v(_vm._s(member.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(member.count_comment != '0')?_c('v-icon',{staticStyle:{"font-size":"19px"},attrs:{"color":"#d8d8d8"}},[_vm._v("fas fa-comment-dots")]):_vm._e(),_vm._v(" "),(member.count_comment != '0')?_c('span',{staticClass:"ml-2 mr-2",staticStyle:{"color":"#515050","font-size":"13px"}},[_vm._v(_vm._s(member.count_comment))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"ml-3",staticStyle:{"color":"#515050","font-size":"13px"}},[_vm._v(_vm._s(_vm.datetime(member.time_end)))])],1)],1)],1)],1),_vm._v(" "),(indexmember + 1 < state.member.length)?_c('v-divider',{key:indexmember}):_vm._e()]})],2)],1)],1):_vm._e()}))],1)}):_c('v-layout',{staticClass:"mt-5",attrs:{"row":"","wrap":"","align-center":"","justify-center":"","fill-height":""}},[_c('h4',[_vm._v(_vm._s(_vm.$t('Task.allTask.noCardTask')))])])],2)],1)],1),_vm._v(" "),_c('v-card-actions')],1)],1)],1):_vm._e()]})]}}]),model:{value:(_vm.date2),callback:function ($$v) {_vm.date2=$$v},expression:"date2"}})],1):_c('v-sheet',{staticStyle:{"background-color":"#fff0"},attrs:{"height":"500"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{staticStyle:{"margin-top":"100px"},attrs:{"size":100,"indeterminate":_vm.progress_project,"color":"primary"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-sm-left ml-3 mb-2"},[_c('v-btn',{staticClass:"btn_prev_next",on:{"click":function($event){_vm.$refs.calendar.prev()}}},[_vm._v("\n                      "+_vm._s(_vm.$t('Register.Button.back'))+"\n                    ")])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-sm-right mb-2"},[_c('v-btn',{staticClass:"btn_prev_next",on:{"click":function($event){_vm.$refs.calendar.next()}}},[_vm._v("\n                      "+_vm._s(_vm.$t('Task.allTask.next'))+"\n                    ")])],1)],1)],1)],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('CreateTask',{attrs:{"dialogCreateTaskCalendar":_vm.dialogCreateTaskCalendar},on:{"closeCreateTask":_vm.closeCreateTask,"createdtask":_vm.createdtask}}),_vm._v(" "),_c('DetailTask',{attrs:{"dialogDetailTask":_vm.dialogDetailTask,"taskid":_vm.taskid,"roomid":_vm.roomid},on:{"closeDetailTask":_vm.closeDetailTask,"edittask":_vm.edittask,"deletetask":_vm.deletetask,"commenttask":_vm.commenttask}})],1)}
var homepage_calendar_staticRenderFns = []
var homepage_calendar_esExports = { render: homepage_calendar_render, staticRenderFns: homepage_calendar_staticRenderFns }
/* harmony default export */ var manage_task_homepage_calendar = (homepage_calendar_esExports);
// CONCATENATED MODULE: ./src/components/chat/manage_task/homepage_calendar.vue
function homepage_calendar_injectStyle (ssrContext) {
  __webpack_require__("uSQs")
}
var homepage_calendar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var homepage_calendar___vue_template_functional__ = false
/* styles */
var homepage_calendar___vue_styles__ = homepage_calendar_injectStyle
/* scopeId */
var homepage_calendar___vue_scopeId__ = "data-v-18c7a260"
/* moduleIdentifier (server only) */
var homepage_calendar___vue_module_identifier__ = null
var homepage_calendar_Component = homepage_calendar_normalizeComponent(
  homepage_calendar,
  manage_task_homepage_calendar,
  homepage_calendar___vue_template_functional__,
  homepage_calendar___vue_styles__,
  homepage_calendar___vue_scopeId__,
  homepage_calendar___vue_module_identifier__
)

/* harmony default export */ var chat_manage_task_homepage_calendar = (homepage_calendar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/task/homepage_all_project_mo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var homepage_all_project_mo__ = __webpack_require__("M4fF");
/* harmony default export */ var homepage_all_project_mo = ({
  data: function data() {
    return {
      tabs: '',
      tokenuser: '',
      listproject_user: [],
      listproject_group: [],
      listproject: [],
      progress: false,
      search: '',
      search_group: ''
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    this.get_project_by_tokenuser();
  },

  components: {
    vue100vh: vue100vh["a" /* default */]
  },
  computed: {
    FilterListProject: function FilterListProject() {
      var _this = this;

      if (this.search !== '' && this.search !== null) {
        return this.listproject_user.filter(function (post) {
          return post.project_name.toLowerCase().includes(_this.search.toLowerCase());
        });
      } else {
        return this.listproject_user;
      }
    },
    FilterListProjectGroup: function FilterListProjectGroup() {
      var _this2 = this;

      if (this.search_group !== '' && this.search_group !== null) {
        return this.listproject_group.filter(function (post) {
          return post.project_name.toLowerCase().includes(_this2.search_group.toLowerCase());
        });
      } else {
        return this.listproject_group;
      }
    }
  },
  methods: {
    datetime: function datetime(timestamp) {
      return this.$i18n.locale == 'th' ? services["c" /* Momenttime */].momentdatethai(timestamp) : services["c" /* Momenttime */].momentdateen(timestamp);
    },
    toPage: function toPage(path) {
      this.$router.push(path);
    },
    topage_task: function topage_task(projectid, tokenroom) {
      this.$router.push('/mobile/task/' + projectid + '/' + tokenroom);
    },
    get_project_by_tokenuser: function get_project_by_tokenuser() {
      var _this3 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_tokenuser', {
        tokenuser: this.tokenuser
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this3.progress = false;
          _this3.listproject = response.data.data;
          _this3.listproject = homepage_all_project_mo__.reverse(homepage_all_project_mo__.sortBy(_this3.listproject, function (dateObj) {
            return new Date(dateObj.timestamp);
          }));
          // console.log(this.listproject)
          _this3.listproject_group = homepage_all_project_mo__.filter(_this3.listproject, function (o) {
            return o.tokenroom.startsWith('G');
          });
          _this3.listproject_user = homepage_all_project_mo__.filter(_this3.listproject, function (o) {
            return o.tokenroom.startsWith('R');
          });
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133c8400","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/task/homepage_all_project_mo.vue
var homepage_all_project_mo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-container',{staticClass:"pl-0 pr-0 pt-0 pb-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","child-flex":"","wrap":""}},[_c('div',[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/homepage')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('HeaderMenubar.project')))])],1)],1)]),_vm._v(" "),(_vm.progress)?_c('v-layout',{staticClass:"mt-2 ml-4 mr-4 layout-height",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":"80","indeterminate":_vm.progress,"color":"primary"}})],1):_c('v-layout',{staticClass:"mt-2 ml-4 mr-4",attrs:{"row":"","wrap":""}},[_c('v-btn',{attrs:{"absolute":"","dark":"","fab":"","bottom":"","right":"","color":"primary","small":""},on:{"click":function($event){_vm.toPage('/mobile/task/createproject')}}},[_c('v-icon',{staticStyle:{"color":"white !important"}},[_vm._v("add")])],1),_vm._v(" "),_c('v-tabs',{staticClass:"width-100 backgorundMobile",attrs:{"left":"","color":"white","dark":"","icons-and-text":""},model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('v-tabs-slider',{attrs:{"color":"#232b35"}}),_vm._v(" "),_c('v-tab',{key:1,attrs:{"href":"#tab-1"}},[_c('p',{staticStyle:{"color":"#232b35","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.friend')))]),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"20px"},attrs:{"color":"#232b35"}},[_vm._v("fas fa-user")])],1),_vm._v(" "),_c('v-tab',{key:2,attrs:{"href":"#tab-2"}},[_c('p',{staticStyle:{"color":"#232b35","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.group')))]),_vm._v(" "),_c('v-icon',{staticStyle:{"font-size":"20px"},attrs:{"color":"#232b35"}},[_vm._v("fas fa-users")])],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-1"}},[_c('v-layout',{staticClass:"bg-white",attrs:{"row":"","wrap":"","align-center":"","justify-end":""}},[(_vm.listproject_user.length != 0)?_c('v-flex',{staticClass:"mx-auto mt-3",attrs:{"xs11":"","sm11":"","md11":""}},[_c('v-text-field',{attrs:{"solo":"","label":_vm.$t('Task.allTask.placeholderSearchProject'),"clearable":"","append-icon":"search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"layout-height backgorundMobile",attrs:{"flat":""}},_vm._l((_vm.FilterListProject),function(item,index){return (_vm.listproject_user.length != 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticClass:"mb-3 mr-1 ml-1 mt-3 card-project",on:{"click":function($event){_vm.topage_task(item._id, item.tokenroom)}}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":"","lg12":"","xl12":""},on:{"click":function($event){_vm.topage_task(item._id, item.tokenroom)}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('div',{staticClass:"font-size-20 font-weight-bold text-overflow-project ml-3 mt-2"},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"color-grey mr-3 mt-3",staticStyle:{"font-size":"12px"}},[_vm._v("\n                          "+_vm._s(_vm.datetime(item.timestamp))+"\n                        ")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{staticClass:"ml-2 mt-0",attrs:{"column":"","justify-end":""}},[_c('div',{staticClass:"text-overflow-detail",staticStyle:{"font-size":"13px"}},[_vm._v("\n                            "+_vm._s(item.detail)+"\n                          ")])]),_vm._v(" "),_vm._l((item.state),function(i){return [(i.name.includes('Todo') || i.name.includes('todo'))?_c('v-chip',{staticClass:"chipColorTodo",attrs:{"small":"","label":""}},[_vm._v("\n                            "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                          ")]):(i.name.includes('Doing') || i.name.includes('doing'))?_c('v-chip',{staticClass:"chipColorDoing",attrs:{"small":"","label":""}},[_vm._v("\n                            "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                          ")]):(i.name.includes('Done') ||i.name.includes('done'))?_c('v-chip',{staticClass:"chipColorDone",attrs:{"small":"","label":""}},[_vm._v("\n                            "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                          ")]):_c('v-chip',{staticClass:"chipColorEtc",attrs:{"small":"","label":""}},[_vm._v("\n                            "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                          ")])]})],2),_vm._v(" "),_c('v-layout',{staticClass:"ml-3 mb-2",attrs:{"row":"","wrap":""}},[_c('v-avatar',{attrs:{"size":"35px"}},[(item.path_pic)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.path_pic}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"text-overflow-project mt-2 ml-2",staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(item.room_name))])],1)],1)],1)],1)],1):_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"font-size":"60px !important"}},[_vm._v("fas fa-tasks")]),_vm._v(" "),_c('h4',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$t('Task.allTask.noProjectList')))])],1)],1)}))],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[_c('v-layout',{staticClass:"bg-white",attrs:{"row":"","wrap":"","align-center":"","justify-end":""}},[(_vm.listproject_group.length != 0)?_c('v-flex',{staticClass:"mx-auto mt-3",attrs:{"xs11":"","sm11":"","md11":""}},[_c('v-text-field',{attrs:{"solo":"","label":_vm.$t('Task.allTask.placeholderSearchProject'),"clearable":"","append-icon":"search"},model:{value:(_vm.search_group),callback:function ($$v) {_vm.search_group=$$v},expression:"search_group"}})],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"layout-height backgorundMobile",attrs:{"flat":""}},_vm._l((_vm.FilterListProjectGroup),function(item,index){return (_vm.listproject_group.length != 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticClass:"mb-3 mr-1 ml-1 mt-3 card-project",on:{"click":function($event){_vm.topage_task(item._id, item.tokenroom)}}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":"","lg12":"","xl12":""},on:{"click":function($event){_vm.topage_task(item._id, item.tokenroom)}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('div',{staticClass:"font-size-20 font-weight-bold text-overflow-project ml-3 mt-2"},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"color-grey mr-3 mt-3",staticStyle:{"font-size":"12px"}},[_vm._v("\n                          "+_vm._s(_vm.datetime(item.timestamp))+"\n                        ")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{staticClass:"ml-2 mt-0",attrs:{"column":"","justify-end":""}},[_c('div',{staticClass:"text-overflow-detail",staticStyle:{"font-size":"13px"}},[_vm._v("\n                            "+_vm._s(item.detail)+"\n                          ")])]),_vm._v(" "),_vm._l((item.state),function(i){return [(i.name.includes('Todo') || i.name.includes('todo'))?_c('v-chip',{staticClass:"chipColorTodo",attrs:{"small":"","label":""}},[_vm._v("\n                            "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                          ")]):(i.name.includes('Doing') || i.name.includes('doing'))?_c('v-chip',{staticClass:"chipColorDoing",attrs:{"small":"","label":""}},[_vm._v("\n                            "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                          ")]):(i.name.includes('Done') ||i.name.includes('done'))?_c('v-chip',{staticClass:"chipColorDone",attrs:{"small":"","label":""}},[_vm._v("\n                            "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                          ")]):_c('v-chip',{staticClass:"chipColorEtc",attrs:{"small":"","label":""}},[_vm._v("\n                            "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                          ")])]})],2),_vm._v(" "),_c('v-layout',{staticClass:"ml-3 mb-2",attrs:{"row":"","wrap":""}},[_c('v-avatar',{attrs:{"size":"35px"}},[(item.path_pic)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.path_pic}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"text-overflow-project mt-2 ml-2",staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(item.room_name))])],1)],1)],1)],1)],1):_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"font-size":"60px !important"}},[_vm._v("fas fa-tasks")]),_vm._v(" "),_c('h4',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$t('Task.allTask.noProjectList')))])],1)],1)}))],1)],1)],1)],1)],1)],1)}
var homepage_all_project_mo_staticRenderFns = []
var homepage_all_project_mo_esExports = { render: homepage_all_project_mo_render, staticRenderFns: homepage_all_project_mo_staticRenderFns }
/* harmony default export */ var task_homepage_all_project_mo = (homepage_all_project_mo_esExports);
// CONCATENATED MODULE: ./src/components/mobile/task/homepage_all_project_mo.vue
function homepage_all_project_mo_injectStyle (ssrContext) {
  __webpack_require__("1Rv0")
}
var homepage_all_project_mo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var homepage_all_project_mo___vue_template_functional__ = false
/* styles */
var homepage_all_project_mo___vue_styles__ = homepage_all_project_mo_injectStyle
/* scopeId */
var homepage_all_project_mo___vue_scopeId__ = "data-v-133c8400"
/* moduleIdentifier (server only) */
var homepage_all_project_mo___vue_module_identifier__ = null
var homepage_all_project_mo_Component = homepage_all_project_mo_normalizeComponent(
  homepage_all_project_mo,
  task_homepage_all_project_mo,
  homepage_all_project_mo___vue_template_functional__,
  homepage_all_project_mo___vue_styles__,
  homepage_all_project_mo___vue_scopeId__,
  homepage_all_project_mo___vue_module_identifier__
)

/* harmony default export */ var mobile_task_homepage_all_project_mo = (homepage_all_project_mo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/task/created_task_dialog_mo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import DateRangePicker from 'vue2-daterange-picker'
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
var created_task_dialog_mo__ = __webpack_require__("M4fF");
/* harmony default export */ var created_task_dialog_mo = ({
  props: {
    dialogCreateTask: false,
    projectid: ''
  },
  data: function data() {
    return {
      detail_task: '',
      token: '',
      subject_task: '',
      radios: '1',
      menu1: false,
      menu2: false,
      start_date: new Date().toISOString().substr(0, 10),
      end_date: new Date().toISOString().substr(0, 10),
      min_date: '',
      max_date: '',
      priority: '1',
      member: [],
      state: [],
      state_id: '',
      selectemember: [],
      subject_taskRules: [function (v) {
        return !!v || 'กรุณากรอกหัวข้อการ์ดงาน';
      }],
      isloading: false,
      min_date_end: '',
      max_date_end: ''
      // dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10))
    };
  },
  components: {
    // DateRangePicker
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },
  mounted: function mounted() {},

  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.date);
    }
  },
  watch: {
    dialogCreateTask: function dialogCreateTask() {
      // console.log(this.dialogCreateTask)
      if (this.dialogCreateTask) {
        this.getroom();
        this.getstate();
      }
    }
  },
  methods: {
    allowedDates: function allowedDates(val) {
      this.min_date_end = this.start_date;
      if (this.start_date > this.end_date) {
        this.end_date = this.start_date;
      }
      return this.min_date_end;
    },
    allowedDatesEnd: function allowedDatesEnd(val) {
      this.min_date_end = this.start_date;
      if (this.min_date_end > this.end_date) {
        this.end_date = this.min_date_end;
      }
      return this.end_date;
    },
    closeDialog: function closeDialog() {
      this.selectemember = [];
      this.priority = '1';
      this.detail_task = '';
      this.subject_task = '';
      this.start_date = new Date().toISOString().substr(0, 10), this.end_date = new Date().toISOString().substr(0, 10), this.$emit('closeCreateTask', false);
    },
    getstate: function getstate() {
      var _this = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_state_by_project', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_id: this.projectid
      }).then(function (response) {
        _this.state = response.data.data.state;
        _this.state_id = response.data.data.state[0].state_id;
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    cancel_task: function cancel_task() {
      var _this2 = this;

      this.$swal({
        text: this.$t('Alert.Task.removeData'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this2.selectemember = [];
          _this2.priority = '1';
          _this2.detail_task = '';
          _this2.subject_task = '';
          _this2.start_date = new Date().toISOString().substr(0, 10), _this2.end_date = new Date().toISOString().substr(0, 10);
        }
      });
    },
    add_task: function add_task() {
      var _this3 = this;

      this.isloading = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/create_task', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        title: this.subject_task,
        detail: this.detail_task,
        state_id: this.state_id,
        time_start: this.start_date + ' 00:00:00',
        time_end: this.end_date + ' 00:00:00',
        priority: this.priority,
        project_id: this.projectid,
        assign: this.selectemember
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data.data.task_id)
          _this3.isloading = false;
          _this3.$swal('', _this3.$t('Alert.Success.createTask'), 'success');
          _this3.$emit('createdtask', { 'task_id': response.data.data.task_id, 'state_id': _this3.state_id, 'event': 'create' });
          _this3.closeDialog();
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    getroom: function getroom() {
      var _this4 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        if (response.data.status === 'success') {
          var member_active = [];
          member_active = response.data.data_room;
          _this4.member = created_task_dialog_mo__.filter(member_active, function (o) {
            return o.type !== 'bot' && o.statemember == 'active';
          });
          _this4.member.push({
            tokenuser: _this4.token,
            name: localStorage.getItem('name'),
            profilepicture: localStorage.getItem('profilepicture')
          });
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5884ff73","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/task/created_task_dialog_mo.vue
var created_task_dialog_mo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"CSChatThai",attrs:{"persistent":"","max-width":"720"},model:{value:(_vm.dialogCreateTask),callback:function ($$v) {_vm.dialogCreateTask=$$v},expression:"dialogCreateTask"}},[_c('v-card',[_c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-toolbar',{staticClass:"toolbar-card-v2",attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"CSChatThai"},[_vm._v("\n          "+_vm._s(_vm.$t('Task.create.header'))+"\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"black !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"CSChatThai",staticStyle:{"overflow-y":"scroll","height":"70vh"}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.subject'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject_task),expression:"subject_task"}],staticClass:"CSChatThai inputtaskweb",attrs:{"type":"text","placeholder":_vm.$t('Task.create.placeholderSubject')},domProps:{"value":(_vm.subject_task)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject_task=$event.target.value}}})]),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.priority'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-btn',{class:(_vm.priority=='1')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '1';}}},[_c('v-icon',{staticClass:"btn-pri1"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p1'))+"\n              ")],1),_vm._v(" "),_c('v-btn',{class:(_vm.priority=='2')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '2';}}},[_c('v-icon',{staticClass:"btn-pri2"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p2'))+"\n              ")],1),_vm._v(" "),_c('v-btn',{class:(_vm.priority=='3')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '3';}}},[_c('v-icon',{staticClass:"btn-pri3"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p3'))+"\n              ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.startDate'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-menu',{ref:"menu1",staticStyle:{"width":"100%"},attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.start_date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":""},on:{"update:returnValue":function($event){_vm.start_date=$event}},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"","readonly":""},slot:"activator",model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","allowed-dates":_vm.allowedDates},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu1 = false}}},[_vm._v("\n                  "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menu1.save(_vm.start_date)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.endDate'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-menu',{ref:"menu2",staticStyle:{"width":"100%"},attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.end_date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":""},on:{"update:returnValue":function($event){_vm.end_date=$event}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"","readonly":""},slot:"activator",model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","allowed-dates":_vm.allowedDatesEnd,"min":_vm.min_date_end},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu2 = false}}},[_vm._v("\n                  "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menu2.save(_vm.end_date)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.description'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-textarea',{staticStyle:{"width":"100%"},attrs:{"label":_vm.$t('Task.create.placeholderDescription'),"solo":"","no-resize":"","outline":"","height":"80","rows":"3","hide-details":""},model:{value:(_vm.detail_task),callback:function ($$v) {_vm.detail_task=$$v},expression:"detail_task"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.assign'))+" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-autocomplete',{staticStyle:{"width":"75%"},attrs:{"items":_vm.member,"label":_vm.$t('Task.create.placeholderAssign'),"item-text":"name","item-value":"tokenuser","multiple":"","chips":"","max-height":"auto"},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [(data.item.type !== 'bot')?_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selectemember,"close":""},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_c('v-avatar',[(data.item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":data.item.profilepicture}}):(data.item.type === 'company')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'government')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"text-overflow-chip"},[_vm._v(_vm._s(data.item.name))])],1):_vm._e()]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[(data.item.type !== 'bot')?_c('v-list-tile-avatar',[(data.item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":data.item.profilepicture}}):(data.item.type === 'company')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'government')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[(data.item.type !== 'bot')?_c('v-list-tile-title',{staticClass:"text-overflow"},[_vm._v(_vm._s(data.item.name))]):_vm._e()],1)]]}}]),model:{value:(_vm.selectemember),callback:function ($$v) {_vm.selectemember=$$v},expression:"selectemember"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.status'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-select',{staticStyle:{"padding":"0","width":"25%"},attrs:{"items":_vm.state,"outlined":"","hide-details":"","item-text":"name","item-value":"state_id"},model:{value:(_vm.state_id),callback:function ($$v) {_vm.state_id=$$v},expression:"state_id"}})],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"margin-top":"15px"},attrs:{"row":"","wrap":"","align-end":"","justify-center":""}},[_c('v-btn',{staticClass:"btncancle",on:{"click":function($event){_vm.cancel_task()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"btncreate",attrs:{"loading":_vm.isloading,"disabled":_vm.subject_task == '' || _vm.priority == undefined || _vm.start_date == '' || _vm.end_date == ''},on:{"click":function($event){_vm.add_task()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1)],1)}
var created_task_dialog_mo_staticRenderFns = []
var created_task_dialog_mo_esExports = { render: created_task_dialog_mo_render, staticRenderFns: created_task_dialog_mo_staticRenderFns }
/* harmony default export */ var task_created_task_dialog_mo = (created_task_dialog_mo_esExports);
// CONCATENATED MODULE: ./src/components/mobile/task/created_task_dialog_mo.vue
function created_task_dialog_mo_injectStyle (ssrContext) {
  __webpack_require__("OWfu")
}
var created_task_dialog_mo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var created_task_dialog_mo___vue_template_functional__ = false
/* styles */
var created_task_dialog_mo___vue_styles__ = created_task_dialog_mo_injectStyle
/* scopeId */
var created_task_dialog_mo___vue_scopeId__ = "data-v-5884ff73"
/* moduleIdentifier (server only) */
var created_task_dialog_mo___vue_module_identifier__ = null
var created_task_dialog_mo_Component = created_task_dialog_mo_normalizeComponent(
  created_task_dialog_mo,
  task_created_task_dialog_mo,
  created_task_dialog_mo___vue_template_functional__,
  created_task_dialog_mo___vue_styles__,
  created_task_dialog_mo___vue_scopeId__,
  created_task_dialog_mo___vue_module_identifier__
)

/* harmony default export */ var mobile_task_created_task_dialog_mo = (created_task_dialog_mo_Component.exports);

// EXTERNAL MODULE: ./src/components/mobile/task/detail_task_dialog_mo.vue + 2 modules
var detail_task_dialog_mo = __webpack_require__("Dp7v");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/task/homepage_task_mo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var homepage_task_mo__ = __webpack_require__("M4fF");
/* harmony default export */ var homepage_task_mo = ({
  data: function data() {
    return {
      tokenuser: '',
      detail_project: {},
      projectid: '',
      progress: false,
      taskid: '',
      roomid: '',
      dialogDetailTask: false,
      dialogCreateTask: false,
      member: [],
      dialogDetailProject: false,
      image_profile: '',
      widthScreen: document.documentElement.clientWidth,
      width: document.documentElement.clientWidth
    };
  },
  components: {
    CreateTask: mobile_task_created_task_dialog_mo,
    DetailTask: detail_task_dialog_mo["a" /* default */],
    vue100vh: vue100vh["a" /* default */]
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    this.get_data_room();
    window.addEventListener('resize', this.getDimensions);
  },

  watch: {
    windowWidth: function windowWidth() {
      if (this.windowWidth > 960) {
        this.$router.push('/chat/homepage');
      }
    },
    socketmessage: function socketmessage(data) {
      // console.log(data)
      if (data.tokenuser !== this.tokenuser) {
        if (data.message == 'create_task') {
          this.get_task_by_id(data.task_id, data.state.state_id, 'create');
        }
      }
    },
    socket_deletetask: function socket_deletetask(data) {
      var _this = this;

      // console.log(data)
      if (data.tokenuser !== this.tokenuser) {
        this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_id', {
          tokenuser: this.tokenuser,
          tokenroom: this.$route.params.roomid,
          project_id: this.projectid
        }).then(function (responsed) {
          // console.log(responsed.data.data)
          if (responsed.data.status == 'success') {
            _this.detail_project = responsed.data.data;
          }
        });
      }
    },
    socket_edittask: function socket_edittask(data) {
      var _this2 = this;

      // console.log(data)
      if (data.tokenuser !== this.tokenuser) {
        this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_by_id', {
          tokenuser: this.tokenuser,
          task_id: data.task_id
        }).then(function (responsed) {
          if (responsed.data.status == 'success') {
            // console.log(responsed.data.data)
            var new_state = responsed.data.data.state.id;
            var old_index = '';
            var index_member = '';
            var index = '';
            old_index = homepage_task_mo__.findIndex(_this2.detail_project.state, function (o) {
              return o.state_id == data.state_id.id;
            });
            index_member = homepage_task_mo__.findIndex(_this2.detail_project.state[old_index].member, function (o) {
              return o._id == data.task_id;
            });
            index = homepage_task_mo__.findIndex(_this2.detail_project.state, function (o) {
              return o.state_id == new_state;
            });
            _this2.detail_project.state[old_index].member.splice(index_member, 1);
            _this2.detail_project.state[index].member.unshift(responsed.data.data);
          }
        });
      }
    }
  },
  methods: {
    toPage: function toPage() {
      this.$router.go(-1);
    },
    getDimensions: function getDimensions() {
      this.width = document.documentElement.clientWidth;
    },
    get_data_room: function get_data_room() {
      var _this3 = this;

      this.detail = {};
      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: this.tokenuser,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this3.progress = false;
          _this3.detail = response.data;
          var member = [];
          member = response.data.data_room;
          _this3.member = homepage_task_mo__.filter(member, function (o) {
            return o.statemember == 'active';
          });
          _this3.get_project_by_id(_this3.$route.params.projectid);
        }
      });
    },
    get_project_by_id: function get_project_by_id() {
      var _this4 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_id', {
        tokenuser: this.tokenuser,
        tokenroom: this.$route.params.roomid,
        project_id: this.$route.params.projectid
      }).then(function (responsed) {
        // console.log(responsed.data.data)
        _this4.progress = false;
        if (responsed.data.status == 'success') {
          _this4.projectid = _this4.$route.params.projectid;
          _this4.detail_project = responsed.data.data;
          _this4.image_profile = responsed.data.data.owner_info.path_pic;
        }
      });
    },
    checkpriorityTask: function checkpriorityTask(priority) {
      if (priority == '1' || priority == '2' || priority == '3') {
        return 'card-task-pri' + priority;
      } else {
        return 'card-task-pri3';
      }
    },
    open_detail_task: function open_detail_task(taskid, tokenroom) {
      // console.log(tokenroom)
      this.taskid = taskid;
      this.roomid = tokenroom;
      // console.log(this.StateId)
      this.dialogDetailTask = true;
    },
    closeDetailTask: function closeDetailTask(value) {
      this.dialogDetailTask = value;
    },
    open_create_task: function open_create_task() {
      this.dialogCreateTask = true;
    },
    createdtask: function createdtask(value) {
      this.get_task_by_id(value.task_id, value.state_id, value.event);
    },
    closeCreateTask: function closeCreateTask(value) {
      this.dialogCreateTask = value;
    },
    edittask: function edittask(data) {
      // console.log(data)
      this.get_task_by_id(data.task_id, data.state_id, data.event, data.old_state);
    },
    deletetask: function deletetask(data) {
      // console.log(data)
      var index = homepage_task_mo__.findIndex(this.detail_project.state, function (o) {
        return o.state_id == data.state_id;
      });
      var index_member = homepage_task_mo__.findIndex(this.detail_project.state[index].member, function (o) {
        return o._id == data.task_id;
      });
      this.detail_project.state[index].member.splice(index_member, 1);
    },
    commenttask: function commenttask(data) {
      var index = homepage_task_mo__.findIndex(this.detail_project.state, function (o) {
        return o.state_id == data.state_id;
      });
      var index_member = homepage_task_mo__.findIndex(this.detail_project.state[index].member, function (o) {
        return o._id == data.task_id;
      });
      this.detail_project.state[index].member[index_member].count_comment = data.count_comment;
    },
    get_task_by_id: function get_task_by_id(taskid, stateid, stateevent, oldstate) {
      var _this5 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_by_id', {
        tokenuser: this.tokenuser,
        task_id: taskid
      }).then(function (responsed) {
        if (responsed.data.status == 'success') {
          // console.log(responsed.data.data)
          var old_index = '';
          var index_member = '';
          var index = '';
          if (stateevent == 'edit') {
            old_index = homepage_task_mo__.findIndex(_this5.detail_project.state, function (o) {
              return o.state_id == oldstate;
            });
            index_member = homepage_task_mo__.findIndex(_this5.detail_project.state[old_index].member, function (o) {
              return o._id == taskid;
            });
            index = homepage_task_mo__.findIndex(_this5.detail_project.state, function (o) {
              return o.state_id == stateid;
            });
            _this5.detail_project.state[old_index].member.splice(index_member, 1);
            _this5.detail_project.state[index].member.unshift(responsed.data.data);
            // console.log(this.detail_project.state[index].member)
          } else if (stateevent == 'create') {
            index = homepage_task_mo__.findIndex(_this5.detail_project.state, function (o) {
              return o.state_id == stateid;
            });
            _this5.detail_project.state[index].member.unshift(responsed.data.data);
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b14fe19","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/task/homepage_task_mo.vue
var homepage_task_mo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-container',{staticClass:"pl-0 pr-0 pt-0 pb-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","child-flex":"","wrap":""}},[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-icon',{staticClass:"mr-3",staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage()}}},[_vm._v("chevron_left")]),_vm._v(" "),_c('div',{staticClass:"text-overflow",staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.detail_project.project_name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[(_vm.member.length !== 0)?_c('v-flex',{staticClass:"mt-2 mb-0"},[_vm._l((_vm.member),function(item,index){return [(index < 3 && _vm.width > 450)?_c('v-avatar',{staticClass:"ml-2",attrs:{"size":"35"}},[(item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.profilepicture}}):(item.type == 'user')?_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}}):(item.type == 'bot')?_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):(index < 2 && _vm.width <= 450 && _vm.width > 350)?_c('v-avatar',{staticClass:"ml-2",attrs:{"size":"35"}},[(item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.profilepicture}}):(item.type == 'user')?_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}}):(item.type == 'bot')?_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):(index < 1 && _vm.width <= 350)?_c('v-avatar',{staticClass:"ml-2",attrs:{"size":"35"}},[(item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.profilepicture}}):(item.type == 'user')?_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}}):(item.type == 'bot')?_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):_vm._e()]}),_vm._v(" "),((_vm.member.length - 3) > 0 && _vm.width > 450)?_c('v-avatar',{staticClass:"btn-plus-user",attrs:{"size":"18px"}},[_c('span',[_vm._v("+"+_vm._s(_vm.member.length - 3))])]):_vm._e(),_vm._v(" "),((_vm.member.length - 2) > 0 && _vm.width <= 450 && _vm.width > 350)?_c('v-avatar',{staticClass:"btn-plus-user",attrs:{"size":"18px"}},[_c('span',[_vm._v("+"+_vm._s(_vm.member.length - 2))])]):_vm._e(),_vm._v(" "),((_vm.member.length - 1) > 0 && _vm.width <= 350)?_c('v-avatar',{staticClass:"btn-plus-user",attrs:{"size":"18px"}},[_c('span',[_vm._v("+"+_vm._s(_vm.member.length - 1))])]):_vm._e()],2):_c('v-flex',{staticClass:"mt-2 mb-0"},[_c('v-avatar',{attrs:{"size":"35"}},[(_vm.image_profile)?_c('img',{staticClass:"object-fit-img",attrs:{"src":_vm.image_profile}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),(_vm.detail_project.detail !== '')?_c('v-icon',{staticClass:"ml-2",staticStyle:{"color":"black"},on:{"click":function($event){_vm.dialogDetailProject = true}}},[_vm._v("more_vert")]):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{staticStyle:{"overflow-x":"hidden !important"},attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialogDetailProject),callback:function ($$v) {_vm.dialogDetailProject=$$v},expression:"dialogDetailProject"}},[_c('v-card',[_c('v-card-title',{staticClass:"font-size18"},[_vm._v(_vm._s(_vm.$t('Task.allTask.projectDetail')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"word-break":"break-all !important"}},[_vm._v(_vm._s(_vm.detail_project.detail))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"round":"","color":"primary darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogDetailProject = false}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1)],1),_vm._v(" "),(_vm.progress)?_c('v-layout',{staticClass:"mt-2 ml-4 mr-4 layout-height",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":"80","indeterminate":_vm.progress,"color":"primary"}})],1):_c('v-layout',{staticClass:"mt-2 layout-height",attrs:{"row":"","wrap":""}},[_c('v-btn',{attrs:{"absolute":"","dark":"","fab":"","bottom":"","right":"","color":"primary","small":""},on:{"click":function($event){_vm.open_create_task()}}},[_c('v-icon',{staticStyle:{"color":"white !important"}},[_vm._v("add")])],1),_vm._v(" "),_c('v-flex',{staticClass:"scrolling-wrapper",attrs:{"sm12":"","md12":"","xl12":"","lg12":""}},_vm._l((_vm.detail_project.state),function(item,index){return _c('div',[_c('v-layout',{staticClass:"ml-3",attrs:{"column":"","wrap":""}},[_c('v-flex',{attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticClass:"ml-2 font-size-14 mt-2 color-numtask"},[_vm._v("\n                    "+_vm._s(_vm.$t('Task.allTask.numTask',{count: item.member.length}))+"\n                  ")])]),_vm._v(" "),(item.name.includes('Todo') || item.name.includes('todo'))?_c('v-system-bar',{staticClass:"system-barTodo"}):(item.name.includes('Doing') || item.name.includes('doing'))?_c('v-system-bar',{staticClass:"system-barDoing"}):(item.name.includes('Done') ||item.name.includes('done'))?_c('v-system-bar',{staticClass:"system-barDone"}):_c('v-system-bar',{staticClass:"system-barEtc"})],1),_vm._v(" "),_c('div',{staticClass:"color-card-task"},[_c('v-container',{staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-xs":""}},_vm._l((item.member),function(member,indexmem){return _c('v-flex',{attrs:{"xs12":""}},[_c('div',{class:_vm.checkpriorityTask(member.priority),on:{"click":function($event){_vm.open_detail_task(member._id, _vm.detail_project.tokenroom)}}},[_c('p',{staticClass:"mb-0 font-title-task ml-2"},[_vm._v(_vm._s(member.title))]),_vm._v(" "),_c('v-layout',{staticClass:"mr-2 mt-2",attrs:{"row":"","wrap":"","justify-end":""}},[(member.count_comment != '0' && member.count_comment != undefined)?_c('v-icon',{staticClass:"ml-3",attrs:{"color":"#d8d8d8"}},[_vm._v("fas fa-comment-dots")]):_vm._e(),_vm._v(" "),(member.count_comment != '0' && member.count_comment != undefined)?_c('span',{staticClass:"ml-2 pt-1"},[_vm._v(_vm._s(member.count_comment))]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._l((member.assign),function(item,index){return (index < 3)?_c('v-avatar',{staticStyle:{"margin-left":"2px!important"},attrs:{"size":"30"}},[(item.path_pic)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.path_pic}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):_vm._e()}),_vm._v(" "),((member.assign.length - 3) > 0)?_c('span',{staticClass:"mt-1 ml-2"},[_vm._v("+"+_vm._s(member.assign.length - 3))]):_vm._e()],2)],1)])}))],1)],1)],1)}))],1)],1),_vm._v(" "),_c('CreateTask',{attrs:{"dialogCreateTask":_vm.dialogCreateTask,"projectid":_vm.projectid},on:{"closeCreateTask":_vm.closeCreateTask,"createdtask":_vm.createdtask}}),_vm._v(" "),_c('DetailTask',{attrs:{"dialogDetailTask":_vm.dialogDetailTask,"taskid":_vm.taskid,"roomid":_vm.roomid},on:{"closeDetailTask":_vm.closeDetailTask,"edittask":_vm.edittask,"deletetask":_vm.deletetask,"commenttask":_vm.commenttask}})],1)],1)}
var homepage_task_mo_staticRenderFns = []
var homepage_task_mo_esExports = { render: homepage_task_mo_render, staticRenderFns: homepage_task_mo_staticRenderFns }
/* harmony default export */ var task_homepage_task_mo = (homepage_task_mo_esExports);
// CONCATENATED MODULE: ./src/components/mobile/task/homepage_task_mo.vue
function homepage_task_mo_injectStyle (ssrContext) {
  __webpack_require__("F4Xa")
}
var homepage_task_mo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var homepage_task_mo___vue_template_functional__ = false
/* styles */
var homepage_task_mo___vue_styles__ = homepage_task_mo_injectStyle
/* scopeId */
var homepage_task_mo___vue_scopeId__ = "data-v-7b14fe19"
/* moduleIdentifier (server only) */
var homepage_task_mo___vue_module_identifier__ = null
var homepage_task_mo_Component = homepage_task_mo_normalizeComponent(
  homepage_task_mo,
  task_homepage_task_mo,
  homepage_task_mo___vue_template_functional__,
  homepage_task_mo___vue_styles__,
  homepage_task_mo___vue_scopeId__,
  homepage_task_mo___vue_module_identifier__
)

/* harmony default export */ var mobile_task_homepage_task_mo = (homepage_task_mo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/task/created_project_dialog_mo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import DateRangePicker from 'vue2-daterange-picker'
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
var created_project_dialog_mo__ = __webpack_require__("M4fF");
/* harmony default export */ var created_project_dialog_mo = ({
  props: {
    dialogCreateProject: false,
    projectid: ''
  },
  data: function data() {
    return {
      detail_project: '',
      token: '',
      subject_project: '',
      radios: '1',
      menu1: false,
      menu2: false,
      start_date: new Date().toISOString().substr(0, 10),
      end_date: new Date().toISOString().substr(0, 10),
      min_date: '',
      max_date: '',
      priority: '1',
      member: [],
      state: [],
      state_id: '',
      selectemember: [],
      subject_projectRules: [function (v) {
        return !!v || 'กรุณากรอกหัวข้อการ์ด';
      }],
      isloading: false,
      min_date_end: '',
      max_date_end: ''
      // dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10))
    };
  },
  components: {
    // DateRangePicker
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },
  mounted: function mounted() {},

  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.date);
    }
  },
  watch: {
    dialogCreateProject: function dialogCreateProject() {
      // console.log(this.dialogCreateTask)
      if (this.dialogCreateProject) {
        // this.getroom()
        // this.getstate()
      }
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.selectemember = [];
      this.priority = '1';
      this.detail_project = '';
      this.subject_project = '';
      this.start_date = new Date().toISOString().substr(0, 10), this.end_date = new Date().toISOString().substr(0, 10), this.$emit('closeCreateProject', false);
    },
    cancel_task: function cancel_task() {
      this.selectemember = [];
      this.priority = '1';
      this.detail_project = '';
      this.subject_project = '';
      this.isloading = false;
    },
    create_project: function create_project() {
      var _this = this;

      this.isloading = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/create_project', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_name: this.subject_project,
        detail: this.detail_project
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data.data)
          _this.isloading = false;
          // this.$swal('','สร้างโปรเจคสำเร็จ', 'success')
          _this.$swal({ title: _this.$t('Alert.Success.createProject'), type: 'success' });
          _this.$emit('createdproject', { 'project_id': response.data.data._id, 'event': 'create_project' });
          _this.closeDialog();
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30b2c60b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/task/created_project_dialog_mo.vue
var created_project_dialog_mo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"CSChatThai",attrs:{"persistent":"","max-width":"720"},model:{value:(_vm.dialogCreateProject),callback:function ($$v) {_vm.dialogCreateProject=$$v},expression:"dialogCreateProject"}},[_c('v-card',[_c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-toolbar',{staticClass:"toolbar-card-v2",attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"CSChatThai"},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("fas fa-tasks")]),_vm._v("  "+_vm._s(_vm.$t('Task.allTask.createProject'))+"\n        ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"black !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"CSChatThai",staticStyle:{"overflow-y":"scroll","height":"40vh","justify-content":"center","align-items":"center","display":"grid"}},[_c('v-layout',{attrs:{"column":"","wrap":"","align-start":""}},[_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.projectSubject'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject_project),expression:"subject_project"}],staticClass:"CSChatThai inputtaskweb",attrs:{"type":"text","placeholder":_vm.$t('Task.create.placeholderSubjectProject')},domProps:{"value":(_vm.subject_project)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject_project=$event.target.value}}})]),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.description'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-textarea',{staticStyle:{"width":"100%"},attrs:{"label":_vm.$t('Task.create.placeholderDescription'),"solo":"","no-resize":"","outline":"","height":"80","rows":"3","rules":[function (v) { return v.length <= 250 || ''; }],"counter":250},model:{value:(_vm.detail_project),callback:function ($$v) {_vm.detail_project=$$v},expression:"detail_project"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-btn',{staticClass:"btncancle",on:{"click":function($event){_vm.cancel_task()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"btncreate",attrs:{"loading":_vm.isloading,"disabled":_vm.subject_project == '' || _vm.detail_project.length > 250},on:{"click":function($event){_vm.create_project()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1)],1)}
var created_project_dialog_mo_staticRenderFns = []
var created_project_dialog_mo_esExports = { render: created_project_dialog_mo_render, staticRenderFns: created_project_dialog_mo_staticRenderFns }
/* harmony default export */ var task_created_project_dialog_mo = (created_project_dialog_mo_esExports);
// CONCATENATED MODULE: ./src/components/mobile/task/created_project_dialog_mo.vue
function created_project_dialog_mo_injectStyle (ssrContext) {
  __webpack_require__("mKv4")
}
var created_project_dialog_mo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var created_project_dialog_mo___vue_template_functional__ = false
/* styles */
var created_project_dialog_mo___vue_styles__ = created_project_dialog_mo_injectStyle
/* scopeId */
var created_project_dialog_mo___vue_scopeId__ = "data-v-30b2c60b"
/* moduleIdentifier (server only) */
var created_project_dialog_mo___vue_module_identifier__ = null
var created_project_dialog_mo_Component = created_project_dialog_mo_normalizeComponent(
  created_project_dialog_mo,
  task_created_project_dialog_mo,
  created_project_dialog_mo___vue_template_functional__,
  created_project_dialog_mo___vue_styles__,
  created_project_dialog_mo___vue_scopeId__,
  created_project_dialog_mo___vue_module_identifier__
)

/* harmony default export */ var mobile_task_created_project_dialog_mo = (created_project_dialog_mo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/task/homepage_project_mo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var homepage_project_mo__ = __webpack_require__("M4fF");
/* harmony default export */ var homepage_project_mo = ({
  data: function data() {
    return {
      tabs: '',
      tokenuser: '',
      listproject_user: [],
      listproject_group: [],
      listproject: [],
      progress: false,
      search: '',
      search_group: '',
      projectid: '',
      dialogCreateProject: false
    };
  },
  components: {
    CreateProject: mobile_task_created_project_dialog_mo,
    vue100vh: vue100vh["a" /* default */]
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    this.get_project_by_tokenroom();
  },

  computed: {
    FilterListProject: function FilterListProject() {
      var _this = this;

      if (this.search !== '' && this.search !== null) {
        return this.listproject.filter(function (post) {
          return post.project_name.toLowerCase().includes(_this.search.toLowerCase());
        });
      } else {
        return this.listproject;
      }
    },
    FilterListProjectGroup: function FilterListProjectGroup() {
      var _this2 = this;

      if (this.search_group !== '' && this.search_group !== null) {
        return this.listproject_group.filter(function (post) {
          return post.project_name.toLowerCase().includes(_this2.search_group.toLowerCase());
        });
      } else {
        return this.listproject_group;
      }
    }
  },
  methods: {
    closeCreateProject: function closeCreateProject(value) {
      this.dialogCreateProject = value;
    },
    createdproject: function createdproject(value) {
      this.get_project_by_id(value.project_id, value.event);
    },
    open_create_project: function open_create_project() {
      this.dialogCreateProject = true;
    },
    datetime: function datetime(timestamp) {
      return this.$i18n.locale == 'th' ? services["c" /* Momenttime */].momentdatethai(timestamp) : services["c" /* Momenttime */].momentdateen(timestamp);
    },
    toPage: function toPage(path) {
      this.$router.push(path + this.$route.params.roomid);
    },
    topage_task: function topage_task(projectid, tokenroom) {
      this.$router.push('/mobile/task/' + projectid + '/' + tokenroom);
    },
    get_project_by_tokenroom: function get_project_by_tokenroom() {
      var _this3 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_tokenroom', {
        tokenuser: this.tokenuser,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this3.progress = false;
          _this3.listproject = response.data.data;
          _this3.listproject = homepage_project_mo__.reverse(homepage_project_mo__.sortBy(_this3.listproject, function (dateObj) {
            return new Date(dateObj.timestamp);
          }));
          _this3.projectid = _this3.listproject._id;
          // console.log(this.listproject)
          // this.listproject_group = _.filter(this.listproject, function(o) { return o.tokenroom.startsWith('G') })
          // this.listproject_user = _.filter(this.listproject, function(o) { return o.tokenroom.startsWith('R') })
        } else {
          _this3.progress = false;
          _this3.listproject = [];
        }
      }).catch(function (error) {
        _this3.progress = false;
        console.log(error.message);
      });
    },
    get_project_by_id: function get_project_by_id(projectid, events) {
      var _this4 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_id', {
        tokenuser: this.tokenuser,
        tokenroom: this.$route.params.roomid,
        project_id: projectid
      }).then(function (responsed) {
        // console.log(responsed.data.data)
        if (responsed.data.status == 'success') {
          if (events == 'create_project') {
            _this4.listproject.unshift({
              'project_name': responsed.data.data.project_name,
              'timestamp': responsed.data.data.timestamp,
              'count_task': '0',
              '_id': responsed.data.data._id,
              'detail': responsed.data.data.detail,
              'tokenroom': responsed.data.data.tokenroom,
              'state': responsed.data.data.state,
              'path_pic': responsed.data.data.owner_info.path_pic
            });
            // this.listproject.unshift(responsed.data.data)
          }
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76d643db","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/task/homepage_project_mo.vue
var homepage_project_mo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-container',{staticClass:"pl-0 pr-0 pt-0 pb-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","child-flex":"","wrap":""}},[_c('div',[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/room/')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('Task.allTask.myProject', {count: _vm.listproject.length})))])],1)],1)]),_vm._v(" "),(_vm.progress)?_c('v-layout',{staticClass:"mt-2 ml-4 mr-4 layout-height",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":"80","indeterminate":_vm.progress,"color":"primary"}})],1):_c('v-layout',{staticClass:"mt-2 ml-4 mr-4",attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-btn',{attrs:{"absolute":"","dark":"","fab":"","bottom":"","right":"","color":"primary","small":""},on:{"click":function($event){_vm.open_create_project()}}},[_c('v-icon',{staticStyle:{"color":"white !important"}},[_vm._v("add")])],1),_vm._v(" "),_c('v-layout',{staticClass:"bg-white",attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[(_vm.listproject.length != 0)?_c('v-flex',{staticClass:"ml-1 mt-3",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"solo":"","label":_vm.$t('Task.allTask.placeholderSearchProject'),"clearable":"","append-icon":"search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"layout-height",attrs:{"flat":""}},_vm._l((_vm.FilterListProject),function(item,index){return (_vm.listproject.length != 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticClass:"mb-3 mr-1 ml-1 mt-3 card-project",on:{"click":function($event){_vm.topage_task(item._id, item.tokenroom)}}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":"","lg12":"","xl12":""},on:{"click":function($event){_vm.topage_task(item._id, item.tokenroom)}}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":""}},[_c('div',{staticClass:"font-size-18 text-overflow-project"},[_vm._v(_vm._s(item.project_name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"color-grey"},[_vm._v("\n                        "+_vm._s(_vm.$t('Task.allTask.createDate',{date: _vm.datetime(item.timestamp)}))+"\n                      ")])],1)],1),_vm._v(" "),_c('v-card-actions',[_vm._l((item.state),function(i,index){return (index < 3)?_c('v-chip',{attrs:{"text-color":"primary","outline":"","label":""}},[_vm._v("\n                      "+_vm._s(i.name)+" "+_vm._s(i.count_member)+"\n                    ")]):_vm._e()}),_vm._v(" "),((item.state.length - 3) > 0)?_c('v-btn',{staticClass:"mt-1 ml-1 mr-1 mb-1 btn-fab",attrs:{"outline":"","fab":"","color":"primary","small":""}},[_vm._v("\n                      +"+_vm._s(item.state.length - 3)+"\n                    ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-avatar',{attrs:{"size":"40px"}},[(item.path_pic)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.path_pic,"alt":"alt","class":"object-fit-img"}}):_c('img',{staticClass:"border-img object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png","alt":""}})])],2),_vm._v(" "),_c('v-divider',{staticClass:"mt-2",attrs:{"light":""}}),_vm._v(" "),_c('v-layout',{staticClass:"mt-1",attrs:{"row":"","wrap":""}},[_c('span',{staticClass:"pl-3 pr-3"},[_vm._v("\n                      "+_vm._s(_vm.$t('Task.allTask.detailProject'))+"\n                    ")]),_vm._v(" "),_c('v-icon',[_vm._v("fas fa-angle-right")])],1)],1)],1)],1)],1):_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"font-size":"60px !important"}},[_vm._v("fas fa-tasks")]),_vm._v(" "),_c('h4',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$t('Task.allTask.noProjectList')))])],1)],1)}))],1)],1),_vm._v(" "),_c('CreateProject',{attrs:{"dialogCreateProject":_vm.dialogCreateProject,"projectid":_vm.projectid},on:{"closeCreateProject":_vm.closeCreateProject,"createdproject":_vm.createdproject}})],1)],1)}
var homepage_project_mo_staticRenderFns = []
var homepage_project_mo_esExports = { render: homepage_project_mo_render, staticRenderFns: homepage_project_mo_staticRenderFns }
/* harmony default export */ var task_homepage_project_mo = (homepage_project_mo_esExports);
// CONCATENATED MODULE: ./src/components/mobile/task/homepage_project_mo.vue
function homepage_project_mo_injectStyle (ssrContext) {
  __webpack_require__("Ldof")
}
var homepage_project_mo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var homepage_project_mo___vue_template_functional__ = false
/* styles */
var homepage_project_mo___vue_styles__ = homepage_project_mo_injectStyle
/* scopeId */
var homepage_project_mo___vue_scopeId__ = "data-v-76d643db"
/* moduleIdentifier (server only) */
var homepage_project_mo___vue_module_identifier__ = null
var homepage_project_mo_Component = homepage_project_mo_normalizeComponent(
  homepage_project_mo,
  task_homepage_project_mo,
  homepage_project_mo___vue_template_functional__,
  homepage_project_mo___vue_styles__,
  homepage_project_mo___vue_scopeId__,
  homepage_project_mo___vue_module_identifier__
)

/* harmony default export */ var mobile_task_homepage_project_mo = (homepage_project_mo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/task/homepage_calendar_mo.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import CreateTask from '@/components/chat/manage_task/test_created_task_dialog'



var homepage_calendar_mo__ = __webpack_require__("M4fF");
var homepage_calendar_mo_moment = __webpack_require__("PJh5");
/* harmony default export */ var homepage_calendar_mo = ({
  props: {
    source: String
  },
  components: {
    Rightside: chat_layout_RightSide,
    // CreateTask,
    DetailTask: detail_task_dialog_mo["a" /* default */],
    vue100vh: vue100vh["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      dialogDetailProject: false,
      dialogDetailTask: false,
      dialogCreateTask: false,
      status_login: '',
      windowWidth: '',
      mini: true,
      dialog: false,
      drawer: true,
      search: '',
      detail: {},
      token: '',
      detail_project: {},
      progress: false,
      projectid: '',
      state_id: '',
      member: [],
      taskid: '',
      roomid: '',
      arrayEvents: null,
      date1: null,
      date2: new Date().toISOString().substr(0, 10),
      listproject: [],
      time_now: new Date().toISOString().substr(0, 10),
      time_day: new Date().toISOString().substr(0, 10),
      progress_project: false,
      list_date_task: [],
      monthLater: '',
      list_project_month: [],
      listdateCalendar: [],
      length_listproject: ''
    }, defineProperty_default()(_ref, 'progress', false), defineProperty_default()(_ref, 'date', new Date().toISOString().substr(0, 10)), defineProperty_default()(_ref, 'start', new Date().toISOString().substr(0, 10)), defineProperty_default()(_ref, 'listdataTask', []), defineProperty_default()(_ref, 'listGetproject', []), defineProperty_default()(_ref, 'checkListstr', []), defineProperty_default()(_ref, 'checkdates', new Date().toISOString().substr(0, 10)), defineProperty_default()(_ref, 'checkroomname', ''), defineProperty_default()(_ref, 'progress_task', false), _ref;
  },
  mounted: function mounted() {
    // this.$nextTick(() => {
    //   window.addEventListener('resize', () => {
    //     this.windowWidth = window.innerWidth
    //   })
    // })
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.status_login = decoded['status_login'];
    // this.get_data_room()
    // this.progress = true
    this.get_task_in_month(this.time_now);
    // this.get_task_in_day()
    // this.get_task_in_month(this.time_now)
  },

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*'), {
    FilterListProject: function FilterListProject() {
      var _this = this;

      if (this.search !== '' && this.search !== null) {
        return this.listproject.filter(function (post) {
          return post.project_name.toLowerCase().includes(_this.search.toLowerCase());
        });
      } else {
        return this.listproject;
      }
    }
  }),
  watch: {
    date2: function date2() {
      if (this.date.split('-')[1] !== this.date2.split('-')[1]) {
        this.progress_project = true;
        this.checkdates = this.date;
        this.date = this.date2;
        this.time_day = this.date2;
        localStorage.setItem('datestart', this.time_day);
        this.get_task_in_month(this.time_day);
        // this.get_task_in_day()
        // this.check_range_date()
      } else {
        this.date = this.date2;
        this.checkdates = this.date2;
      }
    },
    windowWidth: function windowWidth() {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage');
      }
    },
    socketmessage: function socketmessage(data) {
      // console.log(data)
      // if (data.tokenuser !== this.token) {
      //   if (data.message == 'create_task') {
      //     this.get_task_by_id(data.task_id, data.state.state_id, 'create')
      //   }
      // }
    },
    socket_deletetask: function socket_deletetask(data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        // this.get_task_in_day()
        this.get_task_in_month(this.time_day);
      }
    },
    socket_edittask: function socket_edittask(data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        // this.get_task_in_day()
        this.get_task_in_month(this.time_day);
      }
    }
  },
  methods: {
    toPage: function toPage(path) {
      this.$router.push(path);
    },
    datetimecheck: function datetimecheck(timecheck) {
      if (timecheck.split('-')[1] !== this.checkdates.split('-')[1]) {
        var timeTH = services["c" /* Momenttime */].momentdatethai(timecheck).split(' ')[1] + ' ' + services["c" /* Momenttime */].momentdatethai(timecheck).split(' ')[2];
        var timeEN = services["c" /* Momenttime */].momentdateen(timecheck).split(' ')[0] + ' ' + services["c" /* Momenttime */].momentdateen(timecheck).split(' ')[2];
        return this.$i18n.locale == 'th' ? timeTH : timeEN;
      } else {
        return this.$i18n.locale == 'th' ? services["c" /* Momenttime */].momentdatethai(timecheck) : services["c" /* Momenttime */].momentdateen(timecheck);
      }
    },
    datetime: function datetime(timestamp) {
      return this.$i18n.locale == 'th' ? services["c" /* Momenttime */].momentdatethai(timestamp) : services["c" /* Momenttime */].momentdateen(timestamp);
    },
    get_task_in_month: function get_task_in_month(time_now) {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_in_month', {
        tokenuser: this.token,
        time_now: time_now + ' 00:00:00.000000'
      }).then(function (response) {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          _this2.list_project_month = response.data.data;
          _this2.check_range_date();
        }
      });
    },
    get_task_in_day: function get_task_in_day(time) {
      var _this3 = this;

      this.progress_task = true;
      this.listproject = [];
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_in_day', {
        tokenuser: this.token,
        time_day: time + ' 00:00:00.000000'
      }).then(function (response) {
        if (response.data.status === 'success') {
          // this.progress_project = false
          // this.progress = false
          _this3.listproject = response.data.data;
          _this3.progress_task = false;
          // this.length_listproject = this.listproject.length
          // console.log(this.listproject)
        }
      });
    },
    functionEvents: function functionEvents(date) {
      // console.log(date)
      var month = date.split('-')[0] + '-' + date.split('-')[1];
      if (month !== this.monthLater) {
        this.monthLater = month;
        this.time_now = month + '-01';
        this.get_task_in_month(this.time_now);
        return this.checkdate(date);
      } else {
        return this.checkdate(date);
      }
    },
    functionEventsColor: function functionEventsColor() {
      return 'green darken-1';
    },
    check_range_date: function check_range_date() {
      // console.log(this.list_date_task)
      this.listGetproject = [];
      this.listdataTask = [];
      this.listdateCalendar = [];
      var time_end = '',
          time_start = '';
      for (var i = 0; i < this.list_project_month.length; i++) {
        for (var j = 0; j < this.list_project_month[i].state.length; j++) {
          for (var k = 0; k < this.list_project_month[i].state[j].member.length; k++) {
            time_start = this.list_project_month[i].state[j].member[k].time_start.split(' ')[0];
            time_end = this.list_project_month[i].state[j].member[k].time_end.split(' ')[0];
            this.listdateCalendar = homepage_calendar_mo__.union(this.listdateCalendar.concat(this.getDates(time_start, time_end, this.list_project_month[i].room_name)));
            // console.log(this.listdateCalendar)
          }
        }
      }
      this.checkIncludes();
    },
    getDates: function getDates(startDate, stopDate, project) {
      // console.log(startDate, stopDate)
      var dateArray = [];
      var currentDate = homepage_calendar_mo_moment(startDate);
      var stopDate = homepage_calendar_mo_moment(stopDate);
      while (currentDate <= stopDate) {
        this.listGetproject.push({
          task: project,
          time: homepage_calendar_mo_moment(currentDate).format('YYYY-MM-DD')
        });
        dateArray.push(homepage_calendar_mo_moment(currentDate).format('YYYY-MM-DD'));
        currentDate = homepage_calendar_mo_moment(currentDate).add(1, 'days');
      }
      return dateArray;
    },
    checkIncludes: function checkIncludes() {
      var arr = [];
      arr = this.listGetproject.filter(function (value, index, self) {
        return index === self.findIndex(function (t, i) {
          return t.task === value.task && t.time === value.time;
        });
      });

      var output = [];
      var existingIndex = [];
      arr.forEach(function (item) {
        var existing = output.filter(function (v, i) {
          return v.time == item.time;
        });
        if (existing.length) {
          existingIndex = output.indexOf(existing[0]);
          output[existingIndex].task = output[existingIndex].task.concat(item.task);
        } else {
          if (typeof item.task == 'string') item.task = [item.task];
          output.push(item);
        }
      });

      this.listdataTask = output;
      this.progress_project = false;
    },
    checkdate: function checkdate(date) {
      // console.log(date)
      // console.log(this.listdateCalendar)
      var test = [];
      test = this.listdateCalendar;
      if (test.includes(date) || test.includes(date)) {
        return true;
      } else {
        return false;
      }
    },
    momentday: function momentday(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    commenttask: function commenttask(data) {
      var index = homepage_calendar_mo__.findIndex(this.listproject, function (o) {
        return o._id == data.project_id;
      });
      var index_state = homepage_calendar_mo__.findIndex(this.listproject[index].state, function (o) {
        return o.state_id == data.state_id;
      });
      var index_member = homepage_calendar_mo__.findIndex(this.listproject[index].state[index_state].member, function (o) {
        return o._id == data.task_id;
      });
      this.listproject[index].state[index_state].member[index_member].count_comment = data.count_comment;
    },
    checkpriorityTask: function checkpriorityTask(priority) {
      if (priority == '1' || priority == '2' || priority == '3') {
        return 'card-task-pri' + priority;
      } else {
        return 'card-task-pri3';
      }
    },
    createdtask: function createdtask(value) {
      // this.get_task_by_id(value.task_id, value.state_id, value.event)
      this.get_task_in_day();
    },
    closeCreateTask: function closeCreateTask(value) {
      this.dialogCreateTask = value;
    },
    edittask: function edittask(data) {
      // console.log(data)
      // this.get_task_by_id(data.task_id, data.state_id, data.event, data.old_state)
      this.get_task_in_day();
    },
    deletetask: function deletetask(data) {
      // console.log(data)
      // var index = _.findIndex(this.listproject, function(o) { return o._id == data.project_id })
      // var index_state = _.findIndex(this.listproject[index].state, function(o) { return o.state_id == data.state_id })
      // var index_member = _.findIndex(this.listproject[index].state[index_state].member, function(o) { return o._id == data.task_id })
      // this.listproject[index].state[index_state].member.splice(index_member, 1)
      // this.length_listproject = this.listproject[index].state[index_state].member.length
      this.get_task_in_day();
    },
    closeDetailTask: function closeDetailTask(value) {
      this.dialogDetailTask = value;
    },
    open_create_task: function open_create_task() {
      this.dialogCreateTask = true;
    },
    open_detail_task: function open_detail_task(taskid, tokenroom) {
      this.dialog = false;
      // console.log(tokenroom)
      this.taskid = taskid;
      this.roomid = tokenroom;
      // console.log(this.StateId)
      this.dialogDetailTask = true;
    },
    toChatroom: function toChatroom() {
      this.$router.push('/mobile/room/project/' + this.$route.params.roomid);
    },
    get_data_room: function get_data_room() {
      var _this4 = this;

      this.detail = {};
      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this4.progress = false;
          _this4.detail = response.data;
          var member = [];
          member = response.data.data_room;
          _this4.member = homepage_calendar_mo__.filter(member, function (o) {
            return o.statemember == 'active';
          });
          _this4.get_task_in_day();
          // this.get_project_by_id(this.$route.params.projectid)
        }
      });
    },
    get_project_by_id: function get_project_by_id(projectid) {
      var _this5 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_id', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_id: projectid
      }).then(function (responsed) {
        if (responsed.data.status == 'success') {
          _this5.projectid = projectid;
          _this5.detail_project = responsed.data.data;
        }
      });
    },
    get_task_by_id: function get_task_by_id(taskid, stateid, stateevent, oldstate) {
      var _this6 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_by_id', {
        tokenuser: this.token,
        task_id: taskid
      }).then(function (responsed) {
        if (responsed.data.status == 'success') {
          // console.log(responsed.data.data)
          var old_index = '';
          var index_member = '';
          var index = '';
          if (stateevent == 'edit') {
            old_index = homepage_calendar_mo__.findIndex(_this6.detail_project.state, function (o) {
              return o.state_id == oldstate;
            });
            index_member = homepage_calendar_mo__.findIndex(_this6.detail_project.state[old_index].member, function (o) {
              return o._id == taskid;
            });
            index = homepage_calendar_mo__.findIndex(_this6.detail_project.state, function (o) {
              return o.state_id == stateid;
            });
            _this6.detail_project.state[old_index].member.splice(index_member, 1);
            _this6.detail_project.state[index].member.unshift(responsed.data.data);
            // console.log(this.detail_project.state[index].member)
          } else if (stateevent == 'create') {
            index = homepage_calendar_mo__.findIndex(_this6.detail_project.state, function (o) {
              return o.state_id == stateid;
            });
            _this6.detail_project.state[index].member.unshift(responsed.data.data);
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cda74fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/task/homepage_calendar_mo.vue
var homepage_calendar_mo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticClass:"backgorundMobile",staticStyle:{"position":"fixed","width":"100%"}},[_c('v-container',{staticClass:"pl-0 pr-0 pt-0 pb-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","child-flex":"","wrap":""}},[_c('div',[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/homepage/')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('HeaderMenubar.calendar')))])],1)],1)]),_vm._v(" "),(_vm.progress)?_c('v-layout',{staticClass:"mt-2 ml-4 mr-4 layout-height",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":"80","indeterminate":_vm.progress,"color":"primary"}})],1):_c('v-layout',{staticClass:"mt-2 layout-height",attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-card',{staticStyle:{"width":"80%"},attrs:{"flat":""}},[_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"justify-center":"","wrap":"","row":"","align-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"text-sm-left text-xs-left"},[_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){_vm.$refs.calendar.prev()}}},[_c('v-icon',{attrs:{"small":"","dark":"","color":"primary"}},[_vm._v("fas fa-arrow-left")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-sm-center text-xs-center"},[_c('h3',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.datetimecheck(_vm.date)))])]),_vm._v(" "),_c('v-flex',{staticClass:"text-sm-right text-xs-right"},[_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){_vm.$refs.calendar.next()}}},[_c('v-icon',{attrs:{"small":"","dark":"","color":"primary"}},[_vm._v("fas fa-arrow-right")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-2 mt-2 ml-2 mr-2",attrs:{"xs12":"","sm12":""}},[(!_vm.progress_project)?_c('v-sheet',{attrs:{"height":"400"}},[_c('v-calendar',{ref:"calendar",attrs:{"now":_vm.start,"value":_vm.date,"locale":_vm.$t('Task.allTask.localepicker'),"color":"primary"},scopedSlots:_vm._u([{key:"day",fn:function(date){return [_vm._l((_vm.listdataTask),function(member,index){return [(member.time == date.date)?_c('v-layout',{key:index,attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_vm._l((member.task),function(roomname,index2){return [(index2 < 1)?_c('div',{key:index2},[_c('v-icon',{staticStyle:{"font-size":"13px"},attrs:{"color":"primary"},on:{"click":function($event){_vm.get_task_in_day(member.time), _vm.dialog = true}}},[_vm._v("fa fa-circle")])],1):_vm._e()]})],2):_vm._e()]})]}}]),model:{value:(_vm.date2),callback:function ($$v) {_vm.date2=$$v},expression:"date2"}})],1):_c('v-sheet',{staticStyle:{"background-color":"#fff0"},attrs:{"height":"400"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{staticStyle:{"margin-top":"100px"},attrs:{"size":80,"indeterminate":_vm.progress_project,"color":"primary"}})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-layout',{staticClass:"layout-heightdialog",attrs:{"wrap":"","row":"","align-center":"","justify-center":""}},[_c('v-toolbar',{attrs:{"dense":"","dark":"","color":"#1a222c"}},[_c('p',{staticClass:"mt-3",staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('HeaderMenubar.project'))+" ("+_vm._s(_vm.datetime(_vm.date))+")")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{attrs:{"right":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                        mdi-close\n                      ")])],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-3 mt-3 mr-3",attrs:{"xs12":"","ms12":""}},[_c('v-text-field',{staticClass:"searchBox",attrs:{"solo":"","label":_vm.$t('Task.allTask.placeholderSearchProject'),"clearable":"","append-icon":"search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-layout',{staticClass:"mr-1 ml-3 mt-1",staticStyle:{"background-color":"#f4f1f1","border-radius":"20px"},attrs:{"wrap":"","align-center":"","justify-center":"","fill-height":""}},[_c('v-layout',{staticClass:"taskScroll",staticStyle:{"height":"calc(100vh - 300px) !important","overflow-y":"auto"},attrs:{"align-start":"","justify-end":"","row":"","fill-height":""}},[_c('v-flex',[(_vm.progress_task)?_c('v-layout',{staticStyle:{"height":"25vh !important"},attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":40,"indeterminate":_vm.progress_task,"color":"primary"}})],1):(_vm.listproject.length != 0)?_vm._l((_vm.FilterListProject),function(item,i){return _c('v-layout',{key:i,staticClass:"mr-3 ml-3 mb-4",attrs:{"column":""}},[(_vm.listproject.length != 0)?_c('v-layout',{staticClass:"mb-2 mt-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-left"},[_c('h3',{staticClass:"text-overflow-projectname"},[_vm._v(_vm._s(item.project_name))])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right mt-1"},[_c('span',{staticClass:"text-overflow-groupname"},[_vm._v(_vm._s(item.room_name))])])],1):_vm._e(),_vm._v(" "),_c('v-expansion-panel',_vm._l((item.state),function(state,index){return (state.member.length != 0)?_c('v-expansion-panel-content',{attrs:{"expand-icon":"mdi-menu-down"}},[(state.member.length != 0)?_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(state.name)+"\n                                    "),_c('span',{staticClass:"span-numtask"},[_vm._v(_vm._s(_vm.$t('Task.allTask.numTask',{count: state.member.length})))])]):_vm._e(),_vm._v(" "),_c('v-card',[_c('v-list',[_vm._l((state.member),function(member,indexmember){return [_c('v-list-tile',{key:member._id,class:_vm.checkpriorityTask(member.priority),attrs:{"avatar":""},on:{"click":function($event){_vm.open_detail_task(member._id, _vm.listproject[i].tokenroom)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('span',{staticClass:"pl-2"},[_vm._v(_vm._s(member.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(member.count_comment != '0')?_c('v-icon',{staticStyle:{"font-size":"19px"},attrs:{"color":"#d8d8d8"}},[_vm._v("fas fa-comment-dots")]):_vm._e(),_vm._v(" "),(member.count_comment != '0')?_c('span',{staticClass:"ml-2 mr-2",staticStyle:{"color":"#515050","font-size":"13px"}},[_vm._v(_vm._s(member.count_comment))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"ml-3",staticStyle:{"color":"#515050","font-size":"13px"}},[_vm._v(_vm._s(_vm.datetime(member.time_end)))])],1)],1)],1)],1),_vm._v(" "),(indexmember + 1 < state.member.length)?_c('v-divider',{key:indexmember}):_vm._e()]})],2)],1)],1):_vm._e()}))],1)}):_c('v-layout',{staticClass:"mt-5",attrs:{"row":"","wrap":"","align-center":"","justify-center":"","fill-height":""}},[_c('h4',[_vm._v(_vm._s(_vm.$t('Task.allTask.noCardTask')))])])],2)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('DetailTask',{attrs:{"dialogDetailTask":_vm.dialogDetailTask,"taskid":_vm.taskid,"roomid":_vm.roomid},on:{"closeDetailTask":_vm.closeDetailTask,"edittask":_vm.edittask,"deletetask":_vm.deletetask,"commenttask":_vm.commenttask}})],1)}
var homepage_calendar_mo_staticRenderFns = []
var homepage_calendar_mo_esExports = { render: homepage_calendar_mo_render, staticRenderFns: homepage_calendar_mo_staticRenderFns }
/* harmony default export */ var task_homepage_calendar_mo = (homepage_calendar_mo_esExports);
// CONCATENATED MODULE: ./src/components/mobile/task/homepage_calendar_mo.vue
function homepage_calendar_mo_injectStyle (ssrContext) {
  __webpack_require__("k5oh")
}
var homepage_calendar_mo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var homepage_calendar_mo___vue_template_functional__ = false
/* styles */
var homepage_calendar_mo___vue_styles__ = homepage_calendar_mo_injectStyle
/* scopeId */
var homepage_calendar_mo___vue_scopeId__ = "data-v-2cda74fa"
/* moduleIdentifier (server only) */
var homepage_calendar_mo___vue_module_identifier__ = null
var homepage_calendar_mo_Component = homepage_calendar_mo_normalizeComponent(
  homepage_calendar_mo,
  task_homepage_calendar_mo,
  homepage_calendar_mo___vue_template_functional__,
  homepage_calendar_mo___vue_styles__,
  homepage_calendar_mo___vue_scopeId__,
  homepage_calendar_mo___vue_module_identifier__
)

/* harmony default export */ var mobile_task_homepage_calendar_mo = (homepage_calendar_mo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/task/create_project_page_mo.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import Rightside from '@/components/chat/layout/RightSide'
// import CreateProject from '@/components/chat/manage_task/created_project_dialog'




var create_project_page_mo__ = __webpack_require__("M4fF");
/* harmony default export */ var create_project_page_mo = ({
  // props: {
  //   source: String
  // },
  components: {
    // Rightside,
    // CreateProject,
    CreateGroupDialog: CreateGroupDialog["a" /* default */],
    AddDialog: AddFriendDialog["a" /* default */],
    vue100vh: vue100vh["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      AddFriend: false,
      radios: '',
      tabs: '',
      text: 'mm',
      listproject: [],
      dialogDetailTask: false,
      dialogCreateProject: false,
      status_login: '',
      windowWidth: '',
      mini: true,
      dialog: false,
      drawer: true,
      detail: {},
      token: '',
      detail_project: {},
      progress: false,
      projectid: '',
      state_id: '',
      member: [],
      taskid: '',
      search: '',
      search_group: '',
      listproject_user: [],
      listproject_group: [],
      listfriend: [],
      listgroup: [],
      project_name: ''
    }, defineProperty_default()(_ref, 'detail_project', ''), defineProperty_default()(_ref, 'isloading', false), defineProperty_default()(_ref, 'CreateGroup', false), defineProperty_default()(_ref, 'stepSelect', 1), defineProperty_default()(_ref, 'create_project', null), _ref;
  },
  mounted: function mounted() {
    // this.$nextTick(() => {
    //   window.addEventListener('resize', () => {
    //     this.windowWidth = window.innerWidth
    //   })
    // })
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.status_login = decoded['status_login'];
    // this.get_project_room()
    this.get_list_friend();
    this.get_list_group();
  },

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*'), {
    pages: function pages() {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 0;

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    },
    FilterListFriend: function FilterListFriend() {
      var _this = this;

      if (this.search !== '' && this.search !== null) {
        return this.listfriend.filter(function (post) {
          return post.name.toLowerCase().includes(_this.search.toLowerCase());
        });
      } else {
        return this.listfriend;
      }
    },
    FilterListGroup: function FilterListGroup() {
      var _this2 = this;

      if (this.search_group !== '' && this.search_group !== null) {
        return this.listgroup.filter(function (post) {
          return post.name.toLowerCase().includes(_this2.search_group.toLowerCase());
        });
      } else {
        return this.listgroup;
      }
    }
  }),
  watch: {
    windowWidth: function windowWidth() {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage');
      }
    },
    create_project: function create_project() {
      var _this3 = this;

      var l = this.create_project;
      this[l] = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/create_project', {
        tokenuser: this.token,
        tokenroom: this.radios,
        project_name: this.project_name,
        detail: this.detail_project
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data.data)
          _this3[l] = false;
          _this3.cancel_project();
          _this3.$swal('', _this3.$t('Alert.Success.createProject'), 'success');
          _this3.projectid = response.data.data._id;
          _this3.$router.push('/mobile/task/' + _this3.projectid + '/' + response.data.data.tokenroom);
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    socketmessage: function socketmessage(data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        if (data.message == 'create_task') {
          this.get_task_by_id(data.task_id, data.state.state_id, 'create');
        }
      }
    },
    socket_deletetask: function socket_deletetask(data) {
      var _this4 = this;

      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_id', {
          tokenuser: this.token,
          tokenroom: this.$route.params.roomid,
          project_id: this.projectid
        }).then(function (responsed) {
          // console.log(responsed.data.data)
          if (responsed.data.status == 'success') {
            _this4.detail_project = responsed.data.data;
          }
        });
      }
    },
    socket_edittask: function socket_edittask(data) {
      var _this5 = this;

      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_by_id', {
          tokenuser: this.token,
          task_id: data.task_id
        }).then(function (responsed) {
          if (responsed.data.status == 'success') {
            // console.log(responsed.data.data)
            var new_state = responsed.data.data.state.id;
            var old_index = '';
            var index_member = '';
            var index = '';
            old_index = create_project_page_mo__.findIndex(_this5.detail_project.state, function (o) {
              return o.state_id == data.state_id.id;
            });
            index_member = create_project_page_mo__.findIndex(_this5.detail_project.state[old_index].member, function (o) {
              return o._id == data.task_id;
            });
            index = create_project_page_mo__.findIndex(_this5.detail_project.state, function (o) {
              return o.state_id == new_state;
            });
            _this5.detail_project.state[old_index].member.splice(index_member, 1);
            _this5.detail_project.state[index].member.unshift(responsed.data.data);
          }
        });
      }
    },
    socketaccept_friend: function socketaccept_friend(data) {
      var _this6 = this;

      var tokenfriend = data.tokenfriend;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', { tokenuser: this.token, tokenfriend: tokenfriend }).then(function (response) {
        if (create_project_page_mo__.find(_this6.listfriend, function (o) {
          return o.tokenuser === response.data.user.tokenuser;
        }) === undefined) {
          _this6.listfriend.unshift(response.data.user);
          _this6.radios = '';
        }
      });
    },
    socketremove_friend: function socketremove_friend(data) {
      // console.log(data)
      var index = create_project_page_mo__.findIndex(this.listfriend, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (index >= 0) {
        this.listfriend.splice(index, 1);
      }
    },
    block_friend: function block_friend(data) {
      this.blockevent(data);
    }
  },
  methods: {
    blockevent: function blockevent(data) {
      // console.log(data)
      if (data.event === 'unblock_friend') {
        this.listfriend.push(data);
      }
    },
    open_add_friend: function open_add_friend() {
      this.AddFriend = true;
    },
    open_create_group: function open_create_group() {
      this.CreateGroup = true;
    },
    closeDialogCreateGroup: function closeDialogCreateGroup(value) {
      this.CreateGroup = value;
    },
    closeDialogAddFriend: function closeDialogAddFriend(value) {
      this.AddFriend = value;
    },
    updatecreategroup: function updatecreategroup(data, filename) {
      if (create_project_page_mo__.find(this.listgroup, function (o) {
        return o.group_id === data.group_id;
      }) === undefined) {
        this.listgroup.unshift({
          count_read: '',
          create_date: data.create_date,
          group_id: data.group_id,
          member: data.member,
          name: data.name,
          picture: filename,
          state: data.state,
          timestamp: data.timestamp,
          tokenroom: data.tokenroom,
          type: data.type
        });
        this.listgroup = create_project_page_mo__.reverse(create_project_page_mo__.sortBy(this.listgroup, function (dateObj) {
          return new Date(dateObj.create_date);
        }));
      }
    },
    cancel_project: function cancel_project() {
      this.project_name = '';
      this.detail_project = '';
      // this.radios = ''
    },
    cancel_radios: function cancel_radios() {
      this.radios = '';
    },
    get_list_friend: function get_list_friend() {
      var _this7 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistfriend', {
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          _this7.progress = false;
          _this7.listfriend = response.data['listfriend'];
          // console.log(this.listfriend)
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    get_list_group: function get_list_group() {
      var _this8 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistgroup', {
        tokenuser: this.token
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this8.progress = false;
          _this8.listgroup = response.data['listgroup'];
          // console.log(this.listgroup)
          _this8.listgroup = create_project_page_mo__.reverse(create_project_page_mo__.sortBy(_this8.listgroup, function (dateObj) {
            return new Date(dateObj.create_date);
          }));
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    toPage: function toPage(path) {
      this.$router.push(path);
    },
    topage_task: function topage_task(projectid, tokenroom) {
      // console.log(projectid)
      this.$router.push('/mobile/task/' + projectid + '/' + tokenroom);
    },
    momentday: function momentday(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    createdproject: function createdproject(value) {
      this.get_project_by_id(value.project_id, value.event);
    },
    closeCreateProject: function closeCreateProject(value) {
      this.dialogCreateProject = value;
    },
    edittask: function edittask(data) {
      // console.log(data)
      this.get_task_by_id(data.task_id, data.state_id, data.event, data.old_state);
    },
    deletetask: function deletetask(data) {
      // console.log(data)
      var index = create_project_page_mo__.findIndex(this.detail_project.state, function (o) {
        return o.state_id == data.state_id;
      });
      var index_member = create_project_page_mo__.findIndex(this.detail_project.state[index].member, function (o) {
        return o._id == data.task_id;
      });
      this.detail_project.state[index].member.splice(index_member, 1);
    },
    closeDetailTask: function closeDetailTask(value) {
      this.dialogDetailTask = value;
    },
    open_create_project: function open_create_project() {
      this.dialogCreateProject = true;
    },
    open_detail_task: function open_detail_task(taskid) {
      this.taskid = taskid;
      // console.log(this.StateId)
      this.dialogDetailTask = true;
    },
    toChatroom: function toChatroom() {
      // this.$router.push('/chat/room/' + this.$route.params.roomid)
      this.$router.go(-1);
    },
    get_data_room: function get_data_room() {
      var _this9 = this;

      this.detail = {};
      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this9.progress = false;
          _this9.detail = response.data;
          // console.log(this.detail)
          var member = [];
          member = response.data.data_room;
          _this9.member = create_project_page_mo__.filter(member, function (o) {
            return o.statemember == 'active';
          });
          // this.check_project_room()
        }
      });
    },
    get_project_room: function get_project_room() {
      var _this10 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_tokenuser', {
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          _this10.progress = false;
          _this10.listproject = response.data.data;
          _this10.listproject = create_project_page_mo__.reverse(create_project_page_mo__.sortBy(_this10.listproject, function (dateObj) {
            return new Date(dateObj.timestamp);
          }));
          _this10.listproject_group = create_project_page_mo__.filter(_this10.listproject, function (o) {
            return o.tokenroom.startsWith('G');
          });
          _this10.listproject_user = create_project_page_mo__.filter(_this10.listproject, function (o) {
            return o.tokenroom.startsWith('R');
          });
          // console.log(this.listproject_group)
          // console.log(this.listproject_user)
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },

    // created_project () {
    //   this.isLoading = true
    //   this.axios.post(process.env.APIpub + '/v1/user/create_project', {
    //     tokenuser: this.token,
    //     tokenroom: this.radios,
    //     project_name: this.project_name,
    //     detail: this.detail_project
    //   }).then((response) => {
    //     if (response.data.status === 'success') {
    //       // console.log(response.data.data)
    //       this.isLoading = false
    //       this.cancel_project()
    //       this.$swal('', this.$t('Alert.Success.createProject'), 'success')
    //       this.projectid = response.data.data._id
    //       this.$router.push('/mobile/task/' + this.projectid + '/' + response.data.data.tokenroom)
    //     }
    //   }).catch(error => {
    //     console.log(error.message)
    //   })
    // },
    get_project_by_id: function get_project_by_id(projectid, events) {
      var _this11 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_project_by_id', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_id: projectid
      }).then(function (responsed) {
        // console.log(responsed.data.data)
        if (responsed.data.status == 'success') {
          if (events == 'create_project') {
            _this11.listproject.unshift(responsed.data.data);
          }
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    get_task_by_id: function get_task_by_id(taskid, stateid, stateevent, oldstate) {
      var _this12 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_by_id', {
        tokenuser: this.token,
        task_id: taskid
      }).then(function (responsed) {
        if (responsed.data.status == 'success') {
          // console.log(responsed.data.data)
          var old_index = '';
          var index_member = '';
          var index = '';
          if (stateevent == 'edit') {
            old_index = create_project_page_mo__.findIndex(_this12.detail_project.state, function (o) {
              return o.state_id == oldstate;
            });
            index_member = create_project_page_mo__.findIndex(_this12.detail_project.state[old_index].member, function (o) {
              return o._id == taskid;
            });
            index = create_project_page_mo__.findIndex(_this12.detail_project.state, function (o) {
              return o.state_id == stateid;
            });
            _this12.detail_project.state[old_index].member.splice(index_member, 1);
            _this12.detail_project.state[index].member.unshift(responsed.data.data);
            // console.log(this.detail_project.state[index].member)
          } else if (stateevent == 'create') {
            index = create_project_page_mo__.findIndex(_this12.detail_project.state, function (o) {
              return o.state_id == stateid;
            });
            _this12.detail_project.state[index].member.unshift(responsed.data.data);
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f9600fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/task/create_project_page_mo.vue
var create_project_page_mo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{staticStyle:{"position":"fixed","width":"100%"}},[_c('v-content',[_c('v-container',{staticClass:"pl-0 pr-0 pt-0 pb-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","child-flex":"","wrap":""}},[_c('div',[_c('v-toolbar',{staticStyle:{"background-color":"white !important"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toPage('/mobile/task/project')}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('HeaderMenubar.createproject')))])],1)],1)]),_vm._v(" "),(_vm.progress)?_c('v-layout',{staticClass:"mt-2 ml-4 mr-4 layout-height",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":"80","indeterminate":_vm.progress,"color":"primary"}})],1):_c('v-flex',{staticClass:"chatboxnonselect layout-height height-100vh",attrs:{"sm12":"","xs12":""}},[_c('v-content',[_c('v-container',{staticClass:"scrolling-wrapper",attrs:{"fluid":"","fill-height":""}},[_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.stepSelect),callback:function ($$v) {_vm.stepSelect=$$v},expression:"stepSelect"}},[_c('v-stepper-step',{attrs:{"complete":_vm.stepSelect > 1,"step":"1"}},[_vm._v("\n                "+_vm._s(_vm.$t('Task.create.placeholderSubjectProject'))+"\n              ")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-layout',{staticClass:"mt-2",attrs:{"column":"","justify-center":""}},[[_c('v-flex',{staticClass:"layoutfield"},[_c('v-text-field',{attrs:{"name":"projectname","label":_vm.$t('Task.create.placeholderSubjectProject'),"id":"id","solo":""},model:{value:(_vm.project_name),callback:function ($$v) {_vm.project_name=$$v},expression:"project_name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"layoutfield"},[_c('v-textarea',{attrs:{"label":_vm.$t('Task.create.description'),"name":"descriptionproject","no-resize":"","solo":"","rules":[function (v) { return v.length <= 250 || ''; }],"counter":250},model:{value:(_vm.detail_project),callback:function ($$v) {_vm.detail_project=$$v},expression:"detail_project"}})],1)]],2),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":"","align-end":""}},[[_c('v-btn',{staticClass:"btnclear",attrs:{"small":""},on:{"click":function($event){_vm.cancel_project()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.clear')))]),_vm._v(" "),(_vm.project_name !== '')?_c('v-btn',{attrs:{"icon":"","dark":"","small":""},on:{"click":function($event){_vm.stepSelect = 2}}},[_c('v-icon',{attrs:{"small":"","color":"primary"}},[_vm._v("fas fa-arrow-right")])],1):_c('v-btn',{attrs:{"icon":"","disabled":"","small":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("fas fa-arrow-right")])],1)]],2)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepSelect > 2,"step":"2"}},[_vm._v("\n                "+_vm._s(_vm.$t('Task.create.select'))+"\n              ")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-layout',{staticClass:"mt-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-tabs',{staticClass:"mt-2",attrs:{"left":"","color":"white","dark":"","icons-and-text":""},model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('v-tabs-slider',{attrs:{"color":"#232b35"}}),_vm._v(" "),_c('v-tab',{key:1,attrs:{"href":"#tab-1"}},[_c('p',{staticStyle:{"color":"#232b35","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.friend')))]),_vm._v(" "),_c('v-icon',{attrs:{"small":"","color":"#232b35"}},[_vm._v("fas fa-user")])],1),_vm._v(" "),_c('v-tab',{key:2,attrs:{"href":"#tab-2"}},[_c('p',{staticStyle:{"color":"#232b35","text-transform":"none"}},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.group')))]),_vm._v(" "),_c('v-icon',{attrs:{"small":"","color":"#232b35"}},[_vm._v("fas fa-users")])],1),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',{attrs:{"id":"tab-1"}},[(_vm.listfriend.length !== 0)?_c('v-layout',[_c('v-flex',{staticClass:"mt-3"},[_c('v-text-field',{attrs:{"solo":"","label":_vm.$t('Task.allTask.placeholderSearchFriend'),"clearable":"","append-icon":"search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.listfriend.length != 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-card',{staticClass:"card-tabs"},[_c('v-container',{staticClass:"scrolling-wrapper",staticStyle:{"min-height":"0","height":"calc(100vh - 160px) !important"}},[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('div',{staticClass:"listFrinend"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.FilterListFriend),function(item,index){return [_c('v-flex',{key:index,attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticClass:"cardOfFriendList",nativeOn:{"click":function($event){_vm.radios=item.tokenroom}}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"sm4":"","xs4":"","md4":"","d-flex":""}},[_c('v-avatar',{staticStyle:{"margin-top":"5px"},attrs:{"size":"45px"}},[(item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.profilepicture}}):(item.type == 'user')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}}):(item.type == 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):(item.type == 'business')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"sm6":"","xs6":"","md6":"","d-flex":""}},[_c('strong',{staticClass:"textWrap",staticStyle:{"margin-bottom":"20px","margin-top":"20px","font-size":"13px"}},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('v-flex',{attrs:{"sm2":"","xs2":"","md2":"","d-flex":""}},[_c('v-radio-group',{attrs:{"mandatory":false},model:{value:(_vm.radios),callback:function ($$v) {_vm.radios=$$v},expression:"radios"}},[_c('v-radio',{staticClass:"radioPosition",attrs:{"value":item.tokenroom}})],1)],1)],1)],1)],1)]})],2)],1)])],1)],1)],1):_c('v-flex',{staticClass:"flex-center cal-height-100vh",attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"font-size":"60px !important"}},[_vm._v("fas fa-user-friends")]),_vm._v(" "),_c('h4',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$t('Task.allTask.noListFriend')))])],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[(_vm.listgroup.length !== 0)?_c('v-layout',[_c('v-flex',{staticClass:"mt-3"},[_c('v-text-field',{attrs:{"solo":"","label":_vm.$t('Task.allTask.placeholderSearchGroup'),"clearable":"","append-icon":"search"},model:{value:(_vm.search_group),callback:function ($$v) {_vm.search_group=$$v},expression:"search_group"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.listgroup.length != 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-card',{staticClass:"card-tabs"},[_c('v-container',{staticClass:"scrolling-wrapper",staticStyle:{"min-height":"0","height":"calc(100vh - 160px) !important"}},[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('div',{staticClass:"listFrinend"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.FilterListGroup),function(item,index){return [_c('v-flex',{key:index,attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticClass:"cardOfFriendList",nativeOn:{"click":function($event){_vm.radios=item.tokenroom}}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"sm4":"","xs4":"","md4":"","d-flex":""}},[_c('v-avatar',{staticStyle:{"margin-top":"5px"},attrs:{"size":"45px"}},[(item.picture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.picture}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/group-white.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"sm6":"","xs6":"","md6":"","d-flex":""}},[_c('strong',{staticClass:"textWrap",staticStyle:{"margin-bottom":"20px","margin-top":"20px","font-size":"16px"}},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('v-flex',{attrs:{"sm2":"","xs2":"","md2":"","d-flex":""}},[_c('v-radio-group',{attrs:{"mandatory":false},model:{value:(_vm.radios),callback:function ($$v) {_vm.radios=$$v},expression:"radios"}},[_c('v-radio',{staticClass:"radioPosition",attrs:{"value":item.tokenroom}})],1)],1)],1)],1)],1)]})],2)],1)])],1)],1)],1):_c('v-flex',{staticClass:"flex-center mt-3 cal-height-100vh",attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"font-size":"60px !important"}},[_vm._v("fas fa-users")]),_vm._v(" "),_c('h4',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$t('Task.allTask.noListGroup')))])],1)],1)],1)],1),_vm._v(" "),(_vm.tabs == 'tab-1')?_c('v-layout',{staticClass:"ml-1 mr-5 bg-white",attrs:{"row":"","wrap":"","align-center":""}},[(_vm.listfriend.length == 0)?_c('v-flex',{staticClass:"mt-2"},[_c('v-btn',{staticClass:"btncreate",attrs:{"small":""},on:{"click":function($event){_vm.open_add_friend()}}},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.addFriend')))])],1):_vm._e()],1):_c('v-layout',{staticClass:"ml-1 mr-5 bg-white",attrs:{"row":"","wrap":"","align-center":"","justify-end":""}},[_c('v-btn',{staticClass:"btncreate",attrs:{"small":""},on:{"click":function($event){_vm.open_create_group()}}},[_vm._v(_vm._s(_vm.$t('Task.allTask.newGroup')))])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-2 mb-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-left"},[_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){_vm.stepSelect = 1}}},[_c('v-icon',{attrs:{"small":"","dark":"","color":"primary"}},[_vm._v("fas fa-arrow-left")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"btnclear",staticStyle:{"margin-right":"60px"},attrs:{"small":""},on:{"click":function($event){_vm.cancel_radios()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.clear')))]),_vm._v(" "),_c('v-btn',{staticClass:"btncreate",attrs:{"small":"","loading":_vm.isloading,"disabled":_vm.project_name == '' || _vm.radios == ''},on:{"click":function($event){_vm.create_project = 'isloading'}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('CreateGroupDialog',{attrs:{"dialogGroup":_vm.CreateGroup},on:{"closeDialogCreateGroup":_vm.closeDialogCreateGroup,"updatecreategroup":_vm.updatecreategroup}}),_vm._v(" "),_c('AddDialog',{attrs:{"dialogAdd":_vm.AddFriend},on:{"closeDialogAddFriend":_vm.closeDialogAddFriend,"blockevent":_vm.blockevent}})],1)],1)}
var create_project_page_mo_staticRenderFns = []
var create_project_page_mo_esExports = { render: create_project_page_mo_render, staticRenderFns: create_project_page_mo_staticRenderFns }
/* harmony default export */ var task_create_project_page_mo = (create_project_page_mo_esExports);
// CONCATENATED MODULE: ./src/components/mobile/task/create_project_page_mo.vue
function create_project_page_mo_injectStyle (ssrContext) {
  __webpack_require__("p43r")
}
var create_project_page_mo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var create_project_page_mo___vue_template_functional__ = false
/* styles */
var create_project_page_mo___vue_styles__ = create_project_page_mo_injectStyle
/* scopeId */
var create_project_page_mo___vue_scopeId__ = "data-v-8f9600fa"
/* moduleIdentifier (server only) */
var create_project_page_mo___vue_module_identifier__ = null
var create_project_page_mo_Component = create_project_page_mo_normalizeComponent(
  create_project_page_mo,
  task_create_project_page_mo,
  create_project_page_mo___vue_template_functional__,
  create_project_page_mo___vue_styles__,
  create_project_page_mo___vue_scopeId__,
  create_project_page_mo___vue_module_identifier__
)

/* harmony default export */ var mobile_task_create_project_page_mo = (create_project_page_mo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/service/market.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var market = ({
  data: function data() {
    return {
      url: '',
      status_login: '',
      token: ''
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.status_login = decoded['status_login'];
    this.token = decoded['tokenuser'];
    this.getMarketPlace();
  },

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  methods: {
    checkredirectpath: function checkredirectpath() {
      // if ("https://portal.thaidotcompayment.co.th")
      var url_market = document.getElementById('url_market').src;
      // console.log(url_market)
      if (url_market.includes('https://portal.thaidotcompayment.co.th')) {
        // console.log("url_market")
      }
    },
    home: function home() {
      // this.$router.push('/chat/service/market')
      this.linkmarket = '';
      this.getMarketPlace();
    },
    getMarketPlace: function getMarketPlace() {
      var _this = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/v2/get_url_locallife', { tokenuser: this.token, env: "staging" }).then(function (response) {
        // this.axios.post('https://chat-manage.one.th:8997/v2/get_url_locallife', {tokenuser: this.token, env: 'production'}).then((response) => {
        // console.log(response.data.url)
        if (response.data.status === 'success') {
          if (_this.$route.query.goto == 'link_market' && _this.linkmarket) {
            _this.url = _this.linkmarket.replace('{auth_token}', response.data.access_token);
            document.getElementById('url_market').src = _this.url;
          } else {
            _this.url = response.data.url + "?access_token=" + response.data.access_token;
            document.getElementById('url_market').src = _this.url;
          }
        }
      }, function () {
        _this.Progress.ListChat = false;
        console.log('error');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d97a0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/market.vue
var market_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"overflow":"hidden !important"},attrs:{"fluid":""}},[(_vm.status_login === 'T')?_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"chatboxnonselect"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('img',{staticStyle:{"border":"2px solid rgb(37, 98, 175)","border-radius":"15px","margin-top":"10px","margin-left":"10px","width":"70px","float":"left","cursor":"pointer"},attrs:{"slot":"activator","src":"/static/img/icons/home_markettopThin.svg"},on:{"click":function($event){_vm.home()}},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v("Go to home merket")])]),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('iframe',{staticStyle:{"visibility":"visible","width":"49vw","height":"calc(100vh - 85px)"},attrs:{"id":"url_market","frameborder":"0","src":_vm.url,"allow":"geolocation *;","sandbox":"allow-same-origin allow-scripts allow-popups allow-forms allow-navigation"}})])]),_vm._v(" "),_c('br')],1)])],1):_vm._e()],1)}
var market_staticRenderFns = []
var market_esExports = { render: market_render, staticRenderFns: market_staticRenderFns }
/* harmony default export */ var service_market = (market_esExports);
// CONCATENATED MODULE: ./src/components/service/market.vue
function market_injectStyle (ssrContext) {
  __webpack_require__("QeBL")
}
var market_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var market___vue_template_functional__ = false
/* styles */
var market___vue_styles__ = market_injectStyle
/* scopeId */
var market___vue_scopeId__ = "data-v-75d97a0c"
/* moduleIdentifier (server only) */
var market___vue_module_identifier__ = null
var market_Component = market_normalizeComponent(
  market,
  service_market,
  market___vue_template_functional__,
  market___vue_styles__,
  market___vue_scopeId__,
  market___vue_module_identifier__
)

/* harmony default export */ var components_service_market = (market_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Relation_login.vue
var Relation_login = __webpack_require__("O5wB");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b077d5fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Relation_login.vue
var Relation_login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"CSChatThai",staticStyle:{"overflow-y":"hidden","background":"white"},attrs:{"id":"inspire"}},[_c('main',[_c('v-content',{staticStyle:{"height":"calc(100vh - 64px)"}},[_c('v-layout',{staticClass:"white--text hidden-sm-and-down",staticStyle:{"background-color":"white !important","background-size":"100% 100%","height":"calc(100% - 5vh)","width":"100vw","background-repeat":"no-repeat","margin-top":"4vh","overflow-y":"hidden"},attrs:{"column":"","align-center":"","justify-center":"","id":"desktop"}},[_c('v-container',{attrs:{"grid-md":"","text-xs-center":""}},[_c('v-layout',{staticStyle:{"align-items":"center","margin-top":"10vh"},attrs:{"row":"","justify-center":"true"}},[_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}}),_vm._v(" "),(_vm.progress)?_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[(_vm.progress)?_c('v-progress-circular',{staticStyle:{"margin":"auto"},attrs:{"size":250,"width":10,"indeterminate":"","color":"blue"}}):_vm._e()],1):_c('v-flex',{attrs:{"sm8":"","md8":"","lg8":"","xl8":""}},[_c('v-layout',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"margin":"0px","width":"33vw","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"33vw"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 15%","color":"black"}},[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":"ชื่อผู้ใช้งาน","prepend-inner-icon":"person"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()},"keypress":function($event){_vm.isNumandaz($event)}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"},attrs:{"solo":"","label":"รหัสผ่าน","type":_vm.showPassword ? 'text' : 'password',"prepend-inner-icon":"lock","append-icon":_vm.showPassword ? 'mdi-eye' : 'mdi-eye-off'},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()},"keypress":function($event){_vm.isnotthai($event)},"click:append":function($event){_vm.showPassword = !_vm.showPassword}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),(_vm.status == 'fail' )?_c('div',{staticStyle:{"color":"#f9a1a1","width":"100%"}},[_c('v-icon',{staticStyle:{"color":"#f9a1a1"}},[_vm._v("info")]),_vm._v(" "+_vm._s(_vm.failmessage)+" ")],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"btnloginweb",on:{"click":function($event){_vm.login()}}},[_vm._v("เข้าสู่ระบบ")]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"5vh","padding-top":"1vh","text-align":"center"}},[_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right"}},[_c('b',[_c('span',{staticClass:"forgetpass",on:{"click":function($event){_vm.open_link('https://one.th/type_forgot_password')}}},[_vm._v("ลืมรหัสผ่าน?")])])])])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right !important"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}})],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"white--text hidden-md-and-up scrolling-wrapper",staticStyle:{"background-color":"white !important","background-size":"auto 100%","height":"calc(100vh - 64px)","width":"100vw","background-repeat":"no-repeat","margin-top":"4vh"},attrs:{"column":"","align-center":"","justify-center":"","id":"mobile"}},[(_vm.progress)?_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-progress-circular',{attrs:{"size":100,"width":7,"indeterminate":"","color":"blue"}})],1)],1):_c('v-container',{staticClass:"scrolling-wrapper",staticStyle:{"height":"calc(100vh - 64px)"},attrs:{"grid-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":""}},[_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticClass:"elevation-24",staticStyle:{"height":"auto","width":"auto","justify-content":"center","margin-top":"8vh","border-radius":"10px","background":"#2562ae"},attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"width":"100%"},attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline Kanit"},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":"static/img/icons/logoonechat_full-white.png"}})])])],1),_vm._v(" "),_c('div',{staticClass:"CSChatThai",staticStyle:{"padding":"0px 10%"}},[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center","color":"white !important"},attrs:{"solo":"","label":"ชื่อผู้ใช้งาน","rules":_vm.usernameRules,"prepend-inner-icon":"person"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"},attrs:{"solo":"","label":"รหัสผ่าน","type":_vm.showPassword ? 'text' : 'password',"rules":_vm.passwordRules,"prepend-inner-icon":"lock","append-icon":_vm.showPassword ? 'mdi-eye' : 'mdi-eye-off'},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.login()},"click:append":function($event){_vm.showPassword = !_vm.showPassword}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),(_vm.status == 'fail' )?_c('div',{staticStyle:{"color":"#f9a1a1","width":"100%"}},[_c('v-icon',{staticStyle:{"color":"#f9a1a1"}},[_vm._v("info")]),_vm._v(" "+_vm._s(_vm.failmessage)+" ")],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-center CSChatThai",staticStyle:{"padding-bottom":"30px","padding-top":"0px","display":"flex","justify-content":"center"}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('v-btn',{staticClass:"btnloginmobile",attrs:{"disabled":_vm.username == '' || _vm.password == ''},on:{"click":function($event){_vm.login()}}},[_vm._v("เข้าสู่ระบบ")]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-end":""}},[_c('p',{staticClass:"CSChatThai"},[_c('b',[_c('span',{on:{"click":function($event){_vm.open_link('https://one.th/type_forgot_password')}}},[_vm._v("ลืมรหัสผ่าน?")])])])])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"footermo hidden-md-and-up"},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/about')}}},[_vm._v("เกี่ยวกับเรา")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toNewTab()}}},[_vm._v("API")]),_vm._v(" |")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"0px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบาย")]),_vm._v(" |")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"5px","color":"black !important"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/contactus')}}},[_vm._v("ติดต่อเรา")])])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('p',{staticStyle:{"padding-left":"20px","padding-right":"20px","color":"black !important"}},[_c('b',[_vm._v("© "+_vm._s(new Date().getFullYear())+" One Centric Company Limited")])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"footer hidden-sm-and-down"},[_c('v-layout',{attrs:{"align-center":"","row":"","justify-center":""}},[_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/about')}}},[_vm._v("เกี่ยวกับเรา")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toNewTab()}}},[_vm._v("API")])])]),_vm._v(" "),_c('p',{staticStyle:{"padding-left":"20px","padding-right":"20px","color":"black"}},[_c('b',[_vm._v("© "+_vm._s(new Date().getFullYear())+" One Centric Company Limited")])]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"text-align":"right","padding-right":"5px","color":"black"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบาย")])]),_vm._v(" |")]),_vm._v(" "),_c('p',{staticClass:"CSChatThai",staticStyle:{"padding-left":"5px"}},[_c('b',[_c('a',{staticStyle:{"color":"black"},on:{"click":function($event){_vm.toPage('/contactus')}}},[_vm._v("ติดต่อเรา")])])])])],1)],1)],1)])}
var Relation_login_staticRenderFns = []
var Relation_login_esExports = { render: Relation_login_render, staticRenderFns: Relation_login_staticRenderFns }
/* harmony default export */ var homepage_Relation_login = (Relation_login_esExports);
// CONCATENATED MODULE: ./src/components/homepage/Relation_login.vue
function Relation_login_injectStyle (ssrContext) {
  __webpack_require__("m0Iv")
}
var Relation_login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Relation_login___vue_template_functional__ = false
/* styles */
var Relation_login___vue_styles__ = Relation_login_injectStyle
/* scopeId */
var Relation_login___vue_scopeId__ = "data-v-b077d5fc"
/* moduleIdentifier (server only) */
var Relation_login___vue_module_identifier__ = null
var Relation_login_Component = Relation_login_normalizeComponent(
  Relation_login["a" /* default */],
  homepage_Relation_login,
  Relation_login___vue_template_functional__,
  Relation_login___vue_styles__,
  Relation_login___vue_scopeId__,
  Relation_login___vue_module_identifier__
)

/* harmony default export */ var components_homepage_Relation_login = (Relation_login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Relation_friend.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Relation_friend = ({
  data: function data() {
    return {
      dialog: false,
      drawer: true,
      mini: true,
      right: null,
      profile_picture: '',
      name: '',
      email: '',
      phone: '',
      status: '',
      state_login: '',
      list_friend_user: [],
      list_friend_serch: [],
      list_infor_business: [],
      infor_business: [],
      progress_listfriend: false,
      progress_seach: false,
      search: '',
      infor_friend_search: {},
      message_search: '',
      list_bot_filter: ['B54284b8db2e75aa8ab646dec485ddb97', 'Bc2483eb3c24457c189cfd6c26b7dd511', 'Bbc41524dcbc3515ebc3cfd36a1b4ac81', 'B8c7ab7357ed5506eade2e932cb0e2102', 'B8bb8493bce765ca99374070aefd167cb', 'B183c8cc3eab55d6aa54e003b68c3f205', 'B2e44b62af2985c548ccca79d0bce8e71', 'Bc651b9fbc93a5adeabc0b2b643447f0e', 'Beb7ed25c5c2058f9b6fb397c2e8873a9', 'B2e29e6bb3dac51e2b6c5cfcf55002ff6', 'B3ac5bf6f32465bde99216952701ac327', 'B4540aaecd0e95ac3b568a1606001ceaf', 'B0f97ea8eebb95f68a2cb641b695097b7', 'Bf575c15407015ca1888aa2209db033ab', 'B4f7385bc7ee356c89f3560795eeb8067', 'B862cf51869e05d158dad18b63ac466bf', 'Bb22876be9b195cfe87294be0f4c42bfa', 'Bcff6cb4e22e75e49aa2a72da6f98523e', 'Bb50c0737947e5e91b9fb035f535e46f8'],
      list_bot_filter_dev: ['B99032998bace587e9652badd46b758c2', 'B150e5db5d81a51d29f34b95f21804b50', 'B82a3f1373a005621b175e38aca401708', 'Beed8d2a1ce8a5cdc94d46f986598b9ce']
    };
  },
  mounted: function mounted() {
    if (this.state_login === 'T') {
      this.$router.push('/relation/friend');
    } else {
      this.$router.push('/relation');
    }
  },
  created: function created() {
    this.state_login = localStorage.getItem('state_login');
    this.profile_picture = localStorage.getItem('profilepicture');
    this.name = localStorage.getItem('name');
    this.phone = localStorage.getItem('phone');
    this.email = localStorage.getItem('email');
    this.status = localStorage.getItem('status');
    this.get_list_friend_user(this.email);
  },

  watch: {
    search: function search() {
      if (this.search === '' || this.search === null) {
        this.list_friend_serch = [];
        this.message_search = '';
      }
    }
  },
  methods: {
    closedialog: function closedialog() {
      this.infor_business = [];
      this.dialog = false;
    },
    opendialog: function opendialog() {
      this.infor_business = this.list_infor_business;
      this.dialog = true;
    },
    logout: function logout() {
      localStorage.removeItem('state_login');
      this.$router.push('/relation');
    },
    get_list_friend_user: function get_list_friend_user(email) {
      var _this = this;

      this.progress_listfriend = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/listbotfriend', {
        key: email
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          _this.progress_listfriend = false;
          if (false) {
            var list_filter = [];
            list_filter = _.filter(response.data.listfriend, function (o) {
              return o.tokenuser === 'B54284b8db2e75aa8ab646dec485ddb97' || o.tokenuser === 'Bc2483eb3c24457c189cfd6c26b7dd511' || o.tokenuser === 'Bbc41524dcbc3515ebc3cfd36a1b4ac81' || o.tokenuser === 'B8c7ab7357ed5506eade2e932cb0e2102' || o.tokenuser === 'B8bb8493bce765ca99374070aefd167cb' || o.tokenuser === 'B183c8cc3eab55d6aa54e003b68c3f205' || o.tokenuser === 'B2e44b62af2985c548ccca79d0bce8e71' || o.tokenuser === 'Bc651b9fbc93a5adeabc0b2b643447f0e' || o.tokenuser === 'Beb7ed25c5c2058f9b6fb397c2e8873a9' || o.tokenuser === 'B2e29e6bb3dac51e2b6c5cfcf55002ff6' || o.tokenuser === 'B3ac5bf6f32465bde99216952701ac327' || o.tokenuser === 'B4540aaecd0e95ac3b568a1606001ceaf' || o.tokenuser === 'B0f97ea8eebb95f68a2cb641b695097b7' || o.tokenuser === 'Bf575c15407015ca1888aa2209db033ab' || o.tokenuser === 'B4f7385bc7ee356c89f3560795eeb8067' || o.tokenuser === 'B862cf51869e05d158dad18b63ac466bf' || o.tokenuser === 'Bb22876be9b195cfe87294be0f4c42bfa' || o.tokenuser === 'Bcff6cb4e22e75e49aa2a72da6f98523e' || o.tokenuser === 'Bb50c0737947e5e91b9fb035f535e46f8';
            });
            // console.log(list_filter)
            _this.list_friend_user = list_filter;
          } else {
            // list_filter = _.filter(response.data.listfriend, function(o) {
            //   return o.tokenuser === 'B99032998bace587e9652badd46b758c2' ||
            //          o.tokenuser === 'B150e5db5d81a51d29f34b95f21804b50' ||
            //          o.tokenuser === 'B82a3f1373a005621b175e38aca401708' ||
            //          o.tokenuser === 'Beed8d2a1ce8a5cdc94d46f986598b9ce'
            // })
            // console.log(list_filter)
            _this.list_friend_user = response.data.listfriend;
            // this.list_friend_user = []
          }
          _this.list_infor_business = response.data.user_business;
        }
      }).catch(function (error) {
        _this.progress_listfriend = false;
        console.log(error);
      });
    },
    search_friend: function search_friend() {
      var _this2 = this;

      this.progress_seach = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/listbotfriend', {
        key: this.search
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          _this2.progress_seach = false;
          // this.list_friend_serch = response.data.listfriend
          if (false) {
            var list_filter = [];
            list_filter = _.filter(response.data.listfriend, function (o) {
              return o.tokenuser === 'B54284b8db2e75aa8ab646dec485ddb97' || o.tokenuser === 'Bc2483eb3c24457c189cfd6c26b7dd511' || o.tokenuser === 'Bbc41524dcbc3515ebc3cfd36a1b4ac81' || o.tokenuser === 'B8c7ab7357ed5506eade2e932cb0e2102' || o.tokenuser === 'B8bb8493bce765ca99374070aefd167cb' || o.tokenuser === 'B183c8cc3eab55d6aa54e003b68c3f205' || o.tokenuser === 'B2e44b62af2985c548ccca79d0bce8e71' || o.tokenuser === 'Bc651b9fbc93a5adeabc0b2b643447f0e' || o.tokenuser === 'Beb7ed25c5c2058f9b6fb397c2e8873a9' || o.tokenuser === 'B2e29e6bb3dac51e2b6c5cfcf55002ff6' || o.tokenuser === 'B3ac5bf6f32465bde99216952701ac327' || o.tokenuser === 'B4540aaecd0e95ac3b568a1606001ceaf' || o.tokenuser === 'B0f97ea8eebb95f68a2cb641b695097b7' || o.tokenuser === 'Bf575c15407015ca1888aa2209db033ab' || o.tokenuser === 'B4f7385bc7ee356c89f3560795eeb8067' || o.tokenuser === 'B862cf51869e05d158dad18b63ac466bf' || o.tokenuser === 'Bb22876be9b195cfe87294be0f4c42bfa' || o.tokenuser === 'Bcff6cb4e22e75e49aa2a72da6f98523e' || o.tokenuser === 'Bb50c0737947e5e91b9fb035f535e46f8';
            });
            _this2.list_friend_serch = list_filter;
          } else {
            // list_filter = _.filter(response.data.listfriend, function(o) { return o.tokenuser === me.list_bot_filter_dev })
            // console.log(list_filter)
            // list_filter = _.filter(response.data.listfriend, function(o) {
            //   return o.tokenuser === 'B99032998bace587e9652badd46b758c2' ||
            //          o.tokenuser === 'B150e5db5d81a51d29f34b95f21804b50' ||
            //          o.tokenuser === 'B82a3f1373a005621b175e38aca401708' ||
            //          o.tokenuser === 'Beed8d2a1ce8a5cdc94d46f986598b9ce'
            // })
            // this.list_friend_serch = list_filter
            _this2.list_friend_serch = response.data.listfriend;
          }
          _this2.infor_friend_search = response.data.user_data;
          _this2.list_infor_business = response.data.user_business;
        } else if (response.data.message === 'user not found') {
          _this2.progress_seach = false;
          _this2.message_search = 'ไม่พบชื่อผู้ใช้งานหรืออีเมลนี้ในระบบ กรุณาตรวจสอบข้อมูลให้ถูกต้อง.';
        }
      }).catch(function (error) {
        _this2.progress_seach = false;
        console.log(error);
      });
    },
    convert_date: function convert_date(date) {
      return services["c" /* Momenttime */].momentdatethai(date);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-040d2f48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Relation_friend.vue
var Relation_friend_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state_login === 'T')?_c('div',[_c('v-layout',{staticClass:"hidden-sm-and-down mt-5",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"border-right",attrs:{"xs3":"","md3":"","sm3":"","lg3":"","md3":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":"80"}},[(_vm.profile_picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile_picture}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('h3',{staticClass:"mt-3 text-transform-bot"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('h4',{staticClass:"mt-3 text-transform-bot color-grey"},[_vm._v(_vm._s(_vm.status))]),_vm._v(" "),_c('h4',{staticClass:"mt-1 color-grey"},[_vm._v(_vm._s(_vm.email))]),_vm._v(" "),_c('v-btn',{staticClass:"mt-2",attrs:{"color":"primary","round":"","outline":"","small":""},on:{"click":function($event){_vm.logout()}}},[_vm._v("ออกจากระบบ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-3"}),_vm._v(" "),(_vm.progress_listfriend)?_c('v-layout',{staticClass:"height-listbot overflow-y",attrs:{"row":"","wrap":""}},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.progress_listfriend}})],1):_c('v-layout',{staticClass:"height-listbot-friend overflow-y",attrs:{"row":"","wrap":""}},[(_vm.list_friend_user.length !== 0)?_c('v-list',{staticStyle:{"width":"100%"},attrs:{"three-line":"","dense":""}},[_vm._l((_vm.list_friend_user),function(item,index){return [_c('v-list-tile',{key:item.tokenuser,attrs:{"avatar":""}},[_c('v-list-tile-avatar',[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle border-img",attrs:{"src":item.profilepicture}}):_c('img',{staticClass:"alligator-turtle border-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('h4',{staticClass:"text-transform-bot-friend"},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"text-transform-bot-friend"},[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"mt-3 fz-13 color-grey"},[_vm._v("เป็นเพื่อนกันเมื่อ : "+_vm._s(_vm.convert_date(item.timestamp_friend)))])])],1)],1),_vm._v(" "),(index + 1 < _vm.list_friend_user.length)?_c('v-divider',{key:index}):_vm._e()]})],2):_c('h4',{staticClass:"mt-5 text-center"},[_vm._v("ไม่มีรายการเพื่อน")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","md8":"","sm8":"","lg8":"","md8":""}},[_c('h2',{staticClass:"mb-3",staticStyle:{"text-align":"center"}},[_vm._v("ค้นหาข้อมูล")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-text-field',{attrs:{"name":"name","label":"กรุณากรอกชื่อผู้ใช้งานหรืออีเมลของบุคคลที่ต้องการค้นหา...","id":"id","clearable":"","solo":"","dense":"","hide-details":"","prepend-inner-icon":"search"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.search_friend()}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","round":"","disabled":_vm.search === '' || _vm.search === null},on:{"click":function($event){_vm.search_friend()}}},[_vm._v("ค้นหา")])],1),_vm._v(" "),(_vm.progress_seach)?_c('v-layout',{staticClass:"height-listbot",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":80,"width":4,"color":"primary","indeterminate":_vm.progress_seach}})],1):_c('v-layout',{attrs:{"column":"","justify-center":"","align-center":""}},[(_vm.list_friend_serch.length === 0)?_c('v-layout',{attrs:{"column":"","justify-center":"","align-center":""}},[_c('h3',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.message_search))])]):_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"column":"","justify-start":"","align-start":""}},[_c('v-flex',{staticStyle:{"width":"100%"},attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":"","lg6":"","xl6":""}},[_c('h3',{staticClass:"text-transform mt-5"},[_vm._v("ข้อมูลส่วนตัว")]),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-avatar',{staticClass:"mt-3",attrs:{"size":"70"}},[(_vm.infor_friend_search.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.infor_friend_search.profilepicture,"alt":"alt"}}):_c('img',{staticClass:"alligator-turtle border-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('h4',{staticClass:"text-transform-bot mt-2"},[_vm._v(_vm._s(_vm.infor_friend_search.nickname))]),_vm._v(" "),_c('span',{staticClass:"color-grey text-transform-bot"},[_vm._v(_vm._s(_vm.infor_friend_search.status))]),_vm._v(" "),_c('span',{staticClass:"color-grey text-transform"},[_vm._v(_vm._s(_vm.infor_friend_search.email))])],1)],1),_vm._v(" "),(_vm.list_infor_business.length !== 0)?_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":"","lg6":"","xl6":""}},[_c('h3',{staticClass:"text-transform mt-5"},[_vm._v("ข้อมูลองค์กร")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","margin-left":"10px","width":"400px","overflow-x":"scroll","overflow-y":"hidden","display":"-webkit-inline-box","background":"none"}},_vm._l((_vm.list_infor_business),function(infor,index){return _c('div',{staticClass:"mb-4"},[_c('v-card',{staticStyle:{"border-radius":"20px","width":"200px","margin-right":"10px"}},[_c('v-layout',{staticStyle:{"height":"170px"},attrs:{"column":"","wrap":"","align-center":"","justify-start":""}},[_c('v-avatar',{staticClass:"mt-3",attrs:{"size":"50"}},[(infor.business_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":infor.business_pic,"alt":"alt"}}):_c('img',{staticClass:"alligator-turtle border-img",attrs:{"src":"/static/img/default_profile/business-white.png"}})]),_vm._v(" "),_c('h4',{staticClass:"text-transform-bot mt-2"},[_vm._v("บริษัท : "+_vm._s(infor.business_name))]),_vm._v(" "),_c('span',{staticClass:"mt-2 color-grey text-transform-bot"},[_vm._v("ตำแหน่ง : "+_vm._s(infor.role_name))])],1)],1)],1)}))]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('span',{staticClass:"mt-2"},[_vm._v("รายชื่อบอทที่เป็นเพื่อนกับ ")]),_c('h4',{staticClass:"text-transform mt-2 ml-2"},[_vm._v(_vm._s(_vm.infor_friend_search.nickname))])]),_vm._v(" "),_c('v-layout',{staticClass:"height-listbot overflow-y mt-3",attrs:{"row":"","wrap":""}},_vm._l((_vm.list_friend_serch),function(item,index){return _c('v-flex',{key:item.tokenuser,staticClass:"mt-2 mb-3 pl-3",attrs:{"xs6":"","d-flex":""}},[_c('v-card',{staticClass:"d-flex",staticStyle:{"min-height":"90px","border-radius":"20px","min-width":"300px","margin-right":"10px"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"pl-3",attrs:{"xs2":"","sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-avatar',{staticClass:"mt-3",attrs:{"size":"50"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture,"alt":"alt"}}):_c('img',{staticClass:"alligator-turtle border-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs10":"","sm10":"","md10":"","lg10":"","xl10":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-start":"","align-start":""}},[_c('h4',{staticClass:"text-transform mt-2"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticClass:"color-grey text-transform"},[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('span',{staticClass:"mt-1 color-grey text-transform"},[_vm._v("เป็นเพื่อนกันเมื่อ : "+_vm._s(_vm.convert_date(item.timestamp_friend)))])])],1)],1)],1)],1)}))],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"hidden-md-and-up",attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-navigation-drawer',{attrs:{"app":"","mini-variant":_vm.mini,"stateless":""},on:{"update:miniVariant":function($event){_vm.mini=$event}},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{staticClass:"transparent",staticStyle:{"height":"220px"},attrs:{"flat":""}},[_c('v-list',{staticClass:"pa-0"},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-btn',{attrs:{"flat":"","icon":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.mini = !_vm.mini}}},[_c('v-icon',[_vm._v(_vm._s(_vm.mini ? 'fas fa-chevron-left' : 'fas fa-chevron-right'))])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":"50"}},[(_vm.profile_picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.profile_picture}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('h3',{staticClass:"mt-3 text-transform-bot"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('h4',{staticClass:"mt-3 text-transform-bot color-grey"},[_vm._v(_vm._s(_vm.status))]),_vm._v(" "),_c('h4',{staticClass:"mt-1 color-grey"},[_vm._v(_vm._s(_vm.email))]),_vm._v(" "),_c('v-btn',{staticClass:"mt-2",attrs:{"color":"primary","round":"","outline":"","small":""},on:{"click":function($event){_vm.logout()}}},[_vm._v("ออกจากระบบ")])],1)],1),_vm._v(" "),(_vm.list_friend_user.length !== 0)?_c('v-list',{staticClass:"pt-0 height-listbot-friend-mobile overflow-y",staticStyle:{"width":"100%"},attrs:{"three-line":"","dense":""}},[_c('v-divider'),_vm._v(" "),_vm._l((_vm.list_friend_user),function(item,index){return [_c('v-list-tile',{key:item.tokenuser,attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-avatar',{staticClass:"mt-3",attrs:{"size":"50"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture,"alt":"alt"}}):_c('img',{staticClass:"alligator-turtle border-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs10":"","sm10":"","md10":"","lg10":"","xl10":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-start":"","align-start":""}},[_c('h4',{staticClass:"text-transform mt-2"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticClass:"color-grey text-transform"},[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('span',{staticClass:"mt-1 color-grey text-transform"},[_vm._v("เป็นเพื่อนกันเมื่อ : "+_vm._s(_vm.convert_date(item.timestamp_friend)))])])],1)],1)],1)],1),_vm._v(" "),(index + 1 < _vm.list_friend_user.length)?_c('v-divider',{key:index}):_vm._e()]})],2):_c('h4',{staticClass:"mt-5 text-center"},[_vm._v("ไม่มีรายการเพื่อน")])],1),_vm._v(" "),_c('v-content',[_c('v-flex',{staticClass:"mt-1 ml-2",attrs:{"xs12":"","md12":"","sm12":"","lg12":"","md12":""}},[_c('h2',{staticClass:"mb-3",staticStyle:{"text-align":"center"}},[_vm._v("ค้นหาข้อมูล")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-text-field',{attrs:{"name":"name","label":"กรุณากรอกชื่อผู้ใช้งานหรืออีเมลของบุคคลที่ต้องการค้นหา...","id":"id","clearable":"","solo":"","dense":"","hide-details":"","prepend-inner-icon":"search"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.search_friend()}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","round":"","disabled":_vm.search === '' || _vm.search === null},on:{"click":function($event){_vm.search_friend()}}},[_vm._v("ค้นหา")])],1),_vm._v(" "),(_vm.progress_seach)?_c('v-layout',{staticClass:"height-listbot",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":80,"width":4,"color":"primary","indeterminate":_vm.progress_seach}})],1):_c('v-layout',{attrs:{"column":"","justify-center":"","align-center":""}},[(_vm.list_friend_serch.length === 0)?_c('v-layout',{attrs:{"column":"","justify-center":"","align-center":""}},[_c('h3',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.message_search))])]):_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"column":"","justify-start":"","align-start":""}},[_c('v-flex',{staticStyle:{"width":"100%"},attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('h3',{staticClass:"text-transform mt-1"},[_vm._v("ข้อมูลส่วนตัว")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-avatar',{staticClass:"mt-3",attrs:{"size":"70"}},[(_vm.infor_friend_search.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.infor_friend_search.profilepicture,"alt":"alt"}}):_c('img',{staticClass:"alligator-turtle border-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('h4',{staticClass:"text-transform-bot mt-2"},[_vm._v(_vm._s(_vm.infor_friend_search.nickname))]),_vm._v(" "),_c('span',{staticClass:"color-grey text-transform-bot"},[_vm._v(_vm._s(_vm.infor_friend_search.status))]),_vm._v(" "),_c('span',{staticClass:"color-grey text-transform"},[_vm._v(_vm._s(_vm.infor_friend_search.email))]),_vm._v(" "),(_vm.list_infor_business.length !== 0)?_c('v-btn',{staticClass:"mt-2",attrs:{"color":"primary","small":"","round":"","outline":""},on:{"click":_vm.opendialog}},[_vm._v("ข้อมูลองค์กร")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('span',{staticClass:"mt-2"},[_vm._v("รายชื่อบอทที่เป็นเพื่อนกับ")]),_c('h4',{staticClass:"text-transform mt-2 ml-2"},[_vm._v(_vm._s(_vm.infor_friend_search.nickname))])]),_vm._v(" "),_c('v-layout',{staticClass:"height-listbot overflow-y mt-3",attrs:{"row":"","wrap":""}},_vm._l((_vm.list_friend_serch),function(item,index){return _c('v-flex',{key:item.tokenuser,staticClass:"mt-2 mb-3 pl-3",attrs:{"xs12":"","d-flex":""}},[_c('v-card',{staticClass:"d-flex",staticStyle:{"min-height":"90px","border-radius":"20px","width":"200px","margin-right":"10px"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"pl-3",attrs:{"xs2":"","sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-avatar',{staticClass:"mt-3",attrs:{"size":"50"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture,"alt":"alt"}}):_c('img',{staticClass:"alligator-turtle border-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}})])],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs10":"","sm10":"","md10":"","lg10":"","xl10":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-start":"","align-start":""}},[_c('h4',{staticClass:"text-transform mt-2"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticClass:"color-grey text-transform"},[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('span',{staticClass:"mt-1 color-grey text-transform"},[_vm._v("เป็นเพื่อนกันเมื่อ : "+_vm._s(_vm.convert_date(item.timestamp_friend)))])])],1)],1)],1)],1)}))],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',{staticClass:"mt-2"},[_vm._v("ข้อมูลองค์กร")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.closedialog}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticStyle:{"margin-left":"10px","width":"200px","overflow-x":"scroll","overflow-y":"hidden","display":"-webkit-inline-box","background":"none"}},_vm._l((_vm.list_infor_business),function(infor,index){return _c('div',{staticClass:"mb-4"},[_c('v-card',{staticStyle:{"border-radius":"20px","width":"200px","margin-right":"10px"}},[_c('v-layout',{staticStyle:{"height":"170px"},attrs:{"column":"","wrap":"","align-center":"","justify-start":""}},[_c('v-avatar',{staticClass:"mt-3",attrs:{"size":"50"}},[(infor.business_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":infor.business_pic,"alt":"alt"}}):_c('img',{staticClass:"alligator-turtle border-img",attrs:{"src":"/static/img/default_profile/business-white.png"}})]),_vm._v(" "),_c('h4',{staticClass:"text-transform-bot mt-2"},[_vm._v("บริษัท : "+_vm._s(infor.business_name))]),_vm._v(" "),_c('span',{staticClass:"mt-2 color-grey text-transform-bot"},[_vm._v("ตำแหน่ง : "+_vm._s(infor.role_name))])],1)],1)],1)}))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":_vm.closedialog}},[_vm._v("\n          ตกลง\n        ")])],1)],1)],1)],1):_vm._e()}
var Relation_friend_staticRenderFns = []
var Relation_friend_esExports = { render: Relation_friend_render, staticRenderFns: Relation_friend_staticRenderFns }
/* harmony default export */ var homepage_Relation_friend = (Relation_friend_esExports);
// CONCATENATED MODULE: ./src/components/homepage/Relation_friend.vue
function Relation_friend_injectStyle (ssrContext) {
  __webpack_require__("FucP")
}
var Relation_friend_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Relation_friend___vue_template_functional__ = false
/* styles */
var Relation_friend___vue_styles__ = Relation_friend_injectStyle
/* scopeId */
var Relation_friend___vue_scopeId__ = "data-v-040d2f48"
/* moduleIdentifier (server only) */
var Relation_friend___vue_module_identifier__ = null
var Relation_friend_Component = Relation_friend_normalizeComponent(
  Relation_friend,
  homepage_Relation_friend,
  Relation_friend___vue_template_functional__,
  Relation_friend___vue_styles__,
  Relation_friend___vue_scopeId__,
  Relation_friend___vue_module_identifier__
)

/* harmony default export */ var components_homepage_Relation_friend = (Relation_friend_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/vue2-datepicker/index.esm.js + 5 modules
var index_esm = __webpack_require__("trBP");

// EXTERNAL MODULE: ./node_modules/vue2-datepicker/index.css
var vue2_datepicker = __webpack_require__("1QwG");
var vue2_datepicker_default = /*#__PURE__*/__webpack_require__.n(vue2_datepicker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/conference/layoutConference.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var layoutConference = ({
  components: {
    DatePicker: index_esm["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      showPassword: false,
      show1: false,
      messages: [{
        avatar: 'https://avatars0.githubusercontent.com/u/9064066?v=4&s=460',
        name: 'John Leider',
        title: 'Welcome to Vuetify.js!',
        excerpt: 'Thank you for joining our community...'
      }, {
        color: 'red',
        icon: 'people',
        name: 'Social',
        new: 1,
        total: 3,
        title: 'Twitter'
      }, {
        color: 'teal',
        icon: 'local_offer',
        name: 'Promos',
        new: 2,
        total: 4,
        title: 'Shop your way',
        exceprt: 'New deals available, Join Today'
      }],
      createroom_dialog: false,
      text: 'test',
      tab: 'tab-1',
      headers: [{
        text: 'Dessert (100g serving)',
        align: 'left',
        sortable: false,
        value: 'name'
      }, { text: 'Calories', value: 'calories' }, { text: 'Fat (g)', value: 'fat' }, { text: 'Carbs (g)', value: 'carbs' }, { text: 'Protein (g)', value: 'protein' }, { text: 'Iron (%)', value: 'iron' }],
      desserts: [{
        name: 'Frozen Yogurt',
        calories: 159,
        fat: 6.0,
        carbs: 24,
        protein: 4.0,
        iron: '1%'
      }, {
        name: 'Ice cream sandwich',
        calories: 237,
        fat: 9.0,
        carbs: 37,
        protein: 4.3,
        iron: '1%'
      }, {
        name: 'Eclair',
        calories: 262,
        fat: 16.0,
        carbs: 23,
        protein: 6.0,
        iron: '7%'
      }, {
        name: 'Cupcake',
        calories: 305,
        fat: 3.7,
        carbs: 67,
        protein: 4.3,
        iron: '8%'
      }, {
        name: 'Gingerbread',
        calories: 356,
        fat: 16.0,
        carbs: 49,
        protein: 3.9,
        iron: '16%'
      }, {
        name: 'Jelly bean',
        calories: 375,
        fat: 0.0,
        carbs: 94,
        protein: 0.0,
        iron: '0%'
      }, {
        name: 'Lollipop',
        calories: 392,
        fat: 0.2,
        carbs: 98,
        protein: 0,
        iron: '2%'
      }, {
        name: 'Honeycomb',
        calories: 408,
        fat: 3.2,
        carbs: 87,
        protein: 6.5,
        iron: '45%'
      }, {
        name: 'Donut',
        calories: 452,
        fat: 25.0,
        carbs: 51,
        protein: 4.9,
        iron: '22%'
      }, {
        name: 'KitKat',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%'
      }],
      items: [{ title: 'Click Me' }, { title: 'Click Me' }, { title: 'Click Me' }, { title: 'Click Me 2' }],
      drawer: null,
      member: []
    }, defineProperty_default()(_ref, 'items', []), defineProperty_default()(_ref, 'search', ""), defineProperty_default()(_ref, 'switch1', true), defineProperty_default()(_ref, 'date', new Date()), defineProperty_default()(_ref, 'time', new Date()), defineProperty_default()(_ref, 'subject', ''), defineProperty_default()(_ref, 'duration', ''), defineProperty_default()(_ref, 'password', ''), defineProperty_default()(_ref, 'phones', []), defineProperty_default()(_ref, 'checktypemail', null), defineProperty_default()(_ref, 'member_invite', []), defineProperty_default()(_ref, 'emailRules', [function (v) {
      for (var i = 0; i < v.length; i++) {
        if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v[i])) {
          // this.checktypemail = false
          return 'รูปแบบอีเมลไม่ถูกต้อง';
        }
        // v[i] = parseInt(v[i]);
      }
    }]), defineProperty_default()(_ref, 'activeColor', 'red'), defineProperty_default()(_ref, 'fontSize', 30), defineProperty_default()(_ref, 'height', window.innerHeight), defineProperty_default()(_ref, 'totalHeight', 100), _ref;
  },
  mounted: function mounted() {
    this.makeid();
    console.log(window.innerHeight);
    // let height = this.$refs.infoBox.clientHeight;
    // console.log(height)
  },

  watch: {
    member: function member() {
      var list_member = this.member;
      this.member_invite = list_member;
      var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var result = list_member.filter(function (email) {
        return !regex.test(email);
      });
      // console.log(result)
      if (result.length == 0) {
        // mail ok
        this.checktypemail = true;
      } else {
        this.checktypemail = false;
      }
    }
  },
  methods: {
    cancle: function cancle() {
      var _this = this;

      this.$swal({
        title: 'ต้องการลบข้อมูลทั้งหมดใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1976d2',
        cancelButtonColor: 'grey',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this.subject = '';
          _this.date = null;
          _this.time = null;
          _this.duration = '';
          _this.member = [];
          _this.makeid();
        }
      });
    },
    disableBtn: function disableBtn() {
      if (this.subject != '' && this.date != null && this.time != null && this.duration != '' && this.password != '' && this.member_invite.length > 0 && this.checktypemail == true) {
        return false;
      } else {
        return true;
      }
    },
    openDialog: function openDialog() {
      this.createroom_dialog = true;
    },
    closeDialog: function closeDialog(value) {
      this.createroom_dialog = value;
    },
    updateTags: function updateTags() {
      var _member;

      (_member = this.member).push.apply(_member, toConsumableArray_default()(this.search.split(",")));
      this.search = "";
    },
    makeid: function makeid() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (var i = 0; i < 7; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      // console.log(text)
      this.password = text;
    },
    notBeforeToday: function notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    createRoomConference: function createRoomConference() {
      var data = {
        subject: this.subject,
        key: this.password,
        date: this.date,
        time: this.time,
        duration: this.duration,
        secretroom: this.switch1,
        member: this.member_invite
      };
      console.log(data);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c37d9ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/conference/layoutConference.vue
var layoutConference_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"color":"white"}},[_c('v-toolbar-items',[_c('v-layout',{attrs:{"align-center":"","fill-height":""}},[_c('img',{staticStyle:{"height":"50px","padding-top":"4px"},attrs:{"src":"/static/img/inet/inetlogo.jpg","alt":""}})])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-side-icon',{staticStyle:{"color":"grey"},on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}})],1),_vm._v(" "),_c('div',{staticClass:"bodyConference hidden-sm-and-down",staticStyle:{"height":"100vh"}},[_c('div',{staticClass:"bodytab"},[_c('v-tabs',{attrs:{"width":"800","color":"white","slider-color":"#1976D2"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{staticStyle:{"color":"#1976D2"},attrs:{"href":"#tab-1"}},[_vm._v("\n            สร้างห้องประชุม\n          ")]),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{attrs:{"id":"tab-1"}},[_c('v-card',[_c('v-layout',{staticStyle:{"padding-left":"120px","padding-right":"120px"},attrs:{"column":"","justify-center":""}},[_c('div',{staticStyle:{"padding":"24px 24px 0px 24px"}},[_c('v-layout',{class:_vm.$vuetify.breakpoint.height <400 ? 'web' : 'other_web',attrs:{"column":""}},[_c('div',{staticStyle:{"padding":"24px","width":"70vh"}},[_c('v-layout',{attrs:{"column":""}},[_c('span',{staticClass:"headerInputMobile",staticStyle:{"margin-bottom":"10px"}},[_vm._v("หัวข้อการประชุม :")]),_vm._v(" "),_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"},attrs:{"solo":"","label":"หัวข้อการประชุม","hide-details":""},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}}),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-bottom":"8px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('div',{staticStyle:{"margin-bottom":"10px","margin-top":"10px"}},[_c('span',{staticClass:"headerInputMobile"},[_vm._v("วันและเวลา :")])]),_vm._v(" "),_c('date-picker',{staticStyle:{"margin-top":"10px"},attrs:{"value-type":"date","placeholder":"กรุณาเลือกวัน","disabled-date":_vm.notBeforeToday,"format":"dddd, MMM, YYYY"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('date-picker',{attrs:{"type":"time","placeholder":"กรุณาเลือกเวลา","format":"HH:mm"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"12px"},attrs:{"xs5":"","sm5":"","md5":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.duration),expression:"duration"}],staticClass:"mx-input",attrs:{"type":"text","placeholder":"ระยะเวลา"},domProps:{"value":(_vm.duration)},on:{"input":function($event){if($event.target.composing){ return; }_vm.duration=$event.target.value}}})]),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"Inputminute"},[_vm._v("นาที")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-bottom":"15px","margin-top":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{staticStyle:{"margin-top":"10px","margin-bottom":"10px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{staticClass:"headerInputMobile"},[_vm._v("ส่งคำเชิญไปที่ :")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs9":"","sm9":"","md9":""}},[_c('v-combobox',{staticClass:"tag-input",attrs:{"multiple":"","placeholder":"กรุณากรอกอีเมล","outline":"","append-icon":"","chips":"","small-chips":"","allow-overflow":"","deletable-chips":"","search-input":_vm.search,"hide-details":""},on:{"update:searchInput":function($event){_vm.search=$event}},model:{value:(_vm.member),callback:function ($$v) {_vm.member=$$v},expression:"member"}}),_vm._v(" "),(_vm.checktypemail === false)?_c('p',{staticStyle:{"color":"red","margin-bottom":"0px"}},[_vm._v("รูปแบบอีเมลไม่ถูกต้อง")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-btn',{attrs:{"outline":"","small":""},on:{"click":_vm.updateTags}},[_c('v-icon',[_vm._v("mdi-plus")]),_vm._v("\n                                        เพิ่ม\n                                      ")],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-bottom":"10px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('span',{staticClass:"headerInputMobile"},[_vm._v("ตั้งรหัสผ่าน :")])]),_vm._v(" "),_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"},attrs:{"solo":"","label":"รหัสผ่าน","hide-details":"","append-icon":"fas fa-dice"},on:{"click:append":function($event){_vm.makeid()}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"10px","padding-bottom":"10px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{attrs:{"align-center":"","fill-height":""}},[_c('span',{staticClass:"headerInputMobile"},[_vm._v("Secret meeting :")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"hide-details":""},model:{value:(_vm.switch1),callback:function ($$v) {_vm.switch1=$$v},expression:"switch1"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","justify-end":""}},[_c('v-btn',{staticStyle:{"border-radius":"12px"},attrs:{"color":"primary","disabled":_vm.disableBtn()},on:{"click":function($event){_vm.createRoomConference()}}},[_vm._v("บันทึก")]),_vm._v(" "),_c('v-btn',{staticStyle:{"border-radius":"12px","color":"grey"},attrs:{"outline":""},on:{"click":function($event){_vm.cancle()}}},[_vm._v("เคลียร์")])],1)],1)])],1)])],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[_c('v-card',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-data-table',{staticClass:"elevation-1",staticStyle:{"margin-top":"20px","margin-bottom":"20px"},attrs:{"headers":_vm.headers,"items":_vm.desserts},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.calories))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.fat))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.carbs))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.protein))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.iron))])]}}])})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-3"}},[_c('v-card',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-data-table',{staticClass:"elevation-1",staticStyle:{"margin-top":"20px","margin-bottom":"20px"},attrs:{"headers":_vm.headers,"items":_vm.desserts},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.calories))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.fat))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.carbs))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.protein))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.iron))])]}}])})],1)],1)],1)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"hidden-md-and-up",staticStyle:{"height":"100vh"}},[_c('v-layout',{staticStyle:{"margin-top":"24px !important"},attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('v-tabs',{attrs:{"color":"white","slider-color":"#1976D2"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{staticStyle:{"color":"#1976D2"},attrs:{"href":"#tab-1"}},[_vm._v("\n                สร้างห้องประชุม\n              ")]),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{attrs:{"id":"tab-1"}},[_c('v-card',[_c('v-layout',{staticStyle:{"overflow-y":"auto"},style:({height:'calc(100vh - '+128+'px'}),attrs:{"justify-center":""}},[_c('div',{staticStyle:{"padding":"24px","width":"70vh"}},[_c('v-layout',{attrs:{"column":""}},[_c('span',{staticClass:"headerInputMobile",staticStyle:{"margin-bottom":"10px"}},[_vm._v("หัวข้อการประชุม :")]),_vm._v(" "),_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"},attrs:{"solo":"","label":"หัวข้อการประชุม","hide-details":""},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}}),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-bottom":"8px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('div',{staticStyle:{"margin-bottom":"10px","margin-top":"10px"}},[_c('span',{staticClass:"headerInputMobile"},[_vm._v("วันและเวลา :")])]),_vm._v(" "),_c('date-picker',{staticStyle:{"margin-top":"10px"},attrs:{"value-type":"date","placeholder":"กรุณาเลือกวัน","disabled-date":_vm.notBeforeToday,"format":"dddd, MMM, YYYY"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('date-picker',{attrs:{"type":"time","placeholder":"กรุณาเลือกเวลา","format":"HH:mm"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-left":"12px"},attrs:{"xs5":"","sm5":"","md5":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.duration),expression:"duration"}],staticClass:"mx-input",attrs:{"type":"text","placeholder":"ระยะเวลา"},domProps:{"value":(_vm.duration)},on:{"input":function($event){if($event.target.composing){ return; }_vm.duration=$event.target.value}}})]),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"Inputminute"},[_vm._v("นาที")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-bottom":"15px","margin-top":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{staticStyle:{"margin-top":"10px","margin-bottom":"10px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{staticClass:"headerInputMobile"},[_vm._v("ส่งคำเชิญไปที่ :")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs9":"","sm9":"","md9":""}},[_c('v-combobox',{staticClass:"tag-input",attrs:{"multiple":"","placeholder":"กรุณากรอกอีเมล","outline":"","append-icon":"","chips":"","small-chips":"","allow-overflow":"","deletable-chips":"","search-input":_vm.search,"hide-details":""},on:{"update:searchInput":function($event){_vm.search=$event}},model:{value:(_vm.member),callback:function ($$v) {_vm.member=$$v},expression:"member"}}),_vm._v(" "),(_vm.checktypemail === false)?_c('p',{staticStyle:{"color":"red","margin-bottom":"0px"}},[_vm._v("รูปแบบอีเมลไม่ถูกต้อง")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-btn',{attrs:{"outline":"","small":""},on:{"click":_vm.updateTags}},[_c('v-icon',[_vm._v("mdi-plus")]),_vm._v("\n                                        เพิ่ม\n                                      ")],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-bottom":"10px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('span',{staticClass:"headerInputMobile"},[_vm._v("ตั้งรหัสผ่าน :")])]),_vm._v(" "),_c('v-text-field',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"},attrs:{"solo":"","label":"รหัสผ่าน","hide-details":"","append-icon":"fas fa-dice"},on:{"click:append":function($event){_vm.makeid()}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"10px","padding-bottom":"10px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{attrs:{"align-center":"","fill-height":""}},[_c('span',{staticClass:"headerInputMobile"},[_vm._v("Secret meeting :")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"hide-details":""},model:{value:(_vm.switch1),callback:function ($$v) {_vm.switch1=$$v},expression:"switch1"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"padding-bottom":"10px"},attrs:{"row":"","justify-end":""}},[_c('v-btn',{staticStyle:{"border-radius":"12px"},attrs:{"color":"primary","disabled":_vm.disableBtn()},on:{"click":function($event){_vm.createRoomConference()}}},[_vm._v("บันทึก")]),_vm._v(" "),_c('v-btn',{staticStyle:{"border-radius":"12px","color":"grey"},attrs:{"outline":""},on:{"click":function($event){_vm.cancle()}}},[_vm._v("เคลียร์")])],1)],1)])],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[_c('v-card',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.desserts},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.calories))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.fat))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.carbs))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.protein))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.iron))])]}}])})],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-3"}},[_c('v-card',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.desserts},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.calories))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.fat))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.carbs))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.protein))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.iron))])]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.drawer)?_c('v-navigation-drawer',{attrs:{"absolute":"","temporary":"","right":"","height":"100vh","width":"200"},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":"https://cdn.vuetifyjs.com/images/lists/1.jpg"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("test1234567 test")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("teset@mail.com")])],1)],1)],1)],1):_vm._e()],1)}
var layoutConference_staticRenderFns = []
var layoutConference_esExports = { render: layoutConference_render, staticRenderFns: layoutConference_staticRenderFns }
/* harmony default export */ var conference_layoutConference = (layoutConference_esExports);
// CONCATENATED MODULE: ./src/components/conference/layoutConference.vue
function layoutConference_injectStyle (ssrContext) {
  __webpack_require__("E14g")
}
var layoutConference_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var layoutConference___vue_template_functional__ = false
/* styles */
var layoutConference___vue_styles__ = layoutConference_injectStyle
/* scopeId */
var layoutConference___vue_scopeId__ = "data-v-5c37d9ea"
/* moduleIdentifier (server only) */
var layoutConference___vue_module_identifier__ = null
var layoutConference_Component = layoutConference_normalizeComponent(
  layoutConference,
  conference_layoutConference,
  layoutConference___vue_template_functional__,
  layoutConference___vue_styles__,
  layoutConference___vue_scopeId__,
  layoutConference___vue_module_identifier__
)

/* harmony default export */ var components_conference_layoutConference = (layoutConference_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// CONCATENATED MODULE: ./src/agora.config.js
var AGORA_APP_ID = 'b63e9546e042410dbc7158d58d766341';
// EXTERNAL MODULE: ./node_modules/agora-rtc-sdk-ng/AgoraRTC_N-production.js
var AgoraRTC_N_production = __webpack_require__("te/r");
var AgoraRTC_N_production_default = /*#__PURE__*/__webpack_require__.n(AgoraRTC_N_production);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/agora_call/end_call_v2.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var end_call_v2 = ({
  props: {
    EndCallDialog: Boolean,
    infor_friend: {},
    time_count: Number
  },
  data: function data() {
    return {};
  },
  created: function created() {
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
  },

  watch: {
    EndCallDialog: function EndCallDialog() {
      if (this.EndCallDialog) {
        // console.log(this.infor_friend)
      }
    }
  },
  methods: {
    closedialog: function closedialog() {
      this.$emit('closeEndCallDialog', false);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa874c88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/agora_call/end_call_v2.vue
var end_call_v2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"width":"500","persistent":""},model:{value:(_vm.EndCallDialog),callback:function ($$v) {_vm.EndCallDialog=$$v},expression:"EndCallDialog"}},[_c('v-card',{staticStyle:{"height":"350px !important"}},[_c('v-card-text',[_c('v-layout',{staticStyle:{"height":"265px !important"},attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":100}},[(_vm.infor_friend.picture)?_c('img',{staticClass:"img-w-h",attrs:{"src":_vm.infor_friend.picture}}):_c('img',{staticClass:"img-w-h",attrs:{"src":"/static/img/default_profile/bot-white.png"}})]),_vm._v(" "),_c('h3',{staticClass:"text-overflow mt-3 text-transform"},[_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.end')))]),_vm._v(" "),_c('h2',{staticClass:"text-overflow mt-3"},[_vm._v(_vm._s(_vm.infor_friend.nickname))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"border-radius text-transform",attrs:{"dark":"","color":"primary"},on:{"click":function($event){_vm.closedialog()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1)],1)],1)}
var end_call_v2_staticRenderFns = []
var end_call_v2_esExports = { render: end_call_v2_render, staticRenderFns: end_call_v2_staticRenderFns }
/* harmony default export */ var agora_call_end_call_v2 = (end_call_v2_esExports);
// CONCATENATED MODULE: ./src/components/chat/agora_call/end_call_v2.vue
function end_call_v2_injectStyle (ssrContext) {
  __webpack_require__("kin6")
}
var end_call_v2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var end_call_v2___vue_template_functional__ = false
/* styles */
var end_call_v2___vue_styles__ = end_call_v2_injectStyle
/* scopeId */
var end_call_v2___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var end_call_v2___vue_module_identifier__ = null
var end_call_v2_Component = end_call_v2_normalizeComponent(
  end_call_v2,
  agora_call_end_call_v2,
  end_call_v2___vue_template_functional__,
  end_call_v2___vue_styles__,
  end_call_v2___vue_scopeId__,
  end_call_v2___vue_module_identifier__
)

/* harmony default export */ var chat_agora_call_end_call_v2 = (end_call_v2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/agora_call/video_call_v3.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// create Agora client
var client = AgoraRTC_N_production_default.a.createClient({ mode: "rtc", codec: "vp8" });
var video_call_v3__ = __webpack_require__("M4fF");
var localTracks = {
  videoTrack: null,
  audioTrack: null
};
var localTrackState = {
  videoTrackMuted: false,
  audioTrackMuted: false
};
var recorder = void 0;
var audio = void 0;

/* harmony default export */ var video_call_v3 = ({
  components: {
    EndCallDialog: chat_agora_call_end_call_v2
  },
  data: function data() {
    return {
      options: {
        appid: null,
        channel: null,
        uid: null,
        token: null
      },
      remoteUsers: {},
      typeCall: '',
      disableJoin: false,
      time_count: 0,
      tokenuser: '',
      infor_friend: {},
      picture_user: '',
      EndCallDialog: false,
      muteState: false,
      muteStateFriend: false,
      muteStateVideo: false,
      muteVideoUser: false,
      statusTime: false,
      recordStatus: false
    };
  },

  props: {
    msg: String
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  sockets: {
    connect: function connect() {
      console.log('socket connected');
      this.$socket.emit('join', { room: this.tokenuser, type: 'web' });
    },
    disconnect: function disconnect() {
      console.log('disconnected');
    },
    update_agora: function update_agora(data) {
      console.log(data);
      this.socket_update_agora = data;
      if (data.status === 'end') {
        // end call
        this.disableJoin = false;
        // this.leave_btn()
        this.cleartimer();
        if (this.typeCall !== 'video') {
          localTracks['audioTrack'].stop();
          localTracks['audioTrack'].close();
        } else {
          localTracks['videoTrack'].stop();
          localTracks['videoTrack'].close();
          localTracks['audioTrack'].stop();
          localTracks['audioTrack'].close();
        }

        // remove remote users and player views
        this.remoteUsers = {};
        if (document.getElementById('remote-playerlist') !== null) {
          document.getElementById('remote-playerlist').innerHTML = '';
          document.getElementById('local-player').innerHTML = '';
        }
        // leave the channel
        client.leave();
        var me = this;
        setTimeout(function () {
          me.EndCallDialog = true;
        }, 2000);
      }
    }
  },
  watch: {
    socket_update_agora: function socket_update_agora(data) {
      console.log(data);
    }
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    this.$socket.emit('join', { room: this.tokenuser, type: 'web' });

    this.infor_friend = JSON.parse(services["a" /* Decode */].decode(this.$route.query.user_infor));
    this.options.token = services["a" /* Decode */].decodeToken(this.$route.query.token);
    this.options.channel = services["a" /* Decode */].decodeToken(this.$route.query.channel_name);
    this.options.appid = AGORA_APP_ID;
    this.options.uid = this.infor_friend.one_id;
    this.typeCall = this.$route.params.typecall;
    this.picture_user = localStorage.getItem('profilepicture');
    console.log(this.infor_friend);
    console.log(this.options);
    // this.getRoom(this.tokenuser, this.$route.params.roomid)
    // this.getOneID(this.tokenuser)
    this.submit();
    // console.log(this.options)
    // console.log(this.infor_friend)
  },

  methods: {
    switchToVideo: function switchToVideo() {
      try {
        var me = this;
        this.$swal({
          type: 'info',
          title: 'ต้องการเปลี่ยนเป็นวิดีโอคอลหรือไม่?',
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          showCloseButton: true,
          showCancelButton: true,
          reverseButtons: true
        }).then(function (result) {
          if (result.value) {
            me.typeCall = 'video';
            client.unpublish(values_default()(localTracks));
            me.joinVideo();
            console.log(localTracks);
          } else {
            me.typeCall = 'audio';
          }
        });
      } catch (e) {
        console.log(e);
      }
      // me.typeCall = 'video'
      // await client.unpublish(Object.values(localTracks));
      // await me.joinVideo()
    },
    setAudio: function setAudio() {
      console.log(localTracks.audioTrack);
      if (!localTrackState.audioTrackMuted) {
        this.muteAudio();
      } else {
        this.unmuteAudio();
      }
    },
    unmuteAudio: function unmuteAudio() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(localTracks.audioTrack);
                _this.muteState = false;

                if (localTracks.audioTrack) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return localTracks.audioTrack.setEnabled(true);

              case 6:
                localTrackState.audioTrackMuted = false;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    muteAudio: function muteAudio() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(localTracks.audioTrack);
                _this2.muteState = true;

                if (localTracks.audioTrack) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                _context2.next = 6;
                return localTracks.audioTrack.setEnabled(false);

              case 6:
                localTrackState.audioTrackMuted = true;

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    muteVideo: function muteVideo() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('muteVideo');
                console.log(localTracks.videoTrack);
                _this3.muteStateVideo = true;

                if (localTracks.videoTrack) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt('return');

              case 5:
                _context3.next = 7;
                return localTracks.videoTrack.setEnabled(false);

              case 7:
                localTrackState.videoTrackMuted = true;

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    unmuteVideo: function unmuteVideo() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('un muteVideo');
                console.log(localTracks.videoTrack);
                _this4.muteStateVideo = false;

                if (localTracks.videoTrack) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt('return');

              case 5:
                _context4.next = 7;
                return localTracks.videoTrack.setEnabled(true);

              case 7:
                localTrackState.videoTrackMuted = false;
                localTracks.videoTrack.play("local-player");

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getOneID: function getOneID(tokenuser) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.axios.get("https://uatchat-manage.one.th/go_api/api" + ('/v1/getOneID/' + tokenuser)).then(function (response) {
                  if (response.data.status === 'success') {
                    _this5.options.uid = response.data.one_id;
                    // console.log(this.options)
                    _this5.submit();
                  }
                }).catch(function (err) {
                  console.log(err);
                });

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    getRoom: function getRoom(tokenuser, tokenroom) {
      var _this6 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: tokenuser,
        tokenroom: tokenroom
      }).then(function (response) {
        console.log(response.data);
        if (response.data.status === 'success') {
          _this6.infor_friend = response.data.data_room[0];
          console.log(_this6.infor_friend);
        }
      });
    },
    closeEndCallDialog: function closeEndCallDialog(value) {
      this.EndCallDialog = value;
      window.close();
    },
    joinVideo: function joinVideo() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        var me, user;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                console.log('join video');
                me = _this7;

                client.on("user-published", function () {
                  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(user, mediaType) {
                    return regenerator_default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return me.handleUserPublished(user, mediaType);

                          case 2:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this7);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
                client.on("user-unpublished", function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7(user, mediaType) {
                    return regenerator_default.a.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            _context7.next = 2;
                            return me.handleUserUnpublished(user, mediaType);

                          case 2:
                          case 'end':
                            return _context7.stop();
                        }
                      }
                    }, _callee7, _this7);
                  }));

                  return function (_x3, _x4) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                client.on("user-info-updated", function () {
                  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8(user, msg) {
                    return regenerator_default.a.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _context8.next = 2;
                            return me.handleUserInfoUpdate(user, msg);

                          case 2:
                          case 'end':
                            return _context8.stop();
                        }
                      }
                    }, _callee8, _this7);
                  }));

                  return function (_x5, _x6) {
                    return _ref3.apply(this, arguments);
                  };
                }());
                client.on("user-left", function () {
                  var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9(user, reason) {
                    return regenerator_default.a.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.next = 2;
                            return me.handleUserLeft(user, reason);

                          case 2:
                          case 'end':
                            return _context9.stop();
                        }
                      }
                    }, _callee9, _this7);
                  }));

                  return function (_x7, _x8) {
                    return _ref4.apply(this, arguments);
                  };
                }());
                // client.on("network-quality", async (stats) => {
                //   await me.handleNetwork(stats)
                // })
                // add event listener to play remote tracks when remote user publishs.
                console.log('mediaType: ' + me.typeCall);
                localTracks = {
                  videoTrack: null,
                  audioTrack: null
                };
                localTrackState = {
                  videoTrackMuted: false,
                  audioTrackMuted: false
                };
                _context10.next = 12;
                return AgoraRTC_N_production_default.a.createMicrophoneAudioTrack();

              case 12:
                localTracks.audioTrack = _context10.sent;
                _context10.next = 15;
                return AgoraRTC_N_production_default.a.createCameraVideoTrack({
                  encoderConfig: {
                    width: 640,
                    // Specify a value range and an ideal value
                    height: { ideal: 480, min: 400, max: 500 },
                    frameRate: 15,
                    bitrateMin: 600, bitrateMax: 1000
                  }
                });

              case 15:
                localTracks.videoTrack = _context10.sent;

                localTracks.videoTrack.play("local-player");
                console.log(localTracks);
                // publish local tracks to channel
                _context10.next = 20;
                return client.publish(values_default()(localTracks));

              case 20:
                user = {
                  uid: me.options.uid,
                  videoTrack: localTracks.videoTrack,
                  audioTrack: localTracks.audioTrack
                };

                console.log(user);
                // await client.subscribe(user, 'video')
                // me.unmuteVideo()
                console.log("publish video success");
                _context10.next = 29;
                break;

              case 25:
                _context10.prev = 25;
                _context10.t0 = _context10['catch'](0);

                console.log(_context10.t0);
                console.log(localTracks);

              case 29:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this7, [[0, 25]]);
      }))();
    },
    join: function join() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15() {
        var me, _ref9, _ref10, _ref11, _ref12;

        return regenerator_default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;

                console.log('join');
                me = _this8;
                // add event listener to play remote tracks when remote user publishs.

                client.on("user-published", function () {
                  var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11(user, mediaType) {
                    return regenerator_default.a.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            _context11.next = 2;
                            return me.handleUserPublished(user, mediaType);

                          case 2:
                          case 'end':
                            return _context11.stop();
                        }
                      }
                    }, _callee11, _this8);
                  }));

                  return function (_x9, _x10) {
                    return _ref5.apply(this, arguments);
                  };
                }());
                client.on("user-unpublished", function () {
                  var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12(user, mediaType) {
                    return regenerator_default.a.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            _context12.next = 2;
                            return me.handleUserUnpublished(user, mediaType);

                          case 2:
                          case 'end':
                            return _context12.stop();
                        }
                      }
                    }, _callee12, _this8);
                  }));

                  return function (_x11, _x12) {
                    return _ref6.apply(this, arguments);
                  };
                }());
                client.on("user-info-updated", function () {
                  var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13(user, msg) {
                    return regenerator_default.a.wrap(function _callee13$(_context13) {
                      while (1) {
                        switch (_context13.prev = _context13.next) {
                          case 0:
                            _context13.next = 2;
                            return me.handleUserInfoUpdate(user, msg);

                          case 2:
                          case 'end':
                            return _context13.stop();
                        }
                      }
                    }, _callee13, _this8);
                  }));

                  return function (_x13, _x14) {
                    return _ref7.apply(this, arguments);
                  };
                }());
                client.on("user-left", function () {
                  var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14(user, reason) {
                    return regenerator_default.a.wrap(function _callee14$(_context14) {
                      while (1) {
                        switch (_context14.prev = _context14.next) {
                          case 0:
                            _context14.next = 2;
                            return me.handleUserLeft(user, reason);

                          case 2:
                          case 'end':
                            return _context14.stop();
                        }
                      }
                    }, _callee14, _this8);
                  }));

                  return function (_x15, _x16) {
                    return _ref8.apply(this, arguments);
                  };
                }());
                // client.on("network-quality", async (stats) => {
                //   await me.handleNetwork(stats)
                // })
                console.log('mediaType: ' + me.typeCall);
                if (me.typeCall === 'video') {
                  localTracks = {
                    videoTrack: null,
                    audioTrack: null
                  };
                  localTrackState = {
                    videoTrackMuted: false,
                    audioTrackMuted: false
                  };
                }
                if (me.typeCall === 'audio') {
                  localTracks = {
                    audioTrack: null
                  };
                  localTrackState = {
                    audioTrackMuted: false
                  };
                }
                // console.log(localTracks)
                // console.log(localTrackState)

                if (!(me.typeCall === 'video')) {
                  _context15.next = 19;
                  break;
                }

                _context15.next = 13;
                return promise_default.a.all([
                // join the channel
                client.join(me.options.appid, me.options.channel, me.options.token || null, me.options.uid || null),
                // create local tracks, using microphone and camera
                AgoraRTC_N_production_default.a.createMicrophoneAudioTrack(), AgoraRTC_N_production_default.a.createCameraVideoTrack({
                  encoderConfig: {
                    width: 640,
                    // Specify a value range and an ideal value
                    height: { ideal: 480, min: 400, max: 500 },
                    frameRate: 15,
                    bitrateMin: 600, bitrateMax: 1000
                  }
                })]);

              case 13:
                _ref9 = _context15.sent;
                _ref10 = slicedToArray_default()(_ref9, 3);
                me.options.uid = _ref10[0];
                localTracks.audioTrack = _ref10[1];
                localTracks.videoTrack = _ref10[2];

                // play local video track
                localTracks.videoTrack.play("local-player");

              case 19:
                if (!(me.typeCall === 'audio')) {
                  _context15.next = 26;
                  break;
                }

                _context15.next = 22;
                return promise_default.a.all([
                // join the channel
                client.join(me.options.appid, me.options.channel, me.options.token || null, me.options.uid || null),
                // create local tracks, using microphone
                AgoraRTC_N_production_default.a.createMicrophoneAudioTrack()]);

              case 22:
                _ref11 = _context15.sent;
                _ref12 = slicedToArray_default()(_ref11, 2);
                me.options.uid = _ref12[0];
                localTracks.audioTrack = _ref12[1];

              case 26:

                console.log(localTracks);
                // publish local tracks to channel
                _context15.next = 29;
                return client.publish(values_default()(localTracks));

              case 29:
                console.log("publish success");
                _context15.next = 35;
                break;

              case 32:
                _context15.prev = 32;
                _context15.t0 = _context15['catch'](0);

                console.log(_context15.t0);

              case 35:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this8, [[0, 32]]);
      }))();
    },
    leave: function leave() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
        var trackName, track;
        return regenerator_default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                // console.log(localTracks)
                try {
                  for (trackName in localTracks) {
                    track = localTracks[trackName];

                    if (track) {
                      track.stop();
                      track.close();
                      localTracks[trackName] = undefined;
                    }
                  }
                  setTimeout(function () {
                    window.close();
                  }, 1000);
                } catch (e) {
                  console.log(e);
                }

                // remove remote users and player views
                _this9.remoteUsers = {};
                if (document.getElementById('remote-playerlist') !== null) {
                  document.getElementById('remote-playerlist').innerHTML = '';
                  document.getElementById('local-player').innerHTML = '';
                }
                // document.getElementById('local-player-name').innerHTML = ''
                // leave the channel
                _context16.next = 5;
                return client.leave();

              case 5:
                console.log("client leaves channel success");
                _this9.cleartimer();
                _this9.statusTime = false;
                // this.updataState()

              case 8:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this9);
      }))();
    },
    subscribe: function subscribe(user, mediaType) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17() {
        var me, uid, element, player;
        return regenerator_default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                console.log('subscribe: ', mediaType);
                console.log(user);
                me = _this10;
                uid = user.uid;
                // me.typeCall = mediaType

                console.log('subscribe success: ' + uid);
                // subscribe to a remote user
                _context17.next = 7;
                return client.subscribe(user, mediaType);

              case 7:
                console.log(localTracks);
                if (mediaType === 'video') {
                  me.typeCall = 'video';
                  // ถ้า localTracks ยังไม่มี video แต่เพื่อนขอเปลี่ยนเป็น video
                  if (localTracks.videoTrack === undefined) {
                    me.$swal({
                      type: 'warning',
                      text: me.infor_friend.nickname + ' \u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E17\u0E19\u0E32\u0E41\u0E1A\u0E1A\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D\u0E04\u0E2D\u0E25 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?',
                      confirmButtonText: 'ตกลง',
                      cancelButtonText: 'ยกเลิก',
                      showConfirmButton: true,
                      showCancelButton: true,
                      confirmButtonColor: 'primary',
                      cancelButtonColor: 'red'
                    }).then(function (result) {
                      if (result.value) {
                        console.log('document.getElementById ', document.getElementById('local-player') !== null);
                        // ยังไม่เปิดกล้อง เปิดกล้องตัวเอง
                        client.unpublish(values_default()(localTracks));
                        me.joinVideo();
                        // add subscribe video friend
                        me.remoteUsers[uid] = user;
                        console.log(me.remoteUsers[uid]);
                        // <p class="player-name">remoteUser(${uid})</p>
                        var player = '\n                <div id="player-wrapper-' + uid + '">\n                  <div id="player-' + uid + '" class="player" style="width: 700px !important; height: 320px !important;"></div>\n                </div>\n              ';
                        document.getElementById("remote-playerlist").insertAdjacentHTML('beforeend', player);
                        user.videoTrack.play('player-' + uid);
                      }
                    });
                  } else {
                    // ลบ element เก่า ออก
                    element = document.getElementById('player-wrapper-' + uid);

                    console.log(element);
                    if (element) {
                      element.remove();
                    }
                    // add video friend ใหม่
                    // <p class="player-name">remoteUser(${uid})</p>
                    player = '\n            <div id="player-wrapper-' + uid + '">\n              <div id="player-' + uid + '" class="player" style="width: 700px !important; height: 320px !important;"></div>\n            </div>\n          ';

                    document.getElementById("remote-playerlist").insertAdjacentHTML('beforeend', player);
                    user.videoTrack.play('player-' + uid);
                    // play local video track
                    localTracks.videoTrack.play("local-player");
                  }
                }
                if (mediaType === 'audio') {
                  console.log('document friend: ', document.getElementById('player-wrapper-' + uid));
                  console.log('document user: ', document.getElementById('local-player'));
                  if (localTracks.videoTrack !== undefined) {
                    me.typeCall = 'video';
                    if (document.getElementById('player-wrapper-' + uid !== null)) {
                      user.videoTrack.play('player-' + uid);
                      me.muteVideoUser = false;
                    } else {
                      me.muteVideoUser = true;
                    }
                    // play local video track
                    localTracks.videoTrack.play("local-player");
                  } else {
                    me.typeCall = 'audio';
                    user.audioTrack.play();
                  }
                }

              case 10:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this10);
      }))();
    },
    handleNetwork: function handleNetwork(stats) {
      console.log('handleNetwork: ', stats);
      console.log("downlinkNetworkQuality", stats.downlinkNetworkQuality);
      console.log("uplinkNetworkQuality", stats.uplinkNetworkQuality);
    },
    handleUserLeft: function handleUserLeft(user, reason) {
      console.log('handleUserLeft: ', user);
      console.log('handleUserLeft Reason: ', reason);
      var me = this;
      var id = user.uid;
      delete me.remoteUsers[id];
      // friend leave room
      if (reason === 'Quit') {
        if (user.uid !== me.options.uid) {
          setTimeout(function () {
            me.EndCallDialog = true;
            me.statusTime = false;
          }, 2000);
        }
      }
      // document.getElementById(`player-wrapper-${id}`).innerHTML = ''
    },
    handleUserPublished: function handleUserPublished(user, mediaType) {
      console.log('handleUserPublished: ' + mediaType);
      console.log('handleUserPublished: ', user);
      var me = this;
      // friend join room start timer
      if (user.uid !== me.options.uid) {
        me.statusTime = true;
        me.muteVideoUser = false;
        me.settimer();
      }
      var id = user.uid;
      console.log(me.typeCall);
      me.remoteUsers[id] = user;
      me.subscribe(user, mediaType);
      console.log(me.remoteUsers[id]);
    },
    handleUserJoined: function handleUserJoined(user) {
      console.log('handleUserJoined:', user);
      var me = this;
      var id = user.uid;
      me.remoteUsers[id] = user;
      console.log(me.remoteUsers[id]);
    },
    handleUserInfoUpdate: function handleUserInfoUpdate(user, msg) {
      console.log('handleUserInfoUpdate: ', user);
      console.log('handleUserInfoUpdate: ' + msg);
      var me = this;
      if (user.uid !== me.options.uid) {
        if (msg === 'mute-video') {
          me.muteVideoUser = true;
          var element = document.getElementById('player-wrapper-' + user.uid);
          console.log(element);
          if (element) {
            element.remove();
          }
        } else if (msg === 'unmute-video') {
          me.muteVideoUser = false;
        } else if (msg === 'mute-audio') {
          me.muteStateFriend = true;
        } else if (msg === 'unmute-audio') {
          me.muteStateFriend = false;
        }
      }
    },
    handleUserUnpublished: function handleUserUnpublished(user, mediaType) {
      console.log('handleUserUnpublished: ', user);
      console.log('handleUserUnpublished: ' + mediaType);
      var me = this;
      var id = user.uid;
      delete me.remoteUsers[id];
      if (mediaType === 'video') {
        var element = document.getElementById('player-wrapper-' + id);
        console.log(element);
        if (element) {
          element.remove();
        }
      }
    },
    submit: function submit() {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18() {
        var me;
        return regenerator_default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                me = _this11;
                _context18.prev = 1;

                console.log(me.options);
                _context18.next = 5;
                return me.join();

              case 5:
                _context18.next = 10;
                break;

              case 7:
                _context18.prev = 7;
                _context18.t0 = _context18['catch'](1);

                console.error(_context18.t0);

              case 10:
                _this11.disableJoin = true;
                // this.settimer()

              case 11:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this11, [[1, 7]]);
      }))();
    },
    leave_btn: function leave_btn() {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19() {
        var me;
        return regenerator_default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                me = _this12;
                _context19.next = 3;
                return me.leave();

              case 3:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, _this12);
      }))();
    },
    secondsToHms: function secondsToHms(d) {
      d = Number(d);
      var hours = Math.floor(d / 3600);
      var minutes = Math.floor((d - hours * 3600) / 60);
      var seconds = d - hours * 3600 - minutes * 60;
      var time = '';

      if (hours !== 0) {
        time = hours + ':';
      }
      if (minutes !== 0 || time !== '') {
        minutes = minutes < 10 && time !== '' ? '0' + minutes : String(minutes);
        time += minutes + ':';
      }
      if (time === '') {
        time = seconds + 's';
      } else {
        time += seconds < 10 ? '0' + seconds : String(seconds);
      }
      return time;
    },
    cleartimer: function cleartimer() {
      clearInterval(this.refreshIntervalId);
    },
    settimer: function settimer() {
      var _this13 = this;

      this.refreshIntervalId = setInterval(function () {
        return _this13.getSecs();
      }, 1000);
    },
    getSecs: function getSecs() {
      this.time_count = this.time_count + 1;
    },
    updataState: function updataState() {
      this.disableJoin = true;
      console.log(this.infor_friend);
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/update-agora', {
        tokenroom: this.infor_friend.tokenroom,
        tokenmessage: this.infor_friend.tokenmessage,
        tokenuser: this.tokenuser,
        time: this.time_count.toString(),
        message: 'end'
      }).then(function (response) {
        console.log(response.data);
        setTimeout(function () {
          window.close();
        }, 1000);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37b3ac6f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/agora_call/video_call_v3.vue
var video_call_v3_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello",staticStyle:{"overflow":"hidden","height":"100vh","background-color":"#202124"}},[_c('div',[(_vm.typeCall === 'video')?_c('div',{staticClass:"row video-group"},[(_vm.statusTime)?_c('v-layout',{staticStyle:{"height":"100vh","overflow":"hidden"},attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-layout',{staticStyle:{"height":"400px","border-radius":"10px","background-color":"#000000","margin":"10px"},attrs:{"row":"","wrap":"","justify-center":"","align-end":""}},[(!_vm.muteVideoUser)?_c('div',{staticClass:"ma-1",attrs:{"id":"remote-playerlist"}}):_c('v-avatar',{attrs:{"size":150}},[(_vm.infor_friend.picture)?_c('img',{staticClass:"img-w-h",attrs:{"src":_vm.infor_friend.picture}}):_c('img',{staticClass:"img-w-h",attrs:{"src":"/static/img/default_profile/bot-white.png"}})]),_vm._v(" "),_c('v-layout',{staticStyle:{"width":"100%","margin-left":"10px","margin-bottom":"10px"},attrs:{"row":"","wrap":"","align-center":""}},[_c('h3',{staticClass:"text-overflow mt-3 color-white"},[_vm._v(_vm._s(_vm.infor_friend.nickname))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.muteStateFriend)?_c('v-icon',{staticStyle:{"margin-right":"10px","margin-top":"20px","font-size":"15px !important"},attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-microphone")]):_c('v-icon',{staticStyle:{"margin-right":"10px","margin-top":"20px","font-size":"15px !important"},attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-microphone-slash")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":"","lg6":"","xl6":""}},[_c('v-layout',{staticStyle:{"height":"400px","border-radius":"10px","background-color":"#000000","margin":"10px"},attrs:{"row":"","wrap":"","justify-center":"","align-end":""}},[(!_vm.muteStateVideo)?_c('div',{staticClass:"player user-local-player ma-1",attrs:{"id":"local-player"}}):_c('v-avatar',{attrs:{"size":150}},[(_vm.picture_user)?_c('img',{staticClass:"img-w-h",attrs:{"src":_vm.picture_user}}):_c('img',{staticClass:"img-w-h",attrs:{"src":"/static/img/default_profile/bot-white.png"}})]),_vm._v(" "),_c('v-layout',{staticStyle:{"width":"100%","margin-left":"10px","margin-bottom":"10px"},attrs:{"row":"","wrap":"","align-center":""}},[_c('h3',{staticClass:"text-overflow mt-3 color-white"},[_vm._v("คุณ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.muteState)?_c('v-icon',{staticStyle:{"margin-right":"10px","margin-top":"20px","font-size":"15px !important"},attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-microphone")]):_c('v-icon',{staticStyle:{"margin-right":"10px","margin-top":"20px","font-size":"15px !important"},attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-microphone-slash")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.statusTime)?_c('div',{staticClass:"col width-video-call-user",staticStyle:{"height":"80vh","overflow":"hidden"}},[_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":150}},[(_vm.infor_friend.picture)?_c('img',{staticClass:"img-w-h",attrs:{"src":_vm.infor_friend.picture}}):_c('img',{staticClass:"img-w-h",attrs:{"src":"/static/img/default_profile/bot-white.png"}})]),_vm._v(" "),_c('div',{staticClass:"loader"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.typeCall === 'audio')?_c('v-layout',{staticStyle:{"height":"85vh","overflow":"hidden","background-color":"black","margin":"20px","border-radius":"20px"},attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":150}},[(_vm.infor_friend.picture)?_c('img',{staticClass:"img-w-h",attrs:{"src":_vm.infor_friend.picture}}):_c('img',{staticClass:"img-w-h",attrs:{"src":"/static/img/default_profile/bot-white.png"}})]),_vm._v(" "),(!_vm.muteStateFriend)?_c('v-icon',{staticStyle:{"position":"absolute","margin-top":"50px","font-size":"15px !important","top":"0px","right":"40px"},attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-microphone")]):_c('v-icon',{staticStyle:{"position":"absolute","margin-top":"50px","font-size":"15px !important","top":"0px","right":"40px"},attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-microphone-slash")]),_vm._v(" "),_c('h2',{staticClass:"text-overflow mt-5 color-white"},[_vm._v(_vm._s(_vm.infor_friend.nickname))]),_vm._v(" "),(_vm.statusTime)?_c('h4',{staticClass:"text-overflow mt-3 color-white"}):_c('div',{staticClass:"loader"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])],1):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"layout-bottom",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('div',{staticClass:"agora-button"},[(!_vm.muteState)?_c('v-btn',{attrs:{"color":"primary","dark":"","plain":"","fab":"","small":"","disabled":!_vm.statusTime},on:{"click":function($event){_vm.muteAudio()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-microphone")])],1):_c('v-btn',{attrs:{"color":"primary","plain":"","fab":"","small":""},on:{"click":function($event){_vm.unmuteAudio()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-microphone-slash")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"green","disabled":_vm.disableJoin,"fab":"","dark":"","small":""},on:{"click":function($event){_vm.submit()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-phone")])],1),_vm._v(" "),(_vm.typeCall === 'audio')?_c('v-btn',{attrs:{"color":"primary","plain":"","fab":"","dark":"","small":"","disabled":!_vm.statusTime},on:{"click":function($event){_vm.switchToVideo()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-video")])],1):_vm._e(),_vm._v(" "),(_vm.typeCall === 'video')?_c('div',[(!_vm.muteStateVideo)?_c('v-btn',{attrs:{"color":"primary","dark":"","plain":"","fab":"","small":"","disabled":!_vm.statusTime},on:{"click":function($event){_vm.muteVideo()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-video")])],1):_c('v-btn',{attrs:{"color":"primary","plain":"","fab":"","small":""},on:{"click":function($event){_vm.unmuteVideo()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-video-slash")])],1)],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","plain":"","disabled":!_vm.disableJoin,"fab":"","dark":"","small":""},on:{"click":function($event){_vm.leave_btn()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-phone-slash")])],1)],1)])],1),_vm._v(" "),_c('EndCallDialog',{attrs:{"EndCallDialog":_vm.EndCallDialog,"infor_friend":_vm.infor_friend,"time_count":_vm.time_count},on:{"closeEndCallDialog":_vm.closeEndCallDialog}})],1)}
var video_call_v3_staticRenderFns = []
var video_call_v3_esExports = { render: video_call_v3_render, staticRenderFns: video_call_v3_staticRenderFns }
/* harmony default export */ var agora_call_video_call_v3 = (video_call_v3_esExports);
// CONCATENATED MODULE: ./src/components/chat/agora_call/video_call_v3.vue
function video_call_v3_injectStyle (ssrContext) {
  __webpack_require__("o+65")
}
var video_call_v3_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var video_call_v3___vue_template_functional__ = false
/* styles */
var video_call_v3___vue_styles__ = video_call_v3_injectStyle
/* scopeId */
var video_call_v3___vue_scopeId__ = "data-v-37b3ac6f"
/* moduleIdentifier (server only) */
var video_call_v3___vue_module_identifier__ = null
var video_call_v3_Component = video_call_v3_normalizeComponent(
  video_call_v3,
  agora_call_video_call_v3,
  video_call_v3___vue_template_functional__,
  video_call_v3___vue_styles__,
  video_call_v3___vue_scopeId__,
  video_call_v3___vue_module_identifier__
)

/* harmony default export */ var chat_agora_call_video_call_v3 = (video_call_v3_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/agora_call/video_call_v4.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// create Agora client
var video_call_v4_client = AgoraRTC_N_production_default.a.createClient({ mode: "rtc", codec: "vp8" });
var video_call_v4__ = __webpack_require__("M4fF");
var video_call_v4_localTracks = {
  videoTrack: null,
  audioTrack: null
};
var video_call_v4_localTrackState = {
  videoTrackMuted: false,
  audioTrackMuted: false
};
var video_call_v4_recorder = void 0;
var video_call_v4_audio = void 0;

/* harmony default export */ var video_call_v4 = ({
  components: {
    EndCallDialog: chat_agora_call_end_call_v2
  },
  data: function data() {
    return {
      options: {
        appid: null,
        channel: null,
        uid: null,
        token: null
      },
      remoteUsers: {},
      typeCall: '',
      disableJoin: false,
      time_count: 0,
      tokenuser: '',
      infor_friend: {},
      picture_user: '',
      EndCallDialog: false,
      muteState: false,
      muteStateFriend: false,
      muteStateVideo: false,
      muteVideoUser: false,
      statusTime: false,
      recordStatus: false
    };
  },

  props: {
    msg: String
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  sockets: {
    connect: function connect() {
      console.log('socket connected');
      this.$socket.emit('join', { room: this.tokenuser, type: 'web' });
    },
    disconnect: function disconnect() {
      console.log('disconnected');
    },
    update_agora: function update_agora(data) {
      console.log(data);
      this.socket_update_agora = data;
      if (data.status === 'end') {
        // end call
        this.disableJoin = false;
        // this.leave_btn()
        this.cleartimer();
        if (this.typeCall !== 'video') {
          video_call_v4_localTracks['audioTrack'].stop();
          video_call_v4_localTracks['audioTrack'].close();
        } else {
          video_call_v4_localTracks['videoTrack'].stop();
          video_call_v4_localTracks['videoTrack'].close();
          video_call_v4_localTracks['audioTrack'].stop();
          video_call_v4_localTracks['audioTrack'].close();
        }

        // remove remote users and player views
        this.remoteUsers = {};
        if (document.getElementById('remote-playerlist') !== null) {
          document.getElementById('remote-playerlist').innerHTML = '';
          document.getElementById('local-player').innerHTML = '';
        }
        // leave the channel
        video_call_v4_client.leave();
        var me = this;
        setTimeout(function () {
          me.EndCallDialog = true;
        }, 2000);
      }
    }
  },
  watch: {
    socket_update_agora: function socket_update_agora(data) {
      console.log(data);
    }
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    console.log(this.tokenuser);
    console.log(this.$route.params.typecall);
    this.$socket.emit('join', { room: this.tokenuser, type: 'web' });
    this.typeCall = this.$route.params.typecall;
    this.infor_friend = JSON.parse(services["a" /* Decode */].decode(this.$route.query.user_infor));
    this.options.token = services["a" /* Decode */].decodeToken(this.$route.query.token);
    this.options.channel = services["a" /* Decode */].decodeToken(this.$route.query.channel_name);
    this.options.appid = AGORA_APP_ID;
    this.options.uid = this.infor_friend.one_id;
    this.picture_user = localStorage.getItem('profilepicture');
    console.log(this.infor_friend);
    console.log(this.options);
    console.log('created typecall: ', this.typeCall);
    // this.getRoom(this.tokenuser, this.$route.params.roomid)
    // this.getOneID(this.tokenuser)
    // this.submit()
    // console.log(this.options)
    // console.log(this.infor_friend)
  },

  methods: {
    switchToVideo: function switchToVideo() {
      try {
        var me = this;
        this.$swal({
          type: 'info',
          title: 'ต้องการเปลี่ยนเป็นวิดีโอคอลหรือไม่?',
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          showCloseButton: true,
          showCancelButton: true,
          reverseButtons: true
        }).then(function (result) {
          if (result.value) {
            me.typeCall = 'video';
            video_call_v4_client.unpublish(values_default()(video_call_v4_localTracks));
            me.joinVideo();
            console.log(video_call_v4_localTracks);
          } else {
            me.typeCall = 'audio';
          }
        });
      } catch (e) {
        console.log(e);
      }
      // me.typeCall = 'video'
      // await client.unpublish(Object.values(localTracks));
      // await me.joinVideo()
    },
    setAudio: function setAudio() {
      console.log(video_call_v4_localTracks.audioTrack);
      if (!video_call_v4_localTrackState.audioTrackMuted) {
        this.muteAudio();
      } else {
        this.unmuteAudio();
      }
    },
    unmuteAudio: function unmuteAudio() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(video_call_v4_localTracks.audioTrack);
                _this.muteState = false;

                if (video_call_v4_localTracks.audioTrack) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return video_call_v4_localTracks.audioTrack.setEnabled(true);

              case 6:
                video_call_v4_localTrackState.audioTrackMuted = false;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    muteAudio: function muteAudio() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(video_call_v4_localTracks.audioTrack);
                _this2.muteState = true;

                if (video_call_v4_localTracks.audioTrack) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                _context2.next = 6;
                return video_call_v4_localTracks.audioTrack.setEnabled(false);

              case 6:
                video_call_v4_localTrackState.audioTrackMuted = true;

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    muteVideo: function muteVideo() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('muteVideo');
                console.log(video_call_v4_localTracks.videoTrack);
                _this3.muteStateVideo = true;

                if (video_call_v4_localTracks.videoTrack) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt('return');

              case 5:
                _context3.next = 7;
                return video_call_v4_localTracks.videoTrack.setEnabled(false);

              case 7:
                video_call_v4_localTrackState.videoTrackMuted = true;

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    unmuteVideo: function unmuteVideo() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('un muteVideo');
                console.log(video_call_v4_localTracks.videoTrack);
                _this4.muteStateVideo = false;

                if (video_call_v4_localTracks.videoTrack) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt('return');

              case 5:
                _context4.next = 7;
                return video_call_v4_localTracks.videoTrack.setEnabled(true);

              case 7:
                video_call_v4_localTrackState.videoTrackMuted = false;
                video_call_v4_localTracks.videoTrack.play("local-player");

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getOneID: function getOneID(tokenuser) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.axios.get("https://uatchat-manage.one.th/go_api/api" + ('/v1/getOneID/' + tokenuser)).then(function (response) {
                  if (response.data.status === 'success') {
                    _this5.options.uid = response.data.one_id;
                    // console.log(this.options)
                    _this5.submit();
                  }
                }).catch(function (err) {
                  console.log(err);
                });

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    getRoom: function getRoom(tokenuser, tokenroom) {
      var _this6 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: tokenuser,
        tokenroom: tokenroom
      }).then(function (response) {
        console.log(response.data);
        if (response.data.status === 'success') {
          _this6.infor_friend = response.data.data_room[0];
          console.log(_this6.infor_friend);
        }
      });
    },
    closeEndCallDialog: function closeEndCallDialog(value) {
      this.EndCallDialog = value;
      // window.close()
    },
    joinVideo: function joinVideo() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        var me, user;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                console.log('join video');
                me = _this7;

                video_call_v4_client.on("user-published", function () {
                  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(user, mediaType) {
                    return regenerator_default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return me.handleUserPublished(user, mediaType);

                          case 2:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this7);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
                video_call_v4_client.on("user-unpublished", function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7(user, mediaType) {
                    return regenerator_default.a.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            _context7.next = 2;
                            return me.handleUserUnpublished(user, mediaType);

                          case 2:
                          case 'end':
                            return _context7.stop();
                        }
                      }
                    }, _callee7, _this7);
                  }));

                  return function (_x3, _x4) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                video_call_v4_client.on("user-info-updated", function () {
                  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8(user, msg) {
                    return regenerator_default.a.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _context8.next = 2;
                            return me.handleUserInfoUpdate(user, msg);

                          case 2:
                          case 'end':
                            return _context8.stop();
                        }
                      }
                    }, _callee8, _this7);
                  }));

                  return function (_x5, _x6) {
                    return _ref3.apply(this, arguments);
                  };
                }());
                video_call_v4_client.on("user-left", function () {
                  var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9(user, reason) {
                    return regenerator_default.a.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.next = 2;
                            return me.handleUserLeft(user, reason);

                          case 2:
                          case 'end':
                            return _context9.stop();
                        }
                      }
                    }, _callee9, _this7);
                  }));

                  return function (_x7, _x8) {
                    return _ref4.apply(this, arguments);
                  };
                }());
                // client.on("network-quality", async (stats) => {
                //   await me.handleNetwork(stats)
                // })
                // add event listener to play remote tracks when remote user publishs.
                console.log('mediaType: ' + me.typeCall);
                video_call_v4_localTracks = {
                  videoTrack: null,
                  audioTrack: null
                };
                video_call_v4_localTrackState = {
                  videoTrackMuted: false,
                  audioTrackMuted: false
                };
                _context10.next = 12;
                return AgoraRTC_N_production_default.a.createMicrophoneAudioTrack();

              case 12:
                video_call_v4_localTracks.audioTrack = _context10.sent;
                _context10.next = 15;
                return AgoraRTC_N_production_default.a.createCameraVideoTrack({
                  encoderConfig: {
                    width: 640,
                    // Specify a value range and an ideal value
                    height: { ideal: 480, min: 400, max: 500 },
                    frameRate: 15,
                    bitrateMin: 600, bitrateMax: 1000
                  }
                });

              case 15:
                video_call_v4_localTracks.videoTrack = _context10.sent;

                video_call_v4_localTracks.videoTrack.play("local-player");
                console.log(video_call_v4_localTracks);
                // publish local tracks to channel
                _context10.next = 20;
                return video_call_v4_client.publish(values_default()(video_call_v4_localTracks));

              case 20:
                user = {
                  uid: me.options.uid,
                  videoTrack: video_call_v4_localTracks.videoTrack,
                  audioTrack: video_call_v4_localTracks.audioTrack
                };

                console.log(user);
                // await client.subscribe(user, 'video')
                // me.unmuteVideo()
                console.log("publish video success");
                _context10.next = 29;
                break;

              case 25:
                _context10.prev = 25;
                _context10.t0 = _context10['catch'](0);

                console.log(_context10.t0);
                console.log(video_call_v4_localTracks);

              case 29:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this7, [[0, 25]]);
      }))();
    },
    join: function join() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15() {
        var me, _ref9, _ref10, _ref11, _ref12;

        return regenerator_default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;

                console.log('join');
                me = _this8;
                // add event listener to play remote tracks when remote user publishs.

                video_call_v4_client.on("user-published", function () {
                  var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11(user, mediaType) {
                    return regenerator_default.a.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            _context11.next = 2;
                            return me.handleUserPublished(user, mediaType);

                          case 2:
                          case 'end':
                            return _context11.stop();
                        }
                      }
                    }, _callee11, _this8);
                  }));

                  return function (_x9, _x10) {
                    return _ref5.apply(this, arguments);
                  };
                }());
                video_call_v4_client.on("user-unpublished", function () {
                  var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12(user, mediaType) {
                    return regenerator_default.a.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            _context12.next = 2;
                            return me.handleUserUnpublished(user, mediaType);

                          case 2:
                          case 'end':
                            return _context12.stop();
                        }
                      }
                    }, _callee12, _this8);
                  }));

                  return function (_x11, _x12) {
                    return _ref6.apply(this, arguments);
                  };
                }());
                video_call_v4_client.on("user-info-updated", function () {
                  var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13(user, msg) {
                    return regenerator_default.a.wrap(function _callee13$(_context13) {
                      while (1) {
                        switch (_context13.prev = _context13.next) {
                          case 0:
                            _context13.next = 2;
                            return me.handleUserInfoUpdate(user, msg);

                          case 2:
                          case 'end':
                            return _context13.stop();
                        }
                      }
                    }, _callee13, _this8);
                  }));

                  return function (_x13, _x14) {
                    return _ref7.apply(this, arguments);
                  };
                }());
                video_call_v4_client.on("user-left", function () {
                  var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14(user, reason) {
                    return regenerator_default.a.wrap(function _callee14$(_context14) {
                      while (1) {
                        switch (_context14.prev = _context14.next) {
                          case 0:
                            _context14.next = 2;
                            return me.handleUserLeft(user, reason);

                          case 2:
                          case 'end':
                            return _context14.stop();
                        }
                      }
                    }, _callee14, _this8);
                  }));

                  return function (_x15, _x16) {
                    return _ref8.apply(this, arguments);
                  };
                }());
                // client.on("network-quality", async (stats) => {
                //   await me.handleNetwork(stats)
                // })
                console.log('mediaType: ' + me.typeCall);
                if (me.typeCall === 'video') {
                  video_call_v4_localTracks = {
                    videoTrack: null,
                    audioTrack: null
                  };
                  video_call_v4_localTrackState = {
                    videoTrackMuted: false,
                    audioTrackMuted: false
                  };
                }
                if (me.typeCall === 'audio') {
                  video_call_v4_localTracks = {
                    audioTrack: null
                  };
                  video_call_v4_localTrackState = {
                    audioTrackMuted: false
                  };
                }
                // console.log(localTracks)
                // console.log(localTrackState)

                if (!(me.typeCall === 'video')) {
                  _context15.next = 19;
                  break;
                }

                _context15.next = 13;
                return promise_default.a.all([
                // join the channel
                video_call_v4_client.join(me.options.appid, me.options.channel, me.options.token || null, me.options.uid || null),
                // create local tracks, using microphone and camera
                AgoraRTC_N_production_default.a.createMicrophoneAudioTrack(), AgoraRTC_N_production_default.a.createCameraVideoTrack({
                  encoderConfig: {
                    width: 640,
                    // Specify a value range and an ideal value
                    height: { ideal: 480, min: 400, max: 500 },
                    frameRate: 15,
                    bitrateMin: 600, bitrateMax: 1000
                  }
                })]);

              case 13:
                _ref9 = _context15.sent;
                _ref10 = slicedToArray_default()(_ref9, 3);
                me.options.uid = _ref10[0];
                video_call_v4_localTracks.audioTrack = _ref10[1];
                video_call_v4_localTracks.videoTrack = _ref10[2];

                // play local video track
                video_call_v4_localTracks.videoTrack.play("local-player");

              case 19:
                if (!(me.typeCall === 'audio')) {
                  _context15.next = 26;
                  break;
                }

                _context15.next = 22;
                return promise_default.a.all([
                // join the channel
                video_call_v4_client.join(me.options.appid, me.options.channel, me.options.token || null, me.options.uid || null),
                // create local tracks, using microphone
                AgoraRTC_N_production_default.a.createMicrophoneAudioTrack()]);

              case 22:
                _ref11 = _context15.sent;
                _ref12 = slicedToArray_default()(_ref11, 2);
                me.options.uid = _ref12[0];
                video_call_v4_localTracks.audioTrack = _ref12[1];

              case 26:

                console.log(video_call_v4_localTracks);
                // publish local tracks to channel
                _context15.next = 29;
                return video_call_v4_client.publish(values_default()(video_call_v4_localTracks));

              case 29:
                console.log("publish success");
                _context15.next = 35;
                break;

              case 32:
                _context15.prev = 32;
                _context15.t0 = _context15['catch'](0);

                console.log(_context15.t0);

              case 35:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this8, [[0, 32]]);
      }))();
    },
    leave: function leave() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
        var trackName, track;
        return regenerator_default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                // console.log(localTracks)
                try {
                  for (trackName in video_call_v4_localTracks) {
                    track = video_call_v4_localTracks[trackName];

                    if (track) {
                      track.stop();
                      track.close();
                      video_call_v4_localTracks[trackName] = undefined;
                    }
                  }
                  // setTimeout(function() {
                  //   window.close()
                  // }, 1000)
                } catch (e) {
                  console.log(e);
                }

                // remove remote users and player views
                _this9.remoteUsers = {};
                if (document.getElementById('remote-playerlist') !== null) {
                  document.getElementById('remote-playerlist').innerHTML = '';
                  document.getElementById('local-player').innerHTML = '';
                }
                // document.getElementById('local-player-name').innerHTML = ''
                // leave the channel
                _context16.next = 5;
                return video_call_v4_client.leave();

              case 5:
                console.log("client leaves channel success");
                _this9.cleartimer();
                _this9.statusTime = false;
                // this.updataState()

              case 8:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this9);
      }))();
    },
    subscribe: function subscribe(user, mediaType) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17() {
        var me, uid, element, player;
        return regenerator_default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                console.log('subscribe: ', mediaType);
                console.log(user);
                me = _this10;
                uid = user.uid;
                // me.typeCall = mediaType

                console.log('subscribe success: ' + uid);
                // subscribe to a remote user
                _context17.next = 7;
                return video_call_v4_client.subscribe(user, mediaType);

              case 7:
                console.log(video_call_v4_localTracks);
                if (mediaType === 'video') {
                  me.typeCall = 'video';
                  // ถ้า localTracks ยังไม่มี video แต่เพื่อนขอเปลี่ยนเป็น video
                  if (video_call_v4_localTracks.videoTrack === undefined) {
                    me.$swal({
                      type: 'warning',
                      text: me.infor_friend.nickname + ' \u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E17\u0E19\u0E32\u0E41\u0E1A\u0E1A\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D\u0E04\u0E2D\u0E25 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?',
                      confirmButtonText: 'ตกลง',
                      cancelButtonText: 'ยกเลิก',
                      showConfirmButton: true,
                      showCancelButton: true,
                      confirmButtonColor: 'primary',
                      cancelButtonColor: 'red'
                    }).then(function (result) {
                      if (result.value) {
                        console.log('document.getElementById ', document.getElementById('local-player') !== null);
                        // ยังไม่เปิดกล้อง เปิดกล้องตัวเอง
                        video_call_v4_client.unpublish(values_default()(video_call_v4_localTracks));
                        me.joinVideo();
                        // add subscribe video friend
                        me.remoteUsers[uid] = user;
                        console.log(me.remoteUsers[uid]);
                        // <p class="player-name">remoteUser(${uid})</p>
                        var player = '\n                <div id="player-wrapper-' + uid + '">\n                  <div id="player-' + uid + '" class="player" style="width: 700px !important; height: 320px !important;"></div>\n                </div>\n              ';
                        document.getElementById("remote-playerlist").insertAdjacentHTML('beforeend', player);
                        user.videoTrack.play('player-' + uid);
                      }
                    });
                  } else {
                    // ลบ element เก่า ออก
                    element = document.getElementById('player-wrapper-' + uid);

                    console.log(element);
                    if (element) {
                      element.remove();
                    }
                    // add video friend ใหม่
                    // <p class="player-name">remoteUser(${uid})</p>
                    player = '\n            <div id="player-wrapper-' + uid + '">\n              <div id="player-' + uid + '" class="player" style="width: 700px !important; height: 320px !important;"></div>\n            </div>\n          ';

                    document.getElementById("remote-playerlist").insertAdjacentHTML('beforeend', player);
                    user.videoTrack.play('player-' + uid);
                    // play local video track
                    video_call_v4_localTracks.videoTrack.play("local-player");
                  }
                }
                if (mediaType === 'audio') {
                  console.log('document friend: ', document.getElementById('player-wrapper-' + uid));
                  console.log('document user: ', document.getElementById('local-player'));
                  if (video_call_v4_localTracks.videoTrack !== undefined) {
                    me.typeCall = 'video';
                    if (document.getElementById('player-wrapper-' + uid !== null)) {
                      user.videoTrack.play('player-' + uid);
                      me.muteVideoUser = false;
                    } else {
                      me.muteVideoUser = true;
                    }
                    // play local video track
                    video_call_v4_localTracks.videoTrack.play("local-player");
                  } else {
                    me.typeCall = 'audio';
                    user.audioTrack.play();
                  }
                }

              case 10:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this10);
      }))();
    },
    handleNetwork: function handleNetwork(stats) {
      console.log('handleNetwork: ', stats);
      console.log("downlinkNetworkQuality", stats.downlinkNetworkQuality);
      console.log("uplinkNetworkQuality", stats.uplinkNetworkQuality);
    },
    handleUserLeft: function handleUserLeft(user, reason) {
      console.log('handleUserLeft: ', user);
      console.log('handleUserLeft Reason: ', reason);
      var me = this;
      var id = user.uid;
      delete me.remoteUsers[id];
      // friend leave room
      if (reason === 'Quit') {
        if (user.uid !== me.options.uid) {
          setTimeout(function () {
            me.EndCallDialog = true;
            me.statusTime = false;
          }, 2000);
        }
      }
      // document.getElementById(`player-wrapper-${id}`).innerHTML = ''
    },
    handleUserPublished: function handleUserPublished(user, mediaType) {
      console.log('handleUserPublished: ' + mediaType);
      console.log('handleUserPublished: ', user);
      var me = this;
      // friend join room start timer
      if (user.uid !== me.options.uid) {
        me.statusTime = true;
        me.muteVideoUser = false;
        me.settimer();
      }
      var id = user.uid;
      console.log(me.typeCall);
      me.remoteUsers[id] = user;
      me.subscribe(user, mediaType);
      console.log(me.remoteUsers[id]);
    },
    handleUserJoined: function handleUserJoined(user) {
      console.log('handleUserJoined:', user);
      var me = this;
      var id = user.uid;
      me.remoteUsers[id] = user;
      console.log(me.remoteUsers[id]);
    },
    handleUserInfoUpdate: function handleUserInfoUpdate(user, msg) {
      console.log('handleUserInfoUpdate: ', user);
      console.log('handleUserInfoUpdate: ' + msg);
      var me = this;
      if (user.uid !== me.options.uid) {
        if (msg === 'mute-video') {
          me.muteVideoUser = true;
          var element = document.getElementById('player-wrapper-' + user.uid);
          console.log(element);
          if (element) {
            element.remove();
          }
        } else if (msg === 'unmute-video') {
          me.muteVideoUser = false;
        } else if (msg === 'mute-audio') {
          me.muteStateFriend = true;
        } else if (msg === 'unmute-audio') {
          me.muteStateFriend = false;
        }
      }
    },
    handleUserUnpublished: function handleUserUnpublished(user, mediaType) {
      console.log('handleUserUnpublished: ', user);
      console.log('handleUserUnpublished: ' + mediaType);
      var me = this;
      var id = user.uid;
      delete me.remoteUsers[id];
      if (mediaType === 'video') {
        var element = document.getElementById('player-wrapper-' + id);
        console.log(element);
        if (element) {
          element.remove();
        }
      }
    },
    submit: function submit() {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18() {
        var me;
        return regenerator_default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                me = _this11;
                _context18.prev = 1;

                console.log(me.options);
                _context18.next = 5;
                return me.join();

              case 5:
                _context18.next = 10;
                break;

              case 7:
                _context18.prev = 7;
                _context18.t0 = _context18['catch'](1);

                console.error(_context18.t0);

              case 10:
                _this11.disableJoin = true;
                // this.settimer()

              case 11:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this11, [[1, 7]]);
      }))();
    },
    leave_btn: function leave_btn() {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19() {
        var me;
        return regenerator_default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                me = _this12;
                _context19.next = 3;
                return me.leave();

              case 3:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, _this12);
      }))();
    },
    secondsToHms: function secondsToHms(d) {
      d = Number(d);
      var hours = Math.floor(d / 3600);
      var minutes = Math.floor((d - hours * 3600) / 60);
      var seconds = d - hours * 3600 - minutes * 60;
      var time = '';

      if (hours !== 0) {
        time = hours + ':';
      }
      if (minutes !== 0 || time !== '') {
        minutes = minutes < 10 && time !== '' ? '0' + minutes : String(minutes);
        time += minutes + ':';
      }
      if (time === '') {
        time = seconds + 's';
      } else {
        time += seconds < 10 ? '0' + seconds : String(seconds);
      }
      return time;
    },
    cleartimer: function cleartimer() {
      clearInterval(this.refreshIntervalId);
    },
    settimer: function settimer() {
      var _this13 = this;

      this.refreshIntervalId = setInterval(function () {
        return _this13.getSecs();
      }, 1000);
    },
    getSecs: function getSecs() {
      this.time_count = this.time_count + 1;
    },
    updataState: function updataState() {
      this.disableJoin = true;
      console.log(this.infor_friend);
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/update-agora', {
        tokenroom: this.infor_friend.tokenroom,
        tokenmessage: this.infor_friend.tokenmessage,
        tokenuser: this.tokenuser,
        time: this.time_count.toString(),
        message: 'end'
      }).then(function (response) {
        console.log(response.data);
        // setTimeout(function() {
        //   window.close()
        // }, 1000);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35207c9d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/agora_call/video_call_v4.vue
var video_call_v4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello",staticStyle:{"overflow":"hidden","height":"100vh","background-color":"#202124"}},[_c('div',[_c('form',{attrs:{"id":"join-form"}},[_c('div',{staticClass:"row join-info-group"},[_c('div',{staticClass:"col-sm"},[_c('p',{staticClass:"join-info-text"},[_vm._v("AppID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.appid),expression:"options.appid"}],attrs:{"id":"appid","type":"text","placeholder":"enter appid","required":""},domProps:{"value":(_vm.options.appid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.options, "appid", $event.target.value)}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('p',{staticClass:"join-info-text"},[_vm._v("Token")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.token),expression:"options.token"}],attrs:{"id":"token","type":"text","placeholder":"enter token"},domProps:{"value":(_vm.options.token)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.options, "token", $event.target.value)}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('p',{staticClass:"join-info-text"},[_vm._v("Channel")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.channel),expression:"options.channel"}],attrs:{"id":"channel","type":"text","placeholder":"enter channel name","required":""},domProps:{"value":(_vm.options.channel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.options, "channel", $event.target.value)}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('p',{staticClass:"join-info-text"},[_vm._v("UID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.uid),expression:"options.uid"}],attrs:{"id":"uid","type":"text","placeholder":"enter channel name","required":""},domProps:{"value":(_vm.options.uid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.options, "uid", $event.target.value)}}}),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('v-layout',{staticClass:"layout-bottom",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('div',{staticClass:"agora-button"},[(!_vm.muteState)?_c('v-btn',{attrs:{"color":"primary","dark":"","plain":"","fab":"","small":"","disabled":!_vm.statusTime},on:{"click":function($event){_vm.muteAudio()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-microphone")])],1):_c('v-btn',{attrs:{"color":"primary","plain":"","fab":"","small":""},on:{"click":function($event){_vm.unmuteAudio()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-microphone-slash")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"green","disabled":_vm.disableJoin,"fab":"","dark":"","small":""},on:{"click":function($event){_vm.submit()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-phone")])],1),_vm._v(" "),(_vm.typeCall === 'audio')?_c('v-btn',{attrs:{"color":"primary","plain":"","fab":"","dark":"","small":"","disabled":!_vm.statusTime},on:{"click":function($event){_vm.switchToVideo()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-video")])],1):_vm._e(),_vm._v(" "),(_vm.typeCall === 'video')?_c('div',[(!_vm.muteStateVideo)?_c('v-btn',{attrs:{"color":"primary","dark":"","plain":"","fab":"","small":"","disabled":!_vm.statusTime},on:{"click":function($event){_vm.muteVideo()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-video")])],1):_c('v-btn',{attrs:{"color":"primary","plain":"","fab":"","small":""},on:{"click":function($event){_vm.unmuteVideo()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-video-slash")])],1)],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","plain":"","disabled":!_vm.disableJoin,"fab":"","dark":"","small":""},on:{"click":function($event){_vm.leave_btn()}}},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("fas fa-phone-slash")])],1)],1)])],1),_vm._v(" "),_c('EndCallDialog',{attrs:{"EndCallDialog":_vm.EndCallDialog,"infor_friend":_vm.infor_friend,"time_count":_vm.time_count},on:{"closeEndCallDialog":_vm.closeEndCallDialog}})],1)}
var video_call_v4_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tips"},[_vm._v("If you don`t know what is your appid, checkout "),_c('a',{attrs:{"href":"https://docs.agora.io/en/Agora%20Platform/terms?platform=All%20Platforms#a-nameappidaapp-id"}},[_vm._v("this")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tips"},[_vm._v("If you don`t know what is your token, checkout "),_c('a',{attrs:{"href":"https://docs.agora.io/en/Agora%20Platform/terms?platform=All%20Platforms#a-namekeyadynamic-key"}},[_vm._v("this")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tips"},[_vm._v("If you don`t know what is your channel, checkout "),_c('a',{attrs:{"href":"https://docs.agora.io/en/Agora%20Platform/terms?platform=All%20Platforms#channel"}},[_vm._v("this")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tips"},[_vm._v("If you don`t know what is your channel, checkout "),_c('a',{attrs:{"href":"https://docs.agora.io/en/Agora%20Platform/terms?platform=All%20Platforms#channel"}},[_vm._v("this")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row video-group"},[_c('div',{staticClass:"col"},[_c('p',{staticClass:"player-name",attrs:{"id":"local-player-name"}}),_vm._v(" "),_c('div',{staticClass:"player",attrs:{"id":"local-player"}})]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{attrs:{"id":"remote-playerlist"}})])])}]
var video_call_v4_esExports = { render: video_call_v4_render, staticRenderFns: video_call_v4_staticRenderFns }
/* harmony default export */ var agora_call_video_call_v4 = (video_call_v4_esExports);
// CONCATENATED MODULE: ./src/components/chat/agora_call/video_call_v4.vue
function video_call_v4_injectStyle (ssrContext) {
  __webpack_require__("rmFL")
}
var video_call_v4_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var video_call_v4___vue_template_functional__ = false
/* styles */
var video_call_v4___vue_styles__ = video_call_v4_injectStyle
/* scopeId */
var video_call_v4___vue_scopeId__ = "data-v-35207c9d"
/* moduleIdentifier (server only) */
var video_call_v4___vue_module_identifier__ = null
var video_call_v4_Component = video_call_v4_normalizeComponent(
  video_call_v4,
  agora_call_video_call_v4,
  video_call_v4___vue_template_functional__,
  video_call_v4___vue_styles__,
  video_call_v4___vue_scopeId__,
  video_call_v4___vue_module_identifier__
)

/* harmony default export */ var chat_agora_call_video_call_v4 = (video_call_v4_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/RedirectUrlRoom.vue

//
//
//
//
//
//


/* harmony default export */ var RedirectUrlRoom = ({
  data: function data() {
    return {
      progress: true,
      decoded: '',
      token: '',
      windowWidth: '',
      url_redirect: "https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect"
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
  },
  created: function created() {
    this.windowWidth = window.innerWidth;
    console.log('authen: ' + "https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect");
    localStorage.setItem('botid_redirect_url', stringify_default()({
      'bot_id': this.$route.query.bot_token,
      'auth': this.$route.query.authorization,
      'url': this.$route.query.url
    }));
    // console.log(JSON.parse(localStorage.getItem('botid_redirect_url')))
    // this.$cookie.set('logouturl', this.$route.query.logouturl)
    if (localStorage.getItem('Authenrization') !== null) {
      this.decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      if (this.decoded.status_login !== 'T') {
        if (true) {
          window.open(this.url_redirect, '_parent');
        } else {
          this.$router.push('/login');
        }
      } else {
        // this.token = this.decoded['tokenuser']
        this.searchFriend(this.$route.query.bot_token, this.decoded['tokenuser']);
      }
    } else {
      // this.$router.push('/login')
      if (true) {
        window.open(this.url_redirect, '_parent');
      } else {
        console.log('to login');
        this.$router.push('/login');
      }
    }
  },

  methods: {
    searchFriend: function searchFriend(botid, token) {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend", {
        tokenbot: botid,
        tokenuser: token
      }).then(function (response) {
        // console.log(response.data.listuser)
        if (response.data.listuser.length === 0) {
          _this2.progress = false;
          // localStorage.removeItem('botid_redirect_url')
          // this.$swal('', 'ไม่มีข้อมูลบอทในระบบ กรุณาตรวจสอบข้อมูลให้ถูกต้อง', 'warning')
          if (_this2.windowWidth <= 960) {
            _this2.$router.push('/mobile/homepage');
          } else {
            _this2.$router.push('/chat');
          }
        } else {
          if (response.data.listuser.relation === 'friend') {
            _this2.progress = false;
            // localStorage.removeItem('botid_redirect_url')
            if (_this2.windowWidth <= 960) {
              _this2.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom);
            } else {
              _this2.$router.push('/chat/room/' + response.data.listuser.user.tokenroom);
            }
          } else {
            console.log('not friend');
            _this2.$router.push('/addbot/' + botid);
          }
        }
      }).catch(function (error) {
        console.log(error);
        console.log(error.response);
        _this2.progress = false;
        localStorage.removeItem('botid_redirect_url');
        // this.$swal('', 'ไม่มีข้อมูลบอทในระบบ กรุณาตรวจสอบข้อมูลให้ถูกต้อง', 'warning')
        if (_this2.windowWidth <= 960) {
          _this2.$router.push('/mobile/homepage');
        } else {
          _this2.$router.push('/chat');
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8be47fa0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/RedirectUrlRoom.vue
var RedirectUrlRoom_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"height":"100vh"},attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"width":8,"size":80,"color":"primary","indeterminate":_vm.progress}})],1)}
var RedirectUrlRoom_staticRenderFns = []
var RedirectUrlRoom_esExports = { render: RedirectUrlRoom_render, staticRenderFns: RedirectUrlRoom_staticRenderFns }
/* harmony default export */ var homepage_RedirectUrlRoom = (RedirectUrlRoom_esExports);
// CONCATENATED MODULE: ./src/components/homepage/RedirectUrlRoom.vue
function RedirectUrlRoom_injectStyle (ssrContext) {
  __webpack_require__("cHLP")
}
var RedirectUrlRoom_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RedirectUrlRoom___vue_template_functional__ = false
/* styles */
var RedirectUrlRoom___vue_styles__ = RedirectUrlRoom_injectStyle
/* scopeId */
var RedirectUrlRoom___vue_scopeId__ = "data-v-8be47fa0"
/* moduleIdentifier (server only) */
var RedirectUrlRoom___vue_module_identifier__ = null
var RedirectUrlRoom_Component = RedirectUrlRoom_normalizeComponent(
  RedirectUrlRoom,
  homepage_RedirectUrlRoom,
  RedirectUrlRoom___vue_template_functional__,
  RedirectUrlRoom___vue_styles__,
  RedirectUrlRoom___vue_scopeId__,
  RedirectUrlRoom___vue_module_identifier__
)

/* harmony default export */ var components_homepage_RedirectUrlRoom = (RedirectUrlRoom_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RedirectRoomWithUrl.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var RedirectRoomWithUrl = ({
  data: function data() {
    var _ref;

    return _ref = {
      progress: false,
      openedApp: false,
      snackbar: false,
      textsnackbar: 'ดาวน์โหลดแอปพลิเคชัน One Chat',
      deviceos: '',
      status_login: '',
      onechat: 'One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้'
    }, defineProperty_default()(_ref, 'deviceos', ''), defineProperty_default()(_ref, 'dialogProblem', false), defineProperty_default()(_ref, 'dialogus', false), defineProperty_default()(_ref, 'cardtext', [{ text: 'ส่งข้อความ, ไฟล์, เสียง, รูปภาพ และยังมีฟังก์ชันอื่น ๆ', icon: '/static/img/homepage/icon/chat2x.png' }, { text: 'บริการในตระกูล One Platform', icon: '/static/img/homepage/icon/one2x.png' }, { text: 'เชื่อมต่อกับ One E-mail ที่ให้บริการฟรีอีเมล', icon: '/static/img/homepage/icon/mail2x.png' }, { text: 'การใช้งาน Chat Bot', icon: '/static/img/homepage/icon/bot2x.png' }, { text: 'มีบริการ One Box ที่ให้บริการฟรีพื้นที่จัดเก็บไฟล์ข้อมูล', icon: '/static/img/homepage/icon/box2x.png' }, { text: 'ระบบความน่าเชื่อถือในตัวบุคคล', icon: '/static/img/homepage/icon/security2x.png' }]), defineProperty_default()(_ref, 'onechatDev', Object({"NODE_ENV":"uat","API":"https://uatchat.one.th","APIQRcode":"https://uatchat.one.th","APIpub":"https://uatchat-manage.one.th/event","APIimage":"https://uatchat-manage.one.th/message","APIsocket":"https://uatchat-public.one.th:8998","APImanage":"https://uatchat-manage.one.th/manage","ONEID_API":"https://testoneid.inet.co.th/api","WEBchatdev":"https://uatchat.one.th:8089/docs","Bot_idPaperless":"B0df132b88f9a526691a0576bfdb24196","Bot_idcovid":"Bbe2c9fe1bcc956738a61c9ad0d91cb19","taxid_consent":"0107544000094","serviceid_consent":"SVC-1611218040238","formid_consent":"600956682f8678001cce54e8","AuthenOneid":"https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect","LogoutOneid":"https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage","redirect_url":"https://uatchat.one.th/authorization/redirect","Market_env":"staging","APInew_listchat":"https://uatchat-manage.one.th/go_api/api/v4/getListChat","APInew_getdict":"https://uatchat-manage.one.th/alpine/api/v1/getdictmessage","APInew_pushmessage":"https://uatchat-manage.one.th/alpine/api/v1/pushMessage","APInew_getaccesstoken":"https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken","APInew_getrichmenu":"https://uatchat-manage.one.th/go_api/api/v1/getRichmenuByTokenroom","APInew_addfriend":"https://uatchat-manage.one.th/go_api/api/v1/add-friend","APIcheck_consent":"https://uatapigw.appsdigit.inet.co.th/api/chat/service/check-consent","APInew_pushvideo":"https://uatchat-manage.one.th/media/api/v1/send-video","APInew_acceptfriend":"https://uatchat-manage.one.th/go_api/api/v1/accept-friend","APInew_creategroup":"https://uatchat-manage.one.th/go_api/api/v1/create-group","APIalpine":"https://uatchat-manage.one.th/alpine","APIgo_api":"https://uatchat-manage.one.th/go_api/api","WEBoneEmail":"https://testoneid.inet.co.th/preauth","WEBoneBox":"https://testoneid.inet.co.th/oauth/authorize?client_id=155&response_type=code&scope=account","WEBNews":"https://news.chat.korkla.in/checkauthen?authen=","WEB_Redirect_Onebox":"https://uatbox.one.th/loginbysharetoken?token=","WebAnonymous":"https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token=","Savelognews":"https://news.chat.one.th/backend/api/v1/page-analytics","urlEkyc":"https://uat-ekyc.id.th/redirect-share-token?shared_token=","linkonemeet":"https://meet-test.one.th/?sharetoken=","API_onemeet":"https://meet-test.one.th/","WEB_centrifuge":"wss://uatchat-manage.one.th/connection/websocket","centrifuge_key":'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs',"APIsearchfriend":"https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend","urlLoa":"https://testoneid.inet.co.th/login?redirect_url=https://testoneid.inet.co.th/portal_level&shared_token=","check_password":"https://uatchat-manage.one.th/bot-message/check"}).ONECHATDEV + 'docs'), _ref;
  },

  components: {
    ProblemDialog: components_homepage_ProblemDialog,
    messageusDialog: dialog_message_messageus,
    Login: components_homepage_login
  },
  created: function created() {
    // console.log(window.location)
    // console.log(window.location.pathname)
    // console.log(window.location.pathname === '/weburl-go-room')
    if (window.location.pathname === '/weburl-go-room') {
      var url = '';
      if (this.$route.query.url !== undefined && this.$route.query.url !== 'undefined') {
        url = '&url=' + this.$route.query.url;
      }
      // alert('onechat://com.oneplatform/qrcode-go-room?bot_token=' + this.$route.query.bot_token + '&data=')
      console.log('onechat://com.oneplatform/weburl-go-room?bot_token=' + this.$route.query.bot_token + '&authorization=' + this.$route.query.authorization + url);
      this.redirectto('onechat://com.oneplatform/weburl-go-room?bot_token=' + this.$route.query.bot_token + '&authorization=' + this.$route.query.authorization + url);
      // this.redirectto('onechat://com.oneplatform/qrcode-go-room?bot_token=' + this.$route.query.bot_token + '&data=')
      localStorage.setItem('botid_redirect_url', stringify_default()({
        'bot_id': this.$route.query.bot_token,
        'auth': this.$route.query.authorization,
        'url': this.$route.query.url
      }));
    }

    try {
      // console.log(Decode.decode(localStorage.getItem('Authenrization')))
      var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      // console.log(decoded)
      this.status_login = decoded['status_login'];
    } catch (er) {
      console.log(er);
    }
    // console.log(this.status_login)

    if (window.location.pathname === '/weburl-go-room') {
      if (this.status_login === 'T') {
        console.log(window.innerWidth);
        if (window.innerWidth <= 960) {
          if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
            // redirect bot room with url
            var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
            // console.log(data)
            var url = '';
            if (data.url !== undefined && data.url !== 'undefined') {
              url = '&url=' + data.url;
            }
            this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + url);
          } else {
            this.$router.push('/mobile/homepage');
          }
        } else {
          if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
            var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
            // console.log(data)
            var url = '';
            if (data.url !== undefined && data.url !== 'undefined') {
              url = '&url=' + data.url;
            }
            this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + url);
          } else {
            this.$router.push('/chat');
          }
        }
      } else {
        console.log('type: ' + this.$route.params.type);
        console.log('status login: ' + this.status_login);
        // this.$router.push('/login')
        // มีคีย์ login มาด้วยให้ login auto ถ้าไม่มีให้อยู่หน้า login
        if (this.$route.query.login_key !== undefined) {
          this.loginWithSharetoken(this.$route.query.login_key);
        }
      }
    }
  },

  methods: {
    loginWithSharetoken: function loginWithSharetoken(token) {
      var _this = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/login_sharedtoken', { shared_token: token }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          _this.progress = false;
          var profile = response.data['account']['profile'];
          _this.myprofilepicture = profile['profilepicture'];
          _this.myname = profile['name'];
          _this.$i18n.locale = _this.$cookie.get('language') ? _this.$cookie.get('language') : 'th';
          localStorage.setItem('Authenrization', services["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
          localStorage.setItem('profilepicture', profile['profilepicture']);
          localStorage.setItem('name', profile['name']);
          localStorage.setItem('phone', profile['phone']);
          localStorage.setItem('email', profile['email']);
          localStorage.setItem('status', profile['status']);
          localStorage.setItem('type_user', profile['type']);
          localStorage.setItem('wallpaperInfo', stringify_default()({
            'info': [{
              'room': '',
              'background': ''
            }]
          }));
          if (profile['username'] === '' || profile['username'] === 'None') {
            localStorage.setItem('status_username', 'false');
          } else {
            localStorage.setItem('status_username', 'true');
          }
          if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
            // redirect bot room with url
            var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
            var url = '';
            if (data.url !== undefined && data.url !== 'undefined') {
              url = '&url=' + data.url;
            }
            _this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + url);
          }
        } else {
          _this.$cookie.set('status_login', 'F');
          _this.progress = false;
          if (response.data['message'] === 'Expired token') {
            _this.$swal('', _this.$t('Settings.messageEditPhone.MsgTokenExpire'), 'warning');
          } else {
            _this.$swal('', response.data['message'], 'warning');
          }
        }
      }).catch(function (error) {
        console.log(error);
        _this.$cookie.set('status_login', 'F');
        _this.progress = false;
        _this.$t('Alert.Fail.default.somethingWrong');
      });
    },
    openAppOrStore: function openAppOrStore(url, store) {
      console.log(store);
      // var me = this
      // setTimeout(function () {
      //   if (!me.openedApp) {
      //     window.location = store;
      //   }
      // }, 25);

      try {
        window.location = url;
        if (window.location.href.indexOf("onechat://") !== -1) {
          me.openedApp = true;
        }
      } catch (e) {}

      // window.location.replace(url)
      // setTimeout(function () {
      //   window.location.replace(store)
      // }, 2000)
    },
    redirectto: function redirectto(url) {
      var me = this;
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // console.log(userAgent)
      setTimeout(function () {
        if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
          // console.log(me.$route.query.service)
          // console.log(me.$route.params.type)
          // console.log(me.$route.name)
          // if(me.$route.params.type && me.$route.query.service) {
          //   if (me.$route.params.type !== 'friend' || me.$route.query.service !== 'onemeet') {
          //     me.openAppOrStore(url, 'https://apps.apple.com/th/app/onechat/id1394435274#?platform=iphone');
          //   }
          // } else
          // if(me.$route.params.type) {
          me.openAppOrStore(url, 'https://apps.apple.com/th/app/onechat/id1394435274#?platform=iphone');
          // }
        } else {
          me.openAppOrStore(url, 'https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat');
        }
      }, 25);
    },
    redirectto2: function redirectto2(url) {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // if (/android/i.test(userAgent)) {
      //   setTimeout(function () { window.location = "https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat"; }, 25);
      //   window.location = url;
      // }
      // if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
      //   setTimeout(function () { window.location = "https://itunes.apple.com/th/app/onechat/id1394435274?mt=8"; }, 25);
      //   window.location = url;
      // }
      // return "unknown";
      if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
        var now = new Date().valueOf();
        setTimeout(function () {
          if (new Date().valueOf() - now > 100) return;
          window.location = "https://apps.apple.com/th/app/onechat/id1394435274#?platform=iphone";
        }, 25);
        window.location = url;
      } else {
        var now = new Date().valueOf();
        setTimeout(function () {
          if (new Date().valueOf() - now > 100) return;
          window.location = "https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat";
        }, 25);
        window.location = url;
      }
    },
    toNewTab: function toNewTab() {
      window.open("https://uatchat.one.th:8089/docs", '_blank').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    downloadios: function downloadios() {
      window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus();
    },
    downloadandroid: function downloadandroid() {
      window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus();
    },
    closedownload: function closedownload() {
      this.snackbar = false;
    },
    loadepage: function loadepage() {
      window.open('http://onelink.to/hpyvpk', '_blank');
    },
    closeDialogProblem: function closeDialogProblem(value) {
      this.dialogProblem = value;
    },
    closeDialogus: function closeDialogus(value) {
      this.dialogus = value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34fce731","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RedirectRoomWithUrl.vue
var RedirectRoomWithUrl_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status_login !== '')?_c('div',{class:_vm.$vuetify.breakpoint.mdAndUp ? 'Background' : 'BackgroundMobile',staticStyle:{"background-color":"white","height":"100vh","padding-top":"64px","overflow-y":"auto","overflow-x":"hidden"},attrs:{"dark":"","id":"home"}},[_c('v-layout',{},[_c('div',{staticClass:"text"},[_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"height":"90vh"},attrs:{"align-center":"","row":"","wrap":"","justify-center":"","fill-height":""}},[_c('v-flex',{staticStyle:{"display":"grid"},attrs:{"xs12":"","sm12":"","md5":"","xl5":"","lg5":""}},[_c('v-img',{staticStyle:{"max-height":"90vh"},attrs:{"src":"/static/img/homepage/onechat_app.png","alt":"banner onechat"}}),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"4vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"200","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"200","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"4vh"},attrs:{"xs12":"","sm12":"","md7":"","xl7":"","lg7":""}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"2vh"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-img',{staticStyle:{"max-height":"100px","justify-content":"center","width":"256px"},attrs:{"src":"/static/img/icons/logoonechat_full.png","alt":"icon onechat"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"6vh","color":"black","font-size":"20px"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("\" แอปพลิเคชันแชทของคนไทยเพื่อคนไทย")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("เราจะทำให้ทุกการสนทนาของคุณปลอดภัย \"")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-sm-and-down",staticStyle:{"display":"flex","margin-top":"6vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-btn',{staticClass:"btnhover",attrs:{"to":"/register","round":"","dark":"","color":"#2562B0"}},[_vm._v("ร่วมเป็นส่วนหนึ่งกับพวกเรา")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"align-center":"","row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticStyle:{"margin-top":"6em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{attrs:{"src":"/static/img/icons/logoonechat_full.png","width":"120","height":"50"}}),_vm._v(" "),_c('h1',{staticStyle:{"color":"#2562B0","padding-left":"20px"}},[_vm._v("คือ อะไร?")])])],1),_vm._v(" "),(_vm.$vuetify.breakpoint.width <= 1028 && _vm.$vuetify.breakpoint.height >=1366)?_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"margin-top":"1.5em"},attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"700"}},[_c('p',{staticStyle:{"padding":"20px","margin-bottom":"0px","font-size":"20px"}},[_vm._v("\n                     One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้\n              ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10em","margin-right":"10em","margin-top":"140px"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"50vh"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","max-width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1),_vm._v(" "),_c('div',[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"20px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการฟรีอีเมล")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"margin-left":"20px"},attrs:{"round":"","color":"#2562B0","target":"_blank","href":" https://mail.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs122":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"190"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"370","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)])],1)],1)],1)],1):_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"margin-top":"1.5em","border-radius":"10px"},attrs:{"align-center":"","justify-space-around":"","row":"","wrap":"","fill-height":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"700"}},[_c('p',{staticStyle:{"padding":"20px","margin-bottom":"0px","font-size":"20px"}},[_vm._v("\n                     One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้\n              ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10em","margin-right":"10em","margin-top":"140px"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"50vh"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":"","align-center":"","fill-height":""}},[_c('div',[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","max-width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1),_vm._v(" "),_c('div',[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"20px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการฟรีอีเมล")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"margin-left":"20px"},attrs:{"round":"","color":"#2562B0","target":"_blank","href":" https://mail.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","margin-right":"100px"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0"},attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px","margin-left":"150px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh","margin-right":"10em"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"margin-left":"30px"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"190"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","margin-right":"120px"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"370","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh","margin-left":"80px"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"hidden-md-and-up",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticStyle:{"padding-top":"3em"},attrs:{"xs12":"","sm12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"max-height":"100px","justify-content":"center","width":"256px"},attrs:{"src":"/static/img/icons/logoonechat_full.png","alt":"icon onechat"}})])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"2em","color":"black","font-size":"15px"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("\" แอปพลิเคชันแชทของคนไทยเพื่อคนไทย")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("เราจะทำให้ทุกการสนทนาของคุณปลอดภัย \"")])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"6vh","margin-bottom":"3em","color":"black","justify-content":"center"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-btn',{attrs:{"to":"/register","round":"","dark":"","color":"#2562B0"}},[_vm._v("ร่วมเป็นส่วนหนึ่งกับพวกเรา")])],1),_vm._v(" "),_c('img',{staticClass:"hidden-md-and-up",staticStyle:{"max-height":"40vh"},attrs:{"src":"/static/img/homepage/onechat_app.png","alt":"banner onechat"}}),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"4vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",staticStyle:{"max-width":"150px"},attrs:{"src":"/static/img/download/rsz_googleplay.png","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",staticStyle:{"max-width":"150px"},attrs:{"src":"/static/img/download/rsz_appstore.png","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"hidden-md-and-up",staticStyle:{"margin-top":"6em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{attrs:{"src":"/static/img/icons/logoonechat_full.png","width":"120","height":"50"}}),_vm._v(" "),_c('h1',{staticStyle:{"color":"#2562B0","padding-left":"20px"}},[_vm._v("คือ อะไร?")])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"480"}},[_c('p',{staticStyle:{"padding":"20px","font-size":"18px","margin-bottom":"0px"}},[_vm._v("\n                       One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้\n                ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic","margin-bottom":"20px"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"150","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1),_vm._v(" "),_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"30px"},attrs:{"color":"#BFDBFF","tile":"","width":"150","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("บริการฟรีอีเมล")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"margin-left":"40px"},attrs:{"round":"","color":"#2562B0","target":"_blank","href":" https://mail.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"170"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic","max-height":"100vh"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"170"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat download"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('messageusDialog',{attrs:{"dialogus":_vm.dialogus},on:{"closeDialogus":_vm.closeDialogus}}),_vm._v(" "),_c('ProblemDialog',{attrs:{"dialogProblem":_vm.dialogProblem},on:{"closeDialogProblem":_vm.closeDialogProblem}})],1),_vm._v(" "),_c('div',{staticClass:"footer hidden-sm-and-down"},[_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{staticClass:"footertitle"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"justify-end":""}},[_c('img',{staticStyle:{"width":"260px"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{staticStyle:{"padding-left":"20px"},attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-start":""}},[_c('b',[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-start":""}},[_c('div',[_c('span',{staticStyle:{"display":"flex-inline"}},[_vm._v(" เวลาทำการ วันจันทร์ - ศุกร์ ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_vm._v("เวลา 09.00 - 17.00 น.")])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                       ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                      ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        เขตห้วยขวาง กรุงเทพมหานคร 10310\n                      ")])],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"align-start":"","row":"","wrap":"","justify-start":"","fill-height":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบายการใช้งาน")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v("ส่งข้อความถึงเรา")])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"problemIcon hidden-sm-and-down"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticStyle:{"background":"#2662af","height":"60px !important","width":"60px !important"},attrs:{"slot":"activator","fab":"","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogProblem = !_vm.dialogProblem}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"30px"}},[_vm._v("fas fa-bullhorn")])],1),_vm._v(" "),_c('span',[_vm._v("พบเจอปัญหา")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"footerMobile hidden-md-and-up"},[(_vm.$vuetify.breakpoint.width >= 768)?_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{staticClass:"footermobiletext"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"220px","height":"intrinsic"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{staticStyle:{"padding-left":"20px"},attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('b',[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{},[_vm._v(" เวลาทำการ วันจันทร์ - ศุกร์ ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("เวลา 09.00 - 17.00")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',[_vm._v("\n                          1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                          "),_c('br'),_vm._v("\n                          ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                          "),_c('br'),_vm._v("\n                          เขตห้วยขวาง กรุงเทพมหานคร 10310\n                        ")])])],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"align-start":"","row":"","wrap":"","justify-center":"","fill-height":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('a',{staticClass:"footerlink",staticStyle:{"color":"black !important"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบายการใช้งาน")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v("ส่งข้อความถึงเรา")])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1):_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"300px","height":"intrinsic"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticStyle:{"padding-left":"25px"}},[_c('v-flex',{staticStyle:{"margin-bottom":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('b',[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-bottom":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{},[_vm._v(" เวลาทำการ วันจันทร์ - ศุกร์ ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("เวลา 09.00 - 17.00")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',[_vm._v("\n                        1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                        "),_c('br'),_vm._v("\n                        ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                        "),_c('br'),_vm._v("\n                        เขตห้วยขวาง กรุงเทพมหานคร 10310\n                      ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"color":"black !important"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบายการใช้งาน")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v("ส่งข้อความถึงเรา")])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"problemIconMobile hidden-md-and-up"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticStyle:{"background":"#2662af","height":"40px !important","width":"40px !important"},attrs:{"slot":"activator","fab":"","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogProblem = !_vm.dialogProblem}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"20px"}},[_vm._v("fas fa-bullhorn")])],1),_vm._v(" "),_c('span',[_vm._v("พบเจอปัญหา")])],1)],1)],1):_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.progress)?_c('v-layout',{staticStyle:{"height":"100vh"},attrs:{"column":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"color":"primary","size":100,"indeterminate":_vm.progress,"width":6}})],1):_c('Login')],1)}
var RedirectRoomWithUrl_staticRenderFns = []
var RedirectRoomWithUrl_esExports = { render: RedirectRoomWithUrl_render, staticRenderFns: RedirectRoomWithUrl_staticRenderFns }
/* harmony default export */ var components_RedirectRoomWithUrl = (RedirectRoomWithUrl_esExports);
// CONCATENATED MODULE: ./src/components/RedirectRoomWithUrl.vue
function RedirectRoomWithUrl_injectStyle (ssrContext) {
  __webpack_require__("WNQp")
}
var RedirectRoomWithUrl_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RedirectRoomWithUrl___vue_template_functional__ = false
/* styles */
var RedirectRoomWithUrl___vue_styles__ = RedirectRoomWithUrl_injectStyle
/* scopeId */
var RedirectRoomWithUrl___vue_scopeId__ = "data-v-34fce731"
/* moduleIdentifier (server only) */
var RedirectRoomWithUrl___vue_module_identifier__ = null
var RedirectRoomWithUrl_Component = RedirectRoomWithUrl_normalizeComponent(
  RedirectRoomWithUrl,
  components_RedirectRoomWithUrl,
  RedirectRoomWithUrl___vue_template_functional__,
  RedirectRoomWithUrl___vue_styles__,
  RedirectRoomWithUrl___vue_scopeId__,
  RedirectRoomWithUrl___vue_module_identifier__
)

/* harmony default export */ var src_components_RedirectRoomWithUrl = (RedirectRoomWithUrl_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RedirectRoomWithSharedToken.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var RedirectRoomWithSharedToken = ({
  data: function data() {
    var _ref;

    return _ref = {
      progress: false,
      openedApp: false,
      snackbar: false,
      textsnackbar: 'ดาวน์โหลดแอปพลิเคชัน One Chat',
      deviceos: '',
      status_login: '',
      onechat: 'One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้'
    }, defineProperty_default()(_ref, 'deviceos', ''), defineProperty_default()(_ref, 'dialogProblem', false), defineProperty_default()(_ref, 'dialogus', false), defineProperty_default()(_ref, 'cardtext', [{ text: 'ส่งข้อความ, ไฟล์, เสียง, รูปภาพ และยังมีฟังก์ชันอื่น ๆ', icon: '/static/img/homepage/icon/chat2x.png' }, { text: 'บริการในตระกูล One Platform', icon: '/static/img/homepage/icon/one2x.png' }, { text: 'เชื่อมต่อกับ One E-mail ที่ให้บริการฟรีอีเมล', icon: '/static/img/homepage/icon/mail2x.png' }, { text: 'การใช้งาน Chat Bot', icon: '/static/img/homepage/icon/bot2x.png' }, { text: 'มีบริการ One Box ที่ให้บริการฟรีพื้นที่จัดเก็บไฟล์ข้อมูล', icon: '/static/img/homepage/icon/box2x.png' }, { text: 'ระบบความน่าเชื่อถือในตัวบุคคล', icon: '/static/img/homepage/icon/security2x.png' }]), defineProperty_default()(_ref, 'onechatDev', Object({"NODE_ENV":"uat","API":"https://uatchat.one.th","APIQRcode":"https://uatchat.one.th","APIpub":"https://uatchat-manage.one.th/event","APIimage":"https://uatchat-manage.one.th/message","APIsocket":"https://uatchat-public.one.th:8998","APImanage":"https://uatchat-manage.one.th/manage","ONEID_API":"https://testoneid.inet.co.th/api","WEBchatdev":"https://uatchat.one.th:8089/docs","Bot_idPaperless":"B0df132b88f9a526691a0576bfdb24196","Bot_idcovid":"Bbe2c9fe1bcc956738a61c9ad0d91cb19","taxid_consent":"0107544000094","serviceid_consent":"SVC-1611218040238","formid_consent":"600956682f8678001cce54e8","AuthenOneid":"https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect","LogoutOneid":"https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage","redirect_url":"https://uatchat.one.th/authorization/redirect","Market_env":"staging","APInew_listchat":"https://uatchat-manage.one.th/go_api/api/v4/getListChat","APInew_getdict":"https://uatchat-manage.one.th/alpine/api/v1/getdictmessage","APInew_pushmessage":"https://uatchat-manage.one.th/alpine/api/v1/pushMessage","APInew_getaccesstoken":"https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken","APInew_getrichmenu":"https://uatchat-manage.one.th/go_api/api/v1/getRichmenuByTokenroom","APInew_addfriend":"https://uatchat-manage.one.th/go_api/api/v1/add-friend","APIcheck_consent":"https://uatapigw.appsdigit.inet.co.th/api/chat/service/check-consent","APInew_pushvideo":"https://uatchat-manage.one.th/media/api/v1/send-video","APInew_acceptfriend":"https://uatchat-manage.one.th/go_api/api/v1/accept-friend","APInew_creategroup":"https://uatchat-manage.one.th/go_api/api/v1/create-group","APIalpine":"https://uatchat-manage.one.th/alpine","APIgo_api":"https://uatchat-manage.one.th/go_api/api","WEBoneEmail":"https://testoneid.inet.co.th/preauth","WEBoneBox":"https://testoneid.inet.co.th/oauth/authorize?client_id=155&response_type=code&scope=account","WEBNews":"https://news.chat.korkla.in/checkauthen?authen=","WEB_Redirect_Onebox":"https://uatbox.one.th/loginbysharetoken?token=","WebAnonymous":"https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token=","Savelognews":"https://news.chat.one.th/backend/api/v1/page-analytics","urlEkyc":"https://uat-ekyc.id.th/redirect-share-token?shared_token=","linkonemeet":"https://meet-test.one.th/?sharetoken=","API_onemeet":"https://meet-test.one.th/","WEB_centrifuge":"wss://uatchat-manage.one.th/connection/websocket","centrifuge_key":'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs',"APIsearchfriend":"https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend","urlLoa":"https://testoneid.inet.co.th/login?redirect_url=https://testoneid.inet.co.th/portal_level&shared_token=","check_password":"https://uatchat-manage.one.th/bot-message/check"}).ONECHATDEV + 'docs'), defineProperty_default()(_ref, 'key_authen', 'share_token'), _ref;
  },

  components: {
    ProblemDialog: components_homepage_ProblemDialog,
    messageusDialog: dialog_message_messageus,
    Login: components_homepage_login
  },
  created: function created() {
    // console.log(window.location)
    // console.log(window.location.pathname)
    // console.log(window.location.pathname === '/weburl-go-room')
    localStorage.clear();
    if (window.location.pathname === '/redirect-room-sharetoken') {
      var url = '';
      if (this.$route.query.url !== undefined && this.$route.query.url !== 'undefined') {
        url = '&url=' + this.$route.query.url;
      }
      localStorage.setItem('botid_redirect_url', stringify_default()({
        'bot_id': this.$route.query.bot_token,
        'auth': this.key_authen,
        'url': this.$route.query.url
      }));
    }

    try {
      // console.log(Decode.decode(localStorage.getItem('Authenrization')))
      var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      // console.log(decoded)
      this.status_login = decoded['status_login'];
    } catch (er) {
      console.log(er);
    }
    // console.log(this.status_login)

    if (this.status_login === 'T') {
      console.log(window.innerWidth);
      if (window.innerWidth <= 960) {
        if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
          // redirect bot room with url
          var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
          // console.log(data)
          var url = '';
          if (data.url !== undefined && data.url !== 'undefined') {
            url = '&url=' + data.url;
          }
          this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + url);
        } else {
          this.$router.push('/mobile/homepage');
        }
      } else {
        if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
          var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
          // console.log(data)
          var url = '';
          if (data.url !== undefined && data.url !== 'undefined') {
            url = '&url=' + data.url;
          }
          this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + url);
        } else {
          this.$router.push('/chat');
        }
      }
    } else {
      console.log('type: ' + this.$route.params.type);
      console.log('status login: ' + this.status_login);
      // this.$router.push('/login')
      // มีคีย์ login มาด้วยให้ login auto ถ้าไม่มีให้อยู่หน้า login
      if (this.$route.query.shared_token !== undefined) {
        this.loginWithSharetoken(this.$route.query.shared_token);
      }
    }
  },

  methods: {
    loginWithSharetoken: function loginWithSharetoken(token) {
      var _this = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/login_sharedtoken', { shared_token: token }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          _this.progress = false;
          var profile = response.data['account']['profile'];
          _this.myprofilepicture = profile['profilepicture'];
          _this.myname = profile['name'];
          _this.$i18n.locale = _this.$cookie.get('language') ? _this.$cookie.get('language') : 'th';
          localStorage.setItem('Authenrization', services["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
          localStorage.setItem('profilepicture', profile['profilepicture']);
          localStorage.setItem('name', profile['name']);
          localStorage.setItem('phone', profile['phone']);
          localStorage.setItem('email', profile['email']);
          localStorage.setItem('status', profile['status']);
          localStorage.setItem('type_user', profile['type']);
          localStorage.setItem('wallpaperInfo', stringify_default()({
            'info': [{
              'room': '',
              'background': ''
            }]
          }));
          if (profile['username'] === '' || profile['username'] === 'None') {
            localStorage.setItem('status_username', 'false');
          } else {
            localStorage.setItem('status_username', 'true');
          }
          if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
            // redirect bot room with url
            var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
            var url = '';
            if (data.url !== undefined && data.url !== 'undefined') {
              url = '&url=' + data.url;
            }
            _this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + url);
          }
        } else {
          _this.$cookie.set('status_login', 'F');
          _this.progress = false;
          if (response.data['message'] === 'Expired token') {
            _this.$swal('', _this.$t('Settings.messageEditPhone.MsgTokenExpire'), 'warning');
          } else {
            _this.$swal('', response.data['message'], 'warning');
          }
        }
      }).catch(function (error) {
        console.log(error);
        _this.$cookie.set('status_login', 'F');
        _this.progress = false;
        _this.$t('Alert.Fail.default.somethingWrong');
      });
    },
    openAppOrStore: function openAppOrStore(url, store) {
      console.log(store);
      // var me = this
      // setTimeout(function () {
      //   if (!me.openedApp) {
      //     window.location = store;
      //   }
      // }, 25);

      try {
        window.location = url;
        if (window.location.href.indexOf("onechat://") !== -1) {
          me.openedApp = true;
        }
      } catch (e) {}

      // window.location.replace(url)
      // setTimeout(function () {
      //   window.location.replace(store)
      // }, 2000)
    },
    redirectto: function redirectto(url) {
      var me = this;
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // console.log(userAgent)
      setTimeout(function () {
        if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
          // console.log(me.$route.query.service)
          // console.log(me.$route.params.type)
          // console.log(me.$route.name)
          // if(me.$route.params.type && me.$route.query.service) {
          //   if (me.$route.params.type !== 'friend' || me.$route.query.service !== 'onemeet') {
          //     me.openAppOrStore(url, 'https://apps.apple.com/th/app/onechat/id1394435274#?platform=iphone');
          //   }
          // } else
          // if(me.$route.params.type) {
          me.openAppOrStore(url, 'https://apps.apple.com/th/app/onechat/id1394435274#?platform=iphone');
          // }
        } else {
          me.openAppOrStore(url, 'https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat');
        }
      }, 25);
    },
    redirectto2: function redirectto2(url) {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // if (/android/i.test(userAgent)) {
      //   setTimeout(function () { window.location = "https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat"; }, 25);
      //   window.location = url;
      // }
      // if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
      //   setTimeout(function () { window.location = "https://itunes.apple.com/th/app/onechat/id1394435274?mt=8"; }, 25);
      //   window.location = url;
      // }
      // return "unknown";
      if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
        var now = new Date().valueOf();
        setTimeout(function () {
          if (new Date().valueOf() - now > 100) return;
          window.location = "https://apps.apple.com/th/app/onechat/id1394435274#?platform=iphone";
        }, 25);
        window.location = url;
      } else {
        var now = new Date().valueOf();
        setTimeout(function () {
          if (new Date().valueOf() - now > 100) return;
          window.location = "https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat";
        }, 25);
        window.location = url;
      }
    },
    toNewTab: function toNewTab() {
      window.open("https://uatchat.one.th:8089/docs", '_blank').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    downloadios: function downloadios() {
      window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus();
    },
    downloadandroid: function downloadandroid() {
      window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus();
    },
    closedownload: function closedownload() {
      this.snackbar = false;
    },
    loadepage: function loadepage() {
      window.open('http://onelink.to/hpyvpk', '_blank');
    },
    closeDialogProblem: function closeDialogProblem(value) {
      this.dialogProblem = value;
    },
    closeDialogus: function closeDialogus(value) {
      this.dialogus = value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-635c214a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RedirectRoomWithSharedToken.vue
var RedirectRoomWithSharedToken_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status_login !== '')?_c('div',{class:_vm.$vuetify.breakpoint.mdAndUp ? 'Background' : 'BackgroundMobile',staticStyle:{"background-color":"white","height":"100vh","padding-top":"64px","overflow-y":"auto","overflow-x":"hidden"},attrs:{"dark":"","id":"home"}},[_c('v-layout',{},[_c('div',{staticClass:"text"},[_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"height":"90vh"},attrs:{"align-center":"","row":"","wrap":"","justify-center":"","fill-height":""}},[_c('v-flex',{staticStyle:{"display":"grid"},attrs:{"xs12":"","sm12":"","md5":"","xl5":"","lg5":""}},[_c('v-img',{staticStyle:{"max-height":"90vh"},attrs:{"src":"/static/img/homepage/onechat_app.png","alt":"banner onechat"}}),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"4vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"200","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"200","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"4vh"},attrs:{"xs12":"","sm12":"","md7":"","xl7":"","lg7":""}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"2vh"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-img',{staticStyle:{"max-height":"100px","justify-content":"center","width":"256px"},attrs:{"src":"/static/img/icons/logoonechat_full.png","alt":"icon onechat"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"6vh","color":"black","font-size":"20px"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("\" แอปพลิเคชันแชทของคนไทยเพื่อคนไทย")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("เราจะทำให้ทุกการสนทนาของคุณปลอดภัย \"")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-sm-and-down",staticStyle:{"display":"flex","margin-top":"6vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-btn',{staticClass:"btnhover",attrs:{"to":"/register","round":"","dark":"","color":"#2562B0"}},[_vm._v("ร่วมเป็นส่วนหนึ่งกับพวกเรา")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"align-center":"","row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticStyle:{"margin-top":"6em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{attrs:{"src":"/static/img/icons/logoonechat_full.png","width":"120","height":"50"}}),_vm._v(" "),_c('h1',{staticStyle:{"color":"#2562B0","padding-left":"20px"}},[_vm._v("คือ อะไร?")])])],1),_vm._v(" "),(_vm.$vuetify.breakpoint.width <= 1028 && _vm.$vuetify.breakpoint.height >=1366)?_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"margin-top":"1.5em"},attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"700"}},[_c('p',{staticStyle:{"padding":"20px","margin-bottom":"0px","font-size":"20px"}},[_vm._v("\n                     One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้\n              ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10em","margin-right":"10em","margin-top":"140px"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"50vh"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","max-width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1),_vm._v(" "),_c('div',[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"20px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการฟรีอีเมล")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"margin-left":"20px"},attrs:{"round":"","color":"#2562B0","target":"_blank","href":" https://mail.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs122":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"190"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"370","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)])],1)],1)],1)],1):_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"margin-top":"1.5em","border-radius":"10px"},attrs:{"align-center":"","justify-space-around":"","row":"","wrap":"","fill-height":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"700"}},[_c('p',{staticStyle:{"padding":"20px","margin-bottom":"0px","font-size":"20px"}},[_vm._v("\n                     One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้\n              ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10em","margin-right":"10em","margin-top":"140px"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"50vh"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":"","align-center":"","fill-height":""}},[_c('div',[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","max-width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1),_vm._v(" "),_c('div',[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"20px"},attrs:{"color":"#BFDBFF","tile":"","width":"250","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("บริการฟรีอีเมล")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"margin-left":"20px"},attrs:{"round":"","color":"#2562B0","target":"_blank","href":" https://mail.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","margin-right":"100px"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0"},attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px","margin-left":"150px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh","margin-right":"10em"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"margin-left":"30px"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"400","height":"190"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20em","margin-right":"20em","margin-top":"10em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","margin-right":"120px"}},[_c('v-card',{staticClass:"cardstyle",staticStyle:{"margin-left":"0","margin-right":"0px"},attrs:{"color":"#BFDBFF","tile":"","width":"370","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincard"},[_vm._v("One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"40vh","margin-left":"80px"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"hidden-md-and-up",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticStyle:{"padding-top":"3em"},attrs:{"xs12":"","sm12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"max-height":"100px","justify-content":"center","width":"256px"},attrs:{"src":"/static/img/icons/logoonechat_full.png","alt":"icon onechat"}})])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"2em","color":"black","font-size":"15px"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("\" แอปพลิเคชันแชทของคนไทยเพื่อคนไทย")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","xl12":"","lg12":""}},[_c('span',[_vm._v("เราจะทำให้ทุกการสนทนาของคุณปลอดภัย \"")])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"6vh","margin-bottom":"3em","color":"black","justify-content":"center"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-btn',{attrs:{"to":"/register","round":"","dark":"","color":"#2562B0"}},[_vm._v("ร่วมเป็นส่วนหนึ่งกับพวกเรา")])],1),_vm._v(" "),_c('img',{staticClass:"hidden-md-and-up",staticStyle:{"max-height":"40vh"},attrs:{"src":"/static/img/homepage/onechat_app.png","alt":"banner onechat"}}),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","margin-top":"4vh","color":"black"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",staticStyle:{"max-width":"150px"},attrs:{"src":"/static/img/download/rsz_googleplay.png","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{staticClass:"download",staticStyle:{"max-width":"150px"},attrs:{"src":"/static/img/download/rsz_appstore.png","height":"60","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"hidden-md-and-up",staticStyle:{"margin-top":"6em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{attrs:{"src":"/static/img/icons/logoonechat_full.png","width":"120","height":"50"}}),_vm._v(" "),_c('h1',{staticStyle:{"color":"#2562B0","padding-left":"20px"}},[_vm._v("คือ อะไร?")])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"},attrs:{"color":"#BFDBFF","width":"480"}},[_c('p',{staticStyle:{"padding":"20px","font-size":"18px","margin-bottom":"0px"}},[_vm._v("\n                       One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้\n                ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic","margin-bottom":"20px"},attrs:{"src":"/static/img/homepage/one_platform.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"130"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/one2x.png"}})])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px"},attrs:{"color":"#BFDBFF","tile":"","width":"150","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/box2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"round":"","dark":"","color":"#2562B0","target":"_blank","href":"https://box.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1),_vm._v(" "),_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"margin-top":"1em","border-radius":"10px","margin-left":"30px"},attrs:{"color":"#BFDBFF","tile":"","width":"150","height":"150"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("บริการฟรีอีเมล")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/mail2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"margin-left":"40px"},attrs:{"round":"","color":"#2562B0","target":"_blank","href":" https://mail.one.th/"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"height":"60vh","border-radius":"30px"},attrs:{"src":"/static/img/homepage/message_image.gif"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"170"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1)])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic","max-height":"100vh"},attrs:{"src":"/static/img/homepage/multios.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"170"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)\n                        ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/chat2x.png"}})])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2em"},attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticClass:"mr-4 download",attrs:{"src":"/static/img/download/rsz_googleplay.png","width":"130","height":"50","alt":"download onechat"},on:{"click":function($event){_vm.downloadapp_and()}}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/download/rsz_appstore.png","width":"130","height":"50","alt":"download onechat download"},on:{"click":function($event){_vm.downloadapp_ios()}}})])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"5em"},attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"90vw","height":"intrinsic"},attrs:{"src":"/static/img/homepage/web_develop.png"}})])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"3em"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","fill-height":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-card',{staticClass:"cardstyle",attrs:{"color":"#BFDBFF","tile":"","width":"300","height":"180"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('span',{staticClass:"textincardMobile"},[_vm._v("One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ")]),_vm._v(" "),_c('v-avatar',{staticClass:"iconcard",attrs:{"tile":"","size":"58"}},[_c('img',{attrs:{"src":"/static/img/homepage/icon/bot2x.png"}})])],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"20px"},attrs:{"round":"","dark":"","color":"#2562B0","href":_vm.onechatDev,"target":"_blank"}},[_vm._v("ดูข้อมูลเพิ่มเติม")])],1)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('messageusDialog',{attrs:{"dialogus":_vm.dialogus},on:{"closeDialogus":_vm.closeDialogus}}),_vm._v(" "),_c('ProblemDialog',{attrs:{"dialogProblem":_vm.dialogProblem},on:{"closeDialogProblem":_vm.closeDialogProblem}})],1),_vm._v(" "),_c('div',{staticClass:"footer hidden-sm-and-down"},[_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{staticClass:"footertitle"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"justify-end":""}},[_c('img',{staticStyle:{"width":"260px"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{staticStyle:{"padding-left":"20px"},attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-start":""}},[_c('b',[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-start":""}},[_c('div',[_c('span',{staticStyle:{"display":"flex-inline"}},[_vm._v(" เวลาทำการ วันจันทร์ - ศุกร์ ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_vm._v("เวลา 09.00 - 17.00 น.")])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                       ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                      ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n                        เขตห้วยขวาง กรุงเทพมหานคร 10310\n                      ")])],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"align-start":"","row":"","wrap":"","justify-start":"","fill-height":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบายการใช้งาน")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v("ส่งข้อความถึงเรา")])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"problemIcon hidden-sm-and-down"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticStyle:{"background":"#2662af","height":"60px !important","width":"60px !important"},attrs:{"slot":"activator","fab":"","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogProblem = !_vm.dialogProblem}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"30px"}},[_vm._v("fas fa-bullhorn")])],1),_vm._v(" "),_c('span',[_vm._v("พบเจอปัญหา")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"footerMobile hidden-md-and-up"},[(_vm.$vuetify.breakpoint.width >= 768)?_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{staticClass:"footermobiletext"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"220px","height":"intrinsic"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{staticStyle:{"padding-left":"20px"},attrs:{"justify-center":""}},[_c('div',[_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('b',[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{},[_vm._v(" เวลาทำการ วันจันทร์ - ศุกร์ ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("เวลา 09.00 - 17.00")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-bottom":"30px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',[_vm._v("\n                          1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                          "),_c('br'),_vm._v("\n                          ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                          "),_c('br'),_vm._v("\n                          เขตห้วยขวาง กรุงเทพมหานคร 10310\n                        ")])])],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-layout',{attrs:{"align-start":"","row":"","wrap":"","justify-center":"","fill-height":""}},[_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('a',{staticClass:"footerlink",staticStyle:{"color":"black !important"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบายการใช้งาน")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"30px","padding-bottom":"15px"},attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v("ส่งข้อความถึงเรา")])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1):_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"flex",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":""}},[_c('v-card-title',{},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('img',{staticStyle:{"width":"300px","height":"intrinsic"},attrs:{"src":"/static/img/homepage/onecentric_logo.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticStyle:{"padding-left":"25px"}},[_c('v-flex',{staticStyle:{"margin-bottom":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('b',[_vm._v("บริษัท วัน เซ็นทริค จำกัด")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-bottom":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{},[_vm._v(" เวลาทำการ วันจันทร์ - ศุกร์ ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("เวลา 09.00 - 17.00")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',[_vm._v("\n                        1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16\n                        "),_c('br'),_vm._v("\n                        ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ\n                        "),_c('br'),_vm._v("\n                        เขตห้วยขวาง กรุงเทพมหานคร 10310\n                      ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"color":"black !important"},attrs:{"href":"mailto:onechat@one.th"}},[_vm._v("onechat@one.th")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("mdi-book-variant")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toPage('/policy')}}},[_vm._v("นโยบายการใช้งาน")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('span',{staticClass:"footerlink",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.dialogus = !_vm.dialogus}}},[_vm._v("ส่งข้อความถึงเรา")])])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"problemIconMobile hidden-md-and-up"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticStyle:{"background":"#2662af","height":"40px !important","width":"40px !important"},attrs:{"slot":"activator","fab":"","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogProblem = !_vm.dialogProblem}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"20px"}},[_vm._v("fas fa-bullhorn")])],1),_vm._v(" "),_c('span',[_vm._v("พบเจอปัญหา")])],1)],1)],1):_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.progress)?_c('v-layout',{staticStyle:{"height":"100vh"},attrs:{"column":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"color":"primary","size":100,"indeterminate":_vm.progress,"width":6}})],1):_c('Login')],1)}
var RedirectRoomWithSharedToken_staticRenderFns = []
var RedirectRoomWithSharedToken_esExports = { render: RedirectRoomWithSharedToken_render, staticRenderFns: RedirectRoomWithSharedToken_staticRenderFns }
/* harmony default export */ var components_RedirectRoomWithSharedToken = (RedirectRoomWithSharedToken_esExports);
// CONCATENATED MODULE: ./src/components/RedirectRoomWithSharedToken.vue
function RedirectRoomWithSharedToken_injectStyle (ssrContext) {
  __webpack_require__("4enG")
}
var RedirectRoomWithSharedToken_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RedirectRoomWithSharedToken___vue_template_functional__ = false
/* styles */
var RedirectRoomWithSharedToken___vue_styles__ = RedirectRoomWithSharedToken_injectStyle
/* scopeId */
var RedirectRoomWithSharedToken___vue_scopeId__ = "data-v-635c214a"
/* moduleIdentifier (server only) */
var RedirectRoomWithSharedToken___vue_module_identifier__ = null
var RedirectRoomWithSharedToken_Component = RedirectRoomWithSharedToken_normalizeComponent(
  RedirectRoomWithSharedToken,
  components_RedirectRoomWithSharedToken,
  RedirectRoomWithSharedToken___vue_template_functional__,
  RedirectRoomWithSharedToken___vue_styles__,
  RedirectRoomWithSharedToken___vue_scopeId__,
  RedirectRoomWithSharedToken___vue_module_identifier__
)

/* harmony default export */ var src_components_RedirectRoomWithSharedToken = (RedirectRoomWithSharedToken_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/custsat/custsat.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var custsat = ({
  data: function data() {
    return {
      email: '',
      android: false,
      ios: false,
      website: false,
      frequencyUse: 0,
      rateFunction: 0,
      rateSpeedResponse: 0,
      rateOfficer: 0,
      feedback: '',
      onechat_token: '',
      isSet: undefined
    };
  },
  components: {},
  created: function created() {
    this.onechat_token = this.$route.query.onechat_token;
    this.checkform(this.$route.query.onechat_token);
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
  },

  methods: {
    changeLan: function changeLan(lang) {
      this.$i18n.locale = lang;
    },
    checkdisabled: function checkdisabled() {
      return (this.android || this.ios || this.website) && this.frequencyUse != 0 && this.rateFunction != 0 && this.rateSpeedResponse != 0 && this.rateOfficer != 0;
    },
    sendform: function sendform() {
      var _this = this;

      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/cussat/set', {
        onechat_token: this.onechat_token,
        ios: this.ios,
        android: this.android,
        web: this.website,
        frequency: this.frequencyUse,
        function: this.rateFunction,
        performance: this.rateSpeedResponse,
        support: this.rateOfficer,
        comment: this.feedback
      }).then(function (response) {
        console.log(response.data);
        _this.isSet = true;
      });
    },
    checkform: function checkform(onechattoken) {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/cussat/get', {
        onechat_token: onechattoken
      }).then(function (response) {
        // console.log(response.data.isSet)
        _this2.isSet = response.data.isSet;
        _this2.email = response.data.email;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1441ad57","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custsat/custsat.vue
var custsat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Kanit",staticStyle:{"padding":"15px","height":"100vh","overflow":"scroll","background":"#2562af"}},[_c('v-img',{staticStyle:{"max-width":"250px","margin":"auto"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}}),_vm._v(" "),(_vm.isSet==false)?_c('v-menu',{staticStyle:{"z-index":"11","border-radius":"10px","display":"flex","justify-content":"center"},attrs:{"offset-y":""}},[(_vm.$i18n.locale == 'th')?_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('span',{staticStyle:{"color":"white"}},[_vm._v("ภาษา :   ")]),_c('img',{staticClass:"iconLanguage",attrs:{"src":"/static/flag/thailand.svg"}})]):_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('span',{staticStyle:{"color":"white"}},[_vm._v("Language :   ")]),_c('img',{staticClass:"iconLanguage",attrs:{"src":"/static/flag/united-kingdom.svg"}})]),_vm._v(" "),_c('v-list',{staticStyle:{"border-radius":"10px"}},[_c('v-list-tile',{on:{"click":function($event){_vm.changeLan('th')}}},[_c('v-list-tile-title',[_c('img',{staticStyle:{"height":"20px"},attrs:{"src":"/static/flag/thailand.svg"}}),_vm._v("  ไทย\n      ")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeLan('en')}}},[_c('v-list-tile-title',[_c('img',{staticStyle:{"height":"20px"},attrs:{"src":"/static/flag/united-kingdom.svg"}}),_vm._v("  ENG\n      ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isSet == undefined)?_c('div',{staticClass:"bginform"},[_c('v-container',{staticStyle:{"justify-content":"center","display":"grid","text-align":"center"}},[_c('v-img',{staticStyle:{"justify-self":"center","width":"50vw","min-width":"250px","object-fit":"cover","object-position":"50% 0"},attrs:{"src":"/static/img/pagedefault/notfound.jpg"}}),_vm._v(" "),_c('h2',{staticClass:"mt-3 mb-2 indentText",staticStyle:{"justify-content":"center","display":"flex"}},[_vm._v("ไม่พบข้อมูลผู้ใช้งาน "),_c('br'),_vm._v("กรุณาติดต่อใหม่ในภายหลัง\n\n      ")])],1)],1):(!_vm.isSet)?_c('div',{staticClass:"bginform"},[_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('h2',[_vm._v(_vm._s(_vm.$t('custsat.Header')))])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('custsat.username'))+": ")]),_vm._v("  "+_vm._s(_vm.email)+" ")])]),_vm._v(" "),_c('v-flex',{staticClass:"rowForm",attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('div',[_c('b',[_vm._v("1. "+_vm._s(_vm.$t('custsat.ask_1.operation_system_1'))+" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px","color":"gray"}},[_vm._v("("+_vm._s(_vm.$t('custsat.ask_1.morethanone'))+") ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"15px"}},[_c('v-checkbox',{attrs:{"hide-details":"","label":_vm.$t('custsat.ask_1.android'),"color":"#2562af"},model:{value:(_vm.android),callback:function ($$v) {_vm.android=$$v},expression:"android"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"hide-details":"","label":_vm.$t('custsat.ask_1.ios'),"color":"#2562af"},model:{value:(_vm.ios),callback:function ($$v) {_vm.ios=$$v},expression:"ios"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"hide-details":"","label":_vm.$t('custsat.ask_1.website'),"color":"#2562af"},model:{value:(_vm.website),callback:function ($$v) {_vm.website=$$v},expression:"website"}})],1)]),_vm._v(" "),_c('v-flex',{staticClass:"rowForm",attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('div',[_c('b',[_vm._v("2. "+_vm._s(_vm.$t('custsat.ask_2.frequencyUse'))+" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"15px"}},[_c('v-radio-group',{attrs:{"hide-details":""},model:{value:(_vm.frequencyUse),callback:function ($$v) {_vm.frequencyUse=$$v},expression:"frequencyUse"}},[_c('v-radio',{attrs:{"value":1,"color":"#2562af","label":_vm.$t('custsat.ask_2.option1')}}),_vm._v(" "),_c('v-radio',{attrs:{"value":2,"color":"#2562af","label":_vm.$t('custsat.ask_2.option2')}}),_vm._v(" "),_c('v-radio',{attrs:{"value":3,"color":"#2562af","label":_vm.$t('custsat.ask_2.option3')}}),_vm._v(" "),_c('v-radio',{attrs:{"value":4,"color":"#2562af","label":_vm.$t('custsat.ask_2.option4')}})],1)],1)]),_vm._v(" "),_c('v-flex',{staticClass:"rowForm",attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('div',[_c('b',[_vm._v("3. "+_vm._s(_vm.$t('custsat.ask_3'))+" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])])]),_vm._v(" "),_c('div',{staticClass:"rate"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateFunction),expression:"rateFunction"}],attrs:{"type":"radio","id":"rateFunction5"},domProps:{"value":5,"checked":_vm._q(_vm.rateFunction,5)},on:{"change":function($event){_vm.rateFunction=5}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateFunction5","title":"text"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateFunction),expression:"rateFunction"}],attrs:{"type":"radio","id":"rateFunction4"},domProps:{"value":4,"checked":_vm._q(_vm.rateFunction,4)},on:{"change":function($event){_vm.rateFunction=4}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateFunction4","title":"text"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateFunction),expression:"rateFunction"}],attrs:{"type":"radio","id":"rateFunction3"},domProps:{"value":3,"checked":_vm._q(_vm.rateFunction,3)},on:{"change":function($event){_vm.rateFunction=3}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateFunction3","title":"text"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateFunction),expression:"rateFunction"}],attrs:{"type":"radio","id":"rateFunction2"},domProps:{"value":2,"checked":_vm._q(_vm.rateFunction,2)},on:{"change":function($event){_vm.rateFunction=2}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateFunction2","title":"text"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateFunction),expression:"rateFunction"}],attrs:{"type":"radio","id":"rateFunction1"},domProps:{"value":1,"checked":_vm._q(_vm.rateFunction,1)},on:{"change":function($event){_vm.rateFunction=1}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateFunction1","title":"text"}})]),_vm._v(" "),(_vm.rateFunction != 0)?_c('span',{staticStyle:{"vertical-align":"middle","line-height":"46px"}},[_vm._v("("+_vm._s(_vm.rateFunction)+" "+_vm._s(_vm.$t('custsat.point'))+")")]):_vm._e()]),_vm._v(" "),_c('v-flex',{staticClass:"rowForm",attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('div',[_c('b',[_vm._v("4. "+_vm._s(_vm.$t('custsat.ask_4'))+" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])])]),_vm._v(" "),_c('div',{staticClass:"rate"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateSpeedResponse),expression:"rateSpeedResponse"}],attrs:{"type":"radio","id":"rateSpeedResponse5"},domProps:{"value":5,"checked":_vm._q(_vm.rateSpeedResponse,5)},on:{"change":function($event){_vm.rateSpeedResponse=5}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateSpeedResponse5","title":"text"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateSpeedResponse),expression:"rateSpeedResponse"}],attrs:{"type":"radio","id":"rateSpeedResponse4"},domProps:{"value":4,"checked":_vm._q(_vm.rateSpeedResponse,4)},on:{"change":function($event){_vm.rateSpeedResponse=4}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateSpeedResponse4","title":"text"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateSpeedResponse),expression:"rateSpeedResponse"}],attrs:{"type":"radio","id":"rateSpeedResponse3"},domProps:{"value":3,"checked":_vm._q(_vm.rateSpeedResponse,3)},on:{"change":function($event){_vm.rateSpeedResponse=3}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateSpeedResponse3","title":"text"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateSpeedResponse),expression:"rateSpeedResponse"}],attrs:{"type":"radio","id":"rateSpeedResponse2"},domProps:{"value":2,"checked":_vm._q(_vm.rateSpeedResponse,2)},on:{"change":function($event){_vm.rateSpeedResponse=2}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateSpeedResponse2","title":"text"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateSpeedResponse),expression:"rateSpeedResponse"}],attrs:{"type":"radio","id":"rateSpeedResponse1"},domProps:{"value":1,"checked":_vm._q(_vm.rateSpeedResponse,1)},on:{"change":function($event){_vm.rateSpeedResponse=1}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateSpeedResponse1","title":"text"}})]),_vm._v(" "),(_vm.rateSpeedResponse != 0)?_c('span',{staticStyle:{"vertical-align":"middle","line-height":"46px"}},[_vm._v("("+_vm._s(_vm.rateSpeedResponse)+" "+_vm._s(_vm.$t('custsat.point'))+")")]):_vm._e()]),_vm._v(" "),_c('v-flex',{staticClass:"rowForm",attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('div',[_c('b',[_vm._v("5. "+_vm._s(_vm.$t('custsat.ask_5'))+" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])])]),_vm._v(" "),_c('div',{staticClass:"rate"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateOfficer),expression:"rateOfficer"}],attrs:{"type":"radio","id":"rateOfficer5"},domProps:{"value":5,"checked":_vm._q(_vm.rateOfficer,5)},on:{"change":function($event){_vm.rateOfficer=5}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateOfficer5","title":"text"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateOfficer),expression:"rateOfficer"}],attrs:{"type":"radio","id":"rateOfficer4"},domProps:{"value":4,"checked":_vm._q(_vm.rateOfficer,4)},on:{"change":function($event){_vm.rateOfficer=4}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateOfficer4","title":"text"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateOfficer),expression:"rateOfficer"}],attrs:{"type":"radio","id":"rateOfficer3"},domProps:{"value":3,"checked":_vm._q(_vm.rateOfficer,3)},on:{"change":function($event){_vm.rateOfficer=3}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateOfficer3","title":"text"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateOfficer),expression:"rateOfficer"}],attrs:{"type":"radio","id":"rateOfficer2"},domProps:{"value":2,"checked":_vm._q(_vm.rateOfficer,2)},on:{"change":function($event){_vm.rateOfficer=2}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateOfficer2","title":"text"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rateOfficer),expression:"rateOfficer"}],attrs:{"type":"radio","id":"rateOfficer1"},domProps:{"value":1,"checked":_vm._q(_vm.rateOfficer,1)},on:{"change":function($event){_vm.rateOfficer=1}}}),_vm._v(" "),_c('label',{attrs:{"for":"rateOfficer1","title":"text"}})]),_vm._v(" "),(_vm.rateOfficer != 0)?_c('span',{staticStyle:{"vertical-align":"middle","line-height":"46px"}},[_vm._v("("+_vm._s(_vm.rateOfficer)+" "+_vm._s(_vm.$t('custsat.point'))+")")]):_vm._e()]),_vm._v(" "),_c('v-flex',{staticClass:"rowForm",attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('div',[_c('b',[_vm._v(_vm._s(_vm.$t('custsat.comment')))])]),_vm._v(" "),_c('div',[_c('v-textarea',{staticClass:"InputEdit",staticStyle:{"height":"120px","resize":"none","margin-bottom":"15px"},attrs:{"placeholder":_vm.$t('custsat.comment'),"full-width":""},model:{value:(_vm.feedback),callback:function ($$v) {_vm.feedback=$$v},expression:"feedback"}})],1)]),_vm._v(" "),_c('v-flex',{staticClass:"rowForm",staticStyle:{"text-align":"center","display":"block"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('v-btn',{staticStyle:{"background":"#2562af","color":"white","border-radius":"10px"},attrs:{"disabled":!_vm.checkdisabled()},on:{"click":function($event){_vm.sendform()}}},[_vm._v(_vm._s(_vm.$t('custsat.send')))])],1)],1):(_vm.isSet)?_c('div',{staticClass:"bginform"},[_c('v-container',{staticStyle:{"justify-content":"center","display":"grid","text-align":"center"}},[_c('v-img',{staticStyle:{"justify-self":"center","width":"50vw","min-width":"250px","object-fit":"cover","object-position":"50% 0"},attrs:{"src":"/static/img/custsat/celebration.png"}}),_vm._v(" "),_c('h2',{staticClass:"mt-3 mb-2 indentText",staticStyle:{"justify-content":"center","display":"flex"}},[_vm._v("ขอบคุณสำหรับการตอบคำถามนะคะ "),_c('br'),_vm._v(" เราจะนำคำแนะนำไปปรับปรุงบริการให้ดีขึ้น\n\n      ")])],1)],1):_vm._e()],1)}
var custsat_staticRenderFns = []
var custsat_esExports = { render: custsat_render, staticRenderFns: custsat_staticRenderFns }
/* harmony default export */ var custsat_custsat = (custsat_esExports);
// CONCATENATED MODULE: ./src/components/custsat/custsat.vue
function custsat_injectStyle (ssrContext) {
  __webpack_require__("JSpy")
}
var custsat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var custsat___vue_template_functional__ = false
/* styles */
var custsat___vue_styles__ = custsat_injectStyle
/* scopeId */
var custsat___vue_scopeId__ = "data-v-1441ad57"
/* moduleIdentifier (server only) */
var custsat___vue_module_identifier__ = null
var custsat_Component = custsat_normalizeComponent(
  custsat,
  custsat_custsat,
  custsat___vue_template_functional__,
  custsat___vue_styles__,
  custsat___vue_scopeId__,
  custsat___vue_module_identifier__
)

/* harmony default export */ var components_custsat_custsat = (custsat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/consent/consent.vue
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var consent = ({
  data: function data() {
    return {};
  },
  components: {},
  created: function created() {
    // this.onechat_token = this.$route.query.onechat_token
    // this.checkform(this.$route.query.onechat_token)
    // this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f784c4d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/consent/consent.vue
var consent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Kanit",staticStyle:{"padding":"15px","height":"100vh","overflow":"scroll","background":"#2562af"}},[_c('v-img',{staticStyle:{"max-width":"250px","margin":"auto"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}}),_vm._v(" "),_c('div',{staticClass:"bginform"},[_c('router-view')],1)],1)}
var consent_staticRenderFns = []
var consent_esExports = { render: consent_render, staticRenderFns: consent_staticRenderFns }
/* harmony default export */ var consent_consent = (consent_esExports);
// CONCATENATED MODULE: ./src/components/consent/consent.vue
function consent_injectStyle (ssrContext) {
  __webpack_require__("rCqH")
}
var consent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var consent___vue_template_functional__ = false
/* styles */
var consent___vue_styles__ = consent_injectStyle
/* scopeId */
var consent___vue_scopeId__ = "data-v-7f784c4d"
/* moduleIdentifier (server only) */
var consent___vue_module_identifier__ = null
var consent_Component = consent_normalizeComponent(
  consent,
  consent_consent,
  consent___vue_template_functional__,
  consent___vue_styles__,
  consent___vue_scopeId__,
  consent___vue_module_identifier__
)

/* harmony default export */ var components_consent_consent = (consent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/consent/Policy.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navbar from '@/components/homepage/Navbar'
// import Footer from '@/components/homepage/Footer'
// import PolicyMobile from '@/components/mobile/settings/PolicyMobile'
// import Footer from '@/components/home/Footer'
/* harmony default export */ var consent_Policy = ({
  components: {
    // Navbar,
    // Footer,
    // PolicyMobile
    // ,Footer
  },
  created: function created() {
    // this.$i18n.locale = 'th'
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
  },

  methods: {
    linkAPI: function linkAPI() {
      window.open('/docs', '_blank').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    linkregister: function linkregister() {
      window.open('/register').focus();
    },
    linkdownload: function linkdownload() {
      window.open('/download').focus();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d315a9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/consent/Policy.vue
var consent_Policy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"Kanit",staticStyle:{"height":"calc(100vh - 170px)","overflow-y":"scroll","background":"white","font-size":"16px","padding":"10px !important"},attrs:{"id":"policy"}},[_c('br'),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center","text-decoration":"underline"}},[_vm._v(_vm._s(_vm.$t('Settings.policy.header'))+"\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',{staticClass:"Kanit"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.header')))]),_vm._v(" "),_c('p',{staticClass:"Kanit",staticStyle:{"padding":"1vw","font-size":"13px"}},[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject1.introDetail'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro1'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro2'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro3'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro4'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro5'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro6'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro7'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject1.subjectIntro8'))+"\n    ")]),_vm._v(" "),_c('h3',{staticClass:"Kanit"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject2.header')))]),_vm._v(" "),_c('p',{staticClass:"Kanit",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject2.subHeaderScopeA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeA1'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeA2'))),_c('br'),_vm._v(" "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject2.subHeaderScopeB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject2.detailScopeB1'))+"\n    ")]),_vm._v(" "),_c('h3',{staticClass:"Kanit"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject3.header')))]),_vm._v(" "),_c('p',{staticClass:"Kanit",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subHeaderTypeA')))]),_vm._v("\n       "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubHeaderA'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectA1')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA1'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectA2')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA2'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectA21'))),_c('br'),_vm._v(" "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subHeaderTypeB')))]),_vm._v("\n       "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubHeaderB'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB1')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB1'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB12'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB2')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB2'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB3')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB3'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB4')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB41'))+"\n      "),_c('br'),_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB42'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB5')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB51'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB52'))+"\n\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB6')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB6'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB7')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB71'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB72'))+"\n\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB8')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB8'))+"\n\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject3.subjectB9')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB91'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject3.detailSubjectB92'))+"\n       \n      "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"Kanit"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject4.header')))]),_vm._v(" "),_c('p',{staticClass:"Kanit",staticStyle:{"font-size":"13px","padding":"1vw"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA'))+"\n\n\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA1'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA2'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA3'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA4'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA5'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA6'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA7'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA8'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA9'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA10'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA11'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA12'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA13'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA14'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA15'))+"\n\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectA16'))+"\n\n       "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectB1'))+"\n\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectB2'))+"\n\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectC')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectC'))+"\n       "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectD')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD1'))+"\n      "),_c('br'),_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD2'))+"\n      "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD3'))+"\n      "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD4'))+"\n      "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD5'))+"\n      "),_c('br'),_vm._v("    • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectD6'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectE')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectE'))+"\n       "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectF')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectF'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject4.subjectG')))]),_vm._v(" "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG1'))+"\n      "),_c('br'),_vm._v("      "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG2'))+"\n      "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG3'))+"\n      "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG4'))+"\n      "),_c('br'),_vm._v("      • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG5'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG6'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG7'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG8'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject4.detailSubjectG9'))+"\n      "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"Kanit"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject5.header')))]),_vm._v(" "),_c('p',{staticClass:"Kanit",staticStyle:{"padding":"1vw","font-size":"13px"}},[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.detailHeader'))+"\n        "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA1'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA2'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA3'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectA4'))+"\n       "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject5.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB1'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB2'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB3'))+"\n      "),_c('br'),_vm._v("     • "+_vm._s(_vm.$t('Settings.policy.subject5.detailSubjectB4'))+"\n      "),_c('br')]),_vm._v(" "),_c('h3',{staticClass:"Kanit"},[_vm._v("  "+_vm._s(_vm.$t('Settings.policy.subject6.header')))]),_vm._v(" "),_c('p',{staticClass:"Kanit",staticStyle:{"padding":"1vw","font-size":"13px"}},[_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject6.subjectA')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectA'))+"\n      "),_c('br'),_c('b',[_vm._v("    "+_vm._s(_vm.$t('Settings.policy.subject6.subjectB')))]),_vm._v(" "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectB1'))+"\n      "),_c('br'),_vm._v("     "+_vm._s(_vm.$t('Settings.policy.subject6.detailSubjectB2'))+"\n\n      "),_c('br')]),_vm._v(" "),_c('br')])],1)}
var consent_Policy_staticRenderFns = []
var consent_Policy_esExports = { render: consent_Policy_render, staticRenderFns: consent_Policy_staticRenderFns }
/* harmony default export */ var components_consent_Policy = (consent_Policy_esExports);
// CONCATENATED MODULE: ./src/components/consent/Policy.vue
function consent_Policy_injectStyle (ssrContext) {
  __webpack_require__("X8t3")
}
var consent_Policy_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var consent_Policy___vue_template_functional__ = false
/* styles */
var consent_Policy___vue_styles__ = consent_Policy_injectStyle
/* scopeId */
var consent_Policy___vue_scopeId__ = "data-v-1d315a9e"
/* moduleIdentifier (server only) */
var consent_Policy___vue_module_identifier__ = null
var consent_Policy_Component = consent_Policy_normalizeComponent(
  consent_Policy,
  components_consent_Policy,
  consent_Policy___vue_template_functional__,
  consent_Policy___vue_styles__,
  consent_Policy___vue_scopeId__,
  consent_Policy___vue_module_identifier__
)

/* harmony default export */ var src_components_consent_Policy = (consent_Policy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/consent/consent_C7gi50r08q6.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var consent_C7gi50r08q6 = ({
  data: function data() {
    return {
      show: false,
      consent_1: '',
      consent_2: '',
      consent_check: '',
      showpolicy: false
    };
  },
  components: {
    policydialog: src_components_consent_Policy
  },
  created: function created() {
    this.onechat_token = this.$route.query.onechat_token;
    this.checkconsent();
    // this.checkform(this.$route.query.onechat_token)
    // this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
  },

  methods: {
    changeLan: function changeLan(lang) {
      this.$i18n.locale = lang;
    },
    checkdisabled: function checkdisabled() {
      return this.consent_check == 'true' ? true : false;
    },
    sendconsentALL: function sendconsentALL() {
      this.consent_1 = "true";
      this.consent_2 = "true";
      this.sendconsent();
    },
    sendconsent: function sendconsent() {
      var _this = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/set-consent', {
        onechat_token: this.onechat_token,
        consent_status: [this.consent_1, this.consent_2],
        consent_version: "C7gi50r08q6"
      }).then(function (response) {
        // console.log(response.data)
        _this.checkconsent();
        // this.isSet = true
      });
    },
    checkconsent: function checkconsent() {
      var _this2 = this;

      // console.log('test')
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-consent', {
        onechat_token: this.onechat_token,
        consent_version: "C7gi50r08q6"
      }).then(function (response) {
        // console.log(response.data.data.consent_status)
        try {
          _this2.consent_check = response.data.data.consent_check;
          _this2.consent_1 = response.data.data.consent_status[0];
          _this2.consent_2 = response.data.data.consent_status[1];
        } catch (err) {
          console.log(err);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-585f2d77","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/consent/consent_C7gi50r08q6.vue
var consent_C7gi50r08q6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Kanit",staticStyle:{"padding":"15px","height":"calc(100vh - 170px)","overflow":"scroll","text-align":"center"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),(_vm.show)?_c('div',{staticStyle:{"text-align":"left","margin-top":"10px"}},[_c('h4',[_vm._v("1. วัตถุประสงค์ในการเก็บรวบรวม/ใช้/เปิดเผย ข้อมูลส่วนบุคคล")]),_vm._v(" "),_c('div',{staticClass:"consentbordersite"},[_vm._m(2),_vm._v(" "),_c('span',[_vm._v("เพื่อให้คุณใช้งานได้สะดวก ตรงใจมากขึ้น เราอาจเก็บข้อมูลของท่านและนำมาวิเคราะห์และปรับปรุงบริการของเรา รวมไปถึงการอำนวยความสะดวก เพื่อให้ประสบการณ์ใช้งานที่รวดเร็ว ตอบสนองต่อความต้องการและพึงพอใจของผู้ใช้ คุณยินยอมให้ บริษัท วัน เซ็นทริค จำกัด เก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของคุณเพื่อจุดประสงค์ที่กล่าวมาข้างต้น")]),_vm._v(" "),_c('hr',{staticClass:"underline_consent"}),_vm._v(" "),_c('div',[_c('v-radio-group',{attrs:{"hide-details":"","row":""},model:{value:(_vm.consent_1),callback:function ($$v) {_vm.consent_1=$$v},expression:"consent_1"}},[_c('v-radio',{staticStyle:{"width":"33vw"},attrs:{"label":"ยินยอม","value":"true","color":"#2562af"}}),_vm._v(" "),_c('v-radio',{staticStyle:{"width":"33vw"},attrs:{"label":"ไม่ยินยอม","value":"false","color":"#2562af"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"consentbordersite"},[_c('h4',[_vm._v("ความยินยอมในการติดต่อกลับสำหรับแนะนำผลิตภัณฑ์ และนำเสนอบริการต่าง ๆ ของบริษัทฯเพิ่มเติมตามที่ท่านทำการร้องขอ หรือบริการอื่น ๆ ที่เกี่ยวข้อง)")]),_vm._v(" "),_c('span',[_vm._v("เพื่อให้คุณได้รับข้อเสนอ โปรโมชั่น เนื้อหา สินค้า หรือ บริการที่คัดสรรมาสำหรับคุณโดยเฉพาะ และตอบโจทย์คุณมากยิ่งขึ้น คุณยินยอมให้ บริษัท วัน เซ็นทริค จำกัด เก็บรวมรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของคุณเพื่อจุดประสงค์ที่กล่าวมาข้างต้น")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"linkpolicy",on:{"click":function($event){_vm.showpolicy=true}}},[_vm._v("นโยบายคุ้มครองความเป็นส่วนตัว ของบริษัท วัน เซ็นทริค จำกัด")]),_vm._v(" "),_c('hr',{staticClass:"underline_consent"}),_vm._v(" "),_c('div',[_c('v-radio-group',{attrs:{"hide-details":"","row":""},model:{value:(_vm.consent_2),callback:function ($$v) {_vm.consent_2=$$v},expression:"consent_2"}},[_c('v-radio',{staticStyle:{"width":"33vw"},attrs:{"label":"ยินยอม","value":"true","color":"#2562af"}}),_vm._v(" "),_c('v-radio',{staticStyle:{"width":"33vw"},attrs:{"label":"ไม่ยินยอม","value":"false","color":"#2562af"}})],1)],1)]),_vm._v(" "),_c('h4',{staticStyle:{"margin-top":"10px"}},[_vm._v("2. ข้อมูลที่เจ้าของข้อมูลให้ไว้ตามวัตถุประสงค์ในข้อ 1 ได้แก่")]),_vm._v(" "),_c('span',[_vm._v("      ข้อมูลส่วนตัว ได้แก่ ชื่อ-นามสกุล, เบอร์โทรศัพท์")]),_vm._v(" "),_c('h4',{staticStyle:{"margin-top":"10px"}},[_vm._v("3. สิทธิของเจ้าของข้อมูล")]),_vm._v(" "),_c('span',[_vm._v("      3.1 สิทธิในการเพิกถอนความยินยอมให้บริษัทฯประมวลผลข้อมูลส่วนบุคคลของท่าน")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("      3.2 สิทธิในการเข้าถึงและรับสำเนาข้อมูลส่วนบุคคลที่บริษัทฯได้เก็บรวบรวม ใช้ เปิดเผย")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("      3.3 สิทธิในการขอให้โอนย้ายข้อมูลส่วนบุคคลของท่าน")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("      3.4 สิทธิในการคัดค้าน การประมวลผลข้อมูลส่วนบุคคลของท่าน")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("      3.5 สิทธิในการขอให้ลบ ทำลาย หรือทำให้ข้อมูลส่วนบุคคลของท่านซึ่งไม่อาจระบุตัวตนได้")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("      3.6 สิทธิในการระงับการใช้ข้อมูลส่วนบุคคลของท่าน")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("      3.7 สิทธิในการขอแก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้องเป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("      3.8 สิทธิที่จะร้องเรียนในกรณีที่ท่านเห็นว่าถูกบริษัทฯฯ หรือเจ้าหน้าที่หรือตัวแทนของบริษัทฯฯ ละเมิดสิทธิตาม พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562")]),_c('br'),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h4',{staticStyle:{"margin-top":"10px"}},[_vm._v("4. ระยะเวลาการเก็บข้อมูล")]),_vm._v(" "),_c('span',[_vm._v("      บริษัทฯจะจัดเก็บ ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่าน และข้อมูลอื่น ๆ เป็นระยะเวลา 1 ปี หรือตามสัญญาหลักที่ทำกับบริษัทฯ หรือจนกว่าท่านจะยกเลิกการให้ความยินยอม")]),_vm._v(" "),_c('h4',{staticStyle:{"margin-top":"10px"}},[_vm._v("5. ช่องทางการติดต่อ")]),_vm._v(" "),_c('span',[_vm._v("      • บริษัท วัน เซ็นทริค จำกัด 1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16 ถนนเพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310 ")]),_c('br'),_vm._v(" "),_vm._m(4),_c('br'),_vm._v(" "),_vm._m(5)]):_vm._e(),_vm._v(" "),(!_vm.show)?_c('div',[_c('v-btn',{staticClass:"detailbtn",on:{"click":function($event){_vm.show=true}}},[_vm._v("ดูรายละเอียด")]),_vm._v(" "),_c('v-btn',{staticClass:"consentbtn",attrs:{"disabled":_vm.checkdisabled()},on:{"click":function($event){_vm.sendconsentALL()}}},[_vm._v("ให้ความยินยอม")])],1):_c('div',[_c('v-btn',{staticClass:"consentbtn",attrs:{"disabled":_vm.consent_1 == '' || _vm.consent_2 == ''},on:{"click":function($event){_vm.sendconsent()}}},[_vm._v("บันทึก")])],1),_vm._v(" "),_c('v-dialog',{staticStyle:{"border-radius":"10px"},model:{value:(_vm.showpolicy),callback:function ($$v) {_vm.showpolicy=$$v},expression:"showpolicy"}},[_c('v-card',{staticStyle:{"border-radius":"10px"}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text Kanit"},[_vm._v("  "+_vm._s(_vm.$t('RightSide.header.privatepolicy')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},nativeOn:{"click":function($event){_vm.showpolicy=false}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('policydialog')],1)],1)],1)}
var consent_C7gi50r08q6_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_vm._v("ความยินยอมในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล"),_c('br'),_vm._v("สำหรับลูกค้าของ บริษัท วัน เซ็นทริค จำกัด")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","margin-top":"10px"}},[_c('span',[_vm._v("      บริษัท วัน เซ็นทริค จำกัด ได้พัฒนา Platform OneChat เป็นแอปพลิเคชันสำหรับการติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ใช้เป็นเครื่องมือในการทำธุรกรรมตัวตนดิจิตอลที่น่าเชื่อถือ รองรับการยืนยันตัวตนแบบ e-KYC และสามารถรองรับการลงลายมือชื่ออิเล็กทรอนิกส์โดยใช้ใบรับรองอิเล็กทรอนิกส์ (Certificate) ที่ระบุตัวตน หรือองค์กรผู้เป็นเจ้าของลายมือชื่อ เพื่อแสดงว่าบุคคล หรือองค์กรดังกล่าวยอมรับข้อความในข้อมูลอิเล็กทรอนิกส์นั้นได้ และขณะเดียวกัน บริษัท วัน เซ็นทริค จำกัด ให้ความสำคัญต่อความเป็นส่วนตัว เราจะทำงานอย่างดีที่สุดเพื่อรักษาความลับ และควบคุมข้อมูลส่วนบุคคลของคุณให้ปลอดภัย โดยที่คุณสามารถเลือกที่จะให้หรือไม่ให้ความยินยอมก็ได้\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_vm._v("ความยินยอมเป็นฐานข้อมูลในการวิจัยหรือจัดทำสถิติ การปรับปรุงคุณภาพของการให้บริการของบริษัทฯ "),_c('span',{staticStyle:{"color":"#8b8b8b !important","margin-bottom":"0px","font-weight":"500"}},[_vm._v("(จำเป็น)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("      3.9 ท่านสามารถแจ้งความประสงค์การดำเนินการตามข้อ 3.1 ถึงข้อ 3.8 ได้ โดยแจ้งมายัง  "),_c('a',{attrs:{"href":"mailto:noc@inet.co.th"}},[_vm._v("noc@inet.co.th")]),_vm._v(" หรือ Call center "),_c('a',{attrs:{"href":"tel:022577000"}},[_vm._v("02-257-7000")]),_vm._v(", "),_c('a',{attrs:{"href":"tel:022577111"}},[_vm._v("02-257-7111")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("      Email : "),_c('a',{attrs:{"href":"mailto:noc@inet.co.th"}},[_vm._v("noc@inet.co.th")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("      •  โทร "),_c('a',{attrs:{"href":"tel:022577000"}},[_vm._v("02-257-7000")]),_vm._v(", "),_c('a',{attrs:{"href":"tel:022577111"}},[_vm._v("02-257-7111")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("      ข้าพเจ้าตกลงยินยอมที่จะผูกพันตนเองตามข้อกำหนดและเงื่อนไขที่ปรากฏในหนังสือขอความยินยอมในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลสำหรับลูกค้าของบริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)")])])}]
var consent_C7gi50r08q6_esExports = { render: consent_C7gi50r08q6_render, staticRenderFns: consent_C7gi50r08q6_staticRenderFns }
/* harmony default export */ var consent_consent_C7gi50r08q6 = (consent_C7gi50r08q6_esExports);
// CONCATENATED MODULE: ./src/components/consent/consent_C7gi50r08q6.vue
function consent_C7gi50r08q6_injectStyle (ssrContext) {
  __webpack_require__("/cf8")
}
var consent_C7gi50r08q6_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var consent_C7gi50r08q6___vue_template_functional__ = false
/* styles */
var consent_C7gi50r08q6___vue_styles__ = consent_C7gi50r08q6_injectStyle
/* scopeId */
var consent_C7gi50r08q6___vue_scopeId__ = "data-v-585f2d77"
/* moduleIdentifier (server only) */
var consent_C7gi50r08q6___vue_module_identifier__ = null
var consent_C7gi50r08q6_Component = consent_C7gi50r08q6_normalizeComponent(
  consent_C7gi50r08q6,
  consent_consent_C7gi50r08q6,
  consent_C7gi50r08q6___vue_template_functional__,
  consent_C7gi50r08q6___vue_styles__,
  consent_C7gi50r08q6___vue_scopeId__,
  consent_C7gi50r08q6___vue_module_identifier__
)

/* harmony default export */ var components_consent_consent_C7gi50r08q6 = (consent_C7gi50r08q6_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LoginWithSharedToken.vue


//
//
//
//
//
//
//
//
//
//
//

// import Navbar from '@/components/homepage/Navbar'




var LoginWithSharedToken__ = __webpack_require__("M4fF");
var LoginWithSharedToken_Centrifuge = __webpack_require__("9wbP");
var LoginWithSharedToken_centrifuge = new LoginWithSharedToken_Centrifuge("wss://uatchat-manage.one.th/connection/websocket");
/* harmony default export */ var LoginWithSharedToken = ({
  data: function data() {
    return {
      newConsentDialog: false,
      newConsentDetail: {},
      url_consent: '',
      consentOnechatDialog: false,
      progress: true,
      code: '',
      status: '',
      passlogin: '',
      shared_token: ''
    };
  },

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  created: function created() {
    this.shared_token = this.$route.query.shared_token;
    if (this.shared_token) {
      this.loginWithSharetoken(this.shared_token);
    } else {
      console.log('error: access_denied');
      this.$router.push('/login');
    }
  },

  methods: {
    closeNewConsent: function closeNewConsent(value) {
      console.log("close new consent", value);
      this.newConsentDialog = value.close;
      this.newConsentDetail = {};
      // set localStorage authorization
      this.progress = true;
      localStorage.setItem('Authenrization', services["b" /* Encode */].encode({ 'tokenuser': value.token, 'status_login': 'T', 'type_user': 'user' }));
      if (localStorage.getItem('botid_redirect') !== null) {
        this.progress = false;
        this.searchFriend(localStorage.getItem('botid_redirect'));
      } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
        this.progress = false;
        // redirect bot room with url
        var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
        this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + '&url=' + data.url);
      } else {
        this.progress = false;
        // console.log(`this.isMobile(): ${this.isMobile()}`)
        if (window.innerWidth <= 960) {
          this.$router.push('/mobile/homepage');
        } else {
          this.$router.push('/chat');
        }
      }
    },
    closeDialogConsentOnechat: function closeDialogConsentOnechat(value) {
      this.consentOnechatDialog = value;
    },
    connectCentrifuge: function connectCentrifuge(token) {
      var me = this;
      var events = '';
      var data_msg = '';
      LoginWithSharedToken_centrifuge.setToken('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs');
      LoginWithSharedToken_centrifuge.subscribe(token, function (message) {
        console.log(message.data.event);
        events = message.data.event;
        if (events === 'consent') {
          // consent close dialog
          me.consentOnechatDialog = false;
          me.getOnechatToken(token);
        }
      });
      LoginWithSharedToken_centrifuge.on('connect', function () {
        console.log("connected centrifuge authen login");
      });
      LoginWithSharedToken_centrifuge.on('disconnect', function () {
        console.log("disconnected centrifuge authen login");
      });
      LoginWithSharedToken_centrifuge.connect();
    },
    getOnechatToken: function getOnechatToken(token) {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var hour = String(today.getHours() + 1).padStart(2, '0');
      var minute = String(today.getMinutes()).padStart(2, '0');
      var seconds = String(today.getSeconds()).padStart(2, '0');
      var milsec = today.getMilliseconds();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00';
        dd = String(today.getDate() + 1).padStart(2, '0');
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1';
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1';
            yyyy = today.getFullYear() + 1;
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0');
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
      // console.log(today)
      var expireddate = Date.parse(today);
      // console.log(expireddate)
      var body = services["b" /* Encode */].encodeRichmenu({ 'userid': token, 'expired_date': expireddate });
      // console.log(body)
      // console.log(body.split('=')[1]);

      // check new consent
      if (this.$cookie.get('check-consent-' + token) === null || this.$cookie.get('check-consent-' + token) === undefined) {
        // test new consent
        this.progress = false;
        this.newConsentDialog = true;
        this.newConsentDetail = { token: token };
      } else {
        this.progress = false;
        // set localStorage authorization
        localStorage.setItem('Authenrization', services["b" /* Encode */].encode({ 'tokenuser': token, 'status_login': 'T', 'type_user': 'user' }));
        if (localStorage.getItem('botid_redirect') !== null) {
          this.searchFriend(localStorage.getItem('botid_redirect'));
        } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
          // redirect bot room with url
          var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
          this.$router.push('/redirect-room?bot_token=' + data.bot_id + '&authorization=' + data.auth + '&url=' + data.url);
        } else {
          // console.log(`this.isMobile(): ${this.isMobile()}`)
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage');
          } else {
            this.$router.push('/chat');
          }
        }
      }

      // this.axios.post(process.env.APIgo_api + `/v1/get-consent`, { onechat_token: body }).then((response) => {
      //   // console.log(response.data)
      //   if (response.data.status === 'success') {
      //     this.progress = false
      //     if (response.data.data.consent_check === 'true') {
      //       this.progress = false
      //       // set localStorage authorization
      //       localStorage.setItem('Authenrization', Encode.encode({'tokenuser': token, 'status_login': 'T', 'type_user': 'user'}))
      //       if (localStorage.getItem('botid_redirect') !== null) {
      //         this.searchFriend(localStorage.getItem('botid_redirect'))
      //       } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
      //         // redirect bot room with url
      //         var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
      //         this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
      //       } else {
      //         if (window.innerWidth <= 960) {
      //           this.$router.push('/mobile/homepage')
      //         } else {
      //           this.$router.push('/chat')
      //         }
      //       }
      //     } else {
      //       // console.log('consentOnechatDialog: ', this.consentOnechatDialog)
      //       // show dialog consent
      //       this.consentOnechatDialog = true
      //       this.url_consent = response.data.data.consent_url
      //       // clear localStorage autherization
      //       console.log('dialog: ', this.consentOnechatDialog)
      //       // console.log('url: ', this.url_consent)
      //       // localStorage.setItem('Authenrization', Encode.encode({'tokenuser': token, 'status_login': 'F', 'type_user': 'user'}))
      //       localStorage.removeItem('Authenrization')
      //       // this.$router.push({path: '/login', force: true})
      //     }
      //   }
      // }).catch(err => {
      //   console.log(err)
      //   this.progress = false
      // })
    },
    loginWithSharetoken: function loginWithSharetoken(token) {
      var _this = this;

      this.progress = true;
      var source = {
        shared_token: token
      };
      this.axios.post("https://uatchat-manage.one.th/manage" + '/login_sharedtoken', source).then(function (response) {
        _this.status = response.data['status'];
        _this.progress = false;
        if (_this.status === 'success') {
          var profile = response.data['account']['profile'];
          _this.myprofilepicture = profile['profilepicture'];
          _this.myname = profile['name'];
          _this.$i18n.locale = _this.$cookie.get('language') ? _this.$cookie.get('language') : 'th';
          localStorage.setItem('Authenrization', services["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
          localStorage.setItem('profilepicture', profile['profilepicture']);
          localStorage.setItem('name', profile['name']);
          localStorage.setItem('phone', profile['phone']);
          localStorage.setItem('email', profile['email']);
          localStorage.setItem('status', profile['status']);
          localStorage.setItem('type_user', profile['type']);
          localStorage.setItem('wallpaperInfo', stringify_default()({
            'info': [{
              'room': '',
              'background': ''
            }]
          }));
          _this.progress = false;
          // connect centrifuge
          _this.connectCentrifuge(profile['tokenuser']);
          if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
            _this.getOnechatToken(profile['tokenuser']);
          } else {
            _this.$router.push(localStorage.getItem('pathRoom'));
          }
        } else {
          _this.$cookie.set('status_login', 'F');
          _this.progress = false;
          if (response.data['message'] === 'The request is missing a required parameter, includes an invalid parameter value, includes a parameter more than once, or is otherwise malformed.') {
            _this.logout();
          } else {
            _this.$router.push('/not_found');
          }
        }
      }, function (error) {
        console.log(error);
        _this.status = 'fail';
        _this.progress = false;
        _this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.';
      });
    },
    logout: function logout() {
      localStorage.clear();
      var logouturl = this.$cookie.get('logouturl');
      if (true) {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent');
          this.$cookie.delete('logouturl');
        } else {
          window.open("https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage", '_parent');
        }
      } else {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent');
          this.$cookie.delete('logouturl');
        } else {
          this.$router.push({ path: '/login', force: true });
        }
      }
    },
    searchFriend: function searchFriend(botid) {
      var _this2 = this;

      var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend", {
        tokenbot: botid,
        tokenuser: decoded.tokenuser
      }).then(function (response) {
        // console.log(response.data.listuser)
        if (response.data.listuser.length === 0) {
          localStorage.removeItem('botid_redirect');
          if (window.innerWidth <= 960) {
            _this2.$router.push('/mobile/homepage');
          } else {
            _this2.$router.push('/chat');
          }
        } else {
          if (response.data.listuser.relation === 'friend') {
            localStorage.removeItem('botid_redirect');
            if (window.innerWidth <= 960) {
              _this2.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom);
            } else {
              _this2.$router.push('/chat/room/' + response.data.listuser.user.tokenroom);
            }
          } else {
            console.log('not friend');
            _this2.$router.push('/addbot/' + localStorage.getItem('botid_redirect'));
          }
        }
      }).catch(function (error) {
        console.log(error);
        localStorage.removeItem('botid_redirect');
        if (window.innerWidth <= 960) {
          _this2.$router.push('/mobile/homepage');
        } else {
          _this2.$router.push('/chat');
        }
      });
    }
  },
  components: {
    // Navbar,
    checkconsentOnechatDialog: consent_onechat_dialog["a" /* default */],
    newConsent: new_consent["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c39c93e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginWithSharedToken.vue
var LoginWithSharedToken_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"CSChatThai",staticStyle:{"overflow-y":"hidden","background":"white"},attrs:{"id":"inspire"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[(_vm.progress)?_c('v-progress-circular',{staticStyle:{"margin":"auto"},attrs:{"size":150,"width":10,"indeterminate":"","color":"blue"}}):_vm._e(),_vm._v(" "),_c('checkconsentOnechatDialog',{attrs:{"url_consent":_vm.url_consent,"consentOnechatDialog":_vm.consentOnechatDialog},on:{"closeDialogConsentOnechat":_vm.closeDialogConsentOnechat}}),_vm._v(" "),_c('newConsent',{attrs:{"newConsentDialog":_vm.newConsentDialog,"newConsentDetail":_vm.newConsentDetail},on:{"closeNewConsent":_vm.closeNewConsent}})],1)],1)}
var LoginWithSharedToken_staticRenderFns = []
var LoginWithSharedToken_esExports = { render: LoginWithSharedToken_render, staticRenderFns: LoginWithSharedToken_staticRenderFns }
/* harmony default export */ var components_LoginWithSharedToken = (LoginWithSharedToken_esExports);
// CONCATENATED MODULE: ./src/components/LoginWithSharedToken.vue
function LoginWithSharedToken_injectStyle (ssrContext) {
  __webpack_require__("sD5H")
}
var LoginWithSharedToken_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LoginWithSharedToken___vue_template_functional__ = false
/* styles */
var LoginWithSharedToken___vue_styles__ = LoginWithSharedToken_injectStyle
/* scopeId */
var LoginWithSharedToken___vue_scopeId__ = "data-v-0c39c93e"
/* moduleIdentifier (server only) */
var LoginWithSharedToken___vue_module_identifier__ = null
var LoginWithSharedToken_Component = LoginWithSharedToken_normalizeComponent(
  LoginWithSharedToken,
  components_LoginWithSharedToken,
  LoginWithSharedToken___vue_template_functional__,
  LoginWithSharedToken___vue_styles__,
  LoginWithSharedToken___vue_scopeId__,
  LoginWithSharedToken___vue_module_identifier__
)

/* harmony default export */ var src_components_LoginWithSharedToken = (LoginWithSharedToken_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js


// import HelloWorld from '@/components/HelloWorld'

// homepage










// layout chat





// pagedefault



// settings







// mobile layout






// mobile settings










// mobile mange










// test




// tasks





// tasks Mobile





// import TestLayoutMo from '@/components/mobile/layout/TestLayout'
//service

// relation_friend with bot


//conference

// agora_call


// import AgroraTestCall from '@/components/chat/agora_call/test_call'
// redirect url to chatroom






// login with sharetoken


vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{ path: '/', component: components_homepage_Home }, { path: '/custsat', component: components_custsat_custsat }, { path: '/homepage', component: components_homepage_Home }, { path: '/test', component: src_components_test }, { path: '/test2', component: src_components_test2 }, { path: '/test3', component: src_components_test3 }, { path: '/redirect', component: src_components_redirecttest }, { path: '/authorization/redirect', component: src_components_authenCallbackOneid }, { path: '/login', component: components_homepage_Login, meta: { requiresHome: true } }, { path: '/login-with-shared-token', component: src_components_LoginWithSharedToken }, { path: '/download', component: components_homepage_Download }, { path: '/register', component: components_homepage_RegisterPhone }, { path: '/about', component: components_homepage_Aboutuspage }, { path: '/policy', component: components_homepage_Policy }, { path: '/contactus', component: components_homepage_Contact }, { path: '/qrcode/:type', component: src_components_qrcodeRedirect }, { path: '/redirect-addfriend', component: components_homepage_redirect_addfriend }, { path: '/service/:type', component: src_components_qrcodeRedirect }, { path: '/not_found', component: chat_pagedefault_NotFound }, { path: '/redirect_service/:serviceinfor', component: components_homepage_RedirectService }, { path: '/check-consent/:tokenroom', component: components_homepage_Check_consent }, { path: '/relation', component: components_homepage_Relation_login }, { path: '/relation/friend', component: components_homepage_Relation_friend }, { path: '/redirect/chatroom/:botid', component: components_homepage_RedirectChatRoom }, { path: '/redirect-room', component: components_homepage_RedirectUrlRoom }, { path: '/weburl-go-room', component: src_components_RedirectRoomWithUrl }, { path: '/redirect-room-sharetoken', component: src_components_RedirectRoomWithSharedToken }, { path: '/addbot/:botid', component: components_homepage_AddBot }, { path: '/conference/auth',
    component: components_conference_layoutConference
    // children: []
  }, { path: '/chat/room/call/:typecall', component: chat_agora_call_video_call_v3 }, { path: '/chat/room/testcall/:typecall', component: chat_agora_call_video_call_v4 },
  // { path: '/chat/room/call/:typecall/:roomid', component: AgroraCall },
  // { path: '/chat/room/test/call/:roomid', component: AgroraTestCall },
  { path: '/chat',
    component: chat_layout_Layout,
    children: [{ path: '/anonymousone_group', component: chat_layout_anonymousone_group }, { path: '/chat', component: chat_pagedefault_HomepageChat }, { path: '/chat/not_found', component: chat_pagedefault_NotFound }, { path: '/chat/not_permission', component: chat_pagedefault_NotPermission }, { path: '/chat/room/:roomid', component: chat_layout_LayoutChat }, { path: '/chat/settings/profile', component: chat_settings_EditProfile }, { path: '/chat/settings/uploadfile/onebox', component: chat_settings_Dropfile }, { path: '/chat/settings/feedback', component: chat_settings_Feedback }, { path: '/chat/settings/support', component: components_chat_settings_Contact }, { path: '/chat/settings/policy', component: chat_settings_Policy }, { path: '/chat/settings/terms_of_service', component: chat_settings_terms_of_service }, { path: '/chat/settings/managefriend', component: chat_settings_Managefriend }, { path: '/chat/task/:projectid/:roomid', component: chat_manage_task_homepage_task }, { path: '/chat/room/project/:roomid', component: chat_manage_task_homepage_project }, { path: '/chat/project/all_project', component: chat_manage_task_homepage_all_project }, { path: '/chat/project/create_project', component: chat_manage_task_homepage_created_project }, { path: '/chat/project/calendar', component: chat_manage_task_homepage_calendar }, { path: '/chat/service/market', component: components_service_market }, { path: '/onemeeting', component: chat_onemeet_LayoutOnemeet }, { path: '/onemeet/chat/:roomid', component: chat_onemeet_ChatSideOnemeet }],
    meta: { requiresLogin: true }
  }, { path: '/layoutmobile',
    component: mobile_layout_LayoutMobile,
    children: [{ path: '/mobile/homepage', component: mobile_layout_LeftSideMobileTest }, { path: '/mobile/room/:roomid', component: mobile_layout_LayoutChatMobile }, { path: '/mobile/room/infor/:roomid', component: mobile_layout_RightSideMobile }, { path: '/mobile/settings/profile', component: mobile_settings_Editprofile }, { path: '/mobile/settings/profile/editphone', component: mobile_settings_EditPhoneMo }, { path: '/mobile/settings/feedback', component: src_components_mobile_settings_Feedback }, { path: '/mobile/settings/support', component: src_components_mobile_settings_Contact }, { path: '/mobile/settings/policy', component: src_components_mobile_settings_Policy }, { path: '/mobile/settings/terms_of_service', component: mobile_settings_TermsofService }, { path: '/mobile/settings/uploadfile/onebox', component: mobile_settings_Sendfileonebox }, { path: '/mobile/settings/managefriend', component: src_components_mobile_settings_Managefriend }, { path: '/mobile/settings/anonymousone_group', component: mobile_settings_Anonymousone }, { path: '/mobile/settings/languages', component: mobile_settings_Languages }, { path: '/mobile/addfriend', component: mobile_manage_Addfriend }, { path: '/mobile/creategroup', component: mobile_manage_Creategroup }, { path: '/mobile/forward/:roomid', component: mobile_manage_Forwardmessage }, { path: '/mobile/profilefriend/:profileid', component: mobile_manage_Profilefriend }, { path: '/mobile/qrcode', component: mobile_manage_Qrcodepage }, { path: '/mobile/task/project', component: mobile_task_homepage_all_project_mo }, { path: '/mobile/task/:projectid/:roomid', component: mobile_task_homepage_task_mo }, { path: '/mobile/room/project/:roomid', component: mobile_task_homepage_project_mo }, { path: '/mobile/task/calendar', component: mobile_task_homepage_calendar_mo }, { path: '/mobile/task/createproject', component: mobile_task_create_project_page_mo }, { path: '/mobile/wallpaper/:roomid', component: mobile_manage_Wallpaper }, { path: '/mobile/progress/:roomid', component: mobile_layout_ProgressLayout
      // { path: '/mobile/testlayout', component: TestLayoutMo }
    }],
    meta: { requiresLogin: true }
  }, {
    path: '/consent',
    component: components_consent_consent,
    children: [{ path: 'C7gi50r08q6', component: components_consent_consent_C7gi50r08q6 }]
    // meta: {requiresLogin: true}
  }, { path: '*', redirect: '/' }]
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (x) {
    return x.meta.requiresLogin;
  })) {
    if (localStorage.getItem('Authenrization') == undefined) {
      next({ path: '/login' });
    } else {
      next();
    }
    return;
  } else if (to.matched.some(function (x) {
    return x.meta.requiresHome;
  })) {
    if (localStorage.getItem('Authenrization') == undefined) {
      next();
    } else {
      next({ path: '/chat/homepage' });
    }
    return;
  }
  next();
});
/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-axios/dist/vue-axios.min.js
var vue_axios_min = __webpack_require__("Rf8U");
var vue_axios_min_default = /*#__PURE__*/__webpack_require__.n(vue_axios_min);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.min.css
var vuetify_min = __webpack_require__("7zck");
var vuetify_min_default = /*#__PURE__*/__webpack_require__.n(vuetify_min);

// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__("xNPZ");
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);

// EXTERNAL MODULE: ./node_modules/vue-sweetalert2/src/index.js
var vue_sweetalert2_src = __webpack_require__("oYt9");

// EXTERNAL MODULE: ./node_modules/vue-clipboard2/vue-clipboard.js
var vue_clipboard = __webpack_require__("wvfG");
var vue_clipboard_default = /*#__PURE__*/__webpack_require__.n(vue_clipboard);

// EXTERNAL MODULE: ./node_modules/vue-socket.io/dist/build.js
var build = __webpack_require__("hMcO");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// EXTERNAL MODULE: ./node_modules/vue-qr/dist/vue-qr.js
var vue_qr = __webpack_require__("PUIo");
var vue_qr_default = /*#__PURE__*/__webpack_require__.n(vue_qr);

// EXTERNAL MODULE: ./node_modules/vue2-google-maps/dist/main.js
var main = __webpack_require__("sA6N");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./static/fonts/Kanit/stylesheet.css
var stylesheet = __webpack_require__("yQDo");
var stylesheet_default = /*#__PURE__*/__webpack_require__.n(stylesheet);

// EXTERNAL MODULE: ./static/fonts/CSChatThai/stylesheet.css
var CSChatThai_stylesheet = __webpack_require__("Qmlu");
var CSChatThai_stylesheet_default = /*#__PURE__*/__webpack_require__.n(CSChatThai_stylesheet);

// EXTERNAL MODULE: ./node_modules/vue-qrcode-reader/dist/VueQrcodeReader.umd.min.js
var VueQrcodeReader_umd_min = __webpack_require__("ikHa");
var VueQrcodeReader_umd_min_default = /*#__PURE__*/__webpack_require__.n(VueQrcodeReader_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-cookie/src/vue-cookie.js
var vue_cookie = __webpack_require__("K/Lq");
var vue_cookie_default = /*#__PURE__*/__webpack_require__.n(vue_cookie);

// EXTERNAL MODULE: ./node_modules/vue-read-more/index.js + 1 modules
var vue_read_more = __webpack_require__("uIjV");

// EXTERNAL MODULE: ./node_modules/@ashwamegh/vue-link-preview/dist/vuelinkpreview.esm.js
var vuelinkpreview_esm = __webpack_require__("nPZZ");

// EXTERNAL MODULE: ./node_modules/vue-headful/dist/vue-headful.js
var vue_headful = __webpack_require__("WiKS");
var vue_headful_default = /*#__PURE__*/__webpack_require__.n(vue_headful);

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// EXTERNAL MODULE: ./src/plugins/en.json
var en = __webpack_require__("j0Qy");
var en_default = /*#__PURE__*/__webpack_require__.n(en);

// EXTERNAL MODULE: ./src/plugins/th.json
var th = __webpack_require__("YyZ0");
var th_default = /*#__PURE__*/__webpack_require__.n(th);

// EXTERNAL MODULE: ./src/plugins/cn.json
var cn = __webpack_require__("sSr1");
var cn_default = /*#__PURE__*/__webpack_require__.n(cn);

// CONCATENATED MODULE: ./src/plugins/lang.js




var defaultLocale = 'th';

var languages = {
  en: en_default.a,
  th: th_default.a,
  cn: cn_default.a
};
// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















// import '../static/fonts/Athiti/stylesheet.css'
// import '../static/fonts/Poppins/stylesheet.css'
// import '../static/fonts/THSarabun/stylesheet.css'

// import '../static/fonts/Maitree/stylesheet.css'




// import * as firebase from "firebase/app";
// import "firebase/firestore";
// import "firebase/analytics";


vue_esm["default"].use(vue_hls_player_default.a);

// import VueI18n from 'vue-i18n'
// import { i18n } from '../static/dictionary/lang.js'
// import i18n from '@/plugins/lang.js'

vue_esm["default"].use(vue_i18n_esm["a" /* default */]);



var messages = assign_default()(languages);

// const firebaseConfig = {
//   apiKey: "AIzaSyDliKV5rvjsLNNK_AxSrcRl5sDUMS_hQF8",
//   authDomain: "onechat-de3fe.firebaseapp.com",
//   databaseURL: "https://onechat-de3fe.firebaseio.com",
//   projectId: "onechat-de3fe",
//   storageBucket: "onechat-de3fe.appspot.com",
//   messagingSenderId: "501136854127",
//   appId: "1:501136854127:web:5b2629b97804c79169919a",
//   measurementId: "G-95176H8WVQ"
// };
// Initialize Firebase
// const init = firebase.initializeApp(firebaseConfig);
// const analytic = firebase.analytics();
// analytic.logEvent('notification_received');
// analytic.logEvent('goal_completion', { name: 'lever_puzzle'});

// firebase.initializeApp(firebaseConfig);
// firebase.analytics();

vue_esm["default"].config.productionTip = false;
vue_esm["default"].config.devtools = true;
vue_esm["default"].config.performance = true;
// alias
// Vue.prototype.$analytics = firebase.analytics()


// Vue.use(VueI18n)
// Vue.component('vue-headful', vueHeadful)
vue_esm["default"].use(vue_headful_default.a);
vue_esm["default"].use(vue_read_more["a" /* default */]);
vue_esm["default"].use(vue_cookie_default.a);
vue_esm["default"].use(VueQrcodeReader_umd_min_default.a);
vue_esm["default"].use(vuetify_default.a);
vue_esm["default"].use(vue_qr_default.a);
vue_esm["default"].use(vue_axios_min_default.a, axios_default.a);
vue_esm["default"].use(moment_default.a);
vue_esm["default"].use(moment_timezone_default.a);
vue_esm["default"].use(vue_sweetalert2_src["a" /* default */]);
vue_esm["default"].use(vue_clipboard_default.a);
vue_esm["default"].use(build_default.a, "https://uatchat-public.one.th:8998");
vue_esm["default"].use(main, {
  load: {
    placeid: 'ChIJ4ZnvKX274jARFsZN_d404sI',
    key: 'AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic',
    libraries: 'places' // necessary for places input
  }
});

vue_esm["default"].use(vuelinkpreview_esm["a" /* default */]);

// const i18n = new VueI18n({
//   locale: 'en', // set locale
//   messages, // set locale messages
// })

// Vue.config.productionTip = false

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: defaultLocale,
  fallbackLocale: 'th',
  messages: messages
});

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: src_router,
  store: store,
  i18n: i18n,
  components: { App: src_App },
  template: '<App/>'
}).$mount('#app');

/***/ }),

/***/ "NgZZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nnh+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O5wB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chenfengyuan_vue_countdown__ = __webpack_require__("aCbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chenfengyuan_vue_countdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__chenfengyuan_vue_countdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_homepage_Navbar__ = __webpack_require__("6n5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_pathify__ = __webpack_require__("YtWf");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import NewFooter from '@/components/home/NewFooter'
// import Vue from 'vue'


// import VueSocketio from 'vue-socket.io'
var _ = __webpack_require__("M4fF");
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_2__chenfengyuan_vue_countdown___default.a.name, __WEBPACK_IMPORTED_MODULE_2__chenfengyuan_vue_countdown___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      usernameRules: [function (v) {
        return _this.regular_username_mobile();
      }],
      passwordRules: [function (v) {
        return _this.regular_pass_mobile();
      }],
      valid: '',
      username: '',
      password: '',
      status: '',
      friend: '',
      status_login: '',
      progress: false,
      failmessage: 'ชื่อผู้ใช้งาน หรือ รหัสผ่าน ไม่ถูกต้อง',
      webdev: "https://uatchat.one.th:8089/docs",
      showPassword: false,
      url_redirect: "https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect",
      validmobile: '',
      type: 'first',
      phone: '',
      otpCode: '',
      Refcode: '',
      mobile_ref_id: '',
      type_otp: '',
      counting: false,
      loading: false,
      state_login: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex_pathify__["c" /* sync */])('*')),
  created: function created() {
    // if (localStorage.getItem('Authenrization')) {
    //   this.status_login = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))['status_login']
    //   // console.log(this.status_login)
    //   if (this.status_login === 'T') {
    //     if (this.isMobile()) {
    //       this.$router.push('/mobile/homepage')
    //     } else {
    //       this.$router.push('/chat')
    //     }
    //   }
    // } else {
    // }
    if (localStorage.getItem('state_login')) {
      this.status_login = localStorage.getItem('state_login');
      if (this.status_login === 'T') {
        this.$router.push('/relation/friend');
      } else {
        this.$router.push('/relation');
      }
    }
  },

  methods: {
    handleCountdownEnd: function handleCountdownEnd() {
      this.OTP = '';
      this.counting = false;
    },
    open_link: function open_link(link) {
      window.open(link, '_blank');
    },
    otp: function otp() {
      var _this2 = this;

      this.loading = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/otp_login_and_regis', { phone: this.phone, type: 'login' }).then(function (response) {
        if (response.data['status'] === 'success') {
          // console.log(response.data)
          if (response.data.type_otp == 'login') {
            _this2.loading = false;
            _this2.Refcode = response.data.refcode;
            _this2.mobile_ref_id = response.data.mobile_ref_id;
            _this2.type_otp = response.data.type_otp;
            _this2.counting = true;
            _this2.type = "otp";
          } else {
            _this2.loading = false;
            _this2.phone = '';
            _this2.$swal('ขออภัย!', 'หมายเลขโทรศัพท์นี้ยังไม่ได้รับการลงทะเบียน กรุณาลงทะเบียนหรือกรอกหมายเลขโทรศัพท์อื่น', 'error');
          }
        }
      }, function (error) {
        console.log(error);
        _this2.status = 'fail';
        _this2.progress = false;
        _this2.type = 'first';
        _this2.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.';
      });
    },
    loginWithotp: function loginWithotp() {
      var _this3 = this;

      this.progress = true;
      var source = { type_otp: this.type_otp, phone: this.phone, otp: this.otpCode, mobile_ref_id: this.mobile_ref_id };
      this.axios.post("https://uatchat-manage.one.th/manage" + '/login_and_regis', source).then(function (response) {
        _this3.status = response.data['status'];
        // console.log(response.data)
        if (_this3.status === 'success') {
          var profile = response.data['account']['profile'];
          _this3.myprofilepicture = profile['profilepicture'];
          _this3.myname = profile['name'];
          _this3.$cookie.set('language', 'th');
          localStorage.setItem('Authenrization', __WEBPACK_IMPORTED_MODULE_4__services__["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
          localStorage.setItem('profilepicture', profile['profilepicture']);
          localStorage.setItem('name', profile['name']);
          localStorage.setItem('phone', profile['phone']);
          localStorage.setItem('email', profile['email']);
          localStorage.setItem('status', profile['status']);
          localStorage.setItem('type_user', profile['type']);
          if (profile['username'] === '' || profile['username'] === 'None') {
            localStorage.setItem('status_username', 'false');
          } else {
            localStorage.setItem('status_username', 'true');
          }
          _this3.progress = false;
          if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
            _this3.$router.push('/relation/friend');
          } else {
            _this3.$router.push(localStorage.getItem('pathRoom'));
          }
        } else {
          _this3.$cookie.set('status_login', 'F');
          _this3.progress = false;
          _this3.$swal('ขออภัย!', 'กรอกรหัส OTP ไม่ถูกต้อง', 'error');
        }
      }, function (error) {
        console.log(error);
        _this3.status = 'fail';
        _this3.progress = false;
        _this3.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.';
      });
    },
    loginRedirect: function loginRedirect() {
      this.progress = true;
      window.open(this.url_redirect, '_parent');
    },
    redirectUrl: function redirectUrl(url) {
      try {
        var link = document.getElementById("iframename").contentWindow.location.href;
        // console.log(link)
        // console.log(_.includes(link, [process.env.redirect_url]))
        if (_.includes(link, ["https://uatchat.one.th/authorization/redirect"])) {
          window.open(link + '&passlogin=true', '_parent');
        }
      } catch (err) {
        console.log(err);
      }
    },
    regular_username_mobile: function regular_username_mobile() {
      // var str = this.username
      this.username = this.username.replace(/[^a-z-0-9@.]/i, '');
      this.username = this.username.toLowerCase();
    },
    regular_pass_mobile: function regular_pass_mobile() {
      this.password = this.password.replace(/^[ก-๛]+/i, '');
    },
    isNumandaz: function isNumandaz($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122) && keyCode != 46 && keyCode != 64) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    isnotthai: function isnotthai($event) {
      // console.log($event)
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // console.log(keyCode)
      if (keyCode >= 3585 && keyCode <= 3642 || keyCode >= 3647 && keyCode <= 3675) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    toNewTab: function toNewTab() {
      window.open(this.webdev, '_parent').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    isMobile: function isMobile() {
      if ($('#mobile').is(':hidden')) {
        return false;
      } else {
        return true;
      }
    },
    login: function login() {
      var _this4 = this;

      var addyear = 10;
      var newDate = new Date();
      newDate.setTime(newDate.getTime() + addyear * 365 * 24 * 60 * 60 * 1000);
      var expiresInTime = "expires=" + newDate.toUTCString();

      if (this.username === '' || this.password === '') {
        this.failmessage = 'กรุณากรอกชื่อผู้ใช้งานและรหัสผ่าน.';
      } else {
        this.progress = true;
        var source = __WEBPACK_IMPORTED_MODULE_4__services__["b" /* Encode */].encode({ 'username': this.username, 'password': this.password });
        this.axios.post("https://uatchat-manage.one.th/manage" + '/loginuserwithbusiness', { source: source }).then(function (response) {
          _this4.status = response.data['status'];
          if (_this4.status === 'success') {
            var profile = response.data['account']['profile'];
            _this4.myprofilepicture = profile['profilepicture'];
            _this4.myname = profile['name'];
            _this4.$cookie.set('language', 'th');
            localStorage.setItem('Authenrization', __WEBPACK_IMPORTED_MODULE_4__services__["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
            localStorage.setItem('profilepicture', profile['profilepicture']);
            localStorage.setItem('name', profile['name']);
            localStorage.setItem('phone', profile['phone']);
            localStorage.setItem('email', profile['email']);
            localStorage.setItem('status', profile['status']);
            localStorage.setItem('type_user', profile['type']);
            localStorage.setItem('state_login', 'T');
            if (profile['username'] === '' || profile['username'] === 'None') {
              localStorage.setItem('status_username', 'false');
            } else {
              localStorage.setItem('status_username', 'true');
            }
            _this4.progress = false;
            if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
              // console.log(this.isMobile())
              // if (this.isMobile()) {
              //   this.$router.push('/mobile/homepage')
              // } else {
              //   this.$router.push('/chat')
              // }
              _this4.$router.push('/relation/friend');
            } else {
              _this4.$router.push(localStorage.getItem('pathRoom'));
            }
          } else {
            localStorage.getItem('state_login', 'F');
            _this4.$cookie.set('status_login', 'F');
            _this4.progress = false;
            if (response.data['message'] === 'Wrong Username / Password') {
              _this4.failmessage = 'ชื่อผู้ใช้งานหรือรหัสผ่านผิด กรุณาตรวจสอบใหม่อีกครั้ง.';
            } else {
              _this4.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.';
            }
          }
        }, function (error) {
          console.log(error);
          _this4.status = 'fail';
          _this4.progress = false;
          _this4.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.';
        });
      }
    }
  },
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_3__components_homepage_Navbar__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "OCah":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_chat/ApproveDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ApproveDialog = ({
  props: { dialogApprove: false, ApproveDetail: {} },
  data: function data() {
    return {};
  },
  watch: {
    socketdisableapprove: function socketdisableapprove(data) {
      if (data.tokenroom === this.$route.params.roomid && data.tokenmessage === this.ApproveDetail.tokenmessage) {
        this.ApproveDetail.disable = 'true';
      }
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeApprove', false);
    },
    sendansApprove: function sendansApprove(item) {
      this.$emit('sendansApprove', item, this.ApproveDetail.tokenmessage);
      this.closeDialog();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e3b7b5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_chat/ApproveDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"max-width":"500px","persistent":"","max-height":"500px"},model:{value:(_vm.dialogApprove),callback:function ($$v) {_vm.dialogApprove=$$v},expression:"dialogApprove"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-toolbar',{staticStyle:{"background":"white !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"CSChatThai",staticStyle:{"color":"#2562ae !important"}},[_vm._v(" "+_vm._s(_vm.ApproveDetail.info_ans[0].title)+"\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"#2562ae !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),(_vm.ApproveDetail.disable === 'false')?_c('v-card-text',{staticStyle:{"padding":"10px","padding-top":"5px","padding-left":"0px"}},[_c('v-container',{staticStyle:{"padding-top":"0px"},attrs:{"wrap":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","wrap":""}},[(_vm.ApproveDetail.info_ans[0].image)?_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('img',{staticClass:"alligator-turtle",staticStyle:{"height":"20vh"},attrs:{"src":_vm.ApproveDetail.info_ans[0].image}})]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('p',[_vm._v(_vm._s(_vm.$t('Dialog.approve.detail'))+" : ")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-container',{staticClass:"scroll-y CSChatThai",staticStyle:{"height":"20vh","margin-top":"0","width":"90%","padding":"0"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.ApproveDetail.info_ans[0].detail.replace(/(?:\r\n|\r|\n)/g, '<br>'))}})])],1)],1)],1)],1):_c('v-card-text',{staticStyle:{"padding":"10px","padding-top":"5px","padding-left":"0px"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('v-icon',{staticStyle:{"color":"#757575 !important","font-size":"80px !important"}},[_vm._v("error_outline")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"font-size":"17px","color":"#757575"}},[_vm._v(_vm._s(_vm.$t('Dialog.approve.answer')))])],1)]),_vm._v(" "),(_vm.ApproveDetail.disable === 'false')?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_vm._l((_vm.ApproveDetail.info_ans[0].choice),function(item,index){return _c('div',{staticStyle:{"margin-left":"15px"}},[(item.type=='cancel')?_c('v-btn',{staticStyle:{"text-transform":"none","border":"1px solid","border-radius":"15px"},attrs:{"color":"red","flat":""},on:{"click":function($event){_vm.sendansApprove(item)}}},[_vm._v(_vm._s(item.label))]):_c('v-btn',{staticStyle:{"text-transform":"none","border":"1px solid","border-radius":"15px"},attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.sendansApprove(item)}}},[_vm._v(_vm._s(item.label))])],1)})],2):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var manage_chat_ApproveDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_chat/ApproveDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("tlbM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73e3b7b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ApproveDialog,
  manage_chat_ApproveDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_manage_chat_ApproveDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OWfu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P/6R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "POKh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-resize-sensor/src/resize-sensor.vue
//
//
//
//
//
//



/* harmony default export */ var resize_sensor = ({

	// thanks to https://github.com/marcj/css-element-queries
	props: {
		initial: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			size: {
				width: -1,
				height: -1
			}
		};
	},
	methods: {
		reset: function () {

			var expand = this.$el.firstChild;
			var shrink = this.$el.lastChild;
			expand.scrollLeft = 100000;
			expand.scrollTop = 100000;
			shrink.scrollLeft = 100000;
			shrink.scrollTop = 100000;
		},
		update: function () {

			this.size.width = this.$el.offsetWidth;
			this.size.height = this.$el.offsetHeight;
		}
	},
	watch: {
		size: {
			deep: true,
			handler: function (size) {

				this.reset();
				this.$emit('resize', { width: this.size.width, height: this.size.height });
			}
		}
	},
	render: function (create) {

		var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
		var styleChild = 'position: absolute; left: 0; top: 0;';

		return create('div', {
			style: style + 'animation-name: resizeSensorVisibility;',
			on: {
				'~animationstart': this.update
			}
		}, [create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 100000px; height: 100000px;'
		})]), create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 200%; height: 200%;'
		})])]);
	},
	beforeDestroy: function () {

		this.$emit('resize', { width: 0, height: 0 });
		this.$emit('resizeSensorBeforeDestroy');
	},
	mounted: function () {

		if (this.initial === true) this.$nextTick(this.update);

		if (this.$el.offsetParent !== this.$el.parentNode) this.$el.parentNode.style.position = 'relative';

		if ('attachEvent' in this.$el && !('AnimationEvent' in window)) {

			var onresizeHandler = function () {

				this.update();
				removeOnresizeEvent();
			}.bind(this);

			var removeOnresizeEvent = function () {

				this.$el.detachEvent('onresize', onresizeHandler);
				this.$off('resizeSensorBeforeDestroy', removeOnresizeEvent);
			}.bind(this);

			this.$el.attachEvent('onresize', onresizeHandler);
			this.$on('resizeSensorBeforeDestroy', removeOnresizeEvent);
			this.reset();
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-resize-sensor/src/resize-sensor.vue
function injectStyle (ssrContext) {
  __webpack_require__("6jRI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  resize_sensor,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_resize_sensor = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PW2i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q6Iw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q6K3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QAlu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QaDA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/NoteDialogMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var NoteDialogMobile = ({
  props: { dialogNote: false, note_id: '', status_block: String },
  data: function data() {
    return {
      datanote: { note_data: { text: 'test' } },
      tokenuser: '',
      edit: false,
      edittext: '',
      preedittext: '',
      progress: true,
      status: 'show',
      errormessage: ''
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeNote', false);
      this.edit = false;
    },
    remove: function remove() {
      var _this = this;

      this.$swal({
        type: 'warning',
        title: '<div class="CSChatThai" style="font-size: 16px;">' + this.$t('Dialog.note.deleteNote') + '</div>',
        confirmButtonColor: '#d33',
        confirmButtonText: '<div class="CSChatThai" style="font-size: 14px;">' + this.$t('AnswerQuestion.ok') + '</div>',
        cancelButtonColor: '#3085d6',
        cancelButtonText: '<div class="CSChatThai" style="font-size: 14px;">' + this.$t('AnswerQuestion.cancel') + '</div>',
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then(function (result) {
        // console.log(result.value)
        if (result.value) {
          _this.axios.post("https://uatchat-manage.one.th/manage" + '/removenote', { note_id: _this.note_id, tokenuser: _this.tokenuser }).then(function (response) {
            if (response.data.status === 'success') {
              _this.status = 'error';
              _this.errormessage = _this.$t('Dialog.note.noNote');
              _this.$emit('removeNote', _this.note_id);
              _this.closeDialog();
            } else {
              _this.$swal('Network error', _this.$t('Alert.Fail.default.networkError'), 'error');
            }
          });
        }
      });
    },
    save: function save() {
      var _this2 = this;

      this.edit = false;
      if (this.edittext !== this.preedittext) {
        this.datanote.note_data.text = this.edittext;
        this.preedittext = this.edittext;
        this.axios.post("https://uatchat-manage.one.th/manage" + '/editnote', { note_id: this.note_id, tokenuser: this.tokenuser, text: this.edittext }).then(function (response) {
          if (response.data.status === 'success') {
            // console.log(response.data)
            _this2.$emit('editNote', _this2.edittext, _this2.note_id);
          } else {
            _this2.$swal('Network error', _this2.$t('Alert.Fail.default.networkError'), 'error');
          }
        });
      }
    },
    cancel: function cancel() {
      this.edit = false;
      this.edittext = this.preedittext;
    },
    date: function date(timestamp) {
      // return Momenttime.momentdatethai(timestamp)
      if (this.$i18n.locale == 'th') {
        return services["c" /* Momenttime */].momentdatethai(timestamp);
      } else if (this.$i18n.locale == 'cn') {
        return services["c" /* Momenttime */].momentdatecn(timestamp);
      } else {
        return services["c" /* Momenttime */].momentdateen(timestamp);
      }
    },
    time: function time(timestamp) {
      return services["c" /* Momenttime */].momenttimethai(timestamp);
    },
    convert: function convert(msg) {
      var linkifyStr = __webpack_require__("nN35");
      var str = msg;
      var processedContent = linkifyStr(str);
      return processedContent;
    }
  },
  watch: {
    dialogNote: function dialogNote() {
      var _this3 = this;

      if (this.dialogNote) {
        this.datanote.note_data.text = 'test';
        this.progress = true;
        this.status = 'progress';
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getnote', { note_id: this.note_id }).then(function (response) {
          if (response.data.list_note.length !== 0) {
            _this3.status = 'show';
            _this3.progress = false;
            _this3.datanote = response.data.list_note[0];
            _this3.edittext = response.data.list_note[0].note_data.text;
            _this3.preedittext = response.data.list_note[0].note_data.text;
          } else {
            _this3.progress = false;
            _this3.status = 'error';
            _this3.errormessage = _this3.$t('Dialog.note.noNote');
          }
        });
      }
    }

    // note_id () {
    //   // console.log(this.note_id + 'dd')
    //   this.datanote.note_data.text = 'test'
    //   this.progress = true
    //   this.status = 'progress'
    //   this.axios.post(process.env.APImanage + '/getnote', {note_id: this.note_id}).then((response) => {
    //     if (response.data.list_note.length !== 0) {
    //       this.status = 'show'
    //       this.progress = false
    //       this.datanote = response.data.list_note[0]
    //       this.edittext = response.data.list_note[0].note_data.text
    //       this.preedittext = response.data.list_note[0].note_data.text
    //     } else {
    //       this.progress = false
    //       this.status = 'error'
    //       this.errormessage = 'ขออภัย!! โน๊ตนี้ถูกลบแล้ว'
    //     }
    //   })
    // }

  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e20caa22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/NoteDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden !important"},attrs:{"max-width":"500px","persistent":"","max-height":"500px"},model:{value:(_vm.dialogNote),callback:function ($$v) {_vm.dialogNote=$$v},expression:"dialogNote"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-sticky-note")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.note.headerNote')))],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.tokenuser == _vm.datanote.owner && !_vm.edit)?_c('div',[(_vm.status_block != 'block')?_c('v-menu',{attrs:{"bottom":"","offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","flat":"","row":"","wrap":""},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"15px !important"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{staticStyle:{"width":"140px"}},[_c('v-list-tile',{on:{"click":function($event){_vm.edit = !_vm.edit}}},[_c('v-icon',{staticStyle:{"font-size":"15px"}},[_vm._v("edit")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(" "+_vm._s(_vm.$t('AnswerQuestion.edit')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.remove}},[_c('v-icon',{staticStyle:{"font-size":"15px"}},[_vm._v("far fa-trash-alt")]),_vm._v("  "),_c('v-list-tile-title',{staticClass:"CSChatThai"},[_vm._v(" "+_vm._s(_vm.$t('AnswerQuestion.remove')))])],1)],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"30px"}},[(_vm.status == 'progress')?_c('v-progress-linear',{attrs:{"indeterminate":_vm.progress}}):(_vm.status == 'show')?_c('div',[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[_c('v-avatar',{staticClass:"user-photonote"},[(_vm.datanote.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.datanote.profilepicture}}):(_vm.datanote.type ==='business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.datanote.type ==='bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('p',{staticClass:"text2",staticStyle:{"font-size":"18px","padding-left":"10px","padding-top":"10px"}},[_vm._v(_vm._s(_vm.datanote.nickname))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","position":"absolute","right":"10px","color":"#5a616b !important"}},[_vm._v("\n            "+_vm._s(_vm.date(_vm.datanote.create_date))+" "+_vm._s(_vm.time(_vm.datanote.create_date))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"200px","min-height":"100px","margin-top":"10px","word-break":"break-all"}},[(_vm.edit)?_c('div',{staticStyle:{"width":"100%"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.edittext),expression:"edittext"}],staticClass:"scrolling-wrapper",staticStyle:{"width":"100%","height":"150px","background":"#1a222b12","padding":"20px"},domProps:{"value":(_vm.edittext)},on:{"input":function($event){if($event.target.composing){ return; }_vm.edittext=$event.target.value}}})]):_c('p',{domProps:{"innerHTML":_vm._s(_vm.convert(_vm.datanote.note_data.text ).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})]),_vm._v(" "),_c('div',[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{staticStyle:{"padding-right":"10px"},attrs:{"align-center":"","justify-end":"","row":"","wrap":""}},[(_vm.tokenuser == _vm.datanote.owner && _vm.edit)?_c('v-btn',{staticClass:"btncancel text-transform",attrs:{"dark":""},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[(_vm.tokenuser == _vm.datanote.owner && _vm.edit)?_c('v-btn',{staticClass:"btnallow text-transform",attrs:{"dark":""},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                ")]):_vm._e()],1)],1)],1)],1)],1):(_vm.status == 'error')?_c('div',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#757575 !important","font-size":"80px !important"}},[_vm._v("error_outline")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"font-size":"20px","color":"#757575"}},[_vm._v(" "+_vm._s(_vm.errormessage)+" ")])],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_NoteDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/NoteDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("eGFP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e20caa22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  NoteDialogMobile,
  dialog_NoteDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_NoteDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QeBL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QeVX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qmlu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qng6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qok8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RG12":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RH2/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/@xkeshi/vue-qrcode/dist/vue-qrcode.esm.js
var vue_qrcode_esm = __webpack_require__("8Vd+");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/QrcodeDialogMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




vue_esm["default"].component(vue_qrcode_esm["a" /* default */].name, vue_qrcode_esm["a" /* default */]);
/* harmony default export */ var QrcodeDialogMobile = ({
  props: { dialogQrcode: false, detail: {} },
  data: function data() {
    return {
      token: '',
      tokenuserQR: ''
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },

  computed: {},
  watch: {
    detail: function detail() {
      // this.tokenuserQR = 'https://com.oneplatform.android.onechat.group/u/' + btoa(this.detail.group_id)
      this.tokenuserQR = "https://uatchat.one.th" + '/qrcode/group?id=' + btoa(this.detail.group_id);
    }
  },
  methods: {
    Close: function Close() {
      this.$emit('closeQrcode', false);
    },
    loadqr: function loadqr() {
      var cnvs = document.getElementById('downloadqr');
      var button = document.getElementById('btn-download');
      var dataURL = cnvs.toDataURL('image/png');
      button.href = dataURL;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aa1634b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/QrcodeDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"500px","max-height":"350px"},model:{value:(_vm.dialogQrcode),callback:function ($$v) {_vm.dialogQrcode=$$v},expression:"dialogQrcode"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai",staticStyle:{"white-space":"nowrap","width":"100%","overflow":"hidden","text-overflow":"ellipsis"}},[_c('span',{staticClass:"headline CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("group")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.group.group'))+" "+_vm._s(_vm.detail.group_name)+"\n          ")],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.Close()}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',{staticClass:"header",staticStyle:{"text-overflow":"ellipsis !important","overflow":"hidden !important"}},[_vm._v(_vm._s(_vm.$t('Dialog.group.detailQrjoingroup'))+" "+_vm._s(_vm.detail.group_name))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('div',[_c('p',{staticStyle:{"justify-content":"center","display":"flex"}},[_c('qrcode',{staticStyle:{"width":"180px","height":"180px"},attrs:{"value":_vm.tokenuserQR,"id":"downloadqr"}})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('Dialog.group.detailQrcode'))+"\n              "),_c('a',{staticClass:"button",attrs:{"href":"#","id":"btn-download","download":'qrcode_group_' + _vm.detail.group_name + '.png'},on:{"click":function($event){_vm.loadqr()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.download')))])])])])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_QrcodeDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/QrcodeDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("mdMH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6aa1634b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  QrcodeDialogMobile,
  dialog_QrcodeDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_QrcodeDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S3wp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SDBt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sd8O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Se/A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Se0g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/CheckBrowserDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var CheckBrowserDialog = ({
  props: {
    checkBrowserDialog: Boolean,
    checkBrowserInfor: {}
  },
  data: function data() {
    return {
      url: '',
      payload: '',
      token: ''
    };
  },

  watch: {
    checkBrowserDialog: function checkBrowserDialog() {
      if (this.checkBrowserDialog) {
        // console.log(this.checkBrowserInfor)
        // console.log(this.checkBrowserInfor.payload)
        if (this.checkBrowserInfor.payload !== undefined || this.checkBrowserInfor.payload !== null) {
          this.url = this.checkBrowserInfor.url;
          this.payload = this.checkBrowserInfor.payload;
        } else {
          this.url = this.checkBrowserInfor.url;
        }
      }
    }
  },
  methods: {
    open_tab: function open_tab() {
      window.open(this.url, '_blank');
      if (this.checkBrowserInfor.payload !== undefined) {
        if (this.checkBrowserInfor.payload.news_id !== undefined) {
          this.saveLogNews(this.payload);
        }
      }
      this.$emit('closeCheckBrowser', false);
    },
    close_dialog: function close_dialog() {
      this.$emit('closeCheckBrowser', false);
    },
    saveLogNews: function saveLogNews(item) {
      var _this = this;

      // console.log(item)
      var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      this.token = decoded['tokenuser'];
      this.axios.get("https://uatchat-manage.one.th/go_api/api" + '/v1/getOneID/' + this.token).then(function (response) {
        var one_id = response.data.one_id;
        // console.log(one_id)
        _this.axios.post("https://news.chat.one.th/backend/api/v1/page-analytics", {
          'one_id': one_id,
          'news_id': item.news_id,
          'news_index': item.news_index.toString(),
          'page_name': item.page_name
        }).then(function (response) {
          // console.log(response)
        }).catch(function (error) {
          console.log(error);
        });
      }, function (error) {
        console.log(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e55c5c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/CheckBrowserDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"350"},model:{value:(_vm.checkBrowserDialog),callback:function ($$v) {_vm.checkBrowserDialog=$$v},expression:"checkBrowserDialog"}},[_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"font-size":"80px !important"},attrs:{"color":"#ffbb39"}},[_vm._v("fas fa-exclamation-circle")]),_vm._v(" "),_c('h3',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('Alert.CheckOpenNewTab')))])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{attrs:{"color":"#2562af","dark":"","round":""},on:{"click":function($event){_vm.open_tab()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#2562af","dark":"","round":"","outline":""},on:{"click":function($event){_vm.close_dialog()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_CheckBrowserDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/CheckBrowserDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("43GH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e55c5c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  CheckBrowserDialog,
  dialog_CheckBrowserDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var chat_dialog_CheckBrowserDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SsPv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T5eZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TMdv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UJPE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/components/chat/dialog/manage_friend/AddFriendDialog.vue + 2 modules
var AddFriendDialog = __webpack_require__("sSPP");

// EXTERNAL MODULE: ./src/components/chat/dialog/manage_group/CreateGroupDialog.vue + 1 modules
var CreateGroupDialog = __webpack_require__("sHvA");

// EXTERNAL MODULE: ./src/components/chat/dialog/manage_group/ShowFriendDialog.vue + 1 modules
var ShowFriendDialog = __webpack_require__("pZ8M");

// EXTERNAL MODULE: ./src/components/chat/dialog/CheckBrowserDialog.vue + 2 modules
var CheckBrowserDialog = __webpack_require__("Se0g");

// EXTERNAL MODULE: ./src/components/chat/dialog/consent/consent_onechat_dialog.vue + 2 modules
var consent_onechat_dialog = __webpack_require__("IWN4");

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./node_modules/vue-context/dist/js/vue-context.js
var vue_context = __webpack_require__("IaZh");
var vue_context_default = /*#__PURE__*/__webpack_require__.n(vue_context);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-headful/dist/vue-headful.js
var vue_headful = __webpack_require__("WiKS");
var vue_headful_default = /*#__PURE__*/__webpack_require__.n(vue_headful);

// EXTERNAL MODULE: ./src/components/consent/new_consent.vue + 2 modules
var new_consent = __webpack_require__("F8NA");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/layout/Lefttest.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













vue_esm["default"].component('vue-headful', vue_headful_default.a);

var _ = __webpack_require__("M4fF");

/* harmony default export */ var Lefttest = ({
  data: function data() {
    return {
      newConsentDialog: false,
      newConsentDetail: {},
      // ProgressListChat: false,
      // ProgressListFriend: false,
      // ProgressListGroup: false,
      checkBrowserDialog: false,
      checkBrowserInfor: {},
      SelectedMessageDetail: {},
      ListMenuRightClick: [],
      rightclickdialog: false,
      Progress: {
        ListChat: false,
        ListFriend: false,
        ListGroup: false
      },
      search: '',
      listfriend: [],
      listgroup: [],
      listchat: [],
      tabs: null,
      AddFriend: false,
      ShowFriend: false,
      block: false,
      CreateGroup: false,
      actionF: '',
      token: '',
      listmenusettingapi: [{
        title: 'ส่งไฟล์ไป One box',
        icon: 'file_upload',
        path: 'onebox'
      }, {
        title: 'ข้อเสนอแนะ',
        icon: 'feedback',
        path: 'feedback'
      }, {
        title: 'ศูนย์ช่วยเหลือ',
        icon: 'contact_support',
        path: 'contact_support'
      }, {
        title: 'นโยบายความเป็นส่วนตัว',
        icon: 'book',
        path: 'private_policy'
      }],
      listmenutask: [],
      listmenu: [],
      listmenuService: [{
        title: 'OneEmail',
        icon: '/static/img/oneplatform/oneemail2.png',
        path: "https://testoneid.inet.co.th/preauth",
        type: 'link'
      }, {
        title: 'OneBox',
        icon: '/static/img/oneplatform/onebox.png',
        path: "https://testoneid.inet.co.th/oauth/authorize?client_id=155&response_type=code&scope=account",
        type: 'share_token_onebox'
      },
      // {
      //   title: 'OneChat News',
      //   icon: '/static/img/oneplatform/onechat_news.jpg',
      //   path: process.env.WEBNews,
      //   type: 'function_news'
      // },
      {
        title: 'One Anonymous',
        icon: '/static/img/oneplatform/anonymousone.png',
        path: '/anonymousone_group',
        type: 'route'
        // {
        //   title: 'Market',
        //   icon: '/static/img/oneplatform/market2.png',
        //   path: '/chat/service/market',
        //   type: 'route'
        // }
      }],
      //   {
      //     title: 'แก้ไขโปรไฟล์',
      //     icon: 'person',
      //     path: 'profile'
      //   },
      //   {
      //     title: 'จัดการเพื่อน',
      //     icon: 'fas fa-users',
      //     path: 'managefriend'
      //   },
      //   {
      //     title: 'ส่งไฟล์ไป One box',
      //     icon: 'file_upload',
      //     path: 'uploadfile/onebox'
      //   },
      //   {
      //     title: 'ข้อเสนอแนะ',
      //     icon: 'feedback',
      //     path: 'feedback'
      //   },
      //   {
      //     title: 'ศูนย์ช่วยเหลือ',
      //     icon: 'contact_support',
      //     path: 'support'
      //   },
      //   {
      //     title: 'นโยบายความเป็นส่วนตัว',
      //     icon: 'book',
      //     path: 'policy'
      //   }

      // ],
      listmenubroadcast: [{
        title: 'บรอดแคส',
        icon: 'settings_input_antenna',
        path: 'broadcast'
      }, {
        title: 'ประวัติการบรอดแคส',
        icon: 'view_list',
        path: 'history_broadcast'
      }],
      listmenuapi: [{
        title: 'ข้อมูลนักพัฒนา',
        icon: 'person',
        path: 'dev_profile'
      }, {
        title: 'ข้อมูลห้องแชทเพื่อน',
        icon: 'chat',
        path: 'dev_infofriend'
      }, {
        title: 'ข้อมูลห้องแชทกลุ่ม',
        icon: 'group',
        path: 'dev_infogroup'
      }],
      listmenuOnemeet: [{
        title: 'ข้อมูลนักพัฒนา',
        icon: 'person',
        path: '/onemeet',
        type: 'chatroom'
      }],
      FriendReq: [],
      FriendSendReq: [],
      GroupReq: [],
      active: null,
      menu1: 'nonselect_Menu',
      menu2: 'select_Menu',
      menu3: 'nonselect_Menu',
      menu4: 'nonselect_Menu',
      menu5: 'nonselect_Menu',
      menu6: 'nonselect_Menu',
      menu7: 'nonselect_Menu',
      menu8: 'nonselect_Menu',
      showgroup: false,
      num_friendreq: 0,
      num_groupreq: 0,
      count_read: 'OneChat',
      notread: 0,
      encodeToken_News: '',
      one_id: '',
      state_organize: true,
      base_env: "uat",
      consentOnechatDialog: false,
      url_consent: ''
    };
  },
  components: {
    AddDialog: AddFriendDialog["a" /* default */],
    CreateGroupDialog: CreateGroupDialog["a" /* default */],
    ShowFriendDialog: ShowFriendDialog["a" /* default */],
    VueContext: vue_context["VueContext"],
    CheckBrowserDialog: CheckBrowserDialog["a" /* default */],
    checkconsentOnechatDialog: consent_onechat_dialog["a" /* default */],
    newConsent: new_consent["a" /* default */]
  },
  created: function created() {
    // เอาไว้เช็คเมนูเวลาสลับมาจากหน้า onemeet
    var menu_left = JSON.parse(localStorage.getItem('menu_left'));
    // console.log(menu_left)
    if (menu_left === null || menu_left === undefined) {
      this.active = 'tab-2';
    } else {
      this.active = menu_left.active;
      this.menu1 = menu_left.menu1;
      this.menu2 = menu_left.menu2;
      this.menu3 = menu_left.menu3;
      this.menu4 = menu_left.menu4;
      this.menu5 = menu_left.menu5;
      this.menu6 = menu_left.menu6;
      this.menu7 = menu_left.menu7;
      this.menu8 = menu_left.menu8;
    }
    // var test = {
    //   one_id: 'u77',
    //   ExpiredDate: Momenttime.momentCreateDate()
    // }
    // this.encodeToken_News = Encode.encodeAuthen_news(test)
    // console.log(mama)
    // console.log(Decode.decodeAuthen_news(mama))
    // this.active = 'tab-2'
    this.changeLangMenu();
    this.removefriend = false;
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.typeuser = localStorage.getItem('type_user');
    this.actionF = this.$route.params.roomid;
    // console.log(this.actionF)
    if (this.actionF != undefined) {
      var data = { tokenroom: this.actionF };
      this.mark_read(data);
    }
    this.getlistfriend();
    this.getlistgroup();
    this.getlistchat();
    this.getlistpending();
    this.getcount_notread();
    this.getOneid();
    // console.log(Momenttime.momentCreateDate())
  },

  // computed: {
  //   count_read () {
  //     if (this.notread == 0) {
  //       this.count_read = 'Onechat'
  //     } else {
  //       this.count_read = '('+response.data.count_read+') Onechat'
  //     }
  //   }
  // },
  methods: {
    closeNewConsent: function closeNewConsent(value) {
      console.log("close new consent", value);
      this.newConsentDialog = value.close;
      this.newConsentDetail = {};
    },
    closeDialogConsentOnechat: function closeDialogConsentOnechat(value) {
      this.consentOnechatDialog = value;
    },
    check_consent: function check_consent(token) {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var hour = String(today.getHours() + 1).padStart(2, '0');
      var minute = String(today.getMinutes()).padStart(2, '0');
      var seconds = String(today.getSeconds()).padStart(2, '0');
      var milsec = today.getMilliseconds();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00';
        dd = String(today.getDate() + 1).padStart(2, '0');
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1';
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1';
            yyyy = today.getFullYear() + 1;
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0');
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
      // console.log(today)
      var expireddate = Date.parse(today);
      // console.log(expireddate)
      var body = services["b" /* Encode */].encodeRichmenu({ 'userid': token, 'expired_date': expireddate });
      // console.log(body)
      this.progress = true;
      // check new consent
      if (this.$cookie.get('check-consent-' + token) === null || this.$cookie.get('check-consent-' + token) === undefined) {
        // test new consent
        this.progress = false;
        this.newConsentDialog = true;
        this.newConsentDetail = { token: token };
      } else {
        this.progress = false;
      }
      // this.axios.post(process.env.APIgo_api + `/v1/get-consent`, { onechat_token: body }).then((response) => {
      //   // console.log(response.data)
      //   if (response.data.status === 'success') {
      //     this.progress = false
      //     if (response.data.data.consent_check === 'false') {
      //       this.consentOnechatDialog = true
      //       this.url_consent = response.data.data.consent_url
      //     }
      //   }
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    toPageOnemeet: function toPageOnemeet(path, type) {
      // console.log(path)
      console.log(type);
      this.$router.push(path);
    },
    getlistpending: function getlistpending() {
      var _this = this;

      // this.axios.post(process.env.APImanage + '/web/getlistrequestfriend', {tokenuser: this.token}).then((response) => {
      //   this.FriendReq = response.data['listrequestfriend']
      //   this.num_friendreq = response.data['listrequestfriend'].length
      // })
      // this.axios.post(process.env.APImanage + '/web/getlistpendingfriend', {tokenuser: this.token}).then((response) => {
      //   this.FriendSendReq = response.data['listpendingfriend']
      // })
      // this.axios.post(process.env.APImanage + '/web/getlistpendinggroup', {tokenuser: this.token}).then((response) => {
      //   this.GroupReq = response.data['listpendinggroup']
      //   this.num_groupreq = response.data['listpendinggroup'].length
      // })

      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-pending', { tokenuser: this.token }).then(function (response) {
        _this.FriendSendReq = response.data['list_send_request_friend'];
        _this.FriendReq = response.data['list_request_friend'];
        _this.GroupReq = response.data['list_pending_group'];

        _this.num_friendreq = response.data['list_request_friend'].length;
        _this.num_groupreq = response.data['list_pending_group'].length;
      });
    },
    closeCheckBrowser: function closeCheckBrowser(value) {
      this.checkBrowserDialog = value;
      this.checkBrowserInfor = {};
    },
    checkBrowser: function checkBrowser(url) {
      // console.log(url)
      console.log('check browser');
      // Get the user-agent string
      var userAgentString = navigator.userAgent;
      // Detect Chrome
      var chromeAgent = userAgentString.indexOf("Chrome") > -1;
      // Detect Internet Explorer
      var IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
      // Detect Firefox
      var firefoxAgent = userAgentString.indexOf("Firefox") > -1;
      // Detect Safari
      var safariAgent = userAgentString.indexOf("Safari") > -1;
      // Discard Safari since it also matches Chrome
      var operaAgent = userAgentString.indexOf("OP") > -1;
      // console.log('firefox = > ' + firefoxAgent)
      // console.log('ie = > ' + IExplorerAgent)
      // console.log('chrome = > ' + chromeAgent)
      // console.log('opera = > ' + operaAgent)
      // console.log('safari = > ' + safariAgent)
      if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
        this.checkBrowserInfor = {
          url: url,
          payload: ''
        };
        this.checkBrowserDialog = true;
      } else if (safariAgent === true && chromeAgent === true) {
        window.open(url, '_blank');
      } else if (safariAgent === true) {
        this.checkBrowserInfor = {
          url: url,
          payload: ''
        };
        this.checkBrowserDialog = true;
      } else {
        window.open(url, '_blank');
      }
    },
    convertMention: function convertMention(msg) {
      msg = msg.replace(/\<tax>/g, '<span style="color:#1976d2;">@');
      msg = msg.replace(/<\/tax>/g, '</span>');
      // console.log(msg)
      return msg;
    },
    getOneid: function getOneid() {
      var _this2 = this;

      this.axios.get("https://uatchat-manage.one.th/go_api/api" + '/v1/getOneID/' + this.token).then(function (response) {
        // console.log(response.data.one_id)
        _this2.one_id = response.data.one_id;
        // this.getSharedtoken(this.one_id)
        // if (response.data.status === 'success') {
        //   // console.log(response.data)
        //   if (response.data.count_read != 0) {
        //     // this.count_read = '('+response.data.count_read+') Onechat'
        //     this.notread = response.data.count_read
        //   } else {
        //     // this.count_read = 'Onechat'
        //     this.notread = 0
        //   }
        // }
      }, function () {
        console.log('error');
      });
    },
    getSharedtoken: function getSharedtoken(oneid) {
      var _this3 = this;

      this.axios.post("https://uatchat-manage.one.th/message" + '/api/v1/get_shared_token', { user_id: oneid }).then(function (response) {
        if (response.data.status === 'success') {
          _this3.axios.get("https://meet-test.one.th/" + 'api/onemeeting/checkMemberInOrganize', { headers: { Authorization: 'Bearer ' + response.data.data.shared_token } }).then(function (response) {
            // console.log(response.data)
            console.log('status organize: ' + response.data.organize);
            if (response.data.status === 'Success' || response.data.status === 'success') {
              _this3.state_organize = response.data.organize;
            } else {
              _this3.state_organize = false;
            }
          }).catch(function (error) {
            console.log(error);
            console.log("uat");
            _this3.state_organize = false;
            if (true) {
              // this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
            }
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this3.state_organize = false;
        if (true) {
          // this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
        }
      });
    },
    changepathservice: function changepathservice(path, type) {
      var _this4 = this;

      // console.log('type' + type)

      if (type == 'link') {
        window.open(path);
      } else if (type == 'route') {
        this.$router.push(path);
      } else if (type == 'function_news') {
        // console.log('test')
        // console.log(Momenttime.momenttimestamp())
        var test = {
          one_id: this.one_id,
          createdDate: services["c" /* Momenttime */].momentCreateDate()
        };
        this.encodeToken_News = services["b" /* Encode */].encodeAuthen_news(test);
        window.open(path + this.encodeToken_News);
        // console.log(window.navigator.geolocation)
        // if (window.navigator.geolocation) {
        //   console.log('oo')
        //   window.navigator.geolocation.getCurrentPosition((position) => {
        //     console.log('rr')
        //     var test = {
        //       one_id: this.one_id,
        //       createdDate: Momenttime.momentCreateDate(),
        //       latitude: position.coords.latitude,
        //       longitude: position.coords.longitude
        //     }
        //     this.encodeToken_News = Encode.encodeAuthen_news(test)
        //     console.log(Decode.decodeAuthen_news(this.encodeToken_News))
        //     window.open(path + this.encodeToken_News)
        //   })
        // } else {
        //   var test = {
        //     one_id: this.one_id,
        //     createdDate: Momenttime.momentCreateDate()
        //   }
        //   this.encodeToken_News = Encode.encodeAuthen_news(test)
        //   console.log(Decode.decodeAuthen_news(this.encodeToken_News))
        //   window.open(path + this.encodeToken_News)
        // }
      } else if ('share_token_onebox') {
        this.axios.post("https://uatchat-manage.one.th/message" + '/api/v1/get_encode_shared_token', {
          user_id: this.one_id
        }).then(function (response) {
          // console.log(response.data.data.encode_shared_token)
          var url = "https://uatbox.one.th/loginbysharetoken?token=" + response.data.data.encode_shared_token;
          _this4.checkBrowser(url);
        });
      }
    },
    getcount_notread: function getcount_notread() {
      var _this5 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getnotreadcount', {
        tokenuser: this.token
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          if (response.data.count_read != 0) {
            // this.count_read = '('+response.data.count_read+') Onechat'
            _this5.notread = response.data.count_read;
          } else {
            // this.count_read = 'Onechat'
            _this5.notread = 0;
          }
        }
      }, function () {
        console.log('error');
      });
    },
    RightClickDialog: function RightClickDialog($event, list, item) {
      // console.log(list)
      // console.log(item)
      this.ListMenuRightClick = [];
      if (item.state == 'active') {
        if (list.includes("pinchat")) {
          if (item.pin == "false") {
            this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.pinChat'), methods: 'pinchat' });
          } else if (item.pin == "true") {
            this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.unpinChat'), methods: 'unpinchat' });
          }
        }
        this.rightclickdialog = true;
        this.$refs.menu.open($event);
        this.SelectedMessageDetail = item;
      }
    },
    SelectMenuRightClick: function SelectMenuRightClick(selected) {
      // console.log(selected)
      if (selected == 'pinchat') {
        this.pin_chat();
      } else if (selected == 'unpinchat') {
        this.unpin_chat();
      }
    },
    pin_chat: function pin_chat() {
      var _this6 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', {
        tokenuser: this.token,
        tokenroom: this.SelectedMessageDetail.tokenroom,
        pin: 'true'
      }).then(function (response) {
        if (response.data.status === 'success') {
          // pinchat
          var tokenroom = _this6.SelectedMessageDetail.tokenroom;
          var index = '';
          index = _.findIndex(_this6.listchat, function (o) {
            return o.tokenroom == tokenroom;
          });
          _this6.listchat[index].pin = 'true';
          var listpin = [];
          var linstunpin = [];
          _this6.listchat = _.partition(_this6.listchat, function (o) {
            return o.pin == 'true';
          });
          listpin = _.orderBy(_this6.listchat[0], 'timestamp', 'desc');
          linstunpin = _.orderBy(_this6.listchat[1], 'timestamp', 'desc');
          _this6.listchat = _.union(listpin, linstunpin);
          // console.log(this.listchat)
        }
      }, function () {
        console.log('error');
      });
    },
    unpin_chat: function unpin_chat() {
      var _this7 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', {
        tokenuser: this.token,
        tokenroom: this.SelectedMessageDetail.tokenroom,
        pin: 'false'
      }).then(function (response) {
        if (response.data.status === 'success') {
          // pinchat
          var tokenroom = _this7.SelectedMessageDetail.tokenroom;
          var index = '';
          index = _.findIndex(_this7.listchat, function (o) {
            return o.tokenroom == tokenroom;
          });
          _this7.listchat[index].pin = 'false';
          var listpin = [];
          var linstunpin = [];
          _this7.listchat = _.partition(_this7.listchat, function (o) {
            return o.pin == 'true';
          });
          listpin = _.orderBy(_this7.listchat[0], 'timestamp', 'desc');
          linstunpin = _.orderBy(_this7.listchat[1], 'timestamp', 'desc');
          _this7.listchat = _.union(listpin, linstunpin);
          // console.log(this.listchat)
        }
      }, function () {
        console.log('error');
      });
    },
    changeLangMenu: function changeLangMenu() {
      this.listmenu = [{
        title: this.$t('HeaderMenubar.editProfile'),
        icon: 'person',
        path: 'profile'
      }, {
        title: this.$t('HeaderMenubar.managefriend'),
        icon: 'fas fa-users',
        path: 'managefriend'
      },
      // {
      //   title: this.$t('HeaderMenubar.sendOnebox'),
      //   icon: 'file_upload',
      //   path: 'uploadfile/onebox'
      // },
      {
        title: this.$t('HeaderMenubar.feedback'),
        icon: 'feedback',
        path: 'feedback'
      }, {
        title: this.$t('HeaderMenubar.support'),
        icon: 'contact_support',
        path: 'support'
      }, {
        title: this.$t('HeaderMenubar.terms_of_service'),
        icon: 'book',
        path: 'terms_of_service'
      }, {
        title: this.$t('HeaderMenubar.policy'),
        icon: 'book',
        path: 'policy'
      }], this.listmenutask = [{
        title: this.$t('HeaderMenubar.calendar'),
        icon: 'fas fa-calendar-alt',
        path: 'calendar'
      }, {
        title: this.$t('HeaderMenubar.createproject'),
        icon: 'fas fa-plus-circle',
        path: 'create_project'
      }, {
        title: this.$t('HeaderMenubar.project'),
        icon: 'fas fa-tasks',
        path: 'all_project'
      }];
    },
    secondsToHms: function secondsToHms(d) {
      d = Number(d);
      var hours = Math.floor(d / 3600);
      var minutes = Math.floor((d - hours * 3600) / 60);
      var seconds = d - hours * 3600 - minutes * 60;
      var time = '';

      if (hours !== 0) {
        time = hours + ':';
      }
      if (minutes !== 0 || time !== '') {
        minutes = minutes < 10 && time !== '' ? '0' + minutes : String(minutes);
        time += minutes + ':';
      }
      if (time === '') {
        time = seconds + ' s';
      } else {
        time += seconds < 10 ? '0' + seconds : String(seconds);
      }
      return time;
    },
    updatelistreq: function updatelistreq(data) {
      if (data.event === 'accept') {
        this.FriendReq.splice(_.findIndex(this.FriendReq, function (o) {
          return o.tokenuser === data.tokenuser;
        }), 1);
        if (_.find(this.listfriend, function (o) {
          return o.tokenuser === data.tokenuser;
        }) === undefined) {
          this.listfriend.unshift({
            email: data.email,
            name: data.name,
            profilepicture: data.profilepicture,
            state: data.state,
            status: data.status,
            tokenuser: data.tokenuser,
            type: data.type,
            tokenroom: data.tokenroom
          });
          this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc']);
        }
        if (_.find(this.listchat, function (o) {
          return o.tokenuser === data.tokenuser;
        }) === undefined) {
          this.listchat.unshift({
            email: data.email,
            name: data.name,
            is_active: 'true',
            profilepicture: data.profilepicture,
            state: data.state,
            status: data.status,
            tokenuser: data.tokenuser,
            type: data.type,
            tokenroom: data.tokenroom,
            nickname: '',
            timestamp: data.timestamp,
            count_read: '0'
          });
        }
      } else if (data.event === 'removeReq') {
        var index = _.findIndex(this.FriendSendReq, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        if (index >= 0) {
          this.FriendSendReq.splice(index, 1);
        }
      }
    },
    updatecreategroup: function updatecreategroup(data, filename) {
      if (_.find(this.listgroup, function (o) {
        return o.group_id === data.group_id;
      }) === undefined) {
        this.listgroup.unshift({
          count_read: '0',
          create_date: data.create_date,
          group_id: data.group_id,
          member: data.member,
          name: data.name,
          picture: filename,
          state: data.state,
          timestamp: data.timestamp,
          tokenroom: data.tokenroom,
          type: data.type
        });
        this.listgroup = _.orderBy(this.listgroup, ['name'], ['asc']);
      }
    },
    updatelistchat: function updatelistchat(data, filename) {
      // console.log(data)
      if (_.find(this.listchat, function (o) {
        return o.group_id === data.group_id;
      }) === undefined) {
        this.listchat.unshift({
          is_active: 'true',
          count_read: '0',
          create_date: data.create_date,
          group_id: data.group_id,
          member: data.member,
          name: data.name,
          nickname: '',
          picture: filename,
          state: data.state,
          timestamp: data.create_date,
          tokenroom: data.tokenroom,
          type: data.type
        });
      }
    },
    getlistchat: function getlistchat() {
      var _this8 = this;

      this.Progress.ListChat = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api/v4/getListChat", { tokenuser: this.token }).then(function (response) {
        _this8.Progress.ListChat = false;
        if (response.data.status === 'success') {
          _this8.listchat = response.data['listchat'];
          // console.log(this.listchat)
          // pinchat
          var listpin = [];
          var linstunpin = [];
          // check consent onechat
          _this8.check_consent(_this8.token);
          // this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true'})
          // listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
          // linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
          // this.listchat = _.union(listpin, linstunpin)
        }
      }, function () {
        _this8.Progress.ListChat = false;
        console.log('error');
      });
    },
    getlistfriend: function getlistfriend() {
      var _this9 = this;

      this.Progress.ListFriend = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-friend', { tokenuser: this.token }).then(function (response) {
        _this9.Progress.ListFriend = false;
        if (response.data.status === 'success') {
          _this9.listfriend = response.data['list_friend'];
        }
      }, function () {
        _this9.Progress.ListFriend = false;
      });
    },
    getlistgroup: function getlistgroup() {
      var _this10 = this;

      this.Progress.ListGroup = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-group', { tokenuser: this.token }).then(function (response) {
        _this10.Progress.ListGroup = false;
        if (response.data.status === 'success') {
          _this10.listgroup = response.data['list_active_group'];
        }
      }, function () {
        _this10.Progress.ListGroup = false;
      });
    },
    showUserInGroup: function showUserInGroup(item) {
      this.showgroup = item;
      this.showDialog('ShowFriend');
    },
    changepathsettings: function changepathsettings(path) {
      this.pathsettings = '/chat/settings/' + path;
      this.$router.push('/chat/settings/' + path);
    },
    changepathproject: function changepathproject(path) {
      this.pathsettings = '/chat/project/' + path;
      this.$router.push('/chat/project/' + path);
    },
    changebroadcast: function changebroadcast(path) {
      this.$router.push('/broadcast/' + path);
      localStorage.setItem('room', path);
    },
    changepathapi: function changepathapi(path) {
      this.$router.push('/api/' + path);
      localStorage.setItem('room', path);
    },
    selectmenu: function selectmenu(menu) {
      console.log('menu: ', menu);
      if (menu === 1) {
        this.active = 'tab-1';
        this.menu1 = 'select_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 2) {
        this.active = 'tab-2';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'select_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 3) {
        this.active = 'tab-3';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'select_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 4) {
        this.active = 'tab-4';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'select_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 5) {
        this.active = 'tab-5';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'select_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 6) {
        this.active = 'tab-6';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'select_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 7) {
        this.active = 'tab-7';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'select_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 8) {
        this.active = 'tab-8';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'select_Menu ';
        this.toPageOnemeet('/onemeeting', 'onemeet');
      }
    },
    RemoveReq_FriendSendReq: function RemoveReq_FriendSendReq(item) {
      var _this11 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', { tokenfriend: item.tokenuser, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          _this11.FriendSendReq.splice(_.findIndex(_this11.FriendSendReq, function (o) {
            return o.tokenuser === item.tokenuser;
          }), 1);
        }
      });
    },
    AcceptReq_GroupReq: function AcceptReq_GroupReq(group) {
      var _this12 = this;

      // process.env.APImanage + '/activeinvitegroup'
      // process.env.APIgo_api + '/v1/accept-group'
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/accept-group', { group_id: group.group_id, tokenuser: this.token }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          var tokenuser = _this12.token;
          var indexgroup = _.findIndex(response.data.group.member, function (o) {
            return o.tokenuser === tokenuser;
          });
          if (indexgroup >= 0) {
            _this12.socketactive_group = { timestamp: response.data.group.member[indexgroup].timestamp_in, groupid: group.group_id, tokenuser: _this12.token };
          } else {
            _this12.socketactive_group = { timestamp: '', groupid: group.group_id, tokenuser: _this12.token };
          }
        }
      });
    },
    RemoveReq_GroupReq: function RemoveReq_GroupReq(group) {
      var _this13 = this;

      // console.log(group)
      this.$swal({
        title: '',
        text: this.$t('Alert.Group.cancelGroup', { name: group.name }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this13.axios.post("https://uatchat-manage.one.th/manage" + '/cancelinvitegroup', { group_id: group.group_id, tokenuser: _this13.token }).then(function (response) {
            if (response.data.status === 'success') {
              // this.GroupReq.splice(this.GroupReq.indexOf(group), 1) // ลบ GroupReq ตอนยกเลิกเข้ากลุ่ม
            }
          });
        }
      });
    },
    AcceptReq_FriendReq: function AcceptReq_FriendReq(Friend) {
      var _this14 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/accept-friend", { tokenfriend: Friend.tokenuser, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          var index = _.findIndex(_this14.FriendReq, function (o) {
            return o.tokenuser === Friend.tokenuser;
          });
          if (index >= 0) {
            _this14.FriendReq.splice(index, 1);
          }
          _this14.$router.push('/chat/room/' + response.data.tokenroom);
          var data = response.data.source;
          data['tokenroom'] = response.data.tokenroom;
        } else {}
      });
    },
    RemoveReq_FriendReq: function RemoveReq_FriendReq(Friend) {
      var _this15 = this;

      this.$swal({
        title: '',
        text: this.$t('Alert.Left.cancelRequest', { name: Friend.name }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          // if (Friend.type === 'user') {
          _this15.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', { tokenfriend: Friend.tokenuser, tokenuser: _this15.token }).then(function (response) {
            if (response.data['status'] === 'success') {
              _this15.socketremove_request_friend = {
                tokenuser: Friend.tokenuser,
                tokenfriend: _this15.token
              };
            } else {}
          });
        }
      });
    },
    lengthactive: function lengthactive(member) {
      return _.filter(member, function (member) {
        return member.statemember === 'active';
      }).length;
    },
    showDialog: function showDialog(dialog) {
      if (dialog === 'AddFriend') {
        this.AddFriend = true;
      } else if (dialog === 'CreateGroup') {
        this.CreateGroup = true;
      } else if (dialog === 'ShowFriend') {
        this.ShowFriend = true;
      }
    },
    closeDialogShowFriend: function closeDialogShowFriend(value) {
      this.ShowFriend = value;
    },
    closeDialogAddFriend: function closeDialogAddFriend(value) {
      this.AddFriend = value;
    },
    closeDialogCreateGroup: function closeDialogCreateGroup(value) {
      this.CreateGroup = value;
    },
    time: function time(timestamp) {
      if (this.$i18n.locale == 'th') {
        return services["c" /* Momenttime */].momenttimethaiformnow(timestamp);
      } else if (this.$i18n.locale == 'cn') {
        return services["c" /* Momenttime */].momenttimethaiformnowcn(timestamp);
      } else {
        return services["c" /* Momenttime */].momenttimethaiformnowen(timestamp);
      }
      // return (this.$i18n.locale == 'th')? Momenttime.momenttimethaiformnow(timestamp): Momenttime.momenttimethaiformnowen(timestamp)
    },
    routeChat: function routeChat(data) {
      // console.log(data)
      // this.$cookie.set('typeuser_friend', data.type)
      // this.$cookie.set('tokenuser_friend', Encode.encodeToken(data.tokenuser))
      this.actionF = data.tokenroom;
      // check consent
      if (data.type === 'bot') {
        this.getConsent(data.tokenuser, data.tokenroom);
      } else {
        this.$router.push('/chat/room/' + data.tokenroom);
      }
      // this.$router.push('/chat/room/' + data.tokenroom)
      var indexmsg = _.findIndex(this.listchat, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (this.listchat[indexmsg].is_active == 'true') {
        this.notread = this.notread - this.listchat[indexmsg].count_read;
      }
      this.listchat[indexmsg].is_active = 'true';

      this.listchat[indexmsg].count_read = 0;

      this.mark_read(data);
      this.pathsettings = '/chat/room/' + data.tokenroom;
    },
    getConsent: function getConsent(botid, tokenroom) {
      var _this16 = this;

      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/get-consent-bot', {
        tokenuser: this.token,
        bot_id: botid
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          if (response.data.isConsent === true && response.data.isAccept === false) {
            var dataConsent = services["b" /* Encode */].encode(response.data.data);
            _this16.$router.push('/check-consent/' + tokenroom + ('/?data_consent=' + dataConsent));
          } else {
            _this16.$router.push('/chat/room/' + tokenroom);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    mark_read: function mark_read(data) {
      // console.log('mark_read')
      if (data.count_read !== '0' && data.count_read !== '') {
        this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/user-mark-read', { tokenuser: this.token, tokenroom: data.tokenroom }).then(function (response) {});
      }
    },
    blockevent: function blockevent(data) {
      var _this17 = this;

      if (data.event === 'block_friend') {
        var indexmsg = _.findIndex(this.listchat, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        var indexchat = _.findIndex(this.listchat, function (o) {
          return o.tokenroom === data.tokenroom;
        });
        if (indexchat != -1) {
          this.listchat[indexchat]['timestamp'] = data.timestamp;
          this.listchat[indexchat]['state'] = 'block';
          // this.listchat = _.orderBy(this.listchat, ['timestamp'], ['asc']).reverse()
          this.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', { tokenroom: data.tokenroom, tokenuser: this.token, pin: 'false' }).then(function (response) {
            var listpin = [];
            var linstunpin = [];
            _this17.listchat[indexchat].pin = 'false';
            _this17.listchat = _.partition(_this17.listchat, function (o) {
              return o.pin == 'true';
            });
            listpin = _.orderBy(_this17.listchat[0], 'timestamp', 'desc');
            linstunpin = _.orderBy(_this17.listchat[1], 'timestamp', 'desc');
            _this17.listchat = _.union(listpin, linstunpin);
          });
        }
        indexmsg = _.findIndex(this.listfriend, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        if (indexmsg != -1) {
          _.pullAt(this.listfriend, indexmsg);
        }
      } else if (data.event === 'unblock_friend') {
        this.listfriend.push(data);
        this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc']);
        indexmsg = _.findIndex(this.listchat, function (o) {
          return o.tokenroom === data.tokenroom;
        });
        if (indexmsg != -1) {
          this.listchat[indexmsg].state = 'active';
          this.listchat[indexmsg].nickname = '';
        }
      }
    }
  },
  computed: extends_default()({
    // count_read () {
    //   if (this.notread == 0) {
    //     return 'OneChat'
    //   } else {
    //     return '(' + this.notread + ') Onechat'
    //   }
    // },
    FilterFriendList: function FilterFriendList() {
      var _this18 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listfriend.filter(function (post) {
          return post.name.toLowerCase().includes(_this18.search.toLowerCase());
        });
      } else {
        return this.listfriend;
      }
    },
    FilterGroupList: function FilterGroupList() {
      var _this19 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listgroup.filter(function (post) {
          return post.name.toLowerCase().includes(_this19.search.toLowerCase());
        });
      } else {
        return this.listgroup;
      }
    },
    FilterChatList: function FilterChatList() {
      var _this20 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listchat.filter(function (post) {
          return post.name.toLowerCase().includes(_this20.search.toLowerCase());
        });
      } else {
        return this.listchat;
      }
    }
  }, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {
    centrifuge_consent: function centrifuge_consent(data) {
      // console.log(data)
      if (data.consent_version !== undefined) {
        this.consentOnechatDialog = false;
      }
    },
    GroupReq: function GroupReq() {
      this.num_groupreq = this.GroupReq.length;
    },
    FriendReq: function FriendReq() {
      this.num_friendreq = this.FriendReq.length;
    },
    chIsactive: function chIsactive(data) {
      var _this21 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/setisactive', { tokenroom: data, tokenuser: this.token, is_active: 'false' }).then(function (response) {
        if (response.data.status === 'success') {
          var indexmsg = _.findIndex(_this21.listchat, function (o) {
            return o.tokenroom === data;
          });
          _this21.listchat[indexmsg].is_active = false;
          _this21.$router.push('/chat/homepage');
          _this21.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', { tokenroom: data, tokenuser: _this21.token, pin: 'false' }).then(function (response) {
            var listpin = [];
            var linstunpin = [];
            _this21.listchat[indexmsg].pin = 'false';
            _this21.listchat = _.partition(_this21.listchat, function (o) {
              return o.pin == 'true';
            });
            listpin = _.orderBy(_this21.listchat[0], 'timestamp', 'desc');
            linstunpin = _.orderBy(_this21.listchat[1], 'timestamp', 'desc');
            _this21.listchat = _.union(listpin, linstunpin);
          });
        }
      });
    },
    block_friend: function block_friend(data) {
      this.blockevent(data);
    },
    socket_unsendmessage: function socket_unsendmessage(data) {
      var _this22 = this;

      // console.log(data)
      this.axios.post("https://uatchat-manage.one.th/event" + '/getmessage', { tokenmessage: data.last_tokenmessage._id, tokenuser: this.token }).then(function (response) {
        // console.log(response.data.source)
        var dataunsend = {};
        dataunsend = response.data.source;
        var indexmsg = _.findIndex(_this22.listchat, function (o) {
          return o.tokenroom === data.tokenroom;
        });
        if (indexmsg !== -1) {
          _this22.listchat[indexmsg].is_active = 'true';
          // var message = dataunsend.message
          // if (data.tokenroom !== this.actionF) {
          //   this.listchat[indexmsg].count_read = parseInt(this.listchat[indexmsg].count_read) + 1
          // }
          _this22.listchat[indexmsg].message = dataunsend.message;
          _this22.listchat[indexmsg].timestamp = dataunsend.timestamp;
          _this22.listchat[indexmsg].nickname = dataunsend.nickname;
          _this22.listchat[indexmsg].typeofmessage = dataunsend.typeofmessage;
          _this22.listchat[indexmsg].time_count = dataunsend.time_count;
          _this22.listchat[indexmsg].file_name = dataunsend.file_name;
          _this22.listchat[indexmsg].tokenuser = dataunsend.tokenuser;
          var listpin = [];
          var linstunpin = [];
          var pin = _.partition(_this22.listchat, function (o) {
            return o.pin == 'true';
          });
          listpin = _.orderBy(pin[0], 'timestamp', 'desc');
          linstunpin = _.orderBy(pin[1], 'timestamp', 'desc');
          _this22.listchat = _.union(listpin, linstunpin);
          // if (indexmsg === 0) {
          //   this.listchat[indexmsg].message = dataunsend.message
          //   this.listchat[indexmsg].timestamp = dataunsend.timestamp
          //   this.listchat[indexmsg].nickname = dataunsend.nickname
          //   this.listchat[indexmsg].typeofmessage = dataunsend.typeofmessage
          //   this.listchat[indexmsg].time_count = dataunsend.time_count
          //   this.listchat[indexmsg].file_name = dataunsend.file_name
          //   this.listchat[indexmsg].tokenuser = dataunsend.tokenuser
          // } else {
          //   var dataindex = this.listchat[indexmsg]
          //   dataindex.message = dataunsend.message
          //   dataindex.timestamp = dataunsend.timestamp
          //   dataindex.nickname = dataunsend.nickname
          //   dataindex.typeofmessage = dataunsend.typeofmessage
          //   dataindex.time_count = dataunsend.time_count
          //   dataindex.file_name = dataunsend.file_name
          //   dataindex.tokenuser = dataunsend.tokenuser
          //   _.pullAt(this.listchat, indexmsg) // ลบ listchat เดิม
          //   this.listchat.unshift(dataindex) // เพิ่ม lischat ใหม่เข้าไป
          // }
        }
      });
    },
    socketmessage: function socketmessage(data) {
      // console.log(data)
      // console.log(this.listchat)
      if (data.typeofmessage !== "system_action") {
        var indexmsg = _.findIndex(this.listchat, function (o) {
          return o.tokenroom === data.tokenroom;
        });
        if (indexmsg !== -1) {
          this.listchat[indexmsg].is_active = 'true';
          var message = data.message;
          // if (data.typeofmessage !== 'message') {
          //   message = 'Send ' + data.message
          // }
          if (data.tokenroom !== this.actionF && data.tokenuser != this.token) {
            this.listchat[indexmsg].count_read = parseInt(this.listchat[indexmsg].count_read) + 1;
            this.notread = this.notread + 1;
          } else if (data.tokenuser == this.token) {
            this.notread = this.notread - parseInt(this.listchat[indexmsg].count_read);
            this.listchat[indexmsg].count_read = 0;
          }
          if (indexmsg === 0) {
            this.listchat[0].message = message;
            this.listchat[0].timestamp = data.timestamp;
            this.listchat[0].nickname = data.nickname;
            this.listchat[0].typeofmessage = data.typeofmessage;
            this.listchat[0].time_count = data.time_count;
            this.listchat[0].file_name = data.file_name;
            this.listchat[0].tokenuser = data.tokenuser;
          } else {
            var dataindex = this.listchat[indexmsg];
            dataindex.message = message;
            dataindex.timestamp = data.timestamp;
            dataindex.nickname = data.nickname;
            dataindex.typeofmessage = data.typeofmessage;
            dataindex.time_count = data.time_count;
            dataindex.file_name = data.file_name;
            dataindex.tokenuser = data.tokenuser;
            _.pullAt(this.listchat, indexmsg); // ลบ listchat เดิม
            this.listchat.unshift(dataindex); // เพิ่ม lischat ใหม่เข้าไป
          }
        }
        // เรียงแชทใหม่ กรณที่มีการ pin
        var listpin = [];
        var linstunpin = [];
        this.listchat = _.partition(this.listchat, function (o) {
          return o.pin == 'true';
        });
        listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc');
        linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc');
        this.listchat = _.union(listpin, linstunpin);
        // console.log(this.listchat)
      }
    },
    socket_update_agora: function socket_update_agora(data) {
      console.log(data);
      var self = this;
      // if (data.tokenuser === self.token) {
      var indexchat = _.findIndex(self.listchat, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (indexchat >= 0) {
        if (data.status === 'cancel') {
          self.listchat[indexchat].message = 'Sent agora_call';
          self.listchat[indexchat].time_count = '';
        }
      }
      // }
    },
    socketleave_group: function socketleave_group(data) {
      // console.log(data)
      var self = this;
      data.listkick.forEach(function (item) {
        var _this23 = this;

        if (item === self.token) {
          var index = _.findIndex(self.listgroup, function (o) {
            return o.tokenroom === data.tokenroom;
          });
          if (index >= 0) {
            self.listgroup.splice(index, 1);
          }
          var indexchat = _.findIndex(self.listchat, function (o) {
            return o.tokenroom === data.tokenroom;
          });
          if (indexchat >= 0) {
            self.listchat[indexchat].state = 'leave';
            self.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', { tokenroom: data.tokenroom, tokenuser: self.token, pin: 'false' }).then(function (response) {
              var listpin = [];
              var linstunpin = [];
              self.listchat[indexchat].pin = 'false';
              self.listchat = _.partition(self.listchat, function (o) {
                return o.pin == 'true';
              });
              listpin = _.orderBy(_this23.listchat[0], 'timestamp', 'desc');
              linstunpin = _.orderBy(_this23.listchat[1], 'timestamp', 'desc');
              self.listchat = _.union(listpin, linstunpin);
            });
          }
        }
      });
    },
    socket_kickmember: function socket_kickmember(data) {
      var self = this;
      data.listkick.forEach(function (item) {
        if (item === self.token) {
          var index = _.findIndex(self.listgroup, function (o) {
            return o.tokenroom === data.tokenroom;
          });
          if (index >= 0) {
            self.listgroup.splice(index, 1);
          }
          var indexchat = _.findIndex(self.listchat, function (o) {
            return o.tokenroom === data.tokenroom;
          });
          if (indexchat >= 0) {
            self.listchat[indexchat].state = 'leave';
          }
        }
      });
    },
    socketactive_group: function socketactive_group(data) {
      var _this24 = this;

      // console.log(data)
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', { group_id: data.groupid, tokenuser: this.token }).then(function (response) {
        // console.log(response.data)
        var indexgroup = _.findIndex(_this24.GroupReq, function (o) {
          return o.group_id === response.data.group.group_id;
        }); // หาตำแหน่งของ group req ที่ต้องการจะลบ
        if (indexgroup >= 0) {
          _.pullAt(_this24.GroupReq, indexgroup); // ลบ GroupReq เดิม
          _this24.num_groupreq = _this24.GroupReq.length; // จำนวน group req
        }
        // update listgroup
        if (_.find(_this24.listgroup, function (o) {
          return o.group_id === response.data.group.group_id;
        }) === undefined) {
          // console.log('有group')
          var group = response.data.group;
          group.timestamp = data.timestamp;
          _this24.listgroup.unshift(group);
          _this24.listgroup = _.orderBy(_this24.listgroup, ['name'], ['asc']);
          _this24.getlistchat();
        }
        // update listchat
        // console.log(this.listchat)
        // if (_.find(this.listchat, function (o) { return o.group_id === response.data.group.group_id }) === undefined) {
        //   console.log(response.data.group)
        //   var chat = response.data.group
        //   chat.timestamp = data.timestamp
        //   chat.count_read = ''
        //   chat.nickname = ''
        //   chat.is_active = 'true'
        //   this.listchat.unshift(chat)
        //   console.log(this.listchat.unshift(chat))
        // }
        if (data.tokenuser === _this24.token) {
          var indexchat = _.findIndex(_this24.listchat, function (o) {
            return o.group_id === response.data.group.group_id;
          }); // หาตำแหน่งของ group req ที่ต้องการจะลบ
          // console.log(indexchat)
          if (indexchat != -1) {
            _this24.listchat[indexchat].state = 'active';
          }
          // this.listchat[indexchat].state = 'active'
        }
      });
    },
    socketcencel_group: function socketcencel_group(data) {
      // console.log(data)
      if (this.GroupReq.length !== 0) {
        // ลบ group req
        var index = _.findIndex(this.GroupReq, function (o) {
          return o.group_id === data.group_id;
        });
        if (index >= 0) {
          this.GroupReq.splice(index, 1);
        }
      }
    },
    socketremove_friend: function socketremove_friend(data) {
      // console.log(data)
      var index = _.findIndex(this.listfriend, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (index >= 0) {
        this.listfriend.splice(index, 1);
      }
      var indexchat = _.findIndex(this.listchat, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (indexchat >= 0) {
        this.listchat[indexchat].state = 'unfriend';
      }
    },
    socketremove_request_friend: function socketremove_request_friend(data) {
      var indexReq = _.findIndex(this.FriendReq, function (o) {
        return o.tokenuser === data.tokenuser;
      });
      var indexSendReq = _.findIndex(this.FriendSendReq, function (o) {
        return o.tokenuser === data.tokenuser;
      });
      if (indexReq >= 0) {
        this.FriendReq.splice(indexReq, 1);
      }
      if (indexSendReq >= 0) {
        this.FriendSendReq.splice(indexSendReq, 1);
      }
    },
    socketaccept_friend: function socketaccept_friend(data) {
      var _this25 = this;

      // console.log(data)
      var tokenfriend = data.tokenfriend;
      if (this.token === data.tokenfriend) {
        tokenfriend = data.tokenuser;
        var indexSendReq = _.findIndex(this.FriendSendReq, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        if (indexSendReq >= 0) {
          this.FriendSendReq.splice(indexSendReq, 1);
        }
      } else {
        var indexReq = _.findIndex(this.FriendReq, function (o) {
          return o.tokenuser === data.tokenfriend;
        });
        if (indexReq >= 0) {
          this.FriendReq.splice(indexReq, 1);
        }
      }
      this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', { tokenuser: this.token, tokenfriend: tokenfriend }).then(function (response) {
        if (_.find(_this25.listfriend, function (o) {
          return o.tokenuser === response.data.user.tokenuser;
        }) === undefined) {
          _this25.listfriend.unshift(response.data.user);
          // this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
        }
        // update listchat
        var indexchat = _.findIndex(_this25.listchat, function (o) {
          return o.tokenroom === data.tokenroom;
        });
        var json = response.data.user;
        json.nickname = '';
        json.picture = response.data.user.profilepicture;
        json.state = 'user';
        json.timestamp = data.timestamp;
        json.count_read = '0';
        json.is_active = 'true';
        // console.log(json)
        if (indexchat >= 0) {
          _this25.listchat.splice(indexchat, 1);
          _this25.listchat.unshift(json);
        } else {
          _this25.listchat.unshift(json);
        }
        // เรียงแชทใหม่ กรณที่มีการ pin
        var listpin = [];
        var linstunpin = [];
        _this25.listchat = _.partition(_this25.listchat, function (o) {
          return o.pin == 'true';
        });
        listpin = _.orderBy(_this25.listchat[0], 'timestamp', 'desc');
        linstunpin = _.orderBy(_this25.listchat[1], 'timestamp', 'desc');
        _this25.listchat = _.union(listpin, linstunpin);
      });
    },
    socketfriend: function socketfriend(data) {
      var _this26 = this;

      // console.log(data)
      // console.log(process.env.APImanage + '/searchtokenuser', {tokenuser: this.token, tokenfriend: data.tokenfriend})
      this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', { tokenuser: this.token, tokenfriend: data.tokenfriend[0] }).then(function (response) {
        // var _ = require('lodash')
        if (data.konAdd !== _this26.token) {
          // update Friend request
          if (_.find(_this26.FriendReq, function (o) {
            return o.tokenuser === response.data.user.tokenuser;
          }) === undefined) {
            _this26.FriendReq.unshift(response.data.user);
            _this26.FriendReq = _.orderBy(_this26.FriendReq, ['name'], ['asc']).reverse();
          }
        } else {
          if (_.find(_this26.FriendSendReq, function (o) {
            return o.tokenuser === response.data.user.tokenuser;
          }) === undefined) {
            _this26.FriendSendReq.unshift(response.data.user);
            _this26.FriendSendReq = _.orderBy(_this26.FriendSendReq, ['name'], ['asc']).reverse();
          }
        }
      });
    },
    socketinvite_group: function socketinvite_group(data) {
      var _this27 = this;

      // console.log(data)
      // if (data.totokenuser !== this.token) {
      var index = _.findIndex(this.listgroup, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (index < 0) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', { group_id: data.groupid, tokenuser: data.userinvited }).then(function (response) {
          // console.log(response.data.group)
          _this27.GroupReq.unshift(response.data.group);
          _this27.GroupReq = _.orderBy(_this27.GroupReq, ['create_date'], ['asc']);
          _this27.GroupReq = _.unionBy(_this27.GroupReq, 'group_id');
        });
      }
      // }
    },
    socketcreate_group: function socketcreate_group(data) {
      var _this28 = this;

      if (data.fromtokenuser !== this.token) {
        if (_.find(this.GroupReq, function (o) {
          return o.group_id === data.groupid;
        }) === undefined) {
          this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', { group_id: data.groupid, tokenuser: data.fromtokenuser }).then(function (response) {
            _this28.GroupReq.unshift(response.data.group);
            _this28.GroupReq = _.orderBy(_this28.GroupReq, ['create_date'], ['asc']);
            _this28.GroupReq = _.unionBy(_this28.GroupReq, 'group_id');
          });
        }
      }
    },
    '$route.params.roomid': function $routeParamsRoomid() {
      this.actionF = this.$route.params.roomid;
    },
    '$i18n.locale': function $i18nLocale() {
      this.changeLangMenu();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-179546e1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/layout/Lefttest.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"leftbox ",staticStyle:{"padding":"0px"}},[_c('vue-headful',{attrs:{"title":_vm.count_read}}),_vm._v(" "),_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm2":"","md2":"","lg2":"","xl2":""}},[_c('v-container',{staticClass:"scrolling-wrapper CSChatThai",staticStyle:{"padding":"0px !important","height":"94vh"}},[_c('v-layout',{attrs:{"column":"","fluid":""}},[_c('v-list',{staticStyle:{"padding":"0px !important","background-color":"#1b232d !important","height":"94vh"},attrs:{"three-line":""}},[_c('v-list-tile',{class:_vm.menu1,staticStyle:{"padding":"0px !important"},on:{"click":function($event){_vm.selectmenu(1)}}},[_c('v-list-tile-content',{staticStyle:{"padding":"0 !important","margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"padding":"0px !important","text-align":"center","height":"44px"}},[((_vm.num_friendreq + _vm.num_groupreq) !== 0)?_c('v-badge',{attrs:{"color":"red","right":"","overlap":""}},[((_vm.num_friendreq + _vm.num_groupreq) < 100)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.num_friendreq + _vm.num_groupreq))]):_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v("99+")]),_vm._v(" "),_c('v-icon',{class:_vm.menu1,staticStyle:{"font-size":"30px !important"}},[_vm._v("person")])],1):_c('v-icon',{class:_vm.menu1,staticStyle:{"font-size":"30px !important","margin-top":"11px !important"}},[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu1,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                      "+_vm._s(_vm.$t('LeftSide.header.friend'))+"\n                    ")])])],1)],1),_vm._v(" "),_c('v-list-tile',{class:_vm.menu2,on:{"click":function($event){_vm.selectmenu(2)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('v-icon',{class:_vm.menu2,staticStyle:{"font-size":"30px !important"}},[_vm._v("chat")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu2,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                      "+_vm._s(_vm.$t('LeftSide.header.chat'))+"\n                    ")])])],1)],1),_vm._v(" "),_c('v-list-tile',{class:_vm.menu3,on:{"click":function($event){_vm.selectmenu(3)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('v-icon',{class:_vm.menu3,staticStyle:{"font-size":"30px !important"}},[_vm._v("fas fa-calendar-alt")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu3,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                      "+_vm._s(_vm.$t('LeftSide.header.calendar'))+"\n                    ")])])],1)],1),_vm._v(" "),_c('v-list-tile',{class:_vm.menu7,on:{"click":function($event){_vm.selectmenu(7)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('v-icon',{class:_vm.menu7,staticStyle:{"font-size":"30px !important"}},[_vm._v("mdi-package-variant")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu7,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                      "+_vm._s(_vm.$t('LeftSide.header.service'))+"\n                    ")])])],1)],1),_vm._v(" "),(_vm.state_organize && _vm.base_env === 'uat')?_c('v-list-tile',{class:_vm.menu8,on:{"click":function($event){_vm.selectmenu(8)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('img',{staticStyle:{"height":"30px !important"},attrs:{"src":"/static/img/icons/onemeet2.png","alt":""}})]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu8,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                     "+_vm._s(_vm.$t('LeftSide.header.onemeet'))+"\n                   ")])])],1)],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{class:_vm.menu4,staticStyle:{"bottom":"0px","position":"fixed","width":"4%"},on:{"click":function($event){_vm.selectmenu(4)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('v-icon',{class:_vm.menu4,staticStyle:{"font-size":"30px !important"}},[_vm._v("settings")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu4,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                     "+_vm._s(_vm.$t('LeftSide.header.setting'))+"\n                   ")])])],1)],1),_vm._v(" "),(_vm.typeuser=='business')?_c('v-list-tile',{class:_vm.menu5,on:{"click":function($event){_vm.selectmenu(5)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('v-icon',{class:_vm.menu5,staticStyle:{"font-size":"30px !important"}},[_vm._v("info")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu5,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                      API\n                    ")])])],1)],1):_vm._e(),_vm._v(" "),(_vm.typeuser=='business')?_c('v-list-tile',{class:_vm.menu6,on:{"click":function($event){_vm.selectmenu(6)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('v-icon',{class:_vm.menu6,staticStyle:{"font-size":"30px !important"}},[_vm._v("settings_input_antenna")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu6,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                      Broadcast\n                    ")])])],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm10":"","md10":"","lg10":"","xl10":""}},[_c('v-tabs',{staticClass:"layoutsearchweb",attrs:{"slot":"extension","fixed-tabs":"","centered":""},slot:"extension",model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab',{key:1,staticStyle:{"display":"none !important"},attrs:{"href":"#tab-1"}}),_vm._v(" "),_c('v-tab',{key:2,staticStyle:{"display":"none !important"},attrs:{"href":"#tab-2"}}),_vm._v(" "),_c('v-tab',{key:3,staticStyle:{"display":"none !important"},attrs:{"href":"#tab-3"}}),_vm._v(" "),_c('v-tab',{key:4,staticStyle:{"display":"none !important"},attrs:{"href":"#tab-4"}}),_vm._v(" "),_c('v-tab',{key:7,staticStyle:{"display":"none !important"},attrs:{"href":"#tab-7"}}),_vm._v(" "),_c('v-tab',{key:8,staticStyle:{"display":"none !important"},attrs:{"href":"#tab-8"}}),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',{attrs:{"id":"tab-1"}},[_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"padding-top":"0px"},attrs:{"dense":""}},[_c('v-container',{staticClass:"layoutsearchweb"},[_c('v-layout',{staticClass:"layoutsearchweb",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-text-field',{staticClass:"bgsearchweb CSChatThai",staticStyle:{"color":"white !important"},attrs:{"append-icon":"search","label":_vm.$t('LeftSide.searching'),"solo":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"80vh"},attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-content',{staticClass:"expansion_container"},[(_vm.GroupReq.length != 0)?_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.groupInvite'))+" ("+_vm._s(_vm.GroupReq.length)+")")]):_vm._e(),_vm._v(" "),_vm._l((_vm.GroupReq),function(item,index){return (_vm.GroupReq.length != 0)?_c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"#1b232d !important","width":"100%","cursor":"pointer"},attrs:{"two-line":"","subheader":""}},[_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"},on:{"click":function($event){_vm.showUserInGroup(item)}}},[(item.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.picture}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/group-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"},on:{"click":function($event){_vm.showUserInGroup(item)}}},[_vm._v("\n                                      "+_vm._s(item.name)+"\n                                    ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat ",on:{"click":function($event){_vm.showUserInGroup(item)}}},[_c('span',{staticClass:"fontselectchat ",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                        "+_vm._s(_vm.$t('LeftSide.friend.haveMember', {count: _vm.lengthactive(item.member)}))+"\n                                      ")])]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"CSChatThai"},[_c('v-btn',{staticClass:"btnallow",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.AcceptReq_GroupReq(item)}}},[_vm._v("\n                                          "+_vm._s(_vm.$t('AnswerQuestion.joinGroup'))+"\n                                        ")]),_vm._v(" "),_c('v-btn',{staticClass:"btncancel",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.RemoveReq_GroupReq(item)}}},[_vm._v("\n                                          "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                                        ")])],1)],1)],1)],1),_vm._v(" "),_c('v-divider')],1):_vm._e()})],2)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',{staticClass:"expansion_container"},[(_vm.FriendSendReq.length != 0)?_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.sendFriendInvite'))+" ("+_vm._s(_vm.FriendSendReq.length)+")")]):_vm._e(),_vm._v(" "),(_vm.FriendSendReq.length != 0)?_c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"#1b232d !important","width":"100%"},attrs:{"two-line":"","subheader":""}},[_vm._l((_vm.FriendSendReq),function(item,index){return [_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"}},[_vm._v("\n                                      "+_vm._s(item.name)+"\n                                    ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat "},[_c('span',{staticClass:"fontselectchat ",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                        "+_vm._s(_vm.$t('LeftSide.friend.waitingRequestFriend'))+"\n                                      ")])]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"CSChatThai"},[_c('v-btn',{staticClass:"btncancel",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.RemoveReq_FriendSendReq(item)}}},[_vm._v("\n                                         "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                                      ")])],1)],1)],1)],1),_vm._v(" "),_c('v-divider')]})],2):_vm._e()],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',{staticClass:"expansion_container"},[(_vm.FriendReq.length != 0)?_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.friendInvite'))+" ("+_vm._s(_vm.FriendReq.length)+")")]):_vm._e(),_vm._v(" "),(_vm.FriendReq.length != 0)?_c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"#1b232d !important","width":"100%"},attrs:{"two-line":"","subheader":""}},[_vm._l((_vm.FriendReq),function(item,index){return [_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"15px"}},[_vm._v("\n                                      "+_vm._s(item.name)+"\n                                    ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat "},[_c('span',{staticClass:"fontselectchat ",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                        "+_vm._s(_vm.$t('LeftSide.friend.wantToBeFriend'))+"\n                                      ")])]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"CSChatThai"},[_c('v-btn',{staticClass:"btnallow",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.AcceptReq_FriendReq(item)}}},[_vm._v("\n                                        "+_vm._s(_vm.$t('AnswerQuestion.acceptFriend'))+"\n                                      ")]),_vm._v(" "),_c('v-btn',{staticClass:"btncancel",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.RemoveReq_FriendReq(item)}}},[_vm._v("\n                                         "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                                      ")])],1)],1)],1)],1),_vm._v(" "),_c('v-divider')]})],2):_vm._e()],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',{staticClass:"expansion_container"},[(_vm.FilterFriendList.length != 0)?_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.friend'))+" ("+_vm._s(_vm.FilterFriendList.length)+")")]):_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(" "+_vm._s(_vm.$t('LeftSide.friend.friend')))]),_vm._v(" "),(!_vm.Progress.ListFriend)?_c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"#1b232d !important","width":"100%"},attrs:{"subheader":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.showDialog('AddFriend')}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"CSChatThai ",staticStyle:{"font-size":"12px","text-align":"center","color":"white"}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("add_circle")]),_vm._v("\n                                  "+_vm._s(_vm.$t('LeftSide.friend.addFriend'))+"\n                                ")],1)],1)],1),_vm._v(" "),_vm._l((_vm.FilterFriendList),function(item,index){return (_vm.FilterFriendList.length != 0)?[_c('div',{staticStyle:{"padding-top":"0px","cursor":"pointer"},attrs:{"avatar":""},on:{"click":function($event){_vm.routeChat(item)}}},[(_vm.actionF == item.tokenroom)?_c('v-list-tile',{staticClass:"selectF",attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"}},[_vm._v("\n                                      "+_vm._s(item.name)+"\n                                    ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat"},[(item.status !== '')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                        "+_vm._s(item.status)+"\n                                      ")]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile-action',[(item.type === 'bot')?_c('p',{staticStyle:{"margin-right":"2vw"}},[_c('v-badge',{attrs:{"color":"transparent"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_c('v-icon',{staticStyle:{"font-size":"14px","color":"white"}},[_vm._v("fas fa-robot")])],1)])],1):_vm._e()])],1):_c('v-list-tile',{staticClass:"nonselectF",attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"font-size":"13px","color":"white !important"}},[_vm._v("\n                                      "+_vm._s(item.name)+"\n                                    ")]),_vm._v(" "),_c('v-list-tile-sub-title',[(item.status !== '')?_c('span',{staticClass:"text--primary  ",staticStyle:{"color":"#7a7a7a !important","font-size":"10px!important"}},[_vm._v("\n                                        "+_vm._s(item.status)+"\n                                      ")]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile-action',[(item.type === 'bot')?_c('p',{staticStyle:{"margin-right":"2vw"}},[_c('v-badge',{attrs:{"color":"transparent"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_c('v-icon',{staticStyle:{"font-size":"14px"}},[_vm._v("fas fa-robot")])],1)])],1):_vm._e()])],1)],1),_vm._v(" "),_c('v-divider')]:_vm._e()})],2):_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":_vm.Progress.ListFriend}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',{staticClass:"expansion_container"},[(_vm.FilterGroupList.length != 0)?_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.group'))+" ("+_vm._s(_vm.FilterGroupList.length)+")")]):_c('b',{staticClass:"CSChatThai",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('LeftSide.friend.group')))]),_vm._v(" "),(!_vm.Progress.ListFriend)?_c('div',{attrs:{"subheader":""}},[_c('v-list',{staticStyle:{"padding-left":"0px","padding-right":"0px","background-color":"#1b232d !important","width":"100%","cursor":"pointer"},attrs:{"subheader":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.showDialog('CreateGroup')}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"CSChatThai ",staticStyle:{"font-size":"12px","text-align":"center","color":"white"}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"18px !important"}},[_vm._v("add_circle")]),_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.friend.createGroup'))+"\n                                  ")],1)],1)],1),_vm._v(" "),_vm._l((_vm.FilterGroupList),function(item,index){return (_vm.FilterGroupList.length != 0)?[_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""},on:{"click":function($event){_vm.routeChat(item)}}},[(_vm.actionF == item.tokenroom)?_c('v-list-tile',{staticClass:"selectF",attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.picture}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/group-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","padding-right":"1vw"}},[_c('v-list-tile-title',{staticClass:"fontselect ",staticStyle:{"font-size":"13px"}},[_vm._v("\n                                        "+_vm._s(item.name)+"\n                                      ")])],1)],1):_c('v-list-tile',{staticClass:"nonselectF",attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[(item.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.picture}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/group-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"font-size":"13px","color":"white !important"}},[_vm._v("\n                                        "+_vm._s(item.name)+"\n                                      ")])],1)],1)],1),_vm._v(" "),_c('v-divider')]:_vm._e()})],2)],1):_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":_vm.Progress.ListGroup}})],1)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"padding-top":"0px !important"},attrs:{"dense":""}},[_c('vue-context',{ref:"menu",staticStyle:{"z-index":"1500"}},_vm._l((_vm.ListMenuRightClick),function(list){return _c('li',[_c('a',{on:{"click":function($event){_vm.SelectMenuRightClick(list.methods)}}},[_vm._v(_vm._s(list.message))])])})),_vm._v(" "),_c('v-container',{staticClass:"layoutsearchweb"},[_c('v-layout',{staticClass:"layoutsearchweb",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-text-field',{staticClass:"bgsearchweb CSChatThai",attrs:{"append-icon":"search","label":_vm.$t('LeftSide.searching'),"solo":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(!_vm.Progress.ListChat)?_c('v-flex',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"80vh"},attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-list',{staticStyle:{"padding-left":"0px !important","padding-right":"0px","background-color":"#1b232d !important","width":"100%","cursor":"pointer"},attrs:{"two-line":"","subheader":""}},[_vm._l((_vm.FilterChatList),function(item,index){return (_vm.FilterChatList.length != 0)?[(item.is_active == 'true')?_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""},on:{"click":function($event){_vm.routeChat(item)}}},[(_vm.actionF == item.tokenroom)?_c('v-list-tile',{staticClass:"selectF",attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['pinchat'], item)}}},[(item.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.picture}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'group')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/group-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}}),_vm._v(" "),(item.pin == 'true')?_c('v-badge',{attrs:{"color":"primary"}},[_c('img',{staticClass:"img-pin",attrs:{"slot":"badge","src":"/static/img/icons/pin@3x.png","alt":""},slot:"badge"})]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-content',{on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['pinchat'], item)}}},[_c('v-list-tile-title',{staticClass:"fontselect"},[_vm._v("\n                                  "+_vm._s(item.name)+"\n                                ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat"},[(item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.leftChat'))+"\n                                  ")]):(item.typeofmessage === 'message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"},domProps:{"innerHTML":_vm._s(_vm.convertMention(item.message))}}):(item.typeofmessage === 'sticker')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendSticker'))+"\n                                  ")]):(item.typeofmessage === 'file' || item.typeofmessage === 'password_file')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendFile'))+"\n                                  ")]):(item.typeofmessage === 'location')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendLocation'))+"\n                                  ")]):(item.typeofmessage === 'contact')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendContact'))+"\n                                  ")]):(item.typeofmessage === 'image')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendPicture'))+"\n                                  ")]):(item.typeofmessage === 'note')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendNote'))+"\n                                  ")]):(item.typeofmessage === 'video')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendVideo'))+"\n                                  ")]):(item.typeofmessage === 'mention_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(item.message)+"\n                                  ")]):(item.typeofmessage === 'albums_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.createAlbum'))+"\n                                  ")]):(item.typeofmessage === 'task_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.createTask'))+"\n                                  ")]):(item.typeofmessage === 'system_action_task')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.createProject'))+"\n                                  ")]):(item.typeofmessage === 'approve_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.approveMessage'))+"\n                                  ")]):(item.typeofmessage === 'unsend_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.unsendMessage'))+"\n                                  ")]):(item.typeofmessage === 'official_template')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendOfficial_template'))+"\n                                  ")]):(item.typeofmessage === 'conference_msg')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendConference_msg'))+"\n                                  ")]):(item.typeofmessage === 'carousel')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendCarousel'))+"\n                                  ")]):(item.typeofmessage === 'system' || item.typeofmessage === 'template' || item.typeofmessage === 'date' || item.typeofmessage === 'datetime')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(item.message)+"\n                                  ")]):(item.typeofmessage === 'call')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[(item.message === 'success')?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone fa-rotate-90")]),_vm._v(" "+_vm._s(_vm.$t('LeftSide.chat.call.time'))+" "+_vm._s(_vm.secondsToHms(item.time_count))+"\n                                    ")],1):(item.message === 'decline' && item.tokenuser === _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.noResponse'))+"\n                                    ")],1):(item.message === 'decline' && item.tokenuser !== _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                                    ")],1):(item.message === 'cancle' && item.tokenuser === _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                                    ")],1):(item.message === 'cancle' && item.tokenuser !== _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.missed'))+"\n                                    ")],1):(item.message === 'cancel' && item.tokenuser === _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                                    ")],1):(item.message === 'cancel' && item.tokenuser !== _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.missed'))+"\n                                    ")],1):_vm._e()]):(item.typeofmessage === 'agora_call')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[(item.message === 'Sent agora_call' && item.time_count !== '')?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone fa-rotate-90")]),_vm._v(" "+_vm._s(_vm.$t('LeftSide.chat.call.time'))+" "+_vm._s(item.time_count)+"\n                                    ")],1):(item.message === 'Sent agora_call' && item.time_count === '' && item.tokenuser === _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                                    ")],1):(item.message === 'Sent agora_call' && item.time_count === '' && item.tokenuser !== _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.missed'))+"\n                                    ")],1):(item.message === 'Sent agora_call' && item.time_count === '' && item.tokenuser === _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                                    ")],1):(item.message === 'Sent agora_call' && item.time_count === '' && item.tokenuser !== _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.missed'))+"\n                                    ")],1):(item.message === 'end' && item.tokenuser === _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.end'))+"\n                                    ")],1):(item.message === 'end' && item.tokenuser !== _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.end'))+"\n                                    ")],1):(item.message === 'call')?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone fa-rotate-180")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.sendConference_msg'))+"\n                                    ")],1):_vm._e()]):(item.typeofmessage === 'system_action')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[(item.message === 'invite')?_c('div',[_vm._v("\n                                      "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n                                    ")]):(item.message === 'kick')?_c('div',[_vm._v("\n                                      "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n                                    ")]):(item.message === 'leave' && item.tokenuser === _vm.token)?_c('div',[_vm._v("\n                                      "+_vm._s(_vm.$t('ChatSide.system.self.leftGroup'))+"\n                                    ")]):(item.message === 'leave' && item.tokenuser !== _vm.token)?_c('div',[_vm._v("\n                                      "+_vm._s(_vm.$t('ChatSide.system.other.leftGroup', { name: item.nickname} ))+"\n                                    ")]):(item.message === 'active' && item.tokenuser === _vm.token)?_c('div',[_vm._v("\n                                      "+_vm._s(_vm.$t('ChatSide.system.self.joinGroup'))+"\n                                    ")]):(item.message === 'active' && item.tokenuser !== _vm.token)?_c('div',[_vm._v("\n                                      "+_vm._s(_vm.$t('ChatSide.system.other.joinGroup', { name: item.nickname} ))+"\n                                    ")]):_vm._e()]):(item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user' && item.typeofmessage !== 'message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px !important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.startChat'))+"\n                                  ")]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile-action',{on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['pinchat'], item)}}},[(item.timestamp != ''&& (item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user'))?_c('p',{staticStyle:{"margin-right":"0.5vw","color":"#bdbdbd !important","font-size":"11px"}},[_vm._v("\n                                  "+_vm._s(_vm.time(item.timestamp))+"\n                                ")]):_vm._e(),_vm._v(" "),(item.state == 'friend' || item.state == 'active' || item.state == 'group' || item.state == 'user')?_c('p',{staticStyle:{"margin-right":"2vw"}},[_c('v-badge',{attrs:{"color":"red"}},[(parseInt(item.count_read) >= 1000)?_c('span',{staticClass:"Kanit",staticStyle:{"font-size":"12px"},attrs:{"slot":"badge"},slot:"badge"},[_vm._v("999+")]):(item.count_read != '' && parseInt(item.count_read) != 0 && item.message != '')?_c('span',{staticClass:"Kanit",staticStyle:{"font-size":"11px","text-align":"center"},attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(item.count_read))]):_vm._e()])],1):_vm._e()])],1):_c('v-list-tile',{staticClass:"nonselectF",attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"},on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['pinchat'], item)}}},[(item.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.picture}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'group')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/group-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}}),_vm._v(" "),(item.pin == 'true')?_c('v-badge',{attrs:{"color":"primary"}},[_c('img',{staticClass:"img-pin",attrs:{"slot":"badge","src":"/static/img/icons/pin@3x.png","alt":""},slot:"badge"})]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-content',{on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['pinchat'], item)}}},[_c('v-list-tile-title',{staticClass:"nonfontselect"},[_vm._v("\n                                  "+_vm._s(item.name)+"\n                                ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"fontselectchat"},[(item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.leftChat'))+"\n                                  ")]):(item.typeofmessage === 'message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"},domProps:{"innerHTML":_vm._s(_vm.convertMention(item.message))}}):(item.typeofmessage === 'sticker')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendSticker'))+"\n                                  ")]):(item.typeofmessage === 'file' || item.typeofmessage === 'password_file')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendFile'))+"\n                                  ")]):(item.typeofmessage === 'location')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendLocation'))+"\n                                  ")]):(item.typeofmessage === 'contact')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendContact'))+"\n                                  ")]):(item.typeofmessage === 'image')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendPicture'))+"\n                                  ")]):(item.typeofmessage === 'note')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendNote'))+"\n                                  ")]):(item.typeofmessage === 'video')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendVideo'))+"\n                                  ")]):(item.typeofmessage === 'mention_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(item.message)+"\n                                  ")]):(item.typeofmessage === 'albums_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.createAlbum'))+"\n                                  ")]):(item.typeofmessage === 'task_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.createTask'))+"\n                                  ")]):(item.typeofmessage === 'system_action_task')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.createProject'))+"\n                                  ")]):(item.typeofmessage === 'approve_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.approveMessage'))+"\n                                  ")]):(item.typeofmessage === 'unsend_message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.unsendMessage'))+"\n                                  ")]):(item.typeofmessage === 'official_template')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendOfficial_template'))+"\n                                  ")]):(item.typeofmessage === 'conference_msg')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendConference_msg'))+"\n                                  ")]):(item.typeofmessage === 'carousel')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('LeftSide.chat.sendCarousel'))+"\n                                  ")]):(item.typeofmessage === 'system' || item.typeofmessage === 'template' || item.typeofmessage === 'date' || item.typeofmessage === 'datetime')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[_vm._v("\n                                    "+_vm._s(item.message)+"\n                                  ")]):(item.typeofmessage === 'call')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[(item.message === 'success')?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone fa-rotate-90")]),_vm._v(" "+_vm._s(_vm.$t('LeftSide.chat.call.time'))+" "+_vm._s(_vm.secondsToHms(item.time_count))+"\n                                    ")],1):(item.message === 'decline' && item.tokenuser === _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.noResponse'))+"\n                                    ")],1):(item.message === 'decline' && item.tokenuser !== _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                                    ")],1):(item.message === 'cancle' && item.tokenuser === _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                                    ")],1):(item.message === 'cancle' && item.tokenuser !== _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.missed'))+"\n                                    ")],1):(item.message === 'cancel' && item.tokenuser === _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                                    ")],1):(item.message === 'cancel' && item.tokenuser !== _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.missed'))+"\n                                    ")],1):_vm._e()]):(item.typeofmessage === 'agora_call')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[(item.message === 'Sent agora_call' && item.time_count !== '')?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone fa-rotate-90")]),_vm._v(" "+_vm._s(_vm.$t('LeftSide.chat.call.time'))+" "+_vm._s(item.time_count)+"\n                                    ")],1):(item.message === 'Sent agora_call' && item.time_count === '' && item.tokenuser === _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                                    ")],1):(item.message === 'Sent agora_call' && item.time_count === '' && item.tokenuser !== _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.missed'))+"\n                                    ")],1):(item.message === 'Sent agora_call' && item.time_count === '' && item.tokenuser === _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.cancel'))+"\n                                    ")],1):(item.message === 'Sent agora_call' && item.time_count === '' && item.tokenuser !== _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.missed'))+"\n                                    ")],1):(item.message === 'end' && item.tokenuser === _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.end'))+"\n                                    ")],1):(item.message === 'end' && item.tokenuser !== _vm.token)?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone-slash fa-rotate-90")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.call.end'))+"\n                                    ")],1):(item.message === 'call')?_c('div',[_c('v-icon',{staticStyle:{"font-size":"13px","color":"white","margin-right":"5px"}},[_vm._v("fas fa-phone fa-rotate-180")]),_vm._v(_vm._s(_vm.$t('LeftSide.chat.sendConference_msg'))+"\n                                    ")],1):_vm._e()]):(item.typeofmessage === 'system_action')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}},[(item.message === 'invite')?_c('div',[_vm._v("\n                                      "+_vm._s(_vm.$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n                                    ")]):(item.message === 'kick')?_c('div',[_vm._v("\n                                      "+_vm._s(_vm.$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name}))+"\n                                    ")]):(item.message === 'leave' && item.tokenuser === _vm.token)?_c('div',[_vm._v("\n                                      "+_vm._s(_vm.$t('ChatSide.system.self.leftGroup'))+"\n                                    ")]):(item.message === 'leave' && item.tokenuser !== _vm.token)?_c('div',[_vm._v("\n                                      "+_vm._s(_vm.$t('ChatSide.system.other.leftGroup', { name: item.nickname} ))+"\n                                    ")]):(item.message === 'active' && item.tokenuser === _vm.token)?_c('div',[_vm._v("\n                                      "+_vm._s(_vm.$t('ChatSide.system.self.joinGroup'))+"\n                                    ")]):(item.message === 'active' && item.tokenuser !== _vm.token)?_c('div',[_vm._v("\n                                      "+_vm._s(_vm.$t('ChatSide.system.other.joinGroup', { name: item.nickname} ))+"\n                                    ")]):_vm._e()]):(item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user' && item.typeofmessage !== 'message')?_c('span',{staticClass:"fontselectchat",staticStyle:{"font-size":"11px!important"}}):_vm._e()])],1),_vm._v(" "),_c('v-list-tile-action',{on:{"contextmenu":function($event){$event.preventDefault();_vm.RightClickDialog($event, ['pinchat'], item)}}},[(item.timestamp != '' && (item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user'))?_c('p',{staticStyle:{"margin-right":"0.5vw","color":"#bdbdbd !important","font-size":"11px"}},[_vm._v("\n                                  "+_vm._s(_vm.time(item.timestamp))+"\n                                ")]):_vm._e(),_vm._v(" "),(item.state == 'friend' || item.state == 'active' || item.state == 'group' || item.state == 'user')?_c('p',{staticStyle:{"margin-right":"2vw"}},[_c('v-badge',{attrs:{"color":"red"}},[(parseInt(item.count_read) >= 1000)?_c('span',{staticClass:"Kanit",staticStyle:{"font-size":"12px"},attrs:{"slot":"badge"},slot:"badge"},[_vm._v("999+")]):(item.count_read != '' && parseInt(item.count_read) != 0 && item.message != '')?_c('span',{staticClass:"Kanit",staticStyle:{"font-size":"11px","text-align":"center"},attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(item.count_read))]):_vm._e()])],1):_vm._e()])],1)],1):_vm._e(),_vm._v(" "),(item.is_active == 'true')?_c('v-divider'):_vm._e()]:_vm._e()})],2)],1):_c('v-flex',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"80vh"},attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-progress-linear',{attrs:{"indeterminate":_vm.Progress.ListChat}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{staticClass:"layoutsearchweb",attrs:{"id":"tab-3"}},[_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"padding-top":"0px !important"},attrs:{"dense":""}},[_c('v-container',{staticClass:"layoutsearchweb"},[_c('v-layout',{staticClass:"layoutsearchweb",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"80vh"},attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[(_vm.typeuser != 'business')?_c('v-list',{staticStyle:{"padding-left":"0px !important","padding-right":"0px","background-color":"#1b232d !important","width":"100%"},attrs:{"subheader":""}},[_vm._l((_vm.listmenutask),function(item,index){return [_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""}},[(_vm.$router.currentRoute.path == '/chat/project/'+ item.path || _vm.pathsettings == '/chat/project/'+ item.path)?_c('v-list-tile',{staticClass:"selectF",attrs:{"avatar":""},on:{"click":function($event){_vm.changepathproject(item.path)}}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[_c('v-icon',{staticStyle:{"color":"#53CEFF !important"}},[_vm._v(" "+_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"fontselect"},[_vm._v("\n                                  "+_vm._s(item.title)+"\n                                ")])],1)],1):_c('v-list-tile',{staticClass:"nonselectF",attrs:{"avatar":""},on:{"click":function($event){_vm.changepathproject(item.path)}}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[_c('v-icon',{staticStyle:{"color":"#d1d1d1 !important"}},[_vm._v(" "+_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"nonfontselect",staticStyle:{"color":"#d1d1d1 !important"}},[_vm._v("\n                                 "+_vm._s(item.title)+"\n                                ")])],1)],1)],1),_vm._v(" "),_c('v-divider')]})],2):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{staticClass:"layoutsearchweb",attrs:{"id":"tab-4"}},[_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"padding-top":"0px !important"},attrs:{"dense":""}},[_c('v-container',{staticClass:"layoutsearchweb"},[_c('v-layout',{staticClass:"layoutsearchweb",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"80vh"},attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[(_vm.typeuser != 'business')?_c('v-list',{staticStyle:{"padding-left":"0px !important","padding-right":"0px","background-color":"#1b232d !important","width":"100%"},attrs:{"subheader":""}},[_vm._l((_vm.listmenu),function(item,index){return [_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""}},[(_vm.$router.currentRoute.path == '/chat/settings/'+ item.path || _vm.pathsettings == '/chat/settings/'+ item.path)?_c('v-list-tile',{staticClass:"selectF",attrs:{"avatar":""},on:{"click":function($event){_vm.changepathsettings(item.path)}}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[_c('v-icon',{staticStyle:{"color":"#53CEFF !important"}},[_vm._v(" "+_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"fontselect"},[_vm._v("\n                                  "+_vm._s(item.title)+"\n                                ")])],1)],1):_c('v-list-tile',{staticClass:"nonselectF",attrs:{"avatar":""},on:{"click":function($event){_vm.changepathsettings(item.path)}}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[_c('v-icon',{staticStyle:{"color":"#d1d1d1 !important"}},[_vm._v(" "+_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"nonfontselect",staticStyle:{"color":"#d1d1d1 !important"}},[_vm._v("\n                                 "+_vm._s(item.title)+"\n                                ")])],1)],1)],1),_vm._v(" "),_c('v-divider')]})],2):_c('v-list',{staticStyle:{"padding-left":"0px !important","padding-right":"0px","background-color":"#1b232d !important","width":"100%"},attrs:{"subheader":""}},[_vm._l((_vm.listmenusettingapi),function(item,index){return [_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""}},[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.changepathsettings(item.path)}}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[_c('v-icon',{staticStyle:{"color":"white"}},[_vm._v(" "+_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"fontselect"},[_vm._v("\n                                  "+_vm._s(item.title)+"\n                                ")])],1)],1)],1),_vm._v(" "),_c('v-divider')]})],2)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{staticClass:"layoutsearchweb",attrs:{"id":"tab-5"}},[_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"padding-top":"0px !important"},attrs:{"dense":""}},[_c('v-container',{staticClass:"layoutsearchweb"},[_c('v-layout',{staticClass:"layoutsearchweb",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"80vh"},attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-list',{staticStyle:{"padding-left":"0px !important","padding-right":"0px","background-color":"#1b232d !important","width":"100%"},attrs:{"subheader":""}},[_vm._l((_vm.listmenuapi),function(item,index){return [_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""}},[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.changepathapi(item.path)}}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[_c('v-icon',{staticStyle:{"color":"white"}},[_vm._v(" "+_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"fontselect"},[_vm._v("\n                                  "+_vm._s(item.title)+"\n                                ")])],1)],1)],1),_vm._v(" "),_c('v-divider')]})],2)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{staticClass:"layoutsearchweb",attrs:{"id":"tab-6"}},[_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"padding-top":"0px !important"},attrs:{"dense":""}},[_c('v-container',{staticClass:"layoutsearchweb"},[_c('v-layout',{staticClass:"layoutsearchweb",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"80vh"},attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-list',{staticStyle:{"padding-left":"0px !important","padding-right":"0px","background-color":"#1b232d !important","width":"100%"},attrs:{"subheader":""}},[_vm._l((_vm.listmenubroadcast),function(item,index){return [_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""}},[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.changebroadcast(item.path)}}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[_c('v-icon',{staticStyle:{"color":"white"}},[_vm._v(" "+_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"fontselect"},[_vm._v("\n                                  "+_vm._s(item.title)+"\n                                ")])],1)],1)],1),_vm._v(" "),_c('v-divider')]})],2)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{staticClass:"layoutsearchweb",attrs:{"id":"tab-7"}},[_c('v-list',{staticClass:"layoutsearchweb",staticStyle:{"padding-top":"0px !important"},attrs:{"dense":""}},[_c('v-container',{staticClass:"layoutsearchweb"},[_c('v-layout',{staticClass:"layoutsearchweb",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"80vh"},attrs:{"xl12":"","md12":"","sm12":"","lg12":""}},[_c('v-list',{staticStyle:{"padding-left":"0px !important","padding-right":"0px","background-color":"#1b232d !important","width":"100%"},attrs:{"subheader":""}},[_vm._l((_vm.listmenuService),function(item,index){return [_c('div',{staticStyle:{"padding-top":"0px"},attrs:{"avatar":""}},[_c('v-list-tile',{class:_vm.$router.currentRoute.path ==  item.path? 'selectF':'nonselectF',attrs:{"avatar":""},on:{"click":function($event){_vm.changepathservice(item.path, item.type)}}},[_c('v-list-tile-avatar',{staticStyle:{"padding-left":"1vw","margin-right":"1vw"}},[_c('img',{attrs:{"src":item.icon}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"nonfontselect"},[_vm._v("\n                                  "+_vm._s(item.title)+"\n                                ")])],1)],1)],1),_vm._v(" "),_c('v-divider')]})],2)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('AddDialog',{attrs:{"dialogAdd":_vm.AddFriend},on:{"closeDialogAddFriend":_vm.closeDialogAddFriend,"updatelistreq":_vm.updatelistreq,"blockevent":_vm.blockevent}}),_vm._v(" "),_c('CreateGroupDialog',{attrs:{"dialogGroup":_vm.CreateGroup},on:{"closeDialogCreateGroup":_vm.closeDialogCreateGroup,"updatecreategroup":_vm.updatecreategroup,"updatelistchat":_vm.updatelistchat}}),_vm._v(" "),_c('ShowFriendDialog',{attrs:{"dialogShowfriend":_vm.ShowFriend,"showgroup":_vm.showgroup},on:{"closeDialogShowFriend":_vm.closeDialogShowFriend}}),_vm._v(" "),_c('CheckBrowserDialog',{attrs:{"checkBrowserDialog":_vm.checkBrowserDialog,"checkBrowserInfor":_vm.checkBrowserInfor},on:{"closeCheckBrowser":_vm.closeCheckBrowser}}),_vm._v(" "),_c('checkconsentOnechatDialog',{attrs:{"url_consent":_vm.url_consent,"consentOnechatDialog":_vm.consentOnechatDialog},on:{"closeDialogConsentOnechat":_vm.closeDialogConsentOnechat}}),_vm._v(" "),_c('newConsent',{attrs:{"newConsentDialog":_vm.newConsentDialog,"newConsentDetail":_vm.newConsentDetail},on:{"closeNewConsent":_vm.closeNewConsent}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var layout_Lefttest = (esExports);
// CONCATENATED MODULE: ./src/components/chat/layout/Lefttest.vue
function injectStyle (ssrContext) {
  __webpack_require__("8SS7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-179546e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Lefttest,
  layout_Lefttest,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var chat_layout_Lefttest = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UdIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Urw1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UtNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/SaveoneboxDialogMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var SaveoneboxDialogMobile = ({
  data: function data() {
    return {
      tokenuser: '',
      tokenmessage: '',
      list_account: [],
      list_folder: [],
      progress: false,
      state: false,
      account_id: ''
    };
  },

  props: {
    dialogSaveOnebox: false,
    tokenmessage_savebox: ''
  },
  watch: {
    dialogSaveOnebox: function dialogSaveOnebox() {
      this.tokenmessage = this.tokenmessage_savebox;
      var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      this.tokenuser = decoded['tokenuser'];
      this.get_account();
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.state = false;
      this.$emit('closeSaveOnebox', false);
    },
    get_mainfolder: function get_mainfolder(id) {
      var _this = this;

      this.progress = true;
      this.state = true;
      this.account_id = id;
      this.axios.post("https://uatchat-manage.one.th/event" + '/api/box/get_mainfolder_byaccountid', { account_id: this.account_id }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this.progress = false;
          _this.list_folder = response.data.data;
          // console.log(this.list_folder)
        }
      }).catch(function (error) {
        _this.progress = false;
        console.log(error);
      });
    },
    get_account: function get_account() {
      var _this2 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/api/box/get_account_byuserid', { user_id: this.tokenuser }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this2.progress = false;
          _this2.state = false;
          _this2.list_account = response.data.data;
          // console.log(this.list_account)
        }
      }).catch(function (error) {
        _this2.progress = false;
        console.log(error);
      });
    },
    save_onebox: function save_onebox(id) {
      var _this3 = this;

      this.$swal({
        type: 'warning',
        title: '<div class="CSChatThai" style="font-size: 16px;">' + this.$t('Alert.Saveonebox') + '</div>',
        confirmButtonColor: '#2562af',
        confirmButtonText: '<div class="CSChatThai" style="font-size: 14px;">' + this.$t('AnswerQuestion.ok') + '</div>',
        cancelButtonColor: '#9f9f9f',
        cancelButtonText: '<div class="CSChatThai" style="font-size: 14px;">' + this.$t('AnswerQuestion.cancel') + '</div>',
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this3.axios.post("https://uatchat-manage.one.th/event" + '/api/box/savefile', { account_id: _this3.account_id, folder_id: id, tokenmessage: _this3.tokenmessage_savebox }).then(function (response) {
            // console.log(response.data)
            if (response.data.status === 'success') {
              _this3.$swal(_this3.$t('Alert.Success.sending'), _this3.$t('Alert.Success.sendFile'), 'success');
              _this3.$emit('closeSaveOnebox', false);
            }
          }).catch(function (error) {
            _this3.progress = false;
            _this3.$swal('', _this3.$t('Alert.Unsavefile'), 'warning');
            // this.$swal('', 'ไฟล์นี้ถูกบันทึกแล้ว ไม่สามารถบันทึกไฟล์ซ้ำได้', 'warning')
            console.log(error);
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49e90080","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/SaveoneboxDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"max-width":"500px","max-height":"500px","persistent":""},model:{value:(_vm.dialogSaveOnebox),callback:function ($$v) {_vm.dialogSaveOnebox=$$v},expression:"dialogSaveOnebox"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[(!_vm.state)?_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-user-circle")]),_vm._v(" "),_c('span',{staticClass:"font-size14"},[_vm._v(_vm._s(_vm.$t('Dialog.Saveonebox.titleaccount')))])],1):_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-folder")]),_vm._v(" "),_c('span',{staticClass:"font-size14"},[_vm._v(_vm._s(_vm.$t('Dialog.Saveonebox.titlefolder')))])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),(_vm.state)?_c('v-card-title',[_c('v-btn',{staticClass:"color-grey",attrs:{"round":"","flat":"","small":"","color":"white"},on:{"click":function($event){_vm.state = !_vm.state}}},[_c('v-icon',{staticClass:"pr-2",attrs:{"color":"primary"}},[_vm._v("fas fa-chevron-left")]),_vm._v("\n        "+_vm._s(_vm.$t('Task.allTask.back'))+"\n      ")],1)],1):_vm._e(),_vm._v(" "),(!_vm.state)?_c('v-card-text',{staticStyle:{"padding":"0","height":"250px !important","overflow-y":"scroll"}},[(_vm.progress)?_c('v-layout',{staticStyle:{"height":"250px"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"size":"50","indeterminate":_vm.progress,"color":"primary"}})],1):_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.list_account),function(item,index){return [_c('v-list-tile',{key:index,staticClass:"cursor-pointer",on:{"click":function($event){_vm.get_mainfolder(item.account_id)}}},[_c('v-list-tile-avatar',[_c('img',{staticClass:"border-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-size14",domProps:{"innerHTML":_vm._s(item.account_name)}})],1)],1),_vm._v(" "),(index + 1 < _vm.list_account.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1):_c('v-card-text',{staticStyle:{"padding":"0","height":"200px !important","overflow-y":"scroll"}},[(_vm.progress)?_c('v-layout',{staticStyle:{"height":"170px"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"size":"50","indeterminate":_vm.progress,"color":"primary"}})],1):_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.list_folder),function(item,index){return [_c('v-list-tile',{key:item.folder_id,staticClass:"cursor-pointer",on:{"click":function($event){_vm.save_onebox(item.folder_id)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fas fa-folder-open")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-size14",domProps:{"innerHTML":_vm._s(item.folder_name)}})],1)],1),_vm._v(" "),(index + 1 < _vm.list_folder.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_SaveoneboxDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/SaveoneboxDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("/vcd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49e90080"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  SaveoneboxDialogMobile,
  dialog_SaveoneboxDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_SaveoneboxDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VFen":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W4Xu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _ = __webpack_require__("M4fF");

/* harmony default export */ __webpack_exports__["a"] = ({
  props: { dialogCreatealbums: false, tokenroom: '' },
  data: function data() {
    return {
      token: '',
      files: [],
      albumsname: '',
      loading: false,
      borderinputfile: 'text-align:center;border: 1px solid #00000036; border-radius: 5px; width: 100px !important; height: 100px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 23px;',
      normal: 'text-align:center; border-radius: 5px; width: 100px !important; height: 100px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 23px;',
      dragAndDropCapable: false
    };
  },
  created: function created() {
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },
  mounted: function mounted() {
    this.dragAndDropCapable = this.determineDragAndDropCapable();
    var me = this;
    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
        this.$refs.fileform.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }.bind(this));
      this.$refs.fileform.addEventListener('dragover', function (e) {
        this.borderinputfile = this.normal + 'border: 2px dotted #00000036;';
      }.bind(this));
      this.$refs.fileform.addEventListener('dragleave', function (e) {
        this.borderinputfile = this.normal + 'border: 1px solid #00000036;';
      }.bind(this));
      this.$refs.fileform.addEventListener('drop', function (e) {
        for (var i = 0; i < e.dataTransfer.files.length; i++) {
          this.files.push({ file: e.dataTransfer.files[i], status: 'waiting' });
          this.getImagePreviews();
          this.borderinputfile = this.normal + 'border: 1px solid #00000036;';
          // }
        }
      }.bind(this));
    }
  },

  methods: {
    determineDragAndDropCapable: function determineDragAndDropCapable() {
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
    },
    uppic: function uppic() {
      $('#files').click();
    },
    closeDialog: function closeDialog() {
      this.files = [];
      this.albumsname = '';
      this.$emit('closeCreatealbums', false);
    },
    createalbums: function createalbums() {
      var _this = this;

      // console.log(this.files)
      var formData = new FormData();
      var lengthfile = this.files.length;
      var sizealums = [];
      for (var i = 0; i < lengthfile; i++) {
        var file = this.files[i].file;
        formData.append('file[]', file, file.name);
        // console.log(this.files[i].file.size)
        sizealums[i] = this.files[i].file.size;
      }
      // console.log(_.sum(sizealums)/ 1024 / 1024)
      if (_.sum(sizealums) / 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Album.maxSizeFile'), type: 'warning' });
        this.files = [];
        this.loading = false;
      } else {
        this.loading = true;
        formData.append('tokenuser', this.token);
        formData.append('tokenroom', this.$route.params.roomid);
        formData.append('albums_name', this.albumsname);
        this.axios.post("https://uatchat-manage.one.th/event" + '/create_album', formData).then(function (response) {
          // console.log(response.data.data)
          _this.loading = false;
          var infoalbums = {};
          infoalbums = response.data.data.albums;
          // console.log(infoalbums)
          _this.$swal('', _this.$t('Alert.Success.createAlbum'), 'success');
          _this.$emit('CreateAlbums', response.data.status, infoalbums);
          _this.files = [];
          _this.albumsname = '';
          _this.$emit('closeCreatealbums', false);
        }, function () {
          _this.loading = false;
          _this.$swal('', _this.$t('Alert.Fail.default.somethingWrong'), 'error');
        });
      }
    },
    extension: function extension(files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase();
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
      var pdf = ['pdf'];
      var file = ['ai', 'ps', 'psd'];
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm'];
      var presentation = ['ppt', 'pps', 'pot', 'pptx'];
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff'];
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf';
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive';
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel';
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint';
      } else if (word.includes(extension)) {
        return 'fas fa-file-word';
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code';
      } else if (image.includes(extension)) {
        return 'fas fa-file-image';
      } else if (file.includes(extension)) {
        return 'fas fa-file';
      } else {
        return 'fas fa-file-alt';
      }
      // return extension[extension.length-1]
    },
    handleFilesUpload: function handleFilesUpload(key) {
      var uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({
          file: uploadedFiles[i],
          status: 'waiting'
        });
      }
      this.getImagePreviews(key);
      document.querySelector('#files').value = '';
    },
    removeFile: function removeFile(key) {
      this.files.splice(key, 1);
      this.getImagePreviews(key);
    },
    getImagePreviews: function getImagePreviews(key) {
      var _this2 = this;

      console.log('getImagePreviews-----');

      var _loop = function _loop(i) {
        if (/\.(jpe?g|png|gif)$/i.test(_this2.files[i].file.name)) {
          var reader = new FileReader();
          reader.addEventListener('load', function () {
            this.$refs['preview' + parseInt(i)][0].src = reader.result;
          }.bind(_this2), false);
          reader.readAsDataURL(_this2.files[i].file);
        } else {
          _this2.removeFile(i);
          alert(_this2.$t('Alert.Fail.Album.supportType'));
        }
      };

      for (var i = 0; i < this.files.length; i++) {
        _loop(i);
      }
    }
  },
  watch: {
    files: function files() {
      if (this.files.length > 5) {
        this.$swal('', this.$t('Alert.Fail.Album.maxFiles'), 'warning');
        _.pullAt(this.files, [5]);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "W9jF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__xkeshi_vue_qrcode__ = __webpack_require__("8Vd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_qrcode_reader__ = __webpack_require__("ikHa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_qrcode_reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_qrcode_reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_chat_dialog_settings_Openwebsite__ = __webpack_require__("gDCn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_4__xkeshi_vue_qrcode__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__xkeshi_vue_qrcode__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'dialogShowQRCode': false,
    'typemenu': String,
    'tokenroom': String,
    'QrcodeInfor': {}
  },
  data: function data() {
    return {
      active_tab: 'tab-1',
      token: '',
      name: '',
      tokenuserQR: '',
      error: '',
      result: '',
      camera: false,
      dialogopenwebsite: false,
      id: '',
      type: '',
      type_menu: ''
    };
  },
  watch: {
    dialogShowQRCode: function dialogShowQRCode() {
      this.type_menu = this.typemenu;
      if (this.dialogShowQRCode) {
        if (this.typemenu === 'richmenu') {
          this.active_tab = 'tab-2';
          this.camera = true;
          // console.log(this.typemenu)
        } else {
          this.active_tab = 'tab-1';
          // console.log(this.typemenu)
        }
      }
    },
    active_tab: function active_tab() {
      // console.log(this.active_tab)
      if (this.active_tab === 'tab-2') {
        this.camera = true;
      } else {
        this.camera = false;
      }
    }
  },
  methods: {
    upfileqrcode: function upfileqrcode() {
      $('#qrcode-capture').click();
    },
    closeDialog: function closeDialog() {
      this.camera = false;
      this.dialogopenwebsite = false;
      this.result = '';
      this.id = '';
      this.type = '';
      this.$emit('closeShowQRCodeUser', false);
    },
    loadqr: function loadqr() {
      var cnvs = document.getElementById('downloadqruser');
      var button = document.getElementById('btn-download');
      var dataURL = cnvs.toDataURL('image/png');
      button.href = dataURL;
    },
    checkonechat: function checkonechat(url) {
      var _this = this;

      if (url.includes("https://uatchat.one.th" + '/qrcode/friend?id=')) {
        var code = url.split("https://uatchat.one.th" + '/qrcode/friend?id=');
        this.id = atob(code[1]);
        this.type = 'friend';
        this.dialogopenwebsite = true;
        this.$emit('closeShowQRCodeUser', false);
      } else if (url.includes("https://uatchat.one.th" + '/qrcode/group?id=')) {
        var code = url.split("https://uatchat.one.th" + '/qrcode/group?id=');
        this.id = atob(code[1]);
        this.type = 'group';
        this.dialogopenwebsite = true;
        this.$emit('closeShowQRCodeUser', false);
      } else {
        this.$emit('closeShowQRCodeUser', false);
        this.$swal({
          text: 'ผลการสแกน ' + url,
          showCancelButton: true,
          confirmButtonColor: '#2562af',
          cancelButtonColor: '#9f9f9f',
          confirmButtonText: 'เปิด',
          cancelButtonText: 'ยกเลิก',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then(function (result) {
          if (result.value) {
            window.open(url);
            _this.closeDialog();
          } else {
            _this.closeDialog();
          }
        });
      }
    },
    onDecode: function onDecode(result) {
      // console.log(result)
      // console.log(this.type_menu)
      this.result = result;
      if (result != '' && this.type_menu !== 'richmenu') {
        this.checkonechat(result);
        this.camera = false;
      } else if (this.type_menu === 'richmenu') {
        this.sendScanQrcode(result);
      }
    },
    sendScanQrcode: function sendScanQrcode(url) {
      var _this2 = this;

      if (this.QrcodeInfor.status === 'false') {
        this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/qrcode-scan', {
          tokenuser: this.token,
          tokenroom: this.tokenroom,
          data: url
        }).then(function (response) {
          // console.log(response.data)
          if (response.data.status === 'success') {
            _this2.$swal('', _this2.$t('Alert.Success.success'), 'success');
            _this2.closeDialog();
          }
        }).catch(function (error) {
          console.log(error);
          _this2.$swal('Network error', _this2.$t('Alert.Fail.default.networkError'), 'error');
        });
      } else {
        this.axios.post(Object({"NODE_ENV":"uat","API":"https://uatchat.one.th","APIQRcode":"https://uatchat.one.th","APIpub":"https://uatchat-manage.one.th/event","APIimage":"https://uatchat-manage.one.th/message","APIsocket":"https://uatchat-public.one.th:8998","APImanage":"https://uatchat-manage.one.th/manage","ONEID_API":"https://testoneid.inet.co.th/api","WEBchatdev":"https://uatchat.one.th:8089/docs","Bot_idPaperless":"B0df132b88f9a526691a0576bfdb24196","Bot_idcovid":"Bbe2c9fe1bcc956738a61c9ad0d91cb19","taxid_consent":"0107544000094","serviceid_consent":"SVC-1611218040238","formid_consent":"600956682f8678001cce54e8","AuthenOneid":"https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect","LogoutOneid":"https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage","redirect_url":"https://uatchat.one.th/authorization/redirect","Market_env":"staging","APInew_listchat":"https://uatchat-manage.one.th/go_api/api/v4/getListChat","APInew_getdict":"https://uatchat-manage.one.th/alpine/api/v1/getdictmessage","APInew_pushmessage":"https://uatchat-manage.one.th/alpine/api/v1/pushMessage","APInew_getaccesstoken":"https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken","APInew_getrichmenu":"https://uatchat-manage.one.th/go_api/api/v1/getRichmenuByTokenroom","APInew_addfriend":"https://uatchat-manage.one.th/go_api/api/v1/add-friend","APIcheck_consent":"https://uatapigw.appsdigit.inet.co.th/api/chat/service/check-consent","APInew_pushvideo":"https://uatchat-manage.one.th/media/api/v1/send-video","APInew_acceptfriend":"https://uatchat-manage.one.th/go_api/api/v1/accept-friend","APInew_creategroup":"https://uatchat-manage.one.th/go_api/api/v1/create-group","APIalpine":"https://uatchat-manage.one.th/alpine","APIgo_api":"https://uatchat-manage.one.th/go_api/api","WEBoneEmail":"https://testoneid.inet.co.th/preauth","WEBoneBox":"https://testoneid.inet.co.th/oauth/authorize?client_id=155&response_type=code&scope=account","WEBNews":"https://news.chat.korkla.in/checkauthen?authen=","WEB_Redirect_Onebox":"https://uatbox.one.th/loginbysharetoken?token=","WebAnonymous":"https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token=","Savelognews":"https://news.chat.one.th/backend/api/v1/page-analytics","urlEkyc":"https://uat-ekyc.id.th/redirect-share-token?shared_token=","linkonemeet":"https://meet-test.one.th/?sharetoken=","API_onemeet":"https://meet-test.one.th/","WEB_centrifuge":"wss://uatchat-manage.one.th/connection/websocket","centrifuge_key":'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs',"APIsearchfriend":"https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend","urlLoa":"https://testoneid.inet.co.th/login?redirect_url=https://testoneid.inet.co.th/portal_level&shared_token=","check_password":"https://uatchat-manage.one.th/bot-message/check"}).APIQRcodeLoation, {
          tokenuser: this.token,
          tokenroom: this.tokenroom,
          data: url,
          lat: this.QrcodeInfor.lat,
          long: this.QrcodeInfor.lng,
          address: this.QrcodeInfor.address
        }).then(function (response) {
          // console.log(response.data)
          if (response.data.status === 'success') {
            _this2.$swal('', _this2.$t('Alert.Success.success'), 'success');
            _this2.closeDialog();
          }
        }).catch(function (error) {
          console.log(error);
          _this2.$swal('Network error', _this2.$t('Alert.Fail.default.networkError'), 'error');
        });
      }
    },
    onInit: function onInit(promise) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return promise;

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context['catch'](0);

                if (_context.t0.name === 'NotAllowedError') {
                  _this3.error = "ERROR: you need to grant camera access permisson";
                } else if (_context.t0.name === 'NotFoundError') {
                  _this3.error = "ERROR: no camera on this device";
                } else if (_context.t0.name === 'NotSupportedError') {
                  _this3.error = "ERROR: secure context required (HTTPS, localhost)";
                } else if (_context.t0.name === 'NotReadableError') {
                  _this3.error = "ERROR: is the camera already in use?";
                } else if (_context.t0.name === 'OverconstrainedError') {
                  _this3.error = "ERROR: installed cameras are not suitable";
                } else if (_context.t0.name === 'StreamApiNotSupportedError') {
                  _this3.error = "ERROR: Stream API is not supported in this browser";
                }

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 5]]);
      }))();
    }
  },
  components: {
    QrcodeStream: __WEBPACK_IMPORTED_MODULE_5_vue_qrcode_reader__["QrcodeStream"],
    Openwebsite: __WEBPACK_IMPORTED_MODULE_6__components_chat_dialog_settings_Openwebsite__["a" /* default */],
    QrcodeCapture: __WEBPACK_IMPORTED_MODULE_5_vue_qrcode_reader__["QrcodeCapture"]
  },
  created: function created() {
    this.name = localStorage.getItem('name');
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.tokenuserQR = "https://uatchat.one.th" + '/qrcode/friend?id=' + btoa(this.token);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "WC/7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WJD3":
/***/ (function(module, exports) {

module.exports = {"People":{"smile":"😄","smiley":"😃","grinning":"😀","blush":"😊","wink":"😉","heart_eyes":"😍","kissing_heart":"😘","kissing_closed_eyes":"😚","kissing":"😗","kissing_smiling_eyes":"😙","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","flushed":"😳","grin":"😁","pensive":"😔","relieved":"😌","unamused":"😒","disappointed":"😞","persevere":"😣","cry":"😢","joy":"😂","sob":"😭","sleepy":"😪","disappointed_relieved":"😥","cold_sweat":"😰","sweat_smile":"😅","sweat":"😓","weary":"😩","tired_face":"😫","fearful":"😨","scream":"😱","angry":"😠","rage":"😡","triumph":"😤","confounded":"😖","laughing":"😆","yum":"😋","mask":"😷","sunglasses":"😎","sleeping":"😴","dizzy_face":"😵","astonished":"😲","worried":"😟","frowning":"😦","anguished":"😧","imp":"👿","open_mouth":"😮","grimacing":"😬","neutral_face":"😐","confused":"😕","hushed":"😯","smirk":"😏","expressionless":"😑","man_with_gua_pi_mao":"👲","man_with_turban":"👳","cop":"👮","construction_worker":"👷","guardsman":"💂","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","older_man":"👴","older_woman":"👵","person_with_blond_hair":"👱","angel":"👼","princess":"👸","smiley_cat":"😺","smile_cat":"😸","heart_eyes_cat":"😻","kissing_cat":"😽","smirk_cat":"😼","scream_cat":"🙀","crying_cat_face":"😿","joy_cat":"😹","pouting_cat":"😾","japanese_ogre":"👹","japanese_goblin":"👺","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","skull":"💀","alien":"👽","hankey":"💩","fire":"🔥","sparkles":"✨","star2":"🌟","dizzy":"💫","boom":"💥","anger":"💢","sweat_drops":"💦","droplet":"💧","zzz":"💤","dash":"💨","ear":"👂","eyes":"👀","nose":"👃","tongue":"👅","lips":"👄","thumbs_up":"👍","-1":"👎","ok_hand":"👌","facepunch":"👊","fist":"✊","wave":"👋","hand":"✋","open_hands":"👐","point_up_2":"👆","point_down":"👇","point_right":"👉","point_left":"👈","raised_hands":"🙌","pray":"🙏","clap":"👏","muscle":"💪","walking":"🚶","runner":"🏃","dancer":"💃","couple":"👫","family":"👪","couplekiss":"💏","couple_with_heart":"💑","dancers":"👯","ok_woman":"🙆","no_good":"🙅","information_desk_person":"💁","raising_hand":"🙋","massage":"💆","haircut":"💇","nail_care":"💅","bride_with_veil":"👰","person_with_pouting_face":"🙎","person_frowning":"🙍","bow":"🙇","tophat":"🎩","crown":"👑","womans_hat":"👒","athletic_shoe":"👟","mans_shoe":"👞","sandal":"👡","high_heel":"👠","boot":"👢","shirt":"👕","necktie":"👔","womans_clothes":"👚","dress":"👗","running_shirt_with_sash":"🎽","jeans":"👖","kimono":"👘","bikini":"👙","briefcase":"💼","handbag":"👜","pouch":"👝","purse":"👛","eyeglasses":"👓","ribbon":"🎀","closed_umbrella":"🌂","lipstick":"💄","yellow_heart":"💛","blue_heart":"💙","purple_heart":"💜","green_heart":"💚","broken_heart":"💔","heartpulse":"💗","heartbeat":"💓","two_hearts":"💕","sparkling_heart":"💖","revolving_hearts":"💞","cupid":"💘","love_letter":"💌","kiss":"💋","ring":"💍","gem":"💎","bust_in_silhouette":"👤","speech_balloon":"💬","footprints":"👣"},"Nature":{"dog":"🐶","wolf":"🐺","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","frog":"🐸","tiger":"🐯","koala":"🐨","bear":"🐻","pig":"🐷","pig_nose":"🐽","cow":"🐮","boar":"🐗","monkey_face":"🐵","monkey":"🐒","horse":"🐴","sheep":"🐑","elephant":"🐘","panda_face":"🐼","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatched_chick":"🐥","hatching_chick":"🐣","chicken":"🐔","snake":"🐍","turtle":"🐢","bug":"🐛","bee":"🐝","ant":"🐜","beetle":"🐞","snail":"🐌","octopus":"🐙","shell":"🐚","tropical_fish":"🐠","fish":"🐟","dolphin":"🐬","whale":"🐳","racehorse":"🐎","dragon_face":"🐲","blowfish":"🐡","camel":"🐫","poodle":"🐩","feet":"🐾","bouquet":"💐","cherry_blossom":"🌸","tulip":"🌷","four_leaf_clover":"🍀","rose":"🌹","sunflower":"🌻","hibiscus":"🌺","maple_leaf":"🍁","leaves":"🍃","fallen_leaf":"🍂","herb":"🌿","ear_of_rice":"🌾","mushroom":"🍄","cactus":"🌵","palm_tree":"🌴","chestnut":"🌰","seedling":"🌱","blossom":"🌼","new_moon":"🌑","first_quarter_moon":"🌓","moon":"🌔","full_moon":"🌕","first_quarter_moon_with_face":"🌛","crescent_moon":"🌙","earth_asia":"🌏","volcano":"🌋","milky_way":"🌌","stars":"🌠","partly_sunny":"⛅","snowman":"⛄","cyclone":"🌀","foggy":"🌁","rainbow":"🌈","ocean":"🌊"},"Objects":{"bamboo":"🎍","gift_heart":"💝","dolls":"🎎","school_satchel":"🎒","mortar_board":"🎓","flags":"🎏","fireworks":"🎆","sparkler":"🎇","wind_chime":"🎐","rice_scene":"🎑","jack_o_lantern":"🎃","ghost":"👻","santa":"🎅","christmas_tree":"🎄","gift":"🎁","tanabata_tree":"🎋","tada":"🎉","confetti_ball":"🎊","balloon":"🎈","crossed_flags":"🎌","crystal_ball":"🔮","movie_camera":"🎥","camera":"📷","video_camera":"📹","vhs":"📼","cd":"💿","dvd":"📀","minidisc":"💽","floppy_disk":"💾","computer":"💻","iphone":"📱","telephone_receiver":"📞","pager":"📟","fax":"📠","satellite":"📡","tv":"📺","radio":"📻","loud_sound":"🔊","bell":"🔔","loudspeaker":"📢","mega":"📣","hourglass_flowing_sand":"⏳","hourglass":"⌛","alarm_clock":"⏰","watch":"⌚","unlock":"🔓","lock":"🔒","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","key":"🔑","mag_right":"🔎","bulb":"💡","flashlight":"🔦","electric_plug":"🔌","battery":"🔋","mag":"🔍","bath":"🛀","toilet":"🚽","wrench":"🔧","nut_and_bolt":"🔩","hammer":"🔨","door":"🚪","smoking":"🚬","bomb":"💣","gun":"🔫","hocho":"🔪","pill":"💊","syringe":"💉","moneybag":"💰","yen":"💴","dollar":"💵","credit_card":"💳","money_with_wings":"💸","calling":"📲","e-mail":"📧","inbox_tray":"📥","outbox_tray":"📤","envelope_with_arrow":"📩","incoming_envelope":"📨","mailbox":"📫","mailbox_closed":"📪","postbox":"📮","package":"📦","memo":"📝","page_facing_up":"📄","page_with_curl":"📃","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","scroll":"📜","clipboard":"📋","date":"📅","calendar":"📆","card_index":"📇","file_folder":"📁","open_file_folder":"📂","pushpin":"📌","paperclip":"📎","straight_ruler":"📏","triangular_ruler":"📐","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","books":"📚","book":"📖","bookmark":"🔖","name_badge":"📛","newspaper":"📰","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_note":"🎵","notes":"🎶","musical_keyboard":"🎹","violin":"🎻","trumpet":"🎺","saxophone":"🎷","guitar":"🎸","space_invader":"👾","video_game":"🎮","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄","game_die":"🎲","dart":"🎯","football":"🏈","basketball":"🏀","soccer":"⚽","baseball":"⚾","tennis":"🎾","8ball":"🎱","bowling":"🎳","golf":"⛳","checkered_flag":"🏁","trophy":"🏆","ski":"🎿","snowboarder":"🏂","swimmer":"🏊","surfer":"🏄","fishing_pole_and_fish":"🎣","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","cocktail":"🍸","tropical_drink":"🍹","wine_glass":"🍷","fork_and_knife":"🍴","pizza":"🍕","hamburger":"🍔","fries":"🍟","poultry_leg":"🍗","meat_on_bone":"🍖","spaghetti":"🍝","curry":"🍛","fried_shrimp":"🍤","bento":"🍱","sushi":"🍣","fish_cake":"🍥","rice_ball":"🍙","rice_cracker":"🍘","rice":"🍚","ramen":"🍜","stew":"🍲","oden":"🍢","dango":"🍡","egg":"🍳","bread":"🍞","doughnut":"🍩","custard":"🍮","icecream":"🍦","ice_cream":"🍨","shaved_ice":"🍧","birthday":"🎂","cake":"🍰","cookie":"🍪","chocolate_bar":"🍫","candy":"🍬","lollipop":"🍭","honey_pot":"🍯","apple":"🍎","green_apple":"🍏","tangerine":"🍊","cherries":"🍒","grapes":"🍇","watermelon":"🍉","strawberry":"🍓","peach":"🍑","melon":"🍈","banana":"🍌","pineapple":"🍍","sweet_potato":"🍠","eggplant":"🍆","tomato":"🍅","corn":"🌽"},"Places":{"house":"🏠","house_with_garden":"🏡","school":"🏫","office":"🏢","post_office":"🏣","hospital":"🏥","bank":"🏦","convenience_store":"🏪","love_hotel":"🏩","hotel":"🏨","wedding":"💒","church":"⛪","department_store":"🏬","city_sunrise":"🌇","city_sunset":"🌆","japanese_castle":"🏯","european_castle":"🏰","tent":"⛺","factory":"🏭","tokyo_tower":"🗼","japan":"🗾","mount_fuji":"🗻","sunrise_over_mountains":"🌄","sunrise":"🌅","night_with_stars":"🌃","statue_of_liberty":"🗽","bridge_at_night":"🌉","carousel_horse":"🎠","ferris_wheel":"🎡","fountain":"⛲","roller_coaster":"🎢","ship":"🚢","boat":"⛵","speedboat":"🚤","rocket":"🚀","seat":"💺","station":"🚉","bullettrain_side":"🚄","bullettrain_front":"🚅","metro":"🚇","railway_car":"🚃","bus":"🚌","blue_car":"🚙","car":"🚗","taxi":"🚕","truck":"🚚","rotating_light":"🚨","police_car":"🚓","fire_engine":"🚒","ambulance":"🚑","bike":"🚲","barber":"💈","busstop":"🚏","ticket":"🎫","traffic_light":"🚥","construction":"🚧","beginner":"🔰","fuelpump":"⛽","izakaya_lantern":"🏮","slot_machine":"🎰","moyai":"🗿","circus_tent":"🎪","performing_arts":"🎭","round_pushpin":"📍","triangular_flag_on_post":"🚩"},"Symbols":{"100":"💯","1234":"🔢","keycap_ten":"🔟","symbols":"🔣","capital_abcd":"🔠","abcd":"🔡","abc":"🔤","arrow_up_small":"🔼","arrow_down_small":"🔽","rewind":"⏪","fast_forward":"⏩","arrow_double_up":"⏫","arrow_double_down":"⏬","ok":"🆗","new":"🆕","up":"🆙","cool":"🆒","free":"🆓","ng":"🆖","signal_strength":"📶","cinema":"🎦","koko":"🈁","u6307":"🈯","u7a7a":"🈳","u6e80":"🈵","u5408":"🈴","u7981":"🈲","ideograph_advantage":"🉐","u5272":"🈹","u55b6":"🈺","u6709":"🈶","u7121":"🈚","restroom":"🚻","mens":"🚹","womens":"🚺","baby_symbol":"🚼","wc":"🚾","no_smoking":"🚭","u7533":"🈸","accept":"🉑","cl":"🆑","sos":"🆘","id":"🆔","no_entry_sign":"🚫","underage":"🔞","no_entry":"⛔","negative_squared_cross_mark":"❎","white_check_mark":"✅","heart_decoration":"💟","vs":"🆚","vibration_mode":"📳","mobile_phone_off":"📴","ab":"🆎","diamond_shape_with_a_dot_inside":"💠","ophiuchus":"⛎","six_pointed_star":"🔯","atm":"🏧","chart":"💹","heavy_dollar_sign":"💲","currency_exchange":"💱","x":"❌","exclamation":"❗","question":"❓","grey_exclamation":"❕","grey_question":"❔","o":"⭕","top":"🔝","end":"🔚","back":"🔙","on":"🔛","soon":"🔜","arrows_clockwise":"🔃","clock12":"🕛","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","white_flower":"💮","radio_button":"🔘","link":"🔗","curly_loop":"➰","trident":"🔱","small_red_triangle":"🔺","black_square_button":"🔲","white_square_button":"🔳","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle_down":"🔻","white_large_square":"⬜","black_large_square":"⬛","large_orange_diamond":"🔶","large_blue_diamond":"🔷","small_orange_diamond":"🔸","small_blue_diamond":"🔹"}}

/***/ }),

/***/ "WNQp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WWt4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./src/components/chat/dialog/manage_friend/AddFriendDialog.vue + 2 modules
var AddFriendDialog = __webpack_require__("sSPP");

// EXTERNAL MODULE: ./src/components/chat/dialog/manage_group/CreateGroupDialog.vue + 1 modules
var CreateGroupDialog = __webpack_require__("sHvA");

// EXTERNAL MODULE: ./src/components/chat/dialog/manage_group/ShowFriendDialog.vue + 1 modules
var ShowFriendDialog = __webpack_require__("pZ8M");

// EXTERNAL MODULE: ./src/components/chat/dialog/CheckBrowserDialog.vue + 2 modules
var CheckBrowserDialog = __webpack_require__("Se0g");

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./node_modules/vue-context/dist/js/vue-context.js
var vue_context = __webpack_require__("IaZh");
var vue_context_default = /*#__PURE__*/__webpack_require__.n(vue_context);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-headful/dist/vue-headful.js
var vue_headful = __webpack_require__("WiKS");
var vue_headful_default = /*#__PURE__*/__webpack_require__.n(vue_headful);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/onemeet/LefttestOnemeet.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











vue_esm["default"].component('vue-headful', vue_headful_default.a);

var _ = __webpack_require__("M4fF");

/* harmony default export */ var LefttestOnemeet = ({
  data: function data() {
    return {
      // ProgressListChat: false,
      // ProgressListFriend: false,
      // ProgressListGroup: false,
      checkBrowserDialog: false,
      checkBrowserInfor: {},
      SelectedMessageDetail: {},
      ListMenuRightClick: [],
      rightclickdialog: false,
      Progress: {
        ListChat: false,
        ListFriend: false,
        ListGroup: false
      },
      search: '',
      listfriend: [],
      listgroup: [],
      listchat: [],
      tabs: null,
      AddFriend: false,
      ShowFriend: false,
      block: false,
      CreateGroup: false,
      actionF: '',
      token: '',
      listmenusettingapi: [{
        title: 'ส่งไฟล์ไป One box',
        icon: 'file_upload',
        path: 'onebox'
      }, {
        title: 'ข้อเสนอแนะ',
        icon: 'feedback',
        path: 'feedback'
      }, {
        title: 'ศูนย์ช่วยเหลือ',
        icon: 'contact_support',
        path: 'contact_support'
      }, {
        title: 'นโยบายความเป็นส่วนตัว',
        icon: 'book',
        path: 'private_policy'
      }],
      listmenutask: [],
      listmenu: [],
      listmenuService: [{
        title: 'OneEmail',
        icon: '/static/img/oneplatform/oneemail2.png',
        path: "https://testoneid.inet.co.th/preauth",
        type: 'link'
      }, {
        title: 'OneBox',
        icon: '/static/img/oneplatform/onebox.png',
        path: "https://testoneid.inet.co.th/oauth/authorize?client_id=155&response_type=code&scope=account",
        type: 'share_token_onebox'
      }, {
        title: 'OneChat News',
        icon: '/static/img/oneplatform/onechat_news.jpg',
        path: "https://news.chat.korkla.in/checkauthen?authen=",
        type: 'function_news'
      }, {
        title: 'One Anonymous',
        icon: '/static/img/oneplatform/anonymousone.png',
        path: '/anonymousone_group',
        type: 'route'
        // {
        //   title: 'Market',
        //   icon: '/static/img/oneplatform/market2.png',
        //   path: '/chat/service/market',
        //   type: 'route'
        // }
      }],
      //   {
      //     title: 'แก้ไขโปรไฟล์',
      //     icon: 'person',
      //     path: 'profile'
      //   },
      //   {
      //     title: 'จัดการเพื่อน',
      //     icon: 'fas fa-users',
      //     path: 'managefriend'
      //   },
      //   {
      //     title: 'ส่งไฟล์ไป One box',
      //     icon: 'file_upload',
      //     path: 'uploadfile/onebox'
      //   },
      //   {
      //     title: 'ข้อเสนอแนะ',
      //     icon: 'feedback',
      //     path: 'feedback'
      //   },
      //   {
      //     title: 'ศูนย์ช่วยเหลือ',
      //     icon: 'contact_support',
      //     path: 'support'
      //   },
      //   {
      //     title: 'นโยบายความเป็นส่วนตัว',
      //     icon: 'book',
      //     path: 'policy'
      //   }

      // ],
      listmenubroadcast: [{
        title: 'บรอดแคส',
        icon: 'settings_input_antenna',
        path: 'broadcast'
      }, {
        title: 'ประวัติการบรอดแคส',
        icon: 'view_list',
        path: 'history_broadcast'
      }],
      listmenuapi: [{
        title: 'ข้อมูลนักพัฒนา',
        icon: 'person',
        path: 'dev_profile'
      }, {
        title: 'ข้อมูลห้องแชทเพื่อน',
        icon: 'chat',
        path: 'dev_infofriend'
      }, {
        title: 'ข้อมูลห้องแชทกลุ่ม',
        icon: 'group',
        path: 'dev_infogroup'
      }],
      listmenuOnemeet: [{
        title: 'ข้อมูลนักพัฒนา',
        icon: 'person',
        path: '/onemeet',
        type: 'chatroom'
      }],
      FriendReq: [],
      FriendSendReq: [],
      GroupReq: [],
      active: null,
      menu1: 'nonselect_Menu',
      menu2: 'nonselect_Menu',
      menu3: 'nonselect_Menu',
      menu4: 'nonselect_Menu',
      menu5: 'nonselect_Menu',
      menu6: 'nonselect_Menu',
      menu7: 'nonselect_Menu',
      menu8: 'select_Menu',
      showgroup: false,
      num_friendreq: 0,
      num_groupreq: 0,
      count_read: 'OneChat',
      notread: 0,
      encodeToken_News: '',
      one_id: ''
    };
  },
  components: {
    AddDialog: AddFriendDialog["a" /* default */],
    CreateGroupDialog: CreateGroupDialog["a" /* default */],
    ShowFriendDialog: ShowFriendDialog["a" /* default */],
    VueContext: vue_context["VueContext"],
    CheckBrowserDialog: CheckBrowserDialog["a" /* default */]
  },
  created: function created() {
    // var test = {
    //   one_id: 'u77',
    //   ExpiredDate: Momenttime.momentCreateDate()
    // }
    // this.encodeToken_News = Encode.encodeAuthen_news(test)
    // console.log(mama)
    // console.log(Decode.decodeAuthen_news(mama))
    this.active = 'tab-8';
    this.menu8 = 'select_Menu ';
    this.changeLangMenu();
    this.removefriend = false;
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.typeuser = localStorage.getItem('type_user');
    this.actionF = this.$route.params.roomid;
    // console.log(this.actionF)
    if (this.actionF != undefined) {
      var data = { tokenroom: this.actionF };
      this.mark_read(data);
    }
    this.getlistfriend();
    this.getlistgroup();
    this.getlistchat();
    this.getlistpending();
    this.getcount_notread();
    this.getOneid();
    // console.log(Momenttime.momentCreateDate())
  },

  // computed: {
  //   count_read () {
  //     if (this.notread == 0) {
  //       this.count_read = 'Onechat'
  //     } else {
  //       this.count_read = '('+response.data.count_read+') Onechat'
  //     }
  //   }
  // },
  methods: {
    toPageOnemeet: function toPageOnemeet(path, type) {
      console.log(path);
      console.log(type);
      this.$router.push(path);
    },
    getlistpending: function getlistpending() {
      var _this = this;

      // this.axios.post(process.env.APImanage + '/web/getlistrequestfriend', {tokenuser: this.token}).then((response) => {
      //   this.FriendReq = response.data['listrequestfriend']
      //   this.num_friendreq = response.data['listrequestfriend'].length
      // })
      // this.axios.post(process.env.APImanage + '/web/getlistpendingfriend', {tokenuser: this.token}).then((response) => {
      //   this.FriendSendReq = response.data['listpendingfriend']
      // })
      // this.axios.post(process.env.APImanage + '/web/getlistpendinggroup', {tokenuser: this.token}).then((response) => {
      //   this.GroupReq = response.data['listpendinggroup']
      //   this.num_groupreq = response.data['listpendinggroup'].length
      // })

      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-pending', { tokenuser: this.token }).then(function (response) {
        _this.FriendSendReq = response.data['list_send_request_friend'];
        _this.FriendReq = response.data['list_request_friend'];
        _this.GroupReq = response.data['list_pending_group'];

        _this.num_friendreq = response.data['list_request_friend'].length;
        _this.num_groupreq = response.data['list_pending_group'].length;
      });
    },
    closeCheckBrowser: function closeCheckBrowser(value) {
      this.checkBrowserDialog = value;
      this.checkBrowserInfor = {};
    },
    checkBrowser: function checkBrowser(url) {
      // console.log(url)
      console.log('check browser');
      // Get the user-agent string
      var userAgentString = navigator.userAgent;
      // Detect Chrome
      var chromeAgent = userAgentString.indexOf("Chrome") > -1;
      // Detect Internet Explorer
      var IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
      // Detect Firefox
      var firefoxAgent = userAgentString.indexOf("Firefox") > -1;
      // Detect Safari
      var safariAgent = userAgentString.indexOf("Safari") > -1;
      // Discard Safari since it also matches Chrome
      var operaAgent = userAgentString.indexOf("OP") > -1;
      // console.log('firefox = > ' + firefoxAgent)
      // console.log('ie = > ' + IExplorerAgent)
      // console.log('chrome = > ' + chromeAgent)
      // console.log('opera = > ' + operaAgent)
      // console.log('safari = > ' + safariAgent)
      if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
        this.checkBrowserInfor = {
          url: url,
          payload: ''
        };
        this.checkBrowserDialog = true;
      } else if (safariAgent === true && chromeAgent === true) {
        window.open(url, '_blank');
      } else if (safariAgent === true) {
        this.checkBrowserInfor = {
          url: url,
          payload: ''
        };
        this.checkBrowserDialog = true;
      } else {
        window.open(url, '_blank');
      }
    },
    convertMention: function convertMention(msg) {
      msg = msg.replace(/\<tax>/g, '<span style="color:#1976d2;">@');
      msg = msg.replace(/<\/tax>/g, '</span>');
      // console.log(msg)
      return msg;
    },
    getOneid: function getOneid() {
      var _this2 = this;

      this.axios.get("https://uatchat-manage.one.th/go_api/api" + '/v1/getOneID/' + this.token).then(function (response) {
        // console.log(response.data.one_id)
        _this2.one_id = response.data.one_id;
        // if (response.data.status === 'success') {
        //   // console.log(response.data)
        //   if (response.data.count_read != 0) {
        //     // this.count_read = '('+response.data.count_read+') Onechat'
        //     this.notread = response.data.count_read
        //   } else {
        //     // this.count_read = 'Onechat'
        //     this.notread = 0
        //   }
        // }
      }, function () {
        console.log('error');
      });
    },
    changepathservice: function changepathservice(path, type) {
      var _this3 = this;

      // console.log('type' + type)

      if (type == 'link') {
        window.open(path);
      } else if (type == 'route') {
        this.$router.push(path);
      } else if (type == 'function_news') {
        // console.log('test')
        // console.log(Momenttime.momenttimestamp())
        var test = {
          one_id: this.one_id,
          createdDate: services["c" /* Momenttime */].momentCreateDate()
        };
        this.encodeToken_News = services["b" /* Encode */].encodeAuthen_news(test);
        window.open(path + this.encodeToken_News);
        // console.log(window.navigator.geolocation)
        // if (window.navigator.geolocation) {
        //   console.log('oo')
        //   window.navigator.geolocation.getCurrentPosition((position) => {
        //     console.log('rr')
        //     var test = {
        //       one_id: this.one_id,
        //       createdDate: Momenttime.momentCreateDate(),
        //       latitude: position.coords.latitude,
        //       longitude: position.coords.longitude
        //     }
        //     this.encodeToken_News = Encode.encodeAuthen_news(test)
        //     console.log(Decode.decodeAuthen_news(this.encodeToken_News))
        //     window.open(path + this.encodeToken_News)
        //   })
        // } else {
        //   var test = {
        //     one_id: this.one_id,
        //     createdDate: Momenttime.momentCreateDate()
        //   }
        //   this.encodeToken_News = Encode.encodeAuthen_news(test)
        //   console.log(Decode.decodeAuthen_news(this.encodeToken_News))
        //   window.open(path + this.encodeToken_News)
        // }
      } else if ('share_token_onebox') {
        this.axios.post("https://uatchat-manage.one.th/message" + '/api/v1/get_encode_shared_token', {
          user_id: this.one_id
        }).then(function (response) {
          // console.log(response.data.data.encode_shared_token)
          var url = "https://uatbox.one.th/loginbysharetoken?token=" + response.data.data.encode_shared_token;
          _this3.checkBrowser(url);
        });
      }
    },
    getcount_notread: function getcount_notread() {
      var _this4 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getnotreadcount', {
        tokenuser: this.token
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          if (response.data.count_read != 0) {
            // this.count_read = '('+response.data.count_read+') Onechat'
            _this4.notread = response.data.count_read;
          } else {
            // this.count_read = 'Onechat'
            _this4.notread = 0;
          }
        }
      }, function () {
        console.log('error');
      });
    },
    RightClickDialog: function RightClickDialog($event, list, item) {
      // console.log(list)
      // console.log(item)
      this.ListMenuRightClick = [];
      if (item.state == 'active') {
        if (list.includes("pinchat")) {
          if (item.pin == "false") {
            this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.pinChat'), methods: 'pinchat' });
          } else if (item.pin == "true") {
            this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.unpinChat'), methods: 'unpinchat' });
          }
        }
        this.rightclickdialog = true;
        this.$refs.menu.open($event);
        this.SelectedMessageDetail = item;
      }
    },
    SelectMenuRightClick: function SelectMenuRightClick(selected) {
      // console.log(selected)
      if (selected == 'pinchat') {
        this.pin_chat();
      } else if (selected == 'unpinchat') {
        this.unpin_chat();
      }
    },
    pin_chat: function pin_chat() {
      var _this5 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', {
        tokenuser: this.token,
        tokenroom: this.SelectedMessageDetail.tokenroom,
        pin: 'true'
      }).then(function (response) {
        if (response.data.status === 'success') {
          // pinchat
          var tokenroom = _this5.SelectedMessageDetail.tokenroom;
          var index = '';
          index = _.findIndex(_this5.listchat, function (o) {
            return o.tokenroom == tokenroom;
          });
          _this5.listchat[index].pin = 'true';
          var listpin = [];
          var linstunpin = [];
          _this5.listchat = _.partition(_this5.listchat, function (o) {
            return o.pin == 'true';
          });
          listpin = _.orderBy(_this5.listchat[0], 'timestamp', 'desc');
          linstunpin = _.orderBy(_this5.listchat[1], 'timestamp', 'desc');
          _this5.listchat = _.union(listpin, linstunpin);
          // console.log(this.listchat)
        }
      }, function () {
        console.log('error');
      });
    },
    unpin_chat: function unpin_chat() {
      var _this6 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', {
        tokenuser: this.token,
        tokenroom: this.SelectedMessageDetail.tokenroom,
        pin: 'false'
      }).then(function (response) {
        if (response.data.status === 'success') {
          // pinchat
          var tokenroom = _this6.SelectedMessageDetail.tokenroom;
          var index = '';
          index = _.findIndex(_this6.listchat, function (o) {
            return o.tokenroom == tokenroom;
          });
          _this6.listchat[index].pin = 'false';
          var listpin = [];
          var linstunpin = [];
          _this6.listchat = _.partition(_this6.listchat, function (o) {
            return o.pin == 'true';
          });
          listpin = _.orderBy(_this6.listchat[0], 'timestamp', 'desc');
          linstunpin = _.orderBy(_this6.listchat[1], 'timestamp', 'desc');
          _this6.listchat = _.union(listpin, linstunpin);
          // console.log(this.listchat)
        }
      }, function () {
        console.log('error');
      });
    },
    changeLangMenu: function changeLangMenu() {
      this.listmenu = [{
        title: this.$t('HeaderMenubar.editProfile'),
        icon: 'person',
        path: 'profile'
      }, {
        title: this.$t('HeaderMenubar.managefriend'),
        icon: 'fas fa-users',
        path: 'managefriend'
      },
      // {
      //   title: this.$t('HeaderMenubar.sendOnebox'),
      //   icon: 'file_upload',
      //   path: 'uploadfile/onebox'
      // },
      {
        title: this.$t('HeaderMenubar.feedback'),
        icon: 'feedback',
        path: 'feedback'
      }, {
        title: this.$t('HeaderMenubar.support'),
        icon: 'contact_support',
        path: 'support'
      }, {
        title: this.$t('HeaderMenubar.terms_of_service'),
        icon: 'book',
        path: 'terms_of_service'
      }, {
        title: this.$t('HeaderMenubar.policy'),
        icon: 'book',
        path: 'policy'
      }], this.listmenutask = [{
        title: this.$t('HeaderMenubar.calendar'),
        icon: 'fas fa-calendar-alt',
        path: 'calendar'
      }, {
        title: this.$t('HeaderMenubar.createproject'),
        icon: 'fas fa-plus-circle',
        path: 'create_project'
      }, {
        title: this.$t('HeaderMenubar.project'),
        icon: 'fas fa-tasks',
        path: 'all_project'
      }];
    },
    secondsToHms: function secondsToHms(d) {
      d = Number(d);
      var hours = Math.floor(d / 3600);
      var minutes = Math.floor((d - hours * 3600) / 60);
      var seconds = d - hours * 3600 - minutes * 60;
      var time = '';

      if (hours !== 0) {
        time = hours + ':';
      }
      if (minutes !== 0 || time !== '') {
        minutes = minutes < 10 && time !== '' ? '0' + minutes : String(minutes);
        time += minutes + ':';
      }
      if (time === '') {
        time = seconds + ' s';
      } else {
        time += seconds < 10 ? '0' + seconds : String(seconds);
      }
      return time;
    },
    updatelistreq: function updatelistreq(data) {
      if (data.event === 'accept') {
        this.FriendReq.splice(_.findIndex(this.FriendReq, function (o) {
          return o.tokenuser === data.tokenuser;
        }), 1);
        if (_.find(this.listfriend, function (o) {
          return o.tokenuser === data.tokenuser;
        }) === undefined) {
          this.listfriend.unshift({
            email: data.email,
            name: data.name,
            profilepicture: data.profilepicture,
            state: data.state,
            status: data.status,
            tokenuser: data.tokenuser,
            type: data.type,
            tokenroom: data.tokenroom
          });
          this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc']);
        }
        if (_.find(this.listchat, function (o) {
          return o.tokenuser === data.tokenuser;
        }) === undefined) {
          this.listchat.unshift({
            email: data.email,
            name: data.name,
            is_active: 'true',
            profilepicture: data.profilepicture,
            state: data.state,
            status: data.status,
            tokenuser: data.tokenuser,
            type: data.type,
            tokenroom: data.tokenroom,
            nickname: '',
            timestamp: data.timestamp,
            count_read: '0'
          });
        }
      } else if (data.event === 'removeReq') {
        var index = _.findIndex(this.FriendSendReq, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        if (index >= 0) {
          this.FriendSendReq.splice(index, 1);
        }
      }
    },
    updatecreategroup: function updatecreategroup(data, filename) {
      if (_.find(this.listgroup, function (o) {
        return o.group_id === data.group_id;
      }) === undefined) {
        this.listgroup.unshift({
          count_read: '0',
          create_date: data.create_date,
          group_id: data.group_id,
          member: data.member,
          name: data.name,
          picture: filename,
          state: data.state,
          timestamp: data.timestamp,
          tokenroom: data.tokenroom,
          type: data.type
        });
        this.listgroup = _.orderBy(this.listgroup, ['name'], ['asc']);
      }
    },
    updatelistchat: function updatelistchat(data, filename) {
      // console.log(data)
      if (_.find(this.listchat, function (o) {
        return o.group_id === data.group_id;
      }) === undefined) {
        this.listchat.unshift({
          is_active: 'true',
          count_read: '0',
          create_date: data.create_date,
          group_id: data.group_id,
          member: data.member,
          name: data.name,
          nickname: '',
          picture: filename,
          state: data.state,
          timestamp: data.create_date,
          tokenroom: data.tokenroom,
          type: data.type
        });
      }
    },
    getlistchat: function getlistchat() {
      var _this7 = this;

      this.Progress.ListChat = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api/v4/getListChat", { tokenuser: this.token }).then(function (response) {
        _this7.Progress.ListChat = false;
        if (response.data.status === 'success') {
          _this7.listchat = response.data['listchat'];
          // console.log(this.listchat)
          // pinchat
          var listpin = [];
          var linstunpin = [];
          // this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true'})
          // listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
          // linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
          // this.listchat = _.union(listpin, linstunpin)
        }
      }, function () {
        _this7.Progress.ListChat = false;
        console.log('error');
      });
    },
    getlistfriend: function getlistfriend() {
      var _this8 = this;

      this.Progress.ListFriend = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-friend', { tokenuser: this.token }).then(function (response) {
        _this8.Progress.ListFriend = false;
        if (response.data.status === 'success') {
          _this8.listfriend = response.data['list_friend'];
        }
      }, function () {
        _this8.Progress.ListFriend = false;
      });
    },
    getlistgroup: function getlistgroup() {
      var _this9 = this;

      this.Progress.ListGroup = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-group', { tokenuser: this.token }).then(function (response) {
        _this9.Progress.ListGroup = false;
        if (response.data.status === 'success') {
          _this9.listgroup = response.data['list_active_group'];
        }
      }, function () {
        _this9.Progress.ListGroup = false;
      });
    },
    showUserInGroup: function showUserInGroup(item) {
      this.showgroup = item;
      this.showDialog('ShowFriend');
    },
    changepathsettings: function changepathsettings(path) {
      this.pathsettings = '/chat/settings/' + path;
      this.$router.push('/chat/settings/' + path);
    },
    changepathproject: function changepathproject(path) {
      this.pathsettings = '/chat/project/' + path;
      this.$router.push('/chat/project/' + path);
    },
    changebroadcast: function changebroadcast(path) {
      this.$router.push('/broadcast/' + path);
      localStorage.setItem('room', path);
    },
    changepathapi: function changepathapi(path) {
      this.$router.push('/api/' + path);
      localStorage.setItem('room', path);
    },
    selectmenu: function selectmenu(menu) {
      if (menu === 1) {
        this.active = 'tab-1';
        this.menu1 = 'select_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 2) {
        this.active = 'tab-2';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'select_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 3) {
        this.active = 'tab-3';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'select_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 4) {
        this.active = 'tab-4';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'select_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 5) {
        this.active = 'tab-5';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'select_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 6) {
        this.active = 'tab-6';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'select_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 7) {
        this.active = 'tab-7';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'select_Menu ';
        this.menu8 = 'nonselect_Menu ';
      } else if (menu === 8) {
        this.active = 'tab-8';
        this.menu1 = 'nonselect_Menu ';
        this.menu2 = 'nonselect_Menu ';
        this.menu3 = 'nonselect_Menu ';
        this.menu4 = 'nonselect_Menu ';
        this.menu5 = 'nonselect_Menu ';
        this.menu6 = 'nonselect_Menu ';
        this.menu7 = 'nonselect_Menu ';
        this.menu8 = 'select_Menu ';
        console.log('active: ' + this.active);
        // this.toPageOnemeet('/onemeeting', 'onemeet')
      }
      // เซตค่าเวลาที่สลับ layout
      // this.$router.push('/chat')
      if (this.active !== 'tab-8') {
        this.$router.push('/chat');
      }
      localStorage.setItem('menu_left', stringify_default()({
        'active': this.active,
        'menu1': this.menu1,
        'menu2': this.menu2,
        'menu3': this.menu3,
        'menu4': this.menu4,
        'menu5': this.menu5,
        'menu6': this.menu6,
        'menu7': this.menu7,
        'menu8': this.menu8
      }));
    },
    RemoveReq_FriendSendReq: function RemoveReq_FriendSendReq(item) {
      var _this10 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', { tokenfriend: item.tokenuser, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          _this10.FriendSendReq.splice(_.findIndex(_this10.FriendSendReq, function (o) {
            return o.tokenuser === item.tokenuser;
          }), 1);
        }
      });
    },
    AcceptReq_GroupReq: function AcceptReq_GroupReq(group) {
      var _this11 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/activeinvitegroup', { group_id: group.group_id, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          var tokenuser = _this11.token;
          var indexgroup = _.findIndex(response.data.group.member, function (o) {
            return o.tokenuser === tokenuser;
          });
          if (indexgroup >= 0) {
            _this11.socketactive_group = { timestamp: response.data.group.member[indexgroup].timestamp_in, groupid: group.group_id, tokenuser: _this11.token };
          } else {
            _this11.socketactive_group = { timestamp: '', groupid: group.group_id, tokenuser: _this11.token };
          }
        }
      });
    },
    RemoveReq_GroupReq: function RemoveReq_GroupReq(group) {
      var _this12 = this;

      // console.log(group)
      this.$swal({
        title: 'คุณแน่ใจหรือไหม?',
        text: 'คุณกำลังยกเลิกคำเชิญเข้ากลุ่ม ' + group.name + ' !',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ใช่, ฉันต้องยกเลิกคำเชิญ!',
        cancelButtonText: 'ไม่ใช่, ยกเลิก!',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this12.axios.post("https://uatchat-manage.one.th/manage" + '/cancelinvitegroup', { group_id: group.group_id, tokenuser: _this12.token }).then(function (response) {
            if (response.data.status === 'success') {
              // this.GroupReq.splice(this.GroupReq.indexOf(group), 1) // ลบ GroupReq ตอนยกเลิกเข้ากลุ่ม
            }
          });
        }
      });
    },
    AcceptReq_FriendReq: function AcceptReq_FriendReq(Friend) {
      var _this13 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/accept-friend", { tokenfriend: Friend.tokenuser, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          var index = _.findIndex(_this13.FriendReq, function (o) {
            return o.tokenuser === Friend.tokenuser;
          });
          if (index >= 0) {
            _this13.FriendReq.splice(index, 1);
          }
          _this13.$router.push('/chat/room/' + response.data.tokenroom);
          var data = response.data.source;
          data['tokenroom'] = response.data.tokenroom;
        } else {}
      });
    },
    RemoveReq_FriendReq: function RemoveReq_FriendReq(Friend) {
      var _this14 = this;

      this.$swal({
        title: 'คุณแน่ใจหรือไหม?',
        text: 'คุณกำลังยกเลิกคำเชิญ ' + Friend.name + ' !',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ใช่, ฉันต้องยกเลิกคำเชิญ!',
        cancelButtonText: 'ไม่ใช่, ยกเลิก!',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          // if (Friend.type === 'user') {
          _this14.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', { tokenfriend: Friend.tokenuser, tokenuser: _this14.token }).then(function (response) {
            if (response.data['status'] === 'success') {
              _this14.socketremove_request_friend = {
                tokenuser: Friend.tokenuser,
                tokenfriend: _this14.token
              };
            } else {}
          });
        }
      });
    },
    lengthactive: function lengthactive(member) {
      return _.filter(member, function (member) {
        return member.statemember === 'active';
      }).length;
    },
    showDialog: function showDialog(dialog) {
      if (dialog === 'AddFriend') {
        this.AddFriend = true;
      } else if (dialog === 'CreateGroup') {
        this.CreateGroup = true;
      } else if (dialog === 'ShowFriend') {
        this.ShowFriend = true;
      }
    },
    closeDialogShowFriend: function closeDialogShowFriend(value) {
      this.ShowFriend = value;
    },
    closeDialogAddFriend: function closeDialogAddFriend(value) {
      this.AddFriend = value;
    },
    closeDialogCreateGroup: function closeDialogCreateGroup(value) {
      this.CreateGroup = value;
    },
    time: function time(timestamp) {
      return this.$i18n.locale == 'th' ? services["c" /* Momenttime */].momenttimethaiformnow(timestamp) : services["c" /* Momenttime */].momenttimethaiformnowen(timestamp);
    },
    routeChat: function routeChat(data) {
      // console.log(data)
      // this.$cookie.set('typeuser_friend', data.type)
      // this.$cookie.set('tokenuser_friend', Encode.encodeToken(data.tokenuser))
      this.actionF = data.tokenroom;
      // check consent
      if (data.type === 'bot') {
        this.getConsent(data.tokenuser, data.tokenroom);
      } else {
        this.$router.push('/chat/room/' + data.tokenroom);
      }
      // this.$router.push('/chat/room/' + data.tokenroom)
      var indexmsg = _.findIndex(this.listchat, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (this.listchat[indexmsg].is_active == 'true') {
        this.notread = this.notread - this.listchat[indexmsg].count_read;
      }
      this.listchat[indexmsg].is_active = 'true';

      this.listchat[indexmsg].count_read = 0;

      this.mark_read(data);
      this.pathsettings = '/chat/room/' + data.tokenroom;
    },
    getConsent: function getConsent(botid, tokenroom) {
      var _this15 = this;

      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/get-consent-bot', {
        tokenuser: this.token,
        bot_id: botid
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          if (response.data.isConsent === true && response.data.isAccept === false) {
            var dataConsent = services["b" /* Encode */].encode(response.data.data);
            _this15.$router.push('/check-consent/' + tokenroom + ('/?data_consent=' + dataConsent));
          } else {
            _this15.$router.push('/chat/room/' + tokenroom);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    mark_read: function mark_read(data) {
      // console.log('mark_read')
      if (data.count_read !== '0' && data.count_read !== '') {
        this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/user-mark-read', { tokenuser: this.token, tokenroom: data.tokenroom }).then(function (response) {});
      }
    },
    blockevent: function blockevent(data) {
      var _this16 = this;

      if (data.event === 'block_friend') {
        var indexmsg = _.findIndex(this.listchat, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        var indexchat = _.findIndex(this.listchat, function (o) {
          return o.tokenroom === data.tokenroom;
        });
        if (indexchat != -1) {
          this.listchat[indexchat]['timestamp'] = data.timestamp;
          this.listchat[indexchat]['state'] = 'block';
          // this.listchat = _.orderBy(this.listchat, ['timestamp'], ['asc']).reverse()
          this.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', { tokenroom: data.tokenroom, tokenuser: this.token, pin: 'false' }).then(function (response) {
            var listpin = [];
            var linstunpin = [];
            _this16.listchat[indexchat].pin = 'false';
            _this16.listchat = _.partition(_this16.listchat, function (o) {
              return o.pin == 'true';
            });
            listpin = _.orderBy(_this16.listchat[0], 'timestamp', 'desc');
            linstunpin = _.orderBy(_this16.listchat[1], 'timestamp', 'desc');
            _this16.listchat = _.union(listpin, linstunpin);
          });
        }
        indexmsg = _.findIndex(this.listfriend, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        if (indexmsg != -1) {
          _.pullAt(this.listfriend, indexmsg);
        }
      } else if (data.event === 'unblock_friend') {
        this.listfriend.push(data);
        this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc']);
        indexmsg = _.findIndex(this.listchat, function (o) {
          return o.tokenroom === data.tokenroom;
        });
        if (indexmsg != -1) {
          this.listchat[indexmsg].state = 'active';
          this.listchat[indexmsg].nickname = '';
        }
      }
    }
  },
  computed: extends_default()({
    // count_read () {
    //   if (this.notread == 0) {
    //     return 'OneChat'
    //   } else {
    //     return '(' + this.notread + ') Onechat'
    //   }
    // },
    FilterFriendList: function FilterFriendList() {
      var _this17 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listfriend.filter(function (post) {
          return post.name.toLowerCase().includes(_this17.search.toLowerCase());
        });
      } else {
        return this.listfriend;
      }
    },
    FilterGroupList: function FilterGroupList() {
      var _this18 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listgroup.filter(function (post) {
          return post.name.toLowerCase().includes(_this18.search.toLowerCase());
        });
      } else {
        return this.listgroup;
      }
    },
    FilterChatList: function FilterChatList() {
      var _this19 = this;

      if (this.search !== '' && this.search !== null) {
        return this.listchat.filter(function (post) {
          return post.name.toLowerCase().includes(_this19.search.toLowerCase());
        });
      } else {
        return this.listchat;
      }
    }
  }, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {
    GroupReq: function GroupReq() {
      this.num_groupreq = this.GroupReq.length;
    },
    FriendReq: function FriendReq() {
      this.num_friendreq = this.FriendReq.length;
    },
    chIsactive: function chIsactive(data) {
      var _this20 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/setisactive', { tokenroom: data, tokenuser: this.token, is_active: 'false' }).then(function (response) {
        if (response.data.status === 'success') {
          var indexmsg = _.findIndex(_this20.listchat, function (o) {
            return o.tokenroom === data;
          });
          _this20.listchat[indexmsg].is_active = false;
          _this20.$router.push('/chat/homepage');
          _this20.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', { tokenroom: data, tokenuser: _this20.token, pin: 'false' }).then(function (response) {
            var listpin = [];
            var linstunpin = [];
            _this20.listchat[indexmsg].pin = 'false';
            _this20.listchat = _.partition(_this20.listchat, function (o) {
              return o.pin == 'true';
            });
            listpin = _.orderBy(_this20.listchat[0], 'timestamp', 'desc');
            linstunpin = _.orderBy(_this20.listchat[1], 'timestamp', 'desc');
            _this20.listchat = _.union(listpin, linstunpin);
          });
        }
      });
    },
    block_friend: function block_friend(data) {
      this.blockevent(data);
    },
    socket_unsendmessage: function socket_unsendmessage(data) {
      var _this21 = this;

      // console.log(data)
      this.axios.post("https://uatchat-manage.one.th/event" + '/getmessage', { tokenmessage: data.last_tokenmessage._id, tokenuser: this.token }).then(function (response) {
        // console.log(response.data.source)
        var dataunsend = {};
        dataunsend = response.data.source;
        var indexmsg = _.findIndex(_this21.listchat, function (o) {
          return o.tokenroom === data.tokenroom;
        });
        if (indexmsg !== -1) {
          _this21.listchat[indexmsg].is_active = 'true';
          // var message = dataunsend.message
          // if (data.tokenroom !== this.actionF) {
          //   this.listchat[indexmsg].count_read = parseInt(this.listchat[indexmsg].count_read) + 1
          // }
          _this21.listchat[indexmsg].message = dataunsend.message;
          _this21.listchat[indexmsg].timestamp = dataunsend.timestamp;
          _this21.listchat[indexmsg].nickname = dataunsend.nickname;
          _this21.listchat[indexmsg].typeofmessage = dataunsend.typeofmessage;
          _this21.listchat[indexmsg].time_count = dataunsend.time_count;
          _this21.listchat[indexmsg].file_name = dataunsend.file_name;
          _this21.listchat[indexmsg].tokenuser = dataunsend.tokenuser;
          var listpin = [];
          var linstunpin = [];
          var pin = _.partition(_this21.listchat, function (o) {
            return o.pin == 'true';
          });
          listpin = _.orderBy(pin[0], 'timestamp', 'desc');
          linstunpin = _.orderBy(pin[1], 'timestamp', 'desc');
          _this21.listchat = _.union(listpin, linstunpin);
          // if (indexmsg === 0) {
          //   this.listchat[indexmsg].message = dataunsend.message
          //   this.listchat[indexmsg].timestamp = dataunsend.timestamp
          //   this.listchat[indexmsg].nickname = dataunsend.nickname
          //   this.listchat[indexmsg].typeofmessage = dataunsend.typeofmessage
          //   this.listchat[indexmsg].time_count = dataunsend.time_count
          //   this.listchat[indexmsg].file_name = dataunsend.file_name
          //   this.listchat[indexmsg].tokenuser = dataunsend.tokenuser
          // } else {
          //   var dataindex = this.listchat[indexmsg]
          //   dataindex.message = dataunsend.message
          //   dataindex.timestamp = dataunsend.timestamp
          //   dataindex.nickname = dataunsend.nickname
          //   dataindex.typeofmessage = dataunsend.typeofmessage
          //   dataindex.time_count = dataunsend.time_count
          //   dataindex.file_name = dataunsend.file_name
          //   dataindex.tokenuser = dataunsend.tokenuser
          //   _.pullAt(this.listchat, indexmsg) // ลบ listchat เดิม
          //   this.listchat.unshift(dataindex) // เพิ่ม lischat ใหม่เข้าไป
          // }
        }
      });
    },
    socketmessage: function socketmessage(data) {
      // console.log(data)
      // console.log(this.listchat)
      if (data.typeofmessage !== "system_action") {
        var indexmsg = _.findIndex(this.listchat, function (o) {
          return o.tokenroom === data.tokenroom;
        });
        if (indexmsg !== -1) {
          this.listchat[indexmsg].is_active = 'true';
          var message = data.message;
          // if (data.typeofmessage !== 'message') {
          //   message = 'Send ' + data.message
          // }
          if (data.tokenroom !== this.actionF && data.tokenuser != this.token) {
            this.listchat[indexmsg].count_read = parseInt(this.listchat[indexmsg].count_read) + 1;
            this.notread = this.notread + 1;
          } else if (data.tokenuser == this.token) {
            this.notread = this.notread - parseInt(this.listchat[indexmsg].count_read);
            this.listchat[indexmsg].count_read = 0;
          }
          if (indexmsg === 0) {
            this.listchat[0].message = message;
            this.listchat[0].timestamp = data.timestamp;
            this.listchat[0].nickname = data.nickname;
            this.listchat[0].typeofmessage = data.typeofmessage;
            this.listchat[0].time_count = data.time_count;
            this.listchat[0].file_name = data.file_name;
            this.listchat[0].tokenuser = data.tokenuser;
          } else {
            var dataindex = this.listchat[indexmsg];
            dataindex.message = message;
            dataindex.timestamp = data.timestamp;
            dataindex.nickname = data.nickname;
            dataindex.typeofmessage = data.typeofmessage;
            dataindex.time_count = data.time_count;
            dataindex.file_name = data.file_name;
            dataindex.tokenuser = data.tokenuser;
            _.pullAt(this.listchat, indexmsg); // ลบ listchat เดิม
            this.listchat.unshift(dataindex); // เพิ่ม lischat ใหม่เข้าไป
          }
        }
        // เรียงแชทใหม่ กรณที่มีการ pin
        var listpin = [];
        var linstunpin = [];
        this.listchat = _.partition(this.listchat, function (o) {
          return o.pin == 'true';
        });
        listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc');
        linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc');
        this.listchat = _.union(listpin, linstunpin);
        // console.log(this.listchat)
      }
    },
    socketleave_group: function socketleave_group(data) {
      // console.log(data)
      var self = this;
      data.listkick.forEach(function (item) {
        var _this22 = this;

        if (item === self.token) {
          var index = _.findIndex(self.listgroup, function (o) {
            return o.tokenroom === data.tokenroom;
          });
          if (index >= 0) {
            self.listgroup.splice(index, 1);
          }
          var indexchat = _.findIndex(self.listchat, function (o) {
            return o.tokenroom === data.tokenroom;
          });
          if (indexchat >= 0) {
            self.listchat[indexchat].state = 'leave';
            self.axios.post("https://uatchat-manage.one.th/manage" + '/setpin', { tokenroom: data.tokenroom, tokenuser: self.token, pin: 'false' }).then(function (response) {
              var listpin = [];
              var linstunpin = [];
              self.listchat[indexchat].pin = 'false';
              self.listchat = _.partition(self.listchat, function (o) {
                return o.pin == 'true';
              });
              listpin = _.orderBy(_this22.listchat[0], 'timestamp', 'desc');
              linstunpin = _.orderBy(_this22.listchat[1], 'timestamp', 'desc');
              self.listchat = _.union(listpin, linstunpin);
            });
          }
        }
      });
    },
    socket_kickmember: function socket_kickmember(data) {
      var self = this;
      data.listkick.forEach(function (item) {
        if (item === self.token) {
          var index = _.findIndex(self.listgroup, function (o) {
            return o.tokenroom === data.tokenroom;
          });
          if (index >= 0) {
            self.listgroup.splice(index, 1);
          }
          var indexchat = _.findIndex(self.listchat, function (o) {
            return o.tokenroom === data.tokenroom;
          });
          if (indexchat >= 0) {
            self.listchat[indexchat].state = 'leave';
          }
        }
      });
    },
    socketactive_group: function socketactive_group(data) {
      var _this23 = this;

      // console.log(data)
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', { group_id: data.groupid, tokenuser: this.token }).then(function (response) {
        // console.log(response.data)
        var indexgroup = _.findIndex(_this23.GroupReq, function (o) {
          return o.group_id === response.data.group.group_id;
        }); // หาตำแหน่งของ group req ที่ต้องการจะลบ
        if (indexgroup >= 0) {
          _.pullAt(_this23.GroupReq, indexgroup); // ลบ GroupReq เดิม
          _this23.num_groupreq = _this23.GroupReq.length; // จำนวน group req
        }
        // update listgroup
        if (_.find(_this23.listgroup, function (o) {
          return o.group_id === response.data.group.group_id;
        }) === undefined) {
          // console.log('有group')
          var group = response.data.group;
          group.timestamp = data.timestamp;
          _this23.listgroup.unshift(group);
          _this23.listgroup = _.orderBy(_this23.listgroup, ['name'], ['asc']);
          _this23.getlistchat();
        }
        // update listchat
        // console.log(this.listchat)
        // if (_.find(this.listchat, function (o) { return o.group_id === response.data.group.group_id }) === undefined) {
        //   console.log(response.data.group)
        //   var chat = response.data.group
        //   chat.timestamp = data.timestamp
        //   chat.count_read = ''
        //   chat.nickname = ''
        //   chat.is_active = 'true'
        //   this.listchat.unshift(chat)
        //   console.log(this.listchat.unshift(chat))
        // }
        if (data.tokenuser === _this23.token) {
          var indexchat = _.findIndex(_this23.listchat, function (o) {
            return o.group_id === response.data.group.group_id;
          }); // หาตำแหน่งของ group req ที่ต้องการจะลบ
          // console.log(indexchat)
          if (indexchat != -1) {
            _this23.listchat[indexchat].state = 'active';
          }
          // this.listchat[indexchat].state = 'active'
        }
      });
    },
    socketcencel_group: function socketcencel_group(data) {
      // console.log(data)
      if (this.GroupReq.length !== 0) {
        // ลบ group req
        var index = _.findIndex(this.GroupReq, function (o) {
          return o.group_id === data.group_id;
        });
        if (index >= 0) {
          this.GroupReq.splice(index, 1);
        }
      }
    },
    socketremove_friend: function socketremove_friend(data) {
      // console.log(data)
      var index = _.findIndex(this.listfriend, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (index >= 0) {
        this.listfriend.splice(index, 1);
      }
      var indexchat = _.findIndex(this.listchat, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (indexchat >= 0) {
        this.listchat[indexchat].state = 'unfriend';
      }
    },
    socketremove_request_friend: function socketremove_request_friend(data) {
      var indexReq = _.findIndex(this.FriendReq, function (o) {
        return o.tokenuser === data.tokenuser;
      });
      var indexSendReq = _.findIndex(this.FriendSendReq, function (o) {
        return o.tokenuser === data.tokenuser;
      });
      if (indexReq >= 0) {
        this.FriendReq.splice(indexReq, 1);
      }
      if (indexSendReq >= 0) {
        this.FriendSendReq.splice(indexSendReq, 1);
      }
    },
    socketaccept_friend: function socketaccept_friend(data) {
      var _this24 = this;

      // console.log(data)
      var tokenfriend = data.tokenfriend;
      if (this.token === data.tokenfriend) {
        tokenfriend = data.tokenuser;
        var indexSendReq = _.findIndex(this.FriendSendReq, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        if (indexSendReq >= 0) {
          this.FriendSendReq.splice(indexSendReq, 1);
        }
      } else {
        var indexReq = _.findIndex(this.FriendReq, function (o) {
          return o.tokenuser === data.tokenfriend;
        });
        if (indexReq >= 0) {
          this.FriendReq.splice(indexReq, 1);
        }
      }
      this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', { tokenuser: this.token, tokenfriend: tokenfriend }).then(function (response) {
        if (_.find(_this24.listfriend, function (o) {
          return o.tokenuser === response.data.user.tokenuser;
        }) === undefined) {
          _this24.listfriend.unshift(response.data.user);
          // this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
        }
        // update listchat
        var indexchat = _.findIndex(_this24.listchat, function (o) {
          return o.tokenroom === data.tokenroom;
        });
        var json = response.data.user;
        json.nickname = '';
        json.picture = response.data.user.profilepicture;
        json.state = 'user';
        json.timestamp = data.timestamp;
        json.count_read = '0';
        json.is_active = 'true';
        // console.log(json)
        if (indexchat >= 0) {
          _this24.listchat.splice(indexchat, 1);
          _this24.listchat.unshift(json);
        } else {
          _this24.listchat.unshift(json);
        }
        // เรียงแชทใหม่ กรณที่มีการ pin
        var listpin = [];
        var linstunpin = [];
        _this24.listchat = _.partition(_this24.listchat, function (o) {
          return o.pin == 'true';
        });
        listpin = _.orderBy(_this24.listchat[0], 'timestamp', 'desc');
        linstunpin = _.orderBy(_this24.listchat[1], 'timestamp', 'desc');
        _this24.listchat = _.union(listpin, linstunpin);
      });
    },
    socketfriend: function socketfriend(data) {
      var _this25 = this;

      // console.log(data)
      // console.log(process.env.APImanage + '/searchtokenuser', {tokenuser: this.token, tokenfriend: data.tokenfriend})
      this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', { tokenuser: this.token, tokenfriend: data.tokenfriend[0] }).then(function (response) {
        // var _ = require('lodash')
        if (data.konAdd !== _this25.token) {
          // update Friend request
          if (_.find(_this25.FriendReq, function (o) {
            return o.tokenuser === response.data.user.tokenuser;
          }) === undefined) {
            _this25.FriendReq.unshift(response.data.user);
            _this25.FriendReq = _.orderBy(_this25.FriendReq, ['name'], ['asc']).reverse();
          }
        } else {
          if (_.find(_this25.FriendSendReq, function (o) {
            return o.tokenuser === response.data.user.tokenuser;
          }) === undefined) {
            _this25.FriendSendReq.unshift(response.data.user);
            _this25.FriendSendReq = _.orderBy(_this25.FriendSendReq, ['name'], ['asc']).reverse();
          }
        }
      });
    },
    socketinvite_group: function socketinvite_group(data) {
      var _this26 = this;

      // console.log(data)
      var index = _.findIndex(this.listgroup, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (index < 0) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', { group_id: data.groupid, tokenuser: data.userinvited }).then(function (response) {
          // console.log(response.data.group)
          _this26.GroupReq.unshift(response.data.group);
          _this26.GroupReq = _.orderBy(_this26.GroupReq, ['create_date'], ['asc']);
        });
      }
    },
    socketcreate_group: function socketcreate_group(data) {
      var _this27 = this;

      if (data.fromtokenuser !== this.token) {
        if (_.find(this.GroupReq, function (o) {
          return o.group_id === data.groupid;
        }) === undefined) {
          this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', { group_id: data.groupid, tokenuser: data.fromtokenuser }).then(function (response) {
            _this27.GroupReq.unshift(response.data.group);
            _this27.GroupReq = _.orderBy(_this27.GroupReq, ['create_date'], ['asc']);
          });
        }
      }
    },
    '$route.params.roomid': function $routeParamsRoomid() {
      this.actionF = this.$route.params.roomid;
    },
    '$i18n.locale': function $i18nLocale() {
      this.changeLangMenu();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00843c8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/onemeet/LefttestOnemeet.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"leftbox ",staticStyle:{"padding":"0px"}},[_c('vue-headful',{attrs:{"title":_vm.count_read}}),_vm._v(" "),_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-container',{staticClass:"scrolling-wrapper CSChatThai",staticStyle:{"padding":"0px !important","height":"94vh"}},[_c('v-layout',{attrs:{"column":"","fluid":""}},[_c('v-list',{staticStyle:{"padding":"0px !important","background-color":"#1b232d !important","height":"94vh"},attrs:{"three-line":""}},[_c('v-list-tile',{class:_vm.menu1,staticStyle:{"padding":"0px !important"},on:{"click":function($event){_vm.selectmenu(1)}}},[_c('v-list-tile-content',{staticStyle:{"padding":"0 !important","margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"padding":"0px !important","text-align":"center","height":"44px"}},[((_vm.num_friendreq + _vm.num_groupreq) !== 0)?_c('v-badge',{attrs:{"color":"red","right":"","overlap":""}},[((_vm.num_friendreq + _vm.num_groupreq) < 100)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.num_friendreq + _vm.num_groupreq))]):_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v("99+")]),_vm._v(" "),_c('v-icon',{class:_vm.menu1,staticStyle:{"font-size":"30px !important"}},[_vm._v("person")])],1):_c('v-icon',{class:_vm.menu1,staticStyle:{"font-size":"30px !important","margin-top":"11px !important"}},[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu1,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                    "+_vm._s(_vm.$t('LeftSide.header.friend'))+"\n                  ")])])],1)],1),_vm._v(" "),_c('v-list-tile',{class:_vm.menu2,on:{"click":function($event){_vm.selectmenu(2)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('v-icon',{class:_vm.menu2,staticStyle:{"font-size":"30px !important"}},[_vm._v("chat")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu2,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                    "+_vm._s(_vm.$t('LeftSide.header.chat'))+"\n                  ")])])],1)],1),_vm._v(" "),_c('v-list-tile',{class:_vm.menu3,on:{"click":function($event){_vm.selectmenu(3)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('v-icon',{class:_vm.menu3,staticStyle:{"font-size":"30px !important"}},[_vm._v("fas fa-calendar-alt")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu3,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                    "+_vm._s(_vm.$t('LeftSide.header.calendar'))+"\n                  ")])])],1)],1),_vm._v(" "),_c('v-list-tile',{class:_vm.menu7,on:{"click":function($event){_vm.selectmenu(7)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('v-icon',{class:_vm.menu7,staticStyle:{"font-size":"30px !important"}},[_vm._v("mdi-package-variant")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu7,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                    "+_vm._s(_vm.$t('LeftSide.header.service'))+"\n                  ")])])],1)],1),_vm._v(" "),_c('v-list-tile',{class:_vm.menu8,on:{"click":function($event){_vm.selectmenu(8)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('img',{staticStyle:{"height":"30px !important"},attrs:{"src":"/static/img/icons/onemeet.png","alt":""}})]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu8,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                   "+_vm._s(_vm.$t('LeftSide.header.onemeet'))+"\n                 ")])])],1)],1),_vm._v(" "),_c('v-list-tile',{class:_vm.menu4,staticStyle:{"bottom":"0px","position":"fixed","width":"4%"},on:{"click":function($event){_vm.selectmenu(4)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('v-icon',{class:_vm.menu4,staticStyle:{"font-size":"30px !important"}},[_vm._v("settings")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu4,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                   "+_vm._s(_vm.$t('LeftSide.header.setting'))+"\n                 ")])])],1)],1),_vm._v(" "),(_vm.typeuser=='business')?_c('v-list-tile',{class:_vm.menu5,on:{"click":function($event){_vm.selectmenu(5)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('v-icon',{class:_vm.menu5,staticStyle:{"font-size":"30px !important"}},[_vm._v("info")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu5,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                    API\n                  ")])])],1)],1):_vm._e(),_vm._v(" "),(_vm.typeuser=='business')?_c('v-list-tile',{class:_vm.menu6,on:{"click":function($event){_vm.selectmenu(6)}}},[_c('v-list-tile-content',{staticStyle:{"margin-right":"0vw","text-align":"center"}},[_c('v-list-tile-title',{staticStyle:{"text-align":"center","height":"30px"}},[_c('v-icon',{class:_vm.menu6,staticStyle:{"font-size":"30px !important"}},[_vm._v("settings_input_antenna")])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:" CSChatThai",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b',{class:_vm.menu6,staticStyle:{"font-size":"12px !important"}},[_vm._v("\n                    Broadcast\n                  ")])])],1)],1):_vm._e()],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var onemeet_LefttestOnemeet = (esExports);
// CONCATENATED MODULE: ./src/components/chat/onemeet/LefttestOnemeet.vue
function injectStyle (ssrContext) {
  __webpack_require__("b4FA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00843c8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  LefttestOnemeet,
  onemeet_LefttestOnemeet,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var chat_onemeet_LefttestOnemeet = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WXa+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wj7+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WrTz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X8t3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XJSl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XuE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y4Rx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("T5eZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YTSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/SelectAccount.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var SelectAccount = ({
  props: {
    dialogSelectaccount: Boolean,
    list_accounts: Array,
    phoneNumber: String
  },
  data: function data() {
    return {
      selectedItem: '',
      items: [{
        avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
        username: 'Brunch this weekend?',
        email: "fdgdfgdgfgd",
        one_id: '1'
      }, {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
        username: 'Summer BBQ',
        email: "dfgfdgdgdgdf",
        one_id: '2'
      }, {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
        username: 'Oui oui',
        email: "asaddssdadasdsd",
        one_id: '3'
      }, {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
        username: null,
        email: "ssssssssssssssssss",
        one_id: '4'
      }, {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
        username: '',
        email: "asaSasASAsadasds",
        one_id: '5'
      }],
      myprofilepicture: '',
      myname: '',
      isLoading: false,
      nameShowalert: '',
      loading: false,
      activeItem: null
    };
  },

  watch: {
    // selectedItem (val) {
    //   this.selectedItem = val
    //   console.log('val' , val)
    //   // this.$store.commit('item/setIteminStore', payload)
    // }
    dialogSelectaccount: function dialogSelectaccount() {
      console.log(this.dialogSelectaccount);
      if (this.dialogSelectaccount) {
        // this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
        this.$i18n.locale = 'th';
      }
    }
  },
  created: function created() {
    // this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
    this.$i18n.locale = 'th';
    console.log('this.$i18n.locale: ' + this.$i18n.locale);
  },

  methods: {
    // selectItem(i) {
    //   this.activeItem = i;
    // },
    itemType: function itemType(payload, i) {
      // console.log(payload.one_id)
      this.selectedItem = payload;
      this.activeItem = i;
    },
    disableBTN: function disableBTN() {
      if (this.selectedItem == '') {
        return true;
      } else {
        return false;
      }
    },
    closeSelectaccount: function closeSelectaccount() {
      this.$emit('closeSelectaccount', false);
    },
    selectAccount: function selectAccount() {
      var _this = this;

      this.loading = true;
      if (this.selectedItem.username === '' || this.selectedItem.username === null) {
        // console.log('test :', this.selectedItem.username)
        this.nameShowalert = this.selectedItem.email;
      } else {
        this.nameShowalert = this.selectedItem.username;
      }
      this.$swal({
        title: '<span style=" font-family: CS ChatThaiUI !important;">' + this.$t('Dialog.selectaccount.alert.title') + '</span>',
        html: '<span style=" font-family: CS ChatThaiUI !important;"> ' + this.$t('Dialog.selectaccount.alert.text1') + ' ' + '<b  style="font-size: 18px;font-weight: bold; color:#3085d6;">' + this.nameShowalert + '</b>' + (' ' + this.$t('Dialog.selectaccount.alert.text2') + '?</span>'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: 'grey',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true,
        showLoaderOnConfirm: true
      }).then(function (result) {
        // console.log(result.value)
        if (result.value === true) {
          var data = {
            type_otp: "set accounts",
            phone: _this.phoneNumber,
            one_id: _this.selectedItem.one_id
            // console.log(data)
          };_this.axios.post("https://uatchat-manage.one.th/manage" + '/v2/login_and_regis', data).then(function (response) {
            if (response.data.status === 'success') {
              var profile = response.data['account']['profile'];
              _this.myprofilepicture = profile['profilepicture'];
              _this.myname = profile['name'];
              // this.$cookie.set('language', 'th')
              _this.$i18n.locale = _this.$cookie.get('language') ? _this.$cookie.get('language') : 'th';
              localStorage.setItem('Authenrization', services["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
              localStorage.setItem('profilepicture', profile['profilepicture']);
              localStorage.setItem('name', profile['name']);
              localStorage.setItem('phone', profile['phone']);
              localStorage.setItem('email', profile['email']);
              localStorage.setItem('status', profile['status']);
              localStorage.setItem('type_user', profile['type']);
              localStorage.setItem('wallpaperInfo', stringify_default()({
                'info': [{
                  'room': '',
                  'background': ''
                }]
              }));
              if (profile['username'] === '' || profile['username'] === 'None') {
                localStorage.setItem('status_username', 'false');
              } else {
                localStorage.setItem('status_username', 'true');
              }
              _this.loading = false;
              if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
                _this.$router.push('/chat');
              } else {
                _this.$router.push(localStorage.getItem('pathRoom'));
              }
            }
          });
        } else {
          _this.loading = false;
        }
      });
    },
    selectAccount2: function selectAccount2() {
      var _this2 = this;

      if (this.selectedItem.username === '' || this.selectedItem.username === null) {
        console.log('test :', this.selectedItem.username);
        this.nameShowalert = this.selectedItem.email;
      } else {
        this.nameShowalert = this.selectedItem.username;
      }
      this.$swal({
        title: '<span style=" font-family: CS ChatThaiUI !important;">ยืนยันการเลือกบัญชีเข้าใช้งาน?</span>',
        html: '<span style=" font-family: CS ChatThaiUI !important;"> คุณต้องการใช้บัญชี ' + '<b  style="font-size: 18px;font-weight: bold; color:#3085d6;">' + this.nameShowalert + '</b>' + ' ในการเข้าใช้งาน OneChat ใช่หรือไม่?</span>',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: 'grey',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true,
        showLoaderOnConfirm: true
      }).then(function (result) {
        console.log(result.value);
        if (result.value === true) {
          var test = {
            account: {
              profile: {
                account_title_eng: "Miss",
                account_title_th: "นางสาว",
                email: "jantakarn.siv@one.th",
                first_name_eng: "jantakarn",
                first_name_th: "จันทกานติ์",
                id_card_num: "XXXXXX0213531",
                id_card_type: "ID_CARD",
                ip: "172.24.9.54:8998",
                last_name_eng: "sivilize",
                last_name_th: "ศิวิลัยซ์",
                loa: "loa0",
                name: "jantakarn.siv@one.th",
                nickname: "jantakarn.siv@one.th",
                one_id: "100512130944",
                phone: "0905769269",
                profilepicture: "https://testchat.one.th/alpine/api/v1/file/jyc3K7o6nxU6c00766dad3c5b9cb8facfd06d702d45_2020-06-26_10:15:11:049748.png",
                status: "",
                tokenservice: "Aa515b790db355f35a1127f1636d28b49c6402e15cf1040ffb81e900c63e6df13260cf9269f7b4088929c057cce3b415d",
                tokenuser: "U6c00766dad3c5b9cb8facfd06d702d45",
                type: "user",
                username: "jantakarnss"
              }
            }
          };
          var profile = test['account']['profile'];
          // console.log('Profile :' , profile)
          _this2.myprofilepicture = profile['profilepicture'];
          // console.log(this.myprofilepicture)
          _this2.myname = profile['name'];
          _this2.$cookie.set('language', 'th');
          localStorage.setItem('Authenrization', services["b" /* Encode */].encode({ 'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type'] }));
          localStorage.setItem('profilepicture', profile['profilepicture']);
          localStorage.setItem('name', profile['name']);
          localStorage.setItem('phone', profile['phone']);
          localStorage.setItem('email', profile['email']);
          localStorage.setItem('status', profile['status']);
          localStorage.setItem('type_user', profile['type']);
          if (profile['username'] === '' || profile['username'] === 'None') {
            localStorage.setItem('status_username', 'false');
          } else {
            localStorage.setItem('status_username', 'true');
          }
          _this2.isLoading = false;
          if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
            _this2.$router.push('/chat');
          } else {
            _this2.$router.push(localStorage.getItem('pathRoom'));
          }
        }
      });

      // var username = 'jantakarnSivi'
      // this.$cookie.set('language', 'th')
      // localStorage.setItem('Authenrization','9JiclNXdiojIyV2c19VZwlHdiwiIUJiOi4Wan9GbfNXd0FGdzJCLiUDNkJDM3QmNwQmZjFmZ4I2Y5IWNjNDZhRmN2cDMwMmNVJiOiIXZzVnblt2b0JyeAe5pBp2')
      // localStorage.setItem('profilepicture', 'https://testchat.one.th/alpine/api/v1/file/jyc3K7o6nxU6c00766dad3c5b9cb8facfd06d702d45_2020-06-26_10:15:11:049748.png')
      // localStorage.setItem('name', 'jantakarn.siv@one.th')
      // localStorage.setItem('phone', '0905769269')
      // localStorage.setItem('email', 'jantakarn.siv@one.th')
      // localStorage.setItem('status', "")
      // localStorage.setItem('type_user', "type_user")
      // if (username === '' || username === 'None') {
      //   localStorage.setItem('status_username', 'false')
      // } else {
      //   localStorage.setItem('status_username', 'true')
      // }
      //   this.isLoading = false
      //   if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
      //     this.$router.push('/chat')
      //   } else {
      //     this.$router.push(localStorage.getItem('pathRoom'))
      //   }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3945c79a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/SelectAccount.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"border-radius":"10px"},attrs:{"width":"500","persistent":""},model:{value:(_vm.dialogSelectaccount),callback:function ($$v) {_vm.dialogSelectaccount=$$v},expression:"dialogSelectaccount"}},[_c('v-card',{staticStyle:{"border-radius":"10px"}},[_c('v-toolbar',{staticStyle:{"border-top-left-radius":"10px !important","border-top-right-radius":"10px"},attrs:{"color":"white"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('Dialog.selectaccount.title1')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.closeSelectaccount()}}},[_vm._v("close")])],1),_vm._v(" "),_c('div',{staticClass:"padding-text"},[_c('h3',[_vm._v(_vm._s(_vm.$t('Dialog.selectaccount.title2')))])]),_vm._v(" "),_c('div',{staticClass:"scrolling-wrapper",staticStyle:{"overflow-y":"auto","height":"400px"}},[_c('v-list',{attrs:{"three-line":""}},[_vm._l((_vm.list_accounts),function(item,index){return [_c('v-list-tile',{key:index,class:{ active: index === _vm.activeItem},attrs:{"avatar":""},on:{"click":function($event){_vm.itemType(item,index)}}},[_c('v-list-tile-avatar',[(item.profilepicture)?_c('img',{attrs:{"src":item.profilepicture}}):_c('img',{attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[(item.username)?_c('v-list-tile-title',[_vm._v(_vm._s(item.username))]):_c('v-list-tile-title',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.email))])],1)],1)]})],2)],1),_vm._v(" "),_c('div',{staticClass:"padding-text",staticStyle:{"padding-right":"16px","text-transform":"none"}},[_c('v-layout',{attrs:{"justify-end":""}},[_c('v-btn',{staticStyle:{"color":"white","text-transform":"none"},attrs:{"round":"","color":"primary","loading":_vm.loading,"disabled":_vm.disableBTN()},on:{"click":function($event){_vm.selectAccount()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.login')))]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"dark":"","round":"","color":"red"},on:{"click":function($event){_vm.closeSelectaccount()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_SelectAccount = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/SelectAccount.vue
function injectStyle (ssrContext) {
  __webpack_require__("QeVX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3945c79a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  SelectAccount,
  dialog_SelectAccount,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var chat_dialog_SelectAccount = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yary":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yd74":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YdzA":
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),

/***/ "Ym2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        dialogus: false
    },
    data: function data() {
        var _this = this;

        return {
            loading: false,
            dragAndDropCapable: false,
            borderinputfile: 'border: 1px solid #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;',
            files: [],
            phone: '',
            name: '',
            email: '',
            title: {},
            detail: '',
            phoneRules: [function (v) {
                return !!v && v.length === 10 || _this.$t('Homepage.Dialog.inputphoneErrorDigit');
            }, function (v) {
                return !!v || _this.$t('Homepage.Dialog.inputphoneErrorNumber');
            }, function (v) {
                return (/^0[0-9]{9}/.test(v) || _this.$t('Homepage.Dialog.inputphoneErrorFormat')
                );
            }],
            emailRules: [function (v) {
                return !!v || _this.$t('Homepage.Dialog.inputEmail');
            }, function (v) {
                return !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || _this.$t('Homepage.Dialog.inputEmailError');
            }],
            items: []
        };
    },
    created: function created() {
        this.getsubject();
    },
    mounted: function mounted() {
        this.dragAndDropCapable = this.determineDragAndDropCapable();
        var me = this;
        if (this.dragAndDropCapable) {
            ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
                this.$refs.fileform.addEventListener(evt, function (e) {
                    // console.log(evt)
                    e.preventDefault();
                    e.stopPropagation();
                });
            }.bind(this));
            this.$refs.fileform.addEventListener('dragover', function (e) {
                this.borderinputfile = 'border: 2px dotted #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;';
            }.bind(this));
            this.$refs.fileform.addEventListener('dragleave', function (e) {
                this.borderinputfile = 'border: 1px solid #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;';
            }.bind(this));
            this.$refs.fileform.addEventListener('drop', function (e) {
                for (var i = 0; i < e.dataTransfer.files.length; i++) {
                    this.files.push({ file: e.dataTransfer.files[i], status: 'waiting' });
                    this.getImagePreviews();
                    // if ( e.target.className == "borderfile" ) {
                    this.borderinputfile = 'border: 1px solid #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;';
                    // }
                }
            }.bind(this));
        }
    },

    watch: {
        files: function files() {
            if (this.files.length > 5) {
                this.$swal('', this.$t('Alert.Fail.feedback.maxFiles'), 'warning');
                _.pullAt(this.files, [5]);
            }
        },
        filesmo: function filesmo() {
            if (this.filesmo.length > 5) {
                this.$swal('', this.$t('Alert.Fail.feedback.maxFiles'), 'warning');
                _.pullAt(this.filesmo, [5]);
            }
        }
    },
    methods: {
        closedialog: function closedialog() {
            this.cancel();
            this.$emit('closeDialogus', false);
        },
        uppic: function uppic() {
            $('#files').click();
        },
        uppicmo: function uppicmo() {
            $('#filesmo').click();
        },
        sendfeedback: function sendfeedback() {
            var _this2 = this;

            var lengthfile = this.files.length;
            if (lengthfile === 0) {
                var formData = new FormData();
                formData.append('phone', this.phone);
                formData.append('email', this.email);
                formData.append('comment', this.detail);
                formData.append('name', this.name);
                formData.append('category_id', this.title.category_id);
                this.loading = true;
                this.axios.post("https://uatchat-manage.one.th/manage" + '/feedbackcategory', formData).then(function (response) {
                    if (response.data.status === 'success') {
                        // console.log(response.data)
                        _this2.loading = false;
                        _this2.$swal('', _this2.$t('Alert.Success.success'), 'success');
                        _this2.cancel();
                    } else {
                        _this2.loading = false;
                        _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
                    }
                }).catch(function (err) {
                    console.log(err);
                    _this2.loading = false;
                    _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
                });
            } else {
                this.sendfeedbackfile();
                // for (var i = 0; i < lengthfile; i++) {
                //   this.sendfeedbackfile(i)
                // }
            }
        },
        sendfeedbackmo: function sendfeedbackmo() {
            var _this3 = this;

            var lengthfile = this.filesmo.length;
            if (lengthfile === 0) {
                var formData = new FormData();
                formData.append('phone', this.phone);
                formData.append('email', this.email);
                formData.append('comment', this.detail);
                formData.append('name', this.name);
                formData.append('category_id', this.title.category_id);
                this.axios.post("https://uatchat-manage.one.th/manage" + '/feedbackcategory', formData).then(function (response) {
                    // console.log(response.data)
                    _this3.$swal('', _this3.$t('Alert.Success.success'), 'success');
                    _this3.cancel();
                }, function () {
                    _this3.$swal('', _this3.$t('Alert.Fail.default.somethingWrong'), 'error');
                });
            } else {
                this.sendfeedbackfilemo();
                // for (var i = 0; i < lengthfile; i++) {
                //   this.sendfeedbackfile(i)
                // }
            }
        },
        sendfeedbackfile: function sendfeedbackfile() {
            var _this4 = this;

            var formData = new FormData();
            var lengthfile = this.files.length;
            for (var i = 0; i < lengthfile; i++) {
                var file = this.files[i].file;
                formData.append('file', file, file.name);
            }
            // console.log(formData)
            formData.append('phone', this.phone);
            formData.append('email', this.email);
            formData.append('comment', this.detail);
            formData.append('name', this.name);
            formData.append('category_id', this.title.category_id);
            this.loading = true;
            this.axios.post("https://uatchat-manage.one.th/manage" + '/feedbackcategory', formData).then(function (response) {
                if (response.data.status === 'success') {
                    // console.log(response.data)
                    _this4.loading = false;
                    _this4.$swal('', _this4.$t('Alert.Success.success'), 'success');
                    _this4.cancel();
                } else {
                    _this4.loading = false;
                    _this4.$swal('', _this4.$t('Alert.Fail.default.somethingWrong'), 'error');
                }
            }).catch(function (err) {
                console.log(err);
                _this4.loading = false;
                _this4.$swal('', _this4.$t('Alert.Fail.default.somethingWrong'), 'error');
            });
        },
        sendfeedbackfilemo: function sendfeedbackfilemo() {
            var _this5 = this;

            var formData = new FormData();
            var lengthfile = this.filesmo.length;
            for (var i = 0; i < lengthfile; i++) {
                var file = this.filesmo[i].file;
                formData.append('file', file, file.name);
            }
            // console.log(formData)
            formData.append('phone', this.phone);
            formData.append('email', this.email);
            formData.append('comment', this.detail);
            formData.append('name', this.name);
            formData.append('category_id', this.title.category_id);
            this.axios.post("https://uatchat-manage.one.th/manage" + '/feedbackcategory', formData).then(function (response) {
                // console.log(response.data)
                _this5.$swal('', _this5.$t('Alert.Success.success'), 'success');
                _this5.cancel();
            }, function () {
                _this5.$swal('', _this5.$t('Alert.Fail.default.somethingWrong'), 'error');
            });
        },
        removeFile: function removeFile(key) {
            this.files.splice(key, 1);
            this.getImagePreviews(key);
        },
        removeFilemo: function removeFilemo(key) {
            this.filesmo.splice(key, 1);
            this.getImagePreviewsmo(key);
        },
        getImagePreviews: function getImagePreviews(key) {
            var _this6 = this;

            var _loop = function _loop(i) {
                if (/\.(jpe?g|png|gif)$/i.test(_this6.files[i].file.name)) {
                    var reader = new FileReader();
                    reader.addEventListener('load', function () {
                        this.$refs['preview' + parseInt(i)][0].src = reader.result;
                    }.bind(_this6), false);
                    reader.readAsDataURL(_this6.files[i].file);
                } else {}
            };

            for (var i = 0; i < this.files.length; i++) {
                _loop(i);
            }
        },
        getImagePreviewsmo: function getImagePreviewsmo(key) {
            var _this7 = this;

            var _loop2 = function _loop2(i) {
                if (/\.(jpe?g|png|gif)$/i.test(_this7.filesmo[i].file.name)) {
                    var reader = new FileReader();
                    reader.addEventListener('load', function () {
                        this.$refs['preview' + parseInt(i)][0].src = reader.result;
                    }.bind(_this7), false);
                    reader.readAsDataURL(_this7.filesmo[i].file);
                    // this.extension(this.files[i].name)
                    // console.log(this.extension())
                } else {
                        // this.$nextTick(function(){
                        // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
                        // });
                        // console.log('mm')
                    }
            };

            for (var i = 0; i < this.filesmo.length; i++) {
                _loop2(i);
            }
        },
        extension: function extension(files) {
            var extension = files.split('.')[files.split('.').length - 1].toLowerCase();
            var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
            var pdf = ['pdf'];
            var file = ['ai', 'ps', 'psd'];
            var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm'];
            var presentation = ['ppt', 'pps', 'pot', 'pptx'];
            var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
            var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
            var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff'];
            if (pdf.includes(extension)) {
                return 'fas fa-file-pdf';
            } else if (archive.includes(extension)) {
                return 'fas fa-file-archive';
            } else if (spreadsheet.includes(extension)) {
                return 'fas fa-file-excel';
            } else if (presentation.includes(extension)) {
                return 'fas fa-file-powerpoint';
            } else if (word.includes(extension)) {
                return 'fas fa-file-word';
            } else if (execution.includes(extension)) {
                return 'fas fa-file-code';
            } else if (image.includes(extension)) {
                return 'fas fa-file-image';
            } else if (file.includes(extension)) {
                return 'fas fa-file';
            } else {
                return 'fas fa-file-alt';
            }
            // return extension[extension.length-1]
        },
        determineDragAndDropCapable: function determineDragAndDropCapable() {
            var div = document.createElement('div');
            return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
        },
        handleFilesUpload: function handleFilesUpload(key) {
            var uploadedFiles = this.$refs.files.files;
            for (var i = 0; i < uploadedFiles.length; i++) {
                this.files.push({ file: uploadedFiles[i], status: 'waiting' });
            }
            this.getImagePreviews(key);
            document.querySelector('#files').value = '';
        },
        handleFilesUploadmo: function handleFilesUploadmo(key) {
            var uploadedFiles = this.$refs.filesmo.files;
            for (var i = 0; i < uploadedFiles.length; i++) {
                this.filesmo.push({ file: uploadedFiles[i], status: 'waiting' });
            }
            this.getImagePreviewsmo(key);
            document.querySelector('#filesmo').value = '';
        },
        getsubject: function getsubject() {
            var _this8 = this;

            this.axios.post("https://uatchat-manage.one.th/manage" + '/getcategory').then(function (response) {
                if (response.data.status === 'success') {
                    // console.log(response.data)
                    _this8.items = response.data;
                }
            });
        },
        cancel: function cancel() {
            this.phone = '';
            this.name = '';
            this.email = '';
            this.title = {};
            this.detail = '';
            this.files = [];
            this.filesmo = [];
        },
        clear: function clear() {
            var _this9 = this;

            if (this.name !== '' || this.email !== '' || this.title.category_TH || this.detail !== '') {
                this.$swal({
                    title: this.$t('Alert.Sure'),
                    text: this.$t('Alert.Clear'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.$t('AnswerQuestion.ok'),
                    cancelButtonText: this.$t('AnswerQuestion.cancel'),
                    confirmButtonClass: 'btn btn-success',
                    cancelButtonClass: 'btn btn-danger',
                    buttonsStyling: true,
                    showCloseButton: true,
                    reverseButtons: true
                }).then(function (result) {
                    if (result.value) {
                        _this9.cancel();
                        // this.$emit('closeDialogus', false)
                    }
                });
            }
        },
        sendme: function sendme() {
            var _this10 = this;

            this.axios.post("https://uatchat-manage.one.th/manage" + '/contactus', { name: this.name, email: this.email, title: this.title.category_TH, detail: this.detail, platform: 'webportal' }).then(function (response) {
                if (response.data.status === 'success') {
                    _this10.$swal('', _this10.$t('Alert.Success.success'), 'success');
                    _this10.cancel();
                }
            }, function (response) {});
        },
        linkAPI: function linkAPI() {
            window.open('/docs', '_blank').focus();
        },
        toPage: function toPage(page) {
            this.$router.push(page);
        },
        linkregister: function linkregister() {
            window.open('/register').focus();
        },
        linkdownload: function linkdownload() {
            window.open('/download').focus();
        },
        toNewTab: function toNewTab() {
            window.open(this.webdev, '_blank').focus();
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "YtfS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YyZ0":
/***/ (function(module, exports) {

module.exports = {"welcomeMsg":"สวัสดีค่ะ {name}","HeaderMenubar":{"qrcode":"คิวอาร์โค้ด","loa":"ระดับความน่าเชื่อถือ","editProfile":"แก้ไขโปรไฟล์","managefriend":"จัดการเพื่อน","sendOnebox":"ส่งไฟล์ไป One Box","feedback":"ข้อเสนอแนะ","support":"ศูนย์ช่วยเหลือ","terms_of_service":"เงื่อนไขการให้บริการ","policy":"นโยบายความเป็นส่วนตัว","logout":"ออกจากระบบ","createproject":"สร้างโปรเจค","project":"โปรเจคทั้งหมด","calendar":"ปฏิทิน","languages":"ภาษา","general":"ทั่วไป","profile":"โปรไฟล์"},"Conjunction":{"or":"หรือ","and":"และ"},"AnswerQuestion":{"ok":"ตกลง","cancel":"ยกเลิก","sure":"แน่ใจ","no":"ไม่!","edit":"แก้ไข","remove":"ลบ","update":"อัปเดต","sendme":"ส่งถึงเรา","forward":"ส่งต่อ","send":"ส่ง","joinGroup":"เข้ากลุ่ม","acceptFriend":"ตอบรับคำขอ","removeFriend":"ลบเพื่อน","kickMemberGroup":"ลบออกจากกลุ่ม","chat":"แชท","cancelRequest":"ยกเลิกคำขอ","cancelInvite":"ยกเลิกคำเชิญ","unblock":"ยกเลิกการบล็อก","addFriend":"เพิ่มเพื่อน","createGroup":"สร้างกลุ่ม","keep":"บันทึก","Onebox":"Onebox","download":"ดาวน์โหลด","uploadPhoto":"อัปโหลดรูปภาพ","sendOnebox":"ส่งไปยัง Onebox","selectPicture":"เลือกรูปภาพ","selectFile":"เลือกไฟล์","uploadAll":"อัปโหลดทั้งหมด","newuUpload":"อัปโหลดใหม่","upload":"อัปโหลด","clear":"ล้างข้อมูล","resetbackground":"ลบพื้นหลังแชท","setbackground":"เปลี่ยนพื้นหลังแชท","continue":"ดำเนินการต่อ","open":"เปิด","login":"เข้าสู่ระบบ"},"Dialog":{"Saveonebox":{"titlefolder":"เลือกโฟล์เดอร์","titleaccount":"เลือกบัญชีผู้ใช้งาน"},"ShowFriendDialog":{"header":"สมาชิกในกลุ่ม {groupname}","noMember":"ยังไม่มีสมาชิกตอบรับ"},"account":"ส่งข้อมูลติดต่อ","pictureProfile":"รูปโปรไฟล์","forward":{"header":"เลือกห้องสนทนา","friend":"เพื่อน","group":"กลุ่ม","searchgroup":"ค้นหากลุ่ม"},"map":{"header":"ส่งตำแหน่ง","placeholder":"เลือกสถานที่"},"approve":{"detail":"รายละเอียด","answer":"ขออภัย!! ข้อความนี้ได้รับการตอบกลับแล้ว"},"sendEmail":{"header":"ส่งไปยังอีเมล","to":"ถึง:","subject":"เรื่อง:","detail":"รายละเอียด...","removeFile":"[ ลบ ]","send":"ส่ง","note":"หมายเหตุ: กรุณาใส่ , (Comma) คั่นอีเมล กรณีต้องการส่งถึงผู้รับมากกว่า 1 คน","note2":"หมายเหตุ: กรุณากด ⏎ (Enter) กรณีต้องการส่งถึงผู้รับมากกว่า 1 คน"},"album":{"headerAddImage":"เพิ่มรูปภาพในอัลบั้ม","headerCreate":"สร้างอัลบั้ม","nameAlbum":"ชื่ออัลบั้ม","btnCreate":"สร้างอัลบั้ม","btnAddImage":"เพิ่มรูปภาพ","btnEdit":"แก้ไขชื่ออัลบั้ม","btnRemoveImage":"ลบรูปภาพ","btnRemoveAlbum":"ลบอัลบั้ม","noDataAlbum":"ไม่มีรายการอัลบั้ม","noAlbum":"อัลบั้มนี้ถูกลบแล้ว","noImageAlbum":"ไม่มีรูปภาพในอัลบั้มนี้"},"showImage":{"by":"ส่งโดย","date":"วันที่"},"group":{"headerInvite":"เชิญเพื่อนเข้ากลุ่ม","headerSetting":"ตั้งค่ากลุ่มเพื่อน","chooseFriend":"เลือกเพื่อน","groupName":"ชื่อกลุ่ม","group":"กลุ่ม: ","detailQrcode":"คุณสามารถใช้ คิวอาร์โค้ด นี้ส่งมอบให้บุคคลอื่น เพื่อรับเข้ากลุ่ม","searching":"ค้นหาเพื่อน","detailQrjoingroup":"คิวอาร์โค้ดสำหรับการเข้ากลุ่ม"},"note":{"headerCreate":"สร้างโน้ต","headerNote":"โน้ต","noNote":"ขออภัย!! โน้ตนี้ถูกลบแล้ว","deleteNote":"คุณต้องการจะลบโน๊ตนี้ใช่หรือไม่?"},"wallpaper":{"headerWallpaper":"พื้นหลังแชท"},"anonymous":{"headerCreate":"สร้างกลุ่มแชท","createGroupName":"ตั้งชื่อกลุ่ม","groupName":"ชื่อกลุ่ม","addMember":"ดึงตัวเองเข้ากลุ่ม"},"download":{"textDownload":"ดาวน์โหลดแอปพลิเคชัน One Chat"},"profilefriend":{"headerProfile":"ดูโปรไฟล์"},"ocr":{"selectText":"กรุณาเลือกข้อความที่ท่านต้องการ","processing":"กรุณารอสักครู่ ระบบกำลังประมวลผล"},"selectaccount":{"title1":"หมายเลขนี้มีการเปิดหลายบัญชี","title2":"โปรดเลือกบัญชีที่ต้องการตั้งค่าการลงชื่อเข้าใช้งาน","alert":{"title":"ยืนยันการเลือกบัญชีเข้าใช้งาน","text1":"คุณต้องการใช้บัญชี","text2":"ในการเข้าใช้งาน OneChat ใช่หรือไม่"}}},"LeftSide":{"header":{"friend":"เพื่อน","chat":"แชท","service":"บริการ","project":"โปรเจค","setting":"ตั้งค่า","calendar":"ปฏิทิน","onemeet":"วันมีท","homepage":"หน้าแรก","qrcode":"คิวอาร์โค้ด"},"searching":"ค้นหาเพื่อน หรือกลุ่มเพื่อน","noDataSearching":"ไม่พบข้อมูลที่ค้นหา","friend":{"friendInvite":"ตอบรับเป็นเพื่อน","wantToBeFriend":"ต้องการเป็นเพื่อนกับคุณ","sendFriendInvite":"คำขอเป็นเพื่อน","waitingRequestFriend":"รอการตอบรับคำขอเป็นเพื่อน","groupInvite":"ตอบรับเข้ากลุ่ม","haveMember":"มีสมาชิก {count} คน","friend":"เพื่อน","addFriend":"เพิ่มเพื่อน","group":"กลุ่ม","createGroup":"สร้างกลุ่มเพื่อน"},"addFiend":{"header":"เพิ่มเพื่อน","searching":"ค้นหาเพื่อน","detailSearch":"คุณสามารถค้นหาเพื่อนได้จาก เบอร์โทรศัพท์, อีเมล หรือ Bot ID","nodata":"ไม่พบข้อมูล {key}","placeholderPassword":"กรุณากรอกรหัสผ่าน","messageCheckbot":"รหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบรหัสผ่าน","headerCheckpass":"ตรวจสอบรหัสผ่าน"},"createGroup":{"header":"สร้างกลุ่ม","selectPicture":"เลือกรูปภาพ","detailSearch":"กรุณากรอกชื่อกลุ่ม","searching":"ค้นหาเพื่อน","numberFriend":"เพื่อนที่เชิญเข้ากลุ่ม {count} คน","noneSelect":"คุณยังไม่ได้เลือกเพื่อน"},"chat":{"leftChat":"คุณได้ออกจากการสนทนาแล้ว","startChat":"เริ่มต้นการสนทนา","sendSticker":"ส่งสติกเกอร์","sendFile":"ส่งไฟล์","sendLocation":"ส่งสถานที่","sendContact":"ส่งผู้ติดต่อ","sendPicture":"ส่งรูปภาพ","sendNote":"ส่งโน๊ต","sendVideo":"ส่งวิดีโอ","sendReply":"ตอบกลับข้อความ","sendOfficial_template":"ส่ง official_template","sendConference_msg":"เริ่มการโทร","createAlbum":"สร้างอัลบั้ม","createTask":"สร้างการ์ดงาน","createProject":"สร้างโปรเจค","approveMessage":"ส่งแบบฟอร์มยืนยัน","unsendMessage":"ยกเลิกข้อความ","call":{"time":"เวลาโทร","noResponse":"ไม่มีการตอบรับ","cancel":"ยกเลิกการโทร","missed":"ไม่ได้รับสาย","end":"จบการสนทนา"},"sendCarousel":"ส่งข้อความรูปภาพ"}},"ChatSide":{"loadHistory":"โหลดข้อความเก่า","system":{"self":{"cancelMsg":"คุณได้ยกเลิกข้อความ","editNameAlbum":"คุณแก้ไขชื่ออัลบั้ม","createAlbum":"คุณสร้างอัลบั้ม {name}","deleteAlbum":"คุณลบอัลบั้ม","deleteImageAlbum":"คุณลบรูปภาพในอัลบั้ม","editTask":"คุณแก้ไขการ์ดงาน","joinGroup":"คุณเข้าร่วมกลุ่ม","leftGroup":"คุณออกจากกลุ่ม","createProject":"คุณสร้างโปรเจค"},"other":{"cancelMsg":"{name} ยกเลิกข้อความ","editNameAlbum":"{name} แก้ไขชื่ออัลบั้ม","createAlbum":"{name} สร้างอัลบั้ม {album_name}","deleteAlbum":"{name} ลบอัลบั้ม","deleteImageAlbum":"{name} ลบรูปภาพในอัลบั้ม","editTask":"{name} แก้ไขการ์ดงาน","joinGroup":"{name} เข้าร่วมกลุ่ม","leftGroup":"{name} ออกจากกลุ่ม","createProject":"{name} สร้างโปรเจค"},"default":{"kickMemberGroup":"{name_active} ลบ {name_passive} ออกจากกลุ่ม","inviteMemberGroup":"{name_active} เชิญ {name_passive}"}},"Album":{"createAlbumHeader":"สร้างอัลบั้ม","insertImageAlbum":"เพิ่มรูปภาพในอัลบั้ม {name}","numberImage":"รวม: {count} ภาพ"},"Task":{"viewDetail":"ดูรายละเอียด Task","editAssign":"กำหนดภาระงาน","assign":"ผู้รับผิดชอบ"},"image":"รูปภาพ","sticker":"สติกเกอร์","note":"โน้ต","emoji":"อีโมจิ","file":"ไฟล์","friend":"เพื่อน","location":"ตำแหน่งที่ตั้ง","forward":"ส่งต่อข้อความ","numberMsgSent":"ข้อความที่ถูกส่ง","noMsg":"ไม่สามารถแสดงข้อความนี้ได้","notSupportVersion":"ขออภัยข้อความนี้ยังไม่รองรับในเวอร์ชันนี้","resend":"ส่งใหม่อีกครั้ง","conference":{"joinCall":"เข้าร่วม","startCall":"เริ่มการโทร","startVideo":"เริ่มวิดีโอคอล"},"approve_message":{"viewDetail":"คลิกดูรายละเอียด","receiveAns":"ได้รับคำตอบจากคุณแล้ว"},"textarea":{"normal":"พิมพ์ข้อความ...","inactive":"ไม่สามารถพิมพ์ข้อความได้"},"Read":{"readmore":"แสดงเพิ่มเติม","readless":"แสดงน้อยลง"},"announce":{"delete":"ไม่แสดงอีก","minimize":"ย่อ"},"RightClickMenu":{"addImageAlbum":"เพิ่มรูปภาพในอัลบั้ม","mention":"ตอบกลับข้อความ","sendmail":"ส่งไปยังอีเมล","cancelMsg":"ยกเลิกข้อความ","announce":"ประกาศ","cancelAnnounce":"ไม่แสดงอีก","pinChat":"ปักหมุด","unpinChat":"เลิกปักหมุด","forward":"ส่งต่อข้อความ","openfile":"เปิดไฟล์","openlocation":"ดูแผนที่","openimage":"ดูรูปภาพ","profile":"ดูข้อมูลเพื่อน"}},"RightSide":{"header":{"profile":"ข้อมูลส่วนตัว","image":"รูปภาพ","file":"ไฟล์","privatepolicy":"ข้อตกลงยินยอมความเป็นส่วนตัว"},"menu":{"project":"โปรเจคงาน","album":"อัลบั้ม","note":"โน้ต","clearChat":"ลบแชท","block":"บล็อกเพื่อน","unblock":"ยกเลิกการบล็อก","qrCode":"คิวอาร์โค้ด","leave":"ออกจากกลุ่ม","invite":"เชิญเพื่อน","setting":"ตั้งค่า","setwall":"พื้นหลังแชท"},"noImage":"ไม่พบการส่งภาพในห้องสนทนานี้","noFile":"ไม่พบการส่งไฟล์ในห้องสนทนานี้","group":"กลุ่ม","member":"สมาชิก","pending":"กำลังเชิญ","noMember":"ยังไม่มีสมาชิกตอบรับ","loadmore":"โหลดเพิ่ม","noNote":"ยังไม่มีการสร้างโน้ต"},"Alert":{"Sure":"คุณแน่ใจหรือไม่?","Clear":"เรากำลังลบข้อมูลทั้งหมด ที่คุณกรอก","Unblocking":"เรากำลังยกเลิกการบล็อก {name}!","Blocking":"เรากำลังทำการบล็อก {name}!","RemoveFriend":"คุณต้องการลบ {name} ใช่หรือไม่?","Saveonebox":"คุณต้องการบันทึกไฟล์ที่โฟลเดอร์นี้ใช่หรือไม่?","Unsavefile":"ไฟล์นี้ถูกบันทึกแล้ว ไม่สามารถบันทึกไฟล์ซ้ำได้","Chat":{"announce":{"cancel":"ไม่แสดงข้อความนี้อีก?","deleteAll":"ไม่แสดงข้อความทั้งหมดอีก?"},"unsent":"คุณต้องการยกเลิกการส่งข้อความ?","sendDatetime":"คุณต้องการจะส่ง"},"Left":{"cancelRequest":"คุณต้องการยกเลิกคำขอเป็นเพื่อนจาก {name} ใช่หรือไม่?"},"Right":{"clearChat":"คุณต้องการลบข้อความในห้องแชทหรือไม่?","cancelInvite":"คุณต้องการยกเลิกคำเชิญ {name}?","deleteFriendGroup":"คุณต้องการลบ {name} ออกจากกลุ่ม?","leaveGroup":"คุณต้องการออกจากกลุ่มนี้?","removeNote":"คุณต้องการจะลบโน้ตนี้ใช่หรือไม่?","removeWallpaper":"คุณต้องการจะลบพื้นหลังแชทนี้ใช่หรือไม่?","cancleEditPhone":"ต้องการยกเลิกใช่หรือไม่"},"Album":{"headerAddImageAlbum":"เพิ่มรูปในอัลบั้ม","textAddImageAlbum":"คุณต้องการเพิ่มรูปในอัลบั้ม {name}?","deleteImage":"คุณต้องการลบรูปในอัลบั้มนี้ใช่หรือไม่?","deleteAlbum":"คุณต้องการลบอัลบั้มนี้ใช่หรือไม่?"},"Group":{"cancelGroup":"คุณต้องการยกเลิกเข้ากลุ่ม {name} ใช่หรือไม่?"},"Task":{"remove":"คุณต้องการลบการ์ดงานนี้ใช่หรือไม่","removeComment":"คุณต้องการลบความคิดเห็นนี้ใช่หรือไม่","removeChecklist":"คุณต้องการลบรายการตรวจสอบนี้ใช่หรือไม่","removeData":"คุณต้องการเคลียร์ข้อมูลใช่หรือไม่"},"Login":{"phoneNotVerify":"หมายเลขโทรศัพท์นี้ยังไม่ได้รับการลงทะเบียน กรุณาลงทะเบียนหรือกรอกหมายเลขโทรศัพท์อื่น","phoneVerify":"หมายเลขโทรศัพท์นี้ได้รับการลงทะเบียนไปแล้ว กรุณาลงชื่อเข้าใช้งานหรือกรอกหมายเลขโทรศัพท์อื่น","otpRequest":"หมายเลขโทรศัพท์นี้ร้องขอ otp บ่อยเกินไป กรุณารอซักครู่แล้วเริ่มทำรายการใหม่","otpInvalid":"กรอกรหัส OTP ไม่ถูกต้อง","inputUserPass":"กรุณากรอกชื่อผู้ใช้งานและรหัสผ่าน","invalidUserPass":"ชื่อผู้ใช้งานหรือรหัสผ่านผิด กรุณาตรวจสอบใหม่อีกครั้ง","previouspage":"คุณกำลังย้อนกลับไปเพื่อกรอกหมายเลขโทรศัพท์ใหม่"},"Success":{"success":"สำเร็จ!","createGroup":"สร้างกลุ่มสำเร็จ","feedback":"ส่งข้อเสนอแนะสำเร็จ","announce":"ประกาศข้อความสำเร็จ","unsent":"ยกเลิกการส่งข้อความสำเร็จ","unblock":"ยกเลิกการบล็อกสำเร็จ","block":"ทำการบล็อกสำเร็จ","removefriend":"ลบเพื่อนสำเร็จ","sending":"การส่งสำเร็จ","sendFile":"ไฟล์ของคุณถูกจัดส่งเรียบร้อยแล้ว","sendFiletoOnebox":"ไฟล์ของคุณถูกจัดส่งไปยัง onebox สำเร็จแล้ว","sendMsg":"ข้อความของคุณถูกจัดส่งเรียบร้อยแล้ว","sendEmail":"อีเมลของคุณถูกจัดส่งเรียบร้อยแล้ว","account":"ข้อมูลติดต่อถูกจัดส่งแล้ว","createNote":"สร้างโน้ตสำเร็จ","savePhotoAlbum":"เพิ่มรูปภาพสำเร็จ","renameAlbum":"แก้ไขชื่ออัลบั้มสำเร็จ","createAlbum":"สร้างอัลบั้มสำเร็จ","removePhoto":"ลบรูปภาพสำเร็จ","cancelInvite":"ยกเลิกคำเชิญเข้ากลุ่มสำเร็จ","removeFriendGroup":"ลบเพื่อนออกจากกลุ่มสำเร็จ","inviteFriendGroup":"การเชิญเพื่อนเข้ากลุ่มสำเร็จ","renameGroup":"แก้ไขชื่อกลุ่มสำเร็จ","changePictureGroup":"เปลี่ยนภาพกลุ่มสำเร็จ","createTask":"สร้างการ์ดงานสำเร็จ","removeTask":"ลบการ์ดงานสำเร็จ","editTask":"แก้ไขการ์ดงานสำเร็จ","removeComment":"ลบความคิดเห็นสำเร็จ","createComment":"เพิ่มความคิดเห็นสำเร็จ","createProject":"สร้างโปรเจคสำเร็จ","createChecklist":"สร้างรายการตรวจสอบสำเร็จ","removeChecklist":"ลบรายการตรวจสอบสำเร็จ","setbackground":"เปลี่ยนภาพพื้นหลังสำเร็จ","deletebackground":"ลบพื้นหลังแชทสำเร็จ","settingusername":"ตั้งค่าชื่อผู้ใช้งานและรหัสผ่านสำเร็จ","createGroupChat":"สร้างกลุ่มแชทสำเร็จแล้ว"},"Fail":{"createGroup":{"title":"ไม่สามารถสร้างกลุ่มได้","selectFriend":"กรุณาเลือกเพื่อนอย่างน้อย 1 คน","groupname":"กรุณากรอกชื่อกลุ่ม"},"feedback":{"connectError":"ไม่สามารถส่งข้อความได้ กรุณาลองใหม่ภายหลัง","maxFiles":"เลือกรูปภาพได้สูงสุด 5 รูป"},"Chat":{"maxMessage":"เลือกข้อความได้สูงสุด 5 ข้อความ","maxSizeFile":"ไม่สามารถส่งไฟล์ได้ เนื่องจากไฟล์มีขนาดเกิน 25 MB","maxSizeFile100":"ไม่สามารถส่งไฟล์ได้ เนื่องจากไฟล์มีขนาดเกิน 100 MB","uploadPic":"โปรดอัปโหลดรูปใหม่"},"default":{"somethingWrong":"เกิดความผิดปกติบางอย่างขึ้น กรุณาลองใหม่ในภายหลัง","networkError":"โปรดตรวจสอบการเชื่อมต่ออินเตอร์เน็ต"},"forward":{"maxChatRoom":"เลือกห้องสนทนาได้สูงสุด 5 ห้องสนทนา","selectMessage":"กรุณาเลือกข้อความที่ต้องการส่ง"},"Album":{"maxSizeFile":"ไฟล์ของท่านมีขนาดเกิน 25 MB","maxFiles":"เลือกรูปภาพได้สูงสุด 5 รูป","minFiles":"เลือกรูปภาพอย่างน้อย 1 รูป","removed":"ขออภัย!! อัลบั้มนี้ถูกลบแล้ว","emptyName":"กรุณากรอกชื่ออัลบั้ม","supportType":"สกุลไฟล์ไม่รองรับ"},"Task":{"removed":"ขออภัย การ์ดนี้ถูกลบแล้ว"},"SendMail":{"inputMail":"กรุณากรอกอีเมลที่ต้องการส่ง","inputSubject":"กรุณากรอกหัวข้ออีเมล"},"nameuser":"กรุณากรอกชื่อผู้ใช้"},"Warning":{"link_market":"ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์"},"CheckOpenNewTab":"คุณต้องการเปิดแท็บใหม่ใช่หรือไม่?"},"Task":{"create":{"header":"สร้างการ์ดงาน","subject":"หัวข้อการ์ดงาน","placeholderSubject":"กรุณากรอกหัวข้อการ์ดงาน","priority":"ระดับความสำคัญ","p1":"มาก","p2":"ปานกลาง","p3":"น้อย","startDate":"วันเริ่มต้น","endDate":"วันสิ้นสุด","description":"รายละเอียด","placeholderDescription":"กรุณากรอกรายละเอียดของงาน","assign":"ผู้รับผิดชอบ","placeholderAssign":"เลือกผู้รับผิดชอบ","status":"สถานะ","comment":"ความคิดเห็น","placeholderComment":"กรุณากรอกความคิดเห็น","placeholderSubjectProject":"กรุณากรอกหัวข้อโปรเจค","projectSubject":"หัวข้อโปรเจค","placeholderChecklist":"กรุณากรอกรายการ","checklist":"รายการตรวจสอบ","select":"กรุณาเลือกเพื่อน หรือกลุ่ม"},"detail":{"header":"รายละเอียดงาน","menu":{"edit":"แก้ไขการ์ดงาน","delete":"ลบการ์ดงาน","deletecommemt":"ลบความคิดเห็น","deletechecklist":"ลบรายการ"},"createBy":"สร้างโดย","signDocument":"เซ็นเอกสาร"},"allTask":{"back":"ย้อนกลับ","createTask":"สร้างการ์ดงาน","numTask":"{count} การ์ด","placeholderSearchGroup":"ค้นหาชื่อกลุ่ม","placeholderSearchFriend":"ค้นหาเพื่อน","newGroup":"สร้างกลุ่มใหม่","placeholderSearchProject":"ค้นหาโปรเจค","createDate":"วันที่สร้าง {date}","detailProject":"ดูโปรเจคเพิ่มเติม","moreDetail":"รายละเอียดเพิ่มเติม","noProjectList":"ยังไม่มีรายการโปรเจค กรุณาสร้างโปรเจค","noCardTask":"ยังไม่มีการ์ดงาน กรุณาสร้างการ์ดงาน","createProject":"สร้างโปรเจค","myProject":"โปรเจคของฉัน ({count})","noListFriend":"ไม่มีรายชื่อเพื่อน กรุณาเพิ่มเพื่อน","noListGroup":"ไม่มีรายการกลุ่ม กรุณาสร้างกลุ่ม","projectDetail":"รายละเอียดโปรเจค","localepicker":"th","next":"ถัดไป","selectProject":"กรุณาเลือกห้องสนทนา"}},"Settings":{"Qrcode":{"header":"คิวอาร์โค้ด","myQRcode":"คิวอาร์โค้ดของฉัน","scanQRcode":"ตัวอ่านคิวอาร์โค้ด","openCamera":"กรุณาเปิดกล้อง","resultScan":"ผลการสแกน"},"editProfile":{"changePictureProfile":"เปลี่ยนรูป","support":"รองรับไฟล์","profile":"ข้อมูลส่วนตัว","displayName":"ชื่อผู้ใช้","status":"สถานะ","phone":"เบอร์โทรศัพท์","email":"ที่อยู่อีเมล","qrcodeForAddFriend":"คิวอาร์โค้ด สำหรับเพิ่มเพื่อน","detailQRcode":"คุณสามารถใช้ คิวอาร์โค้ด นี้ส่งมอบให้บุคคลอื่น เพิ่มคุณเป็นเพื่อนได้","settingusername":"ตั้งค่าชื่อผู้ใช้งานและรหัสผ่าน","usernamepassword":"ชื่อผู้ใช้งานและรหัสผ่าน","username":"ชื่อผู้ใช้งาน","password":"รหัสผ่าน","confirmpassword":"ยืนยันรหัสผ่าน","group":"ข้อมูลกลุ่ม","groupName":"ชื่อกลุ่ม"},"messageError":{"UsernameDuplicate":"ชื่อผู้ใช้งานซ้ำ","UsernameRules1":"กรุณากรอกชื่อผู้ใช้งาน","UsernameRules2":"ไม่สามารถใช้อักขระพิเศษได้","UsernameRules3":"กรุณาใส่ตัวอักษรอย่างน้อย 6 ตัว","UsernameRules4":"กรุณากรอกชื่อผู้ใช้งานเป็นภาษาอังกฤษ a-z และ 0-9 เท่านั้น","UsernameRules5":"กรุณากรอกชื่อผู้ใช้งานที่ประกอบด้วยตัวอักษรภาษาอังกฤษ a-z อย่างน้อย 1 ตัว","PasswordRules1":"กรุณากรอกรหัสผ่าน","PasswordRules2":"รหัสผ่านต้องมีตัวเลขหรือตัวอักษรภาษาอังกฤษ อย่างน้อย 1 ตัว ความยาวอย่างน้อย 8 ตัว","RePasswordRules1":"กรุณากรอกรหัสผ่านซ้ำ","RePasswordRules2":"กรุณากรอกรหัสผ่านให้ตรงกัน"},"messageEditPhone":{"TitleDialogEdit":"แก้ไขเบอร์โทรศัพท์","MsgPhoneRegistered":"หมายเลขของคุณมีการลงทะเบียนแล้ว","MsgDetectPhone":"ตรวจพบหมายเลข","MsgDetectPhonenext":"มีการลงทะเบียนใช้งานระบบแล้ว คุณสามารถเข้าสู่ระบบอีกครั้งเพื่อใช้งานบัญชีดังกล่าวได้ทันที","MsgCloseAccountSelect":"ปิดบัญชีผู้ใช้งานปัจจุบัน","MsgCloseAccountSpan":"โปรดเลือกเมื่อคุณต้องการปิดบัญชีผู้ใช้งานปัจจุบันสำหรับหมายเลข","MsgKeepAccountSelect":"เก็บบัญชีผู้ใช้งานไว้ทั้ง 2 บัญชี","MsgKeepAccountSpan":"โปรดเลือกหากคุณต้องการเก็บบัญชีผู้ใช้งานไว้ทั้งสองบัญชี","MsgCloseOnechatAccount":"การปิดบัญชีผู้ใช้งาน Onechat ของคุณ","MsgCloseOnechatAccountSpan":"หากคุณต้องการปิดบัญชีผู้ใช้งาน OneChat โปรดแจ้งให้เราทราบ","MsgCloseOnechatAccountSelect":"การปิดบัญชีผู้ใช้งานของคุณจะเป็นการดำเนินการถาวร เมื่อคุณปิดบัญชีผู้ใช้ OneChat คุณจะไม่สามารถกู้คืนเนื้อหาหรือข้อมูล และข้อความการสนทนาทั้งหมดของคุณจะถูกลบด้วยเช่นกัน","MsgConfirmCloseAccount":"ยืนยันการปิดแอคเคาท์","ChangePhoneNumber":"คุณต้องการเปลี่ยนเบอร์โทรศัพท์ใช่หรือไม่","MsgSendOTP":"เราได้ส่งรหัส 6 หลักไปยังหมายเลข","MsgOTPNotrecieve":"ไม่ได้รับรหัส OTP","MsgResendOTP":"ส่งอีกครั้งใน","MsgVerifyPhone":"ยืนยันตัวตนทางโทรศัพท์","MsgOTPAgain":"ขอ otp อีกครั้ง","MsgLoginPhoneAgain":"กรุณาเข้าสู่ระบบด้วยเบอร์โทรศัพท์อีกครั้ง","MsgSwitchAccount":"คุณต้องการสลับบัญชีผู้ใช้งานใช่หรือไม่?","MsgChangePhoneSuccess":"เปลี่ยนเบอร์โทรศัพท์สำเร็จ","OTPInvalid":"รหัส otp ไม่ถูกต้อง","MsgTooManyRequest":"กรุณารอ 5 นาทีเพื่อขอ otp อีกครั้ง","MsgTokenExpire":"Token หมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง"},"manageFriend":{"headerManageFriend":"ข้อมูลการบล็อกเพื่อน","nodata":"ไม่พบข้อมูลเพื่อนที่คุณบล็อก"},"feedback":{"suggestion":"ข้อเสนอแนะ","headerFeedback":"เราดีใจที่ได้ยินว่าคุณคิดอย่างไรกับเรา ความคิดเห็นจากคุณจะช่วยปรับปรุงประสบการณ์การใช้งาน One Chat ได้ดียิ่งขึ้น","titleFeedback":"คุณสามารถแชร์ประสบการณ์การใช้งาน เสนอแนะบริการ หรือแจ้งความผิดพลาดได้ที่นี่ หากต้องการความช่วยเหลือโปรดติดต่ออีเมล","contact":"ศูนย์ช่วยเหลือ","name":"ชื่อ","title":"หัวข้อ","report":"แจ้งปัญหา","detail":"รายละเอียด","selectPicture":"เลือกรูปภาพ","selcetmultipleImage":"ลากและวางรูปภาพที่นี่","selectmultipleFiles":"ลากและวางไฟล์ที่นี่","or":"หรือ"},"helpCenter":{"header":"ศูนย์ช่วยเหลือ","company":"บริษัท วัน เซ็นทริค จำกัด","address":"1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16 ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310","email":"อีเมล"},"policy":{"header":"นโยบายคุ้มครองสิทธิความเป็นส่วนตัวของวันแชท","subject1":{"header":"1. บทนำ","introDetail":"บริษัท วัน เซ็นทริค จำกัด (“วันแชท”, “บริษัท” หรือ “ของบริษัท”) เชื่อว่าความเป็นส่วนตัวของท่านเป็นสิ่งสำคัญยิ่งในการบรรลุตามข้อผูกพันของบริษัทในการเคารพและคุ้มครองสิทธิความเป็นส่วนตัวของท่าน บริษัทจะปฏิบัติตามหลักการพื้นฐานเหล่านี้","subjectIntro1":"1. บริษัทจะเรียนให้ท่านทราบเกี่ยวกับข้อมูลส่วนบุคคลที่จะขอความยินยอมจากท่านตามที่เห็นสมควรเพื่อเก็บรวบรวม ประมวลผลใช้งาน หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน","subjectIntro2":"2. บริษัทจะระบุวัตถุประสงค์ของการเก็บรวบรวมและประมวลผลอันเป็นข้อมูลส่วนบุคคลของท่าน","subjectIntro3":"3. บริษัทเก็บรวบรวมเฉพาะข้อมูลที่จำเป็นสำหรับการปฏิบัติตามวัตถุประสงค์การใช้งานที่ระบุเท่านั้น","subjectIntro4":"4. บริษัทจะใช้หรือเปิดเผยข้อมูลส่วนบุคคลของท่านตามวัตถุประสงค์ในการเก็บรวบรวมเท่านั้น ยกเว้นได้รับความยินยอมจากท่าน หรือตามที่กฎหมายกำหนด และบริษัทจะเก็บรักษาข้อมูลของท่านไว้ตราบเท่าที่จำเป็นสำหรับวัตถุประสงค์เท่านั้น","subjectIntro5":"5. บริษัทจะพยายามดำเนินการให้แน่ใจว่า ข้อมูลส่วนบุคคลของท่านถูกต้อง ครบถ้วน และเป็นปัจจุบัน","subjectIntro6":"6. บริษัทจะจัดให้มีเทคนิคและมาตรฐานองค์กรที่เหมาะสมเพื่อคุ้มครองข้อมูลส่วนบุคคลของท่านอย่างเหมาะสม","subjectIntro7":"7. บริษัทจะจัดทำนโยบายและแนวปฏิบัติต่าง ๆ ของบริษัท เพื่อให้การจัดการข้อมูลส่วนบุคคลของท่าน มีความโปร่งใสตามสมควรเท่าที่จะเป็นไปได้","subjectIntro8":"8. บริษัทยินดีรับฟังความคิดเห็นของท่าน เกี่ยวกับการปฏิบัติตามหลักการเหล่านี้ นโยบายคุ้มครองสิทธิความเป็นส่วนตัวนี้ และกฎหมายที่ใช้บังคับ"},"subject2":{"header":"2. ขอบเขตนโยบายคุ้มครองสิทธิความเป็นส่วนตัว","subHeaderScopeA":"ก. เป้าหมายของนโยบายคุ้มครองสิทธิความเป็นส่วนตัว","subHeaderScopeB":"ข. นโยบายคุ้มครองสิทธิความเป็นส่วนตัวใด ที่ใช้บังคับกับบริการอื่น ๆ ของวันแชท","detailScopeA1":"นโยบายคุ้มครองสิทธิความเป็นส่วนตัวนี้ อธิบายวิธีที่วันแชท ใช้ในการจัดการและปกป้องข้อมูลส่วนบุคคลของท่าน รวมไปถึงสิทธิทางเลือกต่าง ๆ ที่เกี่ยวกับข้อมูลส่วนบุคคลของท่าน","detailScopeA2":"นโยบายคุ้มครองสิทธิความเป็นส่วนตัวนี้มีผลบังคับใช้กับข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวม จากท่าน เมื่อท่านใช้แอปพลิเคชันเพื่อการติดต่อสื่อสารผ่าน วันแชท (“แอปพลิเคชันวันแชท”) บริการต่าง ๆ ที่มีให้เลือกในแอปพลิเคชันวันแชท และแอปพลิเคชันอื่นที่รวมอยู่ หรือทำงานร่วมกับแอปพลิเคชันวันแชท (เรียกรวมกันว่า “แอปพลิเคชัน”) ข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวมจากท่าน เมื่อท่านเยี่ยมชมเว็บไซต์ต่าง ๆ ที่บริษัทดูแลซึ่งเกี่ยวข้องกับแอปพลิเคชันต่าง ๆ ของบริษัท (“เว็บไซต์”) (ทั้งแอปพลิเคชันและเว็บไซต์เรียกรวมกันว่า “บริการ”) และข้อมูลส่วนบุคคลเกี่ยวกับท่านที่ได้รับจากผู้ใช้บริการคนอื่นๆ","detailScopeB1":"ผู้ใช้อาจขอรับบริการเพิ่มเติมจากวันแชทหรือบริษัทในเครือของวันแชทได้ (“บริการเพิ่มเติม”) เนื่องจากผู้ใช้แต่ละรายมีความต้องการและทางเลือกที่อาจแตกต่างกันไป บริษัทจึงจัดให้มีนโยบายคุ้มครองสิทธิความเป็นส่วนตัวที่แตกต่างกัน หรือบันทึกต่อท้ายนโยบายคุ้มครองสิทธิความเป็นส่วนตัวนี้สำหรับบริการเพิ่มเติมที่เกี่ยวข้อง นโยบายคุ้มครองสิทธิความเป็นส่วนตัวที่แยกต่างหาก และบันทึกต่อท้ายต่าง ๆ จะอธิบายประเภทข้อมูลที่บริษัทเก็บรวบรวม วัตถุประสงค์การใช้งาน และนโยบายอื่น ๆ ที่อาจใช้บังคับกับบริการเพิ่มเติมที่เกี่ยวข้องนั้น ๆ เมื่อท่านเลือกใช้บริการเพิ่มเติม ท่านจะได้รับแจ้งเกี่ยวกับนโยบายคุ้มครองสิทธิความเป็นส่วนตัวหรือบันทึกต่อท้ายที่ใช้บังคับ ซึ่งเป็นส่วนเพิ่มเติม หรือแก้ไขจากนโยบายคุ้มครองสิทธิความเป็นส่วนตัวนี้ จากนั้น ท่านจึงจะสามารถเข้าถึงบริการเพิ่มเติมดังกล่าวได้ ขอเรียนให้ทราบว่า ท่านสามารถตรวจสอบนโยบายคุ้มครองสิทธิความเป็นส่วนตัวและบันทึกต่อท้ายได้ตามบริการที่ใช้"},"subject3":{"header":"3. ประเภทข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวม","subHeaderTypeA":"ก. ข้อมูลส่วนบุคคลใดที่วันแชทเก็บรวบรวม","detailSubHeaderA":"ในการให้บริการแก่ท่าน วันแชทเก็บรวบรวม โอนและใช้งานข้อมูลประเภทต่าง ๆ ดังต่อไปนี้","subjectA1":"1. ข้อมูลเกี่ยวกับบัญชีผู้ใช้ของท่าน","subjectA2":"2. ข้อมูลอุปกรณ์และการบันทึกการเข้าถึงเมื่อท่านใช้บริการของบริษัท","detailSubjectA1":"เมื่อท่านสร้างบัญชีวันแชท เพื่อเข้าใช้บริการ (“บัญชีผู้ใช้”) วันแชทจะขอให้ท่านระบุหมายเลขโทรศัพท์ของท่าน ข้อมูลนี้เป็นข้อมูลที่จำเป็นเนื่องจากบริษัทอาจส่งข้อความผ่านเอสเอ็มเอสไปยังหมายเลขโทรศัพท์ที่ท่านระบุเพื่อตรวจจับและป้องกันอย่างต่อเนื่อง มิให้มีการใช้บริการโดยไม่ได้รับอนุญาต หรือใช้ในลักษณะฉ้อฉล หรือในทางมิชอบ นอกจากนี้ บริษัทอาจใช้หมายเลขโทรศัพท์ที่ท่านลงทะเบียนนี้เพื่อส่งข้อมูลสำคัญเกี่ยวกับบริการให้แก่ท่านอีกด้วย","detailSubjectA2":"เมื่อท่านใช้บริการของบริษัท บริษัทอาจขอรับและเก็บรักษาข้อมูลแสดงตัวตนทางอิเล็กทรอนิกส์หรือบันทึกข้อมูลที่ได้มาโดยอัตโนมัติจากอุปกรณ์ของท่านบางรายการ อาทิเช่น ประเภทอุปกรณ์ ประเภทระบบปฏิบัติการ เลขที่อยู่ไอพี ข้อมูลเบราว์เซอร์ รวมถึงประเภทและการตั้งค่าภาษา ตัวระบุเครื่อง ข้อมูลคุกกี้ ตัวระบุโฆษณา หรือตัวระบุแอปพลิเคชันบนโทรศัพท์เคลื่อนที่","detailSubjectA21":"ข้อมูลนี้เป็นข้อมูลที่จำเป็นสำหรับบริษัทในการตรวจจับและป้องกันอย่างต่อเนื่องมิให้มีการใช้บริการโดยไม่ได้รับอนุญาต หรือใช้ในลักษณะฉ้อฉล หรือในทางมิชอบ ตลอดจนเพื่อให้บริการที่คุณสามารถกำหนดเองได้และให้มีประสิทธิภาพมากที่สุดกับอุปกรณ์ของท่าน นอกจากนี้ ขอเรียนให้ทราบว่า ตัวระบุโฆษณาของบุคคลภายนอกอาจเชื่อมโยงกับบัญชีของท่านผ่านตัวระบุภายในของบริษัท","subHeaderTypeB":"ข. ข้อมูลอื่นใดอีกบ้างที่วันแชทอาจเก็บรวบรวม","detailSubHeaderB":"เพื่อพัฒนาประสิทธิภาพในการให้บริการ บริษัทจึงจัดให้มีฟังก์ชั่นเพิ่มเติม รวมถึงฟังก์ชันการเข้าถึงบัญชีของท่านได้จากอุปกรณ์หลายเครื่อง การช่วยท่านในการค้นหาเพื่อนผ่านบริการ หรือเพื่อการให้บริการมีประสิทธิภาพ สะดวกแก่การใช้ และเพลิดเพลินมากยิ่งขึ้น หากท่านเลือกใช้ฟังก์ชันดังกล่าว หรือเลือกใช้บัญชีของท่านบนอุปกรณ์หลายเครื่อง บริษัทอาจขอให้ท่านระบุข้อมูลต่อไปนี้","subjectB1":"1. อีเมลแอดเดรส [ระบุหรือไม่ก็ได้]","detailSubjectB1":"ท่านอาจต้องการเข้าถึงบัญชีของท่านจากอุปกรณ์หลายได้ (“ล็อกอินหลายเครื่อง”) หรือโอนบัญชีของท่านจากอุปกรณ์เครื่องหนึ่งไปยังอีกเครื่องหนึ่งได้ (“การโอนบัญชี”) ท่านจะต้องระบุอีเมล์แอดเดรสของท่าน และรหัสผ่านหรือรหัสลับส่วนบุคคล (PIN) แก่วันแชทเพื่อที่บริษัทจะได้เชื่อมโยงอุปกรณ์ของท่านกับบัญชีของท่าน บริษัทอาจส่งข้อมูลสำคัญเกี่ยวกับการดำเนินการของบริการให้แก่ท่านผ่านทางอีเมล์แอดเดรสที่ท่านลงทะเบียนไว้ได้","detailSubjectB12":"ขอเรียนให้ทราบว่า หากท่านเปลี่ยนใจในภายหลัง และไม่ประสงค์จะระบุอีเมล์แอดเดรสอีกต่อไปแล้ว ท่านสามารถลบออกเมื่อใดก็ได้โดยไปที่เมนู “ตั้งค่า” > “บัญชี” ในแอปพลิเคชันวันแชท","subjectB2":"2. ไอดีวันแชท [ระบุหรือไม่ก็ได้]","detailSubjectB2":"เพื่อให้เพื่อนของท่านค้นหาท่านในบริการได้ง่ายยิ่งขึ้น ท่านอาจเลือกระบุชื่อไอดีวันแชท (“สำหรับบัญชี”) ของท่านได้ และอนุญาตให้เพื่อนของท่านค้นหาท่านจากไอดีวันแชทได้ หรือท่านอาจเลือกไม่อนุญาตให้ผู้ใช้วันแชทรายอื่นติดต่อท่านโดยใช้ไอดีวันแชทของท่านก็ได้ ขอเรียนว่า ผู้ใช้วันแชทรายอื่นจะไม่สามารถมองเห็นไอดีวันแชทของท่านหากไม่ได้อนุญาตและไอดีวันแชทของท่านอาจเป็นนามแฝงได้ ไม่จำเป็นต้องเป็นชื่อจริงของท่าน","subjectB3":"3. หมายเลขโทรศัพท์ติดต่อ [ระบุหรือไม่ก็ได้]","detailSubjectB3":"หากท่านต้องการเชิญเพื่อนหรือผู้ติดต่อแต่ละคนให้เชื่อมต่อกับท่านโดยใช้แอปพลิเคชันวันแชท ท่านอาจส่งคำเชิญโดยตรงทางอีเมล์โดยตรงจากอุปกรณ์เคลื่อนที่ของท่าน เมื่อท่านใช้ฟังก์ชันการส่งคำเชิญเป็นเพื่อนในแอปพลิเคชันวันแชท","subjectB4":"4. ข้อมูลตำแหน่งที่ตั้ง [ระบุหรือไม่ก็ได้]","detailSubjectB41":"ในการใช้แอปพลิเคชันวันแชท ท่านไม่จำเป็นต้องระบุข้อมูลตำแหน่งที่ตั้งของท่าน (“ข้อมูลตำแหน่งทางภูมิศาสตร์”) อย่างไรก็ตาม บริษัทได้จัดให้มีคุณสมบัติพิเศษเพื่อใช้งานข้อมูลตำแหน่งทางภูมิศาสตร์เพื่ออำนวยความสะดวกแก่ท่าน และเพื่อเพิ่มประสิทธิภาพในการใช้งานให้แก่ท่าน","detailSubjectB42":"ในกรณีอื่น ๆ ที่บริษัทเก็บรวบรวม หรือใช้งานข้อมูลตำแหน่งทางภูมิศาสตร์ของท่านเพื่อการให้บริการเพิ่มเติม บริษัทจะให้คำบอกกล่าวล่วงหน้าแก่ท่าน และขอรับความยินยอมล่วงหน้าจากท่านก่อน","subjectB5":"5. ข้อมูลติดต่อสำหรับบริการช่วยเหลือลูกค้า [ระบุหรือไม่ก็ได้]","detailSubjectB51":"ในบางกรณีท่านอาจประสงค์ที่จะติดต่อกับบริษัทเพื่อขอรับบริการช่วยเหลือลูกค้าจากเรา หากท่านติดต่อบริษัทผ่านแบบฟอร์มติดต่อของบริษัท หรือโดยวิธีการอื่น บริษัทอาจขอรับและเก็บรักษาข้อมูลใด ๆ ที่ท่านเลือกระบุไว้ ซึ่งรวมถึง ชื่อของท่าน ข้อมูลการติดต่อของท่าน เช่น อีเมล์แอดเดรสของท่าน หมายเลขโทรศัพท์ของท่าน ตลอดจน ข้อมูลเกี่ยวกับอุปกรณ์เคลื่อนที่ของท่านหรือคอมพิวเตอร์ส่วนบุคคล เช่น ประเภทอุปกรณ์ และประเภทระบบปฏิบัติการของอุปกรณ์ดังกล่าว บริษัทจะใช้ข้อมูลนี้ในการแก้ไขและตรวจสอบปัญหาที่ท่านส่งมายังบริษัท เพื่อให้การช่วยเหลือแก่ท่าน และเพื่อปรับปรุงบริการช่วยเหลือลูกค้าของบริษัทต่อไป","detailSubjectB52":"เราอาจประมวลผลข้อมูลนี้ที่เกี่ยวกับความช่วยเหลือที่ท่านร้องขอมา จัดการกับบัญชีผู้ใช้ของท่าน และเก็บข้อมูลนี้ไว้ตามบทบัญญัตินโยบายคุ้มครองสิทธิความเป็นส่วนตัวนี้","subjectB6":"6. ข้อมูลติดต่อสำหรับกิจกรรมส่งเสริมการขายและการสำรวจลูกค้า [ระบุหรือไม่ก็ได้]","detailSubjectB6":"หากท่านเลือกเข้าร่วมกิจการส่งเสริมการขายหรือการสำรวจต่าง ๆ ที่วันแชทเสนอเป็นครั้งคราว บริษัทอาจขอรายละเอียดการติดต่อของท่าน (เช่น ชื่อ ที่อยู่สำหรับส่งไปรษณีย์ หมายเลขโทรศัพท์ อีเมล์แอดเดรส เพศ และวันเดือนปีเกิดของท่าน) เพื่อยืนยันสิทธิในการเข้าร่วมกิจกรรมของท่าน เพื่อให้ท่านสามารถกรอกแบบสอบถามได้และ เพื่อจัดส่งของรางวัลใดๆ ที่ท่านอาจชนะรางวัล และเพื่อการจัดการกิจกรรมอื่น","subjectB7":"7. ข้อมูลการชำระเงิน [ระบุหรือไม่ก็ได้]","detailSubjectB71":"หากท่านเลือกซื้อหรือใช้บริการเพิ่มเติมที่คิดค่าบริการ และชำระค่าบริการเพิ่มเติมดังกล่าวโดยวิธีการอื่นนอกเหนือจากการซื้อผ่านแอปพลิเคชัน iTunes หรือ Google Play บริษัทอาจให้ผู้ให้บริการซึ่งเป็นบุคคลภายนอกเก็บและประมวลผลข้อมูลบัตรเครดิตของท่าน โดยบริษัทจะใช้ข้อมูลบัตรเครดิตของท่านเพื่อประมวลผลการซื้อหรือใช้บริการที่มีค่าบริการเท่านั้น ขอเรียนให้ทราบว่า บริษัทจะไม่เก็บข้อมูลบัตรเครดิตของท่านไว้เกินไปจากระยะเวลาที่จำเป็นเพื่อการอำนวยความสะดวกในการชำระเงินที่เกี่ยวข้อง","detailSubjectB72":"การชำระเงินผ่านบัตรเครดิตของท่านจะได้รับการดำเนินการโดยหน่วยงานชำระเงินซึ่งเป็นบุคคลภายนอกที่เหมาะสม","subjectB8":"8. ข้อมูลจากเว็บไซต์และแอปพลิเคชันต่าง ๆ ที่มีบริการของบริษัทรวมอยู่ด้วย [ระบุหรือไม่ก็ได้]","detailSubjectB8":"บริการของบริษัท และ/หรือเว็บไซต์และ/หรือแอปพลิเคชันต่าง ๆ ของบุคคลภายนอก อาจมีแอปพลิเคชันเสริมของบริษัทรวมอยู่ด้วย บริษัทอาจบันทึกข้อมูลการล็อกอินในวันแชทของท่านผ่านการใช้งานแอปพลิเคชันเสริมดังกล่าว หรือได้รับที่อยู่ของเว็บไซต์ที่มีแอปพลิเคชันเสริมของบริษัทซึ่งท่านเยี่ยมชมขณะที่ท่านล็อกอินเข้าใช้บริการของบริษัทผ่านเบราว์เซอร์ของท่าน ขอเรียนให้ทราบว่า จะไม่มีการรับข้อมูลส่วนบุคคลของท่าน จากเว็บไซต์หรือแอปพลิเคชันดังกล่าวที่มีแอปพลิเคชันเสริมของบริษัทหากท่านล็อกเอาท์จากบริการ","subjectB9":"9. ข้อมูลที่ผู้ใช้สร้างขึ้นซึ่งเกี่ยวกับตัวผู้ใช้เองและแบ่งปันกับผู้อื่นเนื้อหาที่ผู้ใช้สร้างขึ้นเอง [ระบุหรือไม่ก็ได้]","detailSubjectB91":"นอกจากข้อมูลตามรายละเอียดข้างต้นแล้ว ท่านอาจเลือกตั้งค่า ข้อมูลโปรไฟล์ (เช่น ชื่อที่แสดง (Display Name), รูปโปรไฟล์ และวลีที่คุณเลือกที่จะแสดงใต้สถานะของท่าน) และแสดงตัวตนของท่านกับผู้ใช้วันแชทคนอื่นๆ ในบริการ ยิ่งไปกว่านั้นท่านอาจเลือกที่จะสร้างเนื้อหาที่ผู้ใช้สร้างขึ้นเอง เช่น ข้อความที่เป็นตัวอักษรและข้อความเสียง รูปถ่าย วีดิทัศน์ ข้อมูลตำแหน่งทางภูมิศาสตร์ หรือข้อมูลติดต่อของเพื่อนในวันแชทของท่าน และแบ่งปันเนื้อหาที่ผู้ใช้สร้างขึ้นเองนี้กับผู้ใช้รายอื่น ท่านอาจเลือกแบ่งปันเนื้อหาที่ผู้ใช้สร้างขึ้นเองของท่านมากหรือน้อยเพียงใดก็ได้ และสามารถเลือกว่าจะแบ่งปันเนื้อหาดังกล่าวกับผู้ใดขณะที่ท่านสร้างข้อความได้โดยการเลือกผู้รับเนื้อหาที่ผู้ใช้สร้างขึ้นเองของท่าน และ/หรือผ่านการตั้งค่าความเป็นส่วนตัวในแอปพลิเคชันวันแชท","detailSubjectB92":"ทั้งนี้ โปรดทราบว่า ข้อมูลโปรไฟล์และเนื้อหาที่ผู้ใช้สร้างขึ้นเองที่ท่านแบ่งปันกับบุคคลอื่นนี้ สามารถคัดลอก จัดเก็บ หรือเผยแพร่โดยผู้รับเนื้อหาดังกล่าวได้ และก็มีความเป็นไปได้ที่สามารถเข้าถึงได้โดยบุคคลภายนอกผู้ที่มิได้มุ่งหมายให้เป็นผู้รับเช่นกัน เนื่องจากเป็นข้อมูลดิจิทัล บริษัทขอให้ท่านระมัดระวังและรอบคอบเมื่อท่านจะสร้างและแบ่งปันข้อมูลส่วนบุคคลหรือเนื้อหาของท่านแก่บุคคลอื่น"},"subject4":{"header":"4. บริษัทใช้และจัดการข้อมูลของท่านอย่างไร","subjectA":"ก. วันแชทนำข้อมูลของผู้ใช้ไปใช้อย่างไร","detailSubjectA":"ในการให้บริการและบริการเพิ่มเติมอื่นใดๆ นั้น วันแชท ซึ่งเป็นผู้ควบคุมข้อมูลหรือผู้ร่วมควบคุมข้อมูลจะใช้ข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ตามนโยบายคุ้มครองสิทธิความเป็นส่วนตัวดังนี้","detailSubjectA1":"เพื่อให้บริการและบริการเพิ่มเติมใดๆ แก่ท่าน และเพื่ออนุญาตให้ท่านส่งเนื้อหาที่ผู้ใช้สร้างเองของท่านให้แก่ผู้ใช้วันแชทรายอื่น","detailSubjectA2":"เพื่อตรวจสอบตัวตนของท่าน","detailSubjectA3":"เพื่อให้ท่านใช้บัญชีวันแชทของท่านบนอุปกรณ์หลายเครื่อง และถ่ายโอนบัญชีวันแชทของท่านไปยังอุปกรณ์อีกเครื่องหนึ่งได้","detailSubjectA4":"เพื่อช่วยท่านค้นหาผู้ที่ท่านรู้จักซึ่งเป็นผู้ใช้วันแชทอยู่แล้ว ซึ่งท่านสามารถเชื่อมต่อกันได้โดยใช้วันแชท และตามที่ท่านได้ตกลงอยู่ก่อน เพื่ออนุญาตให้ผู้ใช้วันแชทรายอื่นสามารถเชื่อมต่อกับท่านได้","detailSubjectA5":"เพื่อให้ท่านสามารถซิงค์ (Sync) กับแอปพลิเคชันอื่นของวันแชท บริษัทในเครือของวันแชท และหุ้นส่วนธุรกิจของวันแชท พร้อมด้วยบัญชีวันแชทของท่าน และเพื่อแบ่งปันข้อมูลระหว่างแอปพลิเคชันต่าง ๆ ที่ท่านใช้","detailSubjectA6":"เพื่อตอบกลับคำขอที่ท่านอาจมีเพื่อใช้บริการเพิ่มเติมของวันแชท","detailSubjectA7":"เพื่อดูแลตรวจจับและป้องกันมิให้มีการใช้บริการโดยไม่ได้รับอนุญาต หรือใช้ในลักษณะฉ้อฉล หรือในทางมิชอบ","detailSubjectA8":"เพื่อปรับปรุงและ/หรือ ทำให้เหมาะสมในบริการและบริการเพิ่มเติม","detailSubjectA9":"เพื่อให้บริษัทสามารถให้บริการช่วยเหลือลูกค้า และตอบข้อซักถามและข้อเรียกร้องของท่านได้อย่างมีประสิทธิภาพ","detailSubjectA10":"เพื่อจัดหาข้อมูลเกี่ยวกับบริการและบริการเพิ่มเติมให้แก่ท่าน","detailSubjectA11":"เพื่อวัดประสิทธิผลของโฆษณาที่บริษัทแสดงในอินเทอร์เน็ตหรือในสื่ออื่น ๆ","detailSubjectA12":"เพื่อแจ้งท่านเกี่ยวกับข้อมูลสำคัญอื่นใดเกี่ยวกับบริการและบริการเพิ่มเติม หากจำเป็น","detailSubjectA13":"เพื่อระบุผู้ชนะการประกวดในกิจกรรมส่งเสริมการขายต่าง ๆ เพื่อส่งของรางวัลให้แก่ผู้ชนะ และเพื่อจัดส่งผลิตภัณฑ์และบริการที่ซื้อ","detailSubjectA14":"เพื่อรวบรวมข้อมูลทางสถิติโดยไม่เปิดเผยตัวตน เกี่ยวกับบริการและบริการเพิ่มเติม และ","detailSubjectA15":"เพื่อปฏิบัติตามกฎหมายที่ใช้บังคับหรือหน้าที่ตามกฎหมาย","detailSubjectA16":"อย่างไรก็ตาม หากบริษัทแจ้งให้ท่านทราบถึงวัตถุประสงค์การใช้งานแบบเฉพาะเจาะจงเพิ่มเติมในขณะที่บริษัทขอรับข้อมูลส่วนบุคคลของท่าน หรือโดยวิธีการอื่น การแจ้งดังกล่าวจะใช้แทนวัตถุประสงค์การใช้งานทั่วไปที่ระบุในข้อ 4.ก ของนโยบายคุ้มครองสิทธิความเป็นส่วนตัวนี้","subjectB":"ข. วันแชทจะปกป้องข้อมูลส่วนบุคคลของผู้ใช้อย่างไร","detailSubjectB1":"ในการดำเนินการตามพันธะหน้าที่ด้านการเคารพและคุ้มครองสิทธิความเป็นส่วนตัวของท่าน และการเก็บรักษาข้อมูลส่วนบุคคลของท่านเป็นความลับ วันแชทได้ใช้เทคนิคและมาตราฐานความปลอดภัยขององค์กรที่เหมาะสม รวมถึงมาตรการป้องกันตามมาตรฐานของอุตสาหกรรมด้านนี้ เพื่อป้องกันการเข้าถึงหรือเปิดเผย การใช้งานในทางมิชอบ การเปลี่ยนแปลงแก้ไข หรือการทำลายข้อมูลของท่านโดยไม่ได้รับ","detailSubjectB2":"เนื่องจากไม่มีวิธีการส่งข้อมูลทางอิเล็กทรอนิกส์ใด หรือวิธีการจัดเก็บข้อมูลใดที่สมบูรณ์แบบหรือไม่สามารถเจาะผ่านได้ บริษัทจึงไม่อาจรับประกันได้ว่า ข้อมูลส่วนบุคคลของท่านจะปลอดภัยแบบเบ็ดเสร็จจากการบุกรุกในระหว่างการส่งข้อมูลหรือจัดเก็บเข้าระบบของบริษัท เพื่อช่วยคุ้มครองสิทธิความเป็นส่วนตัวของท่านและเก็บรักษาข้อมูลส่วนบุคคลของท่านเป็นความลับ บริษัทจำเป็นต้องขอความช่วยเหลือจากท่าน โปรดอย่าเปิดเผยรหัสผ่านของท่านกับบุคคลอื่น หรือใช้รหัสผ่านเดียวกับที่ท่านใช้สำหรับบริการอื่น นอกจากนี้ โปรดแจ้งให้บริษัททราบในกรณีที่ท่านสงสัยว่าจะมีการใช้บัญชีของท่านโดยไม่ได้รับอนุญาต หรือมีการละเมิดการรักษาความปลอดภัยอื่นใดผ่านแบบฟอร์มติดต่อของบริษัท","subjectC":"ค. ข้อมูลส่วนบุคคลของผู้ใช้ถูกส่งและจัดเก็บที่ใด","detailSubjectC":"เพื่อให้บริการด้วยความน่าเชื่อถือและมีความรับผิดชอบ วันแชทจะประมวลผลและจัดเก็บข้อมูลของท่านในเซิร์ฟเวอร์รักษาความปลอดภัยซึ่งตั้งอยู่ในประเทศไทย ทั้งนี้การโอนถ่ายข้อมูลทั้งหมดดังกล่าวจะต้องปฎิบัติตามข้อกำหนดแห่งกฎหมายที่ใช้บังคับด้วย","subjectD":"ง. วันแชทจะเก็บข้อมูลของผู้ใช้ไว้นานเท่าใด","detailSubjectD1":"วันแชทจะเก็บข้อมูลส่วนบุคคลที่ท่านระบุไว้ตลอดเวลาที่บัญชีของท่านยังใช้งานอยู่ เป็นระยะเวลาตราบเท่าที่จำเป็นเพื่อบรรลุตามวัตถุประสงค์การใช้งานตามรายละเอียดในนโยบายคุ้มครองสิทธิส่วนตัวนี้ หรือเพื่อปฏิบัติตามกฎหมายและระเบียบที่ใช้บังคับบริษัทอาจเก็บข้อมูลส่วนบุคคลของท่านไว้แม้ภายหลังจากที่บัญชีของท่านปิดหรือยุติแล้ว หากมีความจำเป็นตามสมควรที่จะต้องเก็บไว้ดังนี้","detailSubjectD2":"บริษัทอาจเก็บข้อมูลส่วนบุคคลของท่านไว้แม้ภายหลังจากที่บัญชีของท่านปิดหรือยุติแล้ว หากมีความจำเป็นตามสมควรที่จะต้องเก็บไว้ดังนี้","detailSubjectD3":"เพื่อปฏิบัติตามกฎหมายและระเบียบที่ใช้บังคับ หรือหน้าที่ตามกฎหมาย","detailSubjectD4":"เพื่อให้บริการช่วยเหลือลูกค้าได้อย่างครบถ้วนสมบูรณ์","detailSubjectD5":"เพื่อระงับข้อพิพาทระหว่าง หรือที่มีกับผู้ใช้วันแชทตลอดระยะเวลาที่ใช้บังคับได้หรือ","detailSubjectD6":"เพื่อตรวจจับและป้องกันมิใช้มีการใช้บริการโดยไม่ได้รับอนุญาต หรือใช้ในลักษณะฉ้อฉล หรือในทางมิชอบ","subjectE":"จ. วันแชทใช้ผู้ให้บริการหรือตัวแทนให้บริการภายนอกหรือไม่","detailSubjectE":"เพื่อให้บริการ ในบางครั้งวันแชทจึงจำเป็นต้องขอให้ผู้ให้บริการซึ่งเป็นบุคคลภายนอกประมวลผลข้อมูลของผู้ใช้ที่อาจรวมถึงข้อมูลส่วนบุคคลของท่าน บริษัทคัดเลือกผู้ให้บริการซึ่งเป็นบุคคลภายนอกดังกล่าวอย่างเคร่งครัด และบริษัทจะใช้ความพยายามตามสมควรเพื่อให้มั่นใจว่า ผู้ให้บริการซึ่งเป็นบุคคลภายนอกได้วางระบบการจัดการข้อมูลและการควบคุมภายในองค์กรที่เหมาะสมและปลอดภัย และเราได้กำหนดหน้าที่ตามสัญญาแก่ผู้ให้บริการดังกล่าวเพื่อให้ผู้ให้บริการดังกล่าวต้องปฏิบัติตามกฎหมายและระเบียบที่ใช้บังคับเกี่ยวกับการประมวลผลข้อมูลส่วนบุคคลด้วย นอกจากนี้ บริษัทยังกำหนดให้ผู้ให้บริการซึ่งเป็นบุคคลภายนอกดังกล่าวเข้าถึงข้อมูลส่วนบุคคลของท่านเฉพาะเพียงภายในขอบเขตที่จำเป็นตามคำสั่งและวัตถุประสงค์ของเราเท่านั้น","subjectF":"ฉ. วันแชทให้ข้อมูลของผู้ใช้แก่บุคคลภายนอกหรือไม่","detailSubjectF":"นอกเหนือจากรายละเอียดข้างต้นในนโยบายคุ้มครองสิทธิความเป็นส่วนตัวนี้ และนโยบายคุ้มครองสิทธิความเป็นส่วนตัวหรือบันทึกต่อท้ายอื่น ๆ ที่เกี่ยวข้อง วันแชทจะไม่ให้ข้อมูลของท่านแก่บุคคลอื่นใดโดยไม่ได้รับความยินยอมจากท่าน เว้นแต่ว่าบริษัทจะเชื่อโดยสุจริตใจว่า บริษัทจำเป็นหรือได้รับอนุญาตให้ดำเนินการดังกล่าวตามกฎหมายที่ใช้บังคับ","subjectG":"ช. วันแชทใช้คุกกี้ (Cookies) หรือเทคโนโลยีอื่นที่คล้ายคลึงกันหรือไม่","detailSubjectG1":"บริษัทใช้คุกกี้หรือเทคโนโลยีการจัดเก็บเฉพาะอื่นที่คล้ายคลึง","detailSubjectG2":"คุกกี้ คือ แฟ้มข้อมูลย่อยที่ถูกเก็บรักษาไว้อยู่บนคอมพิวเตอร์ของท่านเมื่อท่านเข้าเยี่ยมชมเว็บไซต์ แฟ้มข้อมูลนี้จะเก็บข้อมูลที่เว็บไซต์สามารถใช้อ่านได้อีกเมื่อท่านเข้าเยี่ยมชมเว็บไซต์นั้นในวันหน้า ข้อมูลคุ๊กกี้บางข้อมูลมีความจำเป็นเพราะมิเช่นนั้นแล้วเว็บไซต์จะไม่สามารถทำงานได้อย่างเหมาะสม ส่วนข้อมูลคุ๊กกี้อื่นๆ นั้นช่วยอำนวยความสะดวกให้แก่ผู้เยี่ยมชมโดยการจดจำชื่อผู้ใช้ (username) ในทางที่ปลอดภัยและตามภาษาที่ท่านเลือก คุ๊กกี้มีไว้เพื่อให้ท่านมิต้องเติมข้อมูลเดิมๆ ในแต่ละครั้งที่ท่านเยี่ยมชมเว็บไซต์เราใช้คุ๊กกี้เพื่อ:","detailSubjectG3":"ช่วยบริษัทในการรักษาข้อมูลเซสชัน (Session) ของท่านเมื่อท่านใช้บริการและ/หรือบริการเพิ่มเติมใดๆ","detailSubjectG4":"เพิ่มประสิทธิภาพการรักษาความปลอดภัยของระบบของเรา","detailSubjectG5":"เก็บค่าพึงใจ (Preference) และให้บริการที่กำหนดค่าตามความต้องการของท่าน และ","detailSubjectG6":"ช่วยบริษัทในการทำความเข้าใจว่าประชาชนใช้บริการอย่างไรและเพื่อการปรับปรุงบริการเราใช้คุ๊กกี้ของบุคคลภายนอกดังต่อไปนี้ด้วยบนเว็บไซต์","detailSubjectG7":"ตัวเก็บข้อมูลกูเกิ้ล (Google Analytics)","detailSubjectG8":"การที่ท่านใช้บริการต่อไป เป็นการบ่งชี้ว่าท่านยอมรับให้บริษัทใช้คุกกี้และเทคโนโลยีที่คล้ายคลึงกันตามนโยบายคุ้มครองสิทธิความเป็นส่วนตัว","detailSubjectG9":"เบราว์เซอร์ของอินเตอร์เน็ตส่วนใหญ่อนุญาตให้ท่านควบคุมได้ว่าจะยอมรับการใช้คุกกี้หรือไม่ หากท่านปิดการใช้คุกกี้หรือจำกัดความสามารถในการตั้งค่าคุกกี้ ท่านอาจไม่สามารถรับสิทธิประโยชน์จากเว็บไซต์หรือเข้าถึงทุกฟังก์ชันได้ซึ่งอาจจำกัดการใช้งานโดยรวมของท่าน"},"subject5":{"header":"5. ทางเลือกของท่าน สิทธิของท่าน","detailHeader":"มันมีความเป็นไปได้ที่วันแชทอาจได้รับข้อมูลส่วนบุคคลที่เกี่ยวกับบุคคลที่ไม่ใช่ผู้ใช้บริการในปัจจุบัน ขอเรียนให้ทราบว่า ไม่ว่าท่านจะเป็นผู้ใช้บริการหรือไม่ ท่านสามารถเลือกและมีสิทธิต่าง ๆ ตามหัวข้อนี้หากบริษัทเก็บข้อมูลส่วนบุคคลของท่าน","subjectA":"ก. ผู้ใช้จะควบคุมข้อมูลของผู้ใช้ได้อย่างไร","detailSubjectA":"ภายใต้บังคับแห่งกฎหมายที่ใช้บังคับ (รวมถึงข้อยกเว้นหรือบทยกเว้นภายใต้กฎหมายดังกล่าว) ท่านอาจมีสิทธิเข้าถึงข้อมูลส่วนบุคคลของท่าน สิทธิในการแก้ไขข้อผิดพลาดในข้อมูลส่วนบุคคลให้ถูกต้องและสิทธิคัดค้านบนมูลเหตุแห่งกฎหมายการประมวลผลอันข้อมูลส่วนบุคคลของท่าน ท่านสามารถใช้สิทธิได้โดยตรงภายในแอปพลิเคชันวันแชทเมื่อใดก็ได้ ตัวอย่างเช่น","detailSubjectA1":"ในเมนู “โปรไฟล์ (Profile)” ในส่วนของตั้งค่า (Settings) ในแอปพลิเคชัน ท่านสามารถยืนยันและหรือแก้ไขหมายเลขโทรศัพท์ของท่าน และยังสามารถยืนยันและแก้ไขชื่อที่แสดง และรูปโปรไฟล์ของท่านได้อีกด้วย และ","detailSubjectA2":"ในเมนู “บัญชี (Accounts)” ในส่วนของตั้งค่า (Settings) ในแอปพลิเคชัน ท่านสามารถยืนยันและ/หรือแก้ไขอีเมล์แอดเดรสที่ลงทะเบียนของท่านได้ และยังสามารถลบอีเมล์แอดเดรสที่ลงทะเบียนของท่านหรือปิดการเชื่อมต่อกับบัญชีเฟซบุ๊กได้อีกด้วย","detailSubjectA3":"เพื่อใช้สิทธิใดๆ ของท่ายภายใต้กฎหมายที่ใช้บังคับ ท่านอาจติดต่อเราผ่านทางแบบฟอร์มติดต่อ เมื่อตรวจสอบตัวตนของท่านแล้ว บริษัทจะตอบกลับคำขอของท่านภายในระยะเวลาตามสมควรและตามกฎหมายที่เกี่ยวข้อง  หากท่านต้องการส่งคำขอที่เป็นลายลักษณ์อักษรมายังบริษัท โปรดดูอีเมล์แอดเดรสของบริษัทที่ข้อ 6.ก.","detailSubjectA4":"หากท่านไม่ประสงค์จะใช้บริการอีกต่อไปแล้ว หรือหากท่านไม่ประสงค์จะยินยอมให้วันแชทเก็บรวบรวมและใช้งานข้อมูลส่วนบุคคลของท่านอีกต่อไปแล้ว ท่านอาจเลือกลบบัญชีทั้งหมดของท่านได้โดยตรงผ่านแอปพลิเคชันวันแชท บริษัทจะดำเนินการลบข้อมูลของท่านตามข้อ 4.ง.","subjectB":"ข. หากผู้ใช้เปลี่ยนใจจะทำอย่างไร","detailSubjectB":"หากท่านเปลี่ยนใจในเรื่องที่ท่านประสงค์จะแบ่งปันหรือเปิดเผยข้อมูลต่อไปมากน้อยเพียงใดเกี่ยวกับการบริการ ท่านสามารถเปลี่ยนแปลงการตั้งค่าได้ในแอปพลิเคชันวันแชท ยกตัวอย่างเช่นเรื่องที่เกี่ยวข้องกับ","detailSubjectB1":"ข้อมูลโปรไฟล์ของท่าน (เช่น รูปโปรไฟล์ของท่าน ชื่อที่แสดง)","detailSubjectB2":"ให้ผู้ใช้วันแชทรายอื่นติดต่อท่านโดยใช้ไอดีวันแชทของท่านได้หรือไม่","detailSubjectB3":"บล็อกหรือปลดบล็อกผู้ใช้วันแชทบางคน","detailSubjectB4":"ให้ผู้ใช้วันแชทรายอื่นที่มีหมายเลขโทรศัพท์ของท่านอยู่แล้ว สามารถติดต่อท่านผ่านวันแชทได้หรือไม่"},"subject6":{"header":"6. ข้อมูลที่สำคัญอื่น ๆ","subjectA":"ก. ผู้ใช้มีข้อซักถาม/ข้อเสนอแนะ/ข้อกังวลใจ","detailSubjectA":"หากท่านมีข้อซักถาม ข้อเสนอแนะ หรือข้อกังวลใจใด ๆ เกี่ยวกับนโยบายคุ้มครองสิทธิความเป็นส่วนตัวนี้ หรือนโยบายหรือแนวทางปฏิบัติการคุ้มครองสิทธิความเป็นส่วนตัวอื่น ๆ ของบริษัท โปรดติดต่อบริษัทผ่านแบบฟอร์มติดต่อของบริษัทหรือทำหนังสือมาถึงบริษัทที่ 1768 อาคารไทยซัมมิท ทาวเวอร์ชั้น 14 และชั้น IT ถนนเพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310 หรืออีเมล์ onechat@one.th","subjectB":"ข. การเปลี่ยนแปลงแก้ไขนโยบายคุ้มครองสิทธิความเป็นส่วนตัวนี้","detailSubjectB1":"บริษัทอาจแก้ไขนโยบายคุ้มครองสิทธิความเป็นส่วนตัวของบริษัทเป็นครั้งคราวด้วยเหตุผลหลากหลายประการ ซึ่งรวมถึง เพื่อปรับปรุงแนวทางปฏิบัติการคุ้มครองสิทธิความเป็นส่วนตัวของบริษัท เพื่อให้สอดคล้องกับการเปลี่ยนแปลงบริการของบริษัท และเพื่อปฏิบัติตามกฎหมายที่เกี่ยวข้อง  บริษัทได้จัดทำนโยบายคุ้มครองสิทธิความเป็นส่วนตัวนี้ขึ้นครั้งแรกเมื่อวันที่ 21 มิถุนายน 2561","detailSubjectB2":"เมื่อบริษัททำการแก้ไขเปลี่ยนแปลงนโยบายคุ้มครองสิทธิความเป็นส่วนตัวของบริษัทในสาระสำคัญ บริษัทจะแจ้งให้ท่านทราบในบริการของบริษัท หรือโดยวิธีการอื่นตามสมควร บริษัทขอแนะนำให้ท่านตรวจสอบการแก้ไขเปลี่ยนแปลงดังกล่าวด้วยความรอบคอบ หากท่านตกลงตามการแก้ไขเปลี่ยนแปลงดังกล่าว โปรดใช้บริการของบริษัทต่อไป แต่หากท่านไม่ตกลงตามการแก้ไขเปลี่ยนแปลงดังกล่าว และไม่ประสงค์จะใช้บริการของบริษัทอีกต่อไปแล้ว ท่านอาจเลือกปิดบัญชีของท่านได้  ซึ่งการที่ท่านใช้บริการของบริษัทต่อไปหลังจากที่ได้มีการแจ้งให้ท่านทราบเรื่องการแก้ไขเปลี่ยนแปลงแล้วหรือได้มีการประกาศในบริการของบริษัทแล้ว ถือว่าท่านยอมรับการแก้ไขเปลี่ยนแปลงและยินยอมตามนโยบายคุ้มครองสิทธิความเป็นส่วนตัวที่แก้ไขเปลี่ยนแปลงนี้แล้ว"}}},"Anonymous":{"manageGroup":"กลุ่มที่คุณจัดการ","yourGroup":"กลุ่มของคุณ","noManageGroup":"ไม่พบกลุ่มที่คุณจัดการ","noYourManageGroup":"ไม่พบกลุ่มที่ของคุณ","createGroup":"สร้างกลุ่มแชท","createBusiness":"สร้าง Business"},"Homepage":{"Title":{"title1":"แอปพลิเคชันแชทของคนไทยเพื่อคนไทย","title2":"เราจะทำให้ทุกการสนทนาของคุณปลอดภัย","title3":"คือ อะไร?"},"Detail":{"detailOnechat":"One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้","detailOneplatform":"One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box","detailOnebox":"บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี","detailOnemail":"บริการฟรีอีเมล","detailOnechatFn1":"One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย","detailOnechatFn2":"One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)","detailOnechatFn3":"One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ"},"Button":{"join":"ร่วมเป็นส่วนหนึ่งกับพวกเรา","moredetail":"ดูข้อมูลเพิ่มเติม"},"Footer":{"companyname":"บริษัท วัน เซ็นทริค จำกัด","date":"เวลาทำการ วันจันทร์ - ศุกร์","time":"เวลา 9.00 น. - 17.00 น.","address1":"1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16","address2":"ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ","address3":"เขตห้วยขวาง กรุงเทพมหานคร 10310","policy":"นโยบายการใช้งาน","report":"พบเจอปัญหา","sendmsg":"ส่งข้อความถึงเรา"},"Dialog":{"titleReport":"แจ้งปัญหาการใช้งาน Onechat","name":"ชื่อ","email":"อีเมล","phone":"หมายเลขโทรศัพท์","subject":"หัวข้อปัญหา","detail":"รายละเอียดของปัญหา","inputEmail":"กรุณากรอกอีเมล","inputEmailError":"รูปแบบอีเมลไม่ถูกต้อง","inputphoneErrorDigit":"กรุณากรอกหมายเลขโทรศัพท์ของคุณจำนวน 10 หลัก","inputphoneErrorFormat":"รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง","inputphoneErrorNumber":"กรุณากรอกข้อมูลเป็นตัวเลข","inputName":"กรุณากรอกชื่อ","inputDetail":"กรุณากรอกรายละเอียดปัญหา","titleSendMessage":"ส่งข้อความถึงเรา"}},"Login":{"titleLogin1":"ยินดีต้อนรับเข้าสู่ OneChat","titleLogin2":"กรุณาเลือกรูปแบบการลงชื่อเข้าใช้งาน","typeLogin1":"เข้าสู่ระบบด้วย OneID","typeLogin2":"เข้าสู่ระบบด้วยเบอร์โทรศัพท์","phone":"เบอร์โทร","username":"ชื่อผู้ใช้งาน","password":"รหัสผ่าน","forgotpass":"ลืมรหัสผ่าน","conjunction":"หรือ","Button":{"sendotp":"ขอ OTP","time":"วินาที","resend":"ส่ง OTP","login":"เข้าสู่ระบบ","loginnavbar":"ลงชื่อเข้าใช้"}},"Register":{"title1":"ร่วมเป็นส่วนหนึ่งกับพวกเรา","title2":"ลงทะเบียนสมัครสมาชิก","title3":"ลงทะเบียนผู้ใช้งาน","title4":"คุณจะได้ใช้บริการดี ๆ จากเรา","span1":"ฟรี","span2":"อีเมล","span3":"พื้นที่เก็บข้อมูลออนไลน์","Button":{"register":"สมัครสมาชิก","accept":"ยอมรับ","back":"ย้อนกลับ","policy":"เงื่อนไขการใช้งาน"},"content":"<h4>เงื่อนไขการใช้บริการ</h4>1.การใช้บริการของเรา <br>&nbsp;&nbsp;&nbsp;1.1 การใช้บริการของเราไม่ได้ทำให้คุณเป็นเจ้าของสิทธิในทรัพย์สินทางปัญญาใดๆ ในบริการหรือเนื้อหาที่คุณเข้าถึง <br>&nbsp;&nbsp;&nbsp;1.2 การใช้บริการจากเรา เราอาจส่งประกาศเกี่ยวกับบริการ ข่าวสารเกี่ยวกับการบริหารจัดการ และข้อมูลอื่นๆ ให้แก่คุณ คุณสามารถเลือกไม่รับการสื่อสารเหล่านี้บางรายการได้ <br>&nbsp;&nbsp;&nbsp;1.3 บริการบางอย่างของเราสามารถใช้บนอุปกรณ์เคลื่อนทึ่ห้ามใช้บริการดังกล่าวในลักษณะที่ทำให้คุณเสียสมาธิและทำให้ไม่สามารถปฏิบัติตามกฎจราจรหรือกฎหมายด้านความปลอดภัย <br><br>2. บัญชี One Platform ของคุณ <br>&nbsp;&nbsp;&nbsp;2.1 คุณอาจต้องมีบัญชี One Platform เพื่อที่จะใช้บริการบางส่วนของเราอาจมีข้อกำหนดอื่นหรือเพิ่มเติมบังคับใช้กับคุณ และผู้ดูแลระบบของคุณอาจสามารถเข้าถึงหรือปิดการใช้งานบัญชีของคุณได้ <br>&nbsp;&nbsp;&nbsp;2.2 เพื่อปกป้องบัญชี One Platform ของคุณ โปรดเก็บรักษารหัสผ่านเป็นความลับ คุณมีความรับผิดชอบต่อกิจกรรมที่เกิดขึ้นบนหรือผ่านบัญชี One Platform ของคุณ พยายามไม่ใช้รหัสผ่านบัญชี One Platform ซ้ำบนแอปพลิเคชันของบุคคลที่สาม <br><br>3. การคุ้มครองข้อมูลส่วนบุคคลและลิขสิทธิ์ <br>&nbsp;&nbsp;&nbsp;3.1 เมื่อคุณใช้บริการของเรา ถือว่าคุณยินยอมให้ One Platform ใช้ข้อมูลดังกล่าวตามนโยบายส่วนบุคคลนั้น <br><br>4. การปรับเปลี่ยนและการยุติการให้บริการของเรา <br>&nbsp;&nbsp;&nbsp;4.1 เราทำการเปลี่ยนแปลงและปรับปรุงบริการของเราอย่างสม่ำเสมอ เราอาจเพิ่มหรือนำ <br>ระบบการทำงานหรือคุณลักษณะบางอย่างออก และเราอาจระงับหรือหยุดให้บริการใดบริการหนึ่งโดยสิ้นเชิง <br>&nbsp;&nbsp;&nbsp;4.2 คุณสามารถหยุดใช้บริการของเราได้ทุกเมื่อ <br><br>5. การใช้บริการของเราในทางธุรกิจ <br>&nbsp;&nbsp;&nbsp;5.1 หากคุณใช้บริการของเราในนามของธุรกิจ ธุรกิจนั้นจะต้องยอมรับข้อกำหนดเหล่านี้ <br>&nbsp;&nbsp;&nbsp;5.2 ธุรกิจจะไม่เรียกร้องให้ One Platform และบริษัทในเครือ เจ้าหน้าที่ ตัวแทน และพนักงานของ One Platform ชดใช้ค่าเสียหายให้แก่คุณ และคุณจะไม่ฟ้องร้องคดีหรือดำเนินการใดๆอันเกิดจากหรือเกี่ยวกับการใช้บริการหรือการละเมิดข้อกำหนดเหล่านี้รวมถึงไม่ให้บุคคลดังกล่าวมีความรับผิดหรือต้องชำระค่าใช้จ่ายใดๆ ที่เกิดจากการเรียกร้องค่าสินไหมทดแทน การสูญเสีย ความเสียหาย การฟ้องร้องคดี การตัดสินคดี ค่าใช้จ่ายในการดำเนินคดี และค่าทนายความ <br>"},"custsat":{"Header":"แบบสอบถามความพึงพอใจในบริการ One Chat","username":"บัญชีผู้ใช้งาน","point":"คะแนน","ask_1":{"operation_system_1":"ใช้งาน One Chat ผ่านระบบปฏิบัติการใด","morethanone":"เลือกได้มากกว่า 1 ข้อ","android":"แอนดรอยด์ (Android)","ios":"ไอโอเอส (iOS)","website":"เว็บไซต์ (Website)"},"ask_2":{"frequencyUse":"ความถี่ในการใช้งาน","option1":"น้อยกว่า 1 วันต่อสัปดาห์","option2":"1-3 วันต่อสัปดาห์","option3":"4-6 วันต่อสัปดาห์","option4":"ทุกวัน"},"ask_3":"ฟังก์ชันมีความครบถ้วน เหมาะสมกับความต้องการ","ask_4":"ความเร็วในการตอบสนองการใช้งาน","ask_5":"กรณีเกิดปัญหา มีเจ้าหน้าที่ติดตาม ช่วยเหลือ แนะนำการใช้งานอย่างเหมาะสม","comment":"ข้อเสนอแนะเพิ่มเติม (ถ้ามี)","send":"ยืนยัน"},"File":{"passwordFile":"พาสเวิร์ด","textRequirePassword":"กรุณากรอกพาสเวิร์ด","wrongPassword":"พาสเวิร์ดไม่ถูกต้อง","downloadFile":"ดาวน์โหลดไฟล์"}}

/***/ }),

/***/ "a6yM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/DownloadAppMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DownloadAppMobile = ({
  props: {
    dilogDownload: Boolean
  },
  data: function data() {
    return {
      deviceos: '',
      snackbar: '',
      textsnackbar: '',
      type_device: '',
      windowWidth: ''
    };
  },

  watch: {
    dialogDownload: function dialogDownload() {
      console.log(this.dialogDownload);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
  },
  created: function created() {
    // show download application
    var device = __webpack_require__("GtN+").default;
    this.deviceos = device.os;
    this.snackbar = true;
    // this.type_device = 'unknow'
    var isIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
    if (device.os === 'unknown') {
      // isIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
      // console.log(isIpad)
      if (isIpad) {
        this.type_device = 'tablet';
      } else {
        this.type_device = device.type;
      }
    } else {
      this.type_device = device.type;
    }
    // alert(`type: ${device.type}, os: ${device.os}, isipad: ${isIpad}`)
    console.log(isIpad);
    // console.log(navigator.userAgent)
    console.log(device);
    console.log(device.type);
    console.log(this.windowWidth);
  },

  methods: {
    downloadios: function downloadios() {
      // window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus()
      window.open('https://qrcode.chat.one.th/api/v1/go-to-onechat').focus();
    },
    downloadandroid: function downloadandroid() {
      window.open('https://qrcode.chat.one.th/api/v1/go-to-onechat').focus();
      // window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus()
    },
    downloadapp: function downloadapp() {
      window.open('http://onelink.to/2sjwf7').focus();
      // window.open('https://qrcode.chat.one.th/api/v1/go-to-onechat').focus()
    },
    closedownload: function closedownload() {
      this.snackbar = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ea16b3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/DownloadAppMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.snackbar && _vm.type_device !== 'desktop')?_c('v-flex',{staticClass:"CSChatThai card-loading",attrs:{"xs12":"","md12":""},model:{value:(_vm.dilogDownload),callback:function ($$v) {_vm.dilogDownload=$$v},expression:"dilogDownload"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-flex',{attrs:{"xs2":"","md2":""}},[_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){_vm.closedownload()}}},[_c('v-icon',{staticStyle:{"font-size":"18px !important","color":"#2463af"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"font-weight":"700"},attrs:{"xs6":"","md6":""}},[_vm._v("\n      "+_vm._s(_vm.$t('Dialog.download.textDownload'))+"\n    ")]),_vm._v(" "),_c('v-flex',{staticStyle:{"justify-content":"end","display":"flex"},attrs:{"xs4":"","md4":""}},[_c('v-btn',{staticStyle:{"color":"white","border-radius":"26px","text-transform":"none"},attrs:{"color":"#2463af","drak":""},on:{"click":function($event){_vm.downloadapp()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.download')))])],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_DownloadAppMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/DownloadAppMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("p91b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ea16b3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  DownloadAppMobile,
  dialog_DownloadAppMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_DownloadAppMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a8MN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aWhy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/ManageGroupDialogMobile.vue
var ManageGroupDialogMobile = __webpack_require__("tNVr");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fe89715","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/ManageGroupDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px","max-height":"350px"},model:{value:(_vm.dialogManageGroup),callback:function ($$v) {_vm.dialogManageGroup=$$v},expression:"dialogManageGroup"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-users")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.group.headerSetting')))],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeManageGroup}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"sm12":"","md12":""}},[(_vm.detail.statemember == 'active')?_c('v-badge',{attrs:{"color":"orange darken-1","overlap":"","bottom":""}},[_c('v-icon',{staticStyle:{"font-size":"8px !important","cursor":"pointer"},attrs:{"slot":"badge","dark":"","small":""},on:{"click":_vm.uppic},slot:"badge"},[_vm._v("\n                 add_a_photo\n               ")]),_vm._v(" "),_c('v-avatar',{staticStyle:{"margin-top":"3vh","border":"0px #1a222c !important","border-style":"solid !important"},attrs:{"size":"80px"}},[(_vm.detail.picture == '')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"border":"0px #1a222c !important","border-style":"solid !important","cursor":"pointer"},attrs:{"src":"/static/img/default_profile/group-white.png"},on:{"click":_vm.uppic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"border":"0px #1a222c !important","border-style":"solid !important","cursor":"pointer"},attrs:{"src":_vm.detail.picture},on:{"click":_vm.uppic}}),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('input',{staticClass:"CSChatThai",attrs:{"type":"file","name":"file1","accept":"image/*","id":"uploadpicturegroup"},on:{"change":_vm.previewImagegroup}})])])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticStyle:{"justify-content":"center","margin-top":"2vh"},attrs:{"xs12":"","sm12":"","md12":""}},[(!_vm.edit)?_c('div',{staticClass:"CSChatThai",staticStyle:{"width":"100%"}},[_vm._v("\n               "+_vm._s(_vm.$t('Dialog.group.groupName'))+" :   \n               "),_c('div',{staticClass:"groupnameEdit",on:{"click":function($event){_vm.editprofile()}}},[_vm._v("  "+_vm._s(_vm.detail.group_name)+"\n                 "),_c('div',{staticClass:"messageedit",staticStyle:{"color":"#757575","font-size":"13px !important","cursor":"pointer","float":"right"}},[_c('v-icon',{staticStyle:{"font-size":"10px","color":"#757575"}},[_vm._v("settings")]),_vm._v("\n                 "+_vm._s(_vm.$t('AnswerQuestion.edit'))+"\n                 ")],1)])]):_c('div',{staticClass:"CSChatThai",staticStyle:{"width":"100%"}},[_vm._v("\n               "+_vm._s(_vm.$t('Dialog.group.groupName'))+" :   \n                 "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nameedit),expression:"nameedit"}],staticClass:"CSChatThai",staticStyle:{"width":"100%"},attrs:{"type":"texteditgroup","placeholder":_vm.$t('LeftSide.createGroup.detailSearch')},domProps:{"value":(_vm.nameedit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nameedit=$event.target.value}}}),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","text-align":"center","margin-top":"10px"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{staticStyle:{"padding-right":"10px"},attrs:{"align-center":"","justify-end":""}},[_c('v-btn',{staticClass:"btnallow text-transform",on:{"click":function($event){_vm.changeprofile()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.keep')))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":""}},[_c('v-btn',{staticClass:"btncancel text-transform",on:{"click":function($event){_vm.editprofile()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1)],1)],1)],1)])])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_ManageGroupDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/ManageGroupDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("+1lV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fe89715"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ManageGroupDialogMobile["a" /* default */],
  dialog_ManageGroupDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_ManageGroupDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aj2r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_chat/WebviewBigOcrDialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var WebviewBigOcrDialog = ({
  data: function data() {
    // <== changed this line
    return {
      progressLoding: true,
      interval: 0,
      value: 0,
      tokenrooomSelect: String,
      token: String
    };
  },

  props: {
    dialogWebviewbig_ocr: false,
    Webview_item: {}
  },
  watch: {
    socket_close_webview: function socket_close_webview() {
      this.closeDialog();
    },
    dialogWebviewbig_ocr: function dialogWebviewbig_ocr() {
      if (this.dialogWebviewbig_ocr) {
        this.queryAndIndeterminate();
      } else {
        this.value = 0;
        this.progressLoding = true;
      }
    },
    Webview_item: function Webview_item() {
      this.value = 100;
      this.interval = 0;
      this.progressLoding = false;
    }
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  methods: {
    queryAndIndeterminate: function queryAndIndeterminate() {
      this.value = 0;

      // setTimeout(() => {
      var step = 0.3;
      var current_progress = 0;
      var me = this;
      this.interval = setInterval(function () {
        current_progress += step;
        me.value = Math.round(Math.atan(current_progress) / (Math.PI / 2) * 100 * 1000) / 1000;
        if (me.value >= 100) {
          clearInterval(me.interval);
        } else if (me.value >= 70) {
          step = 0.1;
        }
      }, 100);
      // }, 2500)
    },
    closeDialog: function closeDialog() {
      // console.log("closeDialog")
      this.$emit('closeWebview', false);
      this.progressLoding = true;
      this.closewebview();
    },
    closewebview: function closewebview() {
      // console.log(authen.tokenuser)
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/close-webview', {
        tokenroom: this.tokenrooomSelect,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data)
      }).catch(function (error) {
        console.log(error);
      });
    },
    newtab: function newtab() {
      // this.Webview_item.url
      window.open(this.Webview_item.url, '_blank');
      this.closeDialog();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed75e15","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_chat/WebviewBigOcrDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden","border-radius":"20px"},attrs:{"persistent":""},model:{value:(_vm.dialogWebviewbig_ocr),callback:function ($$v) {_vm.dialogWebviewbig_ocr=$$v},expression:"dialogWebviewbig_ocr"}},[_c('v-card',{staticStyle:{"border-radius":"20px","width":"70vw","margin":"auto","overflow-y":"hidden"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Dialog.ocr.selectText'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},nativeOn:{"click":function($event){return _vm.newtab($event)}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("far fa-window-restore")])],1),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding":"0","height":"550px !important"}},[(!_vm.progressLoding)?_c('iframe',{staticStyle:{"visibility":"visible","width":"100% !important","height":"100% !important"},attrs:{"frameborder":"0","src":_vm.Webview_item.url,"allow":"geolocation"}}):_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"justify-content":"center","display":"grid","height":"80vh"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticStyle:{"margin":"auto"}},[_c('v-progress-circular',{staticStyle:{"width":"60vw !important"},attrs:{"rotate":-90,"size":150,"width":15,"value":_vm.value,"color":"#0e468e"}},[_vm._v("\n              "+_vm._s(Math.ceil(_vm.value))+"%\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('Dialog.ocr.processing')))])],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var manage_chat_WebviewBigOcrDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_chat/WebviewBigOcrDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("kMYv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ed75e15"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  WebviewBigOcrDialog,
  manage_chat_WebviewBigOcrDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_manage_chat_WebviewBigOcrDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "at4G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/albums/AddImageDialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import CreateAlbumsDialog from '@/components/chat/dialog/albums/CreateAlbumsDialog'
/* harmony default export */ var AddImageDialog = ({
  props: {
    dialogAddImage: false,
    path_pic_albums: '',
    file_name: ''
  },
  components: {
    // CreateAlbumsDialog
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  data: function data() {
    return {
      tokenuser: '',
      tokenroom: '',
      listalbum: [],
      filter_infoalbum: [],
      lastindex_image: [],
      image_last: [],
      albumsname: '',
      loading: false,
      information_image: []
      // dialogCreatealbums: false
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    this.tokenroom = this.$route.params.roomid;
  },

  methods: {
    // closeCreatealbums(value) {
    //   this.dialogCreatealbums = value
    // },
    closeDialog: function closeDialog() {
      this.$emit('closeAddImage', false);
      this.$emit('path_pic_albums', '');
    },
    date: function date(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    time: function time(timestamp) {
      return services["c" /* Momenttime */].momenttimethai(timestamp);
    },
    addimage_albums: function addimage_albums(albums_id, albums_name) {
      var _this = this;

      // console.log(albums_id)
      this.$swal({
        title: this.$t('Alert.Album.headerAddImageAlbum'),
        text: this.$t('Alert.Album.textAddImageAlbum', { name: albums_name }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel')
      }).then(function (result) {
        if (result.value) {
          _this.axios.post("https://uatchat-manage.one.th/event" + '/addimage_chatroom_to_albums', {
            path_imgs: _this.path_pic_albums,
            tokenuser: _this.tokenuser,
            tokenroom: _this.tokenroom,
            albums_id: albums_id
          }).then(function (response) {
            // console.log(response.data.data)
            _this.$swal('', _this.$t('Alert.Success.savePhotoAlbum'), 'success');
          }).catch(function (err) {
            console.log(err);
          });
        }
      });
    },
    create_albums: function create_albums() {
      var _this2 = this;

      this.loading = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/addimage_chatroom_to_albums', {
        path_imgs: this.path_pic_albums,
        tokenuser: this.tokenuser,
        tokenroom: this.tokenroom,
        albums_name: this.albumsname
      }).then(function (response) {
        _this2.loading = false;
        // console.log(response.data.data)
        _this2.$swal('', _this2.$t('Alert.Success.createAlbum'), 'success');
        _this2.$emit('closeAddImage', false);
      }).catch(function (err) {
        console.log(err);
      });
      // }
      // , () => {
      //   this.$swal('', 'ไม่สามารถสร้างอัลบั้มได้ กรุณาลองใหม่ภายหลัง', 'error')
      // })
    }
  },
  watch: {
    dialogAddImage: function dialogAddImage() {
      var _this3 = this;

      // console.log(this.path_pic_albums)
      this.tokenroom = this.$route.params.roomid;
      if (this.dialogAddImage) {
        this.axios.post("https://uatchat-manage.one.th/event" + '/getlist_albums', { tokenroom: this.tokenroom, tokenuser: this.tokenuser }).then(function (response) {
          // console.log(response.data.data)
          _this3.listalbum = response.data.data;
          // console.log(this.listalbum)
          for (var i = 0; i < _this3.listalbum.length; i++) {
            // console.log(this.listalbum[i]['information'])
            _this3.lastindex_image[i] = _.findLastIndex(_this3.listalbum[i].information, function (o) {
              return o.status == 'active';
            });
            // this.image_last[i] = this.listalbum[this.lastindex_image[i]].information
            // this.filter_infoalbum[i] = _.filter(this.listalbum[i].information, function (information) { return information.status === 'active' })
          }
          // console.log(this.image_last)
          // this.filter_infoalbum = _.filter(this.listalbum.information, function (information) { return information.status === 'active' })
        }).catch(function (error) {
          if (error.response.data.status === 'fail') {
            console.log(error);
          }
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-473be0ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/albums/AddImageDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden","border-radius":"20px !important"},attrs:{"max-width":"500px","persistent":"","max-height":"500px"},model:{value:(_vm.dialogAddImage),callback:function ($$v) {_vm.dialogAddImage=$$v},expression:"dialogAddImage"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-images")]),_vm._v("  \n            "),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t('Dialog.album.headerAddImage')))])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"500px !important","overflow-y":"hidden"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-icon',[_vm._v("fas fa-images")]),_vm._v(" "),_c('v-text-field',{staticClass:"ml-2",attrs:{"name":"albums_name","label":_vm.$t('Dialog.album.nameAlbum'),"id":"id"},model:{value:(_vm.albumsname),callback:function ($$v) {_vm.albumsname=$$v},expression:"albumsname"}}),_vm._v(" "),_c('v-btn',{staticClass:"btnalbums",attrs:{"loading":_vm.loading,"flat":""},on:{"click":function($event){_vm.create_albums()}}},[_vm._v(_vm._s(_vm.$t('Dialog.album.btnCreate')))])],1),_vm._v(" "),_c('v-layout',{staticClass:"scrolling-wrapper",staticStyle:{"height":"500px"},attrs:{"row":"","wrap":""}},[(_vm.listalbum.length != 0)?_c('v-list',{staticStyle:{"width":"100% !important"},attrs:{"two-line":""}},[_vm._l((_vm.listalbum),function(item,index){return [(item.state['status'] !== 'delete')?_c('v-list-tile',{key:item.title,staticStyle:{"cursor":"pointer"},attrs:{"avatar":"","ripple":""}},[_c('v-list-tile-content',_vm._l((item.information),function(image,index){return _c('v-layout',{attrs:{"row":"","wrap":""}},[(image.status == 'active' && index === 0)?_c('img',{staticStyle:{"padding":"10px","height":"80px","border-radius":"15px"},attrs:{"src":image.link,"width":"80px"}}):(index === 0 && image.status == 'delete')?_c('img',{attrs:{"src":"/static/img/icons/image.png","alt":"","width":"80px"}}):_vm._e()])})),_vm._v(" "),_c('v-list-tile-content',{on:{"click":function($event){_vm.addimage_albums(item._id, item.albums_name)}}},[(item.albums_name !== '')?_c('v-list-tile-title',[_vm._v(_vm._s(item.albums_name))]):_c('v-list-tile-title',[_vm._v(_vm._s(_vm.date(item.create_date)))])],1),_vm._v(" "),_c('v-list-tile-action')],1):_vm._e(),_vm._v(" "),(index + 1 < _vm.listalbum.length && item.state['status'] !== 'delete')?_c('v-divider',{key:index}):_vm._e()]})],2):_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('h4',[_vm._v(_vm._s(_vm.$t('Dialog.album.noDataAlbum')))])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var albums_AddImageDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/albums/AddImageDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("jMNM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-473be0ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  AddImageDialog,
  albums_AddImageDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_albums_AddImageDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b4FA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bDfE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bO0B":
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),

/***/ "blpm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/components/chat/dialog/saveonebox/SaveoneboxDialog.vue + 2 modules
var SaveoneboxDialog = __webpack_require__("rTZ8");

// EXTERNAL MODULE: ./src/components/chat/dialog/ShowImage_ProfileDialog.vue + 2 modules
var ShowImage_ProfileDialog = __webpack_require__("sVBg");

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./node_modules/vue-hls-player/lib/vue-hls-player.js
var vue_hls_player = __webpack_require__("VfTH");
var vue_hls_player_default = /*#__PURE__*/__webpack_require__.n(vue_hls_player);

// EXTERNAL MODULE: ./node_modules/vue-pdf/src/vuePdfNoSss.vue + 1 modules
var vuePdfNoSss = __webpack_require__("dAhr");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/ShowPDFDialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var ShowPDFDialog = ({
  props: { dialogshowfile: false, DetailFile: {} },
  data: function data() {
    return {
      token: '',
      dialogshowimage_profile: false,
      pathpicture: '',
      typepathpicture: '',
      dialogSaveOnebox: false,
      tokenmessage_savebox: '',
      numPages: '',
      filepdf: ''
    };
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {
    // filepdf () {
    //   // console.log(this.filepdf)
    //   this.src = pdf.createLoadingTask(this.filepdf)
    //   // console.log(this.src)
    //   this.src.promise.then(pdf => {
    //     // console.log(pdf)
    //     this.numPages = pdf.numPages
    //     // console.log(this.numPages)
    //   })
    // },
    dialogshowfile: function dialogshowfile() {
      if (this.dialogshowfile == true) {
        // console.log(this.DetailFile)
        if (this.extension(this.DetailFile.message) == 'pdf') {
          this.filepdf = this.DetailFile.message;
          // console.log(this.filepdf)
        }
      }
      // DetailFile(){
      //   console.log(this.DetailFile)
      // }
    },
    filepdf: function filepdf() {
      var _this = this;

      // console.log(this.filepdf)
      this.src = vuePdfNoSss["a" /* default */].createLoadingTask(this.filepdf);
      // console.log(this.src)
      this.src.promise.then(function (pdf) {
        // console.log(pdf)
        _this.numPages = pdf.numPages;
        // console.log(this.numPages)
      });
    }
  },
  components: {
    pdf: vuePdfNoSss["a" /* default */],
    ShowImageProfileDialog: ShowImage_ProfileDialog["a" /* default */],
    SaveOnebox: SaveoneboxDialog["a" /* default */],
    vplayer: vue_hls_player["vplayer"]
  },
  methods: {
    // passwordPdf (updatePassword, reason) {
    //   console.log(reason)
    //   updatePassword(prompt('password is "test"'));
    // },
    // errorPdf (err) {
    //   console.log(err)
    // },
    play: function play(e) {
      // console.log(e)
    },
    openPictureProfile: function openPictureProfile(picture, type) {
      this.pathpicture = picture;
      this.typepathpicture = type;
      this.dialogshowimage_profile = true;
    },
    closeDialogShowImage_Profile: function closeDialogShowImage_Profile(value) {
      this.dialogshowimage_profile = value;
    },
    loadpic: function loadpic(filenameSend) {
      // console.log(this.DetailFile)
      if (this.DetailFile.typeofmessage === 'video') {
        this.axios.get(this.DetailFile.original_file, {
          responseType: 'blob'
        }).then(function (response) {
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filenameSend);
          document.body.appendChild(link);
          link.click();
        });
      } else {
        this.axios.get(this.DetailFile.message, {
          responseType: 'blob'
        }).then(function (response) {
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filenameSend);
          document.body.appendChild(link);
          link.click();
        });
      }
    },
    sendonebox: function sendonebox(tokenmessage) {
      this.dialogSaveOnebox = true;
      this.tokenmessage_savebox = tokenmessage;
    },
    closeSaveOnebox: function closeSaveOnebox(value) {
      this.dialogSaveOnebox = value;
    },
    closeDialogShowFile: function closeDialogShowFile() {
      this.$emit('closeDialogShowFile', false);
    },
    date: function date(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    time: function time(timestamp) {
      return services["c" /* Momenttime */].momenttimethai(timestamp);
    },
    extension: function extension(path) {
      if (path !== undefined && path.includes('.') == true) {
        var fullname_path = path.split('.')[path.split('.').length - 1].toLowerCase();
        if (fullname_path.includes(' ')) {
          var path_space = fullname_path.split(' ');
          var extension = path_space[0];
        } else {
          var extension = fullname_path;
        }
        // console.log( 'path' , path)
        // var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
        var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
        var pdf = ['pdf'];
        var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm', 'xlsx'];
        var presentation = ['ppt', 'pps', 'pot', 'pptx'];
        var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
        var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
        var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff'];
        var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4', 'divx', 'dat'];
        var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf'];
        if (pdf.includes(extension)) {
          return 'pdf';
        } else if (archive.includes(extension)) {
          return 'fas fa-file-archive';
        } else if (spreadsheet.includes(extension)) {
          return 'fas fa-file-excel';
        } else if (presentation.includes(extension)) {
          return 'fas fa-file-powerpoint';
        } else if (word.includes(extension)) {
          return 'fas fa-file-word';
        } else if (execution.includes(extension)) {
          return 'fas fa-file-code';
        } else if (image.includes(extension)) {
          return 'fas fa-file-image';
        } else if (media.includes(extension)) {
          return 'media';
        } else if (audio.includes(extension)) {
          return 'audio';
        } else {
          return 'fas fa-file-alt';
        }
      } else {
        return 'fas fa-file-alt';
      }
    }
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];

    if (this.extension(this.DetailFile.message) == 'pdf') {
      this.filepdf = this.DetailFile.message;
      // console.log(this.filepdf)
    }
    // this.filepdf =
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b13d3a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/ShowPDFDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogshowfile),callback:function ($$v) {_vm.dialogshowfile=$$v},expression:"dialogshowfile"}},[_c('v-card',{staticClass:"hidden-sm-and-down",staticStyle:{"background-color":"rgba(0, 0, 0, 0.9)"}},[_c('v-toolbar',{staticStyle:{"background-color":"#1b232d"},attrs:{"dark":""}},[_c('v-flex',{staticStyle:{"text-align":"right","padding-right":"2vw"},attrs:{"xl1":"","lg1":"","md1":"","sm1":""}},[_c('v-avatar',{staticClass:"user-photo",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.openPictureProfile(_vm.DetailFile.path_pic, _vm.DetailFile.type)}}},[(_vm.DetailFile.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.DetailFile.path_pic}}):(_vm.DetailFile.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.DetailFile.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xl6":"","lg6":"","md6":"","sm6":""}},[_c('b',{staticStyle:{"font-size":"14px"}},[_vm._v(" "+_vm._s(_vm.DetailFile.file_name))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px","margin-bottom":"0px"}},[_vm._v(" "+_vm._s(_vm.$t('Dialog.showImage.by'))+" "+_vm._s(_vm.DetailFile.nickname)+"   |  "+_vm._s(_vm.date(_vm.DetailFile.timestamp))+"\n              "),_c('v-icon',{staticStyle:{"font-size":"7px !important","color":"white !important"}},[_vm._v("schedule")]),_vm._v(_vm._s(_vm.time(_vm.DetailFile.timestamp))+"\n            ")],1)]),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"right"},attrs:{"xl4":"","lg4":"","md4":"","sm4":""}},[_c('v-btn',{staticClass:"btnallow CSChatThai",attrs:{"depressed":"","small":"","id":"btn-download"},on:{"click":function($event){_vm.loadpic(_vm.DetailFile.file_name)}}},[_c('v-icon',[_vm._v("file_download")]),_vm._v("  "+_vm._s(_vm.$t('AnswerQuestion.download'))+"\n            ")],1),_vm._v(" "),_c('v-btn',{staticClass:"btncancel CSChatThai",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.sendonebox(_vm.DetailFile.tokenmessage)}}},[_c('v-icon',[_vm._v("cloud_upload")]),_vm._v("   "+_vm._s(_vm.$t('AnswerQuestion.sendOnebox'))+"\n            ")],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"right"},attrs:{"xl1":"","lg1":"","md1":"","sm1":""}},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialogShowFile}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"background":"none"}},[(_vm.DetailFile.typeofmessage !== 'video')?_c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 64px)","justify-content":"center"},attrs:{"src":_vm.DetailFile.message,"frameborder":"0"}}):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"hidden-md-and-up"},[_c('div',{attrs:{"id":"headcaption"}},[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"text-align":"right","padding-right":"2vw"},attrs:{"md2":"","sm2":"","xs2":""}},[_c('v-avatar',{staticClass:"user-photo",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.openPictureProfile(_vm.DetailFile.path_pic, _vm.DetailFile.type)}}},[(_vm.DetailFile.path_pic)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.DetailFile.path_pic}}):(_vm.DetailFile.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.DetailFile.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","md9":"","sm9":""}},[_c('p',{staticStyle:{"font-size":"14px","white-space":"nowrap","width":"16em","overflow":"hidden","text-overflow":"ellipsis","font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.DetailFile.file_name))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px","white-space":"nowrap","width":"20em","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(" "+_vm._s(_vm.$t('Dialog.showImage.by'))+" "+_vm._s(_vm.DetailFile.nickname)+"\n              ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$t('Dialog.showImage.date'))+" "+_vm._s(_vm.date(_vm.DetailFile.timestamp))+"  "),_c('v-icon',{staticStyle:{"font-size":"7px !important","color":"white !important"}},[_vm._v("schedule")]),_vm._v(_vm._s(_vm.time(_vm.DetailFile.timestamp))+"\n              ")],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","md1":"","sm1":""}},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialogShowFile}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-left":"15vw"},attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-btn',{staticClass:"btnallow text-transform",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.loadpic(_vm.DetailFile.file_name)}}},[_c('v-icon',[_vm._v("file_download")]),_vm._v(" \n                  "+_vm._s(_vm.$t('AnswerQuestion.download'))+"\n                ")],1),_vm._v(" "),_c('v-btn',{staticClass:"btncancel text-transform",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.sendonebox(_vm.DetailFile.tokenmessage)}}},[_c('v-icon',[_vm._v("cloud_upload")]),_vm._v("  \n                    "+_vm._s(_vm.$t('AnswerQuestion.sendOnebox'))+"\n                ")],1)],1)],1)],1)],1),_vm._v(" "),(_vm.extension(_vm.DetailFile.message) == 'pdf')?_c('div',{staticStyle:{"overflow-y":"scroll","height":"90%"}},_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,ref:"myPdfComponent",refInFor:true,attrs:{"page":i,"src":_vm.DetailFile.message}})})):_c('div',{staticStyle:{"background":"none"}},[(_vm.DetailFile.typeofmessage !== 'video')?_c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 64px)","justify-content":"center"},attrs:{"src":_vm.DetailFile.message,"frameborder":"0"}}):_c('div',{staticStyle:{"width":"100%","justify-content":"center","height":"calc(100vh - 64px)"}},[_c('vplayer',{attrs:{"playerOptions":{
                  type: 'application/x-mpegURL',
                  src: _vm.DetailFile.message,
                  preload: true,
                  autoplay: false,
                  isLoop: false,
                  playsinline: false,
                  poster: _vm.DetailFile.thumbnail,
                  controls: 'progress, current, durration, volume',
                  crossOrigin: false
                }},on:{"onplay":_vm.play}})],1)])]),_vm._v(" "),_c('ShowImageProfileDialog',{attrs:{"dialogshowimage_profile":_vm.dialogshowimage_profile,"pathpicture":_vm.pathpicture,"typepathpicture":_vm.typepathpicture},on:{"closeDialogShowImage_Profile":_vm.closeDialogShowImage_Profile}}),_vm._v(" "),_c('SaveOnebox',{attrs:{"dialogSaveOnebox":_vm.dialogSaveOnebox,"tokenmessage_savebox":_vm.tokenmessage_savebox},on:{"closeSaveOnebox":_vm.closeSaveOnebox}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_ShowPDFDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/ShowPDFDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("6NYr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b13d3a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ShowPDFDialog,
  dialog_ShowPDFDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var chat_dialog_ShowPDFDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c4nx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c8fY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cGNK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_chat/ForwardDialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var _ = __webpack_require__("M4fF");

/* harmony default export */ var ForwardDialog = ({
  props: { dialogForward: false, selectedForward: '' },
  data: function data() {
    return {
      token: '',
      progress: false,
      status: 'progress',
      statusGroup: 'progress',
      GroupList: [],
      FriendList: [],
      search: '',
      selectedRoomForward: []
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.getlistfriend();
    this.getlistgroup();
  },

  watch: {
    socketaccept_friend: function socketaccept_friend() {
      this.getlistfriend();
    },
    socketremove_friend: function socketremove_friend() {
      this.getlistfriend();
    },
    selectedRoomForward: function selectedRoomForward() {
      if (this.selectedRoomForward.length > 5) {
        this.$swal('', this.$t('Alert.Fail.forward.maxChatRoom'), 'error');
        _.pullAt(this.selectedRoomForward, [5]);
      }
    }
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeForward', false);
      this.selectedRoomForward = [];
      this.search = '';
    },
    sendForward: function sendForward() {
      var _this = this;

      if (this.selectedRoomForward.length !== 0) {
        this.axios.post("https://uatchat-manage.one.th/message" + '/forward_file_message', { list_tokenroom: this.selectedRoomForward, tokenuser: this.token, list_tokenmessage: this.selectedForward }).then(function (response) {
          if (response.data['status'] === 'success') {
            _this.$swal('', _this.$t('Alert.Success.sendMsg'), 'success');
            _this.closeDialog();
          } else {
            _this.$swal('', _this.$t('Alert.Fail.default.somethingWrong'), 'error');
            _this.closeDialog();
          }
        }, function () {
          _this.$swal('Network error', _this.$t('Alert.Fail.default.networkError'), 'error');
          _this.closeDialog();
        });
      }
    },
    getlistfriend: function getlistfriend() {
      var _this2 = this;

      this.status = 'progress';
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-friend', { tokenuser: this.token }).then(function (response) {
        _this2.status = 'show';
        // console.log(response.data)
        _this2.FriendList = response.data['list_friend'];
      });
    },
    getlistgroup: function getlistgroup() {
      var _this3 = this;

      this.statusGroup = 'progress';
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-list-group', { tokenuser: this.token }).then(function (response) {
        _this3.statusGroup = 'show';
        // console.log(response.data['listgroup'])
        _this3.GroupList = response.data['list_active_group'];
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2841b60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_chat/ForwardDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"max-width":"500px","persistent":"","max-height":"500px"},model:{value:(_vm.dialogForward),callback:function ($$v) {_vm.dialogForward=$$v},expression:"dialogForward"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("far fa-comments")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.forward.header')))],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"30px"}},[(_vm.status == 'progress' || _vm.statusGroup == 'progress')?_c('v-progress-linear',{attrs:{"indeterminate":_vm.progress}}):_c('v-container',{staticStyle:{"padding-top":"0px"},attrs:{"wrap":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","wrap":""}},[_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-tabs',{attrs:{"centered":"","dark":"","icons-and-text":"","color":"white"}},[_c('v-tabs-slider',{attrs:{"color":"info"}}),_vm._v(" "),(_vm.FriendList.length !== 0)?_c('v-tab',{key:1,staticStyle:{"color":"black !important","text-transform":"none","background":"white"},attrs:{"href":"#tab-1"}},[_vm._v("\n                  "+_vm._s(_vm.$t('Dialog.forward.friend'))+"\n                    "),_c('v-badge',{attrs:{"right":""}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(" "+_vm._s(_vm.FriendList.length)+" ")]),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"black !important","font-size":"25px !important"}},[_vm._v("person")])],1)],1):_vm._e(),_vm._v(" "),(_vm.GroupList.length !== 0)?_c('v-tab',{key:2,staticStyle:{"color":"black !important","text-transform":"none","background":"white"},attrs:{"href":"#tab-2"}},[_vm._v(_vm._s(_vm.$t('Dialog.forward.group'))+"\n                  "),_c('v-badge',{attrs:{"right":""}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(" "+_vm._s(_vm.GroupList.length)+" ")]),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"black !important","font-size":"25px !important"}},[_vm._v("group")])],1)],1):_vm._e(),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',{attrs:{"id":"tab-1"}},[(_vm.FriendList.length !== 0)?_c('v-list',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"200px"},attrs:{"two-line":""}},[_vm._l((_vm.FriendList),function(item,index){return [(index != 0)?_c('v-divider'):_vm._e(),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"width":"18em"}},[_vm._v("\n                          "+_vm._s(item.name)+"\n                        ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-checkbox',{staticStyle:{"float":"right"},attrs:{"value":item.tokenroom},model:{value:(_vm.selectedRoomForward),callback:function ($$v) {_vm.selectedRoomForward=$$v},expression:"selectedRoomForward"}})],1)],1)]})],2):_vm._e()],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[(_vm.GroupList.length !== 0)?_c('v-list',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"200px"},attrs:{"two-line":""}},[_vm._l((_vm.GroupList),function(item,index){return [(index != 0)?_c('v-divider'):_vm._e(),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',[(item.picture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.picture}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/group-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"width":"18em"},domProps:{"innerHTML":_vm._s(item.name)}})],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-checkbox',{staticStyle:{"float":"right"},attrs:{"value":item.tokenroom},model:{value:(_vm.selectedRoomForward),callback:function ($$v) {_vm.selectedRoomForward=$$v},expression:"selectedRoomForward"}})],1)],1)]})],2):_vm._e()],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-center":"","wrap":""}},[_c('v-btn',{staticClass:"CSChatThai",staticStyle:{"text-transform":"none"},attrs:{"color":"red","flat":""},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"CSChatThai",staticStyle:{"text-transform":"none"},attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.sendForward()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.send')))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var manage_chat_ForwardDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_chat/ForwardDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("iPzF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b2841b60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ForwardDialog,
  manage_chat_ForwardDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_manage_chat_ForwardDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cHLP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cnF5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dAhr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue-pdf/src/componentFactory.js
var componentFactory = __webpack_require__("iwQb");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-pdf/src/vuePdfNoSss.vue
//




if (Object({"NODE_ENV":"uat","API":"https://uatchat.one.th","APIQRcode":"https://uatchat.one.th","APIpub":"https://uatchat-manage.one.th/event","APIimage":"https://uatchat-manage.one.th/message","APIsocket":"https://uatchat-public.one.th:8998","APImanage":"https://uatchat-manage.one.th/manage","ONEID_API":"https://testoneid.inet.co.th/api","WEBchatdev":"https://uatchat.one.th:8089/docs","Bot_idPaperless":"B0df132b88f9a526691a0576bfdb24196","Bot_idcovid":"Bbe2c9fe1bcc956738a61c9ad0d91cb19","taxid_consent":"0107544000094","serviceid_consent":"SVC-1611218040238","formid_consent":"600956682f8678001cce54e8","AuthenOneid":"https://testoneid.inet.co.th/api/oauth/getcode?client_id=908&response_type=code&redirect_uri=https://uatchat.one.th/authorization/redirect","LogoutOneid":"https://testoneid.inet.co.th/api/oauth/logout?redirect_url=https://uatchat.one.th/homepage","redirect_url":"https://uatchat.one.th/authorization/redirect","Market_env":"staging","APInew_listchat":"https://uatchat-manage.one.th/go_api/api/v4/getListChat","APInew_getdict":"https://uatchat-manage.one.th/alpine/api/v1/getdictmessage","APInew_pushmessage":"https://uatchat-manage.one.th/alpine/api/v1/pushMessage","APInew_getaccesstoken":"https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken","APInew_getrichmenu":"https://uatchat-manage.one.th/go_api/api/v1/getRichmenuByTokenroom","APInew_addfriend":"https://uatchat-manage.one.th/go_api/api/v1/add-friend","APIcheck_consent":"https://uatapigw.appsdigit.inet.co.th/api/chat/service/check-consent","APInew_pushvideo":"https://uatchat-manage.one.th/media/api/v1/send-video","APInew_acceptfriend":"https://uatchat-manage.one.th/go_api/api/v1/accept-friend","APInew_creategroup":"https://uatchat-manage.one.th/go_api/api/v1/create-group","APIalpine":"https://uatchat-manage.one.th/alpine","APIgo_api":"https://uatchat-manage.one.th/go_api/api","WEBoneEmail":"https://testoneid.inet.co.th/preauth","WEBoneBox":"https://testoneid.inet.co.th/oauth/authorize?client_id=155&response_type=code&scope=account","WEBNews":"https://news.chat.korkla.in/checkauthen?authen=","WEB_Redirect_Onebox":"https://uatbox.one.th/loginbysharetoken?token=","WebAnonymous":"https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token=","Savelognews":"https://news.chat.one.th/backend/api/v1/page-analytics","urlEkyc":"https://uat-ekyc.id.th/redirect-share-token?shared_token=","linkonemeet":"https://meet-test.one.th/?sharetoken=","API_onemeet":"https://meet-test.one.th/","WEB_centrifuge":"wss://uatchat-manage.one.th/connection/websocket","centrifuge_key":'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MiJ9.IdLgsjcoPzTvA9Gq3t3D73fOLouzt-4CcTjk90saeIs',"APIsearchfriend":"https://uatchat-manage.one.th/go_api/api/v1/bot-search-friend","urlLoa":"https://testoneid.inet.co.th/login?redirect_url=https://testoneid.inet.co.th/portal_level&shared_token=","check_password":"https://uatchat-manage.one.th/bot-message/check"}).VUE_ENV === 'server') {

	var component = Object(componentFactory["a" /* default */])({});
} else {

	var pdfjsWrapper = __webpack_require__("ytml").default;
	var PDFJS = __webpack_require__("N1Pc");
	var component = Object(componentFactory["a" /* default */])(pdfjsWrapper(PDFJS));
}

/* harmony default export */ var vuePdfNoSss = (component);
// CONCATENATED MODULE: ./node_modules/vue-pdf/src/vuePdfNoSss.vue
function injectStyle (ssrContext) {
  __webpack_require__("1He0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  vuePdfNoSss,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_vuePdfNoSss = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dGX+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dJ4h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./node_modules/@bachdgvn/vue-otp-input/dist/vueOtpInput.common.js
var vueOtpInput_common = __webpack_require__("gD2W");
var vueOtpInput_common_default = /*#__PURE__*/__webpack_require__.n(vueOtpInput_common);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/@chenfengyuan/vue-countdown/dist/vue-countdown.js
var vue_countdown = __webpack_require__("aCbg");
var vue_countdown_default = /*#__PURE__*/__webpack_require__.n(vue_countdown);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/settings/Dialogeditphone.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






vue_esm["default"].component(vue_countdown_default.a.name, vue_countdown_default.a);
/* harmony default export */ var Dialogeditphone = ({
  components: {
    OtpInput: vueOtpInput_common_default.a
  },
  props: {
    dialogeditphone: Boolean,
    phoneedit: String,
    phone: String
  },
  data: function data() {
    var _ref;

    return _ref = {
      state_edit: false,
      // date: moment(60 * 5 * 1000),
      radios: '',
      e1: 1,
      radios2: '',
      complete: '',
      interv: '',
      otpinput: '',
      otpinput_terminate: '',
      otp_off: false,
      refcode_terminate: '',
      token: '',
      OTP: '',
      counting: false,
      counting2: false,
      phonenewtologin: '',
      date: moment_default()(60 * 5 * 1000)
    }, defineProperty_default()(_ref, 'interv', ''), defineProperty_default()(_ref, 'progress', false), defineProperty_default()(_ref, 'loadingOtpNewno', false), defineProperty_default()(_ref, 'loadingOtpTerminate', false), defineProperty_default()(_ref, 'progressTerminate', false), _ref;
  },
  computed: {
    time: function time() {
      // console.log(this.date.format('mm:ss'))
      return this.date.format('mm:ss');
    }
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    // console.log(this.token)
  },
  mounted: function mounted() {},

  watch: {
    dialogeditphone: function dialogeditphone() {
      var _this = this;

      this.otpinput_terminate = '';
      this.otpinput = '';
      if (this.dialogeditphone === true) {
        this.phonenewtologin = this.phoneedit;
        //
        var type_account = localStorage.typeAccount;
        if (type_account === 'true') {
          this.progress = true;
          this.axios.post("https://uatchat-manage.one.th/manage" + '/otp_change_phone', {
            new_phone: this.phoneedit,
            tokenuser: this.token
          }).then(function (response) {
            console.log(response);
            if (response.data.status === 'success') {
              _this.progress = false;
              _this.refcode_terminate = response.data.refcode;
            } else if (response.data.message === 'refresh_token expire') {
              _this.$swal({
                title: _this.$t('Settings.messageEditPhone.MsgTokenExpire'),
                type: 'warning'
              });
            } else if (response.data.message === 'too many requests.') {
              _this.refcode_terminate = '';
              _this.$swal({
                title: _this.$t('Settings.messageEditPhone.MsgTooManyRequest'),
                type: 'warning'
              });
            }
          }).catch(function (err) {
            console.log(err);
          });
          this.e1 = 4;
          this.counting = true;
        } else {
          this.e1 = 1;
        }
      }
    },
    e1: function e1() {
      if (this.e1 === 3) {
        this.counting2 = true;
      }
    }
  },
  methods: {
    handleOnChange: function handleOnChange(value) {
      if (value.length < 6) {
        this.complete = false;
      }
      // console.log('OTP changed: ', value);
    },
    handleOnComplete: function handleOnComplete(value) {
      // console.log('OTP complete: ', value);
      this.otpinput = value;
      this.complete = true;
    },
    handleOnChangeTerminate: function handleOnChangeTerminate(value) {
      if (value.length < 6) {
        this.complete = false;
      }
      // console.log('OTP changed: ', value);
    },
    handleOnCompleteTerminate: function handleOnCompleteTerminate(value) {
      // console.log('OTP completed: ', value);
      this.otpinput_terminate = value;
      this.complete = true;
    },
    disableBtn: function disableBtn() {
      // return true
      if (this.complete === true) {
        return false;
      } else {
        return true;
      }
    },
    sendOTPterminate: function sendOTPterminate() {
      var _this2 = this;

      this.loadingOtpTerminate = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/terminate_phone', {
        phone: this.phone,
        otp: this.otpinput_terminate
      }).then(function (response) {
        // console.log(response)
        if (response.data.message === 'terminate success') {
          _this2.loadingOtpTerminate = false;
          _this2.$swal({
            title: _this2.$t('Settings.messageEditPhone.MsgLoginPhoneAgain'),
            type: 'warning'
          }).then(function (result) {
            // console.log(result)
            if (result) {
              _this2.$emit('closeDialogEditPhone', false);
              _this2.$refs.otpInput.clearInput();
              _this2.radios = '';
              _this2.radios2 = '';
              localStorage.removeItem("typeAccount");
              _this2.logout();
              localStorage.tologin = _this2.phonenewtologin;
            }
          });
        } else {
          _this2.loadingOtpTerminate = false;
          _this2.$swal({
            title: _this2.$t('Settings.messageEditPhone.OTPInvalid'),
            type: 'error'
          });
        }
        // else{
        //   console.log('error')
        // }
      }).catch(function (err) {
        console.log(err);
      });
    },
    sendOTP: function sendOTP() {
      var _this3 = this;

      this.loadingOtpNewno = true;
      var type_account = localStorage.typeAccount;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/confirm_otp_change_phone', {
        new_phone: this.phoneedit,
        otp: this.otpinput,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response)
        if (type_account === 'true') {
          if (response.data.message === 'login success') {
            _this3.loadingOtpNewno = false;
            _this3.$swal({
              title: _this3.$t('Settings.messageEditPhone.MsgChangePhoneSuccess'),
              type: 'success'
            }).then(function (result) {
              if (result) {
                _this3.$emit('closeDialogEditPhone', false);
                _this3.$refs.otpInput.clearInput();
                _this3.radios = '';
                _this3.radios2 = '';
                localStorage.removeItem("typeAccount");
                localStorage.phone = _this3.phoneedit;
                localStorage.editphone_success = true;
              }
              // else{
              //   this.phoneedit = this.phone
              // }
            });
          } else if (response.data.message === 'OTP Invalid') {
            _this3.loadingOtpNewno = false;
            localStorage.editphone_success = false;
            _this3.$swal({
              title: _this3.$t('Settings.messageEditPhone.OTPInvalid'),
              type: 'error'
            });
          } else if (response.data.message === 'too many requests.') {
            _this3.loadingOtpNewno = false;
            _this3.refcode_terminate = '';
            _this3.$swal({
              title: _this3.$t('Settings.messageEditPhone.MsgTooManyRequest'),
              type: 'warning'
            });
          }
        } else {
          if (_this3.radios2 !== '') {
            _this3.$swal({
              title: _this3.$t('Settings.messageEditPhone.MsgLoginPhoneAgain'),
              type: 'warning'
            }).then(function (result) {
              if (result) {
                _this3.$emit('closeDialogEditPhone', false);
                // clearInterval(this.interv)
                _this3.date = moment_default()(60 * 5 * 1000);
                _this3.$refs.otpInput.clearInput();
                _this3.radios = '';
                _this3.radios2 = '';
                localStorage.removeItem("typeAccount");
                _this3.logout();
              }
            });
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    cancle: function cancle() {
      var _this4 = this;

      this.$swal({
        title: this.$t('Alert.Right.cancleEditPhone'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        // console.log(result.value)
        if (result.value === true) {
          _this4.$emit('closeDialogEditPhone', false);
          _this4.handleCountdownEnd();
          // clearInterval(this.interv)
          // this.date = moment(60 * 5 * 1000)
          _this4.$refs.otpInputTerminate.clearInput();
          _this4.$refs.otpInput.clearInput();
          _this4.radios = '';
          _this4.radios2 = '';
          localStorage.removeItem("typeAccount");
          // localStorage.phoneedit = this.phone
          // this.phoneedit = this.phone
          localStorage.editphone_success = false;
        }
      });
    },
    checkValue: function checkValue() {
      var _this5 = this;

      if (this.radios === 'closeRecent') {
        this.e1 = 2;
      } else {
        this.$swal({
          title: this.$t('Settings.messageEditPhone.MsgSwitchAccount'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '',
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-success',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then(function (result) {
          if (result.value === true) {
            _this5.$emit('closeDialogEditPhone', false);
            _this5.handleCountdownEnd();
            _this5.$refs.otpInput.clearInput();
            _this5.radios = '';
            _this5.radios2 = '';
            localStorage.removeItem("typeAccount");
            _this5.$swal({
              title: _this5.$t('Settings.messageEditPhone.MsgLoginPhoneAgain'),
              type: 'warning'
            }).then(function (result) {
              if (result) {
                // console.log(result)
                _this5.logout();
                localStorage.tologin = _this5.phonenewtologin;
              }
            });
          }
        });
      }
    },
    disablebtnST1: function disablebtnST1() {
      if (this.radios === '') {
        return true;
      } else {
        return false;
      }
    },
    disablebtnST2: function disablebtnST2() {
      if (this.radios2 === '') {
        return true;
      } else {
        return false;
      }
    },
    logout: function logout() {
      this.$cookie.delete('tokenuser');
      this.$cookie.delete('status_login');
      localStorage.clear();
      this.$router.push({ path: '/login', force: true });
      // if (process.env.LogoutOneid) {
      //   window.open(process.env.LogoutOneid, '_parent')
      // } else {
      //   this.$router.push({path: '/login', force: true})
      // }
    },
    newOtp: function newOtp() {
      var _this6 = this;

      this.counting = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/otp_change_phone', {
        new_phone: this.phoneedit,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response)
        _this6.refcode_terminate = response.data.refcode;
      }).catch(function (err) {
        console.log(err);
      });
    },
    newOtp2: function newOtp2() {
      var _this7 = this;

      // console.log('new otp')
      this.counting2 = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/otp_login_and_regis', {
        phone: this.phone
      }).then(function (response) {
        // console.log(response.data.refcode)
        _this7.refcode_terminate = response.data.refcode;
      });
    },
    Terminate: function Terminate() {
      var _this8 = this;

      // console.log('terminate')
      this.progressTerminate = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/otp_login_and_regis', {
        phone: this.phone
      }).then(function (response) {
        // console.log(response)
        // console.log(response.data.message)
        if (response.data.message === 'too many requests.') {
          _this8.progressTerminate = false;
          _this8.refcode_terminate = '';
          _this8.$swal({
            title: _this8.$t('Settings.messageEditPhone.MsgTooManyRequest'),
            type: 'warning'
          });
        } else if (response.data.status === 'success') {
          _this8.progressTerminate = false;
          _this8.refcode_terminate = response.data.refcode;
        }
      });
      this.e1 = 3;
    },
    handleCountdownEnd: function handleCountdownEnd() {
      this.counting = false;
    },
    handleCountdownEnd2: function handleCountdownEnd2() {
      this.counting2 = false;
    },
    handleCountdownProgress: function handleCountdownProgress(data) {
      // console.log(data.days);
      // console.log(data.hours);
      // console.log(data.minutes);
      // console.log(data.seconds);
      // console.log(data.milliseconds);
      // console.log(data.totalDays);
      // console.log(data.totalHours);
      // console.log(data.totalMinutes);
      // console.log(data.totalSeconds);
      // console.log(data.totalMilliseconds);
    },
    transform: function transform(props) {
      entries_default()(props).forEach(function (_ref2) {
        var _ref3 = slicedToArray_default()(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        // Adds leading zero
        var digits = value < 10 ? '0' + value : value;
        // uses singular form when the value is less than 2
        var word = value < 2 ? key.replace(/s$/, '') : key;
        props[key] = '' + digits;
      });
      return props;
    },
    countdown: function countdown() {
      var _this9 = this;

      this.interv = setInterval(function () {
        _this9.date = moment_default()(_this9.date.subtract(1, 'seconds'));
      }, 1000);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c07cf5f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/settings/Dialogeditphone.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"450"},model:{value:(_vm.dialogeditphone),callback:function ($$v) {_vm.dialogeditphone=$$v},expression:"dialogeditphone"}},[_c('v-card',{staticStyle:{"border-radius":"14px"}},[_c('v-card-title',{staticClass:"headerType"},[_vm._v("\n        "+_vm._s(_vm.$t('Settings.messageEditPhone.TitleDialogEdit'))+"\n        "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"closeIcon",attrs:{"flat":"","icon":"","color":"grey"},on:{"click":function($event){_vm.cancle()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('span',{staticClass:"headerContent"},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgPhoneRegistered')))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px"}},[_vm._v("\n        "+_vm._s(_vm.$t('Settings.messageEditPhone.MsgDetectPhone'))+" "+_vm._s(_vm.phoneedit)+" "+_vm._s(_vm.$t('Settings.messageEditPhone.MsgDetectPhonenext'))+"\n        ")]),_vm._v(" "),_c('v-radio-group',{staticClass:"pl-3",attrs:{"column":""},model:{value:(_vm.radios),callback:function ($$v) {_vm.radios=$$v},expression:"radios"}},[_c('v-radio',{attrs:{"value":"closeRecent"}},[_c('template',{slot:"label"},[_c('div',[_c('strong',{staticStyle:{"color":"black","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgCloseAccountSelect')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"grey","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgCloseAccountSpan'))+" "+_vm._s(_vm.phone)+" ")])])])],2),_vm._v(" "),_c('v-radio',{attrs:{"value":"keepAccount"}},[_c('template',{slot:"label"},[_c('div',[_c('strong',{staticStyle:{"color":"black","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgKeepAccountSelect')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"grey","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgKeepAccountSpan')))])])])],2)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-end":""}},[_c('v-btn',{attrs:{"color":"primary","disabled":_vm.disablebtnST1()},on:{"click":function($event){_vm.checkValue()}}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.continue'))+"\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"red"},on:{"click":function($event){_vm.cancle()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[(_vm.radios === 'closeRecent')?_c('v-card',{staticClass:"mb-2",attrs:{"flat":"","height":"200px"}},[_c('v-btn',{staticClass:"previcon",attrs:{"icon":"","flat":""},on:{"click":function($event){_vm.e1 = 1}}},[_c('v-icon',{staticStyle:{"font-size":"14px !important","cursor":"pointer"}},[_vm._v("fas fa-chevron-left")])],1),_vm._v(" "),_c('span',{staticClass:"headerContent pl-2"},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgCloseOnechatAccount')))]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('p',{staticStyle:{"font-size":"14px","padding-left":"30px"}},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgCloseOnechatAccountSpan')))])]),_vm._v(" "),_c('v-radio-group',{staticClass:"pl-3",attrs:{"column":""},model:{value:(_vm.radios2),callback:function ($$v) {_vm.radios2=$$v},expression:"radios2"}},[_c('v-radio',{attrs:{"value":"closeAccount"}},[_c('template',{slot:"label"},[_c('div',[_c('span',{staticStyle:{"color":"grey","font-size":"14px"}},[_vm._v("\n                "+_vm._s(_vm.$t('Settings.messageEditPhone.MsgCloseOnechatAccountSelect'))+"\n              ")])])])],2)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"justify-end":""}},[_c('v-btn',{attrs:{"color":"primary","disabled":_vm.disablebtnST2()},on:{"click":function($event){_vm.Terminate()}}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.continue'))+"\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"red"},on:{"click":function($event){_vm.cancle()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('span',{staticClass:"headerContent"},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgConfirmCloseAccount')))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgSendOTP'))+" "+_vm._s(this.phone))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px"}},[_vm._v("\n        refcode :\n          "),(_vm.progressTerminate === true)?_c('v-progress-circular',{attrs:{"indeterminate":_vm.progressTerminate,"color":"grey","size":"20"}}):_c('span',[_vm._v(_vm._s(_vm.refcode_terminate))])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"16px","padding-bottom":"0px"}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('OtpInput',{ref:"otpInputTerminate",attrs:{"input-classes":"otp-input","separator":"-","num-inputs":6,"should-auto-focus":true,"is-input-num":true},on:{"on-change":_vm.handleOnChange,"on-complete":_vm.handleOnCompleteTerminate}})],1),_vm._v(" "),_c('v-layout',{staticClass:"pt-3",attrs:{"row":""}},[(_vm.counting2 === true)?_c('span',[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgOTPNotrecieve')))]):_c('span',[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgOTPAgain')))]),_vm._v(" "),(_vm.counting2 === false)?_c('v-icon',{staticClass:"pl-2",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.newOtp2()}}},[_vm._v("mdi-refresh")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.counting2 === true)?_c('countdown',{attrs:{"time":300000,"transform":_vm.transform},on:{"end":_vm.handleCountdownEnd2,"progress":_vm.handleCountdownProgress},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(" "+_vm._s(_vm.$t('Settings.messageEditPhone.MsgResendOTP'))+" "+_vm._s(props.minutes)+":"+_vm._s(props.seconds)+" ")]}}])}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"pt-2 pb-2 pl-2 pr-2",attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"color":"primary","disabled":_vm.disableBtn(),"loading":_vm.loadingOtpTerminate},on:{"click":function($event){_vm.sendOTPterminate()}}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.continue'))+"\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"red"},on:{"click":function($event){_vm.cancle()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('span',{staticClass:"headerContent"},[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgVerifyPhone')))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","margin-bottom":"0px"}},[_vm._v("\n        "+_vm._s(_vm.$t('Settings.messageEditPhone.MsgSendOTP'))+"  "+_vm._s(this.phoneedit)+"\n      ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px"}},[_vm._v("\n        refcode :\n        "),(_vm.progress === true)?_c('v-progress-circular',{attrs:{"indeterminate":_vm.progress,"color":"grey","size":"20"}}):_c('span',[_vm._v(_vm._s(_vm.refcode_terminate))])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"16px","padding-bottom":"0px"}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('OtpInput',{ref:"otpInput",attrs:{"input-classes":"otp-input","separator":"-","num-inputs":6,"should-auto-focus":true,"is-input-num":true},on:{"on-change":_vm.handleOnChange,"on-complete":_vm.handleOnComplete}})],1),_vm._v(" "),_c('v-layout',{staticClass:"pt-3",attrs:{"row":""}},[(_vm.counting === true)?_c('span',[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgOTPNotrecieve')))]):_c('span',[_vm._v(_vm._s(_vm.$t('Settings.messageEditPhone.MsgOTPAgain'))+" ")]),_vm._v(" "),(_vm.counting === false)?_c('v-icon',{staticClass:"pl-2",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.newOtp()}}},[_vm._v("mdi-refresh")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.counting === true)?_c('countdown',{attrs:{"time":300000,"transform":_vm.transform},on:{"end":_vm.handleCountdownEnd,"progress":_vm.handleCountdownProgress},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(" "+_vm._s(_vm.$t('Settings.messageEditPhone.MsgResendOTP'))+" "+_vm._s(props.minutes)+":"+_vm._s(props.seconds)+" ")]}}])}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"pt-2 pb-2 pl-2 pr-2",attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"color":"primary","loading":_vm.loadingOtpNewno,"disabled":_vm.disableBtn()},on:{"click":function($event){_vm.sendOTP()}}},[_vm._v("\n          "+_vm._s(_vm.$t('AnswerQuestion.continue'))+"\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"red"},on:{"click":function($event){_vm.cancle()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var settings_Dialogeditphone = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/settings/Dialogeditphone.vue
function injectStyle (ssrContext) {
  __webpack_require__("oyy4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c07cf5f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Dialogeditphone,
  settings_Dialogeditphone,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_settings_Dialogeditphone = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dXC7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eGFP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eMjO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eOAw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_chat/ReadmoreDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ReadmoreDialog = ({
  props: {
    dialogReadmore: Boolean,
    detailReadmore: {}
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeReadmoreDialog', false);
    },
    convert: function convert(msg) {
      var linkifyStr = __webpack_require__("nN35");
      var str = msg;
      var processedContent = linkifyStr(str);
      var regex = /\s|<tax>+[\u0E00-\u0E7Fa-zA-Z'|/^\S+@\S+\.\S+$/]+<\/tax>/g;
      // var word = msg.match(regex)
      // console.log(word)
      if (msg.match(regex)) {
        for (var i = 0; i < msg.match(regex).length; i++) {
          // var word = msg.match(regex)
          // @click.native.capture=method
          processedContent = processedContent.replace('&lt;tax&gt;', '<b style="color:#1976d2; cursor:pointer;" >@');
          processedContent = processedContent.replace('&lt;/tax&gt;', '</b>');
        }
      }
      return processedContent;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a62d5a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_chat/ReadmoreDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"border-radius":"20px"},attrs:{"persistent":"","scrollable":"","max-width":"500px"},model:{value:(_vm.dialogReadmore),callback:function ($$v) {_vm.dialogReadmore=$$v},expression:"dialogReadmore"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('h2',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('ChatSide.Read.readmore')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"300px","overflow-y":"scroll"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.convert(_vm.detailReadmore.detail).replace(/(?:\r\n|\r|\n)/g, '<br>'))}})]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.closeDialog()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var manage_chat_ReadmoreDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_chat/ReadmoreDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("/K38")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a62d5a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ReadmoreDialog,
  manage_chat_ReadmoreDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_manage_chat_ReadmoreDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eQDG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f3Oo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// EXTERNAL MODULE: ./node_modules/vue2-google-maps/dist/main.js
var main = __webpack_require__("sA6N");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/MapDialogMobile.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import {gmapApi} from 'vue2-google-maps'


/* harmony default export */ var MapDialogMobile = ({
  props: { dialogSendMap: false },
  data: function data() {
    return {
      map: '',
      x: 15,
      y: 30,
      lat: '',
      lng: '',
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      places: [],
      currentPlace: null,
      address: ''
    };
  },
  created: function created() {
    // this.tokenuser = this.$cookie.get('tokenuser')
    // this.typeuser = localStorage.getItem('type_user')
    // this.axios.get('https://maps.googleapis.com/maps/api/place/details/json?key=AIzaSyA0hGnGEcqu2w2eN5XtNUJsNF2Ylv1Vl2g&placeid=ChIJ4ZnvKX274jARFsZN_d404sI').then((response) => {
    //   alert(response.data)
    // })
  },

  components: {
    google: main_default.a
  },
  mounted: function mounted() {
    this.geolocate();
    // this.this.geolocate()()
  },

  watch: {},
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  methods: {
    closeDialogs: function closeDialogs() {
      // console.log('closeDialog')
      this.lat = '';
      this.lng = '';
      this.address = '';
      this.$emit('closeSendMap', false);
    },
    SendMap: function SendMap() {
      // console.log(this.lat, this.lng, this.address)
      this.$emit('send_location', this.lat, this.lng, this.address);
      this.closeDialogs();
    },
    setPlaceandAdd: function setPlaceandAdd(place) {
      this.currentPlace = place;
      this.addMarkerplace(this.currentPlace);
    },
    setPlace: function setPlace(place) {
      // console.log(place)
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker: function addMarker() {
      // console.log(this.currentPlace)
      if (this.currentPlace) {
        var marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.lat = this.currentPlace.geometry.location.lat();
        this.lng = this.currentPlace.geometry.location.lng();
        this.address = this.currentPlace.name + ' ' + this.currentPlace.formatted_address;
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
        // console.log(this.address)
      }
    },
    addMarkerplace: function addMarkerplace(place) {
      // console.log(place)
      if (place) {
        var marker = {
          lat: place.latLng.lat(),
          lng: place.latLng.lng()
        };
        this.lat = place.latLng.lat();
        this.lng = place.latLng.lng();
        this.markers.push({ position: marker });
        this.places.push(place);
        this.center = marker;
        this.currentPlace = null;
      }
      // let self = this
      // var geocoder = new google.maps.Geocoder()
      // console.log(place.placeId)
      // geocoder.geocode({'placeId': 'ChIJyXhX4TYayUwRpj5vNT88SSU'}, function (results, status) {
      //   console.log(results, status)
      //   if (status === 'OK') {
      //     if (results[0]) {
      //       self.address = results[0].formatted_address
      //     }
      //   }
      // })
    },
    geolocate: function geolocate() {
      var _this = this;

      // console.log('geolocate')
      navigator.geolocation.getCurrentPosition(function (position) {
        var marker = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        _this.lat = position.coords.latitude;
        _this.lng = position.coords.longitude;
        // let self = this
        // var geocoder = new google.maps.Geocoder()
        // var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
        // console.log(latlng)
        // geocoder.geocode({'latLng': latlng}, function (results, status) {
        //   if (status === 'OK') {
        //     if (results[0]) {
        //       self.address = results[0].formatted_address
        //     }
        //   }
        // })
        _this.markers.push({ position: marker });
        // console.log(this.address)
        _this.center = marker;
        _this.currentPlace = null;
      });
    }
    // displayLocationInfo (position) {
    //   console.log(position)
    // }
    // init () {
    //   this.map = new longdo.Map({
    //     placeholder: document.getElementById('map'),
    //     lastView: false
    //   })
    //   this.map.Ui.Keyboard.enable(true)
    //   var control3 = new longdo.TagPanel()
    //   this.map.Ui.add(control3)
    //   this.map.Ui.Crosshair.visible(false)
    //   this.map.Ui.LayerSelector.visible(false)
    // },
    // pin () {
    //   this.sendmap.Overlays.clear()
    //   var loc = this.sendmap.location(longdo.LocationMode.Pointer)
    //   // console.log(loc)
    //   this.showloc = loc
    //   var marker = new longdo.Marker(loc, {
    //     icon: {
    //       url: '/static/img/icons/pin.png',
    //       // html: '<em>icon</em>',
    //       offset: { x: this.x, y: this.y }
    //     },
    //     clickable: true,
    //     weight: longdo.OverlayWeight.Top
    //   })
    //   this.sendmap.Overlays.add(marker)
    // }

  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77e17c0b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/MapDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"500px","persistent":"","fullscreen":""},model:{value:(_vm.dialogSendMap),callback:function ($$v) {_vm.dialogSendMap=$$v},expression:"dialogSendMap"}},[_c('v-card',[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("location_on")]),_vm._v("   "+_vm._s(_vm.$t('Dialog.map.header'))+"\n        ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialogs}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticStyle:{"background":"white","padding-top":"2vh"}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('label',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","sm8":"","md8":""}},[_c('gmap-autocomplete',{staticClass:"inputmap",attrs:{"placeholder":_vm.$t('Dialog.map.placeholder')},on:{"place_changed":_vm.setPlace}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"2px","padding-left":"20px"},attrs:{"xs4":"","sm4":"","md4":""}},[_c('button',{staticClass:"btnmap text-transform",on:{"click":_vm.SendMap}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.send')))])])],1)],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('gmap-map',{staticStyle:{"width":"100%","height":"400px"},attrs:{"center":_vm.center,"zoom":15},on:{"click":_vm.setPlaceandAdd}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":_vm.center,"clickable":true,"draggable":true}})}))],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_MapDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/MapDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("DyZE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77e17c0b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MapDialogMobile,
  dialog_MapDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_MapDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f723":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fHqe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fIB/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/components/chat/dialog/ShowImage_ProfileDialog.vue + 2 modules
var ShowImage_ProfileDialog = __webpack_require__("sVBg");

// EXTERNAL MODULE: ./src/components/chat/dialog/saveonebox/SaveoneboxDialog.vue + 2 modules
var SaveoneboxDialog = __webpack_require__("rTZ8");

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/ShowImageDialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var ShowImageDialog = ({
  props: { dialogshowimage: false, DetailImage: {} },
  data: function data() {
    return {
      token: '',
      dialogshowimage_profile: false,
      pathpicture: '',
      typepathpicture: '',
      dialogSaveOnebox: false,
      tokenmessage_savebox: ''
    };
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {},

  // item.message, item.file_name, item.nickname, item.path_pic, dateMoment(item.timestamp),timeMoment(item.timestamp), item.tokenmessage, item.type)
  methods: {
    openPictureProfile: function openPictureProfile(picture, type) {
      this.pathpicture = picture;
      this.typepathpicture = type;
      this.dialogshowimage_profile = true;
    },
    closeDialogShowImage_Profile: function closeDialogShowImage_Profile(value) {
      this.dialogshowimage_profile = value;
    },
    loadpic: function loadpic(filenameSend) {
      this.axios.get(this.DetailImage.path, {
        responseType: 'blob'
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filenameSend);
        document.body.appendChild(link);
        link.click();
      });
    },
    sendonebox: function sendonebox(tokenmessage) {
      this.dialogSaveOnebox = true;
      this.tokenmessage_savebox = tokenmessage;
    },
    closeSaveOnebox: function closeSaveOnebox(value) {
      this.dialogSaveOnebox = value;
    },
    closeDialogShowImage: function closeDialogShowImage() {
      this.$emit('closeDialogShowImage', false);
    },
    date: function date(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    time: function time(timestamp) {
      return services["c" /* Momenttime */].momenttimethai(timestamp);
    }
    // this.dateSend = Momenttime.momentdatethai(timestamp)
    //   // this.timeSend = Momenttime.momenttimethai(timestamp)

  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },

  components: {
    ShowImageProfileDialog: ShowImage_ProfileDialog["a" /* default */],
    SaveOnebox: SaveoneboxDialog["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ccad9b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/ShowImageDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogshowimage),callback:function ($$v) {_vm.dialogshowimage=$$v},expression:"dialogshowimage"}},[_c('v-card',{staticStyle:{"background-color":"rgba(0, 0, 0, 0.9)"}},[_c('v-toolbar',{staticStyle:{"background-color":"#1b232d"},attrs:{"dark":""}},[_c('v-flex',{staticStyle:{"text-align":"right","padding-right":"2vw"},attrs:{"xl1":"","lg1":"","md1":"","sm1":""}},[_c('v-avatar',{staticClass:"user-photo",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.openPictureProfile(_vm.DetailImage.pic_pro, _vm.DetailImage.typeuser)}}},[(_vm.DetailImage.pic_pro)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":_vm.DetailImage.pic_pro}}):(_vm.DetailImage.typeuser === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.DetailImage.typeuser === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xl6":"","lg6":"","md6":"","sm6":""}},[_c('b',{staticStyle:{"font-size":"14px"}},[_vm._v(" "+_vm._s(_vm.DetailImage.file_name)+" ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px","margin-bottom":"0px"}},[_vm._v(" "+_vm._s(_vm.$t('Dialog.showImage.by'))+" "+_vm._s(_vm.DetailImage.file_owner)+"   |  "+_vm._s(_vm.date(_vm.DetailImage.timestamp))+"\n              "),_c('v-icon',{staticStyle:{"font-size":"7px !important","color":"white !important"}},[_vm._v("schedule")]),_vm._v(_vm._s(_vm.time(_vm.DetailImage.timestamp))+"\n            ")],1)]),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"right"},attrs:{"xl4":"","lg4":"","md4":"","sm4":""}},[_c('v-btn',{staticClass:"btnallow CSChatThai",attrs:{"depressed":"","small":"","id":"btn-download"},on:{"click":function($event){_vm.loadpic(_vm.DetailImage.file_name)}}},[_c('v-icon',[_vm._v("file_download")]),_vm._v("  "+_vm._s(_vm.$t('AnswerQuestion.download'))+"\n            ")],1),_vm._v(" "),_c('v-btn',{staticClass:"btncancel CSChatThai",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.sendonebox(_vm.DetailImage.tokenmessage)}}},[_c('v-icon',[_vm._v("cloud_upload")]),_vm._v("   "+_vm._s(_vm.$t('AnswerQuestion.sendOnebox'))+"\n            ")],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"right"},attrs:{"xl1":"","lg1":"","md1":"","sm1":""}},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialogShowImage}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"background":"none"}},[_c('img',{staticClass:"modal-contentc",attrs:{"src":_vm.DetailImage.path}})])],1),_vm._v(" "),_c('ShowImageProfileDialog',{attrs:{"dialogshowimage_profile":_vm.dialogshowimage_profile,"pathpicture":_vm.pathpicture,"typepathpicture":_vm.typepathpicture},on:{"closeDialogShowImage_Profile":_vm.closeDialogShowImage_Profile}}),_vm._v(" "),_c('SaveOnebox',{attrs:{"dialogSaveOnebox":_vm.dialogSaveOnebox,"tokenmessage_savebox":_vm.tokenmessage_savebox},on:{"closeSaveOnebox":_vm.closeSaveOnebox}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_ShowImageDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/ShowImageDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("xJeT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30ccad9b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ShowImageDialog,
  dialog_ShowImageDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var chat_dialog_ShowImageDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fM4f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fWUN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fnKg":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),

/***/ "gDCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/components/chat/dialog/ShowImage_ProfileDialog.vue + 2 modules
var ShowImage_ProfileDialog = __webpack_require__("sVBg");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/settings/Openwebsite.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Openwebsite = ({
  props: { 'dialogopenwebsite': false, id: '', type: '' },
  data: function data() {
    return {
      token: '',
      result: {},
      relation: '',
      pictureFriend: '',
      pictureGroup: '',
      status: 'loading',
      dialogshowimage_profile: false,
      pathpicture: '',
      typepathpicture: ''
    };
  },
  components: {
    ShowImageProfileDialog: ShowImage_ProfileDialog["a" /* default */]
  },
  watch: {
    dialogopenwebsite: function dialogopenwebsite() {
      var _this = this;

      // console.log(this.dialogopenwebsite)
      if (this.dialogopenwebsite) {
        if (this.type == 'friend') {
          this.status = 'loading';
          this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', {
            tokenuser: this.token,
            tokenfriend: this.id
          }).then(function (response) {
            // console.log(response.data)
            _this.status = response.data.status;
            if (response.data.status === 'success') {
              _this.relation = response.data.relation;
              _this.result = response.data.user;
              if (_this.result.profilepicture === '') {
                if (_this.result.type === 'business') {
                  _this.pictureFriend = '/static/img/default_profile/business-white.png';
                } else if (_this.result.type === 'bot') {
                  _this.pictureFriend = '/static/img/default_profile/bot-white.png';
                } else {
                  _this.pictureFriend = '/static/img/default_profile/man-white.png';
                }
              } else {
                _this.pictureFriend = _this.result.profilepicture;
              }
            }
          });
        } else if (this.type == 'group') {
          this.status = 'loading';
          this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', {
            tokenuser: this.token,
            group_id: this.id
          }).then(function (response) {
            // console.log(response.data)
            _this.status = response.data.status;
            if (response.data.status === 'success') {
              _this.result = response.data.group;
              if (_this.result.picture === '') {
                _this.pictureGroup = '/static/img/default_profile/group-white.png';
              } else {
                _this.pictureGroup = _this.result.picture;
              }
            }
          });
        }
      }
    }
  },
  methods: {
    openPictureProfile: function openPictureProfile() {
      this.pathpicture = this.result.profilepicture;
      this.typepathpicture = this.result.type;
      this.dialogshowimage_profile = true;
    },
    openPictureGroup: function openPictureGroup() {
      this.pathpicture = this.result.picture;
      this.typepathpicture = 'group';
      this.dialogshowimage_profile = true;
    },
    closeDialogShowImage_Profile: function closeDialogShowImage_Profile(value) {
      this.dialogshowimage_profile = value;
    },
    AcceptGroup: function AcceptGroup(group_id) {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/joingroup', {
        group_id: group_id,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response)
        _this2.socketactive_group = { timestamp: '', groupid: group_id, tokenuser: _this2.token };
        _this2.closeDialog();
      });
    },
    chat: function chat(tokenroom) {
      this.$router.push('/chat/room/' + tokenroom);
      this.closeDialog();
    },
    AcceptReq: function AcceptReq(tokenFriend) {
      var _this3 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/acceptfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data.tokenroom)
        if (response.data['status'] === 'success') {
          _this3.relation = 'friend';
          _this3.result['tokenroom'] = response.data.tokenroom;
          // this.closeDialog()
        }
      });
    },
    RemoveReq: function RemoveReq(tokenFriend) {
      var _this4 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          _this4.relation = 'unknown';
          // this.closeDialog()
        }
      });
    },
    AddFriend: function AddFriend(tokenFriend) {
      var _this5 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this5.relation = 'sendrequest';
          _this5.$store.dispatch('sendRequest', tokenFriend);
          // this.closeDialog()
        } else {
          alert('Error!!!');
        }
      });
    },
    AddFriendCollab: function AddFriendCollab(item) {
      var _this6 = this;

      // console.log(item)
      // console.log(index)
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/add-friend-accept', { tokenfriend: item.tokenuser, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          // this.loading = false
          // if (state === 'true') {
          //   this.chat(response.data.tokenroom)
          // } else {
          //   this.relation = 'friend'
          // }
          _this6.relation = 'friend';
          _this6.result.tokenroom = response.data.tokenroom;
        } else {
          // this.loading = false
          _this6.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning');
        }
      }).catch(function (error) {
        console.log(error);
        // this.loading = false
        _this6.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning');
      });
    },
    unblock: function unblock(tokenFriend, tokenroom) {
      var _this7 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token,
        tokenroom: tokenroom
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this7.$swal('Unblocked!', _this7.$t('Alert.Success.unblock'), 'success');
          _this7.relation = 'friend';
          _this7.result['state'] = 'friend';
          _this7.result['event'] = 'unblock_friend';
          _this7.block_friend = _this7.result;
        }
      });
    },
    findWithAttr: function findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
    closeDialog: function closeDialog() {
      this.status = 'loading';
      this.result = {};
      this.relation = '';
      this.pictureFriend = '';
      this.pictureGroup = '';
      this.$emit('closeDialog', false);
    }
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    // console.log(this.tokenuserQR)
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-311daeb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/settings/Openwebsite.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialogopenwebsite),callback:function ($$v) {_vm.dialogopenwebsite=$$v},expression:"dialogopenwebsite"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[(_vm.type=='friend' && _vm.status=='success')?_c('div',[_c('img',{staticClass:"pictureProfile",attrs:{"src":_vm.pictureFriend},on:{"click":function($event){_vm.openPictureProfile()}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"}},[_c('h3',[_vm._v(_vm._s(_vm.result.name))]),_vm._v("\n               "+_vm._s(_vm.result.status)+"\n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.relation=='friend')?_c('v-btn',{staticClass:"chatbtn",on:{"click":function($event){_vm.chat(_vm.result.tokenroom)}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.chat'))+"\n              ")]):(_vm.relation=='request')?_c('v-btn',{staticClass:"chatbtn",on:{"click":function($event){_vm.AcceptReq(_vm.result.tokenuser)}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.acceptFriend'))+"\n              ")]):(_vm.relation=='sendrequest')?_c('v-btn',{staticClass:"canclebtn",on:{"click":function($event){_vm.RemoveReq(_vm.result.tokenuser)}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.cancelRequest'))+"\n              ")]):(_vm.relation=='self')?_c('v-btn',{staticClass:"chatbtn",on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n              ")]):(_vm.relation=='unknown' || _vm.relation=='unfriend')?_c('v-btn',{staticClass:"chatbtn",on:{"click":function($event){_vm.AddFriendCollab(_vm.result)}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.addFriend'))+"\n              ")]):(_vm.relation=='block')?_c('v-btn',{staticClass:"canclebtn",on:{"click":function($event){_vm.unblock(_vm.result.tokenuser, _vm.result.tokenroom)}}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.unblock'))+"\n              ")]):_vm._e()],1):(_vm.type=='group' && _vm.status=='success')?_c('div',[_c('img',{staticClass:"pictureProfile",attrs:{"src":_vm.pictureGroup},on:{"click":function($event){_vm.openPictureGroup()}}}),_vm._v(" "),_c('div',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"}},[_c('h3',[_vm._v(_vm._s(_vm.result.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.result.state != 'active')?_c('v-btn',{staticClass:"chatbtn",on:{"click":function($event){_vm.AcceptGroup(_vm.result.group_id)}}},[_vm._v("\n              "+_vm._s(_vm.$t('AnswerQuestion.joinGroup'))+"\n            ")]):_c('v-btn',{staticClass:"chatbtn",on:{"click":function($event){_vm.chat(_vm.result.tokenroom)}}},[_vm._v("\n              "+_vm._s(_vm.$t('AnswerQuestion.chat'))+"\n            ")])],1):(_vm.status=='loading')?_c('div',[_c('v-progress-linear',{attrs:{"color":"light-blue darken-4","indeterminate":"","height":"6"}})],1):_c('div',{staticClass:"CSChatThai",staticStyle:{"text-align":"center"}},[_c('h3',[_vm._v("ไม่พบข้อมูล")])])])],1)],1)],1)],1),_vm._v(" "),_c('ShowImageProfileDialog',{attrs:{"dialogshowimage_profile":_vm.dialogshowimage_profile,"pathpicture":_vm.pathpicture,"typepathpicture":_vm.typepathpicture},on:{"closeDialogShowImage_Profile":_vm.closeDialogShowImage_Profile}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var settings_Openwebsite = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/settings/Openwebsite.vue
function injectStyle (ssrContext) {
  __webpack_require__("LNgp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-311daeb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Openwebsite,
  settings_Openwebsite,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_settings_Openwebsite = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gOkJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chat_dialog_settings_Editpictureprofile__ = __webpack_require__("IuMq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chat_dialog_settings_Dialogeditphone__ = __webpack_require__("dJ4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_pathify__ = __webpack_require__("YtWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_qrcode__ = __webpack_require__("8Vd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services__ = __webpack_require__("+vOg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_qrcode__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_qrcode__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      dialogeditphone: false,
      phoneedit: '',
      loadingphone: false,
      loadingname: false,
      loadingstatus: false,
      phone: '',
      email: '',
      token: '',
      name: '',
      status: '',
      profilepicture: '',
      nameedit: '',
      statusedit: '',
      editname: false,
      editstatus: false,
      typeuser: '',
      alerterror: '',
      tokenuserQR: '',
      dialogEditpictureprofile: false,
      username: '',
      usernameedit: '',
      editusername: false,
      password: '',
      confirmpassword: '',
      username_alerterror: '',
      password_alerterror: '',
      confirm_alerterror: '',
      usernameRules: [function (v) {
        return !!v || '' || _this.$t('Settings.messageError.UsernameRules1');
      }, function (v) {
        return !v && v.length < 6 || /^[^\W_]+$/.test(v) || _this.$t('Settings.messageError.UsernameRules2');
      }, function (v) {
        return !!v && v.length >= 6 || _this.$t('Settings.messageError.UsernameRules3');
      }, function (v) {
        return (/^([^A-Z])+$/.test(v) || _this.$t('Settings.messageError.UsernameRules4')
        );
      }, function (v) {
        return (/^([a-z])+$/.test(v) || /^((?=.*[a-z])(?=.*[0-9]).{6,})+$/.test(v) || _this.$t('Settings.messageError.UsernameRules5')
        );
      }, function (v) {
        return _this.checkUsernameDuplicate() || '';
      }],
      chkUsernameDuplicate: false,
      msgUsernameDuplicate: [],
      e1: false,
      e2: false,
      repasswordRules: [function (v) {
        return !!v || _this.$t('Settings.messageError.RePasswordRules1');
      }, function (v) {
        return v === _this.password || _this.$t('Settings.messageError.RePasswordRules2');
      }],
      passwordRules: [function (v) {
        return !!v || _this.$t('Settings.messageError.PasswordRules1');
      }, function (v) {
        return (/^((?=.*[a-zA-Z])(?=.*[0-9]).{8,})+$/.test(v) || _this.$t('Settings.messageError.RePasswordRules2')
        );
      }],
      status_username: '',
      editphone: false,
      editphone_success: '',
      loadingUpdatePhone: false
    };
  },

  methods: {
    updateusername: function updateusername() {
      var _this2 = this;

      var body = {
        'tokenuser': this.token,
        'username': this.username,
        'password': this.password
        // console.log(process.env.APImanage + '/set_username', body)
      };this.loadingname = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/set_username', body).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this2.loadingname = false;
          _this2.$swal('', _this2.$t('Alert.Success.settingusername'), 'success');
          localStorage.setItem('status_username', 'true');
          _this2.status_username = 'true';
        } else {
          _this2.loadingname = false;
          _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
          localStorage.setItem('status_username', 'false');
          _this2.status_username = 'false';
          _this2.cancelusername();
        }
      }).catch(function (error) {
        console.log(error);
        _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
      });
    },
    checkData: function checkData() {
      return this.username === '' || this.password === '' || this.confirmpassword === '';
    },
    changeUsername: function changeUsername() {
      if (this.chkChangeUsername) {
        this.chkChangeUsername = false;
        this.msgUsernameDuplicate = [];
        this.chkUsernameDuplicate = false;
      }
    },
    checkUsernameDuplicate: function checkUsernameDuplicate() {
      var _this3 = this;

      // console.log(this.username)
      if (this.username !== '') {
        this.axios.get("https://testoneid.inet.co.th/api" + '/check_username?username=' + this.username).then(function (response) {
          // console.log(response.data)
          if (response.status === 200) {
            if (response.data.message === 'Success') {
              _this3.chkUsernameDuplicate = false;
              _this3.msgUsernameDuplicate = [];
            }
          }
        }, function (error) {
          if (error.response.status === 400) {
            if (error.response.data.errorMessage === 'username duplicate') {
              _this3.chkUsernameDuplicate = true;
              _this3.msgUsernameDuplicate = [_this3.$t('Settings.messageError.UsernameDuplicate')];
              _this3.valid = false;
            } else if (_this3.username === '') {
              _this3.msgUsernameDuplicate = [_this3.$t('Settings.messageError.UsernameRules1')];
            }
          }
        });
        return true;
      }
    },
    isNumandaz: function isNumandaz($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122)) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    isnotthai: function isnotthai($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode >= 3585 && keyCode <= 3642 || keyCode >= 3647 && keyCode <= 3675) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    Editpictureprofile: function Editpictureprofile() {
      this.dialogEditpictureprofile = true;
    },
    closeEditpictureprofile: function closeEditpictureprofile(value) {
      this.dialogEditpictureprofile = value;
    },
    uppictest: function uppictest() {
      $('#uploadpicprofilechat').click();
    },
    uppic: function uppic() {
      $('#uploadpicprofilechat').click();
    },
    cancelstatus: function cancelstatus() {
      this.editstatus = !this.editstatus;
      this.statusedit = this.status;
    },
    cancelname: function cancelname() {
      this.editname = !this.editname;
      this.nameedit = this.name;
    },
    cancelusername: function cancelusername() {
      this.editusername = !this.editusername;
      // this.usernameedit = this.username
      this.username = '';
      this.password = '';
      this.confirmpassword = '';
    },
    updatename: function updatename() {
      var _this4 = this;

      this.editname = !this.editname;
      if (this.nameedit !== '') {
        if (this.nameedit !== this.name) {
          this.loadingname = true;
          this.axios.post("https://uatchat-manage.one.th/manage" + '/setnameuser', { tokenuser: this.token, name: this.nameedit }).then(function (response) {
            if (response.data.status === 'success') {
              _this4.name = _this4.nameedit;
              localStorage.setItem('name', _this4.nameedit);
              _this4.myname = _this4.nameedit;
              _this4.loadingname = false;
            } else {
              _this4.loadingname = false;
              _this4.nameedit = _this4.name;
              // console.log(response.data)
              _this4.$swal('', _this4.$t('Alert.Fail.default.somethingWrong'), 'error');
            }
          }, function () {
            _this4.loadingname = false;
            _this4.nameedit = _this4.name;
            _this4.$swal('', _this4.$t('Alert.Fail.default.somethingWrong'), 'error');
          });
        }
      } else {
        this.nameedit = '';
        this.alerterror = this.$t('Alert.Fail.nameuser');
        this.editname = !this.editname;
        this.loadingname = false;
      }
    },
    updatestatus: function updatestatus() {
      var _this5 = this;

      this.editstatus = !this.editstatus;
      if (this.statusedit !== this.status) {
        this.loadingstatus = true;
        this.axios.post("https://uatchat-manage.one.th/manage" + '/setstatususer', { tokenuser: this.token, status: this.statusedit }).then(function (response) {
          if (response.data.status === 'success') {
            localStorage.setItem('status', _this5.statusedit);
            _this5.status = _this5.statusedit;
            _this5.loadingstatus = false;
          } else {
            _this5.loadingstatus = false;
            _this5.statusedit = _this5.status;
            // console.log(response.data)
            _this5.$swal('', _this5.$t('Alert.Fail.default.somethingWrong'), 'error');
          }
        }, function () {
          _this5.loadingstatus = false;
          _this5.statusedit = _this5.status;
          _this5.$swal('', _this5.$t('Alert.Fail.default.somethingWrong'), 'error');
        });
      }
      // }
    },
    previewImageprofiles: function previewImageprofiles(data) {
      var _this6 = this;

      this.selectFile = data.target.files[0];
      var uploadFile = new FormData();
      uploadFile.append('file', this.selectFile, this.selectFile.name);
      uploadFile.append('tokenuser', this.token);
      uploadFile.append('type_user', this.typeuser);
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/set-picture-profile', uploadFile).then(function (response) {
        if (response.data.status === 'success') {
          _this6.profilepicture = response.data.filename;
          localStorage.setItem('profilepicture', _this6.profilepicture);
          _this6.myprofilepicture = _this6.profilepicture;
        }
      });
    },
    loadqr: function loadqr() {
      var cnvs = document.getElementById('downloadqr-web');
      var button = document.getElementById('btn-download-web');
      var dataURL = cnvs.toDataURL('image/png');
      button.href = dataURL;
    },
    updatephone: function updatephone() {
      var _this7 = this;

      this.loadingUpdatePhone = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/check_phone_login', {
        phone: this.phoneedit
      }).then(function (response) {
        // console.log(response)
        if (response.data.status === 'success') {
          // this.loadingUpdatePhone = false
          if (response.data.message === 'non registered') {
            // localStorage.typeAccount = true
          } else if (response.data.message === 'registered') {}
          // localStorage.typeAccount = false

          // this.editphone = !this.editphone
          _this7.ShowdialogEditPhonenum();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    cancelphone: function cancelphone() {
      this.editphone = !this.editphone;
      this.phoneedit = this.phone;
    },
    closeDialogEditPhone: function closeDialogEditPhone(value) {
      this.dialogeditphone = value;
      // this.loadingUpdatePhone = false
      // this.phone = localStorage.phone
      // this.phoneedit = localStorage.phoneedit
      // this.phoneedit = this.phone
    },
    newphonnum: function newphonnum(value) {
      this.phone = value;
    },
    ShowdialogEditPhonenum: function ShowdialogEditPhonenum() {
      this.dialogeditphone = true;
    },
    statusEditphone: function statusEditphone() {
      var _this8 = this;

      this.$swal({
        title: this.$t('Settings.messageEditPhone.ChangePhoneNumber'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value === true) {
          _this8.editphone = !_this8.editphone;
        } else {}
      });
    },
    disableupdatephone: function disableupdatephone() {
      if (this.phoneedit == '' || this.phoneedit == this.phone) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex_pathify__["c" /* sync */])('*')),
  watch: {
    myprofilepicture: function myprofilepicture() {
      this.profilepicture = localStorage.getItem('profilepicture');
    },
    myname: function myname() {
      this.name = localStorage.getItem('name');
    },
    mystatus: function mystatus() {
      this.status = localStorage.getItem('status');
    },
    dialogeditphone: function dialogeditphone() {
      this.phone = localStorage.phone;
      if (this.dialogeditphone === false) {
        this.editphone_success = localStorage.editphone_success;
        if (this.editphone_success === 'false') {
          this.loadingUpdatePhone = false;
          this.editphone = !this.editphone;
          this.phoneedit = this.phone;
        } else if (this.editphone_success === 'true') {
          this.phone = this.phoneedit;
          this.loadingUpdatePhone = false;
          this.editphone = !this.editphone;
        }
      }
    }
  },
  components: {
    Editpictureprofile: __WEBPACK_IMPORTED_MODULE_1__components_chat_dialog_settings_Editpictureprofile__["a" /* default */],
    Dialogeditphone: __WEBPACK_IMPORTED_MODULE_2__components_chat_dialog_settings_Dialogeditphone__["a" /* default */]
  },
  created: function created() {
    this.phone = localStorage.getItem('phone');
    this.email = localStorage.getItem('email');
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_6__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    // this.username = decoded_username['username']
    this.status_username = localStorage.getItem('status_username');
    // this.status_username = 'true'
    // console.log(this.status_username)
    // if (this.status_username === 'false') {
    //   this.username = ''
    // }
    // this.tokenuserQR = 'https://com.oneplatform.android.onechat/u/' + btoa(this.$cookie.get('tokenuser'))
    this.tokenuserQR = "https://uatchat.one.th" + '/qrcode/friend?id=' + btoa(this.token);
    this.name = localStorage.getItem('name');
    this.status = localStorage.getItem('status');
    this.profilepicture = localStorage.getItem('profilepicture');
    this.typeuser = localStorage.getItem('type_user');
    this.nameedit = this.name;
    this.phoneedit = this.phone;
    this.statusedit = this.status;
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "gRgH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gbCs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/InforfriendDialogMobile.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var InforfriendDialogMobile = ({
  props: {
    inforfrienddialog: false,
    tokeninforfriend: '',
    type: ''
  },
  data: function data() {
    return {
      textbtn: '',
      tokenuser: '',
      relation: '',
      inforfriend: {},
      btnicon: '',
      tokenroom: '',
      progress: false
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
  },

  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {
    // tokeninforfriend () {
    //   console.log(this.tokeninforfriend)
    //   this.searchfriend()
    // },
    inforfrienddialog: function inforfrienddialog() {
      // console.log(this.tokeninforfriend)
      this.searchfriend();
    },
    socketremove_request_friend: function socketremove_request_friend(data) {
      // console.log(data)
      this.relation = 'unknown';
      this.textbtn = this.$t('AnswerQuestion.addFriend');
      this.btnicon = 'fas fa-user-plus';
    },
    socketaccept_friend: function socketaccept_friend(data) {
      // console.log(data)
      this.relation = 'friend';
      this.textbtn = this.$t('AnswerQuestion.chat');
      this.btnicon = 'fas fa-comment-dots';
    },
    socketfriend: function socketfriend(data) {
      // console.log(data)
      if (data.konAdd != this.tokenuser) {
        this.relation = 'request';
        this.textbtn = this.$t('AnswerQuestion.acceptFriend');
        this.btnicon = 'how_to_reg';
      } else {
        this.relation = 'sendrequest';
        this.textbtn = this.$t('AnswerQuestion.cancelRequest');
        this.btnicon = 'person_add_disabled';
      }
    },
    socketremove_friend: function socketremove_friend(data) {
      // console.log(data)
      this.relation = 'unfriend';
      this.textbtn = this.$t('AnswerQuestion.addFriend');
      this.btnicon = 'fas fa-user-plus';
    },
    socketblock: function socketblock(data) {
      // console.log(data)
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      // this.relation = ''
      // this.inforfriend = {}
      this.$emit('closeInforfriend', false);
    },
    searchfriend: function searchfriend() {
      var _this = this;

      if (this.type != 'group') {
        this.progress = true;
        this.axios.post("https://uatchat-manage.one.th/manage" + '/searchtokenuser', { tokenuser: this.tokenuser, tokenfriend: this.tokeninforfriend }).then(function (response) {
          if (response.data.status == 'success') {
            // console.log(response.data)
            _this.progress = false;
            _this.relation = response.data.relation;
            _this.inforfriend = response.data.user;
            if (_this.relation == 'friend') {
              _this.textbtn = _this.$t('AnswerQuestion.chat');
              _this.btnicon = 'fas fa-comment-dots';
            } else if (_this.relation == 'request') {
              _this.textbtn = _this.$t('AnswerQuestion.acceptFriend');
              _this.btnicon = 'how_to_reg';
            } else if (_this.relation == 'sendrequest') {
              _this.textbtn = _this.$t('AnswerQuestion.cancelRequest');
              _this.btnicon = 'person_add_disabled';
            } else if (_this.relation == 'unknown') {
              _this.textbtn = _this.$t('AnswerQuestion.addFriend');
              _this.btnicon = 'fas fa-user-plus';
            } else if (_this.relation == 'self') {
              _this.textbtn = _this.$t('AnswerQuestion.ok');
              _this.btnicon = 'fas fa-user-circle';
            } else if (_this.relation == 'unfriend') {
              _this.textbtn = _this.$t('AnswerQuestion.addFriend');
              _this.btnicon = 'fas fa-user-plus';
            } else if (_this.relation == 'block') {
              _this.textbtn = _this.$t('AnswerQuestion.unblock');
              _this.btnicon = 'fas fa-unlock-alt';
            }
            // console.log(this.inforfriend)
            // console.log(this.relation)
          }
        });
      } else {
        this.progress = true;
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getgroup', {
          tokenuser: this.tokenuser,
          group_id: this.tokeninforfriend
        }).then(function (response) {
          // console.log(response.data)
          if (response.data.status === 'success') {
            _this.progress = false;
            _this.inforfriend = response.data.group;
            if (response.data.group.state == 'active') {
              _this.relation = 'active';
              _this.textbtn = _this.$t('AnswerQuestion.chat');
              _this.btnicon = 'fas fa-comment-dots';
            } else {
              _this.relation = 'leave';
              _this.textbtn = _this.$t('AnswerQuestion.joinGroup');
              _this.btnicon = 'fas fa-users';
            }
          }
        });
      }
    },
    actionclick: function actionclick(inforfriend) {
      var _this2 = this;

      // console.log(inforfriend)
      console.log(this.relation);
      if (this.relation == 'friend') {
        if (inforfriend.tokenroom != '') {
          // this.$emit('data', true)
          // this.$emit('chat', true)
          // this.$emit('profile', false)
          this.$router.push('/mobile/room/' + inforfriend.tokenroom);
        } else {
          // this.$emit('data', true)
          // this.$emit('chat', true)
          // this.$emit('profile', false)
          this.$router.push('/mobile/room/' + this.tokenroom);
        }
        this.closeDialog();
      } else if (this.relation == 'request') {
        this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/accept-friend", { tokenfriend: inforfriend.tokenuser, tokenuser: this.tokenuser }).then(function (response) {
          if (response.data['status'] === 'success') {
            // console.log(response.data)
            _this2.tokenroom = response.data.tokenroom;
            // this.relation = 'friend'
            // this.textbtn = 'แชท'
            // this.btnicon = 'fas fa-comment-dots'
            // this.closeDialog()
          }
        });
      } else if (this.relation == 'sendrequest') {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', { tokenfriend: inforfriend.tokenuser, tokenuser: this.tokenuser }).then(function (response) {
          if (response.data['status'] === 'success') {
            // console.log(response.data)
            _this2.relation = 'unknown';
            _this2.textbtn = _this2.$t('AnswerQuestion.addFriend');
            _this2.btnicon = 'fas fa-user-plus';
            // this.closeDialog()
          }
        });
      } else if (this.relation == 'unknown' || this.relation == 'unfriend') {
        // this.axios.post(process.env.APInew_addfriend, {tokenfriend: inforfriend.tokenuser, tokenuser: this.tokenuser}).then((response) => {
        //   if (response.data['status'] === 'success') {
        //     // console.log(response.data)
        //     // this.relation = 'sendrequest'
        //     // this.textbtn = 'ยกเลิกคำขอ'
        //     // this.btnicon = 'person_add_disabled'
        //     // this.closeDialog()
        //   }
        // })
        this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/add-friend-accept', { tokenfriend: inforfriend.tokenuser, tokenuser: this.tokenuser }).then(function (response) {
          if (response.data.status === 'success') {
            _this2.relation = 'friend';
            _this2.textbtn = _this2.$t('AnswerQuestion.chat');
            _this2.btnicon = 'fas fa-comment-dots';
            _this2.tokenroom = response.data.tokenroom;
          } else {
            // this.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning')
            _this2.$swal('Network error', _this2.$t('Alert.Fail.default.networkError'), 'error');
          }
        }).catch(function (error) {
          console.log(error);
          // this.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning')
          _this2.$swal('Network error', _this2.$t('Alert.Fail.default.networkError'), 'error');
        });
      } else if (this.relation == 'self') {
        this.textbtn = this.$t('AnswerQuestion.ok');
        this.btnicon = 'fas fa-user-circle';
        this.closeDialog();
      } else if (this.relation == 'block') {
        this.$swal({
          // text: 'คุณต้องการยกเลิกการบล็อก ' + inforfriend.name + ' ใช่หรือไม่?',
          text: this.$t('Alert.Unblocking', { name: inforfriend.name }),
          type: 'warning',
          imageHeight: 70,
          showCancelButton: true,
          confirmButtonColor: '#2562af',
          cancelButtonColor: '#9f9f9f',
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-success',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then(function (result) {
          if (result.value) {
            _this2.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', { tokenfriend: inforfriend.tokenuser, tokenuser: _this2.tokenuser, tokenroom: inforfriend.tokenroom }).then(function (response) {
              if (response.data['status'] === 'success') {
                // console.log(response.data)
                _this2.$swal('', _this2.$t('Alert.Success.unblock'), 'success');
                _this2.relation = 'friend';
                _this2.textbtn = _this2.$t('AnswerQuestion.chat');
                _this2.btnicon = 'fas fa-comment-dots';
              }
            });
          }
        });
      } else if (this.relation == 'active') {
        // console.log(this.relation)
        this.$router.push('/mobile/room/' + inforfriend.tokenroom);
      } else if (this.relation == 'leave') {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/joingroup', {
          group_id: inforfriend.group_id,
          tokenuser: this.tokenuser
        }).then(function (response) {
          // console.log(response)
          _this2.relation = 'active';
          _this2.textbtn = _this2.$t('AnswerQuestion.chat');
          _this2.btnicon = 'fas fa-comment-dots';
          _this2.socketactive_group = { timestamp: '', groupid: inforfriend.group_id, tokenuser: _this2.tokenuser
            // this.closeDialog()
          };
        });
      }
    },
    viewprofile: function viewprofile(inforfriend) {
      // console.log(inforfriend)
      // console.log(inforfriend.tokenuser)
      // localStorage.setItem('tokenfriend', Encode.encodeToken(inforfriend.tokenuser))
      if (inforfriend.type !== 'group') {
        localStorage.setItem('typefriend', inforfriend.type);
        this.$router.push('/mobile/profilefriend/' + inforfriend.tokenuser);
      } else {
        localStorage.setItem('typefriend', inforfriend.type);
        this.$router.push('/mobile/profilefriend/' + inforfriend.group_id);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22166224","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/InforfriendDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.inforfrienddialog),callback:function ($$v) {_vm.inforfrienddialog=$$v},expression:"inforfrienddialog"}},[(_vm.progress)?_c('v-card',[_c('v-layout',{staticStyle:{"height":"250px"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"size":50,"indeterminate":_vm.progress,"color":"primary"}})],1)],1):_c('v-card',[_c('v-card-title',{staticClass:"headline pa-0"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","flat":"","color":"grey darken-1"},on:{"click":_vm.closeDialog}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"justify-content":"center","display":"flex"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[(_vm.inforfriend.profilepicture)?_c('v-avatar',{attrs:{"size":"90px"}},[_c('img',{staticClass:"img-avatar img-border",attrs:{"src":_vm.inforfriend.profilepicture}})]):_c('v-avatar',{attrs:{"size":"90px"}},[(_vm.inforfriend.type == 'user')?_c('img',{staticClass:"img-avatar img-border",attrs:{"src":"/static/img/default_profile/man-white.png"}}):(_vm.inforfriend.type == 'business')?_c('img',{staticClass:"img-avatar img-border",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.inforfriend.type == 'group')?_c('img',{staticClass:"img-avatar img-border",attrs:{"src":"/static/img/default_profile/group-white.png"}}):_c('img',{staticClass:"img-avatar img-border",attrs:{"src":"/static/img/default_profile/bot-white.png"}})]),_vm._v(" "),_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}}),_vm._v(" "),_c('v-flex',{staticStyle:{"justify-content":"center","align-items":"center","display":"grid"},attrs:{"xs4":""}},[_c('h3',{staticClass:"mt-3 text-hidden"},[_vm._v(_vm._s(_vm.inforfriend.name))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}})],1),_vm._v(" "),(_vm.inforfriend.email)?_c('span',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.inforfriend.email))]):_c('span',{staticClass:"mt-2"},[_vm._v("-")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.relation != 'self')?_c('v-card-actions',{staticClass:"mt-2"},[_c('v-flex',{staticClass:"flex-center pr-2",attrs:{"xs6":"","sm6":""}},[_c('v-layout',{staticClass:"cursor-pointer",attrs:{"column":"","align-center":"","justify-center":""},on:{"click":function($event){_vm.actionclick(_vm.inforfriend)}}},[_c('v-icon',{staticClass:"mb-1 icon-action"},[_vm._v(_vm._s(_vm.btnicon))]),_vm._v(" "),_c('p',{staticClass:"mb-0",staticStyle:{"color":"#2562af"}},[_vm._v(_vm._s(_vm.textbtn))])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"flex-center pl-2",attrs:{"xs6":"","sm6":""}},[_c('v-layout',{staticClass:"cursor-pointer",attrs:{"column":"","align-center":"","justify-center":""},on:{"click":function($event){_vm.viewprofile(_vm.inforfriend)}}},[_c('v-icon',{staticClass:"mb-1 icon-action"},[_vm._v("fas fa-user-circle")]),_vm._v(" "),_c('p',{staticClass:"mb-0",staticStyle:{"color":"#2562af"}},[_vm._v(_vm._s(_vm.$t('Dialog.profilefriend.headerProfile')))])],1)],1)],1):_c('v-card-actions',{staticClass:"mt-2"},[_c('v-flex',{staticClass:"flex-center pr-2",attrs:{"xs12":"","sm12":""}},[_c('v-layout',{staticClass:"cursor-pointer",attrs:{"column":"","align-center":"","justify-center":""},on:{"click":function($event){_vm.actionclick(_vm.inforfriend)}}},[_c('v-icon',{staticClass:"mb-1 icon-action"},[_vm._v(_vm._s(_vm.btnicon))]),_vm._v(" "),_c('p',{staticClass:"mb-0",staticStyle:{"color":"#2562af"}},[_vm._v(_vm._s(_vm.textbtn))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_InforfriendDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/InforfriendDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("p4dp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22166224"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  InforfriendDialogMobile,
  dialog_InforfriendDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_InforfriendDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "glUL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "grGk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_pathify__ = __webpack_require__("YtWf");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState } from 'vuex'


var _ = __webpack_require__("M4fF");
/* harmony default export */ __webpack_exports__["a"] = ({
  props: { 'dialogShowfriend': false, showgroup: '' },
  data: function data() {
    return {
      phone: '',
      email: '',
      token: '',
      status: '',
      TypeSearch: '',
      search: '',
      NewArray: [], // เอาไว้รับค่าที่ socket ส่งมาเพื่อเก็บไว้
      ArrayList: [], // เอาไว้เก็บข้อมูลเพื่อทำการ push เก็บรอการส่งเข้า global variable
      tokenFriend: '',
      filename: '',
      webbackend: '',
      buttonRadio: [{ label: 'Email', color: 'green', value: 'email' }, { label: 'Botname', color: 'blue', value: 'botname' }, { label: 'Phone', color: 'yellow', value: 'phone' }],
      nameedit: '',
      statusedit: '',
      phoneedit: '',
      edit: false,
      returnresponse: '',
      member: [],
      name: '',
      group_id: '',
      typeuser: '',
      membersGroup: [],
      tokenMember: [],
      businessidMember: [],
      GroupReq: [],
      business_id: '',
      listmember: [],
      usertype: []
    };
  },
  methods: {
    uppic: function uppic() {
      $('#uploadpicprofilechat').click();
    },
    closeDialog: function closeDialog() {
      this.$emit('closeDialogShowFriend', false);
      this.edit = false;
    },
    AcceptReq_GroupReq: function AcceptReq_GroupReq() {
      var _this = this;

      // process.env.APImanage + '/activeinvitegroup'
      // process.env.APIgo_api + '/v1/accept-group'
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/accept-group', { group_id: this.group_id, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          var tokenuser = _this.token;
          var indexgroup = _.findIndex(response.data.group.member, function (o) {
            return o.tokenuser === tokenuser;
          });
          if (indexgroup >= 0) {
            _this.socketactive_group = { timestamp: response.data.group.member[indexgroup].timestamp_in, groupid: _this.group_id, tokenuser: _this.token };
          } else {
            _this.socketactive_group = { timestamp: '', groupid: _this.group_id, tokenuser: _this.token };
          }
        } else {
          _this.$swal('', _this.$t('Alert.Fail.default.somethingWrong'), 'warning');
        }
      }).catch(function (error) {
        console.log(error);
        _this.$swal('', _this.$t('Alert.Fail.default.somethingWrong'), 'warning');
      });
      this.closeDialog();
    },
    RemoveReq_GroupReq: function RemoveReq_GroupReq() {
      var _this2 = this;

      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        // text: 'คุณต้องการยกเลิกเข้าร่วมกลุ่ม ' + this.name +' ใช่หรือไม่?',
        text: this.$t('Alert.Group.cancelGroup', { name: this.name }),
        type: 'warning',
        // imageUrl: '../assets/image/block.png',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this2.axios.post("https://uatchat-manage.one.th/manage" + '/cancelinvitegroup', { group_id: _this2.group_id, tokenuser: _this2.token }).then(function (response) {
            if (response.data.status === 'success') {
              // this.$swal('', 'ยกเลิกเข้าร่วมกลุ่มสำเร็จ', 'success')
              _this2.$swal('', _this2.$t('Alert.Success.success'), 'success');
              _this2.closeDialog();
              // console.log('cancel invite group')
              // this.$store.state.listgroupreq = JSON.stringify(this.GroupReq)
              // this.$store.state.groupreq = ''
              // this.$store.dispatch('groupReq', 'groupremove' + this.group_id)
            } else {
              _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'warning');
            }
          });
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex_pathify__["c" /* sync */])('*')),
  watch: {
    showgroup: function showgroup() {
      var _this3 = this;

      this.name = this.showgroup['name'];
      this.group_id = this.showgroup['group_id'];
      this.membersGroup = this.showgroup['member'];
      var _ = __webpack_require__("M4fF");
      this.member = _.filter(this.membersGroup, function (member) {
        return member.statemember === 'active';
      });
      var pluck = __webpack_require__("EYc8");
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', { owner: this.token, tokenuser: pluck(this.member, 'tokenuser') }).then(function (response) {
        // console.log(response.data)
        _this3.member = response.data['user'];
      });
    }
  },
  created: function created() {
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.business_id = localStorage.getItem('business_id');
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "h/Jn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h7JD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hF+m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hUZz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iPzF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iVuR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_100vh__ = __webpack_require__("hErE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _ = __webpack_require__("M4fF");
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      autogrow: false,
      filesmo: [],
      detail: '',
      title: {},
      name: '',
      email: '',
      phone: '',
      items: [],
      token: '',
      comment: '',
      status: '',
      conditions: false,
      content: '',
      phoneRules: [function (v) {
        return !!v && v.length === 10 || 'กรุณากรอกตัวเลขให้ครบ 10 หลัก';
      }, function (v) {
        return !!v || 'กรุณากรอกข้อมูลเป็นตัวเลข';
      }, function (v) {
        return (/^0[0-9]{9}/.test(v) || 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง'
        );
      }],
      emailRules: [function (v) {
        return !!v || 'กรุณากรอกอีเมล์';
      }, function (v) {
        return !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'รูปแบบอีเมล์ไม่ถูกต้อง';
      }]
    };
  },
  created: function created() {
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.email = localStorage.getItem('email');
    this.name = localStorage.getItem('name');
    this.phone = localStorage.getItem('phone');
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
    this.content = '<b>' + this.$t('Settings.helpCenter.company') + '</b> <br>' + this.$t('Settings.helpCenter.address') + ' <br>' + this.$t('Settings.helpCenter.email') + ' <a style="text-decoration: none;" href="mailto:onechat@one.th">onechat@one.th</a>';
    this.getsubject();
  },

  watch: {
    filesmo: function filesmo() {
      if (this.filesmo.length > 5) {
        this.$swal('', this.$t('Alert.Fail.feedback.maxFiles'), 'warning');
        _.pullAt(this.filesmo, [5]);
      }
    }
  },
  components: {
    vue100vh: __WEBPACK_IMPORTED_MODULE_1_vue_100vh__["a" /* default */]
  },
  methods: {
    uppicmo: function uppicmo() {
      $('#filesmo').click();
    },
    handleFilesUploadmo: function handleFilesUploadmo(key) {
      var uploadedFiles = this.$refs.filesmo.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.filesmo.push({
          file: uploadedFiles[i],
          status: 'waiting'
        });
      }
      this.getImagePreviewsmo(key);
      document.querySelector('#filesmo').value = '';
    },
    getImagePreviewsmo: function getImagePreviewsmo(key) {
      var _this = this;

      var _loop = function _loop(i) {
        if (/\.(jpe?g|png|gif)$/i.test(_this.filesmo[i].file.name)) {
          var reader = new FileReader();
          reader.addEventListener('load', function () {
            this.$refs['preview' + parseInt(i)][0].src = reader.result;
          }.bind(_this), false);
          reader.readAsDataURL(_this.filesmo[i].file);
          // this.extension(this.files[i].name)
          // console.log(this.extension())
        } else {
            // this.$nextTick(function(){
            // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
            // });
            // console.log('mm')
          }
      };

      for (var i = 0; i < this.filesmo.length; i++) {
        _loop(i);
      }
    },
    sendfeedbackmo: function sendfeedbackmo() {
      var _this2 = this;

      var lengthfile = this.filesmo.length;
      if (lengthfile === 0) {
        var formData = new FormData();
        formData.append('phone', this.phone);
        formData.append('email', this.email);
        formData.append('comment', this.detail);
        formData.append('name', this.name);
        formData.append('category_id', this.title.category_id);
        this.axios.post("https://uatchat-manage.one.th/manage" + '/feedbackcategory', formData).then(function (response) {
          // console.log(response.data)
          _this2.$swal('', _this2.$t('Alert.Success.feedback'), 'success');
          _this2.cancel();
        }, function () {
          _this2.$swal('', _this2.$t('Alert.Fail.feedback.connectError'), 'error');
        });
      } else {
        this.sendfeedbackfilemo();
        // for (var i = 0; i < lengthfile; i++) {
        //   this.sendfeedbackfile(i)
        // }
      }
    },
    sendfeedbackfilemo: function sendfeedbackfilemo() {
      var _this3 = this;

      var formData = new FormData();
      var lengthfile = this.filesmo.length;
      for (var i = 0; i < lengthfile; i++) {
        var file = this.filesmo[i].file;
        formData.append('file', file, file.name);
      }
      // console.log(formData)
      formData.append('phone', this.phone);
      formData.append('email', this.email);
      formData.append('comment', this.detail);
      formData.append('name', this.name);
      formData.append('category_id', this.title.category_id);
      this.axios.post("https://uatchat-manage.one.th/manage" + '/feedbackcategory', formData).then(function (response) {
        // console.log(response.data)
        _this3.$swal('', _this3.$t('Alert.Success.feedback'), 'success');
        _this3.cancel();
      }, function () {
        _this3.$swal('', _this3.$t('Alert.Fail.feedback.connectError'), 'error');
      });
    },
    extension: function extension(files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase();
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
      var pdf = ['pdf'];
      var file = ['ai', 'ps', 'psd'];
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm'];
      var presentation = ['ppt', 'pps', 'pot', 'pptx'];
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff'];
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf';
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive';
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel';
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint';
      } else if (word.includes(extension)) {
        return 'fas fa-file-word';
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code';
      } else if (image.includes(extension)) {
        return 'fas fa-file-image';
      } else if (file.includes(extension)) {
        return 'fas fa-file';
      } else {
        return 'fas fa-file-alt';
      }
      // return extension[extension.length-1]
    },
    cancel: function cancel() {
      // this.phone = ''
      // this.name = ''
      // this.email = ''
      this.title = {};
      this.detail = '';
      this.filesmo = [];
    },
    getsubject: function getsubject() {
      var _this4 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/getcategory').then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          _this4.items = response.data;
        }
      });
    },
    toPage: function toPage(data) {
      this.$router.push(data);
    },
    removeFilemo: function removeFilemo(key) {
      this.filesmo.splice(key, 1);
      this.getImagePreviewsmo(key);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "iaWL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "if18":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "in91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "izk3":
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),

/***/ "j0Qy":
/***/ (function(module, exports) {

module.exports = {"welcomeMsg":"Welcome to Your Vue.js App","HeaderMenubar":{"qrcode":"QR code","loa":"Level of Assurance(LoA)","editProfile":"Edit Profile","managefriend":"Manage Friend","sendOnebox":"One Box","feedback":"Report issue","support":"Help Center","terms_of_service":"Terms of Service","policy":"Policy","logout":"Sign Out","createproject":"Create project","project":"All project","calendar":"Calendar","languages":"Languages","general":"General","profile":"Profile"},"Conjunction":{"or":"or","and":"and"},"AnswerQuestion":{"ok":"OK","cancel":"Cancel","sure":"Sure","no":"No!","edit":"Edit","remove":"Remove","update":"Update","sendme":"Send","forward":"Forward","send":"Send","joinGroup":"Join Group","acceptFriend":"Accept Friend","removeFriend":"Remove Friend","kickMemberGroup":"Delete","chat":"Chat","cancelRequest":"Cancel Request","cancelInvite":"Cancel","unblock":"Unblock","addFriend":"Add Friend","createGroup":"Create Group","keep":"Keep","Onebox":"Onebox","download":"Download","uploadPhoto":"Upload Photo","sendOnebox":"Send to Onebox","selectPicture":"Choose Image","selectFile":"Choose File","uploadAll":"Upload All File","newuUpload":"Upload again","upload":"Upload","clear":"Clear","resetbackground":"Reset background","setbackground":"Save background","continue":"continue","open":"Open","login":"Login"},"Dialog":{"Saveonebox":{"titlefolder":"Select your folder","titleaccount":"Select your account"},"ShowFriendDialog":{"header":"Member in {groupname}","noMember":"No members"},"account":"Accounts","pictureProfile":"Picture Profile","forward":{"header":"Choose Chat Room","friend":"Friends","group":"Groups","searchgroup":"Search group"},"map":{"header":"Location","placeholder":"Choose Location"},"approve":{"detail":"Detail","answer":"Sorry!! This message has been answered."},"sendEmail":{"header":"Send by Email","to":"To:","subject":"Subject:","detail":"Message...","removeFile":"[ Remove ]","send":"Send","note":"Note: Please enter , (Comma) separated email in case you want to send to more than one recipient.","note2":"Note: Please press ⏎ (Enter) in case you want to send to more than one recipient."},"album":{"headerAddImage":"Save to album","headerCreate":"Create Album","nameAlbum":"Album name","btnCreate":"Create album","btnAddImage":"Add Photos","btnEdit":"Rename album","btnRemoveImage":"Delete photo","btnRemoveAlbum":"Delete album","noDataAlbum":"No album list","noAlbum":"This album has been deleted.","noImageAlbum":"There aren't photos in this album."},"showImage":{"by":"By","date":"Date"},"group":{"headerInvite":"Invite friends","headerSetting":"Settings","chooseFriend":"Choose friend","groupName":"Group's name","group":"Group: ","detailQrcode":"You can send this QRcode to other people for joining group.","searching":"Search","detailQrjoingroup":"QR code for join group"},"note":{"headerCreate":"Create Note","headerNote":"Note","noNote":"Sorry!! This note has been deleted.","deleteNote":"Do you want to delete note ?"},"wallpaper":{"headerWallpaper":"Chat Wallpaper"},"anonymous":{"headerCreate":"Create ChatGroup","createGroupName":"Create group name","groupName":"Group name","addMember":"Add Member"},"download":{"textDownload":"Download One Chat Application"},"profilefriend":{"headerProfile":"View Profile"},"ocr":{"selectText":"Please select a message","processing":"System processing, Please wait a moment"},"selectaccount":{"title1":"Select account","title2":"Please select account for login","alert":{"title":"Confirm account","text1":"Do you want to use an account","text2":"for login Onechat"}}},"LeftSide":{"header":{"friend":"Friend","chat":"Chat","service":"Service","project":"Project","setting":"Settings","calendar":"Calendar","onemeet":"One Meet","homepage":"Home","qrcode":"QR Code"},"searching":"Search Friend or Group","noDataSearching":"List Chat Not found","friend":{"friendInvite":"Friend Invitations","wantToBeFriend":"wants to be your friends","sendFriendInvite":"Send Friend Invitations","waitingRequestFriend":"Awaiting the acceptance","groupInvite":"Group Invitations","haveMember":"There are {count} members","friend":"Friends","addFriend":"Add friend","group":"Groups","createGroup":"Create Group"},"addFiend":{"header":"Add Friend","searching":"Search","detailSearch":"You can search friend from phone number, email or Bot ID.","nodata":"{key} not found.","placeholderPassword":"Please enter your password.","messageCheckbot":"Wrong password, Please check your password.","headerCheckpass":"Check password"},"createGroup":{"header":"Create Group","selectPicture":"Choose Image","detailSearch":"Group Name","searching":"Search","numberFriend":"Member {count}","noneSelect":"You haven't selected friends yet."},"chat":{"leftChat":"Left Conversation","startChat":"Start Conversation","sendSticker":"Send Sticker","sendFile":"Send File","sendLocation":"Send Location","sendContact":"Send Contact","sendPicture":"Send Image","sendNote":"Send Note","sendVideo":"Send Video","sendReply":"Reply message","sendOfficial_template":"Send official_template","sendConference_msg":"Calling started","createAlbum":"Create Album","createTask":"Create Task","createProject":"Create Project","approveMessage":"Send Approve Message","unsendMessage":"Unsent a Message","call":{"time":"Time","noResponse":"No Response","cancel":"Canceled Call","missed":"Missed Call","end":"Ended Call"},"sendCarousel":"Send Carousel images"}},"ChatSide":{"loadHistory":"Load History","system":{"self":{"cancelMsg":"You unsent a message.","editNameAlbum":"You changed the name of album.","createAlbum":"You created the album {name}.","deleteAlbum":"You deleted the album.","deleteImageAlbum":"You deleted a photo from album.","editTask":"You edited the task.","joinGroup":"You joined the group.","leftGroup":"You left the group.","createProject":"You create project."},"other":{"cancelMsg":"{name} unsent a message.","editNameAlbum":"{name} changed the name of album.","createAlbum":"{name} created the album {album_name}.","deleteAlbum":"{name} deleted the album.","deleteImageAlbum":"{name} deleted a photo from album.","editTask":"{name} edited the task.","joinGroup":"{name} joined the group.","leftGroup":"{name} left the group.","createProject":"{name} create project."},"default":{"kickMemberGroup":"{name_active} removed {name_passive} from the group.","inviteMemberGroup":"{name_active} invited {name_passive}."}},"Album":{"createAlbumHeader":"Album created","insertImageAlbum":"Photo added to album {name}.","numberImage":"Total: {count}"},"Task":{"viewDetail":"View detail this task","editAssign":"Edit assignation","assign":"Assign"},"image":"Image","sticker":"Sticker","note":"Note","emoji":"Emoji","file":"File","friend":"Friend","location":"Location","forward":"Forward","numberMsgSent":"Message","noMsg":"This message cannot be displayed.","notSupportVersion":"Sorry, this message isn't supported in this version.","resend":"Resend","conference":{"joinCall":"join","startCall":"Voice call started","startVideo":"Video call started"},"approve_message":{"viewDetail":"Detail","receiveAns":"Received your answer."},"textarea":{"normal":"Type your message...","inactive":"Unable to type message"},"Read":{"readmore":"Show more","readless":"Show less"},"announce":{"delete":"Don't show again","minimize":"Minimize"},"RightClickMenu":{"addImageAlbum":"Save to album","mention":"Reply","sendmail":"Send by Email","cancelMsg":"Unsend","announce":"Announce","cancelAnnounce":"Don't show again","pinChat":"Pin chat","unpinChat":"Unpin chat","forward":"Forward","openfile":"Open File","openlocation":"Open Map","openimage":"Open Image","profile":"View Profile"}},"RightSide":{"header":{"profile":"Profile","image":"Images","file":"Files","privatepolicy":"Privacy consent agreement"},"menu":{"project":"Project","album":"Album","note":"Note","clearChat":"Delete Chat","block":"Block","unblock":"UnBlock","qrCode":"QR code","leave":"Leave Group","invite":"Invite","setting":"Settings","setwall":"Wallpaper"},"noImage":"Images isn't found in this room.","noFile":"Files isn't found in this room.","group":"Group","member":"Members","pending":"Pending members","noMember":"No members","loadmore":"More","noNote":"No notes yet."},"Alert":{"Sure":"Are you sure?","Clear":"We are deleting all the information you entered.","Unblocking":"We are unblocking {name}!","Blocking":"We are blocking {name}!","RemoveFriend":"Do you want to delete {name} ?","Saveonebox":"Do you want to save the file in this folder?","Unsavefile":"This file has been saved. Unable to save the file repeatedly.","Chat":{"announce":{"cancel":"Don't show this message again?","deleteAll":"Don't show all messages again?"},"unsent":"Do you want to unsend message?","sendDatetime":"Do you want to send?"},"Left":{"cancelRequest":"Do you want cancel request friend from {name} ?"},"Right":{"clearChat":"Do you want to delete the message in the chat room?","cancelInvite":"Do you want to cancel the invitation {name}?","deleteFriendGroup":"Do you want to remove {name} from this group?","leaveGroup":"Do you want to leave this group?","removeNote":"Do you want to delete this note?","removeWallpaper":"Do you want to delete this wallpaper?","cancleEditPhone":"Do you want to cancel?"},"Album":{"headerAddImageAlbum":"Save to album","textAddImageAlbum":"Do you want to add a photo to the album {name}?","deleteImage":"Do you want to delete the photo in this album?","deleteAlbum":"Do you want to delete this album?"},"Group":{"cancelGroup":"Do you want to cancel join group {name} ?"},"Task":{"remove":"Do you want to delete this task?","removeComment":"Do you want to delete this comment?","removeChecklist":"Do you want to delete this checklist?","removeData":"Do you want to clear data?"},"Login":{"phoneNotVerify":"Your phone number is not registerd, Please enter new phone number","phoneVerify":"Your phone number is already registed, Please Login or Enter new phone number","otpRequest":"This phone number request OTP too often, Please wait a moment","otpInvalid":"OTP Invalid","inputUserPass":"Please, Enter your Username and Password","invalidUserPass":"Username or Password Not Found","previouspage":"Do you want to go back to the previous page?"},"Success":{"success":"Success!","createGroup":"The group is created.","feedback":"Your feedback is sent.","announce":"Announcement is successed.","unsent":"Message is unsent.","unblock":"Unblock is successed.","block":"Block is successed.","removefriend":"Delete friend is successed.","sending":"Sending is successed","sendFile":"Your file has been sent.","sendFiletoOnebox":"Your file has been sent to onebox.","sendMsg":"Your message has been sent.","sendEmail":"Your Email has been sent.","account":"Account has been sent.","createNote":"The note is created.","savePhotoAlbum":"Adding a photo to the album is successed.","renameAlbum":"The album name has been edited.","createAlbum":"The album is created.","removePhoto":"the photos are deleted.","cancelInvite":"The invitation to the group has been canceled.","removeFriendGroup":"Friend is deleted from group.","inviteFriendGroup":"Invitation has been sent.","renameGroup":"The group's name has been edited.","changePictureGroup":"The group's picture has been changed.","createTask":"This task has been created.","removeTask":"This task has been deleted.","editTask":"This task has been edited.","removeComment":"This comment has been deleted.","createComment":"This comment has been created.","createProject":"This project has been created.","createChecklist":"This checklist has been created.","removeChecklist":"This checklist has been deleted.","setbackground":"Wallpaper applied.","deletebackground":"Wallpaper has been deleted.","settingusername":"Setting username and password success.","createGroupChat":"Create group chat success"},"Fail":{"createGroup":{"title":"Can't Create Group.","selectFriend":"Please select at least 1 friend.","groupname":"Please enter group name."},"feedback":{"connectError":"Unable to send message. Please try again later.","maxFiles":"Select up to 5 images."},"Chat":{"maxMessage":"Select up to 5 messages.","maxSizeFile":"Unable to send file. This file is over 25 MB.","maxSizeFile100":"Unable to send file. This file is over 100 MB.","uploadPic":"Please upload new image"},"default":{"somethingWrong":"Something went wrong. Please try again later.","networkError":"Please check your internet connection."},"forward":{"maxChatRoom":"Select up to 5 rooms.","selectMessage":"Please select message"},"Album":{"maxSizeFile":"This file is over 25 MB.","maxFiles":"Select up to 5 images.","minFiles":"Select at least 1 image","removed":"Sorry, This album has been deleted.","emptyName":"Please enter the album name.","supportType":"Type file isn't supported."},"Task":{"removed":"Sorry, This task has been deleted."},"SendMail":{"inputMail":"Please enter e-mail","inputSubject":"Please enter subject e-mail"},"nameuser":"Please enter display name."},"Warning":{"link_market":"Sorry, Message not support on website."},"CheckOpenNewTab":"Do you want to open new tab?"},"Task":{"create":{"header":"Create Task","subject":"Subject","placeholderSubject":"Enter your subject","priority":"Priority","p1":"Higher","p2":"Middle","p3":"Lower","startDate":"Start Date","endDate":"End Date","description":"Description","placeholderDescription":"Enter your description","assign":"Assign","placeholderAssign":"Assign your team","status":"Status","comment":"Comment","placeholderComment":"Enter your comment","placeholderSubjectProject":"Enter your project name","projectSubject":"Project subject","placeholderChecklist":"Enter your check list","checklist":"Check list","select":"Please select a friend or group"},"detail":{"header":"Detail Task","menu":{"edit":"Edit","delete":"Delete","deletecommemt":"Delete comment","deletechecklist":"Delete checklist"},"createBy":"Created By","signDocument":"Sign Document"},"allTask":{"back":"Back","createTask":"Create Task","numTask":"{count} Tasks","placeholderSearchGroup":"Search group name","placeholderSearchFriend":"Search friends","newGroup":"New Group","placeholderSearchProject":"Search projects","createDate":"Create Date {date}","detailProject":"View detail this project","moreDetail":"More details","noProjectList":"No project list, Please create project.","noCardTask":"No task list, Please create task.","createProject":"Create Project","myProject":"My Project ({count})","noListFriend":"No list friend, Please add friend.","noListGroup":"No list group, Please create group.","projectDetail":"Project detail","localepicker":"en","next":"Next","selectProject":"Please select chatroom"}},"Settings":{"Qrcode":{"header":"QR code","myQRcode":"My QRcode","scanQRcode":"Scan QRcode","openCamera":"Allow sites to use your camera","resultScan":"Result"},"editProfile":{"changePictureProfile":"Change Image","support":"Support type","profile":"Profile","displayName":"Display Name","status":"Status","phone":"Phone","email":"Email Address","qrcodeForAddFriend":"QR code for add friend","detailQRcode":"You can send this QRcode to other people for add you as a friend.","settingusername":"Setting Username and Password","usernamepassword":"Username and Password","username":"Username","password":"Password","confirmpassword":"Confirm password","group":"Group Profile","groupName":"Group Name"},"messageError":{"UsernameDuplicate":"Username Duplicate.","UsernameRules1":"Please enter your username.","UsernameRules2":"Unable to enter special characters.","UsernameRules3":"Please enter at least 6 characters.","UsernameRules4":"Please enter your username in English characters a-z and 0-9 only.","UsernameRules5":"Please enter your username in English characters a-z at least 1 characters.","PasswordRules1":"Please enter your password.","PasswordRules2":"Password must contain at least 1 number or letter in English and at least 8 characters long.","RePasswordRules1":"Please enter your confirmpassword.","RePasswordRules2":"Password not matched."},"messageEditPhone":{"TitleDialogEdit":"Edit phone number","MsgPhoneRegistered":"Your phone number is already registered.","MsgDetectPhone":"Phone number","MsgDetectPhonenext":"is already registered. You can log in again to use that account immediately.","MsgCloseAccountSelect":"Close this user account","MsgCloseAccountSpan":"Please select when you want to close the current account for number ","MsgKeepAccountSelect":"Keep for 2 accounts.","MsgKeepAccountSpan":"Please select if you want to keep 2 accounts.","MsgCloseOnechatAccount":"Close your Onechat account","MsgCloseOnechatAccountSpan":"If you want to close your OneChat account, Please let us know.","MsgCloseOnechatAccountSelect":"Closing your account will be permanent. When you close your OneChat account, you won't be able to recover content or data. And all your chat messages will be deleted as well.","MsgConfirmCloseAccount":"Confirm account closure","ChangePhoneNumber":"Do you want to change phone number?","MsgSendOTP":"We send 6 digit otp number to","MsgOTPNotrecieve":"Didn't get the OTP","MsgResendOTP":"Resend in ","MsgVerifyPhone":"Verification with phone number","MsgOTPAgain":"Get otp again","MsgLoginPhoneAgain":"Please login with phone number again.","MsgSwitchAccount":"Do you want to switch an account?","MsgChangePhoneSuccess":"change phone number is success.","OTPInvalid":"OTP is invalid.","MsgTooManyRequest":"Please wait for 5 minute to Get OTP again.","MsgTokenExpire":"Token is expired.  Please login again."},"manageFriend":{"headerManageFriend":"Block List","nodata":"There aren't block list"},"feedback":{"suggestion":"Suggestion","headerFeedback":"We are glad to hear what you think about us. Your feedback will help improve One Chat.","titleFeedback":"You can share the user experience, Service suggestion, Or report an error here. If you need help, please contact email","contact":"Help Center","name":"Name","title":"Title","report":"Report a problem","detail":"Detail","selectPicture":"Choose Picture","selcetmultipleImage":"Drag the picture here","selectmultipleFiles":"Drag the files here","or":"or"},"helpCenter":{"header":"Help Center","company":"One Centric Company Limited","address":"1768 Thai Summit Tower, Floor 16, New Phetchaburi Road, Bang Kapi, Bangkok 10310","email":"Email"},"policy":{"header":"Privacy Policy of OneChat","subject1":{"header":"1. Introduction","introDetail":"One Centric Company Limited (“OneChat”, “Company” or “of Company”) believes that your privacy is paramount in fulfilling our obligations to respect and protect your privacy rights. The Company will adhere to these basic principles.","subjectIntro1":"1. The company will inform your personal data that will ask for your consent as it deems appropriate to collect, active processing or disclose your personal information","subjectIntro2":"2. The company will specify the purpose of collecting and processing your personal data.","subjectIntro3":"3. The Company will collect only the information necessary for the performance of the stated purpose of use.","subjectIntro4":"4. The Company will use or disclose your personal information only for the purposes for which it was collected, except with your consent or as required by law and the Company will retain your information only for as long as it is necessary for the purpose.","subjectIntro5":"5. The Company will endeavor to ensure that your personal information is correct, complete and current.","subjectIntro6":"6. The Company will provide appropriate techniques and organizational standards to properly protect your personal data.","subjectIntro7":"7. The Company will develop its policies and practices to make the handling of your personal information as transparent as possible.","subjectIntro8":"8. We welcome your comments regarding our compliance with these principles, this Privacy Policy and applicable law."},"subject2":{"header":"2. Scope of Privacy Protection Policy","subHeaderScopeA":"A. Objectives of the Privacy Policy ","subHeaderScopeB":"B. Privacy Policy applicable to other OneChat services.","detailScopeA1":"This Privacy Policy describes how OneChat Used to manage and protect your personal information including various alternative rights in relation to your personal data","detailScopeA2":"This Privacy Policy applies to personal information that the Company collects from you when you use the Application to communicate via the OneChat (“OneChat Application”) service various options are available in the One Chat application and other applications included or work with the OneChat application (collectively referred to as “Applications”), personal information that the Company collects from you. When you visit websites maintained by the Company in connection with the Company's applications (the “Websites”) (both the Application and the Websites collectively the “Services”) and personal information about you received from other users.","detailScopeB1":"Users may request additional services from OneChat or its affiliates. (“Additional Services”) as each user has different needs and options. The company therefore has different privacy protection policies or an annex to this Privacy Policy for applicable additional services. Separate Privacy Policy and the various suffixes describe the types of information the company collects purpose of use and other policies that may apply to such additional services. When you choose to use additional services, you will be informed of the applicable Privacy Shield Policy or addendum, which is in addition to or amendment to the Privacy Policy. You will then be able to access such additional services. Please note that you can review the Privacy Policy and its suffix according to the service used."},"subject3":{"header":"3. Types of personal data the company collects","subHeaderTypeA":"A. Personal data collected by One Chat","detailSubHeaderA":"in providing services to you OneChat collects, transfers and uses of information are as follows","subjectA1":"1. Information about your account","subjectA2":"2. Device information and access records when you use the Company's services.","detailSubjectA1":"When you create a OneChat account to access the service (“User Account”). OneChat will ask you to provide your phone number. This information is necessary as the Company may send SMS messages to the phone number you provide for detection and prevention continuously to prevent unauthorized use of the service or use it in a fraudulent manner we may also use this registered phone number to send you important information about the Service.","detailSubjectA2":"When you use the Company's services, the Company may obtain and maintain electronic identification data or records automatically obtained from certain items of your device, such as the device type, Operating system, type IP, address browser information including type and language settings Machine identifiers, cookie data, advertising identifiers, or mobile application identifiers.","detailSubjectA21":"This information is necessary for the Company to continually detect and prevent unauthorized use of the Service or use it in a fraudulent manner or in a wrong way as well as to provide you with the most customized and efficient service on your device. In addition, please note that third party advertising identifiers may be associated with your account through our internal identifiers.","subHeaderTypeB":"B. What other information may OneChat collect?","detailSubHeaderB":"The company provides additional to improve service efficiency functions including the functionality of accessing your account from multiple devices. Helping you find friends through the service or for efficient service convenient to use and enjoy more if you choose to use this function or choose to use your account on multiple devices The Company may ask you to provide the following information.","subjectB1":" 1. Email address [optional]","detailSubjectB1":"You may wish to access your account from multiple devices. (“Multiple Logins”) or transfer your account from one device to another. (“Account Transfer”), you will be required to provide your e-mail address and a password or personal secret code (PIN) to OneChat so that the Company can associate your device with your account can be registered","detailSubjectB12":"Please note that If you change your mind later and does not wish to specify an e-mail address anymore You can remove it at any time by going to the “Settings” > “Account” menu in the OneChat application.","subjectB2":"2. OneChat ID [optional]","detailSubjectB2":"You may choose to specify the name of the chat ID. You may choose to allow your friends to find you on the Service more easily and allow your friends to find you by their OneChat ID, or you may opt-out of other OneChat users. You can also contact you using your OneChat ID. Please note that other OneChat users will not be able to see your OneChat ID without permission and your OneChat ID may not be a pseudonym it must be your real name.","subjectB3":"3. Contact phone number [Optional]","detailSubjectB3":"If you wish to invite individual friends or contacts to connect with you using the OneChat application, you may send invitations directly by e-mail directly from your mobile device when you use the Send Friend Invite function in OneChat application","subjectB4":"4. Location information [Optional] ","detailSubjectB41":"In order to use the OneChat application, you do not need to provide your location information. However, the Company provides special features to use geolocation information for your convenience and to increase the efficiency of use for you","detailSubjectB42":"In other cases collected by the Company or use your geolocation information to provide additional services, the Company will provide you with prior notice and obtain your prior consent","subjectB5":"5. Contact information for customer support [Optional]","detailSubjectB51":"In some cases, you may wish to contact the Company to obtain customer support from us. If you contact the company through the company contact form or by other means The Company may obtain and retain any information you choose to provide, including your name, your contact information such as your e-mail address, your phone number, as well as information about your mobile device or personal computer, such as the type of device. and the operating system type of the said device The Company will use this information to correct and investigate problems that you have submitted to the Company to help you and to further improve the company's customer support services","detailSubjectB52":"We may process this information in connection with the assistance you request to manage your account and store this information in accordance with the provisions of this Privacy Policy.","subjectB6":"6. Contact information for promotional activities and customer surveys. [Optional]","detailSubjectB6":"If you choose to participate in various promotional or survey activities that OneChat offers from time to time The Company may ask for your contact details (such as name, postal address, phone number your email address, gender and date of birth) to confirm your eligibility to participate in the event so that you can fill out the questionnaire and to deliver any prizes that you might win and to manage other activities","subjectB7":"7. payment information [Optional]","detailSubjectB71":"If you purchase or use additional services that charge and pay for such additional services by means other than purchases through the iTunes or Google Play application. The Company may have a third party service provider store and process your credit card information. The Company will use your credit card information only to process purchases or use of paid services. Please note that The Company will not retain your credit card information for the period necessary to facilitate the relevant payment.","detailSubjectB72":"Your credit card payment will be processed by an appropriate third party payment agency.","subjectB8":"8. Information from websites and applications in which the Company's services are included. [Optional]","detailSubjectB8":"The Company service and/or third party websites and/or applications additional company applications may also be included. The Company may save your chat login information through the use of such add-on applications. or obtain the address of the website containing the Company's add-on applications that you visit while you log in to the Company's services through your browser. Please note that your personal data will not be received from such websites or applications that contain the Company's add-on applications if you log out from the Service.","subjectB9":"9. User Generated Information about the User himself and shared with others User Generated Content. [Optional]","detailSubjectB91":"In addition to the information detailed above you may choose to set profile information (such as your Display Name, profile picture and phrase you choose to display under your status) and identify yourself with other OneChat users on the Service. Choose to create user-generated content, such as text and voice messages, photos, videos, geolocation data or your friends' contact information on your chat days and share this user-generated content with other users. You may choose to share any more or less of your User Generated Content and you can choose who to share that content with when you create a message by selecting the recipients of your own user-generated content and/or through the privacy settings in the OneChat application.","detailSubjectB92":"Please note that profile information and user-generated content that you share with others can be copied, stored or published by recipients of such content and are also likely to be accessible to third parties who not intended to be the recipient as well because it is digital The Company urges you to be careful and cautious when you create and share your personal information or content with others."},"subject4":{"header":"4. How does the company use and manage your information?","subjectA":"A. How does OneChat use data user?","detailSubjectA":" In providing services and any additional of OneChat, the data controller or data controller, will use your personal data for the purposes of this Privacy Policy as follows","detailSubjectA1":"To provide you with any additional services and services and to allow you to submit your own User Generated Content to other users of OneChat","detailSubjectA2":"To verify your identity","detailSubjectA3":"To allow you to use your OneChat account on multiple devices and transfer your OneChat account to another device.","detailSubjectA4":"To help you find people you know who are already using One Chat. which you can connect to each other using one chat and as you have previously agreed to allow other OneChat users to connect with you.","detailSubjectA5":"So that you can sync with other applications of OneChat, affiliates and business partners of OneChat with your chat account and to share information between the applications you use.","detailSubjectA6":"To respond to requests you may have in order to use additional services of OneChat.","detailSubjectA7":"To monitor, detect and prevent unauthorized use of the Service; or use it in a fraudulent manner or in a wrong way","detailSubjectA8":"To improve and/or make it suitable in services and additional services","detailSubjectA9":"So that the company can provide customer support services and respond to your inquiries and requests efficiently","detailSubjectA10":"To provide you with information about additional services and services","detailSubjectA11":"To measure the effectiveness of advertisements displayed by the Company on the Internet or in other media.","detailSubjectA12":"To inform you of any other important information about the Service and, if necessary, additional services.","detailSubjectA13":"To identify the winners of the contest in various promotional activities to send prizes to the winners and to deliver purchased products and services","detailSubjectA14":"To collect statistical data anonymously about additional services and services; and","detailSubjectA15":"To comply with applicable law or legal duty","detailSubjectA16":"However, if the Company notifies you of a more specific purpose of use at the time the Company requests your personal data or by other means, such notification will supersede the general purposes of use specified in clause 4.A of this Privacy Policy","subjectB":"B. How will OneChat protect user privacy?","detailSubjectB1":"To carry out our obligations to respect and protect your right to privacy and keeping your personal information confidential, OneChat use appropriate organizational security techniques and standards as well as industry standard safeguards to prevent unauthorized access or disclosure, misuse, alteration or destruction of your information.","detailSubjectB2":"Because the company does not have any electronic means of transmitting information or any storage method is perfect or impenetrable, therefore cannot guarantee that your personal data will be completely safe from intrusion during transmission or stored in the Company's systems to help protect it. Your right to privacy and to keep your personal information confidential, the company needs your help, please do not share your password with other people or use the same password you use for other services. In addition, please notify the Company in case you suspect any unauthorized use of your account or any other security breach through the Company's contact form.","subjectC":"C. Where is the user's personal information transmitted and stored?","detailSubjectC":" To provide service with reliability and responsibility OneChat will process and store your information on secure servers located in Thailand provided that all such transfers are subject to the requirements of applicable law.","subjectD":" D. How long does a OneChat keep a user's data?","detailSubjectD1":"OneChat will retain the personal information you provide for the duration of your account active, for as long as is necessary to fulfill the purposes of use as detailed in this Privacy Policy or to comply with applicable laws and regulations","detailSubjectD2":"The Company may retain your personal data even after your account has been closed or terminated if it is reasonably necessary to keep it as follows:","detailSubjectD3":"To comply with applicable laws and regulations or legal duties","detailSubjectD4":"To provide complete customer support services","detailSubjectD5":"To settle disputes between or with users on Chat for the duration of the applicable or","detailSubjectD6":"To detect and prevent unauthorized use of the service or use it in a fraudulent manner or in a wrong way","subjectE":"E. Does OneChat use an external service provider or agent?","detailSubjectE":"In order to provide the Services, OneChat sometimes requires that third-party service providers process user data that may include your personal data. The Company strictly selects such Third Party Service Providers and the Company will use reasonable endeavors to ensure that the Third Party Service Providers have put in place appropriate and secure information management and internal controls and we has imposed contractual obligations on such service providers in order for such service providers to comply with applicable laws and regulations regarding the processing of personal data. We also require such third party service providers to access your personal data only to the extent necessary for our instructions and purposes. Such external accesses your personal data only to the extent necessary for our instructions and purposes.","subjectF":"F. Does OneChat provide user information to third parties?","detailSubjectF":"In addition to the details above in this Privacy Policy and privacy protection policies or other relevant suffixes OneChat will not provide your information to any other person without your consent unless the Company has a good faith belief that The Company is required or authorized to do so in accordance with applicable law.","subjectG":"G. Does OneChat use cookies or other similar technologies?","detailSubjectG1":"The Company uses cookies or other similar specific storage technologies.","detailSubjectG2":"Cookies are small files that are stored on your computer when you visit a website. These files store information that a website can use to read again when you visit that website on a later date. This is necessary because otherwise the website will not function properly. Other cookies provide convenience to visitors by remembering their username in a secure way and in the language of your choice. Cookies are provided so that you do not have to fill in the same information each time you visit our website, we use cookies to:","detailSubjectG3":"To help the Company to maintain your session information when you use the Services and/or any additional services.","detailSubjectG4":"Optimize the security of our system.","detailSubjectG5":"Collect preferences and provide services that are customized according to your needs and","detailSubjectG6":"To help the company understand how people use the service and to improve the service, we also use the following third party cookies on the website.","detailSubjectG7":"Google Analytics","detailSubjectG8":"Your continued use of the Service indicates that you agree to the Company's use of cookies and similar technologies in accordance with this Privacy Policy.","detailSubjectG9":"Most Internet browsers allow you to control whether you accept the use of cookies if you disable cookies or limit your ability to set cookies. You may not be able to take advantage of the website or access all its functions, which may limit your overall use."},"subject5":{"header":"5. Your Choices and Rights","detailHeader":"It is possible that OneChat may receive personal information about individuals who are not current users of the service. Please note that whether you are a user or not, you can choose and have different rights. According to this section, if the company collects your personal information","subjectA":"A. How do users control their data?","detailSubjectA":"Subject to applicable law (including exclusions or exceptions under such laws), you may have the right to access your personal data, the right to correct errors in the personal data and the right to object on grounds of legal processing which your personal information.  You may exercise your rights directly within the OneChat application at any time, for example:","detailSubjectA1":"In the “Profile” menu in the Settings section of the application, you can verify and or edit your phone number, and you can also verify and edit your display name. and your profile picture, and","detailSubjectA2":"In the “Accounts” menu in the Settings section of the application you can verify and/or modify your registered email address. You can also delete your registered email address or disconnect your Facebook account.","detailSubjectA3":"To exercise any rights of yours under applicable law you may contact us via the contact form. Upon verifying your identity, the Company will respond to your request within a reasonable period of time and in accordance with applicable law. If you wish to submit a written request to the Company, please see the Company's e-mail address at clause 6.A.","detailSubjectA4":"If you no longer wish to use the service alternatively or no longer wish to allow OneChat to collect and use your personal data, you may choose to delete your entire account directly through the OneChat application. The company will delete your information in accordance with clause 4.D.","subjectB":"B. What if the user changes their mind?","detailSubjectB":"If you change your mind about how much you wish to share or continue disclosing information about the service, you can change your settings in the OneChat application. For example, matters related to","detailSubjectB1":"Your profile information (such as your profile picture, display name).","detailSubjectB2":"Can other OneChat users contact you using your OneChat ID?","detailSubjectB3":"Block or unblock some OneChat users.","detailSubjectB4":"Let other OneChat users who already have your phone number. Can I contact you via OneChat?"},"subject6":{"header":"6. Other important information","subjectA":"A. Users have questions/suggestions/concerns.","detailSubjectA":"If you have any questions, suggestions or concerns about this Privacy Policy or any of the Company's other privacy protection policies or practices, please contact the Company through the Company's contact form or send a letter to the company at 1768 Thai Summit Tower, 14th Floor and IT Floor, New Petchaburi Road, Bang Kapi Sub-district, Huay Khwang District, Bangkok 10310 or E-mail :  onechat@one.th","subjectB":"B. Amendments to this Privacy Policy","detailSubjectB1":"The Company may revise the Company's Privacy Policy from time to time for a variety of reasons, including to improve the Company's privacy practices to reflect changes to the Company's services and to comply with applicable laws. The Company created this Privacy Policy for the first time on June 21, 2018.","detailSubjectB2":"When the company makes changes to the privacy policy of the company in a material way, the company will notify you on the service of the company or by other reasonable means. The Company recommends that you carefully review such amendments, if you agree to such amendments, please continue to use the Company's services but if you do not agree to such amendment and does not wish to use the Company's services any longer You may choose to close your account. Your continued use of the Company's services after having been notified to you of the changes or having been posted on the Company's services is deemed to have accepted the amendments and agreed to the privacy protection policy at his change has been fixed."}}},"Anonymous":{"manageGroup":"Manage Group","yourGroup":"Group","noManageGroup":"No list group","noYourManageGroup":"No list group","createGroup":"Create Group Chat","createBusiness":"Create Business"},"Homepage":{"Title":{"title1":"Chat Application provided by Thai for Thai people","title2":"Your conversations will be safe","title3":"What is?"},"Detail":{"detailOnechat":"One Chat is part of the One Platform services, which is used to communicate between citizens, businesses, and governments. To facilitate an easier and less time-consuming way of expansion of business, assuring the quality of reliable and safety standards.","detailOneplatform":"One Chat is connecting with services in One Platform, such as One E-mail and One Box","detailOnebox":"Free cloud storage","detailOnemail":"Free e-Mail","detailOnechatFn1":"One Chat provides sending free messages, files, voice, pictures, and many other functions","detailOnechatFn2":"One Chat can be compatible with all mobile operating systems whether iOS, Android, or PC (Windows, Mac OS)","detailOnechatFn3":"One Chat provides One Chatbot service, an auto-reply message such as texts, pictures, document files, and other text formats"},"Button":{"join":"Join with us","moredetail":"More Detail"},"Footer":{"companyname":"One Centric Company Limited","date":"Open Monday - Friday","time":"Time 9.00 a.m. - 5.00 p.m.","address1":"1768 Thai Summit Tower 16th Floor","address2":"New Petchaburi Road, Bang Kapi Sub-district","address3":"Huay Khwang District, Bangkok 10310","policy":"Policy","report":"Report a problem","sendmsg":"Send Message"},"Dialog":{"titleReport":"Report","name":"Name","email":"E-mail","phone":"Phone","subject":"Title","detail":"Detail","inputEmail":"Please, Enter your E-mail","inputEmailError":"Invalid E-mail format","inputphoneErrorDigit":"Please, Enter your phone number 10 digits","inputphoneErrorFormat":"Invalid phone number format","inputphoneErrorNumber":"Please, Enter phone number","inputName":"Please, Enter your Name","inputDetail":"Please, Enter your Detail","titleSendMessage":"Send Message"}},"Login":{"titleLogin1":"Welcome to OneChat","titleLogin2":"Login with","typeLogin1":"Login with OneID","typeLogin2":"Login with phone number","phone":"Phone","username":"Username","password":"Password","forgotpass":"Forget Password","conjunction":"or","Button":{"sendotp":"Send OTP","time":"s","resend":"Resend OTP","login":"Login","loginnavbar":"Login"}},"Register":{"title1":"Join with us","title2":"Register","title3":"Register","title4":"You will get good service from us","span1":"Free","span2":"E-mail","span3":"Online Storage","Button":{"register":"Register","accept":"Accept","back":"Back","policy":"Terms and Conditions of Service"},"content":"<h4>Terms and Conditions of Service</h4>1. Using of our services <br>&nbsp;&nbsp;&nbsp;1.1 Your using of our services does not give you ownership of any intellectual property rights in the services or content you access.<br>&nbsp;&nbsp;&nbsp;1.2 By providing services from us, we may send service announcements; provide you with administrative news and other information to you. You can opt-out of some of these communications.<br>&nbsp;&nbsp;&nbsp;1.3 Some of our services can be used on mobile devices so do not use them in a way that distracts and prevents you from complying with traffic or safety laws.<br><br>2. Your One Platform account<br>&nbsp;&nbsp;&nbsp;2.1 You may need a One Platform account in order to use some of our services, other or additional terms may apply to you and your administrator may be able to access or disable your account.<br>&nbsp;&nbsp;&nbsp;2.2 To protect your One Platform account, please keep your password confidential. You are responsible for any activities that occur on through your One Platform account. Try not to reuse your One Platform account password on any third-party applications.<br><br>3. Protection of personal data and copyright<br>&nbsp;&nbsp;&nbsp;3.1 By using our services, you consent to the use of such information by One Platform in accordance with that Privacy Policy.<br><br>4. Modifications and Terminations of our Services<br>&nbsp;&nbsp;&nbsp;4.1 We make changes and improvements to our services regularly, we may add or remove certain functionality or features and we may suspend or discontinue any service altogether.<br>&nbsp;&nbsp;&nbsp;4.2 You can stop using our services at any time.<br><br>5. Business use of our services<br>&nbsp;&nbsp;&nbsp;5.1 If you use our services on behalf of a business, that business must agree to these terms. <br>&nbsp;&nbsp;&nbsp;5.2 The business will not demand that One Platform and its affiliates, officers, agents and employees indemnify to you and you will not litigate or take action arising out of or in connection with your use of the service or breach of these terms including that such person shall not be liable or have to pay any expenses arising from claims, losses, damages, litigation, judgments, litigation costs and attorney fees.<br>"},"File":{"passwordFile":"Password","textRequirePassword":"please enter file's password","wrongPassword":"Wrong Password!","downloadFile":"download file"},"custsat":{"Header":"Customer Satisfaction Survey","username":"User","point":"point","ask_1":{"operation_system_1":"Which Operating System are you currently using on One Chat Application","morethanone":"Can choose more than one","android":"Android","ios":"iOS","website":"Website"},"ask_2":{"frequencyUse":"How often do you use this app","option1":"Less than once a week","option2":"1-3 days a week","option3":"4-6 days a week","option4":"Daily"},"ask_3":"Does it offer all the key features you require","ask_4":"Is the product fast and responsive","ask_5":"Overall, how would you rate the quality of your customer service experience","comment":"Further questions & comments","send":"send"}}

/***/ }),

/***/ "j71L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/ApproveDialogMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ApproveDialogMobile = ({
  props: { dialogApprove: false, ApproveDetail: {} },
  data: function data() {
    return {};
  },
  watch: {
    socketdisableapprove: function socketdisableapprove(data) {
      if (data.tokenroom === this.$route.params.roomid && data.tokenmessage === this.ApproveDetail.tokenmessage) {
        this.ApproveDetail.disable = 'true';
      }
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeApprove', false);
    },
    sendansApprove: function sendansApprove(item) {
      this.$emit('sendansApprove', item, this.ApproveDetail.tokenmessage);
      this.closeDialog();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e52f0cfe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/ApproveDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"max-width":"500px","persistent":"","max-height":"500px"},model:{value:(_vm.dialogApprove),callback:function ($$v) {_vm.dialogApprove=$$v},expression:"dialogApprove"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-toolbar',{staticStyle:{"background":"white !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"CSChatThai",staticStyle:{"color":"#2562ae !important"}},[_vm._v(" "+_vm._s(_vm.ApproveDetail.info_ans[0].title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"#2562ae !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),(_vm.ApproveDetail.disable === 'false')?_c('v-card-text',{staticStyle:{"padding":"10px","padding-top":"5px","padding-left":"0px"}},[_c('v-container',{staticStyle:{"padding-top":"0px"},attrs:{"wrap":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","wrap":""}},[(_vm.ApproveDetail.info_ans[0].image)?_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"sm12":"","md12":"","xs12":""}},[_c('img',{staticClass:"alligator-turtle",staticStyle:{"height":"20vh"},attrs:{"src":_vm.ApproveDetail.info_ans[0].image}})]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","xs12":""}},[_c('p',[_vm._v(_vm._s(_vm.$t('Dialog.approve.detail'))+" : ")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","xs12":""}},[_c('v-container',{staticClass:"scroll-y CSChatThai",staticStyle:{"height":"20vh","margin-top":"0","width":"90%","padding":"0"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.ApproveDetail.info_ans[0].detail.replace(/(?:\r\n|\r|\n)/g, '<br>'))}})])],1)],1)],1)],1):_c('v-card-text',{staticStyle:{"padding":"10px","padding-top":"5px","padding-left":"0px"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('v-icon',{staticStyle:{"color":"#757575 !important","font-size":"80px !important"}},[_vm._v("error_outline")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"font-size":"17px","color":"#757575"}},[_vm._v(" "+_vm._s(_vm.$t('Dialog.approve.answer'))+" ")])],1)]),_vm._v(" "),(_vm.ApproveDetail.disable === 'false')?_c('v-card-actions',[_c('v-layout',{staticStyle:{"margin-left":"30px"},attrs:{"align-center":"","justify-center":"","wrap":"","row":""}},_vm._l((_vm.ApproveDetail.info_ans[0].choice),function(item,index){return _c('div',{staticStyle:{"margin-left":"15px"}},[(item.type=='cancel')?_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-btn',{staticStyle:{"text-transform":"none","border":"1px solid","border-radius":"15px"},attrs:{"small":"","color":"red","flat":""},on:{"click":function($event){_vm.sendansApprove(item)}}},[_vm._v(_vm._s(item.label))])],1)],1):_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-btn',{staticStyle:{"text-transform":"none","border":"1px solid","border-radius":"15px"},attrs:{"small":"","color":"primary","flat":""},on:{"click":function($event){_vm.sendansApprove(item)}}},[_vm._v(_vm._s(item.label))])],1)],1)],1)}))],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_ApproveDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/ApproveDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("SDBt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e52f0cfe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ApproveDialogMobile,
  dialog_ApproveDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_ApproveDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jMNM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jg0w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "js+G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k5oh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k7Zf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kMYv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "khKU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_chat/WebviewBigDialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var WebviewBigDialog = ({
  props: {
    dialogWebviewbig: false,
    Webview_item: {},
    tokenrooomSelect: String,
    token: String
  },
  data: function data() {
    return {
      progressLoding: true
    };
  },

  watch: {
    socket_close_webview: function socket_close_webview() {
      this.closeDialog();
    },
    Webview_item: function Webview_item() {
      if (this.Webview_item.url) {
        this.progressLoding = false;
      }
    }
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeWebview', false);
      this.progressLoding = true;
      this.closewebview();
    },
    newtab: function newtab() {
      // this.Webview_item.url
      window.open(this.Webview_item.url, '_blank');
      this.closeDialog();
    },
    closewebview: function closewebview() {
      // console.log(authen.tokenuser)
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/close-webview', {
        tokenroom: this.tokenrooomSelect,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data)
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5b15a78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_chat/WebviewBigDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden","border-radius":"20px"},attrs:{"width":"500","persistent":""},model:{value:(_vm.dialogWebviewbig),callback:function ($$v) {_vm.dialogWebviewbig=$$v},expression:"dialogWebviewbig"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v("  "+_vm._s(_vm.Webview_item.label)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},nativeOn:{"click":function($event){return _vm.newtab($event)}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("far fa-window-restore")])],1),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding":"0","height":"550px !important"}},[(!_vm.progressLoding)?_c('iframe',{staticStyle:{"visibility":"visible"},attrs:{"width":"500","height":"550","frameborder":"0","allowfullscreen":"","src":_vm.Webview_item.url,"allow":"geolocation;clipboard-read; clipboard-write"}}):_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"justify-content":"center","display":"grid","height":"80vh"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticStyle:{"margin":"auto"}},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("กรุณารอซักครู่ ระบบกำลังประมวลผล")])])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var manage_chat_WebviewBigDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_chat/WebviewBigDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("Y4Rx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c5b15a78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  WebviewBigDialog,
  manage_chat_WebviewBigDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_manage_chat_WebviewBigDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kin6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l1Ae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./src/components/chat/dialog/manage_chat/WebviewBigDialog.vue + 2 modules
var WebviewBigDialog = __webpack_require__("khKU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/manage_task/detail_task_dialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var _ = __webpack_require__("M4fF");
/* harmony default export */ var detail_task_dialog = ({
  props: {
    dialogDetailTask: false,
    taskid: '',
    roomid: ''
    // projectid: ''
  },
  components: {
    WebviewBigDialog: WebviewBigDialog["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      Webview_item: {},
      dialogWebviewbig: false,
      projectid: '',
      infor_task: {},
      edit: false,
      detail_task: '',
      token: '',
      subject_task: '',
      menu1: false,
      menu2: false,
      start_date: '',
      end_date: '',
      priority: null,
      member: [],
      selectemember: [],
      isloading: false,
      state: [],
      state_id: ''
    }, defineProperty_default()(_ref, 'member', []), defineProperty_default()(_ref, 'old_state', ''), defineProperty_default()(_ref, 'min_date', ''), defineProperty_default()(_ref, 'max_date', ''), defineProperty_default()(_ref, 'min_date_end', ''), defineProperty_default()(_ref, 'profilepicture', ''), defineProperty_default()(_ref, 'nickname', ''), defineProperty_default()(_ref, 'state_name', ''), defineProperty_default()(_ref, 'progress', false), defineProperty_default()(_ref, 'listcomment', []), defineProperty_default()(_ref, 'comment_task', ''), defineProperty_default()(_ref, 'check_list', []), defineProperty_default()(_ref, 'check_list_start', []), defineProperty_default()(_ref, 'subject_checklist', ''), defineProperty_default()(_ref, 'show', false), _ref;
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },
  mounted: function mounted() {},

  methods: {
    onModifyClick: function onModifyClick(_ref2, index) {
      var type = _ref2.type,
          target = _ref2.target;

      var event = {
        type: type,
        isCheckbox: target.type === 'checkbox',
        target: {
          value: target.value,
          checked: target.checked
        }
      };
      this.check_list[index].check = event.target.checked.toString();
      // this.check_list_start[index].check = !event.target.checked.toString()
      // console.log(!event.target.checked.toString())
      // console.log(this.check_list)
      // console.log(this.check_list_start)
    },
    clickedit: function clickedit() {
      this.edit = !this.edit;
      this.show = false;
    },
    delete_checklist: function delete_checklist(checklistid, index) {
      var _this = this;

      // console.log(checklistid, index)
      this.$swal({
        text: this.$t('Alert.Task.removeChecklist'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/delete_checklist', {
            tokenuser: _this.token,
            task_id: _this.taskid,
            check_list_id: [checklistid]
          }).then(function (response) {
            if (response.data.status == 'success') {
              _this.check_list.splice(index, 1);
              // this.check_list = this.check_list
              _this.get_task_by_id();
              _this.$swal('', _this.$t('Alert.Success.removeChecklist'), 'success');
            }
          }).catch(function (error) {
            console.log(error.message);
          });
        }
      });
    },
    add_checklist: function add_checklist() {
      var _this2 = this;

      var listcheck = '';
      listcheck = { 'check': 'false', 'label': this.subject_checklist };
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/add_checklist', {
        tokenuser: this.token,
        task_id: this.taskid,
        check_list: [listcheck]
      }).then(function (response) {
        if (response.data.status == 'success') {
          _this2.subject_checklist = '';
          // console.log(this.check_list)
          // console.log(response.data.data.check_list[0])
          _this2.$swal('', _this2.$t('Alert.Success.createChecklist'), 'success');
          _this2.check_list.unshift(response.data.data.check_list[0]);
          // console.log(this.check_list)
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    get_comment: function get_comment() {
      var _this3 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_comment_by_id', {
        tokenuser: this.token,
        task_id: this.taskid
      }).then(function (response) {
        // console.log(response.data.data)
        if (response.data.status == 'success') {
          _this3.listcomment = response.data.data;
          _this3.listcomment = _.reverse(_.sortBy(_this3.listcomment, function (dateObj) {
            return new Date(dateObj.timestamp);
          }));
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    add_comment: function add_comment() {
      var _this4 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/comment_task', {
        tokenuser: this.token,
        task_id: this.taskid,
        comment: this.comment_task
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data.data)
          _this4.listcomment.unshift(response.data.data);
          _this4.$swal('', _this4.$t('Alert.Success.createComment'), 'success');
          _this4.comment_task = '';
          _this4.$emit('commenttask', { 'task_id': _this4.taskid, 'count_comment': _this4.listcomment.length, 'state_id': _this4.state_id, 'project_id': _this4.projectid });
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    delete_commemt: function delete_commemt(commentid) {
      var _this5 = this;

      this.$swal({
        text: this.$t('Alert.Task.removeComment'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this5.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/delete_comment', {
            tokenuser: _this5.token,
            comment_id: commentid
          }).then(function (response) {
            if (response.data.status === 'success') {
              var index = '';
              index = _.findIndex(_this5.listcomment, function (o) {
                return o.comment_id == commentid;
              });
              _this5.listcomment.splice(index, 1);
              _this5.$swal('', _this5.$t('Alert.Success.removeComment'), 'success');
              _this5.$emit('commenttask', { 'task_id': _this5.taskid, 'count_comment': _this5.listcomment.length, 'state_id': _this5.state_id, 'project_id': _this5.projectid });
            }
          }).catch(function (error) {
            console.log(error.message);
          });
        }
      });
    },
    sign_doc: function sign_doc(item) {
      // console.log(item)
      // if (item.type == 'webview') {
      //   this.Webview_item = item
      //   this.dialogWebviewbig = true
      //   this.closeDialog()
      // } else if (item.type == 'link') {
      //   window.open(item.url, '_blank')
      // }
      if (item.sign == 'true') {
        this.getSign(item.url, item);
      } else {
        if (item.type === 'link') {
          window.open(item.url, '_blank');
        } else if (item.type === 'webview') {
          this.Webview_item = item;
          this.dialogWebviewbig = true;
          this.closeDialog();
        }
      }
    },
    getSign: function getSign(url, item) {
      var _this6 = this;

      var body = {
        "tokenuser": this.token,
        "url": url
      };
      this.axios.post("https://uatchat-manage.one.th/event" + '/api/v1/getAccesstoken', body).then(function (response) {
        item.url = response.data.data.url;
        if (item.type === 'link') {
          window.open(item.url, '_blank');
        } else if (item.type === 'webview') {
          _this6.Webview_item = item;
          _this6.dialogWebviewbig = true;
        }
      }, function () {});
    },
    formatDate: function formatDate(input) {
      // console.log(input)
      if (input.match(/\d+/g) !== null && input.match(/\d+/g) !== 'null') {
        var datePart = input.match(/\d+/g),
            year = datePart[0].substring(2),
            // get only two digits
        month = datePart[1],
            day = datePart[2];
        return day + '/' + month + '/' + year;
      } else {
        return '-';
      }
    },
    closeWebview: function closeWebview(value) {
      this.dialogWebviewbig = value;
    },
    allowedDates: function allowedDates(val) {
      this.min_date_end = this.start_date;
      if (this.start_date > this.end_date) {
        this.end_date = this.start_date;
      }
      return this.min_date_end;
    },
    allowedDatesEnd: function allowedDatesEnd(val) {
      this.min_date_end = this.start_date;
      if (this.min_date_end > this.end_date) {
        this.end_date = this.min_date_end;
      }
      return this.end_date;
    },
    closeDialog: function closeDialog() {
      this.check_list = [];
      this.selectemember = [];
      this.detail_task = '';
      this.subject_task = '';
      this.edit = false;
      this.state_id = '';
      this.subject_checklist = '';
      this.$emit('closeDetailTask', false);
    },
    cancel_task: function cancel_task() {
      this.start_date = this.infor_task.time_start.split(' ')[0];
      this.end_date = this.infor_task.time_end.split(' ')[0];
      this.edit = false;
      this.isloading = false;
      this.subject_checklist = '';
      this.get_task_by_id();
    },
    get_task_by_id: function get_task_by_id() {
      var _this7 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v2/user/get_task_by_id', {
        tokenuser: this.token,
        task_id: this.taskid
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this7.progress = false;
          _this7.infor_task = response.data.data;
          _this7.check_list = _.reverse(_this7.infor_task.check_list);
        }
      }).catch(function (error) {
        // console.log(error.message)
        // console.log(error.response.data.message)
        if (error.response.data.message == 'Not found task.') {
          _this7.progress = false;
          _this7.dialogDetailTask = false;
          _this7.closeDialog();
          _this7.$swal('', _this7.$t('Alert.Fail.Task.removed'), 'warning');
        }
      });
    },
    edit_task: function edit_task() {
      var _this8 = this;

      // console.log(this.check_list)
      // var today = new Date();
      // var time = today.getHours() + "00:00:00" + today.getMinutes() + ":" + today.getSeconds();
      var time = "00:00:00.00";
      this.isloading = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/edit_task', {
        tokenuser: this.token,
        tokenroom: this.roomid,
        title: this.subject_task,
        detail: this.detail_task,
        state_id: this.state_id,
        time_start: this.start_date + ' ' + time,
        time_end: this.end_date + ' ' + time,
        priority: this.priority,
        project_id: this.projectid,
        assign: this.selectemember,
        task_id: this.taskid,
        check_list: this.check_list
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this8.isloading = false;
          _this8.$swal('', _this8.$t('Alert.Success.editTask'), 'success');
          _this8.$emit('edittask', { 'task_id': _this8.taskid, 'state_id': _this8.state_id, 'event': 'edit', 'old_state': _this8.old_state, 'date_end': _this8.end_date, 'project_id': _this8.projectid, 'date_start': _this8.start_date });
          _this8.closeDialog();
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    delete_task: function delete_task() {
      var _this9 = this;

      this.show = false;
      this.$swal({
        text: this.$t('Alert.Task.remove'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this9.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/delete_task', {
            tokenuser: _this9.token,
            tokenroom: _this9.roomid,
            list_task_id: [_this9.taskid]
          }).then(function (response) {
            if (response.data.status === 'success') {
              // console.log(response.data.data)
              // console.log(this.taskid)
              _this9.isloading = false;
              _this9.$swal('', _this9.$t('Alert.Success.removeTask'), 'success');
              _this9.$emit('deletetask', { 'task_id': _this9.taskid, 'state_id': _this9.old_state, 'event': 'delete', 'project_id': _this9.projectid, 'date_end': _this9.infor_task.time_end });
              _this9.closeDialog();
            }
          }).catch(function (error) {
            console.log(error.message);
          });
        }
      });
    },
    get_member: function get_member() {
      var _this10 = this;

      // console.log(this.roomid)
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.roomid
      }).then(function (response) {
        if (response.data.status === 'success') {
          var member_active = [];
          member_active = response.data.data_room;
          _this10.member = _.filter(member_active, function (o) {
            return o.type !== 'bot' && o.type !== 'business' && o.statemember == 'active';
          });
          _this10.member.push({
            tokenuser: _this10.token,
            name: localStorage.getItem('name'),
            profilepicture: localStorage.getItem('profilepicture')
          });
          // intersection เพราะเวลาที่มีคนออกจากกลุ่มแล้วทำให้แก้ไข task ไม่ได้
          _this10.selectemember = _.map(_.intersectionBy(_this10.member, _this10.infor_task.assign, 'tokenuser'), 'tokenuser');
        }
      }).catch(function (error) {
        console.log(error.message);
      });
    },
    getstate: function getstate() {
      var _this11 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_state_by_project', {
        tokenuser: this.token,
        tokenroom: this.roomid,
        project_id: this.projectid
      }).then(function (response) {
        _this11.state = response.data.data.state;
        // this.state_id = response.data.data.state[0].state_id
      }).catch(function (error) {
        console.log(error.message);
      });
    }
  },
  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.date);
    }
  },
  watch: {
    dialogDetailTask: function dialogDetailTask() {
      var _this12 = this;

      // this.infor_task = {}
      if (this.dialogDetailTask) {
        this.progress = true;
        this.infor_task = {};
        this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_task_by_id', {
          tokenuser: this.token,
          task_id: this.taskid
        }).then(function (response) {
          // console.log(response.data.data)
          if (response.data.status === 'success') {
            _this12.progress = false;
            _this12.infor_task = response.data.data;
            // console.log(this.infor_task)
            _this12.old_state = _this12.infor_task.state.id;
            _this12.state_id = _this12.infor_task.state.id;
            _this12.check_list_start = _this12.infor_task.check_list;
            _this12.check_list = _.reverse(_this12.infor_task.check_list);
            // this.check_list = _.sortBy(this.infor_task.check_list, [function(o) { return o.label }])
            // console.log(this.check_list)
            _this12.projectid = _this12.infor_task.project_id;
            _this12.subject_task = _this12.infor_task.title;
            _this12.priority = _this12.infor_task.priority;
            _this12.start_date = _this12.infor_task.time_start.split(' ')[0];
            _this12.end_date = _this12.infor_task.time_end.split(' ')[0];
            _this12.detail_task = _this12.infor_task.detail;
            _this12.profilepicture = _this12.infor_task.owner_info.path_pic;
            _this12.nickname = _this12.infor_task.owner_info.nickname;
            _this12.state_name = _this12.infor_task.state.name;
            // this.selectemember = _.map(this.infor_task.assign, 'tokenuser')
            _this12.getstate();
            _this12.get_member();
            _this12.get_comment();
          }
        }).catch(function (error) {
          // console.log(error.message)
          // console.log(error.response.data.message)
          if (error.response.data.message == 'Not found task.') {
            _this12.progress = false;
            _this12.dialogDetailTask = false;
            _this12.closeDialog();
            _this12.$swal('', _this12.$t('Alert.Fail.Task.removed'), 'warning');
          }
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-721f816a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/manage_task/detail_task_dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"CSChatThai",staticStyle:{"overflow-y":"hidden"},attrs:{"persistent":"","max-width":"550"},model:{value:(_vm.dialogDetailTask),callback:function ($$v) {_vm.dialogDetailTask=$$v},expression:"dialogDetailTask"}},[_c('v-card',{staticStyle:{"border-radius":"15px"}},[_c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-toolbar',{staticClass:"toolbar-card-v2",attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"CSChatThai"},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.detail.header')))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.edit)?_c('header',{staticClass:"headerUser",attrs:{"id":"headerMenubarUser"}},[_c('nav',{staticClass:"headerUser__nav"},[_c('ul',{staticClass:"headerUser__navbar"},[_c('li',{staticClass:"headerUser__item"},[_c('a',{staticClass:"headerUser__link",attrs:{"href":"#"}},[_c('button',{key:"off",staticClass:"headerUser--btn",on:{"click":function($event){_vm.show = !_vm.show}}},[_c('v-icon',{staticClass:"headerUser--icon"},[_vm._v("more_vert")])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"dropdown"}},[(_vm.show)?_c('div',{staticClass:"headerUser__dropdown-menu",class:{ active: _vm.show }},[_c('ul',{staticClass:"headerUser__dropdown-menu-nav"},[_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.clickedit()}}},[_c('a',{staticClass:"header__dropdown-menu-link",attrs:{"href":"#"}},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu font-size15",attrs:{"meduim":""}},[_vm._v("mdi-pencil")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                             "+_vm._s(_vm.$t('Task.detail.menu.edit'))+"\n                           ")])])]),_vm._v(" "),_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":_vm.delete_task}},[_c('a',{staticClass:"header__dropdown-menu-link",attrs:{"href":"#"}},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu font-size15",attrs:{"meduim":""}},[_vm._v("far fa-trash-alt")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                             "+_vm._s(_vm.$t('Task.detail.menu.delete'))+"\n                           ")])])])])]):_vm._e()])],1)])])]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"black !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),(_vm.edit)?_c('v-card-text',{staticClass:"scrolling-wrapper",staticStyle:{"height":"70vh"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.subject'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject_task),expression:"subject_task"}],staticClass:"CSChatThai inputtaskweb",attrs:{"type":"text","placeholder":_vm.$t('Task.create.placeholderSubject')},domProps:{"value":(_vm.subject_task)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject_task=$event.target.value}}})]),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.priority'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-btn',{class:(_vm.priority=='1')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '1';}}},[_c('v-icon',{staticClass:"btn-pri1"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p1'))+"\n              ")],1),_vm._v(" "),_c('v-btn',{class:(_vm.priority=='2')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '2';}}},[_c('v-icon',{staticClass:"btn-pri2"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p2'))+"\n              ")],1),_vm._v(" "),_c('v-btn',{class:(_vm.priority=='3')? 'selectedPriority': '',staticStyle:{"text-transform":"none"},attrs:{"flat":""},on:{"click":function($event){_vm.priority = '3';}}},[_c('v-icon',{staticClass:"btn-pri3"},[_vm._v("mdi-checkbox-blank")]),_vm._v("    "+_vm._s(_vm.$t('Task.create.p3'))+"\n              ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.startDate'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-menu',{ref:"menu1",staticStyle:{"width":"25%"},attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.start_date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":""},on:{"update:returnValue":function($event){_vm.start_date=$event}},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"","readonly":""},slot:"activator",model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","allowed-dates":_vm.allowedDates,"locale":_vm.$t('Task.allTask.localepicker')},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu1 = false}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menu1.save(_vm.start_date)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.endDate'))),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-menu',{ref:"menu2",staticStyle:{"width":"25%"},attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.end_date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":""},on:{"update:returnValue":function($event){_vm.end_date=$event}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"","readonly":""},slot:"activator",model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","allowed-dates":_vm.allowedDatesEnd,"min":_vm.min_date_end,"locale":_vm.$t('Task.allTask.localepicker')},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu2 = false}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menu2.save(_vm.end_date)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.description'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-textarea',{staticStyle:{"width":"75%"},attrs:{"label":_vm.$t('Task.create.placeholderDescription'),"solo":"","no-resize":"","outline":"","height":"80","rows":"3","hide-details":""},model:{value:(_vm.detail_task),callback:function ($$v) {_vm.detail_task=$$v},expression:"detail_task"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.assign'))+" :")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-autocomplete',{staticStyle:{"width":"75%"},attrs:{"items":_vm.member,"label":_vm.$t('Task.create.placeholderAssign'),"item-text":"name","item-value":"tokenuser","multiple":"","chips":"","menu-props":{maxHeight:'auto'}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [(data.item.type !== 'bot')?_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selectemember,"close":""},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_c('v-avatar',[(data.item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":data.item.profilepicture}}):(data.item.type === 'company')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'government')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('span',{staticClass:"text-overflow-chip"},[_vm._v(_vm._s(data.item.name))])],1):_vm._e()]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[(data.item.type !== 'bot')?_c('v-list-tile-avatar',[(data.item.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":data.item.profilepicture}}):(data.item.type === 'company')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'government')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(data.item.type === 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[(data.item.type !== 'bot')?_c('v-list-tile-title',{staticClass:"text-overflow"},[_vm._v(_vm._s(data.item.name))]):_vm._e()],1)]]}}]),model:{value:(_vm.selectemember),callback:function ($$v) {_vm.selectemember=$$v},expression:"selectemember"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.status'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-select',{staticStyle:{"padding":"0","width":"25%"},attrs:{"items":_vm.state,"outlined":"","hide-details":"","item-text":"name","item-value":"state_id"},model:{value:(_vm.state_id),callback:function ($$v) {_vm.state_id=$$v},expression:"state_id"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubject",attrs:{"sm4":"","md4":"","xl4":"","lg4":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.checklist'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-layout',{staticClass:"mr-1",attrs:{"row":"","wrap":"","align-start":"","justify-start":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject_checklist),expression:"subject_checklist"}],staticClass:"CSChatThai inputchecklistweb",attrs:{"type":"text","placeholder":_vm.$t('Task.create.placeholderChecklist')},domProps:{"value":(_vm.subject_checklist)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject_checklist=$event.target.value}}})]),_vm._v(" "),_c('v-layout',{staticClass:"mr-2",attrs:{"row":"","wrap":"","align-end":"","justify-end":""}},[_c('v-btn',{staticClass:"btncreate-comment",attrs:{"disabled":_vm.subject_checklist == ''},on:{"click":function($event){_vm.add_checklist()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.keep')))])],1),_vm._v(" "),_vm._l((_vm.check_list),function(item,index){return (item.disable != '1')?_c('v-layout',{staticClass:"mt-2 border-checklist",attrs:{"row":"","wrap":"","justify-center":""}},[_c('div',{staticClass:"item"},[(item.check == 'true')?_c('input',{attrs:{"type":"checkbox","checked":""},domProps:{"value":item.check},on:{"change":function($event){_vm.onModifyClick($event, index)}}}):_c('input',{attrs:{"type":"checkbox"},domProps:{"value":item.check},on:{"change":function($event){_vm.onModifyClick($event, index)}}}),_vm._v(" "),(item.check == 'true')?_c('p',[_vm._v(_vm._s(item.label))]):_c('p',[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","color":"grey","flat":"","icon":"","small":""},on:{"click":function($event){_vm.delete_checklist(item.id, index)}},slot:"activator"},[_c('v-icon',{staticClass:"font-size15"},[_vm._v("fas fa-trash-alt")])],1)],1)]):_vm._e()})],2)],1),_vm._v(" "),_c('v-layout',{staticClass:"mr-5",staticStyle:{"margin-top":"15px"},attrs:{"row":"","wrap":"","align-end":"","justify-end":""}},[_c('v-btn',{staticClass:"btncancle",on:{"click":function($event){_vm.cancel_task()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"btncreate",attrs:{"loading":_vm.isloading,"disabled":_vm.subject_task == '' || _vm.priority == undefined || _vm.start_date == '' || _vm.end_date == ''},on:{"click":function($event){_vm.edit_task()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.keep')))])],1)],1):_c('v-card-text',{staticClass:"CSChatThai scrolling-wrapper",staticStyle:{"height":"70vh"}},[(_vm.progress)?_c('v-layout',{staticStyle:{"height":"100% !important"},attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":"100","color":"primary","indeterminate":_vm.progress}})],1):_c('v-layout',{staticClass:"mb-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","sm2":"","md2":"","xl2":"","lg2":""}},[_c('v-icon',{class:'btn-pri'+ _vm.priority,staticStyle:{"margin-left":"10px"}},[_vm._v("mdi-checkbox-blank")])],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","sm10":"","md10":"","xl10":"","lg10":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","xl12":"","lg12":""}},[_c('h3',{staticStyle:{"color":"#003459","margin-right":"10px"}},[_vm._v(_vm._s(_vm.infor_task.title))])]),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-chip',{staticClass:"ma-2",staticStyle:{"margin":"0 !important","background":"#e6ecf3 !important","color":"#51819e !important","font-weight":"700"},attrs:{"label":"","text-color":"white","small":""}},[_vm._v("\n                "+_vm._s(_vm.state_name)+"\n              ")]),_vm._v(" "),(_vm.start_date || _vm.end_date)?_c('span',{staticClass:"mb-0",staticStyle:{"font-size":"12px","color":"#a6a6a6"}},[_vm._v(_vm._s(_vm.formatDate(_vm.start_date))+" "),(_vm.start_date && _vm.end_date)?_c('span',[_vm._v(" - ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.formatDate(_vm.end_date))+"\n              ")]):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.infor_task.detail)?_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"sm12":"","md12":"","xl12":"","lg12":""}},[_c('div',{staticClass:"descriptionTask"},[_c('read-more',{staticClass:"mb-0 font-size-15",attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":_vm.infor_task.detail ? _vm.infor_task.detail: '-',"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":100}}),_vm._v(" "),(_vm.infor_task.sign_info != undefined)?_c('v-btn',{staticClass:"btn-sign-doc",attrs:{"small":""},on:{"click":function($event){_vm.sign_doc(_vm.infor_task.sign_info)}}},[_vm._v(_vm._s(_vm.infor_task.sign_info.label))]):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"textSubjectDetail",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',{staticClass:"font-size-15"},[_vm._v(_vm._s(_vm.$t('Task.detail.createBy'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px !important"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-chip',{staticStyle:{"background":"#e6ecf3 !important"}},[_c('v-avatar',[(_vm.profilepicture)?_c('img',{staticClass:"object-fit-img",attrs:{"src":_vm.profilepicture}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('span',{staticClass:"text-overflow-chip"},[_vm._v("\n              "+_vm._s(_vm.nickname)+"\n            ")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"textSubjectDetail",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',{staticClass:"font-size-15"},[_vm._v(_vm._s(_vm.$t('Task.create.assign'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px !important"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},_vm._l((_vm.infor_task.assign),function(item,index){return _c('v-chip',{staticStyle:{"background":"#e6ecf3 !important"}},[_c('v-avatar',{staticClass:"teal"},[(item.path_pic)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.path_pic}}):(item.type == 'user')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}}):(item.type == 'bot')?_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('span',{staticClass:"text-overflow-chip"},[_vm._v("\n              "+_vm._s(item.nickname)+"\n            ")])],1)})),_vm._v(" "),(_vm.check_list.length != 0)?_c('v-flex',{staticClass:"textSubjectDetail",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('Task.create.checklist'))+" :")])]):_vm._e(),_vm._v(" "),(_vm.check_list.length != 0)?_c('v-flex',{staticStyle:{"margin-top":"20px"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},_vm._l((_vm.check_list),function(item,index){return (item.disable != '1')?_c('v-layout',{staticClass:"mt-2 border-checklist",attrs:{"row":"","wrap":"","justify-center":""}},[_c('div',{staticClass:"item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(item.check == 'true')?_c('v-icon',{staticClass:"font-size18",attrs:{"color":"primary","disabled":""}},[_vm._v("fas fa-check-square")]):_c('v-icon',{staticClass:"font-size18",attrs:{"color":"primary","disabled":""}},[_vm._v("far fa-square")]),_vm._v(" "),(item.check == 'true')?_c('span',{staticClass:"ml-2 span-line"},[_vm._v(_vm._s(item.label))]):_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(item.label))])],1)],1)]):_vm._e()})):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"textSubjectDetail",attrs:{"sm3":"","md3":"","xl3":"","lg3":""}},[_c('span',{staticClass:"font-size-16"},[_vm._v(_vm._s(_vm.$t('Task.create.comment'))+" :")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px !important"},attrs:{"sm8":"","md8":"","xl8":"","lg8":""}},[_c('v-layout',{staticClass:"mb-2",attrs:{"row":"","wrap":"","align-center":"","justify-end":""}},[_c('v-textarea',{staticStyle:{"width":"75%","margin-right":"10px","margin-top":"10px"},attrs:{"label":_vm.$t('Task.create.placeholderComment'),"solo":"","no-resize":"","outline":"","height":"80","rows":"3","hide-details":""},model:{value:(_vm.comment_task),callback:function ($$v) {_vm.comment_task=$$v},expression:"comment_task"}}),_vm._v(" "),_c('v-btn',{staticClass:"btncreate-comment",attrs:{"disabled":_vm.comment_task == ''},on:{"click":function($event){_vm.add_comment()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.send')))])],1),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":""}},_vm._l((_vm.listcomment),function(item,index){return _c('v-card',{staticClass:"card-comment"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-3 ml-2",attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}},[_c('v-avatar',{attrs:{"size":"40px"}},[(item.path_pic)?_c('img',{staticClass:"object-fit-img",attrs:{"src":item.path_pic,"alt":"alt"}}):_c('img',{staticClass:"object-fit-img",attrs:{"src":"/static/img/default_profile/man-white.png","alt":"alt"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","sm9":"","md9":"","xl9":"","lg9":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"ml-3"},[_c('div',{staticClass:"text-overflow-comment"},[_vm._v(_vm._s(item.nickname))]),_vm._v(" "),_c('read-more',{staticClass:"mb-0 mr-5",staticStyle:{"width":"260px !important"},attrs:{"more-str":_vm.$t('ChatSide.Read.readmore'),"text":item.comment,"link":"#","less-str":_vm.$t('ChatSide.Read.readless'),"max-chars":80}})],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":"","xl1":"","lg1":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","color":"black","icon":"","flat":""},on:{"click":function($event){_vm.delete_commemt(item.comment_id)}},slot:"activator"},[_c('v-icon',{staticStyle:{"color":"rgba(0,0,0,.87)","font-size":"16px"}},[_vm._v("fas fa-trash")])],1)],1)],1)],1)}))],1)],1)],1),_vm._v(" "),_c('WebviewBigDialog',{attrs:{"dialogWebviewbig":_vm.dialogWebviewbig,"Webview_item":_vm.Webview_item},on:{"closeWebview":_vm.closeWebview}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var manage_task_detail_task_dialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/manage_task/detail_task_dialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("/XvZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-721f816a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  detail_task_dialog,
  manage_task_detail_task_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var chat_manage_task_detail_task_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l5uE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lNvL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lxd9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m0Iv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mHWE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mKv4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mQQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_pathify__ = __webpack_require__("YtWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("+vOg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
// import { mapState } from 'vuex'



/* harmony default export */ __webpack_exports__["a"] = ({
  props: { dialogManageGroup: false, detail: '' },
  data: function data() {
    return {
      token: '',
      selectFile: '',
      imageData: '',
      picgroup: '',
      edit: false,
      nameedit: ''
    };
  },
  methods: {
    editprofile: function editprofile() {
      this.edit = !this.edit;
      this.nameedit = this.detail.group_name;
    },
    uppic: function uppic() {
      $('#uploadpicturegroup').click();
    },
    closeManageGroup: function closeManageGroup() {
      this.$emit('closeManageGroup', false);
      this.selectFile = '';
      this.imageData = '';
    },

    previewImage: function previewImage(event) {
      var _this = this;

      var input = event.target;
      this.selectFile = event.target.files[0];
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this.imageData = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImagegroup: function previewImagegroup() {
      var _this2 = this;

      this.selectFile = event.target.files[0];
      if (this.selectFile !== '') {
        var uploadFile = new FormData();
        uploadFile.append('file', this.selectFile, this.selectFile.name);
        uploadFile.append('group_id', this.detail.group_id);
        uploadFile.append('tokenuser', this.token);
        this.axios.post("https://uatchat-manage.one.th/manage" + '/setimagegroup', uploadFile).then(function (response) {
          // console.log(response.data)
          if (response.data['status'] === 'success') {
            _this2.detail.picture = response.data.filename;
            _this2.selectFile = '';
            document.querySelector('#uploadpicturegroup').value = '';
            _this2.$swal('', _this2.$t('Alert.Success.changePictureGroup'), 'success');
          } else {
            // console.log('fail')
            _this2.selectFile = '';
            document.querySelector('#uploadpicturegroup').value = '';
            _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
          }
        }, function () {
          _this2.selectFile = '';
          document.querySelector('#uploadpicturegroup').value = '';
          _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
        });
      }
    },
    changeprofile: function changeprofile() {
      var _this3 = this;

      this.edit = !this.edit;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/setnamegroup', { tokenuser: this.token, groupname: this.nameedit, group_id: this.detail.group_id }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          _this3.detail.group_name = _this3.nameedit;
          _this3.$swal('', _this3.$t('Alert.Success.renameGroup'), 'success');
        }
      }, function () {
        _this3.nameedit = _this3.detail.group_name;
        _this3.$swal('', _this3.$t('Alert.Fail.default.somethingWrong'), 'error');
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex_pathify__["c" /* sync */])('*')),
  watch: {
    dialogManageGroup: function dialogManageGroup() {
      if (this.dialogManageGroup) {}
    }
  },
  created: function created() {
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "mS+9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_homepage_Navbar__ = __webpack_require__("6n5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_pathify__ = __webpack_require__("YtWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_chat_dialog_SelectAccount__ = __webpack_require__("YTSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chenfengyuan_vue_countdown__ = __webpack_require__("aCbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chenfengyuan_vue_countdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__chenfengyuan_vue_countdown__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import NewFooter from '@/components/home/NewFooter'
// import { sync } from 'vuex-pathify'





__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_7__chenfengyuan_vue_countdown___default.a.name, __WEBPACK_IMPORTED_MODULE_7__chenfengyuan_vue_countdown___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    Dialogselectaccount: __WEBPACK_IMPORTED_MODULE_6__components_chat_dialog_SelectAccount__["a" /* default */],
    Navbar: __WEBPACK_IMPORTED_MODULE_3__components_homepage_Navbar__["a" /* default */]
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex_pathify__["c" /* sync */])('*')),
  data: function data() {
    var _this = this;

    return {
      type: 'first',
      phoneNumber: '',
      content: '',
      date: null,
      dateShow: null,
      dateThai: null,
      conditions: false,
      valid: false,
      name: '',
      isLoading: false,
      phoneRules: [function (v) {
        return !!v && v.length === 10 || _this.$t('Homepage.Dialog.inputphoneErrorDigit');
      }, function (v) {
        return !!v || _this.$t('Homepage.Dialog.inputphoneErrorNumber');
      }, function (v) {
        return (/^0[0-9]{9}/.test(v) || _this.$t('Homepage.Dialog.inputphoneErrorFormat')
        );
      }],
      checkbox: false,
      webdev: "https://uatchat.one.th:8089/docs",
      counting: false,
      otpCode: '',
      mobile_ref_id: '',
      Refcode: '',
      type_otp: '',
      dialogSelectaccount: false,
      list_accounts: []
    };
  },
  created: function created() {
    // this.$i18n.locale = 'th'
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
    this.content = this.$t('Register.content');
  },

  methods: {
    loginWithotp2: function loginWithotp2() {
      this.isLoading = true;
      this.dialogSelectaccount = true;
    },
    loginWithotp: function loginWithotp() {
      var _this2 = this;

      this.isLoading = true;
      if (localStorage.type_register === 'true') {
        var source = {
          type_otp: this.type_otp,
          phone: this.phoneNumber,
          otp: this.otpCode,
          mobile_ref_id: this.mobile_ref_id,
          consent_status: "Y"
        };
      } else {
        var source = {
          type_otp: this.type_otp,
          phone: this.phoneNumber,
          otp: this.otpCode,
          mobile_ref_id: this.mobile_ref_id
        };
      }
      // console.log(source)
      this.axios.post("https://uatchat-manage.one.th/manage" + '/v2/login_and_regis', source).then(function (response) {
        _this2.status = response.data['status'];
        if (_this2.status === 'success') {
          // console.log(response)
          if (response.data.list_accounts !== undefined) {
            _this2.list_accounts = response.data.list_accounts;
            // console.log(this.list_accounts)
            _this2.dialogSelectaccount = true;
          } else {
            var profile = response.data['account']['profile'];
            _this2.myprofilepicture = profile['profilepicture'];
            _this2.myname = profile['name'];
            _this2.$cookie.set('language', 'th');
            localStorage.setItem('Authenrization', __WEBPACK_IMPORTED_MODULE_4__services__["b" /* Encode */].encode({
              'tokenuser': profile['tokenuser'],
              'status_login': 'T',
              'type_user': profile['type']
            }));
            localStorage.setItem('profilepicture', profile['profilepicture']);
            localStorage.setItem('name', profile['name']);
            localStorage.setItem('phone', profile['phone']);
            localStorage.setItem('email', profile['email']);
            localStorage.setItem('status', profile['status']);
            localStorage.setItem('type_user', profile['type']);
            localStorage.setItem('wallpaperInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
              'info': [{
                'room': '',
                'background': ''
              }]
            }));
            if (profile['username'] === '' || profile['username'] === 'None') {
              localStorage.setItem('status_username', 'false');
            } else {
              localStorage.setItem('status_username', 'true');
            }
            _this2.isLoading = false;
            if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
              _this2.$router.push('/chat');
            } else {
              _this2.$router.push(localStorage.getItem('pathRoom'));
            }
          }
        } else if (response.data['message'] === 'The resource owner or authorization server denied the request.') {
          _this2.$cookie.set('status_login', 'F');
          _this2.progress = false;
          _this2.$swal('', _this2.$t('Alert.Login.otpInvalid'), 'error');
        } else {
          _this2.$cookie.set('status_login', 'F');
          _this2.progress = false;
          _this2.$swal('', response.data['message'], 'error');
        }
      }, function (error) {
        console.log(error);
        _this2.status = 'fail';
        _this2.isLoading = false;
        _this2.failmessage = _this2.$t('Alert.Fail.default.somethingWrong');
      });
    },
    getotp3: function getotp3() {
      // this.type = "otp"
      this.dialogSelectaccount = true;
    },
    getotp: function getotp() {
      var _this3 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/v2/otp_login_and_regis', {
        phone: this.phoneNumber,
        type: 'register'
      }).then(function (response) {
        // console.log(response)
        if (response.data['status'] === 'success') {
          // console.log(response.data)
          if (response.data.type_otp == 'register') {
            localStorage.type_register = true;
            // console.log('type otp = register')
            _this3.Refcode = response.data.refcode;
            _this3.mobile_ref_id = response.data.mobile_ref_id;
            _this3.type_otp = response.data.type_otp;
            _this3.counting = true;
            _this3.type = "otp";
          } else if (response.data.type_otp == 'login') {
            _this3.$swal('', _this3.$t('Alert.Login.phoneVerify'), 'error');
            // this.Refcode = response.data.refcode
            // this.mobile_ref_id = response.data.mobile_ref_id
            // this.type_otp = response.data.type_otp
            // this.counting = true
            // this.type="otp"
            // console.log('type otp = login')
          } else if (response.data.type_otp == 'select accounts') {
            // console.log('type otp = select account')
            _this3.Refcode = response.data.refcode;
            _this3.mobile_ref_id = response.data.mobile_ref_id;
            _this3.type_otp = response.data.type_otp;
            _this3.counting = true;
            _this3.type = "otp";
            // this.dialogSelectaccount = true
          } else {
            _this3.phone = '';
            _this3.$swal('', _this3.$t('Alert.Login.phoneVerify'), 'error');
          }
        }
      }, function (error) {
        console.log(error);
        _this3.status = 'fail';
        _this3.isLoading = false;
        _this3.type = 'first';
        _this3.failmessage = _this3.$t('Alert.Fail.default.somethingWrong');
      });
    },
    handleCountdownEnd: function handleCountdownEnd() {
      this.OTP = '';
      this.counting = false;
    },
    openlink: function openlink(path) {
      window.open(path, '_blank');
    },
    toNewTab: function toNewTab() {
      window.open(this.webdev, '_blank').focus();
    },
    linkAPI: function linkAPI() {
      window.open('/docs', '_blank').focus();
    },
    toPage: function toPage(page) {
      this.$router.push(page);
    },
    linkregister: function linkregister() {
      window.open('/register').focus();
    },
    linkdownload: function linkdownload() {
      window.open('/download').focus();
    },
    isMobile: function isMobile() {
      if ($('#mobile').is(':hidden')) {
        return false;
      } else {
        return true;
      }
    },
    backtoInputphone: function backtoInputphone() {
      var _this4 = this;

      this.$swal({
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Login.previouspage'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          // this.valid = false
          _this4.type = "first";
          _this4.phoneNumber = '';
          _this4.Refcode = '';
          _this4.mobile_ref_id = '';
          _this4.type_otp = '';
          _this4.counting = false;
          _this4.checkbox = false;
        }
      });
    },
    closeSelectaccount: function closeSelectaccount(value) {
      this.dialogSelectaccount = value;
    }
  },
  watch: {
    '$i18n.locale': function $i18nLocale() {
      // this.$i18n.locale = 'th'
      this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
      this.content = this.$t('Register.content');
    },
    date: function date() {
      if (this.date !== null) {
        var year = (parseInt(this.date.split('-')[0]) + 543).toString();
        this.dateShow = this.date.split('-')[2] + '-' + this.date.split('-')[1] + '-' + year;
        this.dateThai = year - 543 + '-' + this.date.split('-')[1] + '-' + this.date.split('-')[2];
      }
    },
    menu: function menu(val) {
      var _this5 = this;

      val && this.$nextTick(function () {
        return _this5.$refs.picker.activePicker = 'YEAR';
      });
    },
    dialogSelectaccount: function dialogSelectaccount() {
      // console.log(this.dialogSelectaccount)
      if (this.dialogSelectaccount == false) {
        // console.log('test เข้า false')
        this.type = "otp";
        this.isLoading = false;
      }
    }
  }
  // computed: {
  //   valid () {
  //     return (
  //       this.phoneNumber &&
  //       this.username &&
  //       this.password &&
  //       this.checkbox
  //     )
  //   }
  // },
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "mdMH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nCeM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nIDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/chat/dialog/ShowPDFDialog.vue + 2 modules
var ShowPDFDialog = __webpack_require__("blpm");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/dialogGetPassword.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var dialogGetPassword = ({
  components: {
    ShowPDFDialog: ShowPDFDialog["a" /* default */]
  },
  props: {
    dialogGetPassword: Boolean,
    DetailFile: Object
  },
  data: function data() {
    return {
      progressBtn: false,
      passwordFile: '',
      dialogshowfile: false

    };
  },

  methods: {
    submitPassword: function submitPassword() {
      var _this = this;

      this.tokenmsg_file_pass = this.DetailFile.tokenmessage;
      this.name_file_pass = this.DetailFile.file_name;
      // this.tokenmessage
      this.progressBtn = true;
      var body = {
        tokenmessage: this.tokenmsg_file_pass,
        password: this.passwordFile
        // console.log(process.env.check_password + 'api/v1/check-password' , body)
      };this.axios.post("https://uatchat-manage.one.th/bot-message/check" + '/api/v1/check-password', body).then(function (response) {
        if (response.status == '200') {
          _this.progressBtn = false;
          if (response.data.message == 'wrong password') {
            _this.$swal(_this.$t('File.wrongPassword'), '', 'error');
          } else if (response.data.status == 'success') {
            var message = response.data.path;
            var filename = response.data.path.split('.');
            // this.dialogGetPassword = false
            _this.closeDialogGetpassword();
            _this.passwordFile = '';
            _this.axios.get(response.data.path, {
              responseType: 'blob'
            }).then(function (response) {
              if (filename[filename.length - 1] == 'pdf') {
                // message
                _this.DetailFile.message = message;
                _this.dialogshowfile = true;
              } else {
                var url = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', _this.name_file_pass + '.' + filename[filename.length - 1]);
                document.body.appendChild(link);
                link.click();
              }
            });
          } else {
            _this.$swal(_this.$t('Alert.Fail.default.somethingWrong'), '', 'error');
            _this.progressBtn = false;
          }
        }
      }).catch(function (err) {
        // console.log(err)
        // console.log(err.response)
        _this.$swal(_this.$t('Alert.Fail.default.somethingWrong'), '', 'error');
        _this.progressBtn = false;
      });
      // console.log('ddddddddddddddddddddd')
    },
    closeDialogGetpassword: function closeDialogGetpassword() {
      this.passwordFile = '';
      this.$emit('closeDialogpassword', false);
    },
    cancle: function cancle() {
      this.passwordFile = '';
      this.$emit('closeDialogpassword', false);
    },
    closeDialogShowFile: function closeDialogShowFile(value) {
      this.dialogshowfile = value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e46dcbc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/dialogGetPassword.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistant":"","width":"600"},model:{value:(_vm.dialogGetPassword),callback:function ($$v) {_vm.dialogGetPassword=$$v},expression:"dialogGetPassword"}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text"}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":function($event){_vm.closeDialogGetpassword()}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('v-card',[_c('div',{staticClass:"pt-4 pb-4 pr-4 pl-4"},[_c('span',{staticStyle:{"font-size":"18px","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('File.textRequirePassword')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{staticClass:"mt-2",attrs:{"solo":"","label":_vm.$t('File.passwordFile'),"clearable":"","append-icon":"search"},model:{value:(_vm.passwordFile),callback:function ($$v) {_vm.passwordFile=$$v},expression:"passwordFile"}}),_vm._v(" "),_c('v-layout',{attrs:{"justify-end":""}},[_c('v-btn',{staticStyle:{"background-color":"white","color":"#2562af","border-color":"#2562af"},attrs:{"outline":"","round":""},on:{"click":function($event){_vm.cancle()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))]),_vm._v(" "),_c('v-btn',{staticStyle:{"background-color":"#2562af","color":"white"},attrs:{"round":"","disabled":_vm.passwordFile == '' || _vm.passwordFile == null ? true : false,"loading":_vm.progressBtn},on:{"click":function($event){_vm.submitPassword()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))])],1),_vm._v(" "),_c('ShowPDFDialog',{attrs:{"dialogshowfile":_vm.dialogshowfile,"DetailFile":_vm.DetailFile},on:{"closeDialogShowFile":_vm.closeDialogShowFile}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_dialogGetPassword = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/dialogGetPassword.vue
function injectStyle (ssrContext) {
  __webpack_require__("L6bM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e46dcbc0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  dialogGetPassword,
  dialog_dialogGetPassword,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var chat_dialog_dialogGetPassword = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nwzZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o+65":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oyy4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p43r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p4dp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p91b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pP2O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mobile_dialog_QrcodeDialogMobile__ = __webpack_require__("RH2/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mobile_dialog_InviteGroupDialogMobile__ = __webpack_require__("LW8+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mobile_dialog_ManageGroupDialogMobile__ = __webpack_require__("aWhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mobile_dialog_NoteDialogMobile__ = __webpack_require__("QaDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mobile_dialog_CreateNoteDialogMobile__ = __webpack_require__("0xP5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mobile_dialog_AlbumsDialogMobile__ = __webpack_require__("HFu5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mobile_dialog_CreateAlbumsDialogMobile__ = __webpack_require__("//W+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mobile_dialog_InforfriendDialogMobile__ = __webpack_require__("gbCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mobile_dialog_SaveoneboxDialogMobile__ = __webpack_require__("UtNl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_chat_dialog_consent_check_consent_dialog__ = __webpack_require__("zPBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex_pathify__ = __webpack_require__("YtWf");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import LeaveGroup from '@/components/chat/LeaveGroup'











// import DetailFriend from '@/components/chat/DetailFriend'
// import VueGallerySlideshow from 'vue-gallery-slideshow'
// import vuegalleryslideshow from '@/components/chat/gallery-slideshow'
var _ = __webpack_require__("M4fF");
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dataConsent: '',
      isAccept: false,
      checkconsentDialog: false,
      url_consent: '',
      share_token: '',
      Bot_idcovid: "Bbe2c9fe1bcc956738a61c9ad0d91cb19",
      images: [],
      index: null,
      dialogSaveOnebox: false,
      tokenmessage_savebox: '',
      dialogQrcode: false,
      profilepicture: '',
      progressNote: false,
      detail: {},
      showmorefile: false,
      showmoreimage: false,
      dialogNote: false,
      dialogManageGroup: false,
      dialogCreatealbums: false,
      note_id: '',
      friend: '',
      token: '',
      // noti: false,
      members: {},
      membersGroup: {},
      member: [],
      memberpending: [],
      dialogInvite: false,
      LeaveGroup: false,
      SetpicGroup: false,
      edit: false,
      room: '',
      activeinfo: 'tab-1',
      // DetailFriend: '',
      relation: '',
      tokenMember: [],
      tokenMemberpending: [],
      listMenu: [],
      listimageinroom: [],
      listfileinroom: [],
      listnote: [],
      selectFile: '',
      dateSend: '',
      timeSend: '',
      nicknameSend: '',
      filenameSend: '',
      tokenmsgSend: '',
      pathSend: '',
      picSend: '',
      name: '',
      typeuser: '',
      shownotes: false,
      dialogCreatenote: false,
      business_id: '',
      windowWidth: '',
      showalbum: false,
      listalbum: [],
      filter_infoalbum: [],
      albums_id: '',
      dialogAlbums: false,
      tokeninforfriend: '',
      inforfrienddialog: false,
      pagemember: 0,
      limit: 10,
      pagepending: 0,
      memberactive: []
    };
  },
  methods: {
    setListMenu: function setListMenu() {
      this.listMenu = [{
        icon: 'group_add',
        title: this.$t('RightSide.menu.invite'),
        dialog: 'Invite',
        color: 'gray'
      }, {
        icon: 'settings',
        title: this.$t('RightSide.menu.setting'),
        dialog: 'ManageGroup',
        color: 'gray'
      }];
    },
    getmember: function getmember() {
      var _this = this;

      // get member from api jame keep in this.memberpending and this.memberactive
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v2/get-user-group', {
        group_id: this.detail.group_id,
        page: this.pagemember,
        limit: this.limit,
        filter: 'active'
      }).then(function (response) {
        if (response.data.status === 'success') {
          if (_this.pagemember == 0) {
            _this.memberactive = response.data.member;
          } else {
            _this.memberactive.push.apply(_this.memberactive, response.data.member);
          }
          _this.pagemember = _this.pagemember + 1;
        } else {
          // this.progressNote = false
        }
      });
    },
    getpending: function getpending() {
      var _this2 = this;

      // get member from api jame keep in this.memberpending and this.memberactive
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v2/get-user-group', {
        group_id: this.detail.group_id,
        page: this.pagepending,
        limit: this.limit,
        filter: 'pending'
      }).then(function (response) {
        if (response.data.status === 'success') {
          if (_this2.pagemember == 0) {
            _this2.memberpending = response.data.member;
          } else {
            _this2.memberpending.push.apply(_this2.memberpending, response.data.member);
          }
          _this2.pagepending = _this2.pagepending + 1;
        } else {
          // this.progressNote = false
        }
      });
    },
    closeDialogConsent: function closeDialogConsent(value) {
      this.url_consent = '';
      this.checkconsentDialog = value;
    },
    getAccesstoken: function getAccesstoken() {
      var _this3 = this;

      this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", {
        tokenuser: this.token,
        url: ''
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this3.share_token = response.data.data.url;
          _this3.check_consent(response.data.data.url);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    check_consent: function check_consent(token) {
      var _this4 = this;

      this.axios.post(this.dataConsent.endpoint, {
        tax_id: this.dataConsent.tax_id,
        shared_token: token,
        service_id: this.dataConsent.service_id,
        consent_form_id: this.dataConsent.consent_form_id
      }).then(function (response) {
        if (response.data.result === 'success') {
          _this4.url_consent = '';
          // localStorage.setItem('check_consent', response.data.data.status)
          if (response.data.data.status === 'approved') {
            _this4.checkconsentDialog = true;
            _this4.url_consent = response.data.data.response.elements.choice.url + token;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadfile: function loadfile(item) {
      // console.log(item)
      this.axios.get(item.path, { responseType: 'blob' }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', item.file_name);
        document.body.appendChild(link);
        link.click();
      });
    },
    wallpaper: function wallpaper() {
      this.$router.push('/mobile/wallpaper/' + this.$route.params.roomid);
    },
    detailGroup: function detailGroup(detailgroup) {
      // console.log(detailgroup)
      if (detailgroup.picture == '') {
        detailgroup.picture = '/static/img/default_profile/group-white.png';
      }
      this.$swal({
        imageUrl: detailgroup.picture,
        imageHeight: 250,
        showCloseButton: true,
        showConfirmButton: false
      });
    },
    detailimageFriend: function detailimageFriend(detailfriend) {
      // console.log(detailfriend)
      if (detailfriend.profilepicture == '') {
        detailfriend.profilepicture = '/static/img/default_profile/man-white.png';
      }
      this.$swal({
        imageUrl: detailfriend.profilepicture,
        imageHeight: 250,
        showCloseButton: true,
        showConfirmButton: false
      });
    },
    daletechat: function daletechat(tokenroom, detailroom) {
      var _this5 = this;

      // console.log(detailroom)
      this.$swal({
        // title: detailroom,
        // text: 'คุณต้องการลบแชท ' + detailroom +' ใช่หรือไม่?',
        text: this.$t('Alert.Right.clearChat'),
        type: 'warning',
        // imageUrl: '../assets/image/block.png',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this5.axios.post("https://uatchat-manage.one.th/manage" + '/setisactive', { tokenroom: tokenroom, tokenuser: _this5.token, is_active: 'false' }).then(function (response) {
            // console.log(response.data)
            if (response.data.status === 'success') {
              _this5.chIsactive = tokenroom;
            }
          });
        }
      });
    },
    loadpic: function loadpic(filenameSend) {
      this.axios.get(this.pathSend, { responseType: 'blob' }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filenameSend);
        document.body.appendChild(link);
        link.click();
      });
    },
    sendimgonebox: function sendimgonebox(tokenmessage) {
      // console.log(this.dialogSaveOnebox)
      this.dialogSaveOnebox = true;
      this.tokenmessage_savebox = tokenmessage;
    },
    closeSaveOnebox: function closeSaveOnebox(value) {
      this.dialogSaveOnebox = false;
    },
    toPage: function toPage() {
      this.$emit('chat', true);
      this.$router.push('/mobile/room/' + this.$route.params.roomid);
    },
    toPageTask: function toPageTask(path) {
      // console.log(path)
      this.$router.push(path + this.$route.params.roomid);
    },
    toTab: function toTab(tab) {
      if (tab === 1) {
        this.tabs = 'tab-1';
        // console.log(this.tabs)
      } else if (tab === 2) {
        this.tabs = 'tab-2';
        // console.log(this.tabs)
      } else if (tab === 3) {
        this.tabs = 'tab-3';
        // console.log(this.tabs)
      }
    },
    invitemembergroup: function invitemembergroup() {
      // this.getdataroom()
    },
    closeNote: function closeNote(value) {
      this.dialogNote = value;
    },
    closeAlbums: function closeAlbums(value) {
      this.dialogAlbums = value;
    },
    closeManageGroup: function closeManageGroup(value) {
      this.dialogManageGroup = value;
    },
    closeCreatenote: function closeCreatenote(value) {
      this.dialogCreatenote = value;
    },
    closeCreatealbums: function closeCreatealbums(value) {
      this.dialogCreatealbums = value;
    },
    closeInforfriend: function closeInforfriend(value) {
      this.inforfrienddialog = value;
    },
    editNote: function editNote(msg, id) {
      // console.log(msg)
      // console.log(id)
      var _ = __webpack_require__("M4fF");
      var indexid = _.findIndex(this.listnote, function (o) {
        return o.note_id === id;
      });
      this.listnote[indexid]['note_data']['text'] = msg;
      // _.update(listnote, 'note_id',  })
    },
    CreateAlbums: function CreateAlbums(status, infoalbums) {
      // console.log(status)
      // console.log(infoalbums)
      // console.log(this.listalbum)
      if (status === 'success') {
        this.listalbum.unshift(infoalbums);
      }
    },
    editAlbums: function editAlbums(data) {
      // console.log(data)
      // console.log(this.listalbum)
      if (data.event === 'edit_name') {
        var indexid = _.findIndex(this.listalbum, function (o) {
          return o._id === data.albums_id;
        });
        this.listalbum[indexid]['albums_name'] = data.albums_name;
      } else if (data.event === 'add_image') {
        var indexidadd = _.findIndex(this.listalbum, function (o) {
          return o._id === data.albums_id;
        });
        for (var i = 0; i < data.info_albums.length; i++) {
          this.listalbum[indexidadd]['information'].unshift(data.info_albums[i]);
        }
      } else if (data.event === 'delete_image') {
        var index_id_delete = _.findIndex(this.listalbum, function (o) {
          return o._id === data.albums_id;
        });
        for (var i = 0; i < data.image_id.length; i++) {
          var index_image = _.findIndex(this.listalbum[index_id_delete]['information'], function (o) {
            return o.id === data.image_id[i];
          });
          this.listalbum[index_id_delete]['information'].splice(index_image, 1);
        }
      }
    },
    removeAlbums: function removeAlbums(id) {
      _.remove(this.listalbum, function (o) {
        return o._id === id;
      });
    },
    removeNote: function removeNote(id) {
      // console.log(id)
      var _ = __webpack_require__("M4fF");
      _.remove(this.listnote, function (o) {
        return o.note_id === id;
      });
    },

    // createNoteshow () {
    //   this.dialogCreatenote = true
    // },
    detailNote: function detailNote(id) {
      // console.log('detailNote' + id)
      this.dialogNote = true;
      this.note_id = id;
    },
    cancelsendinvite: function cancelsendinvite(tokenuser, name) {
      var _this6 = this;

      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        // text: 'คุณต้องการยกเลิกคำเชิญ ' + name + ' ใช่หรือไม่?',
        text: this.$t('Alert.Right.cancelInvite', { name: name }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this6.axios.post("https://uatchat-manage.one.th/manage" + '/cancelsendinvite', { tokenuser: _this6.token, tokenfriend: tokenuser, group_id: _this6.detail.group_id }).then(function (response) {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              _this6.$swal('', _this6.$t('Alert.Success.cancelInvite'), 'success');
              var index = _.findIndex(_this6.memberpending, function (o) {
                return o.tokenuser === tokenuser;
              });
              // console.log(index)
              // console.log(this.memberpending)
              if (index !== -1) {
                _this6.memberpending[index].statemember = 'leave';
                _this6.memberpending.splice(index, 1);
              }
              _this6.activeinfo = 'tab-2';
            }
          });
        }
      });
    },
    closemodal: function closemodal() {
      var modal = document.getElementById('myModalR');
      modal.style.display = 'none';
    },
    zoom: function zoom(item) {
      // console.log(item)
      this.dateSend = __WEBPACK_IMPORTED_MODULE_11__services__["c" /* Momenttime */].momentdatethai(item.timestamp);
      this.timeSend = __WEBPACK_IMPORTED_MODULE_11__services__["c" /* Momenttime */].momenttimethai(item.timestamp);
      var modal = document.getElementById('myModalR');
      var modalImg = document.getElementById('img02');
      modal.style.display = 'block';
      modalImg.src = item.path;
      this.nicknameSend = item.file_owner;
      this.filenameSend = item.file_name;
      this.picSend = item.pic_pro;
      this.pathSend = item.path;
      this.tokenmsgSend = item.okenmessage;
      this.typeuser = item.typeuser;
    },
    sendonebox: function sendonebox(tokenmessage) {
      var _this7 = this;

      // console.log('tokenmessage')
      // console.log(tokenmessage)
      this.axios.post("https://uatchat-manage.one.th/event" + '/save_onebox2', {
        tokenmessage: tokenmessage,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          _this7.$swal('', _this7.$t('Alert.Success.sendFiletoOnebox'), 'success');
        } else {}
      });
    },
    uppic: function uppic() {
      $('#uploadpicturegroup').click();
    },
    previewImagegroup: function previewImagegroup() {
      var _this8 = this;

      // console.log('previewImagegroup')
      this.selectFile = event.target.files[0];
      if (this.selectFile !== '') {
        var uploadFile = new FormData();
        uploadFile.append('file', this.selectFile, this.selectFile.name);
        uploadFile.append('group_id', this.detail.group_id);
        uploadFile.append('tokenuser', this.token);
        // console.log(uploadFile)
        this.axios.post("https://uatchat-manage.one.th/manage" + '/setimagegroup', uploadFile).then(function (response) {
          // console.log(response.data)
          alert(response.data);
          if (response.data['status'] === 'success') {
            _this8.detail.picture = response.data.filename;
            _this8.selectFile = '';
            document.querySelector('#uploadpicturegroup').value = '';
            // this.$swal(
            //   '',
            //   'เปลี่ยนภาพกลุ่มสำเร็จ',
            //   'success'
            // )
          } else {
            // console.log('fail')
            _this8.selectFile = '';
            document.querySelector('#uploadpicturegroup').value = '';
            _this8.$swal('', _this8.$t('Alert.Fail.default.somethingWrong'), 'error');
          }
        });
      }
    },
    ShowDialog: function ShowDialog(dialog) {
      if (dialog === 'Invite') {
        this.dialogInvite = true;
      } else if (dialog === 'Leave') {
        this.LeaveGroup = true;
      } else if (dialog === 'ManageGroup') {
        this.dialogManageGroup = true;
      } else if (dialog === 'dialogQrcode') {
        this.dialogQrcode = true;
      }
    },

    // ShowDialogdetail (tokenuser) {
    //   this.detailFriend = true
    //   localStorage.setItem('friendtokenuser', tokenuser)
    // },
    findWithAttr: function findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
    closeInvite: function closeInvite(value) {
      this.dialogInvite = value;
    },
    closeQrcode: function closeQrcode(value) {
      this.dialogQrcode = value;
    },
    CloseLeave: function CloseLeave(value) {
      this.LeaveGroup = value;
    },

    // CloseSetpic (value) {
    //   this.SetpicGroup = value
    // },
    detailFriendDialog: function detailFriendDialog(user) {
      // console.log(user)
      this.tokeninforfriend = user.tokenuser;
      this.inforfrienddialog = true;
    },
    chat: function chat(tokenroom) {
      this.$emit('chat', true);
      localStorage.setItem('room', tokenroom);
      this.$router.push('/mobile/room/' + tokenroom);
    },
    AcceptReq: function AcceptReq(tokenFriend) {
      var _this9 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/accept-friend", { tokenfriend: tokenFriend, tokenuser: this.token }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this9.relation = 'friend';
          // this.$store.dispatch('listFriend', JSON.stringify(tokenFriend))
          // this.$store.dispatch('Request', 'acceptrequest' + tokenFriend + ' ' + Math.random())
        }
      });
    },
    RemoveReq: function RemoveReq(tokenFriend) {
      var _this10 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', { tokenfriend: tokenFriend, tokenuser: this.token }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this10.relation = 'unknown';
          // this.$store.dispatch('sendRequest', 'removerequestfriend' + tokenFriend)
        }
      });
    },
    AddFriend: function AddFriend(tokenFriend) {
      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", { tokenfriend: tokenFriend, tokenuser: this.token }).then(function (response) {
        if (response.data['status'] === 'success') {
          // this.$store.dispatch('sendRequest', tokenFriend)
        } else {
          alert('Error!!!');
        }
      });
    },
    unblock: function unblock(tokenFriend) {
      var _this11 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistblockfriend', { tokenuser: this.token }).then(function (response) {
        var room = response.data['listBlockFriend'][_this11.findWithAttr(response.data['listBlockFriend'], 'tokenuser', tokenFriend)]['tokenroom'];
        _this11.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', { tokenfriend: tokenFriend, tokenuser: _this11.token, tokenroom: room }).then(function (response) {
          if (response.data['status'] === 'success') {
            _this11.$swal('', 'ยกเลิกการบล็อคสำเร็จ.', 'success');
            _this11.relation = 'friend';
            _this11.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistblockfriend', { tokenuser: _this11.token }).then(function (response) {
              // this.$store.dispatch('listFriend', 'listBlockFriend' + this.tokenFriend)
            });
          }
        });
      });
    },
    unblockfriend: function unblockfriend(item) {
      var _this12 = this;

      // console.log(item)
      this.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', { tokenfriend: item.tokenuser, tokenuser: this.token, tokenroom: this.$route.params.roomid }).then(function (response) {
        if (response.data['status'] === 'success') {
          // this.getlistblock()
          _this12.statemember = 'active';
          _this12.relation = 'friend';
          item.event = 'unblock_friend';
          item.statemember = 'active';
          item.tokenroom = _this12.$route.params.roomid;
          // this.unblock_friend = item
          _this12.block_friend = item;
          _this12.$swal('', _this12.$t('Alert.Success.unblock'), 'success');
          _this12.$router.push('/mobile/room/' + _this12.$route.params.roomid);
        }
      });
    },
    leavegroupFriend: function leavegroupFriend(tokenuser, name, index) {
      var _this13 = this;

      this.$swal({
        title: this.detail.group_name,
        // text: 'คุณต้องการลบ ' + name + ' ออกจากกลุ่ม ' + this.detail.group_name + ' ?',
        text: this.$t('Alert.Right.deleteFriendGroup', { name: name }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          // process.env.APIgo_api + '/v1/kick-group'
          // process.env.APImanage + '/kickmember'
          _this13.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/kick-group', { group_id: _this13.detail.group_id, tokenuser: _this13.token, listmember: [tokenuser] }).then(function (response) {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              _this13.$swal('', _this13.$t('Alert.Success.removeFriendGroup'), 'success');
              // if (index >= 0) {
              //   this.memberactive[index].statemember = 'leave'
              //   this.memberactive.splice(index, 1)
              // }
              _this13.activeinfo = 'tab-1';
            }
          });
        }
      });
    },
    unfriend: function unfriend(tokenuserfriend, name) {
      var _this14 = this;

      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        text: this.$t('Alert.RemoveFriend', { name: name }),
        type: 'warning',
        // imageUrl: '../assets/image/remove2.png',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this14.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistfriend', { tokenuser: _this14.token }).then(function (response) {
            _this14.friend = response.data['listfriend'];
            // var index = this.findWithAttr(this.friend, 'tokenuser', tokenuserfriend)
            _this14.axios.post("https://uatchat-manage.one.th/manage" + '/removefriend', { tokenfriend: tokenuserfriend, tokenuser: _this14.token, tokenroom: localStorage.getItem('room') }).then(function (response) {
              if (response.data['status'] === 'success') {
                // console.log(response)
                _this14.$swal('', _this14.$t('Alert.Success.removefriend'), 'success');
                _this14.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistfriend', { tokenuser: _this14.token }).then(function (response) {
                  _this14.friend = response.data['listfriend'];
                  // this.$store.dispatch('listFriend', 'removefriend' + tokenuserfriend)
                });
                _this14.$router.push('/mobile/homepage');
              }
            });
          });
        }
      });
    },
    block: function block(tokenuserfriend, name) {
      var _this15 = this;

      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        // text: 'คุณต้องการบล็อก ' + name + ' ใช่หรือไม่?',
        text: this.$t('Alert.Blocking', { name: name }),
        type: 'warning',
        // imageUrl: '../assets/image/block.png',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this15.axios.post("https://uatchat-manage.one.th/manage" + '/blockfriend', { tokenfriend: tokenuserfriend, tokenuser: _this15.token, tokenroom: _this15.$route.params.roomid }).then(function (response) {
            if (response.data['status'] === 'success') {
              // console.log(response.data)
              _this15.$swal('', _this15.$t('Alert.Success.block'), 'success');
              _this15.block_friend = {
                tokenuser: tokenuserfriend,
                timestamp: response.data.timestamp,
                event: 'block_friend',
                tokenroom: _this15.$route.params.roomid
              };
              _this15.statemember = 'block';
              // console.log(this.block_friend)
              _this15.$router.push('/mobile/room/' + _this15.$route.params.roomid);
            }
          });
        }
      });
    },
    clickedit: function clickedit() {
      this.edit = !this.edit;
      this.activeinfo = 'tab-1';
    },
    leavegroup: function leavegroup() {
      var _this16 = this;

      // this.token = this.$cookie.get('tokenuser')
      this.$swal({
        title: this.detail.group_name,
        // text: 'คุณต้องการออกจากกลุ่ม ' + this.detail.group_name + ' ใช่หรือไม่?',
        text: this.$t('Alert.Right.leaveGroup'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          // process.env.APImanage + '/leavegroup'
          // process.env.APIgo_api + '/v1/leave-group'
          _this16.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/leave-group', { group_id: _this16.detail.group_id, tokenuser: _this16.token, listmember: [_this16.token] }).then(function (response) {
            if (response.data['status'] === 'success') {
              _this16.$swal('', _this16.$t('Alert.Success.success'), 'success');
              _this16.$router.push('/mobile/homepage');
            }
          });
        }
      });
    },
    getmoreimage: function getmoreimage() {
      var _this17 = this;

      // console.log(this.listimageinroom[this.listimageinroom.length-1].timestamp)
      if (this.listimageinroom !== []) {
        var time = this.listimageinroom[this.listimageinroom.length - 1].timestamp;
        // if (this.listimageinroom != []){
        //   time = this.listimageinroom[length-1].timestamp
        // }
        this.axios.post("https://uatchat-manage.one.th/event" + '/file/twe_img', { tokenuser: this.token, tokenroom: this.room, time_in: time, type: this.typeuser, business_id: this.business_id }).then(function (response) {
          // console.log(response.data['data'])
          if (response.data['data'].length === 20) {
            _this17.showmoreimage = true;
          } else {
            _this17.showmoreimage = false;
          }
          _this17.listimageinroom.push.apply(_this17.listimageinroom, response.data['data']);
        });
      }
    },
    getmorefile: function getmorefile() {
      var _this18 = this;

      // console.log(this.listfileinroom[this.listfileinroom.length-1].timestamp)
      if (this.listfileinroom !== []) {
        var time = this.listfileinroom[this.listfileinroom.length - 1].timestamp;
        // if (this.listimageinroom != []){
        //   time = this.listimageinroom[length-1].timestamp
        // }
        this.axios.post("https://uatchat-manage.one.th/event" + '/file/twe_file', { tokenuser: this.token, tokenroom: this.room, time_in: time, type: this.typeuser, business_id: this.business_id }).then(function (response) {
          // console.log(response.data['data'])
          if (response.data['data'].length === 20) {
            _this18.showmorefile = true;
          } else {
            _this18.showmorefile = false;
          }
          _this18.listfileinroom.push.apply(_this18.listfileinroom, response.data['data']);
        });
      }
    },
    getimage: function getimage() {
      var _this19 = this;

      this.images = [];
      this.axios.post("https://uatchat-manage.one.th/event" + '/file/twe_img', { tokenuser: this.token, tokenroom: this.room, time_in: '', type: this.typeuser, business_id: this.business_id }).then(function (response) {
        // console.log(response.data['data'])
        if (response.data['data'].length === 20) {
          _this19.showmoreimage = true;
        } else {
          _this19.showmoreimage = false;
        }
        _this19.listimageinroom = response.data['data'];
        // test vue gallery
        for (var i = 0; i < _this19.listimageinroom.length; i++) {
          _this19.images[i] = _this19.listimageinroom[i].path;
        }
        // console.log(this.images)
      });
    },
    getfile: function getfile() {
      var _this20 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/file/twe_file', { tokenuser: this.token, tokenroom: this.room, time_in: '', type: this.typeuser, business_id: this.business_id }).then(function (response) {
        // console.log(response.data['data'])
        if (response.data['data'].length === 20) {
          _this20.showmorefile = true;
        } else {
          _this20.showmorefile = false;
        }
        _this20.listfileinroom = response.data['data'];
      });
    },
    zoomgroup: function zoomgroup(src) {
      this.$swal({
        imageUrl: src,
        showCloseButton: true,
        animation: true,
        showCancelButton: false,
        showConfirmButton: false
      });
    },
    extension: function extension(path) {
      var extension = path.split('.')[path.split('.').length - 1];
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
      var pdf = ['pdf'];
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm'];
      var presentation = ['ppt', 'pps', 'pot', 'pptx'];
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff'];
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf';
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive';
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel';
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint';
      } else if (word.includes(extension)) {
        return 'fas fa-file-word';
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code';
      } else if (image.includes(extension)) {
        return 'fas fa-file-image';
      } else {
        return 'fas fa-file-alt';
      }
    },
    count_memberpendingactive: function count_memberpendingactive(member) {
      // console.log(member)
      var _ = __webpack_require__("M4fF");
      return _.filter(member, function (member) {
        return member.statemember === 'pending';
      });
    },
    count_memberactive: function count_memberactive(member) {
      var _ = __webpack_require__("M4fF");
      return _.filter(member, function (member) {
        return member.statemember === 'active';
      });
    },
    convert: function convert(msg) {
      var linkifyStr = __webpack_require__("nN35");
      var str = msg;
      var processedContent = linkifyStr(str);
      return processedContent;
    },
    CreateNote: function CreateNote(status, createdate, noteid, tokenroom, updatedate, text) {
      if (status === 'success') {
        var _ = __webpack_require__("M4fF");
        if (_.find(this.listnote, function (o) {
          return o.note_id === noteid;
        }) === undefined) {
          this.listnote.unshift({ create_date: createdate,
            nickname: localStorage.getItem('name'),
            note_data: {
              image: [],
              text: text
            },
            note_id: noteid,
            owner: this.token,
            profilepicture: localStorage.getItem('profilepicture'),
            tokenroom: tokenroom,
            type: localStorage.getItem('type_user'),
            update_date: updatedate
          });
          this.listnote = _.sortBy(this.listnote, function (dateObj) {
            return new Date(dateObj.create_date);
          }).reverse();
          this.listnote = _.unionBy(this.listnote, 'note_id');
        }
      }
    },
    getnote: function getnote() {
      var _this21 = this;

      this.listnote = [];
      this.progressNote = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getlistnote2', { tokenuser: this.token, tokenroom: this.room }).then(function (response) {
        if (response.data.status === 'success') {
          _this21.progressNote = false;
          _this21.listnote = response.data.list_note;
          var _ = __webpack_require__("M4fF");
          _this21.listnote = _.sortBy(_this21.listnote, function (dateObj) {
            return new Date(dateObj.create_date);
          }).reverse();
          _this21.listnote = _.unionBy(_this21.listnote, 'note_id');
        } else {
          _this21.progressNote = false;
        }
      });
    },
    date: function date(timestamp) {
      // return Momenttime.momentdatethai(timestamp)
      if (this.$i18n.locale == 'th') {
        return __WEBPACK_IMPORTED_MODULE_11__services__["c" /* Momenttime */].momentdatethai(timestamp);
      } else if (this.$i18n.locale == 'cn') {
        return __WEBPACK_IMPORTED_MODULE_11__services__["c" /* Momenttime */].momentdatecn(timestamp);
      } else {
        return __WEBPACK_IMPORTED_MODULE_11__services__["c" /* Momenttime */].momentdateen(timestamp);
      }
    },
    time: function time(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_11__services__["c" /* Momenttime */].momenttimethai(timestamp);
    },
    getdataroom: function getdataroom() {
      var _this22 = this;

      this.shownotes = false;
      this.detail = {};
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', { tokenuser: this.token, tokenroom: this.$route.params.roomid }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this22.detail = response.data;
          _this22.statemember = response.data.statemember;
          // console.log(this.detail)
          if (_this22.detail.data_room[0].type === 'bot') {
            _this22.getConsent(_this22.detail.data_room[0].tokenuser, _this22.$route.params.roomid);
          }
          _this22.getimage();
          _this22.getfile();
          _this22.getmember();
          _this22.getpending();
          // if (response.data.data_room[0].statemember === 'active') {
          _this22.getnote();
          _this22.getListAlbums();
          // }
        }
      });
    },
    getConsent: function getConsent(botid, tokenroom) {
      var _this23 = this;

      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/get-consent-bot', {
        tokenuser: this.token,
        bot_id: botid
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          if (response.data.isConsent === true && response.data.isAccept === false) {
            var dataConsent = __WEBPACK_IMPORTED_MODULE_11__services__["b" /* Encode */].encode(response.data.data);
            _this23.$router.push('/check-consent/' + tokenroom + ('/?data_consent=' + dataConsent));
          } else {
            _this23.dataConsent = response.data.data;
            _this23.isAccept = response.data.isAccept;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getnoteid: function getnoteid(id) {
      var _this24 = this;

      var _ = __webpack_require__("M4fF");
      if (_.find(this.listnote, function (o) {
        return o.note_id === id;
      }) === undefined) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getnote', { note_id: id }).then(function (response) {
          if (response.data.status === 'success') {
            _this24.listnote.unshift({ create_date: response.data.list_note[0].create_date,
              nickname: response.data.list_note[0].nickname,
              note_data: {
                image: [],
                text: response.data.list_note[0].note_data.text
              },
              note_id: response.data.list_note[0].note_id,
              owner: response.data.list_note[0].owner,
              profilepicture: response.data.list_note[0].profilepicture,
              tokenroom: response.data.list_note[0].tokenroom,
              type: response.data.list_note[0].type,
              update_date: response.data.list_note[0].update_date
            });
            _this24.listnote = _.sortBy(_this24.listnote, function (dateObj) {
              return new Date(dateObj.create_date);
            }).reverse();
            _this24.listnote = _.unionBy(_this24.listnote, 'note_id');
          }
        });
      }
    },
    getListAlbums: function getListAlbums() {
      var _this25 = this;

      this.listalbum = [];
      this.progressNote = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/getlist_albums', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this25.progressNote = false;
          _this25.listalbum = response.data.data;
          // this.filter_infoalbum = this.listalbum.information
          _this25.filter_infoalbum = _.filter(_this25.listalbum, function (information) {
            return information['state']['status'] === 'active';
          });
          // console.log(this.listalbum)
          // for (var i = 0; i < this.listalbum.length; i++) {
          //   this.filter_infoalbum = _.filter(this.listalbum[i]['information'], function (information) { return information.status === 'active' })
          // }
        }
      });
    },
    detailAlbums: function detailAlbums(id, index) {
      this.dialogAlbums = true;
      this.albums_id = id;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_12_vuex_pathify__["c" /* sync */])('*')),
  mounted: function mounted() {
    var _this26 = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this26.windowWidth = window.innerWidth;
      });
    });
  },

  watch: {
    '$i18n.locale': function $i18nLocale() {
      this.setListMenu();
    },
    block_friend: function block_friend(data) {
      // console.log(data)
      if (data.event === 'block_friend') {
        this.statemember = 'block';
      } else {
        this.statemember = 'active';
      }
      this.showalbum = false;
      this.shownotes = false;
      // console.log(this.statemember)
    },
    windowWidth: function windowWidth() {
      if (this.windowWidth > 960) {
        this.$router.push('/chat/room/' + this.$route.params.roomid);
      }
    },
    socketmessage: function socketmessage() {
      var _this27 = this;

      // console.log(this.socketmessage)
      // console.log(this.socketmessage.image_add)
      this.getimage();
      this.getfile();
      var albums_id = this.socketmessage.file_name;
      if (this.socketmessage.message === 'addimage_albums') {
        // console.log(this.listalbum)
        var indexidadd = _.findIndex(this.listalbum, function (o) {
          return o._id === albums_id;
        });
        if (indexidadd >= 0) {
          for (var i = 0; i < this.socketmessage.image_add.length; i++) {
            this.listalbum[indexidadd]['information'].unshift(this.socketmessage.image_add[i]);
            // this.listalbum[indexidadd]['information'] = _.unionBy(this.socketmessage.image_add[i], 'id')
          }
        }
      } else if (this.socketmessage.message === 'delete_images_albums') {
        var albums_id_delete = this.socketmessage.albums_id;
        var index_id_delete = _.findIndex(this.listalbum, function (o) {
          return o._id === albums_id_delete;
        });
        this.axios.post("https://uatchat-manage.one.th/event" + '/get_albums', {
          albums_id: albums_id_delete,
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token
        }).then(function (response) {
          _this27.listalbum[index_id_delete]['information'] = response.data.data.information;
          for (var i = 0; i < _this27.listalbum[index_id_delete]['information'].length; i++) {
            var index_image = _.findIndex(_this27.listalbum[index_id_delete]['information'], function (o) {
              return o.status === 'delete';
            });
            _this27.listalbum[index_id_delete]['information'].splice(index_image, 1);
          }
        }).catch(function (error) {
          if (error.response.data.status === 'fail') {
            console.log(error);
          }
        });
      } else if (this.socketmessage.message === 'create_albums') {
        // console.log('create_albums')
        this.axios.post("https://uatchat-manage.one.th/event" + '/get_albums', {
          albums_id: albums_id,
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token
        }).then(function (response) {
          _this27.listalbum.unshift(response.data.data);
          _this27.listalbum = _.unionBy(_this27.listalbum, '_id');
          _this27.filter_infoalbum = _.filter(_this27.listalbum, function (information) {
            return information['state']['status'] === 'active';
          });
        }).catch(function (error) {
          if (error.response.data.status === 'fail') {
            console.log(error);
          }
        });
      } else if (this.socketmessage.message === 'delete_albums') {
        this.filter_infoalbum = _.filter(this.listalbum, function (information) {
          return information['state']['status'] === 'active';
        });
        // console.log(this.filter_infoalbum.length)
        // console.log(this.filter_infoalbum.length - 1)
      }
    },
    socketnote: function socketnote() {
      var id = this.socketnote.note_id;
      this.getnoteid(id);
    },
    socketupdate_file: function socketupdate_file() {
      if (this.statemember == 'active') {
        // console.log(this.socketupdate_file)
        this.listfileinroom.unshift({
          file_name: this.socketupdate_file.file_name,
          file_owner: this.socketupdate_file.nickname,
          path: this.socketupdate_file.message,
          pic_pro: this.socketupdate_file.path_pic,
          timestamp: this.socketupdate_file.timestamp,
          tokenmessage: this.socketupdate_file.tokenmessage,
          tokenuser: this.socketupdate_file.tokenuser,
          typeuser: this.socketupdate_file.type
        });
      }
    },
    socketupdate_img: function socketupdate_img() {
      if (this.statemember == 'active') {
        // console.log(this.socketupdate_img)
        for (var i = 0; i < this.socketupdate_img.length; i++) {
          this.images[i] = this.socketupdate_img.message;
          // console.log(this.images[i])
          // console.log(this.socketupdate_img.length)
        }
        this.images.unshift({
          path: this.socketupdate_img.message
        });
        // console.log(this.images)
        this.listimageinroom.unshift({
          file_name: this.socketupdate_img.file_name,
          file_owner: this.socketupdate_img.nickname,
          path: this.socketupdate_img.message,
          pic_pro: this.socketupdate_img.path_pic,
          timestamp: this.socketupdate_img.timestamp,
          tokenmessage: this.socketupdate_img.tokenmessage,
          tokenuser: this.socketupdate_img.tokenuser,
          typeuser: this.socketupdate_img.type
        });
      }
    },
    socket_kickmember: function socket_kickmember(data) {
      // console.log(data)
      var self = this;
      data.listkick.forEach(function (item) {
        if (self.token === item) {
          self.memberactive.statemember = 'leave';
        }
        var index = _.findIndex(self.memberactive, function (o) {
          return o.tokenuser === item;
        });
        if (index >= 0) {
          self.memberactive[index].statemember = 'leave';
          self.memberactive.splice(index, 1);
        }
      });
      this.detail.count_member = parseInt(this.detail.count_member) - 1;
    },
    socketinvite_group: function socketinvite_group(data) {
      var _this28 = this;

      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', { owner: this.token, tokenuser: data.list_invite }).then(function (response) {
          // console.log(response.data)
          // console.log(this.detail.data_room)
          for (var i = 0; i < response.data.user.length; i++) {
            var user = response.data.user[i];
            if (response.data.user[i].type === 'user') {
              user.statemember = 'pending';
              user.nickname = response.data.user[i].name;
              // this.detail.data_room.push(user)
              _this28.memberpending.push(user);
              _this28.memberpending = _.unionBy(_this28.memberpending, 'tokenuser');
              // console.log(`count_pending old: ${this.detail.count_pending}`)
              _this28.detail.count_pending = parseInt(_this28.detail.count_pending) + 1;
              // console.log(`count_pending: ${this.detail.count_pending}`)
            } else {
              user.statemember = 'active';
              user.nickname = response.data.user[i].name;
              // this.detail.data_room.push(user)
              _this28.memberactive.push(user);
              _this28.memberactive = _.unionBy(_this28.memberactive, 'tokenuser');
              // this.detail.data_room.push(user)
              // this.detail.count_member = parseInt(this.detail.count_member) + 1
              // console.log(`count_active: ${this.detail.count_member}`)
            }
          }
        });
      }
    },
    socketactive_group: function socketactive_group(data) {
      var _this29 = this;

      // console.log(data)
      // if (this.detail.type === 'group' && this.count_memberpendingactive(this.detail.data_room).length !== 0 && this.detail.group_id === data.groupid) {
      //   var index = _.findIndex(this.detail.data_room, function (o) { return o.tokenuser === data.tokenuser })
      //   if (index >= 0) {
      //     this.detail.data_room[index].statemember = 'active'
      //     this.detail.statemember = 'active'
      //   }
      // }
      if (this.detail.group_id === data.groupid) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', { owner: this.token, tokenuser: [data.tokenuser] }).then(function (response) {
          // console.log(response.data.user[0])
          // หาข้อมูล user active
          var user = response.data.user[0];
          user.statemember = 'active';
          user.nickname = response.data.user[0].name;
          _this29.memberactive.push(user);
          _this29.memberactive = _.unionBy(_this29.memberactive, 'tokenuser');
          // ลบ list user pending ที่เพิ่ง active
          var index = _.findIndex(_this29.memberpending, function (o) {
            return o.tokenuser === data.tokenuser;
          });
          if (index >= 0) {
            _this29.memberpending.splice(index, 1);
          }
          // console.log(`member old: ${this.detail.count_member}`)
          _this29.detail.count_member = parseInt(_this29.detail.count_member) + 1;
          if (response.data.user[0].type !== 'bot') {
            _this29.detail.count_pending = parseInt(_this29.detail.count_pending) - 1;
          }
          // console.log(`member new: ${this.detail.count_member}`)
        });
      }
    },
    socketleave_group: function socketleave_group(data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        // var self = this
        // data.listkick.forEach(function (item) {
        //   if (self.token === item) {
        //     self.detail.statemember = 'leave'
        //   }
        //   var index = _.findIndex(self.detail.data_room, function (o) { return o.tokenuser === item })
        //   if (index >= 0) {
        //     self.detail.data_room.splice(index, 1)
        //   }
        // })
        // ลบ list user active
        var index = _.findIndex(this.memberactive, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        if (index >= 0) {
          this.memberactive.splice(index, 1);
        }
        this.detail.count_member = parseInt(this.detail.count_member) - 1;
      }
    },
    socketcencel_group: function socketcencel_group(data) {
      // console.log(data)
      // if (this.detail.type === 'group' && this.count_memberpendingactive(this.detail.data_room).length !== 0 && this.detail.group_id === data.group_id) {
      //   // ลบ group req
      //   var index = _.findIndex(this.detail.data_room, function (o) { return o.tokenuser === data.tokenuser })
      //   if (index >= 0) {
      //     this.detail.data_room.splice(index, 1)
      //   }
      // }
      // ลบ list user pending
      var index = _.findIndex(this.memberpending, function (o) {
        return o.tokenuser === data.tokenuser;
      });
      if (index >= 0) {
        this.memberpending.splice(index, 1);
      }
      this.detail.count_pending = parseInt(this.detail.count_pending) - 1;
    },
    '$route.params.roomid': function $routeParamsRoomid() {
      // console.log('miew')
      this.room = this.$route.params.roomid;
      this.getdataroom();
      this.getListAlbums();
    }
  },
  created: function created() {
    this.business_id = localStorage.getItem('business_id');
    this.typeuser = localStorage.getItem('type_user');
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_11__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.room = this.$route.params.roomid;
    this.shownotes = false;
    this.showalbum = false;
    this.getdataroom();
    this.setListMenu();
  },

  components: {
    InviteGroup: __WEBPACK_IMPORTED_MODULE_2__components_mobile_dialog_InviteGroupDialogMobile__["a" /* default */],
    NoteDialog: __WEBPACK_IMPORTED_MODULE_4__components_mobile_dialog_NoteDialogMobile__["a" /* default */],
    CreateNoteDialog: __WEBPACK_IMPORTED_MODULE_5__components_mobile_dialog_CreateNoteDialogMobile__["a" /* default */],
    ManageGroup: __WEBPACK_IMPORTED_MODULE_3__components_mobile_dialog_ManageGroupDialogMobile__["a" /* default */],
    QrcodeGroup: __WEBPACK_IMPORTED_MODULE_1__components_mobile_dialog_QrcodeDialogMobile__["a" /* default */],
    AlbumsDialogMobile: __WEBPACK_IMPORTED_MODULE_6__components_mobile_dialog_AlbumsDialogMobile__["a" /* default */],
    CreateAlbumsDialogMobile: __WEBPACK_IMPORTED_MODULE_7__components_mobile_dialog_CreateAlbumsDialogMobile__["a" /* default */],
    InforfriendDialogMobile: __WEBPACK_IMPORTED_MODULE_8__components_mobile_dialog_InforfriendDialogMobile__["a" /* default */],
    SaveOnebox: __WEBPACK_IMPORTED_MODULE_9__components_mobile_dialog_SaveoneboxDialogMobile__["a" /* default */],
    checkconsentdialog: __WEBPACK_IMPORTED_MODULE_10__components_chat_dialog_consent_check_consent_dialog__["a" /* default */]
    // vuegalleryslideshow
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "pZ8M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_group/ShowFriendDialog.vue
var ShowFriendDialog = __webpack_require__("3nji");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-509aa708","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_group/ShowFriendDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialogShowfriend),callback:function ($$v) {_vm.dialogShowfriend=$$v},expression:"dialogShowfriend"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai",staticStyle:{"white-space":"nowrap","width":"100%","overflow":"hidden","text-overflow":"ellipsis"}},[_c('span',{staticClass:"headline CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("group")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.ShowFriendDialog.header',{groupname: _vm.name}))+"\n            "),(_vm.member.length !== 0)?_c('span',{staticStyle:{"font-size":"13px"}},[_vm._v("("+_vm._s(_vm.member.length)+")")]):_vm._e()],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_vm._l((_vm.member),function(item,index){return (_vm.member.length !== 0)?_c('v-flex',{staticStyle:{"justify-content":"center"},attrs:{"sm4":"","md4":"","lg4":"","xl4":""}},[_c('v-layout',{staticStyle:{"justify-content":"center","display":"flex"}},[_c('v-avatar',{staticClass:"user-photo"},[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","white-space":"nowrap","width":"100%","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v("\n              "+_vm._s(item.name)+"\n            ")])],1):_vm._e()}),_vm._v(" "),(_vm.member.length == 0)?_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_vm._v("\n            "+_vm._s(_vm.$t('Dialog.ShowFriendDialog.noMember'))+"\n          ")]):_vm._e()],2)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-flex',{attrs:{"xs9":"","md9":"","xl9":"","lg9":""}},[_c('v-layout',{attrs:{"align-center":"","justify-end":"","row":"","fill-height":"","wrap":""}},[_c('v-btn',{staticClass:"btnallow",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.AcceptReq_GroupReq()}}},[_vm._v("\n            "+_vm._s(_vm.$t('AnswerQuestion.joinGroup'))+"\n          ")])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"1vw"},attrs:{"xs3":"","md3":"","xl3":"","lg3":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","fill-height":"","wrap":""}},[_c('v-btn',{staticClass:"btncancel",attrs:{"depressed":"","small":""},on:{"click":function($event){_vm.RemoveReq_GroupReq()}}},[_vm._v("\n            "+_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var manage_group_ShowFriendDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_group/ShowFriendDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("lxd9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-509aa708"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ShowFriendDialog["a" /* default */],
  manage_group_ShowFriendDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_manage_group_ShowFriendDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-google-maps/dist/components/autocomplete.vue
//
//
//
//
//

/* harmony default export */ var autocomplete = ((function (x) {
  return x.default || x;
})(__webpack_require__("hQTS")));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5bf798c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-google-maps/dist/components/autocomplete.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_autocomplete = (esExports);
// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/autocomplete.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  autocomplete,
  components_autocomplete,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dist_components_autocomplete = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qQMV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-avatar-editor-improved/src/components/VueAvatar.vue
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VueAvatar = ({
    props: {
        image: {
            type: String,
            default: ''
        },
        border: {
            type: Number,
            default: 25
        },
        borderRadius: {
            type: Number,
            default: 0
        },
        width: {
            type: Number,
            default: 200
        },
        height: {
            type: Number,
            default: 200
        },
        color: {
            type: Array,
            default: function _default() {
                return [0, 0, 0, 0.5];
            }
        },
        scale: {
            type: Number,
            default: 1
        },
        rotation: {
            type: Number,
            default: 0
        }
    },
    data: function data() {
        return {
            cursor: 'cursorPointer',
            canvas: null,
            context: null,
            dragged: false,
            imageLoaded: false,
            changed: false,
            state: {
                drag: false,
                my: null,
                mx: null,
                xxx: 'ab',
                image: {
                    x: 0,
                    y: 0,
                    resource: null
                }
            }
        };
    },

    computed: {
        canvasWidth: function canvasWidth() {
            return this.getDimensions().canvas.width;
        },
        canvasHeight: function canvasHeight() {
            return this.getDimensions().canvas.height;
        },
        rotationRadian: function rotationRadian() {
            return this.rotation * Math.PI / 180;
        }
    },
    mounted: function mounted() {
        var self = this;
        this.canvas = this.$refs.avatarEditorCanvas;
        this.context = this.canvas.getContext('2d');
        this.paint();

        if (!this.image) {
            var placeHolder = this.svgToImage('<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 65"><defs><style>.cls-1{fill:#000;}</style></defs><title>Upload_Upload</title><path class="cls-1" d="M32.5,1A31.5,31.5,0,1,1,1,32.5,31.54,31.54,0,0,1,32.5,1m0-1A32.5,32.5,0,1,0,65,32.5,32.5,32.5,0,0,0,32.5,0h0Z"/><polygon class="cls-1" points="41.91 28.2 32.59 18.65 23.09 28.39 24.17 29.44 31.87 21.54 31.87 40.05 33.37 40.05 33.37 21.59 40.83 29.25 41.91 28.2"/><polygon class="cls-1" points="40.66 40.35 40.66 44.35 24.34 44.35 24.34 40.35 22.34 40.35 22.34 44.35 22.34 46.35 24.34 46.35 40.66 46.35 42.66 46.35 42.66 44.35 42.66 40.35 40.66 40.35"/></svg>');

            placeHolder.onload = function () {
                var x = self.canvasWidth / 2 - this.width / 2;
                var y = self.canvasHeight / 2 - this.height / 2;
                self.context.drawImage(placeHolder, x, y, this.width, this.height);
            };
        } else {
            this.loadImage(this.image);
        }
    },

    methods: {
        drawRoundedRect: function drawRoundedRect(context, x, y, width, height, borderRadius) {
            if (borderRadius === 0) {
                context.rect(x, y, width, height);
            } else {
                var widthMinusRad = width - borderRadius;
                var heightMinusRad = height - borderRadius;
                context.translate(x, y);
                context.arc(borderRadius, borderRadius, borderRadius, Math.PI, Math.PI * 1.5);
                context.lineTo(widthMinusRad, 0);
                context.arc(widthMinusRad, borderRadius, borderRadius, Math.PI * 1.5, Math.PI * 2);
                context.lineTo(width, heightMinusRad);
                context.arc(widthMinusRad, heightMinusRad, borderRadius, Math.PI * 2, Math.PI * 0.5);
                context.lineTo(borderRadius, height);
                context.arc(borderRadius, heightMinusRad, borderRadius, Math.PI * 0.5, Math.PI);
                context.translate(-x, -y);
            }
        },
        svgToImage: function svgToImage(rawSVG) {
            var svg = new Blob([rawSVG], { type: 'image/svg+xml;charset=utf-8' });
            var domURL = self.URL || self.webkitURL || self;
            var url = domURL.createObjectURL(svg);
            var img = new Image();
            img.src = url;
            return img;
        },
        setState: function setState(state1) {
            var min = Math.ceil(1);
            var max = Math.floor(10000);

            this.state = state1;
            this.state.cnt = 'HELLO' + Math.floor(Math.random() * (max - min)) + min;
        },
        paint: function paint() {
            this.context.save();
            this.context.translate(0, 0);
            this.context.fillStyle = 'rgba(' + this.color.slice(0, 4).join(',') + ')';

            var borderRadius = this.borderRadius;
            var dimensions = this.getDimensions();
            var borderSize = dimensions.border;
            var height = dimensions.canvas.height;
            var width = dimensions.canvas.width;

            // clamp border radius between zero (perfect rectangle) and half the size without borders (perfect circle or "pill")
            borderRadius = Math.max(borderRadius, 0);
            borderRadius = Math.min(borderRadius, width / 2 - borderSize, height / 2 - borderSize);

            this.context.beginPath();

            // inner rect, possibly rounded
            this.drawRoundedRect(this.context, borderSize, borderSize, width - borderSize * 2, height - borderSize * 2, borderRadius);

            this.context.rect(width, 0, -width, height); // outer rect, drawn "counterclockwise"
            this.context.fill('evenodd');
            this.context.restore();
        },
        getDimensions: function getDimensions() {
            return {
                width: this.width,
                height: this.height,
                border: this.border,
                canvas: {
                    width: this.width + this.border * 2,
                    height: this.height + this.border * 2
                }
            };
        },
        onDrop: function onDrop(e) {
            var _this = this;

            e = e || window.event;
            e.stopPropagation();
            e.preventDefault();

            if (e.dataTransfer && e.dataTransfer.files.length) {
                // this.props.onDropFile(e)
                var reader = new FileReader();
                var file = e.dataTransfer.files[0];
                this.changed = true;
                reader.onload = function (e) {
                    return _this.loadImage(e.target.result);
                };
                reader.readAsDataURL(file);
            }
        },
        onDragStart: function onDragStart(e) {
            var _this2 = this;

            e = e || window.event;
            e.preventDefault();
            this.state.drag = true;
            this.state.mx = null;
            this.state.my = null;
            this.cursor = 'cursorGrabbing';
            var eventSubject = document;
            var hasMoved = false;
            var handleMouseUp = function handleMouseUp(event) {
                _this2.onDragEnd(event);
                if (!hasMoved && event.targetTouches) {
                    e.target.click();
                }
                eventSubject.removeEventListener('mouseup', handleMouseUp);
                eventSubject.removeEventListener('mousemove', handleMouseMove);
                eventSubject.removeEventListener('touchend', handleMouseUp);
                eventSubject.removeEventListener('touchmove', handleMouseMove);
            };
            var handleMouseMove = function handleMouseMove(event) {
                hasMoved = true;
                _this2.onMouseMove(event);
            };
            eventSubject.addEventListener('mouseup', handleMouseUp);
            eventSubject.addEventListener('mousemove', handleMouseMove);
            eventSubject.addEventListener('touchend', handleMouseUp);
            eventSubject.addEventListener('touchmove', handleMouseMove);
        },
        onDragEnd: function onDragEnd(e) {
            if (this.state.drag) {
                this.state.drag = false;
                this.cursor = 'cursorPointer';
            }
        },
        onMouseMove: function onMouseMove(e) {
            e = e || window.event;
            if (this.state.drag === false) {
                return;
            }

            this.dragged = true;
            this.changed = true;

            var imageState = this.state.image;
            var lastX = imageState.x;
            var lastY = imageState.y;

            var mousePositionX = e.targetTouches ? e.targetTouches[0].pageX : e.clientX;
            var mousePositionY = e.targetTouches ? e.targetTouches[0].pageY : e.clientY;

            var newState = {
                mx: mousePositionX,
                my: mousePositionY,
                image: imageState
            };

            if (this.state.mx && this.state.my) {
                var xDiff = (this.state.mx - mousePositionX) / this.scale;
                var yDiff = (this.state.my - mousePositionY) / this.scale;

                imageState.y = this.getBoundedY(lastY - yDiff, this.scale);
                imageState.x = this.getBoundedX(lastX - xDiff, this.scale);
            }

            this.state.mx = newState.mx;
            this.state.my = newState.my;
            this.state.image = imageState;
            // this.setState(newState)
        },
        replaceImageInBounds: function replaceImageInBounds() {
            var imageState = this.state.image;
            imageState.y = this.getBoundedY(imageState.y, this.scale);
            imageState.x = this.getBoundedX(imageState.x, this.scale);
        },
        loadImage: function loadImage(imageURL) {
            var imageObj = new Image();
            var self = this;

            // imageObj.onload = () => this.handleImageReady(imageObj);
            imageObj.onload = function () {
                var imageState = self.getInitialSize(imageObj.width, imageObj.height);
                self.state.image.x = 0;
                self.state.image.y = 0;
                self.state.image.resource = imageObj;
                self.state.image.width = imageState.width;
                self.state.image.height = imageState.height;
                self.state.drag = false;
                self.$emit('vue-avatar-editor:image-ready', self.scale);
                self.imageLoaded = true;
                self.cursor = 'cursorGrab';
            };
            imageObj.onerror = function (err) {
                return console.log('error loading image: ', err);
            };

            // imageObj.onerror = this.props.onLoadFailure
            if (!this.isDataURL(imageURL)) {
                imageObj.crossOrigin = 'anonymous';
            }

            imageObj.src = imageURL;
        },
        getInitialSize: function getInitialSize(width, height) {
            var newHeight = void 0;
            var newWidth = void 0;

            var dimensions = this.getDimensions();
            var canvasRatio = dimensions.height / dimensions.width;
            var imageRatio = height / width;

            if (canvasRatio > imageRatio) {
                newHeight = this.getDimensions().height;
                newWidth = width * (newHeight / height);
            } else {
                newWidth = this.getDimensions().width;
                newHeight = height * (newWidth / width);
            }

            return {
                height: newHeight,
                width: newWidth
            };
        },
        isDataURL: function isDataURL(str) {
            if (str === null) {
                return false;
            }
            return !!str.match(/^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+=[a-z\-]+)?)?(;base64)?,[a-z0-9!$&',()*+;=\-._~:@\/?%\s]*\s*$/i); // eslint-disable-line no-useless-escape
        },
        getBoundedX: function getBoundedX(x, scale) {
            var image = this.state.image;
            var dimensions = this.getDimensions();
            var width = Math.abs(image.width * Math.cos(this.rotationRadian)) + Math.abs(image.height * Math.sin(this.rotationRadian));
            var widthDiff = Math.floor((width - dimensions.width / scale) / 2);
            widthDiff = Math.max(0, widthDiff);
            return Math.max(-widthDiff, Math.min(x, widthDiff));
        },
        getBoundedY: function getBoundedY(y, scale) {
            var image = this.state.image;
            var dimensions = this.getDimensions();
            var height = Math.abs(image.width * Math.sin(this.rotationRadian)) + Math.abs(image.height * Math.cos(this.rotationRadian));
            var heightDiff = Math.floor((height - dimensions.height / scale) / 2);
            heightDiff = Math.max(0, heightDiff);
            return Math.max(-heightDiff, Math.min(y, heightDiff));
        },
        paintImage: function paintImage(context, image, border) {
            if (image.resource) {
                var position = this.calculatePosition(image, border);
                context.save();
                context.globalCompositeOperation = 'destination-over';
                var dimensions = this.getDimensions();
                context.translate(dimensions.canvas.width / 2, dimensions.canvas.height / 2);
                context.rotate(this.rotationRadian);
                context.translate(-dimensions.canvas.width / 2, -dimensions.canvas.height / 2);
                context.drawImage(image.resource, position.x, position.y, position.width, position.height);
                context.restore();
            }
        },
        transformDataWithRotation: function transformDataWithRotation(x, y) {
            var radian = -this.rotationRadian;
            var rx = x * Math.cos(radian) - y * Math.sin(radian);
            var ry = x * Math.sin(radian) + y * Math.cos(radian);
            return [rx, ry];
        },
        calculatePosition: function calculatePosition(image, border) {
            image = image || this.state.image;
            var dimensions = this.getDimensions();
            var width = image.width * this.scale;
            var height = image.height * this.scale;
            var widthDiff = (width - dimensions.width) / 2;
            var heightDiff = (height - dimensions.height) / 2;
            var x = image.x * this.scale; // - widthDiff;
            var y = image.y * this.scale; // - heightDiff;

            var _transformDataWithRot = this.transformDataWithRotation(x, y);

            var _transformDataWithRot2 = _slicedToArray(_transformDataWithRot, 2);

            x = _transformDataWithRot2[0];
            y = _transformDataWithRot2[1];

            x += border - widthDiff;
            y += border - heightDiff;
            return {
                x: x,
                y: y,
                height: height,
                width: width
            };
        },
        redraw: function redraw() {
            this.context.clearRect(0, 0, this.getDimensions().canvas.width, this.getDimensions().canvas.height);
            this.paint();
            this.paintImage(this.context, this.state.image, this.border);
        },
        getImage: function getImage() {
            var cropRect = this.getCroppingRect();
            var image = this.state.image;

            // get actual pixel coordinates
            cropRect.x *= image.resource.width;
            cropRect.y *= image.resource.height;
            cropRect.width *= image.resource.width;
            cropRect.height *= image.resource.height;

            // create a canvas with the correct dimensions
            var canvas = document.createElement('canvas');
            canvas.width = cropRect.width;
            canvas.height = cropRect.height;

            // draw the full-size image at the correct position,
            // the image gets truncated to the size of the canvas.
            canvas.getContext('2d').drawImage(image.resource, -cropRect.x, -cropRect.y);

            return canvas;
        },
        getImageScaled: function getImageScaled() {
            var _getDimensions = this.getDimensions(),
                width = _getDimensions.width,
                height = _getDimensions.height;

            var canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;

            // don't paint a border here, as it is the resulting image
            this.paintImage(canvas.getContext('2d'), this.state.image, 0);

            return canvas;
        },
        imageChanged: function imageChanged() {
            return this.changed;
        },
        getCroppingRect: function getCroppingRect() {
            var dim = this.getDimensions();
            var frameRect = {
                x: dim.border,
                y: dim.border,
                width: dim.width,
                height: dim.height
            };
            var imageRect = this.calculatePosition(this.state.image, dim.border);

            return {
                x: (frameRect.x - imageRect.x) / imageRect.width,
                y: (frameRect.y - imageRect.y) / imageRect.height,
                width: frameRect.width / imageRect.width,
                height: frameRect.height / imageRect.height
            };
        },
        clicked: function clicked(e) {
            if (this.dragged === true) {
                this.dragged = false;
            } else {
                this.$refs.input.click();
            }
        },
        fileSelected: function fileSelected(e) {
            var _this3 = this;

            var files = e.target.files || e.dataTransfer.files;
            this.$emit('select-file', files);

            if (!files.length) {
                return;
            }

            // var image = new Image();
            var reader = new FileReader();

            this.changed = true;
            reader.onload = function (e) {
                return _this3.loadImage(e.target.result);
            };
            reader.readAsDataURL(files[0]);
        }
    },
    watch: {
        state: {
            handler: function handler(val, oldval) {
                if (this.imageLoaded) {
                    this.redraw();
                }
            },

            deep: true
        },
        scale: function scale() {
            if (this.imageLoaded) {
                this.replaceImageInBounds();
                this.redraw();
            }
        },
        rotation: function rotation() {
            if (this.imageLoaded) {
                this.replaceImageInBounds();
                this.redraw();
            }
        },
        borderRadius: function borderRadius() {
            this.redraw();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf61f6dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-avatar-editor-improved/src/components/VueAvatar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"avatarEditorCanvas",staticClass:"cursorPointer",attrs:{"width":_vm.canvasWidth,"height":_vm.canvasHeight,"id":"avatarEditorCanvas"},on:{"dragover":function($event){$event.preventDefault();},"drop":_vm.onDrop,"mousedown":_vm.onDragStart,"touchstart":_vm.onDragStart,"click":_vm.clicked}}),_vm._v(" "),_c('input',{ref:"input",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.fileSelected}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_VueAvatar = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-avatar-editor-improved/src/components/VueAvatar.vue
function injectStyle (ssrContext) {
  __webpack_require__("Yary")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  VueAvatar,
  components_VueAvatar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_VueAvatar = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qTcZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/WebviewOcrDialogMobile.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var WebviewOcrDialogMobile = ({
  data: function data() {
    // <== changed this line
    return {
      progressLoding: true,
      interval: 0,
      value: 0,
      tokenrooomSelect: String,
      toekn: String
    };
  },

  props: {
    dialogWebviewbig_ocr: false,
    Webview_item: {}
  },
  watch: {
    socket_close_webview: function socket_close_webview() {
      this.closeDialog();
    },
    dialogWebviewbig_ocr: function dialogWebviewbig_ocr() {
      if (this.dialogWebviewbig_ocr) {
        this.queryAndIndeterminate();
      } else {
        this.value = 0;
        this.progressLoding = true;
      }
    },
    Webview_item: function Webview_item() {
      this.value = 100;
      this.interval = 0;
      this.progressLoding = false;
    }
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  methods: {
    queryAndIndeterminate: function queryAndIndeterminate() {
      this.value = 0;

      // setTimeout(() => {
      var step = 0.3;
      var current_progress = 0;
      var me = this;
      this.interval = setInterval(function () {
        current_progress += step;
        me.value = Math.round(Math.atan(current_progress) / (Math.PI / 2) * 100 * 1000) / 1000;
        if (me.value >= 100) {
          clearInterval(me.interval);
        } else if (me.value >= 70) {
          step = 0.1;
        }
      }, 100);
      // }, 2500)
    },
    closeDialog: function closeDialog() {
      // console.log("closeDialog")
      this.$emit('closewebview', false);
      this.progressLoding = true;
      this.closewebview();
    },
    closewebview: function closewebview() {
      // console.log(authen.tokenuser)
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/close-webview', {
        tokenroom: this.tokenrooomSelect,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data)
      }).catch(function (error) {
        console.log(error);
      });
    },
    newtab: function newtab() {
      // this.Webview_item.url
      window.open(this.Webview_item.url, '_blank');
      this.closeDialog();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79378753","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/WebviewOcrDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden","border-radius":"20px"},attrs:{"persistent":"","fullscreen":""},model:{value:(_vm.dialogWebviewbig_ocr),callback:function ($$v) {_vm.dialogWebviewbig_ocr=$$v},expression:"dialogWebviewbig_ocr"}},[_c('v-card',{staticStyle:{"border-radius":"20px","width":"70vw","margin":"auto","overflow-y":"hidden"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('Dialog.ocr.selectText'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},nativeOn:{"click":function($event){return _vm.newtab($event)}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("far fa-window-restore")])],1),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding":"0","height":"550px !important"}},[(!_vm.progressLoding)?_c('iframe',{staticStyle:{"visibility":"visible","width":"100% !important","height":"100% !important"},attrs:{"frameborder":"0","src":_vm.Webview_item.url,"allow":"geolocation"}}):_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"justify-content":"center","display":"grid","height":"80vh"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticStyle:{"margin":"auto"}},[_c('v-progress-circular',{staticStyle:{"width":"60vw !important"},attrs:{"rotate":-90,"size":150,"width":15,"value":_vm.value,"color":"#0e468e"}},[_vm._v("\n              "+_vm._s(Math.ceil(_vm.value))+"%\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('Dialog.ocr.processing')))])],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_WebviewOcrDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/WebviewOcrDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("yB1m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79378753"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  WebviewOcrDialogMobile,
  dialog_WebviewOcrDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_WebviewOcrDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qkiP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./node_modules/vue-trix/dist/vue-trix.esm.js
var vue_trix_esm = __webpack_require__("sYAI");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/mail/CreatemailDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var CreatemailDialog = ({
  props: { dialogCreatemail: false, message: {} },
  data: function data() {
    return {
      items: [],
      model: [],
      search: null,
      token: '',
      to: '',
      sender: '',
      subject: '',
      editorContent: '',
      listfriend: [],
      loading: false
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.sender = localStorage.getItem('email');
    this.getlistfriend();
  },
  mounted: function mounted() {},

  methods: {
    closeDialog: function closeDialog() {
      this.editorContent = '';
      this.subject = '';
      this.to = '';
      this.model = [];
      this.$emit('closeCreatemail', false);
    },
    clearMessage: function clearMessage() {
      this.message = {};
    },
    sendmail: function sendmail() {
      var _this = this;

      this.loading = true;
      if (this.to === '') {
        this.loading = false;
        this.$swal('', this.$t('Alert.Fail.SendMail.inputMail'), 'warning');
      } else if (this.subject === '') {
        this.loading = false;
        this.$swal('', this.$t('Alert.Fail.SendMail.inputSubject'), 'warning');
      } else {
        this.axios.post("https://uatchat-manage.one.th/event" + '/send_email', { sender: this.sender, to: this.to, subject: this.subject, detail: this.editorContent, file_name: this.message.file_name ? this.message.file_name : '', file: this.message.message ? this.message.message : '' }).then(function (response) {
          if (response.data.status === 'success') {
            _this.loading = false;
            _this.$swal('', _this.$t('Alert.Success.sendEmail'), 'success');
            _this.closeDialog();
          }
        }).catch(function (error) {
          console.log(error);
          _this.loading = false;
          _this.$swal('Network error', _this.$t('Alert.Fail.default.networkError'), 'error');
        });
      }
    },
    getlistfriend: function getlistfriend() {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistfriend', { tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          _this2.listfriend = response.data['listfriend'];
        }
      }, function () {});
    },
    blockevent: function blockevent(data) {
      if (data.event === 'block_friend') {
        indexmsg = _.findIndex(this.listfriend, function (o) {
          return o.tokenuser === data.tokenuser;
        });
        if (indexmsg != -1) {
          _.pullAt(this.listfriend, indexmsg);
        }
      } else if (data.event === 'unblock_friend') {
        this.listfriend.push(data);
        this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc']);
      }
    }
  },
  watch: {
    model: function model(val) {
      // if (val.length > 5) {
      //   this.$nextTick(() => this.model.pop())
      // }
      this.to = val.toString();
    },
    block_friend: function block_friend(data) {
      this.blockevent(data);
    },
    socketremove_friend: function socketremove_friend(data) {
      var index = _.findIndex(this.listfriend, function (o) {
        return o.tokenroom === data.tokenroom;
      });
      if (index >= 0) {
        this.listfriend.splice(index, 1);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44cb380c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/mail/CreatemailDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.dialogCreatemail),callback:function ($$v) {_vm.dialogCreatemail=$$v},expression:"dialogCreatemail"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-email-open-multiple-outline")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.sendEmail.header'))+"\n        ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"30px","height":"535px","overflow-y":"scroll"}},[_c('div',{staticStyle:{"overflow-y":"hidden","margin-top":"10px"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mt-1 pr-2 pl-1",attrs:{"xs12":"","xl12":"","lg12":"","md12":"","sm12":""}},[_c('v-combobox',{attrs:{"items":_vm.items,"search-input":_vm.search,"hide-selected":"","placeholder":_vm.$t('Dialog.sendEmail.to'),"multiple":"","persistent-hint":"","small-chips":"","deletable-chips":"","solo":"","dense":"","outline":"","hide-details":""},on:{"update:searchInput":function($event){_vm.search=$event}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-1 mb-1",attrs:{"xs12":"","xl12":"","lg12":"","md12":"","sm12":""}},[_c('span',{staticStyle:{"color":"#666666","font-size":"12px","padding-left":"10px"}},[_vm._v(_vm._s(_vm.$t('Dialog.sendEmail.note2')))])]),_vm._v(" "),_c('v-flex',{staticClass:"pr-2 pl-1",staticStyle:{"margin-top":"8px"},attrs:{"xs12":"","xl12":"","lg12":"","md12":"","sm12":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject),expression:"subject"}],staticClass:"CSChatThai",attrs:{"type":"text","placeholder":_vm.$t('Dialog.sendEmail.subject')},domProps:{"value":(_vm.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject=$event.target.value}}})]),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px"},attrs:{"xs12":"","xl12":"","lg12":"","md12":"","sm12":""}},[_c('VueTrix',{staticClass:"CSChatThai",attrs:{"inputId":"editor1","placeholder":_vm.$t('Dialog.sendEmail.detail')},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})],1),_vm._v(" "),(_vm.message.message)?_c('v-flex',{staticStyle:{"margin-top":"8px"},attrs:{"xs12":"","xl12":"","lg12":"","md12":"","sm12":""}},[_c('div',{staticClass:"attachment_file"},[_c('v-icon',{staticStyle:{"color":"#666666"}},[_vm._v("mdi-paperclip")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#666666"}},[_vm._v(_vm._s(_vm.message.file_name))])],1),_vm._v(" "),_c('span',{staticStyle:{"color":"red"},on:{"click":function($event){_vm.clearMessage()}}},[_vm._v(" "+_vm._s(_vm.$t('Dialog.sendEmail.removeFile'))+" ")])]):_vm._e(),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"15px","text-align":"center"},attrs:{"xs12":"","xl12":"","lg12":"","md12":"","sm12":""}},[_c('v-btn',{staticStyle:{"background":"#2562af","color":"white","text-transform":"none"},attrs:{"loading":_vm.loading,"disabled":_vm.to === '' || _vm.subject === ''},on:{"click":function($event){_vm.sendmail()}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("mdi-send-outline")]),_vm._v("\n          "+_vm._s(_vm.$t('Dialog.sendEmail.send'))+"\n        ")],1)],1)],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var mail_CreatemailDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/mail/CreatemailDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("Wj7+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44cb380c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  CreatemailDialog,
  mail_CreatemailDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_mail_CreatemailDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qo2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qtw1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_pathify__ = __webpack_require__("YtWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_100vh__ = __webpack_require__("hErE");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import AddDialog from '@/components/chat/dialog/manage_friend/ManageFriendDialog'



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      AddFriend: false,
      imageData: '',
      selectFile: '',
      token: '',
      selected: [],
      invites: [],
      idbusiness: [],
      GroupName: '',
      FriendList: [],
      searchfriend: '',
      business_id: '',
      listmember: [],
      typeuser: '',
      step_creategroup: 1
      // group_id: '',
      // group_createdate: '',
      // group_status: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    FilterFriendList: function FilterFriendList() {
      var _this = this;

      if (this.searchfriend !== '' && this.searchfriend !== null) {
        return this.FriendList.filter(function (post) {
          return post.name.toLowerCase().includes(_this.searchfriend.toLowerCase());
        });
      } else {
        return this.FriendList;
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex_pathify__["c" /* sync */])('*')),
  watch: {
    socketaccept_friend: function socketaccept_friend(data) {
      var _this2 = this;

      if (data.tokenuser === this.token) {
        this.axios.post("https://uatchat-manage.one.th/manage" + '/getuser', { owner: this.token, tokenuser: [data.tokenfriend] }).then(function (response) {
          var _ = __webpack_require__("M4fF");
          // update list friend after accept friend
          if (_.find(_this2.FriendList, function (o) {
            return o.tokenuser === response.data.user[0].tokenuser;
          }) === undefined) {
            _this2.FriendList.unshift({
              email: response.data.user[0].email,
              name: response.data.user[0].name,
              phone: response.data.user[0].phone,
              profilepicture: response.data.user[0].profilepicture,
              state: response.data.user[0].state,
              status: response.data.user[0].status,
              tokenuser: response.data.user[0].tokenuser,
              type: response.data.user[0].type,
              tokenroom: data.tokenroom
            });
            _this2.FriendList = _.orderBy(_this2.FriendList, ['name'], ['asc']);
          }
        });
      }
    }
  },
  components: {
    // AddDialog
    vue100vh: __WEBPACK_IMPORTED_MODULE_3_vue_100vh__["a" /* default */]
  },
  methods: {
    toPage_Addfriend: function toPage_Addfriend(path) {
      this.$router.push(path);
    },
    toPage: function toPage() {
      this.$router.go(-1);
    },
    removeListAddGroup: function removeListAddGroup(item) {
      this.selected.splice(this.selected.indexOf(item), 1);
    },
    showDialog: function showDialog(dialog) {
      if (dialog === 'AddFriend') {
        this.AddFriend = true;
      }
    },
    closeDialogAddFriend: function closeDialogAddFriend(value) {
      this.AddFriend = value;
    },
    uppic: function uppic() {
      $('#uploadpicgroupweb').click();
    },
    closeDialog: function closeDialog() {
      var self = this;
      // this.$emit('closeDialogCreateGroup', false)
      this.invites = [];
      this.idbusiness = [];
      this.GroupName = '';
      this.selected = [];
      self.imageData = '';
      self.selectFile = '';
      document.getElementById('uploadpicgroupweb').value = '';
      this.loading = false;
    },
    previewImageweb: function previewImageweb(data) {
      var _this3 = this;

      var input = data.target;
      this.selectFile = data.target.files[0];
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this3.imageData = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    submit: function submit() {
      var _this4 = this;

      if (this.selected.length < 1) {
        this.$swal({
          title: this.$t('Alert.Fail.createGroup.title'),
          text: this.$t('Alert.Fail.createGroup.selectFriend'),
          type: 'warning',
          showCloseButton: true,
          reverseButtons: true
        });
      } else if (this.GroupName === '') {
        this.$swal({
          title: this.$t('Alert.Fail.createGroup.title'),
          text: this.$t('Alert.Fail.createGroup.groupname'),
          type: 'warning',
          showCloseButton: true,
          reverseButtons: true
        });
      } else {
        for (var i = 0; i < this.selected.length; i++) {
          this.invites[i] = this.selected[i].tokenuser;
          // this.idbusiness[i] = this.selected[i].business_id
          // this.listmember[i] = {tokenuser: this.invites[i], business_id: this.idbusiness[i]}
          if (i === this.selected.length - 1) {
            this.loading = true;
            // console.log(this.invites)
            this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/create-group", { tokenuser: this.token, listmember: this.invites, group_name: this.GroupName }).then(function (response) {
              if (response.data.status === 'success') {
                // console.log(response.data)
                if (_this4.selectFile !== '') {
                  var uploadFile = new FormData();
                  uploadFile.append('file', _this4.selectFile, _this4.selectFile.name);
                  uploadFile.append('group_id', response.data.group.group_id);
                  uploadFile.append('tokenuser', _this4.token);
                  _this4.axios.post("https://uatchat-manage.one.th/manage" + '/setimagegroup', uploadFile).then(function (responsed) {
                    // console.log(responsed.data)
                    if (responsed.data.status === 'success') {
                      _this4.$swal(_this4.$t('Alert.Success.createGroup'), '', 'success');
                      // let self = this
                      _this4.selectFile = '';
                      _this4.imageData = '';
                      _this4.selected = [];
                      _this4.closeDialog();
                      document.getElementById('uploadpicgroupweb').value = '';
                      _this4.$emit('updatecreategroup', response.data.group, responsed.data.filename);
                      _this4.$emit('updatelistchat', response.data.group, responsed.data.filename);
                      _this4.loading = false;
                    }
                    _this4.$router.push('/mobile/homepage');
                    // this.$emit('closeDialogCreateGroup', false)
                  });
                } else {
                  // let self = this
                  _this4.$swal(_this4.$t('Alert.Success.createGroup'), '', 'success');
                  _this4.selectFile = '';
                  _this4.imageData = '';
                  _this4.selected = [];
                  _this4.closeDialog();
                  document.getElementById('uploadpicgroupweb').value = '';
                  // this.$emit('closeDialogCreateGroup', false)
                  _this4.$emit('updatecreategroup', response.data.group);
                  _this4.$emit('updatelistchat', response.data.group);
                  // console.log(this.$emit('updatecreategroup', response.data.group))
                  _this4.$router.push('/mobile/homepage');
                  _this4.loading = false;
                }
              } else {
                // console.log(response.data)
                _this4.loading = false;
              }
            });
          }
        }
      }
    }
  },
  created: function created() {
    var _this5 = this;

    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.business_id = localStorage.getItem('business_id');
    this.typeuser = localStorage.getItem('type_user');
    this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistfriend', { tokenuser: this.token }).then(function (response) {
      // console.log(response.data)
      _this5.FriendList = response.data['listfriend'];
    });
    this.$i18n.locale = this.$cookie.get('language') ? this.$cookie.get('language') : 'th';
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "r052":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),

/***/ "r7AF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8p6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rCqH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rTZ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/saveonebox/SaveoneboxDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var SaveoneboxDialog = ({
  data: function data() {
    return {
      tokenuser: '',
      tokenmessage: '',
      list_account: [],
      list_folder: [],
      progress: false,
      state: false,
      account_id: ''
    };
  },

  props: {
    dialogSaveOnebox: false,
    tokenmessage_savebox: ''
  },
  watch: {
    dialogSaveOnebox: function dialogSaveOnebox() {
      this.tokenmessage = this.tokenmessage_savebox;
      var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
      this.tokenuser = decoded['tokenuser'];
      this.get_account();
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.state = false;
      this.$emit('closeSaveOnebox', false);
    },
    get_mainfolder: function get_mainfolder(id) {
      var _this = this;

      this.progress = true;
      this.state = true;
      this.account_id = id;
      this.axios.post("https://uatchat-manage.one.th/event" + '/api/box/get_mainfolder_byaccountid', { account_id: this.account_id }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this.progress = false;
          _this.list_folder = response.data.data;
          // console.log(this.list_folder)
        }
      }).catch(function (error) {
        _this.progress = false;
        console.log(error);
      });
    },
    get_account: function get_account() {
      var _this2 = this;

      this.progress = true;
      this.axios.post("https://uatchat-manage.one.th/event" + '/api/box/get_account_byuserid', { user_id: this.tokenuser }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this2.progress = false;
          _this2.state = false;
          _this2.list_account = response.data.data;
          // console.log(this.list_account)
        }
      }).catch(function (error) {
        _this2.progress = false;
        console.log(error);
      });
    },
    save_onebox: function save_onebox(id) {
      var _this3 = this;

      this.$swal({
        type: 'warning',
        title: '<div class="CSChatThai" style="font-size: 16px;">' + this.$t('Alert.Saveonebox') + '</div>',
        confirmButtonColor: '#2562af',
        confirmButtonText: '<div class="CSChatThai" style="font-size: 14px;">' + this.$t('AnswerQuestion.ok') + '</div>',
        cancelButtonColor: '#9f9f9f',
        cancelButtonText: '<div class="CSChatThai" style="font-size: 14px;">' + this.$t('AnswerQuestion.cancel') + '</div>',
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this3.axios.post("https://uatchat-manage.one.th/event" + '/api/box/savefile', { account_id: _this3.account_id, folder_id: id, tokenmessage: _this3.tokenmessage_savebox }).then(function (response) {
            // console.log(response.data)
            if (response.data.status === 'success') {
              _this3.$swal(_this3.$t('Alert.Success.sending'), _this3.$t('Alert.Success.sendFile'), 'success');
              _this3.$emit('closeSaveOnebox', false);
            }
          }).catch(function (error) {
            _this3.progress = false;
            _this3.$swal('', _this3.$t('Alert.Unsavefile'), 'warning');
            // this.$swal('', 'ไฟล์นี้ถูกบันทึกแล้ว ไม่สามารถบันทึกไฟล์ซ้ำได้', 'warning')
            console.log(error);
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b457092","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/saveonebox/SaveoneboxDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"max-width":"500px","max-height":"500px","persistent":""},model:{value:(_vm.dialogSaveOnebox),callback:function ($$v) {_vm.dialogSaveOnebox=$$v},expression:"dialogSaveOnebox"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[(!_vm.state)?_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-user-circle")]),_vm._v(" "),_c('span',{staticClass:"font-size14"},[_vm._v(_vm._s(_vm.$t('Dialog.Saveonebox.titleaccount')))])],1):_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-folder")]),_vm._v(" "),_c('span',{staticClass:"font-size14"},[_vm._v(_vm._s(_vm.$t('Dialog.Saveonebox.titlefolder')))])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),(_vm.state)?_c('v-card-title',[_c('v-btn',{staticClass:"color-grey",attrs:{"round":"","flat":"","small":"","color":"white"},on:{"click":function($event){_vm.state = !_vm.state}}},[_c('v-icon',{staticClass:"pr-2",attrs:{"color":"primary"}},[_vm._v("fas fa-chevron-left")]),_vm._v("\n        "+_vm._s(_vm.$t('Task.allTask.back'))+"\n      ")],1)],1):_vm._e(),_vm._v(" "),(!_vm.state)?_c('v-card-text',{staticClass:"scrolling-wrapper",staticStyle:{"padding":"0","height":"250px !important"}},[(_vm.progress)?_c('v-layout',{staticStyle:{"height":"250px"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"size":"50","indeterminate":_vm.progress,"color":"primary"}})],1):_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.list_account),function(item,index){return [_c('v-list-tile',{key:item.account_id,staticClass:"cursor-pointer",on:{"click":function($event){_vm.get_mainfolder(item.account_id)}}},[_c('v-list-tile-avatar',[_c('img',{staticClass:"border-img",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-size14",domProps:{"innerHTML":_vm._s(item.account_name)}})],1)],1),_vm._v(" "),(index + 1 < _vm.list_account.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1):_c('v-card-text',{staticClass:"scrolling-wrapper",staticStyle:{"padding":"0","height":"200px !important"}},[(_vm.progress)?_c('v-layout',{staticStyle:{"height":"170px"},attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"size":"50","indeterminate":_vm.progress,"color":"primary"}})],1):_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.list_folder),function(item,index){return [_c('v-list-tile',{key:item.folder_id,staticClass:"cursor-pointer",on:{"click":function($event){_vm.save_onebox(item.folder_id)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fas fa-folder-open")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-size14",domProps:{"innerHTML":_vm._s(item.folder_name)}})],1)],1),_vm._v(" "),(index + 1 < _vm.list_folder.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var saveonebox_SaveoneboxDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/saveonebox/SaveoneboxDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("dGX+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b457092"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  SaveoneboxDialog,
  saveonebox_SaveoneboxDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_saveonebox_SaveoneboxDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rfCq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rhU9":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ "rmFL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rn0h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s68P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sD5H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sHvA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_group/CreateGroupDialog.vue
var CreateGroupDialog = __webpack_require__("1eJt");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-337f7ac2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_group/CreateGroupDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"550px","max-height":"600px"},model:{value:(_vm.dialogGroup),callback:function ($$v) {_vm.dialogGroup=$$v},expression:"dialogGroup"}},[_c('v-card',{staticStyle:{"border-radius":"20px"},attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('span',{staticClass:"headline CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("group_add")]),_vm._v("  "+_vm._s(_vm.$t('LeftSide.createGroup.header'))+"\n        ")],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding":"0px"}},[_c('v-stepper',{model:{value:(_vm.step_creategroup),callback:function ($$v) {_vm.step_creategroup=$$v},expression:"step_creategroup"}},[_c('v-stepper-items',[_c('v-stepper-content',{staticStyle:{"height":"550px"},attrs:{"step":"1"}},[_c('v-container',{staticStyle:{"padding-top":"0px","padding-bottom":"10px"},attrs:{"wrap":""}},[_c('h4',{staticStyle:{"padding-left":"10px"}},[_vm._v(_vm._s(_vm.$t('Dialog.group.chooseFriend')))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"borderlistfriend",attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-text-field',{staticStyle:{"margin":"7px"},attrs:{"solo":"","hide-details":"","append-icon":"search","label":_vm.$t('LeftSide.createGroup.searching'),"clearable":""},model:{value:(_vm.searchfriend),callback:function ($$v) {_vm.searchfriend=$$v},expression:"searchfriend"}}),_vm._v(" "),(_vm.FilterFriendList.length != 0)?_c('v-list',{staticClass:"CSChatThai widthfull scrolling-wrapper",staticStyle:{"padding":"0px"}},[_vm._l((_vm.FilterFriendList),function(item,index){return [_c('v-list-tile',{key:item.tokenuser,attrs:{"avatar":"","ripple":""}},[_c('v-list-tile-avatar',[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'company')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"textoverflow"},[_vm._v("\n                              "+_vm._s(item.name)+"\n                            ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-checkbox',{staticStyle:{"color":"#2562af !important"},attrs:{"value":item},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)]})],2):_c('v-container',[_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.showDialog('AddFriend')}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"CSChatThai ",staticStyle:{"font-size":"12px","text-align":"center","color":"black"}},[_c('v-icon',{staticStyle:{"color":"black","font-size":"18px !important"}},[_vm._v("add_circle")]),_vm._v("\n                              "+_vm._s(_vm.$t('AnswerQuestion.addFriend'))+"\n                            ")],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"borderlistfriendSelect",attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"setBorder ml-1"},[_c('v-layout',{staticClass:"setPaddingButtomListFriendInGroup",staticStyle:{"margin-top":"5px"},attrs:{"row":"","wrap":""}},[(_vm.selected.length != 0)?_c('h4',{staticStyle:{"padding-left":"12px"}},[_vm._v(_vm._s(_vm.$t('RightSide.member'))+" ("+_vm._s(_vm.selected.length)+")")]):_vm._e()]),_vm._v(" "),(_vm.selected.length != 0)?_c('div',{staticClass:"scrolling-wrapperx"},[_c('v-item-group',_vm._l((_vm.selected),function(i,index){return _c('v-item',{key:index,scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
return _c('v-chip',{attrs:{"selected":active,"close":""},on:{"input":function($event){_vm.removeListAddGroup(i)}}},[_c('v-avatar',[(i.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":i.profilepicture,"alt":i.name}}):(i.type === 'company')?_c('img',{attrs:{"src":"/static/img/default_profile/business-white.png","alt":i.name}}):(i.type === 'government')?_c('img',{attrs:{"src":"/static/img/default_profile/business-white.png","alt":i.name}}):(i.type === 'bot')?_c('img',{attrs:{"src":"/static/img/default_profile/bot-white.png","alt":i.name}}):_c('img',{attrs:{"src":"/static/img/default_profile/man-white.png","alt":i.name}})]),_vm._v("\n                            "+_vm._s(i.name)+"\n                          ")],1)}}])})}))],1):_c('div',{staticStyle:{"margin-top":"40px"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":"","row":""}},[_c('h5',[_vm._v(_vm._s(_vm.$t('LeftSide.createGroup.noneSelect')))])])],1)],1)])],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"margin-top":"20px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-left"},[[_c('v-btn',{staticClass:"CSChatThai btncanclegroup",nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel'))+" ")])]],2),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"CSChatThai btncreategroup",attrs:{"color":"primary","disabled":!(_vm.selected.length !== 0)},on:{"click":function($event){_vm.step_creategroup = 2}}},[_vm._v(_vm._s(_vm.$t('Task.allTask.next')))])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{staticStyle:{"height":"550px"},attrs:{"step":"2"}},[_c('v-container',{staticStyle:{"padding-top":"0px","padding-bottom":"10px"},attrs:{"wrap":""}},[_c('h4',{staticStyle:{"padding-left":"10px"}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.createGroup')))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center","padding-bottom":"5px"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"List_item_body"},[_c('div',{staticClass:"SettingImg"},[_c('div',{staticClass:"SettingImgWrap"},[_c('div',[(_vm.imageData == '')?_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer","width":"140px","height":"140px"},attrs:{"src":"/static/img/default_profile/group-white.png"},on:{"click":_vm.uppic}}):_c('img',{staticClass:"alligator-turtle",staticStyle:{"cursor":"pointer","width":"140px","height":"140px"},attrs:{"src":_vm.imageData},on:{"click":_vm.uppic}}),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('input',{staticClass:"CSChatThai",attrs:{"type":"file","name":"file1","accept":"image/*","id":"uploadpicgroupweb"},on:{"change":_vm.previewImageweb}})]),_vm._v(" "),_c('label',{staticClass:"SettingImgBtn",attrs:{"for":"SettingImg"},on:{"click":function($event){_vm.uppic()}}},[_vm._v("\n                            "+_vm._s(_vm.$t('AnswerQuestion.selectPicture'))+"\n                          ")])])])]),_vm._v(" "),_c('p',{staticClass:"EditAreaNote"},[_vm._v(_vm._s(_vm.$t('Settings.editProfile.support'))+" .JPEG/.PNG/.GIF")]),_c('p',{staticClass:"EditAreaNote"}),_c('p',{staticClass:"EditAreaNote"})])]),_vm._v(" "),_c('v-flex',{staticClass:"mt-2 mr-2 ml-2",attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":"","row":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.GroupName),expression:"GroupName"}],staticClass:"CSChatThai inputgroupweb",attrs:{"type":"text","placeholder":_vm.$t('LeftSide.createGroup.detailSearch')},domProps:{"value":(_vm.GroupName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.GroupName=$event.target.value}}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"margin-top":"170px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-left"},[[_c('v-btn',{staticClass:"CSChatThai btncanclegroup",on:{"click":function($event){_vm.step_creategroup = 1}}},[_vm._v(_vm._s(_vm.$t('Register.Button.back')))])]],2),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"CSChatThai btncreategroup",attrs:{"loading":_vm.loading,"disabled":!(_vm.selected.length !== 0 && _vm.GroupName !== '')},on:{"click":function($event){_vm.submit()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.createGroup')))])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('AddDialog',{attrs:{"dialogAdd":_vm.AddFriend},on:{"closeDialogAddFriend":_vm.closeDialogAddFriend}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var manage_group_CreateGroupDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_group/CreateGroupDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("3dGV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-337f7ac2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  CreateGroupDialog["a" /* default */],
  manage_group_CreateGroupDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_manage_group_CreateGroupDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sSPP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/components/chat/dialog/ShowImage_ProfileDialog.vue + 2 modules
var ShowImage_ProfileDialog = __webpack_require__("sVBg");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/manage_friend/AddFriendDialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState } from 'vuex'
// var _ = require('lodash')




/* harmony default export */ var AddFriendDialog = ({
  props: { 'dialogAdd': false },
  data: function data() {
    return {
      search: '',
      token: '',
      listuser: [],
      listbot: [],
      statusSearch: '',
      dialogshowimage_profile: false,
      pathpicture: '',
      typepathpicture: '',
      dialogPassword: false,
      password: '',
      infor_bot: {},
      message_error: '',
      loading: false,
      passwordRules: [function (v) {
        return !!v && v.length >= 6 || 'กรุณากรอกตัวเลขอย่างน้อย 6 ตัว';
      }, function (v) {
        return (/^([0-9])+$/.test(v) || 'กรุณากรอกเป็นตัวเลข 0-9 เท่านั้น'
        );
      }, function (v) {
        return (/[^\W_]+$/.test(v) || 'ไม่สามารถกรอกตัวอักษรหรืออักขระพิเศษได้'
        );
      }]
    };
  },
  methods: {
    openPictureProfile: function openPictureProfile(picture, type) {
      this.pathpicture = picture;
      this.typepathpicture = type;
      this.dialogshowimage_profile = true;
    },
    closeDialogShowImage_Profile: function closeDialogShowImage_Profile(value) {
      this.dialogshowimage_profile = value;
    },
    closeDialog: function closeDialog() {
      this.$emit('closeDialogAddFriend', false);
      this.search = '';
      this.statusSearch = '';
      this.listuser = [];
      this.listbot = [];
      this.message_error = '';
      this.infor_bot = {};
    },
    searchuser: function searchuser() {
      var _this = this;

      this.listbot = [];
      this.listuser = [];
      this.axios.post("https://uatchat-manage.one.th/manage" + '/searchusernontype3', { tokenuser: this.token, key: this.search }).then(function (response) {
        if (response.data.status === 'success') {
          if (response.data['listuser'].length !== 0 || response.data['listBot'].length !== 0) {
            _this.listuser = response.data['listuser'];
            _this.listbot = response.data['listBot'];
            // console.log(this.listbot)
            _this.statusSearch = 'found';
          } else {
            _this.statusSearch = 'not found';
          }
        }
      });
    },
    AcceptReq: function AcceptReq(index, item) {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/accept-friend", { tokenfriend: item.user.tokenuser, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          _this2.listuser[index].relation = 'friend';
          _this2.$emit('updatelistreq', {
            event: 'accept',
            tokenuser: item.user.tokenuser,
            name: item.user.name,
            profilepicture: item.user.profilepicture,
            email: item.user.email,
            state: 'friend',
            status: item.user.status,
            type: item.user.type,
            tokenroom: response.data.tokenroom,
            timestamp: response.data.timestamp
          });
        } else {
          console.log('Error');
        }
      });
    },
    RemoveReq: function RemoveReq(index, item) {
      var _this3 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', { tokenfriend: item.user.tokenuser, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          _this3.listuser[index].relation = 'unknown';
          _this3.$emit('updatelistreq', {
            event: 'removeReq',
            tokenuser: item.user.tokenuser
          });
        }
      });
    },
    AddFriend: function AddFriend(index, tokenfriend, typeuser, item) {
      var _this4 = this;

      // console.log(item)
      if (typeuser === 'user') {
        this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", { tokenfriend: tokenfriend, tokenuser: this.token }).then(function (response) {
          if (response.data.status === 'success') {
            if (typeuser === 'user') {
              _this4.listuser[index].relation = 'sendrequest';
            }
          }
        });
      } else if (typeuser === 'bot' && item.user.is_password !== '0') {
        this.dialogPassword = true;
        this.infor_bot = { 'tokenbot': tokenfriend, 'index': index };
      } else {
        this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", { tokenfriend: tokenfriend, tokenuser: this.token }).then(function (response) {
          if (response.data.status === 'success') {
            _this4.listbot[index].relation = 'friend';
            _this4.listbot[index].user.tokenroom = response.data.tokenroom;
          }
        });
      }
    },
    AddFriendCollab: function AddFriendCollab(index, item, state) {
      var _this5 = this;

      // console.log(item)
      // console.log(index)
      this.loading = true;
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/add-friend-accept', { tokenfriend: item.tokenuser, tokenuser: this.token }).then(function (response) {
        if (response.data.status === 'success') {
          _this5.loading = false;
          if (state === 'true') {
            _this5.chat(response.data.tokenroom);
          } else {
            _this5.listuser[index].relation = 'friend';
            _this5.listuser[index].user.tokenroom = response.data.tokenroom;
          }
        } else {
          _this5.loading = false;
          // this.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning')
          _this5.$swal('', _this5.$t('Alert.Fail.default.somethingWrong'), 'warning');
        }
      }).catch(function (error) {
        console.log(error);
        _this5.loading = false;
        // this.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning')
        _this5.$swal('', _this5.$t('Alert.Fail.default.somethingWrong'), 'warning');
      });
    },
    check_password_bot: function check_password_bot() {
      var _this6 = this;

      this.message_error = '';
      this.loading = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/check_password_bot', { tokenBot: this.infor_bot.tokenbot, password: this.password }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          if (response.data.message === 'correct password') {
            _this6.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", { tokenfriend: _this6.infor_bot.tokenbot, tokenuser: _this6.token }).then(function (response) {
              if (response.data.status === 'success') {
                _this6.dialogPassword = false;
                _this6.loading = false;
                _this6.password = '';
                _this6.listbot[_this6.infor_bot.index].relation = 'friend';
                _this6.listbot[_this6.infor_bot.index].user.tokenroom = response.data.tokenroom;
              }
            });
          } else {
            _this6.loading = false;
            _this6.message_error = _this6.$t('LeftSide.addFiend.messageCheckbot');
            // console.log(response.data.message)
          }
        }
      });
    },
    close_dialog_pass: function close_dialog_pass() {
      this.dialogPassword = false;
      this.message_error = '';
      this.password = '';
      this.infor_bot = {};
    },
    clear_dialog_pass: function clear_dialog_pass() {
      // this.dialogPassword = false
      this.message_error = '';
      this.password = '';
      // this.infor_bot = {}
    },
    chat: function chat(room) {
      this.closeDialog();
      this.$router.push('/chat/room/' + room);
    },
    unblock: function unblock(index, item, type) {
      var _this7 = this;

      this.$swal({
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Unblocking', { name: item.user.name }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this7.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', { tokenfriend: item.user.tokenuser, tokenuser: _this7.token, tokenroom: item.user.tokenroom }).then(function (response) {
            if (response.data['status'] === 'success') {
              _this7.$swal('Unblocked!', _this7.$t('Alert.Success.unblock'), 'success');
              if (type === 'user') {
                _this7.listuser[index].relation = 'friend';
              } else if (type === 'bot') {
                _this7.listbot[index].relation = 'friend';
              }
              // emit ย้อนกลับได้
              var itemfriend = item.user;
              itemfriend.event = 'unblock_friend';
              _this7.$emit('blockevent', itemfriend);
            }
          });
        }
      });
    }
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  },

  watch: {
    search: function search() {
      this.listuser = [];
      this.listbot = [];
      this.statusSearch = '';
    },
    socketaccept_friend: function socketaccept_friend(data) {
      // console.log(data)
      var tokenfriend = data.tokenuser;
      // console.log(this.listuser)
      var indexFriend = _.findIndex(this.listuser, function (o) {
        return o.user.tokenuser === tokenfriend;
      });
      // console.log(indexFriend)
      if (indexFriend != -1) {
        // console.log(this.listuser[indexFriend])
        this.listuser[indexFriend].relation = 'friend';
      }
      //     tokenfriend = data.tokenuser
      //     var indexSendReq = _.findIndex(this.FriendSendReq, function (o) { return o.tokenuser === data.tokenuser })
      //     if (indexSendReq >= 0) {
      //       this.FriendSendReq.splice(indexSendReq, 1)
      //     }
      //   } else {
      //     var indexReq = _.findIndex(this.FriendReq, function (o) { return o.tokenuser === data.tokenfriend })
      //     if (indexReq >= 0) {
      //       this.FriendReq.splice(indexReq, 1)
      //     }
      //   }
      //   this.axios.post(process.env.APImanage + '/searchtokenuser', {tokenuser: this.token, tokenfriend: tokenfriend}).then((response) => {
      //     if (_.find(this.listfriend, function (o) { return o.tokenuser === response.data.user.tokenuser }) === undefined) {
      //       this.listfriend.unshift(response.data.user)
      //       this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
      //     }
      //     // update listchat
      //     var indexchat = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
      //     var json = response.data.user
      //     json.nickname = ''
      //     json.picture = response.data.user.profilepicture
      //     json.state = 'user'
      //     json.timestamp = data.timestamp
      //     json.count_read = '0'
      //     json.is_active = 'true'
      //     // console.log(json)
      //     if (indexchat >= 0) {
      //       this.listchat.splice(indexchat, 1)
      //       this.listchat.unshift(json)
      //     } else {
      //       this.listchat.unshift(json)
      //     }
      //     // เรียงแชทใหม่ กรณที่มีการ pin
      //     var listpin = []
      //     var linstunpin = []
      //     this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
      //     listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
      //     linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
      //     this.listchat = _.union(listpin, linstunpin)
      //   })
    }
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  components: {
    ShowImageProfileDialog: ShowImage_ProfileDialog["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f70012","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/manage_friend/AddFriendDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow":"hidden !important"},attrs:{"persistent":"","max-width":"550px","max-height":"600px"},model:{value:(_vm.dialogAdd),callback:function ($$v) {_vm.dialogAdd=$$v},expression:"dialogAdd"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("person_add")]),_vm._v("  "+_vm._s(_vm.$t('LeftSide.addFiend.header')))],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"400px","overflow":"hidden !important","padding":"0"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center","padding-left":"30px","padding-right":"30px"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-text-field',{staticClass:"bgsearch",staticStyle:{"color":"white !important"},attrs:{"append-icon":"search","solo":"","label":_vm.$t('LeftSide.addFiend.searching'),"clearable":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.searchuser()},"click:append":function($event){_vm.searchuser()}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(_vm.statusSearch === '')?_c('v-flex',{staticClass:"CSChatThai",staticStyle:{"padding-left":"30px","padding-right":"30px"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[_c('img',{staticStyle:{"width":"170px"},attrs:{"src":"/static/img/onechat/search.jpg"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('LeftSide.addFiend.detailSearch')))])])],1):(_vm.statusSearch === 'not found')?_c('v-flex',{staticClass:"CSChatThai",staticStyle:{"padding-left":"30px","padding-right":"30px"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[_c('img',{staticStyle:{"width":"120px","margin-bottom":"20px"},attrs:{"src":"/static/img/onechat/nosearch.png"}}),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.$t('LeftSide.addFiend.nodata', {key: _vm.search})))])])],1):_c('v-flex',{staticStyle:{"padding-left":"30px","padding-right":"30px"},attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-tabs',{attrs:{"centered":"","color":"cyan","dark":"","icons-and-text":""}},[_c('v-tabs-slider',{attrs:{"color":"info"}}),_vm._v(" "),(_vm.listuser.length !== 0)?_c('v-tab',{key:2,staticStyle:{"color":"black !important"},attrs:{"href":"#tab-2"}},[_vm._v("\n                  User\n                    "),_c('v-badge',{attrs:{"right":""}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(" "+_vm._s(_vm.listuser.length)+" ")]),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"black !important","font-size":"25px !important"}},[_vm._v("person")])],1)],1):_vm._e(),_vm._v(" "),(_vm.listbot.length !== 0)?_c('v-tab',{key:1,staticStyle:{"color":"black !important"},attrs:{"href":"#tab-1"}},[_vm._v("Bot\n                  "),_c('v-badge',{attrs:{"right":""}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(" "+_vm._s(_vm.listbot.length)+" ")]),_vm._v(" "),_c('img',{staticClass:"alligator-turtle",staticStyle:{"width":"25px"},attrs:{"src":"/static/img/icons/robot.svg"}})])],1):_vm._e(),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',{attrs:{"id":"tab-1"}},[(_vm.listbot.length !== 0)?_c('v-list',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"200px"},attrs:{"two-line":""}},[_vm._l((_vm.listbot),function(item,index){return [(index != 0)?_c('v-divider'):_vm._e(),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',{staticStyle:{"cursor":"pointer !important"},on:{"click":function($event){_vm.openPictureProfile(item.user.profilepicture, item.user.type)}}},[(item.user.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.user.profilepicture}}):(item.user.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):(item.user.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"width":"18em"}},[_vm._v("\n                          "+_vm._s(item.user.name)+"\n                        ")])],1),_vm._v(" "),_c('v-list-tile-action',[(item.relation == 'friend')?_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.chat(item.user.tokenroom)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.chat')))]):(item.relation == 'request')?_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.AcceptReq(index,item)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.acceptFriend')))]):(item.relation == 'sendrequest')?_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.RemoveReq(index,item)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancelRequest')))]):(item.relation == 'block')?_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.unblock(index,item,'bot')}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.unblock')))]):(item.relation == 'self')?_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))]):(item.relation == 'unknown' || item.relation == 'unfriend')?_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.AddFriend(index,item.user.tokenuser,item.user.type, item)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.addFriend')))]):_vm._e()],1)],1)]})],2):_vm._e()],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[(_vm.listuser.length !== 0)?_c('v-list',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"200px"},attrs:{"two-line":""}},[_vm._l((_vm.listuser),function(item,index){return [(index != 0)?_c('v-divider'):_vm._e(),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',{staticStyle:{"cursor":"pointer !important"},on:{"click":function($event){_vm.openPictureProfile(item.user.profilepicture, item.user.type)}}},[(item.user.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.user.profilepicture}}):(item.user.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):(item.user.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"width":"18em"},domProps:{"innerHTML":_vm._s(item.user.name)}})],1),_vm._v(" "),_c('v-list-tile-action',[(item.relation == 'friend')?_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.chat(item.user.tokenroom)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.chat')))]):(item.relation == 'request')?_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.AcceptReq(index,item)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.acceptFriend')))]):(item.relation == 'sendrequest')?_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.RemoveReq(index,item)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancelRequest')))]):(item.relation == 'block')?_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.unblock(index,item,'user')}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.unblock')))]):(item.relation == 'self')?_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.ok')))]):((item.relation == 'unknown' || item.relation == 'unfriend') && item.collab_mail == 'true')?_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"blue darken-1","flat":"","loading":_vm.loading},nativeOn:{"click":function($event){_vm.AddFriendCollab(index, item.user, item.collab_mail)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.chat')))]):((item.relation == 'unknown' || item.relation == 'unfriend') && item.collab_mail == 'false')?_c('v-btn',{staticClass:"CSChatThai",attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.AddFriendCollab(index, item.user, item.collab_mail)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.addFriend')))]):_vm._e()],1)],1)]})],2):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialogPassword),callback:function ($$v) {_vm.dialogPassword=$$v},expression:"dialogPassword"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('LeftSide.addFiend.headerCheckpass'))+"\n              "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.close_dialog_pass}},[_c('v-icon',{staticStyle:{"color":"black !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"solo":"","label":_vm.$t('LeftSide.addFiend.placeholderPassword'),"clearable":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.check_password_bot($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"red","padding-left":"10px"}},[_vm._v(_vm._s(_vm.message_error))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"btncancle",on:{"click":_vm.clear_dialog_pass}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.clear'))+"\n              ")]),_vm._v(" "),_c('v-btn',{staticClass:"btnaddfriend",attrs:{"loading":_vm.loading},on:{"click":_vm.check_password_bot}},[_vm._v("\n                "+_vm._s(_vm.$t('AnswerQuestion.addFriend'))+"\n              ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('ShowImageProfileDialog',{attrs:{"dialogshowimage_profile":_vm.dialogshowimage_profile,"pathpicture":_vm.pathpicture,"typepathpicture":_vm.typepathpicture},on:{"closeDialogShowImage_Profile":_vm.closeDialogShowImage_Profile}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var manage_friend_AddFriendDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/manage_friend/AddFriendDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("Sd8O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49f70012"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  AddFriendDialog,
  manage_friend_AddFriendDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_manage_friend_AddFriendDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sSr1":
/***/ (function(module, exports) {

module.exports = {"welcomeMsg":"Welcome to Your Vue.js App","HeaderMenubar":{"qrcode":"二维码","loa":"Level of Assurance(LoA)","editProfile":"个人资料","managefriend":"管理好友","sendOnebox":"One Box","feedback":"报告问题","support":"帮助中心","terms_of_service":"服务条款","policy":"隐私权政策","logout":"退出登录","createproject":"创建项目","project":"项目","calendar":"日历","languages":"语言","general":"通用","profile":"帐户设置"},"Conjunction":{"or":"或","and":"和"},"AnswerQuestion":{"ok":"确定","cancel":"取消","sure":"确定","no":"否","edit":"编辑","remove":"删除","update":"保存","sendme":"发送","forward":"分享","send":"发送","joinGroup":"加入","acceptFriend":"添加","removeFriend":"移除","kickMemberGroup":"移除","chat":"聊天","cancelRequest":"取消邀请","cancelInvite":"拒绝","unblock":"解除屏蔽","addFriend":"添加","createGroup":"建立群","keep":"保存","Onebox":"Onebox","download":"下传","uploadPhoto":"上传图片","sendOnebox":"保存至onebox","selectPicture":"添加照片","selectFile":"添加文件","uploadAll":"上传所有文件","newuUpload":"再上传","upload":"上传","clear":"删除","resetbackground":"删除聊天背景","setbackground":"背景设定","continue":"下一步","open":"打开","login":"登录"},"Dialog":{"Saveonebox":{"titlefolder":"请选择您想要的文件夹。","titleaccount":"请选择您想要的用户帐户。"},"ShowFriendDialog":{"header":"群组成员: {groupname}","noMember":"没有群成员"},"account":"用户帐户","pictureProfile":"头像","forward":{"header":"分享至","friend":"好友","group":"群","searchgroup":"搜索群名称"},"map":{"header":"位置","placeholder":"搜索地点"},"approve":{"detail":"查看更多","answer":"对不起!! 此消息已答复。"},"sendEmail":{"header":"新邮件","to":"收件人:","subject":"主题:","detail":"消息...","removeFile":"[ 移除 ]","send":"发送","note":"注意: 验证多个用逗号(,) 分隔开的邮箱.","note2":"Note: Please press ⏎ (Enter) in case you want to send to more than one recipient."},"album":{"headerAddImage":"保存至相册","headerCreate":"创建相册","nameAlbum":"相册名","btnCreate":" 创建相册","btnAddImage":"添加照片","btnEdit":"更改相册名","btnRemoveImage":"删除照片","btnRemoveAlbum":"删除相册","noDataAlbum":"尚无任何相册。","noAlbum":"该相册已被删除。","noImageAlbum":"尚无任何照片。"},"showImage":{"by":"By","date":"Date"},"group":{"headerInvite":"邀请好友","headerSetting":"设置","chooseFriend":"选择好友","groupName":"群名称","group":"群: ","detailQrcode":"邀请好友扫描此二维码,或将二维码保存至设备并分享给好友。","searching":"搜索","detailQrjoingroup":"二维码加人群"},"note":{"headerCreate":"新建记事本","headerNote":"记事本","noNote":"该帖子已被删除!","deleteNote":"确定删除吗?"},"wallpaper":{"headerWallpaper":"背景设定"},"anonymous":{"headerCreate":"创建聊天群","createGroupName":"创建组名称","groupName":"群名称","addMember":"添加成员"},"download":{"textDownload":"下载 One Chat"},"profilefriend":{"headerProfile":"查看个人资料"},"ocr":{"selectText":"请选择您想要的消息","processing":"系统正在处理, 请稍候。"},"selectaccount":{"title1":"选择帐户","title2":"请选择要登录的帐户","alert":{"title":"Confirm account","text1":"Do you want to use an account","text2":"for login Onechat"}}},"LeftSide":{"header":{"friend":"好友","chat":"聊天","service":"服务","project":"项目","setting":"设置","calendar":"日历","onemeet":"One Meet","homepage":"首页","qrcode":"二维码"},"searching":"搜索好友和群名","noDataSearching":"未找到","friend":{"friendInvite":"好友的邀请","wantToBeFriend":"想和你做朋友","sendFriendInvite":"发送的好友邀请","waitingRequestFriend":"等待接受...","groupInvite":"群邀请","haveMember":"有 {count} 位成员","friend":"好友","addFriend":"搜索好友","group":"群","createGroup":"建立群"},"addFiend":{"header":"搜索好友","searching":"搜索","detailSearch":"您可以通过电话号码、邮箱地址 或 Bot ID 搜索朋友。","nodata":"{key} 未找到。","placeholderPassword":"请输入您的密码。","messageCheckbot":"密码有误 请检查您的密码。","headerCheckpass":"检查密码"},"createGroup":{"header":"设置群资料","selectPicture":"添加照片","detailSearch":"群名称","searching":"搜索","numberFriend":"成员 {count}","noneSelect":"您尚未选择任何好友。"},"chat":{"leftChat":"您退出该群。","startChat":"开始对话。","sendSticker":"发送了贴图。","sendFile":"发送了文件。","sendLocation":"发送了位置信息。","sendContact":"发送了一个联系人。","sendPicture":"发送了照片。","sendNote":"发送了记事本。","sendVideo":"发送了视频。","sendReply":"回复消息","sendOfficial_template":"发来了 official_template。","sendConference_msg":"通话开始","createAlbum":"已创建相册。","createTask":"新增任務","createProject":"创建项目","approveMessage":"发送了 Approve Message","unsendMessage":"撤回了一条消息。","call":{"time":"通话时间","noResponse":"没反应","cancel":"取消","missed":"未接来电","end":"通话已结束"},"sendCarousel":"发来了照片Carousel"}},"ChatSide":{"loadHistory":"查看聊天更多","system":{"self":{"cancelMsg":"您撤回了一条消息。","editNameAlbum":"您已更改相册名称。","createAlbum":"您已创建 {name} 相册。","deleteAlbum":"您删除了相册。","deleteImageAlbum":"您删除了相册的照片。","editTask":"您已更改任務。","joinGroup":"您加入该群。","leftGroup":"您退出该群。","createProject":"您已创建项目"},"other":{"cancelMsg":"{name} 撤回了一条消息。","editNameAlbum":"{name} 已更改相册名称","createAlbum":"{name} 已创建 {album_name} 相册。","deleteAlbum":"{name} 删除了相册。","deleteImageAlbum":"{name} 删除了相册的照片。","editTask":"{name} 已更改任務。","joinGroup":"{name} 已加入该群。","leftGroup":"{name} 已退出该群。","createProject":"{name} 已创建项目。"},"default":{"kickMemberGroup":"{name_active} 已将 {name_passive} 移出群。","inviteMemberGroup":"{name_active} 已邀请 {name_passive}加入群。"}},"Album":{"createAlbumHeader":"已创建相册。","insertImageAlbum":"图片已上传至 “{name}” 相册。","numberImage":"共: {count}件"},"Task":{"viewDetail":"查看更多","editAssign":"编辑","assign":"成员"},"image":"照片","sticker":"贴图","note":"记事本","emoji":"表情贴","file":"文件","friend":"好友","location":"位置信息","forward":"分享","numberMsgSent":"消息","noMsg":"无法显示此消息。","notSupportVersion":"对不起，当前版本暂不支持查看此消息","resend":"重新发送","conference":{"joinCall":"加入","startCall":"开始语音通话","startVideo":"开始视频通话"},"approve_message":{"viewDetail":"查看更多","receiveAns":"已得到答案。"},"textarea":{"normal":"输入消息...","inactive":"您无法与对方聊天。"},"Read":{"readmore":"查看更多","readless":"更少"},"announce":{"delete":"不再显示","minimize":"最小化"},"RightClickMenu":{"addImageAlbum":"相册","mention":"回复","sendmail":"发送邮件","cancelMsg":"撤回","announce":"公告","cancelAnnounce":"不再显示","pinChat":"固定聊天","unpinChat":"取消固定","forward":"分享","openfile":"打开文件","openlocation":"打开Map","openimage":"打开图片","profile":"查看个人资料"}},"RightSide":{"header":{"profile":"个人资料","image":"照片","file":"文件","privatepolicy":"Privacy consent agreement"},"menu":{"project":"项目","album":"相册","note":"记事本","clearChat":"删除聊天","block":"屏蔽","unblock":"解除屏蔽","qrCode":"二维码","leave":"退群","invite":"邀请","setting":"设置","setwall":"背景设定"},"noImage":"此聊天中未分享照片。","noFile":"此聊天中未分享文件。","group":"群","member":"成员","pending":"正在邀请","noMember":"没有群成员","loadmore":"更多","noNote":"记事本尚未创建。"},"Alert":{"Sure":"您确定吗?","Clear":"我们正在删除您输入的。","Unblocking":"您解除屏蔽了 {name}!","Blocking":"您屏蔽了 {name}!","RemoveFriend":"是否要移除朋友({name}) ?","Saveonebox":"是否要将文件保存在此文件夹中?","Unsavefile":"此文件已保存。无法重复保存文件。","Chat":{"announce":{"cancel":"不要再显示此消息?","deleteAll":"不要再显示这些消息?"},"unsent":"是否撤回该条消息?","sendDatetime":"您想发送的吗?"},"Left":{"cancelRequest":"你要取消{name}的请求朋友吗?"},"Right":{"clearChat":"确定要删除此聊天吗?","cancelInvite":"是否取消邀请 {name} 加入群?","deleteFriendGroup":"需要从群里删除{name}吗?","leaveGroup":"您确定要退出群吗?","removeNote":"您否要删除记事本?","removeWallpaper":"您否要删除聊天背景?","cancleEditPhone":"您确定要放弃吗?"},"Album":{"headerAddImageAlbum":"保存至相册","textAddImageAlbum":"是否要在相册({name})中添加照片?","deleteImage":"您否要删除该相册的照片?","deleteAlbum":"您否要删除该相册?"},"Group":{"cancelGroup":"是否要取消加入该群({name}) ?"},"Task":{"remove":"您想删除此任务?","removeComment":"您想删除此评论?","removeChecklist":"您想删除此清单?","removeData":"是否要清除数据?"},"Login":{"phoneNotVerify":"您的电话号码未注册, 请输入新电话号码。","phoneVerify":"您的电话号码已注册, 请登录或输入新电话号码。","otpRequest":"这个电话号码请求OTP太频繁, 请稍候。","otpInvalid":"OTP 无效","inputUserPass":"请输入您的用户名密码","invalidUserPass":"用户名或密码无效","previouspage":"是否要返回上一页面?"},"Success":{"success":"成功！","createGroup":"该群已创建。","feedback":"您的评论已成功发送。","announce":"已公告成功。","unsent":"您撤回了一条消息。","unblock":"解除屏蔽成功了。","block":"屏蔽成功了。","removefriend":"好友删除成功。","sending":"已成功发送。","sendFile":"您的文件已成功发送。","sendFiletoOnebox":"您的文件已成功发送到onebox。","sendMsg":"您的消息已成功发送。","sendEmail":"您的邮件已成功发送。","account":"发送了一个联系人。","createNote":"该记事本已创建。","savePhotoAlbum":"已添加相册的照片。","renameAlbum":"该相册名已更新。","createAlbum":"该相册已创建。","removePhoto":"已删除相册的照片。","cancelInvite":"该组的邀请已被取消。","removeFriendGroup":"好友已从群组中删除。","inviteFriendGroup":"您的邀请已发送。","renameGroup":"群名变了。","changePictureGroup":"群组图变了。","createTask":"此任务已新增。","removeTask":"此任务已删除。","editTask":"此任务已更新。","removeComment":"评论目已删除。","createComment":"评论目已创建。","createProject":"该项目已创建。","createChecklist":"此清单目已创建。","removeChecklist":"此清单目已删除。","setbackground":"设置背景完成。","deletebackground":"背景已被删除。","settingusername":"设置用户名和密码成功。","createGroupChat":"创造群聊成功。"},"Fail":{"createGroup":{"title":"群创建失败了。","selectFriend":"请选择至少 1个朋友。","groupname":"请输入群名称"},"feedback":{"connectError":"无法发送消息。 请稍后再试。","maxFiles":"选择多达5个图像。"},"Chat":{"maxMessage":"最多选择5条消息。","maxSizeFile":"无法发送文件。 此文件超过 25 MB。","maxSizeFile100":"无法发送文件。 此文件超过 100 MB。","uploadPic":"请上传新图像。"},"default":{"somethingWrong":"出了问题, 请稍后再试。","networkError":"请检查您的网络连接。"},"forward":{"maxChatRoom":"选择多达5个聊天室。","selectMessage":"请选择留言。"},"Album":{"maxSizeFile":"不允许大小超过 25 MB 的文件。","maxFiles":"选择多达5个图像。","minFiles":"请选择至少 1个图像。","removed":"该相册已被删除。","emptyName":"请输入相册名。","supportType":"这种类型的文件不受支持。"},"Task":{"removed":"对不起, 此任务已被删除。"},"SendMail":{"inputMail":"请输入电子邮件地址。","inputSubject":"请输入主题。"},"nameuser":"请输入您的名字。"},"Warning":{"link_market":"对不起, 不支持此消息类型。"},"CheckOpenNewTab":"在新标签中打开?"},"Task":{"create":{"header":"新增任务","subject":"任务名称","placeholderSubject":"写入任务名称。","priority":"Priority","p1":"Higher","p2":"Middle","p3":"Lower","startDate":"开始日期","endDate":"到期日","description":"描述","placeholderDescription":"添加详细描述。","assign":"指派对象","placeholderAssign":"Assign your team","status":"Status","comment":"评论","placeholderComment":"请写下您的评论","placeholderSubjectProject":"项目名称","projectSubject":"项目名称","placeholderChecklist":"写入清单","checklist":"清单","select":"請選擇一個朋友或組。"},"detail":{"header":"任务","menu":{"edit":"编辑","delete":"删除","deletecommemt":"删除评论","deletechecklist":"删除清单"},"createBy":"创建的","signDocument":"签署文件"},"allTask":{"back":"后退","createTask":"新增任務","numTask":"{count} 个任务","placeholderSearchGroup":"搜索群名","placeholderSearchFriend":"搜索好友","newGroup":"建立群","placeholderSearchProject":"搜索","createDate":"创建日期 {date}","detailProject":"查看更多","moreDetail":"更多细节","noProjectList":"没有项目,请创建项目。","noCardTask":"没有任务列表,请创建任务。","createProject":"创建项目","myProject":"您的看板 ({count})","noListFriend":"没有好友","noListGroup":"没有群","projectDetail":"项目详细信息","localepicker":"en","next":"下一步","selectProject":"请选择聊天室"}},"Settings":{"Qrcode":{"header":"二维码","myQRcode":"我的二维码","scanQRcode":"扫一扫二维码","openCamera":"允许我们的网站使用您的摄像头","resultScan":"成果"},"editProfile":{"changePictureProfile":"更改图像","support":"支持","profile":"个人资料","displayName":"名字","status":"状态消息","phone":"手机号","email":"邮箱","qrcodeForAddFriend":"二维码","detailQRcode":"扫一扫上面的二维码图案，加我onechat。","settingusername":"设置用户名密码","usernamepassword":"用户名和密码","username":"用户名","password":"密码","confirmpassword":"确认密码","group":"群组信息","groupName":"群名称"},"messageError":{"UsernameDuplicate":"用户名已经存在,请重新输入。","UsernameRules1":"请输入您的用户名。","UsernameRules2":" 无法输入特殊字符。","UsernameRules3":"请至少输入 6 个字符。","UsernameRules4":"用户名可以包含字母(a-z)和数字(0-9)","UsernameRules5":"请输入至少1个字符的英文字符a-z","PasswordRules1":"请输入密码","PasswordRules2":"密码必须包含至少1个英文字母(a-z,A-Z),至少1个数字(0-9) 和长度至少为8个字符。","RePasswordRules1":"请输入您的密码以确认","RePasswordRules2":"密码不匹配。"},"messageEditPhone":{"TitleDialogEdit":"编辑电话号码","MsgPhoneRegistered":"您的电话号码已注册.","MsgDetectPhone":"手机号","MsgDetectPhonenext":"已注册。您可以再次登录以立即使用该帐户。","MsgCloseAccountSelect":"关闭用户账户","MsgCloseAccountSpan":"如果要关闭经常帐户,请选择","MsgKeepAccountSelect":"您需要都保留2个帐户。","MsgKeepAccountSpan":"请选择如果要保留2个帐户","MsgCloseOnechatAccount":"关闭Onechat帐户","MsgCloseOnechatAccountSpan":"如果要关闭OneChat帐户,请告诉我们。","MsgCloseOnechatAccountSelect":"Closing your account will be permanent. When you close your OneChat account, you won't be able to recover content or data. And all your chat messages will be deleted as well.","MsgConfirmCloseAccount":"确认关闭账户","ChangePhoneNumber":"是否要更改电话号码?","MsgSendOTP":"我们向您的电话发送6位数字otp号码 - ","MsgOTPNotrecieve":"未收到OTP","MsgResendOTP":"重新获取 ","MsgVerifyPhone":"验证电话号码","MsgOTPAgain":"请求新的 OTP","MsgLoginPhoneAgain":"请使用电话号码再次登录。","MsgSwitchAccount":"是否要切换帐户?","MsgChangePhoneSuccess":"更改电话号码是成功的。","OTPInvalid":"OTP 无效","MsgTooManyRequest":"5分钟后请按‘发送验证码’请求新的 OTP。","MsgTokenExpire":"令牌已过期。 请重新登录。"},"manageFriend":{"headerManageFriend":"屏蔽列表","nodata":"您尚未屏蔽任何用户。"},"feedback":{"suggestion":"意见反馈","headerFeedback":"我们很高兴收到您的意见。 您的反馈信息有助于我们提高产品的质量和服务素质！","titleFeedback":"您可以在此处分享用户体验、服务建议或报告错误。 如果您需要帮助，请通过电子邮件与我们联系","contact":"帮助中心","name":"名字","title":"主题","report":"报告问题","detail":"消息","selectPicture":"插入照片","selcetmultipleImage":"把圖片拖到這裡","selectmultipleFiles":"将文件拖到这里","or":"或者"},"helpCenter":{"header":"帮助中心","company":"One Centric Company Limited","address":"1768 Thai Summit Tower, Floor 16, New Phetchaburi Road, Bang Kapi, Bangkok 10310","email":"邮箱"},"policy":{"header":"Privacy Policy of OneChat","subject1":{"header":"1. Introduction","introDetail":"One Centric Company Limited (“OneChat”, “Company” or “of Company”) believes that your privacy is paramount in fulfilling our obligations to respect and protect your privacy rights. The Company will adhere to these basic principles.","subjectIntro1":"1. The company will inform your personal data that will ask for your consent as it deems appropriate to collect, active processing or disclose your personal information","subjectIntro2":"2. The company will specify the purpose of collecting and processing your personal data.","subjectIntro3":"3. The Company will collect only the information necessary for the performance of the stated purpose of use.","subjectIntro4":"4. The Company will use or disclose your personal information only for the purposes for which it was collected, except with your consent or as required by law and the Company will retain your information only for as long as it is necessary for the purpose.","subjectIntro5":"5. The Company will endeavor to ensure that your personal information is correct, complete and current.","subjectIntro6":"6. The Company will provide appropriate techniques and organizational standards to properly protect your personal data.","subjectIntro7":"7. The Company will develop its policies and practices to make the handling of your personal information as transparent as possible.","subjectIntro8":"8. We welcome your comments regarding our compliance with these principles, this Privacy Policy and applicable law."},"subject2":{"header":"2. Scope of Privacy Protection Policy","subHeaderScopeA":"A. Objectives of the Privacy Policy ","subHeaderScopeB":"B. Privacy Policy applicable to other OneChat services.","detailScopeA1":"This Privacy Policy describes how OneChat Used to manage and protect your personal information including various alternative rights in relation to your personal data","detailScopeA2":"This Privacy Policy applies to personal information that the Company collects from you when you use the Application to communicate via the OneChat (“OneChat Application”) service various options are available in the One Chat application and other applications included or work with the OneChat application (collectively referred to as “Applications”), personal information that the Company collects from you. When you visit websites maintained by the Company in connection with the Company's applications (the “Websites”) (both the Application and the Websites collectively the “Services”) and personal information about you received from other users.","detailScopeB1":"Users may request additional services from OneChat or its affiliates. (“Additional Services”) as each user has different needs and options. The company therefore has different privacy protection policies or an annex to this Privacy Policy for applicable additional services. Separate Privacy Policy and the various suffixes describe the types of information the company collects purpose of use and other policies that may apply to such additional services. When you choose to use additional services, you will be informed of the applicable Privacy Shield Policy or addendum, which is in addition to or amendment to the Privacy Policy. You will then be able to access such additional services. Please note that you can review the Privacy Policy and its suffix according to the service used."},"subject3":{"header":"3. Types of personal data the company collects","subHeaderTypeA":"A. Personal data collected by One Chat","detailSubHeaderA":"in providing services to you OneChat collects, transfers and uses of information are as follows","subjectA1":"1. Information about your account","subjectA2":"2. Device information and access records when you use the Company's services.","detailSubjectA1":"When you create a OneChat account to access the service (“User Account”). OneChat will ask you to provide your phone number. This information is necessary as the Company may send SMS messages to the phone number you provide for detection and prevention continuously to prevent unauthorized use of the service or use it in a fraudulent manner we may also use this registered phone number to send you important information about the Service.","detailSubjectA2":"When you use the Company's services, the Company may obtain and maintain electronic identification data or records automatically obtained from certain items of your device, such as the device type, Operating system, type IP, address browser information including type and language settings Machine identifiers, cookie data, advertising identifiers, or mobile application identifiers.","detailSubjectA21":"This information is necessary for the Company to continually detect and prevent unauthorized use of the Service or use it in a fraudulent manner or in a wrong way as well as to provide you with the most customized and efficient service on your device. In addition, please note that third party advertising identifiers may be associated with your account through our internal identifiers.","subHeaderTypeB":"B. What other information may OneChat collect?","detailSubHeaderB":"The company provides additional to improve service efficiency functions including the functionality of accessing your account from multiple devices. Helping you find friends through the service or for efficient service convenient to use and enjoy more if you choose to use this function or choose to use your account on multiple devices The Company may ask you to provide the following information.","subjectB1":" 1. Email address [optional]","detailSubjectB1":"You may wish to access your account from multiple devices. (“Multiple Logins”) or transfer your account from one device to another. (“Account Transfer”), you will be required to provide your e-mail address and a password or personal secret code (PIN) to OneChat so that the Company can associate your device with your account can be registered","detailSubjectB12":"Please note that If you change your mind later and does not wish to specify an e-mail address anymore You can remove it at any time by going to the “Settings” > “Account” menu in the OneChat application.","subjectB2":"2. OneChat ID [optional]","detailSubjectB2":"You may choose to specify the name of the chat ID. You may choose to allow your friends to find you on the Service more easily and allow your friends to find you by their OneChat ID, or you may opt-out of other OneChat users. You can also contact you using your OneChat ID. Please note that other OneChat users will not be able to see your OneChat ID without permission and your OneChat ID may not be a pseudonym it must be your real name.","subjectB3":"3. Contact phone number [Optional]","detailSubjectB3":"If you wish to invite individual friends or contacts to connect with you using the OneChat application, you may send invitations directly by e-mail directly from your mobile device when you use the Send Friend Invite function in OneChat application","subjectB4":"4. Location information [Optional] ","detailSubjectB41":"In order to use the OneChat application, you do not need to provide your location information. However, the Company provides special features to use geolocation information for your convenience and to increase the efficiency of use for you","detailSubjectB42":"In other cases collected by the Company or use your geolocation information to provide additional services, the Company will provide you with prior notice and obtain your prior consent","subjectB5":"5. Contact information for customer support [Optional]","detailSubjectB51":"In some cases, you may wish to contact the Company to obtain customer support from us. If you contact the company through the company contact form or by other means The Company may obtain and retain any information you choose to provide, including your name, your contact information such as your e-mail address, your phone number, as well as information about your mobile device or personal computer, such as the type of device. and the operating system type of the said device The Company will use this information to correct and investigate problems that you have submitted to the Company to help you and to further improve the company's customer support services","detailSubjectB52":"We may process this information in connection with the assistance you request to manage your account and store this information in accordance with the provisions of this Privacy Policy.","subjectB6":"6. Contact information for promotional activities and customer surveys. [Optional]","detailSubjectB6":"If you choose to participate in various promotional or survey activities that OneChat offers from time to time The Company may ask for your contact details (such as name, postal address, phone number your email address, gender and date of birth) to confirm your eligibility to participate in the event so that you can fill out the questionnaire and to deliver any prizes that you might win and to manage other activities","subjectB7":"7. payment information [Optional]","detailSubjectB71":"If you purchase or use additional services that charge and pay for such additional services by means other than purchases through the iTunes or Google Play application. The Company may have a third party service provider store and process your credit card information. The Company will use your credit card information only to process purchases or use of paid services. Please note that The Company will not retain your credit card information for the period necessary to facilitate the relevant payment.","detailSubjectB72":"Your credit card payment will be processed by an appropriate third party payment agency.","subjectB8":"8. Information from websites and applications in which the Company's services are included. [Optional]","detailSubjectB8":"The Company service and/or third party websites and/or applications additional company applications may also be included. The Company may save your chat login information through the use of such add-on applications. or obtain the address of the website containing the Company's add-on applications that you visit while you log in to the Company's services through your browser. Please note that your personal data will not be received from such websites or applications that contain the Company's add-on applications if you log out from the Service.","subjectB9":"9. User Generated Information about the User himself and shared with others User Generated Content. [Optional]","detailSubjectB91":"In addition to the information detailed above you may choose to set profile information (such as your Display Name, profile picture and phrase you choose to display under your status) and identify yourself with other OneChat users on the Service. Choose to create user-generated content, such as text and voice messages, photos, videos, geolocation data or your friends' contact information on your chat days and share this user-generated content with other users. You may choose to share any more or less of your User Generated Content and you can choose who to share that content with when you create a message by selecting the recipients of your own user-generated content and/or through the privacy settings in the OneChat application.","detailSubjectB92":"Please note that profile information and user-generated content that you share with others can be copied, stored or published by recipients of such content and are also likely to be accessible to third parties who not intended to be the recipient as well because it is digital The Company urges you to be careful and cautious when you create and share your personal information or content with others."},"subject4":{"header":"4. How does the company use and manage your information?","subjectA":"A. How does OneChat use data user?","detailSubjectA":" In providing services and any additional of OneChat, the data controller or data controller, will use your personal data for the purposes of this Privacy Policy as follows","detailSubjectA1":"To provide you with any additional services and services and to allow you to submit your own User Generated Content to other users of OneChat","detailSubjectA2":"To verify your identity","detailSubjectA3":"To allow you to use your OneChat account on multiple devices and transfer your OneChat account to another device.","detailSubjectA4":"To help you find people you know who are already using One Chat. which you can connect to each other using one chat and as you have previously agreed to allow other OneChat users to connect with you.","detailSubjectA5":"So that you can sync with other applications of OneChat, affiliates and business partners of OneChat with your chat account and to share information between the applications you use.","detailSubjectA6":"To respond to requests you may have in order to use additional services of OneChat.","detailSubjectA7":"To monitor, detect and prevent unauthorized use of the Service; or use it in a fraudulent manner or in a wrong way","detailSubjectA8":"To improve and/or make it suitable in services and additional services","detailSubjectA9":"So that the company can provide customer support services and respond to your inquiries and requests efficiently","detailSubjectA10":"To provide you with information about additional services and services","detailSubjectA11":"To measure the effectiveness of advertisements displayed by the Company on the Internet or in other media.","detailSubjectA12":"To inform you of any other important information about the Service and, if necessary, additional services.","detailSubjectA13":"To identify the winners of the contest in various promotional activities to send prizes to the winners and to deliver purchased products and services","detailSubjectA14":"To collect statistical data anonymously about additional services and services; and","detailSubjectA15":"To comply with applicable law or legal duty","detailSubjectA16":"However, if the Company notifies you of a more specific purpose of use at the time the Company requests your personal data or by other means, such notification will supersede the general purposes of use specified in clause 4.A of this Privacy Policy","subjectB":"B. How will OneChat protect user privacy?","detailSubjectB1":"To carry out our obligations to respect and protect your right to privacy and keeping your personal information confidential, OneChat use appropriate organizational security techniques and standards as well as industry standard safeguards to prevent unauthorized access or disclosure, misuse, alteration or destruction of your information.","detailSubjectB2":"Because the company does not have any electronic means of transmitting information or any storage method is perfect or impenetrable, therefore cannot guarantee that your personal data will be completely safe from intrusion during transmission or stored in the Company's systems to help protect it. Your right to privacy and to keep your personal information confidential, the company needs your help, please do not share your password with other people or use the same password you use for other services. In addition, please notify the Company in case you suspect any unauthorized use of your account or any other security breach through the Company's contact form.","subjectC":"C. Where is the user's personal information transmitted and stored?","detailSubjectC":" To provide service with reliability and responsibility OneChat will process and store your information on secure servers located in Thailand provided that all such transfers are subject to the requirements of applicable law.","subjectD":" D. How long does a OneChat keep a user's data?","detailSubjectD1":"OneChat will retain the personal information you provide for the duration of your account active, for as long as is necessary to fulfill the purposes of use as detailed in this Privacy Policy or to comply with applicable laws and regulations","detailSubjectD2":"The Company may retain your personal data even after your account has been closed or terminated if it is reasonably necessary to keep it as follows:","detailSubjectD3":"To comply with applicable laws and regulations or legal duties","detailSubjectD4":"To provide complete customer support services","detailSubjectD5":"To settle disputes between or with users on Chat for the duration of the applicable or","detailSubjectD6":"To detect and prevent unauthorized use of the service or use it in a fraudulent manner or in a wrong way","subjectE":"E. Does OneChat use an external service provider or agent?","detailSubjectE":"In order to provide the Services, OneChat sometimes requires that third-party service providers process user data that may include your personal data. The Company strictly selects such Third Party Service Providers and the Company will use reasonable endeavors to ensure that the Third Party Service Providers have put in place appropriate and secure information management and internal controls and we has imposed contractual obligations on such service providers in order for such service providers to comply with applicable laws and regulations regarding the processing of personal data. We also require such third party service providers to access your personal data only to the extent necessary for our instructions and purposes. Such external accesses your personal data only to the extent necessary for our instructions and purposes.","subjectF":"F. Does OneChat provide user information to third parties?","detailSubjectF":"In addition to the details above in this Privacy Policy and privacy protection policies or other relevant suffixes OneChat will not provide your information to any other person without your consent unless the Company has a good faith belief that The Company is required or authorized to do so in accordance with applicable law.","subjectG":"G. Does OneChat use cookies or other similar technologies?","detailSubjectG1":"The Company uses cookies or other similar specific storage technologies.","detailSubjectG2":"Cookies are small files that are stored on your computer when you visit a website. These files store information that a website can use to read again when you visit that website on a later date. This is necessary because otherwise the website will not function properly. Other cookies provide convenience to visitors by remembering their username in a secure way and in the language of your choice. Cookies are provided so that you do not have to fill in the same information each time you visit our website, we use cookies to:","detailSubjectG3":"To help the Company to maintain your session information when you use the Services and/or any additional services.","detailSubjectG4":"Optimize the security of our system.","detailSubjectG5":"Collect preferences and provide services that are customized according to your needs and","detailSubjectG6":"To help the company understand how people use the service and to improve the service, we also use the following third party cookies on the website.","detailSubjectG7":"Google Analytics","detailSubjectG8":"Your continued use of the Service indicates that you agree to the Company's use of cookies and similar technologies in accordance with this Privacy Policy.","detailSubjectG9":"Most Internet browsers allow you to control whether you accept the use of cookies if you disable cookies or limit your ability to set cookies. You may not be able to take advantage of the website or access all its functions, which may limit your overall use."},"subject5":{"header":"5. Your Choices and Rights","detailHeader":"It is possible that OneChat may receive personal information about individuals who are not current users of the service. Please note that whether you are a user or not, you can choose and have different rights. According to this section, if the company collects your personal information","subjectA":"A. How do users control their data?","detailSubjectA":"Subject to applicable law (including exclusions or exceptions under such laws), you may have the right to access your personal data, the right to correct errors in the personal data and the right to object on grounds of legal processing which your personal information.  You may exercise your rights directly within the OneChat application at any time, for example:","detailSubjectA1":"In the “Profile” menu in the Settings section of the application, you can verify and or edit your phone number, and you can also verify and edit your display name. and your profile picture, and","detailSubjectA2":"In the “Accounts” menu in the Settings section of the application you can verify and/or modify your registered email address. You can also delete your registered email address or disconnect your Facebook account.","detailSubjectA3":"To exercise any rights of yours under applicable law you may contact us via the contact form. Upon verifying your identity, the Company will respond to your request within a reasonable period of time and in accordance with applicable law. If you wish to submit a written request to the Company, please see the Company's e-mail address at clause 6.A.","detailSubjectA4":"If you no longer wish to use the service alternatively or no longer wish to allow OneChat to collect and use your personal data, you may choose to delete your entire account directly through the OneChat application. The company will delete your information in accordance with clause 4.D.","subjectB":"B. What if the user changes their mind?","detailSubjectB":"If you change your mind about how much you wish to share or continue disclosing information about the service, you can change your settings in the OneChat application. For example, matters related to","detailSubjectB1":"Your profile information (such as your profile picture, display name).","detailSubjectB2":"Can other OneChat users contact you using your OneChat ID?","detailSubjectB3":"Block or unblock some OneChat users.","detailSubjectB4":"Let other OneChat users who already have your phone number. Can I contact you via OneChat?"},"subject6":{"header":"6. Other important information","subjectA":"A. Users have questions/suggestions/concerns.","detailSubjectA":"If you have any questions, suggestions or concerns about this Privacy Policy or any of the Company's other privacy protection policies or practices, please contact the Company through the Company's contact form or send a letter to the company at 1768 Thai Summit Tower, 14th Floor and IT Floor, New Petchaburi Road, Bang Kapi Sub-district, Huay Khwang District, Bangkok 10310 or E-mail :  onechat@one.th","subjectB":"B. Amendments to this Privacy Policy","detailSubjectB1":"The Company may revise the Company's Privacy Policy from time to time for a variety of reasons, including to improve the Company's privacy practices to reflect changes to the Company's services and to comply with applicable laws. The Company created this Privacy Policy for the first time on June 21, 2018.","detailSubjectB2":"When the company makes changes to the privacy policy of the company in a material way, the company will notify you on the service of the company or by other reasonable means. The Company recommends that you carefully review such amendments, if you agree to such amendments, please continue to use the Company's services but if you do not agree to such amendment and does not wish to use the Company's services any longer You may choose to close your account. Your continued use of the Company's services after having been notified to you of the changes or having been posted on the Company's services is deemed to have accepted the amendments and agreed to the privacy protection policy at his change has been fixed."}}},"Anonymous":{"manageGroup":"您管理的群组","yourGroup":"您的群组","noManageGroup":"没有您管理的群组","noYourManageGroup":"没有您的群组","createGroup":"建立群聊天","createBusiness":"建立Business"},"Homepage":{"Title":{"title1":"Chat Application provided by Thai for Thai people","title2":"Your conversations will be safe","title3":"What is?"},"Detail":{"detailOnechat":"One Chat is part of the One Platform services, which is used to communicate between citizens, businesses, and governments. To facilitate an easier and less time-consuming way of expansion of business, assuring the quality of reliable and safety standards.","detailOneplatform":"One Chat is connecting with services in One Platform, such as One E-mail and One Box","detailOnebox":"Free cloud storage","detailOnemail":"Free e-Mail","detailOnechatFn1":"One Chat provides sending free messages, files, voice, pictures, and many other functions","detailOnechatFn2":"One Chat can be compatible with all mobile operating systems whether iOS, Android, or PC (Windows, Mac OS)","detailOnechatFn3":"One Chat provides One Chatbot service, an auto-reply message such as texts, pictures, document files, and other text formats"},"Button":{"join":"加入我们","moredetail":"查看更多"},"Footer":{"companyname":"One Centric Company Limited","date":"星期一至星期五在工作时间内开放","time":"上午9.00 - 下午5.00","address1":"1768 Thai Summit Tower 16th Floor","address2":"New Petchaburi Road, Bang Kapi Sub-district","address3":"Huay Khwang District, Bangkok 10310","policy":"隐私权政策","report":"报告问题","sendmsg":"联系我们"},"Dialog":{"titleReport":"报告问题","name":"名字","email":"邮箱","phone":"手机号码","subject":"主题","detail":"您的问题...","inputEmail":"请输入您的电子邮件地址","inputEmailError":"您的邮箱地址无效","inputphoneErrorDigit":"请输入您的手机号码","inputphoneErrorFormat":"您的手机号码无效","inputphoneErrorNumber":"请填写手机号","inputName":"请填写您名字","inputDetail":"请输入您的问题","titleSendMessage":"发送"}},"Login":{"titleLogin1":"欢迎来到 OneChat","titleLogin2":"登录","typeLogin1":"用OneID","typeLogin2":"用手机号","phone":"手机号码","username":"用户名","password":"密码","forgotpass":"忘记密码","conjunction":"或","Button":{"sendotp":"发送验证码","time":"秒","resend":"发送验证码","login":"登录","loginnavbar":"登录"}},"Register":{"title1":"","title2":"欢迎注册","title3":"注册","title4":"您将得到我们的良好服务","span1":"免费","span2":"邮箱","span3":"在线存储空间","Button":{"register":"注册","accept":"确定","back":"后退","policy":"服务条款"},"content":"<h4>Terms and Conditions of Service</h4>1. Using of our services <br>&nbsp;&nbsp;&nbsp;1.1 Your using of our services does not give you ownership of any intellectual property rights in the services or content you access.<br>&nbsp;&nbsp;&nbsp;1.2 By providing services from us, we may send service announcements; provide you with administrative news and other information to you. You can opt-out of some of these communications.<br>&nbsp;&nbsp;&nbsp;1.3 Some of our services can be used on mobile devices so do not use them in a way that distracts and prevents you from complying with traffic or safety laws.<br><br>2. Your One Platform account<br>&nbsp;&nbsp;&nbsp;2.1 You may need a One Platform account in order to use some of our services, other or additional terms may apply to you and your administrator may be able to access or disable your account.<br>&nbsp;&nbsp;&nbsp;2.2 To protect your One Platform account, please keep your password confidential. You are responsible for any activities that occur on through your One Platform account. Try not to reuse your One Platform account password on any third-party applications.<br><br>3. Protection of personal data and copyright<br>&nbsp;&nbsp;&nbsp;3.1 By using our services, you consent to the use of such information by One Platform in accordance with that Privacy Policy.<br><br>4. Modifications and Terminations of our Services<br>&nbsp;&nbsp;&nbsp;4.1 We make changes and improvements to our services regularly, we may add or remove certain functionality or features and we may suspend or discontinue any service altogether.<br>&nbsp;&nbsp;&nbsp;4.2 You can stop using our services at any time.<br><br>5. Business use of our services<br>&nbsp;&nbsp;&nbsp;5.1 If you use our services on behalf of a business, that business must agree to these terms. <br>&nbsp;&nbsp;&nbsp;5.2 The business will not demand that One Platform and its affiliates, officers, agents and employees indemnify to you and you will not litigate or take action arising out of or in connection with your use of the service or breach of these terms including that such person shall not be liable or have to pay any expenses arising from claims, losses, damages, litigation, judgments, litigation costs and attorney fees.<br>"},"File":{"passwordFile":"Password","textRequirePassword":"please enter file's password","wrongPassword":"Wrong Password!","downloadFile":"download file"},"custsat":{"Header":"Customer Satisfaction Survey","username":"User","ask_1":{"operation_system_1":"Which Operating System are you currently using on One Chat Application","morethanone":"Can choose more than one","android":"Android","ios":"iOS","website":"Website"},"ask_2":{"frequencyUse":"How often do you use this app","option1":"Less than once a week","option2":"1-3 days a week","option3":"4-6 days a week","option4":"Daily"},"ask_3":"Does it offer all the key features you require","ask_4":"Is the product fast and responsive","ask_5":"Overall, how would you rate the quality of your customer service experience","comment":"Further questions & comments","send":"send"}}

/***/ }),

/***/ "sVBg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/ShowImage_ProfileDialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ShowImage_ProfileDialog = ({
  props: { dialogshowimage_profile: false, pathpicture: '', typepathpicture: '' },
  data: function data() {
    return {
      token: ''
    };
  },
  computed: extends_default()({}, Object(vuex_pathify_esm["c" /* sync */])('*')),
  watch: {},

  // item.message, item.file_name, item.nickname, item.path_pic, dateMoment(item.timestamp),timeMoment(item.timestamp), item.tokenmessage, item.type)
  methods: {
    loadpic: function loadpic(filenameSend) {
      this.axios.get(this.DetailImage.path, {
        responseType: 'blob'
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filenameSend);
        document.body.appendChild(link);
        link.click();
      });
    },
    sendimgonebox: function sendimgonebox(tokenmessage) {
      var _this = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/save_onebox2', {
        tokenmessage: tokenmessage,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          _this.$swal('Send Success!', 'Your file has been sent.', 'success');
        }
      });
    },
    closeDialogShowImage_Profile: function closeDialogShowImage_Profile() {
      this.$emit('closeDialogShowImage_Profile', false);
    },
    date: function date(timestamp) {
      return services["c" /* Momenttime */].momentdatethai(timestamp);
    },
    time: function time(timestamp) {
      return services["c" /* Momenttime */].momenttimethai(timestamp);
    }
    // this.dateSend = Momenttime.momentdatethai(timestamp)
    //   // this.timeSend = Momenttime.momenttimethai(timestamp)

  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b66a2f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/ShowImage_ProfileDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogshowimage_profile),callback:function ($$v) {_vm.dialogshowimage_profile=$$v},expression:"dialogshowimage_profile"}},[_c('v-card',{staticStyle:{"background-color":"rgba(0, 0, 0, 0.9)"}},[_c('v-toolbar',{staticStyle:{"background":"none !important"},attrs:{"dark":""}},[_c('v-flex',{staticStyle:{"text-align":"right","background":"none !important"},attrs:{"xl12":"","lg12":"","md12":"","sm12":""}},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialogShowImage_Profile}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"background":"none"}},[(_vm.pathpicture)?_c('img',{staticClass:"modal-contentc",attrs:{"src":_vm.pathpicture}}):(_vm.typepathpicture=='group')?_c('img',{staticClass:"modal-contentc",attrs:{"src":"/static/img/default_profile/group-white.png"}}):(_vm.typepathpicture=='business')?_c('img',{staticClass:"modal-contentc",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(_vm.typepathpicture=='bot')?_c('img',{staticClass:"modal-contentc",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"modal-contentc",attrs:{"src":"/static/img/default_profile/man-white.png"}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_ShowImage_ProfileDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/ShowImage_ProfileDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("Bln8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74b66a2f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ShowImage_ProfileDialog,
  dialog_ShowImage_ProfileDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var chat_dialog_ShowImage_ProfileDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sXCK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sfrc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sray":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t8h1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex-pathify/dist/vuex-pathify.esm.js
var vuex_pathify_esm = __webpack_require__("YtWf");

// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__("+vOg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/dialog/AccountDialogMobile.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var AccountDialogMobile = ({
  props: { dialogAccount: false },
  data: function data() {
    return {
      tokenuser: '',
      progress: false,
      status: 'progress',
      FriendList: [],
      search: '',
      contact_select: '',
      typeuser: ''
    };
  },
  created: function created() {
    var decoded = JSON.parse(services["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.tokenuser = decoded['tokenuser'];
    this.typeuser = localStorage.getItem('type_user');
    this.getlistfriend();
  },

  watch: {
    socketaccept_friend: function socketaccept_friend() {
      this.getlistfriend();
    },
    socketremove_friend: function socketremove_friend() {
      this.getlistfriend();
    }
  },
  computed: extends_default()({
    FilterFriendList: function FilterFriendList() {
      var _this = this;

      if (this.search !== '' && this.search !== null) {
        return this.FriendList.filter(function (post) {
          return post.name.toLowerCase().includes(_this.search.toLowerCase());
        });
      } else {
        return this.FriendList;
      }
    }
  }, Object(vuex_pathify_esm["c" /* sync */])('*')),
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeAccount', false);
      this.contact_select = '';
      this.search = '';
    },
    sendContact: function sendContact() {
      var _this2 = this;

      if (this.contact_select !== '') {
        // console.log(this.contact_select)
        this.axios.post("https://uatchat-manage.one.th/message" + '/push_contact', { tokenroom: this.$route.params.roomid, tokenuser: this.tokenuser, tokencontact: this.contact_select['tokenuser'], type: this.typeuser }).then(function (response) {
          if (response.data['status'] === 'success') {
            _this2.$emit('pushcontact', { data: response.data.data, status: 'success' });
            _this2.$swal('', _this2.$t('Alert.Success.account'), 'success');
            _this2.closeDialog();
          } else {
            _this2.$swal('Network error', _this2.$t('Alert.Fail.default.networkError'), 'error');
            _this2.closeDialog();
          }
        }, function () {
          // console.log(this.contact_select)
          _this2.$emit('pushcontact', { data: _this2.contact_select, status: 'error' });
          _this2.$swal('Network error', _this2.$t('Alert.Fail.default.networkError'), 'error');
          _this2.closeDialog();
        });
      }
    },
    getlistfriend: function getlistfriend() {
      var _this3 = this;

      this.status = 'progress';
      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistfriend', { tokenuser: this.tokenuser }).then(function (response) {
        _this3.status = 'show';
        _this3.FriendList = response.data['listfriend'];
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ff722f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/dialog/AccountDialogMobile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"max-width":"500px","persistent":"","max-height":"500px"},model:{value:(_vm.dialogAccount),callback:function ($$v) {_vm.dialogAccount=$$v},expression:"dialogAccount"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("assignment_ind")]),_vm._v("  "+_vm._s(_vm.$t('Dialog.account')))],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[(_vm.status == 'progress')?_c('v-progress-linear',{attrs:{"indeterminate":_vm.progress}}):_c('v-container',{staticStyle:{"padding-top":"0px"},attrs:{"wrap":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","wrap":""}},[_c('v-flex',{staticStyle:{"height":"50px"},attrs:{"sm12":"","md12":"","xs12":""}},[_c('v-text-field',{staticClass:"bgsearchcontact CSChatThai",attrs:{"append-icon":"search","label":_vm.$t('LeftSide.addFiend.searching'),"solo":"","clearable":"","id":"searchcontact"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":"","xs12":""}},[(_vm.FilterFriendList.length != 0)?_c('v-container',{staticClass:"scroll-y CSChatThai",staticStyle:{"height":"30vh","margin-top":"0","width":"100%","padding":"0"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-list',{staticClass:"scroll-y CSChatThai",staticStyle:{"width":"100%","overflow-x":"hidden"},attrs:{"two-line":""}},[_c('v-radio-group',{attrs:{"column":""},model:{value:(_vm.contact_select),callback:function ($$v) {_vm.contact_select=$$v},expression:"contact_select"}},[_vm._l((_vm.FilterFriendList),function(item,index){return [_c('v-list-tile',{attrs:{"avatar":"","ripple":""}},[_c('v-list-tile-action',[_c('v-radio',{attrs:{"value":item}})],1),_vm._v(" "),_c('v-list-tile-avatar',[(item.profilepicture)?_c('img',{staticClass:"alligator-turtle",attrs:{"src":item.profilepicture}}):(item.type === 'business')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'government')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/business-white.png"}}):(item.type === 'bot')?_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/bot-white.png"}}):_c('img',{staticClass:"alligator-turtle",attrs:{"src":"/static/img/default_profile/man-white.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"text-overflow":"ellipsis","overflow":"hidden","white-space":"nowrap","width":"80px"}},[_vm._v("\n                          "+_vm._s(item.name)+"\n                        ")])],1)],1)]})],2)],1)],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{attrs:{"align-center":"","justify-center":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{staticStyle:{"margin-right":"10px"},attrs:{"align-center":"","justify-end":"","row":"","wrap":""}},[_c('v-btn',{staticClass:"btncancel text-transform",attrs:{"color":"red"},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel')))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[_c('v-btn',{staticClass:"btnallow text-transform",attrs:{"color":"blue darken-1","disabled":_vm.contact_select.length == 0},on:{"click":function($event){_vm.sendContact()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.send')))])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dialog_AccountDialogMobile = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/dialog/AccountDialogMobile.vue
function injectStyle (ssrContext) {
  __webpack_require__("8xQL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ff722f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  AccountDialogMobile,
  dialog_AccountDialogMobile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mobile_dialog_AccountDialogMobile = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tNVr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_pathify__ = __webpack_require__("YtWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("+vOg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
// import { mapState } from 'vuex'


/* harmony default export */ __webpack_exports__["a"] = ({
  props: { dialogManageGroup: false, detail: '' },
  data: function data() {
    return {
      token: '',
      selectFile: '',
      imageData: '',
      picgroup: '',
      edit: false,
      nameedit: ''
    };
  },
  methods: {
    editprofile: function editprofile() {
      this.edit = !this.edit;
      this.nameedit = this.detail.group_name;
    },
    uppic: function uppic() {
      $('#uploadpicturegroup').click();
    },
    closeManageGroup: function closeManageGroup() {
      this.$emit('closeManageGroup', false);
      this.selectFile = '';
      this.imageData = '';
    },

    previewImage: function previewImage(event) {
      var _this = this;

      var input = event.target;
      this.selectFile = event.target.files[0];
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this.imageData = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImagegroup: function previewImagegroup() {
      var _this2 = this;

      this.selectFile = event.target.files[0];
      if (this.selectFile !== '') {
        var uploadFile = new FormData();
        uploadFile.append('file', this.selectFile, this.selectFile.name);
        uploadFile.append('group_id', this.detail.group_id);
        uploadFile.append('tokenuser', this.token);
        this.axios.post("https://uatchat-manage.one.th/manage" + '/setimagegroup', uploadFile).then(function (response) {
          // console.log(response.data)
          if (response.data['status'] === 'success') {
            _this2.detail.picture = response.data.filename;
            _this2.picturegroup = response.data.filename;
            _this2.selectFile = '';
            document.querySelector('#uploadpicturegroup').value = '';
            _this2.$swal('', _this2.$t('Alert.Success.changePictureGroup'), 'success');
          } else {
            // console.log('fail')
            _this2.selectFile = '';
            document.querySelector('#uploadpicturegroup').value = '';
            _this2.$swal('', _this2.$t('Alert.Fail.default.somethingWrong'), 'error');
          }
        });
      }
    },
    changeprofile: function changeprofile() {
      var _this3 = this;

      this.edit = !this.edit;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/setnamegroup', { tokenuser: this.token, groupname: this.nameedit, group_id: this.detail.group_id }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          _this3.detail.group_name = _this3.nameedit;
          _this3.groupname = _this3.nameedit;
          _this3.$swal('', _this3.$t('Alert.Success.renameGroup'), 'success');
        }
      }, function (response) {});
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex_pathify__["c" /* sync */])('*')),
  watch: {
    dialogManageGroup: function dialogManageGroup() {
      if (this.dialogManageGroup) {}
    }
  },
  created: function created() {
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.webbackend = "https://uatchat.one.th";
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "tTlU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dragAndDropCapable: false,
      files: [],
      token: ''
    };
  },
  mounted: function mounted() {
    this.dragAndDropCapable = this.determineDragAndDropCapable();
    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
        this.$refs.fileform.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }.bind(this));
      this.$refs.fileform.addEventListener('drop', function (e) {
        for (var i = 0; i < e.dataTransfer.files.length; i++) {
          this.files.push({ file: e.dataTransfer.files[i], status: 'waiting' });
          this.getImagePreviews();
        }
      }.bind(this));
    }
  },

  methods: {
    openFileimage: function openFileimage() {
      this.$refs.files.click();
    },
    upfile: function upfile() {
      $('#uploadfile').click();
    },
    determineDragAndDropCapable: function determineDragAndDropCapable() {
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
    },
    getImagePreviews: function getImagePreviews(key) {
      var _this = this;

      var _loop = function _loop(i) {
        if (/\.(jpe?g|png|gif)$/i.test(_this.files[i].file.name)) {
          var reader = new FileReader();
          reader.addEventListener('load', function () {
            this.$refs['preview' + parseInt(i)][0].src = reader.result;
          }.bind(_this), false);
          reader.readAsDataURL(_this.files[i].file);
          // this.extension(this.files[i].name)
          // console.log(this.extension())
        } else {
            // this.$nextTick(function(){
            // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
            // });
            // console.log('mm')
          }
      };

      for (var i = 0; i < this.files.length; i++) {
        _loop(i);
      }
    },
    handleFilesUpload: function handleFilesUpload(key) {
      var uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({ file: uploadedFiles[i], status: 'waiting' });
      }
      this.getImagePreviews(key);
      document.querySelector('#files').value = '';
    },
    submitFiles: function submitFiles(key) {
      var _this2 = this;

      var formData = new FormData();
      // for (var i = 0; i < this.files.length; i++) {
      var file = this.files[key].file;
      formData.append('files[' + key + ']', file);
      formData.append('file', file, file.name);
      formData.append('tokenuser', this.token);
      formData.append('appkey', 'QWErty1234');
      this.axios.post("https://uatchat-manage.one.th/event" + '/save_onebox', formData).then(function (response) {
        console.log(response.data);
        if (response.data.status === 'success') {
          // console.log(response)
          _this2.$swal('ส่งไฟล์ไป One box', 'ส่งไฟล์สำเร็จ', 'success');
          // this.files.splice(key, 1)
          _this2.removeFile(key);
          // this.files.splice( key )
        } else {
          _this2.$swal('ส่งไฟล์ไป One box', 'ส่งไฟล์ไม่สำเร็จ', 'error');
          _this2.files[key]['status'] = 'fail';
        }
      }, function (response) {
        console.log('error');
        _this2.$swal('ส่งไฟล์ไป One box', 'ส่งไฟล์ไม่สำเร็จ', 'error');
        _this2.files[key]['status'] = 'fail';
      }).catch(function (error) {
        console.log(error);
        _this2.$swal('ส่งไฟล์ไป One box', 'ส่งไฟล์ไม่สำเร็จ', 'error');
        _this2.files[key]['status'] = 'fail';
      });
    },
    removeFile: function removeFile(key) {
      this.files.splice(key, 1);
      // this.getImagePreviews(key)
    },
    submitallFiles: function submitallFiles() {
      var lengthfile = this.files.length;
      for (var i = 0; i < lengthfile; i++) {
        this.senbox(i);
      }
    },
    senbox: function senbox(i) {
      var _this3 = this;

      var formData = new FormData();
      var file = this.files[i].file;
      // formData.append('files[0]', file)
      formData.append('file', file, file.name);
      formData.append('tokenuser', this.token);
      this.files[i]['status'] = 'process';
      this.axios.post("https://uatchat-manage.one.th/event" + '/save_onebox', formData).then(function (response) {
        if (response.data.status === 'success') {
          console.log('success');
          _this3.files[i]['status'] = 'success';
          // this.removeFile(i)
          // console.log(this.files.length)
          // return 'true'
          // console.log(this.files.length)
        } else {
          _this3.$swal('ส่งไฟล์ไป One box', 'ส่งไฟล์ไม่สำเร็จ', 'error');
          _this3.files[i]['status'] = 'fail';
          // return 'false'
        }
      }).catch(function (error) {
        console.log(error);
        _this3.$swal('ส่งไฟล์ไป One box', 'ส่งไฟล์ไม่สำเร็จ', 'error');
        _this3.files[i]['status'] = 'fail';
      });
    },
    extension: function extension(files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase();
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
      var pdf = ['pdf'];
      var file = ['ai', 'ps', 'psd'];
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm'];
      var presentation = ['ppt', 'pps', 'pot', 'pptx'];
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff'];
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf';
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive';
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel';
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint';
      } else if (word.includes(extension)) {
        return 'fas fa-file-word';
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code';
      } else if (image.includes(extension)) {
        return 'fas fa-file-image';
      } else if (file.includes(extension)) {
        return 'fas fa-file';
      } else {
        return 'fas fa-file-alt';
      }
      // return extension[extension.length-1]
    }
  },
  created: function created() {
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    // console.log(this.token)
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "tjwz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tlbM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "turh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tx5O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uEgb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uS+H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uSQs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ui8T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pdf__ = __webpack_require__("dAhr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mobile_dialog_NoteDialogMobile__ = __webpack_require__("QaDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mobile_dialog_AccountDialogMobile__ = __webpack_require__("t8h1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mobile_dialog_MapDialogMobile__ = __webpack_require__("f3Oo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mobile_dialog_ApproveDialogMobile__ = __webpack_require__("j71L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_mobile_dialog_AlbumsDialogMobile__ = __webpack_require__("HFu5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mobile_dialog_AddImageDialogMobile__ = __webpack_require__("FcrC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_mobile_dialog_InforfriendDialogMobile__ = __webpack_require__("gbCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_mobile_task_detail_task_dialog_mo__ = __webpack_require__("Dp7v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_mobile_dialog_SaveoneboxDialogMobile__ = __webpack_require__("UtNl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_mobile_dialog_RichmenuDialogMobile__ = __webpack_require__("8yZq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_mobile_dialog_WebviewOcrDialogMobile__ = __webpack_require__("qTcZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_chat_dialog_CheckBrowserDialog__ = __webpack_require__("Se0g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_mobile_dialog_QrCodeRichMenuDialog__ = __webpack_require__("9kuc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_mobile_dialog_CreatemailDialogMobile__ = __webpack_require__("43wB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_mobile_dialog_ReadmoreDialogMobile__ = __webpack_require__("E/iq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_chat_dialog_dialogGetPassword__ = __webpack_require__("nIDX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuex_pathify__ = __webpack_require__("YtWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_context__ = __webpack_require__("IaZh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_100vh__ = __webpack_require__("hErE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_hls_player__ = __webpack_require__("VfTH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_hls_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_hls_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_link_prevue__ = __webpack_require__("mo46");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_link_prevue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_link_prevue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_screen_size__ = __webpack_require__("B8hy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_long_click__ = __webpack_require__("+ReX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_long_click___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_long_click__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_pdf_embed_dist_vue2_pdf_embed__ = __webpack_require__("Nps2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_pdf_embed_dist_vue2_pdf_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vue_pdf_embed_dist_vue2_pdf_embed__);




var _watch;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import Forward from '@/components/mobile/manage/Forwardmessage'
















// import ModalImg from '@/components/chat/modal/ModalImg'






// import Vue100vh from 'vue-div-100vh'


// import VuePdfEmbed from 'vue-pdf-embed'

var longClickInstance = Object(__WEBPACK_IMPORTED_MODULE_28_vue_long_click__["longClickDirective"])({ delay: 1000, interval: 1000 });
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].directive('longclick', longClickInstance);

var emojiGroups = __webpack_require__("WJD3");
var _ = __webpack_require__("M4fF");
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_27_vue_screen_size__["a" /* default */].VueScreenSizeMixin],
  components: {
    VuePdfEmbed: __WEBPACK_IMPORTED_MODULE_29_vue_pdf_embed_dist_vue2_pdf_embed___default.a,
    ReadmoreDialog: __WEBPACK_IMPORTED_MODULE_20__components_mobile_dialog_ReadmoreDialogMobile__["a" /* default */],
    CreateMailMobileDialog: __WEBPACK_IMPORTED_MODULE_19__components_mobile_dialog_CreatemailDialogMobile__["a" /* default */],
    vplayer: __WEBPACK_IMPORTED_MODULE_25_vue_hls_player__["vplayer"],
    QrCodeRichMenuDialog: __WEBPACK_IMPORTED_MODULE_18__components_mobile_dialog_QrCodeRichMenuDialog__["a" /* default */],
    CheckBrowserDialog: __WEBPACK_IMPORTED_MODULE_17__components_chat_dialog_CheckBrowserDialog__["a" /* default */],
    // EmojiPicker,
    WebviewBigOcrDialog: __WEBPACK_IMPORTED_MODULE_16__components_mobile_dialog_WebviewOcrDialogMobile__["a" /* default */],
    Richmenudialogmobile: __WEBPACK_IMPORTED_MODULE_15__components_mobile_dialog_RichmenuDialogMobile__["a" /* default */],
    pdf: __WEBPACK_IMPORTED_MODULE_4_vue_pdf__["a" /* default */],
    // ModalImg,
    ApproveDialogMobile: __WEBPACK_IMPORTED_MODULE_9__components_mobile_dialog_ApproveDialogMobile__["a" /* default */],
    MapDialogMobile: __WEBPACK_IMPORTED_MODULE_8__components_mobile_dialog_MapDialogMobile__["a" /* default */],
    NoteDialog: __WEBPACK_IMPORTED_MODULE_6__components_mobile_dialog_NoteDialogMobile__["a" /* default */],
    AccountDialog: __WEBPACK_IMPORTED_MODULE_7__components_mobile_dialog_AccountDialogMobile__["a" /* default */],
    AddImageDialogMobile: __WEBPACK_IMPORTED_MODULE_11__components_mobile_dialog_AddImageDialogMobile__["a" /* default */],
    AlbumsDialogMobile: __WEBPACK_IMPORTED_MODULE_10__components_mobile_dialog_AlbumsDialogMobile__["a" /* default */],
    InforfriendDialogMobile: __WEBPACK_IMPORTED_MODULE_12__components_mobile_dialog_InforfriendDialogMobile__["a" /* default */],
    VueContext: __WEBPACK_IMPORTED_MODULE_23_vue_context__["VueContext"],
    DetailTask: __WEBPACK_IMPORTED_MODULE_13__components_mobile_task_detail_task_dialog_mo__["a" /* default */],
    SaveOnebox: __WEBPACK_IMPORTED_MODULE_14__components_mobile_dialog_SaveoneboxDialogMobile__["a" /* default */],
    LinkPrevue: __WEBPACK_IMPORTED_MODULE_26_link_prevue___default.a,
    // Vue100vh
    vue100vh: __WEBPACK_IMPORTED_MODULE_24_vue_100vh__["a" /* default */],
    DialogGetpassword: __WEBPACK_IMPORTED_MODULE_21__components_chat_dialog_dialogGetPassword__["a" /* default */]
    // Forward
    // LeftSideMobile
    // shareContactDialog
  },
  // props: {infofriend: ''},
  data: function data() {
    var _ref;

    return _ref = {
      showPdf: true,
      loadedRatio: 0,
      dialogReadmore: false,
      detailReadmore: {},
      dialogCreatemailMobile: false,
      bot_dialog_message: false,
      bot_dialog_list: [],
      status_tag: false,
      listfriend_filter: [],
      listfriend: [],
      infor_file: '',
      innerHeight: 0,
      ocr_detailItem: {},
      itemdetail_quickreply: {},
      dialogQrcodRichMenu: false,
      checkBrowserInfor: {},
      checkBrowserDialog: false,
      Webview_item: {},
      Webview_item_ocr: {},
      dialogWebviewbig_ocr: false,
      cycle: false,
      snackbar: false,
      textsnackbar: 'ดาวน์โหลดแอปพลิเคชัน One Chat',
      deviceos: '',
      chatbox: '',
      list_richmenu: [],
      richmenu_label: '',
      type_richmenu: 0,
      Richmenudialog: false,
      inforrichmenu: {},
      sheetrichmenu: false,
      RichmenuState: false,
      default_behavior: 0,
      inforquickreply: {},
      inforwebview: {},
      dialogSaveOnebox: false,
      tokenmessage_savebox: '',
      official_item: {},
      official_sheet: false,
      tokeninforfriend: '',
      inforfrienddialog: false,
      showphone: false,
      tabShowmention: '',
      mentiondialog: false,
      showmention: false,
      picturechip: '',
      chip: false,
      forwarddialog: false,
      forwardimagedialog: false,
      unsenddialog: false,
      unsenddetail: {},
      settingdialog: false,
      imagealbumsdialog: false,
      ApproveDetail: {},
      dialogApprove: false,
      locationName: '',
      dialogSendMap: false,
      sheetmap: false,
      landscape: false,
      sheetwebviewmenu: false,
      sheetwebview: false,
      modalpic: false,
      temp: [],
      selectedmsg: false,
      sheetForward: false,
      showMenu: false,
      selected: false,
      selectedmessage: [],
      centerboxstyle: '',
      sheet: false,
      marker: true,
      iconIndex: 0,
      icons: ['mdi-emoticon', 'mdi-emoticon-cool', 'mdi-emoticon-dead', 'mdi-emoticon-excited', 'mdi-emoticon-happy', 'mdi-emoticon-neutral', 'mdi-emoticon-sad', 'mdi-emoticon-tongue'],
      textinput: false,
      showloc: '',
      dialogAccount: false,
      dialogMap: false,
      statemember: '',
      imgShow: false,
      messageQuickreply: true,
      Quickreply: {},
      datepicker: false,
      timepicker: false,
      dialogNote: false,
      dateselect: '',
      maxdate: '',
      mindate: '',
      timeselect: '',
      maxtime: '',
      mintime: '',
      typepicker: '',
      infodata: '',
      search: '',
      box_height: '',
      note_id: '',
      tabs: ['tab-1', 'tab-2', 'tab-3'],
      active: null,
      model: 'tab-2',
      filepdf: '',
      // shareContact: false,
      currentPage: 1,
      // pageCount: 0,
      // id: getGuid(),
      // select image
      scrollMaxOld: 0,
      firsttime: true,
      statePage: '',
      profile: '',
      members: {},
      offsetTop: 0, // test scroll
      dialog: false,
      tokenrooomSelect: '',
      image: '',
      alert: true,
      items: [],
      // items_friend: [],
      // items_self: [],
      itemShow: [],
      sendmsg: '',
      date: '',
      name: '',
      selectFile: null,
      typeofmessage: '',
      statusload: false,
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      places: [],
      currentPlace: null,
      groupnameTest: '',
      currentLocation: { lat: 0, lng: 0 },
      searchAddressInput: '',
      loadfileData: {},
      place: null,
      lat: '',
      lng: '',
      address: '',
      state: true,
      nicknameSend: '',
      filenameSend: '',
      timeSend: '',
      picSend: '',
      dateSend: '',
      tokenmsgSend: '',
      pathSend: '',
      typeuserSend: '',
      activeEmoji: null,
      activeSticker: null,
      activetapEmo: null,
      sheetother: false,
      sheetsticker: false,
      chatlogsFlex: '',
      showmessagebottom: false,
      showmessage: '',
      sticker: [{ 'list_sticker': [] }],
      typeuser: '',
      progressLoadChat: false,
      emojiGroups: emojiGroups,
      business_id: '',
      map: '',
      x: 15,
      y: 30,
      locationArray: [],
      infofriend: {},
      windowWidth: '',
      dialogAlbums: false,
      dialogAddImage: false,
      albums_id: '',
      path_pic_albums: '',
      file_name: '',
      announce_message: {},
      listannounce: [],
      announcedialog: false,
      expansion_announce: false,
      less: false,
      show: false,
      rightclickdialog: false,
      SelectedMessageDetail: {},
      ListMenuRightClick: []
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'name', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogDetailTask', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'roomid', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'taskid', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'imageData', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'bot_id_richmenu', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'progressBtn', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'numPages', 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'src', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'gotoTokenmessage', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'QrcodeInfor', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'text_search', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'one_id', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'status_block', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'block', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogGetPassword', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'passwordFile', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'DetailFile', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'filetype', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'page', null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'pageCount', 1), _ref;
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    icon: function icon() {
      return this.icons[this.iconIndex];
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_22_vuex_pathify__["c" /* sync */])('*')),
  mounted: function mounted() {
    var _this = this;

    // this.geolocate()
    // this.initmapShow()
    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    });
  },
  updated: function updated() {
    // console.log('update')
    // // this.gotoMessage("5f6440e68bb547000bdb52a1")
    // console.log(this.gotoTokenmessage)
    setTimeout(this.gotoMessage(this.gotoTokenmessage), 2000);
  },

  watch: (_watch = {
    bot_dialog_message: function bot_dialog_message() {
      if (!this.bot_dialog_message) {
        this.bot_dialog_list = [];
      }
    },
    block_friend: function block_friend(data) {
      // console.log(data)
      if (data.event === 'block_friend') {
        this.statemember = 'block';
      } else {
        this.statemember = 'active';
      }
    },
    '$vssHeight': function $vssHeight() {
      this.box_height = this.$vssHeight - (34.0 + 40.0 + 82.0 - 10.0);
      // console.log('height center ==> '+ this.$vssHeight)
      // console.log(this.box_height)
      this.checkHeightRichmenu();
    },
    innerHeight: function innerHeight() {
      // console.log(this.innerHeight)
      // this.box_height = (this.innerHeight - ((34.0 + 40.0 + 82.0) - 10.0))
      this.box_height = this.innerHeight - (34.0 + 40.0 + 82.0 - 10.0);
      // console.log(this.box_height)
    },

    // scrollval () {
    //   var container = this.$el.querySelector('#myscroll')
    //   this.scrollval = container.scrollTop
    //   console.log(this.scrollval)
    // },
    // scrollMaxOld () {
    //   console.log(this.scrollMaxOld)
    // },

    // filepdf () {
    //   console.log(this.filepdf)
    //   this.src = pdf.createLoadingTask(this.filepdf)
    //   console.log(this.src)
    //   this.src.promise.then(pdf => {
    //     console.log(pdf)
    //     this.numPages = pdf.numPages
    //     console.log(this.numPages)
    //   })
    //   // .catch((err) => {
    //   //   console.log(err)
    //   // })
    // },

    socket_drop_menu: function socket_drop_menu(data) {
      // console.log('drop_menu')
      if (data.tokenroom === this.$route.params.roomid) {
        this.sheetrichmenu = false;
      }
    },
    socket_close_webview: function socket_close_webview(data) {
      // console.log(data)
      this.official_item = {};
      this.official_sheet = false;
    },
    socket_switch_keyboard: function socket_switch_keyboard(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.RichmenuState = false;
        this.sheetrichmenu = false;
      }
    },
    socket_switch_richmenu: function socket_switch_richmenu(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.RichmenuState = true;
        this.sheetrichmenu = true;
      }
    },
    socket_official_template: function socket_official_template(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        // console.log(data)
        var index_target = data.target_index;
        var index = _.findIndex(this.items, function (o) {
          return o.tokenmessage == data.tokenmessage;
        });
        this.items[index].element.choice[index_target].disable = '1';
        // console.log(index_target)
      }
    },
    chat_wallpaper: function chat_wallpaper() {
      // console.log(this.chat_wallpaper.info)
      var room = this.$route.params.roomid;
      var index = _.findIndex(this.chat_wallpaper.info, function (o) {
        return o.room === room;
      });
      // console.log(index)
      if (index === -1) {
        this.imageData = '';
      } else {
        this.imageData = this.chat_wallpaper.info[index].background;
      }
      this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - ' + '185px) !important; background-image: url(' + this.imageData + ');';
      // console.log(this.imageData)
    },
    less: function less() {
      if (this.less) {
        this.$cookie.set(this.$route.params.roomid, 'less');
      } else {
        this.$cookie.delete(this.$route.params.roomid);
      }
    },
    socket_announce: function socket_announce(data) {
      var _this2 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_announce_room_by_id', {
        tokenuser: this.token,
        token_announce: data.token_announce,
        tokenroom: this.tokenrooomSelect
      }).then(function (response) {
        _this2.listannounce.unshift(response.data.data);
      });
    },
    showmention: function showmention() {
      if (this.showmention === true && window.innerWidth <= 360) {
        this.tabShowmention = 'bottom: 67px !important;';
      } else if (this.showmention === true && window.innerWidth > 360) {
        this.tabShowmention = 'bottom: 84px !important;';
      }
    },
    box_height: function box_height() {
      // console.log(this.box_height)
      // console.log(this.$vssHeight)
      if (this.sheetrichmenu !== true) {
        // console.log('obj')
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-color: #fdfdfd;';
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-image: url(' + this.imageData + ');';
        }
      } else {}
    },
    groupname: function groupname(data) {
      this.infofriend.group_name = data;
    },
    picturegroup: function picturegroup(data) {
      this.infofriend.picture = data;
    },
    socketquickreply: function socketquickreply(data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        // console.log(data)
        // this.getreply()
        this.datepicker = false;
        this.timepicker = false;
        this.maxdate = '';
        this.mindate = '';
        this.maxtime = '';
        this.mintime = '';
        this.dateselect = '';
        this.timeselect = '';
        this.infodata = '';
        this.Quickreply = data;
      }
    },
    socketdisablequickreply: function socketdisablequickreply(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        // console.log(data)
        // this.getreply()
        // this.Quickreply = ''
        this.datepicker = false;
        this.timepicker = false;
        this.maxdate = '';
        this.mindate = '';
        this.maxtime = '';
        this.mintime = '';
        this.dateselect = '';
        this.timeselect = '';
        this.infodata = '';
        this.Quickreply = '';
      }
    },
    socketdisableapprove: function socketdisableapprove(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        var indexid = _.findIndex(this.items, function (o) {
          return o.tokenmessage === data.tokenmessage && o.typeofmessage === 'approve_message';
        });
        this.items[indexid].disable = 'true';
      }
    },
    socket_unsendmessage: function socket_unsendmessage(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        var indexid = _.findIndex(this.items, function (o) {
          return o.tokenmessage === data.tokenmessage;
        });
        var mentiontokenmessage = this.items[indexid].tokenmessage;
        var indexmentionmsg = _.findIndex(this.items, function (o) {
          return o.file_name === mentiontokenmessage;
        });
        if (indexmentionmsg === -1) {
          this.items[indexid].typeofmessage = 'unsend_message';
        } else {
          this.items[indexid].typeofmessage = 'unsend_message';
          this.items[indexmentionmsg].source_message.typeofmessage = 'unsend_message';
        }
      }
    },
    socket_kickmember: function socket_kickmember(data) {
      var self = this;
      data.listkick.forEach(function (item) {
        if (self.token === item) {
          self.statemember = 'leave';
        }
      });
    },
    socketactive_group: function socketactive_group(data) {
      var self = this;
      if (self.token === data.tokenuser) {
        self.statemember = 'active';
      }
    }
  }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'socket_announce', function socket_announce(data) {
    var _this3 = this;

    // console.log(data)
    this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_announce_room_by_id', {
      tokenuser: this.token,
      token_announce: data.token_announce,
      tokenroom: this.tokenrooomSelect
    }).then(function (response) {
      _this3.listannounce.unshift(response.data.data);
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'selectedmessage', function selectedmessage() {
    if (this.selectedmessage.length > 5) {
      this.$swal('',
      // 'เลือกข้อความได้สูงสุด 5 ข้อความ.',
      this.$t('Alert.Fail.Chat.maxMessage'), 'error');
      _.pullAt(this.selectedmessage, [5]);
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'windowWidth', function windowWidth() {
    // console.log(this.windowWidth)
    // console.log(this.box_height)
    // console.log(this.$vssHeight)
    // console.log(this.windowWidth > 960)
    // if (this.windowWidth > 960) {
    //   // this.box_height = 0
    //   // console.log(this.box_height)
    //   if (localStorage.getItem('height_center') === undefined || localStorage.getItem('height_center') === null) {
    //     this.box_height = (this.$vssHeight - ((34.0 + 40.0 + 82.0) - 10.0))
    //     localStorage.setItem('height_center', this.$vssHeight)
    //   } else {
    //     this.$vssHeight = parseInt(localStorage.getItem('height_center'))
    //     console.log(this.$vssHeight)
    //   }
    // } else {
    //   this.box_height = (this.$vssHeight - ((34.0 + 40.0 + 82.0) - 10.0))
    // }
    // if (this.windowWidth > 960) {
    //   this.box_height = 0
    //   this.$router.push('/chat/room/' + this.$route.params.roomid)
    // } else {
    //   this.$router.push('/mobile/room/' + this.$route.params.roomid)
    // }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'dialogMap', function dialogMap() {
    // console.log(this.dialogMap)
    if (this.dialogMap) {
      // console.log('dialogmap')
      this.initmapShow();
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'sheetrichmenu', function sheetrichmenu() {
    // console.log('type_richmenu: ' + this.type_richmenu)
    // console.log('sheetrichmenu: ' + this.sheetrichmenu)
    // console.log('imageData: ' + this.imageData)
    if (this.type_richmenu <= 7) {
      if (this.sheetrichmenu) {
        // setTimeout(this.scrollDown, 1)
        if (this.imageData === '') {
          // console.log('obj1')
          // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 370px) !important; background-color: #fdfdfd;';
          // console.log(`${this.chatlogsFlex}`)
        } else {
          // console.log('obj2')
          // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 370px) !important; background-image: url(' + this.imageData + ');';
        }
      } else {
        if (this.imageData === '') {
          // console.log('obj3')
          // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 117px) !important; background-color: #fdfdfd;';
        } else {
          // console.log('obj4')
          // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 117px) !important; background-image: url(' + this.imageData + ');';
        }
      }
    } else {
      if (this.sheetrichmenu) {
        // setTimeout(this.scrollDown, 1)
        if (this.imageData === '') {
          // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 245px) !important; background-color: #fdfdfd;';
        } else {
          // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 245px) !important; background-image: url(' + this.imageData + ');';
        }
      } else {
        if (this.imageData === '') {
          // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 120px) !important; background-color: #fdfdfd;';
        } else {
          // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 120px) !important; background-image: url(' + this.imageData + ');';
        }
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'sheetsticker', function sheetsticker() {
    // if (this.sheetsticker === true) {
    //   this.chatlogsFlex = 'height:25vh !important;'
    // } else {
    //   this.chatlogsFlex = 'height:100% !important;'
    // }
    if (this.sheetsticker) {
      if (this.imageData === '') {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-color: #fdfdfd;';
      } else {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-image: url(' + this.imageData + ');';
      }
    } else {
      if (this.imageData === '') {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-color: #fdfdfd;';
      } else {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-image: url(' + this.imageData + ');';
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'sheetother', function sheetother() {
    // if (this.sheetother === true) {
    //   this.chatlogsFlex = 'height:25vh !important;'
    // } else {
    //   this.chatlogsFlex = 'height:100% !important;'
    // }
    // console.log(this.$vssHeight)
    if (this.sheetother) {
      if (this.imageData === '') {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-color: #fdfdfd;';
      } else {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-image: url(' + this.imageData + ');';
      }
    } else {
      if (this.imageData === '') {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-color: #fdfdfd;';
      } else {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-image: url(' + this.imageData + ');';
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'expansion_announce', function expansion_announce() {
    // console.log(this.expansion_announce)
    // if (this.expansion_announce === true) {
    //   this.chatlogsFlex = 'height: 35% !important;'
    // } else {
    //   this.chatlogsFlex = 'height: 90% !important;'
    // }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'sheetForward', function sheetForward() {
    // if (this.sheetForward === true) {
    //   this.chatlogsFlex = 'height:25vh !important;'
    // } else {
    //   this.chatlogsFlex = 'height:100% !important;'
    // }
    if (this.sheetForward) {
      if (this.imageData === '') {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-color: #fdfdfd;';
      } else {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-image: url(' + this.imageData + ');';
      }
    } else {
      if (this.imageData === '') {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-color: #fdfdfd;';
      } else {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-image: url(' + this.imageData + ');';
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'sheetmap', function sheetmap() {
    // if (this.sheetmap === true) {
    //   this.chatlogsFlex = 'height:25vh !important;'
    // } else {
    //   this.chatlogsFlex = 'height:100% !important'
    // }
    if (this.sheetmap) {
      if (this.imageData === '') {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-color: #fdfdfd;';
      } else {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-image: url(' + this.imageData + ');';
      }
    } else {
      if (this.imageData === '') {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-color: #fdfdfd;';
      } else {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-image: url(' + this.imageData + ');';
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'myprofile', function myprofile() {
    this.profile = localStorage.getItem('profilepicture');
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'layout', function layout() {
    this.tokenrooomSelect = this.$route.params.roomid;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, '$route.params.roomid', function $routeParamsRoomid() {
    this.less = false;
    this.scrollMaxOldSet();
    this.statusload = false;
    this.selected = false;
    this.selectedmessage = [];
    var container = this.$el.querySelector('#myscroll');
    container.scrollTop = container.scrollHeight;
    this.tokenrooomSelect = this.$route.params.roomid;
    this.items = [];
    this.box_height = this.$vssHeight - (34.0 + 40.0 + 82.0 - 10.0);
    // this.get_list_richmenu(this.$route.params.roomid)
    this.getdataroom();
    this.getlistannounce();
    this.getOldMessageFirst('');
    this.getreply();
    var announce = this.$cookie.get(this.$route.params.roomid);
    // console.log(announce)
    if (announce !== null) {
      this.less = true;
    }
    this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
    // console.log(this.chat_wallpaper)
    var room = this.tokenrooomSelect;
    var index = _.findIndex(this.chat_wallpaper.info, function (o) {
      return o.room === room;
    });
    // console.log(index)
    if (index === -1) {
      this.imageData = '';
    } else {
      this.imageData = this.chat_wallpaper.info[index].background;
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'socketmessage', function socketmessage() {
    this.getMessageSocket(this.socketmessage);
    // this.getreply()
    // this.Quickreply = []
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, 'sendmsg', function sendmsg() {
    if (event.keyCode === 13 && event.shiftKey) {
      if (event.type === 'keypress') {
        this.pasteIntoInput(this, '\n');
      }
      event.preventDefault();
    } else if (event.keyCode === 13) {
      if (event.type === 'keypress') {
        this.pasteIntoInput(this, '');
      }
      event.preventDefault();
    }
  }), _watch),
  created: function created() {
    var _this4 = this;

    this.innerHeight = window.innerHeight;
    // this.innerHeight = (window.innerHeight - ((34.0 + 40.0 + 82.0) - 10.0))
    this.gotoTokenmessage = this.$route.query.tokenmessage;
    // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
    // this.box_height = (screen.height - 64.0) - 128.0 - 35.0
    this.box_height = this.$vssHeight - (34.0 + 40.0 + 82.0 - 10.0);
    // console.log(this.box_height)
    var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_5__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
    this.token = decoded['tokenuser'];
    this.tokenrooomSelect = this.$route.params.roomid;
    this.profile = localStorage.getItem('profilepicture');
    this.typeuser = localStorage.getItem('type_user');
    this.business_id = localStorage.getItem('business_id');
    this.name = localStorage.getItem('name');
    // show download application
    var device = __webpack_require__("GtN+").default;
    this.deviceos = device.os;
    this.snackbar = true;
    // this.get_list_richmenu(this.$route.params.roomid)
    // check url redirect room
    this.CheckUrlRoom();
    this.getOldMessageFirst('');
    this.getreply();
    this.getdataroom();
    this.getlistannounce();
    this.get_oneid();
    this.axios.post("https://uatchat-manage.one.th/message" + '/sticker/gettitleallsticker', { tokenuser: this.token }).then(function (responsed) {
      _this4.sticker = responsed.data['data'];
    });
    var announce = this.$cookie.get(this.$route.params.roomid);
    if (announce !== null) {
      this.less = true;
    }
    this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'));
    // console.log(this.chat_wallpaper)
    var room = this.tokenrooomSelect;
    var index = _.findIndex(this.chat_wallpaper.info, function (o) {
      return o.room === room;
    });
    // console.log(index)
    if (index === -1) {
      this.imageData = '';
    } else {
      this.imageData = this.chat_wallpaper.info[index].background;
    }
    this.checkHeightRichmenu();
    // this.hideLayoutChat()
    // var winFeature = 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes'
    // window.open('', 'null', winFeature)
    // document.body.requestFullscreen()
  },

  methods: {
    handleDocumentRender: function handleDocumentRender() {
      // this.isLoading = false
      this.pageCount = this.$refs.myPdfComponent.pageCount;
    },
    handlePasswordRequest: function handlePasswordRequest(callback, retry) {
      callback(prompt(retry ? 'Enter password again' : 'This document is password protected. Please enter a password.'));
    },
    passwordPdf: function passwordPdf(evt, index, item) {
      console.log(evt);
      this.items[index].typeofmessage = 'pdf_password';
    },
    errorPdf: function errorPdf(err) {
      console.log(err);
    },
    errorPdfDialog: function errorPdfDialog(err) {
      console.log(err);
    },
    closeDialogpassword: function closeDialogpassword(value) {
      this.dialogGetPassword = value;
    },

    // cancle() {
    //   this.passwordFile = ''
    //   this.dialogGetPassword = false
    // },
    // submitPassword() {
    //   this.progressBtn = true
    //   // console.log(this.passwordFile)
    //   var body = {
    //     tokenmessage: this.tokenmsg_file_pass,
    //     password: this.passwordFile
    //   }
    //   // console.log(body)
    //     this.axios.post(process.env.check_password + '/api/v1/check-password' , body).then((response) => {
    //       console.log(response)
    //       var path = response.data.path
    //       if(response.status == '200'){
    //         this.progressBtn = false
    //         if(response.data.message == 'wrong password'){
    //           this.$swal(this.$t('File.wrongPassword') , '', 'error')
    //         }else if(response.data.status == 'success'){
    //           var message = response.data.path
    //           var filename = response.data.path.split('.')
    //           this.dialogGetPassword = false
    //           this.passwordFile = ''
    //           this.axios.get(response.data.path, {
    //             responseType: 'blob'
    //           }).then((response) => {
    //             if(filename[filename.length - 1] == 'pdf'){
    //               this.zoomPasswordfile(false ,path , this.datafile)
    //             }else{
    //               const url = window.URL.createObjectURL(new Blob([response.data]))
    //               const link = document.createElement('a')
    //               link.href = url
    //               link.setAttribute('download', `${this.name_file_pass}.${filename[filename.length - 1]}`)
    //               document.body.appendChild(link)
    //               link.click()

    //             }
    //           })
    //         }
    //       }else{
    //       }
    //     }).catch((err) =>{
    //       console.log(JSON.stringify(err))
    //         // console.log(...err)
    //         this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
    //         .then((result) => {
    //           if(result){
    //             this.progressBtn = false
    //           }
    //         })

    //     })
    // },
    CheckUrlRoom: function CheckUrlRoom() {
      if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null && JSON.parse(localStorage.getItem('botid_redirect_url')) !== undefined) {
        var data = JSON.parse(localStorage.getItem('botid_redirect_url'));
        // console.log(data.url)
        var item = {};
        if (data.auth === 'share_token') {
          item = {
            label: '',
            url: data.url,
            size: 'full',
            type: 'webview',
            sign: 'true',
            onechat_token: 'false'
          };
          if (data.url !== undefined && data.url !== 'undefined') {
            this.check_get_accesstoken(item);
          }
        } else {
          item = {
            label: '',
            url: data.url,
            size: 'full',
            type: 'webview',
            sign: 'false',
            onechat_token: 'true'
          };
          if (data.url !== undefined && data.url !== 'undefined') {
            this.check_get_accesstoken(item);
          }
        }
      }
      // หลังเปิด webview ลบค่าตัวแปลที่ใช้เช็ค
      localStorage.removeItem('botid_redirect_url');
    },
    clickReadmore: function clickReadmore(item) {
      this.detailReadmore = item;
      this.dialogReadmore = true;
    },
    closeReadmoreDialog: function closeReadmoreDialog(value) {
      this.dialogReadmore = value;
    },
    closeCreatemail: function closeCreatemail(value) {
      this.dialogCreatemailMobile = value;
    },
    get_oneid: function get_oneid() {
      var _this5 = this;

      this.axios.get("https://uatchat-manage.one.th/go_api/api" + ('/v1/getOneID/' + this.token)).then(function (response) {
        if (response.data.status === 'success') {
          _this5.one_id = response.data.one_id;
        }
      });
    },
    ans_ekyc: function ans_ekyc(item, quickreply) {
      var _this6 = this;

      // console.log(item)
      this.ans_quickreply(item, 'ekyc');
      // console.log(this.one_id)
      this.axios.post("https://uatchat-manage.one.th/message" + '/api/v1/get_shared_token', { user_id: this.one_id }).then(function (response) {
        if (response.data.status === 'success') {
          var url = '' + "https://uat-ekyc.id.th/redirect-share-token?shared_token=" + response.data.data.shared_token + '&bot_id=' + quickreply.tokenuser;
          var infor_webview = {
            label: item.label,
            type: 'ekyc',
            message: item.message,
            payload: '',
            url: url
            // console.log(url)
            // this.official_item = infor_webview
            // this.official_sheet = true
          };_this6.checkBrowser(url, infor_webview);
          // this.clearQuickreply()
        }
      }).catch(function (error) {
        console.log(error);
        _this6.$swal('Network error', _this6.$t('Alert.Fail.default.networkError'), 'error');
      });
    },
    ans_ekyc_template: function ans_ekyc_template(item, tokenbot) {
      var _this7 = this;

      // console.log(item)
      // console.log(tokenbot)
      this.axios.post("https://uatchat-manage.one.th/message" + '/api/v1/get_shared_token', { user_id: this.one_id }).then(function (response) {
        if (response.data.status === 'success') {
          var url = '' + "https://uat-ekyc.id.th/redirect-share-token?shared_token=" + response.data.data.shared_token + '&bot_id=' + tokenbot;
          var infor_webview = {
            label: item.label,
            type: 'ekyc',
            message: item.message,
            payload: '',
            url: url
          };
          _this7.checkBrowser(url, infor_webview);
        }
      }).catch(function (error) {
        console.log(error);
        _this7.$swal('Network error', _this7.$t('Alert.Fail.default.networkError'), 'error');
      });
    },
    handleClickTest: function handleClickTest(e) {
      var _this8 = this;

      // console.log(e)
      var username = e.target.innerHTML.substring(1);
      // console.log(e.target.innerHTML.substring(1))
      var myUser = localStorage.name;
      if (username != myUser) {
        // const item = this.listfriend.filter(friend =>
        //   friend.name.toLowerCase().includes(username.toLowerCase())
        // )
        // console.log(item)
        // const tokenUser = item[0].tokenuser
        // this.detailFriend(tokenUser)
        this.listfriend.forEach(function (freind) {
          var rex = /(?:[\xA9\xAE\u2122\u23E9-\u23EF\u23F3\u23F8-\u23FA\u24C2\u25B6\u2600-\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDE51\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDE80-\uDEFF]|\uD83E[\uDD00-\uDDFF])/g;
          var x = username.replace(rex, function (match) {
            return '[e-' + match.codePointAt(0).toString(16) + ']';
          });
          var y = freind.name.replace(rex, function (match) {
            return '[e-' + match.codePointAt(0).toString(16) + ']';
          });

          if (x.includes(y)) {
            // console.log(freind)
            var tokenUser = freind.tokenuser;
            _this8.detailFriend(tokenUser);
          }
        });
      } else {
        var decoded = JSON.parse(__WEBPACK_IMPORTED_MODULE_5__services__["a" /* Decode */].decode(localStorage.getItem('Authenrization')));
        this.detailFriend(decoded.tokenuser);
      }
    },
    convertMentionAnnounce: function convertMentionAnnounce(msg) {
      msg = msg.replace(/\<tax>/g, '<span style="color:white;">@');
      msg = msg.replace(/<\/tax>/g, '</span>');
      // console.log(msg)
      return msg;
    },
    convertMention: function convertMention(msg) {
      msg = msg.replace(/\<tax>/g, '<span style="color:#1976d2; cursor:pointer;">@');
      msg = msg.replace(/<\/tax>/g, '</span>');
      // console.log(msg)
      return msg;
    },
    tagFriend: function tagFriend(nametag) {
      this.status_tag = false;
      // console.log('tag')
      if (this.text_search == '') {
        this.sendmsg = this.sendmsg + nametag + " ";
      } else {
        if (nametag.toLowerCase().includes(this.text_search)) {
          // console.log()
          this.sendmsg = this.sendmsg.replace(this.text_search, nametag);
        }
      }

      // this.sendmsg = this.sendmsg + nametag + " "
      this.$refs.textareaChat.focus();
    },
    filterlistfriend: function filterlistfriend() {
      var _this9 = this;

      if (this.showmention === false && this.infofriend.type === 'group') {
        // const sectionMsg = this.sendmsg.split(' ')
        // const lastSection = sectionMsg[sectionMsg.length - 1]
        // // console.log(lastSection)
        // const isTag = lastSection.charAt(0) === '@'
        // // console.log(isTag)
        // if(lastSection.charAt(0) === '@' && this.listfriend.length > 1){
        //   var textToSearch = lastSection.slice(1)
        //   this.listfriend_filter = this.listfriend.filter(friend =>
        //     friend.name.toLowerCase().includes(textToSearch.toLowerCase())
        //   )
        //   this.status_tag = true
        //   // console.log(this.listfriend_filter)
        // } else {
        //   this.status_tag = false
        // }
        var sectionMsg = this.sendmsg.split(' ');
        var lastSection = sectionMsg[sectionMsg.length - 1];
        // console.log(lastSection)
        var isTag = lastSection.charAt(0) === '@';
        // console.log(isTag)
        if (isTag) {
          // var textToSearch = lastSection.slice(1)
          this.text_search = lastSection.slice(1);
          this.listfriend_filter = this.listfriend.filter(function (friend) {
            return friend.name.toLowerCase().includes(_this9.text_search.toLowerCase());
          });
          this.status_tag = true;
          // console.log(this.listfriend_filter)
          // console.log(this.status_tag)
        } else {
          this.status_tag = false;
        }
      }
    },
    checkHeightRichmenu: function checkHeightRichmenu() {
      // console.log('type_richmenu: ' + this.type_richmenu)
      // console.log('sheetrichmenu: ' + this.sheetrichmenu)
      // console.log('imageData: ' + this.imageData)
      if (this.type_richmenu <= 7) {
        if (this.sheetrichmenu) {
          // setTimeout(this.scrollDown, 1)
          if (this.imageData === '') {
            // console.log('obj1')
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 300px) !important; background-color: #fdfdfd;';
            // console.log(this.chatlogsFlex)
          } else {
            // console.log('obj2')
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 300px) !important; background-image: url(' + this.imageData + ');';
          }
        } else {
          if (this.imageData === '') {
            // console.log('obj3')
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 117px) !important; background-color: #fdfdfd;';
          } else {
            // console.log('obj4')
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 117px) !important; background-image: url(' + this.imageData + ');';
          }
        }
      } else {
        if (this.sheetrichmenu) {
          // setTimeout(this.scrollDown, 1)
          if (this.imageData === '') {
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.box_height + 'px - 120px) !important; background-color: #fdfdfd;';
          } else {
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.box_height + 'px - 120px) !important; background-image: url(' + this.imageData + ');';
          }
        } else {
          if (this.imageData === '') {
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 117px) !important; background-color: #fdfdfd;';
          } else {
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 117px) !important; background-image: url(' + this.imageData + ');';
          }
        }
      }
    },
    openCall: function openCall(typecall, detailroom) {
      // console.log(detailroom.type)
      var name = '';
      if (detailroom.type === 'group') {
        name = detailroom.group_name;
      }
      this.axios.post("https://uatchat-manage.one.th/message" + '/push_conference', {
        tokenuser: this.token,
        tokenroom: detailroom.tokenroom,
        // room_name: name,
        type_call: typecall
      }).then(function (response) {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          window.open(response.data.data.information.urlroom);
        }
      });

      // localStorage.setItem('stateCall', 'true')
      // localStorage.setItem('detailroomCall', JSON.stringify(detailroom))
      // this.$router.push({
      //   path: '/video_call/' + typecall + '/' + this.room,
      //   force: true
      // })
      // this.$router.push({path: '/video_call/' + this.room, force: true})
    },
    backCall_conference_msg: function backCall_conference_msg(detail) {
      window.open(detail.urlroom);
    },
    joinCall_conference_msg: function joinCall_conference_msg(detail) {
      // console.log(detail)
      this.axios.post("https://uatchat-manage.one.th/message" + '/join_room_conference', {
        meetingid: detail.meetingid,
        name: localStorage.getItem('name'),
        option: detail.option,
        key: detail.key
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          window.open(response.data.data.urlroom);
        }
      });
    },
    play: function play(e) {
      // console.log(e)
    },
    closedialogQrcode: function closedialogQrcode(value) {
      this.dialogQrcodRichMenu = value;
    },
    closeCheckBrowser: function closeCheckBrowser(value) {
      this.checkBrowserDialog = value;
      this.checkBrowserInfor = {};
    },
    selectfile_quickreply: function selectfile_quickreply(item) {
      if (item.type == 'image') {
        $('#uploadpic_quickreply').click();
      } else {
        $('#uploadfile_quickreply').click();
      }
      this.itemdetail_quickreply = item;
    },

    // jammmmmmmmmm
    sendlocation_quickreply: function sendlocation_quickreply() {
      var _this10 = this;

      // console.log(navigator.geolocation)
      if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(function (position) {
          // console.log(position.coords.latitude, position.coords.longitude)
          _this10.send_location(position.coords.latitude, position.coords.longitude, '');
        });
      } else {
        console.log('error geo');
      }
    },
    ocropen: function ocropen(item) {
      $('#uploadpic_ocr').click();
      this.ocr_detailItem = item;
    },
    clearImage: function clearImage() {
      $('#uploadpic_ocr').val("");
      $('#uploadpic_quickreply').val("");
    },
    onimgSelected_ocr: function onimgSelected_ocr(data) {
      var uploadedFiles = data.target.files;
      var lengthfile = uploadedFiles.length;
      // console.log(this.ocr_detailItem)
      var me = this;
      var reader = new FileReader();
      reader.readAsDataURL(data.target.files[0]);
      reader.onloadend = function () {
        var _this11 = this;

        var body = {
          "tokenroom": me.$route.params.roomid,
          "tokenuser": me.token,
          "base64_image": reader.result,
          "multi_select": me.ocr_detailItem.multi_select
        };
        me.dialogWebviewbig_ocr = true;
        // me.Webview_item = {url: "https://chat-develop.one.th/ocr_scantext?id=Ua4KAHvPEqd2wOXF28cD9", label: ''}

        me.axios.post('https://l.one.th/onechat-ocr/api/v1/send-ocr-image', body).then(function (response) {
          // console.log(response.data.data.link)
          if (response.data.message === 'success') {
            // me.dialogWebviewbig = true
            me.Webview_item_ocr = { url: response.data.data.link, label: '' };
            me.clearQuickreply();
          }
        }, function () {
          me.$swal('Upload image fail', _this11.$t('Alert.Fail.Chat.uploadPic'), 'warning');
          // this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        });
      };
    },
    onimgSelected_quickreply: function onimgSelected_quickreply(data) {
      var _this12 = this;

      var uploadedFiles = data.target.files;
      var lengthfile = uploadedFiles.length;
      this.selectFile = data.target.files[0];
      var uploadFile = new FormData();
      uploadFile.append('file', this.selectFile, this.selectFile.name);
      uploadFile.append('tokenroom', this.$route.params.roomid);
      uploadFile.append('tokenuser', this.token);
      uploadFile.append('type_reply', this.itemdetail_quickreply.type);
      uploadFile.append('info_data', this.itemdetail_quickreply.payload);
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/answer_quickreply', uploadFile).then(function (response) {
        if (response.data.status === 'success') {
          if (_.find(_this12.items, function (o) {
            return o.tokenmessage === response.data.data.tokenmessage;
          }) === undefined) {
            // this.socketupdate_img = response.data.data
            // response.data.data.status = 'success'
            _this12.items.push(response.data.data);
            _this12.clearQuickreply();
            _this12.items = _.sortBy(_this12.items, function (dateObj) {
              return new Date(dateObj.timestamp);
            });
            _this12.items = _.unionBy(_this12.items, 'tokenmessage');
            document.querySelector('#uploadfile_quickreply').value = '';
            document.querySelector('#uploadpic_quickreply').value = '';
          }
          setTimeout(_this12.scrollDown, 1);
        } else {}
      }, function (error) {
        console.log(error);
        _this12.$swal('Network error', _this12.$t('Alert.Fail.default.networkError'), 'error');
      });
    },
    btn_answer_carousel: function btn_answer_carousel(item) {
      // console.log(item)
      // if (item.type === 'text' || item.type === 'postback') {
      //   this.ans_carousel(item)
      // } else if (item.type === 'webview' || item.type === 'link') {
      //   var infor = {
      //     sign: item.sign,
      //     url: item.action,
      //     type: item.type,
      //     label: item.button,
      //     onechat_token: item.onechat_token,
      //     size: 'full'
      //   }
      //   this.check_get_accesstoken(infor)
      // }
      if (item.type === 'webview' || item.type === 'link') {
        var infor = {
          sign: item.sign,
          url: item.action,
          type: item.type,
          label: item.button,
          onechat_token: item.onechat_token,
          payload: item.payload,
          size: 'full'
        };
        this.check_get_accesstoken(infor);
      } else if (item.type === 'link_market') {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
      } else {
        this.ans_carousel(item);
      }
    },
    ans_carousel: function ans_carousel(item) {
      var payload = '';
      if (item.payload !== undefined) {
        payload = item.payload;
      }
      var body = {
        tokenuser: this.token,
        tokenroom: this.tokenrooomSelect,
        action: item.action,
        type: item.type,
        payload: payload
        // console.log(body)
      };this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/ansCarousel', body).then(function (response) {
        // console.log(response.data)
      }).catch(function (error) {
        console.log(error);
      });
    },
    hideLayout: function hideLayout() {
      window.addEventListener('load', function () {
        setTimeout(function () {
          // This hides the address bar:
          window.scrollTo(0, 1);
        }, 0);
      });
    },
    hideLayoutChat: function hideLayoutChat() {
      // console.log('fullscreen')
      alert('fullscreen');
      // var container = document.getElementById('container')
      // container.requestFullscreen()
      // document.body.requestFullscreen()
      document.body.webkitRequestFullScreen();
      // document.webkitCancelFullScreen()
    },
    gotoMessage: function gotoMessage(token) {
      // console.log('gotoMessage')
      // this.$route.query.tokenmessage
      // console.log(token)
      if (token) {
        var myElement = document.getElementById(token);
        // console.log(token)
        // console.log(myElement)
        // this.gotoTokenmessage = ''
        // if (myElement != null) {
        // this.$nextTick(() => {
        if (myElement) {
          // console.log('scrollIntoView')
          myElement.scrollIntoView({ duration: true, behavior: 'smooth', block: 'end', queue: false, specialEasing: null });
          window.location.hash = token;
          myElement.setAttribute('tabindex', '-1');
          myElement.removeAttribute('tabindex');
          this.gotoTokenmessage = '';
        }
      }
    },
    downloadios: function downloadios() {
      // window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus()
      window.open('https://qrcode.chat.one.th/api/v1/go-to-onechat').focus();
    },
    downloadandroid: function downloadandroid() {
      window.open('https://qrcode.chat.one.th/api/v1/go-to-onechat').focus();
      // window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus()
    },
    closedownload: function closedownload() {
      this.snackbar = false;
    },
    emitrichmenu: function emitrichmenu(item) {
      var _this13 = this;

      // console.log(item)
      // this.sheetrichmenu = false
      // this.RichmenuState = false
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var hour = String(today.getHours() + 1).padStart(2, '0');
      var minute = String(today.getMinutes()).padStart(2, '0');
      var seconds = String(today.getSeconds()).padStart(2, '0');
      var milsec = today.getMilliseconds();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00';
        dd = String(today.getDate() + 1).padStart(2, '0');
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1';
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1';
            yyyy = today.getFullYear() + 1;
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0');
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
      // console.log(today)

      var expireddate = Date.parse(today);
      var body = __WEBPACK_IMPORTED_MODULE_5__services__["b" /* Encode */].encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate });
      // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
      // var weburl = item.url + url
      var url = '';
      if (_.includes(item.url, ['?'])) {
        url = '&';
      } else {
        url = '?';
      }
      var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate;

      if (item.type === 'text') {
        this.sendMessage(item.message);
      } else if (item.type === 'link') {
        if (item.sign_share === 'true') {
          this.getSign(item.url, item, this.bot_id_richmenu);
        } else if (item.sign === 'true') {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item);
        } else {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item);
        }
      } else if (item.type === 'webview') {
        if (item.sign_share === 'true') {
          this.getSign(item.url, item, this.bot_id_richmenu);
        } else if (item.sign === 'true') {
          var infor_webview = {
            message: item.message,
            picture: item.picture,
            sign: item.sign,
            size: item.size,
            type: item.type,
            url: weburl
          };
          this.official_item = infor_webview;
          this.official_sheet = true;
        } else {
          this.official_item = item;
          this.official_sheet = true;
        }
      } else if (item.type === 'link_market') {
        // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
      } else if (item.type === 'location') {
        // console.log('rich menu type location')
        this.sendlocation_quickreply();
      } else if (item.type === 'qrcode' && item.location_status === 'false') {
        // console.log('rich menu type qrcode')
        this.dialogQrcodRichMenu = true;
        this.QrcodeInfor = { status: item.location_status, lat: '', lng: '', address: '' };
      } else if (item.type === 'qrcode' && item.location_status === 'true') {
        // console.log('rich menu qrcode location')
        this.dialogQrcodRichMenu = true;
        if (window.navigator.geolocation) {
          window.navigator.geolocation.getCurrentPosition(function (position) {
            _this13.QrcodeInfor = { status: item.location_status, lat: position.coords.latitude, lng: position.coords.longitude, address: '' };
          });
        } else {
          console.log('error geo');
          this.QrcodeInfor = { status: item.location_status, lat: '', lng: '', address: '' };
        }
      }
    },
    chsheetrichmenu: function chsheetrichmenu() {
      this.RichmenuState = true;
      // console.log(this.RichmenuState)
    },
    checkBrowser: function checkBrowser(url, item) {
      // console.log(item)
      if (_.includes(url, "https://uatchat.one.th" + '/qrcode/friend?id=')) {
        var link = _.split(url, '?id=', 2);
        // console.log(link[1])
        // console.log(atob(link[1]))
        this.detailFriend(atob(link[1]));
      } else {
        // Get the user-agent string
        var userAgentString = navigator.userAgent;
        // Detect Chrome
        var chromeAgent = userAgentString.indexOf("Chrome") > -1;
        // Detect Internet Explorer
        var IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
        // Detect Firefox
        var firefoxAgent = userAgentString.indexOf("Firefox") > -1;
        // Detect Safari
        var safariAgent = userAgentString.indexOf("Safari") > -1;
        // Discard Safari since it also matches Chrome
        var operaAgent = userAgentString.indexOf("OP") > -1;
        if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
          if (item.payload !== undefined && item.payload !== null) {
            if (item.payload.news_id !== undefined) {
              this.checkBrowserInfor = {
                url: url,
                payload: item.payload
              };
              this.checkBrowserDialog = true;
            } else {
              this.checkBrowserInfor = {
                url: url
              };
              this.checkBrowserDialog = true;
            }
          } else {
            this.checkBrowserInfor = {
              url: url,
              payload: ''
            };
            this.checkBrowserDialog = true;
          }
          // this.checkBrowserDialog = true
        } else if (safariAgent === true && chromeAgent === true) {
          //  console.log('savelog')
          window.open(url, '_blank');
          if (item.payload !== undefined && item.payload !== null) {
            if (item.payload.news_id !== undefined) {
              this.saveLogNews(item);
            }
          }
        } else if (safariAgent === true) {
          // this.checkBrowserInfor =
          if (item.payload !== undefined && item.payload !== null) {
            if (item.payload.news_id !== undefined) {
              this.checkBrowserInfor = {
                url: url,
                payload: item.payload
              };
              this.checkBrowserDialog = true;
            } else {
              this.checkBrowserInfor = {
                url: url
              };
              this.checkBrowserDialog = true;
            }
          } else {
            this.checkBrowserInfor = {
              url: url,
              payload: ''
            };
            this.checkBrowserDialog = true;
          }
          // this.checkBrowserDialog = true
        } else {
          // console.log('savelog')
          window.open(url, '_blank');
          if (item.payload !== undefined && item.payload !== null) {
            if (item.payload.news_id !== undefined) {
              this.saveLogNews(item);
            }
          }
        }
      }
    },
    clearQuickreply: function clearQuickreply() {
      if (this.Quickreply.length !== 0) {
        if (this.Quickreply.timestamp < this.items[this.items.length - 1].timestamp) {
          this.Quickreply = [];
        }
      }
    },
    closeDialog_official: function closeDialog_official() {
      this.official_sheet = false;
      this.official_item = {};
      this.closewebview_webhook();
    },
    newtab: function newtab() {
      // this.Webview_item.url
      window.open(this.official_item.url, '_blank');
      this.official_sheet = false;
    },
    btn_official_template: function btn_official_template(item, tokenuserBot, tokenmessage) {
      var _this14 = this;

      if (item.sign == 'true' && item.type !== 'text') {
        // this.getSign(item.url, item, tokenuserBot)
        var body = {
          "tokenuser": this.token,
          "url": item.url
        };
        this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", body).then(function (response) {
          var new_url = '';
          new_url = response.data.data.url;
          // item.url = response.data.data.url
          if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
            // window.open(new_url, '_blank')
            // window.location.assign(new_url)
            _this14.checkBrowser(new_url, item);
          } else if (item.type === 'webview') {
            _this14.official_item = {
              label: item.label,
              url: new_url,
              size: item.size,
              type: item.type
            };
            _this14.official_sheet = true;
          } else if (item.type === 'link_market') {
            // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
            _this14.$swal('', _this14.$t('Alert.Warning.link_market'), 'warning');
          }
        }, function (error) {
          console.log(erorr);
        });
      } else if (item.onechat_token === 'true' && item.type !== 'text') {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var hour = String(today.getHours() + 1).padStart(2, '0');
        var minute = String(today.getMinutes()).padStart(2, '0');
        var seconds = String(today.getSeconds()).padStart(2, '0');
        var milsec = today.getMilliseconds();
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00';
          dd = String(today.getDate() + 1).padStart(2, '0');
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1';
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1';
              yyyy = today.getFullYear() + 1;
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0');
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
        // console.log(today)
        var expireddate = Date.parse(today);
        var body = __WEBPACK_IMPORTED_MODULE_5__services__["b" /* Encode */].encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate });
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        // var weburl = item.url + url
        var url = '';
        if (_.includes(item.url, ['?'])) {
          url = '&';
        } else {
          url = '?';
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate;

        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item);
        } else if (item.type === 'webview') {
          this.official_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          };
          this.official_sheet = true;
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        }
      } else {
        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item);
        } else if (item.type === 'webview') {
          this.official_item = item;
          this.official_sheet = true;
        } else if (item.type === 'text') {
          this.ans_question(item, tokenmessage, tokenuserBot);
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        }
      }
    },
    btn_img_official_template: function btn_img_official_template(item, tokenuserBot) {
      if (item.sign === 'true') {
        this.getSignImg(item.url, item, tokenuserBot);
      } else if (item.onechat_token === 'true') {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var hour = String(today.getHours() + 1).padStart(2, '0');
        var minute = String(today.getMinutes()).padStart(2, '0');
        var seconds = String(today.getSeconds()).padStart(2, '0');
        var milsec = today.getMilliseconds();
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00';
          dd = String(today.getDate() + 1).padStart(2, '0');
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1';
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1';
              yyyy = today.getFullYear() + 1;
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0');
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
        // console.log(today)
        var expireddate = Date.parse(today);
        var body = __WEBPACK_IMPORTED_MODULE_5__services__["b" /* Encode */].encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate });
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        // var weburl = item.url + url
        var url = '';
        if (_.includes(item.url, ['?'])) {
          url = '&';
        } else {
          url = '?';
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate;

        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item);
        } else if (item.type === 'webview') {
          this.official_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          };
          this.official_sheet = true;
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        }
      } else {
        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item);
        } else if (item.type === 'webview') {
          this.official_item = item;
          this.official_sheet = true;
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
        }
      }
    },
    getSign: function getSign(url, item, tokenuserBot) {
      var _this15 = this;

      var body = {
        "tokenuser": this.token,
        "url": url
      };
      this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", body).then(function (response) {
        var new_url = '';
        new_url = response.data.data.url;
        // item.url = response.data.data.url
        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(new_url, '_blank')
          // window.location.assign(new_url)
          _this15.checkBrowser(new_url, item);
        } else if (item.type === 'webview') {
          _this15.official_item = {
            label: item.label,
            url: new_url,
            size: item.size,
            type: item.type
            // console.log(this.official_item)
          };_this15.official_sheet = true;
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          _this15.$swal('', _this15.$t('Alert.Warning.link_market'), 'warning');
        }
      }, function (error) {
        console.log(erorr);
      });
    },
    getSignImg: function getSignImg(url, item, tokenuserBot) {
      var _this16 = this;

      var body = {
        "tokenuser": this.token,
        "url": url
      };
      this.axios.post("https://uatchat-manage.one.th/event" + '/old/api/v1/getAccesstoken', body).then(function (response) {
        // item.url = response.data.data.url
        var new_url = '';
        new_url = response.data.data.url;
        if (item.type === 'link' || item.type === 'webview' && tokenuserBot === "B0df132b88f9a526691a0576bfdb24196") {
          // window.open(new_url, '_blank')
          _this16.checkBrowser(new_url, item);
        } else if (item.type === 'webview') {
          _this16.official_item = {
            label: item.label,
            url: new_url,
            size: item.size,
            type: item.type
          };
          _this16.official_sheet = true;
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          _this16.$swal('', _this16.$t('Alert.Warning.link_market'), 'warning');
        }
      }, function () {});
    },
    checkbutton: function checkbutton(color, bng) {
      var text = {
        'text-transform': 'none',
        'width': '100%',
        'margin': '0',
        'font-size': '13px',
        'border-radius': '20px'
        // [choice.color]? ('color': choice.color):('color':'black')
      };if (color) {
        text['color'] = color;
      } else {
        text['color'] = 'black';
      }
      if (bng) {
        text['background'] = bng;
      } else {
        text['background'] = 'none';
      }
      return text;
    },
    closeDetailTask: function closeDetailTask(value) {
      this.dialogDetailTask = value;
    },
    open_detail_task: function open_detail_task(taskid, tokenroom) {
      this.taskid = taskid;
      this.roomid = tokenroom;
      this.dialogDetailTask = true;
    },
    checkuserinassign: function checkuserinassign(item) {
      var tokenuser = this.token;
      var index = _.findIndex(item, function (o) {
        return o.tokenuser === tokenuser;
      });
      if (index >= 0) {
        return true;
      } else {
        return false;
      }
    },
    SelectMenuRightClick: function SelectMenuRightClick(selected) {
      // console.log(selected)
      if (selected == 'add_albums') {
        this.add_image_albums();
      } else if (selected == 'mention') {
        this.mention_message();
      } else if (selected == 'cancel') {
        this.unsendmessage();
      } else if (selected == 'sendmail') {
        this.sendemail();
      } else if (selected == 'announce') {
        this.announce_msg();
      } else if (selected == 'cancel_announce') {
        this.cancel_announce();
      }
    },
    RightClickDialog: function RightClickDialog($event, list, item) {
      // console.log(item)
      this.ListMenuRightClick = [];
      if (this.statemember === 'active') {
        if (list.includes("albums")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.addImageAlbum'), methods: 'add_albums' });
        }
        if (list.includes("mention")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.mention'), methods: 'mention' });
        }
        if (list.includes("sendmail")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.sendmail'), methods: 'sendmail' });
        }
        if (list.includes("cancel")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.cancelMsg'), methods: 'cancel' });
        }
        if (list.includes("announce")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.announce'), methods: 'announce' });
        }
        if (list.includes("cancel_announce")) {
          this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.cancelAnnounce'), methods: 'cancel_announce' });
        }
        this.rightclickdialog = true;
        this.$refs.menucontext.open($event);
        this.SelectedMessageDetail = item;
        // console.log(this.rightclickdialog)
        // console.log(this.ListMenuRightClick)
      }
    },
    announce_dialog: function announce_dialog(item) {
      this.announcedialog = true;
      this.announce_message = item;
      // console.log(this.announcedialog)
      // console.log(this.announce_message)
    },
    cancel_announce: function cancel_announce() {
      var _this17 = this;

      this.announcedialog = false;
      this.rightclickdialog = false;
      var token_announce = this.announce_message._id;
      this.$swal({
        text: this.$t('Alert.Chat.announce.cancel'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this17.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/disable_single_announce_room', {
            tokenuser: _this17.token,
            tokenroom: _this17.tokenrooomSelect,
            token_announce: token_announce }).then(function (responsed) {
            if (responsed.data.status == 'success') {
              var index = _.findIndex(_this17.listannounce, function (o) {
                return o._id === token_announce;
              });
              if (index >= 0) {
                _this17.listannounce.splice(index, 1);
              }
            } else {
              _this17.listannounce = [];
            }
          });
        }
      });
    },
    delete_announce: function delete_announce() {
      var _this18 = this;

      this.$swal({
        text: this.$t('Alert.Chat.announce.deleteAll'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this18.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/disable_announce_room', { tokenuser: _this18.token, tokenroom: _this18.tokenrooomSelect }).then(function (responsed) {
            if (responsed.data.status == 'success') {
              _this18.listannounce = [];
            } else {}
          });
        }
      });
    },
    getlistannounce: function getlistannounce() {
      var _this19 = this;

      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/get_announce_room', { tokenuser: this.token, tokenroom: this.tokenrooomSelect }).then(function (responsed) {
        // console.log(responsed.data.data)
        if (responsed.data.status == 'success') {
          _this19.listannounce = responsed.data.data;
          // this.listannounce = _.sortBy(this.listannouncee, function (dateObj) {
          //   return new Date(dateObj.timestamp)
          // }).reverse()
          _this19.listannounce = _.reverse(_this19.listannounce);
          // if (this.listannounce.length !== 0) {
          //   this.expansion_announce = true
          // } else {
          //   this.expansion_announce = false
          // }
          // this.listannounce = _.unionBy(this.listannounce, '_id')
          // console.log(this.listannounce)
        } else {
          _this19.listannounce = [];
        }
      });
    },
    add_image_albums: function add_image_albums() {
      this.dialogAddImage = true;
      this.unsenddialog = false;
      this.settingdialog = false;
      this.forwarddialog = false;
      this.imagealbumsdialog = false;
      this.forwardimagedialog = false;
    },
    closeAlbums: function closeAlbums(value) {
      this.dialogAlbums = value;
    },
    closeAddImage: function closeAddImage(value) {
      this.dialogAddImage = value;
    },
    detailAlbums: function detailAlbums(id) {
      // console.log(id)
      this.dialogAlbums = true;
      this.albums_id = id;
    },
    open: function open(typecall, detailroom) {
      // console.log(detailroom)
      localStorage.setItem('stateCall', 'true');
      localStorage.setItem('detailroomCall', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(detailroom));
      // window.open('/video_call/' + typecall + '/' + this.room, '_blank').focus()
      this.$router.push({ path: '/video_callmo/' + typecall + '/' + this.tokenrooomSelect, force: true });
      // this.$router.push({path: '/video_call/' + this.room, force: true})
    },
    closeshow: function closeshow() {
      this.showphone = false;
    },
    secondsToHms: function secondsToHms(d) {
      d = Number(d);
      var hours = Math.floor(d / 3600);
      var minutes = Math.floor((d - hours * 3600) / 60);
      var seconds = d - hours * 3600 - minutes * 60;
      var time = '';

      if (hours !== 0) {
        time = hours + ':';
      }
      if (minutes !== 0 || time !== '') {
        minutes = minutes < 10 && time !== '' ? '0' + minutes : String(minutes);
        time += minutes + ':';
      }
      if (time === '') {
        time = seconds + 's';
      } else {
        time += seconds < 10 ? '0' + seconds : String(seconds);
      }
      return time;
    },
    checktypeCall: function checktypeCall(call) {
      if (call === 'cancel') {
        return this.$t('AnswerQuestion.cancel');
      } else if (call === 'decline') {
        return this.$t('LeftSide.chat.call.missed');
      } else if (call === 'end') {
        return this.$t('LeftSide.chat.call.end');
      } else {
        return '';
      }
    },
    setting_dialog: function setting_dialog(item, type) {
      if (this.statemember === 'active') {
        if (item.type !== 'bot') {
          this.SelectedMessageDetail = item;
          if (item.typeofmessage == 'file' || item.typeofmessage == 'pdf_password') {
            if (type == 'download') {
              this.loadfile(item);
            } else {
              var file_split = item.message.split('.');
              var type_file = file_split[file_split.length - 1];

              if (type_file == 'pdf') {
                this.settingdialog = true;
                this.temp = [item.tokenmessage];
                this.unsenddetail = item;
                this.mentiondetail = item;
                this.path_pic_albums = item.message;
                this.file_name = item.file_name;
                this.announce_message = item;
              } else {
                this.temp = [item.tokenmessage];
                this.unsenddetail = item;
                this.mentiondetail = item;
                this.path_pic_albums = item.message;
                this.file_name = item.file_name;
                this.announce_message = item;
              }
            }
          } else if (item.typeofmessage == 'video') {
            if (type == 'download') {
              this.loadfile(item);
            }
          } else {
            if (type === 'forwardunsend') {
              this.settingdialog = true;
              this.temp = [item.tokenmessage];
              this.unsenddetail = item;
              this.mentiondetail = item;
              this.path_pic_albums = item.message;
              this.file_name = item.file_name;
              this.announce_message = item;
            } else if (type === 'forward') {
              this.forwarddialog = true;
              this.temp = [item.tokenmessage];
              this.mentiondetail = item;
              this.announce_message = item;
              this.path_pic_albums = item.message;
              this.file_name = item.file_name;
            } else if (type === 'unsend') {
              this.unsenddialog = true;
              this.unsenddetail = item;
              this.mentiondetail = item;
              this.path_pic_albums = item.message;
              this.file_name = item.file_name;
            } else if (type === 'mention') {
              this.mentiondialog = true;
              this.mentiondetail = item;
              this.path_pic_albums = item.message;
              this.file_name = item.file_name;
            } else if (type === 'addimage') {
              this.imagealbumsdialog = true;
              this.mentiondetail = item;
              this.unsenddetail = item;
              this.path_pic_albums = item.message;
              this.file_name = item.file_name;
              this.temp = [item.tokenmessage];
            } else if (type === 'forwardimagedialog') {
              this.forwardimagedialog = true;
              this.mentiondetail = item;
              this.unsenddetail = item;
              this.path_pic_albums = item.message;
              this.file_name = item.file_name;
              this.temp = [item.tokenmessage];
            }
          }
        } else {
          this.bot_dialog_message = true;
          this.temp = [item.tokenmessage];
          this.mentiondetail = item;
          this.announce_message = item;
          if (item.typeofmessage === 'password_file') {
            this.DetailFile = item;
          }
          // this.DetailFile = item
          this.path_pic_albums = item.message;
          this.file_name = item.file_name;
          this.SelectedMessageDetail = item;
          if (item.typeofmessage === 'message') {
            this.bot_dialog_list.push({ message: this.$t('ChatSide.RightClickMenu.announce'), methods: 'announce' }, { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' });
          } else if (item.typeofmessage === 'image') {
            this.bot_dialog_list.push({ message: this.$t('ChatSide.RightClickMenu.openimage'), methods: 'image' }, { message: this.$t('ChatSide.RightClickMenu.addImageAlbum'), methods: 'addimage' }, { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' }, { message: this.$t('ChatSide.RightClickMenu.sendmail'), methods: 'sendmail' });
          } else if (item.typeofmessage === 'video') {
            this.bot_dialog_list.push(
            // { message: this.$t('ChatSide.RightClickMenu.openimage'), methods: 'image' },
            { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' });
          } else if (item.typeofmessage === 'file' || item.typeofmessage === 'pdf_password' && this.extension(item.file_name) === 'pdf') {
            this.bot_dialog_list.push({ message: this.$t('ChatSide.RightClickMenu.openfile'), methods: 'file' }, { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' }, { message: this.$t('ChatSide.RightClickMenu.sendmail'), methods: 'sendmail' });
          } else if (item.typeofmessage === 'file' && this.extension(item.file_name) !== 'pdf') {
            if (type === 'download') {

              this.loadfile(item);
            } else {
              this.bot_dialog_list.push({ message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' }, { message: this.$t('ChatSide.RightClickMenu.sendmail'), methods: 'sendmail' });
            }
          } else if (item.typeofmessage === 'location') {
            this.bot_dialog_list.push({ message: this.$t('ChatSide.RightClickMenu.openlocation'), methods: 'location' }, { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' });
          } else if (item.typeofmessage === 'sticker') {
            this.bot_dialog_list = [];
            this.bot_dialog_message = false;
          } else if (item.typeofmessage === 'password_file') {
            this.datafile = item;
            this.checkPasswordfile = item.typeofmessage;
            this.tokenmsg_file_pass = item.tokenmessage;
            this.name_file_pass = item.file_name;
            this.filetype = this.extension(item.file_name);
            // console.log('filetype' , this.filetype)
            if (this.filetype == 'pdf') {
              this.bot_dialog_list.push({ message: this.$t('ChatSide.RightClickMenu.openfile'), methods: 'password_file' }
              // { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' },
              // { message: this.$t('ChatSide.RightClickMenu.sendmail'), methods: 'sendmail' }
              );
            } else {
              this.bot_dialog_list.push({ message: this.$t('AnswerQuestion.download'), methods: 'password_file' }
              // { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' },
              // { message: this.$t('ChatSide.RightClickMenu.sendmail'), methods: 'sendmail' }
              );
            }
          } else {
            this.bot_dialog_list.push({ message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' }
            // { message: this.$t('ChatSide.RightClickMenu.openfile'), methods: 'password_file' }
            );
          }
          // console.log(this.bot_dialog_list)
        }
      }
    },
    SelectBotMessage: function SelectBotMessage(type) {
      console.log(type);
      if (type === 'announce') {
        this.announce_msg();
      } else if (type === 'forward') {
        this.farwardmessage();
      } else if (type === 'addimage') {
        this.add_image_albums();
      } else if (type === 'image') {
        this.zoom();
      } else if (type === 'file') {
        this.zoomfile();
      } else if (type === 'loadfile') {
        this.loadfile(this.loadfileData);
        this.loadfileData = '';
      } else if (type === 'location') {
        this.openlocation(this.mentiondetail);
      } else if (type === 'sendmail') {
        // console.log('send mail')
        this.dialogCreatemailMobile = true;
        this.settingdialog = false;
        this.forwarddialog = false;
        this.unsenddialog = false;
        this.forwardimagedialog = false;
        this.imagealbumsdialog = false;
      } else if (type === 'password_file') {
        // console.log('send mail')
        this.dialogGetPassword = true;
        this.dialogCreatemailMobile = false;
        this.settingdialog = false;
        this.forwarddialog = false;
        this.unsenddialog = false;
        this.forwardimagedialog = false;
        this.imagealbumsdialog = false;
      }
      this.bot_dialog_message = false;
    },
    farwardmessage: function farwardmessage() {
      this.selected = true;
      this.settingdialog = false;
      this.forwarddialog = false;
      this.forwardimagedialog = false;
      this.imagealbumsdialog = false;
      this.selectedmessage = this.temp;
    },
    announce_msg: function announce_msg() {
      var _this20 = this;

      this.forwarddialog = false;
      this.settingdialog = false;
      this.axios.post("https://uatchat-manage.one.th/event" + '/v1/user/announce_room', {
        tokenuser: this.token,
        tokenmessage: this.announce_message.tokenmessage,
        tokenroom: this.announce_message.tokenroom
      }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this20.$swal('', _this20.$t('Alert.Success.announce'), 'success');
        }
        _this20.show = false;
      });
    },
    mention_message: function mention_message() {
      // console.log(this.mentiondetail)
      if (this.mentiondetail.path_pic === undefined) {
        this.mentionpathpic = localStorage.getItem('profilepicture');
      } else {
        this.mentionpathpic = this.mentiondetail.path_pic;
      }
      this.settingdialog = false;
      this.unsenddialog = false;
      this.forwarddialog = false;
      this.mentiondialog = false;
      this.forwardimagedialog = false;
      this.imagealbumsdialog = false;
      this.showmention = true;
      this.mentionname = this.mentiondetail.nickname;
      this.mentionimage = this.mentiondetail.file_name;
      this.mentionmessage = this.mentiondetail.message;
      this.mentiontypemsg = this.mentiondetail.typeofmessage;
    },
    closemention: function closemention() {
      this.showmention = false;
      this.mentionname = '';
      this.mentionimage = '';
      this.mentionpathpic = '';
      this.mentionmessage = '';
      this.mentiontypemsg = '';
    },
    unsendmessage: function unsendmessage() {
      var _this21 = this;

      this.settingdialog = false;
      this.unsenddialog = false;
      this.forwardimagedialog = false;
      this.imagealbumsdialog = false;
      this.$swal({
        text: this.$t('Alert.Chat.unsent'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this21.axios.post("https://uatchat-manage.one.th/message" + '/delete_message', { tokenuser: _this21.token, tokenmessage: _this21.unsenddetail.tokenmessage }).then(function (response) {
            if (response.data['status'] === 'success') {
              _this21.$swal('', _this21.$t('Alert.Success.unsent'), 'success');
            }
          });
        }
      });
    },
    sendansApprove: function sendansApprove(item, tokenmessage) {
      var _this22 = this;

      var body = { tokenmessage: tokenmessage, tokenuser: this.token, answer: item };
      var indexid = _.findIndex(this.items, function (o) {
        return o.tokenmessage === tokenmessage && o.typeofmessage === 'approve_message';
      });
      this.items[indexid].disable = 'true';
      this.axios.post("https://uatchat-manage.one.th/message" + '/answer_approve', body).then(function (response) {
        // console.log(response.data)
        if (_.find(_this22.items, function (o) {
          return o.tokenmessage === response.data.data.tokenmessage;
        }) === undefined) {
          _this22.items.push(response.data.data);
          _this22.clearQuickreply();
          _this22.items = _.sortBy(_this22.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          _this22.items = _.unionBy(_this22.items, 'tokenmessage');
        }
        setTimeout(_this22.scrollDown, 1);
      }, function () {});
    },
    openapprove: function openapprove(item) {
      this.ApproveDetail = item;
      this.dialogApprove = true;
    },
    initmapShow: function initmapShow() {
      this.map = new longdo.Map({
        placeholder: document.getElementById('map'),
        lastView: true
      });
      this.map.Ui.Keyboard.enable(true);
      var control3 = new longdo.TagPanel();
      this.map.Ui.add(control3);
      // this.map.Ui.Crosshair.visible(false)
      this.map.Ui.LayerSelector.visible(false);
      var location = this.locationName.message.split(',');
      var marker = new longdo.Marker({ lat: location[0], lon: location[1] }, {
        icon: {
          url: '../../../../static/img/icons/pin.png',
          offset: { x: this.x, y: this.y }
        },
        clickable: true
      });
      this.map.Overlays.add(marker);
      // this.GeometryOptions()
      // console.log(parseFloat(location[0]) - 1)
      // console.log(parseFloat(location[0]) + 1)
      this.map.bound({
        minLon: parseFloat(location[0]) - 1,
        minLat: parseFloat(location[1]) - 1,
        maxLon: parseFloat(location[0]) + 1,
        maxLat: parseFloat(location[1]) + 1
      }, {
        lat: location[0],
        lon: location[1]
      });
      // this.showloc = this.map.bound()
      this.map.zoom(15, true);
      // longdo.Search(this.map, true)
    },
    openlocation: function openlocation(item) {
      // console.log(item)
      this.sheetother = false;
      // this.dialogMap = true
      // this.locationName = item
      window.open('http://maps.google.com/maps?daddr=' + item.message + '&amp;ll=');
      this.forwarddialog = false;
      this.settingdialog = false;
    },
    send_location: function send_location(lat, long, address) {
      var _this23 = this;

      // console.log(lat, long, address)
      // var textaddress = ''
      // if (address === '') {
      //   textaddress = lat + ',' + long
      // } else {
      //   textaddress = address
      // }
      if (lat !== '' && long !== '') {
        this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/pushLocation', { 'tokenroom': this.$route.params.roomid, 'tokenuser': this.token, 'lat': lat + '', 'long': long + '', 'address': address }).then(function (response) {
          // console.log(response.data)
          if (response.data.status === 'success') {
            if (_.find(_this23.items, function (o) {
              return o.tokenmessage === response.data.data.tokenmessage;
            }) === undefined) {
              response.data.data.status = 'success';
              _this23.items.push(response.data.data);
              _this23.clearQuickreply();
              _this23.items = _.sortBy(_this23.items, function (dateObj) {
                return new Date(dateObj.timestamp);
              });
              _this23.items = _.unionBy(_this23.items, 'tokenmessage');
              _this23.clearQuickreply();
            }
            setTimeout(_this23.scrollDown, 1);
          } else {}
        }, function (error) {
          console.log(error);
          // this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
          _this23.$swal('Network error', _this23.$t('Alert.Fail.default.networkError'), 'error');
        });
      }
    },
    openmap: function openmap() {
      // var myModalMap = document.getElementById('myModalMap')
      // myModalMap.style.display = 'block'
      this.sheetother = false;
      // this.dialogMap = true
      this.dialogSendMap = true;
    },
    closeSendMap: function closeSendMap(value) {
      // console.log(value)
      // console.log('closeSendMap')
      this.dialogSendMap = value;
    },
    opensheetmap: function opensheetmap() {
      this.sheetmap = true;
      this.initmapShow();
      this.sheetother = false;
    },
    closeApprove: function closeApprove(value) {
      this.dialogApprove = value;
    },
    closewebview: function closewebview() {
      this.sheetwebview = false;
      this.Quickreply = '';
      this.Webview_item = {};
      this.dialogWebviewbig_ocr = false;
      // console.log(this.sheetwebview)
      this.closewebview_webhook();
    },
    closewebviewmenu: function closewebviewmenu() {
      this.sheetwebviewmenu = false;
      this.inforwebview = {};
      // console.log(this.sheetwebviewmenu)
      this.closewebview_webhook();
    },
    closewebview_webhook: function closewebview_webhook() {
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/close-webview', {
        tokenroom: this.tokenrooomSelect,
        tokenuser: this.token
      }).then(function (response) {
        // console.log(response.data)
      }).catch(function (error) {
        console.log(error);
      });
    },
    ans_question: function ans_question(item, tokenmessage, tokenbot) {
      // console.log(item)
      this.answerquestion(item, tokenmessage);
      if (item.type === 'link' || item.type === 'webview') {
        this.check_get_accesstoken(item);
      } else if (item.type === 'file') {
        this.downloadFileMenu(item);
      } else if (item.type === 'link_market') {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
      } else if (item.type === 'ekyc') {
        this.ans_ekyc_template(item, tokenbot);
      }
    },
    answerquestion: function answerquestion(item, tokenmessage) {
      var _this24 = this;

      if (item.payload === undefined) {
        item.payload = null;
      }
      var body = { tokenmessage: tokenmessage, tokenuser: this.token, answer: item };
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/answer_question', body).then(function (response) {
        // console.log(response.data)
        if (item.type === 'text') {
          if (_.find(_this24.items, function (o) {
            return o.tokenmessage === response.data.data.tokenmessage;
          }) === undefined) {
            _this24.items.push(response.data.data);
            _this24.clearQuickreply();
            _this24.items = _.sortBy(_this24.items, function (dateObj) {
              return new Date(dateObj.timestamp);
            });
            _this24.items = _.unionBy(_this24.items, 'tokenmessage');
          }
          setTimeout(_this24.scrollDown, 1);
        }
      }, function () {});
    },
    downloadFileMenu: function downloadFileMenu(item) {
      // console.log(item)
      var name = item.file.split('/')[item.file.split('/').length - 1];
      this.axios.get(item.file, { responseType: 'blob' }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
      });
    },
    saveLogNews: function saveLogNews(item) {
      var _this25 = this;

      // console.log(item)
      this.axios.get("https://uatchat-manage.one.th/go_api/api" + '/v1/getOneID/' + this.token).then(function (response) {
        var one_id = response.data.one_id;
        // console.log(one_id)
        _this25.axios.post("https://news.chat.one.th/backend/api/v1/page-analytics", {
          'one_id': one_id,
          'news_id': item.payload.news_id,
          'news_index': item.payload.news_index.toString(),
          'page_name': item.payload.page_name
        }).then(function (response) {
          // console.log(response)
        }).catch(function (error) {
          console.log(error);
        });
      }, function (error) {
        console.log(error);
      });
    },
    check_get_accesstoken: function check_get_accesstoken(item) {
      var _this26 = this;

      // console.log(item)
      if (item.sign === 'true') {
        var body = {
          "tokenuser": this.token,
          "url": item.url
        };
        this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getAccesstoken", body).then(function (response) {
          // console.log(response.data.data)
          var new_url = '';
          new_url = response.data.data.url;
          if (item.type === 'link') {
            // item.url = response.data.data.url
            // window.open(new_url, '_blank')
            // window.location.assign(new_url)
            _this26.checkBrowser(new_url, item);
          } else if (item.type === 'webview') {
            _this26.inforquickreply = {
              label: item.label,
              url: new_url,
              size: item.size,
              type: item.type
              // console.log(this.inforquickreply)
            };_this26.sheetwebview = true;
            if (item.payload.news_id !== undefined) {
              _this26.saveLogNews(item);
            }
            // console.log(this.inforquickreply)
          }
        }, function (error) {
          console.log(error);
        });
      } else if (item.onechat_token === 'true') {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var hour = String(today.getHours() + 1).padStart(2, '0');
        var minute = String(today.getMinutes()).padStart(2, '0');
        var seconds = String(today.getSeconds()).padStart(2, '0');
        var milsec = today.getMilliseconds();
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00';
          dd = String(today.getDate() + 1).padStart(2, '0');
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate();
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1';
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1';
              yyyy = today.getFullYear() + 1;
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0');
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z';
        // console.log(today)

        var expireddate = Date.parse(today);
        var body = __WEBPACK_IMPORTED_MODULE_5__services__["b" /* Encode */].encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate });
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        var url = '';
        if (_.includes(item.url, ['?'])) {
          url = '&';
        } else {
          url = '?';
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate;

        if (item.type === 'link') {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item);
        } else if (item.type === 'webview') {
          this.inforquickreply = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          };
          this.sheetwebview = true;
          if (item.payload.news_id !== undefined) {
            this.saveLogNews(item);
          }
          // console.log(this.inforquickreply)
        }
      } else {
        if (item.type === 'link') {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item);
        } else if (item.type === 'webview') {
          this.inforquickreply = item;
          this.sheetwebview = true;
          if (item.payload.news_id !== undefined) {
            this.saveLogNews(item);
          }
        }
      }
    },
    ans_quickwebview: function ans_quickwebview(item) {
      var message = { message: '', payload: '' };
      this.ans_quickreply(message, 'webview');
      // this.sheetwebview = true
      // this.inforquickreply = item
      this.check_get_accesstoken(item);
    },
    ans_quicklink_market: function ans_quicklink_market(item) {
      var message = { message: '', payload: '' };
      this.ans_quickreply(message, 'link_market');
      // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
      this.$swal('', this.$t('Alert.Warning.link_market'), 'warning');
      this.Quickreply = '';
    },
    ans_quicklink: function ans_quicklink(item) {
      // console.log(item)
      var message = { message: '', payload: '' };
      this.ans_quickreply(message, 'link');
      // window.open(item.url, '_blank')
      this.check_get_accesstoken(item);
      this.Quickreply = '';
    },
    ans_quickreply: function ans_quickreply(item, type) {
      var _this27 = this;

      // console.log(item)
      var body = {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token,
        type_reply: type,
        message: item.message,
        info_data: item.payload
      };
      this.axios.post("https://uatchat-manage.one.th/message" + '/ans_quickreply', body).then(function (response) {
        // console.log(response.data.data)
        if (_.find(_this27.items, function (o) {
          return o.tokenmessage === response.data.tokenmessage;
        }) === undefined) {
          if (response.data.data !== undefined) {
            _this27.items.push(response.data.data);
          }
          _this27.clearQuickreply();
          _this27.items = _.sortBy(_this27.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          _this27.items = _.unionBy(_this27.items, 'tokenmessage');
        }
        setTimeout(_this27.scrollDown, 1);
      }, function () {});
    },
    loadpic: function loadpic(filenameSend) {
      // console.log(filenameSend)
      // console.log(this.pathSend)
      this.axios.get(this.pathSend, { responseType: 'blob' }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filenameSend);
        document.body.appendChild(link);
        link.click();
      });
    },
    loadfile: function loadfile(item) {
      // console.log(item)
      this.bot_dialog_message = false;
      if (this.extension(item.message) === 'media') {
        this.axios.get(item.original_file, { responseType: 'blob' }).then(function (response) {
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', item.file_name);
          document.body.appendChild(link);
          link.click();
        });
      } else {
        // this.dialogGetPassword = true
        this.axios.get(item.message, { responseType: 'blob' }).then(function (response) {
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', item.file_name);
          document.body.appendChild(link);
          link.click();
        });
      }
    },
    toPageForward: function toPageForward(selectedmessage) {
      this.tokenmsgforward = this.selectedmessage;
      this.$router.push('/mobile/forward/' + this.$route.params.roomid);
    },
    clickforward: function clickforward(item) {
      // console.log(item)
      this.selected = true;
      // this.selectedmessage = []
      // this.sheetother = false
      this.selectedmessage = [item];
    },
    closeSeleted: function closeSeleted() {
      this.selected = false;
      this.selectedmessage = [];
    },
    sendMessages: function sendMessages() {
      this.resetIcon();
      this.clearMessage();
    },
    clearMessage: function clearMessage() {
      this.message = '';
    },
    resetIcon: function resetIcon() {
      this.iconIndex = 0;
    },
    changeIcon: function changeIcon() {
      this.iconIndex === this.icons.length - 1 ? this.iconIndex = 0 : this.iconIndex++;
    },
    toPageinfo: function toPageinfo() {
      this.$emit('profile', true);
      this.selected = false;
      this.$router.push('/mobile/room/infor/' + this.$route.params.roomid);
    },
    toPage: function toPage(data) {
      this.$emit('data', true);
      this.$router.push(data);
      this.selected = false;
      // localStorage.setItem('height_center', null)
      localStorage.removeItem('height_center');
    },
    addloc: function addloc() {
      var loc = this.map.location('POINTER');
      this.locationArray.push(loc);
    },
    getdataroom: function getdataroom() {
      var _this28 = this;

      this.progressBoxChat = true;
      this.axios.post("https://uatchat-manage.one.th/manage" + '/getroom', { tokenuser: this.token, tokenroom: this.$route.params.roomid }).then(function (response) {
        // console.log(response.data)
        if (response.data.status === 'success') {
          _this28.infofriend = response.data;
          _this28.block = response.data.statemember;
          // console.log(this.infofriend)
          var me = _this28;
          _this28.listfriend = _.filter(response.data.data_room, function (o) {
            return o.tokenuser !== me.token && o.type === 'user' && o.statemember === 'active';
          });
          // console.log(this.listfriend)
          _this28.progressBoxChat = false;
          _this28.statemember = response.data.statemember;
          if (_this28.infofriend.data_room[0].type === 'bot') {
            _this28.getConsent(response.data.data_room[0].tokenuser, _this28.$route.params.roomid);
            // this.get_list_richmenu(response.data.data_room[0].tokenuser)
            // state member ต้องเป็น friend และ active ถึงเก็ท richmenu
            if (response.data.statemember === 'friend' || response.data.statemember == 'active') {
              _this28.get_list_richmenu(response.data.data_room[0].tokenuser);
            } else {
              _this28.list_richmenu = [];
            }
          } else if (response.data.data_room.length == 1 && response.data.data_room[0].type == 'bot') {
            var bot_id = response.data.data_room[0].tokenuser;
            // console.log(this.bot_id)
            // state member ต้องเป็น friend และ active ถึงเก็ท richmenu
            if (response.data.statemember === 'friend' || response.data.statemember == 'active') {
              _this28.get_list_richmenu(bot_id);
            } else {
              _this28.list_richmenu = [];
            }
          }
          // console.log(this.statemember)
        } else {
          _this28.progressBoxChat = false;
        }
      });
    },
    getConsent: function getConsent(botid, tokenroom) {
      var _this29 = this;

      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/get-consent-bot', {
        tokenuser: this.token,
        bot_id: botid
      }).then(function (response) {
        if (response.data.status === 'success') {
          // console.log(response.data)
          if (response.data.isConsent === true && response.data.isAccept === false) {
            var dataConsent = __WEBPACK_IMPORTED_MODULE_5__services__["b" /* Encode */].encode(response.data.data);
            _this29.$router.push('/check-consent/' + tokenroom + ('/?data_consent=' + dataConsent));
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    pin: function pin() {
      // this.map.Overlays.clear()
      // var loc = this.map.location('POINTER')
      // console.log(loc)
      // this.showloc = loc
      // var marker = new longdo.Marker(loc, {
      //   icon: {
      //     url: '/static/img/icons/pin.png',
      //     offset: { x: this.x, y: this.y }
      //   },
      //   clickable: true,
      //   weight: longdo.OverlayWeight.Top
      // })
      // this.map.Overlays.add(marker)
      // this.map.Overlays.remove()
      var locat = this.map.location();
      var marker = new longdo.Marker(locat, {
        icon: {
          url: '/static/img/icons/pin.png',
          offset: { x: this.x, y: this.y }
        },
        clickable: true,
        weight: longdo.OverlayWeight.Top
      });
      this.map.Overlays.add(marker);
    },
    senddate: function senddate() {
      var _this30 = this;

      if (this.typepicker === 'datepicker') {
        this.datepicker = false;
        this.$swal({
          title: '<div class="CSChatThai">' + this.$t('Alert.Chat.sendDatetime') + '</div>',
          html: '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.dateselect) + '</div>',
          confirmButtonColor: '#2562af',
          confirmButtonText: '<div class="CSChatThai" style="font-size: 20px;">' + this.$t('AnswerQuestion.ok') + '</div>',
          cancelButtonColor: '#1b232db3',
          cancelButtonText: '<div class="CSChatThai" style="font-size: 20px;">' + this.$t('AnswerQuestion.cancel') + '</div>',
          buttonsStyling: true,
          showCloseButton: true,
          showCancelButton: true,
          reverseButtons: true
        }).then(function (result) {
          if (result.value) {
            var item = { message: _this30.dateselect, payload: _this30.infodata };
            _this30.ans_quickreply(item, 'datepicker');
          }
        });
      } else if (this.typepicker === 'datetimepicker') {
        this.datepicker = false;
        this.timepicker = true;
        if (this.dateselect === this.mindate) {
          this.maxtime = '24:00';
        } else if (this.dateselect === this.maxdate) {
          this.mintime = '00:00';
        } else {
          this.maxtime = '24:00';
          this.mintime = '00:00';
        }
      }
    },
    sendtime: function sendtime() {
      var _this31 = this;

      this.$swal({
        title: '<div class="CSChatThai">' + this.$t('Alert.Chat.sendDatetime') + '</div>',
        html: '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.dateselect) + ' เวลา ' + this.timeselect + '</div>',
        confirmButtonColor: '#2562af',
        confirmButtonText: '<div class="CSChatThai" style="font-size: 20px;">' + this.$t('AnswerQuestion.ok') + '</div>',
        cancelButtonColor: '#1b232db3',
        cancelButtonText: '<div class="CSChatThai" style="font-size: 20px;">' + this.$t('AnswerQuestion.cancel') + '</div>',
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          var item = { message: _this31.dateselect + 'T' + _this31.timeselect, payload: _this31.infodata };
          _this31.timepicker = false;
          _this31.ans_quickreply(item, 'datetimepicker');
        }
      });
    },
    setpicker: function setpicker(data) {
      setTimeout(this.scrollDown, 1);
      if (data.type === 'datepicker') {
        this.typepicker = data.type;
        this.datepicker = true;
        this.maxdate = data.max;
        this.mindate = data.min;
        this.dateselect = data.initial;
        this.infodata = data.payload;
      } else if (data.type === 'datetimepicker') {
        this.typepicker = data.type;
        this.datepicker = true;
        this.maxdate = data.max.split('T')[0];
        this.mindate = data.min.split('T')[0];
        this.maxtime = data.max.split('T')[1];
        this.mintime = data.min.split('T')[1];
        this.dateselect = data.initial.split('T')[0];
        this.timeselect = data.initial.split('T')[1];
        this.infodata = data.payload;
      }
      // console.log(data)
    },
    getreply: function getreply() {
      var _this32 = this;

      this.datepicker = false;
      this.timepicker = false;
      this.maxdate = '';
      this.mindate = '';
      this.maxtime = '';
      this.mintime = '';
      this.dateselect = '';
      this.timeselect = '';
      this.infodata = '';
      this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/get-quickreply', { tokenroom: this.$route.params.roomid, tokenuser: this.token }).then(function (response) {
        // console.log(response)
        if (response.data.status === 'success') {
          _this32.Quickreply = response.data.data;
          // setTimeout(this.scrollDown, 1)
          // console.log(this.Quickreply)
        } else {
            // console.log(response.data)
          }
      });
    },
    momentday: function momentday(data) {
      return __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momentdatetimethai(data);
    },
    checkShowmessagwBottom: function checkShowmessagwBottom(data) {
      var scroll = this.$el.querySelector('#myscroll');
      if (scroll.scrollTop >= scroll.scrollHeight - this.box_height - 70.0) {
        // เห็นข้อความแล้ว ไม่ต้องทำอะไร
        setTimeout(this.scrollDown, 1);
      } else {
        // มีปุ่นให้กดเลื่อนลงมา และแสดงข้อความล่างสุด ถ้าเค้ากดปุ่มแล้วปุ่มมายไปเลยย
        this.showmessagebottom = true;
        this.chip = true;
        this.picturechip = data.path_pic;
        if (data.typeofmessage !== 'message') {
          this.showmessage = 'Send ' + data.typeofmessage;
        } else {
          this.showmessage = data.message;
        }
        // setTimeout(this.scrollDown, 1)
      }
    },
    lookmessage: function lookmessage() {
      this.chip = false;
      this.showmessagebottom = false;
      setTimeout(this.scrollDown, 1);
    },
    closechip: function closechip() {
      this.chip = false;
    },
    scrollFunction: function scrollFunction() {
      var scroll = this.$el.querySelector('#myscroll');
      // console.log('box_height=> '+ this.box_height)
      // console.log(scroll.scrollTop)
      // console.log(scroll.scrollHeight - this.box_height - 70.0)
      // console.log(scroll.scrollTop >= ((scroll.scrollHeight - this.box_height - 70.0)))
      if (scroll.scrollTop >= scroll.scrollHeight - this.box_height - 70.0) {
        this.chip = false;
        this.showmessagebottom = false;
      }
      // if (this.chip) {
      //   if (scroll.scrollTop >= ((scroll.scrollHeight - this.box_height - 70.0))) {
      //     // เห็นข้อความแล้ว ไม่ต้องทำอะไร
      //     this.chip = false
      //     this.showmessagebottom = false
      //     // scroll.scrollTop = 0
      //     var scrollMaxNew = scroll.scrollHeight
      //     scroll.scrollTop = scrollMaxNew - this.scrollMaxOld
      //     this.scrollMaxOld = scrollMaxNew
      //     this.scrollval = scroll.scrollTop
      //   }
      // }
    },

    // scrollcheck () {
    //   var scroll = this.$el.querySelector('#myscroll')
    //   if(scroll.scrollTop >= ((scroll.scrollHeight - 492)-100)){
    //     // เห็นข้อความแล้ว ไม่ต้องทำอะไร

    //   } else {
    //     // มีปุ่นให้กดเลื่อนลงมา และแสดงข้อความล่างสุด ถ้าเค้ากดปุ่มแล้วปุ่มมายไปเลยย
    //     setTimeout(this.scrollDown, 1)
    //   }
    //   console.log(this.$el.querySelector('#myscroll').scrollHeight)
    //   console.log(this.$el.querySelector('#myscroll').scrollTop)
    //   // console.log(this.$el.querySelector('#myscroll').scrollMaxOld)
    // },
    chsheetForward: function chsheetForward() {
      this.sheetForward = !this.sheetForward;
    },
    chsheetother: function chsheetother() {
      document.getElementById('tabother').click();
      this.sheetother = !this.sheetother;
    },
    chsheetsticker: function chsheetsticker() {
      document.getElementById('tabsticker').click();
      this.sheetsticker = !this.sheetsticker;
    },
    changelink: function changelink(path) {
      return path;
    },
    pushSticker: function pushSticker(stickerid) {
      var _this33 = this;

      this.axios.post("https://uatchat-manage.one.th/message" + '/push_sticker', { tokenroom: this.$route.params.roomid, tokenuser: this.token, message: stickerid, type: this.typeuser, business_id: this.business_id }).then(function (response) {
        var messageSendChat = response.data.data;
        if (response.data.status === 'success') {
          _this33.sheetsticker = false;
          messageSendChat['status'] = 'success';
          if (_.find(_this33.items, function (o) {
            return o.tokenmessage === messageSendChat.tokenmessage;
          }) === undefined) {
            // console.log(messageSendChat)
            _this33.items.push(messageSendChat);
            _this33.clearQuickreply();
            _this33.items = _.sortBy(_this33.items, function (dateObj) {
              return new Date(dateObj.timestamp);
            });
            _this33.items = _.unionBy(_this33.items, 'tokenmessage');
          }
          setTimeout(_this33.scrollDown, 1);
          // this.sendmsg = ''
        }
      });
    },
    extension: function extension(path) {
      if (path !== undefined && path.includes('.') == true) {
        var fullname_path = path.split('.')[path.split('.').length - 1].toLowerCase();
        if (fullname_path.includes(' ')) {
          var path_space = fullname_path.split(' ');
          var extension = path_space[0];
        } else {
          var extension = fullname_path;
        }
        // console.log( 'path' , path)
        // var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
        var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z'];
        var pdf = ['pdf'];
        var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm', 'xlsx'];
        var presentation = ['ppt', 'pps', 'pot', 'pptx'];
        var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk'];
        var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift'];
        var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff'];
        var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4', 'divx', 'dat'];
        var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf'];
        if (pdf.includes(extension)) {
          return 'pdf';
        } else if (archive.includes(extension)) {
          return 'fas fa-file-archive';
        } else if (spreadsheet.includes(extension)) {
          return 'fas fa-file-excel';
        } else if (presentation.includes(extension)) {
          return 'fas fa-file-powerpoint';
        } else if (word.includes(extension)) {
          return 'fas fa-file-word';
        } else if (execution.includes(extension)) {
          return 'fas fa-file-code';
        } else if (image.includes(extension)) {
          return 'fas fa-file-image';
        } else if (media.includes(extension)) {
          return 'media';
        } else if (audio.includes(extension)) {
          return 'audio';
        } else {
          return 'fas fa-file-alt';
        }
      } else {
        return 'fas fa-file-alt';
      }
    },
    pushcontact: function pushcontact(item) {
      // console.log(item)
      if (item.status === 'success') {
        if (_.find(this.items, function (o) {
          return o.tokenmessage === item.data.tokenmessage;
        }) === undefined) {
          // console.log(item.data)
          this.items.push(item.data);
          this.clearQuickreply();
          this.items = _.sortBy(this.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          this.items = _.unionBy(this.items, 'tokenmessage');
          setTimeout(this.scrollDown, 1);
        }
      } else {
        this.items.push({
          tokenuser: this.token,
          message: item.data.tokenuser,
          tokenroom: this.$route.params.roomid,
          typeofmessage: 'contact',
          timestamp: __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimestamp(),
          tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimestamp()),
          path_pic: this.profile,
          nickname: '',
          file_name: '',
          nickname_contact: item.data.name,
          pic_contact: item.data.profilepicture,
          type_contact: item.data.type,
          status: 'no'
        });
        this.clearQuickreply();
      }
    },
    closeInforfriend: function closeInforfriend(value) {
      this.inforfrienddialog = value;
    },
    detailFriend: function detailFriend(user) {
      // console.log(user)
      this.tokeninforfriend = user;
      this.inforfrienddialog = true;
      this.settingdialog = false;
    },
    chat: function chat(tokenroom) {
      this.$router.push('/mobile/room/' + tokenroom);
    },
    AcceptReq: function AcceptReq(tokenFriend) {
      var _this34 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/accept-friend", { tokenfriend: tokenFriend, tokenuser: this.token }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this34.relation = 'friend';
          // this.$store.dispatch('listFriend', JSON.stringify(tokenFriend))
          // this.$store.dispatch('Request', 'acceptrequest' + tokenFriend + ' ' + Math.random())
        }
      });
    },
    RemoveReq: function RemoveReq(tokenFriend) {
      var _this35 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/removerequestfriend', { tokenfriend: tokenFriend, tokenuser: this.token }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this35.relation = 'unknown';
          // this.$store.dispatch('sendRequest', 'removerequestfriend' + tokenFriend)
        }
      });
    },
    AddFriend: function AddFriend(tokenFriend) {
      var _this36 = this;

      this.axios.post("https://uatchat-manage.one.th/go_api/api/v1/add-friend", { tokenfriend: tokenFriend, tokenuser: this.token }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this36.$store.dispatch('sendRequest', tokenFriend);
        } else {
          alert('Error!!!');
        }
      });
    },
    unblock: function unblock(tokenFriend) {
      var _this37 = this;

      this.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistblockfriend', { tokenuser: this.token }).then(function (response) {
        var room = response.data['listBlockFriend'][_this37.findWithAttr(response.data['listBlockFriend'], 'tokenuser', tokenFriend)]['tokenroom'];
        _this37.axios.post("https://uatchat-manage.one.th/manage" + '/unblockfriend', { tokenfriend: tokenFriend, tokenuser: _this37.token, tokenroom: room }).then(function (response) {
          if (response.data['status'] === 'success') {
            _this37.$swal('Unblocked!', _this37.$t('Alert.Success.unblock'), 'success');
            _this37.relation = 'friend';
            _this37.axios.post("https://uatchat-manage.one.th/manage" + '/web/getlistblockfriend', { tokenuser: _this37.token }).then(function (response) {
              _this37.$store.dispatch('listFriend', 'listBlockFriend' + _this37.tokenFriend);
            });
          }
        });
      });
    },
    append: function append(emoji) {
      // console.log(emoji)
      this.sendmsg += emoji;
    },

    // onInput (event) {
    //   // console.log(event.data)
    //   this.sendmsg = event.data
    //     //event.data contains the value of the textarea
    // },
    forword: function forword() {
      if (this.currentPage < this.pageCount) {
        this.currentPage = this.currentPage + 1;
      }
    },
    back: function back() {
      if (this.currentPage !== 1) {
        this.currentPage = this.currentPage - 1;
      }
    },
    setPlace: function setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker: function addMarker() {
      if (this.currentPlace) {
        var marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.lat = this.currentPlace.geometry.location.lat();
        this.lng = this.currentPlace.geometry.location.lng();
        this.address = this.currentPlace.name + ' ' + this.currentPlace.formatted_address;
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },
    sendmap: function sendmap() {
      var _this38 = this;

      if (this.lat !== '' && this.lng !== '') {
        this.axios.post("https://uatchat-manage.one.th/event" + '/push_map', {
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token,
          lat: this.lat + '',
          long: this.lng + '',
          address: this.address,
          type: this.typeuser,
          business_id: this.business_id
        }).then(function (response) {
          var _ = __webpack_require__("M4fF");
          if (response.data['status'] === 'success') {
            if (_.find(_this38.items, function (o) {
              return o.tokenmessage === response.data.data.tokenmessage;
            }) === undefined) {
              _this38.date = __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momentdatethai(response.data.data.timestamp);
              _this38.time = __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimethai(response.data.data.timestamp);
              _this38.items.push({
                sender: 'self',
                message: response.data.data.message,
                room: response.data.data.tokenroom,
                tokenuser: response.data.data.tokenuser,
                date: _this38.date,
                timestamp: _this38.time,
                typeofmessage: response.data.data.typeofmessage,
                time: response.data.data.timestamp,
                tokenmessage: response.data.data.tokenmessage,
                path_pic: _this38.profile,
                chatname: response.data.data.nickname,
                file_name: response.data.data.file_name,
                status: 'success'
              });
              _this38.clearQuickreply();
            }
            setTimeout(_this38.scrollDown, 1);
            // this.axios.post(process.env.APIpub '/mark_read', {tokenuser: this.token, tokenroom: response.data.data.tokenroom}).then((response) => {
            // })
            _this38.lat = _this38.lat + '';
            _this38.lng = _this38.lng + '';
            _this38.address = _this38.address;
            _this38.sheet = false;
          } else {
            _this38.date = __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momentdatethai(response.data.source.timestamp);
            _this38.time = __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimethai(response.data.source.timestamp);
            _this38.items.push({
              sender: 'self',
              message: _this38.sendmsg,
              tokenroom: _this38.$route.params.roomid,
              date: _this38.date,
              timestamp: _this38.time,
              typeofmessage: 'message',
              time: _this38.time,
              tokenmessage: '',
              path_pic: _this38.profile,
              chatname: '',
              file_name: '',
              status: 'no'
            });
            _this38.clearQuickreply();
            // this.lat = ''
            // this.lng = ''
            // this.address = ''
            // this.sheet = false
            _this38.lat = _this38.lat + '';
            _this38.lng = _this38.lng + '';
            _this38.address = _this38.address;
            _this38.sheet = false;
            _this38.sheetother = false;
          }
        });
      } else {
        this.sheet = false;
        this.sheetother = false;
      }
    },
    setPlaceandAdd: function setPlaceandAdd(place) {
      this.currentPlace = place;
      this.addMarkerplace(this.currentPlace);
    },
    addMarkerplace: function addMarkerplace(place) {
      if (place) {
        var marker = {
          lat: place.latLng.lat(),
          lng: place.latLng.lng()
        };
        this.lat = place.latLng.lat();
        this.lng = place.latLng.lng();
        this.markers.push({ position: marker });
        this.places.push(place);
        this.center = marker;
        this.currentPlace = null;
      }
      // let self = this
      // var geocoder = new google.maps.Geocoder
      // geocoder.geocode({placeId: place.placeId}, function (results, status) {
      //   if (status === 'OK') {
      //     if (results[0]) {
      //       self.address = results[0].formatted_address
      //     }
      //   }
      // })
    },
    other_noti: function other_noti(group, title, msg, pic) {
      if (Notification.permission === 'granted') {
        var notification = new Notification(title, { body: msg, icon: pic, silent: true });
        notification.onclick = function () {};
      } else {
        Notification.requestPermission().then(function (result) {
          // console.log(result)
        });
      }
    },
    uppic: function uppic() {
      // console.log('uppic')
      document.getElementById('uploadpic').click();
    },
    upfile: function upfile() {
      document.getElementById('uploadfileChat').click();
      this.sheetother = false;
    },
    pasteIntoInput: function pasteIntoInput(el, text) {
      el.focus();
      if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
        var val = el.value;
        var selStart = el.selectionStart;
        el.value = val.slice(0, selStart) + text + val.slice(el.selectionEnd);
        el.selectionEnd = el.selectionStart = selStart + text.length;
      } else if (typeof document.selection !== 'undefined') {
        var textRange = document.selection.createRange();
        textRange.text = text;
        textRange.collapse(false);
        textRange.select();
      }
    },

    // savefile (msg) {
    //   var button = document.getElementById('btn-download')
    //   button.addEventListener('click', function (e) {
    //     var dataURL = canvas.toDataURL('image/png')
    //     button.href = msg
    //   })
    // },
    closemodal: function closemodal() {
      this.filepdf = '';
      // console.log('close modal')
      // console.log(this.src)
      var modal = document.getElementById('myModalImage');
      var modalfile = document.getElementById('myModalFile');
      // var myModalMap = document.getElementById('myModalMap')
      modal.style.display = 'none';
      modalfile.style.display = 'none';
      // myModalMap.style.display = 'none'
    },
    zoomfile: function zoomfile(close, item) {
      // console.log(item)
      this.settingdialog = false;
      this.forwarddialog = false;
      var modalfile = document.getElementById('myModalFile');
      modalfile.style.display = 'block';
      this.filepdf = this.announce_message.message;
      this.nicknameSend = this.announce_message.nickname;
      this.filenameSend = this.announce_message.file_name;
      this.picSend = this.announce_message.path_pic;
      this.dateSend = this.dateMoment(this.announce_message.timestamp);
      this.timeSend = this.timeMoment(this.announce_message.timestamp);
      this.tokenmsgSend = this.announce_message.tokenmessage;
      this.typeuserSend = this.announce_message.type;
      this.infor_file = this.announce_message;
      // console.log(this.announce_message)
      if (close) {
        modalfile.style.display = 'none';
      }
    },
    zoomPasswordfile: function zoomPasswordfile(close, item, data) {
      this.settingdialog = false;
      this.forwarddialog = false;
      var modalfile = document.getElementById('myModalFile');
      modalfile.style.display = 'block';
      this.filepdf = item;
      this.nicknameSend = data.nickname;
      this.filenameSend = data.file_name;
      this.picSend = data.path_pic;
      this.dateSend = this.dateMoment(data.timestamp);
      this.timeSend = this.timeMoment(data.timestamp);
      this.tokenmsgSend = data.tokenmessage;
      this.typeuserSend = data.type;
      this.infor_file = data;
      // console.log(this.announce_message)
      if (close) {
        modalfile.style.display = 'none';
      }
    },
    zoom: function zoom() {
      // console.log(item)
      this.imagealbumsdialog = false;
      this.forwarddialog = false;
      this.forwardimagedialog = false;
      var modal = document.getElementById('myModalImage');
      var modalImg = document.getElementById('img01');
      modal.style.display = 'block';
      modalImg.src = this.mentiondetail.message;
      if (this.mentiondetail.path_pic === undefined) {
        this.picSend = localStorage.getItem('profilepicture');
      } else {
        this.picSend = this.mentiondetail.path_pic;
      }
      this.nicknameSend = this.mentiondetail.nickname;
      this.filenameSend = this.mentiondetail.file_name;
      this.dateSend = this.dateMoment(this.mentiondetail.timestamp);
      this.timeSend = this.timeMoment(this.mentiondetail.timestamp);
      this.tokenmsgSend = this.mentiondetail.tokenmessage;
      this.pathSend = this.mentiondetail.message;
      this.typeuserSend = this.mentiondetail.type;
    },
    sendimgonebox: function sendimgonebox(tokenmessage) {
      this.dialogSaveOnebox = true;
      this.tokenmessage_savebox = tokenmessage;
    },
    closeSaveOnebox: function closeSaveOnebox(value) {
      this.dialogSaveOnebox = false;
    },
    scrollMaxOldSet: function scrollMaxOldSet() {
      // var container = this.$el.querySelector('#myscroll')
      this.scrollMaxOld = 0;
    },
    scrollDown: function scrollDown() {
      var container = this.$el.querySelector('#myscroll');
      // console.log(`scH: ${container.scrollHeight}`)
      container.scrollTop = container.scrollHeight;
      this.scrollval = container.scrollTop;
    },
    loadchathistory: function loadchathistory() {
      // this.box_height = (this.$vssHeight - ((34.0 + 40.0 + 82.0) - 10.0))
      // console.log(this.box_height)
      // alert(this.box_height + ' : ' + this.$vssHeight)
      this.progressLoadChat = true;
      this.temp = this.selectedmessage;
      this.selectedmessage = [];
      this.getOldMessageFirst(this.items[0].timestamp);
      // var container = this.$el.querySelector('#myscroll')
      // this.scrollval = container.scrollTop
      // if (this.scrollval < 20) {
      //   this.getOldMessageFirst(this.items[0].timestamp)
      //   var scrollMaxNew = container.scrollHeight
      //   container.scrollTop = scrollMaxNew - this.scrollMaxOld
      //   this.scrollMaxOld = scrollMaxNew
      //   this.scrollval = container.scrollTop
      // }
    },
    getOldMessageFirst: function getOldMessageFirst(time) {
      var _this39 = this;

      this.progressLoadChat = true;
      if (time === '') {
        this.progressLoadChat = true;
      }
      console.log('tokenroom mobile: ', this.$route.params.roomid !== null && this.$route.params.roomid !== undefined);
      if (this.$route.params.roomid !== null && this.$route.params.roomid !== undefined) {
        this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/getdictmessage", {
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token,
          time_in: time,
          type: this.typeuser
        }).then(function (response) {
          if (response.data['status'] === 'success') {
            _this39.progressLoadChat = false;
            // console.log(response.data)
            _this39.statemember = response.data.state_member;
            if (response.data.data.length === 20) {
              _this39.statusload = true;
            } else if (response.data.data.length < 20) {
              _this39.statusload = false;
            }
            _this39.selectedmessage = _this39.temp;
            // if (time === '') {
            //   this.items.unshift.apply(this.items, response.data['data'].reverse())
            //   setTimeout(this.scrollDown, 1)
            // } else {
            //   this.gotoTokenmessage = response.data.data[0].tokenmessage
            //   this.items = response.data['data'].reverse().concat(this.items)
            // }
            // console.log(this.$route.query.tokenmessage)
            if (time === '') {
              // console.log('notime')
              _this39.items = response.data['data'].reverse();
              // setTimeout(this.scrollDown, 1)
              _this39.$nextTick(function () {
                // console.log('nextTick')
                // console.log(this.$route.query.tokenmessage)
                if (_this39.$route.query.tokenmessage) {
                  // console.log('have tokenmessage')
                  _this39.gotoMessage(_this39.$route.query.tokenmessage);
                } else {
                  // console.log('no tokenmessage')
                  setTimeout(_this39.scrollDown, 1);
                }
              });
            } else {
              _this39.gotoTokenmessage = response.data.data[0].tokenmessage;
              _this39.items = response.data['data'].reverse().concat(_this39.items);
              // console.log(this.items)
              // console.log(this.gotoTokenmessage)
            }
          } else {
            if (response.data.message === 'not member.') {
              _this39.$router.push('/layouthompage');
            }
          }
        }).catch(function (error) {
          _this39.progressLoadChat = false;
          // this.progressLoadChatBox = false
          if (error.response.data.message === 'Tokenroom not found.') {
            _this39.$router.push('/layouthompage');
          }
        });
      } else {
        this.$router.push('/layouthompage');
      }
    },
    get_list_richmenu: function get_list_richmenu(botid) {
      var _this40 = this;

      // console.log(typeroom)
      // if (typeroom !== 'group') {
      this.axios.post("https://uatchat-manage.one.th/go_api/api" + '/v1/get-richmenu-by-botid', { bot_id: botid }).then(function (response) {
        // console.log(response.data.data)
        // console.log(response.data.data.list_menu)
        if (response.data.status === 'success') {
          _this40.list_richmenu = response.data.data.list_menu;
          _this40.type_richmenu = parseInt(response.data.data.type_menu);
          _this40.inforrichmenu = response.data.data.list_menu;
          _this40.richmenu_label = response.data.data.menu_label;
          _this40.bot_id_richmenu = response.data.data.bot_id;
          // console.log(response.data.data.list_menu)
          _this40.default_behavior = parseInt(response.data.data.default_behavior);
          if (_this40.default_behavior === 1) {
            _this40.RichmenuState = true;
            _this40.sheetrichmenu = true;
          } else {
            _this40.RichmenuState = false;
            _this40.sheetrichmenu = false;
          }
          // console.log(this.type_richmenu)
          // console.log(this.inforrichmenu)
        } else {
          // console.log(response.data)
          _this40.list_richmenu = [];
        }
      }).catch(function (error) {
        console.log(error);
      });
      // }
    },
    isBlank: function isBlank(str) {
      return !str || /^\s*$/.test(str);
    },
    isEmpty: function isEmpty(str) {
      return !str || str.length === 0;
    },
    resendMessage: function resendMessage(data) {
      _.remove(this.items, function (n) {
        return n.tokenmessage === data.tokenmessage;
      });
      this.sendMessage(data.message);
    },
    resendContact: function resendContact(data) {
      _.remove(this.items, function (n) {
        return n.tokenmessage === data.tokenmessage;
      });
      this.sendContact(data);
    },
    dateMoment: function dateMoment(data) {
      // return Momenttime.momentdatethai(data)
      if (this.$i18n.locale == 'th') {
        return __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momentdatethai(data);
      } else if (this.$i18n.locale == 'cn') {
        return __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momentdatecn(data);
      } else {
        return __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momentdateen(data);
      }
    },
    timeMoment: function timeMoment(data) {
      return __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimethai(data);
      // if (this.$i18n.locale == 'th') {
      //   return Momenttime.momenttimethaiformnow(data)
      // } else if (this.$i18n.locale == 'cn') {
      //   return Momenttime.momenttimethaiformnowcn(data)
      // } else {
      //   return Momenttime.momenttimethaiformnowen(data)
      // }
    },
    datetime: function datetime(data) {
      return __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momentdatethai(data);
    },
    sendMessage: function sendMessage(data) {
      var _this41 = this;

      // console.log(data)
      if (this.showmention === false) {
        try {
          if (event.keyCode === 13 && event.shiftKey) {
            if (event.type === 'keypress') {
              this.pasteIntoInput(this, '\n');
            }
            event.preventDefault();
          } else if (!this.isBlank(data) && !this.isEmpty(data)) {
            // console.log(this.listfriend.length)
            if (this.infofriend.type === 'group') {
              // tag friend
              var result;
              this.listfriend.map(function (item) {
                var pattern = /\B@([^\u0000-\u007F]|[\a-zA-Z])+/gi;
                // var pattern = /\B@([^\u0000-\u007F]|[\a-zA-Z])+\s/gi
                // console.log(item.name)
                result = data.match(pattern);
              });
              // console.log(result)
              if (result) {
                var list_tag = [];
                for (var i = 0; i < result.length; i++) {
                  // console.log(result[i])
                  var test = this.listfriend.find(function (person) {
                    return person.name.includes(result[i].substring(1));
                  });
                  list_tag.push(test);
                  // console.log(test2)
                }
                for (var j = 0; j < list_tag.length; j++) {
                  if (list_tag[j] !== undefined) {
                    data = data.replace('@' + list_tag[j].name, '<tax>' + list_tag[j].tokenuser + '</tax>');
                  }
                }
              } else {
                // ถ้าข้อความมี spacebar แทยค่าด้วย \u00a0
                for (var k = 0; k < data.length; k++) {
                  data = data.replace(/ /g, '\xA0');
                }
              }
            } else {
              // ถ้าข้อความมี spacebar แทยค่าด้วย \u00a0
              for (var l = 0; l < data.length; l++) {
                data = data.replace(/ /g, '\xA0');
              }
            }

            this.axios.post("https://uatchat-manage.one.th/alpine/api/v1/pushMessage", { tokenroom: this.$route.params.roomid, tokenuser: this.token, type: this.typeuser, message: data }).then(function (response) {
              var messageSendChat = response.data.data;
              if (response.data.status === 'success') {
                messageSendChat['status'] = 'success';
                if (_.find(_this41.items, function (o) {
                  return o.tokenmessage === messageSendChat.tokenmessage;
                }) === undefined) {
                  // console.log(messageSendChat)
                  _this41.items.push(messageSendChat);
                  _this41.clearQuickreply();
                  _this41.items = _.sortBy(_this41.items, function (dateObj) {
                    return new Date(dateObj.timestamp);
                  });
                  _this41.items = _.unionBy(_this41.items, 'tokenmessage');
                }
                setTimeout(_this41.scrollDown, 1);
                _this41.sendmsg = '';
              } else {
                _this41.items.push({ tokenuser: _this41.token, message: data, tokenroom: _this41.$route.params.roomid, typeofmessage: 'message', timestamp: __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimestamp(), tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimestamp()), path_pic: _this41.profile, nickname: '', file_name: '', status: 'no' });
                _this41.clearQuickreply();
                _this41.sendmsg = '';
              }
            }, function (error) {
              _this41.items.push({ tokenuser: _this41.token, message: data, tokenroom: _this41.$route.params.roomid, typeofmessage: 'message', timestamp: __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimestamp(), tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimestamp()), path_pic: _this41.profile, nickname: '', file_name: '', status: 'no' });
              _this41.clearQuickreply();
              _this41.sendmsg = '';
              _this41.$swal('Network error', _this41.$t('Alert.Fail.default.networkError'), 'error');
              setTimeout(_this41.scrollDown, 1);
              console.log(error);
            });
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        this.sendMessageMention(data);
      }
    },
    sendMessageMention: function sendMessageMention(data) {
      var _this42 = this;

      this.showmention = false;
      try {
        if (!this.isBlank(data) && !this.isEmpty(data)) {
          this.axios.post("https://uatchat-manage.one.th/message" + '/mention_message', { tokenroom: this.$route.params.roomid, tokenuser: this.token, tokenmessage: this.mentiondetail.tokenmessage, mention_message: data }).then(function (response) {
            var messageSendChat = response.data.data;
            // console.log(messageSendChat)
            if (response.data.status === 'success') {
              messageSendChat['status'] = 'success';
              if (_.find(_this42.items, function (o) {
                return o.tokenmessage === messageSendChat.tokenmessage;
              }) === undefined) {
                _this42.items.push(messageSendChat);
                _this42.clearQuickreply();
                _this42.items = _.sortBy(_this42.items, function (dateObj) {
                  return new Date(dateObj.timestamp);
                });
                _this42.items = _.unionBy(_this42.items, 'tokenmessage');
              }
              setTimeout(_this42.scrollDown, 1);
              _this42.sendmsg = '';
            } else {
              _this42.items.push({ tokenuser: _this42.token, message: data, tokenroom: _this42.$route.params.roomid, typeofmessage: 'mention_message', timestamp: __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimestamp(), tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimestamp()), path_pic: _this42.profile, nickname: '', file_name: '', status: 'no' });
              _this42.clearQuickreply();
              _this42.sendmsg = '';
            }
          }, function (error) {
            _this42.items.push({ tokenuser: _this42.token, message: data, tokenroom: _this42.$route.params.roomid, typeofmessage: 'mention_message', timestamp: __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimestamp(), tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimestamp()), path_pic: _this42.profile, nickname: '', file_name: '', status: 'no' });
            _this42.clearQuickreply();
            _this42.sendmsg = '';
            // this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
            _this42.$swal('Network error', _this42.$t('Alert.Fail.default.networkError'), 'error');
            console.log(error);
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    sendContact: function sendContact(data) {
      var _this43 = this;

      this.axios.post("https://uatchat-manage.one.th/message" + '/push_contact', { tokenroom: this.$route.params.roomid, tokenuser: this.token, tokencontact: data.message, type: this.typeuser }).then(function (response) {
        if (response.data['status'] === 'success') {
          _this43.sheetother = false;
          // console.log(response.data)
          if (_.find(_this43.items, function (o) {
            return o.tokenmessage === response.data.tokenmessage;
          }) === undefined) {
            _this43.items.push(response.data);
            _this43.clearQuickreply();
            _this43.items = _.sortBy(_this43.items, function (dateObj) {
              return new Date(dateObj.timestamp);
            });
            _this43.items = _.unionBy(_this43.items, 'tokenmessage');
            setTimeout(_this43.scrollDown, 1);
          }
          // this.$swal('', 'ข้อมูลติดต่อถูกจัดส่งแล้ว', 'success')
          _this43.$swal('', _this43.$t('Alert.Success.account'), 'success');
        } else {
          _this43.items.push({ tokenuser: _this43.token, message: data.tokenuser, tokenroom: _this43.$route.params.roomid, typeofmessage: 'contact', timestamp: __WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimestamp(), tokenmessage: btoa(__WEBPACK_IMPORTED_MODULE_5__services__["c" /* Momenttime */].momenttimestamp()), path_pic: _this43.profile, nickname: '', file_name: '', nickname_contact: data.name, pic_contact: data.profilepicture, type_contact: data.type, status: 'no' });
          _this43.clearQuickreply();
          setTimeout(_this43.scrollDown, 1);
          // this.$swal('', 'เกิดความผิดปกติบางอย่างขึ้น ไม่สามารถส่งข้อมูลติดต่อได้ กรุณาลองใหม่ในภายหลัง', 'error')
          _this43.$swal('', _this43.$t('Alert.Fail.default.somethingWrong'), 'error');
        }
      }, function () {
        // this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
        _this43.$swal('Network error', _this43.$t('Alert.Fail.default.networkError'), 'error');
      });
    },
    checksen: function checksen(data) {
      if (!this.isBlank(data) && !this.isEmpty(data)) {
        return true;
      } else {
        return false;
      }
    },
    getMessageSocket: function getMessageSocket(data) {
      // console.log(data)
      // this.clearQuickreply()
      if (data.tokenroom === this.$route.params.roomid) {
        if (data.tokenuser !== this.token) {
          this.checkShowmessagwBottom(data);
        }
        if (_.find(this.items, function (o) {
          return o.tokenmessage === data.tokenmessage;
        }) === undefined) {
          this.items.push(data);
          this.clearQuickreply();
          this.items = _.sortBy(this.items, function (dateObj) {
            return new Date(dateObj.timestamp);
          });
          this.items = _.unionBy(this.items, 'tokenmessage');
          // setTimeout(this.scrollDown, 1)
          if (data.typeofmessage === 'file') {
            this.socketupdate_file = data;
          } else if (data.typeofmessage === 'image') {
            this.socketupdate_img = data;
          }
          if (data.tokenuser !== this.token) {
            this.axios.post("https://uatchat-manage.one.th/alpine" + '/api/v1/user-mark-read', { tokenuser: this.token, tokenroom: data.tokenroom }).then(function (response) {});
          }
        }
      }
    },
    onScroll: function onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },

    // onimgSelected (data) {
    //   console.log(data)
    //   this.sheetother = false
    //   let uploadedFiles = data.target.files
    //   var lengthfile = uploadedFiles.length
    //   var sizefile = []
    //   for (var i = 0; i < lengthfile; i++) {
    //     sizefile[i] = uploadedFiles[i].size
    //   }
    //   if (_.sum(sizefile)/ 1024 / 1024 > 100) {
    //     this.$swal({ title: 'ไม่สามารถส่งไฟล์ได้ เนื่องจากไฟล์มีขนาดเกิน 100 MB', type: 'warning' })
    //   } else {
    //     for (let i = 0; i < uploadedFiles.length; i++) {
    //       // this.selectFile = data.target.files[i]
    //       // console.log(data.target.files[i].type)
    //       if (data.target.files[i].type === 'image/jpeg' || data.target.files[i].type === 'image/png' || data.target.files[i].type === 'image/jpg') {
    //         // console.log(this.selectFile)
    //         this.selectFile = data.target.files[i]
    //         var uploadFile = new FormData()
    //         uploadFile.append('file', this.selectFile, this.selectFile.name)
    //         uploadFile.append('tokenroom', this.$route.params.roomid)
    //         uploadFile.append('tokenuser', this.token)
    //         uploadFile.append('type', this.typeuser)
    //         this.axios.post(process.env.APIimage + '/push_image', uploadFile).then((response) => {
    //           if (response.data.status === 'success') {
    //             if (_.find(this.items, function(o) {
    //                 return o.tokenmessage === response.data.data.tokenmessage
    //               }) === undefined) {
    //               this.socketupdate_img = response.data.data
    //               response.data.data.status = 'success'
    //               this.items.push(response.data.data)
    //               this.clearQuickreply()
    //               this.items = _.sortBy(this.items, function(dateObj) {
    //                 return new Date(dateObj.timestamp)
    //               })
    //               this.items = _.unionBy(this.items, 'tokenmessage')
    //               document.querySelector('#uploadpic').value = ''
    //               document.querySelector('#uploadfileChat').value = ''
    //             }
    //             setTimeout(this.scrollDown, 1)
    //           } else {}
    //         }, (error) => {
    //           console.log(error)
    //           this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
    //         })
    //       } else {
    //         // console.log(data.target.files[i].type)
    //         this.onFileSelected(data)
    //       }
    //     }
    //   }
    // },
    onimgSelected: function onimgSelected(data) {
      var _this44 = this;

      // console.log(data)
      this.sheetother = false;
      var lengthfile = data.length;
      var sizefile = [];
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = data[i].size;
      }
      if (_.sum(sizefile) / 1024 / 1024 > 100) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile100'), type: 'warning' });
      } else {
        for (var _i = 0; _i < data.length; _i++) {
          if (data[_i].type === 'image/jpeg' || data[_i].type === 'image/png' || data[_i].type === 'image/jpg') {
            // console.log('it image')
            this.selectFile = data[_i];
            // console.log(this.selectFile)
            var uploadFile = new FormData();
            uploadFile.append('file', this.selectFile, this.selectFile.name);
            uploadFile.append('tokenroom', this.$route.params.roomid);
            uploadFile.append('tokenuser', this.token);
            uploadFile.append('type', this.typeuser);
            this.axios.post("https://uatchat-manage.one.th/message" + '/push_image', uploadFile).then(function (response) {
              if (response.data.status === 'success') {
                // console.log(response.data.data)
                if (_.find(_this44.items, function (o) {
                  return o.tokenmessage === response.data.data.tokenmessage;
                }) === undefined) {
                  _this44.socketupdate_img = response.data.data;
                  response.data.data.status = 'success';
                  _this44.items.push(response.data.data);
                  _this44.clearQuickreply();
                  _this44.items = _.sortBy(_this44.items, function (dateObj) {
                    return new Date(dateObj.timestamp);
                  });
                  _this44.items = _.unionBy(_this44.items, 'tokenmessage');
                  document.querySelector('#uploadpic').value = '';
                  document.querySelector('#uploadfileChat').value = '';
                }
                setTimeout(_this44.scrollDown, 1);
              } else {}
            }, function (error) {
              console.log(error);
              _this44.$swal('Network error', _this44.$t('Alert.Fail.default.networkError'), 'error');
            });
          } else {}
        }
      }
    },
    onFileSelected: function onFileSelected(data) {
      var _this45 = this;

      // console.log(data)
      // console.log(data.target.files)
      // console.log(this.extension(data.target.files))
      this.sheetother = false;
      var uploadedFiles = data.target.files;
      var lengthfile = uploadedFiles.length;
      var sizefile = [];
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = uploadedFiles[i].size;
      }
      if (_.sum(sizefile) / 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile'), type: 'warning' });
      } else {
        for (var _i2 = 0; _i2 < uploadedFiles.length; _i2++) {
          if (uploadedFiles[_i2].type === 'image/jpeg' || uploadedFiles[_i2].type === 'image/png' || uploadedFiles[_i2].type === 'image/jpg') {
            var datas = [];
            datas.push(uploadedFiles[_i2]);
            this.onimgSelected(datas);
          } else if (this.extension(uploadedFiles[_i2].name) === 'media') {
            var file_video = [];
            file_video.push(uploadedFiles[_i2]);
            this.push_video(file_video);
          } else {
            this.selectFile = uploadedFiles[_i2];
            var uploadFile = new FormData();
            uploadFile.append('file', this.selectFile, this.selectFile.name);
            uploadFile.append('tokenroom', this.$route.params.roomid);
            uploadFile.append('tokenuser', this.token);
            uploadFile.append('type', this.typeuser);
            this.axios.post("https://uatchat-manage.one.th/message" + '/push_file', uploadFile).then(function (response) {
              // console.log(response.data)
              if (response.data.status === 'success') {
                if (_.find(_this45.items, function (o) {
                  return o.tokenmessage === response.data.data.tokenmessage;
                }) === undefined) {
                  response.data.data.status = 'success';
                  _this45.items.push(response.data.data);
                  _this45.clearQuickreply();
                  _this45.items = _.sortBy(_this45.items, function (dateObj) {
                    return new Date(dateObj.timestamp);
                  });
                  _this45.items = _.unionBy(_this45.items, 'tokenmessage');
                  document.querySelector('#uploadfileChat').value = '';
                  _this45.socketupdate_file = response.data.data;
                }
                setTimeout(_this45.scrollDown, 1);
              } else {}
            }, function (error) {
              console.log(error);
              _this45.$swal('Network error', _this45.$t('Alert.Fail.default.networkError'), 'error');
            });
          }
        }
      }
    },

    // onFileSelected (data) {
    //   console.log(data.target.files)
    //   this.sheetother = false
    //   let uploadedFiles = data.target.files
    //   var lengthfile = uploadedFiles.length
    //   var sizefile = []
    //   for (var i = 0; i < lengthfile; i++) {
    //     sizefile[i] = uploadedFiles[i].size
    //   }
    //   if (data.target.files.type === 'image/jpeg' || data.target.files.type === 'image/png' || data.target.files.type === 'image/jpg') {
    //     this.onimgSelected(data)
    //     // console.log(data.target.files[i])
    //   } else if (this.extension(uploadedFiles[i].name) === 'media') {
    //     var file_video = []
    //     file_video.push(uploadedFiles[i])
    //     this.push_video(file_video)
    //   } else {
    //     if (_.sum(sizefile)/ 1024 / 1024 > 25) {
    //       this.$swal({ title: 'ไม่สามารถส่งไฟล์ได้ เนื่องจากไฟล์มีขนาดเกิน 25 MB', type: 'warning' })
    //     } else {
    //       for (let i = 0; i < uploadedFiles.length; i++) {
    //         // console.log(data.target.files[i].type)
    //         this.selectFile = data.target.files[i]
    //         // console.log(this.selectFile)
    //         var uploadFile = new FormData()
    //         uploadFile.append('file', this.selectFile, this.selectFile.name)
    //         uploadFile.append('tokenroom', this.$route.params.roomid)
    //         uploadFile.append('tokenuser', this.token)
    //         uploadFile.append('type', this.typeuser)
    //         this.axios.post(process.env.APIimage + '/push_file', uploadFile).then((response) => {
    //           if (response.data.status === 'success') {
    //             if (_.find(this.items, function(o) {
    //                 return o.tokenmessage === response.data.data.tokenmessage
    //               }) === undefined) {
    //               response.data.data.status = 'success'
    //               // this.items.push(response.data.data)
    //               this.clearQuickreply()
    //               // this.items = _.sortBy(this.items, function(dateObj) {
    //               //   return new Date(dateObj.timestamp)
    //               // })
    //               // this.items = _.unionBy(this.items, 'tokenmessage')
    //               document.querySelector('#uploadfileChat').value = ''
    //               // console.log(response.data.data)
    //               this.socketupdate_file = response.data.data
    //             }
    //             setTimeout(this.scrollDown, 1)
    //           } else {}
    //         }, (error) => {
    //           console.log(error)
    //           this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
    //         })
    //       }
    //     }
    //   }
    // },
    push_video: function push_video(data) {
      var _this46 = this;

      // console.log(data)
      this.sheetother = false;
      var lengthfile = data.length;
      var sizefile = [];
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = data[i].size;
      }
      if (_.sum(sizefile) / 1024 / 1024 > 100) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile100'), type: 'warning' });
      } else {
        for (var _i3 = 0; _i3 < data.length; _i3++) {
          // console.log('it image')
          this.selectFile = data[_i3];
          var uploadFile = new FormData();
          uploadFile.append('file', this.selectFile, this.selectFile.name);
          uploadFile.append('tokenroom', this.$route.params.roomid);
          uploadFile.append('tokenuser', this.token);
          this.axios.post("https://uatchat-manage.one.th/media/api/v1/send-video", uploadFile).then(function (response) {
            if (response.data.status === 'success') {
              if (_.find(_this46.items, function (o) {
                return o.tokenmessage === response.data.data.tokenmessage;
              }) === undefined) {
                _this46.socketupdate_file = response.data.data;
                // console.log(response.data.data)
                response.data.data.status = 'success';
                _this46.items.push(response.data.data);
                _this46.clearQuickreply();
                _this46.items = _.sortBy(_this46.items, function (dateObj) {
                  return new Date(dateObj.timestamp);
                });
                _this46.items = _.unionBy(_this46.items, 'tokenmessage');
                document.querySelector('#uploadpic').value = '';
                document.querySelector('#uploadfileChat').value = '';
              }
              setTimeout(_this46.scrollDown, 1);
            } else {}
          }, function (error) {
            console.log(error);
            _this46.$swal('Network error', _this46.$t('Alert.Fail.default.networkError'), 'error');
          });
        }
      }
    },
    closeNote: function closeNote(value) {
      this.dialogNote = value;
    },
    closeAccount: function closeAccount(value) {
      this.dialogAccount = value;
    },

    // closeMap (value) {
    //   this.dialogMap = value
    // },
    detailNote: function detailNote(id) {
      this.dialogNote = true;
      this.note_id = id;
      this.status_block = this.block;
    },
    convert: function convert(msg) {
      // var linkifyStr = require('linkifyjs/string')
      // var str = msg
      // var processedContent = linkifyStr(str)
      // return processedContent
      var linkifyStr = __webpack_require__("nN35");
      var str = msg;
      var processedContent = linkifyStr(str);
      var regex = /\s|<tax>+[\u0E00-\u0E7Fa-zA-Z'|/^\S+@\S+\.\S+$/]+<\/tax>/g;
      // console.log(msg.match(regex))
      if (msg.match(regex)) {
        for (var i = 0; i < msg.match(regex).length; i++) {
          processedContent = processedContent.replace('&lt;tax&gt;', '<b style="color:#1976d2;">@');
          processedContent = processedContent.replace('&lt;/tax&gt;', '</b>');
          // processedContent = processedContent.replace(' ', '&nbsp;')
          processedContent = processedContent.replace('\t', '\xA0\xA0\xA0\xA0\xA0');
        }
      }
      return processedContent;
    },
    convertURL: function convertURL(msg) {
      var urlRegex = /\bhttps?:\/\/\S+/gi;
      var linkmsg = msg.match(urlRegex);
      if (linkmsg !== null) {
        if (linkmsg.length !== 0) {
          // console.log(linkmsg.slice(0,5))
          linkmsg.length = 1;
          return linkmsg;
        }
        return '';
      } else {
        return '';
      }
      // console.log(msg.match(urlRegex) !== null);
    },
    clicklink_website: function clicklink_website(url) {
      // window.open(url)
      this.checkBrowser(url, '');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "w74u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wgae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/settings/ShowQRCodeUserDialog.vue
var ShowQRCodeUserDialog = __webpack_require__("W9jF");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a5ca4aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/settings/ShowQRCodeUserDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialogShowQRCode),callback:function ($$v) {_vm.dialogShowQRCode=$$v},expression:"dialogShowQRCode"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai",staticStyle:{"white-space":"nowrap","width":"100%","overflow":"hidden","text-overflow":"ellipsis"}},[_c('span',{staticClass:"headline CSChatThai"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-qrcode")]),_vm._v("  "+_vm._s(_vm.$t('Settings.Qrcode.header'))+"\n          ")],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"margin-top":"0vh","margin-bottom":"0vh","justify-content":"center !important","height":"460px !important"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-tabs',{staticStyle:{"height":"350px"},attrs:{"centered":"","icons-and-text":""},model:{value:(_vm.active_tab),callback:function ($$v) {_vm.active_tab=$$v},expression:"active_tab"}},[_c('v-tabs-slider',{attrs:{"color":"info"}}),_vm._v(" "),(_vm.type_menu !== 'richmenu')?_c('v-tab',{key:1,staticStyle:{"color":"white !important","background":"#2562af !important","text-transform":"none"},attrs:{"href":"#tab-1"}},[_vm._v("\n                "+_vm._s(_vm.$t('Settings.Qrcode.myQRcode'))+"\n                "),_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("fas fa-qrcode")])],1):_vm._e(),_vm._v(" "),_c('v-tab',{key:2,staticStyle:{"color":"white !important","background":"#2562af !important","text-transform":"none"},attrs:{"href":"#tab-2"}},[_vm._v("\n                 "+_vm._s(_vm.$t('Settings.Qrcode.scanQRcode'))+"\n                "),_c('v-icon',{staticStyle:{"color":"white !important","font-size":"25px !important"}},[_vm._v("mdi-qrcode-scan")])],1),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"margin-top":"15px"}},[_c('v-tab-item',{attrs:{"id":"tab-1"}},[_c('div',[_c('p',{staticStyle:{"text-align":"center"}},[_c('qrcode',{staticStyle:{"margin":"0 !important","height":"220px","width":"220px","padding":"5px","border":"3px solid","border-radius":"10px"},attrs:{"value":_vm.tokenuserQR,"id":"downloadqruser"}})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('Settings.editProfile.detailQRcode'))+"\n                    "),_c('a',{staticClass:"button",attrs:{"href":"#","id":"btn-download","download":'qrcode_user_' + _vm.name + '.png'},on:{"click":function($event){_vm.loadqr()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.download')))])])])]),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[_c('div',[_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('qrcode-stream',{attrs:{"id":"qrcode-stream","camera":_vm.camera? 'auto':'off'},on:{"decode":_vm.onDecode,"init":_vm.onInit}}),_vm._v(" "),_c('qrcode-capture',{staticStyle:{"display":"none !important"},attrs:{"id":"qrcode-capture"},on:{"decode":_vm.onDecode}})],1),_vm._v(" "),(_vm.type_menu !== 'richmenu')?_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-btn',{staticClass:"btn-upfileqrcode",on:{"click":function($event){_vm.upfileqrcode()}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.selectPicture')))])],1):_vm._e()],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('Openwebsite',{attrs:{"dialogopenwebsite":_vm.dialogopenwebsite,"id":_vm.id,"type":_vm.type},on:{"closeDialog":_vm.closeDialog}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var settings_ShowQRCodeUserDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/settings/ShowQRCodeUserDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("nCeM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a5ca4aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ShowQRCodeUserDialog["a" /* default */],
  settings_ShowQRCodeUserDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_settings_ShowQRCodeUserDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wleB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue-100vh/src/vue100vh/convertStyle/convertStyle.js
var convertStyle = __webpack_require__("Tn58");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-100vh/src/vue100vh/vue100vh.vue
//
//
//
//
//


/* harmony default export */ var vue100vh = ({
  name: 'vue100vh',
  props: ['css'],
  data: function data() {
    return {
      objectStyle: {}
    };
  },
  mounted: function mounted() {
    this.updateStyle();
    window.addEventListener('resize', this.updateStyle);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.updateStyle);
  },

  methods: {
    updateStyle: function updateStyle() {
      var convertedStyle = Object(convertStyle["a" /* default */])(this.css, this.getWindowHeight());
      this.objectStyle = convertedStyle;
    },
    getWindowHeight: function getWindowHeight() {
      return window.innerHeight;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e2ed393","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-100vh/src/vue100vh/vue100vh.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.objectStyle),attrs:{"data-vue100vh":""}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vue100vh_vue100vh = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-100vh/src/vue100vh/vue100vh.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  vue100vh,
  vue100vh_vue100vh,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_vue100vh_vue100vh = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x2ZK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJeT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xY0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xh2Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/albums/AlbumsDialog.vue
var AlbumsDialog = __webpack_require__("MBWy");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ba164ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/albums/AlbumsDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticStyle:{"overflow-y":"hidden"},attrs:{"max-width":"500px","persistent":"","max-height":"500px"},model:{value:(_vm.dialogAlbums),callback:function ($$v) {_vm.dialogAlbums=$$v},expression:"dialogAlbums"}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fas fa-images")]),_vm._v("  \n            "),(_vm.infoalbums.albums_name != '' && _vm.status == 'show')?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.infoalbums.albums_name)+" ("+_vm._s(_vm.filter_infoalbum.length)+")")]):(_vm.status == 'error')?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t('Dialog.album.noAlbum')))]):_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.date(_vm.infoalbums.create_date)))])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.edit && !_vm.edit_name && !_vm.delete_image && _vm.status != 'error')?_c('div',[_c('header',{staticClass:"headerUser",staticStyle:{"z-index":"8 !important"},attrs:{"id":"headerMenubarUser"}},[_c('nav',{staticClass:"headerUser__nav"},[_c('ul',{staticClass:"headerUser__navbar"},[_c('li',{staticClass:"headerUser__item"},[_c('a',{staticClass:"headerUser__link",attrs:{"href":"#"}},[_c('button',{key:"off",staticClass:"headerUser--btn",on:{"click":function($event){_vm.show = !_vm.show}}},[_c('v-icon',{staticClass:"headerUser--icon"},[_vm._v("more_vert")])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"dropdown"}},[(_vm.show)?_c('div',{staticClass:"headerUser__dropdown-menu",class:{ active: _vm.show }},[_c('ul',{staticClass:"headerUser__dropdown-menu-nav"},[_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.clickedit()}}},[_c('a',{staticClass:"header__dropdown-menu-link",attrs:{"href":"#"}},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu font-size15",attrs:{"meduim":""}},[_vm._v("fas fa-plus-circle")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                               "+_vm._s(_vm.$t('Dialog.album.btnAddImage'))+"\n                             ")])])]),_vm._v(" "),_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.clickeditname()}}},[_c('a',{staticClass:"header__dropdown-menu-link",attrs:{"href":"#"}},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu font-size15",attrs:{"meduim":""}},[_vm._v("fas fa-edit")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                               "+_vm._s(_vm.$t('Dialog.album.btnEdit'))+"\n                             ")])])]),_vm._v(" "),_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":function($event){_vm.clickdeleteimage()}}},[_c('a',{staticClass:"header__dropdown-menu-link",attrs:{"href":"#"}},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu font-size15",attrs:{"meduim":""}},[_vm._v("far fa-trash-alt")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                               "+_vm._s(_vm.$t('Dialog.album.btnRemoveImage'))+"\n                             ")])])]),_vm._v(" "),_c('li',{staticClass:"header__dropdown-menu-item",on:{"click":_vm.remove}},[_c('a',{staticClass:"header__dropdown-menu-link",attrs:{"href":"#"}},[_c('div',{staticClass:"header__dropdown-menu-svg"},[_c('v-icon',{staticClass:"header--icon--menu font-size15",attrs:{"meduim":""}},[_vm._v("far fa-trash-alt")])],1),_vm._v(" "),_c('div',{staticClass:"header__dropdown-menu-text"},[_vm._v("\n                               "+_vm._s(_vm.$t('Dialog.album.btnRemoveAlbum'))+"\n                             ")])])])])]):_vm._e()])],1)])])])]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"30px"}},[(_vm.edit_name)?_c('div',{staticStyle:{"width":"100%","margin-bottom":"10px"}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs7":"","sm7":"","md7":"","xl7":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.albumsname),expression:"albumsname"}],staticClass:"CSChatThai",attrs:{"type":"text","placeholder":_vm.$t('Dialog.album.nameAlbum')},domProps:{"value":(_vm.albumsname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.albumsname=$event.target.value}}})]),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"right"},attrs:{"xs5":"","sm5":"","md5":"","xl5":""}},[_c('v-btn',{staticClass:"btncancel",on:{"click":function($event){_vm.edit_name = !_vm.edit_name}}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel'))+" ")]),_vm._v(" "),_c('v-btn',{staticClass:"btnallow",attrs:{"loading":_vm.loading},on:{"click":function($event){_vm.Edit_Name()}}},[_vm._v(" "+_vm._s(_vm.$t('AnswerQuestion.ok'))+" ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.status == 'progress')?_c('v-progress-linear',{attrs:{"indeterminate":_vm.progress}}):(_vm.status == 'show')?_c('div',[(_vm.filter_infoalbum.length != 0)?_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[_c('v-container',_vm._b({staticStyle:{"padding":"2px !important"},attrs:{"fluid":""}},'v-container',( _obj = {}, _obj["grid-list-sm"] = true, _obj ),false),[_c('v-layout',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"322px","background":"#f3f2f2","border-radius":"5px","padding":"5px"},attrs:{"row":"","wrap":""}},_vm._l((_vm.filter_infoalbum),function(image,index){return _c('v-flex',{staticStyle:{"cursor":"pointer"},attrs:{"sm3":"","md3":"","lg3":"","xl3":""}},[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-media',{attrs:{"src":image.link,"height":"100px"},on:{"click":function($event){_vm.delete_image? _vm.noneF(''):_vm.zoom(image)}}},[(_vm.delete_image)?_c('v-checkbox',{staticStyle:{"float":"right","margin-top":"0"},attrs:{"value":{'image_id':image.id, 'index': index},"color":"info"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e()],1)],1)],1)}))],1)],1):_c('v-layout',{attrs:{"column":"","wrap":"","align-center":"","justify-center":""}},[_c('img',{attrs:{"src":"/static/img/icons/image.png","width":"150px"}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('Dialog.album.noImageAlbum')))])]),_vm._v(" "),_c('div',{staticClass:"scrolling-wrapper",staticStyle:{"max-height":"200px","min-height":"100px","margin-top":"10px","word-break":"break-all"}},[_c('div',{style:(_vm.edit? '': 'display:none;')},[_c('form',{ref:"fileformalbum"},[_c('v-flex',{staticClass:"containers hidden-sm-and-down listfile",attrs:{"xs12":"","sm12":"","md12":"","xl12":""}},[_vm._l((_vm.files),function(file,key){return (key < 5)?_c('div',{staticClass:"borderfile",staticStyle:{"justify-content":"center","margin-right":"10px"}},[_c('div',{staticStyle:{"text-align":"right","padding-right":"10px"}},[_c('a',{staticClass:"close-classic",on:{"click":function($event){_vm.removeFile( key )}}})]),_vm._v(" "),(_vm.extension(file.file.name) == 'fas fa-file-image')?_c('div',{staticStyle:{"text-align":"center","display":"grid","justify-content":"center","padding-left":"10px","padding-right":"10px"}},[_c('img',{ref:'preview' + parseInt( key ),refInFor:true,staticClass:"preview",staticStyle:{"height":"60px !important","width":"60px !important","display":"flex","justify-content":"center"}})]):_vm._e()]):_vm._e()}),_vm._v(" "),_c('label',[_c('div',{style:(_vm.borderinputfile)},[_c('v-icon',{staticStyle:{"color":"#757575"}},[_vm._v("mdi-plus")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#757575"}},[_vm._v("\n                    "+_vm._s(_vm.$t('AnswerQuestion.uploadPhoto'))+"\n                  ")]),_vm._v(" "),_c('input',{ref:"filesAlbum",staticStyle:{"display":"none"},attrs:{"type":"file","id":"filesAlbum","multiple":"","accept":".png, .jpg, .jpeg, .gif, .bmp, .wbmp"},on:{"change":function($event){_vm.handleFilesAlbumUpload()}}})],1)])],2)],1)])]),_vm._v(" "),_c('div',[(_vm.edit)?_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{staticStyle:{"padding-right":"10px"},attrs:{"align-center":"","justify-end":"","row":"","wrap":""}},[(_vm.edit)?_c('v-btn',{staticClass:"btncancel",attrs:{"dark":""},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel'))+" ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[(_vm.edit && _vm.files.length > 0)?_c('v-btn',{staticClass:"btnallow",attrs:{"dark":"","loading":_vm.loading},on:{"click":function($event){_vm.addimage()}}},[_vm._v(" "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                ")]):_c('v-btn',{staticClass:"btnallow",attrs:{"disabled":""}},[_vm._v(" "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                ")])],1)],1)],1):(_vm.delete_image)?_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{staticStyle:{"padding-right":"10px"},attrs:{"align-center":"","justify-end":"","row":"","wrap":""}},[(_vm.delete_image)?_c('v-btn',{staticClass:"btncancel",attrs:{"dark":""},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('AnswerQuestion.cancel'))+"\n                ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","wrap":""}},[(_vm.delete_image)?_c('v-btn',{staticClass:"btnallow",attrs:{"dark":"","loading":_vm.loading},on:{"click":function($event){_vm.deleteimage()}}},[_vm._v(" "+_vm._s(_vm.$t('AnswerQuestion.ok'))+"\n                ")]):_vm._e()],1)],1)],1):_vm._e()],1)],1):(_vm.status == 'error')?_c('div',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"#757575 !important","font-size":"80px !important"}},[_vm._v("error_outline")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"font-size":"20px","color":"#757575"}},[_vm._v(" "+_vm._s(_vm.errormessage)+" ")])],1):_vm._e()],1)],1),_vm._v(" "),_c('ShowImageProfileDialog',{attrs:{"dialogshowimage_profile":_vm.dialogshowimage_profile,"pathpicture":_vm.pathpicture,"typepathpicture":_vm.typepathpicture},on:{"closeDialogShowImage_Profile":_vm.closeDialogShowImage_Profile}})],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var albums_AlbumsDialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/albums/AlbumsDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("KBma")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ba164ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  AlbumsDialog["a" /* default */],
  albums_AlbumsDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_albums_AlbumsDialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xuAh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue-avatar-editor-improved/src/components/VueAvatar.vue + 2 modules
var VueAvatar = __webpack_require__("qQMV");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-avatar-editor-improved/src/components/VueAvatarEditor.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var VueAvatarEditor = ({
    props: {
        finishText: {
            type: String,
            default: 'Save'
        },
        hasRotation: {
            type: Boolean,
            default: true
        },
        hasScale: {
            type: Boolean,
            default: true
        },
        image: {
            type: String,
            default: ''
        },
        border: {
            type: Number,
            default: 25
        },
        borderRadius: {
            type: Number,
            default: 0
        },
        width: {
            type: Number,
            default: 200
        },
        height: {
            type: Number,
            default: 200
        },
        color: {
            type: Array,
            default: function _default() {
                return [0, 0, 0, 0.5];
            }
        }
    },
    data: function data() {
        return {
            rotation: 0,
            scale: 1
        };
    },

    components: {
        VueAvatar: VueAvatar["a" /* default */]
    },
    methods: {
        onSelectFile: function onSelectFile(files) {
            this.$emit('select-file', files);
        },
        onImageReady: function onImageReady() {
            this.scale = 1;
            this.rotation = 0;
        },
        finished: function finished() {
            return this.$emit('finished', this.$refs.vueavatar.getImageScaled());
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e00b7e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-avatar-editor-improved/src/components/VueAvatarEditor.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-avatar',{ref:"vueavatar",attrs:{"width":_vm.width,"height":_vm.height,"rotation":_vm.rotation,"borderRadius":_vm.borderRadius,"border":_vm.border,"color":_vm.color,"scale":_vm.scale},on:{"vue-avatar-editor:image-ready":_vm.onImageReady,"select-file":function($event){_vm.onSelectFile($event)}}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.hasScale)?_c('label',[_vm._v("\n    Zoom : "+_vm._s(_vm.scale)+"x\n    "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.scale),expression:"scale"}],attrs:{"type":"range","min":"1","max":"3","step":"0.02"},domProps:{"value":(_vm.scale)},on:{"__r":function($event){_vm.scale=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.hasRotation)?_c('label',[_vm._v("\n    Rotation : "+_vm._s(_vm.rotation)+"°\n    "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rotation),expression:"rotation"}],attrs:{"type":"range","min":"0","max":"360","step":"1"},domProps:{"value":(_vm.rotation)},on:{"__r":function($event){_vm.rotation=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{on:{"click":_vm.finished}},[_vm._v(_vm._s(_vm.finishText))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_VueAvatarEditor = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-avatar-editor-improved/src/components/VueAvatarEditor.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  VueAvatarEditor,
  components_VueAvatarEditor,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_VueAvatarEditor = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y86/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yB1m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yQDo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z+1B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zM04":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zPBl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/dialog/consent/check_consent_dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var check_consent_dialog = ({
  props: {
    checkconsentDialog: Boolean,
    url_consent: String
  },
  data: function data() {
    return {};
  },

  watch: {
    checkconsentDialog: function checkconsentDialog() {
      if (this.checkconsentDialog) {
        // console.log(this.url_consent)
      }
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeDialogConsent', false);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7ded904","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/dialog/consent/check_consent_dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":"","width":"600px","persistent":""},model:{value:(_vm.checkconsentDialog),callback:function ($$v) {_vm.checkconsentDialog=$$v},expression:"checkconsentDialog"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"background":"#1a222c !important"},attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"white--text CSChatThai"},[_vm._v("  "+_vm._s(_vm.$t('RightSide.header.privatepolicy')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":"","flat":""},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_c('v-icon',{staticStyle:{"color":"white !important","font-size":"20px !important"}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"550px"}},[_c('iframe',{staticStyle:{"visibility":"visible","justify-content":"center","align-items":"center","width":"100%"},attrs:{"width":"500","height":"550","frameborder":"0","src":_vm.url_consent,"allow":"geolocation"}})]),_vm._v(" "),_c('v-divider')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var consent_check_consent_dialog = (esExports);
// CONCATENATED MODULE: ./src/components/chat/dialog/consent/check_consent_dialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("H5BG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b7ded904"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  check_consent_dialog,
  consent_check_consent_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialog_consent_check_consent_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zdN6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zhhA":
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.92fd97f6fb4ed329b260.js